export const states = [
    { id: 1, name: 'Andaman Nicobar' },
    { id: 2, name: 'Andhra Pradesh' },
    { id: 3, name: 'Arunachal Pradesh' },
    { id: 4, name: 'Assam' },
    { id: 5, name: 'Bihar' },
    { id: 6, name: 'Chandigarh' },
    { id: 7, name: 'Chhattisgarh' },
    { id: 8, name: 'Dadra & Nagar Haveli' },
    { id: 9, name: 'Daman & Diu' },
    { id: 10, name: 'Delhi' },
    { id: 11, name: 'Goa' },
    { id: 12, name: 'Gujarat' },
    { id: 13, name: 'Haryana' },
    { id: 14, name: 'Himachal Pradesh' },
    { id: 15, name: 'Jammu & Kashmir' },
    { id: 16, name: 'Jharkhand' },
    { id: 17, name: 'Karnataka' },
    { id: 18, name: 'Kerala' },
    { id: 19, name: 'Lakshadweep' },
    { id: 20, name: 'Madhya Pradesh' },
    { id: 21, name: 'Maharashtra' },
    { id: 22, name: 'Manipur' },
    { id: 23, name: 'Meghalaya' },
    { id: 24, name: 'Mizoram' },
    { id: 25, name: 'Nagaland' },
    { id: 26, name: 'Odisha' },
    { id: 27, name: 'Pondicherry' },
    { id: 28, name: 'Punjab' },
    { id: 29, name: 'Rajasthan' },
    { id: 30, name: 'Sikkim' },
    { id: 31, name: 'Tamil Nadu' },
    { id: 32, name: 'Tripura' },
    { id: 33, name: 'Uttar Pradesh' },
    { id: 34, name: 'Uttarakhand' },
    { id: 35, name: 'West Bengal' },
    { id: 39, name: 'Chennai' },
    { id: 42, name: 'Telangana' },
];
export const cities = [
    { id: 1, name: "Car Nicobar", stateId: 1 },
    { id: 2, name: "Port Blai2", stateId: 1 },
    { id: 4, name: "Addanki", stateId: 2 },
    { id: 12, name: "Amalapuram", stateId: 2 },
    { id: 13, name: "Anakapalle", stateId: 2 },
    { id: 14, name: "Anantapur", stateId: 2 },
    { id: 21, name: "Bhadrachalam", stateId: 2 },
    { id: 25, name: "Chembakur", stateId: 2 },
    { id: 27, name: "Chittoor", stateId: 2 },
    { id: 28, name: "Cuddapah", stateId: 2 },
    { id: 34, name: "East Godavari", stateId: 2 },
    { id: 36, name: "Eluru", stateId: 2 },
    { id: 39, name: "Gudivada", stateId: 2 },
    { id: 40, name: "Gudur", stateId: 2 },
    { id: 45, name: "Guntur", stateId: 2 },
    { id: 50, name: "Ibrahimpatnam", stateId: 2 },
    { id: 51, name: "Ichapuram", stateId: 2 },
    { id: 54, name: "Kadiri", stateId: 2 },
    { id: 55, name: "Kakinada", stateId: 2 },
    { id: 58, name: "Kandukur", stateId: 2 },
    { id: 59, name: "Kanuru", stateId: 2 },
    { id: 64, name: "Kovvur", stateId: 2 },
    { id: 65, name: "Krishna", stateId: 2 },
    { id: 66, name: "Kuppam", stateId: 2 },
    { id: 67, name: "Kurnool", stateId: 2 },
    { id: 70, name: "Machilipatnam", stateId: 2 },
    { id: 74, name: "Mangalagiri", stateId: 2 },
    { id: 77, name: "Nagari", stateId: 2 },
    { id: 79, name: "Nandyal", stateId: 2 },
    { id: 81, name: "Narsapur", stateId: 2 },
    { id: 82, name: "Narsipatnam", stateId: 2 },
    { id: 83, name: "Nellore", stateId: 2 },
    { id: 84, name: "Nidadavole", stateId: 2 },
    { id: 87, name: "Nuzvid", stateId: 2 },
    { id: 88, name: "Ongole", stateId: 2 },
    { id: 90, name: "Pedana", stateId: 2 },
    { id: 91, name: "Peddapuram", stateId: 2 },
    { id: 93, name: "Prakasam", stateId: 2 },
    { id: 94, name: "Proddatur", stateId: 2 },
    { id: 96, name: "Rajahmundry", stateId: 2 },
    { id: 104, name: "Sattenapalle", stateId: 2 },
    { id: 108, name: "Sompeta", stateId: 2 },
    { id: 109, name: "Srikakulam", stateId: 2 },
    { id: 112, name: "Tadepalligudem", stateId: 2 },
    { id: 114, name: "Tanuku", stateId: 2 },
    { id: 115, name: "Tenali", stateId: 2 },
    { id: 116, name: "Tirumala", stateId: 2 },
    { id: 117, name: "Tirupati", stateId: 2 },
    { id: 118, name: "Vepagunta", stateId: 2 },
    { id: 119, name: "Vijayawada", stateId: 2 },
    { id: 120, name: "Visakhapatnam", stateId: 2 },
    { id: 121, name: "Vishakhapatnam", stateId: 2 },
    { id: 122, name: "Vizianagaram", stateId: 2 },
    { id: 125, name: "West Godavari", stateId: 2 },
    { id: 2790, name: "Punjagutta", stateId: 2 },
    { id: 2833, name: "West Kameng", stateId: 2 },
    { id: 2912, name: "Rangareddi", stateId: 2 },
    { id: 2924, name: "Qutubullapur", stateId: 2 },
    { id: 2926, name: "Gollapudi", stateId: 2 },
    { id: 2972, name: "Nalgonda", stateId: 2 },
    { id: 2979, name: "Amalapuram", stateId: 2 },
    { id: 2980, name: "Ananthapur", stateId: 2 },
    { id: 2981, name: "Avanigadda", stateId: 2 },
    { id: 2982, name: "Bapatla", stateId: 2 },
    { id: 2983, name: "Kadapa", stateId: 2 },
    { id: 2984, name: "Karim Nagar", stateId: 2 },
    { id: 2985, name: "Mahabub Nagar", stateId: 2 },
    { id: 2986, name: "Palakol", stateId: 2 },
    { id: 2987, name: "Rangareddy", stateId: 2 },
    { id: 2988, name: "Srikalahasti", stateId: 2 },
    { id: 3206, name: "Begumpet", stateId: 2 },
    { id: 3214, name: "Hyderabad", stateId: 2 },
    { id: 3226, name: "Bhimavaram", stateId: 2 },
    { id: 131, name: "Along", stateId: 3 },
    { id: 132, name: "Basar", stateId: 3 },
    { id: 133, name: "Bomdila", stateId: 3 },
    { id: 134, name: "Changlang", stateId: 3 },
    { id: 135, name: "Daporijo", stateId: 3 },
    { id: 136, name: "Itanagar", stateId: 3 },
    { id: 137, name: "Jairampur", stateId: 3 },
    { id: 138, name: "Khonsa", stateId: 3 },
    { id: 139, name: "Namsai", stateId: 3 },
    { id: 140, name: "Pasighat", stateId: 3 },
    { id: 141, name: "Roing", stateId: 3 },
    { id: 142, name: "Seppa", stateId: 3 },
    { id: 143, name: "Tezu", stateId: 3 },
    { id: 144, name: "Yingkiong", stateId: 3 },
    { id: 145, name: "Ziro", stateId: 3 },
    { id: 2834, name: "Lower Subansiri", stateId: 3 },
    { id: 2835, name: "West Siang", stateId: 3 },
    { id: 2836, name: "Papum Pare", stateId: 3 },
    { id: 2837, name: "Tirap", stateId: 3 },
    { id: 2839, name: "Tawang", stateId: 3 },
    { id: 2840, name: "Lohit", stateId: 3 },
    { id: 2841, name: "Upper Siang", stateId: 3 },
    { id: 2842, name: "Kurung Kumey", stateId: 3 },
    { id: 2875, name: "Naharlagun", stateId: 3 },
    { id: 2876, name: "Doimukh", stateId: 3 },
    { id: 2877, name: "Aalo", stateId: 3 },
    { id: 2878, name: "Rumgong", stateId: 3 },
    { id: 2880, name: "Boleng", stateId: 3 },
    { id: 2881, name: "Yazali", stateId: 3 },
    { id: 2882, name: "Mebo", stateId: 3 },
    { id: 2883, name: "Chimpu", stateId: 3 },
    { id: 2884, name: "Tuting", stateId: 3 },
    { id: 2885, name: "Seijosa", stateId: 3 },
    { id: 2886, name: "Ruksin", stateId: 3 },
    { id: 2887, name: "Palin", stateId: 3 },
    { id: 2888, name: "Ganga Village", stateId: 3 },
    { id: 2889, name: "Hapoli", stateId: 3 },
    { id: 2890, name: "Likabali", stateId: 3 },
    { id: 2891, name: "Chandannagar", stateId: 3 },
    { id: 2892, name: "Jollang", stateId: 3 },
    { id: 2901, name: "Chongkham", stateId: 3 },
    { id: 2902, name: "Deomali", stateId: 3 },
    { id: 2903, name: "Koloriang", stateId: 3 },
    { id: 2904, name: "Manmao", stateId: 3 },
    { id: 2905, name: "Miao", stateId: 3 },
    { id: 2919, name: "Bordumsa", stateId: 3 },
    { id: 2920, name: "Yachuli", stateId: 3 },
    { id: 2935, name: "Nirjuli", stateId: 3 },
    { id: 2938, name: "Dirang", stateId: 3 },
    { id: 2941, name: "Balukpong", stateId: 3 },
    { id: 2946, name: "West Kameng", stateId: 3 },
    { id: 2948, name: "Momng", stateId: 3 },
    { id: 2989, name: "Dibang Valley", stateId: 3 },
    { id: 2990, name: "East Kameng", stateId: 3 },
    { id: 2991, name: "East Siang", stateId: 3 },
    { id: 2992, name: "Lower Dibang Valley", stateId: 3 },
    { id: 2993, name: "Upper Dibang Valley", stateId: 3 },
    { id: 2994, name: "Upper Subansiri", stateId: 3 },
    { id: 146, name: "Abhayapuri", stateId: 4 },
    { id: 147, name: "Amguri", stateId: 4 },
    { id: 148, name: "Badarpur", stateId: 4 },
    { id: 149, name: "Barpathar", stateId: 4 },
    { id: 150, name: "Barpeta", stateId: 4 },
    { id: 151, name: "Basugaon", stateId: 4 },
    { id: 152, name: "Bijni", stateId: 4 },
    { id: 153, name: "Bokajan", stateId: 4 },
    { id: 154, name: "Bokakhat", stateId: 4 },
    { id: 155, name: "Bongaigaon", stateId: 4 },
    { id: 156, name: "Chabua", stateId: 4 },
    { id: 157, name: "Chapar", stateId: 4 },
    { id: 158, name: "Dergaon", stateId: 4 },
    { id: 159, name: "Dharapur", stateId: 4 },
    { id: 160, name: "Dhekiajuli", stateId: 4 },
    { id: 161, name: "Dhemaji", stateId: 4 },
    { id: 162, name: "Dhing", stateId: 4 },
    { id: 163, name: "Dhubri", stateId: 4 },
    { id: 164, name: "Dibrugarh", stateId: 4 },
    { id: 165, name: "Digboi", stateId: 4 },
    { id: 166, name: "Diphu", stateId: 4 },
    { id: 167, name: "Goalpara", stateId: 4 },
    { id: 168, name: "Gohpur", stateId: 4 },
    { id: 169, name: "Golaghat", stateId: 4 },
    { id: 170, name: "Guwahati", stateId: 4 },
    { id: 171, name: "Haflong", stateId: 4 },
    { id: 172, name: "Hailakandi", stateId: 4 },
    { id: 173, name: "Hajo", stateId: 4 },
    { id: 174, name: "Hamren", stateId: 4 },
    { id: 175, name: "Hojai", stateId: 4 },
    { id: 176, name: "Howli", stateId: 4 },
    { id: 177, name: "Howraghat", stateId: 4 },
    { id: 178, name: "Jorhat", stateId: 4 },
    { id: 179, name: "Kalaigaon", stateId: 4 },
    { id: 180, name: "Karimganj", stateId: 4 },
    { id: 181, name: "Kokrajhar", stateId: 4 },
    { id: 182, name: "Lakhipur", stateId: 4 },
    { id: 183, name: "Lala", stateId: 4 },
    { id: 184, name: "Lanka", stateId: 4 },
    { id: 185, name: "Lumding", stateId: 4 },
    { id: 186, name: "Mahur", stateId: 4 },
    { id: 187, name: "Maibong", stateId: 4 },
    { id: 188, name: "Mangaldoi", stateId: 4 },
    { id: 189, name: "Mankachar", stateId: 4 },
    { id: 190, name: "Margherita", stateId: 4 },
    { id: 191, name: "Mariani", stateId: 4 },
    { id: 192, name: "Marigaon", stateId: 4 },
    { id: 193, name: "Moranhat", stateId: 4 },
    { id: 194, name: "Nagaon", stateId: 4 },
    { id: 195, name: "Nalbari", stateId: 4 },
    { id: 196, name: "Namrup", stateId: 4 },
    { id: 197, name: "Narayanpur", stateId: 4 },
    { id: 198, name: "Nazira", stateId: 4 },
    { id: 199, name: "North Guwahati", stateId: 4 },
    { id: 200, name: "North Lakhimpur", stateId: 4 },
    { id: 201, name: "Palasbari", stateId: 4 },
    { id: 202, name: "Pathsala", stateId: 4 },
    { id: 203, name: "Rangapara", stateId: 4 },
    { id: 204, name: "Rangia", stateId: 4 },
    { id: 205, name: "Sapatgram", stateId: 4 },
    { id: 206, name: "Sarthebari", stateId: 4 },
    { id: 207, name: "Sarupathar", stateId: 4 },
    { id: 208, name: "Sibsagar", stateId: 4 },
    { id: 209, name: "Silapathar", stateId: 4 },
    { id: 210, name: "Silchar", stateId: 4 },
    { id: 211, name: "Sonari", stateId: 4 },
    { id: 212, name: "Tangla", stateId: 4 },
    { id: 213, name: "Tezpur", stateId: 4 },
    { id: 214, name: "Tihu", stateId: 4 },
    { id: 215, name: "Tinsukia", stateId: 4 },
    { id: 216, name: "Udalguri", stateId: 4 },
    { id: 2850, name: "Mawlai", stateId: 4 },
    { id: 2907, name: "Garchuk", stateId: 4 },
    { id: 2944, name: "Kharupetia", stateId: 4 },
    { id: 2966, name: "Dispur", stateId: 4 },
    { id: 2975, name: "Goreswar", stateId: 4 },
    { id: 2996, name: "Baksa", stateId: 4 },
    { id: 2997, name: "Cachar", stateId: 4 },
    { id: 2998, name: "Darrang", stateId: 4 },
    { id: 2999, name: "Dima Hasso - North Cachar Hill", stateId: 4 },
    { id: 3000, name: "Kamrup", stateId: 4 },
    { id: 3001, name: "Kamrup Metropolitan", stateId: 4 },
    { id: 3002, name: "Karbi Anglong", stateId: 4 },
    { id: 3003, name: "Lakhimpur", stateId: 4 },
    { id: 3004, name: "Sonitpur", stateId: 4 },
    { id: 3219, name: "Hengrabari", stateId: 4 },
    { id: 3228, name: "Cahaideo", stateId: 4 },
    { id: 3229, name: "Charaideo", stateId: 4 },
    { id: 3231, name: "Uparhali", stateId: 4 },
    { id: 3232, name: "Bijoynagar", stateId: 4 },
    { id: 217, name: 'Katihar', stateId: 5 },
    { id: 218, name: 'Abgila', stateId: 5 },
    { id: 219, name: 'Adapur', stateId: 5 },
    { id: 220, name: 'Afzalpur', stateId: 5 },
    { id: 221, name: 'Ahirawan', stateId: 5 },
    { id: 222, name: 'Ahmadpur Harna', stateId: 5 },
    { id: 223, name: 'Akbarpur', stateId: 5 },
    { id: 224, name: 'Amarpur', stateId: 5 },
    { id: 225, name: 'Amawan', stateId: 5 },
    { id: 226, name: 'Araria', stateId: 5 },
    { id: 227, name: 'Areraj', stateId: 5 },
    { id: 228, name: 'Arrah', stateId: 5 },
    { id: 229, name: 'Asarganj', stateId: 5 },
    { id: 230, name: 'Aurangabad', stateId: 5 },
    { id: 231, name: 'Bagaha', stateId: 5 },
    { id: 232, name: 'Bahadurganj', stateId: 5 },
    { id: 233, name: 'Bahadurpur', stateId: 5 },
    { id: 234, name: 'Baikunthpur', stateId: 5 },
    { id: 235, name: 'Bakhtiarpur', stateId: 5 },
    { id: 236, name: 'Banka', stateId: 5 },
    { id: 237, name: 'Barahiya', stateId: 5 },
    { id: 238, name: 'Barh', stateId: 5 },
    { id: 239, name: 'Begusarai', stateId: 5 },
    { id: 240, name: 'Behea', stateId: 5 },
    { id: 241, name: 'Belsand', stateId: 5 },
    { id: 242, name: 'Betia', stateId: 5 },
    { id: 243, name: 'Bettiah', stateId: 5 },
    { id: 244, name: 'Bhabua', stateId: 5 },
    { id: 245, name: 'Bhagalpur', stateId: 5 },
    { id: 246, name: 'Bhagwanpur', stateId: 5 },
    { id: 247, name: 'Biharsharif', stateId: 5 },
    { id: 248, name: 'Bikramganj', stateId: 5 },
    { id: 249, name: 'Birpur', stateId: 5 },
    { id: 250, name: 'Bodh Gaya', stateId: 5 },
    { id: 251, name: 'Buxar', stateId: 5 },
    { id: 252, name: 'Chanpatia', stateId: 5 },
    { id: 253, name: 'Chapra', stateId: 5 },
    { id: 254, name: 'Colgong', stateId: 5 },
    { id: 255, name: 'Darbhanga', stateId: 5 },
    { id: 256, name: 'Daudnagar', stateId: 5 },
    { id: 257, name: 'Dhaka', stateId: 5 },
    { id: 258, name: 'Dighalbank', stateId: 5 },
    { id: 259, name: 'Dighwara', stateId: 5 },
    { id: 260, name: 'Durgawati', stateId: 5 },
    { id: 261, name: 'Forbesganj', stateId: 5 },
    { id: 262, name: 'Gaya', stateId: 5 },
    { id: 263, name: 'Ghoghardiha', stateId: 5 },
    { id: 264, name: 'Ghoshi', stateId: 5 },
    { id: 265, name: 'Gidhaur', stateId: 5 },
    { id: 266, name: 'Gopalganj', stateId: 5 },
    { id: 267, name: 'Hajipur', stateId: 5 },
    { id: 268, name: 'Hazipur', stateId: 5 },
    { id: 269, name: 'Hilsa', stateId: 5 },
    { id: 270, name: 'Islampur', stateId: 5 },
    { id: 271, name: 'Jagdishpur', stateId: 5 },
    { id: 272, name: 'Jahanabad', stateId: 5 },
    { id: 273, name: 'Jainagar', stateId: 5 },
    { id: 274, name: 'Jamalpur', stateId: 5 },
    { id: 275, name: 'Jamui', stateId: 5 },
    { id: 276, name: 'Jhajha', stateId: 5 },
    { id: 277, name: 'Jhanjharpur', stateId: 5 },
    { id: 278, name: 'Jogbani', stateId: 5 },
    { id: 279, name: 'Kaimur', stateId: 5 },
    { id: 280, name: 'Kanti', stateId: 5 },
    { id: 281, name: 'Karpi', stateId: 5 },
    { id: 282, name: 'Kasba', stateId: 5 },
    { id: 283, name: 'Khagaria', stateId: 5 },
    { id: 284, name: 'Khagaul', stateId: 5 },
    { id: 285, name: 'Khusrupur', stateId: 5 },
    { id: 286, name: 'Kishanganj', stateId: 5 },
    { id: 287, name: 'Koath', stateId: 5 },
    { id: 288, name: 'Koilwar', stateId: 5 },
    { id: 289, name: 'Lakhisarai', stateId: 5 },
    { id: 290, name: 'Lalganj', stateId: 5 },
    { id: 291, name: 'Madhepura', stateId: 5 },
    { id: 292, name: 'Madhubani', stateId: 5 },
    { id: 293, name: 'Maharajganj', stateId: 5 },
    { id: 294, name: 'Mairwa', stateId: 5 },
    { id: 295, name: 'Makhdumpur', stateId: 5 },
    { id: 296, name: 'Maner', stateId: 5 },
    { id: 297, name: 'Manihari', stateId: 5 },
    { id: 298, name: 'Masaurhi', stateId: 5 },
    { id: 299, name: 'Mirganj', stateId: 5 },
    { id: 300, name: 'Mohiuddinagar', stateId: 5 },
    { id: 301, name: 'Motihari', stateId: 5 },
    { id: 302, name: 'Motipur', stateId: 5 },
    { id: 303, name: 'Munger', stateId: 5 },
    { id: 304, name: 'Murliganj', stateId: 5 },
    { id: 305, name: 'Muzaffarpur', stateId: 5 },
    { id: 306, name: 'Nabinagar', stateId: 5 },
    { id: 307, name: 'Narkatiaganj', stateId: 5 },
    { id: 308, name: 'Nawada', stateId: 5 },
    { id: 309, name: 'Nirmali', stateId: 5 },
    { id: 310, name: 'Patna', stateId: 5 },
    { id: 311, name: 'Purnia', stateId: 5 },
    { id: 312, name: 'Rafiganj', stateId: 5 },
    { id: 313, name: 'Raghunathpur', stateId: 5 },
    { id: 314, name: 'Rajgir', stateId: 5 },
    { id: 315, name: 'Revelganj', stateId: 5 },
    { id: 316, name: 'Saharsa', stateId: 5 },
    { id: 317, name: 'Samastipur', stateId: 5 },
    { id: 318, name: 'Saran', stateId: 5 },
    { id: 319, name: 'Sasara', stateId: 5 },
    { id: 320, name: 'Sheikhpura', stateId: 5 },
    { id: 321, name: 'Sheohar', stateId: 5 },
    { id: 322, name: 'Sherghati', stateId: 5 },
    { id: 323, name: 'Silao', stateId: 5 },
    { id: 324, name: 'Sitamarhi', stateId: 5 },
    { id: 325, name: 'Siwan', stateId: 5 },
    { id: 326, name: 'Sonepur', stateId: 5 },
    { id: 327, name: 'Sugauli', stateId: 5 },
    { id: 328, name: 'Sultanganj', stateId: 5 },
    { id: 329, name: 'Supaul', stateId: 5 },
    { id: 330, name: 'Tekari', stateId: 5 },
    { id: 331, name: 'Warisaliganj', stateId: 5 },
    { id: 2933, name: 'Vaishali', stateId: 5 },
    { id: 2936, name: 'West Champaran', stateId: 5 },
    { id: 2950, name: 'Chenari', stateId: 5 },
    { id: 2959, name: 'East Champaran', stateId: 5 },
    { id: 2965, name: 'Masuri', stateId: 5 },
    { id: 2969, name: 'Rohtas', stateId: 5 },
    { id: 3005, name: 'ARWAL', stateId: 5 },
    { id: 3006, name: 'AURANAGABAD', stateId: 5 },
    { id: 3007, name: 'BHOJPUR', stateId: 5 },
    { id: 3008, name: 'JEHANABAD', stateId: 5 },
    { id: 3009, name: 'KAIMUR BHABUA', stateId: 5 },
    { id: 3010, name: 'NA', stateId: 5 },
    { id: 3011, name: 'NALANDA', stateId: 5 },
    { id: 332, name: 'Chandigarh', stateId: 6 },
    { id: 333, name: 'Akaltara', stateId: 7 },
    { id: 334, name: 'Ambikapur', stateId: 7 },
    { id: 335, name: 'Arang', stateId: 7 },
    { id: 336, name: 'Baikunthpur', stateId: 7 },
    { id: 337, name: 'Baloda', stateId: 7 },
    { id: 338, name: 'Bhanpuri', stateId: 7 },
    { id: 339, name: 'Bhatapara', stateId: 7 },
    { id: 340, name: 'Bhatgaon', stateId: 7 },
    { id: 341, name: 'Bilaspur', stateId: 7 },
    { id: 342, name: 'Bilha', stateId: 7 },
    { id: 343, name: 'Birgaon', stateId: 7 },
    { id: 344, name: 'Champa', stateId: 7 },
    { id: 345, name: 'Dantewada', stateId: 7 },
    { id: 346, name: 'Dhamtari', stateId: 7 },
    { id: 347, name: 'Dongargaon', stateId: 7 },
    { id: 348, name: 'Durg', stateId: 7 },
    { id: 349, name: 'Geedam', stateId: 7 },
    { id: 350, name: 'Gharghoda', stateId: 7 },
    { id: 351, name: 'Jagdalpur', stateId: 7 },
    { id: 352, name: 'Janjgir - Champa', stateId: 7 },
    { id: 353, name: 'Jashpur', stateId: 7 },
    { id: 354, name: 'Kanker', stateId: 7 },
    { id: 355, name: 'Katghora', stateId: 7 },
    { id: 356, name: 'Kawardha', stateId: 7 },
    { id: 357, name: 'Khairagarh', stateId: 7 },
    { id: 358, name: 'Kharod', stateId: 7 },
    { id: 359, name: 'Kharsia', stateId: 7 },
    { id: 360, name: 'Kirandul', stateId: 7 },
    { id: 361, name: 'Kondagaon', stateId: 7 },
    { id: 362, name: 'Korba', stateId: 7 },
    { id: 363, name: 'Kurud', stateId: 7 },
    { id: 364, name: 'Mahasamund', stateId: 7 },
    { id: 365, name: 'Manendragarh', stateId: 7 },
    { id: 366, name: 'Mungeli', stateId: 7 },
    { id: 367, name: 'Patan', stateId: 7 },
    { id: 368, name: 'Pendra', stateId: 7 },
    { id: 369, name: 'Raigarh', stateId: 7 },
    { id: 370, name: 'Raipur', stateId: 7 },
    { id: 371, name: 'Rajnandgaon', stateId: 7 },
    { id: 372, name: 'Ratanpur', stateId: 7 },
    { id: 373, name: 'Sakti', stateId: 7 },
    { id: 374, name: 'Saraipali', stateId: 7 },
    { id: 375, name: 'Sarangarh', stateId: 7 },
    { id: 376, name: 'Simga', stateId: 7 },
    { id: 377, name: 'Surajpur', stateId: 7 },
    { id: 378, name: 'Takhatpur', stateId: 7 },
    { id: 2809, name: 'Bhilai', stateId: 7 },
    { id: 2947, name: 'Janakpur', stateId: 7 },
    { id: 2957, name: 'Balod', stateId: 7 },
    { id: 3164, name: 'BALOD BAZER', stateId: 7 },
    { id: 3165, name: 'Bastar', stateId: 7 },
    { id: 3166, name: 'BEMETARA', stateId: 7 },
    { id: 3167, name: 'Bijapur(CGH)', stateId: 7 },
    { id: 3168, name: 'BILASPURCGH', stateId: 7 },
    { id: 3169, name: 'GARIABAND', stateId: 7 },
    { id: 3170, name: 'JANJGIRCHAMPA', stateId: 7 },
    { id: 3171, name: 'Janjgir-Champa', stateId: 7 },
    { id: 3172, name: 'KORIYA', stateId: 7 },
    { id: 3173, name: 'Makdi', stateId: 7 },
    { id: 3174, name: 'SUKMA', stateId: 7 },
    { id: 379, name: 'Silvasa', stateId: 8 },
    { id: 3176, name: 'DADRA NAGAR HAVELI', stateId: 8 },
    { id: 380, name: 'Daman', stateId: 9 },
    { id: 381, name: 'Diu', stateId: 9 },
    { id: 382, name: 'New Delhi', stateId: 10 },
    { id: 3012, name: 'CENTRAL DELHI', stateId: 10 },
    { id: 3013, name: 'EAST DELHI', stateId: 10 },
    { id: 3014, name: 'NORTH DELHI', stateId: 10 },
    { id: 3015, name: 'NORTH EAST DELHI', stateId: 10 },
    { id: 3016, name: 'NORTH WEST DELHI', stateId: 10 },
    { id: 3017, name: 'SHAHDARA', stateId: 10 },
    { id: 3018, name: 'SOUTH DELHI', stateId: 10 },
    { id: 3019, name: 'SOUTH WEST DELHI', stateId: 10 },
    { id: 3020, name: 'WEST DELHI', stateId: 10 },
    { id: 383, name: 'Aldana', stateId: 11 },
    { id: 384, name: 'Aquem', stateId: 11 },
    { id: 385, name: 'Calangute', stateId: 11 },
    { id: 386, name: 'Canacona', stateId: 11 },
    { id: 387, name: 'Candolim', stateId: 11 },
    { id: 388, name: 'Chicalim', stateId: 11 },
    { id: 389, name: 'Colvale', stateId: 11 },
    { id: 390, name: 'Cuncolim', stateId: 11 },
    { id: 391, name: 'Goa Velha', stateId: 11 },
    { id: 392, name: 'Margao', stateId: 11 },
    { id: 393, name: 'Navelim', stateId: 11 },
    { id: 394, name: 'Pale', stateId: 11 },
    { id: 395, name: 'Panaji', stateId: 11 },
    { id: 396, name: 'Pernem', stateId: 11 },
    { id: 397, name: 'Ponda', stateId: 11 },
    { id: 398, name: 'Queula', stateId: 11 },
    { id: 399, name: 'Saligao', stateId: 11 },
    { id: 400, name: 'Sanquelim', stateId: 11 },
    { id: 401, name: 'Siolim', stateId: 11 },
    { id: 402, name: 'Valpoi', stateId: 11 },
    { id: 2770, name: 'Margaon', stateId: 11 },
    { id: 2795, name: 'Mapusa', stateId: 11 },
    { id: 2796, name: 'Vasco', stateId: 11 },
    { id: 2918, name: 'Curchorem', stateId: 11 },
    { id: 2925, name: 'Sancoale', stateId: 11 },
    { id: 2927, name: 'North Goa', stateId: 11 },
    { id: 2928, name: 'South Goa', stateId: 11 },
    { id: 403, name: 'Abrama', stateId: 12 },
    { id: 404, name: 'Adalaj', stateId: 12 },
    { id: 405, name: 'Ahmedabad', stateId: 12 },
    { id: 406, name: 'Ambaji', stateId: 12 },
    { id: 407, name: 'Amreli', stateId: 12 },
    { id: 408, name: 'Anand', stateId: 12 },
    { id: 409, name: 'Andada', stateId: 12 },
    { id: 410, name: 'Anjar', stateId: 12 },
    { id: 411, name: 'Atul', stateId: 12 },
    { id: 412, name: 'Bantwa', stateId: 12 },
    { id: 413, name: 'Bavla', stateId: 12 },
    { id: 414, name: 'Bhachau', stateId: 12 },
    { id: 415, name: 'Bhanvad', stateId: 12 },
    { id: 416, name: 'Bharuch', stateId: 12 },
    { id: 417, name: 'Bhavnagar', stateId: 12 },
    { id: 418, name: 'Bhayavadar', stateId: 12 },
    { id: 419, name: 'Bhuj', stateId: 12 },
    { id: 420, name: 'Bodeli', stateId: 12 },
    { id: 421, name: 'Boriavi', stateId: 12 },
    { id: 422, name: 'Borsad', stateId: 12 },
    { id: 423, name: 'Botad', stateId: 12 },
    { id: 424, name: 'Chaklasi', stateId: 12 },
    { id: 425, name: 'Chalala', stateId: 12 },
    { id: 426, name: 'Chalthan', stateId: 12 },
    { id: 427, name: 'Chanasma', stateId: 12 },
    { id: 428, name: 'Chhaya', stateId: 12 },
    { id: 429, name: 'Chikhli', stateId: 12 },
    { id: 430, name: 'Chorvad', stateId: 12 },
    { id: 431, name: 'Dabhoi', stateId: 12 },
    { id: 432, name: 'Dahegam', stateId: 12 },
    { id: 433, name: 'Dakor', stateId: 12 },
    { id: 434, name: 'Damnagar', stateId: 12 },
    { id: 435, name: 'Devsar', stateId: 12 },
    { id: 436, name: 'Dhandhuka', stateId: 12 },
    { id: 437, name: 'Dhanera', stateId: 12 },
    { id: 438, name: 'Dharampur', stateId: 12 },
    { id: 439, name: 'Dhola', stateId: 12 },
    { id: 440, name: 'Dholka', stateId: 12 },
    { id: 441, name: 'Dhrangadhra', stateId: 12 },
    { id: 442, name: 'Dhrol', stateId: 12 },
    { id: 443, name: 'Digvijaygram', stateId: 12 },
    { id: 444, name: 'Dohad', stateId: 12 },
    { id: 445, name: 'Dwarka', stateId: 12 },
    { id: 446, name: 'Gandevi', stateId: 12 },
    { id: 447, name: 'Gandhinagar', stateId: 12 },
    { id: 448, name: 'Godhara', stateId: 12 },
    { id: 449, name: 'Godhra', stateId: 12 },
    { id: 450, name: 'Gondal', stateId: 12 },
    { id: 451, name: 'Halol', stateId: 12 },
    { id: 452, name: 'Harij', stateId: 12 },
    { id: 453, name: 'Himatnagar', stateId: 12 },
    { id: 454, name: 'Idar', stateId: 12 },
    { id: 455, name: 'Jafrabad', stateId: 12 },
    { id: 456, name: 'Jalalpore', stateId: 12 },
    { id: 457, name: 'Jam Jodhpur', stateId: 12 },
    { id: 458, name: 'Jamnagar', stateId: 12 },
    { id: 459, name: 'Jasdan', stateId: 12 },
    { id: 460, name: 'Junagadh', stateId: 12 },
    { id: 461, name: 'Kadi', stateId: 12 },
    { id: 462, name: 'Kadodara', stateId: 12 },
    { id: 463, name: 'Kalavad', stateId: 12 },
    { id: 464, name: 'Kalol', stateId: 12 },
    { id: 465, name: 'Kanodar', stateId: 12 },
    { id: 466, name: 'Karamsad', stateId: 12 },
    { id: 467, name: 'Keshod', stateId: 12 },
    { id: 468, name: 'Khambhalia', stateId: 12 },
    { id: 469, name: 'Khambhat', stateId: 12 },
    { id: 470, name: 'Kharaghoda', stateId: 12 },
    { id: 471, name: 'Kheda', stateId: 12 },
    { id: 472, name: 'Khedbrahma', stateId: 12 },
    { id: 473, name: 'Kheralu', stateId: 12 },
    { id: 474, name: 'Kutiyana', stateId: 12 },
    { id: 475, name: 'Lathi', stateId: 12 },
    { id: 476, name: 'Limbdi', stateId: 12 },
    { id: 477, name: 'Lunawada', stateId: 12 },
    { id: 478, name: 'Mahesana', stateId: 12 },
    { id: 479, name: 'Mahudha', stateId: 12 },
    { id: 480, name: 'Mahuva', stateId: 12 },
    { id: 481, name: 'Malpur', stateId: 12 },
    { id: 482, name: 'Manavadar', stateId: 12 },
    { id: 483, name: 'Mandvi', stateId: 12 },
    { id: 484, name: 'Mangrol', stateId: 12 },
    { id: 485, name: 'Meghraj', stateId: 12 },
    { id: 486, name: 'Mithapur', stateId: 12 },
    { id: 487, name: 'Modasa', stateId: 12 },
    { id: 488, name: 'Mundra', stateId: 12 },
    { id: 489, name: 'Nadiad', stateId: 12 },
    { id: 490, name: 'Nandej', stateId: 12 },
    { id: 491, name: 'Navsari', stateId: 12 },
    { id: 492, name: 'Ode', stateId: 12 },
    { id: 493, name: 'Paddhari', stateId: 12 },
    { id: 494, name: 'Padra', stateId: 12 },
    { id: 495, name: 'Palanpur', stateId: 12 },
    { id: 496, name: 'Palej', stateId: 12 },
    { id: 497, name: 'Palitana', stateId: 12 },
    { id: 498, name: 'Patan', stateId: 12 },
    { id: 499, name: 'Petlad', stateId: 12 },
    { id: 500, name: 'Porbandar', stateId: 12 },
    { id: 501, name: 'Prantij', stateId: 12 },
    { id: 502, name: 'Radhanpur', stateId: 12 },
    { id: 503, name: 'Rajkot', stateId: 12 },
    { id: 504, name: 'Rajpipla', stateId: 12 },
    { id: 505, name: 'Rajula', stateId: 12 },
    { id: 506, name: 'Ramol', stateId: 12 },
    { id: 507, name: 'Ranavav', stateId: 12 },
    { id: 508, name: 'Ranip', stateId: 12 },
    { id: 509, name: 'Ranoli', stateId: 12 },
    { id: 510, name: 'Sachin', stateId: 12 },
    { id: 511, name: 'Salaya', stateId: 12 },
    { id: 512, name: 'Sanand', stateId: 12 },
    { id: 513, name: 'Santrampur', stateId: 12 },
    { id: 514, name: 'Savarkundla', stateId: 12 },
    { id: 515, name: 'Sayan', stateId: 12 },
    { id: 516, name: 'Sidhpur', stateId: 12 },
    { id: 517, name: 'Sihor', stateId: 12 },
    { id: 518, name: 'Songadh', stateId: 12 },
    { id: 519, name: 'Surat', stateId: 12 },
    { id: 520, name: 'Surendranagar', stateId: 12 },
    { id: 521, name: 'Talaja', stateId: 12 },
    { id: 522, name: 'Talod', stateId: 12 },
    { id: 523, name: 'Thangadh', stateId: 12 },
    { id: 524, name: 'Tharad', stateId: 12 },
    { id: 525, name: 'The Dangs', stateId: 12 },
    { id: 526, name: 'Umreth', stateId: 12 },
    { id: 527, name: 'Un', stateId: 12 },
    { id: 528, name: 'Unjha', stateId: 12 },
    { id: 529, name: 'Upleta', stateId: 12 },
    { id: 530, name: 'Vadia', stateId: 12 },
    { id: 531, name: 'Vadodara', stateId: 12 },
    { id: 532, name: 'Valsad', stateId: 12 },
    { id: 533, name: 'Vapi', stateId: 12 },
    { id: 534, name: 'Vartej', stateId: 12 },
    { id: 535, name: 'Vastral', stateId: 12 },
    { id: 536, name: 'Vejalpur', stateId: 12 },
    { id: 537, name: 'Veraval', stateId: 12 },
    { id: 538, name: 'Vijapur', stateId: 12 },
    { id: 539, name: 'Viramgam', stateId: 12 },
    { id: 540, name: 'Visavadar', stateId: 12 },
    { id: 541, name: 'Visnagar', stateId: 12 },
    { id: 542, name: 'Vyara', stateId: 12 },
    { id: 543, name: 'Wankaner', stateId: 12 },
    { id: 2765, name: 'Baroda', stateId: 12 },
    { id: 2787, name: 'Bardoli', stateId: 12 },
    { id: 2788, name: 'Daman', stateId: 12 },
    { id: 2789, name: 'Silvassa', stateId: 12 },
    { id: 2799, name: 'Ankleshwar', stateId: 12 },
    { id: 2813, name: 'Bopal', stateId: 12 },
    { id: 2852, name: 'Panchmahal', stateId: 12 },
    { id: 2853, name: 'Madhapar', stateId: 12 },
    { id: 2860, name: 'Sabarkantha', stateId: 12 },
    { id: 2862, name: 'Tapi', stateId: 12 },
    { id: 2866, name: 'Gandhidham', stateId: 12 },
    { id: 2867, name: 'Banaskantha', stateId: 12 },
    { id: 2868, name: 'Dahod', stateId: 12 },
    { id: 2896, name: 'Umergaon', stateId: 12 },
    { id: 2909, name: 'Umargam', stateId: 12 },
    { id: 2929, name: 'Lakhpat', stateId: 12 },
    { id: 2949, name: 'Kachchh', stateId: 12 },
    { id: 2956, name: 'Jhalod', stateId: 12 },
    { id: 2958, name: 'Jegol', stateId: 12 },
    { id: 2967, name: 'Arvalli', stateId: 12 },
    { id: 3021, name: 'Ahmedabad City', stateId: 12 },
    { id: 3022, name: 'ARAVALLI', stateId: 12 },
    { id: 3023, name: 'BOTAB', stateId: 12 },
    { id: 3024, name: 'CHHOTA UDEPUR', stateId: 12 },
    { id: 3025, name: 'Chhotaudepur', stateId: 12 },
    { id: 3026, name: 'DANGS', stateId: 12 },
    { id: 3027, name: 'DEVBHOOMI DWERKA', stateId: 12 },
    { id: 3028, name: 'GIR SOMNATH', stateId: 12 },
    { id: 3029, name: 'MAHISAGAR', stateId: 12 },
    { id: 3030, name: 'MORBI', stateId: 12 },
    { id: 3031, name: 'NA', stateId: 12 },
    { id: 3032, name: 'NARMADA', stateId: 12 },
    { id: 3033, name: 'PANCH MAHALS', stateId: 12 },
    { id: 3034, name: 'SURENDRA NAGAR', stateId: 12 },
    { id: 3227, name: 'Ankle', stateId: 12 },
    { id: 544, name: 'Ambala', stateId: 13 },
    { id: 545, name: 'Assandh', stateId: 13 },
    { id: 546, name: 'Bahadurgarh', stateId: 13 },
    { id: 547, name: 'Barwala', stateId: 13 },
    { id: 548, name: 'Bawal', stateId: 13 },
    { id: 549, name: 'Bawani Khera', stateId: 13 },
    { id: 550, name: 'Beri', stateId: 13 },
    { id: 551, name: 'Bhiwani', stateId: 13 },
    { id: 552, name: 'Bilaspur', stateId: 13 },
    { id: 553, name: 'Charkhi Dadri', stateId: 13 },
    { id: 554, name: 'Chhachhrauli', stateId: 13 },
    { id: 555, name: 'Dharuhera', stateId: 13 },
    { id: 556, name: 'Ellenabad', stateId: 13 },
    { id: 557, name: 'Faridabad', stateId: 13 },
    { id: 558, name: 'Fatehabad', stateId: 13 },
    { id: 559, name: 'Fatehbad', stateId: 13 },
    { id: 560, name: 'Ferozepur Jhirka', stateId: 13 },
    { id: 561, name: 'Ganaur', stateId: 13 },
    { id: 562, name: 'Gharaunda', stateId: 13 },
    { id: 563, name: 'Gohana', stateId: 13 },
    { id: 564, name: 'Gurgaon', stateId: 13 },
    { id: 565, name: 'Hansi', stateId: 13 },
    { id: 566, name: 'Hassanpur', stateId: 13 },
    { id: 567, name: 'Hathin', stateId: 13 },
    { id: 568, name: 'Hissar', stateId: 13 },
    { id: 569, name: 'Jagadhri', stateId: 13 },
    { id: 570, name: 'Jakhal Mandi', stateId: 13 },
    { id: 571, name: 'Jhajjar', stateId: 13 },
    { id: 572, name: 'Jind', stateId: 13 },
    { id: 573, name: 'Julana', stateId: 13 },
    { id: 574, name: 'Kaithal', stateId: 13 },
    { id: 575, name: 'Kalanaur', stateId: 13 },
    { id: 576, name: 'Kalka', stateId: 13 },
    { id: 577, name: 'Kanina', stateId: 13 },
    { id: 578, name: 'Karnal', stateId: 13 },
    { id: 579, name: 'Kurukshetra', stateId: 13 },
    { id: 580, name: 'Ladwa', stateId: 13 },
    { id: 581, name: 'Loharu', stateId: 13 },
    { id: 582, name: 'Mandi Dabwali', stateId: 13 },
    { id: 583, name: 'Mustafabad', stateId: 13 },
    { id: 584, name: 'Naraingarh', stateId: 13 },
    { id: 585, name: 'Narnaul', stateId: 13 },
    { id: 586, name: 'Narnaund', stateId: 13 },
    { id: 587, name: 'Narwana', stateId: 13 },
    { id: 588, name: 'Nilokheri', stateId: 13 },
    { id: 589, name: 'Nuh', stateId: 13 },
    { id: 590, name: 'Palwal', stateId: 13 },
    { id: 591, name: 'Panchkula', stateId: 13 },
    { id: 592, name: 'Panipat', stateId: 13 },
    { id: 593, name: 'Pataudi', stateId: 13 },
    { id: 594, name: 'Pehowa', stateId: 13 },
    { id: 595, name: 'Pinjore', stateId: 13 },
    { id: 596, name: 'Pundri', stateId: 13 },
    { id: 597, name: 'Radaur', stateId: 13 },
    { id: 598, name: 'Raipur Rani', stateId: 13 },
    { id: 599, name: 'Rania', stateId: 13 },
    { id: 600, name: 'Rewari', stateId: 13 },
    { id: 601, name: 'Rohtak', stateId: 13 },
    { id: 602, name: 'Safidon', stateId: 13 },
    { id: 603, name: 'Samalkha', stateId: 13 },
    { id: 604, name: 'Sirsa', stateId: 13 },
    { id: 605, name: 'Sohna', stateId: 13 },
    { id: 606, name: 'Sonepat', stateId: 13 },
    { id: 607, name: 'Tohana', stateId: 13 },
    { id: 608, name: 'Tosham', stateId: 13 },
    { id: 609, name: 'Uchana', stateId: 13 },
    { id: 610, name: 'Yamunanagar', stateId: 13 },
    { id: 2937, name: 'Mohindergarh', stateId: 13 },
    { id: 2974, name: 'Adampur', stateId: 13 },
    { id: 3035, name: 'Ambala City', stateId: 13 },
    { id: 3036, name: 'HISAR', stateId: 13 },
    { id: 3037, name: 'MAHENDRAGARH', stateId: 13 },
    { id: 3038, name: 'MEWAT', stateId: 13 },
    { id: 3039, name: 'SONIPAT', stateId: 13 },
    { id: 611, name: 'Bilaspur', stateId: 14 },
    { id: 612, name: 'Arki', stateId: 14 },
    { id: 613, name: 'Bakloh', stateId: 14 },
    { id: 614, name: 'Banjar', stateId: 14 },
    { id: 615, name: 'Bhota', stateId: 14 },
    { id: 616, name: 'Bhuntar', stateId: 14 },
    { id: 617, name: 'Bilaspur', stateId: 14 },
    { id: 618, name: 'Chamba', stateId: 14 },
    { id: 619, name: 'Dagshai', stateId: 14 },
    { id: 620, name: 'Daulatpur', stateId: 14 },
    { id: 621, name: 'Dharamasala', stateId: 14 },
    { id: 622, name: 'Gagret', stateId: 14 },
    { id: 623, name: 'Ghumarwin', stateId: 14 },
    { id: 624, name: 'Hamirpur', stateId: 14 },
    { id: 625, name: 'Jubbal', stateId: 14 },
    { id: 626, name: 'Jutogh', stateId: 14 },
    { id: 627, name: 'Kangra', stateId: 14 },
    { id: 628, name: 'Kasauli', stateId: 14 },
    { id: 629, name: 'Keylong', stateId: 14 },
    { id: 630, name: 'Kullu', stateId: 14 },
    { id: 631, name: 'Mandi', stateId: 14 },
    { id: 632, name: 'Nadaun', stateId: 14 },
    { id: 633, name: 'Nagrota Bagwan', stateId: 14 },
    { id: 634, name: 'Nahan', stateId: 14 },
    { id: 635, name: 'Nalagarh', stateId: 14 },
    { id: 636, name: 'Narkanda', stateId: 14 },
    { id: 637, name: 'Nurpur', stateId: 14 },
    { id: 638, name: 'Palampur', stateId: 14 },
    { id: 639, name: 'Paonta Sahib', stateId: 14 },
    { id: 640, name: 'Parwanoo', stateId: 14 },
    { id: 641, name: 'Rajgarh', stateId: 14 },
    { id: 642, name: 'Rampur', stateId: 14 },
    { id: 643, name: 'Reckong Peo', stateId: 14 },
    { id: 644, name: 'Rohru', stateId: 14 },
    { id: 645, name: 'Santokhgarh', stateId: 14 },
    { id: 646, name: 'Sarkaghat', stateId: 14 },
    { id: 647, name: 'Shimla', stateId: 14 },
    { id: 648, name: 'Solan', stateId: 14 },
    { id: 649, name: 'Theog', stateId: 14 },
    { id: 650, name: 'Una', stateId: 14 },
    { id: 2916, name: 'Sirmaur', stateId: 14 },
    { id: 2953, name: 'Kinnaur', stateId: 14 },
    { id: 3040, name: 'BILASPUR (HP)', stateId: 14 },
    { id: 3041, name: 'BILASPUR HP', stateId: 14 },
    { id: 3042, name: 'HAMIRPUR(HP)', stateId: 14 },
    { id: 3043, name: 'HAMIRPURHP', stateId: 14 },
    { id: 3044, name: 'LAHUL SPITI', stateId: 14 },
    { id: 3045, name: 'NA', stateId: 14 },
    { id: 651, name: 'Achabal', stateId: 15 },
    { id: 652, name: 'Anantnag', stateId: 15 },
    { id: 653, name: 'Arnia', stateId: 15 },
    { id: 654, name: 'Awantipora', stateId: 15 },
    { id: 655, name: 'Badgam', stateId: 15 },
    { id: 656, name: 'Banihal', stateId: 15 },
    { id: 657, name: 'Baramulla', stateId: 15 },
    { id: 658, name: 'Bari Brahmana', stateId: 15 },
    { id: 659, name: 'Batote', stateId: 15 },
    { id: 660, name: 'Beerwah', stateId: 15 },
    { id: 661, name: 'Bijbehara', stateId: 15 },
    { id: 662, name: 'Chenani', stateId: 15 },
    { id: 663, name: 'Doda', stateId: 15 },
    { id: 664, name: 'Ganderbal', stateId: 15 },
    { id: 665, name: 'Gulmarg', stateId: 15 },
    { id: 666, name: 'Hajan', stateId: 15 },
    { id: 667, name: 'Handwara', stateId: 15 },
    { id: 668, name: 'Jammu', stateId: 15 },
    { id: 669, name: 'Jourian', stateId: 15 },
    { id: 670, name: 'Kargil', stateId: 15 },
    { id: 671, name: 'Kathua', stateId: 15 },
    { id: 672, name: 'Katra', stateId: 15 },
    { id: 673, name: 'Khour', stateId: 15 },
    { id: 674, name: 'Khrew', stateId: 15 },
    { id: 675, name: 'Kishtwar', stateId: 15 },
    { id: 676, name: 'Kud', stateId: 15 },
    { id: 677, name: 'Kulgam', stateId: 15 },
    { id: 678, name: 'Kunzer', stateId: 15 },
    { id: 679, name: 'Kupwara', stateId: 15 },
    { id: 680, name: 'Leh', stateId: 15 },
    { id: 681, name: 'Magam', stateId: 15 },
    { id: 682, name: 'Pahalgam', stateId: 15 },
    { id: 683, name: 'Parole', stateId: 15 },
    { id: 684, name: 'Pattan', stateId: 15 },
    { id: 685, name: 'Poonch', stateId: 15 },
    { id: 686, name: 'Pulwama', stateId: 15 },
    { id: 687, name: 'Pulwana', stateId: 15 },
    { id: 688, name: 'Qazigund', stateId: 15 },
    { id: 689, name: 'Rajouri', stateId: 15 },
    { id: 690, name: 'Ramban', stateId: 15 },
    { id: 691, name: 'Ranbirsinghpora', stateId: 15 },
    { id: 692, name: 'Reasi', stateId: 15 },
    { id: 693, name: 'Samba', stateId: 15 },
    { id: 694, name: 'Sopore', stateId: 15 },
    { id: 695, name: 'Srinagar', stateId: 15 },
    { id: 696, name: 'Sumbal', stateId: 15 },
    { id: 697, name: 'Sunderbani', stateId: 15 },
    { id: 698, name: 'Tral', stateId: 15 },
    { id: 699, name: 'Udhampur', stateId: 15 },
    { id: 700, name: 'Uri', stateId: 15 },
    { id: 701, name: 'Vijay Pur', stateId: 15 },
    { id: 2960, name: 'Channi Himmat', stateId: 15 },
    { id: 3177, name: 'ANANTHNAG', stateId: 15 },
    { id: 3178, name: 'BANDIPUR', stateId: 15 },
    { id: 3179, name: 'BUDGAM', stateId: 15 },
    { id: 3180, name: 'RAJAURI', stateId: 15 },
    { id: 3181, name: 'SHOPIAN', stateId: 15 },
    { id: 702, name: 'Adityapur', stateId: 16 },
    { id: 703, name: 'Bermo', stateId: 16 },
    { id: 704, name: 'Bokaro', stateId: 16 },
    { id: 705, name: 'Bundu', stateId: 16 },
    { id: 706, name: 'Chakradharpur', stateId: 16 },
    { id: 707, name: 'Chandil', stateId: 16 },
    { id: 708, name: 'Chandrapura', stateId: 16 },
    { id: 709, name: 'Chas', stateId: 16 },
    { id: 710, name: 'Chatra', stateId: 16 },
    { id: 711, name: 'Chiria', stateId: 16 },
    { id: 712, name: 'Chirkunda', stateId: 16 },
    { id: 713, name: 'Deoghar', stateId: 16 },
    { id: 714, name: 'Dhanbad', stateId: 16 },
    { id: 715, name: 'Dumka', stateId: 16 },
    { id: 716, name: 'Garhwa', stateId: 16 },
    { id: 717, name: 'Ghatshila', stateId: 16 },
    { id: 718, name: 'Giridih', stateId: 16 },
    { id: 719, name: 'Gobindpur', stateId: 16 },
    { id: 720, name: 'Gomoh', stateId: 16 },
    { id: 721, name: 'Grahwa', stateId: 16 },
    { id: 722, name: 'Gua', stateId: 16 },
    { id: 723, name: 'Gumla', stateId: 16 },
    { id: 724, name: 'Hazaribagh', stateId: 16 },
    { id: 725, name: 'Jamadoba', stateId: 16 },
    { id: 726, name: 'Jamshedpur', stateId: 16 },
    { id: 727, name: 'Jamtara', stateId: 16 },
    { id: 728, name: 'Jaridih Bazar', stateId: 16 },
    { id: 729, name: 'Jasidih', stateId: 16 },
    { id: 730, name: 'Jharia', stateId: 16 },
    { id: 731, name: 'Jhinkpani', stateId: 16 },
    { id: 732, name: 'Jhumri Tilaiya', stateId: 16 },
    { id: 733, name: 'Jugsalai', stateId: 16 },
    { id: 734, name: 'Kandra', stateId: 16 },
    { id: 735, name: 'Kanke', stateId: 16 },
    { id: 736, name: 'Kedla', stateId: 16 },
    { id: 737, name: 'Khunti', stateId: 16 },
    { id: 738, name: 'Kodarma', stateId: 16 },
    { id: 739, name: 'Kuju', stateId: 16 },
    { id: 740, name: 'Latehar', stateId: 16 },
    { id: 741, name: 'Lohardaga', stateId: 16 },
    { id: 742, name: 'Madhupur', stateId: 16 },
    { id: 743, name: 'Malkera', stateId: 16 },
    { id: 744, name: 'Mango', stateId: 16 },
    { id: 745, name: 'Mihijam', stateId: 16 },
    { id: 746, name: 'Mugma', stateId: 16 },
    { id: 747, name: 'Noamundi', stateId: 16 },
    { id: 748, name: 'Pakaur', stateId: 16 },
    { id: 749, name: 'Palamu', stateId: 16 },
    { id: 750, name: 'Paschimi Singhbhum', stateId: 16 },
    { id: 751, name: 'Patratu', stateId: 16 },
    { id: 752, name: 'Rajmahal', stateId: 16 },
    { id: 753, name: 'Ranchi', stateId: 16 },
    { id: 754, name: 'Sahebganj', stateId: 16 },
    { id: 755, name: 'Sahibganj', stateId: 16 },
    { id: 756, name: 'Sijua', stateId: 16 },
    { id: 757, name: 'Simdega', stateId: 16 },
    { id: 758, name: 'Sindri', stateId: 16 },
    { id: 759, name: 'Sini', stateId: 16 },
    { id: 760, name: 'Sirka', stateId: 16 },
    { id: 761, name: 'Tisra', stateId: 16 },
    { id: 762, name: 'Topa', stateId: 16 },
    { id: 763, name: 'Topchanchi', stateId: 16 },
    { id: 2800, name: 'Ramgarh', stateId: 16 },
    { id: 2844, name: 'Chakuliya', stateId: 16 },
    { id: 2872, name: 'Godda', stateId: 16 },
    { id: 2943, name: 'Sonari', stateId: 16 },
    { id: 764, name: 'Belgaum', stateId: 17 },
    { id: 765, name: 'Adyar', stateId: 17 },
    { id: 766, name: 'Afzalpur', stateId: 17 },
    { id: 767, name: 'Aland', stateId: 17 },
    { id: 768, name: 'Alnavar', stateId: 17 },
    { id: 769, name: 'Alur', stateId: 17 },
    { id: 770, name: 'Anekal', stateId: 17 },
    { id: 771, name: 'Ankola', stateId: 17 },
    { id: 772, name: 'Annigeri', stateId: 17 },
    { id: 773, name: 'Arkalgud', stateId: 17 },
    { id: 774, name: 'Arsikere', stateId: 17 },
    { id: 775, name: 'Athni', stateId: 17 },
    { id: 776, name: 'Aurad', stateId: 17 },
    { id: 777, name: 'Badami', stateId: 17 },
    { id: 778, name: 'Bagalkot', stateId: 17 },
    { id: 779, name: 'Bagepalli', stateId: 17 },
    { id: 780, name: 'Bajpe', stateId: 17 },
    { id: 781, name: 'Bangalore', stateId: 17 },
    { id: 782, name: 'Bangalore North', stateId: 17 },
    { id: 783, name: 'Bangalore South', stateId: 17 },
    { id: 784, name: 'Bangarapet', stateId: 17 },
    { id: 785, name: 'Bannur', stateId: 17 },
    { id: 786, name: 'Bantwal', stateId: 17 },
    { id: 787, name: 'Basavakalyan', stateId: 17 },
    { id: 788, name: 'Basavana Bagevadi', stateId: 17 },
    { id: 789, name: 'Belgaum', stateId: 17 },
    { id: 790, name: 'Bellary', stateId: 17 },
    { id: 791, name: 'Belur', stateId: 17 },
    { id: 792, name: 'Bhadravati', stateId: 17 },
    { id: 793, name: 'Bhalki', stateId: 17 },
    { id: 794, name: 'Bhatkal', stateId: 17 },
    { id: 795, name: 'Bidar', stateId: 17 },
    { id: 796, name: 'Bijapur', stateId: 17 },
    { id: 797, name: 'Bilgi', stateId: 17 },
    { id: 798, name: 'Bommanahalli', stateId: 17 },
    { id: 799, name: 'Byadgi', stateId: 17 },
    { id: 800, name: 'Byatarayanapura', stateId: 17 },
    { id: 801, name: 'Challakere', stateId: 17 },
    { id: 802, name: 'Chamarajanagar', stateId: 17 },
    { id: 803, name: 'Channagiri', stateId: 17 },
    { id: 804, name: 'Channapatna', stateId: 17 },
    { id: 805, name: 'Channarayapatna', stateId: 17 },
    { id: 806, name: 'Chik Ballapur', stateId: 17 },
    { id: 807, name: 'Chikamaglur', stateId: 17 },
    { id: 808, name: 'Chikamangalur', stateId: 17 },
    { id: 809, name: 'Chikmagalur', stateId: 17 },
    { id: 810, name: 'Chiknayakanhalli', stateId: 17 },
    { id: 811, name: 'Chikodi', stateId: 17 },
    { id: 812, name: 'Chincholi', stateId: 17 },
    { id: 813, name: 'Chintamani', stateId: 17 },
    { id: 814, name: 'Chitapur', stateId: 17 },
    { id: 815, name: 'Chitradurga', stateId: 17 },
    { id: 816, name: 'Dandeli', stateId: 17 },
    { id: 817, name: 'Dasarahalli', stateId: 17 },
    { id: 818, name: 'Davanagere', stateId: 17 },
    { id: 819, name: 'Devadurga', stateId: 17 },
    { id: 820, name: 'Devanahalli', stateId: 17 },
    { id: 821, name: 'Dharwad', stateId: 17 },
    { id: 822, name: 'Dharwar', stateId: 17 },
    { id: 823, name: 'Dod Ballapur', stateId: 17 },
    { id: 824, name: 'Gadag', stateId: 17 },
    { id: 825, name: 'Gangawati', stateId: 17 },
    { id: 826, name: 'Gauribidanur', stateId: 17 },
    { id: 827, name: 'Gokak', stateId: 17 },
    { id: 828, name: 'Gonikoppal', stateId: 17 },
    { id: 829, name: 'Gubbi', stateId: 17 },
    { id: 830, name: 'Gulbarga', stateId: 17 },
    { id: 831, name: 'Gundlupet', stateId: 17 },
    { id: 832, name: 'Hadagalli', stateId: 17 },
    { id: 833, name: 'Hagaribommanahalli', stateId: 17 },
    { id: 834, name: 'Haliyal', stateId: 17 },
    { id: 835, name: 'Hangal', stateId: 17 },
    { id: 836, name: 'Harapanahalli', stateId: 17 },
    { id: 837, name: 'Harihar', stateId: 17 },
    { id: 838, name: 'Hassan', stateId: 17 },
    { id: 839, name: 'Haveri', stateId: 17 },
    { id: 840, name: 'Hebbalu', stateId: 17 },
    { id: 841, name: 'Heggadadevankote', stateId: 17 },
    { id: 842, name: 'Hirekerur', stateId: 17 },
    { id: 843, name: 'Hiriyur', stateId: 17 },
    { id: 844, name: 'Holalkere', stateId: 17 },
    { id: 845, name: 'Hole Narsipur', stateId: 17 },
    { id: 846, name: 'Homnabad', stateId: 17 },
    { id: 847, name: 'Honavar', stateId: 17 },
    { id: 848, name: 'Honnali', stateId: 17 },
    { id: 849, name: 'Hosadurga', stateId: 17 },
    { id: 850, name: 'Hosanagara', stateId: 17 },
    { id: 851, name: 'Hoskote', stateId: 17 },
    { id: 852, name: 'Hospet', stateId: 17 },
    { id: 853, name: 'Hubli', stateId: 17 },
    { id: 854, name: 'Hukeri', stateId: 17 },
    { id: 855, name: 'Hungund', stateId: 17 },
    { id: 856, name: 'Hunsur', stateId: 17 },
    { id: 857, name: 'Indi', stateId: 17 },
    { id: 858, name: 'Jagalur', stateId: 17 },
    { id: 859, name: 'Jamkhandi', stateId: 17 },
    { id: 860, name: 'Jevargi', stateId: 17 },
    { id: 861, name: 'Jog Falls', stateId: 17 },
    { id: 862, name: 'Kadur', stateId: 17 },
    { id: 863, name: 'Kalghatgi', stateId: 17 },
    { id: 864, name: 'Kampli', stateId: 17 },
    { id: 865, name: 'Kanakapura', stateId: 17 },
    { id: 866, name: 'Kannur', stateId: 17 },
    { id: 867, name: 'Karwar', stateId: 17 },
    { id: 868, name: 'Kengeri', stateId: 17 },
    { id: 869, name: 'Kerur', stateId: 17 },
    { id: 870, name: 'Khanapur', stateId: 17 },
    { id: 871, name: 'Kodigenahalli', stateId: 17 },
    { id: 872, name: 'Koduru', stateId: 17 },
    { id: 873, name: 'Kolar', stateId: 17 },
    { id: 874, name: 'Kollegal', stateId: 17 },
    { id: 875, name: 'Konnur', stateId: 17 },
    { id: 876, name: 'Koppa', stateId: 17 },
    { id: 877, name: 'Koppal', stateId: 17 },
    { id: 878, name: 'Koratagere', stateId: 17 },
    { id: 879, name: 'Kotturu', stateId: 17 },
    { id: 880, name: 'Krishnarajanagara', stateId: 17 },
    { id: 881, name: 'Krishnarajasagara', stateId: 17 },
    { id: 882, name: 'Krishnarajpet', stateId: 17 },
    { id: 883, name: 'Kudchi', stateId: 17 },
    { id: 884, name: 'Kudligi', stateId: 17 },
    { id: 885, name: 'Kudremukh', stateId: 17 },
    { id: 886, name: 'Kumta', stateId: 17 },
    { id: 887, name: 'Kundgol', stateId: 17 },
    { id: 888, name: 'Kunigal', stateId: 17 },
    { id: 889, name: 'Kushalnagar', stateId: 17 },
    { id: 890, name: 'Kushtagi', stateId: 17 },
    { id: 891, name: 'Lakshmeshwar', stateId: 17 },
    { id: 892, name: 'Lingsugur', stateId: 17 },
    { id: 893, name: 'Londa', stateId: 17 },
    { id: 894, name: 'Maddur', stateId: 17 },
    { id: 895, name: 'Madhugiri', stateId: 17 },
    { id: 896, name: 'Madikeri', stateId: 17 },
    { id: 897, name: 'Magadi', stateId: 17 },
    { id: 898, name: 'Mahadevapura', stateId: 17 },
    { id: 899, name: 'Malavalli', stateId: 17 },
    { id: 900, name: 'Malur', stateId: 17 },
    { id: 901, name: 'Mandya', stateId: 17 },
    { id: 902, name: 'Mangalore', stateId: 17 },
    { id: 903, name: 'Manvi', stateId: 17 },
    { id: 904, name: 'Muddebihal', stateId: 17 },
    { id: 905, name: 'Mudgal', stateId: 17 },
    { id: 906, name: 'Mudhol', stateId: 17 },
    { id: 907, name: 'Mudigere', stateId: 17 },
    { id: 908, name: 'Mulbagal', stateId: 17 },
    { id: 909, name: 'Mulgund', stateId: 17 },
    { id: 910, name: 'Mulki', stateId: 17 },
    { id: 911, name: 'Mundargi', stateId: 17 },
    { id: 912, name: 'Mundgod', stateId: 17 },
    { id: 913, name: 'Mysore', stateId: 17 },
    { id: 914, name: 'Nagamangala', stateId: 17 },
    { id: 915, name: 'Nanjangud', stateId: 17 },
    { id: 916, name: 'Narasimharajapura', stateId: 17 },
    { id: 917, name: 'Naregal', stateId: 17 },
    { id: 918, name: 'Navalgund', stateId: 17 },
    { id: 919, name: 'Nipani', stateId: 17 },
    { id: 920, name: 'Pandavapura', stateId: 17 },
    { id: 921, name: 'Pavagada', stateId: 17 },
    { id: 922, name: 'Piriyapatna', stateId: 17 },
    { id: 923, name: 'Pudu', stateId: 17 },
    { id: 924, name: 'Puttur', stateId: 17 },
    { id: 925, name: 'Raichur', stateId: 17 },
    { id: 926, name: 'Ramanagaram', stateId: 17 },
    { id: 927, name: 'Ramdurg', stateId: 17 },
    { id: 928, name: 'Ranibennur', stateId: 17 },
    { id: 929, name: 'Ron', stateId: 17 },
    { id: 930, name: 'Sagar', stateId: 17 },
    { id: 931, name: 'Sakleshpur', stateId: 17 },
    { id: 932, name: 'Saligram', stateId: 17 },
    { id: 933, name: 'Sandur', stateId: 17 },
    { id: 934, name: 'Sankeshwar', stateId: 17 },
    { id: 935, name: 'Savanur', stateId: 17 },
    { id: 936, name: 'Sedam', stateId: 17 },
    { id: 937, name: 'Shahabad', stateId: 17 },
    { id: 938, name: 'Shahpur', stateId: 17 },
    { id: 939, name: 'Shaktinagar', stateId: 17 },
    { id: 940, name: 'Shiggaon', stateId: 17 },
    { id: 941, name: 'Shikarpur', stateId: 17 },
    { id: 942, name: 'Shimoga', stateId: 17 },
    { id: 943, name: 'Shirhatti', stateId: 17 },
    { id: 944, name: 'Shorapur', stateId: 17 },
    { id: 945, name: 'Siddapur', stateId: 17 },
    { id: 946, name: 'Sidlaghatta', stateId: 17 },
    { id: 947, name: 'Sindgi', stateId: 17 },
    { id: 948, name: 'Sindhnur', stateId: 17 },
    { id: 949, name: 'Sira', stateId: 17 },
    { id: 950, name: 'Sirsi', stateId: 17 },
    { id: 951, name: 'Siruguppa', stateId: 17 },
    { id: 952, name: 'Somvarpet', stateId: 17 },
    { id: 953, name: 'Sorab', stateId: 17 },
    { id: 954, name: 'Sringeri', stateId: 17 },
    { id: 955, name: 'Srinivaspur', stateId: 17 },
    { id: 956, name: 'Supa', stateId: 17 },
    { id: 957, name: 'Tarikere', stateId: 17 },
    { id: 958, name: 'Tekkalakota', stateId: 17 },
    { id: 959, name: 'Terdal', stateId: 17 },
    { id: 960, name: 'Thumbe', stateId: 17 },
    { id: 961, name: 'Tiptur', stateId: 17 },
    { id: 962, name: 'Tirthahalli', stateId: 17 },
    { id: 963, name: 'Tirumakudal Narsipur', stateId: 17 },
    { id: 964, name: 'Tumkur', stateId: 17 },
    { id: 965, name: 'Turuvekere', stateId: 17 },
    { id: 966, name: 'Udupi', stateId: 17 },
    { id: 967, name: 'Ullal', stateId: 17 },
    { id: 968, name: 'Venkatapura', stateId: 17 },
    { id: 969, name: 'Vijayapura', stateId: 17 },
    { id: 970, name: 'Virajpet', stateId: 17 },
    { id: 971, name: 'Wadi', stateId: 17 },
    { id: 972, name: 'Yadgir', stateId: 17 },
    { id: 973, name: 'Yelahanka', stateId: 17 },
    { id: 974, name: 'Yelandur', stateId: 17 },
    { id: 975, name: 'Yelbarga', stateId: 17 },
    { id: 976, name: 'Yellapur', stateId: 17 },
    { id: 977, name: 'Bommasandra', stateId: 17 },
    { id: 978, name: 'Belagavi', stateId: 17 },
    { id: 979, name: 'Srirangapatna', stateId: 17 },
    { id: 980, name: 'Sullia', stateId: 17 },
    { id: 981, name: 'Kodagu', stateId: 17 },
    { id: 982, name: 'Bailhongal', stateId: 17 },
    { id: 983, name: 'BALLARI', stateId: 17 },
    { id: 984, name: 'BENGALURU', stateId: 17 },
    { id: 985, name: 'BENGALURU RURAL', stateId: 17 },
    { id: 986, name: 'BIJAPUR(KAR)', stateId: 17 },
    { id: 987, name: 'Chamrajnagar', stateId: 17 },
    { id: 988, name: 'CHICKMAGALUR', stateId: 17 },
    { id: 989, name: 'CHIKKABALLAPUR', stateId: 17 },
    { id: 990, name: 'Chikkamagaluru', stateId: 17 },
    { id: 991, name: 'Dakshina Kannada', stateId: 17 },
    { id: 992, name: 'DAVANGERE', stateId: 17 },
    { id: 993, name: 'Hanagodu', stateId: 17 },
    { id: 994, name: 'Hubballi', stateId: 17 },
    { id: 995, name: 'Joida', stateId: 17 },
    { id: 996, name: 'KALABURAGI', stateId: 17 },
    { id: 997, name: 'Mysuru', stateId: 17 },
    { id: 998, name: 'RAMANAGAR', stateId: 17 },
    { id: 999, name: 'Ramanagara', stateId: 17 },
    { id: 1000, name: 'Saraswathipuram', stateId: 17 },
    { id: 1001, name: 'SHIVAMOGGA', stateId: 17 },
    { id: 1002, name: 'TUMAKURU', stateId: 17 },
    { id: 1003, name: 'UTTARA KANNADA', stateId: 17 },
    { id: 1004, name: 'Kodlipet', stateId: 17 },
    { id: 978, name: 'Alappuzha', stateId: 18 },
    { id: 979, name: 'Alleppey', stateId: 18 },
    { id: 980, name: 'Aluva', stateId: 18 },
    { id: 981, name: 'Arookutty', stateId: 18 },
    { id: 982, name: 'Aroor', stateId: 18 },
    { id: 983, name: 'Attingal', stateId: 18 },
    { id: 984, name: 'Azhikode South', stateId: 18 },
    { id: 985, name: 'Beypore', stateId: 18 },
    { id: 986, name: 'Brahmakulam', stateId: 18 },
    { id: 987, name: 'Cannanore (Kannur)', stateId: 18 },
    { id: 988, name: 'Changanassery', stateId: 18 },
    { id: 989, name: 'Chavakkad', stateId: 18 },
    { id: 990, name: 'Chendamangalam', stateId: 18 },
    { id: 991, name: 'Chengamanad', stateId: 18 },
    { id: 992, name: 'Chengannur', stateId: 18 },
    { id: 993, name: 'Cheranallur', stateId: 18 },
    { id: 994, name: 'Cherthala', stateId: 18 },
    { id: 995, name: 'Chirakkal', stateId: 18 },
    { id: 996, name: 'Chirayinkeezhu', stateId: 18 },
    { id: 997, name: 'Devikulam', stateId: 18 },
    { id: 998, name: 'Dharmadom', stateId: 18 },
    { id: 999, name: 'Edathala', stateId: 18 },
    { id: 1000, name: 'Eranholi', stateId: 18 },
    { id: 1001, name: 'Ernad', stateId: 18 },
    { id: 1002, name: 'Ernakulam', stateId: 18 },
    { id: 1003, name: 'Hosdurg', stateId: 18 },
    { id: 1004, name: 'Iduki', stateId: 18 },
    { id: 1005, name: 'Irinjalakuda', stateId: 18 },
    { id: 1006, name: 'Kadachira', stateId: 18 },
    { id: 1007, name: 'Kadambur', stateId: 18 },
    { id: 1008, name: 'Kalliasseri', stateId: 18 },
    { id: 1009, name: 'Kalpetta', stateId: 18 },
    { id: 1010, name: 'Kanayannur', stateId: 18 },
    { id: 1011, name: 'Kanhangad', stateId: 18 },
    { id: 1012, name: 'Kanhirode', stateId: 18 },
    { id: 1013, name: 'Kanjirappally', stateId: 18 },
    { id: 1014, name: 'Kannadiparamba', stateId: 18 },
    { id: 1015, name: 'Kannur', stateId: 18 },
    { id: 1016, name: 'Karthikappally', stateId: 18 },
    { id: 1017, name: 'Kasaragod', stateId: 18 },
    { id: 1018, name: 'Kasargode', stateId: 18 },
    { id: 1019, name: 'Kayamkulam', stateId: 18 },
    { id: 1020, name: 'Kochi', stateId: 18 },
    { id: 1021, name: 'Kodungallur', stateId: 18 },
    { id: 1022, name: 'Kollam', stateId: 18 },
    { id: 1023, name: 'Kothamangalam', stateId: 18 },
    { id: 1024, name: 'Kottarakkara', stateId: 18 },
    { id: 1025, name: 'Kottayam', stateId: 18 },
    { id: 1026, name: 'Kozhenchery', stateId: 18 },
    { id: 1027, name: 'Kozhikode', stateId: 18 },
    { id: 1028, name: 'Kudlu', stateId: 18 },
    { id: 1029, name: 'Kunnamkulam', stateId: 18 },
    { id: 1030, name: 'Kunnathunad', stateId: 18 },
    { id: 1031, name: 'Malappuram', stateId: 18 },
    { id: 1032, name: 'Malapuram', stateId: 18 },
    { id: 1033, name: 'Mallappally', stateId: 18 },
    { id: 1034, name: 'Mananthavady', stateId: 18 },
    { id: 1035, name: 'Manjeri', stateId: 18 },
    { id: 1036, name: 'Manjeshwar', stateId: 18 },
    { id: 1037, name: 'Mannarkad', stateId: 18 },
    { id: 1038, name: 'Maradu', stateId: 18 },
    { id: 1039, name: 'Mavoor', stateId: 18 },
    { id: 1040, name: 'Meenachil', stateId: 18 },
    { id: 1041, name: 'Methala', stateId: 18 },
    { id: 1042, name: 'Muhamma', stateId: 18 },
    { id: 1043, name: 'Mukundapuram', stateId: 18 },
    { id: 1044, name: 'Mulavukad', stateId: 18 },
    { id: 1045, name: 'Munderi', stateId: 18 },
    { id: 1046, name: 'Muvattupuzha', stateId: 18 },
    { id: 1047, name: 'Nadathara', stateId: 18 },
    { id: 1048, name: 'Nedumangad', stateId: 18 },
    { id: 1049, name: 'Neyyattinkara', stateId: 18 },
    { id: 1050, name: 'Nilambur', stateId: 18 },
    { id: 1051, name: 'Olavanna', stateId: 18 },
    { id: 1052, name: 'Ottappalam', stateId: 18 },
    { id: 1053, name: 'Palai', stateId: 18 },
    { id: 1054, name: 'Palakkad', stateId: 18 },
    { id: 1055, name: 'Palayad', stateId: 18 },
    { id: 1056, name: 'Palghat', stateId: 18 },
    { id: 1057, name: 'Paluvai', stateId: 18 },
    { id: 1058, name: 'Pappinisseri', stateId: 18 },
    { id: 1059, name: 'Pathanamthitta', stateId: 18 },
    { id: 1060, name: 'Pathiriyad', stateId: 18 },
    { id: 1061, name: 'Payyannur', stateId: 18 },
    { id: 1062, name: 'Peringathur', stateId: 18 },
    { id: 1063, name: 'Perinthalmanna', stateId: 18 },
    { id: 1064, name: 'Perumbaikad', stateId: 18 },
    { id: 1065, name: 'Perumbavoor', stateId: 18 },
    { id: 1066, name: 'Pottore', stateId: 18 },
    { id: 1067, name: 'Punalur', stateId: 18 },
    { id: 1068, name: 'Puranattukara', stateId: 18 },
    { id: 1069, name: 'Quilandy', stateId: 18 },
    { id: 1070, name: 'Ramanattukara', stateId: 18 },
    { id: 1071, name: 'Ranni', stateId: 18 },
    { id: 1072, name: 'Sulthanbathery', stateId: 18 },
    { id: 1073, name: 'Taliparamba', stateId: 18 },
    { id: 1074, name: 'Thaikkad', stateId: 18 },
    { id: 1075, name: 'Thalassery', stateId: 18 },
    { id: 1076, name: 'Thiruvananthapuram', stateId: 18 },
    { id: 1077, name: 'Thiruvankulam', stateId: 18 },
    { id: 1078, name: 'Thodupuzha', stateId: 18 },
    { id: 1079, name: 'Thottada', stateId: 18 },
    { id: 1080, name: 'Thrissur', stateId: 18 },
    { id: 1081, name: 'Tirur', stateId: 18 },
    { id: 1082, name: 'Tirurangadi', stateId: 18 },
    { id: 1083, name: 'Trivandrum', stateId: 18 },
    { id: 1084, name: 'Udma', stateId: 18 },
    { id: 1085, name: 'Udumbanchola', stateId: 18 },
    { id: 1086, name: 'Vadakara', stateId: 18 },
    { id: 1087, name: 'Vaikom', stateId: 18 },
    { id: 1088, name: 'Valapattanam', stateId: 18 },
    { id: 1089, name: 'Vallachira', stateId: 18 },
    { id: 1090, name: 'Varam', stateId: 18 },
    { id: 1091, name: 'Varkala', stateId: 18 },
    { id: 1092, name: 'Vythiri', stateId: 18 },
    { id: 1093, name: 'Wayanad', stateId: 18 },
    { id: 2859, name: 'Thiruvalla', stateId: 18 },
    { id: 3068, name: 'IDUKKI', stateId: 18 },
    { id: 3069, name: 'KASARGOD', stateId: 18 },
    { id: 3070, name: 'MALAPPURM', stateId: 18 },
    { id: 3216, name: 'Calicut', stateId: 18 },
    { id: 1094, name: 'Lakshdweep', stateId: 19 },
    { id: 3182, name: 'Lakshadweep', stateId: 19 },
    { id: 1095, name: 'Balaghat', stateId: 20 },
    { id: 1096, name: 'Raigarh', stateId: 20 },
    { id: 1097, name: 'Ajaigarh', stateId: 20 },
    { id: 1098, name: 'Akoda', stateId: 20 },
    { id: 1099, name: 'Alirajpur', stateId: 20 },
    { id: 1100, name: 'Amanganj', stateId: 20 },
    { id: 1101, name: 'Amarwara', stateId: 20 },
    { id: 1102, name: 'Ambah', stateId: 20 },
    { id: 1103, name: 'Amla', stateId: 20 },
    { id: 1104, name: 'Ashok Nagar', stateId: 20 },
    { id: 1105, name: 'Badnawar', stateId: 20 },
    { id: 1106, name: 'Bagh', stateId: 20 },
    { id: 1107, name: 'Bagli', stateId: 20 },
    { id: 1108, name: 'Baihar', stateId: 20 },
    { id: 1109, name: 'Baikunthpur', stateId: 20 },
    { id: 1110, name: 'Bansatar Kheda', stateId: 20 },
    { id: 1111, name: 'Barela', stateId: 20 },
    { id: 1112, name: 'Barhi', stateId: 20 },
    { id: 1113, name: 'Barwani', stateId: 20 },
    { id: 1114, name: 'Betma', stateId: 20 },
    { id: 1115, name: 'Betul', stateId: 20 },
    { id: 1116, name: 'Bhander', stateId: 20 },
    { id: 1117, name: 'Bharveli', stateId: 20 },
    { id: 1118, name: 'Bhedaghat', stateId: 20 },
    { id: 1119, name: 'Bhind', stateId: 20 },
    { id: 1120, name: 'Bhitarwar', stateId: 20 },
    { id: 1121, name: 'Bhopal', stateId: 20 },
    { id: 1122, name: 'Biaora', stateId: 20 },
    { id: 1123, name: 'Boda', stateId: 20 },
    { id: 1124, name: 'Burhanpur', stateId: 20 },
    { id: 1125, name: 'Buxwaha', stateId: 20 },
    { id: 1126, name: 'Chandla', stateId: 20 },
    { id: 1127, name: 'Chhatarpur', stateId: 20 },
    { id: 1128, name: 'Chhindwara', stateId: 20 },
    { id: 1129, name: 'Chichli', stateId: 20 },
    { id: 1130, name: 'Daboh', stateId: 20 },
    { id: 1131, name: 'Dabra', stateId: 20 },
    { id: 1132, name: 'Damoh', stateId: 20 },
    { id: 1133, name: 'Datia', stateId: 20 },
    { id: 1134, name: 'Depalpur', stateId: 20 },
    { id: 1135, name: 'Dewas', stateId: 20 },
    { id: 1136, name: 'Dhamnod', stateId: 20 },
    { id: 1137, name: 'Dhar', stateId: 20 },
    { id: 1138, name: 'Dharampuri', stateId: 20 },
    { id: 1139, name: 'Dindori', stateId: 20 },
    { id: 1140, name: 'Gadarwara', stateId: 20 },
    { id: 1141, name: 'Gairatganj', stateId: 20 },
    { id: 1142, name: 'Gohad', stateId: 20 },
    { id: 1143, name: 'Gormi', stateId: 20 },
    { id: 1144, name: 'Govindgarh', stateId: 20 },
    { id: 1145, name: 'Guna', stateId: 20 },
    { id: 1146, name: 'Gurh', stateId: 20 },
    { id: 1147, name: 'Gwalior', stateId: 20 },
    { id: 1148, name: 'Harda', stateId: 20 },
    { id: 1149, name: 'Harpalpur', stateId: 20 },
    { id: 1150, name: 'Harsud', stateId: 20 },
    { id: 1151, name: 'Hatta', stateId: 20 },
    { id: 1152, name: 'Hindoria', stateId: 20 },
    { id: 1153, name: 'Hoshangabad', stateId: 20 },
    { id: 1154, name: 'Indore', stateId: 20 },
    { id: 1155, name: 'Itarsi', stateId: 20 },
    { id: 1156, name: 'Jabalpur', stateId: 20 },
    { id: 1157, name: 'Jhabua', stateId: 20 },
    { id: 1158, name: 'Jobat', stateId: 20 },
    { id: 1159, name: 'Joura', stateId: 20 },
    { id: 1160, name: 'Kannod', stateId: 20 },
    { id: 1161, name: 'Kareli', stateId: 20 },
    { id: 1162, name: 'Karnawad', stateId: 20 },
    { id: 1163, name: 'Katangi', stateId: 20 },
    { id: 1164, name: 'Katni', stateId: 20 },
    { id: 1165, name: 'Khandwa', stateId: 20 },
    { id: 1166, name: 'Khargone', stateId: 20 },
    { id: 1167, name: 'Khategaon', stateId: 20 },
    { id: 1168, name: 'Khetia', stateId: 20 },
    { id: 1169, name: 'Kukshi', stateId: 20 },
    { id: 1170, name: 'Lahar', stateId: 20 },
    { id: 1171, name: 'Laundi', stateId: 20 },
    { id: 1172, name: 'Maharajpur', stateId: 20 },
    { id: 1173, name: 'Majholi', stateId: 20 },
    { id: 1174, name: 'Manasa', stateId: 20 },
    { id: 1175, name: 'Manawar', stateId: 20 },
    { id: 1176, name: 'Mandasur', stateId: 20 },
    { id: 1177, name: 'Mandideep', stateId: 20 },
    { id: 1178, name: 'Mandla', stateId: 20 },
    { id: 1179, name: 'Mandleshwar', stateId: 20 },
    { id: 1180, name: 'Mangawan', stateId: 20 },
    { id: 1181, name: 'Manpur', stateId: 20 },
    { id: 1182, name: 'Mau', stateId: 20 },
    { id: 1183, name: 'Mauganj', stateId: 20 },
    { id: 1184, name: 'Meghnagar', stateId: 20 },
    { id: 1185, name: 'Mehgaon', stateId: 20 },
    { id: 1186, name: 'Mihona', stateId: 20 },
    { id: 1187, name: 'Mohgaon', stateId: 20 },
    { id: 1188, name: 'Morena', stateId: 20 },
    { id: 1189, name: 'Multai', stateId: 20 },
    { id: 1190, name: 'Mundi', stateId: 20 },
    { id: 1191, name: 'Mungaoli', stateId: 20 },
    { id: 1192, name: 'Namli', stateId: 20 },
    { id: 1193, name: 'Narasinghpur', stateId: 20 },
    { id: 1194, name: 'Narayangarh', stateId: 20 },
    { id: 1195, name: 'Narsinghgarh', stateId: 20 },
    { id: 1196, name: 'Neemuch', stateId: 20 },
    { id: 1197, name: 'Nepanagar', stateId: 20 },
    { id: 1198, name: 'Pachmarhi Cantt', stateId: 20 },
    { id: 1199, name: 'Pachore', stateId: 20 },
    { id: 1200, name: 'Pandhana', stateId: 20 },
    { id: 1201, name: 'Panna', stateId: 20 },
    { id: 1202, name: 'Pansemal', stateId: 20 },
    { id: 1203, name: 'Patan', stateId: 20 },
    { id: 1204, name: 'Patharia', stateId: 20 },
    { id: 1205, name: 'Porsa', stateId: 20 },
    { id: 1206, name: 'Raisen', stateId: 20 },
    { id: 1207, name: 'Rajgarh', stateId: 20 },
    { id: 1208, name: 'Rajnagar', stateId: 20 },
    { id: 1209, name: 'Rajpur', stateId: 20 },
    { id: 1210, name: 'Ranapur', stateId: 20 },
    { id: 1211, name: 'Ratangarh', stateId: 20 },
    { id: 1212, name: 'Ratlam', stateId: 20 },
    { id: 1213, name: 'Rewa', stateId: 20 },
    { id: 1214, name: 'Sabalgarh', stateId: 20 },
    { id: 1215, name: 'Sagar', stateId: 20 },
    { id: 1216, name: 'Sailana', stateId: 20 },
    { id: 1217, name: 'Sanchi', stateId: 20 },
    { id: 1218, name: 'Sarangpur', stateId: 20 },
    { id: 1219, name: 'Sardarpur', stateId: 20 },
    { id: 1220, name: 'Sarni', stateId: 20 },
    { id: 1221, name: 'Satna', stateId: 20 },
    { id: 1222, name: 'Satwas', stateId: 20 },
    { id: 1223, name: 'Sausar', stateId: 20 },
    { id: 1224, name: 'Sawer', stateId: 20 },
    { id: 1225, name: 'Sehore', stateId: 20 },
    { id: 1226, name: 'Sendhwa', stateId: 20 },
    { id: 1227, name: 'Seoni', stateId: 20 },
    { id: 1228, name: 'Seoni Malwa', stateId: 20 },
    { id: 1229, name: 'Shahdol', stateId: 20 },
    { id: 1230, name: 'Shahpura', stateId: 20 },
    { id: 1231, name: 'Shajapur', stateId: 20 },
    { id: 1232, name: 'Shivpuri', stateId: 20 },
    { id: 1233, name: 'Sidhi', stateId: 20 },
    { id: 1234, name: 'Sihora', stateId: 20 },
    { id: 1235, name: 'Sohagpur', stateId: 20 },
    { id: 1236, name: 'Sultanpur', stateId: 20 },
    { id: 1237, name: 'Tal', stateId: 20 },
    { id: 1238, name: 'Tekanpur', stateId: 20 },
    { id: 1239, name: 'Thandla', stateId: 20 },
    { id: 1240, name: 'Tikamgarh', stateId: 20 },
    { id: 1241, name: 'Tirodi', stateId: 20 },
    { id: 1242, name: 'Udaipura', stateId: 20 },
    { id: 1243, name: 'Ujjain', stateId: 20 },
    { id: 1244, name: 'Ukwa', stateId: 20 },
    { id: 1245, name: 'Umaria', stateId: 20 },
    { id: 1246, name: 'Vidisha', stateId: 20 },
    { id: 2767, name: 'Raipur', stateId: 20 },
    { id: 2849, name: 'Singrauli', stateId: 20 },
    { id: 2921, name: 'Sheopur', stateId: 20 },
    { id: 2951, name: 'Mandsaur', stateId: 20 },
    { id: 3071, name: 'AGAR MALWA', stateId: 20 },
    { id: 3072, name: 'ANUPPUR', stateId: 20 },
    { id: 3073, name: 'NARSINGHPUR', stateId: 20 },
    { id: 1247, name: 'Ahmednagar', stateId: 21 },
    { id: 1248, name: 'Ajra', stateId: 21 },
    { id: 1249, name: 'Akkalkot', stateId: 21 },
    { id: 1250, name: 'Akola', stateId: 21 },
    { id: 1251, name: 'Akot', stateId: 21 },
    { id: 1252, name: 'Alibag', stateId: 21 },
    { id: 1253, name: 'Amalner', stateId: 21 },
    { id: 1254, name: 'Ambad', stateId: 21 },
    { id: 1255, name: 'Ambegaon', stateId: 21 },
    { id: 1256, name: 'Ambejogai', stateId: 21 },
    { id: 1257, name: 'Amravati', stateId: 21 },
    { id: 1258, name: 'Anjangaon', stateId: 21 },
    { id: 1259, name: 'Arvi', stateId: 21 },
    { id: 1260, name: 'Ashti', stateId: 21 },
    { id: 1261, name: 'Aurangabad', stateId: 21 },
    { id: 1262, name: 'Badlapur', stateId: 21 },
    { id: 1263, name: 'Balapur', stateId: 21 },
    { id: 1264, name: 'Ballarpur', stateId: 21 },
    { id: 1265, name: 'Baramati', stateId: 21 },
    { id: 1266, name: 'Barshi', stateId: 21 },
    { id: 1267, name: 'Basmath', stateId: 21 },
    { id: 1268, name: 'Beed', stateId: 21 },
    { id: 1269, name: 'Bhadravati', stateId: 21 },
    { id: 1270, name: 'Bhagur', stateId: 21 },
    { id: 1271, name: 'Bhandara', stateId: 21 },
    { id: 1272, name: 'Bhiwandi', stateId: 21 },
    { id: 1273, name: 'Bhokardan', stateId: 21 },
    { id: 1274, name: 'Bhor', stateId: 21 },
    { id: 1275, name: 'Budhgaon', stateId: 21 },
    { id: 1276, name: 'Buldhana', stateId: 21 },
    { id: 1277, name: 'Chakan', stateId: 21 },
    { id: 1278, name: 'Chalisgaon', stateId: 21 },
    { id: 1279, name: 'Chamorshi', stateId: 21 },
    { id: 1280, name: 'Chandrapur', stateId: 21 },
    { id: 1281, name: 'Chandvad', stateId: 21 },
    { id: 1282, name: 'Chikhaldara', stateId: 21 },
    { id: 1283, name: 'Chinchani', stateId: 21 },
    { id: 1284, name: 'Chopda', stateId: 21 },
    { id: 1285, name: 'Dahanu', stateId: 21 },
    { id: 1286, name: 'Darwha', stateId: 21 },
    { id: 1287, name: 'Daund', stateId: 21 },
    { id: 1288, name: 'Deolali', stateId: 21 },
    { id: 1289, name: 'Deoli', stateId: 21 },
    { id: 1290, name: 'Deoni', stateId: 21 },
    { id: 1291, name: 'Desaiganj (Vadasa)', stateId: 21 },
    { id: 1292, name: 'Dhamangaon Railway', stateId: 21 },
    { id: 1293, name: 'Dharangaon', stateId: 21 },
    { id: 1294, name: 'Dharmabad', stateId: 21 },
    { id: 1295, name: 'Dhule', stateId: 21 },
    { id: 1296, name: 'Digras', stateId: 21 },
    { id: 1297, name: 'Dudhani', stateId: 21 },
    { id: 1298, name: 'Erandol', stateId: 21 },
    { id: 1299, name: 'Faizpur', stateId: 21 },
    { id: 1300, name: 'Gadchiroli', stateId: 21 },
    { id: 1301, name: 'Gangakhed', stateId: 21 },
    { id: 1302, name: 'Gangapur', stateId: 21 },
    { id: 1303, name: 'Ghansawangi', stateId: 21 },
    { id: 1304, name: 'Gokhivare', stateId: 21 },
    { id: 1305, name: 'Goregaon', stateId: 21 },
    { id: 1306, name: 'Guhagar', stateId: 21 },
    { id: 1307, name: 'Hadgaon', stateId: 21 },
    { id: 1308, name: 'Hinganghat', stateId: 21 },
    { id: 1309, name: 'Hingoli', stateId: 21 },
    { id: 1310, name: 'Ichalkaranji', stateId: 21 },
    { id: 1311, name: 'Igatpuri', stateId: 21 },
    { id: 1312, name: 'Indapur', stateId: 21 },
    { id: 1313, name: 'Jalgaon', stateId: 21 },
    { id: 1314, name: 'Jalna', stateId: 21 },
    { id: 1315, name: 'Jamkhed', stateId: 21 },
    { id: 1316, name: 'Jawhar', stateId: 21 },
    { id: 1317, name: 'Jaysingpur', stateId: 21 },
    { id: 1318, name: 'Jejuri', stateId: 21 },
    { id: 1319, name: 'Jintur', stateId: 21 },
    { id: 1320, name: 'Junnar', stateId: 21 },
    { id: 1321, name: 'Kagal', stateId: 21 },
    { id: 1322, name: 'Kalamb', stateId: 21 },
    { id: 1323, name: 'Kalwan', stateId: 21 },
    { id: 1324, name: 'Kankavli', stateId: 21 },
    { id: 1325, name: 'Kannad', stateId: 21 },
    { id: 1326, name: 'Karanja', stateId: 21 },
    { id: 1327, name: 'Karjat', stateId: 21 },
    { id: 1328, name: 'Karmala', stateId: 21 },
    { id: 1329, name: 'Katol', stateId: 21 },
    { id: 1330, name: 'Khapa', stateId: 21 },
    { id: 1331, name: 'Khed', stateId: 21 },
    { id: 1332, name: 'Kherdi', stateId: 21 },
    { id: 1333, name: 'Khopoli', stateId: 21 },
    { id: 1334, name: 'Khuldabad', stateId: 21 },
    { id: 1335, name: 'Kinwat', stateId: 21 },
    { id: 1336, name: 'Kodoli', stateId: 21 },
    { id: 1337, name: 'Kolhapur', stateId: 21 },
    { id: 1338, name: 'Kopargaon', stateId: 21 },
    { id: 1339, name: 'Kudal', stateId: 21 },
    { id: 1340, name: 'Kundalwadi', stateId: 21 },
    { id: 1341, name: 'Kurundvad', stateId: 21 },
    { id: 1342, name: 'Lanja', stateId: 21 },
    { id: 1343, name: 'Lasalgaon', stateId: 21 },
    { id: 1344, name: 'Latur', stateId: 21 },
    { id: 1345, name: 'Loha', stateId: 21 },
    { id: 1346, name: 'Lonar', stateId: 21 },
    { id: 1347, name: 'Lonavala', stateId: 21 },
    { id: 1348, name: 'Mahabaleshwar', stateId: 21 },
    { id: 1349, name: 'Mahad', stateId: 21 },
    { id: 1350, name: 'Maindargi', stateId: 21 },
    { id: 1351, name: 'Malegaon', stateId: 21 },
    { id: 1352, name: 'Malkapur', stateId: 21 },
    { id: 1353, name: 'Malshiras', stateId: 21 },
    { id: 1354, name: 'Manchar', stateId: 21 },
    { id: 1355, name: 'Manmad', stateId: 21 },
    { id: 1356, name: 'Manor', stateId: 21 },
    { id: 1357, name: 'Mansar', stateId: 21 },
    { id: 1358, name: 'Manwath', stateId: 21 },
    { id: 1359, name: 'Matheran', stateId: 21 },
    { id: 1360, name: 'Mhasla', stateId: 21 },
    { id: 1361, name: 'Miraj', stateId: 21 },
    { id: 1362, name: 'Mohpa', stateId: 21 },
    { id: 1363, name: 'Morshi', stateId: 21 },
    { id: 1364, name: 'Mowad', stateId: 21 },
    { id: 1365, name: 'Mukhed', stateId: 21 },
    { id: 1366, name: 'Mul', stateId: 21 },
    { id: 1367, name: 'Mumbai', stateId: 21 },
    { id: 1368, name: 'Murbad', stateId: 21 },
    { id: 1369, name: 'Murgud', stateId: 21 },
    { id: 1370, name: 'Murud', stateId: 21 },
    { id: 1371, name: 'Nagothana', stateId: 21 },
    { id: 1372, name: 'Nagpur', stateId: 21 },
    { id: 1373, name: 'Naldurg', stateId: 21 },
    { id: 1374, name: 'Nanded', stateId: 21 },
    { id: 1375, name: 'Nandgaon', stateId: 21 },
    { id: 1376, name: 'Nandura', stateId: 21 },
    { id: 1377, name: 'Nandurbar', stateId: 21 },
    { id: 1378, name: 'Nashik', stateId: 21 },
    { id: 1379, name: 'Neral', stateId: 21 },
    { id: 1380, name: 'Oras', stateId: 21 },
    { id: 1381, name: 'Osmanabad', stateId: 21 },
    { id: 1382, name: 'Ozar', stateId: 21 },
    { id: 1383, name: 'Pachora', stateId: 21 },
    { id: 1384, name: 'Padagha', stateId: 21 },
    { id: 1385, name: 'Paithan', stateId: 21 },
    { id: 1386, name: 'Pali', stateId: 21 },
    { id: 1387, name: 'Panhala', stateId: 21 },
    { id: 1388, name: 'Paranda', stateId: 21 },
    { id: 1389, name: 'Parbhani', stateId: 21 },
    { id: 1390, name: 'Parola', stateId: 21 },
    { id: 1391, name: 'Partur', stateId: 21 },
    { id: 1392, name: 'Patan', stateId: 21 },
    { id: 1393, name: 'Pathardi', stateId: 21 },
    { id: 1394, name: 'Pathri', stateId: 21 },
    { id: 1395, name: 'Patur', stateId: 21 },
    { id: 1396, name: 'Pen', stateId: 21 },
    { id: 1397, name: 'Phaltan', stateId: 21 },
    { id: 1398, name: 'Pimpri Chinchwad', stateId: 21 },
    { id: 1399, name: 'Poladpur', stateId: 21 },
    { id: 1400, name: 'Pulgaon', stateId: 21 },
    { id: 1401, name: 'Pune', stateId: 21 },
    { id: 1402, name: 'Purna', stateId: 21 },
    { id: 1403, name: 'Pusad', stateId: 21 },
    { id: 1404, name: 'Rahimatpur', stateId: 21 },
    { id: 1405, name: 'Rahuri', stateId: 21 },
    { id: 1406, name: 'Rajapur', stateId: 21 },
    { id: 1407, name: 'Rajur', stateId: 21 },
    { id: 1408, name: 'Ramtek', stateId: 21 },
    { id: 1409, name: 'Ratnagiri', stateId: 21 },
    { id: 1410, name: 'Raver', stateId: 21 },
    { id: 1411, name: 'Risod', stateId: 21 },
    { id: 1412, name: 'Sailu', stateId: 21 },
    { id: 1413, name: 'Sangamner', stateId: 21 },
    { id: 1414, name: 'Sangli', stateId: 21 },
    { id: 1415, name: 'Sangole', stateId: 21 },
    { id: 1416, name: 'Sasti', stateId: 21 },
    { id: 1417, name: 'Satana', stateId: 21 },
    { id: 1418, name: 'Satara', stateId: 21 },
    { id: 1419, name: 'Savda', stateId: 21 },
    { id: 1420, name: 'Savner', stateId: 21 },
    { id: 1421, name: 'Shahade', stateId: 21 },
    { id: 1422, name: 'Shahapur', stateId: 21 },
    { id: 1423, name: 'Shirdi', stateId: 21 },
    { id: 1424, name: 'Shirur', stateId: 21 },
    { id: 1425, name: 'Shivajinagar', stateId: 21 },
    { id: 1426, name: 'Sholapur', stateId: 21 },
    { id: 1427, name: 'Shrivardhan', stateId: 21 },
    { id: 1428, name: 'Sillod', stateId: 21 },
    { id: 1429, name: 'Sindi', stateId: 21 },
    { id: 1430, name: 'Sindkhed Raja', stateId: 21 },
    { id: 1431, name: 'Sinnar', stateId: 21 },
    { id: 1432, name: 'Solapur', stateId: 21 },
    { id: 1433, name: 'Sonpeth', stateId: 21 },
    { id: 1434, name: 'Surgana', stateId: 21 },
    { id: 1435, name: 'Talode', stateId: 21 },
    { id: 1436, name: 'Tarapur', stateId: 21 },
    { id: 1437, name: 'Tasgaon', stateId: 21 },
    { id: 1438, name: 'Telhara', stateId: 21 },
    { id: 1439, name: 'Thane', stateId: 21 },
    { id: 1440, name: 'Tirora', stateId: 21 },
    { id: 1441, name: 'Trimbak', stateId: 21 },
    { id: 1442, name: 'Tuljapur', stateId: 21 },
    { id: 1443, name: 'Tumsar', stateId: 21 },
    { id: 1444, name: 'Udgir', stateId: 21 },
    { id: 1445, name: 'Ulhasnagar', stateId: 21 },
    { id: 1446, name: 'Umred', stateId: 21 },
    { id: 1447, name: 'Uran', stateId: 21 },
    { id: 1448, name: 'Uran Islampur', stateId: 21 },
    { id: 1449, name: 'Vada', stateId: 21 },
    { id: 1450, name: 'Vadgaon', stateId: 21 },
    { id: 1451, name: 'Vaijapur', stateId: 21 },
    { id: 1452, name: 'Vengurla', stateId: 21 },
    { id: 1453, name: 'Virar', stateId: 21 },
    { id: 1454, name: 'Wadi', stateId: 21 },
    { id: 1455, name: 'Wai', stateId: 21 },
    { id: 1456, name: 'Wani', stateId: 21 },
    { id: 1457, name: 'Wardha', stateId: 21 },
    { id: 1458, name: 'Warud', stateId: 21 },
    { id: 1459, name: 'Washim', stateId: 21 },
    { id: 1460, name: 'Yeotamal', stateId: 21 },
    { id: 1461, name: 'Kalyan', stateId: 21 },
    { id: 1462, name: 'Shahad', stateId: 21 },
    { id: 1463, name: 'Vasind', stateId: 21 },
    { id: 1464, name: 'Asaongaon', stateId: 21 },
    { id: 1465, name: 'Titwala', stateId: 21 },
    { id: 1466, name: 'Ambernath', stateId: 21 },
    { id: 1467, name: 'Gondia', stateId: 21 },
    { id: 1468, name: 'Navi Mumbai', stateId: 21 },
    { id: 1469, name: 'Raigad', stateId: 21 },
    { id: 1470, name: 'Panvel', stateId: 21 },
    { id: 1471, name: 'Roha', stateId: 21 },
    { id: 1472, name: 'Bhusawal', stateId: 21 },
    { id: 1473, name: 'Belapur', stateId: 21 },
    { id: 1474, name: 'Kalamboli', stateId: 21 },
    { id: 1475, name: 'Khalapur', stateId: 21 },
    { id: 1476, name: 'Mangaon', stateId: 21 },
    { id: 1477, name: 'Raigarh', stateId: 21 },
    { id: 1478, name: 'Birwadi', stateId: 21 },
    { id: 1479, name: 'Palghar', stateId: 21 },
    { id: 1480, name: 'Vasai', stateId: 21 },
    { id: 1481, name: 'Sawantwadi', stateId: 21 },
    { id: 1482, name: 'Malwan', stateId: 21 },
    { id: 1483, name: 'Sindhudurg', stateId: 21 },
    { id: 1484, name: 'Ahmed Nagar', stateId: 21 },
    { id: 1485, name: 'JALGOAN', stateId: 21 },
    { id: 1486, name: 'MUMBAI SUBUEBAN', stateId: 21 },
    { id: 1487, name: 'NA', stateId: 21 },
    { id: 1488, name: 'RAIGARH(MH)', stateId: 21 },
    { id: 1489, name: 'Shrirampur', stateId: 21 },
    { id: 1490, name: 'Yavatmal', stateId: 21 },
    { id: 1491, name: 'Vaibhavwadi', stateId: 21 },
    { id: 1492, name: 'Bolinj', stateId: 21 },
    { id: 1493, name: 'Devgad', stateId: 21 },
    { id: 1494, name: 'Shahancorwadi', stateId: 21 },
    { id: 1495, name: 'Bhayander', stateId: 21 },
    { id: 1461, name: 'Bishenpur', stateId: 22 },
    { id: 1462, name: 'Chandel', stateId: 22 },
    { id: 1463, name: 'Churachandpur', stateId: 22 },
    { id: 1464, name: 'Imphal', stateId: 22 },
    { id: 1465, name: 'Jiribam', stateId: 22 },
    { id: 1466, name: 'Mayang Imphal', stateId: 22 },
    { id: 1467, name: 'Moirang', stateId: 22 },
    { id: 1468, name: 'Moreh', stateId: 22 },
    { id: 1469, name: 'Nambol', stateId: 22 },
    { id: 1470, name: 'Senapati', stateId: 22 },
    { id: 1471, name: 'Sugnu', stateId: 22 },
    { id: 1472, name: 'Tamenglong', stateId: 22 },
    { id: 1473, name: 'Thoubal', stateId: 22 },
    { id: 1474, name: 'Ukhrul', stateId: 22 },
    { id: 3081, name: 'Imphal East', stateId: 22 },
    { id: 3082, name: 'Imphal West', stateId: 22 },
    { id: 3083, name: 'NA', stateId: 22 },
    { id: 3084, name: 'Tengnoupal', stateId: 22 },
    { id: 3085, name: 'THANLON', stateId: 22 },
    { id: 3086, name: 'West Tripura', stateId: 22 },
    { id: 1475, name: 'Baghmara', stateId: 23 },
    { id: 1476, name: 'Cherrapunjee', stateId: 23 },
    { id: 1477, name: 'Jaiaw', stateId: 23 },
    { id: 1478, name: 'Jowai', stateId: 23 },
    { id: 1479, name: 'MadanRitting', stateId: 23 },
    { id: 1480, name: 'Nongpoh', stateId: 23 },
    { id: 1481, name: 'Nongstoin', stateId: 23 },
    { id: 1482, name: 'Nongthymmai', stateId: 23 },
    { id: 1483, name: 'Resubelpara', stateId: 23 },
    { id: 1484, name: 'Shillong', stateId: 23 },
    { id: 1485, name: 'Tura', stateId: 23 },
    { id: 1486, name: 'Williamnagar', stateId: 23 },
    { id: 2846, name: 'Nongkynrih', stateId: 23 },
    { id: 2847, name: 'Khliehriat', stateId: 23 },
    { id: 2848, name: 'Thangrain', stateId: 23 },
    { id: 2851, name: 'Mawlai', stateId: 23 },
    { id: 2952, name: 'Sohiong', stateId: 23 },
    { id: 2961, name: 'Mawkyrwat', stateId: 23 },
    { id: 3183, name: 'East Garo Hills', stateId: 23 },
    { id: 3184, name: 'East Jaintia Hills', stateId: 23 },
    { id: 3185, name: 'East Khasi Hills', stateId: 23 },
    { id: 3186, name: 'Jaintia Hills', stateId: 23 },
    { id: 3187, name: 'Ri Bhoi', stateId: 23 },
    { id: 3188, name: 'South Garo Hills', stateId: 23 },
    { id: 3189, name: 'South West Khasi Hills', stateId: 23 },
    { id: 3190, name: 'West Garo Hills', stateId: 23 },
    { id: 3191, name: 'West Jaintia Hills', stateId: 23 },
    { id: 3192, name: 'West Khasi Hills', stateId: 23 },
    { id: 3211, name: 'Jirang', stateId: 23 },
    { id: 3213, name: 'Mendipathar', stateId: 23 },
    { id: 3215, name: 'Mawryngkneng', stateId: 23 },
    { id: 1487, name: 'Aizwal', stateId: 24 },
    { id: 1488, name: 'Champhai', stateId: 24 },
    { id: 1489, name: 'Darlawn', stateId: 24 },
    { id: 1490, name: 'Hnahthial', stateId: 24 },
    { id: 1491, name: 'Khawzawl', stateId: 24 },
    { id: 1492, name: 'Kolasib', stateId: 24 },
    { id: 1493, name: 'Lawngtlai', stateId: 24 },
    { id: 1494, name: 'Lungleh', stateId: 24 },
    { id: 1495, name: 'Lunglei', stateId: 24 },
    { id: 1496, name: 'Lungsen', stateId: 24 },
    { id: 1497, name: 'Saiha', stateId: 24 },
    { id: 1498, name: 'Sairang', stateId: 24 },
    { id: 1499, name: 'Saitual', stateId: 24 },
    { id: 1500, name: 'Serchhip', stateId: 24 },
    { id: 1501, name: 'Sherchip', stateId: 24 },
    { id: 1502, name: 'Vairengte', stateId: 24 },
    { id: 2861, name: 'Mamit', stateId: 24 },
    { id: 3087, name: 'Aizawal', stateId: 24 },
    { id: 3088, name: 'Aizawl', stateId: 24 },
    { id: 3089, name: 'Mammit', stateId: 24 },
    { id: 3090, name: 'NA', stateId: 24 },
    { id: 3091, name: 'West Tripura', stateId: 24 },
    { id: 1503, name: 'Chumukhedima', stateId: 25 },
    { id: 1504, name: 'Mon', stateId: 25 },
    { id: 1505, name: 'Wokha', stateId: 25 },
    { id: 1506, name: 'Chukitong', stateId: 25 },
    { id: 1507, name: 'Dimapur', stateId: 25 },
    { id: 1508, name: 'Kohima', stateId: 25 },
    { id: 1509, name: 'Mokokchung', stateId: 25 },
    { id: 1510, name: 'Phek', stateId: 25 },
    { id: 1511, name: 'Tuengsang', stateId: 25 },
    { id: 1512, name: 'Zunehboto', stateId: 25 },
    { id: 2821, name: 'Jalukie', stateId: 25 },
    { id: 2822, name: 'Longleng', stateId: 25 },
    { id: 2829, name: 'Tuli', stateId: 25 },
    { id: 2830, name: 'Mezoma', stateId: 25 },
    { id: 2831, name: 'Wakching', stateId: 25 },
    { id: 2843, name: 'Medziphema', stateId: 25 },
    { id: 2845, name: 'Peren', stateId: 25 },
    { id: 3092, name: 'Kiphire', stateId: 25 },
    { id: 3093, name: 'NA', stateId: 25 },
    { id: 3094, name: 'Tuensang', stateId: 25 },
    { id: 3095, name: 'Zunheboto', stateId: 25 },
    { id: 3096, name: 'Zunhebotto', stateId: 25 },
    { id: 1513, name: 'Anandapur', stateId: 26 },
    { id: 1514, name: 'Anugul', stateId: 26 },
    { id: 1515, name: 'Athmallik', stateId: 26 },
    { id: 1516, name: 'Balangir', stateId: 26 },
    { id: 1517, name: 'Baleshwar', stateId: 26 },
    { id: 1518, name: 'Balimela', stateId: 26 },
    { id: 1519, name: 'Balugaon', stateId: 26 },
    { id: 1520, name: 'Banki', stateId: 26 },
    { id: 1521, name: 'Barbil', stateId: 26 },
    { id: 1522, name: 'Bargarh', stateId: 26 },
    { id: 1523, name: 'Baripara', stateId: 26 },
    { id: 1524, name: 'Basudebpur', stateId: 26 },
    { id: 1525, name: 'Baudh', stateId: 26 },
    { id: 1526, name: 'Belpahar', stateId: 26 },
    { id: 1527, name: 'Bhadrak', stateId: 26 },
    { id: 1528, name: 'Bhawanipatna', stateId: 26 },
    { id: 1529, name: 'Bhuban', stateId: 26 },
    { id: 1530, name: 'Bhubaneswar', stateId: 26 },
    { id: 1531, name: 'Bolangir', stateId: 26 },
    { id: 1532, name: 'Buguda', stateId: 26 },
    { id: 1533, name: 'Burla', stateId: 26 },
    { id: 1534, name: 'Champua', stateId: 26 },
    { id: 1535, name: 'Chatrapur', stateId: 26 },
    { id: 1536, name: 'Cuttack', stateId: 26 },
    { id: 1537, name: 'Damanjodi', stateId: 26 },
    { id: 1538, name: 'Debagarh', stateId: 26 },
    { id: 1539, name: 'Dhenkanal', stateId: 26 },
    { id: 1540, name: 'Digapahandi', stateId: 26 },
    { id: 1541, name: 'Ganjam', stateId: 26 },
    { id: 1542, name: 'Gopalpur', stateId: 26 },
    { id: 1543, name: 'Gudari', stateId: 26 },
    { id: 1544, name: 'Gunupur', stateId: 26 },
    { id: 1545, name: 'Hinjilicut', stateId: 26 },
    { id: 1546, name: 'Hirakud', stateId: 26 },
    { id: 1547, name: 'Jagatsinghapur', stateId: 26 },
    { id: 1548, name: 'Jalda', stateId: 26 },
    { id: 1549, name: 'Jaleswar', stateId: 26 },
    { id: 1550, name: 'Jatani', stateId: 26 },
    { id: 1551, name: 'Jharsuguda', stateId: 26 },
    { id: 1552, name: 'Jhumpura', stateId: 26 },
    { id: 1553, name: 'Joda', stateId: 26 },
    { id: 1554, name: 'Junagarh', stateId: 26 },
    { id: 1555, name: 'Kalahandi', stateId: 26 },
    { id: 1556, name: 'Kandhamal', stateId: 26 },
    { id: 1557, name: 'Kantabanji', stateId: 26 },
    { id: 1558, name: 'Kantilo', stateId: 26 },
    { id: 1559, name: 'Karanjia', stateId: 26 },
    { id: 1560, name: 'Kendrapara', stateId: 26 },
    { id: 1561, name: 'Kendujhar', stateId: 26 },
    { id: 1562, name: 'Kesinga', stateId: 26 },
    { id: 1563, name: 'Khariar', stateId: 26 },
    { id: 1564, name: 'Kodala', stateId: 26 },
    { id: 1565, name: 'Konark', stateId: 26 },
    { id: 1566, name: 'Koraput', stateId: 26 },
    { id: 1567, name: 'Kordha', stateId: 26 },
    { id: 1568, name: 'Kotpad', stateId: 26 },
    { id: 1569, name: 'Malkangiri', stateId: 26 },
    { id: 1570, name: 'Mukhiguda', stateId: 26 },
    { id: 1571, name: 'Nabarangapur', stateId: 26 },
    { id: 1572, name: 'Naupada', stateId: 26 },
    { id: 1573, name: 'Nayagarh', stateId: 26 },
    { id: 1574, name: 'Nuapatna', stateId: 26 },
    { id: 1575, name: 'Padmapur', stateId: 26 },
    { id: 1576, name: 'Panikoii', stateId: 26 },
    { id: 1577, name: 'Panposh', stateId: 26 },
    { id: 1578, name: 'Parlakhemundi', stateId: 26 },
    { id: 1579, name: 'Patnagarh', stateId: 26 },
    { id: 1580, name: 'Pattamundai', stateId: 26 },
    { id: 1581, name: 'Phulbani', stateId: 26 },
    { id: 1582, name: 'Puri', stateId: 26 },
    { id: 1583, name: 'Purusottampur', stateId: 26 },
    { id: 1584, name: 'Rairangpur', stateId: 26 },
    { id: 1585, name: 'Rambha', stateId: 26 },
    { id: 1586, name: 'Rayagada', stateId: 26 },
    { id: 1587, name: 'Remuna', stateId: 26 },
    { id: 1588, name: 'Sambalpur', stateId: 26 },
    { id: 1589, name: 'Sonapur', stateId: 26 },
    { id: 1590, name: 'Soro', stateId: 26 },
    { id: 1591, name: 'Sundargarh', stateId: 26 },
    { id: 1592, name: 'Tensa', stateId: 26 },
    { id: 1593, name: 'Udala', stateId: 26 },
    { id: 1594, name: 'Brahmapur', stateId: 26 },
    { id: 1595, name: 'Berhampur', stateId: 26 },
    { id: 1596, name: 'Rourkela', stateId: 26 },
    { id: 1597, name: 'Mayurbhanj', stateId: 26 },
    { id: 1598, name: 'Jajpur', stateId: 26 },
    { id: 1599, name: 'Jajpur Road', stateId: 26 },
    { id: 1600, name: 'Balasore', stateId: 26 },
    { id: 1601, name: 'Rajganpur', stateId: 26 },
    { id: 1602, name: 'Khurda', stateId: 26 },
    { id: 1603, name: 'Dharpur', stateId: 26 },
    { id: 1604, name: 'Jagatsinghpur', stateId: 26 },
    { id: 1605, name: 'ANGUL', stateId: 26 },
    { id: 1606, name: 'BALESWAR', stateId: 26 },
    { id: 1607, name: 'BOUDH', stateId: 26 },
    { id: 1608, name: 'GAJAPATI', stateId: 26 },
    { id: 1609, name: 'JAJAPUR', stateId: 26 },
    { id: 1610, name: 'KHORDA', stateId: 26 },
    { id: 1611, name: 'NUAPADA', stateId: 26 },
    { id: 1612, name: 'SUNDERGARH', stateId: 26 },
    { id: 2801, name: 'Subarnapur', stateId: 26 },
    { id: 2807, name: 'Bankoi', stateId: 26 },
    { id: 1594, name: 'Karaikal', stateId: 27 },
    { id: 1595, name: 'Mahe', stateId: 27 },
    { id: 1596, name: 'Pondicherry', stateId: 27 },
    { id: 1597, name: 'Yanam', stateId: 27 },
    { id: 3097, name: 'VILLUPURAM', stateId: 27 },
    { id: 1598, name: 'Abohar', stateId: 28 },
    { id: 1599, name: 'Ahmedgarh', stateId: 28 },
    { id: 1600, name: 'Ajnala', stateId: 28 },
    { id: 1601, name: 'Akalgarh', stateId: 28 },
    { id: 1602, name: 'Alawalpur', stateId: 28 },
    { id: 1603, name: 'Amloh', stateId: 28 },
    { id: 1604, name: 'Amritsar', stateId: 28 },
    { id: 1605, name: 'Anandpur Sahib', stateId: 28 },
    { id: 1606, name: 'Badhni Kalan', stateId: 28 },
    { id: 1607, name: 'Banga', stateId: 28 },
    { id: 1608, name: 'Bariwala', stateId: 28 },
    { id: 1609, name: 'Barnala', stateId: 28 },
    { id: 1610, name: 'Batala', stateId: 28 },
    { id: 1611, name: 'Begowal', stateId: 28 },
    { id: 1612, name: 'Bhadaur', stateId: 28 },
    { id: 1613, name: 'Bhatinda', stateId: 28 },
    { id: 1614, name: 'Bhawanigarh', stateId: 28 },
    { id: 1615, name: 'Bhikhi', stateId: 28 },
    { id: 1616, name: 'Bhikhiwind', stateId: 28 },
    { id: 1617, name: 'Budhlada', stateId: 28 },
    { id: 1618, name: 'Cheema', stateId: 28 },
    { id: 1619, name: 'Dera Baba Nanak', stateId: 28 },
    { id: 1620, name: 'Dhanaula', stateId: 28 },
    { id: 1621, name: 'Dharamkot', stateId: 28 },
    { id: 1622, name: 'Dhariwal', stateId: 28 },
    { id: 1623, name: 'Dhilwan', stateId: 28 },
    { id: 1624, name: 'Dhuri', stateId: 28 },
    { id: 1625, name: 'Dina Nagar', stateId: 28 },
    { id: 1626, name: 'Dirba', stateId: 28 },
    { id: 1627, name: 'Faridkot', stateId: 28 },
    { id: 1628, name: 'Fatehgarh Churian', stateId: 28 },
    { id: 1629, name: 'Fatehgarh Sahib', stateId: 28 },
    { id: 1630, name: 'Ferozepur', stateId: 28 },
    { id: 1631, name: 'Ghagga', stateId: 28 },
    { id: 1632, name: 'Ghanaur', stateId: 28 },
    { id: 1633, name: 'Gidderbaha', stateId: 28 },
    { id: 1634, name: 'Goraya', stateId: 28 },
    { id: 1635, name: 'Gurdaspur', stateId: 28 },
    { id: 1636, name: 'Hajipur', stateId: 28 },
    { id: 1637, name: 'Hariana', stateId: 28 },
    { id: 1638, name: 'Hoshiarpur', stateId: 28 },
    { id: 1639, name: 'Jaitu', stateId: 28 },
    { id: 1640, name: 'Jalalabad', stateId: 28 },
    { id: 1641, name: 'Jalandhar', stateId: 28 },
    { id: 1642, name: 'Jandiala', stateId: 28 },
    { id: 1643, name: 'Kalanaur', stateId: 28 },
    { id: 1644, name: 'Kapurthala', stateId: 28 },
    { id: 1645, name: 'Kartarpur', stateId: 28 },
    { id: 1646, name: 'Kharar', stateId: 28 },
    { id: 1647, name: 'Khem Karan', stateId: 28 },
    { id: 1648, name: 'Kurali', stateId: 28 },
    { id: 1649, name: 'Lehragaga', stateId: 28 },
    { id: 1650, name: 'Longowal', stateId: 28 },
    { id: 1651, name: 'Ludhiana', stateId: 28 },
    { id: 1652, name: 'Machhiwara', stateId: 28 },
    { id: 1653, name: 'Mahilpur', stateId: 28 },
    { id: 1654, name: 'Majitha', stateId: 28 },
    { id: 1655, name: 'Makhu', stateId: 28 },
    { id: 1656, name: 'Malerkotla', stateId: 28 },
    { id: 1657, name: 'Malout', stateId: 28 },
    { id: 1658, name: 'Mansa', stateId: 28 },
    { id: 1659, name: 'Maur', stateId: 28 },
    { id: 1660, name: 'Moga', stateId: 28 },
    { id: 1661, name: 'Morinda', stateId: 28 },
    { id: 1662, name: 'Mukerian', stateId: 28 },
    { id: 1663, name: 'Muktsar', stateId: 28 },
    { id: 1664, name: 'Nabha', stateId: 28 },
    { id: 1665, name: 'Nakodar', stateId: 28 },
    { id: 1666, name: 'Nangal', stateId: 28 },
    { id: 1667, name: 'Nawanshahr', stateId: 28 },
    { id: 1668, name: 'Pathankot', stateId: 28 },
    { id: 1669, name: 'Patiala', stateId: 28 },
    { id: 1670, name: 'Patti', stateId: 28 },
    { id: 1671, name: 'Payal', stateId: 28 },
    { id: 1672, name: 'Phagwara', stateId: 28 },
    { id: 1673, name: 'Phillaur', stateId: 28 },
    { id: 1674, name: 'Qadian', stateId: 28 },
    { id: 1675, name: 'Rahon', stateId: 28 },
    { id: 1676, name: 'Raikot', stateId: 28 },
    { id: 1677, name: 'Rajpura', stateId: 28 },
    { id: 1678, name: 'Raman', stateId: 28 },
    { id: 1679, name: 'Rampura Phul', stateId: 28 },
    { id: 1680, name: 'Rupnagar', stateId: 28 },
    { id: 1681, name: 'Samana', stateId: 28 },
    { id: 1682, name: 'Samrala', stateId: 28 },
    { id: 1683, name: 'Sanaur', stateId: 28 },
    { id: 1684, name: 'Sangat', stateId: 28 },
    { id: 1685, name: 'Sangrur', stateId: 28 },
    { id: 1686, name: 'Sardulgarh', stateId: 28 },
    { id: 1687, name: 'Shahkot', stateId: 28 },
    { id: 1688, name: 'Sri Hargobindpur', stateId: 28 },
    { id: 1689, name: 'Sujanpur', stateId: 28 },
    { id: 1690, name: 'Sultanpur Lodhi', stateId: 28 },
    { id: 1691, name: 'Sunam', stateId: 28 },
    { id: 1692, name: 'Talwandi Bhai', stateId: 28 },
    { id: 1693, name: 'Zira', stateId: 28 },
    { id: 1694, name: 'Khanna', stateId: 28 },
    { id: 1695, name: 'Jagraon', stateId: 28 },
    { id: 1696, name: 'Mullanpur', stateId: 28 },
    { id: 1697, name: 'Mohali', stateId: 28 },
    { id: 1698, name: 'Fazilka', stateId: 28 },
    { id: 1699, name: 'BATHINDA', stateId: 28 },
    { id: 1700, name: 'FIROZPUR', stateId: 28 },
    { id: 1701, name: 'ROPAR', stateId: 28 },
    { id: 1702, name: 'TARN TARAN', stateId: 28 },
    { id: 2772, name: 'BANKOI', stateId: 28 },
    { id: 2786, name: 'BATALA', stateId: 28 },
    { id: 2797, name: 'JAGRAON', stateId: 28 },
    { id: 2808, name: 'PATIALA', stateId: 28 },
    { id: 2977, name: 'MALOUT', stateId: 28 },
    { id: 3098, name: 'KAPURTHALA', stateId: 28 },
    { id: 3099, name: 'SANGRUR', stateId: 28 },
    { id: 3100, name: 'MOGA', stateId: 28 },
    { id: 3101, name: 'FATEHGARH SAHIB', stateId: 28 },
    { id: 1694, name: 'Ajmer', stateId: 29 },
    { id: 1695, name: 'Aklera', stateId: 29 },
    { id: 1696, name: 'Alwar', stateId: 29 },
    { id: 1697, name: 'Anupgarh', stateId: 29 },
    { id: 1698, name: 'Asind', stateId: 29 },
    { id: 1699, name: 'Bagru', stateId: 29 },
    { id: 1700, name: 'Bakani', stateId: 29 },
    { id: 1701, name: 'Bali', stateId: 29 },
    { id: 1702, name: 'Balotra', stateId: 29 },
    { id: 1703, name: 'Bandikui', stateId: 29 },
    { id: 1704, name: 'Banswara', stateId: 29 },
    { id: 1705, name: 'Baran', stateId: 29 },
    { id: 1706, name: 'Bari Sadri', stateId: 29 },
    { id: 1707, name: 'Barmer', stateId: 29 },
    { id: 1708, name: 'Bayana', stateId: 29 },
    { id: 1709, name: 'Beawar', stateId: 29 },
    { id: 1710, name: 'Begun', stateId: 29 },
    { id: 1711, name: 'Bharatpur', stateId: 29 },
    { id: 1712, name: 'Bhawani Mandi', stateId: 29 },
    { id: 1713, name: 'Bhilwara', stateId: 29 },
    { id: 1714, name: 'Bhinder', stateId: 29 },
    { id: 1715, name: 'Bhusawar', stateId: 29 },
    { id: 1716, name: 'Bidasar', stateId: 29 },
    { id: 1717, name: 'Bikaner', stateId: 29 },
    { id: 1718, name: 'Bilara', stateId: 29 },
    { id: 1719, name: 'Bissau', stateId: 29 },
    { id: 1720, name: 'Bundi', stateId: 29 },
    { id: 1721, name: 'Chaksu', stateId: 29 },
    { id: 1722, name: 'Chechat', stateId: 29 },
    { id: 1723, name: 'Chhabra', stateId: 29 },
    { id: 1724, name: 'Chhapar', stateId: 29 },
    { id: 1725, name: 'Chhoti Sadri', stateId: 29 },
    { id: 1726, name: 'Chirawa', stateId: 29 },
    { id: 1727, name: 'Chittorgarh', stateId: 29 },
    { id: 1728, name: 'Chomu', stateId: 29 },
    { id: 1729, name: 'Churu', stateId: 29 },
    { id: 1730, name: 'Dausa', stateId: 29 },
    { id: 1731, name: 'Deeg', stateId: 29 },
    { id: 1732, name: 'Deoli', stateId: 29 },
    { id: 1733, name: 'Dhariawad', stateId: 29 },
    { id: 1734, name: 'Dholpur', stateId: 29 },
    { id: 1735, name: 'Didwana', stateId: 29 },
    { id: 1736, name: 'Dungarpur', stateId: 29 },
    { id: 1737, name: 'Gajsinghpur', stateId: 29 },
    { id: 1738, name: 'Galiakot', stateId: 29 },
    { id: 1739, name: 'Ganganagar', stateId: 29 },
    { id: 1740, name: 'Gulabpura', stateId: 29 },
    { id: 1741, name: 'Hanumangarh', stateId: 29 },
    { id: 1742, name: 'Hindaun', stateId: 29 },
    { id: 1743, name: 'Jahazpur', stateId: 29 },
    { id: 1744, name: 'Jaipur', stateId: 29 },
    { id: 1745, name: 'Jaisalmer', stateId: 29 },
    { id: 1746, name: 'Jalore', stateId: 29 },
    { id: 1747, name: 'Jhalawar', stateId: 29 },
    { id: 1748, name: 'JhunJhunu', stateId: 29 },
    { id: 1749, name: 'Jobner', stateId: 29 },
    { id: 1750, name: 'Jodhpur', stateId: 29 },
    { id: 1751, name: 'Kaman', stateId: 29 },
    { id: 1752, name: 'Kapasan', stateId: 29 },
    { id: 1753, name: 'Karanpur', stateId: 29 },
    { id: 1754, name: 'Karauli', stateId: 29 },
    { id: 1755, name: 'Kekri', stateId: 29 },
    { id: 1756, name: 'Keshoraipatan', stateId: 29 },
    { id: 1757, name: 'Khairthal', stateId: 29 },
    { id: 1758, name: 'Khandela', stateId: 29 },
    { id: 1759, name: 'Kherli', stateId: 29 },
    { id: 1760, name: 'Khetri', stateId: 29 },
    { id: 1761, name: 'Kishangarh', stateId: 29 },
    { id: 1762, name: 'Kishangarh Renwal', stateId: 29 },
    { id: 1763, name: 'Kota', stateId: 29 },
    { id: 1764, name: 'Kotputli', stateId: 29 },
    { id: 1765, name: 'Kuchera', stateId: 29 },
    { id: 1766, name: 'Kumher', stateId: 29 },
    { id: 1767, name: 'Kushalgarh', stateId: 29 },
    { id: 1768, name: 'Lakheri', stateId: 29 },
    { id: 1769, name: 'Lalsot', stateId: 29 },
    { id: 1770, name: 'Losal', stateId: 29 },
    { id: 1771, name: 'Mahu Kalan', stateId: 29 },
    { id: 1772, name: 'Mahwa', stateId: 29 },
    { id: 1773, name: 'Makrana', stateId: 29 },
    { id: 1774, name: 'Malpura', stateId: 29 },
    { id: 1775, name: 'Mandalgarh', stateId: 29 },
    { id: 1776, name: 'Mandawa', stateId: 29 },
    { id: 1777, name: 'Manohar Thana', stateId: 29 },
    { id: 1778, name: 'Merta City', stateId: 29 },
    { id: 1779, name: 'Mukandgarh', stateId: 29 },
    { id: 1780, name: 'Nadbai', stateId: 29 },
    { id: 1781, name: 'Nagaur', stateId: 29 },
    { id: 1782, name: 'Nasirabad', stateId: 29 },
    { id: 1783, name: 'Nathdwara', stateId: 29 },
    { id: 1784, name: 'Nawalgarh', stateId: 29 },
    { id: 1785, name: 'Nimbahera', stateId: 29 },
    { id: 1786, name: 'Nohar', stateId: 29 },
    { id: 1787, name: 'Nokha', stateId: 29 },
    { id: 1788, name: 'Padampur', stateId: 29 },
    { id: 1789, name: 'Pali', stateId: 29 },
    { id: 1790, name: 'Parbatsar', stateId: 29 },
    { id: 1791, name: 'Phalodi', stateId: 29 },
    { id: 1792, name: 'Pilani', stateId: 29 },
    { id: 1793, name: 'Pilibanga', stateId: 29 },
    { id: 1794, name: 'Pindwara', stateId: 29 },
    { id: 1795, name: 'Pirawa', stateId: 29 },
    { id: 1796, name: 'Pokaran', stateId: 29 },
    { id: 1797, name: 'Pushkar', stateId: 29 },
    { id: 1798, name: 'Raisinghnagar', stateId: 29 },
    { id: 1799, name: 'Rajakhera', stateId: 29 },
    { id: 1800, name: 'Rajaldesar', stateId: 29 },
    { id: 1801, name: 'Rajsamand', stateId: 29 },
    { id: 1802, name: 'Ramganj Mandi', stateId: 29 },
    { id: 1803, name: 'Rani', stateId: 29 },
    { id: 1804, name: 'Ratangarh', stateId: 29 },
    { id: 1805, name: 'Ratannagar', stateId: 29 },
    { id: 1806, name: 'Sadri', stateId: 29 },
    { id: 1807, name: 'Sadulshahar', stateId: 29 },
    { id: 1808, name: 'Sagwara', stateId: 29 },
    { id: 1809, name: 'Salumbar', stateId: 29 },
    { id: 1810, name: 'Sanchore', stateId: 29 },
    { id: 1811, name: 'Sangod', stateId: 29 },
    { id: 1812, name: 'Sardarshahar', stateId: 29 },
    { id: 1813, name: 'Sarwar', stateId: 29 },
    { id: 1814, name: 'Shahpura', stateId: 29 },
    { id: 1815, name: 'Sheoganj', stateId: 29 },
    { id: 1816, name: 'Sikar', stateId: 29 },
    { id: 1817, name: 'Sirohi', stateId: 29 },
    { id: 1818, name: 'Sri Madhopur', stateId: 29 },
    { id: 1819, name: 'Sujangarh', stateId: 29 },
    { id: 1820, name: 'Suket', stateId: 29 },
    { id: 1821, name: 'Sumerpur', stateId: 29 },
    { id: 1822, name: 'Surajgarh', stateId: 29 },
    { id: 1823, name: 'Suratgarh', stateId: 29 },
    { id: 1824, name: 'Swaimadhopur', stateId: 29 },
    { id: 1825, name: 'Taranagar', stateId: 29 },
    { id: 1826, name: 'Tijara', stateId: 29 },
    { id: 1827, name: 'Tonk', stateId: 29 },
    { id: 1828, name: 'Udaipur', stateId: 29 },
    { id: 1829, name: 'Udaipurwati', stateId: 29 },
    { id: 1830, name: 'Uniara', stateId: 29 },
    { id: 1831, name: 'Viratnagar', stateId: 29 },
    { id: 1832, name: 'Weir', stateId: 29 },
    { id: 2922, name: 'Pratapgarh', stateId: 29 },
    { id: 3102, name: 'JALOR', stateId: 29 },
    { id: 3103, name: 'JHUJHUNU', stateId: 29 },
    { id: 3104, name: 'PRATAPGHAR', stateId: 29 },
    { id: 3105, name: 'SAWAI MADHOPUR', stateId: 29 },
    { id: 3106, name: 'SRI GANGANAGAR', stateId: 29 },
    { id: 3107, name: 'SRIGANGANAGAR', stateId: 29 },
    { id: 1833, name: 'Gangtok', stateId: 30 },
    { id: 1834, name: 'Gyalshing', stateId: 30 },
    { id: 1835, name: 'Mangan', stateId: 30 },
    { id: 1836, name: 'Namchi', stateId: 30 },
    { id: 1837, name: 'Nayabazar', stateId: 30 },
    { id: 1838, name: 'Rangpo', stateId: 30 },
    { id: 1839, name: 'Singtam', stateId: 30 },
    { id: 2939, name: 'Deorali', stateId: 30 },
    { id: 3108, name: 'EAST SIKKIM', stateId: 30 },
    { id: 3109, name: 'NORTH SIKKIM', stateId: 30 },
    { id: 3110, name: 'SOUTH SIKKIM', stateId: 30 },
    { id: 3111, name: 'WEST SIKKIM', stateId: 30 },
    { id: 1840, name: 'Abiramam', stateId: 31 },
    { id: 1841, name: 'Acharapakkam', stateId: 31 },
    { id: 1842, name: 'Alandur', stateId: 31 },
    { id: 1843, name: 'Alanganallur', stateId: 31 },
    { id: 1844, name: 'Alangayam', stateId: 31 },
    { id: 1845, name: 'Alangudi', stateId: 31 },
    { id: 1846, name: 'Alangulam', stateId: 31 },
    { id: 1847, name: 'Alapakkam', stateId: 31 },
    { id: 1848, name: 'Ambasamudram', stateId: 31 },
    { id: 1849, name: 'Ambur', stateId: 31 },
    { id: 1850, name: 'Ammavarikuppam', stateId: 31 },
    { id: 1851, name: 'Ammoor', stateId: 31 },
    { id: 1852, name: 'Anaiyur', stateId: 31 },
    { id: 1853, name: 'Anakaputhur', stateId: 31 },
    { id: 1854, name: 'Annavasal', stateId: 31 },
    { id: 1855, name: 'Anthiyur', stateId: 31 },
    { id: 1856, name: 'Arakandanallur', stateId: 31 },
    { id: 1857, name: 'Aravakurichi', stateId: 31 },
    { id: 1858, name: 'Arimalam', stateId: 31 },
    { id: 1859, name: 'Ariyalur', stateId: 31 },
    { id: 1860, name: 'Ariyur', stateId: 31 },
    { id: 1861, name: 'Arumbavur', stateId: 31 },
    { id: 1862, name: 'Arumuganeri', stateId: 31 },
    { id: 1863, name: 'Athani', stateId: 31 },
    { id: 1864, name: 'Athanur', stateId: 31 },
    { id: 1865, name: 'Attayampatti', stateId: 31 },
    { id: 1866, name: 'Attur', stateId: 31 },
    { id: 1867, name: 'Avadi', stateId: 31 },
    { id: 1868, name: 'Avanashi', stateId: 31 },
    { id: 1869, name: 'Avaniapuram', stateId: 31 },
    { id: 1870, name: 'Ayakudi', stateId: 31 },
    { id: 1871, name: 'Ayyalur', stateId: 31 },
    { id: 1872, name: 'Ayyampalayam', stateId: 31 },
    { id: 1873, name: 'Ayyampettai', stateId: 31 },
    { id: 1874, name: 'Balasamudram', stateId: 31 },
    { id: 1875, name: 'Batlagundu', stateId: 31 },
    { id: 1876, name: 'Bhavanisagar', stateId: 31 },
    { id: 1877, name: 'Bhuvanagiri', stateId: 31 },
    { id: 1878, name: 'Chengalpattu', stateId: 31 },
    { id: 1879, name: 'Chengam', stateId: 31 },
    { id: 1880, name: 'Chennai', stateId: 31 },
    { id: 1881, name: 'Chennasamudram', stateId: 31 },
    { id: 1882, name: 'Chennimalai', stateId: 31 },
    { id: 1883, name: 'Chettipalayam', stateId: 31 },
    { id: 1884, name: 'Chidambaram', stateId: 31 },
    { id: 1885, name: 'Chinnalapatti', stateId: 31 },
    { id: 1886, name: 'Chinnamanur', stateId: 31 },
    { id: 1887, name: 'Chinnasalem', stateId: 31 },
    { id: 1888, name: 'Chitlapakkam', stateId: 31 },
    { id: 1889, name: 'Coimbatore', stateId: 31 },
    { id: 1890, name: 'Cuddalore', stateId: 31 },
    { id: 1891, name: 'Desur', stateId: 31 },
    { id: 1892, name: 'Devadanapatti', stateId: 31 },
    { id: 1893, name: 'Devarshola', stateId: 31 },
    { id: 1894, name: 'Dharmapuri', stateId: 31 },
    { id: 1895, name: 'Dindigul', stateId: 31 },
    { id: 1896, name: 'Dusi', stateId: 31 },
    { id: 1897, name: 'Elathur', stateId: 31 },
    { id: 1898, name: 'Elayirampannai', stateId: 31 },
    { id: 1899, name: 'Eral', stateId: 31 },
    { id: 1900, name: 'Erode', stateId: 31 },
    { id: 1901, name: 'Ganapathipuram', stateId: 31 },
    { id: 1902, name: 'Gangaikondan', stateId: 31 },
    { id: 1903, name: 'Gangavalli', stateId: 31 },
    { id: 1904, name: 'Gingee', stateId: 31 },
    { id: 1905, name: 'Harur', stateId: 31 },
    { id: 1906, name: 'Highways', stateId: 31 },
    { id: 1907, name: 'Hosur', stateId: 31 },
    { id: 1908, name: 'Ilanji', stateId: 31 },
    { id: 1909, name: 'Irugur', stateId: 31 },
    { id: 1910, name: 'Jagathala', stateId: 31 },
    { id: 1911, name: 'Jambai', stateId: 31 },
    { id: 1912, name: 'Kadambur', stateId: 31 },
    { id: 1913, name: 'Kadathur', stateId: 31 },
    { id: 1914, name: 'Kadayanallur', stateId: 31 },
    { id: 1915, name: 'Kalambur', stateId: 31 },
    { id: 1916, name: 'Kalapatti', stateId: 31 },
    { id: 1917, name: 'Kalappanaickenpatti', stateId: 31 },
    { id: 1918, name: 'Kalavai', stateId: 31 },
    { id: 1919, name: 'Kallakudi', stateId: 31 },
    { id: 1920, name: 'Kalugumalai', stateId: 31 },
    { id: 1921, name: 'Kamayagoundanpatti', stateId: 31 },
    { id: 1922, name: 'Kambainallur', stateId: 31 },
    { id: 1923, name: 'Kanadukathan', stateId: 31 },
    { id: 1924, name: 'Kanam', stateId: 31 },
    { id: 1925, name: 'Kancheepuram', stateId: 31 },
    { id: 1926, name: 'Kandanur', stateId: 31 },
    { id: 1927, name: 'Kangayampalayam', stateId: 31 },
    { id: 1928, name: 'Kaniyur', stateId: 31 },
    { id: 1929, name: 'Kanjikoil', stateId: 31 },
    { id: 1930, name: 'Kannamangalam', stateId: 31 },
    { id: 1931, name: 'Kannampalayam', stateId: 31 },
    { id: 1932, name: 'Kannankurichi', stateId: 31 },
    { id: 1933, name: 'Kannivadi', stateId: 31 },
    { id: 1934, name: 'Kanyakumari', stateId: 31 },
    { id: 1935, name: 'Karamadai', stateId: 31 },
    { id: 1936, name: 'Karuppur', stateId: 31 },
    { id: 1937, name: 'Karur', stateId: 31 },
    { id: 1938, name: 'Katpadi', stateId: 31 },
    { id: 1939, name: 'Kaveripattinam', stateId: 31 },
    { id: 1940, name: 'Kovilpatti', stateId: 31 },
    { id: 1941, name: 'Kumbakonam', stateId: 31 },
    { id: 1942, name: 'Kundadam', stateId: 31 },
    { id: 1943, name: 'Kuppam', stateId: 31 },
    { id: 1944, name: 'Kurinjipadi', stateId: 31 },
    { id: 1945, name: 'Kuzhithurai', stateId: 31 },
    { id: 1946, name: 'Lakshmipuram', stateId: 31 },
    { id: 1947, name: 'Lalgudi', stateId: 31 },
    { id: 1948, name: 'Maharajapuram', stateId: 31 },
    { id: 1949, name: 'Madathukulam', stateId: 31 },
    { id: 1950, name: 'Madurai', stateId: 31 },
    { id: 1951, name: 'Magaral', stateId: 31 },
    { id: 1952, name: 'Mahindra World City', stateId: 31 },
    { id: 1953, name: 'Mannargudi', stateId: 31 },
    { id: 1954, name: 'Marakkanam', stateId: 31 },
    { id: 1955, name: 'Mettupalayam', stateId: 31 },
    { id: 1956, name: 'Mettur', stateId: 31 },
    { id: 1957, name: 'Mikilampatti', stateId: 31 },
    { id: 1958, name: 'Muthupettai', stateId: 31 },
    { id: 1959, name: 'Muthur', stateId: 31 },
    { id: 1960, name: 'Mysore', stateId: 31 },
    { id: 1961, name: 'Naduvakurichi', stateId: 31 },
    { id: 1962, name: 'Nagapattinam', stateId: 31 },
    { id: 1963, name: 'Nagercoil', stateId: 31 },
    { id: 1964, name: 'Nallampatti', stateId: 31 },
    { id: 1965, name: 'Nallur', stateId: 31 },
    { id: 1966, name: 'Namakkal', stateId: 31 },
    { id: 1967, name: 'Narasinganallur', stateId: 31 },
    { id: 1968, name: 'Nathampatti', stateId: 31 },
    { id: 1969, name: 'Nedungundram', stateId: 31 },
    { id: 1970, name: 'Neelankarai', stateId: 31 },
    { id: 1971, name: 'Nellikuppam', stateId: 31 },
    { id: 1972, name: 'Neyveli', stateId: 31 },
    { id: 1973, name: 'Nilakkottai', stateId: 31 },
    { id: 1974, name: 'NIT', stateId: 31 },
    { id: 1975, name: 'Omalur', stateId: 31 },
    { id: 1976, name: 'Ooty', stateId: 31 },
    { id: 1977, name: 'Padalur', stateId: 31 },
    { id: 1978, name: 'Palladam', stateId: 31 },
    { id: 1979, name: 'Pallapatti', stateId: 31 },
    { id: 1980, name: 'Pallikaranai', stateId: 31 },
    { id: 1981, name: 'Pallipalayam', stateId: 31 },
    { id: 1982, name: 'Panagudi', stateId: 31 },
    { id: 1983, name: 'Panchapalli', stateId: 31 },
    { id: 1984, name: 'Panchanatham', stateId: 31 },
    { id: 1985, name: 'Parangipettai', stateId: 31 },
    { id: 1986, name: 'Paramakudi', stateId: 31 },
    { id: 1987, name: 'Parvathipuram', stateId: 31 },
    { id: 1988, name: 'Pasumpon', stateId: 31 },
    { id: 1989, name: 'Peddapalayam', stateId: 31 },
    { id: 1990, name: 'Perambalur', stateId: 31 },
    { id: 1991, name: 'Peravurani', stateId: 31 },
    { id: 1992, name: 'Peringarapatti', stateId: 31 },
    { id: 1993, name: 'Perundurai', stateId: 31 },
    { id: 1994, name: 'Pethanayakanpalayam', stateId: 31 },
    { id: 1995, name: 'Pettai', stateId: 31 },
    { id: 1996, name: 'Pondicherry', stateId: 31 },
    { id: 1997, name: 'Pothanur', stateId: 31 },
    { id: 1998, name: 'Pudur', stateId: 31 },
    { id: 1999, name: 'Puliyankudi', stateId: 31 },
    { id: 2000, name: 'Rasipuram', stateId: 31 },
    { id: 2001, name: 'Rajapalayam', stateId: 31 },
    { id: 2002, name: 'Ramachandrapuram', stateId: 31 },
    { id: 2003, name: 'Ramanathapuram', stateId: 31 },
    { id: 2004, name: 'Rasipuram', stateId: 31 },
    { id: 2005, name: 'Reddipatti', stateId: 31 },
    { id: 2006, name: 'Sathuvachari', stateId: 31 },
    { id: 2007, name: 'Sembatti', stateId: 31 },
    { id: 2008, name: 'Sengal', stateId: 31 },
    { id: 2009, name: 'Sengur', stateId: 31 },
    { id: 2010, name: 'Seyyur', stateId: 31 },
    { id: 2011, name: 'Sholavandan', stateId: 31 },
    { id: 2012, name: 'Sivakasi', stateId: 31 },
    { id: 2013, name: 'Sivakumar', stateId: 31 },
    { id: 2014, name: 'Solan', stateId: 31 },
    { id: 2015, name: 'Sriperumbudur', stateId: 31 },
    { id: 2016, name: 'Srirangam', stateId: 31 },
    { id: 2017, name: 'Srirangam', stateId: 31 },
    { id: 2018, name: 'Tenkasi', stateId: 31 },
    { id: 2019, name: 'Tenkasi', stateId: 31 },
    { id: 2020, name: 'Thanjavur', stateId: 31 },
    { id: 2021, name: 'Tharapuram', stateId: 31 },
    { id: 2022, name: 'Theni', stateId: 31 },
    { id: 2023, name: 'Thiruchengode', stateId: 31 },
    { id: 2024, name: 'Thiruchirapalli', stateId: 31 },
    { id: 2025, name: 'Thirunelveli', stateId: 31 },
    { id: 2026, name: 'Thirupathur', stateId: 31 },
    { id: 2027, name: 'Thirupathur', stateId: 31 },
    { id: 2028, name: 'Thiruvallur', stateId: 31 },
    { id: 2029, name: 'Thiruvannamalai', stateId: 31 },
    { id: 2030, name: 'Tiruchendur', stateId: 31 },
    { id: 2031, name: 'Tirunelveli', stateId: 31 },
    { id: 2032, name: 'Tirupur', stateId: 31 },
    { id: 2033, name: 'Tiruvottiyur', stateId: 31 },
    { id: 2034, name: 'Tiruvallur', stateId: 31 },
    { id: 2035, name: 'Tiruvannamalai', stateId: 31 },
    { id: 2036, name: 'Tiruvarur', stateId: 31 },
    { id: 2037, name: 'Vadalur', stateId: 31 },
    { id: 2038, name: 'Vadipatti', stateId: 31 },
    { id: 2039, name: 'Vallam', stateId: 31 },
    { id: 2040, name: 'Vellore', stateId: 31 },
    { id: 2041, name: 'Vembakkam', stateId: 31 },
    { id: 2042, name: 'Vikramasingapuram', stateId: 31 },
    { id: 2043, name: 'Viluppuram', stateId: 31 },
    { id: 2044, name: 'Virudhunagar', stateId: 31 },
    { id: 2045, name: 'Virudhunagar', stateId: 31 },
    { id: 2046, name: 'Vishyamangalam', stateId: 31 },
    { id: 2047, name: 'Yercaud', stateId: 31 },
    { id: 2151, name: 'Amarpur', stateId: 32 },
    { id: 2152, name: 'Badarghat', stateId: 32 },
    { id: 2153, name: 'Beloniya', stateId: 32 },
    { id: 2154, name: 'Dharma Nagar', stateId: 32 },
    { id: 2155, name: 'Jogendranagar', stateId: 32 },
    { id: 2156, name: 'Kamalpur', stateId: 32 },
    { id: 2157, name: 'Kanchanpur', stateId: 32 },
    { id: 2158, name: 'Khowai', stateId: 32 },
    { id: 2159, name: 'Kumarghat', stateId: 32 },
    { id: 2160, name: 'Kunjaban', stateId: 32 },
    { id: 2161, name: 'Ranirbazar', stateId: 32 },
    { id: 2162, name: 'Sabroom', stateId: 32 },
    { id: 2163, name: 'Teliamura', stateId: 32 },
    { id: 2164, name: 'Agartala', stateId: 32 },
    { id: 2165, name: 'Ambassa', stateId: 32 },
    { id: 2166, name: 'Kailashahar', stateId: 32 },
    { id: 2167, name: 'Udaipur', stateId: 32 },
    { id: 2914, name: 'Ganganagar', stateId: 32 },
    { id: 2963, name: 'North Tripura', stateId: 32 },
    { id: 3117, name: 'AgartalaÂ', stateId: 32 },
    { id: 3118, name: 'Dhalai', stateId: 32 },
    { id: 3119, name: 'Dharmanagar', stateId: 32 },
    { id: 3120, name: 'Gomati', stateId: 32 },
    { id: 3121, name: 'Gomti', stateId: 32 },
    { id: 3122, name: 'NA', stateId: 32 },
    { id: 3123, name: 'Sepahijala', stateId: 32 },
    { id: 3124, name: 'South Tripura', stateId: 32 },
    { id: 3125, name: 'West Tripura', stateId: 32 },
    { id: 2168, name: 'Afzalgarh', stateId: 33 },
    { id: 2169, name: 'Agra', stateId: 33 },
    { id: 2170, name: 'Ahraura', stateId: 33 },
    { id: 2171, name: 'Ailum', stateId: 33 },
    { id: 2172, name: 'Akbarpur', stateId: 33 },
    { id: 2173, name: 'Aliganj', stateId: 33 },
    { id: 2174, name: 'Aligarh', stateId: 33 },
    { id: 2175, name: 'Allahabad', stateId: 33 },
    { id: 2176, name: 'Amanpur', stateId: 33 },
    { id: 2177, name: 'Ambedkar Nagar', stateId: 33 },
    { id: 2178, name: 'Ambehta', stateId: 33 },
    { id: 2179, name: 'Amethi', stateId: 33 },
    { id: 2180, name: 'Amila', stateId: 33 },
    { id: 2181, name: 'Amilo', stateId: 33 },
    { id: 2182, name: 'Aminagar Sarai', stateId: 33 },
    { id: 2183, name: 'Amraudha', stateId: 33 },
    { id: 2184, name: 'Amroha', stateId: 33 },
    { id: 2185, name: 'Antu', stateId: 33 },
    { id: 2186, name: 'Anupshahr', stateId: 33 },
    { id: 2187, name: 'Aonla', stateId: 33 },
    { id: 2188, name: 'Armapur Estate', stateId: 33 },
    { id: 2189, name: 'Atrauli', stateId: 33 },
    { id: 2190, name: 'Atraulia', stateId: 33 },
    { id: 2191, name: 'Auraiya', stateId: 33 },
    { id: 2192, name: 'Aurangabad', stateId: 33 },
    { id: 2193, name: 'Awagarh', stateId: 33 },
    { id: 2194, name: 'Ayodhya', stateId: 33 },
    { id: 2195, name: 'Azamgarh', stateId: 33 },
    { id: 2196, name: 'Baberu', stateId: 33 },
    { id: 2197, name: 'Babina', stateId: 33 },
    { id: 2198, name: 'Babrala', stateId: 33 },
    { id: 2199, name: 'Babugarh', stateId: 33 },
    { id: 2200, name: 'Bachhrawan', stateId: 33 },
    { id: 2201, name: 'Badaun', stateId: 33 },
    { id: 2202, name: 'Baghpat', stateId: 33 },
    { id: 2203, name: 'Bah', stateId: 33 },
    { id: 2204, name: 'Bahadurganj', stateId: 33 },
    { id: 2205, name: 'Baheri', stateId: 33 },
    { id: 2206, name: 'Bahjoi', stateId: 33 },
    { id: 2207, name: 'Bahraich', stateId: 33 },
    { id: 2208, name: 'Bajna', stateId: 33 },
    { id: 2209, name: 'Bakewar', stateId: 33 },
    { id: 2210, name: 'Baldeo', stateId: 33 },
    { id: 2211, name: 'Ballia', stateId: 33 },
    { id: 2212, name: 'Balrampur', stateId: 33 },
    { id: 2213, name: 'Banda', stateId: 33 },
    { id: 2214, name: 'Bangarmau', stateId: 33 },
    { id: 2215, name: 'Banki', stateId: 33 },
    { id: 2216, name: 'Bansdih', stateId: 33 },
    { id: 2217, name: 'Bansgaon', stateId: 33 },
    { id: 2218, name: 'Bansi', stateId: 33 },
    { id: 2219, name: 'Barabanki', stateId: 33 },
    { id: 2220, name: 'Baragaon', stateId: 33 },
    { id: 2221, name: 'Baraut', stateId: 33 },
    { id: 2222, name: 'Bareilly', stateId: 33 },
    { id: 2223, name: 'Barhalganj', stateId: 33 },
    { id: 2224, name: 'Barkhera', stateId: 33 },
    { id: 2225, name: 'Barsana', stateId: 33 },
    { id: 2226, name: 'Basti', stateId: 33 },
    { id: 2227, name: 'Beniganj', stateId: 33 },
    { id: 2228, name: 'Bewar', stateId: 33 },
    { id: 2229, name: 'Bhadohi', stateId: 33 },
    { id: 2230, name: 'Bhagwant Nagar', stateId: 33 },
    { id: 2231, name: 'Bharatganj', stateId: 33 },
    { id: 2232, name: 'Bharthana', stateId: 33 },
    { id: 2233, name: 'Bharwari', stateId: 33 },
    { id: 2234, name: 'Bhinga', stateId: 33 },
    { id: 2235, name: 'Bhogaon', stateId: 33 },
    { id: 2236, name: 'Bidhuna', stateId: 33 },
    { id: 2237, name: 'Bijnor', stateId: 33 },
    { id: 2238, name: 'Bijnore', stateId: 33 },
    { id: 2239, name: 'Bikapur', stateId: 33 },
    { id: 2240, name: 'Bilari', stateId: 33 },
    { id: 2241, name: 'Bilaspur', stateId: 33 },
    { id: 2242, name: 'Bilgram', stateId: 33 },
    { id: 2243, name: 'Bilsanda', stateId: 33 },
    { id: 2244, name: 'Bilsi', stateId: 33 },
    { id: 2245, name: 'Bindki', stateId: 33 },
    { id: 2246, name: 'Bisalpur', stateId: 33 },
    { id: 2247, name: 'Bisauli', stateId: 33 },
    { id: 2248, name: 'Biswan', stateId: 33 },
    { id: 2249, name: 'Bithoor', stateId: 33 },
    { id: 2250, name: 'Budaun', stateId: 33 },
    { id: 2251, name: 'Budhana', stateId: 33 },
    { id: 2252, name: 'Bugrasi', stateId: 33 },
    { id: 2253, name: 'Bulandshahr', stateId: 33 },
    { id: 2254, name: 'Chail', stateId: 33 },
    { id: 2255, name: 'Chakia', stateId: 33 },
    { id: 2256, name: 'Chandauli', stateId: 33 },
    { id: 2257, name: 'Chandausi', stateId: 33 },
    { id: 2258, name: 'Chandpur', stateId: 33 },
    { id: 2259, name: 'Chhaprauli', stateId: 33 },
    { id: 2260, name: 'Chhibramau', stateId: 33 },
    { id: 2261, name: 'Chitrakoot', stateId: 33 },
    { id: 2262, name: 'Chopan', stateId: 33 },
    { id: 2263, name: 'Chunar', stateId: 33 },
    { id: 2264, name: 'Colonelganj', stateId: 33 },
    { id: 2265, name: 'Dadri', stateId: 33 },
    { id: 2266, name: 'Dalmau', stateId: 33 },
    { id: 2267, name: 'Dankaur', stateId: 33 },
    { id: 2268, name: 'Dataganj', stateId: 33 },
    { id: 2269, name: 'Daurala', stateId: 33 },
    { id: 2270, name: 'Dayalbagh', stateId: 33 },
    { id: 2271, name: 'Deoband', stateId: 33 },
    { id: 2272, name: 'Deoria', stateId: 33 },
    { id: 2273, name: 'Dewa', stateId: 33 },
    { id: 2274, name: 'Dhampur', stateId: 33 },
    { id: 2275, name: 'Dibai', stateId: 33 },
    { id: 2276, name: 'Dostpur', stateId: 33 },
    { id: 2277, name: 'Dudhi', stateId: 33 },
    { id: 2278, name: 'Ekdil', stateId: 33 },
    { id: 2279, name: 'Erich', stateId: 33 },
    { id: 2280, name: 'Etah', stateId: 33 },
    { id: 2281, name: 'Etawah', stateId: 33 },
    { id: 2282, name: 'Etwah', stateId: 33 },
    { id: 2283, name: 'Faizabad', stateId: 33 },
    { id: 2284, name: 'Faridpur', stateId: 33 },
    { id: 2285, name: 'Farukhabad', stateId: 33 },
    { id: 2286, name: 'Fatehabad', stateId: 33 },
    { id: 2287, name: 'Fatehgarh', stateId: 33 },
    { id: 2288, name: 'Fatehpur', stateId: 33 },
    { id: 2289, name: 'Fatehpur Sikri', stateId: 33 },
    { id: 2290, name: 'Firozabad', stateId: 33 },
    { id: 2291, name: 'Gajraula', stateId: 33 },
    { id: 2292, name: 'Gangaghat', stateId: 33 },
    { id: 2293, name: 'Gangapur', stateId: 33 },
    { id: 2294, name: 'Gangoh', stateId: 33 },
    { id: 2295, name: 'Garautha', stateId: 33 },
    { id: 2296, name: 'Gauri Bazar', stateId: 33 },
    { id: 2297, name: 'Gausganj', stateId: 33 },
    { id: 2298, name: 'Noida', stateId: 33 },
    { id: 2299, name: 'Ghatampur', stateId: 33 },
    { id: 2300, name: 'Ghaziabad', stateId: 33 },
    { id: 2301, name: 'Ghazipur', stateId: 33 },
    { id: 2302, name: 'Ghorawal', stateId: 33 },
    { id: 2303, name: 'Ghosi', stateId: 33 },
    { id: 2304, name: 'Gokul', stateId: 33 },
    { id: 2305, name: 'Gola Bazar', stateId: 33 },
    { id: 2306, name: 'Gonda', stateId: 33 },
    { id: 2307, name: 'Gopamau', stateId: 33 },
    { id: 2308, name: 'Gopiganj', stateId: 33 },
    { id: 2309, name: 'Gorakhpur', stateId: 33 },
    { id: 2310, name: 'Gunnaur', stateId: 33 },
    { id: 2311, name: 'Gursahaiganj', stateId: 33 },
    { id: 2312, name: 'Gursarai', stateId: 33 },
    { id: 2313, name: 'Gyanpur', stateId: 33 },
    { id: 2314, name: 'Haidergarh', stateId: 33 },
    { id: 2315, name: 'Haldaur', stateId: 33 },
    { id: 2316, name: 'Hamirpur', stateId: 33 },
    { id: 2317, name: 'Handia', stateId: 33 },
    { id: 2318, name: 'Hapur', stateId: 33 },
    { id: 2319, name: 'Hardoi', stateId: 33 },
    { id: 2320, name: 'Harduaganj', stateId: 33 },
    { id: 2321, name: 'Hariharpur', stateId: 33 },
    { id: 2322, name: 'Harraiya', stateId: 33 },
    { id: 2323, name: 'Hasanpur', stateId: 33 },
    { id: 2324, name: 'Hasayan', stateId: 33 },
    { id: 2325, name: 'Hastinapur', stateId: 33 },
    { id: 2326, name: 'Hata', stateId: 33 },
    { id: 2327, name: 'Hathras', stateId: 33 },
    { id: 2328, name: 'Iglas', stateId: 33 },
    { id: 2329, name: 'Ikauna', stateId: 33 },
    { id: 2330, name: 'Jahangirabad', stateId: 33 },
    { id: 2331, name: 'Jahangirpur', stateId: 33 },
    { id: 2332, name: 'Jais', stateId: 33 },
    { id: 2333, name: 'Jalalabad', stateId: 33 },
    { id: 2334, name: 'Jalalpur', stateId: 33 },
    { id: 2335, name: 'Jalaun', stateId: 33 },
    { id: 2336, name: 'Jarwal', stateId: 33 },
    { id: 2337, name: 'Jasrana', stateId: 33 },
    { id: 2338, name: 'Jaswantnagar', stateId: 33 },
    { id: 2339, name: 'Jaunpur', stateId: 33 },
    { id: 2340, name: 'Jewar', stateId: 33 },
    { id: 2341, name: 'Jhalu', stateId: 33 },
    { id: 2342, name: 'Jhansi', stateId: 33 },
    { id: 2343, name: 'Jhinjhak', stateId: 33 },
    { id: 2344, name: 'Jhinjhana', stateId: 33 },
    { id: 2345, name: 'Jhusi', stateId: 33 },
    { id: 2346, name: 'Joya', stateId: 33 },
    { id: 2347, name: 'Kadipur', stateId: 33 },
    { id: 2348, name: 'Kairana', stateId: 33 },
    { id: 2349, name: 'Kakrala', stateId: 33 },
    { id: 2350, name: 'Kalpi', stateId: 33 },
    { id: 2351, name: 'Kamalganj', stateId: 33 },
    { id: 2352, name: 'Kannauj', stateId: 33 },
    { id: 2353, name: 'Kanpur', stateId: 33 },
    { id: 2354, name: 'Kanth', stateId: 33 },
    { id: 2355, name: 'Karari', stateId: 33 },
    { id: 2356, name: 'Karhal', stateId: 33 },
    { id: 2357, name: 'Kasganj', stateId: 33 },
    { id: 2358, name: 'Katra', stateId: 33 },
    { id: 2359, name: 'Kauriaganj', stateId: 33 },
    { id: 2360, name: 'Kaushambi', stateId: 33 },
    { id: 2361, name: 'Khadda', stateId: 33 },
    { id: 2362, name: 'Khaga', stateId: 33 },
    { id: 2363, name: 'Khair', stateId: 33 },
    { id: 2364, name: 'Khairabad', stateId: 33 },
    { id: 2365, name: 'Khalilabad', stateId: 33 },
    { id: 2366, name: 'Khamaria', stateId: 33 },
    { id: 2367, name: 'Khanpur', stateId: 33 },
    { id: 2368, name: 'Kharela', stateId: 33 },
    { id: 2369, name: 'Khatauli', stateId: 33 },
    { id: 2370, name: 'Kheri', stateId: 33 },
    { id: 2371, name: 'Khudaganj', stateId: 33 },
    { id: 2372, name: 'Khurja', stateId: 33 },
    { id: 2373, name: 'Khutar', stateId: 33 },
    { id: 2374, name: 'Kiratpur', stateId: 33 },
    { id: 2375, name: 'Kishni', stateId: 33 },
    { id: 2376, name: 'Konch', stateId: 33 },
    { id: 2377, name: 'Kopaganj', stateId: 33 },
    { id: 2378, name: 'Kunda', stateId: 33 },
    { id: 2379, name: 'Kundarki', stateId: 33 },
    { id: 2380, name: 'Kuraoli', stateId: 33 },
    { id: 2381, name: 'Kurara', stateId: 33 },
    { id: 2382, name: 'Kushinagar', stateId: 33 },
    { id: 2383, name: 'Kusmara', stateId: 33 },
    { id: 2384, name: 'Laharpur', stateId: 33 },
    { id: 2385, name: 'Lakhna', stateId: 33 },
    { id: 2386, name: 'Lalganj', stateId: 33 },
    { id: 2387, name: 'Lalitpur', stateId: 33 },
    { id: 2388, name: 'Lar', stateId: 33 },
    { id: 2389, name: 'Loni', stateId: 33 },
    { id: 2390, name: 'Lucknow', stateId: 33 },
    { id: 2391, name: 'Madhoganj', stateId: 33 },
    { id: 2392, name: 'Madhogarh', stateId: 33 },
    { id: 2393, name: 'Maghar', stateId: 33 },
    { id: 2394, name: 'Mahaban', stateId: 33 },
    { id: 2395, name: 'Mahoba', stateId: 33 },
    { id: 2396, name: 'Maholi', stateId: 33 },
    { id: 2397, name: 'Mahrajganj', stateId: 33 },
    { id: 2398, name: 'Mailani', stateId: 33 },
    { id: 2399, name: 'Mainpuri', stateId: 33 },
    { id: 2400, name: 'Majhauli Raj', stateId: 33 },
    { id: 2401, name: 'Malihabad', stateId: 33 },
    { id: 2402, name: 'Mallawan', stateId: 33 },
    { id: 2403, name: 'Mandawar', stateId: 33 },
    { id: 2404, name: 'Manikpur', stateId: 33 },
    { id: 2405, name: 'Marehra', stateId: 33 },
    { id: 2406, name: 'Mariahu', stateId: 33 },
    { id: 2407, name: 'Mathura', stateId: 33 },
    { id: 2408, name: 'Mauranipur', stateId: 33 },
    { id: 2409, name: 'Maurawan', stateId: 33 },
    { id: 2410, name: 'Mawana', stateId: 33 },
    { id: 2411, name: 'Meerut', stateId: 33 },
    { id: 2412, name: 'Mehdawal', stateId: 33 },
    { id: 2413, name: 'Mehnagar', stateId: 33 },
    { id: 2414, name: 'Milak', stateId: 33 },
    { id: 2415, name: 'Mirganj', stateId: 33 },
    { id: 2416, name: 'Mirzapur', stateId: 33 },
    { id: 2417, name: 'Modinagar', stateId: 33 },
    { id: 2418, name: 'Mohammadabad', stateId: 33 },
    { id: 2419, name: 'Mohammadi', stateId: 33 },
    { id: 2420, name: 'Mohan', stateId: 33 },
    { id: 2421, name: 'Mohiuddinpur', stateId: 33 },
    { id: 2422, name: 'Moradabad', stateId: 33 },
    { id: 2423, name: 'Moth', stateId: 33 },
    { id: 2424, name: 'Mubarakpur', stateId: 33 },
    { id: 2425, name: 'Muradnagar', stateId: 33 },
    { id: 2426, name: 'Mursan', stateId: 33 },
    { id: 2427, name: 'Musafirkhana', stateId: 33 },
    { id: 2428, name: 'Muzaffarnagar', stateId: 33 },
    { id: 2429, name: 'Nadigaon', stateId: 33 },
    { id: 2430, name: 'Nagina', stateId: 33 },
    { id: 2431, name: 'Nagram', stateId: 33 },
    { id: 2432, name: 'Nai Bazar', stateId: 33 },
    { id: 2433, name: 'Najibabad', stateId: 33 },
    { id: 2434, name: 'Nakur', stateId: 33 },
    { id: 2435, name: 'Nanauta', stateId: 33 },
    { id: 2436, name: 'Nanpara', stateId: 33 },
    { id: 2437, name: 'Naraini', stateId: 33 },
    { id: 2438, name: 'Narauli', stateId: 33 },
    { id: 2439, name: 'Nawabganj', stateId: 33 },
    { id: 2440, name: 'Nichlaul', stateId: 33 },
    { id: 2441, name: 'Nizamabad', stateId: 33 },
    { id: 2442, name: 'Obra', stateId: 33 },
    { id: 2443, name: 'Orai', stateId: 33 },
    { id: 2444, name: 'Pachperwa', stateId: 33 },
    { id: 2445, name: 'Padrauna', stateId: 33 },
    { id: 2446, name: 'Pahasu', stateId: 33 },
    { id: 2447, name: 'Pali', stateId: 33 },
    { id: 2448, name: 'Patti', stateId: 33 },
    { id: 2449, name: 'Phulpur', stateId: 33 },
    { id: 2450, name: 'Pihani', stateId: 33 },
    { id: 2451, name: 'Pilibhit', stateId: 33 },
    { id: 2452, name: 'Pilkhana', stateId: 33 },
    { id: 2453, name: 'Pilkhuwa', stateId: 33 },
    { id: 2454, name: 'Pinahat', stateId: 33 },
    { id: 2455, name: 'Pratapgarh', stateId: 33 },
    { id: 2456, name: 'Pratapgarh City', stateId: 33 },
    { id: 2457, name: 'Pukhrayan', stateId: 33 },
    { id: 2458, name: 'Puranpur', stateId: 33 },
    { id: 2459, name: 'Purwa', stateId: 33 },
    { id: 2460, name: 'Radhakund', stateId: 33 },
    { id: 2461, name: 'Rae Bareli', stateId: 33 },
    { id: 2462, name: 'Raibareilly', stateId: 33 },
    { id: 2463, name: 'Rajapur', stateId: 33 },
    { id: 2464, name: 'Ramkola', stateId: 33 },
    { id: 2465, name: 'Ramnagar', stateId: 33 },
    { id: 2466, name: 'Rampur', stateId: 33 },
    { id: 2467, name: 'Rampura', stateId: 33 },
    { id: 2468, name: 'Ranipur', stateId: 33 },
    { id: 2469, name: 'Rasra', stateId: 33 },
    { id: 2470, name: 'Rasulabad', stateId: 33 },
    { id: 2471, name: 'Raya', stateId: 33 },
    { id: 2472, name: 'Reoti', stateId: 33 },
    { id: 2473, name: 'Rudrapur', stateId: 33 },
    { id: 2474, name: 'Rura', stateId: 33 },
    { id: 2475, name: 'Sadabad', stateId: 33 },
    { id: 2476, name: 'Sadat', stateId: 33 },
    { id: 2477, name: 'Safipur', stateId: 33 },
    { id: 2478, name: 'Sahanpur', stateId: 33 },
    { id: 2479, name: 'Saharanpur', stateId: 33 },
    { id: 2480, name: 'Sahaspur', stateId: 33 },
    { id: 2481, name: 'Sahaswan', stateId: 33 },
    { id: 2482, name: 'Sahatwar', stateId: 33 },
    { id: 2483, name: 'Sahawar', stateId: 33 },
    { id: 2484, name: 'Sahjanwa', stateId: 33 },
    { id: 2485, name: 'Saidpur', stateId: 33 },
    { id: 2486, name: 'Salempur', stateId: 33 },
    { id: 2487, name: 'Salon', stateId: 33 },
    { id: 2488, name: 'Sambhal', stateId: 33 },
    { id: 2489, name: 'Samthar', stateId: 33 },
    { id: 2490, name: 'Sandi', stateId: 33 },
    { id: 2491, name: 'Sandila', stateId: 33 },
    { id: 2492, name: 'Sarai Mir', stateId: 33 },
    { id: 2493, name: 'Sasni', stateId: 33 },
    { id: 2494, name: 'Satrikh', stateId: 33 },
    { id: 2495, name: 'Saurikh', stateId: 33 },
    { id: 2496, name: 'Seohara', stateId: 33 },
    { id: 2497, name: 'Shahabad', stateId: 33 },
    { id: 2498, name: 'Shahganj', stateId: 33 },
    { id: 2499, name: 'Shahi', stateId: 33 },
    { id: 2500, name: 'Shahjahanpur', stateId: 33 },
    { id: 2501, name: 'Shahpur', stateId: 33 },
    { id: 2502, name: 'Shamli', stateId: 33 },
    { id: 2503, name: 'Shankargarh', stateId: 33 },
    { id: 2504, name: 'Shergarh', stateId: 33 },
    { id: 2505, name: 'Sherkot', stateId: 33 },
    { id: 2506, name: 'Shikarpur', stateId: 33 },
    { id: 2507, name: 'Shikohabad', stateId: 33 },
    { id: 2508, name: 'Shrawasti', stateId: 33 },
    { id: 2509, name: 'Siddharthnagar', stateId: 33 },
    { id: 2510, name: 'Sikanderpur', stateId: 33 },
    { id: 2511, name: 'Sikandra', stateId: 33 },
    { id: 2512, name: 'Sikandrabad', stateId: 33 },
    { id: 2513, name: 'Sirathu', stateId: 33 },
    { id: 2514, name: 'Sirsaganj', stateId: 33 },
    { id: 2515, name: 'Sirsi', stateId: 33 },
    { id: 2516, name: 'Sisauli', stateId: 33 },
    { id: 2517, name: 'Sitapur', stateId: 33 },
    { id: 2518, name: 'Sonbhadra', stateId: 33 },
    { id: 2519, name: 'Suar', stateId: 33 },
    { id: 2520, name: 'Sultanpur', stateId: 33 },
    { id: 2521, name: 'Suriyawan', stateId: 33 },
    { id: 2522, name: 'Talbehat', stateId: 33 },
    { id: 2523, name: 'Talgram', stateId: 33 },
    { id: 2524, name: 'Tanda', stateId: 33 },
    { id: 2525, name: 'Tetri Bazar', stateId: 33 },
    { id: 2526, name: 'Thakurdwara', stateId: 33 },
    { id: 2527, name: 'Thana Bhawan', stateId: 33 },
    { id: 2528, name: 'Tilhar', stateId: 33 },
    { id: 2529, name: 'Tindwari', stateId: 33 },
    { id: 2530, name: 'Tulsipur', stateId: 33 },
    { id: 2531, name: 'Tundla', stateId: 33 },
    { id: 2532, name: 'Ujhani', stateId: 33 },
    { id: 2533, name: 'Ujhari', stateId: 33 },
    { id: 2534, name: 'Umri', stateId: 33 },
    { id: 2535, name: 'Un', stateId: 33 },
    { id: 2536, name: 'Unnao', stateId: 33 },
    { id: 2537, name: 'Usawan', stateId: 33 },
    { id: 2538, name: 'Usehat', stateId: 33 },
    { id: 2539, name: 'Utraula', stateId: 33 },
    { id: 2540, name: 'Varanasi', stateId: 33 },
    { id: 2541, name: 'Wazirganj', stateId: 33 },
    { id: 2542, name: 'Zaidpur', stateId: 33 },
    { id: 2543, name: 'Zamania', stateId: 33 },
    { id: 2764, name: 'Noida', stateId: 33 },
    { id: 2793, name: 'Vasundhra', stateId: 33 },
    { id: 2805, name: 'Greater Noida', stateId: 33 },
    { id: 2894, name: 'Greater Noida West', stateId: 33 },
    { id: 2915, name: 'Maunath Bhanjan Mau', stateId: 33 },
    { id: 2917, name: 'Gautam Budh Nagar', stateId: 33 },
    { id: 2940, name: 'Prithvi Pur', stateId: 33 },
    { id: 2942, name: 'Dharmispur Mau', stateId: 33 },
    { id: 2964, name: 'Kanpur Dehat', stateId: 33 },
    { id: 2968, name: 'Sahibabad', stateId: 33 },
    { id: 2973, name: 'Mau', stateId: 33 },
    { id: 3126, name: 'BAGPAT', stateId: 33 },
    { id: 3127, name: 'FARRUKHABAD', stateId: 33 },
    { id: 3128, name: 'GAUTAM BUDDHA NAGAR', stateId: 33 },
    { id: 3129, name: 'KANPUR NAGAR', stateId: 33 },
    { id: 3130, name: 'KANSHIRAM NAGAR', stateId: 33 },
    { id: 3131, name: 'Prayagraj Allahabad', stateId: 33 },
    { id: 3132, name: 'RAEBARELI', stateId: 33 },
    { id: 3133, name: 'SANT KABIR NAGAR', stateId: 33 },
    { id: 3134, name: 'SANT RAVIDAS NAGAR', stateId: 33 },
    { id: 2544, name: 'Adheriya Khal', stateId: 34 },
    { id: 2545, name: 'Adibadri', stateId: 34 },
    { id: 2546, name: 'Agustmuni', stateId: 34 },
    { id: 2547, name: 'Almora', stateId: 34 },
    { id: 2548, name: 'Badrinath', stateId: 34 },
    { id: 2549, name: 'Bageshwar', stateId: 34 },
    { id: 2550, name: 'Bhimtal', stateId: 34 },
    { id: 2551, name: 'Bhirgukhal', stateId: 34 },
    { id: 2552, name: 'Bhowali', stateId: 34 },
    { id: 2553, name: 'Bughani', stateId: 34 },
    { id: 2554, name: 'Chakisain', stateId: 34 },
    { id: 2555, name: 'Chakrata', stateId: 34 },
    { id: 2556, name: 'Chamoli', stateId: 34 },
    { id: 2557, name: 'Champawat', stateId: 34 },
    { id: 2558, name: 'Chelusain', stateId: 34 },
    { id: 2559, name: 'Chipalghat', stateId: 34 },
    { id: 2560, name: 'Dehal Chauri', stateId: 34 },
    { id: 2561, name: 'Dehradun', stateId: 34 },
    { id: 2562, name: 'Dev Rajkhal', stateId: 34 },
    { id: 2563, name: 'Devidhura', stateId: 34 },
    { id: 2564, name: 'Devprayag', stateId: 34 },
    { id: 2565, name: 'Dharasoo', stateId: 34 },
    { id: 2566, name: 'Didihat', stateId: 34 },
    { id: 2567, name: 'Dineshpur', stateId: 34 },
    { id: 2568, name: 'Doiwala', stateId: 34 },
    { id: 2569, name: 'Dugadd', stateId: 34 },
    { id: 2570, name: 'Dukharkhal', stateId: 34 },
    { id: 2571, name: 'Dwarahat', stateId: 34 },
    { id: 2572, name: 'Dwarikhal', stateId: 34 },
    { id: 2573, name: 'Ekeshwar', stateId: 34 },
    { id: 2574, name: 'Gadarpur', stateId: 34 },
    { id: 2575, name: 'Gairsain', stateId: 34 },
    { id: 2576, name: 'Gauchar', stateId: 34 },
    { id: 2577, name: 'Gokulnagar', stateId: 34 },
    { id: 2578, name: 'Gopeshwar', stateId: 34 },
    { id: 2579, name: 'Guptakashi', stateId: 34 },
    { id: 2580, name: 'Gwaldam', stateId: 34 },
    { id: 2581, name: 'Haldwani', stateId: 34 },
    { id: 2582, name: 'Herbertpur', stateId: 34 },
    { id: 2583, name: 'Jakhani', stateId: 34 },
    { id: 2584, name: 'Jaspur', stateId: 34 },
    { id: 2585, name: 'Joshimath', stateId: 34 },
    { id: 2586, name: 'Kaladhungi', stateId: 34 },
    { id: 2587, name: 'Kalagarh', stateId: 34 },
    { id: 2588, name: 'Kaljikhal', stateId: 34 },
    { id: 2589, name: 'Kanda Khal', stateId: 34 },
    { id: 2590, name: 'Kanskhet', stateId: 34 },
    { id: 2591, name: 'Karan Prayag', stateId: 34 },
    { id: 2592, name: 'Kashipur', stateId: 34 },
    { id: 2593, name: 'Kausani', stateId: 34 },
    { id: 2594, name: 'Khatima', stateId: 34 },
    { id: 2595, name: 'Khirshn', stateId: 34 },
    { id: 2596, name: 'Kichha', stateId: 34 },
    { id: 2597, name: 'Kotdwar', stateId: 34 },
    { id: 2598, name: 'Kotdwara', stateId: 34 },
    { id: 2599, name: 'Lansdowne', stateId: 34 },
    { id: 2600, name: 'Lohaghat', stateId: 34 },
    { id: 2601, name: 'Maithana', stateId: 34 },
    { id: 2602, name: 'Mawadhar', stateId: 34 },
    { id: 2603, name: 'Munsiari', stateId: 34 },
    { id: 2604, name: 'Mussoorie', stateId: 34 },
    { id: 2605, name: 'Nainidada', stateId: 34 },
    { id: 2606, name: 'Nainital', stateId: 34 },
    { id: 2607, name: 'Naithana', stateId: 34 },
    { id: 2608, name: 'Nand Prayag', stateId: 34 },
    { id: 2609, name: 'Naugaon Khal', stateId: 34 },
    { id: 2610, name: 'Okhimath', stateId: 34 },
    { id: 2611, name: 'Pabua', stateId: 34 },
    { id: 2612, name: 'Paidul', stateId: 34 },
    { id: 2613, name: 'Pant Nagar', stateId: 34 },
    { id: 2614, name: 'Parsundakhal', stateId: 34 },
    { id: 2615, name: 'Pattisain', stateId: 34 },
    { id: 2616, name: 'Paukhal', stateId: 34 },
    { id: 2617, name: 'Pauri', stateId: 34 },
    { id: 2618, name: 'Pipalkoti', stateId: 34 },
    { id: 2619, name: 'Pithoragarh', stateId: 34 },
    { id: 2620, name: 'Porhra', stateId: 34 },
    { id: 2621, name: 'Raipur', stateId: 34 },
    { id: 2622, name: 'Raiwala', stateId: 34 },
    { id: 2623, name: 'Ram Nagar', stateId: 34 },
    { id: 2624, name: 'Ramgarh', stateId: 34 },
    { id: 2625, name: 'Rikhani Khal', stateId: 34 },
    { id: 2626, name: 'Rishikesh', stateId: 34 },
    { id: 2627, name: 'Rithakhal', stateId: 34 },
    { id: 2628, name: 'Roorkee', stateId: 34 },
    { id: 2629, name: 'Rudra Prayag', stateId: 34 },
    { id: 2630, name: 'Rudrapur', stateId: 34 },
    { id: 2631, name: 'Satpuri', stateId: 34 },
    { id: 2632, name: 'Sillogl', stateId: 34 },
    { id: 2633, name: 'Sittarganj', stateId: 34 },
    { id: 2634, name: 'Srinagar', stateId: 34 },
    { id: 2635, name: 'Toli', stateId: 34 },
    { id: 2636, name: 'Topowan', stateId: 34 },
    { id: 2637, name: 'Uttarkashi', stateId: 34 },
    { id: 2638, name: 'Vedikhal', stateId: 34 },
    { id: 2639, name: 'Vikas Nagar', stateId: 34 },
    { id: 2784, name: 'Haridwar', stateId: 34 },
    { id: 2900, name: 'Udham Singh Nagar', stateId: 34 },
    { id: 2911, name: 'Tehri Garhwal', stateId: 34 },
    { id: 3201, name: 'PAURI GARHWAL', stateId: 34 },
    { id: 3202, name: 'RUDRAPRAYAG', stateId: 34 },
    { id: 2640, name: 'West Dinajpur', stateId: 35 },
    { id: 2641, name: '24 Parganas', stateId: 35 },
    { id: 2642, name: 'Adra', stateId: 35 },
    { id: 2643, name: 'Aiho', stateId: 35 },
    { id: 2644, name: 'Alipore', stateId: 35 },
    { id: 2645, name: 'Alipurduar', stateId: 35 },
    { id: 2646, name: 'Amtala', stateId: 35 },
    { id: 2647, name: 'Aurangabad', stateId: 35 },
    { id: 2648, name: 'Baduria', stateId: 35 },
    { id: 2649, name: 'Bagnan', stateId: 35 },
    { id: 2650, name: 'Bahula', stateId: 35 },
    { id: 2651, name: 'Balichak', stateId: 35 },
    { id: 2652, name: 'Ballavpur', stateId: 35 },
    { id: 2653, name: 'Bally', stateId: 35 },
    { id: 2654, name: 'Balurghat', stateId: 35 },
    { id: 2655, name: 'Bankura', stateId: 35 },
    { id: 2656, name: 'Bansberia', stateId: 35 },
    { id: 2657, name: 'Baranagar', stateId: 35 },
    { id: 2658, name: 'Barasat', stateId: 35 },
    { id: 2659, name: 'Barast', stateId: 35 },
    { id: 2660, name: 'Bardhaman', stateId: 35 },
    { id: 2661, name: 'Begampur', stateId: 35 },
    { id: 2662, name: 'Beliatore', stateId: 35 },
    { id: 2663, name: 'Berhampore', stateId: 35 },
    { id: 2664, name: 'Bhadreswar', stateId: 35 },
    { id: 2665, name: 'Bidhan Nagar', stateId: 35 },
    { id: 2666, name: 'Birlapur', stateId: 35 },
    { id: 2667, name: 'Bishnupur', stateId: 35 },
    { id: 2668, name: 'Bolpur', stateId: 35 },
    { id: 2669, name: 'Bowali', stateId: 35 },
    { id: 2670, name: 'Budge Budge', stateId: 35 },
    { id: 2671, name: 'Canning - II', stateId: 35 },
    { id: 2672, name: 'Chakdaha', stateId: 35 },
    { id: 2673, name: 'Champdani', stateId: 35 },
    { id: 2674, name: 'Chinsurah', stateId: 35 },
    { id: 2675, name: 'Chittaranjan', stateId: 35 },
    { id: 2676, name: 'Dainhat', stateId: 35 },
    { id: 2677, name: 'Darjiling', stateId: 35 },
    { id: 2678, name: 'Debipur', stateId: 35 },
    { id: 2679, name: 'Dhakuria', stateId: 35 },
    { id: 2680, name: 'Dhandadihi', stateId: 35 },
    { id: 2681, name: 'Dhatrigram', stateId: 35 },
    { id: 2682, name: 'Dhulian', stateId: 35 },
    { id: 2683, name: 'Dinhata', stateId: 35 },
    { id: 2684, name: 'Domjur', stateId: 35 },
    { id: 2685, name: 'Dubrajpur', stateId: 35 },
    { id: 2686, name: 'Durgapur', stateId: 35 },
    { id: 2687, name: 'Egra', stateId: 35 },
    { id: 2688, name: 'English Bazar', stateId: 35 },
    { id: 2689, name: 'Falakata', stateId: 35 },
    { id: 2690, name: 'Gairkata', stateId: 35 },
    { id: 2691, name: 'Gangarampur', stateId: 35 },
    { id: 2692, name: 'Ghatal', stateId: 35 },
    { id: 2693, name: 'Ghorsala', stateId: 35 },
    { id: 2694, name: 'Goaljan', stateId: 35 },
    { id: 2695, name: 'Gobardanga', stateId: 35 },
    { id: 2696, name: 'Gopinathpur', stateId: 35 },
    { id: 2697, name: 'Haldia', stateId: 35 },
    { id: 2698, name: 'Haldibari', stateId: 35 },
    { id: 2699, name: 'Halisahar', stateId: 35 },
    { id: 2700, name: 'Haripur', stateId: 35 },
    { id: 2701, name: 'Howrah', stateId: 35 },
    { id: 2702, name: 'Islampur', stateId: 35 },
    { id: 2703, name: 'Jalpaiguri', stateId: 35 },
    { id: 2704, name: 'Jangipur', stateId: 35 },
    { id: 2705, name: 'Jhalda', stateId: 35 },
    { id: 2706, name: 'Kalimpong', stateId: 35 },
    { id: 2707, name: 'Kalna', stateId: 35 },
    { id: 2708, name: 'Kalyani', stateId: 35 },
    { id: 2709, name: 'Kamarhati', stateId: 35 },
    { id: 2710, name: 'Kanaipur', stateId: 35 },
    { id: 2711, name: 'Kanchrapara', stateId: 35 },
    { id: 2712, name: 'Karimpur', stateId: 35 },
    { id: 2713, name: 'Kasba', stateId: 35 },
    { id: 2714, name: 'Kendua', stateId: 35 },
    { id: 2715, name: 'Kharagpur', stateId: 35 },
    { id: 2716, name: 'Kharar', stateId: 35 },
    { id: 2717, name: 'Koch Bihar', stateId: 35 },
    { id: 2718, name: 'Kolaghat', stateId: 35 },
    { id: 2719, name: 'Kolkata', stateId: 35 },
    { id: 2720, name: 'Konnagar', stateId: 35 },
    { id: 2721, name: 'Krishnagar', stateId: 35 },
    { id: 2722, name: 'Krishnapur', stateId: 35 },
    { id: 2723, name: 'Kulti', stateId: 35 },
    { id: 2724, name: 'Kurseong', stateId: 35 },
    { id: 2725, name: 'Madanpur', stateId: 35 },
    { id: 2726, name: 'Maslandapur', stateId: 35 },
    { id: 2727, name: 'Mathabhanga', stateId: 35 },
    { id: 2728, name: 'Medinipur', stateId: 35 },
    { id: 2729, name: 'Mekliganj', stateId: 35 },
    { id: 2730, name: 'Memari', stateId: 35 },
    { id: 2731, name: 'Mirik', stateId: 35 },
    { id: 2732, name: 'Nabagram', stateId: 35 },
    { id: 2733, name: 'Naihati', stateId: 35 },
    { id: 2734, name: 'Nasra', stateId: 35 },
    { id: 2735, name: 'Natibpur', stateId: 35 },
    { id: 2736, name: 'Panchla', stateId: 35 },
    { id: 2737, name: 'Pandua', stateId: 35 },
    { id: 2738, name: 'Panihati', stateId: 35 },
    { id: 2739, name: 'Panuhat', stateId: 35 },
    { id: 2740, name: 'Puruliya', stateId: 35 },
    { id: 2741, name: 'Raghunathpur', stateId: 35 },
    { id: 2742, name: 'Raiganj', stateId: 35 },
    { id: 2743, name: 'Raigung', stateId: 35 },
    { id: 2744, name: 'Rajarhat Gopalpur', stateId: 35 },
    { id: 2745, name: 'Ramchandrapur', stateId: 35 },
    { id: 2746, name: 'Ramjibanpur', stateId: 35 },
    { id: 2747, name: 'Ramnagar', stateId: 35 },
    { id: 2748, name: 'Rishra', stateId: 35 },
    { id: 2749, name: 'Sahapur', stateId: 35 },
    { id: 2750, name: 'Sainthia', stateId: 35 },
    { id: 2751, name: 'Sankrail', stateId: 35 },
    { id: 2752, name: 'Santipur', stateId: 35 },
    { id: 2753, name: 'Santoshpur', stateId: 35 },
    { id: 2754, name: 'Sarenga', stateId: 35 },
    { id: 2755, name: 'Simla', stateId: 35 },
    { id: 2756, name: 'Singur', stateId: 35 },
    { id: 2757, name: 'Sonamukhi', stateId: 35 },
    { id: 2758, name: 'Suri', stateId: 35 },
    { id: 2759, name: 'Taherpur', stateId: 35 },
    { id: 2760, name: 'Taki', stateId: 35 },
    { id: 2761, name: 'Titagarh', stateId: 35 },
    { id: 2762, name: 'Ukhra', stateId: 35 },
    { id: 2763, name: 'Uluberia', stateId: 35 },
    { id: 2771, name: 'Siliguri', stateId: 35 },
    { id: 2802, name: 'Sodepur', stateId: 35 },
    { id: 2812, name: 'Salt Lake City', stateId: 35 },
    { id: 2814, name: 'Dalkhola', stateId: 35 },
    { id: 2815, name: 'North Dinajpur', stateId: 35 },
    { id: 2816, name: 'Hooghly', stateId: 35 },
    { id: 2817, name: 'Nadia', stateId: 35 },
    { id: 2819, name: 'Murshidabad', stateId: 35 },
    { id: 2823, name: 'Midnapore', stateId: 35 },
    { id: 2824, name: 'Birbhum', stateId: 35 },
    { id: 2825, name: 'Cooch Behar', stateId: 35 },
    { id: 2826, name: 'East Midnapore', stateId: 35 },
    { id: 2827, name: 'Malda', stateId: 35 },
    { id: 2828, name: 'West Midnapore', stateId: 35 },
    { id: 2858, name: 'Baruipur Em Anima Haldar', stateId: 35 },
    { id: 2874, name: 'Jaigaon', stateId: 35 },
    { id: 2879, name: 'Kadamtala', stateId: 35 },
    { id: 2906, name: 'South 24 Parganas', stateId: 35 },
    { id: 2923, name: 'Singadaha', stateId: 35 },
    { id: 2934, name: 'Madhepura', stateId: 35 },
    { id: 3135, name: 'Darjeeling', stateId: 35 },
    { id: 3136, name: 'EAST SIKKIM', stateId: 35 },
    { id: 3137, name: 'NORTH 24 PARGANAS', stateId: 35 },
    { id: 3138, name: 'NORTH SIKKIM', stateId: 35 },
    { id: 3139, name: 'Paschim Bardhaman', stateId: 35 },
    { id: 3140, name: 'SOUTH DINAJPUR', stateId: 35 },
    { id: 3141, name: 'SOUTH SIKKIM', stateId: 35 },
    { id: 3217, name: 'Chalsa', stateId: 35 },
    { id: 3220, name: 'Naxalbari', stateId: 35 },
    { id: 3221, name: 'Hemtabad', stateId: 35 },
    { id: 2769, name: 'Chennai', stateId: 39 },
    { id: 3, name: 'Achanta', stateId: 42 },
    { id: 5, name: 'Adilabad', stateId: 42 },
    { id: 6, name: 'Adivarampet', stateId: 42 },
    { id: 7, name: 'Adoni', stateId: 42 },
    { id: 8, name: 'Agadur', stateId: 42 },
    { id: 9, name: 'Agnoor', stateId: 42 },
    { id: 10, name: 'Ainapur', stateId: 42 },
    { id: 11, name: 'Ajjada', stateId: 42 },
    { id: 15, name: 'Asifabad', stateId: 42 },
    { id: 16, name: 'Balkonda', stateId: 42 },
    { id: 17, name: 'Balusupadu', stateId: 42 },
    { id: 18, name: 'Bandankal', stateId: 42 },
    { id: 19, name: 'Banswada', stateId: 42 },
    { id: 20, name: 'Bardipur', stateId: 42 },
    { id: 22, name: 'Bhainsa', stateId: 42 },
    { id: 23, name: 'Bhongir', stateId: 42 },
    { id: 24, name: 'Bodhan', stateId: 42 },
    { id: 26, name: 'Chirala', stateId: 42 },
    { id: 29, name: 'Dammapeta', stateId: 42 },
    { id: 30, name: 'Dangeru', stateId: 42 },
    { id: 31, name: 'Dharmavaram', stateId: 42 },
    { id: 32, name: 'Domakonda', stateId: 42 },
    { id: 33, name: 'Dommeru', stateId: 42 },
    { id: 35, name: 'Ekambara kuppam', stateId: 42 },
    { id: 37, name: 'Gadwal', stateId: 42 },
    { id: 38, name: 'Gooty', stateId: 42 },
    { id: 41, name: 'Gundmal', stateId: 42 },
    { id: 42, name: 'Gundugolanu', stateId: 42 },
    { id: 43, name: 'Gundupapala', stateId: 42 },
    { id: 44, name: 'Guntakal', stateId: 42 },
    { id: 46, name: 'Hindupur', stateId: 42 },
    { id: 47, name: 'Husnabad', stateId: 42 },
    { id: 48, name: 'Huzurnagar', stateId: 42 },
    { id: 49, name: 'Hyderabad', stateId: 42 },
    { id: 52, name: 'Jagtial', stateId: 42 },
    { id: 53, name: 'Jangaon', stateId: 42 },
    { id: 56, name: 'Kallur', stateId: 42 },
    { id: 57, name: 'Kamareddy', stateId: 42 },
    { id: 60, name: 'Karimnagar', stateId: 42 },
    { id: 61, name: 'Kavali', stateId: 42 },
    { id: 62, name: 'Khammam', stateId: 42 },
    { id: 63, name: 'Koratla', stateId: 42 },
    { id: 68, name: 'Lingotam', stateId: 42 },
    { id: 69, name: 'Macherla', stateId: 42 },
    { id: 71, name: 'Madanapalle', stateId: 42 },
    { id: 72, name: 'Mahboobnagar', stateId: 42 },
    { id: 73, name: 'Malkajgiri', stateId: 42 },
    { id: 75, name: 'Markapur', stateId: 42 },
    { id: 76, name: 'Medak', stateId: 42 },
    { id: 78, name: 'Nalgonda', stateId: 42 },
    { id: 80, name: 'Narayanpet', stateId: 42 },
    { id: 85, name: 'Nirmal', stateId: 42 },
    { id: 86, name: 'Nizamabad', stateId: 42 },
    { id: 89, name: 'Palwancha', stateId: 42 },
    { id: 92, name: 'Ponnur', stateId: 42 },
    { id: 95, name: 'Puttur', stateId: 42 },
    { id: 97, name: 'Rajam', stateId: 42 },
    { id: 98, name: 'Rajendranagar', stateId: 42 },
    { id: 99, name: 'Ranga Reddy', stateId: 42 },
    { id: 100, name: 'Rayadurg', stateId: 42 },
    { id: 101, name: 'Repalle', stateId: 42 },
    { id: 102, name: 'Sangareddy', stateId: 42 },
    { id: 103, name: 'Sarapaka', stateId: 42 },
    { id: 105, name: 'Secunderabad', stateId: 42 },
    { id: 106, name: 'Siddipet', stateId: 42 },
    { id: 107, name: 'Sirsilla', stateId: 42 },
    { id: 110, name: 'Suryapet', stateId: 42 },
    { id: 111, name: 'Suryaraopeta', stateId: 42 },
    { id: 113, name: 'Tandur', stateId: 42 },
    { id: 123, name: 'Wanaparthi', stateId: 42 },
    { id: 124, name: 'Warangal', stateId: 42 },
    { id: 126, name: 'Yeditha', stateId: 42 },
    { id: 127, name: 'Yellandu', stateId: 42 },
    { id: 128, name: 'Yemmiganur', stateId: 42 },
    { id: 129, name: 'Yerraguntla', stateId: 42 },
    { id: 130, name: 'Zahirabad', stateId: 42 },
    { id: 2971, name: 'Rengareddy', stateId: 42 },
    { id: 3142, name: 'BHUPALPALLI', stateId: 42 },
    { id: 3143, name: 'Hanamkonda', stateId: 42 },
    { id: 3144, name: 'JAYASHANKAR', stateId: 42 },
    { id: 3145, name: 'K.V.Rangareddy', stateId: 42 },
    { id: 3146, name: 'KARIM NAGAR', stateId: 42 },
    { id: 3147, name: 'KOTHAGUDEM', stateId: 42 },
    { id: 3148, name: 'KOTHAGUDEM COLLS', stateId: 42 },
    { id: 3149, name: 'Mahabuababad', stateId: 42 },
    { id: 3150, name: 'MAHABUB NAGAR', stateId: 42 },
    { id: 3151, name: 'MAHABUBABAD', stateId: 42 },
    { id: 3152, name: 'MANCHERIAL', stateId: 42 },
    { id: 3153, name: 'NAGAR KURNOOL', stateId: 42 },
    { id: 3154, name: 'Parkal', stateId: 42 },
    { id: 3155, name: 'PEDDAPALLI', stateId: 42 },
    { id: 3156, name: 'RANGAREDDY', stateId: 42 },
    { id: 3157, name: 'SIRCILLA', stateId: 42 },
    { id: 3158, name: 'STN. JADCHERLA', stateId: 42 },
    { id: 3159, name: 'Trimulgherry', stateId: 42 },
    { id: 3160, name: 'Vikarabad', stateId: 42 },
    { id: 3161, name: 'WANAPARTHY', stateId: 42 },
    { id: 3162, name: 'Warangal Rural', stateId: 42 },
    { id: 3163, name: 'ZAHEERABAD', stateId: 42 },
    { id: 3212, name: 'Madhapur', stateId: 42 }
    // Add more cities corresponding to each state
];
export const pincodes = [
    { id: 26082, cityId: 1, code: "744301" },
    { id: 26083, cityId: 2, code: "744101" },
    { id: 26084, cityId: 2, code: "744104" },
    { id: 26085, cityId: 2, code: "744106" },
    { id: 26086, cityId: 2, code: "744107" },
    { id: 26087, cityId: 2, code: "744202" },
    { id: 26088, cityId: 2, code: "744204" },
    { id: 26089, cityId: 2, code: "744205" },
    { id: 26090, cityId: 2, code: "744207" },
    { id: 26091, cityId: 2, code: "744210" },
    { id: 26092, cityId: 2, code: "744302" },
    { id: 26093, cityId: 2, code: "744303" },
    { id: 26094, cityId: 2, code: "744102" },
    { id: 26095, cityId: 2, code: "744103" },
    { id: 26096, cityId: 2, code: "744105" },
    { id: 26097, cityId: 2, code: "744201" },
    { id: 26098, cityId: 2, code: "744203" },
    { id: 26099, cityId: 2, code: "744206" },
    { id: 26100, cityId: 2, code: "744208" },
    { id: 26101, cityId: 2, code: "744209" },
    { id: 26102, cityId: 2, code: "744211" },
    { id: 26103, cityId: 2, code: "744304" },
    { id: 26104, cityId: 3, code: "534123" },
    { id: 26105, cityId: 4, code: "523201" },
    { id: 26106, cityId: 5, code: "504002" },
    { id: 26107, cityId: 5, code: "504103" },
    { id: 26108, cityId: 5, code: "504105" },
    { id: 26109, cityId: 5, code: "504106" },
    { id: 26110, cityId: 5, code: "504201" },
    { id: 26111, cityId: 5, code: "504203" },
    { id: 26112, cityId: 5, code: "504204" },
    { id: 26113, cityId: 5, code: "504206" },
    { id: 26114, cityId: 5, code: "504209" },
    { id: 26115, cityId: 5, code: "504214" },
    { id: 26116, cityId: 5, code: "504217" },
    { id: 26117, cityId: 5, code: "504220" },
    { id: 26118, cityId: 5, code: "504232" },
    { id: 26119, cityId: 5, code: "504251" },
    { id: 26120, cityId: 5, code: "504273" },
    { id: 26121, cityId: 5, code: "504294" },
    { id: 26122, cityId: 5, code: "504296" },
    { id: 26123, cityId: 5, code: "504299" },
    { id: 26124, cityId: 5, code: "504301" },
    { id: 26125, cityId: 5, code: "504304" },
    { id: 26126, cityId: 5, code: "504307" },
    { id: 26127, cityId: 5, code: "504309" },
    { id: 26128, cityId: 5, code: "504310" },
    { id: 26129, cityId: 5, code: "504312" },
    { id: 26130, cityId: 5, code: "504318" },
    { id: 26131, cityId: 5, code: "504323" },
    { id: 26132, cityId: 5, code: "504325" },
    { id: 26133, cityId: 5, code: "504330" },
    { id: 26134, cityId: 5, code: "504344" },
    { id: 26135, cityId: 5, code: "504346" },
    { id: 26136, cityId: 5, code: "504001" },
    { id: 26137, cityId: 5, code: "504003" },
    { id: 26138, cityId: 5, code: "504101" },
    { id: 26139, cityId: 5, code: "504102" },
    { id: 26140, cityId: 5, code: "504109" },
    { id: 26141, cityId: 5, code: "504110" },
    { id: 26142, cityId: 5, code: "504202" },
    { id: 26143, cityId: 5, code: "504205" },
    { id: 26144, cityId: 5, code: "504207" },
    { id: 26145, cityId: 5, code: "504208" },
    { id: 26146, cityId: 5, code: "504215" },
    { id: 26147, cityId: 5, code: "504216" },
    { id: 26148, cityId: 5, code: "504218" },
    { id: 26149, cityId: 5, code: "504231" },
    { id: 26150, cityId: 5, code: "504292" },
    { id: 26151, cityId: 5, code: "504295" },
    { id: 26152, cityId: 5, code: "504305" },
    { id: 26153, cityId: 5, code: "504306" },
    { id: 26154, cityId: 5, code: "504308" },
    { id: 26155, cityId: 5, code: "504311" },
    { id: 26156, cityId: 5, code: "504313" },
    { id: 26157, cityId: 5, code: "504319" },
    { id: 26158, cityId: 5, code: "504321" },
    { id: 26159, cityId: 5, code: "504322" },
    { id: 26160, cityId: 5, code: "504324" },
    { id: 26161, cityId: 5, code: "504327" },
    { id: 26162, cityId: 5, code: "504340" },
    { id: 26163, cityId: 5, code: "504342" },
    { id: 26164, cityId: 5, code: "504343" },
    { id: 26165, cityId: 6, code: "505188" },
    { id: 26166, cityId: 7, code: "518301" },
    { id: 26167, cityId: 8, code: "516421" },
    { id: 26168, cityId: 9, code: "501146" },
    { id: 26169, cityId: 10, code: "501522" },
    { id: 26170, cityId: 11, code: "532552" },
    { id: 26171, cityId: 12, code: "533201" },
    { id: 26172, cityId: 13, code: "531001" },
    { id: 26173, cityId: 14, code: "515001" },
    { id: 26174, cityId: 14, code: "515003" },
    { id: 26175, cityId: 14, code: "515101" },
    { id: 26176, cityId: 14, code: "515122" },
    { id: 26177, cityId: 14, code: "515123" },
    { id: 26178, cityId: 14, code: "515133" },
    { id: 26179, cityId: 14, code: "515144" },
    { id: 26180, cityId: 14, code: "515154" },
    { id: 26181, cityId: 14, code: "515159" },
    { id: 26182, cityId: 14, code: "515202" },
    { id: 26183, cityId: 14, code: "515212" },
    { id: 26184, cityId: 14, code: "515213" },
    { id: 26185, cityId: 14, code: "515231" },
    { id: 26186, cityId: 14, code: "515233" },
    { id: 26187, cityId: 14, code: "515241" },
    { id: 26188, cityId: 14, code: "515271" },
    { id: 26189, cityId: 14, code: "515281" },
    { id: 26190, cityId: 14, code: "515286" },
    { id: 26191, cityId: 14, code: "515292" },
    { id: 26192, cityId: 14, code: "515302" },
    { id: 26193, cityId: 14, code: "515303" },
    { id: 26194, cityId: 14, code: "515305" },
    { id: 26195, cityId: 14, code: "515311" },
    { id: 26196, cityId: 14, code: "515321" },
    { id: 26197, cityId: 14, code: "515331" },
    { id: 26198, cityId: 14, code: "515332" },
    { id: 26199, cityId: 14, code: "515401" },
    { id: 26200, cityId: 14, code: "515408" },
    { id: 26201, cityId: 14, code: "515409" },
    { id: 26202, cityId: 14, code: "515411" },
    { id: 26203, cityId: 14, code: "515414" },
    { id: 26204, cityId: 14, code: "515416" },
    { id: 26205, cityId: 14, code: "515419" },
    { id: 26206, cityId: 14, code: "515422" },
    { id: 26207, cityId: 14, code: "515427" },
    { id: 26208, cityId: 14, code: "515435" },
    { id: 26209, cityId: 14, code: "515445" },
    { id: 26210, cityId: 14, code: "515446" },
    { id: 26211, cityId: 14, code: "515456" },
    { id: 26212, cityId: 14, code: "515501" },
    { id: 26213, cityId: 14, code: "515541" },
    { id: 26214, cityId: 14, code: "515551" },
    { id: 26215, cityId: 14, code: "515572" },
    { id: 26216, cityId: 14, code: "515581" },
    { id: 26217, cityId: 14, code: "515583" },
    { id: 26218, cityId: 14, code: "515631" },
    { id: 26219, cityId: 14, code: "515641" },
    { id: 26220, cityId: 14, code: "515671" },
    { id: 26221, cityId: 14, code: "515711" },
    { id: 26222, cityId: 14, code: "515731" },
    { id: 26223, cityId: 14, code: "515761" },
    { id: 26224, cityId: 14, code: "515763" },
    { id: 26225, cityId: 14, code: "515766" },
    { id: 26226, cityId: 14, code: "515774" },
    { id: 26227, cityId: 14, code: "515787" },
    { id: 26228, cityId: 14, code: "515801" },
    { id: 26229, cityId: 14, code: "515803" },
    { id: 26230, cityId: 14, code: "515814" },
    { id: 26231, cityId: 14, code: "515822" },
    { id: 26232, cityId: 14, code: "515824" },
    { id: 26233, cityId: 14, code: "515832" },
    { id: 26234, cityId: 14, code: "515835" },
    { id: 26235, cityId: 14, code: "515843" },
    { id: 26236, cityId: 14, code: "515866" },
    { id: 26237, cityId: 14, code: "515867" },
    { id: 26238, cityId: 14, code: "515872" },
    { id: 26239, cityId: 14, code: "515002" },
    { id: 26240, cityId: 14, code: "515004" },
    { id: 26241, cityId: 14, code: "515005" },
    { id: 26242, cityId: 14, code: "515102" },
    { id: 26243, cityId: 14, code: "515110" },
    { id: 26244, cityId: 14, code: "515124" },
    { id: 26245, cityId: 14, code: "515134" },
    { id: 26246, cityId: 14, code: "515161" },
    { id: 26247, cityId: 14, code: "515164" },
    { id: 26248, cityId: 14, code: "515211" },
    { id: 26249, cityId: 14, code: "515214" },
    { id: 26250, cityId: 14, code: "515232" },
    { id: 26251, cityId: 14, code: "515261" },
    { id: 26252, cityId: 14, code: "515282" },
    { id: 26253, cityId: 14, code: "515291" },
    { id: 26254, cityId: 14, code: "515301" },
    { id: 26255, cityId: 14, code: "515306" },
    { id: 26256, cityId: 14, code: "515307" },
    { id: 26257, cityId: 14, code: "515322" },
    { id: 26258, cityId: 14, code: "515341" },
    { id: 26259, cityId: 14, code: "515402" },
    { id: 26260, cityId: 14, code: "515404" },
    { id: 26261, cityId: 14, code: "515405" },
    { id: 26262, cityId: 14, code: "515415" },
    { id: 26263, cityId: 14, code: "515421" },
    { id: 26264, cityId: 14, code: "515425" },
    { id: 26265, cityId: 14, code: "515426" },
    { id: 26266, cityId: 14, code: "515455" },
    { id: 26267, cityId: 14, code: "515457" },
    { id: 26268, cityId: 14, code: "515458" },
    { id: 26269, cityId: 14, code: "515465" },
    { id: 26270, cityId: 14, code: "515466" },
    { id: 26271, cityId: 14, code: "515502" },
    { id: 26272, cityId: 14, code: "515511" },
    { id: 26273, cityId: 14, code: "515521" },
    { id: 26274, cityId: 14, code: "515531" },
    { id: 26275, cityId: 14, code: "515561" },
    { id: 26276, cityId: 14, code: "515566" },
    { id: 26277, cityId: 14, code: "515571" },
    { id: 26278, cityId: 14, code: "515601" },
    { id: 26279, cityId: 14, code: "515611" },
    { id: 26280, cityId: 14, code: "515621" },
    { id: 26281, cityId: 14, code: "515651" },
    { id: 26282, cityId: 14, code: "515661" },
    { id: 26283, cityId: 14, code: "515662" },
    { id: 26284, cityId: 14, code: "515672" },
    { id: 26285, cityId: 14, code: "515701" },
    { id: 26286, cityId: 14, code: "515712" },
    { id: 26287, cityId: 14, code: "515722" },
    { id: 26288, cityId: 14, code: "515736" },
    { id: 26289, cityId: 14, code: "515741" },
    { id: 26290, cityId: 14, code: "515751" },
    { id: 26291, cityId: 14, code: "515752" },
    { id: 26292, cityId: 14, code: "515762" },
    { id: 26293, cityId: 14, code: "515765" },
    { id: 26294, cityId: 14, code: "515767" },
    { id: 26295, cityId: 14, code: "515775" },
    { id: 26296, cityId: 14, code: "515812" },
    { id: 26297, cityId: 14, code: "515813" },
    { id: 26298, cityId: 14, code: "515823" },
    { id: 26299, cityId: 14, code: "515833" },
    { id: 26300, cityId: 14, code: "515834" },
    { id: 26301, cityId: 14, code: "515842" },
    { id: 26302, cityId: 14, code: "515844" },
    { id: 26303, cityId: 14, code: "515862" },
    { id: 26304, cityId: 14, code: "515863" },
    { id: 26305, cityId: 14, code: "515865" },
    { id: 26306, cityId: 14, code: "515870" },
    { id: 26307, cityId: 15, code: "504293" },
    { id: 26308, cityId: 16, code: "503217" },
    { id: 26309, cityId: 17, code: "521177" },
    { id: 26310, cityId: 18, code: "505407" },
    { id: 26311, cityId: 19, code: "503187" },
    { id: 26312, cityId: 20, code: "503231" },
    { id: 26313, cityId: 21, code: "507111" },
    { id: 26314, cityId: 22, code: "504103" },
    { id: 26315, cityId: 23, code: "508116" },
    { id: 26316, cityId: 24, code: "503185" },
    { id: 26317, cityId: 25, code: "517417" },
    { id: 26318, cityId: 26, code: "523155" },
    { id: 26319, cityId: 27, code: "517002" },
    { id: 26320, cityId: 27, code: "517004" },
    { id: 26321, cityId: 27, code: "517102" },
    { id: 26322, cityId: 27, code: "517103" },
    { id: 26323, cityId: 27, code: "517105" },
    { id: 26324, cityId: 27, code: "517108" },
    { id: 26325, cityId: 27, code: "517110" },
    { id: 26326, cityId: 27, code: "517111" },
    { id: 26327, cityId: 27, code: "517116" },
    { id: 26328, cityId: 27, code: "517118" },
    { id: 26329, cityId: 27, code: "517123" },
    { id: 26330, cityId: 27, code: "517124" },
    { id: 26331, cityId: 27, code: "517126" },
    { id: 26332, cityId: 27, code: "517129" },
    { id: 26333, cityId: 27, code: "517131" },
    { id: 26334, cityId: 27, code: "517132" },
    { id: 26335, cityId: 27, code: "517134" },
    { id: 26336, cityId: 27, code: "517137" },
    { id: 26337, cityId: 27, code: "517139" },
    { id: 26338, cityId: 27, code: "517140" },
    { id: 26339, cityId: 27, code: "517142" },
    { id: 26340, cityId: 27, code: "517145" },
    { id: 26341, cityId: 27, code: "517147" },
    { id: 26342, cityId: 27, code: "517148" },
    { id: 26343, cityId: 27, code: "517150" },
    { id: 26344, cityId: 27, code: "517153" },
    { id: 26345, cityId: 27, code: "517161" },
    { id: 26346, cityId: 27, code: "517163" },
    { id: 26347, cityId: 27, code: "517166" },
    { id: 26348, cityId: 27, code: "517192" },
    { id: 26349, cityId: 27, code: "517193" },
    { id: 26350, cityId: 27, code: "517195" },
    { id: 26351, cityId: 27, code: "517198" },
    { id: 26352, cityId: 27, code: "517213" },
    { id: 26353, cityId: 27, code: "517214" },
    { id: 26354, cityId: 27, code: "517216" },
    { id: 26355, cityId: 27, code: "517235" },
    { id: 26356, cityId: 27, code: "517237" },
    { id: 26357, cityId: 27, code: "517238" },
    { id: 26358, cityId: 27, code: "517240" },
    { id: 26359, cityId: 27, code: "517248" },
    { id: 26360, cityId: 27, code: "517259" },
    { id: 26361, cityId: 27, code: "517277" },
    { id: 26362, cityId: 27, code: "517280" },
    { id: 26363, cityId: 27, code: "517291" },
    { id: 26364, cityId: 27, code: "517298" },
    { id: 26365, cityId: 27, code: "517299" },
    { id: 26366, cityId: 27, code: "517301" },
    { id: 26367, cityId: 27, code: "517319" },
    { id: 26368, cityId: 27, code: "517325" },
    { id: 26369, cityId: 27, code: "517327" },
    { id: 26370, cityId: 27, code: "517330" },
    { id: 26371, cityId: 27, code: "517351" },
    { id: 26372, cityId: 27, code: "517352" },
    { id: 26373, cityId: 27, code: "517370" },
    { id: 26374, cityId: 27, code: "517391" },
    { id: 26375, cityId: 27, code: "517415" },
    { id: 26376, cityId: 27, code: "517417" },
    { id: 26377, cityId: 27, code: "517418" },
    { id: 26378, cityId: 27, code: "517423" },
    { id: 26379, cityId: 27, code: "517425" },
    { id: 26380, cityId: 27, code: "517431" },
    { id: 26381, cityId: 27, code: "517502" },
    { id: 26382, cityId: 27, code: "517503" },
    { id: 26383, cityId: 27, code: "517505" },
    { id: 26384, cityId: 27, code: "517507" },
    { id: 26385, cityId: 27, code: "517515" },
    { id: 26386, cityId: 27, code: "517516" },
    { id: 26387, cityId: 27, code: "517526" },
    { id: 26388, cityId: 27, code: "517561" },
    { id: 26389, cityId: 27, code: "517566" },
    { id: 26390, cityId: 27, code: "517569" },
    { id: 26391, cityId: 27, code: "517571" },
    { id: 26392, cityId: 27, code: "517584" },
    { id: 26393, cityId: 27, code: "517587" },
    { id: 26394, cityId: 27, code: "517590" },
    { id: 26395, cityId: 27, code: "517619" },
    { id: 26396, cityId: 27, code: "517621" },
    { id: 26397, cityId: 27, code: "517640" },
    { id: 26398, cityId: 27, code: "517643" },
    { id: 26399, cityId: 27, code: "515412" },
    { id: 26400, cityId: 27, code: "517001" },
    { id: 26401, cityId: 27, code: "517003" },
    { id: 26402, cityId: 27, code: "517101" },
    { id: 26403, cityId: 27, code: "517104" },
    { id: 26404, cityId: 27, code: "517106" },
    { id: 26405, cityId: 27, code: "517107" },
    { id: 26406, cityId: 27, code: "517109" },
    { id: 26407, cityId: 27, code: "517112" },
    { id: 26408, cityId: 27, code: "517114" },
    { id: 26409, cityId: 27, code: "517115" },
    { id: 26410, cityId: 27, code: "517117" },
    { id: 26411, cityId: 27, code: "517125" },
    { id: 26412, cityId: 27, code: "517127" },
    { id: 26413, cityId: 27, code: "517128" },
    { id: 26414, cityId: 27, code: "517130" },
    { id: 26415, cityId: 27, code: "517133" },
    { id: 26416, cityId: 27, code: "517135" },
    { id: 26417, cityId: 27, code: "517136" },
    { id: 26418, cityId: 27, code: "517138" },
    { id: 26419, cityId: 27, code: "517141" },
    { id: 26420, cityId: 27, code: "517143" },
    { id: 26421, cityId: 27, code: "517144" },
    { id: 26422, cityId: 27, code: "517146" },
    { id: 26423, cityId: 27, code: "517149" },
    { id: 26424, cityId: 27, code: "517151" },
    { id: 26425, cityId: 27, code: "517152" },
    { id: 26426, cityId: 27, code: "517154" },
    { id: 26427, cityId: 27, code: "517160" },
    { id: 26428, cityId: 27, code: "517162" },
    { id: 26429, cityId: 27, code: "517164" },
    { id: 26430, cityId: 27, code: "517165" },
    { id: 26431, cityId: 27, code: "517167" },
    { id: 26432, cityId: 27, code: "517172" },
    { id: 26433, cityId: 27, code: "517173" },
    { id: 26434, cityId: 27, code: "517194" },
    { id: 26435, cityId: 27, code: "517196" },
    { id: 26436, cityId: 27, code: "517197" },
    { id: 26437, cityId: 27, code: "517199" },
    { id: 26438, cityId: 27, code: "517215" },
    { id: 26439, cityId: 27, code: "517217" },
    { id: 26440, cityId: 27, code: "517218" },
    { id: 26441, cityId: 27, code: "517234" },
    { id: 26442, cityId: 27, code: "517236" },
    { id: 26443, cityId: 27, code: "517239" },
    { id: 26444, cityId: 27, code: "517241" },
    { id: 26445, cityId: 27, code: "517242" },
    { id: 26446, cityId: 27, code: "517247" },
    { id: 26447, cityId: 27, code: "517249" },
    { id: 26448, cityId: 27, code: "517250" },
    { id: 26449, cityId: 27, code: "517257" },
    { id: 26450, cityId: 27, code: "517258" },
    { id: 26451, cityId: 27, code: "517260" },
    { id: 26452, cityId: 27, code: "517278" },
    { id: 26453, cityId: 27, code: "517292" },
    { id: 26454, cityId: 27, code: "517297" },
    { id: 26455, cityId: 27, code: "517302" },
    { id: 26456, cityId: 27, code: "517305" },
    { id: 26457, cityId: 27, code: "517326" },
    { id: 26458, cityId: 27, code: "517350" },
    { id: 26459, cityId: 27, code: "517390" },
    { id: 26460, cityId: 27, code: "517401" },
    { id: 26461, cityId: 27, code: "517403" },
    { id: 26462, cityId: 27, code: "517408" },
    { id: 26463, cityId: 27, code: "517414" },
    { id: 26464, cityId: 27, code: "517416" },
    { id: 26465, cityId: 27, code: "517419" },
    { id: 26466, cityId: 27, code: "517421" },
    { id: 26467, cityId: 27, code: "517422" },
    { id: 26468, cityId: 27, code: "517424" },
    { id: 26469, cityId: 27, code: "517429" },
    { id: 26470, cityId: 27, code: "517432" },
    { id: 26471, cityId: 27, code: "517501" },
    { id: 26472, cityId: 27, code: "517504" },
    { id: 26473, cityId: 27, code: "517506" },
    { id: 26474, cityId: 27, code: "517514" },
    { id: 26475, cityId: 27, code: "517517" },
    { id: 26476, cityId: 27, code: "517520" },
    { id: 26477, cityId: 27, code: "517527" },
    { id: 26478, cityId: 27, code: "517536" },
    { id: 26479, cityId: 27, code: "517541" },
    { id: 26480, cityId: 27, code: "517562" },
    { id: 26481, cityId: 27, code: "517564" },
    { id: 26482, cityId: 27, code: "517565" },
    { id: 26483, cityId: 27, code: "517567" },
    { id: 26484, cityId: 27, code: "517581" },
    { id: 26485, cityId: 27, code: "517583" },
    { id: 26486, cityId: 27, code: "517586" },
    { id: 26487, cityId: 27, code: "517588" },
    { id: 26488, cityId: 27, code: "517589" },
    { id: 26489, cityId: 27, code: "517591" },
    { id: 26490, cityId: 27, code: "517599" },
    { id: 26491, cityId: 27, code: "517620" },
    { id: 26492, cityId: 27, code: "517641" },
    { id: 26493, cityId: 27, code: "517642" },
    { id: 26494, cityId: 27, code: "517644" },
    { id: 26495, cityId: 28, code: "516002" },
    { id: 26496, cityId: 28, code: "516005" },
    { id: 26497, cityId: 28, code: "516103" },
    { id: 26498, cityId: 28, code: "516105" },
    { id: 26499, cityId: 28, code: "516106" },
    { id: 26500, cityId: 28, code: "516108" },
    { id: 26501, cityId: 28, code: "516111" },
    { id: 26502, cityId: 28, code: "516113" },
    { id: 26503, cityId: 28, code: "516114" },
    { id: 26504, cityId: 28, code: "516116" },
    { id: 26505, cityId: 28, code: "516119" },
    { id: 26506, cityId: 28, code: "516127" },
    { id: 26507, cityId: 28, code: "516129" },
    { id: 26508, cityId: 28, code: "516130" },
    { id: 26509, cityId: 28, code: "516132" },
    { id: 26510, cityId: 28, code: "516150" },
    { id: 26511, cityId: 28, code: "516151" },
    { id: 26512, cityId: 28, code: "516153" },
    { id: 26513, cityId: 28, code: "516164" },
    { id: 26514, cityId: 28, code: "516166" },
    { id: 26515, cityId: 28, code: "516172" },
    { id: 26516, cityId: 28, code: "516175" },
    { id: 26517, cityId: 28, code: "516193" },
    { id: 26518, cityId: 28, code: "516213" },
    { id: 26519, cityId: 28, code: "516215" },
    { id: 26520, cityId: 28, code: "516216" },
    { id: 26521, cityId: 28, code: "516218" },
    { id: 26522, cityId: 28, code: "516237" },
    { id: 26523, cityId: 28, code: "516247" },
    { id: 26524, cityId: 28, code: "516260" },
    { id: 26525, cityId: 28, code: "516268" },
    { id: 26526, cityId: 28, code: "516269" },
    { id: 26527, cityId: 28, code: "516271" },
    { id: 26528, cityId: 28, code: "516289" },
    { id: 26529, cityId: 28, code: "516290" },
    { id: 26530, cityId: 28, code: "516292" },
    { id: 26531, cityId: 28, code: "516311" },
    { id: 26532, cityId: 28, code: "516319" },
    { id: 26533, cityId: 28, code: "516321" },
    { id: 26534, cityId: 28, code: "516329" },
    { id: 26535, cityId: 28, code: "516330" },
    { id: 26536, cityId: 28, code: "516350" },
    { id: 26537, cityId: 28, code: "516356" },
    { id: 26538, cityId: 28, code: "516359" },
    { id: 26539, cityId: 28, code: "516361" },
    { id: 26540, cityId: 28, code: "516364" },
    { id: 26541, cityId: 28, code: "516366" },
    { id: 26542, cityId: 28, code: "516380" },
    { id: 26543, cityId: 28, code: "516390" },
    { id: 26544, cityId: 28, code: "516396" },
    { id: 26545, cityId: 28, code: "516401" },
    { id: 26546, cityId: 28, code: "516411" },
    { id: 26547, cityId: 28, code: "516412" },
    { id: 26548, cityId: 28, code: "516433" },
    { id: 26549, cityId: 28, code: "516438" },
    { id: 26550, cityId: 28, code: "516440" },
    { id: 26551, cityId: 28, code: "516441" },
    { id: 26552, cityId: 28, code: "516454" },
    { id: 26553, cityId: 28, code: "516464" },
    { id: 26554, cityId: 28, code: "516486" },
    { id: 26555, cityId: 28, code: "516501" },
    { id: 26556, cityId: 28, code: "516502" },
    { id: 26557, cityId: 28, code: "516504" },
    { id: 26558, cityId: 28, code: "516001" },
    { id: 26559, cityId: 28, code: "516003" },
    { id: 26560, cityId: 28, code: "516004" },
    { id: 26561, cityId: 28, code: "516101" },
    { id: 26562, cityId: 28, code: "516102" },
    { id: 26563, cityId: 28, code: "516104" },
    { id: 26564, cityId: 28, code: "516107" },
    { id: 26565, cityId: 28, code: "516109" },
    { id: 26566, cityId: 28, code: "516110" },
    { id: 26567, cityId: 28, code: "516112" },
    { id: 26568, cityId: 28, code: "516115" },
    { id: 26569, cityId: 28, code: "516117" },
    { id: 26570, cityId: 28, code: "516118" },
    { id: 26571, cityId: 28, code: "516120" },
    { id: 26572, cityId: 28, code: "516126" },
    { id: 26573, cityId: 28, code: "516128" },
    { id: 26574, cityId: 28, code: "516131" },
    { id: 26575, cityId: 28, code: "516133" },
    { id: 26576, cityId: 28, code: "516134" },
    { id: 26577, cityId: 28, code: "516152" },
    { id: 26578, cityId: 28, code: "516155" },
    { id: 26579, cityId: 28, code: "516162" },
    { id: 26580, cityId: 28, code: "516163" },
    { id: 26581, cityId: 28, code: "516165" },
    { id: 26582, cityId: 28, code: "516173" },
    { id: 26583, cityId: 28, code: "516203" },
    { id: 26584, cityId: 28, code: "516214" },
    { id: 26585, cityId: 28, code: "516217" },
    { id: 26586, cityId: 28, code: "516219" },
    { id: 26587, cityId: 28, code: "516227" },
    { id: 26588, cityId: 28, code: "516228" },
    { id: 26589, cityId: 28, code: "516233" },
    { id: 26590, cityId: 28, code: "516238" },
    { id: 26591, cityId: 28, code: "516248" },
    { id: 26592, cityId: 28, code: "516257" },
    { id: 26593, cityId: 28, code: "516259" },
    { id: 26594, cityId: 28, code: "516267" },
    { id: 26595, cityId: 28, code: "516270" },
    { id: 26596, cityId: 28, code: "516272" },
    { id: 26597, cityId: 28, code: "516291" },
    { id: 26598, cityId: 28, code: "516293" },
    { id: 26599, cityId: 28, code: "516309" },
    { id: 26600, cityId: 28, code: "516310" },
    { id: 26601, cityId: 28, code: "516339" },
    { id: 26602, cityId: 28, code: "516349" },
    { id: 26603, cityId: 28, code: "516357" },
    { id: 26604, cityId: 28, code: "516360" },
    { id: 26605, cityId: 28, code: "516362" },
    { id: 26606, cityId: 28, code: "516363" },
    { id: 26607, cityId: 28, code: "516365" },
    { id: 26608, cityId: 28, code: "516392" },
    { id: 26609, cityId: 28, code: "516413" },
    { id: 26610, cityId: 28, code: "516431" },
    { id: 26611, cityId: 28, code: "516432" },
    { id: 26612, cityId: 28, code: "516434" },
    { id: 26613, cityId: 28, code: "516437" },
    { id: 26614, cityId: 28, code: "516439" },
    { id: 26615, cityId: 28, code: "516444" },
    { id: 26616, cityId: 28, code: "516474" },
    { id: 26617, cityId: 28, code: "516484" },
    { id: 26618, cityId: 28, code: "516503" },
    { id: 26619, cityId: 28, code: "516505" },
    { id: 26620, cityId: 29, code: "507306" },
    { id: 26621, cityId: 30, code: "533263" },
    { id: 26622, cityId: 31, code: "515671" },
    { id: 26623, cityId: 31, code: "531148" },
    { id: 26624, cityId: 31, code: "533430" },
    { id: 26625, cityId: 32, code: "503123" },
    { id: 26626, cityId: 33, code: "534351" },
    { id: 26627, cityId: 34, code: "505548" },
    { id: 26628, cityId: 34, code: "533001" },
    { id: 26629, cityId: 34, code: "533002" },
    { id: 26630, cityId: 34, code: "533004" },
    { id: 26631, cityId: 34, code: "533007" },
    { id: 26632, cityId: 34, code: "533105" },
    { id: 26633, cityId: 34, code: "533124" },
    { id: 26634, cityId: 34, code: "533126" },
    { id: 26635, cityId: 34, code: "533203" },
    { id: 26636, cityId: 34, code: "533211" },
    { id: 26637, cityId: 34, code: "533213" },
    { id: 26638, cityId: 34, code: "533214" },
    { id: 26639, cityId: 34, code: "533216" },
    { id: 26640, cityId: 34, code: "533219" },
    { id: 26641, cityId: 34, code: "533221" },
    { id: 26642, cityId: 34, code: "533222" },
    { id: 26643, cityId: 34, code: "533224" },
    { id: 26644, cityId: 34, code: "533227" },
    { id: 26645, cityId: 34, code: "533232" },
    { id: 26646, cityId: 34, code: "533235" },
    { id: 26647, cityId: 34, code: "533237" },
    { id: 26648, cityId: 34, code: "533240" },
    { id: 26649, cityId: 34, code: "533242" },
    { id: 26650, cityId: 34, code: "533243" },
    { id: 26651, cityId: 34, code: "533248" },
    { id: 26652, cityId: 34, code: "533250" },
    { id: 26653, cityId: 34, code: "533251" },
    { id: 26654, cityId: 34, code: "533253" },
    { id: 26655, cityId: 34, code: "533258" },
    { id: 26656, cityId: 34, code: "533261" },
    { id: 26657, cityId: 34, code: "533264" },
    { id: 26658, cityId: 34, code: "533274" },
    { id: 26659, cityId: 34, code: "533275" },
    { id: 26660, cityId: 34, code: "533285" },
    { id: 26661, cityId: 34, code: "533287" },
    { id: 26662, cityId: 34, code: "533288" },
    { id: 26663, cityId: 34, code: "533290" },
    { id: 26664, cityId: 34, code: "533293" },
    { id: 26665, cityId: 34, code: "533295" },
    { id: 26666, cityId: 34, code: "533306" },
    { id: 26667, cityId: 34, code: "533309" },
    { id: 26668, cityId: 34, code: "533333" },
    { id: 26669, cityId: 34, code: "533340" },
    { id: 26670, cityId: 34, code: "533341" },
    { id: 26671, cityId: 34, code: "533343" },
    { id: 26672, cityId: 34, code: "533346" },
    { id: 26673, cityId: 34, code: "533407" },
    { id: 26674, cityId: 34, code: "533410" },
    { id: 26675, cityId: 34, code: "533428" },
    { id: 26676, cityId: 34, code: "533431" },
    { id: 26677, cityId: 34, code: "533433" },
    { id: 26678, cityId: 34, code: "533436" },
    { id: 26679, cityId: 34, code: "533439" },
    { id: 26680, cityId: 34, code: "533446" },
    { id: 26681, cityId: 34, code: "533447" },
    { id: 26682, cityId: 34, code: "533449" },
    { id: 26683, cityId: 34, code: "533462" },
    { id: 26684, cityId: 34, code: "533463" },
    { id: 26685, cityId: 34, code: "533468" },
    { id: 26686, cityId: 34, code: "533566" },
    { id: 26687, cityId: 34, code: "534199" },
    { id: 26688, cityId: 34, code: "533003" },
    { id: 26689, cityId: 34, code: "533005" },
    { id: 26690, cityId: 34, code: "533006" },
    { id: 26691, cityId: 34, code: "533014" },
    { id: 26692, cityId: 34, code: "533016" },
    { id: 26693, cityId: 34, code: "533101" },
    { id: 26694, cityId: 34, code: "533103" },
    { id: 26695, cityId: 34, code: "533104" },
    { id: 26696, cityId: 34, code: "533106" },
    { id: 26697, cityId: 34, code: "533133" },
    { id: 26698, cityId: 34, code: "533201" },
    { id: 26699, cityId: 34, code: "533202" },
    { id: 26700, cityId: 34, code: "533210" },
    { id: 26701, cityId: 34, code: "533212" },
    { id: 26702, cityId: 34, code: "533215" },
    { id: 26703, cityId: 34, code: "533217" },
    { id: 26704, cityId: 34, code: "533218" },
    { id: 26705, cityId: 34, code: "533220" },
    { id: 26706, cityId: 34, code: "533223" },
    { id: 26707, cityId: 34, code: "533225" },
    { id: 26708, cityId: 34, code: "533226" },
    { id: 26709, cityId: 34, code: "533228" },
    { id: 26710, cityId: 34, code: "533230" },
    { id: 26711, cityId: 34, code: "533233" },
    { id: 26712, cityId: 34, code: "533236" },
    { id: 26713, cityId: 34, code: "533238" },
    { id: 26714, cityId: 34, code: "533239" },
    { id: 26715, cityId: 34, code: "533241" },
    { id: 26716, cityId: 34, code: "533244" },
    { id: 26717, cityId: 34, code: "533247" },
    { id: 26718, cityId: 34, code: "533249" },
    { id: 26719, cityId: 34, code: "533252" },
    { id: 26720, cityId: 34, code: "533255" },
    { id: 26721, cityId: 34, code: "533260" },
    { id: 26722, cityId: 34, code: "533262" },
    { id: 26723, cityId: 34, code: "533271" },
    { id: 26724, cityId: 34, code: "533286" },
    { id: 26725, cityId: 34, code: "533289" },
    { id: 26726, cityId: 34, code: "533291" },
    { id: 26727, cityId: 34, code: "533292" },
    { id: 26728, cityId: 34, code: "533294" },
    { id: 26729, cityId: 34, code: "533305" },
    { id: 26730, cityId: 34, code: "533307" },
    { id: 26731, cityId: 34, code: "533308" },
    { id: 26732, cityId: 34, code: "533339" },
    { id: 26733, cityId: 34, code: "533342" },
    { id: 26734, cityId: 34, code: "533344" },
    { id: 26735, cityId: 34, code: "533345" },
    { id: 26736, cityId: 34, code: "533406" },
    { id: 26737, cityId: 34, code: "533408" },
    { id: 26738, cityId: 34, code: "533429" },
    { id: 26739, cityId: 34, code: "533432" },
    { id: 26740, cityId: 34, code: "533434" },
    { id: 26741, cityId: 34, code: "533435" },
    { id: 26742, cityId: 34, code: "533437" },
    { id: 26743, cityId: 34, code: "533440" },
    { id: 26744, cityId: 34, code: "533445" },
    { id: 26745, cityId: 34, code: "533448" },
    { id: 26746, cityId: 34, code: "533450" },
    { id: 26747, cityId: 34, code: "533461" },
    { id: 26748, cityId: 34, code: "533503" },
    { id: 26749, cityId: 34, code: "533514" },
    { id: 26750, cityId: 34, code: "533541" },
    { id: 26751, cityId: 34, code: "533551" },
    { id: 26752, cityId: 34, code: "533554" },
    { id: 26753, cityId: 34, code: "533557" },
    { id: 26754, cityId: 34, code: "533577" },
    { id: 26755, cityId: 34, code: "533583" },
    { id: 26756, cityId: 35, code: "517592" },
    { id: 26757, cityId: 36, code: "534001" },
    { id: 26758, cityId: 37, code: "509125" },
    { id: 26759, cityId: 38, code: "515401" },
    { id: 26760, cityId: 39, code: "521301" },
    { id: 26761, cityId: 40, code: "506134" },
    { id: 26762, cityId: 40, code: "518466" },
    { id: 26763, cityId: 40, code: "508127" },
    { id: 26764, cityId: 40, code: "524101" },
    { id: 26765, cityId: 41, code: "509342" },
    { id: 26766, cityId: 42, code: "534427" },
    { id: 26767, cityId: 43, code: "518150" },
    { id: 26768, cityId: 44, code: "515801" },
    { id: 26769, cityId: 45, code: "522001" },
    { id: 26770, cityId: 45, code: "522002" },
    { id: 26771, cityId: 45, code: "522004" },
    { id: 26772, cityId: 45, code: "522007" },
    { id: 26773, cityId: 45, code: "522009" },
    { id: 26774, cityId: 45, code: "522010" },
    { id: 26775, cityId: 45, code: "522015" },
    { id: 26776, cityId: 45, code: "522017" },
    { id: 26777, cityId: 45, code: "522020" },
    { id: 26778, cityId: 45, code: "522022" },
    { id: 26779, cityId: 45, code: "522036" },
    { id: 26780, cityId: 45, code: "522123" },
    { id: 26781, cityId: 45, code: "522211" },
    { id: 26782, cityId: 45, code: "522213" },
    { id: 26783, cityId: 45, code: "522234" },
    { id: 26784, cityId: 45, code: "522235" },
    { id: 26785, cityId: 45, code: "522237" },
    { id: 26786, cityId: 45, code: "522256" },
    { id: 26787, cityId: 45, code: "522258" },
    { id: 26788, cityId: 45, code: "522259" },
    { id: 26789, cityId: 45, code: "522261" },
    { id: 26790, cityId: 45, code: "522263" },
    { id: 26791, cityId: 45, code: "522264" },
    { id: 26792, cityId: 45, code: "522266" },
    { id: 26793, cityId: 45, code: "522269" },
    { id: 26794, cityId: 45, code: "522271" },
    { id: 26795, cityId: 45, code: "522272" },
    { id: 26796, cityId: 45, code: "522274" },
    { id: 26797, cityId: 45, code: "522277" },
    { id: 26798, cityId: 45, code: "522279" },
    { id: 26799, cityId: 45, code: "522280" },
    { id: 26800, cityId: 45, code: "522282" },
    { id: 26801, cityId: 45, code: "522290" },
    { id: 26802, cityId: 45, code: "522293" },
    { id: 26803, cityId: 45, code: "522295" },
    { id: 26804, cityId: 45, code: "522296" },
    { id: 26805, cityId: 45, code: "522298" },
    { id: 26806, cityId: 45, code: "522301" },
    { id: 26807, cityId: 45, code: "522303" },
    { id: 26808, cityId: 45, code: "522304" },
    { id: 26809, cityId: 45, code: "522306" },
    { id: 26810, cityId: 45, code: "522309" },
    { id: 26811, cityId: 45, code: "522311" },
    { id: 26812, cityId: 45, code: "522314" },
    { id: 26813, cityId: 45, code: "522316" },
    { id: 26814, cityId: 45, code: "522317" },
    { id: 26815, cityId: 45, code: "522324" },
    { id: 26816, cityId: 45, code: "522325" },
    { id: 26817, cityId: 45, code: "522330" },
    { id: 26818, cityId: 45, code: "522332" },
    { id: 26819, cityId: 45, code: "522340" },
    { id: 26820, cityId: 45, code: "522354" },
    { id: 26821, cityId: 45, code: "522401" },
    { id: 26822, cityId: 45, code: "522402" },
    { id: 26823, cityId: 45, code: "522407" },
    { id: 26824, cityId: 45, code: "522409" },
    { id: 26825, cityId: 45, code: "522412" },
    { id: 26826, cityId: 45, code: "522436" },
    { id: 26827, cityId: 45, code: "522439" },
    { id: 26828, cityId: 45, code: "522502" },
    { id: 26829, cityId: 45, code: "522510" },
    { id: 26830, cityId: 45, code: "522515" },
    { id: 26831, cityId: 45, code: "522529" },
    { id: 26832, cityId: 45, code: "522603" },
    { id: 26833, cityId: 45, code: "522611" },
    { id: 26834, cityId: 45, code: "522626" },
    { id: 26835, cityId: 45, code: "522655" },
    { id: 26836, cityId: 45, code: "522658" },
    { id: 26837, cityId: 45, code: "522661" },
    { id: 26838, cityId: 45, code: "522663" },
    { id: 26839, cityId: 45, code: "522003" },
    { id: 26840, cityId: 45, code: "522005" },
    { id: 26841, cityId: 45, code: "522006" },
    { id: 26842, cityId: 45, code: "522008" },
    { id: 26843, cityId: 45, code: "522013" },
    { id: 26844, cityId: 45, code: "522014" },
    { id: 26845, cityId: 45, code: "522016" },
    { id: 26846, cityId: 45, code: "522018" },
    { id: 26847, cityId: 45, code: "522019" },
    { id: 26848, cityId: 45, code: "522021" },
    { id: 26849, cityId: 45, code: "522024" },
    { id: 26850, cityId: 45, code: "522026" },
    { id: 26851, cityId: 45, code: "522034" },
    { id: 26852, cityId: 45, code: "522050" },
    { id: 26853, cityId: 45, code: "522101" },
    { id: 26854, cityId: 45, code: "522111" },
    { id: 26855, cityId: 45, code: "522112" },
    { id: 26856, cityId: 45, code: "522116" },
    { id: 26857, cityId: 45, code: "522124" },
    { id: 26858, cityId: 45, code: "522125" },
    { id: 26859, cityId: 45, code: "522180" },
    { id: 26860, cityId: 45, code: "522201" },
    { id: 26861, cityId: 45, code: "522202" },
    { id: 26862, cityId: 45, code: "522212" },
    { id: 26863, cityId: 45, code: "522214" },
    { id: 26864, cityId: 45, code: "522215" },
    { id: 26865, cityId: 45, code: "522222" },
    { id: 26866, cityId: 45, code: "522233" },
    { id: 26867, cityId: 45, code: "522236" },
    { id: 26868, cityId: 45, code: "522238" },
    { id: 26869, cityId: 45, code: "522257" },
    { id: 26870, cityId: 45, code: "522260" },
    { id: 26871, cityId: 45, code: "522262" },
    { id: 26872, cityId: 45, code: "522265" },
    { id: 26873, cityId: 45, code: "522267" },
    { id: 26874, cityId: 45, code: "522268" },
    { id: 26875, cityId: 45, code: "522270" },
    { id: 26876, cityId: 45, code: "522273" },
    { id: 26877, cityId: 45, code: "522275" },
    { id: 26878, cityId: 45, code: "522276" },
    { id: 26879, cityId: 45, code: "522278" },
    { id: 26880, cityId: 45, code: "522281" },
    { id: 26881, cityId: 45, code: "522291" },
    { id: 26882, cityId: 45, code: "522292" },
    { id: 26883, cityId: 45, code: "522294" },
    { id: 26884, cityId: 45, code: "522297" },
    { id: 26885, cityId: 45, code: "522299" },
    { id: 26886, cityId: 45, code: "522302" },
    { id: 26887, cityId: 45, code: "522305" },
    { id: 26888, cityId: 45, code: "522307" },
    { id: 26889, cityId: 45, code: "522308" },
    { id: 26890, cityId: 45, code: "522310" },
    { id: 26891, cityId: 45, code: "522312" },
    { id: 26892, cityId: 45, code: "522313" },
    { id: 26893, cityId: 45, code: "522315" },
    { id: 26894, cityId: 45, code: "522318" },
    { id: 26895, cityId: 45, code: "522321" },
    { id: 26896, cityId: 45, code: "522329" },
    { id: 26897, cityId: 45, code: "522403" },
    { id: 26898, cityId: 45, code: "522408" },
    { id: 26899, cityId: 45, code: "522410" },
    { id: 26900, cityId: 45, code: "522411" },
    { id: 26901, cityId: 45, code: "522413" },
    { id: 26902, cityId: 45, code: "522421" },
    { id: 26903, cityId: 45, code: "522426" },
    { id: 26904, cityId: 45, code: "522501" },
    { id: 26905, cityId: 45, code: "522503" },
    { id: 26906, cityId: 45, code: "522508" },
    { id: 26907, cityId: 45, code: "522509" },
    { id: 26908, cityId: 45, code: "522511" },
    { id: 26909, cityId: 45, code: "522549" },
    { id: 26910, cityId: 45, code: "522601" },
    { id: 26911, cityId: 45, code: "522612" },
    { id: 26912, cityId: 45, code: "522614" },
    { id: 26913, cityId: 45, code: "522615" },
    { id: 26914, cityId: 45, code: "522620" },
    { id: 26915, cityId: 45, code: "522630" },
    { id: 26916, cityId: 45, code: "522631" },
    { id: 26917, cityId: 45, code: "522646" },
    { id: 26918, cityId: 45, code: "522649" },
    { id: 26919, cityId: 45, code: "522657" },
    { id: 26920, cityId: 45, code: "522659" },
    { id: 26921, cityId: 45, code: "522660" },
    { id: 26922, cityId: 46, code: "515201" },
    { id: 26923, cityId: 47, code: "505467" },
    { id: 26924, cityId: 48, code: "508204" },
    { id: 26925, cityId: 49, code: "500002" },
    { id: 26926, cityId: 49, code: "500003" },
    { id: 26927, cityId: 49, code: "500005" },
    { id: 26928, cityId: 49, code: "500008" },
    { id: 26929, cityId: 49, code: "500010" },
    { id: 26930, cityId: 49, code: "500011" },
    { id: 26931, cityId: 49, code: "500013" },
    { id: 26932, cityId: 49, code: "500016" },
    { id: 26933, cityId: 49, code: "500018" },
    { id: 26934, cityId: 49, code: "500021" },
    { id: 26935, cityId: 49, code: "500024" },
    { id: 26936, cityId: 49, code: "500026" },
    { id: 26937, cityId: 49, code: "500027" },
    { id: 26938, cityId: 49, code: "500029" },
    { id: 26939, cityId: 49, code: "500032" },
    { id: 26940, cityId: 49, code: "500034" },
    { id: 26941, cityId: 49, code: "500035" },
    { id: 26942, cityId: 49, code: "500037" },
    { id: 26943, cityId: 49, code: "500040" },
    { id: 26944, cityId: 49, code: "500042" },
    { id: 26945, cityId: 49, code: "500043" },
    { id: 26946, cityId: 49, code: "500045" },
    { id: 26947, cityId: 49, code: "500048" },
    { id: 26948, cityId: 49, code: "500133" },
    { id: 26949, cityId: 49, code: "500252" },
    { id: 26950, cityId: 49, code: "500265" },
    { id: 26951, cityId: 49, code: "500267" },
    { id: 26952, cityId: 49, code: "500463" },
    { id: 26953, cityId: 49, code: "500482" },
    { id: 26954, cityId: 49, code: "500556" },
    { id: 26955, cityId: 49, code: "500593" },
    { id: 26956, cityId: 49, code: "500659" },
    { id: 26957, cityId: 49, code: "500660" },
    { id: 26958, cityId: 49, code: "500768" },
    { id: 26959, cityId: 49, code: "500855" },
    { id: 26960, cityId: 49, code: "500872" },
    { id: 26961, cityId: 49, code: "500890" },
    { id: 26962, cityId: 49, code: "500001" },
    { id: 26963, cityId: 49, code: "500004" },
    { id: 26964, cityId: 49, code: "500006" },
    { id: 26965, cityId: 49, code: "500007" },
    { id: 26966, cityId: 49, code: "500012" },
    { id: 26967, cityId: 49, code: "500014" },
    { id: 26968, cityId: 49, code: "500015" },
    { id: 26969, cityId: 49, code: "500017" },
    { id: 26970, cityId: 49, code: "500020" },
    { id: 26971, cityId: 49, code: "500022" },
    { id: 26972, cityId: 49, code: "500023" },
    { id: 26973, cityId: 49, code: "500025" },
    { id: 26974, cityId: 49, code: "500028" },
    { id: 26975, cityId: 49, code: "500030" },
    { id: 26976, cityId: 49, code: "500031" },
    { id: 26977, cityId: 49, code: "500036" },
    { id: 26978, cityId: 49, code: "500038" },
    { id: 26979, cityId: 49, code: "500039" },
    { id: 26980, cityId: 49, code: "500041" },
    { id: 26981, cityId: 49, code: "500044" },
    { id: 26982, cityId: 49, code: "500047" },
    { id: 26983, cityId: 49, code: "500049" },
    { id: 26984, cityId: 49, code: "500051" },
    { id: 26985, cityId: 49, code: "500171" },
    { id: 26986, cityId: 49, code: "500253" },
    { id: 26987, cityId: 49, code: "500258" },
    { id: 26988, cityId: 49, code: "500264" },
    { id: 26989, cityId: 49, code: "500266" },
    { id: 26990, cityId: 49, code: "500361" },
    { id: 26991, cityId: 49, code: "500380" },
    { id: 26992, cityId: 49, code: "500457" },
    { id: 26993, cityId: 49, code: "500484" },
    { id: 26994, cityId: 49, code: "500486" },
    { id: 26995, cityId: 49, code: "500587" },
    { id: 26996, cityId: 49, code: "500594" },
    { id: 26997, cityId: 49, code: "500661" },
    { id: 26998, cityId: 49, code: "500762" },
    { id: 26999, cityId: 49, code: "500873" },
    { id: 27000, cityId: 49, code: "500963" },
    { id: 27001, cityId: 49, code: "505468" },
    { id: 27002, cityId: 49, code: "515005" },
    { id: 27003, cityId: 50, code: "501506" },
    { id: 27004, cityId: 51, code: "532312" },
    { id: 27005, cityId: 52, code: "505327" },
    { id: 27006, cityId: 53, code: "501142" },
    { id: 27007, cityId: 53, code: "505547" },
    { id: 27008, cityId: 53, code: "506167" },
    { id: 27009, cityId: 54, code: "515591" },
    { id: 27010, cityId: 55, code: "533001" },
    { id: 27011, cityId: 56, code: "507209" },
    { id: 27012, cityId: 56, code: "517113" },
    { id: 27013, cityId: 57, code: "503111" },
    { id: 27014, cityId: 58, code: "509359" },
    { id: 27015, cityId: 58, code: "515721" },
    { id: 27016, cityId: 59, code: "534329" },
    { id: 27017, cityId: 60, code: "505001" },
    { id: 27018, cityId: 60, code: "505002" },
    { id: 27019, cityId: 60, code: "505102" },
    { id: 27020, cityId: 60, code: "505152" },
    { id: 27021, cityId: 60, code: "505173" },
    { id: 27022, cityId: 60, code: "505174" },
    { id: 27023, cityId: 60, code: "505184" },
    { id: 27024, cityId: 60, code: "505187" },
    { id: 27025, cityId: 60, code: "505208" },
    { id: 27026, cityId: 60, code: "505210" },
    { id: 27027, cityId: 60, code: "505211" },
    { id: 27028, cityId: 60, code: "505301" },
    { id: 27029, cityId: 60, code: "505303" },
    { id: 27030, cityId: 60, code: "505306" },
    { id: 27031, cityId: 60, code: "505309" },
    { id: 27032, cityId: 60, code: "505325" },
    { id: 27033, cityId: 60, code: "505327" },
    { id: 27034, cityId: 60, code: "505330" },
    { id: 27035, cityId: 60, code: "505401" },
    { id: 27036, cityId: 60, code: "505404" },
    { id: 27037, cityId: 60, code: "505412" },
    { id: 27038, cityId: 60, code: "505415" },
    { id: 27039, cityId: 60, code: "505417" },
    { id: 27040, cityId: 60, code: "505425" },
    { id: 27041, cityId: 60, code: "505451" },
    { id: 27042, cityId: 60, code: "505452" },
    { id: 27043, cityId: 60, code: "505454" },
    { id: 27044, cityId: 60, code: "505459" },
    { id: 27045, cityId: 60, code: "505460" },
    { id: 27046, cityId: 60, code: "505462" },
    { id: 27047, cityId: 60, code: "505468" },
    { id: 27048, cityId: 60, code: "505470" },
    { id: 27049, cityId: 60, code: "505473" },
    { id: 27050, cityId: 60, code: "505475" },
    { id: 27051, cityId: 60, code: "505476" },
    { id: 27052, cityId: 60, code: "505481" },
    { id: 27053, cityId: 60, code: "505502" },
    { id: 27054, cityId: 60, code: "505504" },
    { id: 27055, cityId: 60, code: "505505" },
    { id: 27056, cityId: 60, code: "505526" },
    { id: 27057, cityId: 60, code: "505528" },
    { id: 27058, cityId: 60, code: "505529" },
    { id: 27059, cityId: 60, code: "505531" },
    { id: 27060, cityId: 60, code: "518465" },
    { id: 27061, cityId: 60, code: "521132" },
    { id: 27062, cityId: 60, code: "521153" },
    { id: 27063, cityId: 60, code: "521227" },
    { id: 27064, cityId: 60, code: "521421" },
    { id: 27065, cityId: 60, code: "534447" },
    { id: 27066, cityId: 60, code: "505122" },
    { id: 27067, cityId: 60, code: "505153" },
    { id: 27068, cityId: 60, code: "505162" },
    { id: 27069, cityId: 60, code: "505172" },
    { id: 27070, cityId: 60, code: "505185" },
    { id: 27071, cityId: 60, code: "505186" },
    { id: 27072, cityId: 60, code: "505188" },
    { id: 27073, cityId: 60, code: "505209" },
    { id: 27074, cityId: 60, code: "505214" },
    { id: 27075, cityId: 60, code: "505215" },
    { id: 27076, cityId: 60, code: "505302" },
    { id: 27077, cityId: 60, code: "505304" },
    { id: 27078, cityId: 60, code: "505305" },
    { id: 27079, cityId: 60, code: "505307" },
    { id: 27080, cityId: 60, code: "505326" },
    { id: 27081, cityId: 60, code: "505402" },
    { id: 27082, cityId: 60, code: "505403" },
    { id: 27083, cityId: 60, code: "505405" },
    { id: 27084, cityId: 60, code: "505408" },
    { id: 27085, cityId: 60, code: "505410" },
    { id: 27086, cityId: 60, code: "505413" },
    { id: 27087, cityId: 60, code: "505416" },
    { id: 27088, cityId: 60, code: "505445" },
    { id: 27089, cityId: 60, code: "505450" },
    { id: 27090, cityId: 60, code: "505453" },
    { id: 27091, cityId: 60, code: "505455" },
    { id: 27092, cityId: 60, code: "505466" },
    { id: 27093, cityId: 60, code: "505469" },
    { id: 27094, cityId: 60, code: "505471" },
    { id: 27095, cityId: 60, code: "505472" },
    { id: 27096, cityId: 60, code: "505474" },
    { id: 27097, cityId: 60, code: "505480" },
    { id: 27098, cityId: 60, code: "505490" },
    { id: 27099, cityId: 60, code: "505498" },
    { id: 27100, cityId: 60, code: "505501" },
    { id: 27101, cityId: 60, code: "505503" },
    { id: 27102, cityId: 60, code: "505514" },
    { id: 27103, cityId: 60, code: "505524" },
    { id: 27104, cityId: 60, code: "505525" },
    { id: 27105, cityId: 60, code: "505527" },
    { id: 27106, cityId: 60, code: "505532" },
    { id: 27107, cityId: 60, code: "505533" },
    { id: 27108, cityId: 60, code: "505545" },
    { id: 27109, cityId: 60, code: "505567" },
    { id: 27110, cityId: 60, code: "521332" },
    { id: 27111, cityId: 61, code: "524201" },
    { id: 27112, cityId: 62, code: "507001" },
    { id: 27113, cityId: 62, code: "507002" },
    { id: 27114, cityId: 62, code: "507004" },
    { id: 27115, cityId: 62, code: "507113" },
    { id: 27116, cityId: 62, code: "507115" },
    { id: 27117, cityId: 62, code: "507116" },
    { id: 27118, cityId: 62, code: "507118" },
    { id: 27119, cityId: 62, code: "507121" },
    { id: 27120, cityId: 62, code: "507123" },
    { id: 27121, cityId: 62, code: "507124" },
    { id: 27122, cityId: 62, code: "507126" },
    { id: 27123, cityId: 62, code: "507129" },
    { id: 27124, cityId: 62, code: "507131" },
    { id: 27125, cityId: 62, code: "507132" },
    { id: 27126, cityId: 62, code: "507134" },
    { id: 27127, cityId: 62, code: "507137" },
    { id: 27128, cityId: 62, code: "507139" },
    { id: 27129, cityId: 62, code: "507140" },
    { id: 27130, cityId: 62, code: "507152" },
    { id: 27131, cityId: 62, code: "507153" },
    { id: 27132, cityId: 62, code: "507158" },
    { id: 27133, cityId: 62, code: "507160" },
    { id: 27134, cityId: 62, code: "507161" },
    { id: 27135, cityId: 62, code: "507163" },
    { id: 27136, cityId: 62, code: "507166" },
    { id: 27137, cityId: 62, code: "507168" },
    { id: 27138, cityId: 62, code: "507169" },
    { id: 27139, cityId: 62, code: "507174" },
    { id: 27140, cityId: 62, code: "507176" },
    { id: 27141, cityId: 62, code: "507177" },
    { id: 27142, cityId: 62, code: "507182" },
    { id: 27143, cityId: 62, code: "507203" },
    { id: 27144, cityId: 62, code: "507206" },
    { id: 27145, cityId: 62, code: "507208" },
    { id: 27146, cityId: 62, code: "507211" },
    { id: 27147, cityId: 62, code: "507213" },
    { id: 27148, cityId: 62, code: "507214" },
    { id: 27149, cityId: 62, code: "507216" },
    { id: 27150, cityId: 62, code: "507301" },
    { id: 27151, cityId: 62, code: "507303" },
    { id: 27152, cityId: 62, code: "507304" },
    { id: 27153, cityId: 62, code: "507311" },
    { id: 27154, cityId: 62, code: "507312" },
    { id: 27155, cityId: 62, code: "507003" },
    { id: 27156, cityId: 62, code: "507101" },
    { id: 27157, cityId: 62, code: "507103" },
    { id: 27158, cityId: 62, code: "507106" },
    { id: 27159, cityId: 62, code: "507111" },
    { id: 27160, cityId: 62, code: "507112" },
    { id: 27161, cityId: 62, code: "507114" },
    { id: 27162, cityId: 62, code: "507117" },
    { id: 27163, cityId: 62, code: "507119" },
    { id: 27164, cityId: 62, code: "507120" },
    { id: 27165, cityId: 62, code: "507122" },
    { id: 27166, cityId: 62, code: "507125" },
    { id: 27167, cityId: 62, code: "507127" },
    { id: 27168, cityId: 62, code: "507130" },
    { id: 27169, cityId: 62, code: "507133" },
    { id: 27170, cityId: 62, code: "507135" },
    { id: 27171, cityId: 62, code: "507136" },
    { id: 27172, cityId: 62, code: "507138" },
    { id: 27173, cityId: 62, code: "507141" },
    { id: 27174, cityId: 62, code: "507151" },
    { id: 27175, cityId: 62, code: "507154" },
    { id: 27176, cityId: 62, code: "507156" },
    { id: 27177, cityId: 62, code: "507157" },
    { id: 27178, cityId: 62, code: "507159" },
    { id: 27179, cityId: 62, code: "507162" },
    { id: 27180, cityId: 62, code: "507164" },
    { id: 27181, cityId: 62, code: "507165" },
    { id: 27182, cityId: 62, code: "507167" },
    { id: 27183, cityId: 62, code: "507170" },
    { id: 27184, cityId: 62, code: "507172" },
    { id: 27185, cityId: 62, code: "507173" },
    { id: 27186, cityId: 62, code: "507175" },
    { id: 27187, cityId: 62, code: "507183" },
    { id: 27188, cityId: 62, code: "507201" },
    { id: 27189, cityId: 62, code: "507202" },
    { id: 27190, cityId: 62, code: "507204" },
    { id: 27191, cityId: 62, code: "507207" },
    { id: 27192, cityId: 62, code: "507210" },
    { id: 27193, cityId: 62, code: "507212" },
    { id: 27194, cityId: 62, code: "507302" },
    { id: 27195, cityId: 62, code: "507305" },
    { id: 27196, cityId: 62, code: "507313" },
    { id: 27197, cityId: 62, code: "507316" },
    { id: 27198, cityId: 62, code: "507318" },
    { id: 27199, cityId: 63, code: "505326" },
    { id: 27200, cityId: 64, code: "534350" },
    { id: 27201, cityId: 65, code: "520001" },
    { id: 27202, cityId: 65, code: "520002" },
    { id: 27203, cityId: 65, code: "520004" },
    { id: 27204, cityId: 65, code: "520007" },
    { id: 27205, cityId: 65, code: "520009" },
    { id: 27206, cityId: 65, code: "520010" },
    { id: 27207, cityId: 65, code: "520012" },
    { id: 27208, cityId: 65, code: "520015" },
    { id: 27209, cityId: 65, code: "521003" },
    { id: 27210, cityId: 65, code: "521101" },
    { id: 27211, cityId: 65, code: "521104" },
    { id: 27212, cityId: 65, code: "521106" },
    { id: 27213, cityId: 65, code: "521109" },
    { id: 27214, cityId: 65, code: "521111" },
    { id: 27215, cityId: 65, code: "521112" },
    { id: 27216, cityId: 65, code: "521114" },
    { id: 27217, cityId: 65, code: "521117" },
    { id: 27218, cityId: 65, code: "521122" },
    { id: 27219, cityId: 65, code: "521124" },
    { id: 27220, cityId: 65, code: "521125" },
    { id: 27221, cityId: 65, code: "521130" },
    { id: 27222, cityId: 65, code: "521133" },
    { id: 27223, cityId: 65, code: "521135" },
    { id: 27224, cityId: 65, code: "521138" },
    { id: 27225, cityId: 65, code: "521140" },
    { id: 27226, cityId: 65, code: "521148" },
    { id: 27227, cityId: 65, code: "521149" },
    { id: 27228, cityId: 65, code: "521151" },
    { id: 27229, cityId: 65, code: "521156" },
    { id: 27230, cityId: 65, code: "521157" },
    { id: 27231, cityId: 65, code: "521162" },
    { id: 27232, cityId: 65, code: "521164" },
    { id: 27233, cityId: 65, code: "521165" },
    { id: 27234, cityId: 65, code: "521170" },
    { id: 27235, cityId: 65, code: "521175" },
    { id: 27236, cityId: 65, code: "521178" },
    { id: 27237, cityId: 65, code: "521183" },
    { id: 27238, cityId: 65, code: "521185" },
    { id: 27239, cityId: 65, code: "521201" },
    { id: 27240, cityId: 65, code: "521202" },
    { id: 27241, cityId: 65, code: "521207" },
    { id: 27242, cityId: 65, code: "521212" },
    { id: 27243, cityId: 65, code: "521215" },
    { id: 27244, cityId: 65, code: "521228" },
    { id: 27245, cityId: 65, code: "521230" },
    { id: 27246, cityId: 65, code: "521231" },
    { id: 27247, cityId: 65, code: "521246" },
    { id: 27248, cityId: 65, code: "521255" },
    { id: 27249, cityId: 65, code: "521260" },
    { id: 27250, cityId: 65, code: "521263" },
    { id: 27251, cityId: 65, code: "521265" },
    { id: 27252, cityId: 65, code: "521286" },
    { id: 27253, cityId: 65, code: "521321" },
    { id: 27254, cityId: 65, code: "521323" },
    { id: 27255, cityId: 65, code: "521326" },
    { id: 27256, cityId: 65, code: "521329" },
    { id: 27257, cityId: 65, code: "521331" },
    { id: 27258, cityId: 65, code: "521344" },
    { id: 27259, cityId: 65, code: "521345" },
    { id: 27260, cityId: 65, code: "521366" },
    { id: 27261, cityId: 65, code: "521390" },
    { id: 27262, cityId: 65, code: "521403" },
    { id: 27263, cityId: 65, code: "521424" },
    { id: 27264, cityId: 65, code: "521429" },
    { id: 27265, cityId: 65, code: "521456" },
    { id: 27266, cityId: 65, code: "505331" },
    { id: 27267, cityId: 65, code: "509352" },
    { id: 27268, cityId: 65, code: "520003" },
    { id: 27269, cityId: 65, code: "520005" },
    { id: 27270, cityId: 65, code: "520006" },
    { id: 27271, cityId: 65, code: "520008" },
    { id: 27272, cityId: 65, code: "520011" },
    { id: 27273, cityId: 65, code: "520013" },
    { id: 27274, cityId: 65, code: "520014" },
    { id: 27275, cityId: 65, code: "520016" },
    { id: 27276, cityId: 65, code: "520050" },
    { id: 27277, cityId: 65, code: "521001" },
    { id: 27278, cityId: 65, code: "521002" },
    { id: 27279, cityId: 65, code: "521102" },
    { id: 27280, cityId: 65, code: "521105" },
    { id: 27281, cityId: 65, code: "521107" },
    { id: 27282, cityId: 65, code: "521108" },
    { id: 27283, cityId: 65, code: "521110" },
    { id: 27284, cityId: 65, code: "521113" },
    { id: 27285, cityId: 65, code: "521116" },
    { id: 27286, cityId: 65, code: "521118" },
    { id: 27287, cityId: 65, code: "521120" },
    { id: 27288, cityId: 65, code: "521121" },
    { id: 27289, cityId: 65, code: "521123" },
    { id: 27290, cityId: 65, code: "521126" },
    { id: 27291, cityId: 65, code: "521128" },
    { id: 27292, cityId: 65, code: "521129" },
    { id: 27293, cityId: 65, code: "521131" },
    { id: 27294, cityId: 65, code: "521136" },
    { id: 27295, cityId: 65, code: "521137" },
    { id: 27296, cityId: 65, code: "521139" },
    { id: 27297, cityId: 65, code: "521144" },
    { id: 27298, cityId: 65, code: "521150" },
    { id: 27299, cityId: 65, code: "521155" },
    { id: 27300, cityId: 65, code: "521163" },
    { id: 27301, cityId: 65, code: "521171" },
    { id: 27302, cityId: 65, code: "521176" },
    { id: 27303, cityId: 65, code: "521179" },
    { id: 27304, cityId: 65, code: "521181" },
    { id: 27305, cityId: 65, code: "521182" },
    { id: 27306, cityId: 65, code: "521184" },
    { id: 27307, cityId: 65, code: "521190" },
    { id: 27308, cityId: 65, code: "521211" },
    { id: 27309, cityId: 65, code: "521213" },
    { id: 27310, cityId: 65, code: "521214" },
    { id: 27311, cityId: 65, code: "521226" },
    { id: 27312, cityId: 65, code: "521229" },
    { id: 27313, cityId: 65, code: "521235" },
    { id: 27314, cityId: 65, code: "521245" },
    { id: 27315, cityId: 65, code: "521250" },
    { id: 27316, cityId: 65, code: "521251" },
    { id: 27317, cityId: 65, code: "521256" },
    { id: 27318, cityId: 65, code: "521261" },
    { id: 27319, cityId: 65, code: "521301" },
    { id: 27320, cityId: 65, code: "521311" },
    { id: 27321, cityId: 65, code: "521312" },
    { id: 27322, cityId: 65, code: "521322" },
    { id: 27323, cityId: 65, code: "521325" },
    { id: 27324, cityId: 65, code: "521327" },
    { id: 27325, cityId: 65, code: "521330" },
    { id: 27326, cityId: 65, code: "521333" },
    { id: 27327, cityId: 65, code: "521340" },
    { id: 27328, cityId: 65, code: "521343" },
    { id: 27329, cityId: 65, code: "521356" },
    { id: 27330, cityId: 65, code: "521369" },
    { id: 27331, cityId: 65, code: "521370" },
    { id: 27332, cityId: 65, code: "521372" },
    { id: 27333, cityId: 65, code: "521391" },
    { id: 27334, cityId: 65, code: "521401" },
    { id: 27335, cityId: 65, code: "521402" },
    { id: 27336, cityId: 65, code: "521436" },
    { id: 27337, cityId: 66, code: "517425" },
    { id: 27338, cityId: 67, code: "505101" },
    { id: 27339, cityId: 67, code: "518001" },
    { id: 27340, cityId: 67, code: "518004" },
    { id: 27341, cityId: 67, code: "518015" },
    { id: 27342, cityId: 67, code: "518017" },
    { id: 27343, cityId: 67, code: "518020" },
    { id: 27344, cityId: 67, code: "518022" },
    { id: 27345, cityId: 67, code: "518023" },
    { id: 27346, cityId: 67, code: "518102" },
    { id: 27347, cityId: 67, code: "518112" },
    { id: 27348, cityId: 67, code: "518115" },
    { id: 27349, cityId: 67, code: "518123" },
    { id: 27350, cityId: 67, code: "518134" },
    { id: 27351, cityId: 67, code: "518137" },
    { id: 27352, cityId: 67, code: "518145" },
    { id: 27353, cityId: 67, code: "518155" },
    { id: 27354, cityId: 67, code: "518157" },
    { id: 27355, cityId: 67, code: "518158" },
    { id: 27356, cityId: 67, code: "518165" },
    { id: 27357, cityId: 67, code: "518166" },
    { id: 27358, cityId: 67, code: "518176" },
    { id: 27359, cityId: 67, code: "518202" },
    { id: 27360, cityId: 67, code: "518216" },
    { id: 27361, cityId: 67, code: "518219" },
    { id: 27362, cityId: 67, code: "518221" },
    { id: 27363, cityId: 67, code: "518301" },
    { id: 27364, cityId: 67, code: "518333" },
    { id: 27365, cityId: 67, code: "518345" },
    { id: 27366, cityId: 67, code: "518346" },
    { id: 27367, cityId: 67, code: "518348" },
    { id: 27368, cityId: 67, code: "518385" },
    { id: 27369, cityId: 67, code: "518396" },
    { id: 27370, cityId: 67, code: "518398" },
    { id: 27371, cityId: 67, code: "518399" },
    { id: 27372, cityId: 67, code: "518401" },
    { id: 27373, cityId: 67, code: "518412" },
    { id: 27374, cityId: 67, code: "518422" },
    { id: 27375, cityId: 67, code: "518452" },
    { id: 27376, cityId: 67, code: "518462" },
    { id: 27377, cityId: 67, code: "518467" },
    { id: 27378, cityId: 67, code: "518468" },
    { id: 27379, cityId: 67, code: "518470" },
    { id: 27380, cityId: 67, code: "518512" },
    { id: 27381, cityId: 67, code: "518513" },
    { id: 27382, cityId: 67, code: "518515" },
    { id: 27383, cityId: 67, code: "518523" },
    { id: 27384, cityId: 67, code: "518550" },
    { id: 27385, cityId: 67, code: "518555" },
    { id: 27386, cityId: 67, code: "518573" },
    { id: 27387, cityId: 67, code: "518594" },
    { id: 27388, cityId: 67, code: "518669" },
    { id: 27389, cityId: 67, code: "505530" },
    { id: 27390, cityId: 67, code: "516506" },
    { id: 27391, cityId: 67, code: "518002" },
    { id: 27392, cityId: 67, code: "518003" },
    { id: 27393, cityId: 67, code: "518005" },
    { id: 27394, cityId: 67, code: "518011" },
    { id: 27395, cityId: 67, code: "518016" },
    { id: 27396, cityId: 67, code: "518018" },
    { id: 27397, cityId: 67, code: "518019" },
    { id: 27398, cityId: 67, code: "518021" },
    { id: 27399, cityId: 67, code: "518101" },
    { id: 27400, cityId: 67, code: "518122" },
    { id: 27401, cityId: 67, code: "518124" },
    { id: 27402, cityId: 67, code: "518135" },
    { id: 27403, cityId: 67, code: "518138" },
    { id: 27404, cityId: 67, code: "518146" },
    { id: 27405, cityId: 67, code: "518186" },
    { id: 27406, cityId: 67, code: "518196" },
    { id: 27407, cityId: 67, code: "518206" },
    { id: 27408, cityId: 67, code: "518217" },
    { id: 27409, cityId: 67, code: "518220" },
    { id: 27410, cityId: 67, code: "518222" },
    { id: 27411, cityId: 67, code: "518225" },
    { id: 27412, cityId: 67, code: "518302" },
    { id: 27413, cityId: 67, code: "518323" },
    { id: 27414, cityId: 67, code: "518344" },
    { id: 27415, cityId: 67, code: "518347" },
    { id: 27416, cityId: 67, code: "518349" },
    { id: 27417, cityId: 67, code: "518350" },
    { id: 27418, cityId: 67, code: "518360" },
    { id: 27419, cityId: 67, code: "518363" },
    { id: 27420, cityId: 67, code: "518382" },
    { id: 27421, cityId: 67, code: "518390" },
    { id: 27422, cityId: 67, code: "518395" },
    { id: 27423, cityId: 67, code: "518397" },
    { id: 27424, cityId: 67, code: "518402" },
    { id: 27425, cityId: 67, code: "518405" },
    { id: 27426, cityId: 67, code: "518411" },
    { id: 27427, cityId: 67, code: "518426" },
    { id: 27428, cityId: 67, code: "518432" },
    { id: 27429, cityId: 67, code: "518442" },
    { id: 27430, cityId: 67, code: "518463" },
    { id: 27431, cityId: 67, code: "518464" },
    { id: 27432, cityId: 67, code: "518501" },
    { id: 27433, cityId: 67, code: "518503" },
    { id: 27434, cityId: 67, code: "518511" },
    { id: 27435, cityId: 67, code: "518517" },
    { id: 27436, cityId: 67, code: "518533" },
    { id: 27437, cityId: 67, code: "518543" },
    { id: 27438, cityId: 67, code: "518553" },
    { id: 27439, cityId: 67, code: "518583" },
    { id: 27440, cityId: 67, code: "518593" },
    { id: 27441, cityId: 67, code: "518596" },
    { id: 27442, cityId: 67, code: "518598" },
    { id: 27443, cityId: 67, code: "518599" },
    { id: 27444, cityId: 67, code: "518607" },
    { id: 27445, cityId: 67, code: "518675" },
    { id: 27446, cityId: 68, code: "509375" },
    { id: 27447, cityId: 69, code: "509129" },
    { id: 27448, cityId: 69, code: "522426" },
    { id: 27449, cityId: 70, code: "521001" },
    { id: 27450, cityId: 71, code: "517325" },
    { id: 27451, cityId: 71, code: "517327" },
    { id: 27452, cityId: 72, code: "508376" },
    { id: 27453, cityId: 72, code: "509001" },
    { id: 27454, cityId: 72, code: "509104" },
    { id: 27455, cityId: 72, code: "509106" },
    { id: 27456, cityId: 72, code: "509107" },
    { id: 27457, cityId: 72, code: "509109" },
    { id: 27458, cityId: 72, code: "509112" },
    { id: 27459, cityId: 72, code: "509115" },
    { id: 27460, cityId: 72, code: "509117" },
    { id: 27461, cityId: 72, code: "509125" },
    { id: 27462, cityId: 72, code: "509128" },
    { id: 27463, cityId: 72, code: "509130" },
    { id: 27464, cityId: 72, code: "509131" },
    { id: 27465, cityId: 72, code: "509133" },
    { id: 27466, cityId: 72, code: "509135" },
    { id: 27467, cityId: 72, code: "509136" },
    { id: 27468, cityId: 72, code: "509138" },
    { id: 27469, cityId: 72, code: "509141" },
    { id: 27470, cityId: 72, code: "509143" },
    { id: 27471, cityId: 72, code: "509144" },
    { id: 27472, cityId: 72, code: "509146" },
    { id: 27473, cityId: 72, code: "509149" },
    { id: 27474, cityId: 72, code: "509151" },
    { id: 27475, cityId: 72, code: "509152" },
    { id: 27476, cityId: 72, code: "509154" },
    { id: 27477, cityId: 72, code: "509173" },
    { id: 27478, cityId: 72, code: "509202" },
    { id: 27479, cityId: 72, code: "509204" },
    { id: 27480, cityId: 72, code: "509205" },
    { id: 27481, cityId: 72, code: "509207" },
    { id: 27482, cityId: 72, code: "509210" },
    { id: 27483, cityId: 72, code: "509212" },
    { id: 27484, cityId: 72, code: "509213" },
    { id: 27485, cityId: 72, code: "509215" },
    { id: 27486, cityId: 72, code: "509218" },
    { id: 27487, cityId: 72, code: "509220" },
    { id: 27488, cityId: 72, code: "509221" },
    { id: 27489, cityId: 72, code: "509223" },
    { id: 27490, cityId: 72, code: "509226" },
    { id: 27491, cityId: 72, code: "509228" },
    { id: 27492, cityId: 72, code: "509241" },
    { id: 27493, cityId: 72, code: "509242" },
    { id: 27494, cityId: 72, code: "509302" },
    { id: 27495, cityId: 72, code: "509303" },
    { id: 27496, cityId: 72, code: "509305" },
    { id: 27497, cityId: 72, code: "509311" },
    { id: 27498, cityId: 72, code: "509321" },
    { id: 27499, cityId: 72, code: "509324" },
    { id: 27500, cityId: 72, code: "509326" },
    { id: 27501, cityId: 72, code: "509329" },
    { id: 27502, cityId: 72, code: "509331" },
    { id: 27503, cityId: 72, code: "509332" },
    { id: 27504, cityId: 72, code: "509334" },
    { id: 27505, cityId: 72, code: "509337" },
    { id: 27506, cityId: 72, code: "509339" },
    { id: 27507, cityId: 72, code: "509340" },
    { id: 27508, cityId: 72, code: "509345" },
    { id: 27509, cityId: 72, code: "509347" },
    { id: 27510, cityId: 72, code: "509348" },
    { id: 27511, cityId: 72, code: "509350" },
    { id: 27512, cityId: 72, code: "509353" },
    { id: 27513, cityId: 72, code: "509358" },
    { id: 27514, cityId: 72, code: "509361" },
    { id: 27515, cityId: 72, code: "509363" },
    { id: 27516, cityId: 72, code: "509364" },
    { id: 27517, cityId: 72, code: "509371" },
    { id: 27518, cityId: 72, code: "509376" },
    { id: 27519, cityId: 72, code: "509382" },
    { id: 27520, cityId: 72, code: "509384" },
    { id: 27521, cityId: 72, code: "509385" },
    { id: 27522, cityId: 72, code: "509390" },
    { id: 27523, cityId: 72, code: "509401" },
    { id: 27524, cityId: 72, code: "509406" },
    { id: 27525, cityId: 72, code: "509408" },
    { id: 27526, cityId: 72, code: "509409" },
    { id: 27527, cityId: 72, code: "509411" },
    { id: 27528, cityId: 72, code: "509414" },
    { id: 27529, cityId: 72, code: "509416" },
    { id: 27530, cityId: 72, code: "509432" },
    { id: 27531, cityId: 72, code: "509002" },
    { id: 27532, cityId: 72, code: "509102" },
    { id: 27533, cityId: 72, code: "509103" },
    { id: 27534, cityId: 72, code: "509105" },
    { id: 27535, cityId: 72, code: "509108" },
    { id: 27536, cityId: 72, code: "509110" },
    { id: 27537, cityId: 72, code: "509111" },
    { id: 27538, cityId: 72, code: "509113" },
    { id: 27539, cityId: 72, code: "509116" },
    { id: 27540, cityId: 72, code: "509126" },
    { id: 27541, cityId: 72, code: "509127" },
    { id: 27542, cityId: 72, code: "509132" },
    { id: 27543, cityId: 72, code: "509134" },
    { id: 27544, cityId: 72, code: "509137" },
    { id: 27545, cityId: 72, code: "509139" },
    { id: 27546, cityId: 72, code: "509140" },
    { id: 27547, cityId: 72, code: "509142" },
    { id: 27548, cityId: 72, code: "509145" },
    { id: 27549, cityId: 72, code: "509147" },
    { id: 27550, cityId: 72, code: "509150" },
    { id: 27551, cityId: 72, code: "509153" },
    { id: 27552, cityId: 72, code: "509155" },
    { id: 27553, cityId: 72, code: "509171" },
    { id: 27554, cityId: 72, code: "509172" },
    { id: 27555, cityId: 72, code: "509201" },
    { id: 27556, cityId: 72, code: "509203" },
    { id: 27557, cityId: 72, code: "509206" },
    { id: 27558, cityId: 72, code: "509208" },
    { id: 27559, cityId: 72, code: "509209" },
    { id: 27560, cityId: 72, code: "509211" },
    { id: 27561, cityId: 72, code: "509214" },
    { id: 27562, cityId: 72, code: "509216" },
    { id: 27563, cityId: 72, code: "509217" },
    { id: 27564, cityId: 72, code: "509219" },
    { id: 27565, cityId: 72, code: "509222" },
    { id: 27566, cityId: 72, code: "509224" },
    { id: 27567, cityId: 72, code: "509225" },
    { id: 27568, cityId: 72, code: "509227" },
    { id: 27569, cityId: 72, code: "509243" },
    { id: 27570, cityId: 72, code: "509301" },
    { id: 27571, cityId: 72, code: "509306" },
    { id: 27572, cityId: 72, code: "509307" },
    { id: 27573, cityId: 72, code: "509320" },
    { id: 27574, cityId: 72, code: "509323" },
    { id: 27575, cityId: 72, code: "509325" },
    { id: 27576, cityId: 72, code: "509327" },
    { id: 27577, cityId: 72, code: "509328" },
    { id: 27578, cityId: 72, code: "509330" },
    { id: 27579, cityId: 72, code: "509333" },
    { id: 27580, cityId: 72, code: "509335" },
    { id: 27581, cityId: 72, code: "509336" },
    { id: 27582, cityId: 72, code: "509338" },
    { id: 27583, cityId: 72, code: "509341" },
    { id: 27584, cityId: 72, code: "509343" },
    { id: 27585, cityId: 72, code: "509344" },
    { id: 27586, cityId: 72, code: "509346" },
    { id: 27587, cityId: 72, code: "509349" },
    { id: 27588, cityId: 72, code: "509351" },
    { id: 27589, cityId: 72, code: "509357" },
    { id: 27590, cityId: 72, code: "509359" },
    { id: 27591, cityId: 72, code: "509360" },
    { id: 27592, cityId: 72, code: "509362" },
    { id: 27593, cityId: 72, code: "509365" },
    { id: 27594, cityId: 72, code: "509380" },
    { id: 27595, cityId: 72, code: "509381" },
    { id: 27596, cityId: 72, code: "509383" },
    { id: 27597, cityId: 72, code: "509388" },
    { id: 27598, cityId: 72, code: "509389" },
    { id: 27599, cityId: 72, code: "509407" },
    { id: 27600, cityId: 72, code: "509410" },
    { id: 27601, cityId: 72, code: "509412" },
    { id: 27602, cityId: 72, code: "509413" },
    { id: 27603, cityId: 72, code: "509431" },
    { id: 27604, cityId: 72, code: "509433" },
    { id: 27605, cityId: 73, code: "500047" },
    { id: 27606, cityId: 74, code: "522503" },
    { id: 27607, cityId: 75, code: "523316" },
    { id: 27608, cityId: 76, code: "502001" },
    { id: 27609, cityId: 76, code: "502101" },
    { id: 27610, cityId: 76, code: "502104" },
    { id: 27611, cityId: 76, code: "502107" },
    { id: 27612, cityId: 76, code: "502109" },
    { id: 27613, cityId: 76, code: "502114" },
    { id: 27614, cityId: 76, code: "502117" },
    { id: 27615, cityId: 76, code: "502130" },
    { id: 27616, cityId: 76, code: "502210" },
    { id: 27617, cityId: 76, code: "502212" },
    { id: 27618, cityId: 76, code: "502220" },
    { id: 27619, cityId: 76, code: "502228" },
    { id: 27620, cityId: 76, code: "502247" },
    { id: 27621, cityId: 76, code: "502249" },
    { id: 27622, cityId: 76, code: "502255" },
    { id: 27623, cityId: 76, code: "502257" },
    { id: 27624, cityId: 76, code: "502270" },
    { id: 27625, cityId: 76, code: "502271" },
    { id: 27626, cityId: 76, code: "502273" },
    { id: 27627, cityId: 76, code: "502276" },
    { id: 27628, cityId: 76, code: "502278" },
    { id: 27629, cityId: 76, code: "502279" },
    { id: 27630, cityId: 76, code: "502281" },
    { id: 27631, cityId: 76, code: "502284" },
    { id: 27632, cityId: 76, code: "502286" },
    { id: 27633, cityId: 76, code: "502287" },
    { id: 27634, cityId: 76, code: "502289" },
    { id: 27635, cityId: 76, code: "502292" },
    { id: 27636, cityId: 76, code: "502294" },
    { id: 27637, cityId: 76, code: "502297" },
    { id: 27638, cityId: 76, code: "502302" },
    { id: 27639, cityId: 76, code: "502303" },
    { id: 27640, cityId: 76, code: "502305" },
    { id: 27641, cityId: 76, code: "502308" },
    { id: 27642, cityId: 76, code: "502310" },
    { id: 27643, cityId: 76, code: "502318" },
    { id: 27644, cityId: 76, code: "502321" },
    { id: 27645, cityId: 76, code: "502323" },
    { id: 27646, cityId: 76, code: "502324" },
    { id: 27647, cityId: 76, code: "502329" },
    { id: 27648, cityId: 76, code: "502331" },
    { id: 27649, cityId: 76, code: "502334" },
    { id: 27650, cityId: 76, code: "502371" },
    { id: 27651, cityId: 76, code: "502374" },
    { id: 27652, cityId: 76, code: "502102" },
    { id: 27653, cityId: 76, code: "502103" },
    { id: 27654, cityId: 76, code: "502108" },
    { id: 27655, cityId: 76, code: "502110" },
    { id: 27656, cityId: 76, code: "502113" },
    { id: 27657, cityId: 76, code: "502201" },
    { id: 27658, cityId: 76, code: "502211" },
    { id: 27659, cityId: 76, code: "502213" },
    { id: 27660, cityId: 76, code: "502221" },
    { id: 27661, cityId: 76, code: "502246" },
    { id: 27662, cityId: 76, code: "502248" },
    { id: 27663, cityId: 76, code: "502251" },
    { id: 27664, cityId: 76, code: "502256" },
    { id: 27665, cityId: 76, code: "502267" },
    { id: 27666, cityId: 76, code: "502269" },
    { id: 27667, cityId: 76, code: "502277" },
    { id: 27668, cityId: 76, code: "502280" },
    { id: 27669, cityId: 76, code: "502285" },
    { id: 27670, cityId: 76, code: "502288" },
    { id: 27671, cityId: 76, code: "502290" },
    { id: 27672, cityId: 76, code: "502291" },
    { id: 27673, cityId: 76, code: "502293" },
    { id: 27674, cityId: 76, code: "502296" },
    { id: 27675, cityId: 76, code: "502299" },
    { id: 27676, cityId: 76, code: "502301" },
    { id: 27677, cityId: 76, code: "502304" },
    { id: 27678, cityId: 76, code: "502306" },
    { id: 27679, cityId: 76, code: "502307" },
    { id: 27680, cityId: 76, code: "502311" },
    { id: 27681, cityId: 76, code: "502312" },
    { id: 27682, cityId: 76, code: "502314" },
    { id: 27683, cityId: 76, code: "502319" },
    { id: 27684, cityId: 76, code: "502322" },
    { id: 27685, cityId: 76, code: "502325" },
    { id: 27686, cityId: 76, code: "502330" },
    { id: 27687, cityId: 76, code: "502372" },
    { id: 27688, cityId: 76, code: "502375" },
    { id: 27689, cityId: 76, code: "502381" },
    { id: 27690, cityId: 77, code: "517590" },
    { id: 27691, cityId: 78, code: "508013" },
    { id: 27692, cityId: 78, code: "508101" },
    { id: 27693, cityId: 78, code: "508111" },
    { id: 27694, cityId: 78, code: "508114" },
    { id: 27695, cityId: 78, code: "508116" },
    { id: 27696, cityId: 78, code: "508125" },
    { id: 27697, cityId: 78, code: "508201" },
    { id: 27698, cityId: 78, code: "508204" },
    { id: 27699, cityId: 78, code: "508206" },
    { id: 27700, cityId: 78, code: "508207" },
    { id: 27701, cityId: 78, code: "508212" },
    { id: 27702, cityId: 78, code: "508214" },
    { id: 27703, cityId: 78, code: "508215" },
    { id: 27704, cityId: 78, code: "508217" },
    { id: 27705, cityId: 78, code: "508220" },
    { id: 27706, cityId: 78, code: "508222" },
    { id: 27707, cityId: 78, code: "508223" },
    { id: 27708, cityId: 78, code: "508225" },
    { id: 27709, cityId: 78, code: "508230" },
    { id: 27710, cityId: 78, code: "508233" },
    { id: 27711, cityId: 78, code: "508238" },
    { id: 27712, cityId: 78, code: "508244" },
    { id: 27713, cityId: 78, code: "508246" },
    { id: 27714, cityId: 78, code: "508247" },
    { id: 27715, cityId: 78, code: "508252" },
    { id: 27716, cityId: 78, code: "508254" },
    { id: 27717, cityId: 78, code: "508257" },
    { id: 27718, cityId: 78, code: "508259" },
    { id: 27719, cityId: 78, code: "508262" },
    { id: 27720, cityId: 78, code: "508265" },
    { id: 27721, cityId: 78, code: "508268" },
    { id: 27722, cityId: 78, code: "508278" },
    { id: 27723, cityId: 78, code: "508281" },
    { id: 27724, cityId: 78, code: "508283" },
    { id: 27725, cityId: 78, code: "508284" },
    { id: 27726, cityId: 78, code: "508286" },
    { id: 27727, cityId: 78, code: "508289" },
    { id: 27728, cityId: 78, code: "508336" },
    { id: 27729, cityId: 78, code: "508337" },
    { id: 27730, cityId: 78, code: "508347" },
    { id: 27731, cityId: 78, code: "508349" },
    { id: 27732, cityId: 78, code: "508350" },
    { id: 27733, cityId: 78, code: "508352" },
    { id: 27734, cityId: 78, code: "508355" },
    { id: 27735, cityId: 78, code: "508357" },
    { id: 27736, cityId: 78, code: "508365" },
    { id: 27737, cityId: 78, code: "508373" },
    { id: 27738, cityId: 78, code: "508374" },
    { id: 27739, cityId: 78, code: "508381" },
    { id: 27740, cityId: 78, code: "508001" },
    { id: 27741, cityId: 78, code: "508002" },
    { id: 27742, cityId: 78, code: "508102" },
    { id: 27743, cityId: 78, code: "508105" },
    { id: 27744, cityId: 78, code: "508112" },
    { id: 27745, cityId: 78, code: "508113" },
    { id: 27746, cityId: 78, code: "508115" },
    { id: 27747, cityId: 78, code: "508121" },
    { id: 27748, cityId: 78, code: "508123" },
    { id: 27749, cityId: 78, code: "508126" },
    { id: 27750, cityId: 78, code: "508142" },
    { id: 27751, cityId: 78, code: "508202" },
    { id: 27752, cityId: 78, code: "508203" },
    { id: 27753, cityId: 78, code: "508205" },
    { id: 27754, cityId: 78, code: "508210" },
    { id: 27755, cityId: 78, code: "508211" },
    { id: 27756, cityId: 78, code: "508213" },
    { id: 27757, cityId: 78, code: "508216" },
    { id: 27758, cityId: 78, code: "508218" },
    { id: 27759, cityId: 78, code: "508219" },
    { id: 27760, cityId: 78, code: "508221" },
    { id: 27761, cityId: 78, code: "508224" },
    { id: 27762, cityId: 78, code: "508227" },
    { id: 27763, cityId: 78, code: "508229" },
    { id: 27764, cityId: 78, code: "508234" },
    { id: 27765, cityId: 78, code: "508243" },
    { id: 27766, cityId: 78, code: "508245" },
    { id: 27767, cityId: 78, code: "508248" },
    { id: 27768, cityId: 78, code: "508250" },
    { id: 27769, cityId: 78, code: "508253" },
    { id: 27770, cityId: 78, code: "508255" },
    { id: 27771, cityId: 78, code: "508256" },
    { id: 27772, cityId: 78, code: "508258" },
    { id: 27773, cityId: 78, code: "508266" },
    { id: 27774, cityId: 78, code: "508272" },
    { id: 27775, cityId: 78, code: "508277" },
    { id: 27776, cityId: 78, code: "508279" },
    { id: 27777, cityId: 78, code: "508280" },
    { id: 27778, cityId: 78, code: "508282" },
    { id: 27779, cityId: 78, code: "508285" },
    { id: 27780, cityId: 78, code: "508287" },
    { id: 27781, cityId: 78, code: "508288" },
    { id: 27782, cityId: 78, code: "508290" },
    { id: 27783, cityId: 78, code: "508293" },
    { id: 27784, cityId: 78, code: "508296" },
    { id: 27785, cityId: 78, code: "508301" },
    { id: 27786, cityId: 78, code: "508332" },
    { id: 27787, cityId: 78, code: "508333" },
    { id: 27788, cityId: 78, code: "508346" },
    { id: 27789, cityId: 78, code: "508351" },
    { id: 27790, cityId: 78, code: "508353" },
    { id: 27791, cityId: 78, code: "508364" },
    { id: 27792, cityId: 78, code: "508367" },
    { id: 27793, cityId: 78, code: "508375" },
    { id: 27794, cityId: 78, code: "508383" },
    { id: 27795, cityId: 78, code: "508385" },
    { id: 27796, cityId: 79, code: "518501" },
    { id: 27797, cityId: 80, code: "509210" },
    { id: 27798, cityId: 81, code: "502313" },
    { id: 27799, cityId: 81, code: "503307" },
    { id: 27800, cityId: 81, code: "504104" },
    { id: 27801, cityId: 82, code: "531116" },
    { id: 27802, cityId: 83, code: "524003" },
    { id: 27803, cityId: 83, code: "524005" },
    { id: 27804, cityId: 83, code: "524101" },
    { id: 27805, cityId: 83, code: "524119" },
    { id: 27806, cityId: 83, code: "524124" },
    { id: 27807, cityId: 83, code: "524127" },
    { id: 27808, cityId: 83, code: "524132" },
    { id: 27809, cityId: 83, code: "524201" },
    { id: 27810, cityId: 83, code: "524202" },
    { id: 27811, cityId: 83, code: "524222" },
    { id: 27812, cityId: 83, code: "524223" },
    { id: 27813, cityId: 83, code: "524225" },
    { id: 27814, cityId: 83, code: "524228" },
    { id: 27815, cityId: 83, code: "524230" },
    { id: 27816, cityId: 83, code: "524236" },
    { id: 27817, cityId: 83, code: "524302" },
    { id: 27818, cityId: 83, code: "524303" },
    { id: 27819, cityId: 83, code: "524305" },
    { id: 27820, cityId: 83, code: "524308" },
    { id: 27821, cityId: 83, code: "524310" },
    { id: 27822, cityId: 83, code: "524311" },
    { id: 27823, cityId: 83, code: "524313" },
    { id: 27824, cityId: 83, code: "524315" },
    { id: 27825, cityId: 83, code: "524316" },
    { id: 27826, cityId: 83, code: "524318" },
    { id: 27827, cityId: 83, code: "524321" },
    { id: 27828, cityId: 83, code: "524323" },
    { id: 27829, cityId: 83, code: "524324" },
    { id: 27830, cityId: 83, code: "524329" },
    { id: 27831, cityId: 83, code: "524366" },
    { id: 27832, cityId: 83, code: "524401" },
    { id: 27833, cityId: 83, code: "524403" },
    { id: 27834, cityId: 83, code: "524406" },
    { id: 27835, cityId: 83, code: "524408" },
    { id: 27836, cityId: 83, code: "524409" },
    { id: 27837, cityId: 83, code: "524411" },
    { id: 27838, cityId: 83, code: "524413" },
    { id: 27839, cityId: 83, code: "524414" },
    { id: 27840, cityId: 83, code: "524416" },
    { id: 27841, cityId: 83, code: "524421" },
    { id: 27842, cityId: 83, code: "524001" },
    { id: 27843, cityId: 83, code: "524002" },
    { id: 27844, cityId: 83, code: "524004" },
    { id: 27845, cityId: 83, code: "524102" },
    { id: 27846, cityId: 83, code: "524121" },
    { id: 27847, cityId: 83, code: "524123" },
    { id: 27848, cityId: 83, code: "524126" },
    { id: 27849, cityId: 83, code: "524129" },
    { id: 27850, cityId: 83, code: "524131" },
    { id: 27851, cityId: 83, code: "524137" },
    { id: 27852, cityId: 83, code: "524142" },
    { id: 27853, cityId: 83, code: "524152" },
    { id: 27854, cityId: 83, code: "524203" },
    { id: 27855, cityId: 83, code: "524221" },
    { id: 27856, cityId: 83, code: "524224" },
    { id: 27857, cityId: 83, code: "524226" },
    { id: 27858, cityId: 83, code: "524227" },
    { id: 27859, cityId: 83, code: "524234" },
    { id: 27860, cityId: 83, code: "524301" },
    { id: 27861, cityId: 83, code: "524304" },
    { id: 27862, cityId: 83, code: "524306" },
    { id: 27863, cityId: 83, code: "524307" },
    { id: 27864, cityId: 83, code: "524309" },
    { id: 27865, cityId: 83, code: "524312" },
    { id: 27866, cityId: 83, code: "524314" },
    { id: 27867, cityId: 83, code: "524317" },
    { id: 27868, cityId: 83, code: "524319" },
    { id: 27869, cityId: 83, code: "524320" },
    { id: 27870, cityId: 83, code: "524322" },
    { id: 27871, cityId: 83, code: "524333" },
    { id: 27872, cityId: 83, code: "524343" },
    { id: 27873, cityId: 83, code: "524344" },
    { id: 27874, cityId: 83, code: "524346" },
    { id: 27875, cityId: 83, code: "524402" },
    { id: 27876, cityId: 83, code: "524404" },
    { id: 27877, cityId: 83, code: "524405" },
    { id: 27878, cityId: 83, code: "524407" },
    { id: 27879, cityId: 83, code: "524410" },
    { id: 27880, cityId: 83, code: "524412" },
    { id: 27881, cityId: 83, code: "524415" },
    { id: 27882, cityId: 83, code: "524441" },
    { id: 27883, cityId: 84, code: "534301" },
    { id: 27884, cityId: 85, code: "504106" },
    { id: 27885, cityId: 86, code: "276206" },
    { id: 27886, cityId: 86, code: "503001" },
    { id: 27887, cityId: 86, code: "503003" },
    { id: 27888, cityId: 86, code: "503101" },
    { id: 27889, cityId: 86, code: "503102" },
    { id: 27890, cityId: 86, code: "503110" },
    { id: 27891, cityId: 86, code: "503115" },
    { id: 27892, cityId: 86, code: "503120" },
    { id: 27893, cityId: 86, code: "503123" },
    { id: 27894, cityId: 86, code: "503125" },
    { id: 27895, cityId: 86, code: "503144" },
    { id: 27896, cityId: 86, code: "503165" },
    { id: 27897, cityId: 86, code: "503176" },
    { id: 27898, cityId: 86, code: "503178" },
    { id: 27899, cityId: 86, code: "503186" },
    { id: 27900, cityId: 86, code: "503192" },
    { id: 27901, cityId: 86, code: "503202" },
    { id: 27902, cityId: 86, code: "503207" },
    { id: 27903, cityId: 86, code: "503213" },
    { id: 27904, cityId: 86, code: "503215" },
    { id: 27905, cityId: 86, code: "503218" },
    { id: 27906, cityId: 86, code: "503221" },
    { id: 27907, cityId: 86, code: "503224" },
    { id: 27908, cityId: 86, code: "503226" },
    { id: 27909, cityId: 86, code: "503228" },
    { id: 27910, cityId: 86, code: "503236" },
    { id: 27911, cityId: 86, code: "503245" },
    { id: 27912, cityId: 86, code: "503305" },
    { id: 27913, cityId: 86, code: "503306" },
    { id: 27914, cityId: 86, code: "503308" },
    { id: 27915, cityId: 86, code: "503311" },
    { id: 27916, cityId: 86, code: "503313" },
    { id: 27917, cityId: 86, code: "503314" },
    { id: 27918, cityId: 86, code: "503321" },
    { id: 27919, cityId: 86, code: "521206" },
    { id: 27920, cityId: 86, code: "503002" },
    { id: 27921, cityId: 86, code: "503103" },
    { id: 27922, cityId: 86, code: "503111" },
    { id: 27923, cityId: 86, code: "503114" },
    { id: 27924, cityId: 86, code: "503122" },
    { id: 27925, cityId: 86, code: "503124" },
    { id: 27926, cityId: 86, code: "503145" },
    { id: 27927, cityId: 86, code: "503164" },
    { id: 27928, cityId: 86, code: "503166" },
    { id: 27929, cityId: 86, code: "503174" },
    { id: 27930, cityId: 86, code: "503175" },
    { id: 27931, cityId: 86, code: "503177" },
    { id: 27932, cityId: 86, code: "503180" },
    { id: 27933, cityId: 86, code: "503185" },
    { id: 27934, cityId: 86, code: "503187" },
    { id: 27935, cityId: 86, code: "503188" },
    { id: 27936, cityId: 86, code: "503193" },
    { id: 27937, cityId: 86, code: "503201" },
    { id: 27938, cityId: 86, code: "503203" },
    { id: 27939, cityId: 86, code: "503206" },
    { id: 27940, cityId: 86, code: "503212" },
    { id: 27941, cityId: 86, code: "503214" },
    { id: 27942, cityId: 86, code: "503219" },
    { id: 27943, cityId: 86, code: "503220" },
    { id: 27944, cityId: 86, code: "503222" },
    { id: 27945, cityId: 86, code: "503225" },
    { id: 27946, cityId: 86, code: "503227" },
    { id: 27947, cityId: 86, code: "503230" },
    { id: 27948, cityId: 86, code: "503235" },
    { id: 27949, cityId: 86, code: "503246" },
    { id: 27950, cityId: 86, code: "503301" },
    { id: 27951, cityId: 86, code: "503302" },
    { id: 27952, cityId: 86, code: "503307" },
    { id: 27953, cityId: 86, code: "503309" },
    { id: 27954, cityId: 86, code: "503310" },
    { id: 27955, cityId: 86, code: "503315" },
    { id: 27956, cityId: 87, code: "521201" },
    { id: 27957, cityId: 88, code: "523001" },
    { id: 27958, cityId: 89, code: "503116" },
    { id: 27959, cityId: 90, code: "521366" },
    { id: 27960, cityId: 91, code: "533437" },
    { id: 27961, cityId: 92, code: "522124" },
    { id: 27962, cityId: 93, code: "523002" },
    { id: 27963, cityId: 93, code: "523105" },
    { id: 27964, cityId: 93, code: "523106" },
    { id: 27965, cityId: 93, code: "523108" },
    { id: 27966, cityId: 93, code: "523111" },
    { id: 27967, cityId: 93, code: "523113" },
    { id: 27968, cityId: 93, code: "523114" },
    { id: 27969, cityId: 93, code: "523121" },
    { id: 27970, cityId: 93, code: "523124" },
    { id: 27971, cityId: 93, code: "523135" },
    { id: 27972, cityId: 93, code: "523156" },
    { id: 27973, cityId: 93, code: "523166" },
    { id: 27974, cityId: 93, code: "523169" },
    { id: 27975, cityId: 93, code: "523180" },
    { id: 27976, cityId: 93, code: "523182" },
    { id: 27977, cityId: 93, code: "523183" },
    { id: 27978, cityId: 93, code: "523185" },
    { id: 27979, cityId: 93, code: "523187" },
    { id: 27980, cityId: 93, code: "523188" },
    { id: 27981, cityId: 93, code: "523190" },
    { id: 27982, cityId: 93, code: "523195" },
    { id: 27983, cityId: 93, code: "523201" },
    { id: 27984, cityId: 93, code: "523211" },
    { id: 27985, cityId: 93, code: "523212" },
    { id: 27986, cityId: 93, code: "523219" },
    { id: 27987, cityId: 93, code: "523225" },
    { id: 27988, cityId: 93, code: "523227" },
    { id: 27989, cityId: 93, code: "523228" },
    { id: 27990, cityId: 93, code: "523230" },
    { id: 27991, cityId: 93, code: "523240" },
    { id: 27992, cityId: 93, code: "523241" },
    { id: 27993, cityId: 93, code: "523243" },
    { id: 27994, cityId: 93, code: "523246" },
    { id: 27995, cityId: 93, code: "523254" },
    { id: 27996, cityId: 93, code: "523262" },
    { id: 27997, cityId: 93, code: "523264" },
    { id: 27998, cityId: 93, code: "523265" },
    { id: 27999, cityId: 93, code: "523267" },
    { id: 28000, cityId: 93, code: "523272" },
    { id: 28001, cityId: 93, code: "523273" },
    { id: 28002, cityId: 93, code: "523280" },
    { id: 28003, cityId: 93, code: "523281" },
    { id: 28004, cityId: 93, code: "523285" },
    { id: 28005, cityId: 93, code: "523286" },
    { id: 28006, cityId: 93, code: "523291" },
    { id: 28007, cityId: 93, code: "523301" },
    { id: 28008, cityId: 93, code: "523302" },
    { id: 28009, cityId: 93, code: "523304" },
    { id: 28010, cityId: 93, code: "523315" },
    { id: 28011, cityId: 93, code: "523320" },
    { id: 28012, cityId: 93, code: "523326" },
    { id: 28013, cityId: 93, code: "523328" },
    { id: 28014, cityId: 93, code: "523331" },
    { id: 28015, cityId: 93, code: "523333" },
    { id: 28016, cityId: 93, code: "523338" },
    { id: 28017, cityId: 93, code: "523346" },
    { id: 28018, cityId: 93, code: "523357" },
    { id: 28019, cityId: 93, code: "523368" },
    { id: 28020, cityId: 93, code: "523370" },
    { id: 28021, cityId: 93, code: "523371" },
    { id: 28022, cityId: 93, code: "523373" },
    { id: 28023, cityId: 93, code: "523001" },
    { id: 28024, cityId: 93, code: "523101" },
    { id: 28025, cityId: 93, code: "523104" },
    { id: 28026, cityId: 93, code: "523109" },
    { id: 28027, cityId: 93, code: "523110" },
    { id: 28028, cityId: 93, code: "523112" },
    { id: 28029, cityId: 93, code: "523115" },
    { id: 28030, cityId: 93, code: "523125" },
    { id: 28031, cityId: 93, code: "523155" },
    { id: 28032, cityId: 93, code: "523157" },
    { id: 28033, cityId: 93, code: "523165" },
    { id: 28034, cityId: 93, code: "523168" },
    { id: 28035, cityId: 93, code: "523170" },
    { id: 28036, cityId: 93, code: "523181" },
    { id: 28037, cityId: 93, code: "523184" },
    { id: 28038, cityId: 93, code: "523186" },
    { id: 28039, cityId: 93, code: "523189" },
    { id: 28040, cityId: 93, code: "523194" },
    { id: 28041, cityId: 93, code: "523213" },
    { id: 28042, cityId: 93, code: "523216" },
    { id: 28043, cityId: 93, code: "523223" },
    { id: 28044, cityId: 93, code: "523224" },
    { id: 28045, cityId: 93, code: "523226" },
    { id: 28046, cityId: 93, code: "523245" },
    { id: 28047, cityId: 93, code: "523247" },
    { id: 28048, cityId: 93, code: "523252" },
    { id: 28049, cityId: 93, code: "523253" },
    { id: 28050, cityId: 93, code: "523260" },
    { id: 28051, cityId: 93, code: "523261" },
    { id: 28052, cityId: 93, code: "523263" },
    { id: 28053, cityId: 93, code: "523269" },
    { id: 28054, cityId: 93, code: "523271" },
    { id: 28055, cityId: 93, code: "523274" },
    { id: 28056, cityId: 93, code: "523277" },
    { id: 28057, cityId: 93, code: "523279" },
    { id: 28058, cityId: 93, code: "523290" },
    { id: 28059, cityId: 93, code: "523292" },
    { id: 28060, cityId: 93, code: "523297" },
    { id: 28061, cityId: 93, code: "523303" },
    { id: 28062, cityId: 93, code: "523305" },
    { id: 28063, cityId: 93, code: "523316" },
    { id: 28064, cityId: 93, code: "523327" },
    { id: 28065, cityId: 93, code: "523329" },
    { id: 28066, cityId: 93, code: "523330" },
    { id: 28067, cityId: 93, code: "523332" },
    { id: 28068, cityId: 93, code: "523335" },
    { id: 28069, cityId: 93, code: "523345" },
    { id: 28070, cityId: 93, code: "523356" },
    { id: 28071, cityId: 93, code: "523367" },
    { id: 28072, cityId: 93, code: "523369" },
    { id: 28073, cityId: 93, code: "523372" },
    { id: 28074, cityId: 94, code: "516360" },
    { id: 28075, cityId: 95, code: "517583" },
    { id: 28076, cityId: 95, code: "574201" },
    { id: 28077, cityId: 95, code: "574307" },
    { id: 28078, cityId: 96, code: "533101" },
    { id: 28079, cityId: 97, code: "532127" },
    { id: 28080, cityId: 98, code: "515801" },
    { id: 28081, cityId: 98, code: "500030" },
    { id: 28082, cityId: 99, code: "501102" },
    { id: 28083, cityId: 99, code: "501105" },
    { id: 28084, cityId: 99, code: "501108" },
    { id: 28085, cityId: 99, code: "501110" },
    { id: 28086, cityId: 99, code: "501113" },
    { id: 28087, cityId: 99, code: "501115" },
    { id: 28088, cityId: 99, code: "501121" },
    { id: 28089, cityId: 99, code: "501142" },
    { id: 28090, cityId: 99, code: "501144" },
    { id: 28091, cityId: 99, code: "501145" },
    { id: 28092, cityId: 99, code: "501147" },
    { id: 28093, cityId: 99, code: "501150" },
    { id: 28094, cityId: 99, code: "501152" },
    { id: 28095, cityId: 99, code: "501153" },
    { id: 28096, cityId: 99, code: "501155" },
    { id: 28097, cityId: 99, code: "501158" },
    { id: 28098, cityId: 99, code: "501203" },
    { id: 28099, cityId: 99, code: "501205" },
    { id: 28100, cityId: 99, code: "501206" },
    { id: 28101, cityId: 99, code: "501301" },
    { id: 28102, cityId: 99, code: "501401" },
    { id: 28103, cityId: 99, code: "501502" },
    { id: 28104, cityId: 99, code: "501505" },
    { id: 28105, cityId: 99, code: "501510" },
    { id: 28106, cityId: 99, code: "501512" },
    { id: 28107, cityId: 99, code: "501513" },
    { id: 28108, cityId: 99, code: "501515" },
    { id: 28109, cityId: 99, code: "501518" },
    { id: 28110, cityId: 99, code: "501520" },
    { id: 28111, cityId: 99, code: "501521" },
    { id: 28112, cityId: 99, code: "501523" },
    { id: 28113, cityId: 99, code: "501526" },
    { id: 28114, cityId: 99, code: "501528" },
    { id: 28115, cityId: 99, code: "501531" },
    { id: 28116, cityId: 99, code: "501534" },
    { id: 28117, cityId: 99, code: "501536" },
    { id: 28118, cityId: 99, code: "501537" },
    { id: 28119, cityId: 99, code: "500134" },
    { id: 28120, cityId: 99, code: "501101" },
    { id: 28121, cityId: 99, code: "501103" },
    { id: 28122, cityId: 99, code: "501104" },
    { id: 28123, cityId: 99, code: "501106" },
    { id: 28124, cityId: 99, code: "501109" },
    { id: 28125, cityId: 99, code: "501111" },
    { id: 28126, cityId: 99, code: "501112" },
    { id: 28127, cityId: 99, code: "501114" },
    { id: 28128, cityId: 99, code: "501141" },
    { id: 28129, cityId: 99, code: "501143" },
    { id: 28130, cityId: 99, code: "501148" },
    { id: 28131, cityId: 99, code: "501149" },
    { id: 28132, cityId: 99, code: "501151" },
    { id: 28133, cityId: 99, code: "501154" },
    { id: 28134, cityId: 99, code: "501156" },
    { id: 28135, cityId: 99, code: "501157" },
    { id: 28136, cityId: 99, code: "501201" },
    { id: 28137, cityId: 99, code: "501202" },
    { id: 28138, cityId: 99, code: "501204" },
    { id: 28139, cityId: 99, code: "501403" },
    { id: 28140, cityId: 99, code: "501501" },
    { id: 28141, cityId: 99, code: "501503" },
    { id: 28142, cityId: 99, code: "501504" },
    { id: 28143, cityId: 99, code: "501508" },
    { id: 28144, cityId: 99, code: "501509" },
    { id: 28145, cityId: 99, code: "501511" },
    { id: 28146, cityId: 99, code: "501514" },
    { id: 28147, cityId: 99, code: "501516" },
    { id: 28148, cityId: 99, code: "501525" },
    { id: 28149, cityId: 99, code: "501527" },
    { id: 28150, cityId: 99, code: "501533" },
    { id: 28151, cityId: 99, code: "501535" },
    { id: 28152, cityId: 100, code: "515865" },
    { id: 28153, cityId: 101, code: "522265" },
    { id: 28154, cityId: 102, code: "502001" },
    { id: 28155, cityId: 103, code: "507128" },
    { id: 28156, cityId: 104, code: "522403" },
    { id: 28157, cityId: 105, code: "500003" },
    { id: 28158, cityId: 105, code: "500025" },
    { id: 28159, cityId: 106, code: "502103" },
    { id: 28160, cityId: 107, code: "505301" },
    { id: 28161, cityId: 108, code: "532284" },
    { id: 28162, cityId: 109, code: "532005" },
    { id: 28163, cityId: 109, code: "532015" },
    { id: 28164, cityId: 109, code: "532122" },
    { id: 28165, cityId: 109, code: "532124" },
    { id: 28166, cityId: 109, code: "532137" },
    { id: 28167, cityId: 109, code: "532148" },
    { id: 28168, cityId: 109, code: "532185" },
    { id: 28169, cityId: 109, code: "532190" },
    { id: 28170, cityId: 109, code: "532195" },
    { id: 28171, cityId: 109, code: "532201" },
    { id: 28172, cityId: 109, code: "532206" },
    { id: 28173, cityId: 109, code: "532209" },
    { id: 28174, cityId: 109, code: "532211" },
    { id: 28175, cityId: 109, code: "532212" },
    { id: 28176, cityId: 109, code: "532214" },
    { id: 28177, cityId: 109, code: "532219" },
    { id: 28178, cityId: 109, code: "532220" },
    { id: 28179, cityId: 109, code: "532222" },
    { id: 28180, cityId: 109, code: "532243" },
    { id: 28181, cityId: 109, code: "532264" },
    { id: 28182, cityId: 109, code: "532265" },
    { id: 28183, cityId: 109, code: "532270" },
    { id: 28184, cityId: 109, code: "532293" },
    { id: 28185, cityId: 109, code: "532312" },
    { id: 28186, cityId: 109, code: "532323" },
    { id: 28187, cityId: 109, code: "532402" },
    { id: 28188, cityId: 109, code: "532405" },
    { id: 28189, cityId: 109, code: "532407" },
    { id: 28190, cityId: 109, code: "532408" },
    { id: 28191, cityId: 109, code: "532421" },
    { id: 28192, cityId: 109, code: "532426" },
    { id: 28193, cityId: 109, code: "532445" },
    { id: 28194, cityId: 109, code: "532458" },
    { id: 28195, cityId: 109, code: "532460" },
    { id: 28196, cityId: 109, code: "532461" },
    { id: 28197, cityId: 109, code: "532463" },
    { id: 28198, cityId: 109, code: "532474" },
    { id: 28199, cityId: 109, code: "532484" },
    { id: 28200, cityId: 109, code: "532550" },
    { id: 28201, cityId: 109, code: "532551" },
    { id: 28202, cityId: 109, code: "521134" },
    { id: 28203, cityId: 109, code: "531032" },
    { id: 28204, cityId: 109, code: "532001" },
    { id: 28205, cityId: 109, code: "532101" },
    { id: 28206, cityId: 109, code: "532102" },
    { id: 28207, cityId: 109, code: "532123" },
    { id: 28208, cityId: 109, code: "532125" },
    { id: 28209, cityId: 109, code: "532126" },
    { id: 28210, cityId: 109, code: "532128" },
    { id: 28211, cityId: 109, code: "532168" },
    { id: 28212, cityId: 109, code: "532189" },
    { id: 28213, cityId: 109, code: "532208" },
    { id: 28214, cityId: 109, code: "532213" },
    { id: 28215, cityId: 109, code: "532215" },
    { id: 28216, cityId: 109, code: "532216" },
    { id: 28217, cityId: 109, code: "532221" },
    { id: 28218, cityId: 109, code: "532242" },
    { id: 28219, cityId: 109, code: "532244" },
    { id: 28220, cityId: 109, code: "532263" },
    { id: 28221, cityId: 109, code: "532284" },
    { id: 28222, cityId: 109, code: "532290" },
    { id: 28223, cityId: 109, code: "532292" },
    { id: 28224, cityId: 109, code: "532322" },
    { id: 28225, cityId: 109, code: "532401" },
    { id: 28226, cityId: 109, code: "532404" },
    { id: 28227, cityId: 109, code: "532406" },
    { id: 28228, cityId: 109, code: "532409" },
    { id: 28229, cityId: 109, code: "532417" },
    { id: 28230, cityId: 109, code: "532425" },
    { id: 28231, cityId: 109, code: "532427" },
    { id: 28232, cityId: 109, code: "532432" },
    { id: 28233, cityId: 109, code: "532440" },
    { id: 28234, cityId: 109, code: "532443" },
    { id: 28235, cityId: 109, code: "532456" },
    { id: 28236, cityId: 109, code: "532457" },
    { id: 28237, cityId: 109, code: "532459" },
    { id: 28238, cityId: 109, code: "532462" },
    { id: 28239, cityId: 109, code: "532470" },
    { id: 28240, cityId: 109, code: "532485" },
    { id: 28241, cityId: 110, code: "508213" },
    { id: 28242, cityId: 111, code: "520002" },
    { id: 28243, cityId: 112, code: "534101" },
    { id: 28244, cityId: 113, code: "501141" },
    { id: 28245, cityId: 113, code: "504272" },
    { id: 28246, cityId: 114, code: "534211" },
    { id: 28247, cityId: 115, code: "522201" },
    { id: 28248, cityId: 116, code: "517504" },
    { id: 28249, cityId: 117, code: "517501" },
    { id: 28250, cityId: 118, code: "517584" },
    { id: 28251, cityId: 119, code: "520001" },
    { id: 28252, cityId: 120, code: "530001" },
    { id: 28253, cityId: 121, code: "530002" },
    { id: 28254, cityId: 121, code: "530003" },
    { id: 28255, cityId: 121, code: "530005" },
    { id: 28256, cityId: 121, code: "530008" },
    { id: 28257, cityId: 121, code: "530010" },
    { id: 28258, cityId: 121, code: "530011" },
    { id: 28259, cityId: 121, code: "530013" },
    { id: 28260, cityId: 121, code: "530016" },
    { id: 28261, cityId: 121, code: "530018" },
    { id: 28262, cityId: 121, code: "530019" },
    { id: 28263, cityId: 121, code: "530021" },
    { id: 28264, cityId: 121, code: "530023" },
    { id: 28265, cityId: 121, code: "530024" },
    { id: 28266, cityId: 121, code: "530026" },
    { id: 28267, cityId: 121, code: "530029" },
    { id: 28268, cityId: 121, code: "530031" },
    { id: 28269, cityId: 121, code: "530039" },
    { id: 28270, cityId: 121, code: "530040" },
    { id: 28271, cityId: 121, code: "530042" },
    { id: 28272, cityId: 121, code: "531001" },
    { id: 28273, cityId: 121, code: "531011" },
    { id: 28274, cityId: 121, code: "531022" },
    { id: 28275, cityId: 121, code: "531025" },
    { id: 28276, cityId: 121, code: "531027" },
    { id: 28277, cityId: 121, code: "531028" },
    { id: 28278, cityId: 121, code: "531030" },
    { id: 28279, cityId: 121, code: "531033" },
    { id: 28280, cityId: 121, code: "531035" },
    { id: 28281, cityId: 121, code: "531036" },
    { id: 28282, cityId: 121, code: "531075" },
    { id: 28283, cityId: 121, code: "531083" },
    { id: 28284, cityId: 121, code: "531110" },
    { id: 28285, cityId: 121, code: "531117" },
    { id: 28286, cityId: 121, code: "531126" },
    { id: 28287, cityId: 121, code: "531133" },
    { id: 28288, cityId: 121, code: "531149" },
    { id: 28289, cityId: 121, code: "531152" },
    { id: 28290, cityId: 121, code: "531160" },
    { id: 28291, cityId: 121, code: "531162" },
    { id: 28292, cityId: 121, code: "531163" },
    { id: 28293, cityId: 121, code: "531173" },
    { id: 28294, cityId: 121, code: "530001" },
    { id: 28295, cityId: 121, code: "530004" },
    { id: 28296, cityId: 121, code: "530006" },
    { id: 28297, cityId: 121, code: "530007" },
    { id: 28298, cityId: 121, code: "530009" },
    { id: 28299, cityId: 121, code: "530012" },
    { id: 28300, cityId: 121, code: "530014" },
    { id: 28301, cityId: 121, code: "530015" },
    { id: 28302, cityId: 121, code: "530017" },
    { id: 28303, cityId: 121, code: "530020" },
    { id: 28304, cityId: 121, code: "530022" },
    { id: 28305, cityId: 121, code: "530025" },
    { id: 28306, cityId: 121, code: "530027" },
    { id: 28307, cityId: 121, code: "530028" },
    { id: 28308, cityId: 121, code: "530035" },
    { id: 28309, cityId: 121, code: "531002" },
    { id: 28310, cityId: 121, code: "531023" },
    { id: 28311, cityId: 121, code: "531026" },
    { id: 28312, cityId: 121, code: "531029" },
    { id: 28313, cityId: 121, code: "531031" },
    { id: 28314, cityId: 121, code: "531034" },
    { id: 28315, cityId: 121, code: "531040" },
    { id: 28316, cityId: 121, code: "531055" },
    { id: 28317, cityId: 121, code: "531060" },
    { id: 28318, cityId: 121, code: "531061" },
    { id: 28319, cityId: 121, code: "531077" },
    { id: 28320, cityId: 121, code: "531082" },
    { id: 28321, cityId: 121, code: "531105" },
    { id: 28322, cityId: 121, code: "531111" },
    { id: 28323, cityId: 121, code: "531113" },
    { id: 28324, cityId: 121, code: "531127" },
    { id: 28325, cityId: 121, code: "531135" },
    { id: 28326, cityId: 121, code: "531145" },
    { id: 28327, cityId: 121, code: "531151" },
    { id: 28328, cityId: 121, code: "531161" },
    { id: 28329, cityId: 121, code: "531172" },
    { id: 28330, cityId: 121, code: "531281" },
    { id: 28331, cityId: 122, code: "522608" },
    { id: 28332, cityId: 122, code: "531081" },
    { id: 28333, cityId: 122, code: "531084" },
    { id: 28334, cityId: 122, code: "531091" },
    { id: 28335, cityId: 122, code: "531115" },
    { id: 28336, cityId: 122, code: "531202" },
    { id: 28337, cityId: 122, code: "531203" },
    { id: 28338, cityId: 122, code: "531211" },
    { id: 28339, cityId: 122, code: "531213" },
    { id: 28340, cityId: 122, code: "531216" },
    { id: 28341, cityId: 122, code: "531218" },
    { id: 28342, cityId: 122, code: "531219" },
    { id: 28343, cityId: 122, code: "531221" },
    { id: 28344, cityId: 122, code: "531240" },
    { id: 28345, cityId: 122, code: "531242" },
    { id: 28346, cityId: 122, code: "531250" },
    { id: 28347, cityId: 122, code: "531280" },
    { id: 28348, cityId: 122, code: "531303" },
    { id: 28349, cityId: 122, code: "532217" },
    { id: 28350, cityId: 122, code: "532291" },
    { id: 28351, cityId: 122, code: "532403" },
    { id: 28352, cityId: 122, code: "532429" },
    { id: 28353, cityId: 122, code: "532501" },
    { id: 28354, cityId: 122, code: "532521" },
    { id: 28355, cityId: 122, code: "532522" },
    { id: 28356, cityId: 122, code: "532524" },
    { id: 28357, cityId: 122, code: "532527" },
    { id: 28358, cityId: 122, code: "532546" },
    { id: 28359, cityId: 122, code: "532558" },
    { id: 28360, cityId: 122, code: "532580" },
    { id: 28361, cityId: 122, code: "532591" },
    { id: 28362, cityId: 122, code: "532593" },
    { id: 28363, cityId: 122, code: "532599" },
    { id: 28364, cityId: 122, code: "532612" },
    { id: 28365, cityId: 122, code: "532617" },
    { id: 28366, cityId: 122, code: "521338" },
    { id: 28367, cityId: 122, code: "530030" },
    { id: 28368, cityId: 122, code: "531021" },
    { id: 28369, cityId: 122, code: "531024" },
    { id: 28370, cityId: 122, code: "531085" },
    { id: 28371, cityId: 122, code: "531087" },
    { id: 28372, cityId: 122, code: "531114" },
    { id: 28373, cityId: 122, code: "531116" },
    { id: 28374, cityId: 122, code: "531183" },
    { id: 28375, cityId: 122, code: "531201" },
    { id: 28376, cityId: 122, code: "531204" },
    { id: 28377, cityId: 122, code: "531214" },
    { id: 28378, cityId: 122, code: "531215" },
    { id: 28379, cityId: 122, code: "531217" },
    { id: 28380, cityId: 122, code: "531220" },
    { id: 28381, cityId: 122, code: "531230" },
    { id: 28382, cityId: 122, code: "531241" },
    { id: 28383, cityId: 122, code: "531260" },
    { id: 28384, cityId: 122, code: "531270" },
    { id: 28385, cityId: 122, code: "531273" },
    { id: 28386, cityId: 122, code: "532218" },
    { id: 28387, cityId: 122, code: "532428" },
    { id: 28388, cityId: 122, code: "532430" },
    { id: 28389, cityId: 122, code: "532502" },
    { id: 28390, cityId: 122, code: "532523" },
    { id: 28391, cityId: 122, code: "532525" },
    { id: 28392, cityId: 122, code: "532526" },
    { id: 28393, cityId: 122, code: "532534" },
    { id: 28394, cityId: 122, code: "532547" },
    { id: 28395, cityId: 122, code: "532557" },
    { id: 28396, cityId: 122, code: "532568" },
    { id: 28397, cityId: 122, code: "532573" },
    { id: 28398, cityId: 122, code: "532578" },
    { id: 28399, cityId: 122, code: "532579" },
    { id: 28400, cityId: 122, code: "532581" },
    { id: 28401, cityId: 122, code: "532592" },
    { id: 28402, cityId: 122, code: "532663" },
    { id: 28403, cityId: 123, code: "508116" },
    { id: 28404, cityId: 124, code: "506002" },
    { id: 28405, cityId: 124, code: "506005" },
    { id: 28406, cityId: 124, code: "506007" },
    { id: 28407, cityId: 124, code: "506008" },
    { id: 28408, cityId: 124, code: "506010" },
    { id: 28409, cityId: 124, code: "506012" },
    { id: 28410, cityId: 124, code: "506013" },
    { id: 28411, cityId: 124, code: "506015" },
    { id: 28412, cityId: 124, code: "506105" },
    { id: 28413, cityId: 124, code: "506132" },
    { id: 28414, cityId: 124, code: "506142" },
    { id: 28415, cityId: 124, code: "506143" },
    { id: 28416, cityId: 124, code: "506145" },
    { id: 28417, cityId: 124, code: "506151" },
    { id: 28418, cityId: 124, code: "506163" },
    { id: 28419, cityId: 124, code: "506164" },
    { id: 28420, cityId: 124, code: "506166" },
    { id: 28421, cityId: 124, code: "506172" },
    { id: 28422, cityId: 124, code: "506201" },
    { id: 28423, cityId: 124, code: "506222" },
    { id: 28424, cityId: 124, code: "506224" },
    { id: 28425, cityId: 124, code: "506301" },
    { id: 28426, cityId: 124, code: "506302" },
    { id: 28427, cityId: 124, code: "506314" },
    { id: 28428, cityId: 124, code: "506315" },
    { id: 28429, cityId: 124, code: "506317" },
    { id: 28430, cityId: 124, code: "506330" },
    { id: 28431, cityId: 124, code: "506331" },
    { id: 28432, cityId: 124, code: "506344" },
    { id: 28433, cityId: 124, code: "506347" },
    { id: 28434, cityId: 124, code: "506349" },
    { id: 28435, cityId: 124, code: "506352" },
    { id: 28436, cityId: 124, code: "506367" },
    { id: 28437, cityId: 124, code: "506368" },
    { id: 28438, cityId: 124, code: "506370" },
    { id: 28439, cityId: 124, code: "506381" },
    { id: 28440, cityId: 124, code: "506391" },
    { id: 28441, cityId: 124, code: "534483" },
    { id: 28442, cityId: 124, code: "506001" },
    { id: 28443, cityId: 124, code: "506003" },
    { id: 28444, cityId: 124, code: "506004" },
    { id: 28445, cityId: 124, code: "506006" },
    { id: 28446, cityId: 124, code: "506009" },
    { id: 28447, cityId: 124, code: "506011" },
    { id: 28448, cityId: 124, code: "506101" },
    { id: 28449, cityId: 124, code: "506104" },
    { id: 28450, cityId: 124, code: "506112" },
    { id: 28451, cityId: 124, code: "506122" },
    { id: 28452, cityId: 124, code: "506133" },
    { id: 28453, cityId: 124, code: "506144" },
    { id: 28454, cityId: 124, code: "506165" },
    { id: 28455, cityId: 124, code: "506167" },
    { id: 28456, cityId: 124, code: "506168" },
    { id: 28457, cityId: 124, code: "506221" },
    { id: 28458, cityId: 124, code: "506223" },
    { id: 28459, cityId: 124, code: "506244" },
    { id: 28460, cityId: 124, code: "506252" },
    { id: 28461, cityId: 124, code: "506303" },
    { id: 28462, cityId: 124, code: "506310" },
    { id: 28463, cityId: 124, code: "506313" },
    { id: 28464, cityId: 124, code: "506316" },
    { id: 28465, cityId: 124, code: "506318" },
    { id: 28466, cityId: 124, code: "506319" },
    { id: 28467, cityId: 124, code: "506329" },
    { id: 28468, cityId: 124, code: "506332" },
    { id: 28469, cityId: 124, code: "506342" },
    { id: 28470, cityId: 124, code: "506343" },
    { id: 28471, cityId: 124, code: "506345" },
    { id: 28472, cityId: 124, code: "506348" },
    { id: 28473, cityId: 124, code: "506355" },
    { id: 28474, cityId: 124, code: "506356" },
    { id: 28475, cityId: 124, code: "506366" },
    { id: 28476, cityId: 124, code: "506369" },
    { id: 28477, cityId: 124, code: "506371" },
    { id: 28478, cityId: 124, code: "533277" },
    { id: 28479, cityId: 124, code: "534448" },
    { id: 28480, cityId: 125, code: "533125" },
    { id: 28481, cityId: 125, code: "533409" },
    { id: 28482, cityId: 125, code: "534002" },
    { id: 28483, cityId: 125, code: "534004" },
    { id: 28484, cityId: 125, code: "534005" },
    { id: 28485, cityId: 125, code: "534015" },
    { id: 28486, cityId: 125, code: "534102" },
    { id: 28487, cityId: 125, code: "534108" },
    { id: 28488, cityId: 125, code: "534116" },
    { id: 28489, cityId: 125, code: "534124" },
    { id: 28490, cityId: 125, code: "534126" },
    { id: 28491, cityId: 125, code: "534129" },
    { id: 28492, cityId: 125, code: "534134" },
    { id: 28493, cityId: 125, code: "534137" },
    { id: 28494, cityId: 125, code: "534145" },
    { id: 28495, cityId: 125, code: "534156" },
    { id: 28496, cityId: 125, code: "534160" },
    { id: 28497, cityId: 125, code: "534166" },
    { id: 28498, cityId: 125, code: "534176" },
    { id: 28499, cityId: 125, code: "534195" },
    { id: 28500, cityId: 125, code: "534198" },
    { id: 28501, cityId: 125, code: "534201" },
    { id: 28502, cityId: 125, code: "534203" },
    { id: 28503, cityId: 125, code: "534206" },
    { id: 28504, cityId: 125, code: "534208" },
    { id: 28505, cityId: 125, code: "534211" },
    { id: 28506, cityId: 125, code: "534216" },
    { id: 28507, cityId: 125, code: "534222" },
    { id: 28508, cityId: 125, code: "534227" },
    { id: 28509, cityId: 125, code: "534230" },
    { id: 28510, cityId: 125, code: "534235" },
    { id: 28511, cityId: 125, code: "534237" },
    { id: 28512, cityId: 125, code: "534238" },
    { id: 28513, cityId: 125, code: "534240" },
    { id: 28514, cityId: 125, code: "534243" },
    { id: 28515, cityId: 125, code: "534251" },
    { id: 28516, cityId: 125, code: "534261" },
    { id: 28517, cityId: 125, code: "534266" },
    { id: 28518, cityId: 125, code: "534267" },
    { id: 28519, cityId: 125, code: "534269" },
    { id: 28520, cityId: 125, code: "534272" },
    { id: 28521, cityId: 125, code: "534275" },
    { id: 28522, cityId: 125, code: "534280" },
    { id: 28523, cityId: 125, code: "534291" },
    { id: 28524, cityId: 125, code: "534301" },
    { id: 28525, cityId: 125, code: "534311" },
    { id: 28526, cityId: 125, code: "534312" },
    { id: 28527, cityId: 125, code: "534314" },
    { id: 28528, cityId: 125, code: "534320" },
    { id: 28529, cityId: 125, code: "534327" },
    { id: 28530, cityId: 125, code: "534328" },
    { id: 28531, cityId: 125, code: "534330" },
    { id: 28532, cityId: 125, code: "534341" },
    { id: 28533, cityId: 125, code: "534343" },
    { id: 28534, cityId: 125, code: "534352" },
    { id: 28535, cityId: 125, code: "534362" },
    { id: 28536, cityId: 125, code: "534407" },
    { id: 28537, cityId: 125, code: "534426" },
    { id: 28538, cityId: 125, code: "534449" },
    { id: 28539, cityId: 125, code: "534450" },
    { id: 28540, cityId: 125, code: "534452" },
    { id: 28541, cityId: 125, code: "534460" },
    { id: 28542, cityId: 125, code: "534462" },
    { id: 28543, cityId: 125, code: "534486" },
    { id: 28544, cityId: 125, code: "534001" },
    { id: 28545, cityId: 125, code: "534003" },
    { id: 28546, cityId: 125, code: "534006" },
    { id: 28547, cityId: 125, code: "534101" },
    { id: 28548, cityId: 125, code: "534111" },
    { id: 28549, cityId: 125, code: "534112" },
    { id: 28550, cityId: 125, code: "534122" },
    { id: 28551, cityId: 125, code: "534127" },
    { id: 28552, cityId: 125, code: "534136" },
    { id: 28553, cityId: 125, code: "534146" },
    { id: 28554, cityId: 125, code: "534152" },
    { id: 28555, cityId: 125, code: "534154" },
    { id: 28556, cityId: 125, code: "534186" },
    { id: 28557, cityId: 125, code: "534196" },
    { id: 28558, cityId: 125, code: "534197" },
    { id: 28559, cityId: 125, code: "534202" },
    { id: 28560, cityId: 125, code: "534207" },
    { id: 28561, cityId: 125, code: "534209" },
    { id: 28562, cityId: 125, code: "534215" },
    { id: 28563, cityId: 125, code: "534217" },
    { id: 28564, cityId: 125, code: "534218" },
    { id: 28565, cityId: 125, code: "534225" },
    { id: 28566, cityId: 125, code: "534236" },
    { id: 28567, cityId: 125, code: "534239" },
    { id: 28568, cityId: 125, code: "534244" },
    { id: 28569, cityId: 125, code: "534247" },
    { id: 28570, cityId: 125, code: "534250" },
    { id: 28571, cityId: 125, code: "534260" },
    { id: 28572, cityId: 125, code: "534265" },
    { id: 28573, cityId: 125, code: "534268" },
    { id: 28574, cityId: 125, code: "534271" },
    { id: 28575, cityId: 125, code: "534281" },
    { id: 28576, cityId: 125, code: "534302" },
    { id: 28577, cityId: 125, code: "534303" },
    { id: 28578, cityId: 125, code: "534305" },
    { id: 28579, cityId: 125, code: "534313" },
    { id: 28580, cityId: 125, code: "534315" },
    { id: 28581, cityId: 125, code: "534316" },
    { id: 28582, cityId: 125, code: "534326" },
    { id: 28583, cityId: 125, code: "534331" },
    { id: 28584, cityId: 125, code: "534339" },
    { id: 28585, cityId: 125, code: "534340" },
    { id: 28586, cityId: 125, code: "534342" },
    { id: 28587, cityId: 125, code: "534350" },
    { id: 28588, cityId: 125, code: "534390" },
    { id: 28589, cityId: 125, code: "534392" },
    { id: 28590, cityId: 125, code: "534401" },
    { id: 28591, cityId: 125, code: "534411" },
    { id: 28592, cityId: 125, code: "534416" },
    { id: 28593, cityId: 125, code: "534429" },
    { id: 28594, cityId: 125, code: "534437" },
    { id: 28595, cityId: 125, code: "534451" },
    { id: 28596, cityId: 125, code: "534456" },
    { id: 28597, cityId: 125, code: "534459" },
    { id: 28598, cityId: 125, code: "534461" },
    { id: 28599, cityId: 126, code: "533234" },
    { id: 28600, cityId: 127, code: "507123" },
    { id: 28601, cityId: 128, code: "518360" },
    { id: 28602, cityId: 129, code: "518510" },
    { id: 28603, cityId: 130, code: "502220" },
    { id: 28604, cityId: 131, code: "792051" },
    { id: 28605, cityId: 131, code: "791001" },
    { id: 28606, cityId: 132, code: "791101" },
    { id: 28607, cityId: 133, code: "790001" },
    { id: 28608, cityId: 133, code: "790101" },
    { id: 28609, cityId: 133, code: "790114" },
    { id: 28610, cityId: 133, code: "790002" },
    { id: 28611, cityId: 133, code: "790115" },
    { id: 28612, cityId: 134, code: "792055" },
    { id: 28613, cityId: 135, code: "791122" },
    { id: 28614, cityId: 136, code: "791112" },
    { id: 28615, cityId: 136, code: "791111" },
    { id: 28616, cityId: 137, code: "792121" },
    { id: 28617, cityId: 138, code: "792120" },
    { id: 28618, cityId: 138, code: "792122" },
    { id: 28619, cityId: 138, code: "792055" },
    { id: 28620, cityId: 138, code: "792123" },
    { id: 28621, cityId: 139, code: "792103" },
    { id: 28622, cityId: 140, code: "791103" },
    { id: 28623, cityId: 140, code: "791102" },
    { id: 28624, cityId: 140, code: "791104" },
    { id: 28625, cityId: 141, code: "792110" },
    { id: 28626, cityId: 142, code: "790102" },
    { id: 28627, cityId: 142, code: "790104" },
    { id: 28628, cityId: 142, code: "790103" },
    { id: 28629, cityId: 143, code: "792001" },
    { id: 28630, cityId: 143, code: "792101" },
    { id: 28631, cityId: 143, code: "792104" },
    { id: 28632, cityId: 143, code: "792102" },
    { id: 28633, cityId: 143, code: "792111" },
    { id: 28634, cityId: 144, code: "791002" },
    { id: 28635, cityId: 145, code: "791113" },
    { id: 28636, cityId: 145, code: "791121" },
    { id: 28637, cityId: 145, code: "791111" },
    { id: 28638, cityId: 145, code: "791112" },
    { id: 28639, cityId: 145, code: "791120" },
    { id: 28640, cityId: 146, code: "783384" },
    { id: 28641, cityId: 147, code: "785680" },
    { id: 28642, cityId: 148, code: "788806" },
    { id: 28643, cityId: 149, code: "785602" },
    { id: 28644, cityId: 150, code: "781305" },
    { id: 28645, cityId: 150, code: "781308" },
    { id: 28646, cityId: 150, code: "781314" },
    { id: 28647, cityId: 150, code: "781319" },
    { id: 28648, cityId: 150, code: "781321" },
    { id: 28649, cityId: 150, code: "781327" },
    { id: 28650, cityId: 150, code: "781329" },
    { id: 28651, cityId: 150, code: "781330" },
    { id: 28652, cityId: 150, code: "781301" },
    { id: 28653, cityId: 150, code: "781302" },
    { id: 28654, cityId: 150, code: "781309" },
    { id: 28655, cityId: 150, code: "781315" },
    { id: 28656, cityId: 150, code: "781317" },
    { id: 28657, cityId: 150, code: "781318" },
    { id: 28658, cityId: 150, code: "781326" },
    { id: 28659, cityId: 150, code: "781328" },
    { id: 28660, cityId: 150, code: "781352" },
    { id: 28661, cityId: 151, code: "783372" },
    { id: 28662, cityId: 152, code: "783390" },
    { id: 28663, cityId: 153, code: "782480" },
    { id: 28664, cityId: 154, code: "785014" },
    { id: 28665, cityId: 154, code: "785612" },
    { id: 28666, cityId: 155, code: "783373" },
    { id: 28667, cityId: 155, code: "783386" },
    { id: 28668, cityId: 155, code: "781375" },
    { id: 28669, cityId: 155, code: "783380" },
    { id: 28670, cityId: 156, code: "786184" },
    { id: 28671, cityId: 157, code: "783371" },
    { id: 28672, cityId: 158, code: "785614" },
    { id: 28673, cityId: 159, code: "781133" },
    { id: 28674, cityId: 160, code: "784110" },
    { id: 28675, cityId: 161, code: "785692" },
    { id: 28676, cityId: 161, code: "787057" },
    { id: 28677, cityId: 161, code: "787060" },
    { id: 28678, cityId: 161, code: "786110" },
    { id: 28679, cityId: 162, code: "782123" },
    { id: 28680, cityId: 163, code: "783334" },
    { id: 28681, cityId: 163, code: "783335" },
    { id: 28682, cityId: 163, code: "783126" },
    { id: 28683, cityId: 163, code: "783127" },
    { id: 28684, cityId: 163, code: "783301" },
    { id: 28685, cityId: 163, code: "783330" },
    { id: 28686, cityId: 163, code: "783331" },
    { id: 28687, cityId: 163, code: "783338" },
    { id: 28688, cityId: 163, code: "783339" },
    { id: 28689, cityId: 163, code: "783344" },
    { id: 28690, cityId: 163, code: "783349" },
    { id: 28691, cityId: 164, code: "785011" },
    { id: 28692, cityId: 164, code: "785676" },
    { id: 28693, cityId: 164, code: "786002" },
    { id: 28694, cityId: 164, code: "786004" },
    { id: 28695, cityId: 164, code: "786005" },
    { id: 28696, cityId: 164, code: "786007" },
    { id: 28697, cityId: 164, code: "786010" },
    { id: 28698, cityId: 164, code: "786012" },
    { id: 28699, cityId: 164, code: "786052" },
    { id: 28700, cityId: 164, code: "786102" },
    { id: 28701, cityId: 164, code: "786145" },
    { id: 28702, cityId: 164, code: "786147" },
    { id: 28703, cityId: 164, code: "786148" },
    { id: 28704, cityId: 164, code: "786150" },
    { id: 28705, cityId: 164, code: "786153" },
    { id: 28706, cityId: 164, code: "786155" },
    { id: 28707, cityId: 164, code: "786158" },
    { id: 28708, cityId: 164, code: "786171" },
    { id: 28709, cityId: 164, code: "786172" },
    { id: 28710, cityId: 164, code: "786180" },
    { id: 28711, cityId: 164, code: "786182" },
    { id: 28712, cityId: 164, code: "786185" },
    { id: 28713, cityId: 164, code: "786601" },
    { id: 28714, cityId: 164, code: "786611" },
    { id: 28715, cityId: 164, code: "786612" },
    { id: 28716, cityId: 164, code: "786614" },
    { id: 28717, cityId: 164, code: "786622" },
    { id: 28718, cityId: 164, code: "786624" },
    { id: 28719, cityId: 164, code: "786630" },
    { id: 28720, cityId: 164, code: "785015" },
    { id: 28721, cityId: 164, code: "785675" },
    { id: 28722, cityId: 164, code: "785701" },
    { id: 28723, cityId: 164, code: "786001" },
    { id: 28724, cityId: 164, code: "786003" },
    { id: 28725, cityId: 164, code: "786008" },
    { id: 28726, cityId: 164, code: "786053" },
    { id: 28727, cityId: 164, code: "786054" },
    { id: 28728, cityId: 164, code: "786101" },
    { id: 28729, cityId: 164, code: "786125" },
    { id: 28730, cityId: 164, code: "786146" },
    { id: 28731, cityId: 164, code: "786151" },
    { id: 28732, cityId: 164, code: "786152" },
    { id: 28733, cityId: 164, code: "786154" },
    { id: 28734, cityId: 164, code: "786157" },
    { id: 28735, cityId: 164, code: "786159" },
    { id: 28736, cityId: 164, code: "786170" },
    { id: 28737, cityId: 164, code: "786173" },
    { id: 28738, cityId: 164, code: "786183" },
    { id: 28739, cityId: 164, code: "786602" },
    { id: 28740, cityId: 164, code: "786610" },
    { id: 28741, cityId: 164, code: "786613" },
    { id: 28742, cityId: 164, code: "786615" },
    { id: 28743, cityId: 164, code: "786616" },
    { id: 28744, cityId: 164, code: "786623" },
    { id: 28745, cityId: 164, code: "786631" },
    { id: 28746, cityId: 165, code: "786171" },
    { id: 28747, cityId: 166, code: "782448" },
    { id: 28748, cityId: 166, code: "782461" },
    { id: 28749, cityId: 166, code: "782470" },
    { id: 28750, cityId: 166, code: "782475" },
    { id: 28751, cityId: 166, code: "782485" },
    { id: 28752, cityId: 166, code: "782450" },
    { id: 28753, cityId: 166, code: "782460" },
    { id: 28754, cityId: 166, code: "782482" },
    { id: 28755, cityId: 167, code: "783121" },
    { id: 28756, cityId: 167, code: "783124" },
    { id: 28757, cityId: 167, code: "783129" },
    { id: 28758, cityId: 167, code: "783132" },
    { id: 28759, cityId: 167, code: "783134" },
    { id: 28760, cityId: 167, code: "783383" },
    { id: 28761, cityId: 167, code: "783389" },
    { id: 28762, cityId: 167, code: "783101" },
    { id: 28763, cityId: 167, code: "783120" },
    { id: 28764, cityId: 167, code: "783122" },
    { id: 28765, cityId: 167, code: "783123" },
    { id: 28766, cityId: 167, code: "783125" },
    { id: 28767, cityId: 167, code: "783130" },
    { id: 28768, cityId: 167, code: "783133" },
    { id: 28769, cityId: 167, code: "783382" },
    { id: 28770, cityId: 168, code: "784168" },
    { id: 28771, cityId: 169, code: "785112" },
    { id: 28772, cityId: 169, code: "785621" },
    { id: 28773, cityId: 169, code: "782470" },
    { id: 28774, cityId: 169, code: "785614" },
    { id: 28775, cityId: 169, code: "785694" },
    { id: 28776, cityId: 170, code: "781005" },
    { id: 28777, cityId: 170, code: "781007" },
    { id: 28778, cityId: 170, code: "781008" },
    { id: 28779, cityId: 170, code: "781010" },
    { id: 28780, cityId: 170, code: "781013" },
    { id: 28781, cityId: 170, code: "781015" },
    { id: 28782, cityId: 170, code: "781016" },
    { id: 28783, cityId: 170, code: "781018" },
    { id: 28784, cityId: 170, code: "781020" },
    { id: 28785, cityId: 170, code: "781021" },
    { id: 28786, cityId: 170, code: "781023" },
    { id: 28787, cityId: 170, code: "781026" },
    { id: 28788, cityId: 170, code: "781028" },
    { id: 28789, cityId: 170, code: "781031" },
    { id: 28790, cityId: 170, code: "781037" },
    { id: 28791, cityId: 170, code: "781103" },
    { id: 28792, cityId: 170, code: "781121" },
    { id: 28793, cityId: 170, code: "781124" },
    { id: 28794, cityId: 170, code: "781127" },
    { id: 28795, cityId: 170, code: "781129" },
    { id: 28796, cityId: 170, code: "781132" },
    { id: 28797, cityId: 170, code: "781134" },
    { id: 28798, cityId: 170, code: "781135" },
    { id: 28799, cityId: 170, code: "781150" },
    { id: 28800, cityId: 170, code: "781171" },
    { id: 28801, cityId: 170, code: "781320" },
    { id: 28802, cityId: 170, code: "781365" },
    { id: 28803, cityId: 170, code: "781381" },
    { id: 28804, cityId: 170, code: "782401" },
    { id: 28805, cityId: 170, code: "782403" },
    { id: 28806, cityId: 170, code: "785688" },
    { id: 28807, cityId: 170, code: "781001" },
    { id: 28808, cityId: 170, code: "781003" },
    { id: 28809, cityId: 170, code: "781004" },
    { id: 28810, cityId: 170, code: "781006" },
    { id: 28811, cityId: 170, code: "781009" },
    { id: 28812, cityId: 170, code: "781011" },
    { id: 28813, cityId: 170, code: "781012" },
    { id: 28814, cityId: 170, code: "781014" },
    { id: 28815, cityId: 170, code: "781017" },
    { id: 28816, cityId: 170, code: "781019" },
    { id: 28817, cityId: 170, code: "781022" },
    { id: 28818, cityId: 170, code: "781025" },
    { id: 28819, cityId: 170, code: "781027" },
    { id: 28820, cityId: 170, code: "781101" },
    { id: 28821, cityId: 170, code: "781102" },
    { id: 28822, cityId: 170, code: "781120" },
    { id: 28823, cityId: 170, code: "781122" },
    { id: 28824, cityId: 170, code: "781123" },
    { id: 28825, cityId: 170, code: "781125" },
    { id: 28826, cityId: 170, code: "781130" },
    { id: 28827, cityId: 170, code: "781131" },
    { id: 28828, cityId: 170, code: "781136" },
    { id: 28829, cityId: 170, code: "781351" },
    { id: 28830, cityId: 170, code: "781364" },
    { id: 28831, cityId: 170, code: "781366" },
    { id: 28832, cityId: 170, code: "781380" },
    { id: 28833, cityId: 170, code: "781382" },
    { id: 28834, cityId: 170, code: "781385" },
    { id: 28835, cityId: 170, code: "782402" },
    { id: 28836, cityId: 171, code: "788818" },
    { id: 28837, cityId: 171, code: "788819" },
    { id: 28838, cityId: 171, code: "788832" },
    { id: 28839, cityId: 171, code: "788834" },
    { id: 28840, cityId: 172, code: "788151" },
    { id: 28841, cityId: 173, code: "785101" },
    { id: 28842, cityId: 174, code: "782486" },
    { id: 28843, cityId: 175, code: "782435" },
    { id: 28844, cityId: 176, code: "781316" },
    { id: 28845, cityId: 177, code: "782481" },
    { id: 28846, cityId: 178, code: "785001" },
    { id: 28847, cityId: 178, code: "785004" },
    { id: 28848, cityId: 178, code: "785006" },
    { id: 28849, cityId: 178, code: "785007" },
    { id: 28850, cityId: 178, code: "785102" },
    { id: 28851, cityId: 178, code: "785104" },
    { id: 28852, cityId: 178, code: "785105" },
    { id: 28853, cityId: 178, code: "785107" },
    { id: 28854, cityId: 178, code: "785110" },
    { id: 28855, cityId: 178, code: "785113" },
    { id: 28856, cityId: 178, code: "785603" },
    { id: 28857, cityId: 178, code: "785610" },
    { id: 28858, cityId: 178, code: "785611" },
    { id: 28859, cityId: 178, code: "785616" },
    { id: 28860, cityId: 178, code: "785618" },
    { id: 28861, cityId: 178, code: "785619" },
    { id: 28862, cityId: 178, code: "785626" },
    { id: 28863, cityId: 178, code: "785632" },
    { id: 28864, cityId: 178, code: "785005" },
    { id: 28865, cityId: 178, code: "785008" },
    { id: 28866, cityId: 178, code: "785013" },
    { id: 28867, cityId: 178, code: "785106" },
    { id: 28868, cityId: 178, code: "785108" },
    { id: 28869, cityId: 178, code: "785109" },
    { id: 28870, cityId: 178, code: "785615" },
    { id: 28871, cityId: 178, code: "785617" },
    { id: 28872, cityId: 178, code: "785622" },
    { id: 28873, cityId: 178, code: "785625" },
    { id: 28874, cityId: 178, code: "785630" },
    { id: 28875, cityId: 178, code: "785631" },
    { id: 28876, cityId: 178, code: "785636" },
    { id: 28877, cityId: 178, code: "785681" },
    { id: 28878, cityId: 179, code: "786186" },
    { id: 28879, cityId: 180, code: "788145" },
    { id: 28880, cityId: 180, code: "788166" },
    { id: 28881, cityId: 180, code: "788701" },
    { id: 28882, cityId: 180, code: "788706" },
    { id: 28883, cityId: 180, code: "788711" },
    { id: 28884, cityId: 180, code: "788719" },
    { id: 28885, cityId: 180, code: "788720" },
    { id: 28886, cityId: 180, code: "788722" },
    { id: 28887, cityId: 180, code: "788725" },
    { id: 28888, cityId: 180, code: "788727" },
    { id: 28889, cityId: 180, code: "788733" },
    { id: 28890, cityId: 180, code: "788735" },
    { id: 28891, cityId: 180, code: "788736" },
    { id: 28892, cityId: 180, code: "788781" },
    { id: 28893, cityId: 180, code: "788702" },
    { id: 28894, cityId: 180, code: "788705" },
    { id: 28895, cityId: 180, code: "788708" },
    { id: 28896, cityId: 180, code: "788710" },
    { id: 28897, cityId: 180, code: "788716" },
    { id: 28898, cityId: 180, code: "788721" },
    { id: 28899, cityId: 180, code: "788723" },
    { id: 28900, cityId: 180, code: "788724" },
    { id: 28901, cityId: 180, code: "788726" },
    { id: 28902, cityId: 180, code: "788729" },
    { id: 28903, cityId: 180, code: "788734" },
    { id: 28904, cityId: 180, code: "788737" },
    { id: 28905, cityId: 180, code: "788740" },
    { id: 28906, cityId: 180, code: "788790" },
    { id: 28907, cityId: 180, code: "788803" },
    { id: 28908, cityId: 181, code: "783325" },
    { id: 28909, cityId: 181, code: "783332" },
    { id: 28910, cityId: 181, code: "783333" },
    { id: 28911, cityId: 181, code: "783346" },
    { id: 28912, cityId: 181, code: "783351" },
    { id: 28913, cityId: 181, code: "783361" },
    { id: 28914, cityId: 181, code: "783362" },
    { id: 28915, cityId: 181, code: "783370" },
    { id: 28916, cityId: 181, code: "783385" },
    { id: 28917, cityId: 181, code: "783388" },
    { id: 28918, cityId: 181, code: "783391" },
    { id: 28919, cityId: 181, code: "783345" },
    { id: 28920, cityId: 181, code: "783347" },
    { id: 28921, cityId: 181, code: "783350" },
    { id: 28922, cityId: 181, code: "783360" },
    { id: 28923, cityId: 181, code: "783374" },
    { id: 28924, cityId: 181, code: "783381" },
    { id: 28925, cityId: 181, code: "783387" },
    { id: 28926, cityId: 181, code: "783392" },
    { id: 28927, cityId: 182, code: "788103" },
    { id: 28928, cityId: 183, code: "788163" },
    { id: 28929, cityId: 184, code: "782446" },
    { id: 28930, cityId: 185, code: "782447" },
    { id: 28931, cityId: 186, code: "788830" },
    { id: 28932, cityId: 187, code: "788831" },
    { id: 28933, cityId: 188, code: "784115" },
    { id: 28934, cityId: 188, code: "784117" },
    { id: 28935, cityId: 188, code: "784125" },
    { id: 28936, cityId: 188, code: "784144" },
    { id: 28937, cityId: 188, code: "784147" },
    { id: 28938, cityId: 188, code: "784507" },
    { id: 28939, cityId: 188, code: "784514" },
    { id: 28940, cityId: 188, code: "784522" },
    { id: 28941, cityId: 188, code: "784523" },
    { id: 28942, cityId: 188, code: "784525" },
    { id: 28943, cityId: 188, code: "784111" },
    { id: 28944, cityId: 188, code: "784113" },
    { id: 28945, cityId: 188, code: "784116" },
    { id: 28946, cityId: 188, code: "784145" },
    { id: 28947, cityId: 188, code: "784508" },
    { id: 28948, cityId: 188, code: "784510" },
    { id: 28949, cityId: 188, code: "784513" },
    { id: 28950, cityId: 188, code: "784524" },
    { id: 28951, cityId: 188, code: "784526" },
    { id: 28952, cityId: 188, code: "784527" },
    { id: 28953, cityId: 189, code: "783131" },
    { id: 28954, cityId: 190, code: "786181" },
    { id: 28955, cityId: 191, code: "785634" },
    { id: 28956, cityId: 192, code: "782108" },
    { id: 28957, cityId: 192, code: "782121" },
    { id: 28958, cityId: 192, code: "782105" },
    { id: 28959, cityId: 193, code: "785670" },
    { id: 28960, cityId: 194, code: "782001" },
    { id: 28961, cityId: 194, code: "782101" },
    { id: 28962, cityId: 194, code: "782104" },
    { id: 28963, cityId: 194, code: "782107" },
    { id: 28964, cityId: 194, code: "782120" },
    { id: 28965, cityId: 194, code: "782122" },
    { id: 28966, cityId: 194, code: "782125" },
    { id: 28967, cityId: 194, code: "782127" },
    { id: 28968, cityId: 194, code: "782130" },
    { id: 28969, cityId: 194, code: "782135" },
    { id: 28970, cityId: 194, code: "782136" },
    { id: 28971, cityId: 194, code: "782138" },
    { id: 28972, cityId: 194, code: "782141" },
    { id: 28973, cityId: 194, code: "782143" },
    { id: 28974, cityId: 194, code: "782411" },
    { id: 28975, cityId: 194, code: "782427" },
    { id: 28976, cityId: 194, code: "782435" },
    { id: 28977, cityId: 194, code: "782440" },
    { id: 28978, cityId: 194, code: "782445" },
    { id: 28979, cityId: 194, code: "782002" },
    { id: 28980, cityId: 194, code: "782010" },
    { id: 28981, cityId: 194, code: "782102" },
    { id: 28982, cityId: 194, code: "782103" },
    { id: 28983, cityId: 194, code: "782108" },
    { id: 28984, cityId: 194, code: "782121" },
    { id: 28985, cityId: 194, code: "782124" },
    { id: 28986, cityId: 194, code: "782126" },
    { id: 28987, cityId: 194, code: "782137" },
    { id: 28988, cityId: 194, code: "782139" },
    { id: 28989, cityId: 194, code: "782140" },
    { id: 28990, cityId: 194, code: "782142" },
    { id: 28991, cityId: 194, code: "782410" },
    { id: 28992, cityId: 194, code: "782412" },
    { id: 28993, cityId: 194, code: "782425" },
    { id: 28994, cityId: 194, code: "782426" },
    { id: 28995, cityId: 194, code: "782428" },
    { id: 28996, cityId: 194, code: "782439" },
    { id: 28997, cityId: 194, code: "782447" },
    { id: 28998, cityId: 195, code: "781304" },
    { id: 28999, cityId: 195, code: "781310" },
    { id: 29000, cityId: 195, code: "781336" },
    { id: 29001, cityId: 195, code: "781338" },
    { id: 29002, cityId: 195, code: "781339" },
    { id: 29003, cityId: 195, code: "781346" },
    { id: 29004, cityId: 195, code: "781347" },
    { id: 29005, cityId: 195, code: "781349" },
    { id: 29006, cityId: 195, code: "781360" },
    { id: 29007, cityId: 195, code: "781368" },
    { id: 29008, cityId: 195, code: "781370" },
    { id: 29009, cityId: 195, code: "781373" },
    { id: 29010, cityId: 195, code: "781376" },
    { id: 29011, cityId: 195, code: "781378" },
    { id: 29012, cityId: 195, code: "781126" },
    { id: 29013, cityId: 195, code: "781303" },
    { id: 29014, cityId: 195, code: "781306" },
    { id: 29015, cityId: 195, code: "781335" },
    { id: 29016, cityId: 195, code: "781337" },
    { id: 29017, cityId: 195, code: "781345" },
    { id: 29018, cityId: 195, code: "781348" },
    { id: 29019, cityId: 195, code: "781350" },
    { id: 29020, cityId: 195, code: "781353" },
    { id: 29021, cityId: 195, code: "781367" },
    { id: 29022, cityId: 195, code: "781369" },
    { id: 29023, cityId: 195, code: "781372" },
    { id: 29024, cityId: 195, code: "781374" },
    { id: 29025, cityId: 195, code: "781377" },
    { id: 29026, cityId: 196, code: "786621" },
    { id: 29027, cityId: 197, code: "785613" },
    { id: 29028, cityId: 198, code: "785685" },
    { id: 29029, cityId: 199, code: "781030" },
    { id: 29030, cityId: 200, code: "784160" },
    { id: 29031, cityId: 200, code: "784162" },
    { id: 29032, cityId: 200, code: "784165" },
    { id: 29033, cityId: 200, code: "786103" },
    { id: 29034, cityId: 200, code: "787028" },
    { id: 29035, cityId: 200, code: "787052" },
    { id: 29036, cityId: 200, code: "787055" },
    { id: 29037, cityId: 200, code: "787058" },
    { id: 29038, cityId: 200, code: "784161" },
    { id: 29039, cityId: 200, code: "784163" },
    { id: 29040, cityId: 200, code: "787001" },
    { id: 29041, cityId: 200, code: "787029" },
    { id: 29042, cityId: 200, code: "787030" },
    { id: 29043, cityId: 200, code: "787032" },
    { id: 29044, cityId: 200, code: "787051" },
    { id: 29045, cityId: 200, code: "787053" },
    { id: 29046, cityId: 200, code: "787054" },
    { id: 29047, cityId: 200, code: "787056" },
    { id: 29048, cityId: 201, code: "781128" },
    { id: 29049, cityId: 202, code: "781325" },
    { id: 29050, cityId: 203, code: "784505" },
    { id: 29051, cityId: 204, code: "781354" },
    { id: 29052, cityId: 205, code: "783337" },
    { id: 29053, cityId: 206, code: "781307" },
    { id: 29054, cityId: 207, code: "785601" },
    { id: 29055, cityId: 208, code: "785010" },
    { id: 29056, cityId: 208, code: "785103" },
    { id: 29057, cityId: 208, code: "785111" },
    { id: 29058, cityId: 208, code: "785635" },
    { id: 29059, cityId: 208, code: "785640" },
    { id: 29060, cityId: 208, code: "785661" },
    { id: 29061, cityId: 208, code: "785664" },
    { id: 29062, cityId: 208, code: "785666" },
    { id: 29063, cityId: 208, code: "785667" },
    { id: 29064, cityId: 208, code: "785669" },
    { id: 29065, cityId: 208, code: "785672" },
    { id: 29066, cityId: 208, code: "785674" },
    { id: 29067, cityId: 208, code: "785682" },
    { id: 29068, cityId: 208, code: "785683" },
    { id: 29069, cityId: 208, code: "785693" },
    { id: 29070, cityId: 208, code: "785696" },
    { id: 29071, cityId: 208, code: "785604" },
    { id: 29072, cityId: 208, code: "785620" },
    { id: 29073, cityId: 208, code: "785633" },
    { id: 29074, cityId: 208, code: "785660" },
    { id: 29075, cityId: 208, code: "785662" },
    { id: 29076, cityId: 208, code: "785663" },
    { id: 29077, cityId: 208, code: "785665" },
    { id: 29078, cityId: 208, code: "785668" },
    { id: 29079, cityId: 208, code: "785671" },
    { id: 29080, cityId: 208, code: "785673" },
    { id: 29081, cityId: 208, code: "785684" },
    { id: 29082, cityId: 208, code: "785686" },
    { id: 29083, cityId: 208, code: "785687" },
    { id: 29084, cityId: 208, code: "785689" },
    { id: 29085, cityId: 208, code: "785695" },
    { id: 29086, cityId: 209, code: "787059" },
    { id: 29087, cityId: 210, code: "788001" },
    { id: 29088, cityId: 210, code: "788003" },
    { id: 29089, cityId: 210, code: "788004" },
    { id: 29090, cityId: 210, code: "788006" },
    { id: 29091, cityId: 210, code: "788009" },
    { id: 29092, cityId: 210, code: "788011" },
    { id: 29093, cityId: 210, code: "788014" },
    { id: 29094, cityId: 210, code: "788019" },
    { id: 29095, cityId: 210, code: "788025" },
    { id: 29096, cityId: 210, code: "788030" },
    { id: 29097, cityId: 210, code: "788099" },
    { id: 29098, cityId: 210, code: "788101" },
    { id: 29099, cityId: 210, code: "788102" },
    { id: 29100, cityId: 210, code: "788104" },
    { id: 29101, cityId: 210, code: "788107" },
    { id: 29102, cityId: 210, code: "788109" },
    { id: 29103, cityId: 210, code: "788110" },
    { id: 29104, cityId: 210, code: "788112" },
    { id: 29105, cityId: 210, code: "788115" },
    { id: 29106, cityId: 210, code: "788117" },
    { id: 29107, cityId: 210, code: "788120" },
    { id: 29108, cityId: 210, code: "788123" },
    { id: 29109, cityId: 210, code: "788125" },
    { id: 29110, cityId: 210, code: "788126" },
    { id: 29111, cityId: 210, code: "788152" },
    { id: 29112, cityId: 210, code: "788155" },
    { id: 29113, cityId: 210, code: "788160" },
    { id: 29114, cityId: 210, code: "788162" },
    { id: 29115, cityId: 210, code: "788165" },
    { id: 29116, cityId: 210, code: "788801" },
    { id: 29117, cityId: 210, code: "788812" },
    { id: 29118, cityId: 210, code: "788814" },
    { id: 29119, cityId: 210, code: "788817" },
    { id: 29120, cityId: 210, code: "788002" },
    { id: 29121, cityId: 210, code: "788005" },
    { id: 29122, cityId: 210, code: "788007" },
    { id: 29123, cityId: 210, code: "788010" },
    { id: 29124, cityId: 210, code: "788013" },
    { id: 29125, cityId: 210, code: "788015" },
    { id: 29126, cityId: 210, code: "788098" },
    { id: 29127, cityId: 210, code: "788106" },
    { id: 29128, cityId: 210, code: "788108" },
    { id: 29129, cityId: 210, code: "788111" },
    { id: 29130, cityId: 210, code: "788113" },
    { id: 29131, cityId: 210, code: "788114" },
    { id: 29132, cityId: 210, code: "788116" },
    { id: 29133, cityId: 210, code: "788119" },
    { id: 29134, cityId: 210, code: "788121" },
    { id: 29135, cityId: 210, code: "788122" },
    { id: 29136, cityId: 210, code: "788124" },
    { id: 29137, cityId: 210, code: "788150" },
    { id: 29138, cityId: 210, code: "788156" },
    { id: 29139, cityId: 210, code: "788161" },
    { id: 29140, cityId: 210, code: "788164" },
    { id: 29141, cityId: 210, code: "788167" },
    { id: 29142, cityId: 210, code: "788169" },
    { id: 29143, cityId: 210, code: "788731" },
    { id: 29144, cityId: 210, code: "788802" },
    { id: 29145, cityId: 210, code: "788805" },
    { id: 29146, cityId: 210, code: "788808" },
    { id: 29147, cityId: 210, code: "788815" },
    { id: 29148, cityId: 210, code: "788816" },
    { id: 29149, cityId: 211, code: "785690" },
    { id: 29150, cityId: 212, code: "784521" },
    { id: 29151, cityId: 213, code: "784001" },
    { id: 29152, cityId: 213, code: "784025" },
    { id: 29153, cityId: 213, code: "784101" },
    { id: 29154, cityId: 213, code: "784102" },
    { id: 29155, cityId: 213, code: "784104" },
    { id: 29156, cityId: 213, code: "784112" },
    { id: 29157, cityId: 213, code: "784118" },
    { id: 29158, cityId: 213, code: "784120" },
    { id: 29159, cityId: 213, code: "784149" },
    { id: 29160, cityId: 213, code: "784152" },
    { id: 29161, cityId: 213, code: "784154" },
    { id: 29162, cityId: 213, code: "784170" },
    { id: 29163, cityId: 213, code: "784171" },
    { id: 29164, cityId: 213, code: "784173" },
    { id: 29165, cityId: 213, code: "784176" },
    { id: 29166, cityId: 213, code: "784178" },
    { id: 29167, cityId: 213, code: "784179" },
    { id: 29168, cityId: 213, code: "784181" },
    { id: 29169, cityId: 213, code: "784184" },
    { id: 29170, cityId: 213, code: "784189" },
    { id: 29171, cityId: 213, code: "784502" },
    { id: 29172, cityId: 213, code: "784504" },
    { id: 29173, cityId: 213, code: "783348" },
    { id: 29174, cityId: 213, code: "784103" },
    { id: 29175, cityId: 213, code: "784119" },
    { id: 29176, cityId: 213, code: "784150" },
    { id: 29177, cityId: 213, code: "784151" },
    { id: 29178, cityId: 213, code: "784164" },
    { id: 29179, cityId: 213, code: "784166" },
    { id: 29180, cityId: 213, code: "784167" },
    { id: 29181, cityId: 213, code: "784172" },
    { id: 29182, cityId: 213, code: "784174" },
    { id: 29183, cityId: 213, code: "784175" },
    { id: 29184, cityId: 213, code: "784177" },
    { id: 29185, cityId: 213, code: "784180" },
    { id: 29186, cityId: 213, code: "784182" },
    { id: 29187, cityId: 213, code: "784183" },
    { id: 29188, cityId: 213, code: "784185" },
    { id: 29189, cityId: 213, code: "784503" },
    { id: 29190, cityId: 213, code: "784506" },
    { id: 29191, cityId: 213, code: "785009" },
    { id: 29192, cityId: 214, code: "781371" },
    { id: 29193, cityId: 215, code: "786125" },
    { id: 29194, cityId: 215, code: "786151" },
    { id: 29195, cityId: 215, code: "786155" },
    { id: 29196, cityId: 215, code: "786181" },
    { id: 29197, cityId: 216, code: "784509" },
    { id: 29198, cityId: 217, code: "854102" },
    { id: 29199, cityId: 217, code: "854103" },
    { id: 29200, cityId: 217, code: "854105" },
    { id: 29201, cityId: 217, code: "854108" },
    { id: 29202, cityId: 217, code: "854113" },
    { id: 29203, cityId: 217, code: "854116" },
    { id: 29204, cityId: 217, code: "854118" },
    { id: 29205, cityId: 217, code: "854121" },
    { id: 29206, cityId: 217, code: "854123" },
    { id: 29207, cityId: 217, code: "854124" },
    { id: 29208, cityId: 217, code: "854317" },
    { id: 29209, cityId: 217, code: "855114" },
    { id: 29210, cityId: 217, code: "854101" },
    { id: 29211, cityId: 217, code: "854104" },
    { id: 29212, cityId: 217, code: "854106" },
    { id: 29213, cityId: 217, code: "854107" },
    { id: 29214, cityId: 217, code: "854115" },
    { id: 29215, cityId: 217, code: "854117" },
    { id: 29216, cityId: 217, code: "854119" },
    { id: 29217, cityId: 217, code: "854120" },
    { id: 29218, cityId: 217, code: "854122" },
    { id: 29219, cityId: 217, code: "854125" },
    { id: 29220, cityId: 217, code: "855105" },
    { id: 29221, cityId: 217, code: "855113" },
    { id: 29222, cityId: 217, code: "855124" },
    { id: 29223, cityId: 218, code: "804419" },
    { id: 29224, cityId: 219, code: "845304" },
    { id: 29229, cityId: 220, code: "804418" },
    { id: 29235, cityId: 221, code: "845513" },
    { id: 29236, cityId: 222, code: "804421" },
    { id: 29237, cityId: 223, code: "224122" },
    { id: 29238, cityId: 223, code: "209101" },
    { id: 29239, cityId: 223, code: "845513" },
    { id: 29240, cityId: 224, code: "813101" },
    { id: 29241, cityId: 225, code: "845304" },
    { id: 29242, cityId: 226, code: "843120" },
    { id: 29243, cityId: 226, code: "848134" },
    { id: 29244, cityId: 226, code: "854311" },
    { id: 29245, cityId: 226, code: "851216" },
    { id: 29246, cityId: 226, code: "854312" },
    { id: 29247, cityId: 227, code: "845411" },
    { id: 29248, cityId: 228, code: "801119" },
    { id: 29249, cityId: 228, code: "802101" },
    { id: 29250, cityId: 228, code: "802112" },
    { id: 29251, cityId: 228, code: "802114" },
    { id: 29252, cityId: 228, code: "802115" },
    { id: 29253, cityId: 228, code: "802117" },
    { id: 29254, cityId: 228, code: "802120" },
    { id: 29255, cityId: 228, code: "802123" },
    { id: 29256, cityId: 228, code: "802125" },
    { id: 29257, cityId: 228, code: "802128" },
    { id: 29258, cityId: 228, code: "802130" },
    { id: 29259, cityId: 228, code: "802131" },
    { id: 29260, cityId: 228, code: "802133" },
    { id: 29261, cityId: 228, code: "802136" },
    { id: 29262, cityId: 228, code: "802151" },
    { id: 29263, cityId: 228, code: "802152" },
    { id: 29264, cityId: 228, code: "802154" },
    { id: 29265, cityId: 228, code: "802157" },
    { id: 29266, cityId: 228, code: "802159" },
    { id: 29267, cityId: 228, code: "802162" },
    { id: 29268, cityId: 228, code: "802165" },
    { id: 29269, cityId: 228, code: "802173" },
    { id: 29270, cityId: 228, code: "802178" },
    { id: 29271, cityId: 228, code: "802183" },
    { id: 29272, cityId: 228, code: "802202" },
    { id: 29273, cityId: 228, code: "802204" },
    { id: 29274, cityId: 228, code: "802205" },
    { id: 29275, cityId: 228, code: "802210" },
    { id: 29276, cityId: 228, code: "802223" },
    { id: 29277, cityId: 228, code: "802231" },
    { id: 29278, cityId: 228, code: "802237" },
    { id: 29279, cityId: 228, code: "802311" },
    { id: 29280, cityId: 228, code: "802313" },
    { id: 29281, cityId: 228, code: "802316" },
    { id: 29282, cityId: 228, code: "802318" },
    { id: 29283, cityId: 228, code: "802111" },
    { id: 29284, cityId: 228, code: "802113" },
    { id: 29285, cityId: 228, code: "802116" },
    { id: 29286, cityId: 228, code: "802118" },
    { id: 29287, cityId: 228, code: "802126" },
    { id: 29288, cityId: 228, code: "802127" },
    { id: 29289, cityId: 228, code: "802129" },
    { id: 29290, cityId: 228, code: "802135" },
    { id: 29291, cityId: 228, code: "802155" },
    { id: 29292, cityId: 228, code: "802156" },
    { id: 29293, cityId: 228, code: "802158" },
    { id: 29294, cityId: 228, code: "802161" },
    { id: 29295, cityId: 228, code: "802163" },
    { id: 29296, cityId: 228, code: "802164" },
    { id: 29297, cityId: 228, code: "802166" },
    { id: 29298, cityId: 228, code: "802169" },
    { id: 29299, cityId: 228, code: "802171" },
    { id: 29300, cityId: 228, code: "802172" },
    { id: 29301, cityId: 228, code: "802174" },
    { id: 29302, cityId: 228, code: "802201" },
    { id: 29303, cityId: 228, code: "802203" },
    { id: 29304, cityId: 228, code: "802206" },
    { id: 29305, cityId: 228, code: "802208" },
    { id: 29306, cityId: 228, code: "802209" },
    { id: 29307, cityId: 228, code: "802222" },
    { id: 29308, cityId: 228, code: "802225" },
    { id: 29309, cityId: 228, code: "802230" },
    { id: 29310, cityId: 228, code: "802301" },
    { id: 29311, cityId: 228, code: "802312" },
    { id: 29312, cityId: 228, code: "802314" },
    { id: 29313, cityId: 228, code: "802315" },
    { id: 29314, cityId: 228, code: "802317" },
    { id: 29315, cityId: 229, code: "813201" },
    { id: 29316, cityId: 230, code: "221001" },
    { id: 29317, cityId: 230, code: "245401" },
    { id: 29318, cityId: 230, code: "261403" },
    { id: 29319, cityId: 230, code: "415570" },
    { id: 29320, cityId: 230, code: "423702" },
    { id: 29321, cityId: 230, code: "431002" },
    { id: 29322, cityId: 230, code: "431005" },
    { id: 29323, cityId: 230, code: "431105" },
    { id: 29324, cityId: 230, code: "431108" },
    { id: 29325, cityId: 230, code: "431111" },
    { id: 29326, cityId: 230, code: "431116" },
    { id: 29327, cityId: 230, code: "431119" },
    { id: 29328, cityId: 230, code: "431121" },
    { id: 29329, cityId: 230, code: "431137" },
    { id: 29330, cityId: 230, code: "431138" },
    { id: 29331, cityId: 230, code: "431140" },
    { id: 29332, cityId: 230, code: "431148" },
    { id: 29333, cityId: 230, code: "431201" },
    { id: 29334, cityId: 230, code: "431212" },
    { id: 29335, cityId: 230, code: "431402" },
    { id: 29336, cityId: 230, code: "742201" },
    { id: 29337, cityId: 230, code: "814133" },
    { id: 29338, cityId: 230, code: "814141" },
    { id: 29339, cityId: 230, code: "814154" },
    { id: 29340, cityId: 230, code: "814165" },
    { id: 29341, cityId: 230, code: "824102" },
    { id: 29342, cityId: 230, code: "824113" },
    { id: 29343, cityId: 230, code: "824115" },
    { id: 29344, cityId: 230, code: "824121" },
    { id: 29345, cityId: 230, code: "824123" },
    { id: 29346, cityId: 230, code: "824124" },
    { id: 29347, cityId: 230, code: "824126" },
    { id: 29348, cityId: 230, code: "824129" },
    { id: 29349, cityId: 230, code: "824203" },
    { id: 29350, cityId: 230, code: "824211" },
    { id: 29351, cityId: 230, code: "824216" },
    { id: 29352, cityId: 230, code: "824303" },
    { id: 29353, cityId: 230, code: "825101" },
    { id: 29354, cityId: 230, code: "262728" },
    { id: 29355, cityId: 230, code: "423704" },
    { id: 29356, cityId: 230, code: "431001" },
    { id: 29357, cityId: 230, code: "431004" },
    { id: 29358, cityId: 230, code: "431102" },
    { id: 29359, cityId: 230, code: "431104" },
    { id: 29360, cityId: 230, code: "431110" },
    { id: 29361, cityId: 230, code: "431115" },
    { id: 29362, cityId: 230, code: "431133" },
    { id: 29363, cityId: 230, code: "431139" },
    { id: 29364, cityId: 230, code: "431144" },
    { id: 29365, cityId: 230, code: "431146" },
    { id: 29366, cityId: 230, code: "431147" },
    { id: 29367, cityId: 230, code: "431208" },
    { id: 29368, cityId: 230, code: "431210" },
    { id: 29369, cityId: 230, code: "431213" },
    { id: 29370, cityId: 230, code: "814147" },
    { id: 29371, cityId: 230, code: "814155" },
    { id: 29372, cityId: 230, code: "814156" },
    { id: 29373, cityId: 230, code: "824101" },
    { id: 29374, cityId: 230, code: "824112" },
    { id: 29375, cityId: 230, code: "824114" },
    { id: 29376, cityId: 230, code: "824120" },
    { id: 29377, cityId: 230, code: "824122" },
    { id: 29378, cityId: 230, code: "824127" },
    { id: 29379, cityId: 230, code: "824128" },
    { id: 29380, cityId: 230, code: "824130" },
    { id: 29381, cityId: 230, code: "824202" },
    { id: 29382, cityId: 230, code: "824218" },
    { id: 29383, cityId: 230, code: "824302" },
    { id: 29384, cityId: 231, code: "845101" },
    { id: 29385, cityId: 232, code: "275201" },
    { id: 29386, cityId: 232, code: "846004" },
    { id: 29387, cityId: 232, code: "242001" },
    { id: 29388, cityId: 232, code: "855101" },
    { id: 29389, cityId: 233, code: "804429" },
    { id: 29390, cityId: 234, code: "486441" },
    { id: 29391, cityId: 234, code: "804428" },
    { id: 29392, cityId: 234, code: "497335" },
    { id: 29393, cityId: 235, code: "803212" },
    { id: 29394, cityId: 236, code: "813102" },
    { id: 29395, cityId: 236, code: "813118" },
    { id: 29396, cityId: 236, code: "845418" },
    { id: 29397, cityId: 236, code: "824111" },
    { id: 29398, cityId: 236, code: "841238" },
    { id: 29399, cityId: 236, code: "854362" },
    { id: 29400, cityId: 237, code: "811302" },
    { id: 29401, cityId: 237, code: "813111" },
    { id: 29402, cityId: 238, code: "803213" },
    { id: 29403, cityId: 239, code: "848201" },
    { id: 29404, cityId: 239, code: "851101" },
    { id: 29405, cityId: 239, code: "851111" },
    { id: 29406, cityId: 239, code: "851114" },
    { id: 29407, cityId: 239, code: "851116" },
    { id: 29408, cityId: 239, code: "851117" },
    { id: 29409, cityId: 239, code: "851119" },
    { id: 29410, cityId: 239, code: "851122" },
    { id: 29411, cityId: 239, code: "851127" },
    { id: 29412, cityId: 239, code: "851129" },
    { id: 29413, cityId: 239, code: "851130" },
    { id: 29414, cityId: 239, code: "851132" },
    { id: 29415, cityId: 239, code: "851135" },
    { id: 29416, cityId: 239, code: "851137" },
    { id: 29417, cityId: 239, code: "851138" },
    { id: 29418, cityId: 239, code: "851220" },
    { id: 29419, cityId: 239, code: "851222" },
    { id: 29420, cityId: 239, code: "848202" },
    { id: 29421, cityId: 239, code: "848204" },
    { id: 29422, cityId: 239, code: "851112" },
    { id: 29423, cityId: 239, code: "851113" },
    { id: 29424, cityId: 239, code: "851115" },
    { id: 29425, cityId: 239, code: "851118" },
    { id: 29426, cityId: 239, code: "851120" },
    { id: 29427, cityId: 239, code: "851121" },
    { id: 29428, cityId: 239, code: "851126" },
    { id: 29429, cityId: 239, code: "851131" },
    { id: 29430, cityId: 239, code: "851133" },
    { id: 29431, cityId: 239, code: "851134" },
    { id: 29432, cityId: 239, code: "851136" },
    { id: 29433, cityId: 239, code: "851139" },
    { id: 29434, cityId: 239, code: "851221" },
    { id: 29435, cityId: 239, code: "851223" },
    { id: 29436, cityId: 239, code: "851224" },
    { id: 29437, cityId: 240, code: "802152" },
    { id: 29438, cityId: 241, code: "843316" },
    { id: 29439, cityId: 242, code: "845102" },
    { id: 29440, cityId: 242, code: "845103" },
    { id: 29441, cityId: 242, code: "845105" },
    { id: 29442, cityId: 242, code: "845108" },
    { id: 29443, cityId: 242, code: "845110" },
    { id: 29444, cityId: 242, code: "845113" },
    { id: 29445, cityId: 242, code: "845116" },
    { id: 29446, cityId: 242, code: "845118" },
    { id: 29447, cityId: 242, code: "845119" },
    { id: 29448, cityId: 242, code: "845306" },
    { id: 29449, cityId: 242, code: "845307" },
    { id: 29450, cityId: 242, code: "845309" },
    { id: 29451, cityId: 242, code: "845449" },
    { id: 29452, cityId: 242, code: "845450" },
    { id: 29453, cityId: 242, code: "845452" },
    { id: 29454, cityId: 242, code: "845460" },
    { id: 29455, cityId: 242, code: "845471" },
    { id: 29456, cityId: 242, code: "845473" },
    { id: 29457, cityId: 242, code: "845476" },
    { id: 29458, cityId: 242, code: "845478" },
    { id: 29459, cityId: 242, code: "845479" },
    { id: 29460, cityId: 242, code: "845481" },
    { id: 29461, cityId: 242, code: "845484" },
    { id: 29462, cityId: 242, code: "845101" },
    { id: 29463, cityId: 242, code: "845106" },
    { id: 29464, cityId: 242, code: "845107" },
    { id: 29465, cityId: 242, code: "845109" },
    { id: 29466, cityId: 242, code: "845114" },
    { id: 29467, cityId: 242, code: "845115" },
    { id: 29468, cityId: 242, code: "845117" },
    { id: 29469, cityId: 242, code: "845308" },
    { id: 29470, cityId: 242, code: "845310" },
    { id: 29471, cityId: 242, code: "845311" },
    { id: 29472, cityId: 242, code: "845411" },
    { id: 29473, cityId: 242, code: "845437" },
    { id: 29474, cityId: 242, code: "845438" },
    { id: 29475, cityId: 242, code: "845451" },
    { id: 29476, cityId: 242, code: "845453" },
    { id: 29477, cityId: 242, code: "845454" },
    { id: 29478, cityId: 242, code: "845459" },
    { id: 29479, cityId: 242, code: "845470" },
    { id: 29480, cityId: 242, code: "845472" },
    { id: 29481, cityId: 242, code: "845474" },
    { id: 29482, cityId: 242, code: "845475" },
    { id: 29483, cityId: 242, code: "845477" },
    { id: 29484, cityId: 242, code: "845480" },
    { id: 29485, cityId: 242, code: "845483" },
    { id: 29486, cityId: 243, code: "845438" },
    { id: 29487, cityId: 244, code: "821101" },
    { id: 29488, cityId: 245, code: "812002" },
    { id: 29489, cityId: 245, code: "812004" },
    { id: 29490, cityId: 245, code: "812005" },
    { id: 29491, cityId: 245, code: "812007" },
    { id: 29492, cityId: 245, code: "813101" },
    { id: 29493, cityId: 245, code: "813103" },
    { id: 29494, cityId: 245, code: "813104" },
    { id: 29495, cityId: 245, code: "813106" },
    { id: 29496, cityId: 245, code: "813109" },
    { id: 29497, cityId: 245, code: "813112" },
    { id: 29498, cityId: 245, code: "813114" },
    { id: 29499, cityId: 245, code: "813117" },
    { id: 29500, cityId: 245, code: "813119" },
    { id: 29501, cityId: 245, code: "813120" },
    { id: 29502, cityId: 245, code: "813122" },
    { id: 29503, cityId: 245, code: "813125" },
    { id: 29504, cityId: 245, code: "813127" },
    { id: 29505, cityId: 245, code: "813128" },
    { id: 29506, cityId: 245, code: "813202" },
    { id: 29507, cityId: 245, code: "813204" },
    { id: 29508, cityId: 245, code: "813207" },
    { id: 29509, cityId: 245, code: "813209" },
    { id: 29510, cityId: 245, code: "813210" },
    { id: 29511, cityId: 245, code: "813212" },
    { id: 29512, cityId: 245, code: "813223" },
    { id: 29513, cityId: 245, code: "813226" },
    { id: 29514, cityId: 245, code: "813228" },
    { id: 29515, cityId: 245, code: "813231" },
    { id: 29516, cityId: 245, code: "813233" },
    { id: 29517, cityId: 245, code: "814131" },
    { id: 29518, cityId: 245, code: "851215" },
    { id: 29519, cityId: 245, code: "853202" },
    { id: 29520, cityId: 245, code: "853204" },
    { id: 29521, cityId: 245, code: "853205" },
    { id: 29522, cityId: 245, code: "812001" },
    { id: 29523, cityId: 245, code: "812003" },
    { id: 29524, cityId: 245, code: "812006" },
    { id: 29525, cityId: 245, code: "813102" },
    { id: 29526, cityId: 245, code: "813105" },
    { id: 29527, cityId: 245, code: "813107" },
    { id: 29528, cityId: 245, code: "813108" },
    { id: 29529, cityId: 245, code: "813110" },
    { id: 29530, cityId: 245, code: "813113" },
    { id: 29531, cityId: 245, code: "813115" },
    { id: 29532, cityId: 245, code: "813116" },
    { id: 29533, cityId: 245, code: "813121" },
    { id: 29534, cityId: 245, code: "813123" },
    { id: 29535, cityId: 245, code: "813124" },
    { id: 29536, cityId: 245, code: "813126" },
    { id: 29537, cityId: 245, code: "813129" },
    { id: 29538, cityId: 245, code: "813203" },
    { id: 29539, cityId: 245, code: "813205" },
    { id: 29540, cityId: 245, code: "813211" },
    { id: 29541, cityId: 245, code: "813213" },
    { id: 29542, cityId: 245, code: "813222" },
    { id: 29543, cityId: 245, code: "813229" },
    { id: 29544, cityId: 245, code: "814101" },
    { id: 29545, cityId: 245, code: "853201" },
    { id: 29546, cityId: 245, code: "853203" },
    { id: 29547, cityId: 246, code: "802129" },
    { id: 29548, cityId: 247, code: "801305" },
    { id: 29549, cityId: 247, code: "801307" },
    { id: 29550, cityId: 247, code: "801310" },
    { id: 29551, cityId: 247, code: "803101" },
    { id: 29552, cityId: 247, code: "803108" },
    { id: 29553, cityId: 247, code: "803109" },
    { id: 29554, cityId: 247, code: "803111" },
    { id: 29555, cityId: 247, code: "803116" },
    { id: 29556, cityId: 247, code: "803119" },
    { id: 29557, cityId: 247, code: "803124" },
    { id: 29558, cityId: 247, code: "803130" },
    { id: 29559, cityId: 247, code: "811108" },
    { id: 29560, cityId: 247, code: "801301" },
    { id: 29561, cityId: 247, code: "801304" },
    { id: 29562, cityId: 247, code: "801306" },
    { id: 29563, cityId: 247, code: "801309" },
    { id: 29564, cityId: 247, code: "801311" },
    { id: 29565, cityId: 247, code: "803107" },
    { id: 29566, cityId: 247, code: "803110" },
    { id: 29567, cityId: 247, code: "803113" },
    { id: 29568, cityId: 247, code: "803115" },
    { id: 29569, cityId: 247, code: "803118" },
    { id: 29570, cityId: 247, code: "803120" },
    { id: 29571, cityId: 247, code: "803129" },
    { id: 29572, cityId: 247, code: "803131" },
    { id: 29573, cityId: 247, code: "811104" },
    { id: 29574, cityId: 248, code: "802212" },
    { id: 29575, cityId: 249, code: "847240" },
    { id: 29576, cityId: 249, code: "854340" },
    { id: 29577, cityId: 250, code: "824231" },
    { id: 29578, cityId: 251, code: "802102" },
    { id: 29579, cityId: 251, code: "802116" },
    { id: 29580, cityId: 251, code: "847122" },
    { id: 29581, cityId: 251, code: "802101" },
    { id: 29582, cityId: 251, code: "802103" },
    { id: 29583, cityId: 252, code: "845449" },
    { id: 29584, cityId: 253, code: "841301" },
    { id: 29585, cityId: 254, code: "813203" },
    { id: 29586, cityId: 255, code: "846001" },
    { id: 29587, cityId: 255, code: "846003" },
    { id: 29588, cityId: 255, code: "846006" },
    { id: 29589, cityId: 255, code: "847103" },
    { id: 29590, cityId: 255, code: "847105" },
    { id: 29591, cityId: 255, code: "847108" },
    { id: 29592, cityId: 255, code: "847110" },
    { id: 29593, cityId: 255, code: "847111" },
    { id: 29594, cityId: 255, code: "847113" },
    { id: 29595, cityId: 255, code: "847116" },
    { id: 29596, cityId: 255, code: "847118" },
    { id: 29597, cityId: 255, code: "847121" },
    { id: 29598, cityId: 255, code: "847123" },
    { id: 29599, cityId: 255, code: "847124" },
    { id: 29600, cityId: 255, code: "847126" },
    { id: 29601, cityId: 255, code: "847203" },
    { id: 29602, cityId: 255, code: "847301" },
    { id: 29603, cityId: 255, code: "847304" },
    { id: 29604, cityId: 255, code: "847306" },
    { id: 29605, cityId: 255, code: "847307" },
    { id: 29606, cityId: 255, code: "847405" },
    { id: 29607, cityId: 255, code: "846002" },
    { id: 29608, cityId: 255, code: "846004" },
    { id: 29609, cityId: 255, code: "846005" },
    { id: 29610, cityId: 255, code: "846007" },
    { id: 29611, cityId: 255, code: "847101" },
    { id: 29612, cityId: 255, code: "847104" },
    { id: 29613, cityId: 255, code: "847106" },
    { id: 29614, cityId: 255, code: "847109" },
    { id: 29615, cityId: 255, code: "847112" },
    { id: 29616, cityId: 255, code: "847114" },
    { id: 29617, cityId: 255, code: "847115" },
    { id: 29618, cityId: 255, code: "847117" },
    { id: 29619, cityId: 255, code: "847119" },
    { id: 29620, cityId: 255, code: "847120" },
    { id: 29621, cityId: 255, code: "847125" },
    { id: 29622, cityId: 255, code: "847204" },
    { id: 29623, cityId: 255, code: "847205" },
    { id: 29624, cityId: 255, code: "847303" },
    { id: 29625, cityId: 255, code: "847411" },
    { id: 29626, cityId: 255, code: "847422" },
    { id: 29627, cityId: 255, code: "848213" },
    { id: 29628, cityId: 256, code: "824113" },
    { id: 29629, cityId: 257, code: "845418" },
    { id: 29630, cityId: 258, code: "812005" },
    { id: 29631, cityId: 259, code: "841207" },
    { id: 29632, cityId: 260, code: "813206" },
    { id: 29633, cityId: 261, code: "854318" },
    { id: 29634, cityId: 262, code: "804404" },
    { id: 29635, cityId: 262, code: "804405" },
    { id: 29636, cityId: 262, code: "804407" },
    { id: 29637, cityId: 262, code: "805135" },
    { id: 29638, cityId: 262, code: "805136" },
    { id: 29639, cityId: 262, code: "805138" },
    { id: 29640, cityId: 262, code: "805141" },
    { id: 29641, cityId: 262, code: "805143" },
    { id: 29642, cityId: 262, code: "805144" },
    { id: 29643, cityId: 262, code: "823001" },
    { id: 29644, cityId: 262, code: "823002" },
    { id: 29645, cityId: 262, code: "823004" },
    { id: 29646, cityId: 262, code: "824201" },
    { id: 29647, cityId: 262, code: "824207" },
    { id: 29648, cityId: 262, code: "824209" },
    { id: 29649, cityId: 262, code: "824210" },
    { id: 29650, cityId: 262, code: "824212" },
    { id: 29651, cityId: 262, code: "824215" },
    { id: 29652, cityId: 262, code: "824217" },
    { id: 29653, cityId: 262, code: "824233" },
    { id: 29654, cityId: 262, code: "824238" },
    { id: 29655, cityId: 262, code: "824239" },
    { id: 29656, cityId: 262, code: "804403" },
    { id: 29657, cityId: 262, code: "804422" },
    { id: 29658, cityId: 262, code: "804424" },
    { id: 29659, cityId: 262, code: "804427" },
    { id: 29660, cityId: 262, code: "804432" },
    { id: 29661, cityId: 262, code: "805137" },
    { id: 29662, cityId: 262, code: "805139" },
    { id: 29663, cityId: 262, code: "805140" },
    { id: 29664, cityId: 262, code: "805145" },
    { id: 29665, cityId: 262, code: "823003" },
    { id: 29666, cityId: 262, code: "823005" },
    { id: 29667, cityId: 262, code: "824118" },
    { id: 29668, cityId: 262, code: "824205" },
    { id: 29669, cityId: 262, code: "824206" },
    { id: 29670, cityId: 262, code: "824208" },
    { id: 29671, cityId: 262, code: "824213" },
    { id: 29672, cityId: 262, code: "824214" },
    { id: 29673, cityId: 262, code: "824232" },
    { id: 29674, cityId: 262, code: "824234" },
    { id: 29675, cityId: 262, code: "824235" },
    { id: 29676, cityId: 262, code: "824237" },
    { id: 29677, cityId: 262, code: "835208" },
    { id: 29678, cityId: 263, code: "847402" },
    { id: 29679, cityId: 264, code: "804434" },
    { id: 29680, cityId: 265, code: "825103" },
    { id: 29681, cityId: 266, code: "841405" },
    { id: 29682, cityId: 266, code: "841407" },
    { id: 29683, cityId: 266, code: "841413" },
    { id: 29684, cityId: 266, code: "841423" },
    { id: 29685, cityId: 266, code: "841426" },
    { id: 29686, cityId: 266, code: "841437" },
    { id: 29687, cityId: 266, code: "841440" },
    { id: 29688, cityId: 266, code: "841501" },
    { id: 29689, cityId: 266, code: "841503" },
    { id: 29690, cityId: 266, code: "841505" },
    { id: 29691, cityId: 266, code: "841508" },
    { id: 29692, cityId: 266, code: "841409" },
    { id: 29693, cityId: 266, code: "841420" },
    { id: 29694, cityId: 266, code: "841425" },
    { id: 29695, cityId: 266, code: "841427" },
    { id: 29696, cityId: 266, code: "841428" },
    { id: 29697, cityId: 266, code: "841436" },
    { id: 29698, cityId: 267, code: "144221" },
    { id: 29699, cityId: 267, code: "844101" },
    { id: 29700, cityId: 268, code: "843110" },
    { id: 29701, cityId: 268, code: "844101" },
    { id: 29702, cityId: 268, code: "844111" },
    { id: 29703, cityId: 268, code: "844119" },
    { id: 29704, cityId: 268, code: "844122" },
    { id: 29705, cityId: 268, code: "844124" },
    { id: 29706, cityId: 268, code: "844125" },
    { id: 29707, cityId: 268, code: "844130" },
    { id: 29708, cityId: 268, code: "844132" },
    { id: 29709, cityId: 268, code: "844135" },
    { id: 29710, cityId: 268, code: "844137" },
    { id: 29711, cityId: 268, code: "844138" },
    { id: 29712, cityId: 268, code: "844140" },
    { id: 29713, cityId: 268, code: "844501" },
    { id: 29714, cityId: 268, code: "844503" },
    { id: 29715, cityId: 268, code: "844506" },
    { id: 29716, cityId: 268, code: "844508" },
    { id: 29717, cityId: 268, code: "844509" },
    { id: 29718, cityId: 268, code: "844511" },
    { id: 29719, cityId: 268, code: "844514" },
    { id: 29720, cityId: 268, code: "844516" },
    { id: 29721, cityId: 268, code: "844517" },
    { id: 29722, cityId: 268, code: "844519" },
    { id: 29723, cityId: 268, code: "844521" },
    { id: 29724, cityId: 268, code: "844522" },
    { id: 29725, cityId: 268, code: "844532" },
    { id: 29726, cityId: 268, code: "843114" },
    { id: 29727, cityId: 268, code: "844113" },
    { id: 29728, cityId: 268, code: "844115" },
    { id: 29729, cityId: 268, code: "844118" },
    { id: 29730, cityId: 268, code: "844123" },
    { id: 29731, cityId: 268, code: "844126" },
    { id: 29732, cityId: 268, code: "844128" },
    { id: 29733, cityId: 268, code: "844131" },
    { id: 29734, cityId: 268, code: "844133" },
    { id: 29735, cityId: 268, code: "844134" },
    { id: 29736, cityId: 268, code: "844136" },
    { id: 29737, cityId: 268, code: "844139" },
    { id: 29738, cityId: 268, code: "844141" },
    { id: 29739, cityId: 268, code: "844502" },
    { id: 29740, cityId: 268, code: "844504" },
    { id: 29741, cityId: 268, code: "844505" },
    { id: 29742, cityId: 268, code: "844507" },
    { id: 29743, cityId: 268, code: "844510" },
    { id: 29744, cityId: 268, code: "844512" },
    { id: 29745, cityId: 268, code: "844513" },
    { id: 29746, cityId: 268, code: "844515" },
    { id: 29747, cityId: 268, code: "844518" },
    { id: 29748, cityId: 268, code: "844520" },
    { id: 29749, cityId: 269, code: "801302" },
    { id: 29750, cityId: 269, code: "804406" },
    { id: 29751, cityId: 269, code: "804421" },
    { id: 29752, cityId: 270, code: "801303" },
    { id: 29753, cityId: 270, code: "733202" },
    { id: 29754, cityId: 271, code: "813105" },
    { id: 29755, cityId: 272, code: "804402" },
    { id: 29756, cityId: 272, code: "804408" },
    { id: 29757, cityId: 272, code: "804426" },
    { id: 29758, cityId: 272, code: "804435" },
    { id: 29759, cityId: 272, code: "804401" },
    { id: 29760, cityId: 272, code: "804417" },
    { id: 29761, cityId: 272, code: "804420" },
    { id: 29762, cityId: 272, code: "804423" },
    { id: 29763, cityId: 272, code: "804425" },
    { id: 29764, cityId: 272, code: "804430" },
    { id: 29765, cityId: 272, code: "804431" },
    { id: 29766, cityId: 272, code: "804433" },
    { id: 29767, cityId: 273, code: "847226" },
    { id: 29768, cityId: 274, code: "811214" },
    { id: 29769, cityId: 275, code: "811305" },
    { id: 29770, cityId: 275, code: "811308" },
    { id: 29771, cityId: 275, code: "811314" },
    { id: 29772, cityId: 275, code: "811307" },
    { id: 29773, cityId: 275, code: "811312" },
    { id: 29774, cityId: 275, code: "811315" },
    { id: 29775, cityId: 275, code: "811317" },
    { id: 29776, cityId: 275, code: "854342" },
    { id: 29777, cityId: 276, code: "811308" },
    { id: 29778, cityId: 277, code: "804418" },
    { id: 29779, cityId: 277, code: "847404" },
    { id: 29780, cityId: 278, code: "854328" },
    { id: 29781, cityId: 279, code: "821102" },
    { id: 29782, cityId: 279, code: "821109" },
    { id: 29783, cityId: 279, code: "821110" },
    { id: 29784, cityId: 279, code: "821117" },
    { id: 29785, cityId: 279, code: "821120" },
    { id: 29786, cityId: 279, code: "841203" },
    { id: 29787, cityId: 279, code: "844114" },
    { id: 29788, cityId: 279, code: "844129" },
    { id: 29789, cityId: 279, code: "848129" },
    { id: 29790, cityId: 279, code: "848150" },
    { id: 29791, cityId: 279, code: "854347" },
    { id: 29792, cityId: 279, code: "804408" },
    { id: 29793, cityId: 279, code: "821103" },
    { id: 29794, cityId: 279, code: "821105" },
    { id: 29795, cityId: 279, code: "821106" },
    { id: 29796, cityId: 279, code: "821116" },
    { id: 29797, cityId: 279, code: "841408" },
    { id: 29798, cityId: 279, code: "852113" },
    { id: 29799, cityId: 280, code: "843109" },
    { id: 29800, cityId: 281, code: "804419" },
    { id: 29801, cityId: 282, code: "700042" },
    { id: 29802, cityId: 282, code: "854330" },
    { id: 29803, cityId: 283, code: "848203" },
    { id: 29804, cityId: 283, code: "851201" },
    { id: 29805, cityId: 283, code: "851203" },
    { id: 29806, cityId: 283, code: "851204" },
    { id: 29807, cityId: 283, code: "851211" },
    { id: 29808, cityId: 283, code: "851212" },
    { id: 29809, cityId: 283, code: "851214" },
    { id: 29810, cityId: 283, code: "851217" },
    { id: 29811, cityId: 283, code: "851219" },
    { id: 29812, cityId: 283, code: "851225" },
    { id: 29813, cityId: 283, code: "851227" },
    { id: 29814, cityId: 283, code: "851102" },
    { id: 29815, cityId: 283, code: "851128" },
    { id: 29816, cityId: 283, code: "851205" },
    { id: 29817, cityId: 283, code: "851213" },
    { id: 29818, cityId: 283, code: "851216" },
    { id: 29819, cityId: 283, code: "851218" },
    { id: 29820, cityId: 283, code: "851226" },
    { id: 29821, cityId: 283, code: "851228" },
    { id: 29822, cityId: 283, code: "852161" },
    { id: 29823, cityId: 284, code: "801105" },
    { id: 29824, cityId: 285, code: "803202" },
    { id: 29825, cityId: 286, code: "811301" },
    { id: 29826, cityId: 286, code: "854114" },
    { id: 29827, cityId: 286, code: "855107" },
    { id: 29828, cityId: 286, code: "855120" },
    { id: 29829, cityId: 286, code: "855128" },
    { id: 29830, cityId: 286, code: "821118" },
    { id: 29831, cityId: 286, code: "848227" },
    { id: 29832, cityId: 286, code: "854105" },
    { id: 29833, cityId: 286, code: "855106" },
    { id: 29834, cityId: 286, code: "855119" },
    { id: 29835, cityId: 287, code: "802216" },
    { id: 29836, cityId: 288, code: "802160" },
    { id: 29837, cityId: 289, code: "811311" },
    { id: 29838, cityId: 289, code: "811106" },
    { id: 29839, cityId: 289, code: "848301" },
    { id: 29840, cityId: 290, code: "230132" },
    { id: 29841, cityId: 290, code: "276202" },
    { id: 29842, cityId: 290, code: "844121" },
    { id: 29843, cityId: 290, code: "229206" },
    { id: 29844, cityId: 290, code: "231211" },
    { id: 29845, cityId: 290, code: "277216" },
    { id: 29846, cityId: 291, code: "852101" },
    { id: 29847, cityId: 291, code: "852107" },
    { id: 29848, cityId: 291, code: "852112" },
    { id: 29849, cityId: 291, code: "852128" },
    { id: 29850, cityId: 291, code: "852213" },
    { id: 29851, cityId: 291, code: "852218" },
    { id: 29852, cityId: 291, code: "852113" },
    { id: 29853, cityId: 291, code: "852114" },
    { id: 29854, cityId: 291, code: "852129" },
    { id: 29855, cityId: 291, code: "852130" },
    { id: 29856, cityId: 291, code: "852137" },
    { id: 29857, cityId: 291, code: "852217" },
    { id: 29858, cityId: 291, code: "852219" },
    { id: 29859, cityId: 291, code: "852220" },
    { id: 29860, cityId: 292, code: "845104" },
    { id: 29861, cityId: 292, code: "847212" },
    { id: 29862, cityId: 292, code: "847213" },
    { id: 29863, cityId: 292, code: "847223" },
    { id: 29864, cityId: 292, code: "847226" },
    { id: 29865, cityId: 292, code: "847228" },
    { id: 29866, cityId: 292, code: "847231" },
    { id: 29867, cityId: 292, code: "847233" },
    { id: 29868, cityId: 292, code: "847234" },
    { id: 29869, cityId: 292, code: "847236" },
    { id: 29870, cityId: 292, code: "847239" },
    { id: 29871, cityId: 292, code: "847241" },
    { id: 29872, cityId: 292, code: "847242" },
    { id: 29873, cityId: 292, code: "847244" },
    { id: 29874, cityId: 292, code: "847247" },
    { id: 29875, cityId: 292, code: "847249" },
    { id: 29876, cityId: 292, code: "847250" },
    { id: 29877, cityId: 292, code: "847252" },
    { id: 29878, cityId: 292, code: "847255" },
    { id: 29879, cityId: 292, code: "847257" },
    { id: 29880, cityId: 292, code: "847305" },
    { id: 29881, cityId: 292, code: "847308" },
    { id: 29882, cityId: 292, code: "847310" },
    { id: 29883, cityId: 292, code: "847311" },
    { id: 29884, cityId: 292, code: "847313" },
    { id: 29885, cityId: 292, code: "847401" },
    { id: 29886, cityId: 292, code: "847403" },
    { id: 29887, cityId: 292, code: "847406" },
    { id: 29888, cityId: 292, code: "847408" },
    { id: 29889, cityId: 292, code: "847409" },
    { id: 29890, cityId: 292, code: "847414" },
    { id: 29891, cityId: 292, code: "847416" },
    { id: 29892, cityId: 292, code: "847417" },
    { id: 29893, cityId: 292, code: "847419" },
    { id: 29894, cityId: 292, code: "847421" },
    { id: 29895, cityId: 292, code: "847424" },
    { id: 29896, cityId: 292, code: "852139" },
    { id: 29897, cityId: 292, code: "852150" },
    { id: 29898, cityId: 292, code: "847102" },
    { id: 29899, cityId: 292, code: "847201" },
    { id: 29900, cityId: 292, code: "847211" },
    { id: 29901, cityId: 292, code: "847222" },
    { id: 29902, cityId: 292, code: "847224" },
    { id: 29903, cityId: 292, code: "847227" },
    { id: 29904, cityId: 292, code: "847229" },
    { id: 29905, cityId: 292, code: "847230" },
    { id: 29906, cityId: 292, code: "847232" },
    { id: 29907, cityId: 292, code: "847235" },
    { id: 29908, cityId: 292, code: "847237" },
    { id: 29909, cityId: 292, code: "847238" },
    { id: 29910, cityId: 292, code: "847243" },
    { id: 29911, cityId: 292, code: "847245" },
    { id: 29912, cityId: 292, code: "847246" },
    { id: 29913, cityId: 292, code: "847248" },
    { id: 29914, cityId: 292, code: "847251" },
    { id: 29915, cityId: 292, code: "847253" },
    { id: 29916, cityId: 292, code: "847254" },
    { id: 29917, cityId: 292, code: "847256" },
    { id: 29918, cityId: 292, code: "847309" },
    { id: 29919, cityId: 292, code: "847312" },
    { id: 29920, cityId: 292, code: "847407" },
    { id: 29921, cityId: 292, code: "847410" },
    { id: 29922, cityId: 292, code: "847412" },
    { id: 29923, cityId: 292, code: "847413" },
    { id: 29924, cityId: 292, code: "847415" },
    { id: 29925, cityId: 292, code: "847418" },
    { id: 29926, cityId: 292, code: "847420" },
    { id: 29927, cityId: 292, code: "847423" },
    { id: 29928, cityId: 292, code: "847425" },
    { id: 29929, cityId: 292, code: "847426" },
    { id: 29930, cityId: 292, code: "857225" },
    { id: 29931, cityId: 293, code: "841238" },
    { id: 29932, cityId: 294, code: "841239" },
    { id: 29933, cityId: 295, code: "804422" },
    { id: 29934, cityId: 296, code: "801108" },
    { id: 29935, cityId: 297, code: "854113" },
    { id: 29936, cityId: 298, code: "804452" },
    { id: 29937, cityId: 299, code: "841438" },
    { id: 29938, cityId: 299, code: "222165" },
    { id: 29939, cityId: 299, code: "243504" },
    { id: 29940, cityId: 300, code: "848501" },
    { id: 29941, cityId: 301, code: "845120" },
    { id: 29942, cityId: 301, code: "845301" },
    { id: 29943, cityId: 301, code: "845303" },
    { id: 29944, cityId: 301, code: "845314" },
    { id: 29945, cityId: 301, code: "845401" },
    { id: 29946, cityId: 301, code: "845406" },
    { id: 29947, cityId: 301, code: "845412" },
    { id: 29948, cityId: 301, code: "845414" },
    { id: 29949, cityId: 301, code: "845417" },
    { id: 29950, cityId: 301, code: "845419" },
    { id: 29951, cityId: 301, code: "845420" },
    { id: 29952, cityId: 301, code: "845422" },
    { id: 29953, cityId: 301, code: "845425" },
    { id: 29954, cityId: 301, code: "845427" },
    { id: 29955, cityId: 301, code: "845428" },
    { id: 29956, cityId: 301, code: "845430" },
    { id: 29957, cityId: 301, code: "845433" },
    { id: 29958, cityId: 301, code: "845435" },
    { id: 29959, cityId: 301, code: "845436" },
    { id: 29960, cityId: 301, code: "845457" },
    { id: 29961, cityId: 301, code: "845462" },
    { id: 29962, cityId: 301, code: "845464" },
    { id: 29963, cityId: 301, code: "845465" },
    { id: 29964, cityId: 301, code: "845467" },
    { id: 29965, cityId: 301, code: "845486" },
    { id: 29966, cityId: 301, code: "845488" },
    { id: 29967, cityId: 301, code: "845489" },
    { id: 29968, cityId: 301, code: "845491" },
    { id: 29969, cityId: 301, code: "845494" },
    { id: 29970, cityId: 301, code: "845496" },
    { id: 29971, cityId: 301, code: "845497" },
    { id: 29972, cityId: 301, code: "845499" },
    { id: 29973, cityId: 301, code: "845502" },
    { id: 29974, cityId: 301, code: "845504" },
    { id: 29975, cityId: 301, code: "845505" },
    { id: 29976, cityId: 301, code: "845507" },
    { id: 29977, cityId: 301, code: "845515" },
    { id: 29978, cityId: 301, code: "845517" },
    { id: 29979, cityId: 301, code: "845518" },
    { id: 29980, cityId: 301, code: "845520" },
    { id: 29981, cityId: 301, code: "845523" },
    { id: 29982, cityId: 301, code: "845525" },
    { id: 29983, cityId: 301, code: "845145" },
    { id: 29984, cityId: 301, code: "845302" },
    { id: 29985, cityId: 301, code: "845305" },
    { id: 29986, cityId: 301, code: "845312" },
    { id: 29987, cityId: 301, code: "845313" },
    { id: 29988, cityId: 301, code: "845363" },
    { id: 29989, cityId: 301, code: "845413" },
    { id: 29990, cityId: 301, code: "845416" },
    { id: 29991, cityId: 301, code: "845421" },
    { id: 29992, cityId: 301, code: "845423" },
    { id: 29993, cityId: 301, code: "845424" },
    { id: 29994, cityId: 301, code: "845426" },
    { id: 29995, cityId: 301, code: "845429" },
    { id: 29996, cityId: 301, code: "845431" },
    { id: 29997, cityId: 301, code: "845432" },
    { id: 29998, cityId: 301, code: "845434" },
    { id: 29999, cityId: 301, code: "845440" },
    { id: 30000, cityId: 301, code: "845456" },
    { id: 30001, cityId: 301, code: "845458" },
    { id: 30002, cityId: 301, code: "845461" },
    { id: 30003, cityId: 301, code: "845463" },
    { id: 30004, cityId: 301, code: "845466" },
    { id: 30005, cityId: 301, code: "845468" },
    { id: 30006, cityId: 301, code: "845469" },
    { id: 30007, cityId: 301, code: "845487" },
    { id: 30008, cityId: 301, code: "845490" },
    { id: 30009, cityId: 301, code: "845492" },
    { id: 30010, cityId: 301, code: "845495" },
    { id: 30011, cityId: 301, code: "845498" },
    { id: 30012, cityId: 301, code: "845501" },
    { id: 30013, cityId: 301, code: "845503" },
    { id: 30014, cityId: 301, code: "845506" },
    { id: 30015, cityId: 301, code: "845508" },
    { id: 30016, cityId: 301, code: "845509" },
    { id: 30017, cityId: 301, code: "845511" },
    { id: 30018, cityId: 301, code: "845514" },
    { id: 30019, cityId: 301, code: "845516" },
    { id: 30020, cityId: 301, code: "845519" },
    { id: 30021, cityId: 301, code: "845521" },
    { id: 30022, cityId: 301, code: "845522" },
    { id: 30023, cityId: 301, code: "845524" },
    { id: 30024, cityId: 302, code: "843111" },
    { id: 30025, cityId: 303, code: "811103" },
    { id: 30026, cityId: 303, code: "811105" },
    { id: 30027, cityId: 303, code: "811201" },
    { id: 30028, cityId: 303, code: "811211" },
    { id: 30029, cityId: 303, code: "811212" },
    { id: 30030, cityId: 303, code: "811214" },
    { id: 30031, cityId: 303, code: "811304" },
    { id: 30032, cityId: 303, code: "811309" },
    { id: 30033, cityId: 303, code: "811310" },
    { id: 30034, cityId: 303, code: "813221" },
    { id: 30035, cityId: 303, code: "811102" },
    { id: 30036, cityId: 303, code: "811107" },
    { id: 30037, cityId: 303, code: "811109" },
    { id: 30038, cityId: 303, code: "811110" },
    { id: 30039, cityId: 303, code: "811202" },
    { id: 30040, cityId: 303, code: "811213" },
    { id: 30041, cityId: 303, code: "811303" },
    { id: 30042, cityId: 303, code: "811311" },
    { id: 30043, cityId: 303, code: "811313" },
    { id: 30044, cityId: 303, code: "811316" },
    { id: 30045, cityId: 304, code: "852122" },
    { id: 30046, cityId: 305, code: "835221" },
    { id: 30047, cityId: 305, code: "842003" },
    { id: 30048, cityId: 305, code: "842005" },
    { id: 30049, cityId: 305, code: "843102" },
    { id: 30050, cityId: 305, code: "843105" },
    { id: 30051, cityId: 305, code: "843107" },
    { id: 30052, cityId: 305, code: "843108" },
    { id: 30053, cityId: 305, code: "843113" },
    { id: 30054, cityId: 305, code: "843115" },
    { id: 30055, cityId: 305, code: "843116" },
    { id: 30056, cityId: 305, code: "843118" },
    { id: 30057, cityId: 305, code: "843121" },
    { id: 30058, cityId: 305, code: "843123" },
    { id: 30059, cityId: 305, code: "843126" },
    { id: 30060, cityId: 305, code: "843128" },
    { id: 30061, cityId: 305, code: "843129" },
    { id: 30062, cityId: 305, code: "843131" },
    { id: 30063, cityId: 305, code: "843134" },
    { id: 30064, cityId: 305, code: "843136" },
    { id: 30065, cityId: 305, code: "843137" },
    { id: 30066, cityId: 305, code: "843139" },
    { id: 30067, cityId: 305, code: "843142" },
    { id: 30068, cityId: 305, code: "843144" },
    { id: 30069, cityId: 305, code: "843145" },
    { id: 30070, cityId: 305, code: "843147" },
    { id: 30071, cityId: 305, code: "843150" },
    { id: 30072, cityId: 305, code: "843152" },
    { id: 30073, cityId: 305, code: "843153" },
    { id: 30074, cityId: 305, code: "843155" },
    { id: 30075, cityId: 305, code: "843158" },
    { id: 30076, cityId: 305, code: "843160" },
    { id: 30077, cityId: 305, code: "843161" },
    { id: 30078, cityId: 305, code: "843163" },
    { id: 30079, cityId: 305, code: "843312" },
    { id: 30080, cityId: 305, code: "844116" },
    { id: 30081, cityId: 305, code: "844117" },
    { id: 30082, cityId: 305, code: "844127" },
    { id: 30083, cityId: 305, code: "847107" },
    { id: 30084, cityId: 305, code: "842001" },
    { id: 30085, cityId: 305, code: "842002" },
    { id: 30086, cityId: 305, code: "842004" },
    { id: 30087, cityId: 305, code: "843101" },
    { id: 30088, cityId: 305, code: "843103" },
    { id: 30089, cityId: 305, code: "843104" },
    { id: 30090, cityId: 305, code: "843106" },
    { id: 30091, cityId: 305, code: "843109" },
    { id: 30092, cityId: 305, code: "843112" },
    { id: 30093, cityId: 305, code: "843117" },
    { id: 30094, cityId: 305, code: "843119" },
    { id: 30095, cityId: 305, code: "843122" },
    { id: 30096, cityId: 305, code: "843124" },
    { id: 30097, cityId: 305, code: "843125" },
    { id: 30098, cityId: 305, code: "843127" },
    { id: 30099, cityId: 305, code: "843130" },
    { id: 30100, cityId: 305, code: "843132" },
    { id: 30101, cityId: 305, code: "843133" },
    { id: 30102, cityId: 305, code: "843135" },
    { id: 30103, cityId: 305, code: "843138" },
    { id: 30104, cityId: 305, code: "843140" },
    { id: 30105, cityId: 305, code: "843141" },
    { id: 30106, cityId: 305, code: "843143" },
    { id: 30107, cityId: 305, code: "843146" },
    { id: 30108, cityId: 305, code: "843148" },
    { id: 30109, cityId: 305, code: "843149" },
    { id: 30110, cityId: 305, code: "843151" },
    { id: 30111, cityId: 305, code: "843154" },
    { id: 30112, cityId: 305, code: "843156" },
    { id: 30113, cityId: 305, code: "843157" },
    { id: 30114, cityId: 305, code: "843159" },
    { id: 30115, cityId: 305, code: "843162" },
    { id: 30116, cityId: 305, code: "843164" },
    { id: 30117, cityId: 305, code: "843165" },
    { id: 30118, cityId: 305, code: "843321" },
    { id: 30119, cityId: 305, code: "843360" },
    { id: 30120, cityId: 305, code: "844112" },
    { id: 30121, cityId: 305, code: "844120" },
    { id: 30122, cityId: 305, code: "845485" },
    { id: 30123, cityId: 306, code: "824301" },
    { id: 30124, cityId: 307, code: "845455" },
    { id: 30125, cityId: 308, code: "805103" },
    { id: 30126, cityId: 308, code: "805106" },
    { id: 30127, cityId: 308, code: "805108" },
    { id: 30128, cityId: 308, code: "805121" },
    { id: 30129, cityId: 308, code: "805122" },
    { id: 30130, cityId: 308, code: "805124" },
    { id: 30131, cityId: 308, code: "805127" },
    { id: 30132, cityId: 308, code: "805129" },
    { id: 30133, cityId: 308, code: "805132" },
    { id: 30134, cityId: 308, code: "805134" },
    { id: 30135, cityId: 308, code: "805101" },
    { id: 30136, cityId: 308, code: "805102" },
    { id: 30137, cityId: 308, code: "805104" },
    { id: 30138, cityId: 308, code: "805107" },
    { id: 30139, cityId: 308, code: "805109" },
    { id: 30140, cityId: 308, code: "805110" },
    { id: 30141, cityId: 308, code: "805123" },
    { id: 30142, cityId: 308, code: "805125" },
    { id: 30143, cityId: 308, code: "805126" },
    { id: 30144, cityId: 308, code: "805128" },
    { id: 30145, cityId: 308, code: "805131" },
    { id: 30146, cityId: 309, code: "847452" },
    { id: 30147, cityId: 310, code: "800002" },
    { id: 30148, cityId: 310, code: "800003" },
    { id: 30149, cityId: 310, code: "800005" },
    { id: 30150, cityId: 310, code: "800008" },
    { id: 30151, cityId: 310, code: "800010" },
    { id: 30152, cityId: 310, code: "800011" },
    { id: 30153, cityId: 310, code: "800013" },
    { id: 30154, cityId: 310, code: "800016" },
    { id: 30155, cityId: 310, code: "800018" },
    { id: 30156, cityId: 310, code: "800021" },
    { id: 30157, cityId: 310, code: "800023" },
    { id: 30158, cityId: 310, code: "801101" },
    { id: 30159, cityId: 310, code: "801102" },
    { id: 30160, cityId: 310, code: "801104" },
    { id: 30161, cityId: 310, code: "801109" },
    { id: 30162, cityId: 310, code: "801110" },
    { id: 30163, cityId: 310, code: "801112" },
    { id: 30164, cityId: 310, code: "801115" },
    { id: 30165, cityId: 310, code: "801117" },
    { id: 30166, cityId: 310, code: "801118" },
    { id: 30167, cityId: 310, code: "801502" },
    { id: 30168, cityId: 310, code: "801507" },
    { id: 30169, cityId: 310, code: "801509" },
    { id: 30170, cityId: 310, code: "802119" },
    { id: 30171, cityId: 310, code: "803204" },
    { id: 30172, cityId: 310, code: "803213" },
    { id: 30173, cityId: 310, code: "803221" },
    { id: 30174, cityId: 310, code: "803302" },
    { id: 30175, cityId: 310, code: "803303" },
    { id: 30176, cityId: 310, code: "804457" },
    { id: 30177, cityId: 310, code: "800001" },
    { id: 30178, cityId: 310, code: "800004" },
    { id: 30179, cityId: 310, code: "800006" },
    { id: 30180, cityId: 310, code: "800007" },
    { id: 30181, cityId: 310, code: "800009" },
    { id: 30182, cityId: 310, code: "800012" },
    { id: 30183, cityId: 310, code: "800014" },
    { id: 30184, cityId: 310, code: "800015" },
    { id: 30185, cityId: 310, code: "800017" },
    { id: 30186, cityId: 310, code: "800019" },
    { id: 30187, cityId: 310, code: "800020" },
    { id: 30188, cityId: 310, code: "800022" },
    { id: 30189, cityId: 310, code: "801103" },
    { id: 30190, cityId: 310, code: "801105" },
    { id: 30191, cityId: 310, code: "801111" },
    { id: 30192, cityId: 310, code: "801113" },
    { id: 30193, cityId: 310, code: "801114" },
    { id: 30194, cityId: 310, code: "801116" },
    { id: 30195, cityId: 310, code: "801503" },
    { id: 30196, cityId: 310, code: "801505" },
    { id: 30197, cityId: 310, code: "801506" },
    { id: 30198, cityId: 310, code: "801508" },
    { id: 30199, cityId: 310, code: "803201" },
    { id: 30200, cityId: 310, code: "803203" },
    { id: 30201, cityId: 310, code: "803206" },
    { id: 30202, cityId: 310, code: "803211" },
    { id: 30203, cityId: 310, code: "803214" },
    { id: 30204, cityId: 310, code: "803232" },
    { id: 30205, cityId: 310, code: "803301" },
    { id: 30206, cityId: 310, code: "803306" },
    { id: 30207, cityId: 310, code: "803307" },
    { id: 30208, cityId: 310, code: "804451" },
    { id: 30209, cityId: 310, code: "804453" },
    { id: 30210, cityId: 311, code: "853207" },
    { id: 30211, cityId: 311, code: "854126" },
    { id: 30212, cityId: 311, code: "854201" },
    { id: 30213, cityId: 311, code: "854203" },
    { id: 30214, cityId: 311, code: "854206" },
    { id: 30215, cityId: 311, code: "854208" },
    { id: 30216, cityId: 311, code: "854209" },
    { id: 30217, cityId: 311, code: "854301" },
    { id: 30218, cityId: 311, code: "854319" },
    { id: 30219, cityId: 311, code: "854325" },
    { id: 30220, cityId: 311, code: "854327" },
    { id: 30221, cityId: 311, code: "854330" },
    { id: 30222, cityId: 311, code: "854333" },
    { id: 30223, cityId: 311, code: "854335" },
    { id: 30224, cityId: 311, code: "854336" },
    { id: 30225, cityId: 311, code: "854341" },
    { id: 30226, cityId: 311, code: "854343" },
    { id: 30227, cityId: 311, code: "854344" },
    { id: 30228, cityId: 311, code: "854346" },
    { id: 30229, cityId: 311, code: "854349" },
    { id: 30230, cityId: 311, code: "854351" },
    { id: 30231, cityId: 311, code: "854352" },
    { id: 30232, cityId: 311, code: "854354" },
    { id: 30233, cityId: 311, code: "854357" },
    { id: 30234, cityId: 311, code: "854360" },
    { id: 30235, cityId: 311, code: "854364" },
    { id: 30236, cityId: 311, code: "854365" },
    { id: 30237, cityId: 311, code: "854367" },
    { id: 30238, cityId: 311, code: "855117" },
    { id: 30239, cityId: 311, code: "855122" },
    { id: 30240, cityId: 311, code: "853206" },
    { id: 30241, cityId: 311, code: "853208" },
    { id: 30242, cityId: 311, code: "854127" },
    { id: 30243, cityId: 311, code: "854202" },
    { id: 30244, cityId: 311, code: "854204" },
    { id: 30245, cityId: 311, code: "854205" },
    { id: 30246, cityId: 311, code: "854207" },
    { id: 30247, cityId: 311, code: "854302" },
    { id: 30248, cityId: 311, code: "854303" },
    { id: 30249, cityId: 311, code: "854305" },
    { id: 30250, cityId: 311, code: "854315" },
    { id: 30251, cityId: 311, code: "854316" },
    { id: 30252, cityId: 311, code: "854318" },
    { id: 30253, cityId: 311, code: "854326" },
    { id: 30254, cityId: 311, code: "854329" },
    { id: 30255, cityId: 311, code: "854331" },
    { id: 30256, cityId: 311, code: "854332" },
    { id: 30257, cityId: 311, code: "854334" },
    { id: 30258, cityId: 311, code: "854337" },
    { id: 30259, cityId: 311, code: "854345" },
    { id: 30260, cityId: 311, code: "854350" },
    { id: 30261, cityId: 311, code: "854353" },
    { id: 30262, cityId: 311, code: "854355" },
    { id: 30263, cityId: 311, code: "854356" },
    { id: 30264, cityId: 311, code: "854358" },
    { id: 30265, cityId: 311, code: "854366" },
    { id: 30266, cityId: 311, code: "854368" },
    { id: 30267, cityId: 311, code: "855102" },
    { id: 30268, cityId: 311, code: "855115" },
    { id: 30269, cityId: 311, code: "855121" },
    { id: 30270, cityId: 311, code: "855126" },
    { id: 30271, cityId: 312, code: "824125" },
    { id: 30272, cityId: 313, code: "712247" },
    { id: 30273, cityId: 313, code: "723133" },
    { id: 30274, cityId: 313, code: "802134" },
    { id: 30275, cityId: 314, code: "803116" },
    { id: 30276, cityId: 315, code: "841315" },
    { id: 30277, cityId: 316, code: "847451" },
    { id: 30278, cityId: 316, code: "852105" },
    { id: 30279, cityId: 316, code: "852110" },
    { id: 30280, cityId: 316, code: "852123" },
    { id: 30281, cityId: 316, code: "852125" },
    { id: 30282, cityId: 316, code: "852126" },
    { id: 30283, cityId: 316, code: "852131" },
    { id: 30284, cityId: 316, code: "852141" },
    { id: 30285, cityId: 316, code: "852142" },
    { id: 30286, cityId: 316, code: "852144" },
    { id: 30287, cityId: 316, code: "852147" },
    { id: 30288, cityId: 316, code: "852149" },
    { id: 30289, cityId: 316, code: "852152" },
    { id: 30290, cityId: 316, code: "852155" },
    { id: 30291, cityId: 316, code: "852157" },
    { id: 30292, cityId: 316, code: "852158" },
    { id: 30293, cityId: 316, code: "852160" },
    { id: 30294, cityId: 316, code: "852215" },
    { id: 30295, cityId: 316, code: "852216" },
    { id: 30296, cityId: 316, code: "852221" },
    { id: 30297, cityId: 316, code: "854369" },
    { id: 30298, cityId: 316, code: "852106" },
    { id: 30299, cityId: 316, code: "852108" },
    { id: 30300, cityId: 316, code: "852109" },
    { id: 30301, cityId: 316, code: "852111" },
    { id: 30302, cityId: 316, code: "852124" },
    { id: 30303, cityId: 316, code: "852127" },
    { id: 30304, cityId: 316, code: "852138" },
    { id: 30305, cityId: 316, code: "852140" },
    { id: 30306, cityId: 316, code: "852143" },
    { id: 30307, cityId: 316, code: "852145" },
    { id: 30308, cityId: 316, code: "852146" },
    { id: 30309, cityId: 316, code: "852148" },
    { id: 30310, cityId: 316, code: "852151" },
    { id: 30311, cityId: 316, code: "852153" },
    { id: 30312, cityId: 316, code: "852154" },
    { id: 30313, cityId: 316, code: "852156" },
    { id: 30314, cityId: 316, code: "852159" },
    { id: 30315, cityId: 316, code: "852201" },
    { id: 30316, cityId: 316, code: "852212" },
    { id: 30317, cityId: 316, code: "852214" },
    { id: 30318, cityId: 316, code: "852233" },
    { id: 30319, cityId: 316, code: "852235" },
    { id: 30320, cityId: 316, code: "854338" },
    { id: 30321, cityId: 316, code: "854339" },
    { id: 30322, cityId: 317, code: "848102" },
    { id: 30323, cityId: 317, code: "848110" },
    { id: 30324, cityId: 317, code: "848111" },
    { id: 30325, cityId: 317, code: "848113" },
    { id: 30326, cityId: 317, code: "848116" },
    { id: 30327, cityId: 317, code: "848118" },
    { id: 30328, cityId: 317, code: "848119" },
    { id: 30329, cityId: 317, code: "848121" },
    { id: 30330, cityId: 317, code: "848124" },
    { id: 30331, cityId: 317, code: "848126" },
    { id: 30332, cityId: 317, code: "848131" },
    { id: 30333, cityId: 317, code: "848132" },
    { id: 30334, cityId: 317, code: "848137" },
    { id: 30335, cityId: 317, code: "848139" },
    { id: 30336, cityId: 317, code: "848140" },
    { id: 30337, cityId: 317, code: "848142" },
    { id: 30338, cityId: 317, code: "848145" },
    { id: 30339, cityId: 317, code: "848147" },
    { id: 30340, cityId: 317, code: "848148" },
    { id: 30341, cityId: 317, code: "848153" },
    { id: 30342, cityId: 317, code: "848155" },
    { id: 30343, cityId: 317, code: "848156" },
    { id: 30344, cityId: 317, code: "848158" },
    { id: 30345, cityId: 317, code: "848161" },
    { id: 30346, cityId: 317, code: "848163" },
    { id: 30347, cityId: 317, code: "848206" },
    { id: 30348, cityId: 317, code: "848208" },
    { id: 30349, cityId: 317, code: "848209" },
    { id: 30350, cityId: 317, code: "848211" },
    { id: 30351, cityId: 317, code: "848214" },
    { id: 30352, cityId: 317, code: "848216" },
    { id: 30353, cityId: 317, code: "848217" },
    { id: 30354, cityId: 317, code: "848219" },
    { id: 30355, cityId: 317, code: "848222" },
    { id: 30356, cityId: 317, code: "848224" },
    { id: 30357, cityId: 317, code: "848229" },
    { id: 30358, cityId: 317, code: "848230" },
    { id: 30359, cityId: 317, code: "848235" },
    { id: 30360, cityId: 317, code: "848237" },
    { id: 30361, cityId: 317, code: "848238" },
    { id: 30362, cityId: 317, code: "848301" },
    { id: 30363, cityId: 317, code: "848502" },
    { id: 30364, cityId: 317, code: "848503" },
    { id: 30365, cityId: 317, code: "848505" },
    { id: 30366, cityId: 317, code: "848508" },
    { id: 30367, cityId: 317, code: "848510" },
    { id: 30368, cityId: 317, code: "848511" },
    { id: 30369, cityId: 317, code: "848513" },
    { id: 30370, cityId: 317, code: "848515" },
    { id: 30371, cityId: 317, code: "848516" },
    { id: 30372, cityId: 317, code: "848518" },
    { id: 30373, cityId: 317, code: "848101" },
    { id: 30374, cityId: 317, code: "848109" },
    { id: 30375, cityId: 317, code: "848112" },
    { id: 30376, cityId: 317, code: "848114" },
    { id: 30377, cityId: 317, code: "848115" },
    { id: 30378, cityId: 317, code: "848117" },
    { id: 30379, cityId: 317, code: "848120" },
    { id: 30380, cityId: 317, code: "848122" },
    { id: 30381, cityId: 317, code: "848123" },
    { id: 30382, cityId: 317, code: "848125" },
    { id: 30383, cityId: 317, code: "848127" },
    { id: 30384, cityId: 317, code: "848128" },
    { id: 30385, cityId: 317, code: "848130" },
    { id: 30386, cityId: 317, code: "848133" },
    { id: 30387, cityId: 317, code: "848135" },
    { id: 30388, cityId: 317, code: "848136" },
    { id: 30389, cityId: 317, code: "848138" },
    { id: 30390, cityId: 317, code: "848144" },
    { id: 30391, cityId: 317, code: "848146" },
    { id: 30392, cityId: 317, code: "848149" },
    { id: 30393, cityId: 317, code: "848151" },
    { id: 30394, cityId: 317, code: "848152" },
    { id: 30395, cityId: 317, code: "848154" },
    { id: 30396, cityId: 317, code: "848157" },
    { id: 30397, cityId: 317, code: "848159" },
    { id: 30398, cityId: 317, code: "848160" },
    { id: 30399, cityId: 317, code: "848162" },
    { id: 30400, cityId: 317, code: "848183" },
    { id: 30401, cityId: 317, code: "848205" },
    { id: 30402, cityId: 317, code: "848207" },
    { id: 30403, cityId: 317, code: "848210" },
    { id: 30404, cityId: 317, code: "848218" },
    { id: 30405, cityId: 317, code: "848220" },
    { id: 30406, cityId: 317, code: "848221" },
    { id: 30407, cityId: 317, code: "848223" },
    { id: 30408, cityId: 317, code: "848225" },
    { id: 30409, cityId: 317, code: "848226" },
    { id: 30410, cityId: 317, code: "848228" },
    { id: 30411, cityId: 317, code: "848231" },
    { id: 30412, cityId: 317, code: "848233" },
    { id: 30413, cityId: 317, code: "848234" },
    { id: 30414, cityId: 317, code: "848236" },
    { id: 30415, cityId: 317, code: "848239" },
    { id: 30416, cityId: 317, code: "848302" },
    { id: 30417, cityId: 317, code: "848303" },
    { id: 30418, cityId: 317, code: "848504" },
    { id: 30419, cityId: 317, code: "848506" },
    { id: 30420, cityId: 317, code: "848507" },
    { id: 30421, cityId: 317, code: "848509" },
    { id: 30422, cityId: 317, code: "848512" },
    { id: 30423, cityId: 317, code: "848514" },
    { id: 30424, cityId: 317, code: "848517" },
    { id: 30425, cityId: 317, code: "848519" },
    { id: 30426, cityId: 318, code: "841105" },
    { id: 30427, cityId: 318, code: "841201" },
    { id: 30428, cityId: 318, code: "841204" },
    { id: 30429, cityId: 318, code: "841206" },
    { id: 30430, cityId: 318, code: "841208" },
    { id: 30431, cityId: 318, code: "841211" },
    { id: 30432, cityId: 318, code: "841214" },
    { id: 30433, cityId: 318, code: "841216" },
    { id: 30434, cityId: 318, code: "841217" },
    { id: 30435, cityId: 318, code: "841219" },
    { id: 30436, cityId: 318, code: "841222" },
    { id: 30437, cityId: 318, code: "841224" },
    { id: 30438, cityId: 318, code: "841225" },
    { id: 30439, cityId: 318, code: "841232" },
    { id: 30440, cityId: 318, code: "841233" },
    { id: 30441, cityId: 318, code: "841235" },
    { id: 30442, cityId: 318, code: "841240" },
    { id: 30443, cityId: 318, code: "841241" },
    { id: 30444, cityId: 318, code: "841243" },
    { id: 30445, cityId: 318, code: "841246" },
    { id: 30446, cityId: 318, code: "841248" },
    { id: 30447, cityId: 318, code: "841249" },
    { id: 30448, cityId: 318, code: "841251" },
    { id: 30449, cityId: 318, code: "841256" },
    { id: 30450, cityId: 318, code: "841301" },
    { id: 30451, cityId: 318, code: "841312" },
    { id: 30452, cityId: 318, code: "841314" },
    { id: 30453, cityId: 318, code: "841317" },
    { id: 30454, cityId: 318, code: "841339" },
    { id: 30455, cityId: 318, code: "841402" },
    { id: 30456, cityId: 318, code: "841410" },
    { id: 30457, cityId: 318, code: "841412" },
    { id: 30458, cityId: 318, code: "841415" },
    { id: 30459, cityId: 318, code: "841418" },
    { id: 30460, cityId: 318, code: "841421" },
    { id: 30461, cityId: 318, code: "841429" },
    { id: 30462, cityId: 318, code: "841431" },
    { id: 30463, cityId: 318, code: "841442" },
    { id: 30464, cityId: 318, code: "841101" },
    { id: 30465, cityId: 318, code: "841205" },
    { id: 30466, cityId: 318, code: "841210" },
    { id: 30467, cityId: 318, code: "841212" },
    { id: 30468, cityId: 318, code: "841213" },
    { id: 30469, cityId: 318, code: "841215" },
    { id: 30470, cityId: 318, code: "841218" },
    { id: 30471, cityId: 318, code: "841220" },
    { id: 30472, cityId: 318, code: "841221" },
    { id: 30473, cityId: 318, code: "841223" },
    { id: 30474, cityId: 318, code: "841226" },
    { id: 30475, cityId: 318, code: "841231" },
    { id: 30476, cityId: 318, code: "841234" },
    { id: 30477, cityId: 318, code: "841236" },
    { id: 30478, cityId: 318, code: "841237" },
    { id: 30479, cityId: 318, code: "841239" },
    { id: 30480, cityId: 318, code: "841242" },
    { id: 30481, cityId: 318, code: "841244" },
    { id: 30482, cityId: 318, code: "841245" },
    { id: 30483, cityId: 318, code: "841247" },
    { id: 30484, cityId: 318, code: "841250" },
    { id: 30485, cityId: 318, code: "841253" },
    { id: 30486, cityId: 318, code: "841255" },
    { id: 30487, cityId: 318, code: "841311" },
    { id: 30488, cityId: 318, code: "841313" },
    { id: 30489, cityId: 318, code: "841316" },
    { id: 30490, cityId: 318, code: "841318" },
    { id: 30491, cityId: 318, code: "841401" },
    { id: 30492, cityId: 318, code: "841403" },
    { id: 30493, cityId: 318, code: "841411" },
    { id: 30494, cityId: 318, code: "841414" },
    { id: 30495, cityId: 318, code: "841416" },
    { id: 30496, cityId: 318, code: "841417" },
    { id: 30497, cityId: 318, code: "841419" },
    { id: 30498, cityId: 318, code: "841422" },
    { id: 30499, cityId: 318, code: "841424" },
    { id: 30500, cityId: 318, code: "841430" },
    { id: 30501, cityId: 318, code: "841432" },
    { id: 30502, cityId: 318, code: "841433" },
    { id: 30503, cityId: 318, code: "841443" },
    { id: 30504, cityId: 319, code: "473665" },
    { id: 30505, cityId: 319, code: "802132" },
    { id: 30506, cityId: 319, code: "802182" },
    { id: 30507, cityId: 319, code: "802211" },
    { id: 30508, cityId: 319, code: "802212" },
    { id: 30509, cityId: 319, code: "802217" },
    { id: 30510, cityId: 319, code: "802219" },
    { id: 30511, cityId: 319, code: "802220" },
    { id: 30512, cityId: 319, code: "821111" },
    { id: 30513, cityId: 319, code: "821113" },
    { id: 30514, cityId: 319, code: "821119" },
    { id: 30515, cityId: 319, code: "821121" },
    { id: 30516, cityId: 319, code: "821124" },
    { id: 30517, cityId: 319, code: "821301" },
    { id: 30518, cityId: 319, code: "821304" },
    { id: 30519, cityId: 319, code: "821306" },
    { id: 30520, cityId: 319, code: "821307" },
    { id: 30521, cityId: 319, code: "821309" },
    { id: 30522, cityId: 319, code: "821312" },
    { id: 30523, cityId: 319, code: "821314" },
    { id: 30524, cityId: 319, code: "821315" },
    { id: 30525, cityId: 319, code: "821317" },
    { id: 30526, cityId: 319, code: "802213" },
    { id: 30527, cityId: 319, code: "802215" },
    { id: 30528, cityId: 319, code: "802218" },
    { id: 30529, cityId: 319, code: "802221" },
    { id: 30530, cityId: 319, code: "802226" },
    { id: 30531, cityId: 319, code: "821104" },
    { id: 30532, cityId: 319, code: "821106" },
    { id: 30533, cityId: 319, code: "821107" },
    { id: 30534, cityId: 319, code: "821115" },
    { id: 30535, cityId: 319, code: "821122" },
    { id: 30536, cityId: 319, code: "821123" },
    { id: 30537, cityId: 319, code: "821125" },
    { id: 30538, cityId: 319, code: "821302" },
    { id: 30539, cityId: 319, code: "821303" },
    { id: 30540, cityId: 319, code: "821305" },
    { id: 30541, cityId: 319, code: "821308" },
    { id: 30542, cityId: 319, code: "821310" },
    { id: 30543, cityId: 319, code: "821311" },
    { id: 30544, cityId: 319, code: "821313" },
    { id: 30545, cityId: 319, code: "821316" },
    { id: 30546, cityId: 320, code: "800014" },
    { id: 30547, cityId: 320, code: "803205" },
    { id: 30548, cityId: 320, code: "811105" },
    { id: 30549, cityId: 320, code: "841202" },
    { id: 30550, cityId: 320, code: "811101" },
    { id: 30551, cityId: 320, code: "811111" },
    { id: 30552, cityId: 320, code: "843356" },
    { id: 30553, cityId: 320, code: "845112" },
    { id: 30554, cityId: 321, code: "843329" },
    { id: 30555, cityId: 321, code: "843368" },
    { id: 30556, cityId: 322, code: "824211" },
    { id: 30557, cityId: 323, code: "803117" },
    { id: 30558, cityId: 324, code: "843311" },
    { id: 30559, cityId: 324, code: "843313" },
    { id: 30560, cityId: 324, code: "843314" },
    { id: 30561, cityId: 324, code: "843316" },
    { id: 30562, cityId: 324, code: "843319" },
    { id: 30563, cityId: 324, code: "843322" },
    { id: 30564, cityId: 324, code: "843324" },
    { id: 30565, cityId: 324, code: "843327" },
    { id: 30566, cityId: 324, code: "843330" },
    { id: 30567, cityId: 324, code: "843332" },
    { id: 30568, cityId: 324, code: "843335" },
    { id: 30569, cityId: 324, code: "843337" },
    { id: 30570, cityId: 324, code: "843338" },
    { id: 30571, cityId: 324, code: "843340" },
    { id: 30572, cityId: 324, code: "843343" },
    { id: 30573, cityId: 324, code: "843348" },
    { id: 30574, cityId: 324, code: "843350" },
    { id: 30575, cityId: 324, code: "843351" },
    { id: 30576, cityId: 324, code: "843353" },
    { id: 30577, cityId: 324, code: "843358" },
    { id: 30578, cityId: 324, code: "843359" },
    { id: 30579, cityId: 324, code: "843361" },
    { id: 30580, cityId: 324, code: "843364" },
    { id: 30581, cityId: 324, code: "843366" },
    { id: 30582, cityId: 324, code: "843367" },
    { id: 30583, cityId: 324, code: "843301" },
    { id: 30584, cityId: 324, code: "843302" },
    { id: 30585, cityId: 324, code: "843315" },
    { id: 30586, cityId: 324, code: "843317" },
    { id: 30587, cityId: 324, code: "843318" },
    { id: 30588, cityId: 324, code: "843320" },
    { id: 30589, cityId: 324, code: "843323" },
    { id: 30590, cityId: 324, code: "843325" },
    { id: 30591, cityId: 324, code: "843326" },
    { id: 30592, cityId: 324, code: "843328" },
    { id: 30593, cityId: 324, code: "843331" },
    { id: 30594, cityId: 324, code: "843333" },
    { id: 30595, cityId: 324, code: "843334" },
    { id: 30596, cityId: 324, code: "843336" },
    { id: 30597, cityId: 324, code: "843339" },
    { id: 30598, cityId: 324, code: "843341" },
    { id: 30599, cityId: 324, code: "843342" },
    { id: 30600, cityId: 324, code: "843344" },
    { id: 30601, cityId: 324, code: "843346" },
    { id: 30602, cityId: 324, code: "843347" },
    { id: 30603, cityId: 324, code: "843349" },
    { id: 30604, cityId: 324, code: "843352" },
    { id: 30605, cityId: 324, code: "843354" },
    { id: 30606, cityId: 324, code: "843355" },
    { id: 30607, cityId: 324, code: "843357" },
    { id: 30608, cityId: 324, code: "843362" },
    { id: 30609, cityId: 324, code: "843363" },
    { id: 30610, cityId: 324, code: "843365" },
    { id: 30611, cityId: 325, code: "841404" },
    { id: 30612, cityId: 325, code: "841434" },
    { id: 30613, cityId: 325, code: "841439" },
    { id: 30614, cityId: 325, code: "841502" },
    { id: 30615, cityId: 325, code: "841507" },
    { id: 30616, cityId: 325, code: "841226" },
    { id: 30617, cityId: 325, code: "841252" },
    { id: 30618, cityId: 325, code: "841254" },
    { id: 30619, cityId: 325, code: "841405" },
    { id: 30620, cityId: 325, code: "841435" },
    { id: 30621, cityId: 325, code: "841504" },
    { id: 30622, cityId: 325, code: "841506" },
    { id: 30623, cityId: 326, code: "841101" },
    { id: 30624, cityId: 327, code: "845456" },
    { id: 30625, cityId: 328, code: "813213" },
    { id: 30626, cityId: 329, code: "852131" },
    { id: 30627, cityId: 329, code: "847452" },
    { id: 30628, cityId: 330, code: "824236" },
    { id: 30629, cityId: 331, code: "805130" },
    { id: 30630, cityId: 332, code: "160002" },
    { id: 30631, cityId: 332, code: "160003" },
    { id: 30632, cityId: 332, code: "160008" },
    { id: 30633, cityId: 332, code: "160010" },
    { id: 30634, cityId: 332, code: "160011" },
    { id: 30635, cityId: 332, code: "160016" },
    { id: 30636, cityId: 332, code: "160018" },
    { id: 30637, cityId: 332, code: "160019" },
    { id: 30638, cityId: 332, code: "160026" },
    { id: 30639, cityId: 332, code: "160031" },
    { id: 30640, cityId: 332, code: "160055" },
    { id: 30641, cityId: 332, code: "160061" },
    { id: 30642, cityId: 332, code: "160101" },
    { id: 30643, cityId: 332, code: "160106" },
    { id: 30644, cityId: 332, code: "160001" },
    { id: 30645, cityId: 332, code: "160009" },
    { id: 30646, cityId: 332, code: "160012" },
    { id: 30647, cityId: 332, code: "160014" },
    { id: 30648, cityId: 332, code: "160017" },
    { id: 30649, cityId: 332, code: "160020" },
    { id: 30650, cityId: 332, code: "160022" },
    { id: 30651, cityId: 332, code: "160023" },
    { id: 30652, cityId: 332, code: "160036" },
    { id: 30653, cityId: 332, code: "160059" },
    { id: 30654, cityId: 333, code: "495552" },
    { id: 30655, cityId: 334, code: "497111" },
    { id: 30656, cityId: 334, code: "497116" },
    { id: 30657, cityId: 334, code: "497118" },
    { id: 30658, cityId: 334, code: "497119" },
    { id: 30659, cityId: 334, code: "497222" },
    { id: 30660, cityId: 334, code: "497235" },
    { id: 30661, cityId: 334, code: "497333" },
    { id: 30662, cityId: 334, code: "497447" },
    { id: 30663, cityId: 334, code: "497449" },
    { id: 30664, cityId: 334, code: "497553" },
    { id: 30665, cityId: 334, code: "497555" },
    { id: 30666, cityId: 334, code: "497773" },
    { id: 30667, cityId: 334, code: "497778" },
    { id: 30668, cityId: 334, code: "497001" },
    { id: 30669, cityId: 334, code: "497101" },
    { id: 30670, cityId: 334, code: "497210" },
    { id: 30671, cityId: 334, code: "497220" },
    { id: 30672, cityId: 334, code: "497223" },
    { id: 30673, cityId: 334, code: "497225" },
    { id: 30674, cityId: 334, code: "497231" },
    { id: 30675, cityId: 334, code: "497331" },
    { id: 30676, cityId: 334, code: "497339" },
    { id: 30677, cityId: 334, code: "497437" },
    { id: 30678, cityId: 334, code: "497446" },
    { id: 30679, cityId: 334, code: "497448" },
    { id: 30680, cityId: 334, code: "497451" },
    { id: 30681, cityId: 334, code: "497557" },
    { id: 30682, cityId: 334, code: "497559" },
    { id: 30683, cityId: 335, code: "493441" },
    { id: 30684, cityId: 336, code: "804428" },
    { id: 30685, cityId: 336, code: "486441" },
    { id: 30686, cityId: 336, code: "497335" },
    { id: 30687, cityId: 337, code: "495559" },
    { id: 30688, cityId: 338, code: "494224" },
    { id: 30689, cityId: 339, code: "493118" },
    { id: 30690, cityId: 340, code: "493222" },
    { id: 30691, cityId: 341, code: "135102" },
    { id: 30692, cityId: 341, code: "174010" },
    { id: 30693, cityId: 341, code: "174026" },
    { id: 30694, cityId: 341, code: "174029" },
    { id: 30695, cityId: 341, code: "174031" },
    { id: 30696, cityId: 341, code: "174032" },
    { id: 30697, cityId: 341, code: "174034" },
    { id: 30698, cityId: 341, code: "174201" },
    { id: 30699, cityId: 341, code: "174310" },
    { id: 30700, cityId: 341, code: "495001" },
    { id: 30701, cityId: 341, code: "495009" },
    { id: 30702, cityId: 341, code: "495112" },
    { id: 30703, cityId: 341, code: "495117" },
    { id: 30704, cityId: 341, code: "495220" },
    { id: 30705, cityId: 341, code: "495223" },
    { id: 30706, cityId: 341, code: "495446" },
    { id: 30707, cityId: 341, code: "495453" },
    { id: 30708, cityId: 341, code: "495551" },
    { id: 30709, cityId: 341, code: "495557" },
    { id: 30710, cityId: 341, code: "495660" },
    { id: 30711, cityId: 341, code: "495663" },
    { id: 30712, cityId: 341, code: "495679" },
    { id: 30713, cityId: 341, code: "495681" },
    { id: 30714, cityId: 341, code: "495684" },
    { id: 30715, cityId: 341, code: "495687" },
    { id: 30716, cityId: 341, code: "495695" },
    { id: 30717, cityId: 341, code: "95221" },
    { id: 30718, cityId: 341, code: "174001" },
    { id: 30719, cityId: 341, code: "174004" },
    { id: 30720, cityId: 341, code: "174011" },
    { id: 30721, cityId: 341, code: "174012" },
    { id: 30722, cityId: 341, code: "174022" },
    { id: 30723, cityId: 341, code: "174027" },
    { id: 30724, cityId: 341, code: "174028" },
    { id: 30725, cityId: 341, code: "174030" },
    { id: 30726, cityId: 341, code: "174033" },
    { id: 30727, cityId: 341, code: "174035" },
    { id: 30728, cityId: 341, code: "244921" },
    { id: 30729, cityId: 341, code: "495004" },
    { id: 30730, cityId: 341, code: "495007" },
    { id: 30731, cityId: 341, code: "495113" },
    { id: 30732, cityId: 341, code: "495116" },
    { id: 30733, cityId: 341, code: "495118" },
    { id: 30734, cityId: 341, code: "495222" },
    { id: 30735, cityId: 341, code: "495335" },
    { id: 30736, cityId: 341, code: "495447" },
    { id: 30737, cityId: 341, code: "495452" },
    { id: 30738, cityId: 341, code: "495550" },
    { id: 30739, cityId: 341, code: "495553" },
    { id: 30740, cityId: 341, code: "495674" },
    { id: 30741, cityId: 341, code: "495677" },
    { id: 30742, cityId: 341, code: "495680" },
    { id: 30743, cityId: 341, code: "495682" },
    { id: 30744, cityId: 341, code: "495683" },
    { id: 30745, cityId: 342, code: "495224" },
    { id: 30746, cityId: 343, code: "493221" },
    { id: 30747, cityId: 344, code: "495671" },
    { id: 30748, cityId: 345, code: "494449" },
    { id: 30749, cityId: 345, code: "494114" },
    { id: 30750, cityId: 346, code: "493113" },
    { id: 30751, cityId: 346, code: "493773" },
    { id: 30752, cityId: 346, code: "493776" },
    { id: 30753, cityId: 346, code: "493778" },
    { id: 30754, cityId: 347, code: "491661" },
    { id: 30755, cityId: 348, code: "490010" },
    { id: 30756, cityId: 348, code: "490012" },
    { id: 30757, cityId: 348, code: "490021" },
    { id: 30758, cityId: 348, code: "490023" },
    { id: 30759, cityId: 348, code: "490026" },
    { id: 30760, cityId: 348, code: "490036" },
    { id: 30761, cityId: 348, code: "490042" },
    { id: 30762, cityId: 348, code: "491001" },
    { id: 30763, cityId: 348, code: "491003" },
    { id: 30764, cityId: 348, code: "491223" },
    { id: 30765, cityId: 348, code: "491225" },
    { id: 30766, cityId: 348, code: "491226" },
    { id: 30767, cityId: 348, code: "491228" },
    { id: 30768, cityId: 348, code: "491331" },
    { id: 30769, cityId: 348, code: "491332" },
    { id: 30770, cityId: 348, code: "491337" },
    { id: 30771, cityId: 348, code: "491340" },
    { id: 30772, cityId: 348, code: "491771" },
    { id: 30773, cityId: 348, code: "494775" },
    { id: 30774, cityId: 348, code: "490001" },
    { id: 30775, cityId: 348, code: "490006" },
    { id: 30776, cityId: 348, code: "490008" },
    { id: 30777, cityId: 348, code: "490009" },
    { id: 30778, cityId: 348, code: "490011" },
    { id: 30779, cityId: 348, code: "490022" },
    { id: 30780, cityId: 348, code: "490024" },
    { id: 30781, cityId: 348, code: "490025" },
    { id: 30782, cityId: 348, code: "491002" },
    { id: 30783, cityId: 348, code: "491004" },
    { id: 30784, cityId: 348, code: "491113" },
    { id: 30785, cityId: 348, code: "491221" },
    { id: 30786, cityId: 348, code: "491222" },
    { id: 30787, cityId: 348, code: "491227" },
    { id: 30788, cityId: 348, code: "491230" },
    { id: 30789, cityId: 348, code: "491335" },
    { id: 30790, cityId: 348, code: "491338" },
    { id: 30791, cityId: 348, code: "491993" },
    { id: 30792, cityId: 349, code: "494441" },
    { id: 30793, cityId: 350, code: "496111" },
    { id: 30794, cityId: 351, code: "494001" },
    { id: 30795, cityId: 351, code: "494227" },
    { id: 30796, cityId: 351, code: "494229" },
    { id: 30797, cityId: 351, code: "494332" },
    { id: 30798, cityId: 351, code: "494335" },
    { id: 30799, cityId: 351, code: "494435" },
    { id: 30800, cityId: 351, code: "494444" },
    { id: 30801, cityId: 351, code: "494446" },
    { id: 30802, cityId: 351, code: "494449" },
    { id: 30803, cityId: 351, code: "494552" },
    { id: 30804, cityId: 351, code: "494661" },
    { id: 30805, cityId: 351, code: "494669" },
    { id: 30806, cityId: 351, code: "494777" },
    { id: 30807, cityId: 351, code: "494002" },
    { id: 30808, cityId: 351, code: "494005" },
    { id: 30809, cityId: 351, code: "494010" },
    { id: 30810, cityId: 351, code: "494222" },
    { id: 30811, cityId: 351, code: "494223" },
    { id: 30812, cityId: 351, code: "494225" },
    { id: 30813, cityId: 351, code: "494228" },
    { id: 30814, cityId: 351, code: "494230" },
    { id: 30815, cityId: 351, code: "494331" },
    { id: 30816, cityId: 351, code: "494333" },
    { id: 30817, cityId: 351, code: "494334" },
    { id: 30818, cityId: 351, code: "494442" },
    { id: 30819, cityId: 351, code: "494445" },
    { id: 30820, cityId: 351, code: "494447" },
    { id: 30821, cityId: 351, code: "494448" },
    { id: 30822, cityId: 351, code: "494551" },
    { id: 30823, cityId: 351, code: "494553" },
    { id: 30824, cityId: 351, code: "494554" },
    { id: 30825, cityId: 351, code: "494572" },
    { id: 30826, cityId: 351, code: "494635" },
    { id: 30827, cityId: 351, code: "494665" },
    { id: 30828, cityId: 351, code: "494670" },
    { id: 30829, cityId: 351, code: "494771" },
    { id: 30830, cityId: 351, code: "494776" },
    { id: 30831, cityId: 352, code: "495668" },
    { id: 30832, cityId: 352, code: "495691" },
    { id: 30833, cityId: 352, code: "496460" },
    { id: 30834, cityId: 352, code: "495661" },
    { id: 30835, cityId: 352, code: "495688" },
    { id: 30836, cityId: 352, code: "495690" },
    { id: 30837, cityId: 352, code: "495692" },
    { id: 30838, cityId: 353, code: "494111" },
    { id: 30839, cityId: 353, code: "496118" },
    { id: 30840, cityId: 353, code: "496224" },
    { id: 30841, cityId: 353, code: "494115" },
    { id: 30842, cityId: 353, code: "494122" },
    { id: 30843, cityId: 353, code: "494221" },
    { id: 30844, cityId: 353, code: "496223" },
    { id: 30845, cityId: 353, code: "496336" },
    { id: 30846, cityId: 354, code: "494336" },
    { id: 30847, cityId: 354, code: "494337" },
    { id: 30848, cityId: 355, code: "495445" },
    { id: 30849, cityId: 356, code: "491995" },
    { id: 30850, cityId: 356, code: "496334" },
    { id: 30851, cityId: 356, code: "495337" },
    { id: 30852, cityId: 356, code: "497114" },
    { id: 30853, cityId: 357, code: "491881" },
    { id: 30854, cityId: 358, code: "495556" },
    { id: 30855, cityId: 359, code: "496661" },
    { id: 30856, cityId: 360, code: "494556" },
    { id: 30857, cityId: 361, code: "494226" },
    { id: 30858, cityId: 362, code: "495449" },
    { id: 30859, cityId: 362, code: "495450" },
    { id: 30860, cityId: 363, code: "493663" },
    { id: 30861, cityId: 364, code: "493445" },
    { id: 30862, cityId: 365, code: "497442" },
    { id: 30863, cityId: 366, code: "495334" },
    { id: 30864, cityId: 367, code: "384112" },
    { id: 30865, cityId: 367, code: "384255" },
    { id: 30866, cityId: 367, code: "384260" },
    { id: 30867, cityId: 367, code: "384265" },
    { id: 30868, cityId: 367, code: "384271" },
    { id: 30869, cityId: 367, code: "384276" },
    { id: 30870, cityId: 367, code: "491111" },
    { id: 30871, cityId: 367, code: "364292" },
    { id: 30872, cityId: 367, code: "384110" },
    { id: 30873, cityId: 367, code: "384256" },
    { id: 30874, cityId: 367, code: "384277" },
    { id: 30875, cityId: 367, code: "384278" },
    { id: 30876, cityId: 367, code: "415206" },
    { id: 30877, cityId: 367, code: "483113" },
    { id: 30878, cityId: 368, code: "495119" },
    { id: 30879, cityId: 369, code: "465667" },
    { id: 30880, cityId: 369, code: "465686" },
    { id: 30881, cityId: 369, code: "465689" },
    { id: 30882, cityId: 369, code: "496116" },
    { id: 30883, cityId: 369, code: "496225" },
    { id: 30884, cityId: 369, code: "496331" },
    { id: 30885, cityId: 369, code: "496440" },
    { id: 30886, cityId: 369, code: "496450" },
    { id: 30887, cityId: 369, code: "496551" },
    { id: 30888, cityId: 369, code: "496554" },
    { id: 30889, cityId: 369, code: "496665" },
    { id: 30890, cityId: 369, code: "465679" },
    { id: 30891, cityId: 369, code: "465687" },
    { id: 30892, cityId: 369, code: "496001" },
    { id: 30893, cityId: 369, code: "496004" },
    { id: 30894, cityId: 369, code: "496100" },
    { id: 30895, cityId: 369, code: "496107" },
    { id: 30896, cityId: 369, code: "496113" },
    { id: 30897, cityId: 369, code: "496115" },
    { id: 30898, cityId: 369, code: "496227" },
    { id: 30899, cityId: 369, code: "496330" },
    { id: 30900, cityId: 369, code: "496338" },
    { id: 30901, cityId: 370, code: "492001" },
    { id: 30902, cityId: 370, code: "492004" },
    { id: 30903, cityId: 370, code: "492007" },
    { id: 30904, cityId: 370, code: "492009" },
    { id: 30905, cityId: 370, code: "492012" },
    { id: 30906, cityId: 370, code: "492015" },
    { id: 30907, cityId: 370, code: "492112" },
    { id: 30908, cityId: 370, code: "493111" },
    { id: 30909, cityId: 370, code: "493114" },
    { id: 30910, cityId: 370, code: "493116" },
    { id: 30911, cityId: 370, code: "493225" },
    { id: 30912, cityId: 370, code: "493228" },
    { id: 30913, cityId: 370, code: "493338" },
    { id: 30914, cityId: 370, code: "493344" },
    { id: 30915, cityId: 370, code: "493354" },
    { id: 30916, cityId: 370, code: "493551" },
    { id: 30917, cityId: 370, code: "493559" },
    { id: 30918, cityId: 370, code: "493881" },
    { id: 30919, cityId: 370, code: "493889" },
    { id: 30920, cityId: 370, code: "493890" },
    { id: 30921, cityId: 370, code: "493895" },
    { id: 30922, cityId: 370, code: "493996" },
    { id: 30923, cityId: 370, code: "248008" },
    { id: 30924, cityId: 370, code: "486114" },
    { id: 30925, cityId: 370, code: "492003" },
    { id: 30926, cityId: 370, code: "492005" },
    { id: 30927, cityId: 370, code: "492008" },
    { id: 30928, cityId: 370, code: "492109" },
    { id: 30929, cityId: 370, code: "493330" },
    { id: 30930, cityId: 370, code: "493332" },
    { id: 30931, cityId: 370, code: "493335" },
    { id: 30932, cityId: 370, code: "493449" },
    { id: 30933, cityId: 370, code: "493555" },
    { id: 30934, cityId: 370, code: "493562" },
    { id: 30935, cityId: 370, code: "493661" },
    { id: 30936, cityId: 370, code: "493885" },
    { id: 30937, cityId: 370, code: "493992" },
    { id: 30938, cityId: 371, code: "491336" },
    { id: 30939, cityId: 371, code: "491445" },
    { id: 30940, cityId: 371, code: "491557" },
    { id: 30941, cityId: 371, code: "491665" },
    { id: 30942, cityId: 371, code: "491668" },
    { id: 30943, cityId: 371, code: "491885" },
    { id: 30944, cityId: 371, code: "491888" },
    { id: 30945, cityId: 371, code: "491991" },
    { id: 30946, cityId: 371, code: "491229" },
    { id: 30947, cityId: 371, code: "491441" },
    { id: 30948, cityId: 371, code: "491443" },
    { id: 30949, cityId: 371, code: "491444" },
    { id: 30950, cityId: 371, code: "491558" },
    { id: 30951, cityId: 372, code: "495422" },
    { id: 30952, cityId: 373, code: "495689" },
    { id: 30953, cityId: 374, code: "493558" },
    { id: 30954, cityId: 375, code: "496445" },
    { id: 30955, cityId: 376, code: "493101" },
    { id: 30956, cityId: 377, code: "497229" },
    { id: 30957, cityId: 378, code: "495330" },
    { id: 30958, cityId: 379, code: "396230" },
    { id: 30959, cityId: 379, code: "396235" },
    { id: 30960, cityId: 379, code: "396240" },
    { id: 30961, cityId: 380, code: "396210" },
    { id: 30962, cityId: 380, code: "396220" },
    { id: 30963, cityId: 381, code: "362520" },
    { id: 30964, cityId: 382, code: "110002" },
    { id: 30965, cityId: 382, code: "110004" },
    { id: 30966, cityId: 382, code: "110005" },
    { id: 30967, cityId: 382, code: "110007" },
    { id: 30968, cityId: 382, code: "110010" },
    { id: 30969, cityId: 382, code: "110012" },
    { id: 30970, cityId: 382, code: "110013" },
    { id: 30971, cityId: 382, code: "110015" },
    { id: 30972, cityId: 382, code: "110018" },
    { id: 30973, cityId: 382, code: "110020" },
    { id: 30974, cityId: 382, code: "110021" },
    { id: 30975, cityId: 382, code: "110023" },
    { id: 30976, cityId: 382, code: "110026" },
    { id: 30977, cityId: 382, code: "110028" },
    { id: 30978, cityId: 382, code: "110029" },
    { id: 30979, cityId: 382, code: "110031" },
    { id: 30980, cityId: 382, code: "110034" },
    { id: 30981, cityId: 382, code: "110036" },
    { id: 30982, cityId: 382, code: "110037" },
    { id: 30983, cityId: 382, code: "110039" },
    { id: 30984, cityId: 382, code: "110042" },
    { id: 30985, cityId: 382, code: "110044" },
    { id: 30986, cityId: 382, code: "110045" },
    { id: 30987, cityId: 382, code: "110047" },
    { id: 30988, cityId: 382, code: "110052" },
    { id: 30989, cityId: 382, code: "110055" },
    { id: 30990, cityId: 382, code: "110057" },
    { id: 30991, cityId: 382, code: "110058" },
    { id: 30992, cityId: 382, code: "110060" },
    { id: 30993, cityId: 382, code: "110063" },
    { id: 30994, cityId: 382, code: "110065" },
    { id: 30995, cityId: 382, code: "110066" },
    { id: 30996, cityId: 382, code: "110071" },
    { id: 30997, cityId: 382, code: "110073" },
    { id: 30998, cityId: 382, code: "110081" },
    { id: 30999, cityId: 382, code: "110082" },
    { id: 31000, cityId: 382, code: "110084" },
    { id: 31001, cityId: 382, code: "110092" },
    { id: 31002, cityId: 382, code: "110001" },
    { id: 31003, cityId: 382, code: "110003" },
    { id: 31004, cityId: 382, code: "110006" },
    { id: 31005, cityId: 382, code: "110008" },
    { id: 31006, cityId: 382, code: "110011" },
    { id: 31007, cityId: 382, code: "110014" },
    { id: 31008, cityId: 382, code: "110016" },
    { id: 31009, cityId: 382, code: "110017" },
    { id: 31010, cityId: 382, code: "110019" },
    { id: 31011, cityId: 382, code: "110022" },
    { id: 31012, cityId: 382, code: "110024" },
    { id: 31013, cityId: 382, code: "110025" },
    { id: 31014, cityId: 382, code: "110027" },
    { id: 31015, cityId: 382, code: "110030" },
    { id: 31016, cityId: 382, code: "110032" },
    { id: 31017, cityId: 382, code: "110033" },
    { id: 31018, cityId: 382, code: "110035" },
    { id: 31019, cityId: 382, code: "110038" },
    { id: 31020, cityId: 382, code: "110040" },
    { id: 31021, cityId: 382, code: "110041" },
    { id: 31022, cityId: 382, code: "110043" },
    { id: 31023, cityId: 382, code: "110046" },
    { id: 31024, cityId: 382, code: "110048" },
    { id: 31025, cityId: 382, code: "110049" },
    { id: 31026, cityId: 382, code: "110051" },
    { id: 31027, cityId: 382, code: "110053" },
    { id: 31028, cityId: 382, code: "110054" },
    { id: 31029, cityId: 382, code: "110056" },
    { id: 31030, cityId: 382, code: "110059" },
    { id: 31031, cityId: 382, code: "110061" },
    { id: 31032, cityId: 382, code: "110062" },
    { id: 31033, cityId: 382, code: "110064" },
    { id: 31034, cityId: 382, code: "110067" },
    { id: 31035, cityId: 382, code: "110072" },
    { id: 31036, cityId: 382, code: "110075" },
    { id: 31037, cityId: 382, code: "110083" },
    { id: 31038, cityId: 382, code: "110085" },
    { id: 31039, cityId: 382, code: "110091" },
    { id: 31040, cityId: 382, code: "110093" },
    { id: 31041, cityId: 382, code: "110094" },
    { id: 31042, cityId: 382, code: "110096" },
    { id: 31043, cityId: 383, code: "403508" },
    { id: 31044, cityId: 384, code: "403601" },
    { id: 31045, cityId: 385, code: "403516" },
    { id: 31046, cityId: 386, code: "403702" },
    { id: 31047, cityId: 387, code: "403515" },
    { id: 31048, cityId: 388, code: "403711" },
    { id: 31049, cityId: 389, code: "403513" },
    { id: 31050, cityId: 390, code: "403703" },
    { id: 31051, cityId: 391, code: "403108" },
    { id: 31052, cityId: 392, code: "403601" },
    { id: 31053, cityId: 392, code: "403602" },
    { id: 31054, cityId: 392, code: "403604" },
    { id: 31055, cityId: 392, code: "403705" },
    { id: 31056, cityId: 392, code: "403708" },
    { id: 31057, cityId: 392, code: "403710" },
    { id: 31058, cityId: 392, code: "403713" },
    { id: 31059, cityId: 392, code: "403716" },
    { id: 31060, cityId: 392, code: "403718" },
    { id: 31061, cityId: 392, code: "403721" },
    { id: 31062, cityId: 392, code: "403723" },
    { id: 31063, cityId: 392, code: "403724" },
    { id: 31064, cityId: 392, code: "403729" },
    { id: 31065, cityId: 392, code: "403803" },
    { id: 31066, cityId: 392, code: "403110" },
    { id: 31067, cityId: 392, code: "403603" },
    { id: 31068, cityId: 392, code: "403701" },
    { id: 31069, cityId: 392, code: "403704" },
    { id: 31070, cityId: 392, code: "403706" },
    { id: 31071, cityId: 392, code: "403709" },
    { id: 31072, cityId: 392, code: "403712" },
    { id: 31073, cityId: 392, code: "403714" },
    { id: 31074, cityId: 392, code: "403717" },
    { id: 31075, cityId: 392, code: "403719" },
    { id: 31076, cityId: 392, code: "403720" },
    { id: 31077, cityId: 392, code: "403722" },
    { id: 31078, cityId: 392, code: "403725" },
    { id: 31079, cityId: 392, code: "403728" },
    { id: 31080, cityId: 392, code: "403801" },
    { id: 31081, cityId: 392, code: "403802" },
    { id: 31082, cityId: 393, code: "403707" },
    { id: 31083, cityId: 394, code: "403105" },
    { id: 31084, cityId: 395, code: "403006" },
    { id: 31085, cityId: 395, code: "403101" },
    { id: 31086, cityId: 395, code: "403103" },
    { id: 31087, cityId: 395, code: "403104" },
    { id: 31088, cityId: 395, code: "403106" },
    { id: 31089, cityId: 395, code: "403111" },
    { id: 31090, cityId: 395, code: "403204" },
    { id: 31091, cityId: 395, code: "403403" },
    { id: 31092, cityId: 395, code: "403501" },
    { id: 31093, cityId: 395, code: "403503" },
    { id: 31094, cityId: 395, code: "403509" },
    { id: 31095, cityId: 395, code: "403519" },
    { id: 31096, cityId: 395, code: "403527" },
    { id: 31097, cityId: 395, code: "403001" },
    { id: 31098, cityId: 395, code: "403002" },
    { id: 31099, cityId: 395, code: "403004" },
    { id: 31100, cityId: 395, code: "403102" },
    { id: 31101, cityId: 395, code: "403107" },
    { id: 31102, cityId: 395, code: "403112" },
    { id: 31103, cityId: 395, code: "403203" },
    { id: 31104, cityId: 395, code: "403402" },
    { id: 31105, cityId: 395, code: "403404" },
    { id: 31106, cityId: 395, code: "403406" },
    { id: 31107, cityId: 395, code: "403407" },
    { id: 31108, cityId: 395, code: "403502" },
    { id: 31109, cityId: 395, code: "403505" },
    { id: 31110, cityId: 395, code: "403001" },
    { id: 31111, cityId: 395, code: "403510" },
    { id: 31112, cityId: 395, code: "403518" },
    { id: 31113, cityId: 395, code: "403521" },
    { id: 31114, cityId: 395, code: "403523" },
    { id: 31115, cityId: 395, code: "403526" },
    { id: 31116, cityId: 395, code: "403529" },
    { id: 31117, cityId: 395, code: "403727" },
    { id: 31118, cityId: 395, code: "403730" },
    { id: 31119, cityId: 396, code: "403512" },
    { id: 31120, cityId: 397, code: "403401" },
    { id: 31121, cityId: 398, code: "403408" },
    { id: 31122, cityId: 399, code: "403511" },
    { id: 31123, cityId: 400, code: "403505" },
    { id: 31124, cityId: 401, code: "403517" },
    { id: 31125, cityId: 402, code: "403506" },
    { id: 31126, cityId: 403, code: "396406" },
    { id: 31127, cityId: 404, code: "382421" },
    { id: 31128, cityId: 405, code: "363610" },
    { id: 31129, cityId: 405, code: "380002" },
    { id: 31130, cityId: 405, code: "380005" },
    { id: 31131, cityId: 405, code: "380007" },
    { id: 31132, cityId: 405, code: "380008" },
    { id: 31133, cityId: 405, code: "380010" },
    { id: 31134, cityId: 405, code: "380013" },
    { id: 31135, cityId: 405, code: "380015" },
    { id: 31136, cityId: 405, code: "380018" },
    { id: 31137, cityId: 405, code: "380021" },
    { id: 31138, cityId: 405, code: "380023" },
    { id: 31139, cityId: 405, code: "380026" },
    { id: 31140, cityId: 405, code: "380028" },
    { id: 31141, cityId: 405, code: "380050" },
    { id: 31142, cityId: 405, code: "380052" },
    { id: 31143, cityId: 405, code: "380053" },
    { id: 31144, cityId: 405, code: "380055" },
    { id: 31145, cityId: 405, code: "380061" },
    { id: 31146, cityId: 405, code: "382110" },
    { id: 31147, cityId: 405, code: "382115" },
    { id: 31148, cityId: 405, code: "382140" },
    { id: 31149, cityId: 405, code: "382145" },
    { id: 31150, cityId: 405, code: "382150" },
    { id: 31151, cityId: 405, code: "382155" },
    { id: 31152, cityId: 405, code: "382160" },
    { id: 31153, cityId: 405, code: "382166" },
    { id: 31154, cityId: 405, code: "382213" },
    { id: 31155, cityId: 405, code: "382230" },
    { id: 31156, cityId: 405, code: "382240" },
    { id: 31157, cityId: 405, code: "382325" },
    { id: 31158, cityId: 405, code: "382327" },
    { id: 31159, cityId: 405, code: "382330" },
    { id: 31160, cityId: 405, code: "382346" },
    { id: 31161, cityId: 405, code: "382352" },
    { id: 31162, cityId: 405, code: "382410" },
    { id: 31163, cityId: 405, code: "382415" },
    { id: 31164, cityId: 405, code: "382418" },
    { id: 31165, cityId: 405, code: "382425" },
    { id: 31166, cityId: 405, code: "382426" },
    { id: 31167, cityId: 405, code: "382433" },
    { id: 31168, cityId: 405, code: "382449" },
    { id: 31169, cityId: 405, code: "382450" },
    { id: 31170, cityId: 405, code: "382455" },
    { id: 31171, cityId: 405, code: "382463" },
    { id: 31172, cityId: 405, code: "382465" },
    { id: 31173, cityId: 405, code: "380001" },
    { id: 31174, cityId: 405, code: "380003" },
    { id: 31175, cityId: 405, code: "380004" },
    { id: 31176, cityId: 405, code: "380006" },
    { id: 31177, cityId: 405, code: "380009" },
    { id: 31178, cityId: 405, code: "380012" },
    { id: 31179, cityId: 405, code: "380014" },
    { id: 31180, cityId: 405, code: "380016" },
    { id: 31181, cityId: 405, code: "380019" },
    { id: 31182, cityId: 405, code: "380022" },
    { id: 31183, cityId: 405, code: "380024" },
    { id: 31184, cityId: 405, code: "380025" },
    { id: 31185, cityId: 405, code: "380027" },
    { id: 31186, cityId: 405, code: "380051" },
    { id: 31187, cityId: 405, code: "380054" },
    { id: 31188, cityId: 405, code: "382120" },
    { id: 31189, cityId: 405, code: "382130" },
    { id: 31190, cityId: 405, code: "382165" },
    { id: 31191, cityId: 405, code: "382170" },
    { id: 31192, cityId: 405, code: "382220" },
    { id: 31193, cityId: 405, code: "382250" },
    { id: 31194, cityId: 405, code: "382255" },
    { id: 31195, cityId: 405, code: "382260" },
    { id: 31196, cityId: 405, code: "382265" },
    { id: 31197, cityId: 405, code: "382270" },
    { id: 31198, cityId: 405, code: "382305" },
    { id: 31199, cityId: 405, code: "382308" },
    { id: 31200, cityId: 405, code: "382310" },
    { id: 31201, cityId: 405, code: "382315" },
    { id: 31202, cityId: 405, code: "382316" },
    { id: 31203, cityId: 405, code: "382340" },
    { id: 31204, cityId: 405, code: "382345" },
    { id: 31205, cityId: 405, code: "382350" },
    { id: 31206, cityId: 405, code: "382355" },
    { id: 31207, cityId: 405, code: "382360" },
    { id: 31208, cityId: 405, code: "382405" },
    { id: 31209, cityId: 405, code: "382430" },
    { id: 31210, cityId: 405, code: "382440" },
    { id: 31211, cityId: 405, code: "382443" },
    { id: 31212, cityId: 405, code: "382445" },
    { id: 31213, cityId: 405, code: "382451" },
    { id: 31214, cityId: 405, code: "382475" },
    { id: 31215, cityId: 405, code: "387810" },
    { id: 31216, cityId: 406, code: "385110" },
    { id: 31217, cityId: 407, code: "364432" },
    { id: 31218, cityId: 407, code: "364435" },
    { id: 31219, cityId: 407, code: "364440" },
    { id: 31220, cityId: 407, code: "364445" },
    { id: 31221, cityId: 407, code: "364450" },
    { id: 31222, cityId: 407, code: "364456" },
    { id: 31223, cityId: 407, code: "364458" },
    { id: 31224, cityId: 407, code: "364490" },
    { id: 31225, cityId: 407, code: "364535" },
    { id: 31226, cityId: 407, code: "364565" },
    { id: 31227, cityId: 407, code: "364570" },
    { id: 31228, cityId: 407, code: "364601" },
    { id: 31229, cityId: 407, code: "364610" },
    { id: 31230, cityId: 407, code: "364615" },
    { id: 31231, cityId: 407, code: "364620" },
    { id: 31232, cityId: 407, code: "364633" },
    { id: 31233, cityId: 407, code: "364641" },
    { id: 31234, cityId: 407, code: "364660" },
    { id: 31235, cityId: 407, code: "364431" },
    { id: 31236, cityId: 407, code: "364436" },
    { id: 31237, cityId: 407, code: "364455" },
    { id: 31238, cityId: 407, code: "364457" },
    { id: 31239, cityId: 407, code: "364460" },
    { id: 31240, cityId: 407, code: "364470" },
    { id: 31241, cityId: 407, code: "364481" },
    { id: 31242, cityId: 407, code: "364536" },
    { id: 31243, cityId: 407, code: "364545" },
    { id: 31244, cityId: 407, code: "364550" },
    { id: 31245, cityId: 407, code: "364616" },
    { id: 31246, cityId: 407, code: "364622" },
    { id: 31247, cityId: 407, code: "364632" },
    { id: 31248, cityId: 407, code: "364635" },
    { id: 31249, cityId: 407, code: "364640" },
    { id: 31250, cityId: 407, code: "364645" },
    { id: 31251, cityId: 407, code: "364650" },
    { id: 31252, cityId: 408, code: "380001" },
    { id: 31253, cityId: 408, code: "382721" },
    { id: 31254, cityId: 408, code: "388180" },
    { id: 31255, cityId: 408, code: "388212" },
    { id: 31256, cityId: 408, code: "388215" },
    { id: 31257, cityId: 408, code: "388305" },
    { id: 31258, cityId: 408, code: "388308" },
    { id: 31259, cityId: 408, code: "388310" },
    { id: 31260, cityId: 408, code: "388340" },
    { id: 31261, cityId: 408, code: "388355" },
    { id: 31262, cityId: 408, code: "388360" },
    { id: 31263, cityId: 408, code: "388390" },
    { id: 31264, cityId: 408, code: "388461" },
    { id: 31265, cityId: 408, code: "388520" },
    { id: 31266, cityId: 408, code: "388530" },
    { id: 31267, cityId: 408, code: "388543" },
    { id: 31268, cityId: 408, code: "388570" },
    { id: 31269, cityId: 408, code: "388580" },
    { id: 31270, cityId: 408, code: "388585" },
    { id: 31271, cityId: 408, code: "388625" },
    { id: 31272, cityId: 408, code: "388641" },
    { id: 31273, cityId: 408, code: "389348" },
    { id: 31274, cityId: 408, code: "390016" },
    { id: 31275, cityId: 408, code: "370465" },
    { id: 31276, cityId: 408, code: "388001" },
    { id: 31277, cityId: 408, code: "388110" },
    { id: 31278, cityId: 408, code: "388131" },
    { id: 31279, cityId: 408, code: "388132" },
    { id: 31280, cityId: 408, code: "388150" },
    { id: 31281, cityId: 408, code: "388160" },
    { id: 31282, cityId: 408, code: "388205" },
    { id: 31283, cityId: 408, code: "388211" },
    { id: 31284, cityId: 408, code: "388213" },
    { id: 31285, cityId: 408, code: "388216" },
    { id: 31286, cityId: 408, code: "388306" },
    { id: 31287, cityId: 408, code: "388320" },
    { id: 31288, cityId: 408, code: "388330" },
    { id: 31289, cityId: 408, code: "388336" },
    { id: 31290, cityId: 408, code: "388365" },
    { id: 31291, cityId: 408, code: "388370" },
    { id: 31292, cityId: 408, code: "388425" },
    { id: 31293, cityId: 408, code: "388470" },
    { id: 31294, cityId: 408, code: "388515" },
    { id: 31295, cityId: 408, code: "388544" },
    { id: 31296, cityId: 408, code: "388555" },
    { id: 31297, cityId: 408, code: "388640" },
    { id: 31298, cityId: 408, code: "391140" },
    { id: 31299, cityId: 408, code: "395005" },
    { id: 31300, cityId: 409, code: "393016" },
    { id: 31301, cityId: 410, code: "370110" },
    { id: 31302, cityId: 411, code: "396020" },
    { id: 31303, cityId: 412, code: "362620" },
    { id: 31304, cityId: 413, code: "382220" },
    { id: 31305, cityId: 414, code: "370140" },
    { id: 31306, cityId: 415, code: "360510" },
    { id: 31307, cityId: 416, code: "391810" },
    { id: 31308, cityId: 416, code: "391815" },
    { id: 31309, cityId: 416, code: "391816" },
    { id: 31310, cityId: 416, code: "391818" },
    { id: 31311, cityId: 416, code: "392001" },
    { id: 31312, cityId: 416, code: "392011" },
    { id: 31313, cityId: 416, code: "392012" },
    { id: 31314, cityId: 416, code: "392014" },
    { id: 31315, cityId: 416, code: "392020" },
    { id: 31316, cityId: 416, code: "392025" },
    { id: 31317, cityId: 416, code: "392030" },
    { id: 31318, cityId: 416, code: "392035" },
    { id: 31319, cityId: 416, code: "392040" },
    { id: 31320, cityId: 416, code: "392110" },
    { id: 31321, cityId: 416, code: "392115" },
    { id: 31322, cityId: 416, code: "392155" },
    { id: 31323, cityId: 416, code: "392160" },
    { id: 31324, cityId: 416, code: "392162" },
    { id: 31325, cityId: 416, code: "392163" },
    { id: 31326, cityId: 416, code: "392210" },
    { id: 31327, cityId: 416, code: "393002" },
    { id: 31328, cityId: 416, code: "393010" },
    { id: 31329, cityId: 416, code: "393018" },
    { id: 31330, cityId: 416, code: "393020" },
    { id: 31331, cityId: 416, code: "393021" },
    { id: 31332, cityId: 416, code: "393105" },
    { id: 31333, cityId: 416, code: "393110" },
    { id: 31334, cityId: 416, code: "393111" },
    { id: 31335, cityId: 416, code: "393135" },
    { id: 31336, cityId: 416, code: "393145" },
    { id: 31337, cityId: 416, code: "393151" },
    { id: 31338, cityId: 416, code: "393155" },
    { id: 31339, cityId: 416, code: "394115" },
    { id: 31340, cityId: 416, code: "391170" },
    { id: 31341, cityId: 416, code: "391817" },
    { id: 31342, cityId: 416, code: "392002" },
    { id: 31343, cityId: 416, code: "392013" },
    { id: 31344, cityId: 416, code: "392015" },
    { id: 31345, cityId: 416, code: "392021" },
    { id: 31346, cityId: 416, code: "392026" },
    { id: 31347, cityId: 416, code: "392031" },
    { id: 31348, cityId: 416, code: "392111" },
    { id: 31349, cityId: 416, code: "392130" },
    { id: 31350, cityId: 416, code: "392140" },
    { id: 31351, cityId: 416, code: "392150" },
    { id: 31352, cityId: 416, code: "392153" },
    { id: 31353, cityId: 416, code: "392161" },
    { id: 31354, cityId: 416, code: "392180" },
    { id: 31355, cityId: 416, code: "392230" },
    { id: 31356, cityId: 416, code: "392240" },
    { id: 31357, cityId: 416, code: "393001" },
    { id: 31358, cityId: 416, code: "393017" },
    { id: 31359, cityId: 416, code: "393030" },
    { id: 31360, cityId: 416, code: "393107" },
    { id: 31361, cityId: 416, code: "393115" },
    { id: 31362, cityId: 416, code: "393120" },
    { id: 31363, cityId: 416, code: "393125" },
    { id: 31364, cityId: 416, code: "393130" },
    { id: 31365, cityId: 416, code: "394114" },
    { id: 31366, cityId: 416, code: "394810" },
    { id: 31367, cityId: 417, code: "364002" },
    { id: 31368, cityId: 417, code: "364005" },
    { id: 31369, cityId: 417, code: "364021" },
    { id: 31370, cityId: 417, code: "364050" },
    { id: 31371, cityId: 417, code: "364055" },
    { id: 31372, cityId: 417, code: "364061" },
    { id: 31373, cityId: 417, code: "364071" },
    { id: 31374, cityId: 417, code: "364135" },
    { id: 31375, cityId: 417, code: "364145" },
    { id: 31376, cityId: 417, code: "364150" },
    { id: 31377, cityId: 417, code: "364151" },
    { id: 31378, cityId: 417, code: "364225" },
    { id: 31379, cityId: 417, code: "364230" },
    { id: 31380, cityId: 417, code: "364240" },
    { id: 31381, cityId: 417, code: "364241" },
    { id: 31382, cityId: 417, code: "364251" },
    { id: 31383, cityId: 417, code: "364262" },
    { id: 31384, cityId: 417, code: "364265" },
    { id: 31385, cityId: 417, code: "364270" },
    { id: 31386, cityId: 417, code: "364275" },
    { id: 31387, cityId: 417, code: "364280" },
    { id: 31388, cityId: 417, code: "364293" },
    { id: 31389, cityId: 417, code: "364296" },
    { id: 31390, cityId: 417, code: "364310" },
    { id: 31391, cityId: 417, code: "364312" },
    { id: 31392, cityId: 417, code: "364315" },
    { id: 31393, cityId: 417, code: "364330" },
    { id: 31394, cityId: 417, code: "364365" },
    { id: 31395, cityId: 417, code: "364410" },
    { id: 31396, cityId: 417, code: "364421" },
    { id: 31397, cityId: 417, code: "364505" },
    { id: 31398, cityId: 417, code: "364506" },
    { id: 31399, cityId: 417, code: "364508" },
    { id: 31400, cityId: 417, code: "364518" },
    { id: 31401, cityId: 417, code: "364519" },
    { id: 31402, cityId: 417, code: "364521" },
    { id: 31403, cityId: 417, code: "364524" },
    { id: 31404, cityId: 417, code: "364526" },
    { id: 31405, cityId: 417, code: "364561" },
    { id: 31406, cityId: 417, code: "364710" },
    { id: 31407, cityId: 417, code: "364712" },
    { id: 31408, cityId: 417, code: "364714" },
    { id: 31409, cityId: 417, code: "364720" },
    { id: 31410, cityId: 417, code: "364730" },
    { id: 31411, cityId: 417, code: "364741" },
    { id: 31412, cityId: 417, code: "364760" },
    { id: 31413, cityId: 417, code: "364765" },
    { id: 31414, cityId: 417, code: "364001" },
    { id: 31415, cityId: 417, code: "364003" },
    { id: 31416, cityId: 417, code: "364004" },
    { id: 31417, cityId: 417, code: "364006" },
    { id: 31418, cityId: 417, code: "364022" },
    { id: 31419, cityId: 417, code: "364070" },
    { id: 31420, cityId: 417, code: "364110" },
    { id: 31421, cityId: 417, code: "364120" },
    { id: 31422, cityId: 417, code: "364130" },
    { id: 31423, cityId: 417, code: "364131" },
    { id: 31424, cityId: 417, code: "364146" },
    { id: 31425, cityId: 417, code: "364210" },
    { id: 31426, cityId: 417, code: "364215" },
    { id: 31427, cityId: 417, code: "364231" },
    { id: 31428, cityId: 417, code: "364245" },
    { id: 31429, cityId: 417, code: "364260" },
    { id: 31430, cityId: 417, code: "364261" },
    { id: 31431, cityId: 417, code: "364276" },
    { id: 31432, cityId: 417, code: "364290" },
    { id: 31433, cityId: 417, code: "364292" },
    { id: 31434, cityId: 417, code: "364295" },
    { id: 31435, cityId: 417, code: "364297" },
    { id: 31436, cityId: 417, code: "364298" },
    { id: 31437, cityId: 417, code: "364311" },
    { id: 31438, cityId: 417, code: "364313" },
    { id: 31439, cityId: 417, code: "364335" },
    { id: 31440, cityId: 417, code: "364507" },
    { id: 31441, cityId: 417, code: "364510" },
    { id: 31442, cityId: 417, code: "364515" },
    { id: 31443, cityId: 417, code: "364517" },
    { id: 31444, cityId: 417, code: "364522" },
    { id: 31445, cityId: 417, code: "364523" },
    { id: 31446, cityId: 417, code: "364525" },
    { id: 31447, cityId: 417, code: "364530" },
    { id: 31448, cityId: 417, code: "364713" },
    { id: 31449, cityId: 417, code: "364740" },
    { id: 31450, cityId: 417, code: "364750" },
    { id: 31451, cityId: 418, code: "360450" },
    { id: 31452, cityId: 419, code: "370007" },
    { id: 31453, cityId: 419, code: "370015" },
    { id: 31454, cityId: 419, code: "370020" },
    { id: 31455, cityId: 419, code: "370105" },
    { id: 31456, cityId: 419, code: "370110" },
    { id: 31457, cityId: 419, code: "370132" },
    { id: 31458, cityId: 419, code: "370145" },
    { id: 31459, cityId: 419, code: "370147" },
    { id: 31460, cityId: 419, code: "370150" },
    { id: 31461, cityId: 419, code: "370155" },
    { id: 31462, cityId: 419, code: "370156" },
    { id: 31463, cityId: 419, code: "370168" },
    { id: 31464, cityId: 419, code: "370169" },
    { id: 31465, cityId: 419, code: "370203" },
    { id: 31466, cityId: 419, code: "370230" },
    { id: 31467, cityId: 419, code: "370240" },
    { id: 31468, cityId: 419, code: "370405" },
    { id: 31469, cityId: 419, code: "370410" },
    { id: 31470, cityId: 419, code: "370415" },
    { id: 31471, cityId: 419, code: "370425" },
    { id: 31472, cityId: 419, code: "370450" },
    { id: 31473, cityId: 419, code: "370455" },
    { id: 31474, cityId: 419, code: "370460" },
    { id: 31475, cityId: 419, code: "370465" },
    { id: 31476, cityId: 419, code: "370471" },
    { id: 31477, cityId: 419, code: "370510" },
    { id: 31478, cityId: 419, code: "370515" },
    { id: 31479, cityId: 419, code: "370605" },
    { id: 31480, cityId: 419, code: "370627" },
    { id: 31481, cityId: 419, code: "370630" },
    { id: 31482, cityId: 419, code: "370635" },
    { id: 31483, cityId: 419, code: "370640" },
    { id: 31484, cityId: 419, code: "370645" },
    { id: 31485, cityId: 419, code: "370675" },
    { id: 31486, cityId: 419, code: "370001" },
    { id: 31487, cityId: 419, code: "370006" },
    { id: 31488, cityId: 419, code: "370030" },
    { id: 31489, cityId: 419, code: "370040" },
    { id: 31490, cityId: 419, code: "370061" },
    { id: 31491, cityId: 419, code: "370130" },
    { id: 31492, cityId: 419, code: "370135" },
    { id: 31493, cityId: 419, code: "370141" },
    { id: 31494, cityId: 419, code: "370146" },
    { id: 31495, cityId: 419, code: "370157" },
    { id: 31496, cityId: 419, code: "370160" },
    { id: 31497, cityId: 419, code: "370165" },
    { id: 31498, cityId: 419, code: "370170" },
    { id: 31499, cityId: 419, code: "370205" },
    { id: 31500, cityId: 419, code: "370210" },
    { id: 31501, cityId: 419, code: "370406" },
    { id: 31502, cityId: 419, code: "370411" },
    { id: 31503, cityId: 419, code: "370427" },
    { id: 31504, cityId: 419, code: "370429" },
    { id: 31505, cityId: 419, code: "370430" },
    { id: 31506, cityId: 419, code: "370435" },
    { id: 31507, cityId: 419, code: "370440" },
    { id: 31508, cityId: 419, code: "370445" },
    { id: 31509, cityId: 419, code: "370472" },
    { id: 31510, cityId: 419, code: "370475" },
    { id: 31511, cityId: 419, code: "370485" },
    { id: 31512, cityId: 419, code: "370490" },
    { id: 31513, cityId: 419, code: "370610" },
    { id: 31514, cityId: 419, code: "370615" },
    { id: 31515, cityId: 419, code: "370620" },
    { id: 31516, cityId: 419, code: "370625" },
    { id: 31517, cityId: 419, code: "370650" },
    { id: 31518, cityId: 419, code: "370655" },
    { id: 31519, cityId: 419, code: "370660" },
    { id: 31520, cityId: 419, code: "370665" },
    { id: 31521, cityId: 419, code: "370670" },
    { id: 31522, cityId: 420, code: "391135" },
    { id: 31523, cityId: 421, code: "382712" },
    { id: 31524, cityId: 421, code: "387310" },
    { id: 31525, cityId: 422, code: "388540" },
    { id: 31526, cityId: 423, code: "364710" },
    { id: 31527, cityId: 424, code: "387315" },
    { id: 31528, cityId: 425, code: "364630" },
    { id: 31529, cityId: 426, code: "394305" },
    { id: 31530, cityId: 427, code: "384220" },
    { id: 31531, cityId: 428, code: "360578" },
    { id: 31532, cityId: 429, code: "396521" },
    { id: 31533, cityId: 430, code: "362250" },
    { id: 31534, cityId: 431, code: "384328" },
    { id: 31535, cityId: 432, code: "382305" },
    { id: 31536, cityId: 433, code: "388225" },
    { id: 31537, cityId: 434, code: "364220" },
    { id: 31538, cityId: 435, code: "396380" },
    { id: 31539, cityId: 436, code: "382460" },
    { id: 31540, cityId: 437, code: "385310" },
    { id: 31541, cityId: 438, code: "396050" },
    { id: 31542, cityId: 439, code: "364320" },
    { id: 31543, cityId: 440, code: "387810" },
    { id: 31544, cityId: 441, code: "363310" },
    { id: 31545, cityId: 442, code: "361210" },
    { id: 31546, cityId: 443, code: "361140" },
    { id: 31547, cityId: 444, code: "360540" },
    { id: 31548, cityId: 444, code: "364537" },
    { id: 31549, cityId: 444, code: "364555" },
    { id: 31550, cityId: 444, code: "389135" },
    { id: 31551, cityId: 444, code: "389140" },
    { id: 31552, cityId: 444, code: "389156" },
    { id: 31553, cityId: 444, code: "389170" },
    { id: 31554, cityId: 444, code: "389172" },
    { id: 31555, cityId: 444, code: "389175" },
    { id: 31556, cityId: 444, code: "362231" },
    { id: 31557, cityId: 444, code: "389155" },
    { id: 31558, cityId: 444, code: "389157" },
    { id: 31559, cityId: 444, code: "389158" },
    { id: 31560, cityId: 444, code: "389382" },
    { id: 31561, cityId: 444, code: "396375" },
    { id: 31562, cityId: 445, code: "361335" },
    { id: 31563, cityId: 446, code: "396360" },
    { id: 31564, cityId: 447, code: "382010" },
    { id: 31565, cityId: 447, code: "382016" },
    { id: 31566, cityId: 447, code: "382020" },
    { id: 31567, cityId: 447, code: "382021" },
    { id: 31568, cityId: 447, code: "382023" },
    { id: 31569, cityId: 447, code: "382028" },
    { id: 31570, cityId: 447, code: "382029" },
    { id: 31571, cityId: 447, code: "382042" },
    { id: 31572, cityId: 447, code: "382320" },
    { id: 31573, cityId: 447, code: "382423" },
    { id: 31574, cityId: 447, code: "382481" },
    { id: 31575, cityId: 447, code: "382630" },
    { id: 31576, cityId: 447, code: "382640" },
    { id: 31577, cityId: 447, code: "382009" },
    { id: 31578, cityId: 447, code: "382017" },
    { id: 31579, cityId: 447, code: "382019" },
    { id: 31580, cityId: 447, code: "382022" },
    { id: 31581, cityId: 447, code: "382030" },
    { id: 31582, cityId: 447, code: "382041" },
    { id: 31583, cityId: 447, code: "382043" },
    { id: 31584, cityId: 447, code: "382051" },
    { id: 31585, cityId: 447, code: "382321" },
    { id: 31586, cityId: 447, code: "382422" },
    { id: 31587, cityId: 447, code: "382424" },
    { id: 31588, cityId: 447, code: "382470" },
    { id: 31589, cityId: 447, code: "382610" },
    { id: 31590, cityId: 447, code: "382620" },
    { id: 31591, cityId: 447, code: "382650" },
    { id: 31592, cityId: 448, code: "388270" },
    { id: 31593, cityId: 448, code: "388710" },
    { id: 31594, cityId: 448, code: "388712" },
    { id: 31595, cityId: 448, code: "388713" },
    { id: 31596, cityId: 448, code: "388715" },
    { id: 31597, cityId: 448, code: "389001" },
    { id: 31598, cityId: 448, code: "389110" },
    { id: 31599, cityId: 448, code: "389120" },
    { id: 31600, cityId: 448, code: "389121" },
    { id: 31601, cityId: 448, code: "389123" },
    { id: 31602, cityId: 448, code: "389160" },
    { id: 31603, cityId: 448, code: "389210" },
    { id: 31604, cityId: 448, code: "389232" },
    { id: 31605, cityId: 448, code: "389240" },
    { id: 31606, cityId: 448, code: "389250" },
    { id: 31607, cityId: 448, code: "389322" },
    { id: 31608, cityId: 448, code: "389330" },
    { id: 31609, cityId: 448, code: "389343" },
    { id: 31610, cityId: 448, code: "389345" },
    { id: 31611, cityId: 448, code: "389346" },
    { id: 31612, cityId: 448, code: "389351" },
    { id: 31613, cityId: 448, code: "389370" },
    { id: 31614, cityId: 448, code: "389380" },
    { id: 31615, cityId: 448, code: "389390" },
    { id: 31616, cityId: 448, code: "388711" },
    { id: 31617, cityId: 448, code: "388714" },
    { id: 31618, cityId: 448, code: "388716" },
    { id: 31619, cityId: 448, code: "389111" },
    { id: 31620, cityId: 448, code: "389122" },
    { id: 31621, cityId: 448, code: "389145" },
    { id: 31622, cityId: 448, code: "389151" },
    { id: 31623, cityId: 448, code: "389180" },
    { id: 31624, cityId: 448, code: "389190" },
    { id: 31625, cityId: 448, code: "389220" },
    { id: 31626, cityId: 448, code: "389230" },
    { id: 31627, cityId: 448, code: "389310" },
    { id: 31628, cityId: 448, code: "389320" },
    { id: 31629, cityId: 448, code: "389325" },
    { id: 31630, cityId: 448, code: "389341" },
    { id: 31631, cityId: 448, code: "389342" },
    { id: 31632, cityId: 448, code: "389344" },
    { id: 31633, cityId: 448, code: "389347" },
    { id: 31634, cityId: 448, code: "389350" },
    { id: 31635, cityId: 448, code: "389352" },
    { id: 31636, cityId: 448, code: "389355" },
    { id: 31637, cityId: 448, code: "389360" },
    { id: 31638, cityId: 448, code: "389365" },
    { id: 31639, cityId: 449, code: "389001" },
    { id: 31640, cityId: 450, code: "360311" },
    { id: 31641, cityId: 451, code: "389350" },
    { id: 31642, cityId: 452, code: "384240" },
    { id: 31643, cityId: 453, code: "383002" },
    { id: 31644, cityId: 453, code: "383010" },
    { id: 31645, cityId: 453, code: "383215" },
    { id: 31646, cityId: 453, code: "383220" },
    { id: 31647, cityId: 453, code: "383225" },
    { id: 31648, cityId: 453, code: "383230" },
    { id: 31649, cityId: 453, code: "383235" },
    { id: 31650, cityId: 453, code: "383246" },
    { id: 31651, cityId: 453, code: "383251" },
    { id: 31652, cityId: 453, code: "383260" },
    { id: 31653, cityId: 453, code: "383270" },
    { id: 31654, cityId: 453, code: "383275" },
    { id: 31655, cityId: 453, code: "383276" },
    { id: 31656, cityId: 453, code: "383305" },
    { id: 31657, cityId: 453, code: "383307" },
    { id: 31658, cityId: 453, code: "383310" },
    { id: 31659, cityId: 453, code: "383315" },
    { id: 31660, cityId: 453, code: "383320" },
    { id: 31661, cityId: 453, code: "383326" },
    { id: 31662, cityId: 453, code: "383331" },
    { id: 31663, cityId: 453, code: "383355" },
    { id: 31664, cityId: 453, code: "383410" },
    { id: 31665, cityId: 453, code: "383421" },
    { id: 31666, cityId: 453, code: "383434" },
    { id: 31667, cityId: 453, code: "383440" },
    { id: 31668, cityId: 453, code: "383450" },
    { id: 31669, cityId: 453, code: "383001" },
    { id: 31670, cityId: 453, code: "383030" },
    { id: 31671, cityId: 453, code: "383110" },
    { id: 31672, cityId: 453, code: "383120" },
    { id: 31673, cityId: 453, code: "383205" },
    { id: 31674, cityId: 453, code: "383210" },
    { id: 31675, cityId: 453, code: "383240" },
    { id: 31676, cityId: 453, code: "383245" },
    { id: 31677, cityId: 453, code: "383250" },
    { id: 31678, cityId: 453, code: "383255" },
    { id: 31679, cityId: 453, code: "383325" },
    { id: 31680, cityId: 453, code: "383327" },
    { id: 31681, cityId: 453, code: "383330" },
    { id: 31682, cityId: 453, code: "383332" },
    { id: 31683, cityId: 453, code: "383335" },
    { id: 31684, cityId: 453, code: "383340" },
    { id: 31685, cityId: 453, code: "383422" },
    { id: 31686, cityId: 453, code: "383430" },
    { id: 31687, cityId: 453, code: "383460" },
    { id: 31688, cityId: 453, code: "383462" },
    { id: 31689, cityId: 454, code: "383430" },
    { id: 31690, cityId: 455, code: "364540" },
    { id: 31691, cityId: 456, code: "396421" },
    { id: 31692, cityId: 457, code: "360530" },
    { id: 31693, cityId: 458, code: "360510" },
    { id: 31694, cityId: 458, code: "360515" },
    { id: 31695, cityId: 458, code: "360521" },
    { id: 31696, cityId: 458, code: "360531" },
    { id: 31697, cityId: 458, code: "360545" },
    { id: 31698, cityId: 458, code: "360592" },
    { id: 31699, cityId: 458, code: "360595" },
    { id: 31700, cityId: 458, code: "361003" },
    { id: 31701, cityId: 458, code: "361005" },
    { id: 31702, cityId: 458, code: "361006" },
    { id: 31703, cityId: 458, code: "361008" },
    { id: 31704, cityId: 458, code: "361011" },
    { id: 31705, cityId: 458, code: "361013" },
    { id: 31706, cityId: 458, code: "361130" },
    { id: 31707, cityId: 458, code: "361162" },
    { id: 31708, cityId: 458, code: "361170" },
    { id: 31709, cityId: 458, code: "361220" },
    { id: 31710, cityId: 458, code: "361230" },
    { id: 31711, cityId: 458, code: "361305" },
    { id: 31712, cityId: 458, code: "361315" },
    { id: 31713, cityId: 458, code: "361320" },
    { id: 31714, cityId: 458, code: "361321" },
    { id: 31715, cityId: 458, code: "361336" },
    { id: 31716, cityId: 458, code: "361347" },
    { id: 31717, cityId: 458, code: "361350" },
    { id: 31718, cityId: 458, code: "363665" },
    { id: 31719, cityId: 458, code: "363667" },
    { id: 31720, cityId: 458, code: "360405" },
    { id: 31721, cityId: 458, code: "360520" },
    { id: 31722, cityId: 458, code: "360530" },
    { id: 31723, cityId: 458, code: "361001" },
    { id: 31724, cityId: 458, code: "361002" },
    { id: 31725, cityId: 458, code: "361004" },
    { id: 31726, cityId: 458, code: "361007" },
    { id: 31727, cityId: 458, code: "361009" },
    { id: 31728, cityId: 458, code: "361010" },
    { id: 31729, cityId: 458, code: "361012" },
    { id: 31730, cityId: 458, code: "361110" },
    { id: 31731, cityId: 458, code: "361120" },
    { id: 31732, cityId: 458, code: "361150" },
    { id: 31733, cityId: 458, code: "361160" },
    { id: 31734, cityId: 458, code: "361240" },
    { id: 31735, cityId: 458, code: "361250" },
    { id: 31736, cityId: 458, code: "361280" },
    { id: 31737, cityId: 458, code: "361285" },
    { id: 31738, cityId: 458, code: "361290" },
    { id: 31739, cityId: 458, code: "361295" },
    { id: 31740, cityId: 458, code: "361301" },
    { id: 31741, cityId: 458, code: "361306" },
    { id: 31742, cityId: 458, code: "361316" },
    { id: 31743, cityId: 458, code: "361322" },
    { id: 31744, cityId: 458, code: "361325" },
    { id: 31745, cityId: 458, code: "361330" },
    { id: 31746, cityId: 458, code: "361335" },
    { id: 31747, cityId: 458, code: "363655" },
    { id: 31748, cityId: 458, code: "363660" },
    { id: 31749, cityId: 458, code: "363666" },
    { id: 31750, cityId: 458, code: "363668" },
    { id: 31751, cityId: 458, code: "363669" },
    { id: 31752, cityId: 459, code: "360050" },
    { id: 31753, cityId: 460, code: "360572" },
    { id: 31754, cityId: 460, code: "360575" },
    { id: 31755, cityId: 460, code: "360577" },
    { id: 31756, cityId: 460, code: "360579" },
    { id: 31757, cityId: 460, code: "360585" },
    { id: 31758, cityId: 460, code: "360590" },
    { id: 31759, cityId: 460, code: "362002" },
    { id: 31760, cityId: 460, code: "362004" },
    { id: 31761, cityId: 460, code: "362012" },
    { id: 31762, cityId: 460, code: "362013" },
    { id: 31763, cityId: 460, code: "362015" },
    { id: 31764, cityId: 460, code: "362020" },
    { id: 31765, cityId: 460, code: "362021" },
    { id: 31766, cityId: 460, code: "362036" },
    { id: 31767, cityId: 460, code: "362037" },
    { id: 31768, cityId: 460, code: "362110" },
    { id: 31769, cityId: 460, code: "362111" },
    { id: 31770, cityId: 460, code: "362132" },
    { id: 31771, cityId: 460, code: "362140" },
    { id: 31772, cityId: 460, code: "362142" },
    { id: 31773, cityId: 460, code: "362150" },
    { id: 31774, cityId: 460, code: "362155" },
    { id: 31775, cityId: 460, code: "362216" },
    { id: 31776, cityId: 460, code: "362222" },
    { id: 31777, cityId: 460, code: "362224" },
    { id: 31778, cityId: 460, code: "362225" },
    { id: 31779, cityId: 460, code: "362227" },
    { id: 31780, cityId: 460, code: "362230" },
    { id: 31781, cityId: 460, code: "362235" },
    { id: 31782, cityId: 460, code: "362240" },
    { id: 31783, cityId: 460, code: "362245" },
    { id: 31784, cityId: 460, code: "362246" },
    { id: 31785, cityId: 460, code: "362248" },
    { id: 31786, cityId: 460, code: "362256" },
    { id: 31787, cityId: 460, code: "362259" },
    { id: 31788, cityId: 460, code: "362267" },
    { id: 31789, cityId: 460, code: "362275" },
    { id: 31790, cityId: 460, code: "362278" },
    { id: 31791, cityId: 460, code: "362315" },
    { id: 31792, cityId: 460, code: "362510" },
    { id: 31793, cityId: 460, code: "362540" },
    { id: 31794, cityId: 460, code: "362550" },
    { id: 31795, cityId: 460, code: "362571" },
    { id: 31796, cityId: 460, code: "362624" },
    { id: 31797, cityId: 460, code: "362627" },
    { id: 31798, cityId: 460, code: "362630" },
    { id: 31799, cityId: 460, code: "362640" },
    { id: 31800, cityId: 460, code: "362653" },
    { id: 31801, cityId: 460, code: "362715" },
    { id: 31802, cityId: 460, code: "362720" },
    { id: 31803, cityId: 460, code: "362722" },
    { id: 31804, cityId: 460, code: "362725" },
    { id: 31805, cityId: 460, code: "362727" },
    { id: 31806, cityId: 460, code: "362730" },
    { id: 31807, cityId: 460, code: "362733" },
    { id: 31808, cityId: 460, code: "360560" },
    { id: 31809, cityId: 460, code: "360570" },
    { id: 31810, cityId: 460, code: "360571" },
    { id: 31811, cityId: 460, code: "360576" },
    { id: 31812, cityId: 460, code: "360583" },
    { id: 31813, cityId: 460, code: "362001" },
    { id: 31814, cityId: 460, code: "362003" },
    { id: 31815, cityId: 460, code: "362011" },
    { id: 31816, cityId: 460, code: "362014" },
    { id: 31817, cityId: 460, code: "362030" },
    { id: 31818, cityId: 460, code: "362120" },
    { id: 31819, cityId: 460, code: "362133" },
    { id: 31820, cityId: 460, code: "362135" },
    { id: 31821, cityId: 460, code: "362136" },
    { id: 31822, cityId: 460, code: "362151" },
    { id: 31823, cityId: 460, code: "362152" },
    { id: 31824, cityId: 460, code: "362205" },
    { id: 31825, cityId: 460, code: "362215" },
    { id: 31826, cityId: 460, code: "362220" },
    { id: 31827, cityId: 460, code: "362221" },
    { id: 31828, cityId: 460, code: "362223" },
    { id: 31829, cityId: 460, code: "362226" },
    { id: 31830, cityId: 460, code: "362228" },
    { id: 31831, cityId: 460, code: "362242" },
    { id: 31832, cityId: 460, code: "362247" },
    { id: 31833, cityId: 460, code: "362249" },
    { id: 31834, cityId: 460, code: "362255" },
    { id: 31835, cityId: 460, code: "362257" },
    { id: 31836, cityId: 460, code: "362258" },
    { id: 31837, cityId: 460, code: "362260" },
    { id: 31838, cityId: 460, code: "362263" },
    { id: 31839, cityId: 460, code: "362265" },
    { id: 31840, cityId: 460, code: "362266" },
    { id: 31841, cityId: 460, code: "362268" },
    { id: 31842, cityId: 460, code: "362271" },
    { id: 31843, cityId: 460, code: "362276" },
    { id: 31844, cityId: 460, code: "362310" },
    { id: 31845, cityId: 460, code: "362515" },
    { id: 31846, cityId: 460, code: "362520" },
    { id: 31847, cityId: 460, code: "362530" },
    { id: 31848, cityId: 460, code: "362551" },
    { id: 31849, cityId: 460, code: "362552" },
    { id: 31850, cityId: 460, code: "362560" },
    { id: 31851, cityId: 460, code: "362565" },
    { id: 31852, cityId: 460, code: "362570" },
    { id: 31853, cityId: 460, code: "362610" },
    { id: 31854, cityId: 460, code: "362615" },
    { id: 31855, cityId: 460, code: "362620" },
    { id: 31856, cityId: 460, code: "362621" },
    { id: 31857, cityId: 460, code: "362623" },
    { id: 31858, cityId: 460, code: "362625" },
    { id: 31859, cityId: 460, code: "362626" },
    { id: 31860, cityId: 460, code: "362633" },
    { id: 31861, cityId: 460, code: "362634" },
    { id: 31862, cityId: 460, code: "362652" },
    { id: 31863, cityId: 460, code: "362710" },
    { id: 31864, cityId: 460, code: "362721" },
    { id: 31865, cityId: 460, code: "362726" },
    { id: 31866, cityId: 461, code: "382715" },
    { id: 31867, cityId: 462, code: "394327" },
    { id: 31868, cityId: 463, code: "361160" },
    { id: 31869, cityId: 464, code: "382721" },
    { id: 31870, cityId: 465, code: "385520" },
    { id: 31871, cityId: 466, code: "388325" },
    { id: 31872, cityId: 467, code: "362220" },
    { id: 31873, cityId: 468, code: "361305" },
    { id: 31874, cityId: 469, code: "388620" },
    { id: 31875, cityId: 470, code: "382760" },
    { id: 31876, cityId: 471, code: "387411" },
    { id: 31877, cityId: 472, code: "383255" },
    { id: 31878, cityId: 473, code: "384325" },
    { id: 31879, cityId: 474, code: "362265" },
    { id: 31880, cityId: 475, code: "364430" },
    { id: 31881, cityId: 476, code: "363421" },
    { id: 31882, cityId: 477, code: "389230" },
    { id: 31883, cityId: 478, code: "382655" },
    { id: 31884, cityId: 478, code: "382705" },
    { id: 31885, cityId: 478, code: "382707" },
    { id: 31886, cityId: 478, code: "382708" },
    { id: 31887, cityId: 478, code: "382710" },
    { id: 31888, cityId: 478, code: "382713" },
    { id: 31889, cityId: 478, code: "382715" },
    { id: 31890, cityId: 478, code: "382716" },
    { id: 31891, cityId: 478, code: "382718" },
    { id: 31892, cityId: 478, code: "382721" },
    { id: 31893, cityId: 478, code: "382726" },
    { id: 31894, cityId: 478, code: "382728" },
    { id: 31895, cityId: 478, code: "382729" },
    { id: 31896, cityId: 478, code: "382731" },
    { id: 31897, cityId: 478, code: "382734" },
    { id: 31898, cityId: 478, code: "382736" },
    { id: 31899, cityId: 478, code: "382737" },
    { id: 31900, cityId: 478, code: "382739" },
    { id: 31901, cityId: 478, code: "382742" },
    { id: 31902, cityId: 478, code: "382805" },
    { id: 31903, cityId: 478, code: "382806" },
    { id: 31904, cityId: 478, code: "382816" },
    { id: 31905, cityId: 478, code: "382826" },
    { id: 31906, cityId: 478, code: "382832" },
    { id: 31907, cityId: 478, code: "382835" },
    { id: 31908, cityId: 478, code: "382840" },
    { id: 31909, cityId: 478, code: "382845" },
    { id: 31910, cityId: 478, code: "382850" },
    { id: 31911, cityId: 478, code: "382851" },
    { id: 31912, cityId: 478, code: "382856" },
    { id: 31913, cityId: 478, code: "382861" },
    { id: 31914, cityId: 478, code: "382871" },
    { id: 31915, cityId: 478, code: "382880" },
    { id: 31916, cityId: 478, code: "384002" },
    { id: 31917, cityId: 478, code: "384011" },
    { id: 31918, cityId: 478, code: "384111" },
    { id: 31919, cityId: 478, code: "384122" },
    { id: 31920, cityId: 478, code: "384130" },
    { id: 31921, cityId: 478, code: "384132" },
    { id: 31922, cityId: 478, code: "384140" },
    { id: 31923, cityId: 478, code: "384151" },
    { id: 31924, cityId: 478, code: "384153" },
    { id: 31925, cityId: 478, code: "384154" },
    { id: 31926, cityId: 478, code: "384170" },
    { id: 31927, cityId: 478, code: "384172" },
    { id: 31928, cityId: 478, code: "384175" },
    { id: 31929, cityId: 478, code: "384177" },
    { id: 31930, cityId: 478, code: "384178" },
    { id: 31931, cityId: 478, code: "384206" },
    { id: 31932, cityId: 478, code: "384207" },
    { id: 31933, cityId: 478, code: "384212" },
    { id: 31934, cityId: 478, code: "384215" },
    { id: 31935, cityId: 478, code: "384222" },
    { id: 31936, cityId: 478, code: "384225" },
    { id: 31937, cityId: 478, code: "384228" },
    { id: 31938, cityId: 478, code: "384230" },
    { id: 31939, cityId: 478, code: "384235" },
    { id: 31940, cityId: 478, code: "384241" },
    { id: 31941, cityId: 478, code: "384246" },
    { id: 31942, cityId: 478, code: "384257" },
    { id: 31943, cityId: 478, code: "384265" },
    { id: 31944, cityId: 478, code: "384270" },
    { id: 31945, cityId: 478, code: "384273" },
    { id: 31946, cityId: 478, code: "384275" },
    { id: 31947, cityId: 478, code: "384280" },
    { id: 31948, cityId: 478, code: "384291" },
    { id: 31949, cityId: 478, code: "384305" },
    { id: 31950, cityId: 478, code: "384310" },
    { id: 31951, cityId: 478, code: "384312" },
    { id: 31952, cityId: 478, code: "384315" },
    { id: 31953, cityId: 478, code: "384318" },
    { id: 31954, cityId: 478, code: "384320" },
    { id: 31955, cityId: 478, code: "384321" },
    { id: 31956, cityId: 478, code: "384323" },
    { id: 31957, cityId: 478, code: "384328" },
    { id: 31958, cityId: 478, code: "384350" },
    { id: 31959, cityId: 478, code: "384355" },
    { id: 31960, cityId: 478, code: "384360" },
    { id: 31961, cityId: 478, code: "384365" },
    { id: 31962, cityId: 478, code: "384410" },
    { id: 31963, cityId: 478, code: "384411" },
    { id: 31964, cityId: 478, code: "384421" },
    { id: 31965, cityId: 478, code: "384440" },
    { id: 31966, cityId: 478, code: "382704" },
    { id: 31967, cityId: 478, code: "382706" },
    { id: 31968, cityId: 478, code: "382709" },
    { id: 31969, cityId: 478, code: "382711" },
    { id: 31970, cityId: 478, code: "382717" },
    { id: 31971, cityId: 478, code: "382719" },
    { id: 31972, cityId: 478, code: "382725" },
    { id: 31973, cityId: 478, code: "382727" },
    { id: 31974, cityId: 478, code: "382730" },
    { id: 31975, cityId: 478, code: "382732" },
    { id: 31976, cityId: 478, code: "382733" },
    { id: 31977, cityId: 478, code: "382735" },
    { id: 31978, cityId: 478, code: "382741" },
    { id: 31979, cityId: 478, code: "382743" },
    { id: 31980, cityId: 478, code: "382810" },
    { id: 31981, cityId: 478, code: "382815" },
    { id: 31982, cityId: 478, code: "382820" },
    { id: 31983, cityId: 478, code: "382823" },
    { id: 31984, cityId: 478, code: "382825" },
    { id: 31985, cityId: 478, code: "382831" },
    { id: 31986, cityId: 478, code: "382833" },
    { id: 31987, cityId: 478, code: "382836" },
    { id: 31988, cityId: 478, code: "382855" },
    { id: 31989, cityId: 478, code: "382857" },
    { id: 31990, cityId: 478, code: "382860" },
    { id: 31991, cityId: 478, code: "382862" },
    { id: 31992, cityId: 478, code: "382863" },
    { id: 31993, cityId: 478, code: "382865" },
    { id: 31994, cityId: 478, code: "382867" },
    { id: 31995, cityId: 478, code: "382868" },
    { id: 31996, cityId: 478, code: "382870" },
    { id: 31997, cityId: 478, code: "382875" },
    { id: 31998, cityId: 478, code: "383781" },
    { id: 31999, cityId: 478, code: "384001" },
    { id: 32000, cityId: 478, code: "384120" },
    { id: 32001, cityId: 478, code: "384121" },
    { id: 32002, cityId: 478, code: "384131" },
    { id: 32003, cityId: 478, code: "384133" },
    { id: 32004, cityId: 478, code: "384152" },
    { id: 32005, cityId: 478, code: "384160" },
    { id: 32006, cityId: 478, code: "384165" },
    { id: 32007, cityId: 478, code: "384171" },
    { id: 32008, cityId: 478, code: "384174" },
    { id: 32009, cityId: 478, code: "384176" },
    { id: 32010, cityId: 478, code: "384205" },
    { id: 32011, cityId: 478, code: "384210" },
    { id: 32012, cityId: 478, code: "384211" },
    { id: 32013, cityId: 478, code: "384213" },
    { id: 32014, cityId: 478, code: "384221" },
    { id: 32015, cityId: 478, code: "384226" },
    { id: 32016, cityId: 478, code: "384227" },
    { id: 32017, cityId: 478, code: "384229" },
    { id: 32018, cityId: 478, code: "384231" },
    { id: 32019, cityId: 478, code: "384242" },
    { id: 32020, cityId: 478, code: "384245" },
    { id: 32021, cityId: 478, code: "384247" },
    { id: 32022, cityId: 478, code: "384250" },
    { id: 32023, cityId: 478, code: "384261" },
    { id: 32024, cityId: 478, code: "384272" },
    { id: 32025, cityId: 478, code: "384274" },
    { id: 32026, cityId: 478, code: "384285" },
    { id: 32027, cityId: 478, code: "384290" },
    { id: 32028, cityId: 478, code: "384292" },
    { id: 32029, cityId: 478, code: "384311" },
    { id: 32030, cityId: 478, code: "384319" },
    { id: 32031, cityId: 478, code: "384327" },
    { id: 32032, cityId: 478, code: "384329" },
    { id: 32033, cityId: 478, code: "384330" },
    { id: 32034, cityId: 478, code: "384335" },
    { id: 32035, cityId: 478, code: "384340" },
    { id: 32036, cityId: 478, code: "384345" },
    { id: 32037, cityId: 478, code: "384370" },
    { id: 32038, cityId: 478, code: "384375" },
    { id: 32039, cityId: 478, code: "384380" },
    { id: 32040, cityId: 478, code: "384385" },
    { id: 32041, cityId: 478, code: "384430" },
    { id: 32042, cityId: 478, code: "384435" },
    { id: 32043, cityId: 478, code: "384513" },
    { id: 32044, cityId: 478, code: "388230" },
    { id: 32045, cityId: 479, code: "387335" },
    { id: 32046, cityId: 480, code: "364290" },
    { id: 32047, cityId: 481, code: "383345" },
    { id: 32048, cityId: 482, code: "362630" },
    { id: 32049, cityId: 483, code: "370465" },
    { id: 32050, cityId: 484, code: "362225" },
    { id: 32051, cityId: 485, code: "383350" },
    { id: 32052, cityId: 486, code: "361345" },
    { id: 32053, cityId: 487, code: "383315" },
    { id: 32054, cityId: 488, code: "370421" },
    { id: 32055, cityId: 489, code: "387001" },
    { id: 32056, cityId: 489, code: "387002" },
    { id: 32057, cityId: 489, code: "387110" },
    { id: 32058, cityId: 489, code: "387113" },
    { id: 32059, cityId: 489, code: "387115" },
    { id: 32060, cityId: 489, code: "387230" },
    { id: 32061, cityId: 489, code: "387240" },
    { id: 32062, cityId: 489, code: "387320" },
    { id: 32063, cityId: 489, code: "387325" },
    { id: 32064, cityId: 489, code: "387330" },
    { id: 32065, cityId: 489, code: "387340" },
    { id: 32066, cityId: 489, code: "387365" },
    { id: 32067, cityId: 489, code: "387370" },
    { id: 32068, cityId: 489, code: "387375" },
    { id: 32069, cityId: 489, code: "387380" },
    { id: 32070, cityId: 489, code: "387385" },
    { id: 32071, cityId: 489, code: "387510" },
    { id: 32072, cityId: 489, code: "387515" },
    { id: 32073, cityId: 489, code: "387531" },
    { id: 32074, cityId: 489, code: "387550" },
    { id: 32075, cityId: 489, code: "387560" },
    { id: 32076, cityId: 489, code: "387635" },
    { id: 32077, cityId: 489, code: "387640" },
    { id: 32078, cityId: 489, code: "387650" },
    { id: 32079, cityId: 489, code: "387651" },
    { id: 32080, cityId: 489, code: "388122" },
    { id: 32081, cityId: 489, code: "388130" },
    { id: 32082, cityId: 489, code: "388140" },
    { id: 32083, cityId: 489, code: "388170" },
    { id: 32084, cityId: 489, code: "388217" },
    { id: 32085, cityId: 489, code: "388220" },
    { id: 32086, cityId: 489, code: "388225" },
    { id: 32087, cityId: 489, code: "388236" },
    { id: 32088, cityId: 489, code: "388238" },
    { id: 32089, cityId: 489, code: "388239" },
    { id: 32090, cityId: 489, code: "388254" },
    { id: 32091, cityId: 489, code: "388255" },
    { id: 32092, cityId: 489, code: "388257" },
    { id: 32093, cityId: 489, code: "388260" },
    { id: 32094, cityId: 489, code: "388262" },
    { id: 32095, cityId: 489, code: "388265" },
    { id: 32096, cityId: 489, code: "388267" },
    { id: 32097, cityId: 489, code: "388307" },
    { id: 32098, cityId: 489, code: "388315" },
    { id: 32099, cityId: 489, code: "388350" },
    { id: 32100, cityId: 489, code: "388410" },
    { id: 32101, cityId: 489, code: "388421" },
    { id: 32102, cityId: 489, code: "388435" },
    { id: 32103, cityId: 489, code: "388440" },
    { id: 32104, cityId: 489, code: "388445" },
    { id: 32105, cityId: 489, code: "388450" },
    { id: 32106, cityId: 489, code: "388466" },
    { id: 32107, cityId: 489, code: "388480" },
    { id: 32108, cityId: 489, code: "388485" },
    { id: 32109, cityId: 489, code: "388540" },
    { id: 32110, cityId: 489, code: "388556" },
    { id: 32111, cityId: 489, code: "388620" },
    { id: 32112, cityId: 489, code: "388630" },
    { id: 32113, cityId: 489, code: "387111" },
    { id: 32114, cityId: 489, code: "387120" },
    { id: 32115, cityId: 489, code: "387130" },
    { id: 32116, cityId: 489, code: "387135" },
    { id: 32117, cityId: 489, code: "387140" },
    { id: 32118, cityId: 489, code: "387210" },
    { id: 32119, cityId: 489, code: "387220" },
    { id: 32120, cityId: 489, code: "387305" },
    { id: 32121, cityId: 489, code: "387331" },
    { id: 32122, cityId: 489, code: "387345" },
    { id: 32123, cityId: 489, code: "387350" },
    { id: 32124, cityId: 489, code: "387355" },
    { id: 32125, cityId: 489, code: "387360" },
    { id: 32126, cityId: 489, code: "387366" },
    { id: 32127, cityId: 489, code: "387382" },
    { id: 32128, cityId: 489, code: "387421" },
    { id: 32129, cityId: 489, code: "387430" },
    { id: 32130, cityId: 489, code: "387435" },
    { id: 32131, cityId: 489, code: "387520" },
    { id: 32132, cityId: 489, code: "387530" },
    { id: 32133, cityId: 489, code: "387540" },
    { id: 32134, cityId: 489, code: "387570" },
    { id: 32135, cityId: 489, code: "387610" },
    { id: 32136, cityId: 489, code: "387620" },
    { id: 32137, cityId: 489, code: "387630" },
    { id: 32138, cityId: 489, code: "387655" },
    { id: 32139, cityId: 489, code: "387660" },
    { id: 32140, cityId: 489, code: "388001" },
    { id: 32141, cityId: 489, code: "388105" },
    { id: 32142, cityId: 489, code: "388120" },
    { id: 32143, cityId: 489, code: "388121" },
    { id: 32144, cityId: 489, code: "388226" },
    { id: 32145, cityId: 489, code: "388235" },
    { id: 32146, cityId: 489, code: "388240" },
    { id: 32147, cityId: 489, code: "388245" },
    { id: 32148, cityId: 489, code: "388250" },
    { id: 32149, cityId: 489, code: "388256" },
    { id: 32150, cityId: 489, code: "388258" },
    { id: 32151, cityId: 489, code: "388259" },
    { id: 32152, cityId: 489, code: "388261" },
    { id: 32153, cityId: 489, code: "388266" },
    { id: 32154, cityId: 489, code: "388335" },
    { id: 32155, cityId: 489, code: "388430" },
    { id: 32156, cityId: 489, code: "388460" },
    { id: 32157, cityId: 489, code: "388465" },
    { id: 32158, cityId: 489, code: "388510" },
    { id: 32159, cityId: 489, code: "388531" },
    { id: 32160, cityId: 489, code: "388545" },
    { id: 32161, cityId: 489, code: "388550" },
    { id: 32162, cityId: 489, code: "388560" },
    { id: 32163, cityId: 489, code: "388610" },
    { id: 32164, cityId: 489, code: "392165" },
    { id: 32165, cityId: 490, code: "382435" },
    { id: 32166, cityId: 491, code: "382812" },
    { id: 32167, cityId: 491, code: "385575" },
    { id: 32168, cityId: 491, code: "394430" },
    { id: 32169, cityId: 491, code: "396041" },
    { id: 32170, cityId: 491, code: "396110" },
    { id: 32171, cityId: 491, code: "396340" },
    { id: 32172, cityId: 491, code: "396350" },
    { id: 32173, cityId: 491, code: "396440" },
    { id: 32174, cityId: 491, code: "396475" },
    { id: 32175, cityId: 491, code: "363334" },
    { id: 32176, cityId: 491, code: "394352" },
    { id: 32177, cityId: 491, code: "396040" },
    { id: 32178, cityId: 491, code: "396042" },
    { id: 32179, cityId: 491, code: "396060" },
    { id: 32180, cityId: 491, code: "396310" },
    { id: 32181, cityId: 491, code: "396415" },
    { id: 32182, cityId: 491, code: "396424" },
    { id: 32183, cityId: 491, code: "396439" },
    { id: 32184, cityId: 491, code: "396445" },
    { id: 32185, cityId: 491, code: "396452" },
    { id: 32186, cityId: 491, code: "396463" },
    { id: 32187, cityId: 491, code: "396466" },
    { id: 32188, cityId: 491, code: "396469" },
    { id: 32189, cityId: 491, code: "396530" },
    { id: 32190, cityId: 491, code: "396540" },
    { id: 32191, cityId: 491, code: "396590" },
    { id: 32192, cityId: 492, code: "388210" },
    { id: 32193, cityId: 493, code: "360110" },
    { id: 32194, cityId: 494, code: "391440" },
    { id: 32195, cityId: 495, code: "385001" },
    { id: 32196, cityId: 495, code: "385012" },
    { id: 32197, cityId: 495, code: "385112" },
    { id: 32198, cityId: 495, code: "385120" },
    { id: 32199, cityId: 495, code: "385210" },
    { id: 32200, cityId: 495, code: "385325" },
    { id: 32201, cityId: 495, code: "385330" },
    { id: 32202, cityId: 495, code: "385340" },
    { id: 32203, cityId: 495, code: "385505" },
    { id: 32204, cityId: 495, code: "385510" },
    { id: 32205, cityId: 495, code: "385518" },
    { id: 32206, cityId: 495, code: "385521" },
    { id: 32207, cityId: 495, code: "385526" },
    { id: 32208, cityId: 495, code: "385531" },
    { id: 32209, cityId: 495, code: "385533" },
    { id: 32210, cityId: 495, code: "385541" },
    { id: 32211, cityId: 495, code: "385542" },
    { id: 32212, cityId: 495, code: "385550" },
    { id: 32213, cityId: 495, code: "385555" },
    { id: 32214, cityId: 495, code: "385566" },
    { id: 32215, cityId: 495, code: "385571" },
    { id: 32216, cityId: 495, code: "385586" },
    { id: 32217, cityId: 495, code: "385595" },
    { id: 32218, cityId: 495, code: "385002" },
    { id: 32219, cityId: 495, code: "385010" },
    { id: 32220, cityId: 495, code: "385011" },
    { id: 32221, cityId: 495, code: "385111" },
    { id: 32222, cityId: 495, code: "385130" },
    { id: 32223, cityId: 495, code: "385135" },
    { id: 32224, cityId: 495, code: "385215" },
    { id: 32225, cityId: 495, code: "385315" },
    { id: 32226, cityId: 495, code: "385320" },
    { id: 32227, cityId: 495, code: "385326" },
    { id: 32228, cityId: 495, code: "385350" },
    { id: 32229, cityId: 495, code: "385360" },
    { id: 32230, cityId: 495, code: "385410" },
    { id: 32231, cityId: 495, code: "385421" },
    { id: 32232, cityId: 495, code: "385506" },
    { id: 32233, cityId: 495, code: "385516" },
    { id: 32234, cityId: 495, code: "385517" },
    { id: 32235, cityId: 495, code: "385519" },
    { id: 32236, cityId: 495, code: "385522" },
    { id: 32237, cityId: 495, code: "385525" },
    { id: 32238, cityId: 495, code: "385530" },
    { id: 32239, cityId: 495, code: "385535" },
    { id: 32240, cityId: 495, code: "385540" },
    { id: 32241, cityId: 495, code: "385543" },
    { id: 32242, cityId: 495, code: "385545" },
    { id: 32243, cityId: 495, code: "385546" },
    { id: 32244, cityId: 495, code: "385551" },
    { id: 32245, cityId: 495, code: "385554" },
    { id: 32246, cityId: 495, code: "385570" },
    { id: 32247, cityId: 495, code: "385580" },
    { id: 32248, cityId: 495, code: "385585" },
    { id: 32249, cityId: 495, code: "385590" },
    { id: 32250, cityId: 496, code: "392220" },
    { id: 32251, cityId: 497, code: "364270" },
    { id: 32252, cityId: 498, code: "384110" },
    { id: 32253, cityId: 498, code: "384112" },
    { id: 32254, cityId: 498, code: "384255" },
    { id: 32255, cityId: 498, code: "384256" },
    { id: 32256, cityId: 498, code: "384260" },
    { id: 32257, cityId: 498, code: "384271" },
    { id: 32258, cityId: 498, code: "384276" },
    { id: 32259, cityId: 498, code: "384277" },
    { id: 32260, cityId: 498, code: "491111" },
    { id: 32261, cityId: 498, code: "364292" },
    { id: 32262, cityId: 498, code: "384265" },
    { id: 32263, cityId: 498, code: "384278" },
    { id: 32264, cityId: 498, code: "415206" },
    { id: 32265, cityId: 498, code: "483113" },
    { id: 32266, cityId: 499, code: "388450" },
    { id: 32267, cityId: 500, code: "360550" },
    { id: 32268, cityId: 500, code: "360560" },
    { id: 32269, cityId: 500, code: "360575" },
    { id: 32270, cityId: 500, code: "362265" },
    { id: 32271, cityId: 501, code: "383205" },
    { id: 32272, cityId: 502, code: "385340" },
    { id: 32273, cityId: 503, code: "360002" },
    { id: 32274, cityId: 503, code: "360003" },
    { id: 32275, cityId: 503, code: "360005" },
    { id: 32276, cityId: 503, code: "360035" },
    { id: 32277, cityId: 503, code: "360040" },
    { id: 32278, cityId: 503, code: "360050" },
    { id: 32279, cityId: 503, code: "360080" },
    { id: 32280, cityId: 503, code: "360320" },
    { id: 32281, cityId: 503, code: "360360" },
    { id: 32282, cityId: 503, code: "360410" },
    { id: 32283, cityId: 503, code: "360411" },
    { id: 32284, cityId: 503, code: "360421" },
    { id: 32285, cityId: 503, code: "360440" },
    { id: 32286, cityId: 503, code: "360450" },
    { id: 32287, cityId: 503, code: "360480" },
    { id: 32288, cityId: 503, code: "360490" },
    { id: 32289, cityId: 503, code: "363621" },
    { id: 32290, cityId: 503, code: "363642" },
    { id: 32291, cityId: 503, code: "363650" },
    { id: 32292, cityId: 503, code: "360001" },
    { id: 32293, cityId: 503, code: "360004" },
    { id: 32294, cityId: 503, code: "360006" },
    { id: 32295, cityId: 503, code: "360020" },
    { id: 32296, cityId: 503, code: "360022" },
    { id: 32297, cityId: 503, code: "360023" },
    { id: 32298, cityId: 503, code: "360025" },
    { id: 32299, cityId: 503, code: "360060" },
    { id: 32300, cityId: 503, code: "360070" },
    { id: 32301, cityId: 503, code: "360311" },
    { id: 32302, cityId: 503, code: "360335" },
    { id: 32303, cityId: 503, code: "360370" },
    { id: 32304, cityId: 503, code: "360375" },
    { id: 32305, cityId: 503, code: "360380" },
    { id: 32306, cityId: 503, code: "360430" },
    { id: 32307, cityId: 503, code: "360452" },
    { id: 32308, cityId: 503, code: "360460" },
    { id: 32309, cityId: 503, code: "360470" },
    { id: 32310, cityId: 503, code: "363622" },
    { id: 32311, cityId: 503, code: "363630" },
    { id: 32312, cityId: 503, code: "363636" },
    { id: 32313, cityId: 503, code: "363641" },
    { id: 32314, cityId: 503, code: "363670" },
    { id: 32315, cityId: 503, code: "364465" },
    { id: 32316, cityId: 503, code: "364485" },
    { id: 32317, cityId: 504, code: "389130" },
    { id: 32318, cityId: 504, code: "391120" },
    { id: 32319, cityId: 504, code: "391130" },
    { id: 32320, cityId: 504, code: "393040" },
    { id: 32321, cityId: 504, code: "393050" },
    { id: 32322, cityId: 504, code: "393140" },
    { id: 32323, cityId: 504, code: "382740" },
    { id: 32324, cityId: 504, code: "385515" },
    { id: 32325, cityId: 504, code: "391441" },
    { id: 32326, cityId: 504, code: "391780" },
    { id: 32327, cityId: 504, code: "393025" },
    { id: 32328, cityId: 504, code: "393145" },
    { id: 32329, cityId: 504, code: "393150" },
    { id: 32330, cityId: 505, code: "364560" },
    { id: 32331, cityId: 506, code: "387710" },
    { id: 32332, cityId: 507, code: "360550" },
    { id: 32333, cityId: 508, code: "382480" },
    { id: 32334, cityId: 509, code: "391350" },
    { id: 32335, cityId: 510, code: "394230" },
    { id: 32336, cityId: 511, code: "361310" },
    { id: 32337, cityId: 512, code: "382110" },
    { id: 32338, cityId: 513, code: "389260" },
    { id: 32339, cityId: 514, code: "364515" },
    { id: 32340, cityId: 515, code: "394130" },
    { id: 32341, cityId: 516, code: "384151" },
    { id: 32342, cityId: 517, code: "364240" },
    { id: 32343, cityId: 518, code: "364250" },
    { id: 32344, cityId: 519, code: "394105" },
    { id: 32345, cityId: 519, code: "394110" },
    { id: 32346, cityId: 519, code: "394120" },
    { id: 32347, cityId: 519, code: "394125" },
    { id: 32348, cityId: 519, code: "394150" },
    { id: 32349, cityId: 519, code: "394155" },
    { id: 32350, cityId: 519, code: "394160" },
    { id: 32351, cityId: 519, code: "394163" },
    { id: 32352, cityId: 519, code: "394170" },
    { id: 32353, cityId: 519, code: "394210" },
    { id: 32354, cityId: 519, code: "394221" },
    { id: 32355, cityId: 519, code: "394240" },
    { id: 32356, cityId: 519, code: "394242" },
    { id: 32357, cityId: 519, code: "394245" },
    { id: 32358, cityId: 519, code: "394250" },
    { id: 32359, cityId: 519, code: "394330" },
    { id: 32360, cityId: 519, code: "394335" },
    { id: 32361, cityId: 519, code: "394340" },
    { id: 32362, cityId: 519, code: "394345" },
    { id: 32363, cityId: 519, code: "394364" },
    { id: 32364, cityId: 519, code: "394375" },
    { id: 32365, cityId: 519, code: "394380" },
    { id: 32366, cityId: 519, code: "394510" },
    { id: 32367, cityId: 519, code: "394515" },
    { id: 32368, cityId: 519, code: "394520" },
    { id: 32369, cityId: 519, code: "394550" },
    { id: 32370, cityId: 519, code: "394631" },
    { id: 32371, cityId: 519, code: "394632" },
    { id: 32372, cityId: 519, code: "394640" },
    { id: 32373, cityId: 519, code: "394650" },
    { id: 32374, cityId: 519, code: "394655" },
    { id: 32375, cityId: 519, code: "394660" },
    { id: 32376, cityId: 519, code: "394690" },
    { id: 32377, cityId: 519, code: "395002" },
    { id: 32378, cityId: 519, code: "395005" },
    { id: 32379, cityId: 519, code: "395007" },
    { id: 32380, cityId: 519, code: "395008" },
    { id: 32381, cityId: 519, code: "394101" },
    { id: 32382, cityId: 519, code: "394140" },
    { id: 32383, cityId: 519, code: "394180" },
    { id: 32384, cityId: 519, code: "394185" },
    { id: 32385, cityId: 519, code: "394190" },
    { id: 32386, cityId: 519, code: "394220" },
    { id: 32387, cityId: 519, code: "394235" },
    { id: 32388, cityId: 519, code: "394241" },
    { id: 32389, cityId: 519, code: "394243" },
    { id: 32390, cityId: 519, code: "394244" },
    { id: 32391, cityId: 519, code: "394270" },
    { id: 32392, cityId: 519, code: "394310" },
    { id: 32393, cityId: 519, code: "394315" },
    { id: 32394, cityId: 519, code: "394317" },
    { id: 32395, cityId: 519, code: "394320" },
    { id: 32396, cityId: 519, code: "394325" },
    { id: 32397, cityId: 519, code: "394326" },
    { id: 32398, cityId: 519, code: "394350" },
    { id: 32399, cityId: 519, code: "394355" },
    { id: 32400, cityId: 519, code: "394360" },
    { id: 32401, cityId: 519, code: "394363" },
    { id: 32402, cityId: 519, code: "394365" },
    { id: 32403, cityId: 519, code: "394370" },
    { id: 32404, cityId: 519, code: "394378" },
    { id: 32405, cityId: 519, code: "394405" },
    { id: 32406, cityId: 519, code: "394410" },
    { id: 32407, cityId: 519, code: "394421" },
    { id: 32408, cityId: 519, code: "394440" },
    { id: 32409, cityId: 519, code: "394445" },
    { id: 32410, cityId: 519, code: "394530" },
    { id: 32411, cityId: 519, code: "394540" },
    { id: 32412, cityId: 519, code: "394600" },
    { id: 32413, cityId: 519, code: "394620" },
    { id: 32414, cityId: 519, code: "394630" },
    { id: 32415, cityId: 519, code: "394641" },
    { id: 32416, cityId: 519, code: "394670" },
    { id: 32417, cityId: 519, code: "394680" },
    { id: 32418, cityId: 519, code: "395001" },
    { id: 32419, cityId: 519, code: "395003" },
    { id: 32420, cityId: 519, code: "395004" },
    { id: 32421, cityId: 519, code: "395006" },
    { id: 32422, cityId: 519, code: "395009" },
    { id: 32423, cityId: 520, code: "363001" },
    { id: 32424, cityId: 520, code: "363020" },
    { id: 32425, cityId: 520, code: "363023" },
    { id: 32426, cityId: 520, code: "363030" },
    { id: 32427, cityId: 520, code: "363041" },
    { id: 32428, cityId: 520, code: "363110" },
    { id: 32429, cityId: 520, code: "363115" },
    { id: 32430, cityId: 520, code: "363330" },
    { id: 32431, cityId: 520, code: "363332" },
    { id: 32432, cityId: 520, code: "363333" },
    { id: 32433, cityId: 520, code: "363412" },
    { id: 32434, cityId: 520, code: "363415" },
    { id: 32435, cityId: 520, code: "363423" },
    { id: 32436, cityId: 520, code: "363425" },
    { id: 32437, cityId: 520, code: "363430" },
    { id: 32438, cityId: 520, code: "363510" },
    { id: 32439, cityId: 520, code: "363520" },
    { id: 32440, cityId: 520, code: "363626" },
    { id: 32441, cityId: 520, code: "382760" },
    { id: 32442, cityId: 520, code: "382765" },
    { id: 32443, cityId: 520, code: "382770" },
    { id: 32444, cityId: 520, code: "382775" },
    { id: 32445, cityId: 520, code: "382780" },
    { id: 32446, cityId: 520, code: "363002" },
    { id: 32447, cityId: 520, code: "363035" },
    { id: 32448, cityId: 520, code: "363040" },
    { id: 32449, cityId: 520, code: "363045" },
    { id: 32450, cityId: 520, code: "363310" },
    { id: 32451, cityId: 520, code: "363312" },
    { id: 32452, cityId: 520, code: "363315" },
    { id: 32453, cityId: 520, code: "363320" },
    { id: 32454, cityId: 520, code: "363331" },
    { id: 32455, cityId: 520, code: "363410" },
    { id: 32456, cityId: 520, code: "363411" },
    { id: 32457, cityId: 520, code: "363416" },
    { id: 32458, cityId: 520, code: "363421" },
    { id: 32459, cityId: 520, code: "363424" },
    { id: 32460, cityId: 520, code: "363426" },
    { id: 32461, cityId: 520, code: "363427" },
    { id: 32462, cityId: 520, code: "363435" },
    { id: 32463, cityId: 520, code: "363440" },
    { id: 32464, cityId: 520, code: "363535" },
    { id: 32465, cityId: 520, code: "382745" },
    { id: 32466, cityId: 520, code: "382750" },
    { id: 32467, cityId: 520, code: "382755" },
    { id: 32468, cityId: 521, code: "364140" },
    { id: 32469, cityId: 522, code: "383215" },
    { id: 32470, cityId: 523, code: "363530" },
    { id: 32471, cityId: 524, code: "385565" },
    { id: 32472, cityId: 525, code: "394720" },
    { id: 32473, cityId: 525, code: "394730" },
    { id: 32474, cityId: 525, code: "394710" },
    { id: 32475, cityId: 525, code: "394716" },
    { id: 32476, cityId: 526, code: "388220" },
    { id: 32477, cityId: 527, code: "247778" },
    { id: 32478, cityId: 527, code: "385560" },
    { id: 32479, cityId: 528, code: "384170" },
    { id: 32480, cityId: 529, code: "360490" },
    { id: 32481, cityId: 530, code: "364480" },
    { id: 32482, cityId: 531, code: "390001" },
    { id: 32483, cityId: 531, code: "390002" },
    { id: 32484, cityId: 531, code: "390004" },
    { id: 32485, cityId: 531, code: "390007" },
    { id: 32486, cityId: 531, code: "390009" },
    { id: 32487, cityId: 531, code: "390010" },
    { id: 32488, cityId: 531, code: "390012" },
    { id: 32489, cityId: 531, code: "390015" },
    { id: 32490, cityId: 531, code: "390017" },
    { id: 32491, cityId: 531, code: "390018" },
    { id: 32492, cityId: 531, code: "391101" },
    { id: 32493, cityId: 531, code: "391108" },
    { id: 32494, cityId: 531, code: "391111" },
    { id: 32495, cityId: 531, code: "391116" },
    { id: 32496, cityId: 531, code: "391125" },
    { id: 32497, cityId: 531, code: "391145" },
    { id: 32498, cityId: 531, code: "391146" },
    { id: 32499, cityId: 531, code: "391151" },
    { id: 32500, cityId: 531, code: "391156" },
    { id: 32501, cityId: 531, code: "391169" },
    { id: 32502, cityId: 531, code: "391175" },
    { id: 32503, cityId: 531, code: "391220" },
    { id: 32504, cityId: 531, code: "391230" },
    { id: 32505, cityId: 531, code: "391241" },
    { id: 32506, cityId: 531, code: "391243" },
    { id: 32507, cityId: 531, code: "391244" },
    { id: 32508, cityId: 531, code: "391310" },
    { id: 32509, cityId: 531, code: "391320" },
    { id: 32510, cityId: 531, code: "391347" },
    { id: 32511, cityId: 531, code: "391410" },
    { id: 32512, cityId: 531, code: "391421" },
    { id: 32513, cityId: 531, code: "391442" },
    { id: 32514, cityId: 531, code: "391445" },
    { id: 32515, cityId: 531, code: "391450" },
    { id: 32516, cityId: 531, code: "391530" },
    { id: 32517, cityId: 531, code: "391535" },
    { id: 32518, cityId: 531, code: "391750" },
    { id: 32519, cityId: 531, code: "391760" },
    { id: 32520, cityId: 531, code: "391773" },
    { id: 32521, cityId: 531, code: "392170" },
    { id: 32522, cityId: 531, code: "390003" },
    { id: 32523, cityId: 531, code: "390005" },
    { id: 32524, cityId: 531, code: "390006" },
    { id: 32525, cityId: 531, code: "390008" },
    { id: 32526, cityId: 531, code: "390011" },
    { id: 32527, cityId: 531, code: "390013" },
    { id: 32528, cityId: 531, code: "390014" },
    { id: 32529, cityId: 531, code: "390016" },
    { id: 32530, cityId: 531, code: "390019" },
    { id: 32531, cityId: 531, code: "391105" },
    { id: 32532, cityId: 531, code: "391107" },
    { id: 32533, cityId: 531, code: "391110" },
    { id: 32534, cityId: 531, code: "391115" },
    { id: 32535, cityId: 531, code: "391126" },
    { id: 32536, cityId: 531, code: "391136" },
    { id: 32537, cityId: 531, code: "391137" },
    { id: 32538, cityId: 531, code: "391141" },
    { id: 32539, cityId: 531, code: "391142" },
    { id: 32540, cityId: 531, code: "391150" },
    { id: 32541, cityId: 531, code: "391152" },
    { id: 32542, cityId: 531, code: "391155" },
    { id: 32543, cityId: 531, code: "391157" },
    { id: 32544, cityId: 531, code: "391160" },
    { id: 32545, cityId: 531, code: "391165" },
    { id: 32546, cityId: 531, code: "391168" },
    { id: 32547, cityId: 531, code: "391210" },
    { id: 32548, cityId: 531, code: "391240" },
    { id: 32549, cityId: 531, code: "391242" },
    { id: 32550, cityId: 531, code: "391245" },
    { id: 32551, cityId: 531, code: "391250" },
    { id: 32552, cityId: 531, code: "391330" },
    { id: 32553, cityId: 531, code: "391340" },
    { id: 32554, cityId: 531, code: "391345" },
    { id: 32555, cityId: 531, code: "391346" },
    { id: 32556, cityId: 531, code: "391430" },
    { id: 32557, cityId: 531, code: "391443" },
    { id: 32558, cityId: 531, code: "391460" },
    { id: 32559, cityId: 531, code: "391510" },
    { id: 32560, cityId: 531, code: "391520" },
    { id: 32561, cityId: 531, code: "391740" },
    { id: 32562, cityId: 531, code: "391745" },
    { id: 32563, cityId: 531, code: "391770" },
    { id: 32564, cityId: 531, code: "391774" },
    { id: 32565, cityId: 531, code: "391775" },
    { id: 32566, cityId: 531, code: "392310" },
    { id: 32567, cityId: 532, code: "396001" },
    { id: 32568, cityId: 532, code: "396006" },
    { id: 32569, cityId: 532, code: "396020" },
    { id: 32570, cityId: 532, code: "396025" },
    { id: 32571, cityId: 532, code: "396030" },
    { id: 32572, cityId: 532, code: "396035" },
    { id: 32573, cityId: 532, code: "396051" },
    { id: 32574, cityId: 532, code: "396065" },
    { id: 32575, cityId: 532, code: "396112" },
    { id: 32576, cityId: 532, code: "396115" },
    { id: 32577, cityId: 532, code: "396120" },
    { id: 32578, cityId: 532, code: "396125" },
    { id: 32579, cityId: 532, code: "396126" },
    { id: 32580, cityId: 532, code: "396142" },
    { id: 32581, cityId: 532, code: "396150" },
    { id: 32582, cityId: 532, code: "396155" },
    { id: 32583, cityId: 532, code: "396165" },
    { id: 32584, cityId: 532, code: "396170" },
    { id: 32585, cityId: 532, code: "396171" },
    { id: 32586, cityId: 532, code: "396195" },
    { id: 32587, cityId: 532, code: "396202" },
    { id: 32588, cityId: 532, code: "396210" },
    { id: 32589, cityId: 532, code: "396223" },
    { id: 32590, cityId: 532, code: "396240" },
    { id: 32591, cityId: 532, code: "396245" },
    { id: 32592, cityId: 532, code: "396321" },
    { id: 32593, cityId: 532, code: "396385" },
    { id: 32594, cityId: 532, code: "396403" },
    { id: 32595, cityId: 532, code: "396409" },
    { id: 32596, cityId: 532, code: "396412" },
    { id: 32597, cityId: 532, code: "396427" },
    { id: 32598, cityId: 532, code: "396430" },
    { id: 32599, cityId: 532, code: "396436" },
    { id: 32600, cityId: 532, code: "396443" },
    { id: 32601, cityId: 532, code: "396472" },
    { id: 32602, cityId: 532, code: "396510" },
    { id: 32603, cityId: 532, code: "396560" },
    { id: 32604, cityId: 532, code: "396570" },
    { id: 32605, cityId: 532, code: "396007" },
    { id: 32606, cityId: 532, code: "396031" },
    { id: 32607, cityId: 532, code: "396045" },
    { id: 32608, cityId: 532, code: "396055" },
    { id: 32609, cityId: 532, code: "396068" },
    { id: 32610, cityId: 532, code: "396105" },
    { id: 32611, cityId: 532, code: "396130" },
    { id: 32612, cityId: 532, code: "396135" },
    { id: 32613, cityId: 532, code: "396140" },
    { id: 32614, cityId: 532, code: "396145" },
    { id: 32615, cityId: 532, code: "396156" },
    { id: 32616, cityId: 532, code: "396175" },
    { id: 32617, cityId: 532, code: "396180" },
    { id: 32618, cityId: 532, code: "396185" },
    { id: 32619, cityId: 532, code: "396201" },
    { id: 32620, cityId: 532, code: "396217" },
    { id: 32621, cityId: 532, code: "396220" },
    { id: 32622, cityId: 532, code: "396230" },
    { id: 32623, cityId: 532, code: "396235" },
    { id: 32624, cityId: 532, code: "396236" },
    { id: 32625, cityId: 532, code: "396325" },
    { id: 32626, cityId: 532, code: "396370" },
    { id: 32627, cityId: 532, code: "396418" },
    { id: 32628, cityId: 532, code: "396424" },
    { id: 32629, cityId: 532, code: "396445" },
    { id: 32630, cityId: 532, code: "396450" },
    { id: 32631, cityId: 532, code: "396460" },
    { id: 32632, cityId: 532, code: "396580" },
    { id: 32633, cityId: 533, code: "396191" },
    { id: 32634, cityId: 534, code: "364060" },
    { id: 32635, cityId: 535, code: "382418" },
    { id: 32636, cityId: 536, code: "389340" },
    { id: 32637, cityId: 537, code: "362265" },
    { id: 32638, cityId: 538, code: "382870" },
    { id: 32639, cityId: 539, code: "382150" },
    { id: 32640, cityId: 540, code: "362130" },
    { id: 32641, cityId: 541, code: "384315" },
    { id: 32642, cityId: 542, code: "394650" },
    { id: 32643, cityId: 543, code: "363621" },
    { id: 32644, cityId: 544, code: "133005" },
    { id: 32645, cityId: 544, code: "133021" },
    { id: 32646, cityId: 544, code: "133101" },
    { id: 32647, cityId: 544, code: "133104" },
    { id: 32648, cityId: 544, code: "133201" },
    { id: 32649, cityId: 544, code: "133202" },
    { id: 32650, cityId: 544, code: "133204" },
    { id: 32651, cityId: 544, code: "133207" },
    { id: 32652, cityId: 544, code: "133302" },
    { id: 32653, cityId: 544, code: "134007" },
    { id: 32654, cityId: 544, code: "134012" },
    { id: 32655, cityId: 544, code: "134104" },
    { id: 32656, cityId: 544, code: "134107" },
    { id: 32657, cityId: 544, code: "134110" },
    { id: 32658, cityId: 544, code: "134112" },
    { id: 32659, cityId: 544, code: "134113" },
    { id: 32660, cityId: 544, code: "134202" },
    { id: 32661, cityId: 544, code: "134205" },
    { id: 32662, cityId: 544, code: "135002" },
    { id: 32663, cityId: 544, code: "135003" },
    { id: 32664, cityId: 544, code: "135021" },
    { id: 32665, cityId: 544, code: "135101" },
    { id: 32666, cityId: 544, code: "133001" },
    { id: 32667, cityId: 544, code: "133004" },
    { id: 32668, cityId: 544, code: "133102" },
    { id: 32669, cityId: 544, code: "133105" },
    { id: 32670, cityId: 544, code: "133203" },
    { id: 32671, cityId: 544, code: "133205" },
    { id: 32672, cityId: 544, code: "133206" },
    { id: 32673, cityId: 544, code: "133208" },
    { id: 32674, cityId: 544, code: "133301" },
    { id: 32675, cityId: 544, code: "134002" },
    { id: 32676, cityId: 544, code: "134003" },
    { id: 32677, cityId: 544, code: "134011" },
    { id: 32678, cityId: 544, code: "134101" },
    { id: 32679, cityId: 544, code: "134108" },
    { id: 32680, cityId: 544, code: "134109" },
    { id: 32681, cityId: 544, code: "134201" },
    { id: 32682, cityId: 544, code: "134206" },
    { id: 32683, cityId: 544, code: "135001" },
    { id: 32684, cityId: 544, code: "135104" },
    { id: 32685, cityId: 544, code: "135105" },
    { id: 32686, cityId: 545, code: "132039" },
    { id: 32687, cityId: 546, code: "124507" },
    { id: 32688, cityId: 547, code: "126010" },
    { id: 32689, cityId: 547, code: "134118" },
    { id: 32690, cityId: 548, code: "123501" },
    { id: 32691, cityId: 549, code: "125032" },
    { id: 32692, cityId: 550, code: "124201" },
    { id: 32693, cityId: 551, code: "123024" },
    { id: 32694, cityId: 551, code: "123026" },
    { id: 32695, cityId: 551, code: "123307" },
    { id: 32696, cityId: 551, code: "123310" },
    { id: 32697, cityId: 551, code: "125021" },
    { id: 32698, cityId: 551, code: "125023" },
    { id: 32699, cityId: 551, code: "125026" },
    { id: 32700, cityId: 551, code: "125028" },
    { id: 32701, cityId: 551, code: "125029" },
    { id: 32702, cityId: 551, code: "125031" },
    { id: 32703, cityId: 551, code: "125036" },
    { id: 32704, cityId: 551, code: "125037" },
    { id: 32705, cityId: 551, code: "125045" },
    { id: 32706, cityId: 551, code: "125061" },
    { id: 32707, cityId: 551, code: "125063" },
    { id: 32708, cityId: 551, code: "125066" },
    { id: 32709, cityId: 551, code: "125071" },
    { id: 32710, cityId: 551, code: "125074" },
    { id: 32711, cityId: 551, code: "123020" },
    { id: 32712, cityId: 551, code: "123025" },
    { id: 32713, cityId: 551, code: "123301" },
    { id: 32714, cityId: 551, code: "123306" },
    { id: 32715, cityId: 551, code: "123308" },
    { id: 32716, cityId: 551, code: "123309" },
    { id: 32717, cityId: 551, code: "125022" },
    { id: 32718, cityId: 551, code: "125024" },
    { id: 32719, cityId: 551, code: "125025" },
    { id: 32720, cityId: 551, code: "125027" },
    { id: 32721, cityId: 551, code: "125030" },
    { id: 32722, cityId: 551, code: "125041" },
    { id: 32723, cityId: 551, code: "125043" },
    { id: 32724, cityId: 551, code: "125046" },
    { id: 32725, cityId: 551, code: "125064" },
    { id: 32726, cityId: 551, code: "125065" },
    { id: 32727, cityId: 551, code: "125067" },
    { id: 32728, cityId: 551, code: "125072" },
    { id: 32729, cityId: 552, code: "95221" },
    { id: 32730, cityId: 552, code: "174001" },
    { id: 32731, cityId: 552, code: "174004" },
    { id: 32732, cityId: 552, code: "174011" },
    { id: 32733, cityId: 552, code: "174012" },
    { id: 32734, cityId: 552, code: "174022" },
    { id: 32735, cityId: 552, code: "174027" },
    { id: 32736, cityId: 552, code: "174028" },
    { id: 32737, cityId: 552, code: "174030" },
    { id: 32738, cityId: 552, code: "174033" },
    { id: 32739, cityId: 552, code: "174035" },
    { id: 32740, cityId: 552, code: "244921" },
    { id: 32741, cityId: 552, code: "495004" },
    { id: 32742, cityId: 552, code: "495007" },
    { id: 32743, cityId: 552, code: "495113" },
    { id: 32744, cityId: 552, code: "495116" },
    { id: 32745, cityId: 552, code: "495118" },
    { id: 32746, cityId: 552, code: "495222" },
    { id: 32747, cityId: 552, code: "495335" },
    { id: 32748, cityId: 552, code: "495447" },
    { id: 32749, cityId: 552, code: "495452" },
    { id: 32750, cityId: 552, code: "495550" },
    { id: 32751, cityId: 552, code: "495553" },
    { id: 32752, cityId: 552, code: "495674" },
    { id: 32753, cityId: 552, code: "495677" },
    { id: 32754, cityId: 552, code: "495680" },
    { id: 32755, cityId: 552, code: "495682" },
    { id: 32756, cityId: 552, code: "495683" },
    { id: 32757, cityId: 552, code: "135102" },
    { id: 32758, cityId: 552, code: "174010" },
    { id: 32759, cityId: 552, code: "174026" },
    { id: 32760, cityId: 552, code: "174029" },
    { id: 32761, cityId: 552, code: "174031" },
    { id: 32762, cityId: 552, code: "174032" },
    { id: 32763, cityId: 552, code: "174034" },
    { id: 32764, cityId: 552, code: "174201" },
    { id: 32765, cityId: 552, code: "174310" },
    { id: 32766, cityId: 552, code: "495001" },
    { id: 32767, cityId: 552, code: "495009" },
    { id: 32768, cityId: 552, code: "495112" },
    { id: 32769, cityId: 552, code: "495117" },
    { id: 32770, cityId: 552, code: "495220" },
    { id: 32771, cityId: 552, code: "495223" },
    { id: 32772, cityId: 552, code: "495446" },
    { id: 32773, cityId: 552, code: "495453" },
    { id: 32774, cityId: 552, code: "495551" },
    { id: 32775, cityId: 552, code: "495557" },
    { id: 32776, cityId: 552, code: "495660" },
    { id: 32777, cityId: 552, code: "495663" },
    { id: 32778, cityId: 552, code: "495679" },
    { id: 32779, cityId: 552, code: "495681" },
    { id: 32780, cityId: 552, code: "495684" },
    { id: 32781, cityId: 552, code: "495687" },
    { id: 32782, cityId: 552, code: "495695" },
    { id: 32783, cityId: 553, code: "123306" },
    { id: 32784, cityId: 554, code: "135103" },
    { id: 32785, cityId: 555, code: "122106" },
    { id: 32786, cityId: 556, code: "125102" },
    { id: 32787, cityId: 557, code: "121001" },
    { id: 32788, cityId: 557, code: "121003" },
    { id: 32789, cityId: 557, code: "121004" },
    { id: 32790, cityId: 557, code: "121006" },
    { id: 32791, cityId: 557, code: "121101" },
    { id: 32792, cityId: 557, code: "121102" },
    { id: 32793, cityId: 557, code: "121104" },
    { id: 32794, cityId: 557, code: "121002" },
    { id: 32795, cityId: 557, code: "121005" },
    { id: 32796, cityId: 557, code: "121007" },
    { id: 32797, cityId: 557, code: "121105" },
    { id: 32798, cityId: 557, code: "121106" },
    { id: 32799, cityId: 558, code: "283111" },
    { id: 32800, cityId: 558, code: "125050" },
    { id: 32801, cityId: 559, code: "125050" },
    { id: 32802, cityId: 560, code: "122104" },
    { id: 32803, cityId: 561, code: "131101" },
    { id: 32804, cityId: 562, code: "132111" },
    { id: 32805, cityId: 563, code: "124301" },
    { id: 32806, cityId: 564, code: "122001" },
    { id: 32807, cityId: 564, code: "122015" },
    { id: 32808, cityId: 564, code: "122102" },
    { id: 32809, cityId: 564, code: "122105" },
    { id: 32810, cityId: 564, code: "122108" },
    { id: 32811, cityId: 564, code: "122211" },
    { id: 32812, cityId: 564, code: "123508" },
    { id: 32813, cityId: 564, code: "122005" },
    { id: 32814, cityId: 564, code: "122016" },
    { id: 32815, cityId: 564, code: "122050" },
    { id: 32816, cityId: 564, code: "122101" },
    { id: 32817, cityId: 564, code: "122109" },
    { id: 32818, cityId: 564, code: "123507" },
    { id: 32819, cityId: 565, code: "125033" },
    { id: 32820, cityId: 566, code: "121107" },
    { id: 32821, cityId: 567, code: "121103" },
    { id: 32822, cityId: 568, code: "125001" },
    { id: 32823, cityId: 568, code: "125004" },
    { id: 32824, cityId: 568, code: "125011" },
    { id: 32825, cityId: 568, code: "125012" },
    { id: 32826, cityId: 568, code: "125033" },
    { id: 32827, cityId: 568, code: "125035" },
    { id: 32828, cityId: 568, code: "125038" },
    { id: 32829, cityId: 568, code: "125044" },
    { id: 32830, cityId: 568, code: "125049" },
    { id: 32831, cityId: 568, code: "125070" },
    { id: 32832, cityId: 568, code: "125073" },
    { id: 32833, cityId: 568, code: "125080" },
    { id: 32834, cityId: 568, code: "125081" },
    { id: 32835, cityId: 568, code: "125083" },
    { id: 32836, cityId: 568, code: "125086" },
    { id: 32837, cityId: 568, code: "125088" },
    { id: 32838, cityId: 568, code: "125107" },
    { id: 32839, cityId: 568, code: "125109" },
    { id: 32840, cityId: 568, code: "125112" },
    { id: 32841, cityId: 568, code: "126007" },
    { id: 32842, cityId: 568, code: "126008" },
    { id: 32843, cityId: 568, code: "126013" },
    { id: 32844, cityId: 568, code: "126015" },
    { id: 32845, cityId: 568, code: "125002" },
    { id: 32846, cityId: 568, code: "125003" },
    { id: 32847, cityId: 568, code: "125005" },
    { id: 32848, cityId: 568, code: "125034" },
    { id: 32849, cityId: 568, code: "125042" },
    { id: 32850, cityId: 568, code: "125047" },
    { id: 32851, cityId: 568, code: "125048" },
    { id: 32852, cityId: 568, code: "125068" },
    { id: 32853, cityId: 568, code: "125069" },
    { id: 32854, cityId: 568, code: "125079" },
    { id: 32855, cityId: 568, code: "125082" },
    { id: 32856, cityId: 568, code: "125084" },
    { id: 32857, cityId: 568, code: "125105" },
    { id: 32858, cityId: 568, code: "125108" },
    { id: 32859, cityId: 568, code: "125201" },
    { id: 32860, cityId: 568, code: "126006" },
    { id: 32861, cityId: 568, code: "126009" },
    { id: 32862, cityId: 568, code: "126011" },
    { id: 32863, cityId: 568, code: "126014" },
    { id: 32864, cityId: 568, code: "126025" },
    { id: 32865, cityId: 568, code: "126027" },
    { id: 32866, cityId: 568, code: "126120" },
    { id: 32867, cityId: 569, code: "135003" },
    { id: 32868, cityId: 570, code: "126001" },
    { id: 32869, cityId: 571, code: "124104" },
    { id: 32870, cityId: 571, code: "124507" },
    { id: 32871, cityId: 571, code: "124103" },
    { id: 32872, cityId: 571, code: "124201" },
    { id: 32873, cityId: 572, code: "126102" },
    { id: 32874, cityId: 572, code: "126104" },
    { id: 32875, cityId: 572, code: "126107" },
    { id: 32876, cityId: 572, code: "126109" },
    { id: 32877, cityId: 572, code: "126110" },
    { id: 32878, cityId: 572, code: "126117" },
    { id: 32879, cityId: 572, code: "126118" },
    { id: 32880, cityId: 572, code: "126122" },
    { id: 32881, cityId: 572, code: "126123" },
    { id: 32882, cityId: 572, code: "126128" },
    { id: 32883, cityId: 572, code: "126130" },
    { id: 32884, cityId: 572, code: "126131" },
    { id: 32885, cityId: 572, code: "126133" },
    { id: 32886, cityId: 572, code: "126136" },
    { id: 32887, cityId: 572, code: "126139" },
    { id: 32888, cityId: 572, code: "126141" },
    { id: 32889, cityId: 572, code: "126146" },
    { id: 32890, cityId: 572, code: "126147" },
    { id: 32891, cityId: 572, code: "126149" },
    { id: 32892, cityId: 572, code: "126152" },
    { id: 32893, cityId: 572, code: "126154" },
    { id: 32894, cityId: 572, code: "126103" },
    { id: 32895, cityId: 572, code: "126105" },
    { id: 32896, cityId: 572, code: "126106" },
    { id: 32897, cityId: 572, code: "126108" },
    { id: 32898, cityId: 572, code: "126111" },
    { id: 32899, cityId: 572, code: "126113" },
    { id: 32900, cityId: 572, code: "126114" },
    { id: 32901, cityId: 572, code: "126116" },
    { id: 32902, cityId: 572, code: "126121" },
    { id: 32903, cityId: 572, code: "126124" },
    { id: 32904, cityId: 572, code: "126126" },
    { id: 32905, cityId: 572, code: "126127" },
    { id: 32906, cityId: 572, code: "126129" },
    { id: 32907, cityId: 572, code: "126132" },
    { id: 32908, cityId: 572, code: "126135" },
    { id: 32909, cityId: 572, code: "126140" },
    { id: 32910, cityId: 572, code: "126143" },
    { id: 32911, cityId: 572, code: "126145" },
    { id: 32912, cityId: 572, code: "126148" },
    { id: 32913, cityId: 572, code: "126150" },
    { id: 32914, cityId: 572, code: "126151" },
    { id: 32915, cityId: 572, code: "126153" },
    { id: 32916, cityId: 572, code: "132045" },
    { id: 32917, cityId: 573, code: "126101" },
    { id: 32918, cityId: 574, code: "126134" },
    { id: 32919, cityId: 574, code: "132020" },
    { id: 32920, cityId: 574, code: "132021" },
    { id: 32921, cityId: 574, code: "132026" },
    { id: 32922, cityId: 574, code: "132029" },
    { id: 32923, cityId: 574, code: "132042" },
    { id: 32924, cityId: 574, code: "132121" },
    { id: 32925, cityId: 574, code: "132027" },
    { id: 32926, cityId: 574, code: "132032" },
    { id: 32927, cityId: 574, code: "132035" },
    { id: 32928, cityId: 574, code: "132043" },
    { id: 32929, cityId: 574, code: "132120" },
    { id: 32930, cityId: 574, code: "132123" },
    { id: 32931, cityId: 574, code: "132138" },
    { id: 32932, cityId: 575, code: "124113" },
    { id: 32933, cityId: 575, code: "143512" },
    { id: 32934, cityId: 576, code: "133302" },
    { id: 32935, cityId: 577, code: "123027" },
    { id: 32936, cityId: 578, code: "132001" },
    { id: 32937, cityId: 578, code: "132022" },
    { id: 32938, cityId: 578, code: "132024" },
    { id: 32939, cityId: 578, code: "132025" },
    { id: 32940, cityId: 578, code: "132038" },
    { id: 32941, cityId: 578, code: "132040" },
    { id: 32942, cityId: 578, code: "132041" },
    { id: 32943, cityId: 578, code: "132046" },
    { id: 32944, cityId: 578, code: "132104" },
    { id: 32945, cityId: 578, code: "132106" },
    { id: 32946, cityId: 578, code: "132112" },
    { id: 32947, cityId: 578, code: "132115" },
    { id: 32948, cityId: 578, code: "132123" },
    { id: 32949, cityId: 578, code: "132125" },
    { id: 32950, cityId: 578, code: "132138" },
    { id: 32951, cityId: 578, code: "132139" },
    { id: 32952, cityId: 578, code: "132141" },
    { id: 32953, cityId: 578, code: "132144" },
    { id: 32954, cityId: 578, code: "132146" },
    { id: 32955, cityId: 578, code: "132147" },
    { id: 32956, cityId: 578, code: "132149" },
    { id: 32957, cityId: 578, code: "132152" },
    { id: 32958, cityId: 578, code: "132154" },
    { id: 32959, cityId: 578, code: "132002" },
    { id: 32960, cityId: 578, code: "132036" },
    { id: 32961, cityId: 578, code: "132037" },
    { id: 32962, cityId: 578, code: "132103" },
    { id: 32963, cityId: 578, code: "132105" },
    { id: 32964, cityId: 578, code: "132108" },
    { id: 32965, cityId: 578, code: "132111" },
    { id: 32966, cityId: 578, code: "132113" },
    { id: 32967, cityId: 578, code: "132116" },
    { id: 32968, cityId: 578, code: "132121" },
    { id: 32969, cityId: 578, code: "132124" },
    { id: 32970, cityId: 578, code: "132140" },
    { id: 32971, cityId: 578, code: "132142" },
    { id: 32972, cityId: 578, code: "132143" },
    { id: 32973, cityId: 578, code: "132145" },
    { id: 32974, cityId: 578, code: "132148" },
    { id: 32975, cityId: 578, code: "132150" },
    { id: 32976, cityId: 578, code: "132151" },
    { id: 32977, cityId: 578, code: "132153" },
    { id: 32978, cityId: 579, code: "132027" },
    { id: 32979, cityId: 579, code: "132035" },
    { id: 32980, cityId: 579, code: "132043" },
    { id: 32981, cityId: 579, code: "132044" },
    { id: 32982, cityId: 579, code: "132118" },
    { id: 32983, cityId: 579, code: "132120" },
    { id: 32984, cityId: 579, code: "132131" },
    { id: 32985, cityId: 579, code: "132134" },
    { id: 32986, cityId: 579, code: "132136" },
    { id: 32987, cityId: 579, code: "132021" },
    { id: 32988, cityId: 579, code: "132026" },
    { id: 32989, cityId: 579, code: "132034" },
    { id: 32990, cityId: 579, code: "132042" },
    { id: 32991, cityId: 579, code: "132119" },
    { id: 32992, cityId: 579, code: "132129" },
    { id: 32993, cityId: 579, code: "132130" },
    { id: 32994, cityId: 579, code: "132135" },
    { id: 32995, cityId: 579, code: "132137" },
    { id: 32996, cityId: 580, code: "125087" },
    { id: 32997, cityId: 580, code: "132132" },
    { id: 32998, cityId: 581, code: "123201" },
    { id: 32999, cityId: 582, code: "125104" },
    { id: 33000, cityId: 583, code: "133102" },
    { id: 33001, cityId: 584, code: "134203" },
    { id: 33002, cityId: 585, code: "123021" },
    { id: 33003, cityId: 585, code: "123022" },
    { id: 33004, cityId: 585, code: "123029" },
    { id: 33005, cityId: 585, code: "123035" },
    { id: 33006, cityId: 585, code: "123101" },
    { id: 33007, cityId: 585, code: "123103" },
    { id: 33008, cityId: 585, code: "123413" },
    { id: 33009, cityId: 585, code: "123414" },
    { id: 33010, cityId: 585, code: "123504" },
    { id: 33011, cityId: 585, code: "123506" },
    { id: 33012, cityId: 585, code: "123001" },
    { id: 33013, cityId: 585, code: "123023" },
    { id: 33014, cityId: 585, code: "123028" },
    { id: 33015, cityId: 585, code: "123034" },
    { id: 33016, cityId: 585, code: "123102" },
    { id: 33017, cityId: 585, code: "123401" },
    { id: 33018, cityId: 585, code: "123412" },
    { id: 33019, cityId: 585, code: "123502" },
    { id: 33020, cityId: 585, code: "123505" },
    { id: 33021, cityId: 586, code: "125039" },
    { id: 33022, cityId: 587, code: "126116" },
    { id: 33023, cityId: 588, code: "132117" },
    { id: 33024, cityId: 589, code: "122107" },
    { id: 33025, cityId: 590, code: "121102" },
    { id: 33026, cityId: 591, code: "133302" },
    { id: 33027, cityId: 592, code: "132047" },
    { id: 33028, cityId: 592, code: "132048" },
    { id: 33029, cityId: 592, code: "132050" },
    { id: 33030, cityId: 592, code: "132053" },
    { id: 33031, cityId: 592, code: "132058" },
    { id: 33032, cityId: 592, code: "132103" },
    { id: 33033, cityId: 592, code: "132109" },
    { id: 33034, cityId: 592, code: "132049" },
    { id: 33035, cityId: 592, code: "132051" },
    { id: 33036, cityId: 592, code: "132052" },
    { id: 33037, cityId: 592, code: "132102" },
    { id: 33038, cityId: 592, code: "132110" },
    { id: 33039, cityId: 592, code: "132155" },
    { id: 33040, cityId: 593, code: "123503" },
    { id: 33041, cityId: 594, code: "132128" },
    { id: 33042, cityId: 595, code: "134102" },
    { id: 33043, cityId: 596, code: "132026" },
    { id: 33044, cityId: 597, code: "132133" },
    { id: 33045, cityId: 598, code: "134204" },
    { id: 33046, cityId: 599, code: "125076" },
    { id: 33047, cityId: 600, code: "123303" },
    { id: 33048, cityId: 600, code: "123401" },
    { id: 33049, cityId: 600, code: "123302" },
    { id: 33050, cityId: 600, code: "123304" },
    { id: 33051, cityId: 600, code: "123305" },
    { id: 33052, cityId: 600, code: "123411" },
    { id: 33053, cityId: 601, code: "124002" },
    { id: 33054, cityId: 601, code: "124003" },
    { id: 33055, cityId: 601, code: "124005" },
    { id: 33056, cityId: 601, code: "124008" },
    { id: 33057, cityId: 601, code: "124021" },
    { id: 33058, cityId: 601, code: "124024" },
    { id: 33059, cityId: 601, code: "124026" },
    { id: 33060, cityId: 601, code: "124027" },
    { id: 33061, cityId: 601, code: "124029" },
    { id: 33062, cityId: 601, code: "124101" },
    { id: 33063, cityId: 601, code: "124103" },
    { id: 33064, cityId: 601, code: "124108" },
    { id: 33065, cityId: 601, code: "124109" },
    { id: 33066, cityId: 601, code: "124111" },
    { id: 33067, cityId: 601, code: "124114" },
    { id: 33068, cityId: 601, code: "124116" },
    { id: 33069, cityId: 601, code: "124117" },
    { id: 33070, cityId: 601, code: "124119" },
    { id: 33071, cityId: 601, code: "124122" },
    { id: 33072, cityId: 601, code: "124124" },
    { id: 33073, cityId: 601, code: "124125" },
    { id: 33074, cityId: 601, code: "124127" },
    { id: 33075, cityId: 601, code: "124130" },
    { id: 33076, cityId: 601, code: "124132" },
    { id: 33077, cityId: 601, code: "124133" },
    { id: 33078, cityId: 601, code: "124135" },
    { id: 33079, cityId: 601, code: "124138" },
    { id: 33080, cityId: 601, code: "124140" },
    { id: 33081, cityId: 601, code: "124141" },
    { id: 33082, cityId: 601, code: "124204" },
    { id: 33083, cityId: 601, code: "124307" },
    { id: 33084, cityId: 601, code: "124312" },
    { id: 33085, cityId: 601, code: "124315" },
    { id: 33086, cityId: 601, code: "124318" },
    { id: 33087, cityId: 601, code: "124320" },
    { id: 33088, cityId: 601, code: "124321" },
    { id: 33089, cityId: 601, code: "124323" },
    { id: 33090, cityId: 601, code: "124405" },
    { id: 33091, cityId: 601, code: "124410" },
    { id: 33092, cityId: 601, code: "124411" },
    { id: 33093, cityId: 601, code: "124413" },
    { id: 33094, cityId: 601, code: "124416" },
    { id: 33095, cityId: 601, code: "124418" },
    { id: 33096, cityId: 601, code: "124419" },
    { id: 33097, cityId: 601, code: "124421" },
    { id: 33098, cityId: 601, code: "124424" },
    { id: 33099, cityId: 601, code: "124426" },
    { id: 33100, cityId: 601, code: "124427" },
    { id: 33101, cityId: 601, code: "124501" },
    { id: 33102, cityId: 601, code: "124503" },
    { id: 33103, cityId: 601, code: "124506" },
    { id: 33104, cityId: 601, code: "124508" },
    { id: 33105, cityId: 601, code: "124509" },
    { id: 33106, cityId: 601, code: "124511" },
    { id: 33107, cityId: 601, code: "124514" },
    { id: 33108, cityId: 601, code: "124516" },
    { id: 33109, cityId: 601, code: "124517" },
    { id: 33110, cityId: 601, code: "124519" },
    { id: 33111, cityId: 601, code: "124522" },
    { id: 33112, cityId: 601, code: "124524" },
    { id: 33113, cityId: 601, code: "124525" },
    { id: 33114, cityId: 601, code: "124527" },
    { id: 33115, cityId: 601, code: "124530" },
    { id: 33116, cityId: 601, code: "124001" },
    { id: 33117, cityId: 601, code: "124004" },
    { id: 33118, cityId: 601, code: "124006" },
    { id: 33119, cityId: 601, code: "124007" },
    { id: 33120, cityId: 601, code: "124022" },
    { id: 33121, cityId: 601, code: "124023" },
    { id: 33122, cityId: 601, code: "124025" },
    { id: 33123, cityId: 601, code: "124028" },
    { id: 33124, cityId: 601, code: "124030" },
    { id: 33125, cityId: 601, code: "124031" },
    { id: 33126, cityId: 601, code: "124102" },
    { id: 33127, cityId: 601, code: "124104" },
    { id: 33128, cityId: 601, code: "124105" },
    { id: 33129, cityId: 601, code: "124107" },
    { id: 33130, cityId: 601, code: "124110" },
    { id: 33131, cityId: 601, code: "124112" },
    { id: 33132, cityId: 601, code: "124118" },
    { id: 33133, cityId: 601, code: "124120" },
    { id: 33134, cityId: 601, code: "124121" },
    { id: 33135, cityId: 601, code: "124123" },
    { id: 33136, cityId: 601, code: "124126" },
    { id: 33137, cityId: 601, code: "124128" },
    { id: 33138, cityId: 601, code: "124129" },
    { id: 33139, cityId: 601, code: "124131" },
    { id: 33140, cityId: 601, code: "124134" },
    { id: 33141, cityId: 601, code: "124136" },
    { id: 33142, cityId: 601, code: "124137" },
    { id: 33143, cityId: 601, code: "124139" },
    { id: 33144, cityId: 601, code: "124202" },
    { id: 33145, cityId: 601, code: "124203" },
    { id: 33146, cityId: 601, code: "124205" },
    { id: 33147, cityId: 601, code: "124303" },
    { id: 33148, cityId: 601, code: "124308" },
    { id: 33149, cityId: 601, code: "124309" },
    { id: 33150, cityId: 601, code: "124311" },
    { id: 33151, cityId: 601, code: "124314" },
    { id: 33152, cityId: 601, code: "124316" },
    { id: 33153, cityId: 601, code: "124317" },
    { id: 33154, cityId: 601, code: "124322" },
    { id: 33155, cityId: 601, code: "124324" },
    { id: 33156, cityId: 601, code: "124325" },
    { id: 33157, cityId: 601, code: "124401" },
    { id: 33158, cityId: 601, code: "124404" },
    { id: 33159, cityId: 601, code: "124406" },
    { id: 33160, cityId: 601, code: "124407" },
    { id: 33161, cityId: 601, code: "124412" },
    { id: 33162, cityId: 601, code: "124417" },
    { id: 33163, cityId: 601, code: "124420" },
    { id: 33164, cityId: 601, code: "124422" },
    { id: 33165, cityId: 601, code: "124423" },
    { id: 33166, cityId: 601, code: "124425" },
    { id: 33167, cityId: 601, code: "124428" },
    { id: 33168, cityId: 601, code: "124502" },
    { id: 33169, cityId: 601, code: "124504" },
    { id: 33170, cityId: 601, code: "124505" },
    { id: 33171, cityId: 601, code: "124507" },
    { id: 33172, cityId: 601, code: "124510" },
    { id: 33173, cityId: 601, code: "124513" },
    { id: 33174, cityId: 601, code: "124515" },
    { id: 33175, cityId: 601, code: "124518" },
    { id: 33176, cityId: 601, code: "124520" },
    { id: 33177, cityId: 601, code: "124521" },
    { id: 33178, cityId: 601, code: "124523" },
    { id: 33179, cityId: 601, code: "124526" },
    { id: 33180, cityId: 601, code: "124528" },
    { id: 33181, cityId: 601, code: "124531" },
    { id: 33182, cityId: 601, code: "124533" },
    { id: 33183, cityId: 602, code: "125112" },
    { id: 33184, cityId: 603, code: "132101" },
    { id: 33185, cityId: 604, code: "125051" },
    { id: 33186, cityId: 604, code: "125054" },
    { id: 33187, cityId: 604, code: "125056" },
    { id: 33188, cityId: 604, code: "125057" },
    { id: 33189, cityId: 604, code: "125062" },
    { id: 33190, cityId: 604, code: "125075" },
    { id: 33191, cityId: 604, code: "125077" },
    { id: 33192, cityId: 604, code: "125078" },
    { id: 33193, cityId: 604, code: "125101" },
    { id: 33194, cityId: 604, code: "125104" },
    { id: 33195, cityId: 604, code: "125202" },
    { id: 33196, cityId: 604, code: "125050" },
    { id: 33197, cityId: 604, code: "125052" },
    { id: 33198, cityId: 604, code: "125053" },
    { id: 33199, cityId: 604, code: "125055" },
    { id: 33200, cityId: 604, code: "125058" },
    { id: 33201, cityId: 604, code: "125060" },
    { id: 33202, cityId: 604, code: "125103" },
    { id: 33203, cityId: 604, code: "125106" },
    { id: 33204, cityId: 604, code: "125203" },
    { id: 33205, cityId: 605, code: "122103" },
    { id: 33206, cityId: 606, code: "124304" },
    { id: 33207, cityId: 606, code: "124306" },
    { id: 33208, cityId: 606, code: "124402" },
    { id: 33209, cityId: 606, code: "124409" },
    { id: 33210, cityId: 606, code: "124415" },
    { id: 33211, cityId: 606, code: "124529" },
    { id: 33212, cityId: 606, code: "131001" },
    { id: 33213, cityId: 606, code: "131021" },
    { id: 33214, cityId: 606, code: "131022" },
    { id: 33215, cityId: 606, code: "131024" },
    { id: 33216, cityId: 606, code: "131027" },
    { id: 33217, cityId: 606, code: "131029" },
    { id: 33218, cityId: 606, code: "131030" },
    { id: 33219, cityId: 606, code: "131032" },
    { id: 33220, cityId: 606, code: "131035" },
    { id: 33221, cityId: 606, code: "131037" },
    { id: 33222, cityId: 606, code: "131038" },
    { id: 33223, cityId: 606, code: "131101" },
    { id: 33224, cityId: 606, code: "131104" },
    { id: 33225, cityId: 606, code: "131106" },
    { id: 33226, cityId: 606, code: "131107" },
    { id: 33227, cityId: 606, code: "131109" },
    { id: 33228, cityId: 606, code: "131112" },
    { id: 33229, cityId: 606, code: "131114" },
    { id: 33230, cityId: 606, code: "131115" },
    { id: 33231, cityId: 606, code: "124302" },
    { id: 33232, cityId: 606, code: "124305" },
    { id: 33233, cityId: 606, code: "124310" },
    { id: 33234, cityId: 606, code: "124403" },
    { id: 33235, cityId: 606, code: "124408" },
    { id: 33236, cityId: 606, code: "124429" },
    { id: 33237, cityId: 606, code: "124430" },
    { id: 33238, cityId: 606, code: "124532" },
    { id: 33239, cityId: 606, code: "131023" },
    { id: 33240, cityId: 606, code: "131025" },
    { id: 33241, cityId: 606, code: "131026" },
    { id: 33242, cityId: 606, code: "131028" },
    { id: 33243, cityId: 606, code: "131031" },
    { id: 33244, cityId: 606, code: "131033" },
    { id: 33245, cityId: 606, code: "131034" },
    { id: 33246, cityId: 606, code: "131036" },
    { id: 33247, cityId: 606, code: "131102" },
    { id: 33248, cityId: 606, code: "131103" },
    { id: 33249, cityId: 606, code: "131105" },
    { id: 33250, cityId: 606, code: "131108" },
    { id: 33251, cityId: 606, code: "131110" },
    { id: 33252, cityId: 606, code: "131111" },
    { id: 33253, cityId: 606, code: "131113" },
    { id: 33254, cityId: 607, code: "126119" },
    { id: 33255, cityId: 608, code: "125040" },
    { id: 33256, cityId: 609, code: "126115" },
    { id: 33257, cityId: 610, code: "135002" },
    { id: 33258, cityId: 610, code: "135003" },
    { id: 33259, cityId: 611, code: "495012" },
    { id: 33260, cityId: 611, code: "495336" },
    { id: 33261, cityId: 611, code: "495554" },
    { id: 33262, cityId: 612, code: "173208" },
    { id: 33263, cityId: 613, code: "176301" },
    { id: 33264, cityId: 614, code: "175123" },
    { id: 33265, cityId: 615, code: "176041" },
    { id: 33266, cityId: 616, code: "175125" },
    { id: 33267, cityId: 617, code: "95221" },
    { id: 33268, cityId: 617, code: "174001" },
    { id: 33269, cityId: 617, code: "174004" },
    { id: 33270, cityId: 617, code: "174012" },
    { id: 33271, cityId: 617, code: "174022" },
    { id: 33272, cityId: 617, code: "174028" },
    { id: 33273, cityId: 617, code: "174030" },
    { id: 33274, cityId: 617, code: "174031" },
    { id: 33275, cityId: 617, code: "174033" },
    { id: 33276, cityId: 617, code: "495007" },
    { id: 33277, cityId: 617, code: "495113" },
    { id: 33278, cityId: 617, code: "495116" },
    { id: 33279, cityId: 617, code: "495222" },
    { id: 33280, cityId: 617, code: "495447" },
    { id: 33281, cityId: 617, code: "495452" },
    { id: 33282, cityId: 617, code: "495453" },
    { id: 33283, cityId: 617, code: "495550" },
    { id: 33284, cityId: 617, code: "495551" },
    { id: 33285, cityId: 617, code: "495553" },
    { id: 33286, cityId: 617, code: "495677" },
    { id: 33287, cityId: 617, code: "495680" },
    { id: 33288, cityId: 617, code: "495683" },
    { id: 33289, cityId: 617, code: "135102" },
    { id: 33290, cityId: 617, code: "174010" },
    { id: 33291, cityId: 617, code: "174011" },
    { id: 33292, cityId: 617, code: "174026" },
    { id: 33293, cityId: 617, code: "174027" },
    { id: 33294, cityId: 617, code: "174029" },
    { id: 33295, cityId: 617, code: "174032" },
    { id: 33296, cityId: 617, code: "174034" },
    { id: 33297, cityId: 617, code: "174035" },
    { id: 33298, cityId: 617, code: "174201" },
    { id: 33299, cityId: 617, code: "174310" },
    { id: 33300, cityId: 617, code: "244921" },
    { id: 33301, cityId: 617, code: "495001" },
    { id: 33302, cityId: 617, code: "495004" },
    { id: 33303, cityId: 617, code: "495009" },
    { id: 33304, cityId: 617, code: "495112" },
    { id: 33305, cityId: 617, code: "495117" },
    { id: 33306, cityId: 617, code: "495118" },
    { id: 33307, cityId: 617, code: "495220" },
    { id: 33308, cityId: 617, code: "495223" },
    { id: 33309, cityId: 617, code: "495335" },
    { id: 33310, cityId: 617, code: "495446" },
    { id: 33311, cityId: 617, code: "495557" },
    { id: 33312, cityId: 617, code: "495660" },
    { id: 33313, cityId: 617, code: "495663" },
    { id: 33314, cityId: 617, code: "495674" },
    { id: 33315, cityId: 617, code: "495679" },
    { id: 33316, cityId: 617, code: "495681" },
    { id: 33317, cityId: 617, code: "495682" },
    { id: 33318, cityId: 617, code: "495684" },
    { id: 33319, cityId: 617, code: "495687" },
    { id: 33320, cityId: 617, code: "495695" },
    { id: 33321, cityId: 618, code: "176306" },
    { id: 33322, cityId: 618, code: "176311" },
    { id: 33323, cityId: 618, code: "176314" },
    { id: 33324, cityId: 618, code: "176316" },
    { id: 33325, cityId: 618, code: "176317" },
    { id: 33326, cityId: 618, code: "176319" },
    { id: 33327, cityId: 618, code: "176322" },
    { id: 33328, cityId: 618, code: "176324" },
    { id: 33329, cityId: 618, code: "176325" },
    { id: 33330, cityId: 618, code: "176207" },
    { id: 33331, cityId: 618, code: "176302" },
    { id: 33332, cityId: 618, code: "176304" },
    { id: 33333, cityId: 618, code: "176305" },
    { id: 33334, cityId: 618, code: "176310" },
    { id: 33335, cityId: 618, code: "176312" },
    { id: 33336, cityId: 618, code: "176313" },
    { id: 33337, cityId: 618, code: "176315" },
    { id: 33338, cityId: 618, code: "176318" },
    { id: 33339, cityId: 618, code: "176320" },
    { id: 33340, cityId: 618, code: "176321" },
    { id: 33341, cityId: 618, code: "176323" },
    { id: 33342, cityId: 619, code: "173210" },
    { id: 33343, cityId: 620, code: "176038" },
    { id: 33344, cityId: 621, code: "176002" },
    { id: 33345, cityId: 621, code: "176021" },
    { id: 33346, cityId: 621, code: "176023" },
    { id: 33347, cityId: 621, code: "176024" },
    { id: 33348, cityId: 621, code: "176029" },
    { id: 33349, cityId: 621, code: "176037" },
    { id: 33350, cityId: 621, code: "176050" },
    { id: 33351, cityId: 621, code: "176052" },
    { id: 33352, cityId: 621, code: "176053" },
    { id: 33353, cityId: 621, code: "176058" },
    { id: 33354, cityId: 621, code: "176060" },
    { id: 33355, cityId: 621, code: "176063" },
    { id: 33356, cityId: 621, code: "176074" },
    { id: 33357, cityId: 621, code: "176076" },
    { id: 33358, cityId: 621, code: "176084" },
    { id: 33359, cityId: 621, code: "176087" },
    { id: 33360, cityId: 621, code: "176089" },
    { id: 33361, cityId: 621, code: "176092" },
    { id: 33362, cityId: 621, code: "176095" },
    { id: 33363, cityId: 621, code: "176103" },
    { id: 33364, cityId: 621, code: "176127" },
    { id: 33365, cityId: 621, code: "176201" },
    { id: 33366, cityId: 621, code: "176203" },
    { id: 33367, cityId: 621, code: "176204" },
    { id: 33368, cityId: 621, code: "176206" },
    { id: 33369, cityId: 621, code: "176209" },
    { id: 33370, cityId: 621, code: "176211" },
    { id: 33371, cityId: 621, code: "176212" },
    { id: 33372, cityId: 621, code: "176214" },
    { id: 33373, cityId: 621, code: "176217" },
    { id: 33374, cityId: 621, code: "176219" },
    { id: 33375, cityId: 621, code: "176220" },
    { id: 33376, cityId: 621, code: "176222" },
    { id: 33377, cityId: 621, code: "176225" },
    { id: 33378, cityId: 621, code: "176402" },
    { id: 33379, cityId: 621, code: "176022" },
    { id: 33380, cityId: 621, code: "176025" },
    { id: 33381, cityId: 621, code: "176028" },
    { id: 33382, cityId: 621, code: "176033" },
    { id: 33383, cityId: 621, code: "176046" },
    { id: 33384, cityId: 621, code: "176051" },
    { id: 33385, cityId: 621, code: "176054" },
    { id: 33386, cityId: 621, code: "176057" },
    { id: 33387, cityId: 621, code: "176059" },
    { id: 33388, cityId: 621, code: "176062" },
    { id: 33389, cityId: 621, code: "176064" },
    { id: 33390, cityId: 621, code: "176065" },
    { id: 33391, cityId: 621, code: "176075" },
    { id: 33392, cityId: 621, code: "176081" },
    { id: 33393, cityId: 621, code: "176083" },
    { id: 33394, cityId: 621, code: "176085" },
    { id: 33395, cityId: 621, code: "176086" },
    { id: 33396, cityId: 621, code: "176088" },
    { id: 33397, cityId: 621, code: "176091" },
    { id: 33398, cityId: 621, code: "176093" },
    { id: 33399, cityId: 621, code: "176094" },
    { id: 33400, cityId: 621, code: "176096" },
    { id: 33401, cityId: 621, code: "176101" },
    { id: 33402, cityId: 621, code: "176102" },
    { id: 33403, cityId: 621, code: "176107" },
    { id: 33404, cityId: 621, code: "176115" },
    { id: 33405, cityId: 621, code: "176125" },
    { id: 33406, cityId: 621, code: "176126" },
    { id: 33407, cityId: 621, code: "176128" },
    { id: 33408, cityId: 621, code: "176139" },
    { id: 33409, cityId: 621, code: "176205" },
    { id: 33410, cityId: 621, code: "176208" },
    { id: 33411, cityId: 621, code: "176210" },
    { id: 33412, cityId: 621, code: "176213" },
    { id: 33413, cityId: 621, code: "176215" },
    { id: 33414, cityId: 621, code: "176216" },
    { id: 33415, cityId: 621, code: "176218" },
    { id: 33416, cityId: 621, code: "176221" },
    { id: 33417, cityId: 621, code: "176223" },
    { id: 33418, cityId: 621, code: "176401" },
    { id: 33419, cityId: 621, code: "176403" },
    { id: 33420, cityId: 621, code: "176404" },
    { id: 33421, cityId: 622, code: "177201" },
    { id: 33422, cityId: 623, code: "174021" },
    { id: 33423, cityId: 624, code: "174311" },
    { id: 33424, cityId: 624, code: "174313" },
    { id: 33425, cityId: 624, code: "176027" },
    { id: 33426, cityId: 624, code: "176030" },
    { id: 33427, cityId: 624, code: "176032" },
    { id: 33428, cityId: 624, code: "176035" },
    { id: 33429, cityId: 624, code: "176040" },
    { id: 33430, cityId: 624, code: "176043" },
    { id: 33431, cityId: 624, code: "176045" },
    { id: 33432, cityId: 624, code: "176048" },
    { id: 33433, cityId: 624, code: "176501" },
    { id: 33434, cityId: 624, code: "177005" },
    { id: 33435, cityId: 624, code: "177007" },
    { id: 33436, cityId: 624, code: "177020" },
    { id: 33437, cityId: 624, code: "177023" },
    { id: 33438, cityId: 624, code: "177025" },
    { id: 33439, cityId: 624, code: "177026" },
    { id: 33440, cityId: 624, code: "177028" },
    { id: 33441, cityId: 624, code: "177034" },
    { id: 33442, cityId: 624, code: "177041" },
    { id: 33443, cityId: 624, code: "177042" },
    { id: 33444, cityId: 624, code: "177044" },
    { id: 33445, cityId: 624, code: "177047" },
    { id: 33446, cityId: 624, code: "177102" },
    { id: 33447, cityId: 624, code: "177105" },
    { id: 33448, cityId: 624, code: "177107" },
    { id: 33449, cityId: 624, code: "177108" },
    { id: 33450, cityId: 624, code: "177113" },
    { id: 33451, cityId: 624, code: "177116" },
    { id: 33452, cityId: 624, code: "177118" },
    { id: 33453, cityId: 624, code: "210301" },
    { id: 33454, cityId: 624, code: "210422" },
    { id: 33455, cityId: 624, code: "210423" },
    { id: 33456, cityId: 624, code: "210425" },
    { id: 33457, cityId: 624, code: "210428" },
    { id: 33458, cityId: 624, code: "210431" },
    { id: 33459, cityId: 624, code: "210433" },
    { id: 33460, cityId: 624, code: "210502" },
    { id: 33461, cityId: 624, code: "210507" },
    { id: 33462, cityId: 624, code: "174304" },
    { id: 33463, cityId: 624, code: "174309" },
    { id: 33464, cityId: 624, code: "174312" },
    { id: 33465, cityId: 624, code: "176026" },
    { id: 33466, cityId: 624, code: "176031" },
    { id: 33467, cityId: 624, code: "176034" },
    { id: 33468, cityId: 624, code: "176036" },
    { id: 33469, cityId: 624, code: "176039" },
    { id: 33470, cityId: 624, code: "176042" },
    { id: 33471, cityId: 624, code: "176044" },
    { id: 33472, cityId: 624, code: "176049" },
    { id: 33473, cityId: 624, code: "176055" },
    { id: 33474, cityId: 624, code: "176108" },
    { id: 33475, cityId: 624, code: "176110" },
    { id: 33476, cityId: 624, code: "176111" },
    { id: 33477, cityId: 624, code: "177001" },
    { id: 33478, cityId: 624, code: "177006" },
    { id: 33479, cityId: 624, code: "177021" },
    { id: 33480, cityId: 624, code: "177022" },
    { id: 33481, cityId: 624, code: "177024" },
    { id: 33482, cityId: 624, code: "177027" },
    { id: 33483, cityId: 624, code: "177029" },
    { id: 33484, cityId: 624, code: "177030" },
    { id: 33485, cityId: 624, code: "177035" },
    { id: 33486, cityId: 624, code: "177038" },
    { id: 33487, cityId: 624, code: "177040" },
    { id: 33488, cityId: 624, code: "177043" },
    { id: 33489, cityId: 624, code: "177045" },
    { id: 33490, cityId: 624, code: "177046" },
    { id: 33491, cityId: 624, code: "177048" },
    { id: 33492, cityId: 624, code: "177101" },
    { id: 33493, cityId: 624, code: "177103" },
    { id: 33494, cityId: 624, code: "177104" },
    { id: 33495, cityId: 624, code: "177106" },
    { id: 33496, cityId: 624, code: "177111" },
    { id: 33497, cityId: 624, code: "177112" },
    { id: 33498, cityId: 624, code: "177114" },
    { id: 33499, cityId: 624, code: "177117" },
    { id: 33500, cityId: 624, code: "210321" },
    { id: 33501, cityId: 624, code: "210421" },
    { id: 33502, cityId: 624, code: "210424" },
    { id: 33503, cityId: 624, code: "210429" },
    { id: 33504, cityId: 624, code: "210432" },
    { id: 33505, cityId: 624, code: "210434" },
    { id: 33506, cityId: 624, code: "210504" },
    { id: 33507, cityId: 624, code: "210506" },
    { id: 33508, cityId: 625, code: "171205" },
    { id: 33509, cityId: 626, code: "171008" },
    { id: 33510, cityId: 627, code: "176001" },
    { id: 33511, cityId: 628, code: "173204" },
    { id: 33512, cityId: 629, code: "175142" },
    { id: 33513, cityId: 629, code: "172113" },
    { id: 33514, cityId: 630, code: "175121" },
    { id: 33515, cityId: 630, code: "175128" },
    { id: 33516, cityId: 630, code: "175129" },
    { id: 33517, cityId: 630, code: "175131" },
    { id: 33518, cityId: 630, code: "175134" },
    { id: 33519, cityId: 630, code: "175136" },
    { id: 33520, cityId: 630, code: "175137" },
    { id: 33521, cityId: 630, code: "175101" },
    { id: 33522, cityId: 630, code: "175109" },
    { id: 33523, cityId: 630, code: "175122" },
    { id: 33524, cityId: 630, code: "175124" },
    { id: 33525, cityId: 630, code: "175127" },
    { id: 33526, cityId: 630, code: "175130" },
    { id: 33527, cityId: 630, code: "175132" },
    { id: 33528, cityId: 630, code: "175133" },
    { id: 33529, cityId: 630, code: "175135" },
    { id: 33530, cityId: 630, code: "175138" },
    { id: 33531, cityId: 630, code: "175140" },
    { id: 33532, cityId: 630, code: "175141" },
    { id: 33533, cityId: 631, code: "174401" },
    { id: 33534, cityId: 631, code: "174403" },
    { id: 33535, cityId: 631, code: "175002" },
    { id: 33536, cityId: 631, code: "175004" },
    { id: 33537, cityId: 631, code: "175007" },
    { id: 33538, cityId: 631, code: "175025" },
    { id: 33539, cityId: 631, code: "175026" },
    { id: 33540, cityId: 631, code: "175028" },
    { id: 33541, cityId: 631, code: "175031" },
    { id: 33542, cityId: 631, code: "175033" },
    { id: 33543, cityId: 631, code: "175034" },
    { id: 33544, cityId: 631, code: "175036" },
    { id: 33545, cityId: 631, code: "175039" },
    { id: 33546, cityId: 631, code: "175041" },
    { id: 33547, cityId: 631, code: "175042" },
    { id: 33548, cityId: 631, code: "175044" },
    { id: 33549, cityId: 631, code: "175047" },
    { id: 33550, cityId: 631, code: "175049" },
    { id: 33551, cityId: 631, code: "175050" },
    { id: 33552, cityId: 631, code: "175052" },
    { id: 33553, cityId: 631, code: "176090" },
    { id: 33554, cityId: 631, code: "176120" },
    { id: 33555, cityId: 631, code: "176122" },
    { id: 33556, cityId: 631, code: "174402" },
    { id: 33557, cityId: 631, code: "174404" },
    { id: 33558, cityId: 631, code: "174405" },
    { id: 33559, cityId: 631, code: "175001" },
    { id: 33560, cityId: 631, code: "175003" },
    { id: 33561, cityId: 631, code: "175005" },
    { id: 33562, cityId: 631, code: "175006" },
    { id: 33563, cityId: 631, code: "175021" },
    { id: 33564, cityId: 631, code: "175022" },
    { id: 33565, cityId: 631, code: "175027" },
    { id: 33566, cityId: 631, code: "175029" },
    { id: 33567, cityId: 631, code: "175030" },
    { id: 33568, cityId: 631, code: "175032" },
    { id: 33569, cityId: 631, code: "175035" },
    { id: 33570, cityId: 631, code: "175037" },
    { id: 33571, cityId: 631, code: "175038" },
    { id: 33572, cityId: 631, code: "175040" },
    { id: 33573, cityId: 631, code: "175043" },
    { id: 33574, cityId: 631, code: "175045" },
    { id: 33575, cityId: 631, code: "175046" },
    { id: 33576, cityId: 631, code: "175048" },
    { id: 33577, cityId: 631, code: "175051" },
    { id: 33578, cityId: 631, code: "176121" },
    { id: 33579, cityId: 631, code: "176123" },
    { id: 33580, cityId: 632, code: "177033" },
    { id: 33581, cityId: 633, code: "176047" },
    { id: 33582, cityId: 634, code: "173001" },
    { id: 33583, cityId: 634, code: "173003" },
    { id: 33584, cityId: 634, code: "173021" },
    { id: 33585, cityId: 634, code: "173022" },
    { id: 33586, cityId: 634, code: "173024" },
    { id: 33587, cityId: 634, code: "173027" },
    { id: 33588, cityId: 634, code: "173029" },
    { id: 33589, cityId: 634, code: "173103" },
    { id: 33590, cityId: 634, code: "173104" },
    { id: 33591, cityId: 634, code: "173002" },
    { id: 33592, cityId: 634, code: "173004" },
    { id: 33593, cityId: 634, code: "173020" },
    { id: 33594, cityId: 634, code: "173023" },
    { id: 33595, cityId: 634, code: "173026" },
    { id: 33596, cityId: 634, code: "173028" },
    { id: 33597, cityId: 634, code: "173102" },
    { id: 33598, cityId: 635, code: "174101" },
    { id: 33599, cityId: 636, code: "171213" },
    { id: 33600, cityId: 637, code: "176202" },
    { id: 33601, cityId: 638, code: "176061" },
    { id: 33602, cityId: 638, code: "176062" },
    { id: 33603, cityId: 639, code: "173025" },
    { id: 33604, cityId: 640, code: "173220" },
    { id: 33605, cityId: 641, code: "454116" },
    { id: 33606, cityId: 641, code: "173101" },
    { id: 33607, cityId: 642, code: "222203" },
    { id: 33608, cityId: 642, code: "175042" },
    { id: 33609, cityId: 642, code: "233223" },
    { id: 33610, cityId: 642, code: "244901" },
    { id: 33611, cityId: 642, code: "261204" },
    { id: 33612, cityId: 642, code: "274405" },
    { id: 33613, cityId: 643, code: "172022" },
    { id: 33614, cityId: 643, code: "172024" },
    { id: 33615, cityId: 643, code: "172025" },
    { id: 33616, cityId: 643, code: "172027" },
    { id: 33617, cityId: 643, code: "172030" },
    { id: 33618, cityId: 643, code: "172032" },
    { id: 33619, cityId: 643, code: "172033" },
    { id: 33620, cityId: 643, code: "172035" },
    { id: 33621, cityId: 643, code: "172101" },
    { id: 33622, cityId: 643, code: "172102" },
    { id: 33623, cityId: 643, code: "172104" },
    { id: 33624, cityId: 643, code: "172107" },
    { id: 33625, cityId: 643, code: "172109" },
    { id: 33626, cityId: 643, code: "172110" },
    { id: 33627, cityId: 643, code: "172112" },
    { id: 33628, cityId: 643, code: "172115" },
    { id: 33629, cityId: 643, code: "172021" },
    { id: 33630, cityId: 643, code: "172023" },
    { id: 33631, cityId: 643, code: "172026" },
    { id: 33632, cityId: 643, code: "172029" },
    { id: 33633, cityId: 643, code: "172031" },
    { id: 33634, cityId: 643, code: "172034" },
    { id: 33635, cityId: 643, code: "172036" },
    { id: 33636, cityId: 643, code: "172103" },
    { id: 33637, cityId: 643, code: "172105" },
    { id: 33638, cityId: 643, code: "172106" },
    { id: 33639, cityId: 643, code: "172108" },
    { id: 33640, cityId: 643, code: "172111" },
    { id: 33641, cityId: 643, code: "172114" },
    { id: 33642, cityId: 644, code: "171207" },
    { id: 33643, cityId: 645, code: "174301" },
    { id: 33644, cityId: 646, code: "175024" },
    { id: 33645, cityId: 647, code: "171002" },
    { id: 33646, cityId: 647, code: "171005" },
    { id: 33647, cityId: 647, code: "171007" },
    { id: 33648, cityId: 647, code: "171010" },
    { id: 33649, cityId: 647, code: "171013" },
    { id: 33650, cityId: 647, code: "171016" },
    { id: 33651, cityId: 647, code: "171103" },
    { id: 33652, cityId: 647, code: "171108" },
    { id: 33653, cityId: 647, code: "171203" },
    { id: 33654, cityId: 647, code: "171204" },
    { id: 33655, cityId: 647, code: "171206" },
    { id: 33656, cityId: 647, code: "171209" },
    { id: 33657, cityId: 647, code: "171211" },
    { id: 33658, cityId: 647, code: "171212" },
    { id: 33659, cityId: 647, code: "171214" },
    { id: 33660, cityId: 647, code: "171217" },
    { id: 33661, cityId: 647, code: "171219" },
    { id: 33662, cityId: 647, code: "171302" },
    { id: 33663, cityId: 647, code: "171304" },
    { id: 33664, cityId: 647, code: "172001" },
    { id: 33665, cityId: 647, code: "171001" },
    { id: 33666, cityId: 647, code: "171003" },
    { id: 33667, cityId: 647, code: "171004" },
    { id: 33668, cityId: 647, code: "171006" },
    { id: 33669, cityId: 647, code: "171009" },
    { id: 33670, cityId: 647, code: "171011" },
    { id: 33671, cityId: 647, code: "171012" },
    { id: 33672, cityId: 647, code: "171014" },
    { id: 33673, cityId: 647, code: "171017" },
    { id: 33674, cityId: 647, code: "171019" },
    { id: 33675, cityId: 647, code: "171020" },
    { id: 33676, cityId: 647, code: "171101" },
    { id: 33677, cityId: 647, code: "171102" },
    { id: 33678, cityId: 647, code: "171202" },
    { id: 33679, cityId: 647, code: "171208" },
    { id: 33680, cityId: 647, code: "171210" },
    { id: 33681, cityId: 647, code: "171215" },
    { id: 33682, cityId: 647, code: "171216" },
    { id: 33683, cityId: 647, code: "171218" },
    { id: 33684, cityId: 647, code: "171303" },
    { id: 33685, cityId: 647, code: "171305" },
    { id: 33686, cityId: 647, code: "171306" },
    { id: 33687, cityId: 647, code: "172002" },
    { id: 33688, cityId: 648, code: "173201" },
    { id: 33689, cityId: 648, code: "173203" },
    { id: 33690, cityId: 648, code: "173204" },
    { id: 33691, cityId: 648, code: "173206" },
    { id: 33692, cityId: 648, code: "173209" },
    { id: 33693, cityId: 648, code: "173211" },
    { id: 33694, cityId: 648, code: "173212" },
    { id: 33695, cityId: 648, code: "173214" },
    { id: 33696, cityId: 648, code: "173217" },
    { id: 33697, cityId: 648, code: "173219" },
    { id: 33698, cityId: 648, code: "173222" },
    { id: 33699, cityId: 648, code: "173225" },
    { id: 33700, cityId: 648, code: "173227" },
    { id: 33701, cityId: 648, code: "173228" },
    { id: 33702, cityId: 648, code: "173230" },
    { id: 33703, cityId: 648, code: "174102" },
    { id: 33704, cityId: 648, code: "173202" },
    { id: 33705, cityId: 648, code: "173207" },
    { id: 33706, cityId: 648, code: "173208" },
    { id: 33707, cityId: 648, code: "173213" },
    { id: 33708, cityId: 648, code: "173215" },
    { id: 33709, cityId: 648, code: "173216" },
    { id: 33710, cityId: 648, code: "173218" },
    { id: 33711, cityId: 648, code: "173221" },
    { id: 33712, cityId: 648, code: "173223" },
    { id: 33713, cityId: 648, code: "173224" },
    { id: 33714, cityId: 648, code: "173226" },
    { id: 33715, cityId: 648, code: "173229" },
    { id: 33716, cityId: 648, code: "174103" },
    { id: 33717, cityId: 649, code: "171201" },
    { id: 33718, cityId: 650, code: "174302" },
    { id: 33719, cityId: 650, code: "174305" },
    { id: 33720, cityId: 650, code: "174307" },
    { id: 33721, cityId: 650, code: "174315" },
    { id: 33722, cityId: 650, code: "176601" },
    { id: 33723, cityId: 650, code: "177032" },
    { id: 33724, cityId: 650, code: "177109" },
    { id: 33725, cityId: 650, code: "177110" },
    { id: 33726, cityId: 650, code: "177202" },
    { id: 33727, cityId: 650, code: "177205" },
    { id: 33728, cityId: 650, code: "177207" },
    { id: 33729, cityId: 650, code: "177208" },
    { id: 33730, cityId: 650, code: "177210" },
    { id: 33731, cityId: 650, code: "177213" },
    { id: 33732, cityId: 650, code: "177215" },
    { id: 33733, cityId: 650, code: "177216" },
    { id: 33734, cityId: 650, code: "177218" },
    { id: 33735, cityId: 650, code: "174303" },
    { id: 33736, cityId: 650, code: "174306" },
    { id: 33737, cityId: 650, code: "174308" },
    { id: 33738, cityId: 650, code: "176626" },
    { id: 33739, cityId: 650, code: "177031" },
    { id: 33740, cityId: 650, code: "177039" },
    { id: 33741, cityId: 650, code: "177203" },
    { id: 33742, cityId: 650, code: "177204" },
    { id: 33743, cityId: 650, code: "177206" },
    { id: 33744, cityId: 650, code: "177209" },
    { id: 33745, cityId: 650, code: "177211" },
    { id: 33746, cityId: 650, code: "177212" },
    { id: 33747, cityId: 650, code: "177214" },
    { id: 33748, cityId: 650, code: "177217" },
    { id: 33749, cityId: 650, code: "177219" },
    { id: 33750, cityId: 650, code: "177220" },
    { id: 33751, cityId: 651, code: "192201" },
    { id: 33752, cityId: 652, code: "192102" },
    { id: 33753, cityId: 652, code: "192126" },
    { id: 33754, cityId: 652, code: "192129" },
    { id: 33755, cityId: 652, code: "192142" },
    { id: 33756, cityId: 652, code: "192145" },
    { id: 33757, cityId: 652, code: "192203" },
    { id: 33758, cityId: 652, code: "192214" },
    { id: 33759, cityId: 652, code: "192230" },
    { id: 33760, cityId: 652, code: "192232" },
    { id: 33761, cityId: 652, code: "192404" },
    { id: 33762, cityId: 652, code: "192101" },
    { id: 33763, cityId: 652, code: "192125" },
    { id: 33764, cityId: 652, code: "192127" },
    { id: 33765, cityId: 652, code: "192128" },
    { id: 33766, cityId: 652, code: "192141" },
    { id: 33767, cityId: 652, code: "192143" },
    { id: 33768, cityId: 652, code: "192144" },
    { id: 33769, cityId: 652, code: "192202" },
    { id: 33770, cityId: 652, code: "192204" },
    { id: 33771, cityId: 652, code: "192210" },
    { id: 33772, cityId: 652, code: "192212" },
    { id: 33773, cityId: 652, code: "192213" },
    { id: 33774, cityId: 652, code: "192233" },
    { id: 33775, cityId: 652, code: "192234" },
    { id: 33776, cityId: 652, code: "192401" },
    { id: 33777, cityId: 652, code: "192403" },
    { id: 33778, cityId: 653, code: "181131" },
    { id: 33779, cityId: 654, code: "192122" },
    { id: 33780, cityId: 655, code: "191111" },
    { id: 33781, cityId: 655, code: "192211" },
    { id: 33782, cityId: 655, code: "191113" },
    { id: 33783, cityId: 655, code: "191116" },
    { id: 33784, cityId: 655, code: "193108" },
    { id: 33785, cityId: 656, code: "182146" },
    { id: 33786, cityId: 657, code: "193101" },
    { id: 33787, cityId: 657, code: "193106" },
    { id: 33788, cityId: 657, code: "193107" },
    { id: 33789, cityId: 657, code: "193109" },
    { id: 33790, cityId: 657, code: "193122" },
    { id: 33791, cityId: 657, code: "193125" },
    { id: 33792, cityId: 657, code: "193130" },
    { id: 33793, cityId: 657, code: "193131" },
    { id: 33794, cityId: 657, code: "193202" },
    { id: 33795, cityId: 657, code: "193212" },
    { id: 33796, cityId: 657, code: "193220" },
    { id: 33797, cityId: 657, code: "193302" },
    { id: 33798, cityId: 657, code: "193303" },
    { id: 33799, cityId: 657, code: "193504" },
    { id: 33800, cityId: 657, code: "193506" },
    { id: 33801, cityId: 657, code: "193507" },
    { id: 33802, cityId: 657, code: "193102" },
    { id: 33803, cityId: 657, code: "193103" },
    { id: 33804, cityId: 657, code: "193105" },
    { id: 33805, cityId: 657, code: "193124" },
    { id: 33806, cityId: 657, code: "193132" },
    { id: 33807, cityId: 657, code: "193198" },
    { id: 33808, cityId: 657, code: "193201" },
    { id: 33809, cityId: 657, code: "193208" },
    { id: 33810, cityId: 657, code: "193209" },
    { id: 33811, cityId: 657, code: "193211" },
    { id: 33812, cityId: 657, code: "193301" },
    { id: 33813, cityId: 657, code: "193402" },
    { id: 33814, cityId: 657, code: "193502" },
    { id: 33815, cityId: 657, code: "193505" },
    { id: 33816, cityId: 657, code: "193508" },
    { id: 33817, cityId: 658, code: "181133" },
    { id: 33818, cityId: 659, code: "182143" },
    { id: 33819, cityId: 660, code: "193411" },
    { id: 33820, cityId: 661, code: "192124" },
    { id: 33821, cityId: 662, code: "182141" },
    { id: 33822, cityId: 663, code: "182145" },
    { id: 33823, cityId: 663, code: "182161" },
    { id: 33824, cityId: 663, code: "182201" },
    { id: 33825, cityId: 663, code: "182203" },
    { id: 33826, cityId: 663, code: "182222" },
    { id: 33827, cityId: 663, code: "180221" },
    { id: 33828, cityId: 663, code: "182160" },
    { id: 33829, cityId: 663, code: "182202" },
    { id: 33830, cityId: 663, code: "182205" },
    { id: 33831, cityId: 663, code: "182215" },
    { id: 33832, cityId: 663, code: "182220" },
    { id: 33833, cityId: 664, code: "191201" },
    { id: 33834, cityId: 665, code: "193403" },
    { id: 33835, cityId: 666, code: "193509" },
    { id: 33836, cityId: 667, code: "193221" },
    { id: 33837, cityId: 668, code: "180002" },
    { id: 33838, cityId: 668, code: "180003" },
    { id: 33839, cityId: 668, code: "180005" },
    { id: 33840, cityId: 668, code: "180010" },
    { id: 33841, cityId: 668, code: "180011" },
    { id: 33842, cityId: 668, code: "181101" },
    { id: 33843, cityId: 668, code: "181102" },
    { id: 33844, cityId: 668, code: "181104" },
    { id: 33845, cityId: 668, code: "181123" },
    { id: 33846, cityId: 668, code: "181133" },
    { id: 33847, cityId: 668, code: "181134" },
    { id: 33848, cityId: 668, code: "181141" },
    { id: 33849, cityId: 668, code: "181142" },
    { id: 33850, cityId: 668, code: "181144" },
    { id: 33851, cityId: 668, code: "181152" },
    { id: 33852, cityId: 668, code: "181205" },
    { id: 33853, cityId: 668, code: "181207" },
    { id: 33854, cityId: 668, code: "181208" },
    { id: 33855, cityId: 668, code: "181221" },
    { id: 33856, cityId: 668, code: "181223" },
    { id: 33857, cityId: 668, code: "181224" },
    { id: 33858, cityId: 668, code: "184121" },
    { id: 33859, cityId: 668, code: "180001" },
    { id: 33860, cityId: 668, code: "180004" },
    { id: 33861, cityId: 668, code: "180007" },
    { id: 33862, cityId: 668, code: "180009" },
    { id: 33863, cityId: 668, code: "181103" },
    { id: 33864, cityId: 668, code: "181105" },
    { id: 33865, cityId: 668, code: "181113" },
    { id: 33866, cityId: 668, code: "181114" },
    { id: 33867, cityId: 668, code: "181121" },
    { id: 33868, cityId: 668, code: "181122" },
    { id: 33869, cityId: 668, code: "181124" },
    { id: 33870, cityId: 668, code: "181132" },
    { id: 33871, cityId: 668, code: "181143" },
    { id: 33872, cityId: 668, code: "181145" },
    { id: 33873, cityId: 668, code: "181151" },
    { id: 33874, cityId: 668, code: "181201" },
    { id: 33875, cityId: 668, code: "181204" },
    { id: 33876, cityId: 668, code: "181206" },
    { id: 33877, cityId: 668, code: "181209" },
    { id: 33878, cityId: 668, code: "181212" },
    { id: 33879, cityId: 669, code: "181202" },
    { id: 33880, cityId: 670, code: "194109" },
    { id: 33881, cityId: 670, code: "194102" },
    { id: 33882, cityId: 670, code: "194103" },
    { id: 33883, cityId: 670, code: "194105" },
    { id: 33884, cityId: 670, code: "194301" },
    { id: 33885, cityId: 671, code: "184102" },
    { id: 33886, cityId: 671, code: "184142" },
    { id: 33887, cityId: 671, code: "184144" },
    { id: 33888, cityId: 671, code: "184147" },
    { id: 33889, cityId: 671, code: "184152" },
    { id: 33890, cityId: 671, code: "184203" },
    { id: 33891, cityId: 671, code: "184205" },
    { id: 33892, cityId: 671, code: "184206" },
    { id: 33893, cityId: 671, code: "184208" },
    { id: 33894, cityId: 671, code: "184101" },
    { id: 33895, cityId: 671, code: "184103" },
    { id: 33896, cityId: 671, code: "184104" },
    { id: 33897, cityId: 671, code: "184141" },
    { id: 33898, cityId: 671, code: "184143" },
    { id: 33899, cityId: 671, code: "184146" },
    { id: 33900, cityId: 671, code: "184148" },
    { id: 33901, cityId: 671, code: "184201" },
    { id: 33902, cityId: 671, code: "184202" },
    { id: 33903, cityId: 671, code: "184204" },
    { id: 33904, cityId: 671, code: "184207" },
    { id: 33905, cityId: 672, code: "182301" },
    { id: 33906, cityId: 672, code: "211002" },
    { id: 33907, cityId: 673, code: "181203" },
    { id: 33908, cityId: 674, code: "191103" },
    { id: 33909, cityId: 675, code: "182204" },
    { id: 33910, cityId: 676, code: "182142" },
    { id: 33911, cityId: 677, code: "192231" },
    { id: 33912, cityId: 678, code: "193404" },
    { id: 33913, cityId: 679, code: "193222" },
    { id: 33914, cityId: 679, code: "193225" },
    { id: 33915, cityId: 679, code: "193227" },
    { id: 33916, cityId: 679, code: "193228" },
    { id: 33917, cityId: 679, code: "191114" },
    { id: 33918, cityId: 679, code: "193223" },
    { id: 33919, cityId: 679, code: "193224" },
    { id: 33920, cityId: 679, code: "193226" },
    { id: 33921, cityId: 679, code: "193229" },
    { id: 33922, cityId: 680, code: "194104" },
    { id: 33923, cityId: 680, code: "194401" },
    { id: 33924, cityId: 680, code: "194101" },
    { id: 33925, cityId: 680, code: "194106" },
    { id: 33926, cityId: 680, code: "194201" },
    { id: 33927, cityId: 680, code: "194302" },
    { id: 33928, cityId: 681, code: "193230" },
    { id: 33929, cityId: 682, code: "192126" },
    { id: 33930, cityId: 683, code: "184151" },
    { id: 33931, cityId: 683, code: "191101" },
    { id: 33932, cityId: 684, code: "193121" },
    { id: 33933, cityId: 685, code: "185101" },
    { id: 33934, cityId: 685, code: "185122" },
    { id: 33935, cityId: 685, code: "185123" },
    { id: 33936, cityId: 685, code: "185102" },
    { id: 33937, cityId: 685, code: "185121" },
    { id: 33938, cityId: 685, code: "185211" },
    { id: 33939, cityId: 686, code: "192305" },
    { id: 33940, cityId: 686, code: "192306" },
    { id: 33941, cityId: 686, code: "193302" },
    { id: 33942, cityId: 687, code: "192121" },
    { id: 33943, cityId: 687, code: "192301" },
    { id: 33944, cityId: 687, code: "192303" },
    { id: 33945, cityId: 687, code: "192308" },
    { id: 33946, cityId: 687, code: "192309" },
    { id: 33947, cityId: 687, code: "192304" },
    { id: 33948, cityId: 687, code: "192307" },
    { id: 33949, cityId: 688, code: "192221" },
    { id: 33950, cityId: 689, code: "185120" },
    { id: 33951, cityId: 689, code: "185133" },
    { id: 33952, cityId: 689, code: "185135" },
    { id: 33953, cityId: 689, code: "185136" },
    { id: 33954, cityId: 689, code: "185151" },
    { id: 33955, cityId: 689, code: "185152" },
    { id: 33956, cityId: 689, code: "185157" },
    { id: 33957, cityId: 689, code: "185159" },
    { id: 33958, cityId: 689, code: "185212" },
    { id: 33959, cityId: 689, code: "185213" },
    { id: 33960, cityId: 689, code: "185131" },
    { id: 33961, cityId: 689, code: "185132" },
    { id: 33962, cityId: 689, code: "185134" },
    { id: 33963, cityId: 689, code: "185155" },
    { id: 33964, cityId: 689, code: "185156" },
    { id: 33965, cityId: 689, code: "185158" },
    { id: 33966, cityId: 689, code: "185201" },
    { id: 33967, cityId: 689, code: "185214" },
    { id: 33968, cityId: 690, code: "182144" },
    { id: 33969, cityId: 691, code: "181111" },
    { id: 33970, cityId: 691, code: "181112" },
    { id: 33971, cityId: 692, code: "182311" },
    { id: 33972, cityId: 693, code: "180008" },
    { id: 33973, cityId: 693, code: "184121" },
    { id: 33974, cityId: 694, code: "193201" },
    { id: 33975, cityId: 695, code: "190001" },
    { id: 33976, cityId: 695, code: "190002" },
    { id: 33977, cityId: 695, code: "190004" },
    { id: 33978, cityId: 695, code: "190007" },
    { id: 33979, cityId: 695, code: "190009" },
    { id: 33980, cityId: 695, code: "190010" },
    { id: 33981, cityId: 695, code: "190012" },
    { id: 33982, cityId: 695, code: "190015" },
    { id: 33983, cityId: 695, code: "190017" },
    { id: 33984, cityId: 695, code: "191101" },
    { id: 33985, cityId: 695, code: "191104" },
    { id: 33986, cityId: 695, code: "191141" },
    { id: 33987, cityId: 695, code: "191202" },
    { id: 33988, cityId: 695, code: "191204" },
    { id: 33989, cityId: 695, code: "190003" },
    { id: 33990, cityId: 695, code: "190005" },
    { id: 33991, cityId: 695, code: "190006" },
    { id: 33992, cityId: 695, code: "190008" },
    { id: 33993, cityId: 695, code: "190011" },
    { id: 33994, cityId: 695, code: "190014" },
    { id: 33995, cityId: 695, code: "190016" },
    { id: 33996, cityId: 695, code: "191102" },
    { id: 33997, cityId: 695, code: "191112" },
    { id: 33998, cityId: 695, code: "191115" },
    { id: 33999, cityId: 695, code: "191121" },
    { id: 34000, cityId: 695, code: "191123" },
    { id: 34001, cityId: 695, code: "191131" },
    { id: 34002, cityId: 695, code: "191203" },
    { id: 34003, cityId: 695, code: "191205" },
    { id: 34004, cityId: 695, code: "246174" },
    { id: 34005, cityId: 696, code: "193501" },
    { id: 34006, cityId: 697, code: "185153" },
    { id: 34007, cityId: 698, code: "192123" },
    { id: 34008, cityId: 699, code: "182121" },
    { id: 34009, cityId: 699, code: "182123" },
    { id: 34010, cityId: 699, code: "182124" },
    { id: 34011, cityId: 699, code: "182126" },
    { id: 34012, cityId: 699, code: "182312" },
    { id: 34013, cityId: 699, code: "182314" },
    { id: 34014, cityId: 699, code: "182320" },
    { id: 34015, cityId: 699, code: "182101" },
    { id: 34016, cityId: 699, code: "182103" },
    { id: 34017, cityId: 699, code: "182104" },
    { id: 34018, cityId: 699, code: "182122" },
    { id: 34019, cityId: 699, code: "182125" },
    { id: 34020, cityId: 699, code: "182128" },
    { id: 34021, cityId: 699, code: "182302" },
    { id: 34022, cityId: 699, code: "182313" },
    { id: 34023, cityId: 699, code: "182315" },
    { id: 34024, cityId: 699, code: "184145" },
    { id: 34025, cityId: 699, code: "185203" },
    { id: 34026, cityId: 700, code: "193123" },
    { id: 34027, cityId: 701, code: "184120" },
    { id: 34028, cityId: 702, code: "831013" },
    { id: 34029, cityId: 703, code: "835104" },
    { id: 34030, cityId: 704, code: "827001" },
    { id: 34031, cityId: 704, code: "827011" },
    { id: 34032, cityId: 704, code: "827012" },
    { id: 34033, cityId: 704, code: "828134" },
    { id: 34034, cityId: 704, code: "829107" },
    { id: 34035, cityId: 704, code: "829138" },
    { id: 34036, cityId: 704, code: "829141" },
    { id: 34037, cityId: 704, code: "835201" },
    { id: 34038, cityId: 704, code: "815317" },
    { id: 34039, cityId: 704, code: "827010" },
    { id: 34040, cityId: 704, code: "829115" },
    { id: 34041, cityId: 704, code: "829134" },
    { id: 34042, cityId: 705, code: "835204" },
    { id: 34043, cityId: 706, code: "833102" },
    { id: 34044, cityId: 707, code: "832401" },
    { id: 34045, cityId: 708, code: "828403" },
    { id: 34046, cityId: 709, code: "827013" },
    { id: 34047, cityId: 710, code: "814143" },
    { id: 34048, cityId: 710, code: "815316" },
    { id: 34049, cityId: 710, code: "822128" },
    { id: 34050, cityId: 710, code: "825103" },
    { id: 34051, cityId: 710, code: "825404" },
    { id: 34052, cityId: 710, code: "829205" },
    { id: 34053, cityId: 710, code: "825321" },
    { id: 34054, cityId: 710, code: "825401" },
    { id: 34055, cityId: 710, code: "825408" },
    { id: 34056, cityId: 711, code: "833106" },
    { id: 34057, cityId: 712, code: "828202" },
    { id: 34058, cityId: 713, code: "814113" },
    { id: 34059, cityId: 713, code: "814116" },
    { id: 34060, cityId: 713, code: "814150" },
    { id: 34061, cityId: 713, code: "814152" },
    { id: 34062, cityId: 713, code: "815352" },
    { id: 34063, cityId: 713, code: "814112" },
    { id: 34064, cityId: 713, code: "814114" },
    { id: 34065, cityId: 713, code: "814117" },
    { id: 34066, cityId: 713, code: "814151" },
    { id: 34067, cityId: 713, code: "815356" },
    { id: 34068, cityId: 713, code: "815357" },
    { id: 34069, cityId: 714, code: "826003" },
    { id: 34070, cityId: 714, code: "827004" },
    { id: 34071, cityId: 714, code: "827009" },
    { id: 34072, cityId: 714, code: "827014" },
    { id: 34073, cityId: 714, code: "828101" },
    { id: 34074, cityId: 714, code: "828103" },
    { id: 34075, cityId: 714, code: "828106" },
    { id: 34076, cityId: 714, code: "828108" },
    { id: 34077, cityId: 714, code: "828114" },
    { id: 34078, cityId: 714, code: "828116" },
    { id: 34079, cityId: 714, code: "828117" },
    { id: 34080, cityId: 714, code: "828119" },
    { id: 34081, cityId: 714, code: "828125" },
    { id: 34082, cityId: 714, code: "828127" },
    { id: 34083, cityId: 714, code: "828129" },
    { id: 34084, cityId: 714, code: "828135" },
    { id: 34085, cityId: 714, code: "828204" },
    { id: 34086, cityId: 714, code: "828206" },
    { id: 34087, cityId: 714, code: "828207" },
    { id: 34088, cityId: 714, code: "828302" },
    { id: 34089, cityId: 714, code: "828305" },
    { id: 34090, cityId: 714, code: "828307" },
    { id: 34091, cityId: 714, code: "826001" },
    { id: 34092, cityId: 714, code: "826004" },
    { id: 34093, cityId: 714, code: "827003" },
    { id: 34094, cityId: 714, code: "828102" },
    { id: 34095, cityId: 714, code: "828104" },
    { id: 34096, cityId: 714, code: "828107" },
    { id: 34097, cityId: 714, code: "828110" },
    { id: 34098, cityId: 714, code: "828113" },
    { id: 34099, cityId: 714, code: "828115" },
    { id: 34100, cityId: 714, code: "828120" },
    { id: 34101, cityId: 714, code: "828123" },
    { id: 34102, cityId: 714, code: "828126" },
    { id: 34103, cityId: 714, code: "828128" },
    { id: 34104, cityId: 714, code: "828131" },
    { id: 34105, cityId: 714, code: "828133" },
    { id: 34106, cityId: 714, code: "828142" },
    { id: 34107, cityId: 714, code: "828203" },
    { id: 34108, cityId: 714, code: "828205" },
    { id: 34109, cityId: 714, code: "828301" },
    { id: 34110, cityId: 714, code: "828303" },
    { id: 34111, cityId: 714, code: "828306" },
    { id: 34112, cityId: 714, code: "828308" },
    { id: 34113, cityId: 714, code: "828311" },
    { id: 34114, cityId: 715, code: "814103" },
    { id: 34115, cityId: 715, code: "814111" },
    { id: 34116, cityId: 715, code: "814119" },
    { id: 34117, cityId: 715, code: "814145" },
    { id: 34118, cityId: 715, code: "814146" },
    { id: 34119, cityId: 715, code: "814148" },
    { id: 34120, cityId: 715, code: "814158" },
    { id: 34121, cityId: 715, code: "814166" },
    { id: 34122, cityId: 715, code: "815359" },
    { id: 34123, cityId: 715, code: "816103" },
    { id: 34124, cityId: 715, code: "816124" },
    { id: 34125, cityId: 715, code: "814101" },
    { id: 34126, cityId: 715, code: "814102" },
    { id: 34127, cityId: 715, code: "814118" },
    { id: 34128, cityId: 715, code: "814120" },
    { id: 34129, cityId: 715, code: "814141" },
    { id: 34130, cityId: 715, code: "814144" },
    { id: 34131, cityId: 715, code: "814162" },
    { id: 34132, cityId: 715, code: "815355" },
    { id: 34133, cityId: 715, code: "816122" },
    { id: 34134, cityId: 715, code: "816123" },
    { id: 34135, cityId: 716, code: "822114" },
    { id: 34136, cityId: 717, code: "832303" },
    { id: 34137, cityId: 718, code: "815301" },
    { id: 34138, cityId: 718, code: "815312" },
    { id: 34139, cityId: 718, code: "815314" },
    { id: 34140, cityId: 718, code: "815315" },
    { id: 34141, cityId: 718, code: "825318" },
    { id: 34142, cityId: 718, code: "825329" },
    { id: 34143, cityId: 718, code: "825332" },
    { id: 34144, cityId: 718, code: "828404" },
    { id: 34145, cityId: 718, code: "829113" },
    { id: 34146, cityId: 718, code: "829116" },
    { id: 34147, cityId: 718, code: "829121" },
    { id: 34148, cityId: 718, code: "829127" },
    { id: 34149, cityId: 718, code: "829129" },
    { id: 34150, cityId: 718, code: "829211" },
    { id: 34151, cityId: 718, code: "815311" },
    { id: 34152, cityId: 718, code: "815313" },
    { id: 34153, cityId: 718, code: "825107" },
    { id: 34154, cityId: 718, code: "825108" },
    { id: 34155, cityId: 718, code: "825320" },
    { id: 34156, cityId: 718, code: "825412" },
    { id: 34157, cityId: 718, code: "829112" },
    { id: 34158, cityId: 718, code: "829128" },
    { id: 34159, cityId: 718, code: "829144" },
    { id: 34160, cityId: 718, code: "829149" },
    { id: 34161, cityId: 719, code: "835234" },
    { id: 34162, cityId: 719, code: "828109" },
    { id: 34163, cityId: 720, code: "828101" },
    { id: 34164, cityId: 721, code: "822112" },
    { id: 34165, cityId: 721, code: "815301" },
    { id: 34166, cityId: 721, code: "822121" },
    { id: 34167, cityId: 722, code: "833213" },
    { id: 34168, cityId: 723, code: "835201" },
    { id: 34169, cityId: 723, code: "835207" },
    { id: 34170, cityId: 723, code: "835212" },
    { id: 34171, cityId: 723, code: "835220" },
    { id: 34172, cityId: 723, code: "835226" },
    { id: 34173, cityId: 723, code: "835228" },
    { id: 34174, cityId: 723, code: "835230" },
    { id: 34175, cityId: 723, code: "835233" },
    { id: 34176, cityId: 723, code: "835211" },
    { id: 34177, cityId: 723, code: "835224" },
    { id: 34178, cityId: 723, code: "835229" },
    { id: 34179, cityId: 723, code: "835232" },
    { id: 34180, cityId: 723, code: "835235" },
    { id: 34181, cityId: 723, code: "835242" },
    { id: 34182, cityId: 724, code: "825301" },
    { id: 34183, cityId: 724, code: "825315" },
    { id: 34184, cityId: 724, code: "825317" },
    { id: 34185, cityId: 724, code: "825336" },
    { id: 34186, cityId: 724, code: "825402" },
    { id: 34187, cityId: 724, code: "825405" },
    { id: 34188, cityId: 724, code: "825407" },
    { id: 34189, cityId: 724, code: "825410" },
    { id: 34190, cityId: 724, code: "825413" },
    { id: 34191, cityId: 724, code: "825418" },
    { id: 34192, cityId: 724, code: "825421" },
    { id: 34193, cityId: 724, code: "829102" },
    { id: 34194, cityId: 724, code: "829105" },
    { id: 34195, cityId: 724, code: "829108" },
    { id: 34196, cityId: 724, code: "829110" },
    { id: 34197, cityId: 724, code: "829124" },
    { id: 34198, cityId: 724, code: "829126" },
    { id: 34199, cityId: 724, code: "829131" },
    { id: 34200, cityId: 724, code: "829317" },
    { id: 34201, cityId: 724, code: "825101" },
    { id: 34202, cityId: 724, code: "825102" },
    { id: 34203, cityId: 724, code: "825223" },
    { id: 34204, cityId: 724, code: "825313" },
    { id: 34205, cityId: 724, code: "825314" },
    { id: 34206, cityId: 724, code: "825319" },
    { id: 34207, cityId: 724, code: "825324" },
    { id: 34208, cityId: 724, code: "825327" },
    { id: 34209, cityId: 724, code: "825335" },
    { id: 34210, cityId: 724, code: "825403" },
    { id: 34211, cityId: 724, code: "825406" },
    { id: 34212, cityId: 724, code: "825411" },
    { id: 34213, cityId: 724, code: "825420" },
    { id: 34214, cityId: 724, code: "829101" },
    { id: 34215, cityId: 724, code: "829103" },
    { id: 34216, cityId: 724, code: "829106" },
    { id: 34217, cityId: 724, code: "829109" },
    { id: 34218, cityId: 724, code: "829117" },
    { id: 34219, cityId: 724, code: "829119" },
    { id: 34220, cityId: 724, code: "829120" },
    { id: 34221, cityId: 724, code: "829122" },
    { id: 34222, cityId: 724, code: "829125" },
    { id: 34223, cityId: 724, code: "829130" },
    { id: 34224, cityId: 724, code: "829133" },
    { id: 34225, cityId: 724, code: "829135" },
    { id: 34226, cityId: 724, code: "829143" },
    { id: 34227, cityId: 724, code: "829146" },
    { id: 34228, cityId: 724, code: "829201" },
    { id: 34229, cityId: 724, code: "833326" },
    { id: 34230, cityId: 725, code: "828112" },
    { id: 34231, cityId: 726, code: "831001" },
    { id: 34232, cityId: 726, code: "831003" },
    { id: 34233, cityId: 726, code: "831008" },
    { id: 34234, cityId: 726, code: "831009" },
    { id: 34235, cityId: 726, code: "831011" },
    { id: 34236, cityId: 726, code: "831014" },
    { id: 34237, cityId: 726, code: "831016" },
    { id: 34238, cityId: 726, code: "831017" },
    { id: 34239, cityId: 726, code: "832102" },
    { id: 34240, cityId: 726, code: "832103" },
    { id: 34241, cityId: 726, code: "832105" },
    { id: 34242, cityId: 726, code: "832108" },
    { id: 34243, cityId: 726, code: "832110" },
    { id: 34244, cityId: 726, code: "831002" },
    { id: 34245, cityId: 726, code: "831004" },
    { id: 34246, cityId: 726, code: "831005" },
    { id: 34247, cityId: 726, code: "831007" },
    { id: 34248, cityId: 726, code: "831010" },
    { id: 34249, cityId: 726, code: "831015" },
    { id: 34250, cityId: 726, code: "832101" },
    { id: 34251, cityId: 726, code: "832104" },
    { id: 34252, cityId: 726, code: "832106" },
    { id: 34253, cityId: 726, code: "832107" },
    { id: 34254, cityId: 726, code: "832109" },
    { id: 34255, cityId: 726, code: "832111" },
    { id: 34256, cityId: 727, code: "815351" },
    { id: 34257, cityId: 728, code: "829114" },
    { id: 34258, cityId: 729, code: "814142" },
    { id: 34259, cityId: 730, code: "828111" },
    { id: 34260, cityId: 731, code: "833215" },
    { id: 34261, cityId: 732, code: "825409" },
    { id: 34262, cityId: 733, code: "831006" },
    { id: 34263, cityId: 734, code: "832402" },
    { id: 34264, cityId: 735, code: "834006" },
    { id: 34265, cityId: 736, code: "825325" },
    { id: 34266, cityId: 737, code: "835210" },
    { id: 34267, cityId: 738, code: "825410" },
    { id: 34268, cityId: 738, code: "805132" },
    { id: 34269, cityId: 738, code: "847226" },
    { id: 34270, cityId: 739, code: "825316" },
    { id: 34271, cityId: 740, code: "829206" },
    { id: 34272, cityId: 741, code: "835302" },
    { id: 34273, cityId: 741, code: "835304" },
    { id: 34274, cityId: 741, code: "835213" },
    { id: 34275, cityId: 741, code: "835218" },
    { id: 34276, cityId: 741, code: "835305" },
    { id: 34277, cityId: 741, code: "835306" },
    { id: 34278, cityId: 742, code: "815353" },
    { id: 34279, cityId: 743, code: "828304" },
    { id: 34280, cityId: 744, code: "831012" },
    { id: 34281, cityId: 745, code: "815354" },
    { id: 34282, cityId: 746, code: "828504" },
    { id: 34283, cityId: 747, code: "833217" },
    { id: 34284, cityId: 748, code: "816104" },
    { id: 34285, cityId: 748, code: "816107" },
    { id: 34286, cityId: 748, code: "814111" },
    { id: 34287, cityId: 748, code: "816106" },
    { id: 34288, cityId: 749, code: "822101" },
    { id: 34289, cityId: 749, code: "822111" },
    { id: 34290, cityId: 749, code: "822119" },
    { id: 34291, cityId: 749, code: "822120" },
    { id: 34292, cityId: 749, code: "822122" },
    { id: 34293, cityId: 749, code: "822125" },
    { id: 34294, cityId: 749, code: "822127" },
    { id: 34295, cityId: 749, code: "822133" },
    { id: 34296, cityId: 749, code: "822138" },
    { id: 34297, cityId: 749, code: "822141" },
    { id: 34298, cityId: 749, code: "824119" },
    { id: 34299, cityId: 749, code: "829202" },
    { id: 34300, cityId: 749, code: "829204" },
    { id: 34301, cityId: 749, code: "829207" },
    { id: 34302, cityId: 749, code: "822102" },
    { id: 34303, cityId: 749, code: "822110" },
    { id: 34304, cityId: 749, code: "822113" },
    { id: 34305, cityId: 749, code: "822115" },
    { id: 34306, cityId: 749, code: "822116" },
    { id: 34307, cityId: 749, code: "822118" },
    { id: 34308, cityId: 749, code: "822123" },
    { id: 34309, cityId: 749, code: "822124" },
    { id: 34310, cityId: 749, code: "822126" },
    { id: 34311, cityId: 749, code: "822129" },
    { id: 34312, cityId: 749, code: "822131" },
    { id: 34313, cityId: 749, code: "829203" },
    { id: 34314, cityId: 750, code: "831001" },
    { id: 34315, cityId: 750, code: "831003" },
    { id: 34316, cityId: 750, code: "831008" },
    { id: 34317, cityId: 750, code: "831009" },
    { id: 34318, cityId: 750, code: "831011" },
    { id: 34319, cityId: 750, code: "831014" },
    { id: 34320, cityId: 750, code: "831016" },
    { id: 34321, cityId: 750, code: "832105" },
    { id: 34322, cityId: 750, code: "832107" },
    { id: 34323, cityId: 750, code: "832108" },
    { id: 34324, cityId: 750, code: "832110" },
    { id: 34325, cityId: 750, code: "832113" },
    { id: 34326, cityId: 750, code: "832301" },
    { id: 34327, cityId: 750, code: "832304" },
    { id: 34328, cityId: 750, code: "833101" },
    { id: 34329, cityId: 750, code: "833103" },
    { id: 34330, cityId: 750, code: "833104" },
    { id: 34331, cityId: 750, code: "833201" },
    { id: 34332, cityId: 750, code: "833202" },
    { id: 34333, cityId: 750, code: "833212" },
    { id: 34334, cityId: 750, code: "833214" },
    { id: 34335, cityId: 750, code: "833222" },
    { id: 34336, cityId: 750, code: "833233" },
    { id: 34337, cityId: 750, code: "831002" },
    { id: 34338, cityId: 750, code: "831004" },
    { id: 34339, cityId: 750, code: "831005" },
    { id: 34340, cityId: 750, code: "831007" },
    { id: 34341, cityId: 750, code: "831010" },
    { id: 34342, cityId: 750, code: "831015" },
    { id: 34343, cityId: 750, code: "831017" },
    { id: 34344, cityId: 750, code: "831018" },
    { id: 34345, cityId: 750, code: "832101" },
    { id: 34346, cityId: 750, code: "832103" },
    { id: 34347, cityId: 750, code: "832104" },
    { id: 34348, cityId: 750, code: "832106" },
    { id: 34349, cityId: 750, code: "832109" },
    { id: 34350, cityId: 750, code: "832112" },
    { id: 34351, cityId: 750, code: "832302" },
    { id: 34352, cityId: 750, code: "832403" },
    { id: 34353, cityId: 750, code: "833105" },
    { id: 34354, cityId: 750, code: "833203" },
    { id: 34355, cityId: 750, code: "833216" },
    { id: 34356, cityId: 750, code: "833218" },
    { id: 34357, cityId: 750, code: "833219" },
    { id: 34358, cityId: 750, code: "833221" },
    { id: 34359, cityId: 751, code: "829118" },
    { id: 34360, cityId: 752, code: "816108" },
    { id: 34361, cityId: 753, code: "829209" },
    { id: 34362, cityId: 753, code: "829210" },
    { id: 34363, cityId: 753, code: "834001" },
    { id: 34364, cityId: 753, code: "834003" },
    { id: 34365, cityId: 753, code: "834004" },
    { id: 34366, cityId: 753, code: "834006" },
    { id: 34367, cityId: 753, code: "834009" },
    { id: 34368, cityId: 753, code: "834011" },
    { id: 34369, cityId: 753, code: "834012" },
    { id: 34370, cityId: 753, code: "835102" },
    { id: 34371, cityId: 753, code: "835103" },
    { id: 34372, cityId: 753, code: "835206" },
    { id: 34373, cityId: 753, code: "835209" },
    { id: 34374, cityId: 753, code: "835214" },
    { id: 34375, cityId: 753, code: "835216" },
    { id: 34376, cityId: 753, code: "835217" },
    { id: 34377, cityId: 753, code: "835219" },
    { id: 34378, cityId: 753, code: "835222" },
    { id: 34379, cityId: 753, code: "835225" },
    { id: 34380, cityId: 753, code: "835227" },
    { id: 34381, cityId: 753, code: "835235" },
    { id: 34382, cityId: 753, code: "835238" },
    { id: 34383, cityId: 753, code: "835240" },
    { id: 34384, cityId: 753, code: "835301" },
    { id: 34385, cityId: 753, code: "835306" },
    { id: 34386, cityId: 753, code: "829208" },
    { id: 34387, cityId: 753, code: "834002" },
    { id: 34388, cityId: 753, code: "834005" },
    { id: 34389, cityId: 753, code: "834007" },
    { id: 34390, cityId: 753, code: "834008" },
    { id: 34391, cityId: 753, code: "834010" },
    { id: 34392, cityId: 753, code: "835101" },
    { id: 34393, cityId: 753, code: "835202" },
    { id: 34394, cityId: 753, code: "835205" },
    { id: 34395, cityId: 753, code: "835215" },
    { id: 34396, cityId: 753, code: "835234" },
    { id: 34397, cityId: 753, code: "835236" },
    { id: 34398, cityId: 753, code: "835239" },
    { id: 34399, cityId: 753, code: "835244" },
    { id: 34400, cityId: 753, code: "835303" },
    { id: 34401, cityId: 754, code: "816102" },
    { id: 34402, cityId: 754, code: "816105" },
    { id: 34403, cityId: 754, code: "816115" },
    { id: 34404, cityId: 754, code: "816120" },
    { id: 34405, cityId: 754, code: "816121" },
    { id: 34406, cityId: 754, code: "816129" },
    { id: 34407, cityId: 754, code: "816101" },
    { id: 34408, cityId: 754, code: "816104" },
    { id: 34409, cityId: 754, code: "816106" },
    { id: 34410, cityId: 754, code: "816116" },
    { id: 34411, cityId: 754, code: "816117" },
    { id: 34412, cityId: 754, code: "816119" },
    { id: 34413, cityId: 754, code: "816125" },
    { id: 34414, cityId: 755, code: "816109" },
    { id: 34415, cityId: 756, code: "828121" },
    { id: 34416, cityId: 757, code: "835223" },
    { id: 34417, cityId: 758, code: "828122" },
    { id: 34418, cityId: 759, code: "833220" },
    { id: 34419, cityId: 760, code: "829145" },
    { id: 34420, cityId: 761, code: "828144" },
    { id: 34421, cityId: 762, code: "825330" },
    { id: 34422, cityId: 763, code: "828402" },
    { id: 34423, cityId: 764, code: "584142" },
    { id: 34424, cityId: 764, code: "587124" },
    { id: 34425, cityId: 764, code: "590001" },
    { id: 34426, cityId: 764, code: "590003" },
    { id: 34427, cityId: 764, code: "590006" },
    { id: 34428, cityId: 764, code: "590008" },
    { id: 34429, cityId: 764, code: "590009" },
    { id: 34430, cityId: 764, code: "590011" },
    { id: 34431, cityId: 764, code: "590014" },
    { id: 34432, cityId: 764, code: "590543" },
    { id: 34433, cityId: 764, code: "591102" },
    { id: 34434, cityId: 764, code: "591107" },
    { id: 34435, cityId: 764, code: "591108" },
    { id: 34436, cityId: 764, code: "591110" },
    { id: 34437, cityId: 764, code: "591113" },
    { id: 34438, cityId: 764, code: "591115" },
    { id: 34439, cityId: 764, code: "591116" },
    { id: 34440, cityId: 764, code: "591118" },
    { id: 34441, cityId: 764, code: "591121" },
    { id: 34442, cityId: 764, code: "591123" },
    { id: 34443, cityId: 764, code: "591126" },
    { id: 34444, cityId: 764, code: "591129" },
    { id: 34445, cityId: 764, code: "591131" },
    { id: 34446, cityId: 764, code: "591132" },
    { id: 34447, cityId: 764, code: "591134" },
    { id: 34448, cityId: 764, code: "591137" },
    { id: 34449, cityId: 764, code: "591139" },
    { id: 34450, cityId: 764, code: "591140" },
    { id: 34451, cityId: 764, code: "591142" },
    { id: 34452, cityId: 764, code: "591145" },
    { id: 34453, cityId: 764, code: "591147" },
    { id: 34454, cityId: 764, code: "591148" },
    { id: 34455, cityId: 764, code: "591150" },
    { id: 34456, cityId: 764, code: "591152" },
    { id: 34457, cityId: 764, code: "591155" },
    { id: 34458, cityId: 764, code: "591158" },
    { id: 34459, cityId: 764, code: "591160" },
    { id: 34460, cityId: 764, code: "591161" },
    { id: 34461, cityId: 764, code: "591163" },
    { id: 34462, cityId: 764, code: "591168" },
    { id: 34463, cityId: 764, code: "591169" },
    { id: 34464, cityId: 764, code: "591171" },
    { id: 34465, cityId: 764, code: "591176" },
    { id: 34466, cityId: 764, code: "591177" },
    { id: 34467, cityId: 764, code: "591182" },
    { id: 34468, cityId: 764, code: "591184" },
    { id: 34469, cityId: 764, code: "591185" },
    { id: 34470, cityId: 764, code: "591187" },
    { id: 34471, cityId: 764, code: "591190" },
    { id: 34472, cityId: 764, code: "591192" },
    { id: 34473, cityId: 764, code: "591193" },
    { id: 34474, cityId: 764, code: "591195" },
    { id: 34475, cityId: 764, code: "591198" },
    { id: 34476, cityId: 764, code: "591211" },
    { id: 34477, cityId: 764, code: "591213" },
    { id: 34478, cityId: 764, code: "591214" },
    { id: 34479, cityId: 764, code: "591216" },
    { id: 34480, cityId: 764, code: "591219" },
    { id: 34481, cityId: 764, code: "591221" },
    { id: 34482, cityId: 764, code: "591222" },
    { id: 34483, cityId: 764, code: "591224" },
    { id: 34484, cityId: 764, code: "591227" },
    { id: 34485, cityId: 764, code: "591229" },
    { id: 34486, cityId: 764, code: "591230" },
    { id: 34487, cityId: 764, code: "591232" },
    { id: 34488, cityId: 764, code: "591235" },
    { id: 34489, cityId: 764, code: "591237" },
    { id: 34490, cityId: 764, code: "591238" },
    { id: 34491, cityId: 764, code: "591240" },
    { id: 34492, cityId: 764, code: "591243" },
    { id: 34493, cityId: 764, code: "591245" },
    { id: 34494, cityId: 764, code: "591248" },
    { id: 34495, cityId: 764, code: "591250" },
    { id: 34496, cityId: 764, code: "591251" },
    { id: 34497, cityId: 764, code: "591253" },
    { id: 34498, cityId: 764, code: "591256" },
    { id: 34499, cityId: 764, code: "591258" },
    { id: 34500, cityId: 764, code: "591259" },
    { id: 34501, cityId: 764, code: "591261" },
    { id: 34502, cityId: 764, code: "591264" },
    { id: 34503, cityId: 764, code: "591266" },
    { id: 34504, cityId: 764, code: "591267" },
    { id: 34505, cityId: 764, code: "591269" },
    { id: 34506, cityId: 764, code: "591272" },
    { id: 34507, cityId: 764, code: "591274" },
    { id: 34508, cityId: 764, code: "591275" },
    { id: 34509, cityId: 764, code: "591280" },
    { id: 34510, cityId: 764, code: "591282" },
    { id: 34511, cityId: 764, code: "591285" },
    { id: 34512, cityId: 764, code: "591288" },
    { id: 34513, cityId: 764, code: "591290" },
    { id: 34514, cityId: 764, code: "591291" },
    { id: 34515, cityId: 764, code: "591293" },
    { id: 34516, cityId: 764, code: "591295" },
    { id: 34517, cityId: 764, code: "591296" },
    { id: 34518, cityId: 764, code: "591298" },
    { id: 34519, cityId: 764, code: "591303" },
    { id: 34520, cityId: 764, code: "591304" },
    { id: 34521, cityId: 764, code: "591306" },
    { id: 34522, cityId: 764, code: "591309" },
    { id: 34523, cityId: 764, code: "591312" },
    { id: 34524, cityId: 764, code: "591314" },
    { id: 34525, cityId: 764, code: "591317" },
    { id: 34526, cityId: 764, code: "591320" },
    { id: 34527, cityId: 764, code: "591322" },
    { id: 34528, cityId: 764, code: "591327" },
    { id: 34529, cityId: 764, code: "591328" },
    { id: 34530, cityId: 764, code: "591330" },
    { id: 34531, cityId: 764, code: "591333" },
    { id: 34532, cityId: 764, code: "591343" },
    { id: 34533, cityId: 764, code: "591502" },
    { id: 34534, cityId: 764, code: "591505" },
    { id: 34535, cityId: 764, code: "591507" },
    { id: 34536, cityId: 764, code: "591508" },
    { id: 34537, cityId: 764, code: "591510" },
    { id: 34538, cityId: 764, code: "591513" },
    { id: 34539, cityId: 764, code: "591515" },
    { id: 34540, cityId: 764, code: "591516" },
    { id: 34541, cityId: 764, code: "591701" },
    { id: 34542, cityId: 764, code: "591703" },
    { id: 34543, cityId: 764, code: "591802" },
    { id: 34544, cityId: 764, code: "591812" },
    { id: 34545, cityId: 764, code: "581229" },
    { id: 34546, cityId: 764, code: "590002" },
    { id: 34547, cityId: 764, code: "590004" },
    { id: 34548, cityId: 764, code: "590005" },
    { id: 34549, cityId: 764, code: "590007" },
    { id: 34550, cityId: 764, code: "590010" },
    { id: 34551, cityId: 764, code: "590012" },
    { id: 34552, cityId: 764, code: "590013" },
    { id: 34553, cityId: 764, code: "590015" },
    { id: 34554, cityId: 764, code: "591101" },
    { id: 34555, cityId: 764, code: "591103" },
    { id: 34556, cityId: 764, code: "591104" },
    { id: 34557, cityId: 764, code: "591106" },
    { id: 34558, cityId: 764, code: "591109" },
    { id: 34559, cityId: 764, code: "591111" },
    { id: 34560, cityId: 764, code: "591112" },
    { id: 34561, cityId: 764, code: "591114" },
    { id: 34562, cityId: 764, code: "591119" },
    { id: 34563, cityId: 764, code: "591120" },
    { id: 34564, cityId: 764, code: "591122" },
    { id: 34565, cityId: 764, code: "591125" },
    { id: 34566, cityId: 764, code: "591127" },
    { id: 34567, cityId: 764, code: "591128" },
    { id: 34568, cityId: 764, code: "591130" },
    { id: 34569, cityId: 764, code: "591135" },
    { id: 34570, cityId: 764, code: "591136" },
    { id: 34571, cityId: 764, code: "591138" },
    { id: 34572, cityId: 764, code: "591141" },
    { id: 34573, cityId: 764, code: "591143" },
    { id: 34574, cityId: 764, code: "591144" },
    { id: 34575, cityId: 764, code: "591146" },
    { id: 34576, cityId: 764, code: "591149" },
    { id: 34577, cityId: 764, code: "591151" },
    { id: 34578, cityId: 764, code: "591154" },
    { id: 34579, cityId: 764, code: "591157" },
    { id: 34580, cityId: 764, code: "591159" },
    { id: 34581, cityId: 764, code: "591162" },
    { id: 34582, cityId: 764, code: "591164" },
    { id: 34583, cityId: 764, code: "591167" },
    { id: 34584, cityId: 764, code: "591173" },
    { id: 34585, cityId: 764, code: "591175" },
    { id: 34586, cityId: 764, code: "591178" },
    { id: 34587, cityId: 764, code: "591180" },
    { id: 34588, cityId: 764, code: "591181" },
    { id: 34589, cityId: 764, code: "591183" },
    { id: 34590, cityId: 764, code: "591186" },
    { id: 34591, cityId: 764, code: "591188" },
    { id: 34592, cityId: 764, code: "591189" },
    { id: 34593, cityId: 764, code: "591191" },
    { id: 34594, cityId: 764, code: "591194" },
    { id: 34595, cityId: 764, code: "591196" },
    { id: 34596, cityId: 764, code: "591197" },
    { id: 34597, cityId: 764, code: "591201" },
    { id: 34598, cityId: 764, code: "591212" },
    { id: 34599, cityId: 764, code: "591215" },
    { id: 34600, cityId: 764, code: "591217" },
    { id: 34601, cityId: 764, code: "591218" },
    { id: 34602, cityId: 764, code: "591220" },
    { id: 34603, cityId: 764, code: "591225" },
    { id: 34604, cityId: 764, code: "591226" },
    { id: 34605, cityId: 764, code: "591228" },
    { id: 34606, cityId: 764, code: "591233" },
    { id: 34607, cityId: 764, code: "591234" },
    { id: 34608, cityId: 764, code: "591236" },
    { id: 34609, cityId: 764, code: "591239" },
    { id: 34610, cityId: 764, code: "591241" },
    { id: 34611, cityId: 764, code: "591242" },
    { id: 34612, cityId: 764, code: "591244" },
    { id: 34613, cityId: 764, code: "591246" },
    { id: 34614, cityId: 764, code: "591247" },
    { id: 34615, cityId: 764, code: "591249" },
    { id: 34616, cityId: 764, code: "591252" },
    { id: 34617, cityId: 764, code: "591254" },
    { id: 34618, cityId: 764, code: "591255" },
    { id: 34619, cityId: 764, code: "591257" },
    { id: 34620, cityId: 764, code: "591260" },
    { id: 34621, cityId: 764, code: "591262" },
    { id: 34622, cityId: 764, code: "591263" },
    { id: 34623, cityId: 764, code: "591265" },
    { id: 34624, cityId: 764, code: "591268" },
    { id: 34625, cityId: 764, code: "591270" },
    { id: 34626, cityId: 764, code: "591271" },
    { id: 34627, cityId: 764, code: "591273" },
    { id: 34628, cityId: 764, code: "591276" },
    { id: 34629, cityId: 764, code: "591279" },
    { id: 34630, cityId: 764, code: "591281" },
    { id: 34631, cityId: 764, code: "591284" },
    { id: 34632, cityId: 764, code: "591286" },
    { id: 34633, cityId: 764, code: "591287" },
    { id: 34634, cityId: 764, code: "591289" },
    { id: 34635, cityId: 764, code: "591292" },
    { id: 34636, cityId: 764, code: "591297" },
    { id: 34637, cityId: 764, code: "591299" },
    { id: 34638, cityId: 764, code: "591302" },
    { id: 34639, cityId: 764, code: "591305" },
    { id: 34640, cityId: 764, code: "591307" },
    { id: 34641, cityId: 764, code: "591308" },
    { id: 34642, cityId: 764, code: "591310" },
    { id: 34643, cityId: 764, code: "591313" },
    { id: 34644, cityId: 764, code: "591315" },
    { id: 34645, cityId: 764, code: "591316" },
    { id: 34646, cityId: 764, code: "591318" },
    { id: 34647, cityId: 764, code: "591321" },
    { id: 34648, cityId: 764, code: "591323" },
    { id: 34649, cityId: 764, code: "591324" },
    { id: 34650, cityId: 764, code: "591329" },
    { id: 34651, cityId: 764, code: "591331" },
    { id: 34652, cityId: 764, code: "591332" },
    { id: 34653, cityId: 764, code: "591334" },
    { id: 34654, cityId: 764, code: "591337" },
    { id: 34655, cityId: 764, code: "591339" },
    { id: 34656, cityId: 764, code: "591340" },
    { id: 34657, cityId: 764, code: "591344" },
    { id: 34658, cityId: 764, code: "591501" },
    { id: 34659, cityId: 764, code: "591503" },
    { id: 34660, cityId: 764, code: "591504" },
    { id: 34661, cityId: 764, code: "591506" },
    { id: 34662, cityId: 764, code: "591509" },
    { id: 34663, cityId: 764, code: "591511" },
    { id: 34664, cityId: 764, code: "591512" },
    { id: 34665, cityId: 764, code: "591514" },
    { id: 34666, cityId: 764, code: "591517" },
    { id: 34667, cityId: 764, code: "591702" },
    { id: 34668, cityId: 765, code: "575009" },
    { id: 34669, cityId: 766, code: "585246" },
    { id: 34670, cityId: 766, code: "585301" },
    { id: 34671, cityId: 766, code: "577170" },
    { id: 34672, cityId: 766, code: "585104" },
    { id: 34673, cityId: 766, code: "585217" },
    { id: 34674, cityId: 766, code: "585242" },
    { id: 34675, cityId: 766, code: "585332" },
    { id: 34676, cityId: 766, code: "586131" },
    { id: 34677, cityId: 766, code: "587202" },
    { id: 34678, cityId: 766, code: "804418" },
    { id: 34679, cityId: 767, code: "571151" },
    { id: 34680, cityId: 767, code: "585240" },
    { id: 34681, cityId: 767, code: "585314" },
    { id: 34682, cityId: 767, code: "587131" },
    { id: 34683, cityId: 767, code: "573213" },
    { id: 34684, cityId: 767, code: "580117" },
    { id: 34685, cityId: 767, code: "585274" },
    { id: 34686, cityId: 767, code: "585311" },
    { id: 34687, cityId: 767, code: "586113" },
    { id: 34688, cityId: 768, code: "581103" },
    { id: 34689, cityId: 769, code: "571314" },
    { id: 34690, cityId: 769, code: "572217" },
    { id: 34691, cityId: 769, code: "573138" },
    { id: 34692, cityId: 769, code: "573146" },
    { id: 34693, cityId: 769, code: "573218" },
    { id: 34694, cityId: 769, code: "577154" },
    { id: 34695, cityId: 769, code: "563131" },
    { id: 34696, cityId: 769, code: "571172" },
    { id: 34697, cityId: 769, code: "571185" },
    { id: 34698, cityId: 769, code: "571220" },
    { id: 34699, cityId: 769, code: "571418" },
    { id: 34700, cityId: 769, code: "577131" },
    { id: 34701, cityId: 769, code: "577144" },
    { id: 34702, cityId: 769, code: "577219" },
    { id: 34703, cityId: 769, code: "577301" },
    { id: 34704, cityId: 769, code: "577573" },
    { id: 34705, cityId: 770, code: "572151" },
    { id: 34706, cityId: 770, code: "562106" },
    { id: 34707, cityId: 770, code: "572221" },
    { id: 34708, cityId: 770, code: "573101" },
    { id: 34709, cityId: 770, code: "581101" },
    { id: 34710, cityId: 771, code: "581314" },
    { id: 34711, cityId: 772, code: "582201" },
    { id: 34712, cityId: 773, code: "571131" },
    { id: 34713, cityId: 773, code: "571149" },
    { id: 34714, cityId: 773, code: "571240" },
    { id: 34715, cityId: 773, code: "571446" },
    { id: 34716, cityId: 773, code: "572113" },
    { id: 34717, cityId: 773, code: "573102" },
    { id: 34718, cityId: 773, code: "573136" },
    { id: 34719, cityId: 773, code: "573147" },
    { id: 34720, cityId: 773, code: "573154" },
    { id: 34721, cityId: 773, code: "577551" },
    { id: 34722, cityId: 773, code: "571251" },
    { id: 34723, cityId: 773, code: "571511" },
    { id: 34724, cityId: 773, code: "577234" },
    { id: 34725, cityId: 773, code: "577444" },
    { id: 34726, cityId: 774, code: "571102" },
    { id: 34727, cityId: 774, code: "571144" },
    { id: 34728, cityId: 774, code: "571415" },
    { id: 34729, cityId: 774, code: "573112" },
    { id: 34730, cityId: 774, code: "573125" },
    { id: 34731, cityId: 774, code: "573144" },
    { id: 34732, cityId: 774, code: "573160" },
    { id: 34733, cityId: 774, code: "577120" },
    { id: 34734, cityId: 774, code: "577138" },
    { id: 34735, cityId: 774, code: "577572" },
    { id: 34736, cityId: 774, code: "571615" },
    { id: 34737, cityId: 774, code: "572229" },
    { id: 34738, cityId: 774, code: "573103" },
    { id: 34739, cityId: 774, code: "573117" },
    { id: 34740, cityId: 774, code: "573119" },
    { id: 34741, cityId: 775, code: "591304" },
    { id: 34742, cityId: 776, code: "585259" },
    { id: 34743, cityId: 776, code: "572223" },
    { id: 34744, cityId: 776, code: "577584" },
    { id: 34745, cityId: 776, code: "580008" },
    { id: 34746, cityId: 776, code: "587141" },
    { id: 34747, cityId: 777, code: "577583" },
    { id: 34748, cityId: 777, code: "586144" },
    { id: 34749, cityId: 777, code: "587317" },
    { id: 34750, cityId: 777, code: "580216" },
    { id: 34751, cityId: 777, code: "581161" },
    { id: 34752, cityId: 777, code: "582218" },
    { id: 34753, cityId: 777, code: "587144" },
    { id: 34754, cityId: 777, code: "587149" },
    { id: 34755, cityId: 777, code: "587205" },
    { id: 34756, cityId: 777, code: "587210" },
    { id: 34757, cityId: 778, code: "587101" },
    { id: 34758, cityId: 778, code: "587103" },
    { id: 34759, cityId: 778, code: "587114" },
    { id: 34760, cityId: 778, code: "587143" },
    { id: 34761, cityId: 778, code: "587204" },
    { id: 34762, cityId: 778, code: "585256" },
    { id: 34763, cityId: 778, code: "587102" },
    { id: 34764, cityId: 778, code: "587152" },
    { id: 34765, cityId: 778, code: "587213" },
    { id: 34766, cityId: 779, code: "561207" },
    { id: 34767, cityId: 779, code: "563135" },
    { id: 34768, cityId: 779, code: "561212" },
    { id: 34769, cityId: 779, code: "561222" },
    { id: 34770, cityId: 780, code: "574142" },
    { id: 34771, cityId: 781, code: "560001" },
    { id: 34772, cityId: 781, code: "560003" },
    { id: 34773, cityId: 781, code: "560006" },
    { id: 34774, cityId: 781, code: "560008" },
    { id: 34775, cityId: 781, code: "560009" },
    { id: 34776, cityId: 781, code: "560011" },
    { id: 34777, cityId: 781, code: "560013" },
    { id: 34778, cityId: 781, code: "560014" },
    { id: 34779, cityId: 781, code: "560016" },
    { id: 34780, cityId: 781, code: "560019" },
    { id: 34781, cityId: 781, code: "560021" },
    { id: 34782, cityId: 781, code: "560022" },
    { id: 34783, cityId: 781, code: "560024" },
    { id: 34784, cityId: 781, code: "560027" },
    { id: 34785, cityId: 781, code: "560029" },
    { id: 34786, cityId: 781, code: "560030" },
    { id: 34787, cityId: 781, code: "560032" },
    { id: 34788, cityId: 781, code: "560035" },
    { id: 34789, cityId: 781, code: "560037" },
    { id: 34790, cityId: 781, code: "560038" },
    { id: 34791, cityId: 781, code: "560040" },
    { id: 34792, cityId: 781, code: "560043" },
    { id: 34793, cityId: 781, code: "560045" },
    { id: 34794, cityId: 781, code: "560046" },
    { id: 34795, cityId: 781, code: "560051" },
    { id: 34796, cityId: 781, code: "560053" },
    { id: 34797, cityId: 781, code: "560054" },
    { id: 34798, cityId: 781, code: "560056" },
    { id: 34799, cityId: 781, code: "560059" },
    { id: 34800, cityId: 781, code: "560061" },
    { id: 34801, cityId: 781, code: "560064" },
    { id: 34802, cityId: 781, code: "560066" },
    { id: 34803, cityId: 781, code: "560067" },
    { id: 34804, cityId: 781, code: "560069" },
    { id: 34805, cityId: 781, code: "560072" },
    { id: 34806, cityId: 781, code: "560074" },
    { id: 34807, cityId: 781, code: "560075" },
    { id: 34808, cityId: 781, code: "560077" },
    { id: 34809, cityId: 781, code: "560080" },
    { id: 34810, cityId: 781, code: "560082" },
    { id: 34811, cityId: 781, code: "560083" },
    { id: 34812, cityId: 781, code: "560085" },
    { id: 34813, cityId: 781, code: "560088" },
    { id: 34814, cityId: 781, code: "560090" },
    { id: 34815, cityId: 781, code: "560091" },
    { id: 34816, cityId: 781, code: "561203" },
    { id: 34817, cityId: 781, code: "561205" },
    { id: 34818, cityId: 781, code: "561214" },
    { id: 34819, cityId: 781, code: "561227" },
    { id: 34820, cityId: 781, code: "562101" },
    { id: 34821, cityId: 781, code: "562108" },
    { id: 34822, cityId: 781, code: "562109" },
    { id: 34823, cityId: 781, code: "562111" },
    { id: 34824, cityId: 781, code: "562117" },
    { id: 34825, cityId: 781, code: "562119" },
    { id: 34826, cityId: 781, code: "562122" },
    { id: 34827, cityId: 781, code: "562124" },
    { id: 34828, cityId: 781, code: "562125" },
    { id: 34829, cityId: 781, code: "562127" },
    { id: 34830, cityId: 781, code: "562130" },
    { id: 34831, cityId: 781, code: "562132" },
    { id: 34832, cityId: 781, code: "562138" },
    { id: 34833, cityId: 781, code: "562140" },
    { id: 34834, cityId: 781, code: "562143" },
    { id: 34835, cityId: 781, code: "562148" },
    { id: 34836, cityId: 781, code: "562149" },
    { id: 34837, cityId: 781, code: "562151" },
    { id: 34838, cityId: 781, code: "562154" },
    { id: 34839, cityId: 781, code: "573127" },
    { id: 34840, cityId: 781, code: "560002" },
    { id: 34841, cityId: 781, code: "560004" },
    { id: 34842, cityId: 781, code: "560005" },
    { id: 34843, cityId: 781, code: "560007" },
    { id: 34844, cityId: 781, code: "560010" },
    { id: 34845, cityId: 781, code: "560012" },
    { id: 34846, cityId: 781, code: "560015" },
    { id: 34847, cityId: 781, code: "560017" },
    { id: 34848, cityId: 781, code: "560018" },
    { id: 34849, cityId: 781, code: "560020" },
    { id: 34850, cityId: 781, code: "560023" },
    { id: 34851, cityId: 781, code: "560025" },
    { id: 34852, cityId: 781, code: "560026" },
    { id: 34853, cityId: 781, code: "560028" },
    { id: 34854, cityId: 781, code: "560031" },
    { id: 34855, cityId: 781, code: "560033" },
    { id: 34856, cityId: 781, code: "560034" },
    { id: 34857, cityId: 781, code: "560036" },
    { id: 34858, cityId: 781, code: "560039" },
    { id: 34859, cityId: 781, code: "560041" },
    { id: 34860, cityId: 781, code: "560042" },
    { id: 34861, cityId: 781, code: "560044" },
    { id: 34862, cityId: 781, code: "560047" },
    { id: 34863, cityId: 781, code: "560049" },
    { id: 34864, cityId: 781, code: "560050" },
    { id: 34865, cityId: 781, code: "560052" },
    { id: 34866, cityId: 781, code: "560055" },
    { id: 34867, cityId: 781, code: "560058" },
    { id: 34868, cityId: 781, code: "560062" },
    { id: 34869, cityId: 781, code: "560063" },
    { id: 34870, cityId: 781, code: "560065" },
    { id: 34871, cityId: 781, code: "560070" },
    { id: 34872, cityId: 781, code: "560071" },
    { id: 34873, cityId: 781, code: "560073" },
    { id: 34874, cityId: 781, code: "560076" },
    { id: 34875, cityId: 781, code: "560078" },
    { id: 34876, cityId: 781, code: "560079" },
    { id: 34877, cityId: 781, code: "560081" },
    { id: 34878, cityId: 781, code: "560084" },
    { id: 34879, cityId: 781, code: "560086" },
    { id: 34880, cityId: 781, code: "560087" },
    { id: 34881, cityId: 781, code: "560089" },
    { id: 34882, cityId: 781, code: "560097" },
    { id: 34883, cityId: 781, code: "561101" },
    { id: 34884, cityId: 781, code: "561201" },
    { id: 34885, cityId: 781, code: "561204" },
    { id: 34886, cityId: 781, code: "561215" },
    { id: 34887, cityId: 781, code: "561226" },
    { id: 34888, cityId: 781, code: "562107" },
    { id: 34889, cityId: 781, code: "562110" },
    { id: 34890, cityId: 781, code: "562112" },
    { id: 34891, cityId: 781, code: "562115" },
    { id: 34892, cityId: 781, code: "562121" },
    { id: 34893, cityId: 781, code: "562123" },
    { id: 34894, cityId: 781, code: "562126" },
    { id: 34895, cityId: 781, code: "562128" },
    { id: 34896, cityId: 781, code: "562129" },
    { id: 34897, cityId: 781, code: "562131" },
    { id: 34898, cityId: 781, code: "562134" },
    { id: 34899, cityId: 781, code: "562136" },
    { id: 34900, cityId: 781, code: "562137" },
    { id: 34901, cityId: 781, code: "562139" },
    { id: 34902, cityId: 781, code: "562142" },
    { id: 34903, cityId: 781, code: "562144" },
    { id: 34904, cityId: 781, code: "562145" },
    { id: 34905, cityId: 781, code: "562147" },
    { id: 34906, cityId: 781, code: "562150" },
    { id: 34907, cityId: 781, code: "562152" },
    { id: 34908, cityId: 781, code: "562153" },
    { id: 34909, cityId: 781, code: "562157" },
    { id: 34910, cityId: 781, code: "562158" },
    { id: 34911, cityId: 782, code: "571109" },
    { id: 34912, cityId: 782, code: "572126" },
    { id: 34913, cityId: 782, code: "571470" },
    { id: 34914, cityId: 782, code: "582111" },
    { id: 34915, cityId: 783, code: "571485" },
    { id: 34916, cityId: 783, code: "572139" },
    { id: 34917, cityId: 783, code: "572214" },
    { id: 34918, cityId: 783, code: "586160" },
    { id: 34919, cityId: 784, code: "563147" },
    { id: 34920, cityId: 784, code: "571126" },
    { id: 34921, cityId: 784, code: "577221" },
    { id: 34922, cityId: 784, code: "563116" },
    { id: 34923, cityId: 785, code: "571101" },
    { id: 34924, cityId: 786, code: "574211" },
    { id: 34925, cityId: 787, code: "585331" },
    { id: 34926, cityId: 787, code: "585349" },
    { id: 34927, cityId: 787, code: "585354" },
    { id: 34928, cityId: 787, code: "585221" },
    { id: 34929, cityId: 787, code: "585257" },
    { id: 34930, cityId: 788, code: "586121" },
    { id: 34931, cityId: 788, code: "586150" },
    { id: 34932, cityId: 788, code: "586164" },
    { id: 34933, cityId: 788, code: "586232" },
    { id: 34934, cityId: 789, code: "581207" },
    { id: 34935, cityId: 789, code: "591124" },
    { id: 34936, cityId: 789, code: "562103" },
    { id: 34937, cityId: 789, code: "585239" },
    { id: 34938, cityId: 790, code: "583101" },
    { id: 34939, cityId: 790, code: "583104" },
    { id: 34940, cityId: 790, code: "583112" },
    { id: 34941, cityId: 790, code: "583114" },
    { id: 34942, cityId: 790, code: "583115" },
    { id: 34943, cityId: 790, code: "583117" },
    { id: 34944, cityId: 790, code: "583120" },
    { id: 34945, cityId: 790, code: "583123" },
    { id: 34946, cityId: 790, code: "583125" },
    { id: 34947, cityId: 790, code: "583128" },
    { id: 34948, cityId: 790, code: "583130" },
    { id: 34949, cityId: 790, code: "583131" },
    { id: 34950, cityId: 790, code: "583133" },
    { id: 34951, cityId: 790, code: "583136" },
    { id: 34952, cityId: 790, code: "583138" },
    { id: 34953, cityId: 790, code: "583141" },
    { id: 34954, cityId: 790, code: "583143" },
    { id: 34955, cityId: 790, code: "583144" },
    { id: 34956, cityId: 790, code: "583146" },
    { id: 34957, cityId: 790, code: "583149" },
    { id: 34958, cityId: 790, code: "583151" },
    { id: 34959, cityId: 790, code: "583202" },
    { id: 34960, cityId: 790, code: "583212" },
    { id: 34961, cityId: 790, code: "583213" },
    { id: 34962, cityId: 790, code: "583215" },
    { id: 34963, cityId: 790, code: "583218" },
    { id: 34964, cityId: 790, code: "583220" },
    { id: 34965, cityId: 790, code: "583221" },
    { id: 34966, cityId: 790, code: "583223" },
    { id: 34967, cityId: 790, code: "583226" },
    { id: 34968, cityId: 790, code: "583228" },
    { id: 34969, cityId: 790, code: "583239" },
    { id: 34970, cityId: 790, code: "583241" },
    { id: 34971, cityId: 790, code: "583242" },
    { id: 34972, cityId: 790, code: "583244" },
    { id: 34973, cityId: 790, code: "583247" },
    { id: 34974, cityId: 790, code: "583250" },
    { id: 34975, cityId: 790, code: "583252" },
    { id: 34976, cityId: 790, code: "583255" },
    { id: 34977, cityId: 790, code: "583258" },
    { id: 34978, cityId: 790, code: "583263" },
    { id: 34979, cityId: 790, code: "583271" },
    { id: 34980, cityId: 790, code: "583273" },
    { id: 34981, cityId: 790, code: "583274" },
    { id: 34982, cityId: 790, code: "583102" },
    { id: 34983, cityId: 790, code: "583103" },
    { id: 34984, cityId: 790, code: "583111" },
    { id: 34985, cityId: 790, code: "583113" },
    { id: 34986, cityId: 790, code: "583116" },
    { id: 34987, cityId: 790, code: "583118" },
    { id: 34988, cityId: 790, code: "583119" },
    { id: 34989, cityId: 790, code: "583121" },
    { id: 34990, cityId: 790, code: "583124" },
    { id: 34991, cityId: 790, code: "583126" },
    { id: 34992, cityId: 790, code: "583127" },
    { id: 34993, cityId: 790, code: "583129" },
    { id: 34994, cityId: 790, code: "583132" },
    { id: 34995, cityId: 790, code: "583134" },
    { id: 34996, cityId: 790, code: "583135" },
    { id: 34997, cityId: 790, code: "583137" },
    { id: 34998, cityId: 790, code: "583139" },
    { id: 34999, cityId: 790, code: "583140" },
    { id: 35000, cityId: 790, code: "583142" },
    { id: 35001, cityId: 790, code: "583145" },
    { id: 35002, cityId: 790, code: "583147" },
    { id: 35003, cityId: 790, code: "583148" },
    { id: 35004, cityId: 790, code: "583150" },
    { id: 35005, cityId: 790, code: "583201" },
    { id: 35006, cityId: 790, code: "583203" },
    { id: 35007, cityId: 790, code: "583211" },
    { id: 35008, cityId: 790, code: "583214" },
    { id: 35009, cityId: 790, code: "583216" },
    { id: 35010, cityId: 790, code: "583217" },
    { id: 35011, cityId: 790, code: "583219" },
    { id: 35012, cityId: 790, code: "583222" },
    { id: 35013, cityId: 790, code: "583224" },
    { id: 35014, cityId: 790, code: "583225" },
    { id: 35015, cityId: 790, code: "583227" },
    { id: 35016, cityId: 790, code: "583237" },
    { id: 35017, cityId: 790, code: "583238" },
    { id: 35018, cityId: 790, code: "583240" },
    { id: 35019, cityId: 790, code: "583243" },
    { id: 35020, cityId: 790, code: "583245" },
    { id: 35021, cityId: 790, code: "583246" },
    { id: 35022, cityId: 790, code: "583251" },
    { id: 35023, cityId: 790, code: "583253" },
    { id: 35024, cityId: 790, code: "583254" },
    { id: 35025, cityId: 790, code: "583262" },
    { id: 35026, cityId: 790, code: "583267" },
    { id: 35027, cityId: 790, code: "583269" },
    { id: 35028, cityId: 790, code: "583272" },
    { id: 35029, cityId: 791, code: "573120" },
    { id: 35030, cityId: 791, code: "573121" },
    { id: 35031, cityId: 791, code: "573145" },
    { id: 35032, cityId: 791, code: "573216" },
    { id: 35033, cityId: 791, code: "573224" },
    { id: 35034, cityId: 791, code: "571469" },
    { id: 35035, cityId: 791, code: "571811" },
    { id: 35036, cityId: 791, code: "573215" },
    { id: 35037, cityId: 792, code: "442902" },
    { id: 35038, cityId: 792, code: "581182" },
    { id: 35039, cityId: 792, code: "582225" },
    { id: 35040, cityId: 792, code: "577243" },
    { id: 35041, cityId: 793, code: "585356" },
    { id: 35042, cityId: 793, code: "585328" },
    { id: 35043, cityId: 793, code: "586134" },
    { id: 35044, cityId: 794, code: "581185" },
    { id: 35045, cityId: 794, code: "581320" },
    { id: 35046, cityId: 795, code: "585226" },
    { id: 35047, cityId: 795, code: "585305" },
    { id: 35048, cityId: 795, code: "585310" },
    { id: 35049, cityId: 795, code: "585326" },
    { id: 35050, cityId: 795, code: "585329" },
    { id: 35051, cityId: 795, code: "585345" },
    { id: 35052, cityId: 795, code: "585347" },
    { id: 35053, cityId: 795, code: "585350" },
    { id: 35054, cityId: 795, code: "585353" },
    { id: 35055, cityId: 795, code: "585358" },
    { id: 35056, cityId: 795, code: "585377" },
    { id: 35057, cityId: 795, code: "585401" },
    { id: 35058, cityId: 795, code: "585403" },
    { id: 35059, cityId: 795, code: "585411" },
    { id: 35060, cityId: 795, code: "585414" },
    { id: 35061, cityId: 795, code: "585416" },
    { id: 35062, cityId: 795, code: "585417" },
    { id: 35063, cityId: 795, code: "585419" },
    { id: 35064, cityId: 795, code: "585422" },
    { id: 35065, cityId: 795, code: "585424" },
    { id: 35066, cityId: 795, code: "585427" },
    { id: 35067, cityId: 795, code: "585429" },
    { id: 35068, cityId: 795, code: "585432" },
    { id: 35069, cityId: 795, code: "585435" },
    { id: 35070, cityId: 795, code: "585437" },
    { id: 35071, cityId: 795, code: "585438" },
    { id: 35072, cityId: 795, code: "585440" },
    { id: 35073, cityId: 795, code: "585443" },
    { id: 35074, cityId: 795, code: "585227" },
    { id: 35075, cityId: 795, code: "585264" },
    { id: 35076, cityId: 795, code: "585282" },
    { id: 35077, cityId: 795, code: "585327" },
    { id: 35078, cityId: 795, code: "585335" },
    { id: 35079, cityId: 795, code: "585336" },
    { id: 35080, cityId: 795, code: "585341" },
    { id: 35081, cityId: 795, code: "585346" },
    { id: 35082, cityId: 795, code: "585351" },
    { id: 35083, cityId: 795, code: "585352" },
    { id: 35084, cityId: 795, code: "585360" },
    { id: 35085, cityId: 795, code: "585373" },
    { id: 35086, cityId: 795, code: "585402" },
    { id: 35087, cityId: 795, code: "585412" },
    { id: 35088, cityId: 795, code: "585413" },
    { id: 35089, cityId: 795, code: "585415" },
    { id: 35090, cityId: 795, code: "585418" },
    { id: 35091, cityId: 795, code: "585421" },
    { id: 35092, cityId: 795, code: "585423" },
    { id: 35093, cityId: 795, code: "585425" },
    { id: 35094, cityId: 795, code: "585426" },
    { id: 35095, cityId: 795, code: "585428" },
    { id: 35096, cityId: 795, code: "585431" },
    { id: 35097, cityId: 795, code: "585433" },
    { id: 35098, cityId: 795, code: "585434" },
    { id: 35099, cityId: 795, code: "585436" },
    { id: 35100, cityId: 795, code: "585439" },
    { id: 35101, cityId: 795, code: "585441" },
    { id: 35102, cityId: 795, code: "585442" },
    { id: 35103, cityId: 796, code: "586103" },
    { id: 35104, cityId: 796, code: "586105" },
    { id: 35105, cityId: 796, code: "586116" },
    { id: 35106, cityId: 796, code: "586118" },
    { id: 35107, cityId: 796, code: "586124" },
    { id: 35108, cityId: 796, code: "586132" },
    { id: 35109, cityId: 796, code: "586137" },
    { id: 35110, cityId: 796, code: "586142" },
    { id: 35111, cityId: 796, code: "586143" },
    { id: 35112, cityId: 796, code: "586148" },
    { id: 35113, cityId: 796, code: "586153" },
    { id: 35114, cityId: 796, code: "586156" },
    { id: 35115, cityId: 796, code: "586161" },
    { id: 35116, cityId: 796, code: "586169" },
    { id: 35117, cityId: 796, code: "586201" },
    { id: 35118, cityId: 796, code: "586203" },
    { id: 35119, cityId: 796, code: "586208" },
    { id: 35120, cityId: 796, code: "586209" },
    { id: 35121, cityId: 796, code: "586214" },
    { id: 35122, cityId: 796, code: "586219" },
    { id: 35123, cityId: 796, code: "586222" },
    { id: 35124, cityId: 796, code: "586224" },
    { id: 35125, cityId: 796, code: "586227" },
    { id: 35126, cityId: 796, code: "586230" },
    { id: 35127, cityId: 796, code: "586232" },
    { id: 35128, cityId: 796, code: "586233" },
    { id: 35129, cityId: 796, code: "586235" },
    { id: 35130, cityId: 796, code: "586241" },
    { id: 35131, cityId: 796, code: "587112" },
    { id: 35132, cityId: 796, code: "587115" },
    { id: 35133, cityId: 796, code: "587117" },
    { id: 35134, cityId: 796, code: "587123" },
    { id: 35135, cityId: 796, code: "587125" },
    { id: 35136, cityId: 796, code: "587128" },
    { id: 35137, cityId: 796, code: "587135" },
    { id: 35138, cityId: 796, code: "587136" },
    { id: 35139, cityId: 796, code: "587138" },
    { id: 35140, cityId: 796, code: "587152" },
    { id: 35141, cityId: 796, code: "587154" },
    { id: 35142, cityId: 796, code: "587207" },
    { id: 35143, cityId: 796, code: "587215" },
    { id: 35144, cityId: 796, code: "587242" },
    { id: 35145, cityId: 796, code: "587302" },
    { id: 35146, cityId: 796, code: "587311" },
    { id: 35147, cityId: 796, code: "587313" },
    { id: 35148, cityId: 796, code: "587316" },
    { id: 35149, cityId: 796, code: "587318" },
    { id: 35150, cityId: 796, code: "587323" },
    { id: 35151, cityId: 796, code: "586101" },
    { id: 35152, cityId: 796, code: "586102" },
    { id: 35153, cityId: 796, code: "586104" },
    { id: 35154, cityId: 796, code: "586106" },
    { id: 35155, cityId: 796, code: "586107" },
    { id: 35156, cityId: 796, code: "586114" },
    { id: 35157, cityId: 796, code: "586115" },
    { id: 35158, cityId: 796, code: "586120" },
    { id: 35159, cityId: 796, code: "586122" },
    { id: 35160, cityId: 796, code: "586125" },
    { id: 35161, cityId: 796, code: "586133" },
    { id: 35162, cityId: 796, code: "586136" },
    { id: 35163, cityId: 796, code: "586138" },
    { id: 35164, cityId: 796, code: "586141" },
    { id: 35165, cityId: 796, code: "586149" },
    { id: 35166, cityId: 796, code: "586151" },
    { id: 35167, cityId: 796, code: "586152" },
    { id: 35168, cityId: 796, code: "586157" },
    { id: 35169, cityId: 796, code: "586162" },
    { id: 35170, cityId: 796, code: "586205" },
    { id: 35171, cityId: 796, code: "586210" },
    { id: 35172, cityId: 796, code: "586213" },
    { id: 35173, cityId: 796, code: "586218" },
    { id: 35174, cityId: 796, code: "586220" },
    { id: 35175, cityId: 796, code: "586221" },
    { id: 35176, cityId: 796, code: "586228" },
    { id: 35177, cityId: 796, code: "586231" },
    { id: 35178, cityId: 796, code: "586234" },
    { id: 35179, cityId: 796, code: "586236" },
    { id: 35180, cityId: 796, code: "586237" },
    { id: 35181, cityId: 796, code: "586239" },
    { id: 35182, cityId: 796, code: "586245" },
    { id: 35183, cityId: 796, code: "586247" },
    { id: 35184, cityId: 796, code: "587111" },
    { id: 35185, cityId: 796, code: "587118" },
    { id: 35186, cityId: 796, code: "587121" },
    { id: 35187, cityId: 796, code: "587126" },
    { id: 35188, cityId: 796, code: "587132" },
    { id: 35189, cityId: 796, code: "587137" },
    { id: 35190, cityId: 796, code: "587148" },
    { id: 35191, cityId: 796, code: "587153" },
    { id: 35192, cityId: 796, code: "587155" },
    { id: 35193, cityId: 796, code: "587201" },
    { id: 35194, cityId: 796, code: "587203" },
    { id: 35195, cityId: 796, code: "587208" },
    { id: 35196, cityId: 796, code: "587209" },
    { id: 35197, cityId: 796, code: "587211" },
    { id: 35198, cityId: 796, code: "587214" },
    { id: 35199, cityId: 796, code: "587301" },
    { id: 35200, cityId: 796, code: "587312" },
    { id: 35201, cityId: 796, code: "587314" },
    { id: 35202, cityId: 796, code: "587322" },
    { id: 35203, cityId: 796, code: "587325" },
    { id: 35204, cityId: 796, code: "587327" },
    { id: 35205, cityId: 796, code: "587328" },
    { id: 35206, cityId: 797, code: "571180" },
    { id: 35207, cityId: 797, code: "581113" },
    { id: 35208, cityId: 797, code: "581322" },
    { id: 35209, cityId: 797, code: "581426" },
    { id: 35210, cityId: 797, code: "587116" },
    { id: 35211, cityId: 797, code: "587127" },
    { id: 35212, cityId: 797, code: "587129" },
    { id: 35213, cityId: 798, code: "560068" },
    { id: 35214, cityId: 799, code: "581106" },
    { id: 35215, cityId: 799, code: "581153" },
    { id: 35216, cityId: 799, code: "581212" },
    { id: 35217, cityId: 799, code: "581136" },
    { id: 35218, cityId: 800, code: "560092" },
    { id: 35219, cityId: 801, code: "571809" },
    { id: 35220, cityId: 801, code: "577522" },
    { id: 35221, cityId: 802, code: "571111" },
    { id: 35222, cityId: 802, code: "571145" },
    { id: 35223, cityId: 802, code: "571146" },
    { id: 35224, cityId: 802, code: "571170" },
    { id: 35225, cityId: 802, code: "571178" },
    { id: 35226, cityId: 802, code: "571165" },
    { id: 35227, cityId: 802, code: "571174" },
    { id: 35228, cityId: 802, code: "571316" },
    { id: 35229, cityId: 802, code: "571327" },
    { id: 35230, cityId: 803, code: "577564" },
    { id: 35231, cityId: 803, code: "584159" },
    { id: 35232, cityId: 803, code: "577544" },
    { id: 35233, cityId: 803, code: "577565" },
    { id: 35234, cityId: 803, code: "577567" },
    { id: 35235, cityId: 803, code: "582127" },
    { id: 35236, cityId: 804, code: "571501" },
    { id: 35237, cityId: 805, code: "571103" },
    { id: 35238, cityId: 805, code: "571119" },
    { id: 35239, cityId: 805, code: "571474" },
    { id: 35240, cityId: 805, code: "572165" },
    { id: 35241, cityId: 805, code: "573124" },
    { id: 35242, cityId: 805, code: "573141" },
    { id: 35243, cityId: 805, code: "573151" },
    { id: 35244, cityId: 805, code: "573159" },
    { id: 35245, cityId: 805, code: "577532" },
    { id: 35246, cityId: 806, code: "562104" },
    { id: 35247, cityId: 806, code: "571132" },
    { id: 35248, cityId: 806, code: "562118" },
    { id: 35249, cityId: 807, code: "577102" },
    { id: 35250, cityId: 807, code: "577113" },
    { id: 35251, cityId: 807, code: "577116" },
    { id: 35252, cityId: 807, code: "577118" },
    { id: 35253, cityId: 807, code: "577119" },
    { id: 35254, cityId: 807, code: "577121" },
    { id: 35255, cityId: 807, code: "577126" },
    { id: 35256, cityId: 807, code: "577127" },
    { id: 35257, cityId: 807, code: "577134" },
    { id: 35258, cityId: 807, code: "577137" },
    { id: 35259, cityId: 807, code: "577140" },
    { id: 35260, cityId: 807, code: "577145" },
    { id: 35261, cityId: 807, code: "577148" },
    { id: 35262, cityId: 807, code: "577150" },
    { id: 35263, cityId: 807, code: "577155" },
    { id: 35264, cityId: 807, code: "577156" },
    { id: 35265, cityId: 807, code: "577161" },
    { id: 35266, cityId: 807, code: "577163" },
    { id: 35267, cityId: 807, code: "577164" },
    { id: 35268, cityId: 807, code: "577169" },
    { id: 35269, cityId: 807, code: "577171" },
    { id: 35270, cityId: 807, code: "577172" },
    { id: 35271, cityId: 807, code: "577174" },
    { id: 35272, cityId: 807, code: "577179" },
    { id: 35273, cityId: 807, code: "577101" },
    { id: 35274, cityId: 807, code: "577112" },
    { id: 35275, cityId: 807, code: "577114" },
    { id: 35276, cityId: 807, code: "577115" },
    { id: 35277, cityId: 807, code: "577117" },
    { id: 35278, cityId: 807, code: "577125" },
    { id: 35279, cityId: 807, code: "577130" },
    { id: 35280, cityId: 807, code: "577133" },
    { id: 35281, cityId: 807, code: "577136" },
    { id: 35282, cityId: 807, code: "577141" },
    { id: 35283, cityId: 807, code: "577149" },
    { id: 35284, cityId: 807, code: "577151" },
    { id: 35285, cityId: 807, code: "577157" },
    { id: 35286, cityId: 807, code: "577162" },
    { id: 35287, cityId: 807, code: "577165" },
    { id: 35288, cityId: 807, code: "577167" },
    { id: 35289, cityId: 807, code: "577173" },
    { id: 35290, cityId: 807, code: "577175" },
    { id: 35291, cityId: 807, code: "577178" },
    { id: 35292, cityId: 807, code: "577180" },
    { id: 35293, cityId: 808, code: "577548" },
    { id: 35294, cityId: 808, code: "577550" },
    { id: 35295, cityId: 808, code: "572141" },
    { id: 35296, cityId: 809, code: "577168" },
    { id: 35297, cityId: 810, code: "572119" },
    { id: 35298, cityId: 810, code: "572228" },
    { id: 35299, cityId: 810, code: "572218" },
    { id: 35300, cityId: 810, code: "572226" },
    { id: 35301, cityId: 811, code: "585223" },
    { id: 35302, cityId: 811, code: "591201" },
    { id: 35303, cityId: 811, code: "586154" },
    { id: 35304, cityId: 812, code: "585307" },
    { id: 35305, cityId: 812, code: "585322" },
    { id: 35306, cityId: 813, code: "563123" },
    { id: 35307, cityId: 813, code: "563125" },
    { id: 35308, cityId: 813, code: "563128" },
    { id: 35309, cityId: 813, code: "583264" },
    { id: 35310, cityId: 813, code: "563143" },
    { id: 35311, cityId: 813, code: "563150" },
    { id: 35312, cityId: 813, code: "563153" },
    { id: 35313, cityId: 813, code: "563159" },
    { id: 35314, cityId: 814, code: "585218" },
    { id: 35315, cityId: 814, code: "561210" },
    { id: 35316, cityId: 814, code: "581228" },
    { id: 35317, cityId: 814, code: "585239" },
    { id: 35318, cityId: 814, code: "585241" },
    { id: 35319, cityId: 814, code: "585255" },
    { id: 35320, cityId: 814, code: "585312" },
    { id: 35321, cityId: 814, code: "585365" },
    { id: 35322, cityId: 815, code: "572160" },
    { id: 35323, cityId: 815, code: "573130" },
    { id: 35324, cityId: 815, code: "577002" },
    { id: 35325, cityId: 815, code: "577004" },
    { id: 35326, cityId: 815, code: "577005" },
    { id: 35327, cityId: 815, code: "577441" },
    { id: 35328, cityId: 815, code: "577502" },
    { id: 35329, cityId: 815, code: "577503" },
    { id: 35330, cityId: 815, code: "577515" },
    { id: 35331, cityId: 815, code: "577518" },
    { id: 35332, cityId: 815, code: "577521" },
    { id: 35333, cityId: 815, code: "577523" },
    { id: 35334, cityId: 815, code: "577524" },
    { id: 35335, cityId: 815, code: "577526" },
    { id: 35336, cityId: 815, code: "577529" },
    { id: 35337, cityId: 815, code: "577532" },
    { id: 35338, cityId: 815, code: "577534" },
    { id: 35339, cityId: 815, code: "577537" },
    { id: 35340, cityId: 815, code: "577540" },
    { id: 35341, cityId: 815, code: "577545" },
    { id: 35342, cityId: 815, code: "577547" },
    { id: 35343, cityId: 815, code: "577555" },
    { id: 35344, cityId: 815, code: "577561" },
    { id: 35345, cityId: 815, code: "577563" },
    { id: 35346, cityId: 815, code: "577566" },
    { id: 35347, cityId: 815, code: "577568" },
    { id: 35348, cityId: 815, code: "577569" },
    { id: 35349, cityId: 815, code: "577571" },
    { id: 35350, cityId: 815, code: "577574" },
    { id: 35351, cityId: 815, code: "577576" },
    { id: 35352, cityId: 815, code: "577579" },
    { id: 35353, cityId: 815, code: "577587" },
    { id: 35354, cityId: 815, code: "577590" },
    { id: 35355, cityId: 815, code: "577592" },
    { id: 35356, cityId: 815, code: "577593" },
    { id: 35357, cityId: 815, code: "577595" },
    { id: 35358, cityId: 815, code: "577601" },
    { id: 35359, cityId: 815, code: "573144" },
    { id: 35360, cityId: 815, code: "577001" },
    { id: 35361, cityId: 815, code: "577003" },
    { id: 35362, cityId: 815, code: "577414" },
    { id: 35363, cityId: 815, code: "577416" },
    { id: 35364, cityId: 815, code: "577437" },
    { id: 35365, cityId: 815, code: "577501" },
    { id: 35366, cityId: 815, code: "577517" },
    { id: 35367, cityId: 815, code: "577519" },
    { id: 35368, cityId: 815, code: "577520" },
    { id: 35369, cityId: 815, code: "577522" },
    { id: 35370, cityId: 815, code: "577527" },
    { id: 35371, cityId: 815, code: "577528" },
    { id: 35372, cityId: 815, code: "577535" },
    { id: 35373, cityId: 815, code: "577536" },
    { id: 35374, cityId: 815, code: "577538" },
    { id: 35375, cityId: 815, code: "577541" },
    { id: 35376, cityId: 815, code: "577543" },
    { id: 35377, cityId: 815, code: "577546" },
    { id: 35378, cityId: 815, code: "577549" },
    { id: 35379, cityId: 815, code: "577552" },
    { id: 35380, cityId: 815, code: "577554" },
    { id: 35381, cityId: 815, code: "577557" },
    { id: 35382, cityId: 815, code: "577560" },
    { id: 35383, cityId: 815, code: "577562" },
    { id: 35384, cityId: 815, code: "577570" },
    { id: 35385, cityId: 815, code: "577580" },
    { id: 35386, cityId: 815, code: "577581" },
    { id: 35387, cityId: 815, code: "577589" },
    { id: 35388, cityId: 815, code: "577596" },
    { id: 35389, cityId: 815, code: "577602" },
    { id: 35390, cityId: 815, code: "582220" },
    { id: 35391, cityId: 816, code: "581325" },
    { id: 35392, cityId: 817, code: "560057" },
    { id: 35393, cityId: 817, code: "560050" },
    { id: 35394, cityId: 818, code: "577514" },
    { id: 35395, cityId: 818, code: "577525" },
    { id: 35396, cityId: 818, code: "571493" },
    { id: 35397, cityId: 818, code: "577001" },
    { id: 35398, cityId: 818, code: "577512" },
    { id: 35399, cityId: 818, code: "577566" },
    { id: 35400, cityId: 819, code: "584153" },
    { id: 35401, cityId: 819, code: "584156" },
    { id: 35402, cityId: 819, code: "587133" },
    { id: 35403, cityId: 819, code: "571472" },
    { id: 35404, cityId: 819, code: "586127" },
    { id: 35405, cityId: 820, code: "571272" },
    { id: 35406, cityId: 821, code: "580110" },
    { id: 35407, cityId: 821, code: "580113" },
    { id: 35408, cityId: 821, code: "580116" },
    { id: 35409, cityId: 821, code: "581170" },
    { id: 35410, cityId: 821, code: "562116" },
    { id: 35411, cityId: 821, code: "571468" },
    { id: 35412, cityId: 821, code: "581105" },
    { id: 35413, cityId: 821, code: "581139" },
    { id: 35414, cityId: 821, code: "585313" },
    { id: 35415, cityId: 822, code: "580005" },
    { id: 35416, cityId: 822, code: "580007" },
    { id: 35417, cityId: 822, code: "580008" },
    { id: 35418, cityId: 822, code: "580010" },
    { id: 35419, cityId: 822, code: "580022" },
    { id: 35420, cityId: 822, code: "580023" },
    { id: 35421, cityId: 822, code: "580024" },
    { id: 35422, cityId: 822, code: "580029" },
    { id: 35423, cityId: 822, code: "580031" },
    { id: 35424, cityId: 822, code: "580032" },
    { id: 35425, cityId: 822, code: "580114" },
    { id: 35426, cityId: 822, code: "580211" },
    { id: 35427, cityId: 822, code: "581102" },
    { id: 35428, cityId: 822, code: "581112" },
    { id: 35429, cityId: 822, code: "581115" },
    { id: 35430, cityId: 822, code: "581120" },
    { id: 35431, cityId: 822, code: "581122" },
    { id: 35432, cityId: 822, code: "581123" },
    { id: 35433, cityId: 822, code: "581131" },
    { id: 35434, cityId: 822, code: "581138" },
    { id: 35435, cityId: 822, code: "581147" },
    { id: 35436, cityId: 822, code: "581152" },
    { id: 35437, cityId: 822, code: "581154" },
    { id: 35438, cityId: 822, code: "581155" },
    { id: 35439, cityId: 822, code: "581157" },
    { id: 35440, cityId: 822, code: "581160" },
    { id: 35441, cityId: 822, code: "581162" },
    { id: 35442, cityId: 822, code: "581167" },
    { id: 35443, cityId: 822, code: "581168" },
    { id: 35444, cityId: 822, code: "581173" },
    { id: 35445, cityId: 822, code: "581175" },
    { id: 35446, cityId: 822, code: "581181" },
    { id: 35447, cityId: 822, code: "581183" },
    { id: 35448, cityId: 822, code: "581191" },
    { id: 35449, cityId: 822, code: "581192" },
    { id: 35450, cityId: 822, code: "581215" },
    { id: 35451, cityId: 822, code: "581218" },
    { id: 35452, cityId: 822, code: "581221" },
    { id: 35453, cityId: 822, code: "581234" },
    { id: 35454, cityId: 822, code: "581236" },
    { id: 35455, cityId: 822, code: "582102" },
    { id: 35456, cityId: 822, code: "582126" },
    { id: 35457, cityId: 822, code: "582132" },
    { id: 35458, cityId: 822, code: "582140" },
    { id: 35459, cityId: 822, code: "582142" },
    { id: 35460, cityId: 822, code: "582208" },
    { id: 35461, cityId: 822, code: "582209" },
    { id: 35462, cityId: 822, code: "582214" },
    { id: 35463, cityId: 822, code: "582216" },
    { id: 35464, cityId: 822, code: "582219" },
    { id: 35465, cityId: 822, code: "582229" },
    { id: 35466, cityId: 822, code: "582230" },
    { id: 35467, cityId: 822, code: "582232" },
    { id: 35468, cityId: 822, code: "582235" },
    { id: 35469, cityId: 822, code: "582238" },
    { id: 35470, cityId: 822, code: "582240" },
    { id: 35471, cityId: 822, code: "582243" },
    { id: 35472, cityId: 822, code: "580001" },
    { id: 35473, cityId: 822, code: "580003" },
    { id: 35474, cityId: 822, code: "580004" },
    { id: 35475, cityId: 822, code: "580006" },
    { id: 35476, cityId: 822, code: "580009" },
    { id: 35477, cityId: 822, code: "580020" },
    { id: 35478, cityId: 822, code: "580022" },
    { id: 35479, cityId: 822, code: "580025" },
    { id: 35480, cityId: 822, code: "580028" },
    { id: 35481, cityId: 822, code: "580030" },
    { id: 35482, cityId: 822, code: "580115" },
    { id: 35483, cityId: 822, code: "580118" },
    { id: 35484, cityId: 822, code: "580213" },
    { id: 35485, cityId: 822, code: "580215" },
    { id: 35486, cityId: 822, code: "581106" },
    { id: 35487, cityId: 822, code: "581108" },
    { id: 35488, cityId: 822, code: "581110" },
    { id: 35489, cityId: 822, code: "581113" },
    { id: 35490, cityId: 822, code: "581119" },
    { id: 35491, cityId: 822, code: "581127" },
    { id: 35492, cityId: 822, code: "581129" },
    { id: 35493, cityId: 822, code: "581134" },
    { id: 35494, cityId: 822, code: "581135" },
    { id: 35495, cityId: 822, code: "581137" },
    { id: 35496, cityId: 822, code: "581142" },
    { id: 35497, cityId: 822, code: "581151" },
    { id: 35498, cityId: 822, code: "581156" },
    { id: 35499, cityId: 822, code: "581158" },
    { id: 35500, cityId: 822, code: "581163" },
    { id: 35501, cityId: 822, code: "581164" },
    { id: 35502, cityId: 822, code: "581169" },
    { id: 35503, cityId: 822, code: "581171" },
    { id: 35504, cityId: 822, code: "581177" },
    { id: 35505, cityId: 822, code: "581180" },
    { id: 35506, cityId: 822, code: "581187" },
    { id: 35507, cityId: 822, code: "581193" },
    { id: 35508, cityId: 822, code: "581201" },
    { id: 35509, cityId: 822, code: "581204" },
    { id: 35510, cityId: 822, code: "581206" },
    { id: 35511, cityId: 822, code: "581208" },
    { id: 35512, cityId: 822, code: "581214" },
    { id: 35513, cityId: 822, code: "581219" },
    { id: 35514, cityId: 822, code: "581222" },
    { id: 35515, cityId: 822, code: "581227" },
    { id: 35516, cityId: 822, code: "581232" },
    { id: 35517, cityId: 822, code: "581233" },
    { id: 35518, cityId: 822, code: "581405" },
    { id: 35519, cityId: 822, code: "582101" },
    { id: 35520, cityId: 822, code: "582114" },
    { id: 35521, cityId: 822, code: "582122" },
    { id: 35522, cityId: 822, code: "582125" },
    { id: 35523, cityId: 822, code: "582128" },
    { id: 35524, cityId: 822, code: "582131" },
    { id: 35525, cityId: 822, code: "582135" },
    { id: 35526, cityId: 822, code: "582141" },
    { id: 35527, cityId: 822, code: "582146" },
    { id: 35528, cityId: 822, code: "582207" },
    { id: 35529, cityId: 822, code: "582212" },
    { id: 35530, cityId: 822, code: "582213" },
    { id: 35531, cityId: 822, code: "582215" },
    { id: 35532, cityId: 822, code: "582223" },
    { id: 35533, cityId: 822, code: "582231" },
    { id: 35534, cityId: 822, code: "582234" },
    { id: 35535, cityId: 822, code: "582241" },
    { id: 35536, cityId: 823, code: "563148" },
    { id: 35537, cityId: 823, code: "572150" },
    { id: 35538, cityId: 824, code: "582204" },
    { id: 35539, cityId: 824, code: "582115" },
    { id: 35540, cityId: 824, code: "582123" },
    { id: 35541, cityId: 824, code: "582205" },
    { id: 35542, cityId: 825, code: "583229" },
    { id: 35543, cityId: 825, code: "584129" },
    { id: 35544, cityId: 825, code: "581202" },
    { id: 35545, cityId: 825, code: "583270" },
    { id: 35546, cityId: 826, code: "561208" },
    { id: 35547, cityId: 826, code: "561213" },
    { id: 35548, cityId: 826, code: "561219" },
    { id: 35549, cityId: 826, code: "572105" },
    { id: 35550, cityId: 827, code: "591307" },
    { id: 35551, cityId: 828, code: "571213" },
    { id: 35552, cityId: 829, code: "571452" },
    { id: 35553, cityId: 829, code: "572114" },
    { id: 35554, cityId: 829, code: "572216" },
    { id: 35555, cityId: 829, code: "572222" },
    { id: 35556, cityId: 830, code: "577423" },
    { id: 35557, cityId: 830, code: "585102" },
    { id: 35558, cityId: 830, code: "585104" },
    { id: 35559, cityId: 830, code: "585105" },
    { id: 35560, cityId: 830, code: "585152" },
    { id: 35561, cityId: 830, code: "585202" },
    { id: 35562, cityId: 830, code: "585210" },
    { id: 35563, cityId: 830, code: "585213" },
    { id: 35564, cityId: 830, code: "585219" },
    { id: 35565, cityId: 830, code: "585224" },
    { id: 35566, cityId: 830, code: "585229" },
    { id: 35567, cityId: 830, code: "585245" },
    { id: 35568, cityId: 830, code: "585247" },
    { id: 35569, cityId: 830, code: "585248" },
    { id: 35570, cityId: 830, code: "585250" },
    { id: 35571, cityId: 830, code: "585253" },
    { id: 35572, cityId: 830, code: "585264" },
    { id: 35573, cityId: 830, code: "585266" },
    { id: 35574, cityId: 830, code: "585269" },
    { id: 35575, cityId: 830, code: "585271" },
    { id: 35576, cityId: 830, code: "585272" },
    { id: 35577, cityId: 830, code: "585282" },
    { id: 35578, cityId: 830, code: "585285" },
    { id: 35579, cityId: 830, code: "585287" },
    { id: 35580, cityId: 830, code: "585290" },
    { id: 35581, cityId: 830, code: "585292" },
    { id: 35582, cityId: 830, code: "585306" },
    { id: 35583, cityId: 830, code: "585308" },
    { id: 35584, cityId: 830, code: "585309" },
    { id: 35585, cityId: 830, code: "585311" },
    { id: 35586, cityId: 830, code: "585316" },
    { id: 35587, cityId: 830, code: "585317" },
    { id: 35588, cityId: 830, code: "585324" },
    { id: 35589, cityId: 830, code: "585330" },
    { id: 35590, cityId: 830, code: "585333" },
    { id: 35591, cityId: 830, code: "585338" },
    { id: 35592, cityId: 830, code: "585340" },
    { id: 35593, cityId: 830, code: "585343" },
    { id: 35594, cityId: 830, code: "585359" },
    { id: 35595, cityId: 830, code: "585361" },
    { id: 35596, cityId: 830, code: "585370" },
    { id: 35597, cityId: 830, code: "585372" },
    { id: 35598, cityId: 830, code: "585375" },
    { id: 35599, cityId: 830, code: "585378" },
    { id: 35600, cityId: 830, code: "585101" },
    { id: 35601, cityId: 830, code: "585103" },
    { id: 35602, cityId: 830, code: "585106" },
    { id: 35603, cityId: 830, code: "585109" },
    { id: 35604, cityId: 830, code: "585154" },
    { id: 35605, cityId: 830, code: "585201" },
    { id: 35606, cityId: 830, code: "585212" },
    { id: 35607, cityId: 830, code: "585214" },
    { id: 35608, cityId: 830, code: "585220" },
    { id: 35609, cityId: 830, code: "585222" },
    { id: 35610, cityId: 830, code: "585223" },
    { id: 35611, cityId: 830, code: "585236" },
    { id: 35612, cityId: 830, code: "585238" },
    { id: 35613, cityId: 830, code: "585243" },
    { id: 35614, cityId: 830, code: "585244" },
    { id: 35615, cityId: 830, code: "585249" },
    { id: 35616, cityId: 830, code: "585254" },
    { id: 35617, cityId: 830, code: "585260" },
    { id: 35618, cityId: 830, code: "585262" },
    { id: 35619, cityId: 830, code: "585265" },
    { id: 35620, cityId: 830, code: "585268" },
    { id: 35621, cityId: 830, code: "585275" },
    { id: 35622, cityId: 830, code: "585276" },
    { id: 35623, cityId: 830, code: "585278" },
    { id: 35624, cityId: 830, code: "585286" },
    { id: 35625, cityId: 830, code: "585289" },
    { id: 35626, cityId: 830, code: "585302" },
    { id: 35627, cityId: 830, code: "585304" },
    { id: 35628, cityId: 830, code: "585315" },
    { id: 35629, cityId: 830, code: "585320" },
    { id: 35630, cityId: 830, code: "585334" },
    { id: 35631, cityId: 830, code: "585337" },
    { id: 35632, cityId: 830, code: "585339" },
    { id: 35633, cityId: 830, code: "585342" },
    { id: 35634, cityId: 830, code: "585344" },
    { id: 35635, cityId: 830, code: "585363" },
    { id: 35636, cityId: 830, code: "585366" },
    { id: 35637, cityId: 830, code: "585371" },
    { id: 35638, cityId: 830, code: "585374" },
    { id: 35639, cityId: 830, code: "586126" },
    { id: 35640, cityId: 830, code: "586165" },
    { id: 35641, cityId: 831, code: "571111" },
    { id: 35642, cityId: 831, code: "571141" },
    { id: 35643, cityId: 831, code: "571318" },
    { id: 35644, cityId: 831, code: "571336" },
    { id: 35645, cityId: 831, code: "571496" },
    { id: 35646, cityId: 831, code: "571142" },
    { id: 35647, cityId: 832, code: "583266" },
    { id: 35648, cityId: 833, code: "573222" },
    { id: 35649, cityId: 834, code: "581329" },
    { id: 35650, cityId: 835, code: "581150" },
    { id: 35651, cityId: 835, code: "581166" },
    { id: 35652, cityId: 835, code: "581102" },
    { id: 35653, cityId: 835, code: "581104" },
    { id: 35654, cityId: 835, code: "581149" },
    { id: 35655, cityId: 835, code: "581176" },
    { id: 35656, cityId: 835, code: "581189" },
    { id: 35657, cityId: 836, code: "582227" },
    { id: 35658, cityId: 837, code: "577516" },
    { id: 35659, cityId: 837, code: "577530" },
    { id: 35660, cityId: 837, code: "577575" },
    { id: 35661, cityId: 837, code: "577577" },
    { id: 35662, cityId: 837, code: "577588" },
    { id: 35663, cityId: 837, code: "577601" },
    { id: 35664, cityId: 837, code: "577591" },
    { id: 35665, cityId: 838, code: "573115" },
    { id: 35666, cityId: 838, code: "573122" },
    { id: 35667, cityId: 838, code: "573128" },
    { id: 35668, cityId: 838, code: "573131" },
    { id: 35669, cityId: 838, code: "573133" },
    { id: 35670, cityId: 838, code: "573139" },
    { id: 35671, cityId: 838, code: "573149" },
    { id: 35672, cityId: 838, code: "573152" },
    { id: 35673, cityId: 838, code: "573157" },
    { id: 35674, cityId: 838, code: "573162" },
    { id: 35675, cityId: 838, code: "573212" },
    { id: 35676, cityId: 838, code: "573220" },
    { id: 35677, cityId: 838, code: "573223" },
    { id: 35678, cityId: 838, code: "585252" },
    { id: 35679, cityId: 838, code: "585288" },
    { id: 35680, cityId: 838, code: "573103" },
    { id: 35681, cityId: 838, code: "573111" },
    { id: 35682, cityId: 838, code: "573113" },
    { id: 35683, cityId: 838, code: "573116" },
    { id: 35684, cityId: 838, code: "573118" },
    { id: 35685, cityId: 838, code: "573126" },
    { id: 35686, cityId: 838, code: "573129" },
    { id: 35687, cityId: 838, code: "573134" },
    { id: 35688, cityId: 838, code: "573135" },
    { id: 35689, cityId: 838, code: "573137" },
    { id: 35690, cityId: 838, code: "573140" },
    { id: 35691, cityId: 838, code: "573142" },
    { id: 35692, cityId: 838, code: "573143" },
    { id: 35693, cityId: 838, code: "573148" },
    { id: 35694, cityId: 838, code: "573150" },
    { id: 35695, cityId: 838, code: "573153" },
    { id: 35696, cityId: 838, code: "573155" },
    { id: 35697, cityId: 838, code: "573156" },
    { id: 35698, cityId: 838, code: "573158" },
    { id: 35699, cityId: 838, code: "573163" },
    { id: 35700, cityId: 838, code: "573201" },
    { id: 35701, cityId: 838, code: "573211" },
    { id: 35702, cityId: 838, code: "573214" },
    { id: 35703, cityId: 838, code: "573217" },
    { id: 35704, cityId: 838, code: "573219" },
    { id: 35705, cityId: 839, code: "581110" },
    { id: 35706, cityId: 839, code: "581128" },
    { id: 35707, cityId: 839, code: "581133" },
    { id: 35708, cityId: 839, code: "581213" },
    { id: 35709, cityId: 839, code: "581108" },
    { id: 35710, cityId: 839, code: "581132" },
    { id: 35711, cityId: 839, code: "581148" },
    { id: 35712, cityId: 839, code: "581172" },
    { id: 35713, cityId: 840, code: "571616" },
    { id: 35714, cityId: 841, code: "571266" },
    { id: 35715, cityId: 841, code: "571332" },
    { id: 35716, cityId: 841, code: "571334" },
    { id: 35717, cityId: 841, code: "571337" },
    { id: 35718, cityId: 841, code: "571483" },
    { id: 35719, cityId: 841, code: "571118" },
    { id: 35720, cityId: 841, code: "571121" },
    { id: 35721, cityId: 841, code: "571148" },
    { id: 35722, cityId: 841, code: "571150" },
    { id: 35723, cityId: 841, code: "571158" },
    { id: 35724, cityId: 841, code: "571315" },
    { id: 35725, cityId: 841, code: "571331" },
    { id: 35726, cityId: 841, code: "571466" },
    { id: 35727, cityId: 841, code: "572157" },
    { id: 35728, cityId: 841, code: "585281" },
    { id: 35729, cityId: 842, code: "581125" },
    { id: 35730, cityId: 842, code: "581130" },
    { id: 35731, cityId: 842, code: "581210" },
    { id: 35732, cityId: 842, code: "585212" },
    { id: 35733, cityId: 842, code: "581111" },
    { id: 35734, cityId: 842, code: "581116" },
    { id: 35735, cityId: 842, code: "581190" },
    { id: 35736, cityId: 842, code: "581217" },
    { id: 35737, cityId: 843, code: "572143" },
    { id: 35738, cityId: 843, code: "572161" },
    { id: 35739, cityId: 843, code: "577511" },
    { id: 35740, cityId: 843, code: "577585" },
    { id: 35741, cityId: 843, code: "577586" },
    { id: 35742, cityId: 843, code: "572160" },
    { id: 35743, cityId: 843, code: "577242" },
    { id: 35744, cityId: 843, code: "577558" },
    { id: 35745, cityId: 844, code: "577531" },
    { id: 35746, cityId: 844, code: "577526" },
    { id: 35747, cityId: 844, code: "577539" },
    { id: 35748, cityId: 844, code: "577582" },
    { id: 35749, cityId: 845, code: "573210" },
    { id: 35750, cityId: 846, code: "585261" },
    { id: 35751, cityId: 846, code: "585263" },
    { id: 35752, cityId: 846, code: "585270" },
    { id: 35753, cityId: 847, code: "581334" },
    { id: 35754, cityId: 848, code: "577153" },
    { id: 35755, cityId: 848, code: "577217" },
    { id: 35756, cityId: 848, code: "577230" },
    { id: 35757, cityId: 848, code: "577238" },
    { id: 35758, cityId: 848, code: "577223" },
    { id: 35759, cityId: 848, code: "582233" },
    { id: 35760, cityId: 849, code: "573114" },
    { id: 35761, cityId: 849, code: "577235" },
    { id: 35762, cityId: 849, code: "577533" },
    { id: 35763, cityId: 850, code: "577445" },
    { id: 35764, cityId: 850, code: "577436" },
    { id: 35765, cityId: 850, code: "577438" },
    { id: 35766, cityId: 851, code: "571611" },
    { id: 35767, cityId: 851, code: "562114" },
    { id: 35768, cityId: 852, code: "583273" },
    { id: 35769, cityId: 853, code: "580214" },
    { id: 35770, cityId: 853, code: "581140" },
    { id: 35771, cityId: 853, code: "581209" },
    { id: 35772, cityId: 853, code: "581231" },
    { id: 35773, cityId: 853, code: "582226" },
    { id: 35774, cityId: 853, code: "580212" },
    { id: 35775, cityId: 853, code: "581124" },
    { id: 35776, cityId: 854, code: "591309" },
    { id: 35777, cityId: 855, code: "587118" },
    { id: 35778, cityId: 855, code: "587120" },
    { id: 35779, cityId: 855, code: "587139" },
    { id: 35780, cityId: 855, code: "587147" },
    { id: 35781, cityId: 855, code: "587130" },
    { id: 35782, cityId: 855, code: "587145" },
    { id: 35783, cityId: 855, code: "587146" },
    { id: 35784, cityId: 856, code: "571610" },
    { id: 35785, cityId: 856, code: "571105" },
    { id: 35786, cityId: 856, code: "571187" },
    { id: 35787, cityId: 857, code: "581143" },
    { id: 35788, cityId: 857, code: "581188" },
    { id: 35789, cityId: 857, code: "586112" },
    { id: 35790, cityId: 857, code: "586117" },
    { id: 35791, cityId: 857, code: "586204" },
    { id: 35792, cityId: 857, code: "586207" },
    { id: 35793, cityId: 857, code: "586215" },
    { id: 35794, cityId: 857, code: "586223" },
    { id: 35795, cityId: 857, code: "586226" },
    { id: 35796, cityId: 857, code: "586242" },
    { id: 35797, cityId: 857, code: "586111" },
    { id: 35798, cityId: 857, code: "586147" },
    { id: 35799, cityId: 857, code: "586209" },
    { id: 35800, cityId: 857, code: "586211" },
    { id: 35801, cityId: 857, code: "586217" },
    { id: 35802, cityId: 857, code: "586225" },
    { id: 35803, cityId: 857, code: "586238" },
    { id: 35804, cityId: 857, code: "586243" },
    { id: 35805, cityId: 858, code: "577553" },
    { id: 35806, cityId: 858, code: "577513" },
    { id: 35807, cityId: 858, code: "577528" },
    { id: 35808, cityId: 859, code: "587119" },
    { id: 35809, cityId: 859, code: "587320" },
    { id: 35810, cityId: 859, code: "587326" },
    { id: 35811, cityId: 859, code: "586140" },
    { id: 35812, cityId: 859, code: "586145" },
    { id: 35813, cityId: 859, code: "586146" },
    { id: 35814, cityId: 859, code: "586159" },
    { id: 35815, cityId: 859, code: "587301" },
    { id: 35816, cityId: 859, code: "587319" },
    { id: 35817, cityId: 859, code: "587322" },
    { id: 35818, cityId: 859, code: "587324" },
    { id: 35819, cityId: 860, code: "572220" },
    { id: 35820, cityId: 860, code: "584118" },
    { id: 35821, cityId: 860, code: "585303" },
    { id: 35822, cityId: 860, code: "585369" },
    { id: 35823, cityId: 860, code: "581174" },
    { id: 35824, cityId: 860, code: "583232" },
    { id: 35825, cityId: 860, code: "585325" },
    { id: 35826, cityId: 860, code: "585362" },
    { id: 35827, cityId: 861, code: "577435" },
    { id: 35828, cityId: 862, code: "577135" },
    { id: 35829, cityId: 862, code: "577548" },
    { id: 35830, cityId: 862, code: "581146" },
    { id: 35831, cityId: 862, code: "573132" },
    { id: 35832, cityId: 863, code: "581223" },
    { id: 35833, cityId: 863, code: "581226" },
    { id: 35834, cityId: 863, code: "581224" },
    { id: 35835, cityId: 863, code: "581225" },
    { id: 35836, cityId: 863, code: "581230" },
    { id: 35837, cityId: 864, code: "583132" },
    { id: 35838, cityId: 865, code: "562117" },
    { id: 35839, cityId: 866, code: "586119" },
    { id: 35840, cityId: 866, code: "670001" },
    { id: 35841, cityId: 866, code: "670306" },
    { id: 35842, cityId: 866, code: "671321" },
    { id: 35843, cityId: 866, code: "571804" },
    { id: 35844, cityId: 866, code: "574193" },
    { id: 35845, cityId: 867, code: "581301" },
    { id: 35846, cityId: 867, code: "581302" },
    { id: 35847, cityId: 867, code: "581304" },
    { id: 35848, cityId: 867, code: "581314" },
    { id: 35849, cityId: 867, code: "581315" },
    { id: 35850, cityId: 867, code: "581317" },
    { id: 35851, cityId: 867, code: "581320" },
    { id: 35852, cityId: 867, code: "581323" },
    { id: 35853, cityId: 867, code: "581325" },
    { id: 35854, cityId: 867, code: "581328" },
    { id: 35855, cityId: 867, code: "581330" },
    { id: 35856, cityId: 867, code: "581331" },
    { id: 35857, cityId: 867, code: "581333" },
    { id: 35858, cityId: 867, code: "581336" },
    { id: 35859, cityId: 867, code: "581338" },
    { id: 35860, cityId: 867, code: "581341" },
    { id: 35861, cityId: 867, code: "581344" },
    { id: 35862, cityId: 867, code: "581346" },
    { id: 35863, cityId: 867, code: "581347" },
    { id: 35864, cityId: 867, code: "581352" },
    { id: 35865, cityId: 867, code: "581354" },
    { id: 35866, cityId: 867, code: "581355" },
    { id: 35867, cityId: 867, code: "581357" },
    { id: 35868, cityId: 867, code: "581359" },
    { id: 35869, cityId: 867, code: "581360" },
    { id: 35870, cityId: 867, code: "581362" },
    { id: 35871, cityId: 867, code: "581365" },
    { id: 35872, cityId: 867, code: "581367" },
    { id: 35873, cityId: 867, code: "581368" },
    { id: 35874, cityId: 867, code: "581370" },
    { id: 35875, cityId: 867, code: "581373" },
    { id: 35876, cityId: 867, code: "581375" },
    { id: 35877, cityId: 867, code: "581376" },
    { id: 35878, cityId: 867, code: "581378" },
    { id: 35879, cityId: 867, code: "581381" },
    { id: 35880, cityId: 867, code: "581383" },
    { id: 35881, cityId: 867, code: "581384" },
    { id: 35882, cityId: 867, code: "581389" },
    { id: 35883, cityId: 867, code: "581394" },
    { id: 35884, cityId: 867, code: "581402" },
    { id: 35885, cityId: 867, code: "581412" },
    { id: 35886, cityId: 867, code: "581413" },
    { id: 35887, cityId: 867, code: "581418" },
    { id: 35888, cityId: 867, code: "581420" },
    { id: 35889, cityId: 867, code: "581421" },
    { id: 35890, cityId: 867, code: "581423" },
    { id: 35891, cityId: 867, code: "581428" },
    { id: 35892, cityId: 867, code: "581429" },
    { id: 35893, cityId: 867, code: "581431" },
    { id: 35894, cityId: 867, code: "581434" },
    { id: 35895, cityId: 867, code: "581436" },
    { id: 35896, cityId: 867, code: "581437" },
    { id: 35897, cityId: 867, code: "581439" },
    { id: 35898, cityId: 867, code: "581444" },
    { id: 35899, cityId: 867, code: "581445" },
    { id: 35900, cityId: 867, code: "581447" },
    { id: 35901, cityId: 867, code: "581450" },
    { id: 35902, cityId: 867, code: "591319" },
    { id: 35903, cityId: 867, code: "581186" },
    { id: 35904, cityId: 867, code: "581303" },
    { id: 35905, cityId: 867, code: "581305" },
    { id: 35906, cityId: 867, code: "581306" },
    { id: 35907, cityId: 867, code: "581316" },
    { id: 35908, cityId: 867, code: "581318" },
    { id: 35909, cityId: 867, code: "581319" },
    { id: 35910, cityId: 867, code: "581321" },
    { id: 35911, cityId: 867, code: "581326" },
    { id: 35912, cityId: 867, code: "581327" },
    { id: 35913, cityId: 867, code: "581329" },
    { id: 35914, cityId: 867, code: "581332" },
    { id: 35915, cityId: 867, code: "581334" },
    { id: 35916, cityId: 867, code: "581335" },
    { id: 35917, cityId: 867, code: "581337" },
    { id: 35918, cityId: 867, code: "581340" },
    { id: 35919, cityId: 867, code: "581342" },
    { id: 35920, cityId: 867, code: "581343" },
    { id: 35921, cityId: 867, code: "581345" },
    { id: 35922, cityId: 867, code: "581348" },
    { id: 35923, cityId: 867, code: "581350" },
    { id: 35924, cityId: 867, code: "581351" },
    { id: 35925, cityId: 867, code: "581353" },
    { id: 35926, cityId: 867, code: "581358" },
    { id: 35927, cityId: 867, code: "581361" },
    { id: 35928, cityId: 867, code: "581363" },
    { id: 35929, cityId: 867, code: "581364" },
    { id: 35930, cityId: 867, code: "581369" },
    { id: 35931, cityId: 867, code: "581371" },
    { id: 35932, cityId: 867, code: "581372" },
    { id: 35933, cityId: 867, code: "581374" },
    { id: 35934, cityId: 867, code: "581377" },
    { id: 35935, cityId: 867, code: "581379" },
    { id: 35936, cityId: 867, code: "581380" },
    { id: 35937, cityId: 867, code: "581382" },
    { id: 35938, cityId: 867, code: "581388" },
    { id: 35939, cityId: 867, code: "581390" },
    { id: 35940, cityId: 867, code: "581393" },
    { id: 35941, cityId: 867, code: "581395" },
    { id: 35942, cityId: 867, code: "581401" },
    { id: 35943, cityId: 867, code: "581403" },
    { id: 35944, cityId: 867, code: "581411" },
    { id: 35945, cityId: 867, code: "581414" },
    { id: 35946, cityId: 867, code: "581416" },
    { id: 35947, cityId: 867, code: "581417" },
    { id: 35948, cityId: 867, code: "581419" },
    { id: 35949, cityId: 867, code: "581422" },
    { id: 35950, cityId: 867, code: "581424" },
    { id: 35951, cityId: 867, code: "581425" },
    { id: 35952, cityId: 867, code: "581430" },
    { id: 35953, cityId: 867, code: "581432" },
    { id: 35954, cityId: 867, code: "581433" },
    { id: 35955, cityId: 867, code: "581435" },
    { id: 35956, cityId: 867, code: "581440" },
    { id: 35957, cityId: 867, code: "581441" },
    { id: 35958, cityId: 867, code: "581443" },
    { id: 35959, cityId: 867, code: "581446" },
    { id: 35960, cityId: 867, code: "581448" },
    { id: 35961, cityId: 867, code: "581449" },
    { id: 35962, cityId: 868, code: "560060" },
    { id: 35963, cityId: 869, code: "587206" },
    { id: 35964, cityId: 869, code: "591283" },
    { id: 35965, cityId: 870, code: "580112" },
    { id: 35966, cityId: 870, code: "591302" },
    { id: 35967, cityId: 871, code: "572127" },
    { id: 35968, cityId: 872, code: "571201" },
    { id: 35969, cityId: 872, code: "571212" },
    { id: 35970, cityId: 872, code: "571215" },
    { id: 35971, cityId: 872, code: "571217" },
    { id: 35972, cityId: 872, code: "571223" },
    { id: 35973, cityId: 872, code: "571231" },
    { id: 35974, cityId: 872, code: "571236" },
    { id: 35975, cityId: 872, code: "571239" },
    { id: 35976, cityId: 872, code: "571247" },
    { id: 35977, cityId: 872, code: "571249" },
    { id: 35978, cityId: 872, code: "571252" },
    { id: 35979, cityId: 872, code: "571254" },
    { id: 35980, cityId: 872, code: "571257" },
    { id: 35981, cityId: 872, code: "571262" },
    { id: 35982, cityId: 872, code: "571263" },
    { id: 35983, cityId: 872, code: "571265" },
    { id: 35984, cityId: 872, code: "573161" },
    { id: 35985, cityId: 872, code: "571216" },
    { id: 35986, cityId: 872, code: "571221" },
    { id: 35987, cityId: 872, code: "571235" },
    { id: 35988, cityId: 872, code: "571237" },
    { id: 35989, cityId: 872, code: "571242" },
    { id: 35990, cityId: 872, code: "571243" },
    { id: 35991, cityId: 872, code: "571245" },
    { id: 35992, cityId: 872, code: "571248" },
    { id: 35993, cityId: 872, code: "571253" },
    { id: 35994, cityId: 872, code: "571256" },
    { id: 35995, cityId: 872, code: "571258" },
    { id: 35996, cityId: 872, code: "571269" },
    { id: 35997, cityId: 872, code: "571271" },
    { id: 35998, cityId: 872, code: "571272" },
    { id: 35999, cityId: 873, code: "561206" },
    { id: 36000, cityId: 873, code: "561211" },
    { id: 36001, cityId: 873, code: "561217" },
    { id: 36002, cityId: 873, code: "561225" },
    { id: 36003, cityId: 873, code: "562102" },
    { id: 36004, cityId: 873, code: "562141" },
    { id: 36005, cityId: 873, code: "563113" },
    { id: 36006, cityId: 873, code: "563118" },
    { id: 36007, cityId: 873, code: "563119" },
    { id: 36008, cityId: 873, code: "563121" },
    { id: 36009, cityId: 873, code: "563124" },
    { id: 36010, cityId: 873, code: "563126" },
    { id: 36011, cityId: 873, code: "563127" },
    { id: 36012, cityId: 873, code: "563129" },
    { id: 36013, cityId: 873, code: "563132" },
    { id: 36014, cityId: 873, code: "563134" },
    { id: 36015, cityId: 873, code: "563145" },
    { id: 36016, cityId: 873, code: "563156" },
    { id: 36017, cityId: 873, code: "563158" },
    { id: 36018, cityId: 873, code: "565277" },
    { id: 36019, cityId: 873, code: "561208" },
    { id: 36020, cityId: 873, code: "561218" },
    { id: 36021, cityId: 873, code: "561221" },
    { id: 36022, cityId: 873, code: "561223" },
    { id: 36023, cityId: 873, code: "561224" },
    { id: 36024, cityId: 873, code: "562105" },
    { id: 36025, cityId: 873, code: "563101" },
    { id: 36026, cityId: 873, code: "563114" },
    { id: 36027, cityId: 873, code: "563115" },
    { id: 36028, cityId: 873, code: "563117" },
    { id: 36029, cityId: 873, code: "563120" },
    { id: 36030, cityId: 873, code: "563122" },
    { id: 36031, cityId: 873, code: "563125" },
    { id: 36032, cityId: 873, code: "563130" },
    { id: 36033, cityId: 873, code: "563131" },
    { id: 36034, cityId: 873, code: "563133" },
    { id: 36035, cityId: 873, code: "563135" },
    { id: 36036, cityId: 873, code: "563144" },
    { id: 36037, cityId: 873, code: "563146" },
    { id: 36038, cityId: 873, code: "563151" },
    { id: 36039, cityId: 873, code: "563157" },
    { id: 36040, cityId: 874, code: "571440" },
    { id: 36041, cityId: 874, code: "571488" },
    { id: 36042, cityId: 874, code: "571801" },
    { id: 36043, cityId: 874, code: "571320" },
    { id: 36044, cityId: 874, code: "571439" },
    { id: 36045, cityId: 874, code: "571476" },
    { id: 36046, cityId: 874, code: "571479" },
    { id: 36047, cityId: 874, code: "571498" },
    { id: 36048, cityId: 875, code: "582206" },
    { id: 36049, cityId: 875, code: "591231" },
    { id: 36050, cityId: 876, code: "571425" },
    { id: 36051, cityId: 876, code: "577152" },
    { id: 36052, cityId: 876, code: "577159" },
    { id: 36053, cityId: 876, code: "577123" },
    { id: 36054, cityId: 876, code: "577126" },
    { id: 36055, cityId: 876, code: "577442" },
    { id: 36056, cityId: 877, code: "583231" },
    { id: 36057, cityId: 877, code: "583260" },
    { id: 36058, cityId: 877, code: "583230" },
    { id: 36059, cityId: 877, code: "584146" },
    { id: 36060, cityId: 878, code: "572115" },
    { id: 36061, cityId: 878, code: "572121" },
    { id: 36062, cityId: 878, code: "572129" },
    { id: 36063, cityId: 879, code: "583134" },
    { id: 36064, cityId: 880, code: "571603" },
    { id: 36065, cityId: 881, code: "571607" },
    { id: 36066, cityId: 882, code: "571241" },
    { id: 36067, cityId: 882, code: "571267" },
    { id: 36068, cityId: 882, code: "571423" },
    { id: 36069, cityId: 882, code: "571467" },
    { id: 36070, cityId: 882, code: "571602" },
    { id: 36071, cityId: 882, code: "571605" },
    { id: 36072, cityId: 882, code: "587142" },
    { id: 36073, cityId: 883, code: "591311" },
    { id: 36074, cityId: 884, code: "583135" },
    { id: 36075, cityId: 885, code: "577127" },
    { id: 36076, cityId: 886, code: "581343" },
    { id: 36077, cityId: 887, code: "581107" },
    { id: 36078, cityId: 887, code: "581117" },
    { id: 36079, cityId: 887, code: "582236" },
    { id: 36080, cityId: 888, code: "572111" },
    { id: 36081, cityId: 888, code: "572130" },
    { id: 36082, cityId: 888, code: "572167" },
    { id: 36083, cityId: 888, code: "571450" },
    { id: 36084, cityId: 888, code: "572142" },
    { id: 36085, cityId: 888, code: "572155" },
    { id: 36086, cityId: 889, code: "571234" },
    { id: 36087, cityId: 890, code: "584114" },
    { id: 36088, cityId: 890, code: "574121" },
    { id: 36089, cityId: 890, code: "584112" },
    { id: 36090, cityId: 891, code: "582116" },
    { id: 36091, cityId: 892, code: "584141" },
    { id: 36092, cityId: 892, code: "585211" },
    { id: 36093, cityId: 892, code: "584124" },
    { id: 36094, cityId: 892, code: "584139" },
    { id: 36095, cityId: 893, code: "591301" },
    { id: 36096, cityId: 894, code: "571428" },
    { id: 36097, cityId: 894, code: "571460" },
    { id: 36098, cityId: 894, code: "571406" },
    { id: 36099, cityId: 894, code: "571456" },
    { id: 36100, cityId: 895, code: "572112" },
    { id: 36101, cityId: 895, code: "572149" },
    { id: 36102, cityId: 895, code: "572163" },
    { id: 36103, cityId: 895, code: "572124" },
    { id: 36104, cityId: 895, code: "572132" },
    { id: 36105, cityId: 895, code: "585315" },
    { id: 36106, cityId: 896, code: "571201" },
    { id: 36107, cityId: 896, code: "571214" },
    { id: 36108, cityId: 896, code: "571255" },
    { id: 36109, cityId: 896, code: "571261" },
    { id: 36110, cityId: 897, code: "562120" },
    { id: 36111, cityId: 897, code: "582143" },
    { id: 36112, cityId: 898, code: "560048" },
    { id: 36113, cityId: 899, code: "563154" },
    { id: 36114, cityId: 899, code: "571417" },
    { id: 36115, cityId: 899, code: "571430" },
    { id: 36116, cityId: 899, code: "571424" },
    { id: 36117, cityId: 899, code: "571453" },
    { id: 36118, cityId: 899, code: "582228" },
    { id: 36119, cityId: 900, code: "563130" },
    { id: 36120, cityId: 900, code: "571512" },
    { id: 36121, cityId: 900, code: "572153" },
    { id: 36122, cityId: 900, code: "563137" },
    { id: 36123, cityId: 900, code: "563139" },
    { id: 36124, cityId: 900, code: "563142" },
    { id: 36125, cityId: 900, code: "572240" },
    { id: 36126, cityId: 900, code: "577240" },
    { id: 36127, cityId: 901, code: "571401" },
    { id: 36128, cityId: 901, code: "571402" },
    { id: 36129, cityId: 901, code: "571404" },
    { id: 36130, cityId: 901, code: "571428" },
    { id: 36131, cityId: 901, code: "571431" },
    { id: 36132, cityId: 901, code: "571433" },
    { id: 36133, cityId: 901, code: "571434" },
    { id: 36134, cityId: 901, code: "571438" },
    { id: 36135, cityId: 901, code: "571454" },
    { id: 36136, cityId: 901, code: "571455" },
    { id: 36137, cityId: 901, code: "571462" },
    { id: 36138, cityId: 901, code: "571463" },
    { id: 36139, cityId: 901, code: "571465" },
    { id: 36140, cityId: 901, code: "571471" },
    { id: 36141, cityId: 901, code: "571473" },
    { id: 36142, cityId: 901, code: "571481" },
    { id: 36143, cityId: 901, code: "571802" },
    { id: 36144, cityId: 901, code: "571260" },
    { id: 36145, cityId: 901, code: "571403" },
    { id: 36146, cityId: 901, code: "571405" },
    { id: 36147, cityId: 901, code: "571416" },
    { id: 36148, cityId: 901, code: "571419" },
    { id: 36149, cityId: 901, code: "571421" },
    { id: 36150, cityId: 901, code: "571422" },
    { id: 36151, cityId: 901, code: "571427" },
    { id: 36152, cityId: 901, code: "571429" },
    { id: 36153, cityId: 901, code: "571430" },
    { id: 36154, cityId: 901, code: "571432" },
    { id: 36155, cityId: 901, code: "571435" },
    { id: 36156, cityId: 901, code: "571437" },
    { id: 36157, cityId: 901, code: "571443" },
    { id: 36158, cityId: 901, code: "571445" },
    { id: 36159, cityId: 901, code: "571451" },
    { id: 36160, cityId: 901, code: "571458" },
    { id: 36161, cityId: 901, code: "571459" },
    { id: 36162, cityId: 901, code: "571461" },
    { id: 36163, cityId: 901, code: "571464" },
    { id: 36164, cityId: 901, code: "571487" },
    { id: 36165, cityId: 901, code: "571806" },
    { id: 36166, cityId: 902, code: "574101" },
    { id: 36167, cityId: 902, code: "574103" },
    { id: 36168, cityId: 902, code: "574104" },
    { id: 36169, cityId: 902, code: "574106" },
    { id: 36170, cityId: 902, code: "574109" },
    { id: 36171, cityId: 902, code: "574111" },
    { id: 36172, cityId: 902, code: "574112" },
    { id: 36173, cityId: 902, code: "574114" },
    { id: 36174, cityId: 902, code: "574116" },
    { id: 36175, cityId: 902, code: "574117" },
    { id: 36176, cityId: 902, code: "574119" },
    { id: 36177, cityId: 902, code: "574122" },
    { id: 36178, cityId: 902, code: "574124" },
    { id: 36179, cityId: 902, code: "574125" },
    { id: 36180, cityId: 902, code: "574130" },
    { id: 36181, cityId: 902, code: "574132" },
    { id: 36182, cityId: 902, code: "574133" },
    { id: 36183, cityId: 902, code: "574138" },
    { id: 36184, cityId: 902, code: "574140" },
    { id: 36185, cityId: 902, code: "574141" },
    { id: 36186, cityId: 902, code: "574143" },
    { id: 36187, cityId: 902, code: "574146" },
    { id: 36188, cityId: 902, code: "574148" },
    { id: 36189, cityId: 902, code: "574149" },
    { id: 36190, cityId: 902, code: "574151" },
    { id: 36191, cityId: 902, code: "574154" },
    { id: 36192, cityId: 902, code: "574156" },
    { id: 36193, cityId: 902, code: "574157" },
    { id: 36194, cityId: 902, code: "574162" },
    { id: 36195, cityId: 902, code: "574164" },
    { id: 36196, cityId: 902, code: "574167" },
    { id: 36197, cityId: 902, code: "574172" },
    { id: 36198, cityId: 902, code: "574175" },
    { id: 36199, cityId: 902, code: "574177" },
    { id: 36200, cityId: 902, code: "574178" },
    { id: 36201, cityId: 902, code: "574180" },
    { id: 36202, cityId: 902, code: "574183" },
    { id: 36203, cityId: 902, code: "574185" },
    { id: 36204, cityId: 902, code: "574186" },
    { id: 36205, cityId: 902, code: "574188" },
    { id: 36206, cityId: 902, code: "574191" },
    { id: 36207, cityId: 902, code: "574194" },
    { id: 36208, cityId: 902, code: "574196" },
    { id: 36209, cityId: 902, code: "574201" },
    { id: 36210, cityId: 902, code: "574202" },
    { id: 36211, cityId: 902, code: "574210" },
    { id: 36212, cityId: 902, code: "574212" },
    { id: 36213, cityId: 902, code: "574214" },
    { id: 36214, cityId: 902, code: "574217" },
    { id: 36215, cityId: 902, code: "574220" },
    { id: 36216, cityId: 902, code: "574222" },
    { id: 36217, cityId: 902, code: "574223" },
    { id: 36218, cityId: 902, code: "574225" },
    { id: 36219, cityId: 902, code: "574228" },
    { id: 36220, cityId: 902, code: "574230" },
    { id: 36221, cityId: 902, code: "574231" },
    { id: 36222, cityId: 902, code: "574236" },
    { id: 36223, cityId: 902, code: "574238" },
    { id: 36224, cityId: 902, code: "574239" },
    { id: 36225, cityId: 902, code: "574241" },
    { id: 36226, cityId: 902, code: "574244" },
    { id: 36227, cityId: 902, code: "574246" },
    { id: 36228, cityId: 902, code: "574247" },
    { id: 36229, cityId: 902, code: "574249" },
    { id: 36230, cityId: 902, code: "574252" },
    { id: 36231, cityId: 902, code: "574254" },
    { id: 36232, cityId: 902, code: "574255" },
    { id: 36233, cityId: 902, code: "574257" },
    { id: 36234, cityId: 902, code: "574259" },
    { id: 36235, cityId: 902, code: "574260" },
    { id: 36236, cityId: 902, code: "574262" },
    { id: 36237, cityId: 902, code: "574265" },
    { id: 36238, cityId: 902, code: "574268" },
    { id: 36239, cityId: 902, code: "574270" },
    { id: 36240, cityId: 902, code: "574273" },
    { id: 36241, cityId: 902, code: "574275" },
    { id: 36242, cityId: 902, code: "574276" },
    { id: 36243, cityId: 902, code: "574278" },
    { id: 36244, cityId: 902, code: "574283" },
    { id: 36245, cityId: 902, code: "574284" },
    { id: 36246, cityId: 902, code: "574286" },
    { id: 36247, cityId: 902, code: "574289" },
    { id: 36248, cityId: 902, code: "574291" },
    { id: 36249, cityId: 902, code: "574292" },
    { id: 36250, cityId: 902, code: "574294" },
    { id: 36251, cityId: 902, code: "574297" },
    { id: 36252, cityId: 902, code: "574299" },
    { id: 36253, cityId: 902, code: "574302" },
    { id: 36254, cityId: 902, code: "574305" },
    { id: 36255, cityId: 902, code: "574310" },
    { id: 36256, cityId: 902, code: "574312" },
    { id: 36257, cityId: 902, code: "574313" },
    { id: 36258, cityId: 902, code: "574315" },
    { id: 36259, cityId: 902, code: "574318" },
    { id: 36260, cityId: 902, code: "574320" },
    { id: 36261, cityId: 902, code: "574321" },
    { id: 36262, cityId: 902, code: "574323" },
    { id: 36263, cityId: 902, code: "574334" },
    { id: 36264, cityId: 902, code: "574336" },
    { id: 36265, cityId: 902, code: "574337" },
    { id: 36266, cityId: 902, code: "574371" },
    { id: 36267, cityId: 902, code: "574501" },
    { id: 36268, cityId: 902, code: "574503" },
    { id: 36269, cityId: 902, code: "574508" },
    { id: 36270, cityId: 902, code: "575001" },
    { id: 36271, cityId: 902, code: "575004" },
    { id: 36272, cityId: 902, code: "575006" },
    { id: 36273, cityId: 902, code: "575007" },
    { id: 36274, cityId: 902, code: "575012" },
    { id: 36275, cityId: 902, code: "575253" },
    { id: 36276, cityId: 902, code: "576101" },
    { id: 36277, cityId: 902, code: "576103" },
    { id: 36278, cityId: 902, code: "576111" },
    { id: 36279, cityId: 902, code: "576113" },
    { id: 36280, cityId: 902, code: "576114" },
    { id: 36281, cityId: 902, code: "576116" },
    { id: 36282, cityId: 902, code: "576119" },
    { id: 36283, cityId: 902, code: "576121" },
    { id: 36284, cityId: 902, code: "576122" },
    { id: 36285, cityId: 902, code: "576124" },
    { id: 36286, cityId: 902, code: "576127" },
    { id: 36287, cityId: 902, code: "576129" },
    { id: 36288, cityId: 902, code: "576130" },
    { id: 36289, cityId: 902, code: "576132" },
    { id: 36290, cityId: 902, code: "576135" },
    { id: 36291, cityId: 902, code: "576137" },
    { id: 36292, cityId: 902, code: "576138" },
    { id: 36293, cityId: 902, code: "576143" },
    { id: 36294, cityId: 902, code: "576145" },
    { id: 36295, cityId: 902, code: "576146" },
    { id: 36296, cityId: 902, code: "576148" },
    { id: 36297, cityId: 902, code: "576153" },
    { id: 36298, cityId: 902, code: "576201" },
    { id: 36299, cityId: 902, code: "576211" },
    { id: 36300, cityId: 902, code: "576212" },
    { id: 36301, cityId: 902, code: "576214" },
    { id: 36302, cityId: 902, code: "576217" },
    { id: 36303, cityId: 902, code: "576219" },
    { id: 36304, cityId: 902, code: "576220" },
    { id: 36305, cityId: 902, code: "576222" },
    { id: 36306, cityId: 902, code: "576225" },
    { id: 36307, cityId: 902, code: "576227" },
    { id: 36308, cityId: 902, code: "576228" },
    { id: 36309, cityId: 902, code: "576230" },
    { id: 36310, cityId: 902, code: "576233" },
    { id: 36311, cityId: 902, code: "576235" },
    { id: 36312, cityId: 902, code: "576236" },
    { id: 36313, cityId: 902, code: "576238" },
    { id: 36314, cityId: 902, code: "576241" },
    { id: 36315, cityId: 902, code: "576243" },
    { id: 36316, cityId: 902, code: "576244" },
    { id: 36317, cityId: 902, code: "576246" },
    { id: 36318, cityId: 902, code: "576249" },
    { id: 36319, cityId: 902, code: "576251" },
    { id: 36320, cityId: 902, code: "576252" },
    { id: 36321, cityId: 902, code: "576256" },
    { id: 36322, cityId: 902, code: "576257" },
    { id: 36323, cityId: 902, code: "576259" },
    { id: 36324, cityId: 902, code: "576262" },
    { id: 36325, cityId: 902, code: "576264" },
    { id: 36326, cityId: 902, code: "576265" },
    { id: 36327, cityId: 902, code: "576267" },
    { id: 36328, cityId: 902, code: "576270" },
    { id: 36329, cityId: 902, code: "576272" },
    { id: 36330, cityId: 902, code: "576273" },
    { id: 36331, cityId: 902, code: "576275" },
    { id: 36332, cityId: 902, code: "576278" },
    { id: 36333, cityId: 902, code: "576280" },
    { id: 36334, cityId: 902, code: "576281" },
    { id: 36335, cityId: 902, code: "577239" },
    { id: 36336, cityId: 902, code: "571329" },
    { id: 36337, cityId: 902, code: "574102" },
    { id: 36338, cityId: 902, code: "574105" },
    { id: 36339, cityId: 902, code: "574107" },
    { id: 36340, cityId: 902, code: "574108" },
    { id: 36341, cityId: 902, code: "574110" },
    { id: 36342, cityId: 902, code: "574113" },
    { id: 36343, cityId: 902, code: "574115" },
    { id: 36344, cityId: 902, code: "574118" },
    { id: 36345, cityId: 902, code: "574120" },
    { id: 36346, cityId: 902, code: "574121" },
    { id: 36347, cityId: 902, code: "574123" },
    { id: 36348, cityId: 902, code: "574126" },
    { id: 36349, cityId: 902, code: "574128" },
    { id: 36350, cityId: 902, code: "574129" },
    { id: 36351, cityId: 902, code: "574131" },
    { id: 36352, cityId: 902, code: "574134" },
    { id: 36353, cityId: 902, code: "574136" },
    { id: 36354, cityId: 902, code: "574137" },
    { id: 36355, cityId: 902, code: "574139" },
    { id: 36356, cityId: 902, code: "574144" },
    { id: 36357, cityId: 902, code: "574145" },
    { id: 36358, cityId: 902, code: "574147" },
    { id: 36359, cityId: 902, code: "574150" },
    { id: 36360, cityId: 902, code: "574152" },
    { id: 36361, cityId: 902, code: "574153" },
    { id: 36362, cityId: 902, code: "574158" },
    { id: 36363, cityId: 902, code: "574160" },
    { id: 36364, cityId: 902, code: "574161" },
    { id: 36365, cityId: 902, code: "574163" },
    { id: 36366, cityId: 902, code: "574165" },
    { id: 36367, cityId: 902, code: "574166" },
    { id: 36368, cityId: 902, code: "574168" },
    { id: 36369, cityId: 902, code: "574171" },
    { id: 36370, cityId: 902, code: "574173" },
    { id: 36371, cityId: 902, code: "574174" },
    { id: 36372, cityId: 902, code: "574176" },
    { id: 36373, cityId: 902, code: "574179" },
    { id: 36374, cityId: 902, code: "574181" },
    { id: 36375, cityId: 902, code: "574182" },
    { id: 36376, cityId: 902, code: "574184" },
    { id: 36377, cityId: 902, code: "574187" },
    { id: 36378, cityId: 902, code: "574189" },
    { id: 36379, cityId: 902, code: "574190" },
    { id: 36380, cityId: 902, code: "574192" },
    { id: 36381, cityId: 902, code: "574195" },
    { id: 36382, cityId: 902, code: "574197" },
    { id: 36383, cityId: 902, code: "574198" },
    { id: 36384, cityId: 902, code: "574203" },
    { id: 36385, cityId: 902, code: "574208" },
    { id: 36386, cityId: 902, code: "574213" },
    { id: 36387, cityId: 902, code: "574216" },
    { id: 36388, cityId: 902, code: "574218" },
    { id: 36389, cityId: 902, code: "574219" },
    { id: 36390, cityId: 902, code: "574221" },
    { id: 36391, cityId: 902, code: "574224" },
    { id: 36392, cityId: 902, code: "574226" },
    { id: 36393, cityId: 902, code: "574227" },
    { id: 36394, cityId: 902, code: "574232" },
    { id: 36395, cityId: 902, code: "574234" },
    { id: 36396, cityId: 902, code: "574235" },
    { id: 36397, cityId: 902, code: "574237" },
    { id: 36398, cityId: 902, code: "574240" },
    { id: 36399, cityId: 902, code: "574242" },
    { id: 36400, cityId: 902, code: "574243" },
    { id: 36401, cityId: 902, code: "574245" },
    { id: 36402, cityId: 902, code: "574248" },
    { id: 36403, cityId: 902, code: "574250" },
    { id: 36404, cityId: 902, code: "574251" },
    { id: 36405, cityId: 902, code: "574256" },
    { id: 36406, cityId: 902, code: "574258" },
    { id: 36407, cityId: 902, code: "574261" },
    { id: 36408, cityId: 902, code: "574263" },
    { id: 36409, cityId: 902, code: "574264" },
    { id: 36410, cityId: 902, code: "574266" },
    { id: 36411, cityId: 902, code: "574269" },
    { id: 36412, cityId: 902, code: "574272" },
    { id: 36413, cityId: 902, code: "574274" },
    { id: 36414, cityId: 902, code: "574277" },
    { id: 36415, cityId: 902, code: "574279" },
    { id: 36416, cityId: 902, code: "574280" },
    { id: 36417, cityId: 902, code: "574282" },
    { id: 36418, cityId: 902, code: "574285" },
    { id: 36419, cityId: 902, code: "574287" },
    { id: 36420, cityId: 902, code: "574288" },
    { id: 36421, cityId: 902, code: "574290" },
    { id: 36422, cityId: 902, code: "574293" },
    { id: 36423, cityId: 902, code: "574295" },
    { id: 36424, cityId: 902, code: "574296" },
    { id: 36425, cityId: 902, code: "574298" },
    { id: 36426, cityId: 902, code: "574301" },
    { id: 36427, cityId: 902, code: "574303" },
    { id: 36428, cityId: 902, code: "574304" },
    { id: 36429, cityId: 902, code: "574306" },
    { id: 36430, cityId: 902, code: "574309" },
    { id: 36431, cityId: 902, code: "574311" },
    { id: 36432, cityId: 902, code: "574314" },
    { id: 36433, cityId: 902, code: "574316" },
    { id: 36434, cityId: 902, code: "574317" },
    { id: 36435, cityId: 902, code: "574319" },
    { id: 36436, cityId: 902, code: "574333" },
    { id: 36437, cityId: 902, code: "574335" },
    { id: 36438, cityId: 902, code: "574502" },
    { id: 36439, cityId: 902, code: "574504" },
    { id: 36440, cityId: 902, code: "574505" },
    { id: 36441, cityId: 902, code: "574507" },
    { id: 36442, cityId: 902, code: "575002" },
    { id: 36443, cityId: 902, code: "575003" },
    { id: 36444, cityId: 902, code: "575005" },
    { id: 36445, cityId: 902, code: "575008" },
    { id: 36446, cityId: 902, code: "575010" },
    { id: 36447, cityId: 902, code: "575011" },
    { id: 36448, cityId: 902, code: "575013" },
    { id: 36449, cityId: 902, code: "576102" },
    { id: 36450, cityId: 902, code: "576104" },
    { id: 36451, cityId: 902, code: "576112" },
    { id: 36452, cityId: 902, code: "576115" },
    { id: 36453, cityId: 902, code: "576117" },
    { id: 36454, cityId: 902, code: "576118" },
    { id: 36455, cityId: 902, code: "576120" },
    { id: 36456, cityId: 902, code: "576123" },
    { id: 36457, cityId: 902, code: "576126" },
    { id: 36458, cityId: 902, code: "576128" },
    { id: 36459, cityId: 902, code: "576131" },
    { id: 36460, cityId: 902, code: "576133" },
    { id: 36461, cityId: 902, code: "576134" },
    { id: 36462, cityId: 902, code: "576136" },
    { id: 36463, cityId: 902, code: "576139" },
    { id: 36464, cityId: 902, code: "576141" },
    { id: 36465, cityId: 902, code: "576142" },
    { id: 36466, cityId: 902, code: "576144" },
    { id: 36467, cityId: 902, code: "576150" },
    { id: 36468, cityId: 902, code: "576210" },
    { id: 36469, cityId: 902, code: "576213" },
    { id: 36470, cityId: 902, code: "576215" },
    { id: 36471, cityId: 902, code: "576216" },
    { id: 36472, cityId: 902, code: "576218" },
    { id: 36473, cityId: 902, code: "576221" },
    { id: 36474, cityId: 902, code: "576223" },
    { id: 36475, cityId: 902, code: "576224" },
    { id: 36476, cityId: 902, code: "576226" },
    { id: 36477, cityId: 902, code: "576229" },
    { id: 36478, cityId: 902, code: "576231" },
    { id: 36479, cityId: 902, code: "576232" },
    { id: 36480, cityId: 902, code: "576234" },
    { id: 36481, cityId: 902, code: "576237" },
    { id: 36482, cityId: 902, code: "576239" },
    { id: 36483, cityId: 902, code: "576240" },
    { id: 36484, cityId: 902, code: "576242" },
    { id: 36485, cityId: 902, code: "576245" },
    { id: 36486, cityId: 902, code: "576247" },
    { id: 36487, cityId: 902, code: "576248" },
    { id: 36488, cityId: 902, code: "576250" },
    { id: 36489, cityId: 902, code: "576253" },
    { id: 36490, cityId: 902, code: "576255" },
    { id: 36491, cityId: 902, code: "576258" },
    { id: 36492, cityId: 902, code: "576260" },
    { id: 36493, cityId: 902, code: "576261" },
    { id: 36494, cityId: 902, code: "576263" },
    { id: 36495, cityId: 902, code: "576266" },
    { id: 36496, cityId: 902, code: "576269" },
    { id: 36497, cityId: 902, code: "576271" },
    { id: 36498, cityId: 902, code: "576274" },
    { id: 36499, cityId: 902, code: "576276" },
    { id: 36500, cityId: 902, code: "576277" },
    { id: 36501, cityId: 902, code: "576279" },
    { id: 36502, cityId: 902, code: "576282" },
    { id: 36503, cityId: 902, code: "577447" },
    { id: 36504, cityId: 903, code: "584154" },
    { id: 36505, cityId: 903, code: "584123" },
    { id: 36506, cityId: 903, code: "584144" },
    { id: 36507, cityId: 903, code: "584147" },
    { id: 36508, cityId: 903, code: "584203" },
    { id: 36509, cityId: 904, code: "586212" },
    { id: 36510, cityId: 904, code: "586229" },
    { id: 36511, cityId: 905, code: "584125" },
    { id: 36512, cityId: 906, code: "585318" },
    { id: 36513, cityId: 906, code: "585364" },
    { id: 36514, cityId: 906, code: "587122" },
    { id: 36515, cityId: 906, code: "587313" },
    { id: 36516, cityId: 906, code: "583259" },
    { id: 36517, cityId: 906, code: "587134" },
    { id: 36518, cityId: 906, code: "587312" },
    { id: 36519, cityId: 907, code: "577113" },
    { id: 36520, cityId: 907, code: "577122" },
    { id: 36521, cityId: 907, code: "577124" },
    { id: 36522, cityId: 907, code: "577132" },
    { id: 36523, cityId: 908, code: "563131" },
    { id: 36524, cityId: 908, code: "563136" },
    { id: 36525, cityId: 908, code: "563149" },
    { id: 36526, cityId: 908, code: "563152" },
    { id: 36527, cityId: 908, code: "563140" },
    { id: 36528, cityId: 908, code: "563141" },
    { id: 36529, cityId: 908, code: "572148" },
    { id: 36530, cityId: 909, code: "582117" },
    { id: 36531, cityId: 910, code: "574154" },
    { id: 36532, cityId: 911, code: "582113" },
    { id: 36533, cityId: 911, code: "582118" },
    { id: 36534, cityId: 911, code: "582121" },
    { id: 36535, cityId: 911, code: "582222" },
    { id: 36536, cityId: 912, code: "581145" },
    { id: 36537, cityId: 912, code: "581349" },
    { id: 36538, cityId: 913, code: "570001" },
    { id: 36539, cityId: 913, code: "570006" },
    { id: 36540, cityId: 913, code: "570008" },
    { id: 36541, cityId: 913, code: "570009" },
    { id: 36542, cityId: 913, code: "570011" },
    { id: 36543, cityId: 913, code: "570013" },
    { id: 36544, cityId: 913, code: "570014" },
    { id: 36545, cityId: 913, code: "570016" },
    { id: 36546, cityId: 913, code: "570019" },
    { id: 36547, cityId: 913, code: "570021" },
    { id: 36548, cityId: 913, code: "570024" },
    { id: 36549, cityId: 913, code: "571105" },
    { id: 36550, cityId: 913, code: "571107" },
    { id: 36551, cityId: 913, code: "571110" },
    { id: 36552, cityId: 913, code: "571115" },
    { id: 36553, cityId: 913, code: "571123" },
    { id: 36554, cityId: 913, code: "571124" },
    { id: 36555, cityId: 913, code: "571134" },
    { id: 36556, cityId: 913, code: "571136" },
    { id: 36557, cityId: 913, code: "571137" },
    { id: 36558, cityId: 913, code: "571139" },
    { id: 36559, cityId: 913, code: "571147" },
    { id: 36560, cityId: 913, code: "571152" },
    { id: 36561, cityId: 913, code: "571153" },
    { id: 36562, cityId: 913, code: "571155" },
    { id: 36563, cityId: 913, code: "571161" },
    { id: 36564, cityId: 913, code: "571163" },
    { id: 36565, cityId: 913, code: "571166" },
    { id: 36566, cityId: 913, code: "571168" },
    { id: 36567, cityId: 913, code: "571171" },
    { id: 36568, cityId: 913, code: "571176" },
    { id: 36569, cityId: 913, code: "571177" },
    { id: 36570, cityId: 913, code: "571181" },
    { id: 36571, cityId: 913, code: "571182" },
    { id: 36572, cityId: 913, code: "571184" },
    { id: 36573, cityId: 913, code: "571189" },
    { id: 36574, cityId: 913, code: "571301" },
    { id: 36575, cityId: 913, code: "571311" },
    { id: 36576, cityId: 913, code: "571312" },
    { id: 36577, cityId: 913, code: "571317" },
    { id: 36578, cityId: 913, code: "571319" },
    { id: 36579, cityId: 913, code: "571322" },
    { id: 36580, cityId: 913, code: "571325" },
    { id: 36581, cityId: 913, code: "571333" },
    { id: 36582, cityId: 913, code: "571335" },
    { id: 36583, cityId: 913, code: "571340" },
    { id: 36584, cityId: 913, code: "571341" },
    { id: 36585, cityId: 913, code: "571436" },
    { id: 36586, cityId: 913, code: "571444" },
    { id: 36587, cityId: 913, code: "571457" },
    { id: 36588, cityId: 913, code: "571478" },
    { id: 36589, cityId: 913, code: "571484" },
    { id: 36590, cityId: 913, code: "571489" },
    { id: 36591, cityId: 913, code: "571491" },
    { id: 36592, cityId: 913, code: "571494" },
    { id: 36593, cityId: 913, code: "571499" },
    { id: 36594, cityId: 913, code: "571502" },
    { id: 36595, cityId: 913, code: "571608" },
    { id: 36596, cityId: 913, code: "571613" },
    { id: 36597, cityId: 913, code: "571812" },
    { id: 36598, cityId: 913, code: "570002" },
    { id: 36599, cityId: 913, code: "570004" },
    { id: 36600, cityId: 913, code: "570005" },
    { id: 36601, cityId: 913, code: "570007" },
    { id: 36602, cityId: 913, code: "570010" },
    { id: 36603, cityId: 913, code: "570012" },
    { id: 36604, cityId: 913, code: "570015" },
    { id: 36605, cityId: 913, code: "570017" },
    { id: 36606, cityId: 913, code: "570018" },
    { id: 36607, cityId: 913, code: "570020" },
    { id: 36608, cityId: 913, code: "571104" },
    { id: 36609, cityId: 913, code: "571111" },
    { id: 36610, cityId: 913, code: "571114" },
    { id: 36611, cityId: 913, code: "571117" },
    { id: 36612, cityId: 913, code: "571120" },
    { id: 36613, cityId: 913, code: "571122" },
    { id: 36614, cityId: 913, code: "571125" },
    { id: 36615, cityId: 913, code: "571127" },
    { id: 36616, cityId: 913, code: "571128" },
    { id: 36617, cityId: 913, code: "571130" },
    { id: 36618, cityId: 913, code: "571133" },
    { id: 36619, cityId: 913, code: "571135" },
    { id: 36620, cityId: 913, code: "571138" },
    { id: 36621, cityId: 913, code: "571140" },
    { id: 36622, cityId: 913, code: "571143" },
    { id: 36623, cityId: 913, code: "571154" },
    { id: 36624, cityId: 913, code: "571156" },
    { id: 36625, cityId: 913, code: "571157" },
    { id: 36626, cityId: 913, code: "571159" },
    { id: 36627, cityId: 913, code: "571164" },
    { id: 36628, cityId: 913, code: "571167" },
    { id: 36629, cityId: 913, code: "571173" },
    { id: 36630, cityId: 913, code: "571175" },
    { id: 36631, cityId: 913, code: "571183" },
    { id: 36632, cityId: 913, code: "571188" },
    { id: 36633, cityId: 913, code: "571246" },
    { id: 36634, cityId: 913, code: "571302" },
    { id: 36635, cityId: 913, code: "571313" },
    { id: 36636, cityId: 913, code: "571315" },
    { id: 36637, cityId: 913, code: "571321" },
    { id: 36638, cityId: 913, code: "571323" },
    { id: 36639, cityId: 913, code: "571324" },
    { id: 36640, cityId: 913, code: "571326" },
    { id: 36641, cityId: 913, code: "571328" },
    { id: 36642, cityId: 913, code: "571339" },
    { id: 36643, cityId: 913, code: "571426" },
    { id: 36644, cityId: 913, code: "571440" },
    { id: 36645, cityId: 913, code: "571477" },
    { id: 36646, cityId: 913, code: "571480" },
    { id: 36647, cityId: 913, code: "571490" },
    { id: 36648, cityId: 913, code: "571495" },
    { id: 36649, cityId: 913, code: "571501" },
    { id: 36650, cityId: 913, code: "571511" },
    { id: 36651, cityId: 913, code: "571601" },
    { id: 36652, cityId: 913, code: "571602" },
    { id: 36653, cityId: 913, code: "571609" },
    { id: 36654, cityId: 913, code: "571617" },
    { id: 36655, cityId: 913, code: "571803" },
    { id: 36656, cityId: 913, code: "571805" },
    { id: 36657, cityId: 913, code: "571808" },
    { id: 36658, cityId: 914, code: "571432" },
    { id: 36659, cityId: 915, code: "571301" },
    { id: 36660, cityId: 916, code: "577134" },
    { id: 36661, cityId: 916, code: "577160" },
    { id: 36662, cityId: 917, code: "581165" },
    { id: 36663, cityId: 917, code: "582119" },
    { id: 36664, cityId: 918, code: "582208" },
    { id: 36665, cityId: 918, code: "582221" },
    { id: 36666, cityId: 918, code: "582237" },
    { id: 36667, cityId: 919, code: "591237" },
    { id: 36668, cityId: 920, code: "571434" },
    { id: 36669, cityId: 920, code: "571484" },
    { id: 36670, cityId: 921, code: "561202" },
    { id: 36671, cityId: 921, code: "571330" },
    { id: 36672, cityId: 921, code: "572156" },
    { id: 36673, cityId: 921, code: "577527" },
    { id: 36674, cityId: 921, code: "572136" },
    { id: 36675, cityId: 922, code: "571108" },
    { id: 36676, cityId: 922, code: "571614" },
    { id: 36677, cityId: 922, code: "571807" },
    { id: 36678, cityId: 923, code: "574169" },
    { id: 36679, cityId: 924, code: "517583" },
    { id: 36680, cityId: 924, code: "574201" },
    { id: 36681, cityId: 924, code: "574307" },
    { id: 36682, cityId: 925, code: "583233" },
    { id: 36683, cityId: 925, code: "583235" },
    { id: 36684, cityId: 925, code: "583256" },
    { id: 36685, cityId: 925, code: "584101" },
    { id: 36686, cityId: 925, code: "584117" },
    { id: 36687, cityId: 925, code: "584120" },
    { id: 36688, cityId: 925, code: "584122" },
    { id: 36689, cityId: 925, code: "584127" },
    { id: 36690, cityId: 925, code: "584128" },
    { id: 36691, cityId: 925, code: "584133" },
    { id: 36692, cityId: 925, code: "584135" },
    { id: 36693, cityId: 925, code: "584136" },
    { id: 36694, cityId: 925, code: "584138" },
    { id: 36695, cityId: 925, code: "584143" },
    { id: 36696, cityId: 925, code: "584151" },
    { id: 36697, cityId: 925, code: "584160" },
    { id: 36698, cityId: 925, code: "584167" },
    { id: 36699, cityId: 925, code: "584202" },
    { id: 36700, cityId: 925, code: "583231" },
    { id: 36701, cityId: 925, code: "583234" },
    { id: 36702, cityId: 925, code: "583236" },
    { id: 36703, cityId: 925, code: "583257" },
    { id: 36704, cityId: 925, code: "583265" },
    { id: 36705, cityId: 925, code: "584102" },
    { id: 36706, cityId: 925, code: "584110" },
    { id: 36707, cityId: 925, code: "584111" },
    { id: 36708, cityId: 925, code: "584113" },
    { id: 36709, cityId: 925, code: "584116" },
    { id: 36710, cityId: 925, code: "584119" },
    { id: 36711, cityId: 925, code: "584126" },
    { id: 36712, cityId: 925, code: "584131" },
    { id: 36713, cityId: 925, code: "584134" },
    { id: 36714, cityId: 925, code: "584140" },
    { id: 36715, cityId: 925, code: "584145" },
    { id: 36716, cityId: 925, code: "584148" },
    { id: 36717, cityId: 925, code: "584150" },
    { id: 36718, cityId: 925, code: "584155" },
    { id: 36719, cityId: 925, code: "584158" },
    { id: 36720, cityId: 925, code: "584161" },
    { id: 36721, cityId: 925, code: "584164" },
    { id: 36722, cityId: 925, code: "584166" },
    { id: 36723, cityId: 925, code: "584169" },
    { id: 36724, cityId: 925, code: "584201" },
    { id: 36725, cityId: 926, code: "571511" },
    { id: 36726, cityId: 927, code: "591123" },
    { id: 36727, cityId: 928, code: "581179" },
    { id: 36728, cityId: 928, code: "581211" },
    { id: 36729, cityId: 928, code: "581141" },
    { id: 36730, cityId: 928, code: "581144" },
    { id: 36731, cityId: 928, code: "581178" },
    { id: 36732, cityId: 929, code: "582239" },
    { id: 36733, cityId: 929, code: "582203" },
    { id: 36734, cityId: 929, code: "582209" },
    { id: 36735, cityId: 929, code: "582211" },
    { id: 36736, cityId: 929, code: "582217" },
    { id: 36737, cityId: 930, code: "470001" },
    { id: 36738, cityId: 930, code: "470002" },
    { id: 36739, cityId: 930, code: "470113" },
    { id: 36740, cityId: 930, code: "470115" },
    { id: 36741, cityId: 930, code: "470118" },
    { id: 36742, cityId: 930, code: "470120" },
    { id: 36743, cityId: 930, code: "470221" },
    { id: 36744, cityId: 930, code: "470226" },
    { id: 36745, cityId: 930, code: "470227" },
    { id: 36746, cityId: 930, code: "470229" },
    { id: 36747, cityId: 930, code: "470235" },
    { id: 36748, cityId: 930, code: "470335" },
    { id: 36749, cityId: 930, code: "470669" },
    { id: 36750, cityId: 930, code: "577412" },
    { id: 36751, cityId: 930, code: "585323" },
    { id: 36752, cityId: 930, code: "470003" },
    { id: 36753, cityId: 930, code: "470005" },
    { id: 36754, cityId: 930, code: "470051" },
    { id: 36755, cityId: 930, code: "470111" },
    { id: 36756, cityId: 930, code: "470117" },
    { id: 36757, cityId: 930, code: "470119" },
    { id: 36758, cityId: 930, code: "470122" },
    { id: 36759, cityId: 930, code: "470125" },
    { id: 36760, cityId: 930, code: "470223" },
    { id: 36761, cityId: 930, code: "470228" },
    { id: 36762, cityId: 930, code: "470230" },
    { id: 36763, cityId: 930, code: "470337" },
    { id: 36764, cityId: 930, code: "470339" },
    { id: 36765, cityId: 930, code: "470442" },
    { id: 36766, cityId: 930, code: "577128" },
    { id: 36767, cityId: 930, code: "577417" },
    { id: 36768, cityId: 930, code: "577443" },
    { id: 36769, cityId: 931, code: "573157" },
    { id: 36770, cityId: 931, code: "573123" },
    { id: 36771, cityId: 931, code: "573221" },
    { id: 36772, cityId: 931, code: "577147" },
    { id: 36773, cityId: 932, code: "571604" },
    { id: 36774, cityId: 933, code: "583119" },
    { id: 36775, cityId: 934, code: "591313" },
    { id: 36776, cityId: 935, code: "581159" },
    { id: 36777, cityId: 935, code: "581118" },
    { id: 36778, cityId: 936, code: "585222" },
    { id: 36779, cityId: 936, code: "585251" },
    { id: 36780, cityId: 936, code: "585315" },
    { id: 36781, cityId: 936, code: "584101" },
    { id: 36782, cityId: 936, code: "585280" },
    { id: 36783, cityId: 936, code: "587329" },
    { id: 36784, cityId: 937, code: "585228" },
    { id: 36785, cityId: 937, code: "241124" },
    { id: 36786, cityId: 937, code: "244922" },
    { id: 36787, cityId: 938, code: "577401" },
    { id: 36788, cityId: 938, code: "585273" },
    { id: 36789, cityId: 938, code: "585319" },
    { id: 36790, cityId: 938, code: "586129" },
    { id: 36791, cityId: 938, code: "251318" },
    { id: 36792, cityId: 938, code: "585375" },
    { id: 36793, cityId: 939, code: "575016" },
    { id: 36794, cityId: 939, code: "584170" },
    { id: 36795, cityId: 940, code: "581126" },
    { id: 36796, cityId: 940, code: "582136" },
    { id: 36797, cityId: 940, code: "581205" },
    { id: 36798, cityId: 941, code: "202395" },
    { id: 36799, cityId: 941, code: "572166" },
    { id: 36800, cityId: 942, code: "577202" },
    { id: 36801, cityId: 942, code: "577212" },
    { id: 36802, cityId: 942, code: "577213" },
    { id: 36803, cityId: 942, code: "577215" },
    { id: 36804, cityId: 942, code: "577218" },
    { id: 36805, cityId: 942, code: "577220" },
    { id: 36806, cityId: 942, code: "577226" },
    { id: 36807, cityId: 942, code: "577229" },
    { id: 36808, cityId: 942, code: "577231" },
    { id: 36809, cityId: 942, code: "577236" },
    { id: 36810, cityId: 942, code: "577237" },
    { id: 36811, cityId: 942, code: "577241" },
    { id: 36812, cityId: 942, code: "577244" },
    { id: 36813, cityId: 942, code: "577247" },
    { id: 36814, cityId: 942, code: "577303" },
    { id: 36815, cityId: 942, code: "577321" },
    { id: 36816, cityId: 942, code: "577401" },
    { id: 36817, cityId: 942, code: "577411" },
    { id: 36818, cityId: 942, code: "577425" },
    { id: 36819, cityId: 942, code: "577427" },
    { id: 36820, cityId: 942, code: "577432" },
    { id: 36821, cityId: 942, code: "577433" },
    { id: 36822, cityId: 942, code: "577435" },
    { id: 36823, cityId: 942, code: "577446" },
    { id: 36824, cityId: 942, code: "577448" },
    { id: 36825, cityId: 942, code: "577201" },
    { id: 36826, cityId: 942, code: "577211" },
    { id: 36827, cityId: 942, code: "577214" },
    { id: 36828, cityId: 942, code: "577216" },
    { id: 36829, cityId: 942, code: "577222" },
    { id: 36830, cityId: 942, code: "577224" },
    { id: 36831, cityId: 942, code: "577225" },
    { id: 36832, cityId: 942, code: "577227" },
    { id: 36833, cityId: 942, code: "577233" },
    { id: 36834, cityId: 942, code: "577245" },
    { id: 36835, cityId: 942, code: "577301" },
    { id: 36836, cityId: 942, code: "577418" },
    { id: 36837, cityId: 942, code: "577421" },
    { id: 36838, cityId: 942, code: "577426" },
    { id: 36839, cityId: 942, code: "577428" },
    { id: 36840, cityId: 942, code: "577429" },
    { id: 36841, cityId: 942, code: "577434" },
    { id: 36842, cityId: 942, code: "577439" },
    { id: 36843, cityId: 942, code: "577444" },
    { id: 36844, cityId: 942, code: "577449" },
    { id: 36845, cityId: 942, code: "577450" },
    { id: 36846, cityId: 943, code: "582112" },
    { id: 36847, cityId: 943, code: "582120" },
    { id: 36848, cityId: 943, code: "582139" },
    { id: 36849, cityId: 943, code: "582210" },
    { id: 36850, cityId: 943, code: "582224" },
    { id: 36851, cityId: 944, code: "585216" },
    { id: 36852, cityId: 944, code: "585224" },
    { id: 36853, cityId: 944, code: "585237" },
    { id: 36854, cityId: 944, code: "585253" },
    { id: 36855, cityId: 944, code: "582137" },
    { id: 36856, cityId: 944, code: "585215" },
    { id: 36857, cityId: 944, code: "585291" },
    { id: 36858, cityId: 945, code: "584149" },
    { id: 36859, cityId: 945, code: "587151" },
    { id: 36860, cityId: 946, code: "562105" },
    { id: 36861, cityId: 947, code: "586123" },
    { id: 36862, cityId: 947, code: "586128" },
    { id: 36863, cityId: 947, code: "586168" },
    { id: 36864, cityId: 947, code: "586202" },
    { id: 36865, cityId: 947, code: "586155" },
    { id: 36866, cityId: 947, code: "586158" },
    { id: 36867, cityId: 947, code: "586163" },
    { id: 36868, cityId: 947, code: "586166" },
    { id: 36869, cityId: 947, code: "586206" },
    { id: 36870, cityId: 947, code: "587321" },
    { id: 36871, cityId: 948, code: "584128" },
    { id: 36872, cityId: 948, code: "584165" },
    { id: 36873, cityId: 948, code: "584132" },
    { id: 36874, cityId: 949, code: "572137" },
    { id: 36875, cityId: 949, code: "572169" },
    { id: 36876, cityId: 949, code: "572125" },
    { id: 36877, cityId: 949, code: "572152" },
    { id: 36878, cityId: 949, code: "572170" },
    { id: 36879, cityId: 950, code: "244301" },
    { id: 36880, cityId: 950, code: "585258" },
    { id: 36881, cityId: 951, code: "583121" },
    { id: 36882, cityId: 952, code: "571232" },
    { id: 36883, cityId: 952, code: "571244" },
    { id: 36884, cityId: 952, code: "571263" },
    { id: 36885, cityId: 952, code: "577246" },
    { id: 36886, cityId: 952, code: "571238" },
    { id: 36887, cityId: 952, code: "571259" },
    { id: 36888, cityId: 952, code: "571270" },
    { id: 36889, cityId: 953, code: "577413" },
    { id: 36890, cityId: 953, code: "577419" },
    { id: 36891, cityId: 953, code: "577429" },
    { id: 36892, cityId: 953, code: "571169" },
    { id: 36893, cityId: 954, code: "577139" },
    { id: 36894, cityId: 954, code: "577177" },
    { id: 36895, cityId: 955, code: "563138" },
    { id: 36896, cityId: 956, code: "587140" },
    { id: 36897, cityId: 956, code: "581184" },
    { id: 36898, cityId: 957, code: "577228" },
    { id: 36899, cityId: 957, code: "572120" },
    { id: 36900, cityId: 957, code: "577547" },
    { id: 36901, cityId: 958, code: "583122" },
    { id: 36902, cityId: 959, code: "587315" },
    { id: 36903, cityId: 960, code: "574170" },
    { id: 36904, cityId: 961, code: "572201" },
    { id: 36905, cityId: 961, code: "572235" },
    { id: 36906, cityId: 961, code: "572224" },
    { id: 36907, cityId: 962, code: "577422" },
    { id: 36908, cityId: 962, code: "577424" },
    { id: 36909, cityId: 962, code: "577440" },
    { id: 36910, cityId: 962, code: "577158" },
    { id: 36911, cityId: 962, code: "577232" },
    { id: 36912, cityId: 962, code: "577415" },
    { id: 36913, cityId: 963, code: "571160" },
    { id: 36914, cityId: 963, code: "571162" },
    { id: 36915, cityId: 964, code: "561202" },
    { id: 36916, cityId: 964, code: "572101" },
    { id: 36917, cityId: 964, code: "572104" },
    { id: 36918, cityId: 964, code: "572106" },
    { id: 36919, cityId: 964, code: "572114" },
    { id: 36920, cityId: 964, code: "572117" },
    { id: 36921, cityId: 964, code: "572122" },
    { id: 36922, cityId: 964, code: "572123" },
    { id: 36923, cityId: 964, code: "572128" },
    { id: 36924, cityId: 964, code: "572130" },
    { id: 36925, cityId: 964, code: "572138" },
    { id: 36926, cityId: 964, code: "572144" },
    { id: 36927, cityId: 964, code: "572146" },
    { id: 36928, cityId: 964, code: "572147" },
    { id: 36929, cityId: 964, code: "572154" },
    { id: 36930, cityId: 964, code: "572159" },
    { id: 36931, cityId: 964, code: "572162" },
    { id: 36932, cityId: 964, code: "572168" },
    { id: 36933, cityId: 964, code: "572173" },
    { id: 36934, cityId: 964, code: "572175" },
    { id: 36935, cityId: 964, code: "572202" },
    { id: 36936, cityId: 964, code: "572213" },
    { id: 36937, cityId: 964, code: "572231" },
    { id: 36938, cityId: 964, code: "572234" },
    { id: 36939, cityId: 964, code: "572239" },
    { id: 36940, cityId: 964, code: "572103" },
    { id: 36941, cityId: 964, code: "572116" },
    { id: 36942, cityId: 964, code: "572118" },
    { id: 36943, cityId: 964, code: "572129" },
    { id: 36944, cityId: 964, code: "572132" },
    { id: 36945, cityId: 964, code: "572134" },
    { id: 36946, cityId: 964, code: "572135" },
    { id: 36947, cityId: 964, code: "572137" },
    { id: 36948, cityId: 964, code: "572140" },
    { id: 36949, cityId: 964, code: "572143" },
    { id: 36950, cityId: 964, code: "572145" },
    { id: 36951, cityId: 964, code: "572158" },
    { id: 36952, cityId: 964, code: "572164" },
    { id: 36953, cityId: 964, code: "572171" },
    { id: 36954, cityId: 964, code: "572172" },
    { id: 36955, cityId: 964, code: "572174" },
    { id: 36956, cityId: 964, code: "572201" },
    { id: 36957, cityId: 964, code: "572216" },
    { id: 36958, cityId: 964, code: "572219" },
    { id: 36959, cityId: 964, code: "572225" },
    { id: 36960, cityId: 964, code: "572227" },
    { id: 36961, cityId: 964, code: "572230" },
    { id: 36962, cityId: 964, code: "572232" },
    { id: 36963, cityId: 964, code: "572233" },
    { id: 36964, cityId: 965, code: "572215" },
    { id: 36965, cityId: 965, code: "577542" },
    { id: 36966, cityId: 965, code: "572211" },
    { id: 36967, cityId: 965, code: "572212" },
    { id: 36968, cityId: 965, code: "572227" },
    { id: 36969, cityId: 966, code: "576101" },
    { id: 36970, cityId: 966, code: "576103" },
    { id: 36971, cityId: 967, code: "574159" },
    { id: 36972, cityId: 968, code: "561216" },
    { id: 36973, cityId: 969, code: "562135" },
    { id: 36974, cityId: 970, code: "571211" },
    { id: 36975, cityId: 970, code: "571219" },
    { id: 36976, cityId: 970, code: "571250" },
    { id: 36977, cityId: 970, code: "571264" },
    { id: 36978, cityId: 970, code: "571218" },
    { id: 36979, cityId: 970, code: "571222" },
    { id: 36980, cityId: 970, code: "571268" },
    { id: 36981, cityId: 970, code: "571273" },
    { id: 36982, cityId: 971, code: "440023" },
    { id: 36983, cityId: 971, code: "585225" },
    { id: 36984, cityId: 972, code: "585279" },
    { id: 36985, cityId: 972, code: "585284" },
    { id: 36986, cityId: 972, code: "585321" },
    { id: 36987, cityId: 972, code: "571313" },
    { id: 36988, cityId: 973, code: "560063" },
    { id: 36989, cityId: 974, code: "571442" },
    { id: 36990, cityId: 974, code: "571441" },
    { id: 36991, cityId: 974, code: "571497" },
    { id: 36992, cityId: 975, code: "583249" },
    { id: 36993, cityId: 975, code: "586135" },
    { id: 36994, cityId: 976, code: "581359" },
    { id: 36995, cityId: 978, code: "688001" },
    { id: 36996, cityId: 978, code: "688003" },
    { id: 36997, cityId: 978, code: "688006" },
    { id: 36998, cityId: 978, code: "688009" },
    { id: 36999, cityId: 978, code: "688011" },
    { id: 37000, cityId: 978, code: "688014" },
    { id: 37001, cityId: 978, code: "688501" },
    { id: 37002, cityId: 978, code: "688502" },
    { id: 37003, cityId: 978, code: "688504" },
    { id: 37004, cityId: 978, code: "688507" },
    { id: 37005, cityId: 978, code: "688512" },
    { id: 37006, cityId: 978, code: "688523" },
    { id: 37007, cityId: 978, code: "688526" },
    { id: 37008, cityId: 978, code: "688528" },
    { id: 37009, cityId: 978, code: "688530" },
    { id: 37010, cityId: 978, code: "688531" },
    { id: 37011, cityId: 978, code: "688533" },
    { id: 37012, cityId: 978, code: "688536" },
    { id: 37013, cityId: 978, code: "688538" },
    { id: 37014, cityId: 978, code: "688539" },
    { id: 37015, cityId: 978, code: "688544" },
    { id: 37016, cityId: 978, code: "688546" },
    { id: 37017, cityId: 978, code: "688547" },
    { id: 37018, cityId: 978, code: "688549" },
    { id: 37019, cityId: 978, code: "688554" },
    { id: 37020, cityId: 978, code: "688555" },
    { id: 37021, cityId: 978, code: "688557" },
    { id: 37022, cityId: 978, code: "688562" },
    { id: 37023, cityId: 978, code: "688563" },
    { id: 37024, cityId: 978, code: "688570" },
    { id: 37025, cityId: 978, code: "688581" },
    { id: 37026, cityId: 978, code: "688583" },
    { id: 37027, cityId: 978, code: "688586" },
    { id: 37028, cityId: 978, code: "689121" },
    { id: 37029, cityId: 978, code: "689124" },
    { id: 37030, cityId: 978, code: "689126" },
    { id: 37031, cityId: 978, code: "689505" },
    { id: 37032, cityId: 978, code: "689508" },
    { id: 37033, cityId: 978, code: "689510" },
    { id: 37034, cityId: 978, code: "689511" },
    { id: 37035, cityId: 978, code: "689521" },
    { id: 37036, cityId: 978, code: "689571" },
    { id: 37037, cityId: 978, code: "689572" },
    { id: 37038, cityId: 978, code: "689574" },
    { id: 37039, cityId: 978, code: "689577" },
    { id: 37040, cityId: 978, code: "689585" },
    { id: 37041, cityId: 978, code: "689590" },
    { id: 37042, cityId: 978, code: "689595" },
    { id: 37043, cityId: 978, code: "689598" },
    { id: 37044, cityId: 978, code: "689600" },
    { id: 37045, cityId: 978, code: "689622" },
    { id: 37046, cityId: 978, code: "689624" },
    { id: 37047, cityId: 978, code: "689627" },
    { id: 37048, cityId: 978, code: "689630" },
    { id: 37049, cityId: 978, code: "689722" },
    { id: 37050, cityId: 978, code: "689723" },
    { id: 37051, cityId: 978, code: "690104" },
    { id: 37052, cityId: 978, code: "690106" },
    { id: 37053, cityId: 978, code: "690107" },
    { id: 37054, cityId: 978, code: "690109" },
    { id: 37055, cityId: 978, code: "690501" },
    { id: 37056, cityId: 978, code: "690504" },
    { id: 37057, cityId: 978, code: "690506" },
    { id: 37058, cityId: 978, code: "690507" },
    { id: 37059, cityId: 978, code: "690512" },
    { id: 37060, cityId: 978, code: "690514" },
    { id: 37061, cityId: 978, code: "690515" },
    { id: 37062, cityId: 978, code: "690517" },
    { id: 37063, cityId: 978, code: "690527" },
    { id: 37064, cityId: 978, code: "690530" },
    { id: 37065, cityId: 978, code: "690533" },
    { id: 37066, cityId: 978, code: "690535" },
    { id: 37067, cityId: 978, code: "690541" },
    { id: 37068, cityId: 978, code: "690549" },
    { id: 37069, cityId: 978, code: "690551" },
    { id: 37070, cityId: 978, code: "690552" },
    { id: 37071, cityId: 978, code: "690554" },
    { id: 37072, cityId: 978, code: "690559" },
    { id: 37073, cityId: 978, code: "690560" },
    { id: 37074, cityId: 978, code: "690570" },
    { id: 37075, cityId: 978, code: "678594" },
    { id: 37076, cityId: 978, code: "688002" },
    { id: 37077, cityId: 978, code: "688004" },
    { id: 37078, cityId: 978, code: "688005" },
    { id: 37079, cityId: 978, code: "688013" },
    { id: 37080, cityId: 978, code: "688503" },
    { id: 37081, cityId: 978, code: "688505" },
    { id: 37082, cityId: 978, code: "688506" },
    { id: 37083, cityId: 978, code: "688508" },
    { id: 37084, cityId: 978, code: "688511" },
    { id: 37085, cityId: 978, code: "688521" },
    { id: 37086, cityId: 978, code: "688522" },
    { id: 37087, cityId: 978, code: "688527" },
    { id: 37088, cityId: 978, code: "688529" },
    { id: 37089, cityId: 978, code: "688532" },
    { id: 37090, cityId: 978, code: "688535" },
    { id: 37091, cityId: 978, code: "688537" },
    { id: 37092, cityId: 978, code: "688540" },
    { id: 37093, cityId: 978, code: "688542" },
    { id: 37094, cityId: 978, code: "688543" },
    { id: 37095, cityId: 978, code: "688545" },
    { id: 37096, cityId: 978, code: "688548" },
    { id: 37097, cityId: 978, code: "688550" },
    { id: 37098, cityId: 978, code: "688556" },
    { id: 37099, cityId: 978, code: "688558" },
    { id: 37100, cityId: 978, code: "688559" },
    { id: 37101, cityId: 978, code: "688561" },
    { id: 37102, cityId: 978, code: "688564" },
    { id: 37103, cityId: 978, code: "688566" },
    { id: 37104, cityId: 978, code: "688567" },
    { id: 37105, cityId: 978, code: "688582" },
    { id: 37106, cityId: 978, code: "688587" },
    { id: 37107, cityId: 978, code: "689109" },
    { id: 37108, cityId: 978, code: "689122" },
    { id: 37109, cityId: 978, code: "689123" },
    { id: 37110, cityId: 978, code: "689125" },
    { id: 37111, cityId: 978, code: "689504" },
    { id: 37112, cityId: 978, code: "689506" },
    { id: 37113, cityId: 978, code: "689509" },
    { id: 37114, cityId: 978, code: "689512" },
    { id: 37115, cityId: 978, code: "689515" },
    { id: 37116, cityId: 978, code: "689573" },
    { id: 37117, cityId: 978, code: "689575" },
    { id: 37118, cityId: 978, code: "689576" },
    { id: 37119, cityId: 978, code: "689620" },
    { id: 37120, cityId: 978, code: "689621" },
    { id: 37121, cityId: 978, code: "689623" },
    { id: 37122, cityId: 978, code: "689626" },
    { id: 37123, cityId: 978, code: "689629" },
    { id: 37124, cityId: 978, code: "689721" },
    { id: 37125, cityId: 978, code: "690102" },
    { id: 37126, cityId: 978, code: "690103" },
    { id: 37127, cityId: 978, code: "690105" },
    { id: 37128, cityId: 978, code: "690108" },
    { id: 37129, cityId: 978, code: "690110" },
    { id: 37130, cityId: 978, code: "690502" },
    { id: 37131, cityId: 978, code: "690503" },
    { id: 37132, cityId: 978, code: "690505" },
    { id: 37133, cityId: 978, code: "690508" },
    { id: 37134, cityId: 978, code: "690510" },
    { id: 37135, cityId: 978, code: "690511" },
    { id: 37136, cityId: 978, code: "690513" },
    { id: 37137, cityId: 978, code: "690516" },
    { id: 37138, cityId: 978, code: "690529" },
    { id: 37139, cityId: 978, code: "690531" },
    { id: 37140, cityId: 978, code: "690532" },
    { id: 37141, cityId: 978, code: "690534" },
    { id: 37142, cityId: 978, code: "690537" },
    { id: 37143, cityId: 978, code: "690548" },
    { id: 37144, cityId: 978, code: "690550" },
    { id: 37145, cityId: 978, code: "690555" },
    { id: 37146, cityId: 978, code: "690556" },
    { id: 37147, cityId: 978, code: "690558" },
    { id: 37148, cityId: 978, code: "690563" },
    { id: 37149, cityId: 978, code: "690566" },
    { id: 37150, cityId: 978, code: "690571" },
    { id: 37151, cityId: 978, code: "690572" },
    { id: 37152, cityId: 979, code: "688011" },
    { id: 37153, cityId: 979, code: "688012" },
    { id: 37154, cityId: 979, code: "689122" },
    { id: 37155, cityId: 979, code: "688005" },
    { id: 37156, cityId: 979, code: "688007" },
    { id: 37157, cityId: 979, code: "688506" },
    { id: 37158, cityId: 979, code: "688524" },
    { id: 37159, cityId: 980, code: "683101" },
    { id: 37160, cityId: 980, code: "683581" },
    { id: 37161, cityId: 980, code: "683574" },
    { id: 37162, cityId: 981, code: "688535" },
    { id: 37163, cityId: 982, code: "688534" },
    { id: 37164, cityId: 983, code: "695101" },
    { id: 37165, cityId: 984, code: "670009" },
    { id: 37166, cityId: 985, code: "673015" },
    { id: 37167, cityId: 986, code: "680104" },
    { id: 37168, cityId: 987, code: "670003" },
    { id: 37169, cityId: 987, code: "670005" },
    { id: 37170, cityId: 987, code: "670006" },
    { id: 37171, cityId: 987, code: "670011" },
    { id: 37172, cityId: 987, code: "670013" },
    { id: 37173, cityId: 987, code: "670016" },
    { id: 37174, cityId: 987, code: "670018" },
    { id: 37175, cityId: 987, code: "670103" },
    { id: 37176, cityId: 987, code: "670104" },
    { id: 37177, cityId: 987, code: "670109" },
    { id: 37178, cityId: 987, code: "670111" },
    { id: 37179, cityId: 987, code: "670141" },
    { id: 37180, cityId: 987, code: "670143" },
    { id: 37181, cityId: 987, code: "670302" },
    { id: 37182, cityId: 987, code: "670305" },
    { id: 37183, cityId: 987, code: "670307" },
    { id: 37184, cityId: 987, code: "670331" },
    { id: 37185, cityId: 987, code: "670334" },
    { id: 37186, cityId: 987, code: "670337" },
    { id: 37187, cityId: 987, code: "670339" },
    { id: 37188, cityId: 987, code: "670358" },
    { id: 37189, cityId: 987, code: "670501" },
    { id: 37190, cityId: 987, code: "670511" },
    { id: 37191, cityId: 987, code: "670522" },
    { id: 37192, cityId: 987, code: "670564" },
    { id: 37193, cityId: 987, code: "670591" },
    { id: 37194, cityId: 987, code: "670593" },
    { id: 37195, cityId: 987, code: "670601" },
    { id: 37196, cityId: 987, code: "670612" },
    { id: 37197, cityId: 987, code: "670614" },
    { id: 37198, cityId: 987, code: "670622" },
    { id: 37199, cityId: 987, code: "670631" },
    { id: 37200, cityId: 987, code: "670633" },
    { id: 37201, cityId: 987, code: "670641" },
    { id: 37202, cityId: 987, code: "670644" },
    { id: 37203, cityId: 987, code: "670649" },
    { id: 37204, cityId: 987, code: "670662" },
    { id: 37205, cityId: 987, code: "670673" },
    { id: 37206, cityId: 987, code: "670675" },
    { id: 37207, cityId: 987, code: "670676" },
    { id: 37208, cityId: 987, code: "670678" },
    { id: 37209, cityId: 987, code: "670691" },
    { id: 37210, cityId: 987, code: "670692" },
    { id: 37211, cityId: 987, code: "670694" },
    { id: 37212, cityId: 987, code: "670702" },
    { id: 37213, cityId: 987, code: "670704" },
    { id: 37214, cityId: 987, code: "670705" },
    { id: 37215, cityId: 987, code: "670731" },
    { id: 37216, cityId: 987, code: "673507" },
    { id: 37217, cityId: 987, code: "670002" },
    { id: 37218, cityId: 987, code: "670004" },
    { id: 37219, cityId: 987, code: "670007" },
    { id: 37220, cityId: 987, code: "670009" },
    { id: 37221, cityId: 987, code: "670012" },
    { id: 37222, cityId: 987, code: "670014" },
    { id: 37223, cityId: 987, code: "670015" },
    { id: 37224, cityId: 987, code: "670017" },
    { id: 37225, cityId: 987, code: "670102" },
    { id: 37226, cityId: 987, code: "670105" },
    { id: 37227, cityId: 987, code: "670107" },
    { id: 37228, cityId: 987, code: "670110" },
    { id: 37229, cityId: 987, code: "670142" },
    { id: 37230, cityId: 987, code: "670144" },
    { id: 37231, cityId: 987, code: "670301" },
    { id: 37232, cityId: 987, code: "670303" },
    { id: 37233, cityId: 987, code: "670306" },
    { id: 37234, cityId: 987, code: "670308" },
    { id: 37235, cityId: 987, code: "670309" },
    { id: 37236, cityId: 987, code: "670325" },
    { id: 37237, cityId: 987, code: "670327" },
    { id: 37238, cityId: 987, code: "670330" },
    { id: 37239, cityId: 987, code: "670332" },
    { id: 37240, cityId: 987, code: "670333" },
    { id: 37241, cityId: 987, code: "670338" },
    { id: 37242, cityId: 987, code: "670343" },
    { id: 37243, cityId: 987, code: "670346" },
    { id: 37244, cityId: 987, code: "670354" },
    { id: 37245, cityId: 987, code: "670502" },
    { id: 37246, cityId: 987, code: "670563" },
    { id: 37247, cityId: 987, code: "670565" },
    { id: 37248, cityId: 987, code: "670566" },
    { id: 37249, cityId: 987, code: "670571" },
    { id: 37250, cityId: 987, code: "670581" },
    { id: 37251, cityId: 987, code: "670582" },
    { id: 37252, cityId: 987, code: "670592" },
    { id: 37253, cityId: 987, code: "670595" },
    { id: 37254, cityId: 987, code: "670597" },
    { id: 37255, cityId: 987, code: "670602" },
    { id: 37256, cityId: 987, code: "670603" },
    { id: 37257, cityId: 987, code: "670611" },
    { id: 37258, cityId: 987, code: "670613" },
    { id: 37259, cityId: 987, code: "670621" },
    { id: 37260, cityId: 987, code: "670632" },
    { id: 37261, cityId: 987, code: "670643" },
    { id: 37262, cityId: 987, code: "670650" },
    { id: 37263, cityId: 987, code: "670661" },
    { id: 37264, cityId: 987, code: "670671" },
    { id: 37265, cityId: 987, code: "670672" },
    { id: 37266, cityId: 987, code: "670674" },
    { id: 37267, cityId: 987, code: "670677" },
    { id: 37268, cityId: 987, code: "670679" },
    { id: 37269, cityId: 987, code: "670693" },
    { id: 37270, cityId: 987, code: "670701" },
    { id: 37271, cityId: 987, code: "670703" },
    { id: 37272, cityId: 987, code: "670706" },
    { id: 37273, cityId: 987, code: "670741" },
    { id: 37274, cityId: 987, code: "673312" },
    { id: 37275, cityId: 987, code: "673325" },
    { id: 37276, cityId: 988, code: "686541" },
    { id: 37277, cityId: 989, code: "680506" },
    { id: 37278, cityId: 990, code: "683512" },
    { id: 37279, cityId: 991, code: "683578" },
    { id: 37280, cityId: 992, code: "689121" },
    { id: 37281, cityId: 993, code: "682034" },
    { id: 37282, cityId: 994, code: "670646" },
    { id: 37283, cityId: 994, code: "688524" },
    { id: 37284, cityId: 995, code: "670011" },
    { id: 37285, cityId: 996, code: "695605" },
    { id: 37286, cityId: 997, code: "685561" },
    { id: 37287, cityId: 997, code: "685565" },
    { id: 37288, cityId: 997, code: "685615" },
    { id: 37289, cityId: 998, code: "670106" },
    { id: 37290, cityId: 999, code: "683561" },
    { id: 37291, cityId: 1000, code: "670107" },
    { id: 37292, cityId: 1001, code: "676122" },
    { id: 37293, cityId: 1001, code: "676521" },
    { id: 37294, cityId: 1001, code: "676541" },
    { id: 37295, cityId: 1001, code: "673638" },
    { id: 37296, cityId: 1001, code: "673639" },
    { id: 37297, cityId: 1001, code: "676123" },
    { id: 37298, cityId: 1001, code: "679329" },
    { id: 37299, cityId: 1002, code: "680504" },
    { id: 37300, cityId: 1002, code: "682005" },
    { id: 37301, cityId: 1002, code: "682006" },
    { id: 37302, cityId: 1002, code: "682008" },
    { id: 37303, cityId: 1002, code: "682011" },
    { id: 37304, cityId: 1002, code: "682013" },
    { id: 37305, cityId: 1002, code: "682014" },
    { id: 37306, cityId: 1002, code: "682016" },
    { id: 37307, cityId: 1002, code: "682019" },
    { id: 37308, cityId: 1002, code: "682021" },
    { id: 37309, cityId: 1002, code: "682022" },
    { id: 37310, cityId: 1002, code: "682024" },
    { id: 37311, cityId: 1002, code: "682027" },
    { id: 37312, cityId: 1002, code: "682029" },
    { id: 37313, cityId: 1002, code: "682032" },
    { id: 37314, cityId: 1002, code: "682035" },
    { id: 37315, cityId: 1002, code: "682302" },
    { id: 37316, cityId: 1002, code: "682305" },
    { id: 37317, cityId: 1002, code: "682307" },
    { id: 37318, cityId: 1002, code: "682308" },
    { id: 37319, cityId: 1002, code: "682310" },
    { id: 37320, cityId: 1002, code: "682313" },
    { id: 37321, cityId: 1002, code: "682315" },
    { id: 37322, cityId: 1002, code: "682316" },
    { id: 37323, cityId: 1002, code: "682320" },
    { id: 37324, cityId: 1002, code: "682501" },
    { id: 37325, cityId: 1002, code: "682503" },
    { id: 37326, cityId: 1002, code: "682506" },
    { id: 37327, cityId: 1002, code: "682511" },
    { id: 37328, cityId: 1002, code: "682551" },
    { id: 37329, cityId: 1002, code: "682554" },
    { id: 37330, cityId: 1002, code: "682557" },
    { id: 37331, cityId: 1002, code: "682559" },
    { id: 37332, cityId: 1002, code: "683102" },
    { id: 37333, cityId: 1002, code: "683104" },
    { id: 37334, cityId: 1002, code: "683105" },
    { id: 37335, cityId: 1002, code: "683107" },
    { id: 37336, cityId: 1002, code: "683110" },
    { id: 37337, cityId: 1002, code: "683502" },
    { id: 37338, cityId: 1002, code: "683504" },
    { id: 37339, cityId: 1002, code: "683512" },
    { id: 37340, cityId: 1002, code: "683513" },
    { id: 37341, cityId: 1002, code: "683515" },
    { id: 37342, cityId: 1002, code: "683518" },
    { id: 37343, cityId: 1002, code: "683520" },
    { id: 37344, cityId: 1002, code: "683521" },
    { id: 37345, cityId: 1002, code: "683523" },
    { id: 37346, cityId: 1002, code: "683541" },
    { id: 37347, cityId: 1002, code: "683544" },
    { id: 37348, cityId: 1002, code: "683547" },
    { id: 37349, cityId: 1002, code: "683549" },
    { id: 37350, cityId: 1002, code: "683550" },
    { id: 37351, cityId: 1002, code: "683557" },
    { id: 37352, cityId: 1002, code: "683563" },
    { id: 37353, cityId: 1002, code: "683565" },
    { id: 37354, cityId: 1002, code: "683571" },
    { id: 37355, cityId: 1002, code: "683573" },
    { id: 37356, cityId: 1002, code: "683574" },
    { id: 37357, cityId: 1002, code: "683579" },
    { id: 37358, cityId: 1002, code: "683581" },
    { id: 37359, cityId: 1002, code: "683582" },
    { id: 37360, cityId: 1002, code: "683584" },
    { id: 37361, cityId: 1002, code: "683587" },
    { id: 37362, cityId: 1002, code: "683589" },
    { id: 37363, cityId: 1002, code: "683594" },
    { id: 37364, cityId: 1002, code: "686662" },
    { id: 37365, cityId: 1002, code: "686664" },
    { id: 37366, cityId: 1002, code: "686667" },
    { id: 37367, cityId: 1002, code: "686669" },
    { id: 37368, cityId: 1002, code: "686670" },
    { id: 37369, cityId: 1002, code: "686672" },
    { id: 37370, cityId: 1002, code: "686686" },
    { id: 37371, cityId: 1002, code: "686691" },
    { id: 37372, cityId: 1002, code: "686693" },
    { id: 37373, cityId: 1002, code: "686694" },
    { id: 37374, cityId: 1002, code: "686696" },
    { id: 37375, cityId: 1002, code: "686723" },
    { id: 37376, cityId: 1002, code: "686730" },
    { id: 37377, cityId: 1002, code: "695571" },
    { id: 37378, cityId: 1002, code: "682002" },
    { id: 37379, cityId: 1002, code: "682004" },
    { id: 37380, cityId: 1002, code: "682007" },
    { id: 37381, cityId: 1002, code: "682009" },
    { id: 37382, cityId: 1002, code: "682012" },
    { id: 37383, cityId: 1002, code: "682015" },
    { id: 37384, cityId: 1002, code: "682017" },
    { id: 37385, cityId: 1002, code: "682020" },
    { id: 37386, cityId: 1002, code: "682023" },
    { id: 37387, cityId: 1002, code: "682025" },
    { id: 37388, cityId: 1002, code: "682026" },
    { id: 37389, cityId: 1002, code: "682028" },
    { id: 37390, cityId: 1002, code: "682030" },
    { id: 37391, cityId: 1002, code: "682031" },
    { id: 37392, cityId: 1002, code: "682036" },
    { id: 37393, cityId: 1002, code: "682301" },
    { id: 37394, cityId: 1002, code: "682303" },
    { id: 37395, cityId: 1002, code: "682304" },
    { id: 37396, cityId: 1002, code: "682309" },
    { id: 37397, cityId: 1002, code: "682311" },
    { id: 37398, cityId: 1002, code: "682312" },
    { id: 37399, cityId: 1002, code: "682314" },
    { id: 37400, cityId: 1002, code: "682317" },
    { id: 37401, cityId: 1002, code: "682319" },
    { id: 37402, cityId: 1002, code: "682502" },
    { id: 37403, cityId: 1002, code: "682505" },
    { id: 37404, cityId: 1002, code: "682507" },
    { id: 37405, cityId: 1002, code: "682508" },
    { id: 37406, cityId: 1002, code: "682510" },
    { id: 37407, cityId: 1002, code: "682552" },
    { id: 37408, cityId: 1002, code: "682553" },
    { id: 37409, cityId: 1002, code: "682555" },
    { id: 37410, cityId: 1002, code: "682558" },
    { id: 37411, cityId: 1002, code: "683103" },
    { id: 37412, cityId: 1002, code: "683106" },
    { id: 37413, cityId: 1002, code: "683108" },
    { id: 37414, cityId: 1002, code: "683109" },
    { id: 37415, cityId: 1002, code: "683111" },
    { id: 37416, cityId: 1002, code: "683501" },
    { id: 37417, cityId: 1002, code: "683503" },
    { id: 37418, cityId: 1002, code: "683511" },
    { id: 37419, cityId: 1002, code: "683514" },
    { id: 37420, cityId: 1002, code: "683516" },
    { id: 37421, cityId: 1002, code: "683517" },
    { id: 37422, cityId: 1002, code: "683519" },
    { id: 37423, cityId: 1002, code: "683522" },
    { id: 37424, cityId: 1002, code: "683524" },
    { id: 37425, cityId: 1002, code: "683525" },
    { id: 37426, cityId: 1002, code: "683543" },
    { id: 37427, cityId: 1002, code: "683545" },
    { id: 37428, cityId: 1002, code: "683546" },
    { id: 37429, cityId: 1002, code: "683548" },
    { id: 37430, cityId: 1002, code: "683553" },
    { id: 37431, cityId: 1002, code: "683556" },
    { id: 37432, cityId: 1002, code: "683561" },
    { id: 37433, cityId: 1002, code: "683562" },
    { id: 37434, cityId: 1002, code: "683564" },
    { id: 37435, cityId: 1002, code: "683572" },
    { id: 37436, cityId: 1002, code: "683575" },
    { id: 37437, cityId: 1002, code: "683577" },
    { id: 37438, cityId: 1002, code: "683578" },
    { id: 37439, cityId: 1002, code: "683580" },
    { id: 37440, cityId: 1002, code: "683583" },
    { id: 37441, cityId: 1002, code: "683585" },
    { id: 37442, cityId: 1002, code: "683593" },
    { id: 37443, cityId: 1002, code: "686663" },
    { id: 37444, cityId: 1002, code: "686665" },
    { id: 37445, cityId: 1002, code: "686666" },
    { id: 37446, cityId: 1002, code: "686668" },
    { id: 37447, cityId: 1002, code: "686671" },
    { id: 37448, cityId: 1002, code: "686673" },
    { id: 37449, cityId: 1002, code: "686674" },
    { id: 37450, cityId: 1002, code: "686676" },
    { id: 37451, cityId: 1002, code: "686679" },
    { id: 37452, cityId: 1002, code: "686681" },
    { id: 37453, cityId: 1002, code: "686687" },
    { id: 37454, cityId: 1002, code: "686689" },
    { id: 37455, cityId: 1002, code: "686692" },
    { id: 37456, cityId: 1002, code: "686695" },
    { id: 37457, cityId: 1002, code: "686697" },
    { id: 37458, cityId: 1002, code: "686698" },
    { id: 37459, cityId: 1002, code: "686721" },
    { id: 37460, cityId: 1002, code: "686726" },
    { id: 37461, cityId: 1003, code: "670581" },
    { id: 37462, cityId: 1003, code: "671310" },
    { id: 37463, cityId: 1003, code: "670511" },
    { id: 37464, cityId: 1003, code: "670644" },
    { id: 37465, cityId: 1003, code: "671313" },
    { id: 37466, cityId: 1003, code: "671314" },
    { id: 37467, cityId: 1003, code: "671316" },
    { id: 37468, cityId: 1003, code: "671531" },
    { id: 37469, cityId: 1003, code: "671533" },
    { id: 37470, cityId: 1004, code: "685502" },
    { id: 37471, cityId: 1004, code: "685505" },
    { id: 37472, cityId: 1004, code: "685507" },
    { id: 37473, cityId: 1004, code: "685508" },
    { id: 37474, cityId: 1004, code: "685510" },
    { id: 37475, cityId: 1004, code: "685515" },
    { id: 37476, cityId: 1004, code: "685531" },
    { id: 37477, cityId: 1004, code: "685532" },
    { id: 37478, cityId: 1004, code: "685536" },
    { id: 37479, cityId: 1004, code: "685537" },
    { id: 37480, cityId: 1004, code: "685539" },
    { id: 37481, cityId: 1004, code: "685552" },
    { id: 37482, cityId: 1004, code: "685553" },
    { id: 37483, cityId: 1004, code: "685561" },
    { id: 37484, cityId: 1004, code: "685563" },
    { id: 37485, cityId: 1004, code: "685566" },
    { id: 37486, cityId: 1004, code: "685569" },
    { id: 37487, cityId: 1004, code: "685571" },
    { id: 37488, cityId: 1004, code: "685581" },
    { id: 37489, cityId: 1004, code: "685584" },
    { id: 37490, cityId: 1004, code: "685587" },
    { id: 37491, cityId: 1004, code: "685589" },
    { id: 37492, cityId: 1004, code: "685590" },
    { id: 37493, cityId: 1004, code: "685592" },
    { id: 37494, cityId: 1004, code: "685595" },
    { id: 37495, cityId: 1004, code: "685597" },
    { id: 37496, cityId: 1004, code: "685603" },
    { id: 37497, cityId: 1004, code: "685605" },
    { id: 37498, cityId: 1004, code: "685611" },
    { id: 37499, cityId: 1004, code: "685613" },
    { id: 37500, cityId: 1004, code: "685614" },
    { id: 37501, cityId: 1004, code: "685616" },
    { id: 37502, cityId: 1004, code: "685619" },
    { id: 37503, cityId: 1004, code: "685621" },
    { id: 37504, cityId: 1004, code: "686694" },
    { id: 37505, cityId: 1004, code: "685005" },
    { id: 37506, cityId: 1004, code: "685501" },
    { id: 37507, cityId: 1004, code: "685503" },
    { id: 37508, cityId: 1004, code: "685504" },
    { id: 37509, cityId: 1004, code: "685506" },
    { id: 37510, cityId: 1004, code: "685509" },
    { id: 37511, cityId: 1004, code: "685511" },
    { id: 37512, cityId: 1004, code: "685512" },
    { id: 37513, cityId: 1004, code: "685533" },
    { id: 37514, cityId: 1004, code: "685535" },
    { id: 37515, cityId: 1004, code: "685538" },
    { id: 37516, cityId: 1004, code: "685551" },
    { id: 37517, cityId: 1004, code: "685554" },
    { id: 37518, cityId: 1004, code: "685556" },
    { id: 37519, cityId: 1004, code: "685557" },
    { id: 37520, cityId: 1004, code: "685562" },
    { id: 37521, cityId: 1004, code: "685564" },
    { id: 37522, cityId: 1004, code: "685565" },
    { id: 37523, cityId: 1004, code: "685583" },
    { id: 37524, cityId: 1004, code: "685585" },
    { id: 37525, cityId: 1004, code: "685586" },
    { id: 37526, cityId: 1004, code: "685588" },
    { id: 37527, cityId: 1004, code: "685591" },
    { id: 37528, cityId: 1004, code: "685601" },
    { id: 37529, cityId: 1004, code: "685602" },
    { id: 37530, cityId: 1004, code: "685604" },
    { id: 37531, cityId: 1004, code: "685612" },
    { id: 37532, cityId: 1004, code: "685615" },
    { id: 37533, cityId: 1004, code: "685617" },
    { id: 37534, cityId: 1004, code: "685618" },
    { id: 37535, cityId: 1004, code: "685620" },
    { id: 37536, cityId: 1005, code: "680121" },
    { id: 37537, cityId: 1006, code: "670621" },
    { id: 37538, cityId: 1007, code: "605802" },
    { id: 37539, cityId: 1007, code: "679515" },
    { id: 37540, cityId: 1007, code: "670663" },
    { id: 37541, cityId: 1008, code: "670562" },
    { id: 37542, cityId: 1009, code: "673121" },
    { id: 37543, cityId: 1010, code: "682506" },
    { id: 37544, cityId: 1011, code: "671315" },
    { id: 37545, cityId: 1012, code: "670592" },
    { id: 37546, cityId: 1013, code: "686543" },
    { id: 37547, cityId: 1014, code: "670604" },
    { id: 37548, cityId: 1015, code: "571804" },
    { id: 37549, cityId: 1015, code: "574193" },
    { id: 37550, cityId: 1015, code: "586119" },
    { id: 37551, cityId: 1015, code: "670001" },
    { id: 37552, cityId: 1015, code: "670306" },
    { id: 37553, cityId: 1015, code: "671321" },
    { id: 37554, cityId: 1016, code: "691523" },
    { id: 37555, cityId: 1017, code: "671121" },
    { id: 37556, cityId: 1017, code: "671124" },
    { id: 37557, cityId: 1017, code: "671322" },
    { id: 37558, cityId: 1017, code: "671552" },
    { id: 37559, cityId: 1017, code: "671321" },
    { id: 37560, cityId: 1017, code: "671323" },
    { id: 37561, cityId: 1017, code: "671324" },
    { id: 37562, cityId: 1017, code: "671541" },
    { id: 37563, cityId: 1017, code: "671543" },
    { id: 37564, cityId: 1017, code: "695323" },
    { id: 37565, cityId: 1018, code: "671121" },
    { id: 37566, cityId: 1018, code: "671124" },
    { id: 37567, cityId: 1018, code: "671312" },
    { id: 37568, cityId: 1018, code: "671314" },
    { id: 37569, cityId: 1018, code: "671315" },
    { id: 37570, cityId: 1018, code: "671317" },
    { id: 37571, cityId: 1018, code: "671320" },
    { id: 37572, cityId: 1018, code: "671322" },
    { id: 37573, cityId: 1018, code: "671323" },
    { id: 37574, cityId: 1018, code: "671328" },
    { id: 37575, cityId: 1018, code: "671341" },
    { id: 37576, cityId: 1018, code: "671344" },
    { id: 37577, cityId: 1018, code: "671349" },
    { id: 37578, cityId: 1018, code: "671351" },
    { id: 37579, cityId: 1018, code: "671357" },
    { id: 37580, cityId: 1018, code: "671532" },
    { id: 37581, cityId: 1018, code: "671535" },
    { id: 37582, cityId: 1018, code: "671542" },
    { id: 37583, cityId: 1018, code: "671545" },
    { id: 37584, cityId: 1018, code: "671122" },
    { id: 37585, cityId: 1018, code: "671123" },
    { id: 37586, cityId: 1018, code: "671125" },
    { id: 37587, cityId: 1018, code: "671128" },
    { id: 37588, cityId: 1018, code: "671310" },
    { id: 37589, cityId: 1018, code: "671311" },
    { id: 37590, cityId: 1018, code: "671313" },
    { id: 37591, cityId: 1018, code: "671316" },
    { id: 37592, cityId: 1018, code: "671318" },
    { id: 37593, cityId: 1018, code: "671319" },
    { id: 37594, cityId: 1018, code: "671321" },
    { id: 37595, cityId: 1018, code: "671324" },
    { id: 37596, cityId: 1018, code: "671326" },
    { id: 37597, cityId: 1018, code: "671329" },
    { id: 37598, cityId: 1018, code: "671345" },
    { id: 37599, cityId: 1018, code: "671350" },
    { id: 37600, cityId: 1018, code: "671531" },
    { id: 37601, cityId: 1018, code: "671533" },
    { id: 37602, cityId: 1018, code: "671541" },
    { id: 37603, cityId: 1018, code: "671543" },
    { id: 37604, cityId: 1018, code: "671544" },
    { id: 37605, cityId: 1018, code: "671551" },
    { id: 37606, cityId: 1018, code: "671552" },
    { id: 37607, cityId: 1019, code: "690502" },
    { id: 37608, cityId: 1020, code: "682508" },
    { id: 37609, cityId: 1020, code: "682001" },
    { id: 37610, cityId: 1021, code: "680664" },
    { id: 37611, cityId: 1022, code: "690102" },
    { id: 37612, cityId: 1022, code: "690518" },
    { id: 37613, cityId: 1022, code: "690521" },
    { id: 37614, cityId: 1022, code: "690523" },
    { id: 37615, cityId: 1022, code: "690524" },
    { id: 37616, cityId: 1022, code: "690526" },
    { id: 37617, cityId: 1022, code: "690536" },
    { id: 37618, cityId: 1022, code: "690539" },
    { id: 37619, cityId: 1022, code: "690542" },
    { id: 37620, cityId: 1022, code: "690544" },
    { id: 37621, cityId: 1022, code: "690547" },
    { id: 37622, cityId: 1022, code: "690568" },
    { id: 37623, cityId: 1022, code: "690574" },
    { id: 37624, cityId: 1022, code: "691003" },
    { id: 37625, cityId: 1022, code: "691005" },
    { id: 37626, cityId: 1022, code: "691006" },
    { id: 37627, cityId: 1022, code: "691008" },
    { id: 37628, cityId: 1022, code: "691013" },
    { id: 37629, cityId: 1022, code: "691014" },
    { id: 37630, cityId: 1022, code: "691018" },
    { id: 37631, cityId: 1022, code: "691019" },
    { id: 37632, cityId: 1022, code: "691021" },
    { id: 37633, cityId: 1022, code: "691302" },
    { id: 37634, cityId: 1022, code: "691305" },
    { id: 37635, cityId: 1022, code: "691307" },
    { id: 37636, cityId: 1022, code: "691310" },
    { id: 37637, cityId: 1022, code: "691312" },
    { id: 37638, cityId: 1022, code: "691315" },
    { id: 37639, cityId: 1022, code: "691326" },
    { id: 37640, cityId: 1022, code: "691329" },
    { id: 37641, cityId: 1022, code: "691331" },
    { id: 37642, cityId: 1022, code: "691334" },
    { id: 37643, cityId: 1022, code: "691501" },
    { id: 37644, cityId: 1022, code: "691503" },
    { id: 37645, cityId: 1022, code: "691506" },
    { id: 37646, cityId: 1022, code: "691508" },
    { id: 37647, cityId: 1022, code: "691509" },
    { id: 37648, cityId: 1022, code: "691511" },
    { id: 37649, cityId: 1022, code: "691516" },
    { id: 37650, cityId: 1022, code: "691517" },
    { id: 37651, cityId: 1022, code: "691522" },
    { id: 37652, cityId: 1022, code: "691524" },
    { id: 37653, cityId: 1022, code: "691530" },
    { id: 37654, cityId: 1022, code: "691532" },
    { id: 37655, cityId: 1022, code: "691535" },
    { id: 37656, cityId: 1022, code: "691538" },
    { id: 37657, cityId: 1022, code: "691540" },
    { id: 37658, cityId: 1022, code: "691541" },
    { id: 37659, cityId: 1022, code: "691543" },
    { id: 37660, cityId: 1022, code: "691546" },
    { id: 37661, cityId: 1022, code: "691548" },
    { id: 37662, cityId: 1022, code: "691559" },
    { id: 37663, cityId: 1022, code: "691572" },
    { id: 37664, cityId: 1022, code: "691577" },
    { id: 37665, cityId: 1022, code: "691578" },
    { id: 37666, cityId: 1022, code: "691580" },
    { id: 37667, cityId: 1022, code: "691583" },
    { id: 37668, cityId: 1022, code: "691585" },
    { id: 37669, cityId: 1022, code: "691588" },
    { id: 37670, cityId: 1022, code: "691601" },
    { id: 37671, cityId: 1022, code: "691604" },
    { id: 37672, cityId: 1022, code: "691623" },
    { id: 37673, cityId: 1022, code: "691625" },
    { id: 37674, cityId: 1022, code: "695306" },
    { id: 37675, cityId: 1022, code: "689706" },
    { id: 37676, cityId: 1022, code: "690101" },
    { id: 37677, cityId: 1022, code: "690519" },
    { id: 37678, cityId: 1022, code: "690520" },
    { id: 37679, cityId: 1022, code: "690525" },
    { id: 37680, cityId: 1022, code: "690528" },
    { id: 37681, cityId: 1022, code: "690538" },
    { id: 37682, cityId: 1022, code: "690543" },
    { id: 37683, cityId: 1022, code: "690546" },
    { id: 37684, cityId: 1022, code: "690567" },
    { id: 37685, cityId: 1022, code: "690573" },
    { id: 37686, cityId: 1022, code: "691001" },
    { id: 37687, cityId: 1022, code: "691002" },
    { id: 37688, cityId: 1022, code: "691007" },
    { id: 37689, cityId: 1022, code: "691009" },
    { id: 37690, cityId: 1022, code: "691010" },
    { id: 37691, cityId: 1022, code: "691012" },
    { id: 37692, cityId: 1022, code: "691015" },
    { id: 37693, cityId: 1022, code: "691017" },
    { id: 37694, cityId: 1022, code: "691020" },
    { id: 37695, cityId: 1022, code: "691301" },
    { id: 37696, cityId: 1022, code: "691303" },
    { id: 37697, cityId: 1022, code: "691304" },
    { id: 37698, cityId: 1022, code: "691306" },
    { id: 37699, cityId: 1022, code: "691308" },
    { id: 37700, cityId: 1022, code: "691309" },
    { id: 37701, cityId: 1022, code: "691311" },
    { id: 37702, cityId: 1022, code: "691314" },
    { id: 37703, cityId: 1022, code: "691316" },
    { id: 37704, cityId: 1022, code: "691317" },
    { id: 37705, cityId: 1022, code: "691319" },
    { id: 37706, cityId: 1022, code: "691322" },
    { id: 37707, cityId: 1022, code: "691324" },
    { id: 37708, cityId: 1022, code: "691332" },
    { id: 37709, cityId: 1022, code: "691333" },
    { id: 37710, cityId: 1022, code: "691500" },
    { id: 37711, cityId: 1022, code: "691502" },
    { id: 37712, cityId: 1022, code: "691504" },
    { id: 37713, cityId: 1022, code: "691505" },
    { id: 37714, cityId: 1022, code: "691507" },
    { id: 37715, cityId: 1022, code: "691510" },
    { id: 37716, cityId: 1022, code: "691512" },
    { id: 37717, cityId: 1022, code: "691513" },
    { id: 37718, cityId: 1022, code: "691515" },
    { id: 37719, cityId: 1022, code: "691518" },
    { id: 37720, cityId: 1022, code: "691521" },
    { id: 37721, cityId: 1022, code: "691523" },
    { id: 37722, cityId: 1022, code: "691529" },
    { id: 37723, cityId: 1022, code: "691531" },
    { id: 37724, cityId: 1022, code: "691534" },
    { id: 37725, cityId: 1022, code: "691536" },
    { id: 37726, cityId: 1022, code: "691537" },
    { id: 37727, cityId: 1022, code: "691539" },
    { id: 37728, cityId: 1022, code: "691542" },
    { id: 37729, cityId: 1022, code: "691544" },
    { id: 37730, cityId: 1022, code: "691545" },
    { id: 37731, cityId: 1022, code: "691547" },
    { id: 37732, cityId: 1022, code: "691557" },
    { id: 37733, cityId: 1022, code: "691560" },
    { id: 37734, cityId: 1022, code: "691571" },
    { id: 37735, cityId: 1022, code: "691573" },
    { id: 37736, cityId: 1022, code: "691574" },
    { id: 37737, cityId: 1022, code: "691576" },
    { id: 37738, cityId: 1022, code: "691579" },
    { id: 37739, cityId: 1022, code: "691581" },
    { id: 37740, cityId: 1022, code: "691582" },
    { id: 37741, cityId: 1022, code: "691584" },
    { id: 37742, cityId: 1022, code: "691589" },
    { id: 37743, cityId: 1022, code: "691590" },
    { id: 37744, cityId: 1022, code: "691602" },
    { id: 37745, cityId: 1022, code: "691603" },
    { id: 37746, cityId: 1022, code: "691624" },
    { id: 37747, cityId: 1023, code: "686691" },
    { id: 37748, cityId: 1024, code: "689694" },
    { id: 37749, cityId: 1024, code: "691536" },
    { id: 37750, cityId: 1025, code: "686001" },
    { id: 37751, cityId: 1025, code: "686002" },
    { id: 37752, cityId: 1025, code: "686004" },
    { id: 37753, cityId: 1025, code: "686007" },
    { id: 37754, cityId: 1025, code: "686009" },
    { id: 37755, cityId: 1025, code: "686010" },
    { id: 37756, cityId: 1025, code: "686012" },
    { id: 37757, cityId: 1025, code: "686015" },
    { id: 37758, cityId: 1025, code: "686017" },
    { id: 37759, cityId: 1025, code: "686018" },
    { id: 37760, cityId: 1025, code: "686020" },
    { id: 37761, cityId: 1025, code: "686023" },
    { id: 37762, cityId: 1025, code: "686025" },
    { id: 37763, cityId: 1025, code: "686026" },
    { id: 37764, cityId: 1025, code: "686034" },
    { id: 37765, cityId: 1025, code: "686036" },
    { id: 37766, cityId: 1025, code: "686041" },
    { id: 37767, cityId: 1025, code: "686102" },
    { id: 37768, cityId: 1025, code: "686105" },
    { id: 37769, cityId: 1025, code: "686123" },
    { id: 37770, cityId: 1025, code: "686124" },
    { id: 37771, cityId: 1025, code: "686142" },
    { id: 37772, cityId: 1025, code: "686145" },
    { id: 37773, cityId: 1025, code: "686502" },
    { id: 37774, cityId: 1025, code: "686505" },
    { id: 37775, cityId: 1025, code: "686507" },
    { id: 37776, cityId: 1025, code: "686508" },
    { id: 37777, cityId: 1025, code: "686510" },
    { id: 37778, cityId: 1025, code: "686513" },
    { id: 37779, cityId: 1025, code: "686515" },
    { id: 37780, cityId: 1025, code: "686516" },
    { id: 37781, cityId: 1025, code: "686518" },
    { id: 37782, cityId: 1025, code: "686521" },
    { id: 37783, cityId: 1025, code: "686523" },
    { id: 37784, cityId: 1025, code: "686524" },
    { id: 37785, cityId: 1025, code: "686529" },
    { id: 37786, cityId: 1025, code: "686531" },
    { id: 37787, cityId: 1025, code: "686532" },
    { id: 37788, cityId: 1025, code: "686534" },
    { id: 37789, cityId: 1025, code: "686536" },
    { id: 37790, cityId: 1025, code: "686537" },
    { id: 37791, cityId: 1025, code: "686539" },
    { id: 37792, cityId: 1025, code: "686542" },
    { id: 37793, cityId: 1025, code: "686544" },
    { id: 37794, cityId: 1025, code: "686545" },
    { id: 37795, cityId: 1025, code: "686547" },
    { id: 37796, cityId: 1025, code: "686550" },
    { id: 37797, cityId: 1025, code: "686552" },
    { id: 37798, cityId: 1025, code: "686553" },
    { id: 37799, cityId: 1025, code: "686555" },
    { id: 37800, cityId: 1025, code: "686560" },
    { id: 37801, cityId: 1025, code: "686561" },
    { id: 37802, cityId: 1025, code: "686563" },
    { id: 37803, cityId: 1025, code: "686566" },
    { id: 37804, cityId: 1025, code: "686568" },
    { id: 37805, cityId: 1025, code: "686571" },
    { id: 37806, cityId: 1025, code: "686574" },
    { id: 37807, cityId: 1025, code: "686576" },
    { id: 37808, cityId: 1025, code: "686577" },
    { id: 37809, cityId: 1025, code: "686579" },
    { id: 37810, cityId: 1025, code: "686582" },
    { id: 37811, cityId: 1025, code: "686584" },
    { id: 37812, cityId: 1025, code: "686587" },
    { id: 37813, cityId: 1025, code: "686589" },
    { id: 37814, cityId: 1025, code: "686590" },
    { id: 37815, cityId: 1025, code: "686592" },
    { id: 37816, cityId: 1025, code: "686595" },
    { id: 37817, cityId: 1025, code: "686597" },
    { id: 37818, cityId: 1025, code: "686600" },
    { id: 37819, cityId: 1025, code: "686603" },
    { id: 37820, cityId: 1025, code: "686605" },
    { id: 37821, cityId: 1025, code: "686606" },
    { id: 37822, cityId: 1025, code: "686608" },
    { id: 37823, cityId: 1025, code: "686611" },
    { id: 37824, cityId: 1025, code: "686613" },
    { id: 37825, cityId: 1025, code: "686616" },
    { id: 37826, cityId: 1025, code: "686632" },
    { id: 37827, cityId: 1025, code: "686634" },
    { id: 37828, cityId: 1025, code: "686635" },
    { id: 37829, cityId: 1025, code: "686640" },
    { id: 37830, cityId: 1025, code: "686642" },
    { id: 37831, cityId: 1025, code: "686651" },
    { id: 37832, cityId: 1025, code: "686653" },
    { id: 37833, cityId: 1025, code: "680724" },
    { id: 37834, cityId: 1025, code: "686003" },
    { id: 37835, cityId: 1025, code: "686006" },
    { id: 37836, cityId: 1025, code: "686008" },
    { id: 37837, cityId: 1025, code: "686011" },
    { id: 37838, cityId: 1025, code: "686014" },
    { id: 37839, cityId: 1025, code: "686016" },
    { id: 37840, cityId: 1025, code: "686019" },
    { id: 37841, cityId: 1025, code: "686024" },
    { id: 37842, cityId: 1025, code: "686029" },
    { id: 37843, cityId: 1025, code: "686030" },
    { id: 37844, cityId: 1025, code: "686032" },
    { id: 37845, cityId: 1025, code: "686035" },
    { id: 37846, cityId: 1025, code: "686037" },
    { id: 37847, cityId: 1025, code: "686038" },
    { id: 37848, cityId: 1025, code: "686103" },
    { id: 37849, cityId: 1025, code: "686104" },
    { id: 37850, cityId: 1025, code: "686106" },
    { id: 37851, cityId: 1025, code: "686122" },
    { id: 37852, cityId: 1025, code: "686143" },
    { id: 37853, cityId: 1025, code: "686144" },
    { id: 37854, cityId: 1025, code: "686501" },
    { id: 37855, cityId: 1025, code: "686503" },
    { id: 37856, cityId: 1025, code: "686504" },
    { id: 37857, cityId: 1025, code: "686506" },
    { id: 37858, cityId: 1025, code: "686509" },
    { id: 37859, cityId: 1025, code: "686511" },
    { id: 37860, cityId: 1025, code: "686512" },
    { id: 37861, cityId: 1025, code: "686514" },
    { id: 37862, cityId: 1025, code: "686517" },
    { id: 37863, cityId: 1025, code: "686519" },
    { id: 37864, cityId: 1025, code: "686520" },
    { id: 37865, cityId: 1025, code: "686522" },
    { id: 37866, cityId: 1025, code: "686527" },
    { id: 37867, cityId: 1025, code: "686533" },
    { id: 37868, cityId: 1025, code: "686535" },
    { id: 37869, cityId: 1025, code: "686538" },
    { id: 37870, cityId: 1025, code: "686540" },
    { id: 37871, cityId: 1025, code: "686541" },
    { id: 37872, cityId: 1025, code: "686546" },
    { id: 37873, cityId: 1025, code: "686548" },
    { id: 37874, cityId: 1025, code: "686549" },
    { id: 37875, cityId: 1025, code: "686562" },
    { id: 37876, cityId: 1025, code: "686564" },
    { id: 37877, cityId: 1025, code: "686572" },
    { id: 37878, cityId: 1025, code: "686573" },
    { id: 37879, cityId: 1025, code: "686578" },
    { id: 37880, cityId: 1025, code: "686580" },
    { id: 37881, cityId: 1025, code: "686581" },
    { id: 37882, cityId: 1025, code: "686583" },
    { id: 37883, cityId: 1025, code: "686585" },
    { id: 37884, cityId: 1025, code: "686586" },
    { id: 37885, cityId: 1025, code: "686588" },
    { id: 37886, cityId: 1025, code: "686591" },
    { id: 37887, cityId: 1025, code: "686594" },
    { id: 37888, cityId: 1025, code: "686596" },
    { id: 37889, cityId: 1025, code: "686601" },
    { id: 37890, cityId: 1025, code: "686602" },
    { id: 37891, cityId: 1025, code: "686604" },
    { id: 37892, cityId: 1025, code: "686607" },
    { id: 37893, cityId: 1025, code: "686609" },
    { id: 37894, cityId: 1025, code: "686610" },
    { id: 37895, cityId: 1025, code: "686612" },
    { id: 37896, cityId: 1025, code: "686615" },
    { id: 37897, cityId: 1025, code: "686617" },
    { id: 37898, cityId: 1025, code: "686620" },
    { id: 37899, cityId: 1025, code: "686631" },
    { id: 37900, cityId: 1025, code: "686633" },
    { id: 37901, cityId: 1025, code: "686636" },
    { id: 37902, cityId: 1025, code: "686638" },
    { id: 37903, cityId: 1025, code: "686641" },
    { id: 37904, cityId: 1025, code: "686652" },
    { id: 37905, cityId: 1025, code: "686654" },
    { id: 37906, cityId: 1025, code: "686655" },
    { id: 37907, cityId: 1025, code: "695601" },
    { id: 37908, cityId: 1026, code: "689691" },
    { id: 37909, cityId: 1027, code: "673002" },
    { id: 37910, cityId: 1027, code: "673004" },
    { id: 37911, cityId: 1027, code: "673005" },
    { id: 37912, cityId: 1027, code: "673007" },
    { id: 37913, cityId: 1027, code: "673010" },
    { id: 37914, cityId: 1027, code: "673012" },
    { id: 37915, cityId: 1027, code: "673013" },
    { id: 37916, cityId: 1027, code: "673015" },
    { id: 37917, cityId: 1027, code: "673018" },
    { id: 37918, cityId: 1027, code: "673020" },
    { id: 37919, cityId: 1027, code: "673021" },
    { id: 37920, cityId: 1027, code: "673023" },
    { id: 37921, cityId: 1027, code: "673026" },
    { id: 37922, cityId: 1027, code: "673028" },
    { id: 37923, cityId: 1027, code: "673029" },
    { id: 37924, cityId: 1027, code: "673102" },
    { id: 37925, cityId: 1027, code: "673103" },
    { id: 37926, cityId: 1027, code: "673105" },
    { id: 37927, cityId: 1027, code: "673108" },
    { id: 37928, cityId: 1027, code: "673110" },
    { id: 37929, cityId: 1027, code: "673301" },
    { id: 37930, cityId: 1027, code: "673304" },
    { id: 37931, cityId: 1027, code: "673306" },
    { id: 37932, cityId: 1027, code: "673307" },
    { id: 37933, cityId: 1027, code: "673309" },
    { id: 37934, cityId: 1027, code: "673314" },
    { id: 37935, cityId: 1027, code: "673315" },
    { id: 37936, cityId: 1027, code: "673317" },
    { id: 37937, cityId: 1027, code: "673320" },
    { id: 37938, cityId: 1027, code: "673322" },
    { id: 37939, cityId: 1027, code: "673323" },
    { id: 37940, cityId: 1027, code: "673328" },
    { id: 37941, cityId: 1027, code: "673330" },
    { id: 37942, cityId: 1027, code: "673333" },
    { id: 37943, cityId: 1027, code: "673502" },
    { id: 37944, cityId: 1027, code: "673503" },
    { id: 37945, cityId: 1027, code: "673505" },
    { id: 37946, cityId: 1027, code: "673508" },
    { id: 37947, cityId: 1027, code: "673510" },
    { id: 37948, cityId: 1027, code: "673511" },
    { id: 37949, cityId: 1027, code: "673513" },
    { id: 37950, cityId: 1027, code: "673518" },
    { id: 37951, cityId: 1027, code: "673519" },
    { id: 37952, cityId: 1027, code: "673521" },
    { id: 37953, cityId: 1027, code: "673524" },
    { id: 37954, cityId: 1027, code: "673526" },
    { id: 37955, cityId: 1027, code: "673527" },
    { id: 37956, cityId: 1027, code: "673529" },
    { id: 37957, cityId: 1027, code: "673531" },
    { id: 37958, cityId: 1027, code: "673532" },
    { id: 37959, cityId: 1027, code: "673534" },
    { id: 37960, cityId: 1027, code: "673542" },
    { id: 37961, cityId: 1027, code: "673571" },
    { id: 37962, cityId: 1027, code: "673572" },
    { id: 37963, cityId: 1027, code: "673574" },
    { id: 37964, cityId: 1027, code: "673585" },
    { id: 37965, cityId: 1027, code: "673587" },
    { id: 37966, cityId: 1027, code: "673593" },
    { id: 37967, cityId: 1027, code: "673601" },
    { id: 37968, cityId: 1027, code: "673611" },
    { id: 37969, cityId: 1027, code: "673614" },
    { id: 37970, cityId: 1027, code: "673616" },
    { id: 37971, cityId: 1027, code: "673617" },
    { id: 37972, cityId: 1027, code: "673619" },
    { id: 37973, cityId: 1027, code: "673624" },
    { id: 37974, cityId: 1027, code: "673632" },
    { id: 37975, cityId: 1027, code: "673635" },
    { id: 37976, cityId: 1027, code: "673643" },
    { id: 37977, cityId: 1027, code: "673654" },
    { id: 37978, cityId: 1027, code: "673661" },
    { id: 37979, cityId: 1027, code: "678687" },
    { id: 37980, cityId: 1027, code: "686612" },
    { id: 37981, cityId: 1027, code: "673001" },
    { id: 37982, cityId: 1027, code: "673003" },
    { id: 37983, cityId: 1027, code: "673006" },
    { id: 37984, cityId: 1027, code: "673008" },
    { id: 37985, cityId: 1027, code: "673009" },
    { id: 37986, cityId: 1027, code: "673011" },
    { id: 37987, cityId: 1027, code: "673014" },
    { id: 37988, cityId: 1027, code: "673016" },
    { id: 37989, cityId: 1027, code: "673017" },
    { id: 37990, cityId: 1027, code: "673019" },
    { id: 37991, cityId: 1027, code: "673024" },
    { id: 37992, cityId: 1027, code: "673027" },
    { id: 37993, cityId: 1027, code: "673032" },
    { id: 37994, cityId: 1027, code: "673104" },
    { id: 37995, cityId: 1027, code: "673106" },
    { id: 37996, cityId: 1027, code: "673107" },
    { id: 37997, cityId: 1027, code: "673109" },
    { id: 37998, cityId: 1027, code: "673112" },
    { id: 37999, cityId: 1027, code: "673302" },
    { id: 38000, cityId: 1027, code: "673303" },
    { id: 38001, cityId: 1027, code: "673308" },
    { id: 38002, cityId: 1027, code: "673310" },
    { id: 38003, cityId: 1027, code: "673313" },
    { id: 38004, cityId: 1027, code: "673316" },
    { id: 38005, cityId: 1027, code: "673318" },
    { id: 38006, cityId: 1027, code: "673319" },
    { id: 38007, cityId: 1027, code: "673321" },
    { id: 38008, cityId: 1027, code: "673324" },
    { id: 38009, cityId: 1027, code: "673326" },
    { id: 38010, cityId: 1027, code: "673327" },
    { id: 38011, cityId: 1027, code: "673501" },
    { id: 38012, cityId: 1027, code: "673504" },
    { id: 38013, cityId: 1027, code: "673506" },
    { id: 38014, cityId: 1027, code: "673509" },
    { id: 38015, cityId: 1027, code: "673512" },
    { id: 38016, cityId: 1027, code: "673514" },
    { id: 38017, cityId: 1027, code: "673515" },
    { id: 38018, cityId: 1027, code: "673517" },
    { id: 38019, cityId: 1027, code: "673520" },
    { id: 38020, cityId: 1027, code: "673522" },
    { id: 38021, cityId: 1027, code: "673523" },
    { id: 38022, cityId: 1027, code: "673525" },
    { id: 38023, cityId: 1027, code: "673528" },
    { id: 38024, cityId: 1027, code: "673530" },
    { id: 38025, cityId: 1027, code: "673541" },
    { id: 38026, cityId: 1027, code: "673544" },
    { id: 38027, cityId: 1027, code: "673573" },
    { id: 38028, cityId: 1027, code: "673580" },
    { id: 38029, cityId: 1027, code: "673581" },
    { id: 38030, cityId: 1027, code: "673583" },
    { id: 38031, cityId: 1027, code: "673586" },
    { id: 38032, cityId: 1027, code: "673589" },
    { id: 38033, cityId: 1027, code: "673591" },
    { id: 38034, cityId: 1027, code: "673602" },
    { id: 38035, cityId: 1027, code: "673604" },
    { id: 38036, cityId: 1027, code: "673612" },
    { id: 38037, cityId: 1027, code: "673613" },
    { id: 38038, cityId: 1027, code: "673615" },
    { id: 38039, cityId: 1027, code: "673618" },
    { id: 38040, cityId: 1027, code: "673620" },
    { id: 38041, cityId: 1027, code: "673621" },
    { id: 38042, cityId: 1027, code: "673623" },
    { id: 38043, cityId: 1027, code: "673631" },
    { id: 38044, cityId: 1027, code: "673633" },
    { id: 38045, cityId: 1027, code: "673655" },
    { id: 38046, cityId: 1028, code: "671124" },
    { id: 38047, cityId: 1029, code: "680503" },
    { id: 38048, cityId: 1030, code: "683545" },
    { id: 38049, cityId: 1030, code: "679325" },
    { id: 38050, cityId: 1030, code: "683544" },
    { id: 38051, cityId: 1031, code: "676505" },
    { id: 38052, cityId: 1032, code: "673638" },
    { id: 38053, cityId: 1032, code: "673640" },
    { id: 38054, cityId: 1032, code: "673641" },
    { id: 38055, cityId: 1032, code: "673648" },
    { id: 38056, cityId: 1032, code: "673649" },
    { id: 38057, cityId: 1032, code: "676104" },
    { id: 38058, cityId: 1032, code: "676106" },
    { id: 38059, cityId: 1032, code: "676109" },
    { id: 38060, cityId: 1032, code: "676111" },
    { id: 38061, cityId: 1032, code: "676122" },
    { id: 38062, cityId: 1032, code: "676127" },
    { id: 38063, cityId: 1032, code: "676302" },
    { id: 38064, cityId: 1032, code: "676305" },
    { id: 38065, cityId: 1032, code: "676307" },
    { id: 38066, cityId: 1032, code: "676308" },
    { id: 38067, cityId: 1032, code: "676310" },
    { id: 38068, cityId: 1032, code: "676318" },
    { id: 38069, cityId: 1032, code: "676501" },
    { id: 38070, cityId: 1032, code: "676503" },
    { id: 38071, cityId: 1032, code: "676504" },
    { id: 38072, cityId: 1032, code: "676506" },
    { id: 38073, cityId: 1032, code: "676509" },
    { id: 38074, cityId: 1032, code: "676510" },
    { id: 38075, cityId: 1032, code: "676513" },
    { id: 38076, cityId: 1032, code: "676515" },
    { id: 38077, cityId: 1032, code: "676516" },
    { id: 38078, cityId: 1032, code: "676518" },
    { id: 38079, cityId: 1032, code: "676521" },
    { id: 38080, cityId: 1032, code: "676523" },
    { id: 38081, cityId: 1032, code: "676542" },
    { id: 38082, cityId: 1032, code: "676552" },
    { id: 38083, cityId: 1032, code: "676553" },
    { id: 38084, cityId: 1032, code: "676561" },
    { id: 38085, cityId: 1032, code: "679323" },
    { id: 38086, cityId: 1032, code: "679325" },
    { id: 38087, cityId: 1032, code: "679326" },
    { id: 38088, cityId: 1032, code: "679328" },
    { id: 38089, cityId: 1032, code: "679331" },
    { id: 38090, cityId: 1032, code: "679333" },
    { id: 38091, cityId: 1032, code: "679334" },
    { id: 38092, cityId: 1032, code: "679339" },
    { id: 38093, cityId: 1032, code: "679342" },
    { id: 38094, cityId: 1032, code: "679344" },
    { id: 38095, cityId: 1032, code: "679350" },
    { id: 38096, cityId: 1032, code: "679352" },
    { id: 38097, cityId: 1032, code: "679355" },
    { id: 38098, cityId: 1032, code: "679357" },
    { id: 38099, cityId: 1032, code: "679574" },
    { id: 38100, cityId: 1032, code: "679575" },
    { id: 38101, cityId: 1032, code: "679577" },
    { id: 38102, cityId: 1032, code: "679580" },
    { id: 38103, cityId: 1032, code: "679582" },
    { id: 38104, cityId: 1032, code: "679583" },
    { id: 38105, cityId: 1032, code: "679588" },
    { id: 38106, cityId: 1032, code: "679590" },
    { id: 38107, cityId: 1032, code: "679591" },
    { id: 38108, cityId: 1032, code: "679633" },
    { id: 38109, cityId: 1032, code: "689645" },
    { id: 38110, cityId: 1032, code: "673634" },
    { id: 38111, cityId: 1032, code: "673636" },
    { id: 38112, cityId: 1032, code: "673637" },
    { id: 38113, cityId: 1032, code: "673639" },
    { id: 38114, cityId: 1032, code: "673642" },
    { id: 38115, cityId: 1032, code: "673644" },
    { id: 38116, cityId: 1032, code: "673645" },
    { id: 38117, cityId: 1032, code: "673647" },
    { id: 38118, cityId: 1032, code: "673652" },
    { id: 38119, cityId: 1032, code: "676102" },
    { id: 38120, cityId: 1032, code: "676103" },
    { id: 38121, cityId: 1032, code: "676105" },
    { id: 38122, cityId: 1032, code: "676107" },
    { id: 38123, cityId: 1032, code: "676108" },
    { id: 38124, cityId: 1032, code: "676121" },
    { id: 38125, cityId: 1032, code: "676123" },
    { id: 38126, cityId: 1032, code: "676126" },
    { id: 38127, cityId: 1032, code: "676301" },
    { id: 38128, cityId: 1032, code: "676303" },
    { id: 38129, cityId: 1032, code: "676304" },
    { id: 38130, cityId: 1032, code: "676306" },
    { id: 38131, cityId: 1032, code: "676309" },
    { id: 38132, cityId: 1032, code: "676311" },
    { id: 38133, cityId: 1032, code: "676312" },
    { id: 38134, cityId: 1032, code: "676314" },
    { id: 38135, cityId: 1032, code: "676317" },
    { id: 38136, cityId: 1032, code: "676319" },
    { id: 38137, cityId: 1032, code: "676320" },
    { id: 38138, cityId: 1032, code: "676502" },
    { id: 38139, cityId: 1032, code: "676507" },
    { id: 38140, cityId: 1032, code: "676508" },
    { id: 38141, cityId: 1032, code: "676511" },
    { id: 38142, cityId: 1032, code: "676514" },
    { id: 38143, cityId: 1032, code: "676517" },
    { id: 38144, cityId: 1032, code: "676519" },
    { id: 38145, cityId: 1032, code: "676522" },
    { id: 38146, cityId: 1032, code: "676525" },
    { id: 38147, cityId: 1032, code: "676528" },
    { id: 38148, cityId: 1032, code: "676541" },
    { id: 38149, cityId: 1032, code: "676551" },
    { id: 38150, cityId: 1032, code: "676554" },
    { id: 38151, cityId: 1032, code: "676557" },
    { id: 38152, cityId: 1032, code: "676562" },
    { id: 38153, cityId: 1032, code: "679321" },
    { id: 38154, cityId: 1032, code: "679322" },
    { id: 38155, cityId: 1032, code: "679324" },
    { id: 38156, cityId: 1032, code: "679327" },
    { id: 38157, cityId: 1032, code: "679330" },
    { id: 38158, cityId: 1032, code: "679332" },
    { id: 38159, cityId: 1032, code: "679338" },
    { id: 38160, cityId: 1032, code: "679340" },
    { id: 38161, cityId: 1032, code: "679343" },
    { id: 38162, cityId: 1032, code: "679348" },
    { id: 38163, cityId: 1032, code: "679351" },
    { id: 38164, cityId: 1032, code: "679354" },
    { id: 38165, cityId: 1032, code: "679571" },
    { id: 38166, cityId: 1032, code: "679576" },
    { id: 38167, cityId: 1032, code: "679578" },
    { id: 38168, cityId: 1032, code: "679579" },
    { id: 38169, cityId: 1032, code: "679581" },
    { id: 38170, cityId: 1032, code: "679584" },
    { id: 38171, cityId: 1032, code: "679586" },
    { id: 38172, cityId: 1032, code: "679587" },
    { id: 38173, cityId: 1032, code: "679589" },
    { id: 38174, cityId: 1032, code: "679592" },
    { id: 38175, cityId: 1032, code: "679594" },
    { id: 38176, cityId: 1033, code: "686547" },
    { id: 38177, cityId: 1034, code: "670646" },
    { id: 38178, cityId: 1034, code: "670645" },
    { id: 38179, cityId: 1035, code: "676121" },
    { id: 38180, cityId: 1036, code: "671323" },
    { id: 38181, cityId: 1037, code: "678581" },
    { id: 38182, cityId: 1037, code: "678582" },
    { id: 38183, cityId: 1038, code: "682304" },
    { id: 38184, cityId: 1039, code: "673661" },
    { id: 38185, cityId: 1040, code: "683572" },
    { id: 38186, cityId: 1040, code: "686634" },
    { id: 38187, cityId: 1040, code: "686652" },
    { id: 38188, cityId: 1041, code: "683545" },
    { id: 38189, cityId: 1042, code: "688525" },
    { id: 38190, cityId: 1043, code: "676528" },
    { id: 38191, cityId: 1044, code: "682504" },
    { id: 38192, cityId: 1045, code: "679334" },
    { id: 38193, cityId: 1046, code: "686661" },
    { id: 38194, cityId: 1046, code: "686667" },
    { id: 38195, cityId: 1046, code: "686673" },
    { id: 38196, cityId: 1047, code: "680751" },
    { id: 38197, cityId: 1048, code: "682509" },
    { id: 38198, cityId: 1048, code: "695572" },
    { id: 38199, cityId: 1048, code: "695606" },
    { id: 38200, cityId: 1048, code: "695102" },
    { id: 38201, cityId: 1048, code: "695541" },
    { id: 38202, cityId: 1049, code: "695125" },
    { id: 38203, cityId: 1049, code: "695504" },
    { id: 38204, cityId: 1049, code: "695506" },
    { id: 38205, cityId: 1049, code: "695121" },
    { id: 38206, cityId: 1049, code: "695124" },
    { id: 38207, cityId: 1050, code: "679332" },
    { id: 38208, cityId: 1050, code: "679339" },
    { id: 38209, cityId: 1050, code: "676525" },
    { id: 38210, cityId: 1050, code: "679327" },
    { id: 38211, cityId: 1051, code: "673025" },
    { id: 38212, cityId: 1052, code: "679513" },
    { id: 38213, cityId: 1053, code: "686575" },
    { id: 38214, cityId: 1054, code: "678001" },
    { id: 38215, cityId: 1055, code: "670661" },
    { id: 38216, cityId: 1056, code: "678005" },
    { id: 38217, cityId: 1056, code: "678008" },
    { id: 38218, cityId: 1056, code: "678554" },
    { id: 38219, cityId: 1056, code: "679533" },
    { id: 38220, cityId: 1056, code: "678006" },
    { id: 38221, cityId: 1056, code: "678014" },
    { id: 38222, cityId: 1056, code: "678541" },
    { id: 38223, cityId: 1056, code: "679302" },
    { id: 38224, cityId: 1057, code: "680522" },
    { id: 38225, cityId: 1058, code: "670561" },
    { id: 38226, cityId: 1059, code: "689101" },
    { id: 38227, cityId: 1059, code: "689104" },
    { id: 38228, cityId: 1059, code: "689106" },
    { id: 38229, cityId: 1059, code: "689107" },
    { id: 38230, cityId: 1059, code: "689114" },
    { id: 38231, cityId: 1059, code: "689115" },
    { id: 38232, cityId: 1059, code: "689123" },
    { id: 38233, cityId: 1059, code: "689501" },
    { id: 38234, cityId: 1059, code: "689507" },
    { id: 38235, cityId: 1059, code: "689517" },
    { id: 38236, cityId: 1059, code: "689519" },
    { id: 38237, cityId: 1059, code: "689520" },
    { id: 38238, cityId: 1059, code: "689533" },
    { id: 38239, cityId: 1059, code: "689541" },
    { id: 38240, cityId: 1059, code: "689543" },
    { id: 38241, cityId: 1059, code: "689544" },
    { id: 38242, cityId: 1059, code: "689546" },
    { id: 38243, cityId: 1059, code: "689549" },
    { id: 38244, cityId: 1059, code: "689551" },
    { id: 38245, cityId: 1059, code: "689552" },
    { id: 38246, cityId: 1059, code: "689578" },
    { id: 38247, cityId: 1059, code: "689581" },
    { id: 38248, cityId: 1059, code: "689583" },
    { id: 38249, cityId: 1059, code: "689586" },
    { id: 38250, cityId: 1059, code: "689588" },
    { id: 38251, cityId: 1059, code: "689589" },
    { id: 38252, cityId: 1059, code: "689591" },
    { id: 38253, cityId: 1059, code: "689594" },
    { id: 38254, cityId: 1059, code: "689596" },
    { id: 38255, cityId: 1059, code: "689597" },
    { id: 38256, cityId: 1059, code: "689602" },
    { id: 38257, cityId: 1059, code: "689612" },
    { id: 38258, cityId: 1059, code: "689613" },
    { id: 38259, cityId: 1059, code: "689615" },
    { id: 38260, cityId: 1059, code: "689625" },
    { id: 38261, cityId: 1059, code: "689641" },
    { id: 38262, cityId: 1059, code: "689642" },
    { id: 38263, cityId: 1059, code: "689644" },
    { id: 38264, cityId: 1059, code: "689647" },
    { id: 38265, cityId: 1059, code: "689649" },
    { id: 38266, cityId: 1059, code: "689650" },
    { id: 38267, cityId: 1059, code: "689652" },
    { id: 38268, cityId: 1059, code: "689657" },
    { id: 38269, cityId: 1059, code: "689660" },
    { id: 38270, cityId: 1059, code: "689663" },
    { id: 38271, cityId: 1059, code: "689665" },
    { id: 38272, cityId: 1059, code: "689668" },
    { id: 38273, cityId: 1059, code: "689671" },
    { id: 38274, cityId: 1059, code: "689673" },
    { id: 38275, cityId: 1059, code: "689676" },
    { id: 38276, cityId: 1059, code: "689678" },
    { id: 38277, cityId: 1059, code: "689681" },
    { id: 38278, cityId: 1059, code: "689692" },
    { id: 38279, cityId: 1059, code: "689694" },
    { id: 38280, cityId: 1059, code: "689695" },
    { id: 38281, cityId: 1059, code: "689703" },
    { id: 38282, cityId: 1059, code: "689705" },
    { id: 38283, cityId: 1059, code: "689711" },
    { id: 38284, cityId: 1059, code: "689713" },
    { id: 38285, cityId: 1059, code: "690561" },
    { id: 38286, cityId: 1059, code: "690569" },
    { id: 38287, cityId: 1059, code: "691320" },
    { id: 38288, cityId: 1059, code: "691514" },
    { id: 38289, cityId: 1059, code: "691525" },
    { id: 38290, cityId: 1059, code: "691527" },
    { id: 38291, cityId: 1059, code: "691533" },
    { id: 38292, cityId: 1059, code: "691551" },
    { id: 38293, cityId: 1059, code: "691554" },
    { id: 38294, cityId: 1059, code: "691556" },
    { id: 38295, cityId: 1059, code: "688008" },
    { id: 38296, cityId: 1059, code: "689102" },
    { id: 38297, cityId: 1059, code: "689103" },
    { id: 38298, cityId: 1059, code: "689105" },
    { id: 38299, cityId: 1059, code: "689108" },
    { id: 38300, cityId: 1059, code: "689110" },
    { id: 38301, cityId: 1059, code: "689111" },
    { id: 38302, cityId: 1059, code: "689113" },
    { id: 38303, cityId: 1059, code: "689502" },
    { id: 38304, cityId: 1059, code: "689503" },
    { id: 38305, cityId: 1059, code: "689513" },
    { id: 38306, cityId: 1059, code: "689516" },
    { id: 38307, cityId: 1059, code: "689518" },
    { id: 38308, cityId: 1059, code: "689531" },
    { id: 38309, cityId: 1059, code: "689532" },
    { id: 38310, cityId: 1059, code: "689542" },
    { id: 38311, cityId: 1059, code: "689545" },
    { id: 38312, cityId: 1059, code: "689547" },
    { id: 38313, cityId: 1059, code: "689548" },
    { id: 38314, cityId: 1059, code: "689550" },
    { id: 38315, cityId: 1059, code: "689582" },
    { id: 38316, cityId: 1059, code: "689584" },
    { id: 38317, cityId: 1059, code: "689587" },
    { id: 38318, cityId: 1059, code: "689592" },
    { id: 38319, cityId: 1059, code: "689593" },
    { id: 38320, cityId: 1059, code: "689595" },
    { id: 38321, cityId: 1059, code: "689603" },
    { id: 38322, cityId: 1059, code: "689611" },
    { id: 38323, cityId: 1059, code: "689614" },
    { id: 38324, cityId: 1059, code: "689616" },
    { id: 38325, cityId: 1059, code: "689632" },
    { id: 38326, cityId: 1059, code: "689643" },
    { id: 38327, cityId: 1059, code: "689645" },
    { id: 38328, cityId: 1059, code: "689646" },
    { id: 38329, cityId: 1059, code: "689648" },
    { id: 38330, cityId: 1059, code: "689653" },
    { id: 38331, cityId: 1059, code: "689654" },
    { id: 38332, cityId: 1059, code: "689656" },
    { id: 38333, cityId: 1059, code: "689659" },
    { id: 38334, cityId: 1059, code: "689661" },
    { id: 38335, cityId: 1059, code: "689662" },
    { id: 38336, cityId: 1059, code: "689664" },
    { id: 38337, cityId: 1059, code: "689666" },
    { id: 38338, cityId: 1059, code: "689667" },
    { id: 38339, cityId: 1059, code: "689672" },
    { id: 38340, cityId: 1059, code: "689674" },
    { id: 38341, cityId: 1059, code: "689675" },
    { id: 38342, cityId: 1059, code: "689677" },
    { id: 38343, cityId: 1059, code: "689680" },
    { id: 38344, cityId: 1059, code: "689682" },
    { id: 38345, cityId: 1059, code: "689691" },
    { id: 38346, cityId: 1059, code: "689693" },
    { id: 38347, cityId: 1059, code: "689696" },
    { id: 38348, cityId: 1059, code: "689698" },
    { id: 38349, cityId: 1059, code: "689699" },
    { id: 38350, cityId: 1059, code: "690522" },
    { id: 38351, cityId: 1059, code: "691325" },
    { id: 38352, cityId: 1059, code: "691330" },
    { id: 38353, cityId: 1059, code: "691523" },
    { id: 38354, cityId: 1059, code: "691526" },
    { id: 38355, cityId: 1059, code: "691528" },
    { id: 38356, cityId: 1059, code: "691552" },
    { id: 38357, cityId: 1059, code: "691553" },
    { id: 38358, cityId: 1059, code: "691555" },
    { id: 38359, cityId: 1060, code: "673507" },
    { id: 38360, cityId: 1061, code: "670307" },
    { id: 38361, cityId: 1062, code: "670675" },
    { id: 38362, cityId: 1063, code: "679322" },
    { id: 38363, cityId: 1063, code: "679325" },
    { id: 38364, cityId: 1063, code: "679357" },
    { id: 38365, cityId: 1063, code: "679326" },
    { id: 38366, cityId: 1064, code: "686028" },
    { id: 38367, cityId: 1065, code: "683542" },
    { id: 38368, cityId: 1066, code: "680581" },
    { id: 38369, cityId: 1067, code: "691305" },
    { id: 38370, cityId: 1068, code: "680551" },
    { id: 38371, cityId: 1069, code: "670702" },
    { id: 38372, cityId: 1069, code: "673305" },
    { id: 38373, cityId: 1069, code: "695505" },
    { id: 38374, cityId: 1070, code: "673633" },
    { id: 38375, cityId: 1071, code: "689677" },
    { id: 38376, cityId: 1072, code: "673579" },
    { id: 38377, cityId: 1072, code: "673592" },
    { id: 38378, cityId: 1072, code: "673596" },
    { id: 38379, cityId: 1073, code: "670142" },
    { id: 38380, cityId: 1073, code: "670306" },
    { id: 38381, cityId: 1073, code: "670571" },
    { id: 38382, cityId: 1073, code: "670581" },
    { id: 38383, cityId: 1073, code: "670141" },
    { id: 38384, cityId: 1073, code: "670511" },
    { id: 38385, cityId: 1073, code: "670593" },
    { id: 38386, cityId: 1073, code: "670602" },
    { id: 38387, cityId: 1073, code: "670604" },
    { id: 38388, cityId: 1073, code: "670631" },
    { id: 38389, cityId: 1073, code: "670705" },
    { id: 38390, cityId: 1073, code: "673517" },
    { id: 38391, cityId: 1073, code: "685588" },
    { id: 38392, cityId: 1074, code: "680104" },
    { id: 38393, cityId: 1075, code: "670643" },
    { id: 38394, cityId: 1075, code: "670704" },
    { id: 38395, cityId: 1075, code: "671321" },
    { id: 38396, cityId: 1075, code: "670101" },
    { id: 38397, cityId: 1075, code: "670612" },
    { id: 38398, cityId: 1075, code: "670673" },
    { id: 38399, cityId: 1075, code: "670674" },
    { id: 38400, cityId: 1076, code: "695584" },
    { id: 38401, cityId: 1077, code: "682305" },
    { id: 38402, cityId: 1078, code: "685581" },
    { id: 38403, cityId: 1078, code: "685583" },
    { id: 38404, cityId: 1078, code: "685582" },
    { id: 38405, cityId: 1079, code: "670007" },
    { id: 38406, cityId: 1080, code: "678004" },
    { id: 38407, cityId: 1080, code: "678009" },
    { id: 38408, cityId: 1080, code: "678011" },
    { id: 38409, cityId: 1080, code: "678012" },
    { id: 38410, cityId: 1080, code: "678017" },
    { id: 38411, cityId: 1080, code: "678019" },
    { id: 38412, cityId: 1080, code: "678020" },
    { id: 38413, cityId: 1080, code: "678102" },
    { id: 38414, cityId: 1080, code: "678104" },
    { id: 38415, cityId: 1080, code: "678501" },
    { id: 38416, cityId: 1080, code: "678502" },
    { id: 38417, cityId: 1080, code: "678504" },
    { id: 38418, cityId: 1080, code: "678507" },
    { id: 38419, cityId: 1080, code: "678509" },
    { id: 38420, cityId: 1080, code: "678510" },
    { id: 38421, cityId: 1080, code: "678512" },
    { id: 38422, cityId: 1080, code: "678531" },
    { id: 38423, cityId: 1080, code: "678533" },
    { id: 38424, cityId: 1080, code: "678534" },
    { id: 38425, cityId: 1080, code: "678544" },
    { id: 38426, cityId: 1080, code: "678547" },
    { id: 38427, cityId: 1080, code: "678552" },
    { id: 38428, cityId: 1080, code: "678554" },
    { id: 38429, cityId: 1080, code: "678555" },
    { id: 38430, cityId: 1080, code: "678557" },
    { id: 38431, cityId: 1080, code: "678571" },
    { id: 38432, cityId: 1080, code: "678573" },
    { id: 38433, cityId: 1080, code: "678578" },
    { id: 38434, cityId: 1080, code: "678581" },
    { id: 38435, cityId: 1080, code: "678591" },
    { id: 38436, cityId: 1080, code: "678592" },
    { id: 38437, cityId: 1080, code: "678597" },
    { id: 38438, cityId: 1080, code: "678600" },
    { id: 38439, cityId: 1080, code: "678605" },
    { id: 38440, cityId: 1080, code: "678613" },
    { id: 38441, cityId: 1080, code: "678615" },
    { id: 38442, cityId: 1080, code: "678616" },
    { id: 38443, cityId: 1080, code: "678621" },
    { id: 38444, cityId: 1080, code: "678623" },
    { id: 38445, cityId: 1080, code: "678624" },
    { id: 38446, cityId: 1080, code: "678631" },
    { id: 38447, cityId: 1080, code: "678632" },
    { id: 38448, cityId: 1080, code: "678634" },
    { id: 38449, cityId: 1080, code: "678637" },
    { id: 38450, cityId: 1080, code: "678642" },
    { id: 38451, cityId: 1080, code: "678661" },
    { id: 38452, cityId: 1080, code: "678671" },
    { id: 38453, cityId: 1080, code: "678682" },
    { id: 38454, cityId: 1080, code: "678684" },
    { id: 38455, cityId: 1080, code: "678685" },
    { id: 38456, cityId: 1080, code: "678689" },
    { id: 38457, cityId: 1080, code: "678703" },
    { id: 38458, cityId: 1080, code: "678705" },
    { id: 38459, cityId: 1080, code: "678706" },
    { id: 38460, cityId: 1080, code: "678721" },
    { id: 38461, cityId: 1080, code: "678722" },
    { id: 38462, cityId: 1080, code: "678732" },
    { id: 38463, cityId: 1080, code: "678761" },
    { id: 38464, cityId: 1080, code: "679103" },
    { id: 38465, cityId: 1080, code: "679105" },
    { id: 38466, cityId: 1080, code: "679106" },
    { id: 38467, cityId: 1080, code: "679121" },
    { id: 38468, cityId: 1080, code: "679122" },
    { id: 38469, cityId: 1080, code: "679124" },
    { id: 38470, cityId: 1080, code: "679301" },
    { id: 38471, cityId: 1080, code: "679302" },
    { id: 38472, cityId: 1080, code: "679304" },
    { id: 38473, cityId: 1080, code: "679307" },
    { id: 38474, cityId: 1080, code: "679309" },
    { id: 38475, cityId: 1080, code: "679310" },
    { id: 38476, cityId: 1080, code: "679312" },
    { id: 38477, cityId: 1080, code: "679336" },
    { id: 38478, cityId: 1080, code: "679503" },
    { id: 38480, cityId: 1080, code: "679506" },
    { id: 38481, cityId: 1080, code: "679511" },
    { id: 38482, cityId: 1080, code: "679513" },
    { id: 38483, cityId: 1080, code: "679514" },
    { id: 38484, cityId: 1080, code: "679516" },
    { id: 38485, cityId: 1080, code: "679518" },
    { id: 38486, cityId: 1080, code: "679521" },
    { id: 38487, cityId: 1080, code: "679532" },
    { id: 38488, cityId: 1080, code: "679534" },
    { id: 38489, cityId: 1080, code: "679535" },
    { id: 38490, cityId: 1080, code: "679537" },
    { id: 38491, cityId: 1080, code: "679551" },
    { id: 38492, cityId: 1080, code: "679553" },
    { id: 38493, cityId: 1080, code: "679556" },
    { id: 38494, cityId: 1080, code: "679561" },
    { id: 38495, cityId: 1080, code: "679564" },
    { id: 38496, cityId: 1080, code: "679585" },
    { id: 38497, cityId: 1080, code: "680001" },
    { id: 38498, cityId: 1080, code: "680003" },
    { id: 38499, cityId: 1080, code: "680006" },
    { id: 38500, cityId: 1080, code: "680008" },
    { id: 38501, cityId: 1080, code: "680009" },
    { id: 38502, cityId: 1080, code: "680011" },
    { id: 38503, cityId: 1080, code: "680014" },
    { id: 38504, cityId: 1080, code: "680016" },
    { id: 38505, cityId: 1080, code: "680017" },
    { id: 38506, cityId: 1080, code: "680027" },
    { id: 38507, cityId: 1080, code: "680101" },
    { id: 38508, cityId: 1080, code: "680104" },
    { id: 38509, cityId: 1080, code: "680122" },
    { id: 38510, cityId: 1080, code: "680123" },
    { id: 38511, cityId: 1080, code: "680125" },
    { id: 38512, cityId: 1080, code: "680302" },
    { id: 38513, cityId: 1080, code: "680303" },
    { id: 38514, cityId: 1080, code: "680305" },
    { id: 38515, cityId: 1080, code: "680308" },
    { id: 38516, cityId: 1080, code: "680310" },
    { id: 38517, cityId: 1080, code: "680311" },
    { id: 38518, cityId: 1080, code: "680313" },
    { id: 38519, cityId: 1080, code: "680316" },
    { id: 38520, cityId: 1080, code: "680319" },
    { id: 38521, cityId: 1080, code: "680321" },
    { id: 38522, cityId: 1080, code: "680324" },
    { id: 38523, cityId: 1080, code: "680501" },
    { id: 38524, cityId: 1080, code: "680506" },
    { id: 38525, cityId: 1080, code: "680507" },
    { id: 38526, cityId: 1080, code: "680509" },
    { id: 38527, cityId: 1080, code: "680512" },
    { id: 38528, cityId: 1080, code: "680514" },
    { id: 38529, cityId: 1080, code: "680517" },
    { id: 38530, cityId: 1080, code: "680520" },
    { id: 38531, cityId: 1080, code: "680522" },
    { id: 38532, cityId: 1080, code: "680523" },
    { id: 38533, cityId: 1080, code: "680541" },
    { id: 38534, cityId: 1080, code: "680543" },
    { id: 38535, cityId: 1080, code: "680544" },
    { id: 38536, cityId: 1080, code: "680546" },
    { id: 38537, cityId: 1080, code: "680549" },
    { id: 38538, cityId: 1080, code: "680551" },
    { id: 38539, cityId: 1080, code: "680552" },
    { id: 38540, cityId: 1080, code: "680554" },
    { id: 38541, cityId: 1080, code: "680562" },
    { id: 38542, cityId: 1080, code: "680565" },
    { id: 38543, cityId: 1080, code: "680567" },
    { id: 38544, cityId: 1080, code: "680568" },
    { id: 38545, cityId: 1080, code: "680570" },
    { id: 38546, cityId: 1080, code: "680573" },
    { id: 38547, cityId: 1080, code: "680575" },
    { id: 38548, cityId: 1080, code: "680581" },
    { id: 38549, cityId: 1080, code: "680583" },
    { id: 38550, cityId: 1080, code: "680584" },
    { id: 38551, cityId: 1080, code: "680586" },
    { id: 38552, cityId: 1080, code: "680588" },
    { id: 38553, cityId: 1080, code: "680589" },
    { id: 38554, cityId: 1080, code: "680591" },
    { id: 38555, cityId: 1080, code: "680594" },
    { id: 38556, cityId: 1080, code: "680596" },
    { id: 38557, cityId: 1080, code: "680597" },
    { id: 38558, cityId: 1080, code: "680602" },
    { id: 38559, cityId: 1080, code: "680604" },
    { id: 38560, cityId: 1080, code: "680610" },
    { id: 38561, cityId: 1080, code: "680612" },
    { id: 38562, cityId: 1080, code: "680613" },
    { id: 38563, cityId: 1080, code: "680615" },
    { id: 38564, cityId: 1080, code: "680618" },
    { id: 38565, cityId: 1080, code: "680620" },
    { id: 38566, cityId: 1080, code: "680621" },
    { id: 38567, cityId: 1080, code: "680623" },
    { id: 38568, cityId: 1080, code: "680631" },
    { id: 38569, cityId: 1080, code: "680641" },
    { id: 38570, cityId: 1080, code: "680642" },
    { id: 38571, cityId: 1080, code: "680652" },
    { id: 38572, cityId: 1080, code: "680655" },
    { id: 38573, cityId: 1080, code: "680663" },
    { id: 38574, cityId: 1080, code: "680665" },
    { id: 38575, cityId: 1080, code: "680666" },
    { id: 38576, cityId: 1080, code: "680668" },
    { id: 38577, cityId: 1080, code: "680671" },
    { id: 38578, cityId: 1080, code: "680673" },
    { id: 38579, cityId: 1080, code: "680681" },
    { id: 38580, cityId: 1080, code: "680682" },
    { id: 38581, cityId: 1080, code: "680684" },
    { id: 38582, cityId: 1080, code: "680686" },
    { id: 38583, cityId: 1080, code: "680687" },
    { id: 38584, cityId: 1080, code: "680689" },
    { id: 38585, cityId: 1080, code: "680692" },
    { id: 38586, cityId: 1080, code: "680694" },
    { id: 38587, cityId: 1080, code: "680695" },
    { id: 38588, cityId: 1080, code: "680702" },
    { id: 38589, cityId: 1080, code: "680703" },
    { id: 38590, cityId: 1080, code: "680711" },
    { id: 38591, cityId: 1080, code: "680721" },
    { id: 38592, cityId: 1080, code: "680732" },
    { id: 38593, cityId: 1080, code: "680734" },
    { id: 38594, cityId: 1080, code: "680771" },
    { id: 38595, cityId: 1080, code: "686582" },
    { id: 38596, cityId: 1080, code: "691536" },
    { id: 38597, cityId: 1080, code: "678002" },
    { id: 38598, cityId: 1080, code: "678003" },
    { id: 38599, cityId: 1080, code: "678005" },
    { id: 38600, cityId: 1080, code: "678007" },
    { id: 38601, cityId: 1080, code: "678010" },
    { id: 38602, cityId: 1080, code: "678013" },
    { id: 38603, cityId: 1080, code: "678015" },
    { id: 38604, cityId: 1080, code: "678018" },
    { id: 38605, cityId: 1080, code: "678101" },
    { id: 38606, cityId: 1080, code: "678103" },
    { id: 38607, cityId: 1080, code: "678503" },
    { id: 38608, cityId: 1080, code: "678505" },
    { id: 38609, cityId: 1080, code: "678506" },
    { id: 38610, cityId: 1080, code: "678508" },
    { id: 38611, cityId: 1080, code: "678511" },
    { id: 38612, cityId: 1080, code: "678513" },
    { id: 38613, cityId: 1080, code: "678532" },
    { id: 38614, cityId: 1080, code: "678542" },
    { id: 38615, cityId: 1080, code: "678543" },
    { id: 38616, cityId: 1080, code: "678545" },
    { id: 38617, cityId: 1080, code: "678548" },
    { id: 38618, cityId: 1080, code: "678551" },
    { id: 38619, cityId: 1080, code: "678553" },
    { id: 38620, cityId: 1080, code: "678556" },
    { id: 38621, cityId: 1080, code: "678559" },
    { id: 38622, cityId: 1080, code: "678572" },
    { id: 38623, cityId: 1080, code: "678574" },
    { id: 38624, cityId: 1080, code: "678575" },
    { id: 38625, cityId: 1080, code: "678582" },
    { id: 38626, cityId: 1080, code: "678583" },
    { id: 38627, cityId: 1080, code: "678593" },
    { id: 38628, cityId: 1080, code: "678595" },
    { id: 38629, cityId: 1080, code: "678596" },
    { id: 38630, cityId: 1080, code: "678598" },
    { id: 38631, cityId: 1080, code: "678601" },
    { id: 38632, cityId: 1080, code: "678609" },
    { id: 38633, cityId: 1080, code: "678611" },
    { id: 38634, cityId: 1080, code: "678612" },
    { id: 38635, cityId: 1080, code: "678614" },
    { id: 38636, cityId: 1080, code: "678622" },
    { id: 38637, cityId: 1080, code: "678633" },
    { id: 38638, cityId: 1080, code: "678635" },
    { id: 38639, cityId: 1080, code: "678641" },
    { id: 38640, cityId: 1080, code: "678651" },
    { id: 38641, cityId: 1080, code: "678681" },
    { id: 38642, cityId: 1080, code: "678683" },
    { id: 38643, cityId: 1080, code: "678686" },
    { id: 38644, cityId: 1080, code: "678688" },
    { id: 38645, cityId: 1080, code: "678701" },
    { id: 38646, cityId: 1080, code: "678702" },
    { id: 38647, cityId: 1080, code: "678704" },
    { id: 38648, cityId: 1080, code: "678707" },
    { id: 38649, cityId: 1080, code: "678709" },
    { id: 38650, cityId: 1080, code: "678733" },
    { id: 38651, cityId: 1080, code: "678762" },
    { id: 38652, cityId: 1080, code: "679101" },
    { id: 38653, cityId: 1080, code: "679102" },
    { id: 38654, cityId: 1080, code: "679104" },
    { id: 38655, cityId: 1080, code: "679123" },
    { id: 38656, cityId: 1080, code: "679125" },
    { id: 38657, cityId: 1080, code: "679303" },
    { id: 38658, cityId: 1080, code: "679305" },
    { id: 38659, cityId: 1080, code: "679306" },
    { id: 38660, cityId: 1080, code: "679308" },
    { id: 38661, cityId: 1080, code: "679311" },
    { id: 38662, cityId: 1080, code: "679313" },
    { id: 38663, cityId: 1080, code: "679314" },
    { id: 38664, cityId: 1080, code: "679335" },
    { id: 38665, cityId: 1080, code: "679337" },
    { id: 38666, cityId: 1080, code: "679356" },
    { id: 38667, cityId: 1080, code: "679501" },
    { id: 38668, cityId: 1080, code: "679502" },
    { id: 38669, cityId: 1080, code: "679504" },
    { id: 38670, cityId: 1080, code: "679512" },
    { id: 38671, cityId: 1080, code: "679517" },
    { id: 38672, cityId: 1080, code: "679522" },
    { id: 38673, cityId: 1080, code: "679523" },
    { id: 38674, cityId: 1080, code: "679531" },
    { id: 38675, cityId: 1080, code: "679533" },
    { id: 38676, cityId: 1080, code: "679536" },
    { id: 38677, cityId: 1080, code: "679538" },
    { id: 38678, cityId: 1080, code: "679552" },
    { id: 38679, cityId: 1080, code: "679554" },
    { id: 38680, cityId: 1080, code: "679562" },
    { id: 38681, cityId: 1080, code: "679563" },
    { id: 38682, cityId: 1080, code: "679573" },
    { id: 38683, cityId: 1080, code: "680002" },
    { id: 38684, cityId: 1080, code: "680004" },
    { id: 38685, cityId: 1080, code: "680005" },
    { id: 38686, cityId: 1080, code: "680007" },
    { id: 38687, cityId: 1080, code: "680010" },
    { id: 38688, cityId: 1080, code: "680012" },
    { id: 38689, cityId: 1080, code: "680013" },
    { id: 38690, cityId: 1080, code: "680015" },
    { id: 38691, cityId: 1080, code: "680018" },
    { id: 38692, cityId: 1080, code: "680020" },
    { id: 38693, cityId: 1080, code: "680021" },
    { id: 38694, cityId: 1080, code: "680026" },
    { id: 38695, cityId: 1080, code: "680028" },
    { id: 38696, cityId: 1080, code: "680102" },
    { id: 38697, cityId: 1080, code: "680103" },
    { id: 38698, cityId: 1080, code: "680124" },
    { id: 38699, cityId: 1080, code: "680301" },
    { id: 38700, cityId: 1080, code: "680304" },
    { id: 38701, cityId: 1080, code: "680306" },
    { id: 38702, cityId: 1080, code: "680307" },
    { id: 38703, cityId: 1080, code: "680309" },
    { id: 38704, cityId: 1080, code: "680312" },
    { id: 38705, cityId: 1080, code: "680314" },
    { id: 38706, cityId: 1080, code: "680315" },
    { id: 38707, cityId: 1080, code: "680317" },
    { id: 38708, cityId: 1080, code: "680320" },
    { id: 38709, cityId: 1080, code: "680323" },
    { id: 38710, cityId: 1080, code: "680325" },
    { id: 38711, cityId: 1080, code: "680502" },
    { id: 38712, cityId: 1080, code: "680503" },
    { id: 38713, cityId: 1080, code: "680505" },
    { id: 38714, cityId: 1080, code: "680508" },
    { id: 38715, cityId: 1080, code: "680510" },
    { id: 38716, cityId: 1080, code: "680511" },
    { id: 38717, cityId: 1080, code: "680513" },
    { id: 38718, cityId: 1080, code: "680516" },
    { id: 38719, cityId: 1080, code: "680518" },
    { id: 38720, cityId: 1080, code: "680519" },
    { id: 38721, cityId: 1080, code: "680521" },
    { id: 38722, cityId: 1080, code: "680524" },
    { id: 38723, cityId: 1080, code: "680542" },
    { id: 38724, cityId: 1080, code: "680545" },
    { id: 38725, cityId: 1080, code: "680547" },
    { id: 38726, cityId: 1080, code: "680553" },
    { id: 38727, cityId: 1080, code: "680561" },
    { id: 38728, cityId: 1080, code: "680563" },
    { id: 38729, cityId: 1080, code: "680564" },
    { id: 38730, cityId: 1080, code: "680566" },
    { id: 38731, cityId: 1080, code: "680569" },
    { id: 38732, cityId: 1080, code: "680571" },
    { id: 38733, cityId: 1080, code: "680572" },
    { id: 38734, cityId: 1080, code: "680574" },
    { id: 38735, cityId: 1080, code: "680582" },
    { id: 38736, cityId: 1080, code: "680585" },
    { id: 38737, cityId: 1080, code: "680587" },
    { id: 38738, cityId: 1080, code: "680590" },
    { id: 38739, cityId: 1080, code: "680592" },
    { id: 38740, cityId: 1080, code: "680593" },
    { id: 38741, cityId: 1080, code: "680595" },
    { id: 38742, cityId: 1080, code: "680601" },
    { id: 38743, cityId: 1080, code: "680603" },
    { id: 38744, cityId: 1080, code: "680608" },
    { id: 38745, cityId: 1080, code: "680609" },
    { id: 38746, cityId: 1080, code: "680611" },
    { id: 38747, cityId: 1080, code: "680614" },
    { id: 38748, cityId: 1080, code: "680616" },
    { id: 38749, cityId: 1080, code: "680617" },
    { id: 38750, cityId: 1080, code: "680619" },
    { id: 38751, cityId: 1080, code: "680651" },
    { id: 38752, cityId: 1080, code: "680653" },
    { id: 38753, cityId: 1080, code: "680654" },
    { id: 38754, cityId: 1080, code: "680656" },
    { id: 38755, cityId: 1080, code: "680661" },
    { id: 38756, cityId: 1080, code: "680662" },
    { id: 38757, cityId: 1080, code: "680664" },
    { id: 38758, cityId: 1080, code: "680667" },
    { id: 38759, cityId: 1080, code: "680669" },
    { id: 38760, cityId: 1080, code: "680670" },
    { id: 38761, cityId: 1080, code: "680672" },
    { id: 38762, cityId: 1080, code: "680683" },
    { id: 38763, cityId: 1080, code: "680685" },
    { id: 38764, cityId: 1080, code: "680688" },
    { id: 38765, cityId: 1080, code: "680691" },
    { id: 38766, cityId: 1080, code: "680693" },
    { id: 38767, cityId: 1080, code: "680698" },
    { id: 38768, cityId: 1080, code: "680699" },
    { id: 38769, cityId: 1080, code: "680701" },
    { id: 38770, cityId: 1080, code: "680704" },
    { id: 38771, cityId: 1080, code: "680712" },
    { id: 38772, cityId: 1080, code: "680723" },
    { id: 38773, cityId: 1080, code: "680725" },
    { id: 38774, cityId: 1080, code: "680731" },
    { id: 38775, cityId: 1080, code: "680733" },
    { id: 38776, cityId: 1080, code: "680735" },
    { id: 38777, cityId: 1080, code: "680736" },
    { id: 38778, cityId: 1080, code: "680741" },
    { id: 38779, cityId: 1080, code: "680751" },
    { id: 38780, cityId: 1080, code: "680752" },
    { id: 38781, cityId: 1081, code: "676101" },
    { id: 38782, cityId: 1081, code: "695124" },
    { id: 38783, cityId: 1081, code: "676102" },
    { id: 38784, cityId: 1081, code: "676301" },
    { id: 38785, cityId: 1081, code: "676528" },
    { id: 38786, cityId: 1081, code: "676551" },
    { id: 38787, cityId: 1081, code: "679321" },
    { id: 38788, cityId: 1082, code: "676303" },
    { id: 38789, cityId: 1082, code: "676320" },
    { id: 38790, cityId: 1083, code: "685582" },
    { id: 38791, cityId: 1083, code: "691004" },
    { id: 38792, cityId: 1083, code: "695001" },
    { id: 38793, cityId: 1083, code: "695003" },
    { id: 38794, cityId: 1083, code: "695006" },
    { id: 38795, cityId: 1083, code: "695008" },
    { id: 38796, cityId: 1083, code: "695009" },
    { id: 38797, cityId: 1083, code: "695011" },
    { id: 38798, cityId: 1083, code: "695014" },
    { id: 38799, cityId: 1083, code: "695016" },
    { id: 38800, cityId: 1083, code: "695017" },
    { id: 38801, cityId: 1083, code: "695019" },
    { id: 38802, cityId: 1083, code: "695022" },
    { id: 38803, cityId: 1083, code: "695024" },
    { id: 38804, cityId: 1083, code: "695025" },
    { id: 38805, cityId: 1083, code: "695027" },
    { id: 38806, cityId: 1083, code: "695030" },
    { id: 38807, cityId: 1083, code: "695032" },
    { id: 38808, cityId: 1083, code: "695033" },
    { id: 38809, cityId: 1083, code: "695035" },
    { id: 38810, cityId: 1083, code: "695038" },
    { id: 38811, cityId: 1083, code: "695040" },
    { id: 38812, cityId: 1083, code: "695041" },
    { id: 38813, cityId: 1083, code: "695043" },
    { id: 38814, cityId: 1083, code: "695099" },
    { id: 38815, cityId: 1083, code: "695101" },
    { id: 38816, cityId: 1083, code: "695104" },
    { id: 38817, cityId: 1083, code: "695122" },
    { id: 38818, cityId: 1083, code: "695123" },
    { id: 38819, cityId: 1083, code: "695125" },
    { id: 38820, cityId: 1083, code: "695128" },
    { id: 38821, cityId: 1083, code: "695130" },
    { id: 38822, cityId: 1083, code: "695131" },
    { id: 38823, cityId: 1083, code: "695133" },
    { id: 38824, cityId: 1083, code: "695141" },
    { id: 38825, cityId: 1083, code: "695144" },
    { id: 38826, cityId: 1083, code: "695146" },
    { id: 38827, cityId: 1083, code: "695302" },
    { id: 38828, cityId: 1083, code: "695303" },
    { id: 38829, cityId: 1083, code: "695305" },
    { id: 38830, cityId: 1083, code: "695308" },
    { id: 38831, cityId: 1083, code: "695310" },
    { id: 38832, cityId: 1083, code: "695311" },
    { id: 38833, cityId: 1083, code: "695313" },
    { id: 38834, cityId: 1083, code: "695316" },
    { id: 38835, cityId: 1083, code: "695318" },
    { id: 38836, cityId: 1083, code: "695501" },
    { id: 38837, cityId: 1083, code: "695504" },
    { id: 38838, cityId: 1083, code: "695506" },
    { id: 38839, cityId: 1083, code: "695507" },
    { id: 38840, cityId: 1083, code: "695509" },
    { id: 38841, cityId: 1083, code: "695512" },
    { id: 38842, cityId: 1083, code: "695522" },
    { id: 38843, cityId: 1083, code: "695523" },
    { id: 38844, cityId: 1083, code: "695525" },
    { id: 38845, cityId: 1083, code: "695541" },
    { id: 38846, cityId: 1083, code: "695543" },
    { id: 38847, cityId: 1083, code: "695544" },
    { id: 38848, cityId: 1083, code: "695551" },
    { id: 38849, cityId: 1083, code: "695562" },
    { id: 38850, cityId: 1083, code: "695568" },
    { id: 38851, cityId: 1083, code: "695573" },
    { id: 38852, cityId: 1083, code: "695575" },
    { id: 38853, cityId: 1083, code: "695581" },
    { id: 38854, cityId: 1083, code: "695583" },
    { id: 38855, cityId: 1083, code: "695586" },
    { id: 38856, cityId: 1083, code: "695588" },
    { id: 38857, cityId: 1083, code: "695602" },
    { id: 38858, cityId: 1083, code: "695604" },
    { id: 38859, cityId: 1083, code: "695605" },
    { id: 38860, cityId: 1083, code: "695607" },
    { id: 38861, cityId: 1083, code: "695610" },
    { id: 38862, cityId: 1083, code: "695612" },
    { id: 38863, cityId: 1083, code: "695615" },
    { id: 38864, cityId: 1083, code: "685551" },
    { id: 38865, cityId: 1083, code: "695002" },
    { id: 38866, cityId: 1083, code: "695004" },
    { id: 38867, cityId: 1083, code: "695005" },
    { id: 38868, cityId: 1083, code: "695007" },
    { id: 38869, cityId: 1083, code: "695010" },
    { id: 38870, cityId: 1083, code: "695012" },
    { id: 38871, cityId: 1083, code: "695013" },
    { id: 38872, cityId: 1083, code: "695015" },
    { id: 38873, cityId: 1083, code: "695018" },
    { id: 38874, cityId: 1083, code: "695020" },
    { id: 38875, cityId: 1083, code: "695021" },
    { id: 38876, cityId: 1083, code: "695023" },
    { id: 38877, cityId: 1083, code: "695026" },
    { id: 38878, cityId: 1083, code: "695028" },
    { id: 38879, cityId: 1083, code: "695029" },
    { id: 38880, cityId: 1083, code: "695031" },
    { id: 38881, cityId: 1083, code: "695034" },
    { id: 38882, cityId: 1083, code: "695036" },
    { id: 38883, cityId: 1083, code: "695037" },
    { id: 38884, cityId: 1083, code: "695039" },
    { id: 38885, cityId: 1083, code: "695042" },
    { id: 38886, cityId: 1083, code: "695044" },
    { id: 38887, cityId: 1083, code: "695102" },
    { id: 38888, cityId: 1083, code: "695103" },
    { id: 38889, cityId: 1083, code: "695126" },
    { id: 38890, cityId: 1083, code: "695127" },
    { id: 38891, cityId: 1083, code: "695132" },
    { id: 38892, cityId: 1083, code: "695142" },
    { id: 38893, cityId: 1083, code: "695143" },
    { id: 38894, cityId: 1083, code: "695145" },
    { id: 38895, cityId: 1083, code: "695301" },
    { id: 38896, cityId: 1083, code: "695304" },
    { id: 38897, cityId: 1083, code: "695307" },
    { id: 38898, cityId: 1083, code: "695309" },
    { id: 38899, cityId: 1083, code: "695312" },
    { id: 38900, cityId: 1083, code: "695314" },
    { id: 38901, cityId: 1083, code: "695317" },
    { id: 38902, cityId: 1083, code: "695502" },
    { id: 38903, cityId: 1083, code: "695503" },
    { id: 38904, cityId: 1083, code: "695505" },
    { id: 38905, cityId: 1083, code: "695508" },
    { id: 38906, cityId: 1083, code: "695510" },
    { id: 38907, cityId: 1083, code: "695513" },
    { id: 38908, cityId: 1083, code: "695521" },
    { id: 38909, cityId: 1083, code: "695524" },
    { id: 38910, cityId: 1083, code: "695526" },
    { id: 38911, cityId: 1083, code: "695527" },
    { id: 38912, cityId: 1083, code: "695542" },
    { id: 38913, cityId: 1083, code: "695547" },
    { id: 38914, cityId: 1083, code: "695561" },
    { id: 38915, cityId: 1083, code: "695563" },
    { id: 38916, cityId: 1083, code: "695564" },
    { id: 38917, cityId: 1083, code: "695572" },
    { id: 38918, cityId: 1083, code: "695574" },
    { id: 38919, cityId: 1083, code: "695582" },
    { id: 38920, cityId: 1083, code: "695584" },
    { id: 38921, cityId: 1083, code: "695585" },
    { id: 38922, cityId: 1083, code: "695587" },
    { id: 38923, cityId: 1083, code: "695601" },
    { id: 38924, cityId: 1083, code: "695603" },
    { id: 38925, cityId: 1083, code: "695606" },
    { id: 38926, cityId: 1083, code: "695608" },
    { id: 38927, cityId: 1083, code: "695609" },
    { id: 38928, cityId: 1083, code: "695611" },
    { id: 38929, cityId: 1083, code: "695614" },
    { id: 38930, cityId: 1083, code: "695616" },
    { id: 38931, cityId: 1084, code: "671319" },
    { id: 38932, cityId: 1085, code: "685552" },
    { id: 38933, cityId: 1085, code: "685563" },
    { id: 38934, cityId: 1085, code: "685602" },
    { id: 38935, cityId: 1085, code: "685618" },
    { id: 38936, cityId: 1085, code: "685619" },
    { id: 38937, cityId: 1085, code: "685554" },
    { id: 38938, cityId: 1086, code: "673101" },
    { id: 38939, cityId: 1087, code: "686632" },
    { id: 38940, cityId: 1087, code: "686664" },
    { id: 38941, cityId: 1087, code: "686141" },
    { id: 38942, cityId: 1087, code: "686144" },
    { id: 38943, cityId: 1087, code: "686605" },
    { id: 38944, cityId: 1088, code: "670010" },
    { id: 38945, cityId: 1089, code: "680562" },
    { id: 38946, cityId: 1090, code: "670594" },
    { id: 38947, cityId: 1091, code: "695141" },
    { id: 38948, cityId: 1092, code: "673121" },
    { id: 38949, cityId: 1092, code: "673575" },
    { id: 38950, cityId: 1093, code: "670645" },
    { id: 38951, cityId: 1093, code: "670732" },
    { id: 38952, cityId: 1093, code: "673121" },
    { id: 38953, cityId: 1093, code: "673124" },
    { id: 38954, cityId: 1093, code: "673577" },
    { id: 38955, cityId: 1093, code: "673579" },
    { id: 38956, cityId: 1093, code: "673595" },
    { id: 38957, cityId: 1093, code: "673596" },
    { id: 38958, cityId: 1093, code: "673603" },
    { id: 38959, cityId: 1093, code: "670646" },
    { id: 38960, cityId: 1093, code: "670721" },
    { id: 38961, cityId: 1093, code: "673122" },
    { id: 38962, cityId: 1093, code: "673123" },
    { id: 38963, cityId: 1093, code: "673575" },
    { id: 38964, cityId: 1093, code: "673576" },
    { id: 38965, cityId: 1093, code: "673578" },
    { id: 38966, cityId: 1093, code: "673592" },
    { id: 38967, cityId: 1094, code: "682555" },
    { id: 38968, cityId: 1094, code: "682557" },
    { id: 38969, cityId: 1094, code: "682558" },
    { id: 38970, cityId: 1094, code: "682556" },
    { id: 38971, cityId: 1094, code: "682559" },
    { id: 38972, cityId: 1095, code: "481001" },
    { id: 38973, cityId: 1095, code: "481022" },
    { id: 38974, cityId: 1095, code: "481051" },
    { id: 38975, cityId: 1095, code: "481115" },
    { id: 38976, cityId: 1095, code: "481117" },
    { id: 38977, cityId: 1095, code: "481125" },
    { id: 38978, cityId: 1095, code: "481332" },
    { id: 38979, cityId: 1095, code: "481335" },
    { id: 38980, cityId: 1095, code: "481441" },
    { id: 38981, cityId: 1095, code: "481554" },
    { id: 38982, cityId: 1095, code: "481116" },
    { id: 38983, cityId: 1095, code: "481222" },
    { id: 38984, cityId: 1095, code: "481551" },
    { id: 38985, cityId: 1096, code: "465661" },
    { id: 38986, cityId: 1096, code: "465677" },
    { id: 38987, cityId: 1096, code: "465670" },
    { id: 38988, cityId: 1096, code: "465697" },
    { id: 38989, cityId: 1097, code: "488220" },
    { id: 38990, cityId: 1098, code: "477332" },
    { id: 38991, cityId: 1099, code: "457887" },
    { id: 38992, cityId: 1100, code: "488441" },
    { id: 38993, cityId: 1101, code: "480221" },
    { id: 38994, cityId: 1102, code: "476111" },
    { id: 38995, cityId: 1103, code: "460551" },
    { id: 38996, cityId: 1104, code: "473331" },
    { id: 38997, cityId: 1105, code: "454660" },
    { id: 38998, cityId: 1106, code: "454221" },
    { id: 38999, cityId: 1107, code: "455227" },
    { id: 39000, cityId: 1108, code: "481111" },
    { id: 39001, cityId: 1109, code: "804428" },
    { id: 39002, cityId: 1109, code: "486441" },
    { id: 39003, cityId: 1109, code: "497335" },
    { id: 39004, cityId: 1110, code: "470672" },
    { id: 39005, cityId: 1111, code: "483001" },
    { id: 39006, cityId: 1112, code: "477556" },
    { id: 39007, cityId: 1113, code: "451551" },
    { id: 39008, cityId: 1113, code: "451552" },
    { id: 39009, cityId: 1113, code: "451555" },
    { id: 39010, cityId: 1113, code: "451557" },
    { id: 39011, cityId: 1113, code: "451558" },
    { id: 39012, cityId: 1113, code: "451660" },
    { id: 39013, cityId: 1113, code: "451669" },
    { id: 39014, cityId: 1113, code: "451695" },
    { id: 39015, cityId: 1114, code: "453001" },
    { id: 39016, cityId: 1115, code: "460001" },
    { id: 39017, cityId: 1115, code: "460220" },
    { id: 39018, cityId: 1115, code: "460443" },
    { id: 39019, cityId: 1115, code: "460551" },
    { id: 39020, cityId: 1115, code: "460554" },
    { id: 39021, cityId: 1115, code: "460557" },
    { id: 39022, cityId: 1115, code: "460663" },
    { id: 39023, cityId: 1115, code: "460665" },
    { id: 39024, cityId: 1115, code: "460668" },
    { id: 39025, cityId: 1115, code: "460002" },
    { id: 39026, cityId: 1115, code: "460004" },
    { id: 39027, cityId: 1115, code: "460005" },
    { id: 39028, cityId: 1115, code: "460225" },
    { id: 39029, cityId: 1115, code: "460330" },
    { id: 39030, cityId: 1115, code: "460444" },
    { id: 39031, cityId: 1115, code: "460449" },
    { id: 39032, cityId: 1115, code: "460553" },
    { id: 39033, cityId: 1115, code: "460661" },
    { id: 39034, cityId: 1115, code: "460666" },
    { id: 39035, cityId: 1116, code: "475335" },
    { id: 39036, cityId: 1117, code: "481102" },
    { id: 39037, cityId: 1118, code: "482053" },
    { id: 39038, cityId: 1119, code: "477001" },
    { id: 39039, cityId: 1119, code: "477105" },
    { id: 39040, cityId: 1119, code: "477227" },
    { id: 39041, cityId: 1119, code: "477333" },
    { id: 39042, cityId: 1119, code: "477335" },
    { id: 39043, cityId: 1119, code: "477111" },
    { id: 39044, cityId: 1119, code: "477331" },
    { id: 39045, cityId: 1120, code: "475220" },
    { id: 39046, cityId: 1121, code: "462002" },
    { id: 39047, cityId: 1121, code: "462007" },
    { id: 39048, cityId: 1121, code: "462008" },
    { id: 39049, cityId: 1121, code: "462010" },
    { id: 39050, cityId: 1121, code: "462013" },
    { id: 39051, cityId: 1121, code: "462015" },
    { id: 39052, cityId: 1121, code: "462016" },
    { id: 39053, cityId: 1121, code: "462018" },
    { id: 39054, cityId: 1121, code: "462021" },
    { id: 39055, cityId: 1121, code: "462023" },
    { id: 39056, cityId: 1121, code: "462026" },
    { id: 39057, cityId: 1121, code: "462031" },
    { id: 39058, cityId: 1121, code: "462036" },
    { id: 39059, cityId: 1121, code: "463120" },
    { id: 39060, cityId: 1121, code: "462001" },
    { id: 39061, cityId: 1121, code: "462003" },
    { id: 39062, cityId: 1121, code: "462004" },
    { id: 39063, cityId: 1121, code: "462006" },
    { id: 39064, cityId: 1121, code: "462011" },
    { id: 39065, cityId: 1121, code: "462012" },
    { id: 39066, cityId: 1121, code: "462024" },
    { id: 39067, cityId: 1121, code: "462030" },
    { id: 39068, cityId: 1121, code: "462032" },
    { id: 39069, cityId: 1121, code: "463111" },
    { id: 39070, cityId: 1122, code: "465674" },
    { id: 39071, cityId: 1123, code: "465685" },
    { id: 39072, cityId: 1124, code: "450331" },
    { id: 39073, cityId: 1125, code: "471318" },
    { id: 39074, cityId: 1126, code: "471525" },
    { id: 39075, cityId: 1127, code: "471101" },
    { id: 39076, cityId: 1127, code: "471201" },
    { id: 39077, cityId: 1127, code: "471313" },
    { id: 39078, cityId: 1127, code: "471408" },
    { id: 39079, cityId: 1127, code: "471411" },
    { id: 39080, cityId: 1127, code: "471001" },
    { id: 39081, cityId: 1127, code: "471105" },
    { id: 39082, cityId: 1127, code: "471202" },
    { id: 39083, cityId: 1127, code: "471301" },
    { id: 39084, cityId: 1127, code: "471311" },
    { id: 39085, cityId: 1127, code: "471401" },
    { id: 39086, cityId: 1127, code: "471505" },
    { id: 39087, cityId: 1127, code: "471510" },
    { id: 39088, cityId: 1128, code: "480002" },
    { id: 39089, cityId: 1128, code: "480111" },
    { id: 39090, cityId: 1128, code: "480116" },
    { id: 39091, cityId: 1128, code: "480223" },
    { id: 39092, cityId: 1128, code: "480228" },
    { id: 39093, cityId: 1128, code: "480331" },
    { id: 39094, cityId: 1128, code: "480334" },
    { id: 39095, cityId: 1128, code: "480447" },
    { id: 39096, cityId: 1128, code: "480551" },
    { id: 39097, cityId: 1128, code: "480553" },
    { id: 39098, cityId: 1128, code: "480554" },
    { id: 39099, cityId: 1128, code: "480559" },
    { id: 39100, cityId: 1128, code: "480001" },
    { id: 39101, cityId: 1128, code: "480107" },
    { id: 39102, cityId: 1128, code: "480110" },
    { id: 39103, cityId: 1128, code: "480115" },
    { id: 39104, cityId: 1128, code: "480224" },
    { id: 39105, cityId: 1128, code: "480337" },
    { id: 39106, cityId: 1128, code: "480338" },
    { id: 39107, cityId: 1128, code: "480443" },
    { id: 39108, cityId: 1128, code: "480449" },
    { id: 39109, cityId: 1128, code: "480557" },
    { id: 39110, cityId: 1129, code: "487770" },
    { id: 39111, cityId: 1130, code: "477447" },
    { id: 39112, cityId: 1131, code: "475110" },
    { id: 39113, cityId: 1132, code: "470662" },
    { id: 39114, cityId: 1132, code: "470880" },
    { id: 39115, cityId: 1132, code: "470661" },
    { id: 39116, cityId: 1132, code: "470664" },
    { id: 39117, cityId: 1132, code: "470772" },
    { id: 39118, cityId: 1132, code: "470775" },
    { id: 39119, cityId: 1132, code: "470881" },
    { id: 39120, cityId: 1133, code: "475661" },
    { id: 39121, cityId: 1133, code: "475668" },
    { id: 39122, cityId: 1133, code: "475671" },
    { id: 39123, cityId: 1133, code: "475677" },
    { id: 39124, cityId: 1133, code: "475684" },
    { id: 39125, cityId: 1133, code: "475693" },
    { id: 39126, cityId: 1133, code: "475673" },
    { id: 39127, cityId: 1133, code: "475675" },
    { id: 39128, cityId: 1133, code: "475686" },
    { id: 39129, cityId: 1134, code: "453115" },
    { id: 39130, cityId: 1135, code: "455111" },
    { id: 39131, cityId: 1135, code: "455116" },
    { id: 39132, cityId: 1135, code: "455119" },
    { id: 39133, cityId: 1135, code: "455302" },
    { id: 39134, cityId: 1135, code: "455339" },
    { id: 39135, cityId: 1135, code: "455001" },
    { id: 39136, cityId: 1135, code: "455003" },
    { id: 39137, cityId: 1135, code: "455048" },
    { id: 39138, cityId: 1135, code: "455112" },
    { id: 39139, cityId: 1135, code: "455117" },
    { id: 39140, cityId: 1135, code: "455118" },
    { id: 39141, cityId: 1135, code: "455178" },
    { id: 39142, cityId: 1135, code: "455223" },
    { id: 39143, cityId: 1135, code: "455440" },
    { id: 39144, cityId: 1136, code: "454552" },
    { id: 39145, cityId: 1137, code: "451220" },
    { id: 39146, cityId: 1137, code: "454276" },
    { id: 39147, cityId: 1137, code: "454345" },
    { id: 39148, cityId: 1137, code: "454350" },
    { id: 39149, cityId: 1137, code: "454448" },
    { id: 39150, cityId: 1137, code: "454554" },
    { id: 39151, cityId: 1137, code: "454665" },
    { id: 39152, cityId: 1137, code: "454668" },
    { id: 39153, cityId: 1137, code: "454729" },
    { id: 39154, cityId: 1137, code: "480001" },
    { id: 39155, cityId: 1137, code: "451115" },
    { id: 39156, cityId: 1137, code: "451117" },
    { id: 39157, cityId: 1137, code: "451335" },
    { id: 39158, cityId: 1137, code: "451451" },
    { id: 39159, cityId: 1137, code: "454010" },
    { id: 39160, cityId: 1137, code: "454129" },
    { id: 39161, cityId: 1137, code: "454333" },
    { id: 39162, cityId: 1137, code: "454341" },
    { id: 39163, cityId: 1137, code: "454365" },
    { id: 39164, cityId: 1137, code: "454441" },
    { id: 39165, cityId: 1137, code: "454571" },
    { id: 39166, cityId: 1137, code: "454648" },
    { id: 39167, cityId: 1137, code: "454666" },
    { id: 39168, cityId: 1137, code: "454667" },
    { id: 39169, cityId: 1137, code: "454669" },
    { id: 39170, cityId: 1137, code: "454730" },
    { id: 39171, cityId: 1137, code: "454749" },
    { id: 39172, cityId: 1137, code: "454773" },
    { id: 39173, cityId: 1138, code: "454449" },
    { id: 39174, cityId: 1139, code: "481990" },
    { id: 39175, cityId: 1140, code: "487551" },
    { id: 39176, cityId: 1141, code: "464884" },
    { id: 39177, cityId: 1142, code: "477116" },
    { id: 39178, cityId: 1143, code: "477660" },
    { id: 39179, cityId: 1144, code: "486550" },
    { id: 39180, cityId: 1145, code: "473101" },
    { id: 39181, cityId: 1145, code: "473249" },
    { id: 39182, cityId: 1145, code: "473440" },
    { id: 39183, cityId: 1145, code: "473001" },
    { id: 39184, cityId: 1145, code: "473105" },
    { id: 39185, cityId: 1145, code: "473110" },
    { id: 39186, cityId: 1145, code: "473118" },
    { id: 39187, cityId: 1145, code: "473226" },
    { id: 39188, cityId: 1145, code: "473229" },
    { id: 39189, cityId: 1145, code: "473287" },
    { id: 39190, cityId: 1145, code: "473330" },
    { id: 39191, cityId: 1145, code: "473333" },
    { id: 39192, cityId: 1145, code: "473335" },
    { id: 39193, cityId: 1145, code: "473338" },
    { id: 39194, cityId: 1146, code: "486553" },
    { id: 39195, cityId: 1147, code: "474002" },
    { id: 39196, cityId: 1147, code: "474004" },
    { id: 39197, cityId: 1147, code: "474005" },
    { id: 39198, cityId: 1147, code: "474007" },
    { id: 39199, cityId: 1147, code: "474010" },
    { id: 39200, cityId: 1147, code: "474020" },
    { id: 39201, cityId: 1147, code: "474042" },
    { id: 39202, cityId: 1147, code: "474055" },
    { id: 39203, cityId: 1147, code: "474001" },
    { id: 39204, cityId: 1147, code: "474003" },
    { id: 39205, cityId: 1147, code: "474006" },
    { id: 39206, cityId: 1147, code: "474008" },
    { id: 39207, cityId: 1147, code: "474009" },
    { id: 39208, cityId: 1147, code: "474040" },
    { id: 39209, cityId: 1147, code: "475001" },
    { id: 39210, cityId: 1147, code: "475002" },
    { id: 39211, cityId: 1147, code: "475336" },
    { id: 39212, cityId: 1148, code: "461331" },
    { id: 39213, cityId: 1149, code: "471111" },
    { id: 39214, cityId: 1150, code: "450116" },
    { id: 39215, cityId: 1151, code: "481226" },
    { id: 39216, cityId: 1152, code: "470771" },
    { id: 39217, cityId: 1153, code: "461005" },
    { id: 39218, cityId: 1153, code: "461111" },
    { id: 39219, cityId: 1153, code: "461114" },
    { id: 39220, cityId: 1153, code: "461116" },
    { id: 39221, cityId: 1153, code: "461224" },
    { id: 39222, cityId: 1153, code: "461225" },
    { id: 39223, cityId: 1153, code: "461251" },
    { id: 39224, cityId: 1153, code: "461444" },
    { id: 39225, cityId: 1153, code: "461551" },
    { id: 39226, cityId: 1153, code: "461555" },
    { id: 39227, cityId: 1153, code: "461881" },
    { id: 39228, cityId: 1153, code: "461001" },
    { id: 39229, cityId: 1153, code: "461110" },
    { id: 39230, cityId: 1153, code: "461115" },
    { id: 39231, cityId: 1153, code: "461221" },
    { id: 39232, cityId: 1153, code: "461335" },
    { id: 39233, cityId: 1153, code: "461427" },
    { id: 39234, cityId: 1153, code: "461446" },
    { id: 39235, cityId: 1153, code: "461772" },
    { id: 39236, cityId: 1154, code: "452002" },
    { id: 39237, cityId: 1154, code: "452005" },
    { id: 39238, cityId: 1154, code: "452008" },
    { id: 39239, cityId: 1154, code: "452056" },
    { id: 39240, cityId: 1154, code: "453441" },
    { id: 39241, cityId: 1154, code: "453446" },
    { id: 39242, cityId: 1154, code: "453562" },
    { id: 39243, cityId: 1154, code: "453576" },
    { id: 39244, cityId: 1154, code: "453652" },
    { id: 39245, cityId: 1154, code: "455115" },
    { id: 39246, cityId: 1154, code: "452001" },
    { id: 39247, cityId: 1154, code: "452004" },
    { id: 39248, cityId: 1154, code: "452006" },
    { id: 39249, cityId: 1154, code: "452009" },
    { id: 39250, cityId: 1154, code: "452012" },
    { id: 39251, cityId: 1154, code: "452020" },
    { id: 39252, cityId: 1154, code: "453220" },
    { id: 39253, cityId: 1154, code: "453235" },
    { id: 39254, cityId: 1154, code: "453331" },
    { id: 39255, cityId: 1154, code: "453463" },
    { id: 39256, cityId: 1154, code: "453643" },
    { id: 39257, cityId: 1155, code: "461111" },
    { id: 39258, cityId: 1156, code: "482002" },
    { id: 39259, cityId: 1156, code: "482005" },
    { id: 39260, cityId: 1156, code: "482007" },
    { id: 39261, cityId: 1156, code: "482010" },
    { id: 39262, cityId: 1156, code: "482020" },
    { id: 39263, cityId: 1156, code: "482050" },
    { id: 39264, cityId: 1156, code: "482053" },
    { id: 39265, cityId: 1156, code: "483105" },
    { id: 39266, cityId: 1156, code: "483110" },
    { id: 39267, cityId: 1156, code: "483222" },
    { id: 39268, cityId: 1156, code: "483442" },
    { id: 39269, cityId: 1156, code: "483773" },
    { id: 39270, cityId: 1156, code: "483775" },
    { id: 39271, cityId: 1156, code: "483990" },
    { id: 39272, cityId: 1156, code: "482001" },
    { id: 39273, cityId: 1156, code: "482003" },
    { id: 39274, cityId: 1156, code: "482004" },
    { id: 39275, cityId: 1156, code: "482006" },
    { id: 39276, cityId: 1156, code: "482009" },
    { id: 39277, cityId: 1156, code: "482011" },
    { id: 39278, cityId: 1156, code: "482051" },
    { id: 39279, cityId: 1156, code: "482056" },
    { id: 39280, cityId: 1156, code: "483220" },
    { id: 39281, cityId: 1156, code: "483225" },
    { id: 39282, cityId: 1156, code: "483332" },
    { id: 39283, cityId: 1156, code: "483334" },
    { id: 39284, cityId: 1156, code: "483445" },
    { id: 39285, cityId: 1156, code: "483501" },
    { id: 39286, cityId: 1156, code: "483504" },
    { id: 39287, cityId: 1156, code: "483880" },
    { id: 39288, cityId: 1157, code: "457770" },
    { id: 39289, cityId: 1157, code: "457882" },
    { id: 39290, cityId: 1157, code: "457885" },
    { id: 39291, cityId: 1157, code: "457661" },
    { id: 39292, cityId: 1157, code: "457775" },
    { id: 39293, cityId: 1158, code: "457990" },
    { id: 39294, cityId: 1159, code: "476221" },
    { id: 39295, cityId: 1160, code: "455332" },
    { id: 39296, cityId: 1161, code: "487221" },
    { id: 39297, cityId: 1162, code: "455221" },
    { id: 39298, cityId: 1163, code: "481445" },
    { id: 39299, cityId: 1164, code: "451661" },
    { id: 39300, cityId: 1164, code: "473001" },
    { id: 39301, cityId: 1164, code: "481556" },
    { id: 39302, cityId: 1164, code: "483331" },
    { id: 39303, cityId: 1164, code: "483440" },
    { id: 39304, cityId: 1164, code: "483330" },
    { id: 39305, cityId: 1164, code: "485666" },
    { id: 39306, cityId: 1165, code: "450052" },
    { id: 39307, cityId: 1165, code: "450053" },
    { id: 39308, cityId: 1165, code: "450111" },
    { id: 39309, cityId: 1165, code: "450114" },
    { id: 39310, cityId: 1165, code: "450124" },
    { id: 39311, cityId: 1165, code: "450220" },
    { id: 39312, cityId: 1165, code: "450331" },
    { id: 39313, cityId: 1165, code: "450333" },
    { id: 39314, cityId: 1165, code: "450334" },
    { id: 39315, cityId: 1165, code: "450554" },
    { id: 39316, cityId: 1165, code: "450991" },
    { id: 39317, cityId: 1165, code: "450001" },
    { id: 39318, cityId: 1165, code: "450006" },
    { id: 39319, cityId: 1165, code: "450051" },
    { id: 39320, cityId: 1165, code: "450110" },
    { id: 39321, cityId: 1165, code: "450115" },
    { id: 39322, cityId: 1165, code: "450117" },
    { id: 39323, cityId: 1165, code: "450118" },
    { id: 39324, cityId: 1165, code: "450223" },
    { id: 39325, cityId: 1165, code: "450327" },
    { id: 39326, cityId: 1165, code: "450332" },
    { id: 39327, cityId: 1165, code: "450335" },
    { id: 39328, cityId: 1165, code: "450337" },
    { id: 39329, cityId: 1165, code: "450441" },
    { id: 39330, cityId: 1165, code: "450551" },
    { id: 39331, cityId: 1165, code: "450771" },
    { id: 39332, cityId: 1165, code: "450881" },
    { id: 39333, cityId: 1165, code: "451332" },
    { id: 39334, cityId: 1165, code: "451449" },
    { id: 39335, cityId: 1166, code: "451111" },
    { id: 39336, cityId: 1166, code: "451222" },
    { id: 39337, cityId: 1166, code: "451228" },
    { id: 39338, cityId: 1166, code: "451331" },
    { id: 39339, cityId: 1166, code: "451440" },
    { id: 39340, cityId: 1166, code: "451442" },
    { id: 39341, cityId: 1166, code: "451448" },
    { id: 39342, cityId: 1166, code: "451556" },
    { id: 39343, cityId: 1166, code: "451559" },
    { id: 39344, cityId: 1166, code: "451659" },
    { id: 39345, cityId: 1166, code: "451664" },
    { id: 39346, cityId: 1166, code: "451665" },
    { id: 39347, cityId: 1166, code: "451667" },
    { id: 39348, cityId: 1166, code: "456551" },
    { id: 39349, cityId: 1166, code: "451001" },
    { id: 39350, cityId: 1166, code: "451110" },
    { id: 39351, cityId: 1166, code: "451112" },
    { id: 39352, cityId: 1166, code: "451113" },
    { id: 39353, cityId: 1166, code: "451115" },
    { id: 39354, cityId: 1166, code: "451223" },
    { id: 39355, cityId: 1166, code: "451224" },
    { id: 39356, cityId: 1166, code: "451229" },
    { id: 39357, cityId: 1166, code: "451239" },
    { id: 39358, cityId: 1166, code: "451327" },
    { id: 39359, cityId: 1166, code: "451337" },
    { id: 39360, cityId: 1166, code: "451435" },
    { id: 39361, cityId: 1166, code: "451443" },
    { id: 39362, cityId: 1166, code: "451444" },
    { id: 39363, cityId: 1166, code: "451563" },
    { id: 39364, cityId: 1166, code: "451663" },
    { id: 39365, cityId: 1167, code: "455336" },
    { id: 39366, cityId: 1168, code: "451881" },
    { id: 39367, cityId: 1169, code: "454331" },
    { id: 39368, cityId: 1170, code: "477445" },
    { id: 39369, cityId: 1171, code: "471515" },
    { id: 39370, cityId: 1172, code: "471501" },
    { id: 39371, cityId: 1173, code: "486666" },
    { id: 39372, cityId: 1174, code: "458110" },
    { id: 39373, cityId: 1175, code: "454446" },
    { id: 39374, cityId: 1176, code: "458002" },
    { id: 39375, cityId: 1176, code: "458113" },
    { id: 39376, cityId: 1176, code: "458116" },
    { id: 39377, cityId: 1176, code: "458118" },
    { id: 39378, cityId: 1176, code: "458224" },
    { id: 39379, cityId: 1176, code: "458272" },
    { id: 39380, cityId: 1176, code: "458330" },
    { id: 39381, cityId: 1176, code: "458468" },
    { id: 39382, cityId: 1176, code: "458558" },
    { id: 39383, cityId: 1176, code: "458595" },
    { id: 39384, cityId: 1176, code: "458990" },
    { id: 39385, cityId: 1176, code: "458001" },
    { id: 39386, cityId: 1176, code: "458220" },
    { id: 39387, cityId: 1176, code: "458228" },
    { id: 39388, cityId: 1176, code: "458588" },
    { id: 39389, cityId: 1176, code: "458676" },
    { id: 39390, cityId: 1176, code: "470441" },
    { id: 39391, cityId: 1177, code: "462046" },
    { id: 39392, cityId: 1178, code: "481662" },
    { id: 39393, cityId: 1178, code: "481665" },
    { id: 39394, cityId: 1178, code: "481771" },
    { id: 39395, cityId: 1178, code: "481776" },
    { id: 39396, cityId: 1178, code: "481879" },
    { id: 39397, cityId: 1178, code: "481885" },
    { id: 39398, cityId: 1178, code: "481980" },
    { id: 39399, cityId: 1178, code: "481993" },
    { id: 39400, cityId: 1178, code: "481584" },
    { id: 39401, cityId: 1178, code: "481661" },
    { id: 39402, cityId: 1178, code: "481663" },
    { id: 39403, cityId: 1178, code: "481778" },
    { id: 39404, cityId: 1178, code: "481995" },
    { id: 39405, cityId: 1179, code: "451221" },
    { id: 39406, cityId: 1180, code: "486111" },
    { id: 39407, cityId: 1181, code: "453661" },
    { id: 39408, cityId: 1182, code: "477222" },
    { id: 39409, cityId: 1183, code: "486331" },
    { id: 39410, cityId: 1184, code: "457779" },
    { id: 39411, cityId: 1185, code: "477557" },
    { id: 39412, cityId: 1186, code: "477441" },
    { id: 39413, cityId: 1187, code: "480105" },
    { id: 39414, cityId: 1188, code: "476001" },
    { id: 39415, cityId: 1188, code: "476224" },
    { id: 39416, cityId: 1188, code: "476229" },
    { id: 39417, cityId: 1188, code: "476235" },
    { id: 39418, cityId: 1188, code: "476228" },
    { id: 39419, cityId: 1188, code: "476337" },
    { id: 39420, cityId: 1188, code: "476339" },
    { id: 39421, cityId: 1188, code: "476345" },
    { id: 39422, cityId: 1189, code: "460661" },
    { id: 39423, cityId: 1190, code: "450112" },
    { id: 39424, cityId: 1191, code: "473443" },
    { id: 39425, cityId: 1192, code: "457222" },
    { id: 39426, cityId: 1193, code: "487114" },
    { id: 39427, cityId: 1193, code: "487225" },
    { id: 39428, cityId: 1193, code: "487885" },
    { id: 39429, cityId: 1193, code: "487001" },
    { id: 39430, cityId: 1193, code: "487110" },
    { id: 39431, cityId: 1193, code: "487118" },
    { id: 39432, cityId: 1193, code: "487441" },
    { id: 39433, cityId: 1193, code: "487881" },
    { id: 39434, cityId: 1194, code: "458553" },
    { id: 39435, cityId: 1195, code: "470675" },
    { id: 39436, cityId: 1196, code: "458474" },
    { id: 39437, cityId: 1196, code: "458441" },
    { id: 39438, cityId: 1196, code: "458442" },
    { id: 39439, cityId: 1197, code: "450221" },
    { id: 39440, cityId: 1198, code: "461881" },
    { id: 39441, cityId: 1199, code: "465683" },
    { id: 39442, cityId: 1200, code: "450661" },
    { id: 39443, cityId: 1201, code: "488001" },
    { id: 39444, cityId: 1201, code: "488051" },
    { id: 39445, cityId: 1201, code: "488050" },
    { id: 39446, cityId: 1201, code: "488442" },
    { id: 39447, cityId: 1202, code: "451770" },
    { id: 39448, cityId: 1203, code: "364292" },
    { id: 39449, cityId: 1203, code: "384110" },
    { id: 39450, cityId: 1203, code: "384256" },
    { id: 39451, cityId: 1203, code: "384277" },
    { id: 39452, cityId: 1203, code: "415206" },
    { id: 39453, cityId: 1203, code: "384112" },
    { id: 39454, cityId: 1203, code: "384255" },
    { id: 39455, cityId: 1203, code: "384260" },
    { id: 39456, cityId: 1203, code: "384265" },
    { id: 39457, cityId: 1203, code: "384271" },
    { id: 39458, cityId: 1203, code: "384276" },
    { id: 39459, cityId: 1203, code: "384278" },
    { id: 39460, cityId: 1203, code: "483113" },
    { id: 39461, cityId: 1203, code: "491111" },
    { id: 39462, cityId: 1204, code: "470666" },
    { id: 39463, cityId: 1205, code: "476115" },
    { id: 39464, cityId: 1206, code: "464551" },
    { id: 39465, cityId: 1206, code: "464556" },
    { id: 39466, cityId: 1206, code: "464665" },
    { id: 39467, cityId: 1206, code: "464668" },
    { id: 39468, cityId: 1206, code: "464670" },
    { id: 39469, cityId: 1206, code: "464774" },
    { id: 39470, cityId: 1206, code: "464776" },
    { id: 39471, cityId: 1206, code: "464993" },
    { id: 39472, cityId: 1206, code: "464573" },
    { id: 39473, cityId: 1206, code: "464651" },
    { id: 39474, cityId: 1206, code: "464671" },
    { id: 39475, cityId: 1206, code: "464990" },
    { id: 39476, cityId: 1206, code: "464995" },
    { id: 39477, cityId: 1207, code: "454116" },
    { id: 39478, cityId: 1207, code: "173101" },
    { id: 39479, cityId: 1208, code: "471625" },
    { id: 39480, cityId: 1209, code: "451447" },
    { id: 39481, cityId: 1210, code: "457993" },
    { id: 39482, cityId: 1211, code: "331022" },
    { id: 39483, cityId: 1211, code: "458226" },
    { id: 39484, cityId: 1212, code: "457111" },
    { id: 39485, cityId: 1212, code: "457227" },
    { id: 39486, cityId: 1212, code: "457333" },
    { id: 39487, cityId: 1212, code: "457336" },
    { id: 39488, cityId: 1212, code: "457441" },
    { id: 39489, cityId: 1212, code: "457552" },
    { id: 39490, cityId: 1212, code: "457555" },
    { id: 39491, cityId: 1212, code: "457001" },
    { id: 39492, cityId: 1212, code: "457114" },
    { id: 39493, cityId: 1212, code: "457226" },
    { id: 39494, cityId: 1212, code: "457339" },
    { id: 39495, cityId: 1212, code: "457551" },
    { id: 39496, cityId: 1212, code: "457769" },
    { id: 39497, cityId: 1213, code: "485881" },
    { id: 39498, cityId: 1213, code: "486002" },
    { id: 39499, cityId: 1213, code: "486220" },
    { id: 39500, cityId: 1213, code: "486223" },
    { id: 39501, cityId: 1213, code: "486228" },
    { id: 39502, cityId: 1213, code: "486333" },
    { id: 39503, cityId: 1213, code: "486341" },
    { id: 39504, cityId: 1213, code: "486342" },
    { id: 39505, cityId: 1213, code: "486442" },
    { id: 39506, cityId: 1213, code: "486445" },
    { id: 39507, cityId: 1213, code: "486448" },
    { id: 39508, cityId: 1213, code: "486556" },
    { id: 39509, cityId: 1213, code: "486001" },
    { id: 39510, cityId: 1213, code: "486004" },
    { id: 39511, cityId: 1213, code: "486006" },
    { id: 39512, cityId: 1213, code: "486112" },
    { id: 39513, cityId: 1213, code: "486113" },
    { id: 39514, cityId: 1213, code: "486115" },
    { id: 39515, cityId: 1213, code: "486123" },
    { id: 39516, cityId: 1213, code: "486226" },
    { id: 39517, cityId: 1213, code: "486338" },
    { id: 39518, cityId: 1213, code: "486340" },
    { id: 39519, cityId: 1213, code: "486343" },
    { id: 39520, cityId: 1213, code: "486444" },
    { id: 39521, cityId: 1213, code: "486449" },
    { id: 39522, cityId: 1213, code: "486536" },
    { id: 39523, cityId: 1213, code: "486552" },
    { id: 39524, cityId: 1214, code: "476229" },
    { id: 39525, cityId: 1215, code: "470001" },
    { id: 39526, cityId: 1215, code: "470003" },
    { id: 39527, cityId: 1215, code: "470051" },
    { id: 39528, cityId: 1215, code: "470115" },
    { id: 39529, cityId: 1215, code: "470117" },
    { id: 39530, cityId: 1215, code: "470120" },
    { id: 39531, cityId: 1215, code: "470122" },
    { id: 39532, cityId: 1215, code: "470125" },
    { id: 39533, cityId: 1215, code: "470221" },
    { id: 39534, cityId: 1215, code: "470223" },
    { id: 39535, cityId: 1215, code: "470226" },
    { id: 39536, cityId: 1215, code: "470228" },
    { id: 39537, cityId: 1215, code: "470229" },
    { id: 39538, cityId: 1215, code: "470335" },
    { id: 39539, cityId: 1215, code: "470337" },
    { id: 39540, cityId: 1215, code: "577128" },
    { id: 39541, cityId: 1215, code: "577412" },
    { id: 39542, cityId: 1215, code: "577417" },
    { id: 39543, cityId: 1215, code: "470002" },
    { id: 39544, cityId: 1215, code: "470005" },
    { id: 39545, cityId: 1215, code: "470111" },
    { id: 39546, cityId: 1215, code: "470113" },
    { id: 39547, cityId: 1215, code: "470118" },
    { id: 39548, cityId: 1215, code: "470119" },
    { id: 39549, cityId: 1215, code: "470227" },
    { id: 39550, cityId: 1215, code: "470230" },
    { id: 39551, cityId: 1215, code: "470235" },
    { id: 39552, cityId: 1215, code: "470339" },
    { id: 39553, cityId: 1215, code: "470442" },
    { id: 39554, cityId: 1215, code: "470669" },
    { id: 39555, cityId: 1215, code: "577443" },
    { id: 39556, cityId: 1215, code: "585323" },
    { id: 39557, cityId: 1216, code: "457550" },
    { id: 39558, cityId: 1217, code: "464661" },
    { id: 39559, cityId: 1218, code: "465697" },
    { id: 39560, cityId: 1219, code: "454111" },
    { id: 39561, cityId: 1220, code: "460447" },
    { id: 39562, cityId: 1221, code: "485001" },
    { id: 39563, cityId: 1221, code: "485002" },
    { id: 39564, cityId: 1221, code: "485115" },
    { id: 39565, cityId: 1221, code: "485221" },
    { id: 39566, cityId: 1221, code: "485441" },
    { id: 39567, cityId: 1221, code: "485446" },
    { id: 39568, cityId: 1221, code: "485661" },
    { id: 39569, cityId: 1221, code: "485775" },
    { id: 39570, cityId: 1221, code: "485778" },
    { id: 39571, cityId: 1221, code: "485005" },
    { id: 39572, cityId: 1221, code: "485111" },
    { id: 39573, cityId: 1221, code: "485114" },
    { id: 39574, cityId: 1221, code: "485116" },
    { id: 39575, cityId: 1221, code: "485331" },
    { id: 39576, cityId: 1221, code: "485344" },
    { id: 39577, cityId: 1221, code: "485447" },
    { id: 39578, cityId: 1221, code: "485551" },
    { id: 39579, cityId: 1221, code: "485771" },
    { id: 39580, cityId: 1221, code: "485774" },
    { id: 39581, cityId: 1222, code: "455459" },
    { id: 39582, cityId: 1223, code: "480106" },
    { id: 39583, cityId: 1224, code: "453551" },
    { id: 39584, cityId: 1225, code: "466001" },
    { id: 39585, cityId: 1225, code: "466003" },
    { id: 39586, cityId: 1225, code: "466112" },
    { id: 39587, cityId: 1225, code: "466114" },
    { id: 39588, cityId: 1225, code: "466115" },
    { id: 39589, cityId: 1225, code: "466117" },
    { id: 39590, cityId: 1225, code: "466125" },
    { id: 39591, cityId: 1225, code: "466221" },
    { id: 39592, cityId: 1225, code: "466446" },
    { id: 39593, cityId: 1225, code: "466448" },
    { id: 39594, cityId: 1225, code: "466554" },
    { id: 39595, cityId: 1225, code: "466665" },
    { id: 39596, cityId: 1225, code: "466002" },
    { id: 39597, cityId: 1225, code: "466111" },
    { id: 39598, cityId: 1225, code: "466116" },
    { id: 39599, cityId: 1225, code: "466118" },
    { id: 39600, cityId: 1225, code: "466119" },
    { id: 39601, cityId: 1225, code: "466331" },
    { id: 39602, cityId: 1225, code: "466445" },
    { id: 39603, cityId: 1225, code: "466651" },
    { id: 39604, cityId: 1225, code: "466661" },
    { id: 39605, cityId: 1225, code: "473664" },
    { id: 39606, cityId: 1226, code: "451666" },
    { id: 39607, cityId: 1227, code: "480661" },
    { id: 39608, cityId: 1227, code: "480664" },
    { id: 39609, cityId: 1227, code: "480667" },
    { id: 39610, cityId: 1227, code: "480669" },
    { id: 39611, cityId: 1227, code: "480881" },
    { id: 39612, cityId: 1227, code: "480884" },
    { id: 39613, cityId: 1227, code: "480990" },
    { id: 39614, cityId: 1227, code: "480997" },
    { id: 39615, cityId: 1227, code: "480771" },
    { id: 39616, cityId: 1227, code: "480880" },
    { id: 39617, cityId: 1227, code: "480882" },
    { id: 39618, cityId: 1227, code: "480887" },
    { id: 39619, cityId: 1227, code: "480994" },
    { id: 39620, cityId: 1227, code: "480996" },
    { id: 39621, cityId: 1227, code: "480999" },
    { id: 39622, cityId: 1228, code: "461223" },
    { id: 39623, cityId: 1229, code: "484114" },
    { id: 39624, cityId: 1229, code: "484117" },
    { id: 39625, cityId: 1229, code: "484220" },
    { id: 39626, cityId: 1229, code: "484334" },
    { id: 39627, cityId: 1229, code: "484336" },
    { id: 39628, cityId: 1229, code: "484440" },
    { id: 39629, cityId: 1229, code: "484551" },
    { id: 39630, cityId: 1229, code: "484660" },
    { id: 39631, cityId: 1229, code: "484665" },
    { id: 39632, cityId: 1229, code: "484771" },
    { id: 39633, cityId: 1229, code: "484776" },
    { id: 39634, cityId: 1229, code: "484001" },
    { id: 39635, cityId: 1229, code: "484110" },
    { id: 39636, cityId: 1229, code: "484113" },
    { id: 39637, cityId: 1229, code: "484116" },
    { id: 39638, cityId: 1229, code: "484224" },
    { id: 39639, cityId: 1229, code: "484330" },
    { id: 39640, cityId: 1229, code: "484446" },
    { id: 39641, cityId: 1229, code: "484555" },
    { id: 39642, cityId: 1229, code: "484661" },
    { id: 39643, cityId: 1229, code: "484770" },
    { id: 39644, cityId: 1229, code: "484881" },
    { id: 39645, cityId: 1229, code: "484886" },
    { id: 39646, cityId: 1230, code: "311404" },
    { id: 39647, cityId: 1230, code: "460440" },
    { id: 39648, cityId: 1230, code: "483119" },
    { id: 39649, cityId: 1231, code: "465106" },
    { id: 39650, cityId: 1231, code: "465220" },
    { id: 39651, cityId: 1231, code: "465223" },
    { id: 39652, cityId: 1231, code: "465230" },
    { id: 39653, cityId: 1231, code: "465231" },
    { id: 39654, cityId: 1231, code: "465331" },
    { id: 39655, cityId: 1231, code: "465336" },
    { id: 39656, cityId: 1231, code: "465337" },
    { id: 39657, cityId: 1231, code: "465445" },
    { id: 39658, cityId: 1231, code: "465001" },
    { id: 39659, cityId: 1231, code: "465110" },
    { id: 39660, cityId: 1231, code: "465113" },
    { id: 39661, cityId: 1231, code: "465116" },
    { id: 39662, cityId: 1231, code: "465118" },
    { id: 39663, cityId: 1231, code: "465221" },
    { id: 39664, cityId: 1231, code: "465333" },
    { id: 39665, cityId: 1231, code: "465335" },
    { id: 39666, cityId: 1231, code: "465418" },
    { id: 39667, cityId: 1231, code: "465441" },
    { id: 39668, cityId: 1231, code: "465447" },
    { id: 39669, cityId: 1231, code: "465449" },
    { id: 39670, cityId: 1231, code: "465550" },
    { id: 39671, cityId: 1231, code: "465672" },
    { id: 39672, cityId: 1232, code: "473770" },
    { id: 39673, cityId: 1232, code: "473775" },
    { id: 39674, cityId: 1232, code: "473781" },
    { id: 39675, cityId: 1232, code: "473865" },
    { id: 39676, cityId: 1232, code: "473990" },
    { id: 39677, cityId: 1232, code: "473551" },
    { id: 39678, cityId: 1232, code: "473583" },
    { id: 39679, cityId: 1232, code: "473660" },
    { id: 39680, cityId: 1232, code: "473662" },
    { id: 39681, cityId: 1232, code: "473670" },
    { id: 39682, cityId: 1232, code: "473774" },
    { id: 39683, cityId: 1232, code: "473785" },
    { id: 39684, cityId: 1232, code: "473793" },
    { id: 39685, cityId: 1232, code: "473880" },
    { id: 39686, cityId: 1232, code: "473885" },
    { id: 39687, cityId: 1232, code: "473993" },
    { id: 39688, cityId: 1233, code: "486771" },
    { id: 39689, cityId: 1233, code: "486890" },
    { id: 39690, cityId: 1233, code: "486892" },
    { id: 39691, cityId: 1233, code: "486661" },
    { id: 39692, cityId: 1233, code: "486669" },
    { id: 39693, cityId: 1233, code: "486775" },
    { id: 39694, cityId: 1233, code: "486881" },
    { id: 39695, cityId: 1233, code: "486886" },
    { id: 39696, cityId: 1233, code: "486889" },
    { id: 39697, cityId: 1234, code: "483225" },
    { id: 39698, cityId: 1235, code: "461771" },
    { id: 39699, cityId: 1236, code: "222301" },
    { id: 39700, cityId: 1236, code: "222303" },
    { id: 39701, cityId: 1236, code: "227406" },
    { id: 39702, cityId: 1236, code: "227408" },
    { id: 39703, cityId: 1236, code: "227411" },
    { id: 39704, cityId: 1236, code: "227806" },
    { id: 39705, cityId: 1236, code: "227811" },
    { id: 39706, cityId: 1236, code: "227816" },
    { id: 39707, cityId: 1236, code: "228001" },
    { id: 39708, cityId: 1236, code: "228118" },
    { id: 39709, cityId: 1236, code: "228121" },
    { id: 39710, cityId: 1236, code: "228155" },
    { id: 39711, cityId: 1236, code: "228171" },
    { id: 39712, cityId: 1236, code: "228820" },
    { id: 39713, cityId: 1236, code: "464986" },
    { id: 39714, cityId: 1236, code: "222302" },
    { id: 39715, cityId: 1236, code: "222304" },
    { id: 39716, cityId: 1236, code: "227407" },
    { id: 39717, cityId: 1236, code: "227409" },
    { id: 39718, cityId: 1236, code: "227412" },
    { id: 39719, cityId: 1236, code: "227801" },
    { id: 39720, cityId: 1236, code: "227802" },
    { id: 39721, cityId: 1236, code: "227807" },
    { id: 39722, cityId: 1236, code: "227809" },
    { id: 39723, cityId: 1236, code: "227812" },
    { id: 39724, cityId: 1236, code: "227814" },
    { id: 39725, cityId: 1236, code: "227815" },
    { id: 39726, cityId: 1236, code: "227817" },
    { id: 39727, cityId: 1236, code: "228119" },
    { id: 39728, cityId: 1236, code: "228124" },
    { id: 39729, cityId: 1236, code: "228125" },
    { id: 39730, cityId: 1236, code: "228132" },
    { id: 39731, cityId: 1236, code: "228133" },
    { id: 39732, cityId: 1236, code: "228141" },
    { id: 39733, cityId: 1236, code: "228151" },
    { id: 39734, cityId: 1236, code: "228159" },
    { id: 39735, cityId: 1236, code: "228161" },
    { id: 39736, cityId: 1236, code: "262125" },
    { id: 39737, cityId: 1237, code: "457118" },
    { id: 39738, cityId: 1238, code: "475005" },
    { id: 39739, cityId: 1239, code: "457777" },
    { id: 39740, cityId: 1240, code: "472005" },
    { id: 39741, cityId: 1240, code: "472010" },
    { id: 39742, cityId: 1240, code: "472111" },
    { id: 39743, cityId: 1240, code: "472118" },
    { id: 39744, cityId: 1240, code: "472246" },
    { id: 39745, cityId: 1240, code: "472336" },
    { id: 39746, cityId: 1240, code: "472442" },
    { id: 39747, cityId: 1240, code: "472447" },
    { id: 39748, cityId: 1240, code: "476133" },
    { id: 39749, cityId: 1240, code: "472001" },
    { id: 39750, cityId: 1240, code: "472101" },
    { id: 39751, cityId: 1240, code: "472115" },
    { id: 39752, cityId: 1240, code: "472221" },
    { id: 39753, cityId: 1240, code: "472337" },
    { id: 39754, cityId: 1240, code: "472445" },
    { id: 39755, cityId: 1240, code: "472446" },
    { id: 39756, cityId: 1240, code: "472567" },
    { id: 39757, cityId: 1241, code: "481449" },
    { id: 39758, cityId: 1242, code: "464770" },
    { id: 39759, cityId: 1243, code: "456001" },
    { id: 39760, cityId: 1243, code: "456009" },
    { id: 39761, cityId: 1243, code: "456221" },
    { id: 39762, cityId: 1243, code: "456224" },
    { id: 39763, cityId: 1243, code: "456335" },
    { id: 39764, cityId: 1243, code: "456441" },
    { id: 39765, cityId: 1243, code: "456550" },
    { id: 39766, cityId: 1243, code: "456552" },
    { id: 39767, cityId: 1243, code: "456661" },
    { id: 39768, cityId: 1243, code: "456663" },
    { id: 39769, cityId: 1243, code: "456664" },
    { id: 39770, cityId: 1243, code: "456666" },
    { id: 39771, cityId: 1243, code: "456003" },
    { id: 39772, cityId: 1243, code: "456006" },
    { id: 39773, cityId: 1243, code: "456008" },
    { id: 39774, cityId: 1243, code: "456010" },
    { id: 39775, cityId: 1243, code: "456222" },
    { id: 39776, cityId: 1243, code: "456331" },
    { id: 39777, cityId: 1243, code: "456337" },
    { id: 39778, cityId: 1243, code: "456440" },
    { id: 39779, cityId: 1243, code: "456443" },
    { id: 39780, cityId: 1243, code: "456450" },
    { id: 39781, cityId: 1243, code: "456665" },
    { id: 39782, cityId: 1243, code: "456668" },
    { id: 39783, cityId: 1243, code: "456673" },
    { id: 39784, cityId: 1243, code: "456771" },
    { id: 39785, cityId: 1243, code: "456776" },
    { id: 39786, cityId: 1244, code: "481105" },
    { id: 39787, cityId: 1245, code: "485226" },
    { id: 39788, cityId: 1245, code: "487555" },
    { id: 39789, cityId: 1245, code: "485773" },
    { id: 39790, cityId: 1246, code: "464002" },
    { id: 39791, cityId: 1246, code: "464111" },
    { id: 39792, cityId: 1246, code: "464114" },
    { id: 39793, cityId: 1246, code: "464220" },
    { id: 39794, cityId: 1246, code: "464228" },
    { id: 39795, cityId: 1246, code: "464331" },
    { id: 39796, cityId: 1246, code: "464001" },
    { id: 39797, cityId: 1246, code: "464112" },
    { id: 39798, cityId: 1246, code: "464221" },
    { id: 39799, cityId: 1246, code: "464224" },
    { id: 39800, cityId: 1246, code: "464226" },
    { id: 39801, cityId: 1246, code: "464337" },
    { id: 39802, cityId: 1246, code: "464676" },
    { id: 39803, cityId: 1247, code: "413701" },
    { id: 39804, cityId: 1247, code: "413702" },
    { id: 39805, cityId: 1247, code: "413704" },
    { id: 39806, cityId: 1247, code: "413707" },
    { id: 39807, cityId: 1247, code: "413709" },
    { id: 39808, cityId: 1247, code: "413710" },
    { id: 39809, cityId: 1247, code: "413712" },
    { id: 39810, cityId: 1247, code: "413715" },
    { id: 39811, cityId: 1247, code: "413717" },
    { id: 39812, cityId: 1247, code: "413718" },
    { id: 39813, cityId: 1247, code: "413720" },
    { id: 39814, cityId: 1247, code: "413723" },
    { id: 39815, cityId: 1247, code: "413725" },
    { id: 39816, cityId: 1247, code: "413726" },
    { id: 39817, cityId: 1247, code: "413728" },
    { id: 39818, cityId: 1247, code: "413736" },
    { id: 39819, cityId: 1247, code: "413739" },
    { id: 39820, cityId: 1247, code: "414001" },
    { id: 39821, cityId: 1247, code: "414101" },
    { id: 39822, cityId: 1247, code: "414303" },
    { id: 39823, cityId: 1247, code: "414305" },
    { id: 39824, cityId: 1247, code: "414306" },
    { id: 39825, cityId: 1247, code: "414401" },
    { id: 39826, cityId: 1247, code: "414403" },
    { id: 39827, cityId: 1247, code: "414404" },
    { id: 39828, cityId: 1247, code: "414501" },
    { id: 39829, cityId: 1247, code: "414502" },
    { id: 39830, cityId: 1247, code: "414504" },
    { id: 39831, cityId: 1247, code: "414602" },
    { id: 39832, cityId: 1247, code: "414605" },
    { id: 39833, cityId: 1247, code: "414607" },
    { id: 39834, cityId: 1247, code: "422605" },
    { id: 39835, cityId: 1247, code: "422607" },
    { id: 39836, cityId: 1247, code: "422610" },
    { id: 39837, cityId: 1247, code: "422615" },
    { id: 39838, cityId: 1247, code: "422620" },
    { id: 39839, cityId: 1247, code: "423103" },
    { id: 39840, cityId: 1247, code: "423601" },
    { id: 39841, cityId: 1247, code: "423603" },
    { id: 39842, cityId: 1247, code: "413205" },
    { id: 39843, cityId: 1247, code: "413703" },
    { id: 39844, cityId: 1247, code: "413706" },
    { id: 39845, cityId: 1247, code: "413708" },
    { id: 39846, cityId: 1247, code: "413711" },
    { id: 39847, cityId: 1247, code: "413713" },
    { id: 39848, cityId: 1247, code: "413714" },
    { id: 39849, cityId: 1247, code: "413716" },
    { id: 39850, cityId: 1247, code: "413719" },
    { id: 39851, cityId: 1247, code: "413721" },
    { id: 39852, cityId: 1247, code: "413722" },
    { id: 39853, cityId: 1247, code: "413724" },
    { id: 39854, cityId: 1247, code: "413732" },
    { id: 39855, cityId: 1247, code: "413737" },
    { id: 39856, cityId: 1247, code: "413901" },
    { id: 39857, cityId: 1247, code: "414002" },
    { id: 39858, cityId: 1247, code: "414005" },
    { id: 39859, cityId: 1247, code: "414103" },
    { id: 39860, cityId: 1247, code: "414106" },
    { id: 39861, cityId: 1247, code: "414108" },
    { id: 39862, cityId: 1247, code: "414111" },
    { id: 39863, cityId: 1247, code: "414201" },
    { id: 39864, cityId: 1247, code: "414301" },
    { id: 39865, cityId: 1247, code: "414302" },
    { id: 39866, cityId: 1247, code: "414304" },
    { id: 39867, cityId: 1247, code: "414405" },
    { id: 39868, cityId: 1247, code: "414410" },
    { id: 39869, cityId: 1247, code: "414505" },
    { id: 39870, cityId: 1247, code: "414601" },
    { id: 39871, cityId: 1247, code: "414603" },
    { id: 39872, cityId: 1247, code: "414604" },
    { id: 39873, cityId: 1247, code: "414606" },
    { id: 39874, cityId: 1247, code: "414701" },
    { id: 39875, cityId: 1247, code: "414702" },
    { id: 39876, cityId: 1247, code: "422603" },
    { id: 39877, cityId: 1247, code: "422608" },
    { id: 39878, cityId: 1247, code: "422611" },
    { id: 39879, cityId: 1247, code: "422617" },
    { id: 39880, cityId: 1247, code: "422619" },
    { id: 39881, cityId: 1247, code: "423107" },
    { id: 39882, cityId: 1247, code: "423602" },
    { id: 39883, cityId: 1247, code: "423604" },
    { id: 39884, cityId: 1247, code: "423605" },
    { id: 39885, cityId: 1247, code: "423607" },
    { id: 39886, cityId: 1248, code: "416505" },
    { id: 39887, cityId: 1249, code: "413216" },
    { id: 39888, cityId: 1250, code: "444001" },
    { id: 39889, cityId: 1250, code: "444003" },
    { id: 39890, cityId: 1250, code: "444004" },
    { id: 39891, cityId: 1250, code: "444101" },
    { id: 39892, cityId: 1250, code: "444102" },
    { id: 39893, cityId: 1250, code: "444104" },
    { id: 39894, cityId: 1250, code: "444107" },
    { id: 39895, cityId: 1250, code: "444109" },
    { id: 39896, cityId: 1250, code: "444112" },
    { id: 39897, cityId: 1250, code: "444115" },
    { id: 39898, cityId: 1250, code: "444117" },
    { id: 39899, cityId: 1250, code: "444122" },
    { id: 39900, cityId: 1250, code: "444123" },
    { id: 39901, cityId: 1250, code: "444125" },
    { id: 39902, cityId: 1250, code: "444311" },
    { id: 39903, cityId: 1250, code: "444401" },
    { id: 39904, cityId: 1250, code: "444403" },
    { id: 39905, cityId: 1250, code: "444404" },
    { id: 39906, cityId: 1250, code: "444409" },
    { id: 39907, cityId: 1250, code: "444502" },
    { id: 39908, cityId: 1250, code: "444504" },
    { id: 39909, cityId: 1250, code: "444507" },
    { id: 39910, cityId: 1250, code: "422601" },
    { id: 39911, cityId: 1250, code: "444002" },
    { id: 39912, cityId: 1250, code: "444005" },
    { id: 39913, cityId: 1250, code: "444103" },
    { id: 39914, cityId: 1250, code: "444106" },
    { id: 39915, cityId: 1250, code: "444118" },
    { id: 39916, cityId: 1250, code: "444121" },
    { id: 39917, cityId: 1250, code: "444124" },
    { id: 39918, cityId: 1250, code: "444126" },
    { id: 39919, cityId: 1250, code: "444302" },
    { id: 39920, cityId: 1250, code: "444402" },
    { id: 39921, cityId: 1250, code: "444405" },
    { id: 39922, cityId: 1250, code: "444407" },
    { id: 39923, cityId: 1250, code: "444505" },
    { id: 39924, cityId: 1250, code: "444508" },
    { id: 39925, cityId: 1250, code: "444510" },
    { id: 39926, cityId: 1250, code: "444511" },
    { id: 39927, cityId: 1251, code: "444101" },
    { id: 39928, cityId: 1252, code: "400704" },
    { id: 39929, cityId: 1252, code: "402102" },
    { id: 39930, cityId: 1252, code: "402105" },
    { id: 39931, cityId: 1252, code: "402108" },
    { id: 39932, cityId: 1252, code: "402111" },
    { id: 39933, cityId: 1252, code: "402113" },
    { id: 39934, cityId: 1252, code: "402116" },
    { id: 39935, cityId: 1252, code: "402118" },
    { id: 39936, cityId: 1252, code: "402121" },
    { id: 39937, cityId: 1252, code: "402124" },
    { id: 39939, cityId: 1252, code: "402203" },
    { id: 39940, cityId: 1252, code: "402206" },
    { id: 39941, cityId: 1252, code: "402301" },
    { id: 39942, cityId: 1252, code: "402304" },
    { id: 39943, cityId: 1252, code: "402306" },
    { id: 39944, cityId: 1252, code: "402404" },
    { id: 39945, cityId: 1252, code: "402405" },
    { id: 39946, cityId: 1252, code: "410202" },
    { id: 39947, cityId: 1252, code: "410204" },
    { id: 39948, cityId: 1252, code: "410207" },
    { id: 39949, cityId: 1252, code: "402201" },
    { id: 39950, cityId: 1252, code: "415213" },
    { id: 39951, cityId: 1252, code: "402101" },
    { id: 39952, cityId: 1252, code: "402104" },
    { id: 39953, cityId: 1252, code: "402112" },
    { id: 39954, cityId: 1252, code: "402114" },
    { id: 39955, cityId: 1252, code: "402115" },
    { id: 39956, cityId: 1252, code: "402117" },
    { id: 39957, cityId: 1252, code: "402120" },
    { id: 39958, cityId: 1252, code: "402122" },
    { id: 39959, cityId: 1252, code: "402123" },
    { id: 39960, cityId: 1252, code: "402202" },
    { id: 39961, cityId: 1252, code: "402204" },
    { id: 39962, cityId: 1252, code: "402205" },
    { id: 39963, cityId: 1252, code: "402207" },
    { id: 39964, cityId: 1252, code: "402305" },
    { id: 39965, cityId: 1252, code: "402401" },
    { id: 39966, cityId: 1252, code: "402403" },
    { id: 39967, cityId: 1252, code: "410201" },
    { id: 39968, cityId: 1252, code: "410203" },
    { id: 39970, cityId: 1252, code: "410208" },
    { id: 39972, cityId: 1253, code: "425401" },
    { id: 39973, cityId: 1253, code: "413207" },
    { id: 39974, cityId: 1254, code: "431204" },
    { id: 39975, cityId: 1255, code: "400012" },
    { id: 39976, cityId: 1256, code: "431517" },
    { id: 39977, cityId: 1257, code: "444603" },
    { id: 39978, cityId: 1257, code: "444605" },
    { id: 39979, cityId: 1257, code: "444701" },
    { id: 39980, cityId: 1257, code: "444704" },
    { id: 39981, cityId: 1257, code: "444706" },
    { id: 39982, cityId: 1257, code: "444709" },
    { id: 39983, cityId: 1257, code: "444711" },
    { id: 39984, cityId: 1257, code: "444712" },
    { id: 39985, cityId: 1257, code: "444717" },
    { id: 39986, cityId: 1257, code: "444727" },
    { id: 39987, cityId: 1257, code: "444801" },
    { id: 39988, cityId: 1257, code: "444802" },
    { id: 39989, cityId: 1257, code: "444804" },
    { id: 39990, cityId: 1257, code: "444809" },
    { id: 39991, cityId: 1257, code: "444810" },
    { id: 39992, cityId: 1257, code: "444812" },
    { id: 39993, cityId: 1257, code: "444815" },
    { id: 39994, cityId: 1257, code: "444818" },
    { id: 39995, cityId: 1257, code: "444826" },
    { id: 39996, cityId: 1257, code: "444902" },
    { id: 39997, cityId: 1257, code: "444907" },
    { id: 39998, cityId: 1257, code: "444908" },
    { id: 39999, cityId: 1257, code: "444915" },
    { id: 40000, cityId: 1257, code: "444111" },
    { id: 40001, cityId: 1257, code: "444601" },
    { id: 40002, cityId: 1257, code: "444602" },
    { id: 40003, cityId: 1257, code: "444604" },
    { id: 40004, cityId: 1257, code: "444702" },
    { id: 40005, cityId: 1257, code: "444707" },
    { id: 40006, cityId: 1257, code: "444708" },
    { id: 40007, cityId: 1257, code: "444710" },
    { id: 40008, cityId: 1257, code: "444713" },
    { id: 40009, cityId: 1257, code: "444716" },
    { id: 40010, cityId: 1257, code: "444718" },
    { id: 40011, cityId: 1257, code: "444721" },
    { id: 40012, cityId: 1257, code: "444723" },
    { id: 40013, cityId: 1257, code: "444803" },
    { id: 40014, cityId: 1257, code: "444805" },
    { id: 40015, cityId: 1257, code: "444806" },
    { id: 40016, cityId: 1257, code: "444808" },
    { id: 40017, cityId: 1257, code: "444811" },
    { id: 40018, cityId: 1257, code: "444814" },
    { id: 40019, cityId: 1257, code: "444816" },
    { id: 40020, cityId: 1257, code: "444819" },
    { id: 40021, cityId: 1257, code: "444821" },
    { id: 40022, cityId: 1257, code: "444827" },
    { id: 40023, cityId: 1257, code: "444901" },
    { id: 40024, cityId: 1257, code: "444904" },
    { id: 40025, cityId: 1257, code: "444906" },
    { id: 40026, cityId: 1257, code: "444909" },
    { id: 40027, cityId: 1257, code: "444914" },
    { id: 40028, cityId: 1258, code: "444705" },
    { id: 40029, cityId: 1259, code: "412401" },
    { id: 40030, cityId: 1259, code: "400031" },
    { id: 40031, cityId: 1260, code: "400002" },
    { id: 40032, cityId: 1261, code: "221001" },
    { id: 40033, cityId: 1261, code: "245401" },
    { id: 40034, cityId: 1261, code: "423702" },
    { id: 40035, cityId: 1261, code: "423704" },
    { id: 40036, cityId: 1261, code: "431001" },
    { id: 40037, cityId: 1261, code: "431002" },
    { id: 40038, cityId: 1261, code: "431004" },
    { id: 40039, cityId: 1261, code: "431102" },
    { id: 40040, cityId: 1261, code: "431104" },
    { id: 40041, cityId: 1261, code: "431105" },
    { id: 40042, cityId: 1261, code: "431110" },
    { id: 40043, cityId: 1261, code: "431115" },
    { id: 40044, cityId: 1261, code: "431121" },
    { id: 40045, cityId: 1261, code: "431137" },
    { id: 40046, cityId: 1261, code: "431139" },
    { id: 40047, cityId: 1261, code: "431144" },
    { id: 40048, cityId: 1261, code: "431147" },
    { id: 40049, cityId: 1261, code: "431208" },
    { id: 40050, cityId: 1261, code: "431210" },
    { id: 40051, cityId: 1261, code: "431213" },
    { id: 40052, cityId: 1261, code: "814156" },
    { id: 40053, cityId: 1261, code: "824101" },
    { id: 40054, cityId: 1261, code: "824102" },
    { id: 40055, cityId: 1261, code: "824112" },
    { id: 40056, cityId: 1261, code: "824114" },
    { id: 40057, cityId: 1261, code: "824115" },
    { id: 40058, cityId: 1261, code: "824120" },
    { id: 40059, cityId: 1261, code: "824122" },
    { id: 40060, cityId: 1261, code: "824123" },
    { id: 40061, cityId: 1261, code: "824128" },
    { id: 40062, cityId: 1261, code: "824130" },
    { id: 40063, cityId: 1261, code: "824202" },
    { id: 40064, cityId: 1261, code: "824218" },
    { id: 40065, cityId: 1261, code: "824303" },
    { id: 40066, cityId: 1261, code: "261403" },
    { id: 40067, cityId: 1261, code: "262728" },
    { id: 40068, cityId: 1261, code: "415570" },
    { id: 40069, cityId: 1261, code: "431005" },
    { id: 40070, cityId: 1261, code: "431108" },
    { id: 40071, cityId: 1261, code: "431111" },
    { id: 40072, cityId: 1261, code: "431116" },
    { id: 40073, cityId: 1261, code: "431119" },
    { id: 40074, cityId: 1261, code: "431133" },
    { id: 40075, cityId: 1261, code: "431138" },
    { id: 40076, cityId: 1261, code: "431140" },
    { id: 40077, cityId: 1261, code: "431146" },
    { id: 40078, cityId: 1261, code: "431148" },
    { id: 40079, cityId: 1261, code: "431201" },
    { id: 40080, cityId: 1261, code: "431212" },
    { id: 40081, cityId: 1261, code: "431402" },
    { id: 40082, cityId: 1261, code: "742201" },
    { id: 40083, cityId: 1261, code: "814133" },
    { id: 40084, cityId: 1261, code: "814141" },
    { id: 40085, cityId: 1261, code: "814147" },
    { id: 40086, cityId: 1261, code: "814154" },
    { id: 40087, cityId: 1261, code: "814155" },
    { id: 40088, cityId: 1261, code: "814165" },
    { id: 40089, cityId: 1261, code: "824113" },
    { id: 40090, cityId: 1261, code: "824121" },
    { id: 40091, cityId: 1261, code: "824124" },
    { id: 40092, cityId: 1261, code: "824126" },
    { id: 40093, cityId: 1261, code: "824127" },
    { id: 40094, cityId: 1261, code: "824129" },
    { id: 40095, cityId: 1261, code: "824203" },
    { id: 40096, cityId: 1261, code: "824211" },
    { id: 40097, cityId: 1261, code: "824216" },
    { id: 40098, cityId: 1261, code: "824302" },
    { id: 40099, cityId: 1261, code: "825101" },
    { id: 40100, cityId: 1262, code: "421504" },
    { id: 40101, cityId: 1263, code: "444302" },
    { id: 40102, cityId: 1264, code: "442701" },
    { id: 40103, cityId: 1265, code: "413102" },
    { id: 40104, cityId: 1266, code: "413401" },
    { id: 40105, cityId: 1267, code: "400077" },
    { id: 40106, cityId: 1268, code: "413229" },
    { id: 40107, cityId: 1268, code: "414203" },
    { id: 40108, cityId: 1268, code: "414204" },
    { id: 40109, cityId: 1268, code: "431122" },
    { id: 40110, cityId: 1268, code: "431124" },
    { id: 40111, cityId: 1268, code: "431127" },
    { id: 40112, cityId: 1268, code: "431129" },
    { id: 40113, cityId: 1268, code: "431145" },
    { id: 40114, cityId: 1268, code: "431519" },
    { id: 40115, cityId: 1268, code: "431524" },
    { id: 40116, cityId: 1268, code: "414202" },
    { id: 40117, cityId: 1268, code: "414205" },
    { id: 40118, cityId: 1268, code: "414208" },
    { id: 40119, cityId: 1268, code: "431123" },
    { id: 40120, cityId: 1268, code: "431125" },
    { id: 40121, cityId: 1268, code: "431126" },
    { id: 40122, cityId: 1268, code: "431128" },
    { id: 40123, cityId: 1268, code: "431131" },
    { id: 40124, cityId: 1268, code: "431142" },
    { id: 40125, cityId: 1268, code: "431515" },
    { id: 40126, cityId: 1268, code: "431517" },
    { id: 40127, cityId: 1268, code: "431520" },
    { id: 40128, cityId: 1268, code: "431523" },
    { id: 40129, cityId: 1268, code: "431528" },
    { id: 40130, cityId: 1269, code: "442902" },
    { id: 40131, cityId: 1269, code: "577243" },
    { id: 40132, cityId: 1269, code: "581182" },
    { id: 40133, cityId: 1269, code: "582225" },
    { id: 40134, cityId: 1270, code: "422502" },
    { id: 40135, cityId: 1271, code: "441605" },
    { id: 40136, cityId: 1271, code: "441606" },
    { id: 40137, cityId: 1271, code: "441701" },
    { id: 40138, cityId: 1271, code: "441804" },
    { id: 40139, cityId: 1271, code: "441809" },
    { id: 40140, cityId: 1271, code: "441902" },
    { id: 40141, cityId: 1271, code: "441905" },
    { id: 40142, cityId: 1271, code: "441907" },
    { id: 40143, cityId: 1271, code: "441910" },
    { id: 40144, cityId: 1271, code: "441913" },
    { id: 40145, cityId: 1271, code: "441918" },
    { id: 40146, cityId: 1271, code: "441920" },
    { id: 40147, cityId: 1271, code: "441921" },
    { id: 40148, cityId: 1271, code: "441923" },
    { id: 40149, cityId: 1271, code: "444903" },
    { id: 40150, cityId: 1271, code: "441601" },
    { id: 40151, cityId: 1271, code: "441602" },
    { id: 40152, cityId: 1271, code: "441604" },
    { id: 40153, cityId: 1271, code: "441702" },
    { id: 40154, cityId: 1271, code: "441803" },
    { id: 40155, cityId: 1271, code: "441805" },
    { id: 40156, cityId: 1271, code: "441806" },
    { id: 40157, cityId: 1271, code: "441808" },
    { id: 40158, cityId: 1271, code: "441811" },
    { id: 40159, cityId: 1271, code: "441901" },
    { id: 40160, cityId: 1271, code: "441903" },
    { id: 40161, cityId: 1271, code: "441904" },
    { id: 40162, cityId: 1271, code: "441908" },
    { id: 40163, cityId: 1271, code: "441909" },
    { id: 40164, cityId: 1271, code: "441914" },
    { id: 40165, cityId: 1271, code: "441916" },
    { id: 40166, cityId: 1271, code: "441917" },
    { id: 40167, cityId: 1271, code: "441919" },
    { id: 40168, cityId: 1271, code: "441922" },
    { id: 40169, cityId: 1271, code: "441924" },
    { id: 40170, cityId: 1271, code: "441930" },
    { id: 40171, cityId: 1272, code: "421302" },
    { id: 40172, cityId: 1273, code: "431114" },
    { id: 40173, cityId: 1274, code: "412206" },
    { id: 40174, cityId: 1275, code: "416304" },
    { id: 40175, cityId: 1276, code: "443001" },
    { id: 40176, cityId: 1276, code: "443102" },
    { id: 40177, cityId: 1276, code: "443105" },
    { id: 40178, cityId: 1276, code: "443107" },
    { id: 40179, cityId: 1276, code: "443108" },
    { id: 40180, cityId: 1276, code: "443110" },
    { id: 40181, cityId: 1276, code: "443206" },
    { id: 40182, cityId: 1276, code: "443301" },
    { id: 40183, cityId: 1276, code: "443303" },
    { id: 40184, cityId: 1276, code: "443304" },
    { id: 40185, cityId: 1276, code: "443306" },
    { id: 40186, cityId: 1276, code: "443401" },
    { id: 40187, cityId: 1276, code: "443402" },
    { id: 40188, cityId: 1276, code: "443407" },
    { id: 40189, cityId: 1276, code: "444201" },
    { id: 40190, cityId: 1276, code: "444204" },
    { id: 40191, cityId: 1276, code: "444307" },
    { id: 40192, cityId: 1276, code: "444312" },
    { id: 40193, cityId: 1276, code: "443101" },
    { id: 40194, cityId: 1276, code: "443103" },
    { id: 40195, cityId: 1276, code: "443104" },
    { id: 40196, cityId: 1276, code: "443106" },
    { id: 40197, cityId: 1276, code: "443201" },
    { id: 40198, cityId: 1276, code: "443202" },
    { id: 40199, cityId: 1276, code: "443204" },
    { id: 40200, cityId: 1276, code: "443207" },
    { id: 40201, cityId: 1276, code: "443209" },
    { id: 40202, cityId: 1276, code: "443302" },
    { id: 40203, cityId: 1276, code: "443305" },
    { id: 40204, cityId: 1276, code: "443307" },
    { id: 40205, cityId: 1276, code: "443308" },
    { id: 40206, cityId: 1276, code: "443403" },
    { id: 40207, cityId: 1276, code: "443405" },
    { id: 40208, cityId: 1276, code: "443406" },
    { id: 40209, cityId: 1276, code: "444202" },
    { id: 40210, cityId: 1276, code: "444203" },
    { id: 40211, cityId: 1276, code: "444301" },
    { id: 40212, cityId: 1276, code: "444303" },
    { id: 40213, cityId: 1276, code: "444306" },
    { id: 40214, cityId: 1276, code: "444308" },
    { id: 40215, cityId: 1277, code: "410501" },
    { id: 40216, cityId: 1278, code: "400081" },
    { id: 40217, cityId: 1279, code: "400055" },
    { id: 40218, cityId: 1279, code: "400071" },
    { id: 40219, cityId: 1279, code: "400078" },
    { id: 40220, cityId: 1280, code: "441206" },
    { id: 40221, cityId: 1280, code: "441209" },
    { id: 40222, cityId: 1280, code: "441221" },
    { id: 40223, cityId: 1280, code: "441222" },
    { id: 40224, cityId: 1280, code: "441915" },
    { id: 40225, cityId: 1280, code: "442403" },
    { id: 40226, cityId: 1280, code: "442504" },
    { id: 40227, cityId: 1280, code: "442506" },
    { id: 40228, cityId: 1280, code: "442604" },
    { id: 40229, cityId: 1280, code: "442702" },
    { id: 40230, cityId: 1280, code: "442705" },
    { id: 40231, cityId: 1280, code: "442901" },
    { id: 40232, cityId: 1280, code: "442903" },
    { id: 40233, cityId: 1280, code: "442904" },
    { id: 40234, cityId: 1280, code: "442906" },
    { id: 40235, cityId: 1280, code: "442914" },
    { id: 40236, cityId: 1280, code: "441205" },
    { id: 40237, cityId: 1280, code: "441207" },
    { id: 40238, cityId: 1280, code: "441213" },
    { id: 40239, cityId: 1280, code: "441223" },
    { id: 40240, cityId: 1280, code: "441225" },
    { id: 40241, cityId: 1280, code: "442401" },
    { id: 40242, cityId: 1280, code: "442402" },
    { id: 40243, cityId: 1280, code: "442502" },
    { id: 40244, cityId: 1280, code: "442603" },
    { id: 40245, cityId: 1280, code: "442905" },
    { id: 40246, cityId: 1280, code: "442907" },
    { id: 40247, cityId: 1280, code: "442908" },
    { id: 40248, cityId: 1280, code: "442910" },
    { id: 40249, cityId: 1280, code: "442913" },
    { id: 40250, cityId: 1280, code: "442916" },
    { id: 40251, cityId: 1281, code: "400054" },
    { id: 40252, cityId: 1281, code: "400029" },
    { id: 40253, cityId: 1281, code: "400055" },
    { id: 40254, cityId: 1281, code: "400058" },
    { id: 40255, cityId: 1282, code: "444807" },
    { id: 40256, cityId: 1283, code: "401503" },
    { id: 40257, cityId: 1284, code: "400008" },
    { id: 40258, cityId: 1285, code: "401601" },
    { id: 40259, cityId: 1286, code: "445202" },
    { id: 40260, cityId: 1287, code: "413801" },
    { id: 40261, cityId: 1288, code: "422401" },
    { id: 40262, cityId: 1289, code: "304804" },
    { id: 40263, cityId: 1289, code: "442101" },
    { id: 40264, cityId: 1290, code: "400002" },
    { id: 40265, cityId: 1290, code: "400028" },
    { id: 40266, cityId: 1291, code: "400093" },
    { id: 40267, cityId: 1291, code: "400018" },
    { id: 40268, cityId: 1291, code: "400086" },
    { id: 40269, cityId: 1292, code: "400049" },
    { id: 40270, cityId: 1292, code: "400070" },
    { id: 40271, cityId: 1292, code: "400072" },
    { id: 40272, cityId: 1292, code: "400101" },
    { id: 40273, cityId: 1293, code: "443112" },
    { id: 40274, cityId: 1294, code: "431809" },
    { id: 40275, cityId: 1295, code: "424003" },
    { id: 40276, cityId: 1295, code: "424005" },
    { id: 40277, cityId: 1295, code: "424106" },
    { id: 40278, cityId: 1295, code: "424302" },
    { id: 40279, cityId: 1295, code: "424304" },
    { id: 40280, cityId: 1295, code: "424307" },
    { id: 40281, cityId: 1295, code: "424310" },
    { id: 40282, cityId: 1295, code: "424313" },
    { id: 40283, cityId: 1295, code: "424315" },
    { id: 40284, cityId: 1295, code: "425404" },
    { id: 40285, cityId: 1295, code: "425406" },
    { id: 40286, cityId: 1295, code: "425407" },
    { id: 40287, cityId: 1295, code: "425412" },
    { id: 40288, cityId: 1295, code: "425415" },
    { id: 40289, cityId: 1295, code: "425417" },
    { id: 40290, cityId: 1295, code: "425422" },
    { id: 40291, cityId: 1295, code: "425438" },
    { id: 40292, cityId: 1295, code: "425444" },
    { id: 40293, cityId: 1295, code: "424001" },
    { id: 40294, cityId: 1295, code: "424002" },
    { id: 40295, cityId: 1295, code: "424004" },
    { id: 40296, cityId: 1295, code: "424301" },
    { id: 40297, cityId: 1295, code: "424303" },
    { id: 40298, cityId: 1295, code: "424306" },
    { id: 40299, cityId: 1295, code: "424308" },
    { id: 40300, cityId: 1295, code: "424309" },
    { id: 40301, cityId: 1295, code: "424311" },
    { id: 40302, cityId: 1295, code: "425405" },
    { id: 40303, cityId: 1295, code: "425408" },
    { id: 40304, cityId: 1295, code: "425410" },
    { id: 40305, cityId: 1295, code: "425411" },
    { id: 40306, cityId: 1295, code: "425418" },
    { id: 40307, cityId: 1295, code: "425419" },
    { id: 40308, cityId: 1295, code: "425421" },
    { id: 40309, cityId: 1295, code: "425423" },
    { id: 40310, cityId: 1295, code: "425424" },
    { id: 40311, cityId: 1295, code: "425426" },
    { id: 40312, cityId: 1295, code: "425432" },
    { id: 40313, cityId: 1295, code: "425442" },
    { id: 40314, cityId: 1295, code: "425448" },
    { id: 40315, cityId: 1295, code: "425450" },
    { id: 40316, cityId: 1295, code: "425522" },
    { id: 40317, cityId: 1295, code: "444120" },
    { id: 40318, cityId: 1296, code: "445203" },
    { id: 40319, cityId: 1297, code: "413220" },
    { id: 40320, cityId: 1298, code: "425109" },
    { id: 40321, cityId: 1299, code: "425503" },
    { id: 40322, cityId: 1300, code: "413543" },
    { id: 40323, cityId: 1300, code: "441208" },
    { id: 40324, cityId: 1300, code: "413608" },
    { id: 40325, cityId: 1300, code: "415501" },
    { id: 40326, cityId: 1300, code: "416616" },
    { id: 40327, cityId: 1300, code: "442605" },
    { id: 40328, cityId: 1300, code: "442703" },
    { id: 40329, cityId: 1300, code: "442912" },
    { id: 40330, cityId: 1301, code: "431514" },
    { id: 40331, cityId: 1302, code: "221302" },
    { id: 40332, cityId: 1302, code: "431109" },
    { id: 40333, cityId: 1303, code: "400058" },
    { id: 40334, cityId: 1304, code: "401205" },
    { id: 40335, cityId: 1305, code: "400062" },
    { id: 40336, cityId: 1305, code: "431703" },
    { id: 40337, cityId: 1305, code: "400063" },
    { id: 40338, cityId: 1305, code: "402103" },
    { id: 40339, cityId: 1305, code: "441801" },
    { id: 40340, cityId: 1306, code: "400010" },
    { id: 40341, cityId: 1306, code: "415703" },
    { id: 40342, cityId: 1307, code: "431712" },
    { id: 40343, cityId: 1308, code: "442301" },
    { id: 40344, cityId: 1309, code: "431513" },
    { id: 40345, cityId: 1309, code: "431738" },
    { id: 40346, cityId: 1310, code: "416115" },
    { id: 40347, cityId: 1310, code: "416116" },
    { id: 40348, cityId: 1311, code: "422403" },
    { id: 40349, cityId: 1312, code: "413106" },
    { id: 40350, cityId: 1313, code: "414113" },
    { id: 40351, cityId: 1313, code: "423305" },
    { id: 40352, cityId: 1313, code: "424102" },
    { id: 40353, cityId: 1313, code: "424103" },
    { id: 40354, cityId: 1313, code: "424105" },
    { id: 40355, cityId: 1313, code: "424108" },
    { id: 40356, cityId: 1313, code: "424116" },
    { id: 40357, cityId: 1313, code: "424203" },
    { id: 40358, cityId: 1313, code: "424206" },
    { id: 40359, cityId: 1313, code: "424208" },
    { id: 40360, cityId: 1313, code: "424209" },
    { id: 40361, cityId: 1313, code: "425001" },
    { id: 40362, cityId: 1313, code: "425101" },
    { id: 40363, cityId: 1313, code: "425104" },
    { id: 40364, cityId: 1313, code: "425106" },
    { id: 40365, cityId: 1313, code: "425107" },
    { id: 40366, cityId: 1313, code: "425112" },
    { id: 40367, cityId: 1313, code: "425114" },
    { id: 40368, cityId: 1313, code: "425119" },
    { id: 40369, cityId: 1313, code: "425120" },
    { id: 40370, cityId: 1313, code: "425122" },
    { id: 40371, cityId: 1313, code: "425125" },
    { id: 40372, cityId: 1313, code: "425127" },
    { id: 40373, cityId: 1313, code: "425130" },
    { id: 40374, cityId: 1313, code: "425133" },
    { id: 40375, cityId: 1313, code: "425204" },
    { id: 40376, cityId: 1313, code: "425302" },
    { id: 40377, cityId: 1313, code: "425303" },
    { id: 40378, cityId: 1313, code: "425305" },
    { id: 40379, cityId: 1313, code: "425307" },
    { id: 40380, cityId: 1313, code: "425308" },
    { id: 40381, cityId: 1313, code: "425315" },
    { id: 40382, cityId: 1313, code: "425318" },
    { id: 40383, cityId: 1313, code: "425323" },
    { id: 40384, cityId: 1313, code: "425326" },
    { id: 40385, cityId: 1313, code: "425435" },
    { id: 40386, cityId: 1313, code: "425437" },
    { id: 40387, cityId: 1313, code: "425501" },
    { id: 40388, cityId: 1313, code: "425504" },
    { id: 40389, cityId: 1313, code: "425506" },
    { id: 40390, cityId: 1313, code: "425509" },
    { id: 40391, cityId: 1313, code: "425511" },
    { id: 40392, cityId: 1313, code: "425512" },
    { id: 40393, cityId: 1313, code: "425519" },
    { id: 40394, cityId: 1313, code: "431113" },
    { id: 40395, cityId: 1313, code: "431132" },
    { id: 40396, cityId: 1313, code: "431135" },
    { id: 40397, cityId: 1313, code: "431150" },
    { id: 40398, cityId: 1313, code: "431151" },
    { id: 40399, cityId: 1313, code: "431203" },
    { id: 40400, cityId: 1313, code: "431204" },
    { id: 40401, cityId: 1313, code: "431206" },
    { id: 40402, cityId: 1313, code: "413204" },
    { id: 40403, cityId: 1313, code: "424101" },
    { id: 40404, cityId: 1313, code: "424104" },
    { id: 40405, cityId: 1313, code: "424107" },
    { id: 40406, cityId: 1313, code: "424117" },
    { id: 40407, cityId: 1313, code: "424202" },
    { id: 40408, cityId: 1313, code: "424205" },
    { id: 40409, cityId: 1313, code: "424207" },
    { id: 40410, cityId: 1313, code: "424210" },
    { id: 40411, cityId: 1313, code: "425002" },
    { id: 40412, cityId: 1313, code: "425102" },
    { id: 40413, cityId: 1313, code: "425103" },
    { id: 40414, cityId: 1313, code: "425105" },
    { id: 40415, cityId: 1313, code: "425108" },
    { id: 40416, cityId: 1313, code: "425110" },
    { id: 40417, cityId: 1313, code: "425113" },
    { id: 40418, cityId: 1313, code: "425115" },
    { id: 40419, cityId: 1313, code: "425121" },
    { id: 40420, cityId: 1313, code: "425124" },
    { id: 40421, cityId: 1313, code: "425126" },
    { id: 40422, cityId: 1313, code: "425201" },
    { id: 40423, cityId: 1313, code: "425211" },
    { id: 40424, cityId: 1313, code: "425301" },
    { id: 40425, cityId: 1313, code: "425304" },
    { id: 40426, cityId: 1313, code: "425306" },
    { id: 40427, cityId: 1313, code: "425309" },
    { id: 40428, cityId: 1313, code: "425311" },
    { id: 40429, cityId: 1313, code: "425320" },
    { id: 40430, cityId: 1313, code: "425420" },
    { id: 40431, cityId: 1313, code: "425434" },
    { id: 40432, cityId: 1313, code: "425436" },
    { id: 40433, cityId: 1313, code: "425439" },
    { id: 40434, cityId: 1313, code: "425505" },
    { id: 40435, cityId: 1313, code: "425507" },
    { id: 40436, cityId: 1313, code: "425515" },
    { id: 40437, cityId: 1313, code: "425521" },
    { id: 40438, cityId: 1313, code: "425523" },
    { id: 40439, cityId: 1313, code: "425524" },
    { id: 40440, cityId: 1313, code: "431117" },
    { id: 40441, cityId: 1313, code: "431118" },
    { id: 40442, cityId: 1313, code: "431134" },
    { id: 40443, cityId: 1313, code: "431202" },
    { id: 40444, cityId: 1313, code: "431205" },
    { id: 40445, cityId: 1313, code: "431207" },
    { id: 40446, cityId: 1313, code: "431504" },
    { id: 40447, cityId: 1314, code: "444703" },
    { id: 40448, cityId: 1315, code: "400010" },
    { id: 40449, cityId: 1315, code: "413201" },
    { id: 40450, cityId: 1316, code: "401603" },
    { id: 40451, cityId: 1317, code: "416101" },
    { id: 40452, cityId: 1318, code: "412303" },
    { id: 40453, cityId: 1319, code: "431509" },
    { id: 40454, cityId: 1320, code: "410502" },
    { id: 40455, cityId: 1321, code: "416216" },
    { id: 40456, cityId: 1322, code: "445401" },
    { id: 40457, cityId: 1322, code: "410515" },
    { id: 40458, cityId: 1322, code: "413507" },
    { id: 40459, cityId: 1323, code: "400078" },
    { id: 40460, cityId: 1324, code: "400051" },
    { id: 40461, cityId: 1324, code: "416602" },
    { id: 40462, cityId: 1324, code: "400049" },
    { id: 40463, cityId: 1324, code: "400060" },
    { id: 40464, cityId: 1325, code: "431103" },
    { id: 40465, cityId: 1326, code: "444105" },
    { id: 40466, cityId: 1327, code: "414402" },
    { id: 40467, cityId: 1328, code: "413203" },
    { id: 40468, cityId: 1329, code: "441302" },
    { id: 40469, cityId: 1330, code: "441101" },
    { id: 40470, cityId: 1331, code: "415709" },
    { id: 40471, cityId: 1332, code: "415604" },
    { id: 40472, cityId: 1333, code: "410203" },
    { id: 40473, cityId: 1334, code: "431101" },
    { id: 40474, cityId: 1335, code: "431804" },
    { id: 40475, cityId: 1336, code: "416114" },
    { id: 40476, cityId: 1337, code: "416002" },
    { id: 40477, cityId: 1337, code: "416004" },
    { id: 40478, cityId: 1337, code: "416005" },
    { id: 40479, cityId: 1337, code: "416007" },
    { id: 40480, cityId: 1337, code: "416010" },
    { id: 40481, cityId: 1337, code: "416102" },
    { id: 40482, cityId: 1337, code: "416103" },
    { id: 40483, cityId: 1337, code: "416105" },
    { id: 40484, cityId: 1337, code: "416108" },
    { id: 40485, cityId: 1337, code: "416110" },
    { id: 40486, cityId: 1337, code: "416111" },
    { id: 40487, cityId: 1337, code: "416113" },
    { id: 40488, cityId: 1337, code: "416116" },
    { id: 40489, cityId: 1337, code: "416119" },
    { id: 40490, cityId: 1337, code: "416121" },
    { id: 40491, cityId: 1337, code: "416132" },
    { id: 40492, cityId: 1337, code: "416134" },
    { id: 40493, cityId: 1337, code: "416137" },
    { id: 40494, cityId: 1337, code: "416203" },
    { id: 40495, cityId: 1337, code: "416206" },
    { id: 40496, cityId: 1337, code: "416208" },
    { id: 40497, cityId: 1337, code: "416209" },
    { id: 40498, cityId: 1337, code: "416211" },
    { id: 40499, cityId: 1337, code: "416214" },
    { id: 40500, cityId: 1337, code: "416217" },
    { id: 40501, cityId: 1337, code: "416222" },
    { id: 40502, cityId: 1337, code: "416224" },
    { id: 40503, cityId: 1337, code: "416227" },
    { id: 40504, cityId: 1337, code: "416230" },
    { id: 40505, cityId: 1337, code: "416232" },
    { id: 40506, cityId: 1337, code: "416502" },
    { id: 40507, cityId: 1337, code: "416503" },
    { id: 40508, cityId: 1337, code: "416508" },
    { id: 40509, cityId: 1337, code: "416001" },
    { id: 40510, cityId: 1337, code: "416003" },
    { id: 40511, cityId: 1337, code: "416008" },
    { id: 40512, cityId: 1337, code: "416011" },
    { id: 40513, cityId: 1337, code: "416104" },
    { id: 40514, cityId: 1337, code: "416107" },
    { id: 40515, cityId: 1337, code: "416109" },
    { id: 40516, cityId: 1337, code: "416115" },
    { id: 40517, cityId: 1337, code: "416117" },
    { id: 40518, cityId: 1337, code: "416120" },
    { id: 40519, cityId: 1337, code: "416122" },
    { id: 40520, cityId: 1337, code: "416130" },
    { id: 40521, cityId: 1337, code: "416202" },
    { id: 40522, cityId: 1337, code: "416204" },
    { id: 40523, cityId: 1337, code: "416205" },
    { id: 40524, cityId: 1337, code: "416207" },
    { id: 40525, cityId: 1337, code: "416210" },
    { id: 40526, cityId: 1337, code: "416212" },
    { id: 40527, cityId: 1337, code: "416213" },
    { id: 40528, cityId: 1337, code: "416215" },
    { id: 40529, cityId: 1337, code: "416218" },
    { id: 40530, cityId: 1337, code: "416220" },
    { id: 40531, cityId: 1337, code: "416221" },
    { id: 40532, cityId: 1337, code: "416223" },
    { id: 40533, cityId: 1337, code: "416231" },
    { id: 40534, cityId: 1337, code: "416501" },
    { id: 40535, cityId: 1337, code: "416504" },
    { id: 40536, cityId: 1337, code: "416506" },
    { id: 40537, cityId: 1337, code: "416507" },
    { id: 40538, cityId: 1337, code: "416509" },
    { id: 40539, cityId: 1337, code: "416527" },
    { id: 40540, cityId: 1337, code: "416536" },
    { id: 40541, cityId: 1338, code: "423601" },
    { id: 40542, cityId: 1339, code: "415514" },
    { id: 40543, cityId: 1339, code: "416520" },
    { id: 40544, cityId: 1340, code: "431711" },
    { id: 40545, cityId: 1341, code: "416106" },
    { id: 40546, cityId: 1342, code: "416101" },
    { id: 40547, cityId: 1343, code: "422306" },
    { id: 40548, cityId: 1344, code: "413513" },
    { id: 40549, cityId: 1344, code: "413519" },
    { id: 40550, cityId: 1344, code: "413521" },
    { id: 40551, cityId: 1344, code: "413524" },
    { id: 40552, cityId: 1344, code: "413539" },
    { id: 40553, cityId: 1344, code: "413542" },
    { id: 40554, cityId: 1344, code: "413558" },
    { id: 40555, cityId: 1344, code: "413563" },
    { id: 40556, cityId: 1344, code: "431522" },
    { id: 40557, cityId: 1344, code: "431527" },
    { id: 40558, cityId: 1344, code: "413512" },
    { id: 40559, cityId: 1344, code: "413514" },
    { id: 40560, cityId: 1344, code: "413517" },
    { id: 40561, cityId: 1344, code: "413520" },
    { id: 40562, cityId: 1344, code: "413523" },
    { id: 40563, cityId: 1344, code: "413530" },
    { id: 40564, cityId: 1344, code: "413531" },
    { id: 40565, cityId: 1344, code: "413544" },
    { id: 40566, cityId: 1344, code: "413560" },
    { id: 40567, cityId: 1344, code: "431507" },
    { id: 40568, cityId: 1345, code: "431708" },
    { id: 40569, cityId: 1346, code: "443302" },
    { id: 40570, cityId: 1347, code: "410401" },
    { id: 40571, cityId: 1348, code: "412806" },
    { id: 40572, cityId: 1349, code: "402301" },
    { id: 40573, cityId: 1350, code: "413217" },
    { id: 40574, cityId: 1351, code: "444503" },
    { id: 40575, cityId: 1352, code: "415101" },
    { id: 40576, cityId: 1352, code: "443101" },
    { id: 40577, cityId: 1353, code: "400081" },
    { id: 40578, cityId: 1354, code: "410503" },
    { id: 40579, cityId: 1355, code: "423104" },
    { id: 40580, cityId: 1356, code: "401403" },
    { id: 40581, cityId: 1357, code: "441406" },
    { id: 40582, cityId: 1358, code: "431505" },
    { id: 40583, cityId: 1359, code: "410102" },
    { id: 40584, cityId: 1360, code: "402105" },
    { id: 40585, cityId: 1361, code: "400055" },
    { id: 40586, cityId: 1362, code: "441502" },
    { id: 40587, cityId: 1363, code: "444905" },
    { id: 40588, cityId: 1364, code: "441303" },
    { id: 40589, cityId: 1365, code: "431715" },
    { id: 40590, cityId: 1366, code: "441224" },
    { id: 40591, cityId: 1367, code: "400002" },
    { id: 40592, cityId: 1367, code: "400003" },
    { id: 40593, cityId: 1367, code: "400005" },
    { id: 40594, cityId: 1367, code: "400008" },
    { id: 40595, cityId: 1367, code: "400010" },
    { id: 40596, cityId: 1367, code: "400011" },
    { id: 40597, cityId: 1367, code: "400013" },
    { id: 40598, cityId: 1367, code: "400016" },
    { id: 40599, cityId: 1367, code: "400018" },
    { id: 40600, cityId: 1367, code: "400019" },
    { id: 40601, cityId: 1367, code: "400021" },
    { id: 40602, cityId: 1367, code: "400024" },
    { id: 40603, cityId: 1367, code: "400026" },
    { id: 40604, cityId: 1367, code: "400029" },
    { id: 40605, cityId: 1367, code: "400031" },
    { id: 40606, cityId: 1367, code: "400032" },
    { id: 40607, cityId: 1367, code: "400034" },
    { id: 40608, cityId: 1367, code: "400037" },
    { id: 40609, cityId: 1367, code: "400039" },
    { id: 40610, cityId: 1367, code: "400040" },
    { id: 40611, cityId: 1367, code: "400047" },
    { id: 40612, cityId: 1367, code: "400048" },
    { id: 40613, cityId: 1367, code: "400050" },
    { id: 40614, cityId: 1367, code: "400053" },
    { id: 40615, cityId: 1367, code: "400055" },
    { id: 40616, cityId: 1367, code: "400056" },
    { id: 40617, cityId: 1367, code: "400058" },
    { id: 40618, cityId: 1367, code: "400061" },
    { id: 40619, cityId: 1367, code: "400063" },
    { id: 40620, cityId: 1367, code: "400064" },
    { id: 40621, cityId: 1367, code: "400066" },
    { id: 40622, cityId: 1367, code: "400069" },
    { id: 40623, cityId: 1367, code: "400071" },
    { id: 40624, cityId: 1367, code: "400072" },
    { id: 40625, cityId: 1367, code: "400074" },
    { id: 40627, cityId: 1367, code: "400077" },
    { id: 40628, cityId: 1367, code: "400079" },
    { id: 40629, cityId: 1367, code: "400082" },
    { id: 40630, cityId: 1367, code: "400084" },
    { id: 40631, cityId: 1367, code: "400085" },
    { id: 40632, cityId: 1367, code: "400087" },
    { id: 40633, cityId: 1367, code: "400090" },
    { id: 40634, cityId: 1367, code: "400092" },
    { id: 40635, cityId: 1367, code: "400093" },
    { id: 40636, cityId: 1367, code: "400095" },
    { id: 40637, cityId: 1367, code: "400098" },
    { id: 40638, cityId: 1367, code: "400101" },
    { id: 40639, cityId: 1367, code: "400103" },
    { id: 40640, cityId: 1367, code: "400001" },
    { id: 40641, cityId: 1367, code: "400004" },
    { id: 40642, cityId: 1367, code: "400006" },
    { id: 40643, cityId: 1367, code: "400007" },
    { id: 40644, cityId: 1367, code: "400009" },
    { id: 40645, cityId: 1367, code: "400012" },
    { id: 40646, cityId: 1367, code: "400014" },
    { id: 40647, cityId: 1367, code: "400015" },
    { id: 40648, cityId: 1367, code: "400017" },
    { id: 40649, cityId: 1367, code: "400020" },
    { id: 40650, cityId: 1367, code: "400022" },
    { id: 40651, cityId: 1367, code: "400023" },
    { id: 40652, cityId: 1367, code: "400025" },
    { id: 40653, cityId: 1367, code: "400027" },
    { id: 40654, cityId: 1367, code: "400028" },
    { id: 40655, cityId: 1367, code: "400030" },
    { id: 40656, cityId: 1367, code: "400033" },
    { id: 40657, cityId: 1367, code: "400035" },
    { id: 40658, cityId: 1367, code: "400036" },
    { id: 40659, cityId: 1367, code: "400038" },
    { id: 40660, cityId: 1367, code: "400043" },
    { id: 40661, cityId: 1367, code: "400046" },
    { id: 40662, cityId: 1367, code: "400049" },
    { id: 40663, cityId: 1367, code: "400051" },
    { id: 40664, cityId: 1367, code: "400052" },
    { id: 40665, cityId: 1367, code: "400054" },
    { id: 40666, cityId: 1367, code: "400057" },
    { id: 40667, cityId: 1367, code: "400059" },
    { id: 40668, cityId: 1367, code: "400060" },
    { id: 40669, cityId: 1367, code: "400062" },
    { id: 40670, cityId: 1367, code: "400065" },
    { id: 40671, cityId: 1367, code: "400067" },
    { id: 40672, cityId: 1367, code: "400068" },
    { id: 40673, cityId: 1367, code: "400070" },
    { id: 40674, cityId: 1367, code: "400075" },
    { id: 40675, cityId: 1367, code: "400078" },
    { id: 40676, cityId: 1367, code: "400080" },
    { id: 40677, cityId: 1367, code: "400081" },
    { id: 40678, cityId: 1367, code: "400083" },
    { id: 40679, cityId: 1367, code: "400086" },
    { id: 40680, cityId: 1367, code: "400088" },
    { id: 40681, cityId: 1367, code: "400089" },
    { id: 40682, cityId: 1367, code: "400091" },
    { id: 40683, cityId: 1367, code: "400094" },
    { id: 40684, cityId: 1367, code: "400096" },
    { id: 40685, cityId: 1367, code: "400097" },
    { id: 40686, cityId: 1367, code: "400099" },
    { id: 40687, cityId: 1367, code: "400102" },
    { id: 40688, cityId: 1367, code: "400104" },
    { id: 40689, cityId: 1367, code: "400105" },
    { id: 40690, cityId: 1367, code: "400125" },
    { id: 40691, cityId: 1367, code: "400547" },
    { id: 40692, cityId: 1368, code: "421401" },
    { id: 40693, cityId: 1369, code: "416219" },
    { id: 40694, cityId: 1370, code: "413510" },
    { id: 40695, cityId: 1370, code: "415721" },
    { id: 40696, cityId: 1371, code: "402106" },
    { id: 40697, cityId: 1372, code: "440001" },
    { id: 40698, cityId: 1372, code: "440004" },
    { id: 40699, cityId: 1372, code: "440006" },
    { id: 40700, cityId: 1372, code: "440007" },
    { id: 40701, cityId: 1372, code: "440009" },
    { id: 40702, cityId: 1372, code: "440012" },
    { id: 40703, cityId: 1372, code: "440014" },
    { id: 40704, cityId: 1372, code: "440015" },
    { id: 40705, cityId: 1372, code: "440017" },
    { id: 40706, cityId: 1372, code: "440020" },
    { id: 40707, cityId: 1372, code: "440022" },
    { id: 40708, cityId: 1372, code: "440025" },
    { id: 40709, cityId: 1372, code: "441103" },
    { id: 40710, cityId: 1372, code: "441109" },
    { id: 40711, cityId: 1372, code: "441111" },
    { id: 40712, cityId: 1372, code: "441114" },
    { id: 40713, cityId: 1372, code: "441116" },
    { id: 40714, cityId: 1372, code: "441117" },
    { id: 40715, cityId: 1372, code: "441201" },
    { id: 40716, cityId: 1372, code: "441204" },
    { id: 40717, cityId: 1372, code: "441304" },
    { id: 40718, cityId: 1372, code: "441305" },
    { id: 40719, cityId: 1372, code: "441402" },
    { id: 40720, cityId: 1372, code: "441403" },
    { id: 40721, cityId: 1372, code: "441405" },
    { id: 40722, cityId: 1372, code: "441408" },
    { id: 40723, cityId: 1372, code: "441501" },
    { id: 40724, cityId: 1372, code: "441503" },
    { id: 40725, cityId: 1372, code: "441807" },
    { id: 40726, cityId: 1372, code: "440002" },
    { id: 40727, cityId: 1372, code: "440003" },
    { id: 40728, cityId: 1372, code: "440005" },
    { id: 40729, cityId: 1372, code: "440008" },
    { id: 40730, cityId: 1372, code: "440010" },
    { id: 40731, cityId: 1372, code: "440011" },
    { id: 40732, cityId: 1372, code: "440013" },
    { id: 40733, cityId: 1372, code: "440016" },
    { id: 40734, cityId: 1372, code: "440018" },
    { id: 40735, cityId: 1372, code: "440021" },
    { id: 40736, cityId: 1372, code: "440024" },
    { id: 40737, cityId: 1372, code: "440026" },
    { id: 40738, cityId: 1372, code: "440027" },
    { id: 40739, cityId: 1372, code: "440029" },
    { id: 40740, cityId: 1372, code: "441001" },
    { id: 40741, cityId: 1372, code: "441102" },
    { id: 40742, cityId: 1372, code: "441104" },
    { id: 40743, cityId: 1372, code: "441105" },
    { id: 40744, cityId: 1372, code: "441110" },
    { id: 40745, cityId: 1372, code: "441112" },
    { id: 40746, cityId: 1372, code: "441115" },
    { id: 40747, cityId: 1372, code: "441202" },
    { id: 40748, cityId: 1372, code: "441203" },
    { id: 40749, cityId: 1372, code: "441210" },
    { id: 40750, cityId: 1372, code: "441216" },
    { id: 40751, cityId: 1372, code: "441301" },
    { id: 40752, cityId: 1372, code: "441306" },
    { id: 40753, cityId: 1372, code: "441401" },
    { id: 40754, cityId: 1372, code: "441404" },
    { id: 40755, cityId: 1372, code: "441409" },
    { id: 40756, cityId: 1372, code: "441806" },
    { id: 40757, cityId: 1373, code: "413602" },
    { id: 40758, cityId: 1374, code: "431531" },
    { id: 40759, cityId: 1374, code: "431602" },
    { id: 40760, cityId: 1374, code: "431706" },
    { id: 40761, cityId: 1374, code: "431713" },
    { id: 40762, cityId: 1374, code: "431719" },
    { id: 40763, cityId: 1374, code: "431721" },
    { id: 40764, cityId: 1374, code: "431726" },
    { id: 40765, cityId: 1374, code: "431732" },
    { id: 40766, cityId: 1374, code: "431735" },
    { id: 40767, cityId: 1374, code: "431740" },
    { id: 40768, cityId: 1374, code: "431742" },
    { id: 40769, cityId: 1374, code: "431743" },
    { id: 40770, cityId: 1374, code: "431745" },
    { id: 40771, cityId: 1374, code: "431801" },
    { id: 40772, cityId: 1374, code: "431803" },
    { id: 40773, cityId: 1374, code: "431806" },
    { id: 40774, cityId: 1374, code: "431811" },
    { id: 40775, cityId: 1374, code: "431812" },
    { id: 40776, cityId: 1374, code: "431814" },
    { id: 40777, cityId: 1374, code: "431601" },
    { id: 40778, cityId: 1374, code: "431604" },
    { id: 40779, cityId: 1374, code: "431704" },
    { id: 40780, cityId: 1374, code: "431707" },
    { id: 40781, cityId: 1374, code: "431709" },
    { id: 40782, cityId: 1374, code: "431717" },
    { id: 40783, cityId: 1374, code: "431718" },
    { id: 40784, cityId: 1374, code: "431722" },
    { id: 40785, cityId: 1374, code: "431723" },
    { id: 40786, cityId: 1374, code: "431725" },
    { id: 40787, cityId: 1374, code: "431731" },
    { id: 40788, cityId: 1374, code: "431733" },
    { id: 40789, cityId: 1374, code: "431741" },
    { id: 40790, cityId: 1374, code: "431744" },
    { id: 40791, cityId: 1374, code: "431746" },
    { id: 40792, cityId: 1374, code: "431802" },
    { id: 40793, cityId: 1374, code: "431805" },
    { id: 40794, cityId: 1374, code: "431807" },
    { id: 40795, cityId: 1374, code: "431815" },
    { id: 40796, cityId: 1375, code: "402406" },
    { id: 40797, cityId: 1375, code: "423106" },
    { id: 40798, cityId: 1376, code: "443404" },
    { id: 40799, cityId: 1377, code: "425413" },
    { id: 40800, cityId: 1377, code: "425409" },
    { id: 40801, cityId: 1377, code: "425412" },
    { id: 40802, cityId: 1378, code: "422002" },
    { id: 40803, cityId: 1378, code: "422005" },
    { id: 40804, cityId: 1378, code: "422007" },
    { id: 40805, cityId: 1378, code: "422008" },
    { id: 40806, cityId: 1378, code: "422010" },
    { id: 40807, cityId: 1378, code: "422105" },
    { id: 40808, cityId: 1378, code: "422108" },
    { id: 40809, cityId: 1378, code: "422203" },
    { id: 40810, cityId: 1378, code: "422204" },
    { id: 40811, cityId: 1378, code: "422209" },
    { id: 40812, cityId: 1378, code: "422214" },
    { id: 40813, cityId: 1378, code: "422301" },
    { id: 40814, cityId: 1378, code: "422302" },
    { id: 40815, cityId: 1378, code: "422307" },
    { id: 40816, cityId: 1378, code: "422402" },
    { id: 40817, cityId: 1378, code: "422405" },
    { id: 40818, cityId: 1378, code: "422503" },
    { id: 40819, cityId: 1378, code: "423101" },
    { id: 40820, cityId: 1378, code: "423106" },
    { id: 40821, cityId: 1378, code: "423114" },
    { id: 40822, cityId: 1378, code: "423117" },
    { id: 40823, cityId: 1378, code: "423202" },
    { id: 40824, cityId: 1378, code: "423204" },
    { id: 40825, cityId: 1378, code: "423210" },
    { id: 40826, cityId: 1378, code: "423212" },
    { id: 40827, cityId: 1378, code: "423213" },
    { id: 40828, cityId: 1378, code: "423302" },
    { id: 40829, cityId: 1378, code: "423303" },
    { id: 40830, cityId: 1378, code: "423401" },
    { id: 40831, cityId: 1378, code: "423501" },
    { id: 40832, cityId: 1378, code: "422001" },
    { id: 40833, cityId: 1378, code: "422003" },
    { id: 40834, cityId: 1378, code: "422004" },
    { id: 40835, cityId: 1378, code: "422006" },
    { id: 40836, cityId: 1378, code: "422101" },
    { id: 40837, cityId: 1378, code: "422102" },
    { id: 40838, cityId: 1378, code: "422104" },
    { id: 40839, cityId: 1378, code: "422107" },
    { id: 40840, cityId: 1378, code: "422202" },
    { id: 40841, cityId: 1378, code: "422205" },
    { id: 40842, cityId: 1378, code: "422207" },
    { id: 40843, cityId: 1378, code: "422208" },
    { id: 40844, cityId: 1378, code: "422210" },
    { id: 40845, cityId: 1378, code: "422215" },
    { id: 40846, cityId: 1378, code: "422216" },
    { id: 40847, cityId: 1378, code: "422303" },
    { id: 40848, cityId: 1378, code: "422305" },
    { id: 40849, cityId: 1378, code: "422501" },
    { id: 40850, cityId: 1378, code: "423102" },
    { id: 40851, cityId: 1378, code: "423105" },
    { id: 40852, cityId: 1378, code: "423108" },
    { id: 40853, cityId: 1378, code: "423111" },
    { id: 40854, cityId: 1378, code: "423116" },
    { id: 40855, cityId: 1378, code: "423201" },
    { id: 40856, cityId: 1378, code: "423203" },
    { id: 40857, cityId: 1378, code: "423206" },
    { id: 40858, cityId: 1378, code: "423208" },
    { id: 40859, cityId: 1378, code: "423209" },
    { id: 40860, cityId: 1378, code: "423211" },
    { id: 40861, cityId: 1378, code: "423304" },
    { id: 40862, cityId: 1378, code: "423402" },
    { id: 40863, cityId: 1378, code: "423502" },
    { id: 40864, cityId: 1379, code: "410101" },
    { id: 40865, cityId: 1380, code: "415207" },
    { id: 40866, cityId: 1380, code: "415405" },
    { id: 40867, cityId: 1380, code: "416510" },
    { id: 40868, cityId: 1380, code: "416512" },
    { id: 40869, cityId: 1380, code: "416513" },
    { id: 40870, cityId: 1380, code: "416518" },
    { id: 40871, cityId: 1380, code: "416523" },
    { id: 40872, cityId: 1380, code: "416525" },
    { id: 40873, cityId: 1380, code: "416526" },
    { id: 40874, cityId: 1380, code: "416528" },
    { id: 40875, cityId: 1380, code: "416531" },
    { id: 40876, cityId: 1380, code: "416534" },
    { id: 40877, cityId: 1380, code: "416539" },
    { id: 40878, cityId: 1380, code: "416541" },
    { id: 40879, cityId: 1380, code: "416542" },
    { id: 40880, cityId: 1380, code: "416550" },
    { id: 40881, cityId: 1380, code: "416602" },
    { id: 40882, cityId: 1380, code: "416603" },
    { id: 40883, cityId: 1380, code: "416605" },
    { id: 40884, cityId: 1380, code: "416608" },
    { id: 40885, cityId: 1380, code: "416610" },
    { id: 40886, cityId: 1380, code: "416613" },
    { id: 40887, cityId: 1380, code: "416618" },
    { id: 40888, cityId: 1380, code: "416621" },
    { id: 40889, cityId: 1380, code: "416623" },
    { id: 40890, cityId: 1380, code: "416624" },
    { id: 40891, cityId: 1380, code: "416626" },
    { id: 40892, cityId: 1380, code: "416703" },
    { id: 40893, cityId: 1380, code: "416801" },
    { id: 40894, cityId: 1380, code: "416804" },
    { id: 40895, cityId: 1380, code: "416807" },
    { id: 40896, cityId: 1380, code: "416809" },
    { id: 40897, cityId: 1380, code: "422213" },
    { id: 40898, cityId: 1380, code: "416514" },
    { id: 40899, cityId: 1380, code: "416517" },
    { id: 40900, cityId: 1380, code: "416519" },
    { id: 40901, cityId: 1380, code: "416521" },
    { id: 40902, cityId: 1380, code: "416522" },
    { id: 40903, cityId: 1380, code: "416524" },
    { id: 40904, cityId: 1380, code: "416529" },
    { id: 40905, cityId: 1380, code: "416530" },
    { id: 40906, cityId: 1380, code: "416532" },
    { id: 40907, cityId: 1380, code: "416537" },
    { id: 40908, cityId: 1380, code: "416538" },
    { id: 40909, cityId: 1380, code: "416540" },
    { id: 40910, cityId: 1380, code: "416601" },
    { id: 40911, cityId: 1380, code: "416604" },
    { id: 40912, cityId: 1380, code: "416606" },
    { id: 40913, cityId: 1380, code: "416607" },
    { id: 40914, cityId: 1380, code: "416609" },
    { id: 40915, cityId: 1380, code: "416612" },
    { id: 40916, cityId: 1380, code: "416615" },
    { id: 40917, cityId: 1380, code: "416620" },
    { id: 40918, cityId: 1380, code: "416622" },
    { id: 40919, cityId: 1380, code: "416625" },
    { id: 40920, cityId: 1380, code: "416628" },
    { id: 40921, cityId: 1380, code: "416630" },
    { id: 40922, cityId: 1380, code: "416802" },
    { id: 40923, cityId: 1380, code: "416803" },
    { id: 40924, cityId: 1380, code: "416805" },
    { id: 40925, cityId: 1380, code: "416810" },
    { id: 40926, cityId: 1380, code: "418010" },
    { id: 40927, cityId: 1381, code: "413501" },
    { id: 40928, cityId: 1381, code: "413504" },
    { id: 40929, cityId: 1381, code: "413509" },
    { id: 40930, cityId: 1381, code: "413515" },
    { id: 40931, cityId: 1381, code: "413522" },
    { id: 40932, cityId: 1381, code: "413525" },
    { id: 40933, cityId: 1381, code: "413528" },
    { id: 40934, cityId: 1381, code: "413536" },
    { id: 40935, cityId: 1381, code: "413541" },
    { id: 40936, cityId: 1381, code: "413546" },
    { id: 40937, cityId: 1381, code: "413547" },
    { id: 40938, cityId: 1381, code: "413554" },
    { id: 40939, cityId: 1381, code: "413576" },
    { id: 40940, cityId: 1381, code: "413605" },
    { id: 40941, cityId: 1381, code: "413607" },
    { id: 40942, cityId: 1381, code: "413612" },
    { id: 40943, cityId: 1381, code: "413615" },
    { id: 40944, cityId: 1381, code: "413623" },
    { id: 40945, cityId: 1381, code: "413405" },
    { id: 40946, cityId: 1381, code: "413503" },
    { id: 40947, cityId: 1381, code: "413505" },
    { id: 40948, cityId: 1381, code: "413508" },
    { id: 40949, cityId: 1381, code: "413511" },
    { id: 40950, cityId: 1381, code: "413518" },
    { id: 40951, cityId: 1381, code: "413526" },
    { id: 40952, cityId: 1381, code: "413527" },
    { id: 40953, cityId: 1381, code: "413529" },
    { id: 40954, cityId: 1381, code: "413534" },
    { id: 40955, cityId: 1381, code: "413540" },
    { id: 40956, cityId: 1381, code: "413569" },
    { id: 40957, cityId: 1381, code: "413571" },
    { id: 40958, cityId: 1381, code: "413577" },
    { id: 40959, cityId: 1381, code: "413580" },
    { id: 40960, cityId: 1381, code: "413603" },
    { id: 40961, cityId: 1381, code: "413606" },
    { id: 40962, cityId: 1381, code: "413616" },
    { id: 40963, cityId: 1381, code: "413624" },
    { id: 40964, cityId: 1382, code: "422206" },
    { id: 40965, cityId: 1383, code: "424201" },
    { id: 40966, cityId: 1384, code: "421101" },
    { id: 40967, cityId: 1385, code: "431107" },
    { id: 40968, cityId: 1386, code: "306001" },
    { id: 40969, cityId: 1386, code: "306021" },
    { id: 40970, cityId: 1386, code: "306022" },
    { id: 40971, cityId: 1386, code: "306024" },
    { id: 40972, cityId: 1386, code: "306027" },
    { id: 40973, cityId: 1386, code: "306101" },
    { id: 40974, cityId: 1386, code: "306104" },
    { id: 40975, cityId: 1386, code: "306106" },
    { id: 40976, cityId: 1386, code: "306107" },
    { id: 40977, cityId: 1386, code: "306114" },
    { id: 40978, cityId: 1386, code: "306117" },
    { id: 40979, cityId: 1386, code: "306119" },
    { id: 40980, cityId: 1386, code: "306127" },
    { id: 40981, cityId: 1386, code: "306128" },
    { id: 40982, cityId: 1386, code: "306302" },
    { id: 40983, cityId: 1386, code: "306303" },
    { id: 40984, cityId: 1386, code: "306305" },
    { id: 40985, cityId: 1386, code: "306307" },
    { id: 40986, cityId: 1386, code: "306308" },
    { id: 40987, cityId: 1386, code: "306310" },
    { id: 40988, cityId: 1386, code: "306401" },
    { id: 40989, cityId: 1386, code: "306421" },
    { id: 40990, cityId: 1386, code: "306501" },
    { id: 40991, cityId: 1386, code: "306503" },
    { id: 40992, cityId: 1386, code: "306504" },
    { id: 40993, cityId: 1386, code: "306601" },
    { id: 40994, cityId: 1386, code: "306602" },
    { id: 40995, cityId: 1386, code: "306705" },
    { id: 40996, cityId: 1386, code: "306707" },
    { id: 40997, cityId: 1386, code: "306708" },
    { id: 40998, cityId: 1386, code: "306710" },
    { id: 40999, cityId: 1386, code: "306901" },
    { id: 41000, cityId: 1386, code: "241123" },
    { id: 41001, cityId: 1386, code: "306023" },
    { id: 41002, cityId: 1386, code: "306025" },
    { id: 41003, cityId: 1386, code: "306026" },
    { id: 41004, cityId: 1386, code: "306028" },
    { id: 41005, cityId: 1386, code: "306102" },
    { id: 41006, cityId: 1386, code: "306103" },
    { id: 41007, cityId: 1386, code: "306108" },
    { id: 41008, cityId: 1386, code: "306115" },
    { id: 41009, cityId: 1386, code: "306116" },
    { id: 41010, cityId: 1386, code: "306118" },
    { id: 41011, cityId: 1386, code: "306126" },
    { id: 41012, cityId: 1386, code: "306301" },
    { id: 41013, cityId: 1386, code: "306304" },
    { id: 41014, cityId: 1386, code: "306306" },
    { id: 41015, cityId: 1386, code: "306309" },
    { id: 41016, cityId: 1386, code: "306502" },
    { id: 41017, cityId: 1386, code: "306505" },
    { id: 41018, cityId: 1386, code: "306603" },
    { id: 41019, cityId: 1386, code: "306701" },
    { id: 41020, cityId: 1386, code: "306703" },
    { id: 41021, cityId: 1386, code: "306704" },
    { id: 41022, cityId: 1386, code: "306706" },
    { id: 41023, cityId: 1386, code: "306709" },
    { id: 41024, cityId: 1386, code: "306902" },
    { id: 41025, cityId: 1386, code: "410205" },
    { id: 41026, cityId: 1387, code: "416201" },
    { id: 41027, cityId: 1388, code: "413502" },
    { id: 41028, cityId: 1389, code: "431502" },
    { id: 41029, cityId: 1389, code: "431508" },
    { id: 41030, cityId: 1389, code: "431510" },
    { id: 41031, cityId: 1389, code: "431526" },
    { id: 41032, cityId: 1389, code: "431537" },
    { id: 41033, cityId: 1389, code: "431540" },
    { id: 41034, cityId: 1389, code: "431701" },
    { id: 41035, cityId: 1389, code: "431720" },
    { id: 41036, cityId: 1389, code: "431401" },
    { id: 41037, cityId: 1389, code: "431512" },
    { id: 41038, cityId: 1389, code: "431541" },
    { id: 41039, cityId: 1389, code: "431705" },
    { id: 41040, cityId: 1390, code: "425111" },
    { id: 41041, cityId: 1391, code: "431501" },
    { id: 41042, cityId: 1392, code: "364292" },
    { id: 41043, cityId: 1392, code: "384260" },
    { id: 41044, cityId: 1392, code: "384265" },
    { id: 41045, cityId: 1392, code: "384278" },
    { id: 41046, cityId: 1392, code: "415206" },
    { id: 41047, cityId: 1392, code: "491111" },
    { id: 41048, cityId: 1392, code: "384110" },
    { id: 41049, cityId: 1392, code: "384112" },
    { id: 41050, cityId: 1392, code: "384255" },
    { id: 41051, cityId: 1392, code: "384256" },
    { id: 41052, cityId: 1392, code: "384271" },
    { id: 41053, cityId: 1392, code: "384276" },
    { id: 41054, cityId: 1392, code: "384277" },
    { id: 41055, cityId: 1392, code: "483113" },
    { id: 41056, cityId: 1393, code: "414102" },
    { id: 41057, cityId: 1394, code: "431506" },
    { id: 41058, cityId: 1394, code: "441215" },
    { id: 41059, cityId: 1395, code: "444501" },
    { id: 41060, cityId: 1396, code: "400064" },
    { id: 41061, cityId: 1396, code: "402107" },
    { id: 41062, cityId: 1397, code: "415523" },
    { id: 41063, cityId: 1398, code: "431213" },
    { id: 41064, cityId: 1399, code: "402303" },
    { id: 41065, cityId: 1400, code: "442302" },
    { id: 41066, cityId: 1401, code: "410302" },
    { id: 41067, cityId: 1401, code: "410402" },
    { id: 41068, cityId: 1401, code: "410403" },
    { id: 41069, cityId: 1401, code: "410405" },
    { id: 41070, cityId: 1401, code: "410410" },
    { id: 41071, cityId: 1401, code: "410506" },
    { id: 41072, cityId: 1401, code: "410508" },
    { id: 41073, cityId: 1401, code: "410509" },
    { id: 41074, cityId: 1401, code: "410511" },
    { id: 41075, cityId: 1401, code: "410514" },
    { id: 41076, cityId: 1401, code: "411001" },
    { id: 41077, cityId: 1401, code: "411003" },
    { id: 41078, cityId: 1401, code: "411004" },
    { id: 41079, cityId: 1401, code: "411006" },
    { id: 41080, cityId: 1401, code: "411009" },
    { id: 41081, cityId: 1401, code: "411011" },
    { id: 41082, cityId: 1401, code: "411012" },
    { id: 41083, cityId: 1401, code: "411014" },
    { id: 41084, cityId: 1401, code: "411017" },
    { id: 41085, cityId: 1401, code: "411019" },
    { id: 41086, cityId: 1401, code: "411020" },
    { id: 41087, cityId: 1401, code: "411022" },
    { id: 41088, cityId: 1401, code: "411025" },
    { id: 41089, cityId: 1401, code: "411027" },
    { id: 41090, cityId: 1401, code: "411028" },
    { id: 41091, cityId: 1401, code: "411030" },
    { id: 41092, cityId: 1401, code: "411033" },
    { id: 41093, cityId: 1401, code: "411035" },
    { id: 41094, cityId: 1401, code: "411036" },
    { id: 41095, cityId: 1401, code: "411038" },
    { id: 41096, cityId: 1401, code: "411041" },
    { id: 41097, cityId: 1401, code: "411043" },
    { id: 41098, cityId: 1401, code: "411044" },
    { id: 41099, cityId: 1401, code: "411046" },
    { id: 41100, cityId: 1401, code: "411051" },
    { id: 41101, cityId: 1401, code: "411125" },
    { id: 41102, cityId: 1401, code: "411925" },
    { id: 41103, cityId: 1401, code: "412103" },
    { id: 41104, cityId: 1401, code: "412105" },
    { id: 41105, cityId: 1401, code: "412106" },
    { id: 41106, cityId: 1401, code: "412108" },
    { id: 41107, cityId: 1401, code: "412111" },
    { id: 41108, cityId: 1401, code: "412113" },
    { id: 41109, cityId: 1401, code: "412114" },
    { id: 41110, cityId: 1401, code: "412201" },
    { id: 41111, cityId: 1401, code: "412203" },
    { id: 41112, cityId: 1401, code: "412204" },
    { id: 41113, cityId: 1401, code: "412209" },
    { id: 41114, cityId: 1401, code: "412211" },
    { id: 41115, cityId: 1401, code: "412212" },
    { id: 41116, cityId: 1401, code: "412214" },
    { id: 41117, cityId: 1401, code: "412217" },
    { id: 41118, cityId: 1401, code: "412301" },
    { id: 41119, cityId: 1401, code: "412302" },
    { id: 41120, cityId: 1401, code: "412304" },
    { id: 41121, cityId: 1401, code: "412307" },
    { id: 41122, cityId: 1401, code: "412309" },
    { id: 41123, cityId: 1401, code: "412310" },
    { id: 41124, cityId: 1401, code: "412405" },
    { id: 41125, cityId: 1401, code: "412407" },
    { id: 41126, cityId: 1401, code: "412408" },
    { id: 41127, cityId: 1401, code: "412410" },
    { id: 41128, cityId: 1401, code: "412412" },
    { id: 41129, cityId: 1401, code: "412413" },
    { id: 41130, cityId: 1401, code: "412415" },
    { id: 41131, cityId: 1401, code: "413104" },
    { id: 41132, cityId: 1401, code: "413114" },
    { id: 41133, cityId: 1401, code: "413115" },
    { id: 41134, cityId: 1401, code: "413117" },
    { id: 41135, cityId: 1401, code: "413120" },
    { id: 41136, cityId: 1401, code: "413130" },
    { id: 41137, cityId: 1401, code: "410301" },
    { id: 41138, cityId: 1401, code: "410401" },
    { id: 41139, cityId: 1401, code: "410504" },
    { id: 41140, cityId: 1401, code: "410505" },
    { id: 41141, cityId: 1401, code: "410507" },
    { id: 41142, cityId: 1401, code: "411002" },
    { id: 41143, cityId: 1401, code: "411005" },
    { id: 41144, cityId: 1401, code: "411007" },
    { id: 41145, cityId: 1401, code: "411008" },
    { id: 41146, cityId: 1401, code: "411010" },
    { id: 41147, cityId: 1401, code: "411013" },
    { id: 41148, cityId: 1401, code: "411015" },
    { id: 41149, cityId: 1401, code: "411016" },
    { id: 41150, cityId: 1401, code: "411018" },
    { id: 41151, cityId: 1401, code: "411021" },
    { id: 41152, cityId: 1401, code: "411023" },
    { id: 41153, cityId: 1401, code: "411024" },
    { id: 41154, cityId: 1401, code: "411026" },
    { id: 41155, cityId: 1401, code: "411029" },
    { id: 41156, cityId: 1401, code: "411031" },
    { id: 41157, cityId: 1401, code: "411032" },
    { id: 41158, cityId: 1401, code: "411034" },
    { id: 41159, cityId: 1401, code: "411039" },
    { id: 41160, cityId: 1401, code: "411040" },
    { id: 41161, cityId: 1401, code: "411042" },
    { id: 41162, cityId: 1401, code: "411045" },
    { id: 41163, cityId: 1401, code: "411105" },
    { id: 41164, cityId: 1401, code: "412101" },
    { id: 41165, cityId: 1401, code: "412102" },
    { id: 41166, cityId: 1401, code: "412104" },
    { id: 41167, cityId: 1401, code: "412107" },
    { id: 41168, cityId: 1401, code: "412109" },
    { id: 41169, cityId: 1401, code: "412110" },
    { id: 41170, cityId: 1401, code: "412112" },
    { id: 41171, cityId: 1401, code: "412202" },
    { id: 41172, cityId: 1401, code: "412205" },
    { id: 41173, cityId: 1401, code: "412207" },
    { id: 41174, cityId: 1401, code: "412208" },
    { id: 41175, cityId: 1401, code: "412210" },
    { id: 41176, cityId: 1401, code: "412213" },
    { id: 41177, cityId: 1401, code: "412215" },
    { id: 41178, cityId: 1401, code: "412218" },
    { id: 41179, cityId: 1401, code: "412305" },
    { id: 41180, cityId: 1401, code: "412306" },
    { id: 41181, cityId: 1401, code: "412308" },
    { id: 41182, cityId: 1401, code: "412311" },
    { id: 41183, cityId: 1401, code: "412403" },
    { id: 41184, cityId: 1401, code: "412404" },
    { id: 41185, cityId: 1401, code: "412409" },
    { id: 41186, cityId: 1401, code: "412411" },
    { id: 41187, cityId: 1401, code: "413102" },
    { id: 41188, cityId: 1401, code: "413103" },
    { id: 41189, cityId: 1401, code: "413105" },
    { id: 41190, cityId: 1401, code: "413110" },
    { id: 41191, cityId: 1401, code: "413116" },
    { id: 41192, cityId: 1401, code: "413124" },
    { id: 41193, cityId: 1401, code: "413132" },
    { id: 41194, cityId: 1402, code: "431511" },
    { id: 41195, cityId: 1403, code: "445204" },
    { id: 41196, cityId: 1404, code: "415511" },
    { id: 41197, cityId: 1405, code: "413705" },
    { id: 41198, cityId: 1406, code: "211002" },
    { id: 41199, cityId: 1406, code: "282002" },
    { id: 41200, cityId: 1406, code: "416702" },
    { id: 41201, cityId: 1406, code: "210205" },
    { id: 41202, cityId: 1407, code: "422604" },
    { id: 41203, cityId: 1408, code: "441106" },
    { id: 41204, cityId: 1409, code: "415203" },
    { id: 41205, cityId: 1409, code: "415208" },
    { id: 41206, cityId: 1409, code: "415603" },
    { id: 41207, cityId: 1409, code: "415605" },
    { id: 41208, cityId: 1409, code: "415606" },
    { id: 41209, cityId: 1409, code: "415608" },
    { id: 41210, cityId: 1409, code: "415611" },
    { id: 41211, cityId: 1409, code: "415613" },
    { id: 41212, cityId: 1409, code: "415614" },
    { id: 41213, cityId: 1409, code: "415618" },
    { id: 41214, cityId: 1409, code: "415621" },
    { id: 41215, cityId: 1409, code: "415626" },
    { id: 41216, cityId: 1409, code: "415627" },
    { id: 41217, cityId: 1409, code: "415629" },
    { id: 41218, cityId: 1409, code: "415637" },
    { id: 41219, cityId: 1409, code: "415701" },
    { id: 41220, cityId: 1409, code: "415704" },
    { id: 41221, cityId: 1409, code: "415706" },
    { id: 41222, cityId: 1409, code: "415711" },
    { id: 41223, cityId: 1409, code: "415712" },
    { id: 41224, cityId: 1409, code: "415714" },
    { id: 41225, cityId: 1409, code: "415716" },
    { id: 41226, cityId: 1409, code: "415717" },
    { id: 41227, cityId: 1409, code: "415719" },
    { id: 41228, cityId: 1409, code: "415722" },
    { id: 41229, cityId: 1409, code: "415724" },
    { id: 41230, cityId: 1409, code: "415727" },
    { id: 41231, cityId: 1409, code: "415801" },
    { id: 41232, cityId: 1409, code: "415802" },
    { id: 41233, cityId: 1409, code: "415804" },
    { id: 41234, cityId: 1409, code: "415807" },
    { id: 41235, cityId: 1409, code: "416704" },
    { id: 41236, cityId: 1409, code: "416705" },
    { id: 41237, cityId: 1409, code: "416707" },
    { id: 41238, cityId: 1409, code: "416710" },
    { id: 41239, cityId: 1409, code: "416712" },
    { id: 41240, cityId: 1409, code: "415201" },
    { id: 41241, cityId: 1409, code: "415202" },
    { id: 41242, cityId: 1409, code: "415204" },
    { id: 41243, cityId: 1409, code: "415601" },
    { id: 41244, cityId: 1409, code: "415602" },
    { id: 41245, cityId: 1409, code: "415607" },
    { id: 41246, cityId: 1409, code: "415609" },
    { id: 41247, cityId: 1409, code: "415610" },
    { id: 41248, cityId: 1409, code: "415612" },
    { id: 41249, cityId: 1409, code: "415615" },
    { id: 41250, cityId: 1409, code: "415617" },
    { id: 41251, cityId: 1409, code: "415620" },
    { id: 41252, cityId: 1409, code: "415622" },
    { id: 41253, cityId: 1409, code: "415628" },
    { id: 41254, cityId: 1409, code: "415630" },
    { id: 41255, cityId: 1409, code: "415631" },
    { id: 41256, cityId: 1409, code: "415633" },
    { id: 41257, cityId: 1409, code: "415641" },
    { id: 41258, cityId: 1409, code: "415702" },
    { id: 41259, cityId: 1409, code: "415705" },
    { id: 41260, cityId: 1409, code: "415707" },
    { id: 41261, cityId: 1409, code: "415708" },
    { id: 41262, cityId: 1409, code: "415710" },
    { id: 41263, cityId: 1409, code: "415713" },
    { id: 41264, cityId: 1409, code: "415715" },
    { id: 41265, cityId: 1409, code: "415718" },
    { id: 41266, cityId: 1409, code: "415720" },
    { id: 41267, cityId: 1409, code: "415726" },
    { id: 41268, cityId: 1409, code: "415728" },
    { id: 41269, cityId: 1409, code: "415803" },
    { id: 41270, cityId: 1409, code: "415805" },
    { id: 41271, cityId: 1409, code: "415806" },
    { id: 41272, cityId: 1409, code: "416515" },
    { id: 41273, cityId: 1409, code: "416709" },
    { id: 41274, cityId: 1410, code: "425508" },
    { id: 41275, cityId: 1411, code: "444506" },
    { id: 41276, cityId: 1412, code: "431503" },
    { id: 41277, cityId: 1413, code: "422605" },
    { id: 41278, cityId: 1414, code: "413318" },
    { id: 41279, cityId: 1414, code: "415301" },
    { id: 41280, cityId: 1414, code: "415304" },
    { id: 41281, cityId: 1414, code: "415307" },
    { id: 41282, cityId: 1414, code: "415309" },
    { id: 41283, cityId: 1414, code: "415315" },
    { id: 41284, cityId: 1414, code: "415402" },
    { id: 41285, cityId: 1414, code: "415404" },
    { id: 41286, cityId: 1414, code: "415407" },
    { id: 41287, cityId: 1414, code: "415412" },
    { id: 41288, cityId: 1414, code: "415413" },
    { id: 41289, cityId: 1414, code: "415415" },
    { id: 41290, cityId: 1414, code: "415417" },
    { id: 41291, cityId: 1414, code: "415418" },
    { id: 41292, cityId: 1414, code: "416006" },
    { id: 41293, cityId: 1414, code: "416302" },
    { id: 41294, cityId: 1414, code: "416305" },
    { id: 41295, cityId: 1414, code: "416307" },
    { id: 41296, cityId: 1414, code: "416308" },
    { id: 41297, cityId: 1414, code: "416310" },
    { id: 41298, cityId: 1414, code: "416313" },
    { id: 41299, cityId: 1414, code: "416315" },
    { id: 41300, cityId: 1414, code: "416316" },
    { id: 41301, cityId: 1414, code: "416321" },
    { id: 41302, cityId: 1414, code: "416403" },
    { id: 41303, cityId: 1414, code: "416405" },
    { id: 41304, cityId: 1414, code: "416406" },
    { id: 41305, cityId: 1414, code: "416408" },
    { id: 41306, cityId: 1414, code: "416411" },
    { id: 41307, cityId: 1414, code: "416414" },
    { id: 41308, cityId: 1414, code: "416416" },
    { id: 41309, cityId: 1414, code: "416419" },
    { id: 41310, cityId: 1414, code: "416422" },
    { id: 41311, cityId: 1414, code: "415302" },
    { id: 41312, cityId: 1414, code: "415303" },
    { id: 41313, cityId: 1414, code: "415305" },
    { id: 41314, cityId: 1414, code: "415308" },
    { id: 41315, cityId: 1414, code: "415310" },
    { id: 41316, cityId: 1414, code: "415311" },
    { id: 41317, cityId: 1414, code: "415313" },
    { id: 41318, cityId: 1414, code: "415401" },
    { id: 41319, cityId: 1414, code: "415403" },
    { id: 41320, cityId: 1414, code: "415406" },
    { id: 41321, cityId: 1414, code: "415408" },
    { id: 41322, cityId: 1414, code: "415409" },
    { id: 41323, cityId: 1414, code: "415416" },
    { id: 41324, cityId: 1414, code: "416301" },
    { id: 41325, cityId: 1414, code: "416303" },
    { id: 41326, cityId: 1414, code: "416306" },
    { id: 41327, cityId: 1414, code: "416309" },
    { id: 41328, cityId: 1414, code: "416311" },
    { id: 41329, cityId: 1414, code: "416312" },
    { id: 41330, cityId: 1414, code: "416314" },
    { id: 41331, cityId: 1414, code: "416317" },
    { id: 41332, cityId: 1414, code: "416319" },
    { id: 41333, cityId: 1414, code: "416320" },
    { id: 41334, cityId: 1414, code: "416322" },
    { id: 41335, cityId: 1414, code: "416401" },
    { id: 41336, cityId: 1414, code: "416402" },
    { id: 41337, cityId: 1414, code: "416404" },
    { id: 41338, cityId: 1414, code: "416407" },
    { id: 41339, cityId: 1414, code: "416409" },
    { id: 41340, cityId: 1414, code: "416410" },
    { id: 41341, cityId: 1414, code: "416412" },
    { id: 41342, cityId: 1414, code: "416415" },
    { id: 41343, cityId: 1414, code: "416417" },
    { id: 41344, cityId: 1414, code: "416418" },
    { id: 41345, cityId: 1414, code: "416420" },
    { id: 41346, cityId: 1414, code: "416423" },
    { id: 41347, cityId: 1414, code: "416425" },
    { id: 41348, cityId: 1414, code: "416426" },
    { id: 41349, cityId: 1414, code: "416428" },
    { id: 41350, cityId: 1415, code: "413307" },
    { id: 41351, cityId: 1416, code: "442706" },
    { id: 41352, cityId: 1417, code: "423301" },
    { id: 41353, cityId: 1418, code: "412802" },
    { id: 41354, cityId: 1418, code: "412805" },
    { id: 41355, cityId: 1418, code: "415001" },
    { id: 41356, cityId: 1418, code: "415011" },
    { id: 41357, cityId: 1418, code: "415014" },
    { id: 41358, cityId: 1418, code: "415017" },
    { id: 41359, cityId: 1418, code: "415019" },
    { id: 41360, cityId: 1418, code: "415022" },
    { id: 41361, cityId: 1418, code: "415104" },
    { id: 41362, cityId: 1418, code: "415106" },
    { id: 41363, cityId: 1418, code: "415107" },
    { id: 41364, cityId: 1418, code: "415112" },
    { id: 41365, cityId: 1418, code: "415114" },
    { id: 41366, cityId: 1418, code: "415115" },
    { id: 41367, cityId: 1418, code: "415120" },
    { id: 41368, cityId: 1418, code: "415205" },
    { id: 41369, cityId: 1418, code: "415210" },
    { id: 41370, cityId: 1418, code: "415212" },
    { id: 41371, cityId: 1418, code: "415504" },
    { id: 41372, cityId: 1418, code: "415506" },
    { id: 41373, cityId: 1418, code: "415507" },
    { id: 41374, cityId: 1418, code: "415509" },
    { id: 41375, cityId: 1418, code: "415512" },
    { id: 41376, cityId: 1418, code: "415517" },
    { id: 41377, cityId: 1418, code: "415519" },
    { id: 41378, cityId: 1418, code: "415520" },
    { id: 41379, cityId: 1418, code: "415522" },
    { id: 41380, cityId: 1418, code: "415525" },
    { id: 41381, cityId: 1418, code: "415527" },
    { id: 41382, cityId: 1418, code: "415528" },
    { id: 41383, cityId: 1418, code: "415530" },
    { id: 41384, cityId: 1418, code: "415536" },
    { id: 41385, cityId: 1418, code: "425116" },
    { id: 41386, cityId: 1418, code: "412801" },
    { id: 41387, cityId: 1418, code: "412804" },
    { id: 41388, cityId: 1418, code: "415002" },
    { id: 41389, cityId: 1418, code: "415004" },
    { id: 41390, cityId: 1418, code: "415010" },
    { id: 41391, cityId: 1418, code: "415012" },
    { id: 41392, cityId: 1418, code: "415013" },
    { id: 41393, cityId: 1418, code: "415015" },
    { id: 41394, cityId: 1418, code: "415021" },
    { id: 41395, cityId: 1418, code: "415102" },
    { id: 41396, cityId: 1418, code: "415103" },
    { id: 41397, cityId: 1418, code: "415105" },
    { id: 41398, cityId: 1418, code: "415108" },
    { id: 41399, cityId: 1418, code: "415110" },
    { id: 41400, cityId: 1418, code: "415111" },
    { id: 41401, cityId: 1418, code: "415116" },
    { id: 41402, cityId: 1418, code: "415118" },
    { id: 41403, cityId: 1418, code: "415209" },
    { id: 41404, cityId: 1418, code: "415211" },
    { id: 41405, cityId: 1418, code: "415312" },
    { id: 41406, cityId: 1418, code: "415502" },
    { id: 41407, cityId: 1418, code: "415503" },
    { id: 41408, cityId: 1418, code: "415505" },
    { id: 41409, cityId: 1418, code: "415508" },
    { id: 41410, cityId: 1418, code: "415510" },
    { id: 41411, cityId: 1418, code: "415513" },
    { id: 41412, cityId: 1418, code: "415515" },
    { id: 41413, cityId: 1418, code: "415516" },
    { id: 41414, cityId: 1418, code: "415518" },
    { id: 41415, cityId: 1418, code: "415521" },
    { id: 41416, cityId: 1418, code: "415524" },
    { id: 41417, cityId: 1418, code: "415526" },
    { id: 41418, cityId: 1418, code: "415531" },
    { id: 41419, cityId: 1418, code: "415532" },
    { id: 41420, cityId: 1419, code: "425502" },
    { id: 41421, cityId: 1420, code: "441107" },
    { id: 41422, cityId: 1421, code: "425409" },
    { id: 41423, cityId: 1422, code: "400064" },
    { id: 41424, cityId: 1423, code: "423109" },
    { id: 41425, cityId: 1424, code: "413249" },
    { id: 41426, cityId: 1425, code: "442503" },
    { id: 41427, cityId: 1426, code: "413001" },
    { id: 41428, cityId: 1426, code: "413003" },
    { id: 41429, cityId: 1426, code: "413004" },
    { id: 41430, cityId: 1426, code: "413006" },
    { id: 41431, cityId: 1426, code: "413101" },
    { id: 41432, cityId: 1426, code: "413107" },
    { id: 41433, cityId: 1426, code: "413109" },
    { id: 41434, cityId: 1426, code: "413112" },
    { id: 41435, cityId: 1426, code: "413125" },
    { id: 41436, cityId: 1426, code: "413128" },
    { id: 41437, cityId: 1426, code: "413202" },
    { id: 41438, cityId: 1426, code: "413208" },
    { id: 41439, cityId: 1426, code: "413210" },
    { id: 41440, cityId: 1426, code: "413212" },
    { id: 41441, cityId: 1426, code: "413213" },
    { id: 41442, cityId: 1426, code: "413215" },
    { id: 41443, cityId: 1426, code: "413218" },
    { id: 41444, cityId: 1426, code: "413221" },
    { id: 41445, cityId: 1426, code: "413223" },
    { id: 41446, cityId: 1426, code: "413226" },
    { id: 41447, cityId: 1426, code: "413228" },
    { id: 41448, cityId: 1426, code: "413231" },
    { id: 41449, cityId: 1426, code: "413234" },
    { id: 41450, cityId: 1426, code: "413237" },
    { id: 41451, cityId: 1426, code: "413242" },
    { id: 41452, cityId: 1426, code: "413244" },
    { id: 41453, cityId: 1426, code: "413245" },
    { id: 41454, cityId: 1426, code: "413250" },
    { id: 41455, cityId: 1426, code: "413303" },
    { id: 41456, cityId: 1426, code: "413306" },
    { id: 41457, cityId: 1426, code: "413308" },
    { id: 41458, cityId: 1426, code: "413310" },
    { id: 41459, cityId: 1426, code: "413311" },
    { id: 41460, cityId: 1426, code: "413313" },
    { id: 41461, cityId: 1426, code: "413316" },
    { id: 41462, cityId: 1426, code: "413319" },
    { id: 41463, cityId: 1426, code: "413324" },
    { id: 41464, cityId: 1426, code: "413401" },
    { id: 41465, cityId: 1426, code: "413403" },
    { id: 41466, cityId: 1426, code: "413404" },
    { id: 41467, cityId: 1426, code: "413406" },
    { id: 41468, cityId: 1426, code: "413409" },
    { id: 41469, cityId: 1426, code: "413416" },
    { id: 41470, cityId: 1426, code: "413506" },
    { id: 41471, cityId: 1426, code: "413575" },
    { id: 41472, cityId: 1426, code: "412803" },
    { id: 41473, cityId: 1426, code: "413002" },
    { id: 41474, cityId: 1426, code: "413005" },
    { id: 41475, cityId: 1426, code: "413007" },
    { id: 41476, cityId: 1426, code: "413108" },
    { id: 41477, cityId: 1426, code: "413111" },
    { id: 41478, cityId: 1426, code: "413113" },
    { id: 41479, cityId: 1426, code: "413118" },
    { id: 41480, cityId: 1426, code: "413121" },
    { id: 41481, cityId: 1426, code: "413203" },
    { id: 41482, cityId: 1426, code: "413206" },
    { id: 41483, cityId: 1426, code: "413209" },
    { id: 41484, cityId: 1426, code: "413211" },
    { id: 41485, cityId: 1426, code: "413214" },
    { id: 41486, cityId: 1426, code: "413217" },
    { id: 41487, cityId: 1426, code: "413219" },
    { id: 41488, cityId: 1426, code: "413222" },
    { id: 41489, cityId: 1426, code: "413224" },
    { id: 41490, cityId: 1426, code: "413225" },
    { id: 41491, cityId: 1426, code: "413227" },
    { id: 41492, cityId: 1426, code: "413230" },
    { id: 41493, cityId: 1426, code: "413232" },
    { id: 41494, cityId: 1426, code: "413233" },
    { id: 41495, cityId: 1426, code: "413235" },
    { id: 41496, cityId: 1426, code: "413240" },
    { id: 41497, cityId: 1426, code: "413241" },
    { id: 41498, cityId: 1426, code: "413243" },
    { id: 41499, cityId: 1426, code: "413246" },
    { id: 41500, cityId: 1426, code: "413248" },
    { id: 41501, cityId: 1426, code: "413251" },
    { id: 41502, cityId: 1426, code: "413301" },
    { id: 41503, cityId: 1426, code: "413302" },
    { id: 41504, cityId: 1426, code: "413304" },
    { id: 41505, cityId: 1426, code: "413309" },
    { id: 41506, cityId: 1426, code: "413312" },
    { id: 41507, cityId: 1426, code: "413314" },
    { id: 41508, cityId: 1426, code: "413317" },
    { id: 41509, cityId: 1426, code: "413402" },
    { id: 41510, cityId: 1426, code: "413410" },
    { id: 41511, cityId: 1426, code: "413412" },
    { id: 41512, cityId: 1426, code: "431737" },
    { id: 41513, cityId: 1427, code: "402110" },
    { id: 41514, cityId: 1428, code: "431112" },
    { id: 41515, cityId: 1429, code: "442105" },
    { id: 41516, cityId: 1430, code: "443203" },
    { id: 41517, cityId: 1431, code: "422103" },
    { id: 41518, cityId: 1432, code: "413122" },
    { id: 41519, cityId: 1433, code: "431516" },
    { id: 41520, cityId: 1434, code: "422211" },
    { id: 41521, cityId: 1435, code: "425413" },
    { id: 41522, cityId: 1436, code: "401502" },
    { id: 41523, cityId: 1437, code: "416312" },
    { id: 41524, cityId: 1438, code: "444108" },
    { id: 41525, cityId: 1439, code: "400601" },
    { id: 41526, cityId: 1439, code: "400603" },
    { id: 41527, cityId: 1439, code: "400606" },
    { id: 41528, cityId: 1439, code: "400609" },
    { id: 41529, cityId: 1439, code: "400611" },
    { id: 41530, cityId: 1439, code: "400614" },
    { id: 41531, cityId: 1439, code: "400701" },
    { id: 41532, cityId: 1439, code: "401104" },
    { id: 41533, cityId: 1439, code: "401106" },
    { id: 41534, cityId: 1439, code: "401202" },
    { id: 41535, cityId: 1439, code: "401204" },
    { id: 41536, cityId: 1439, code: "401207" },
    { id: 41537, cityId: 1439, code: "401302" },
    { id: 41538, cityId: 1439, code: "401401" },
    { id: 41539, cityId: 1439, code: "401406" },
    { id: 41540, cityId: 1439, code: "401504" },
    { id: 41541, cityId: 1439, code: "401506" },
    { id: 41542, cityId: 1439, code: "401602" },
    { id: 41543, cityId: 1439, code: "401604" },
    { id: 41544, cityId: 1439, code: "401607" },
    { id: 41545, cityId: 1439, code: "401609" },
    { id: 41546, cityId: 1439, code: "401610" },
    { id: 41547, cityId: 1439, code: "401702" },
    { id: 41548, cityId: 1439, code: "401703" },
    { id: 41549, cityId: 1439, code: "421003" },
    { id: 41550, cityId: 1439, code: "421102" },
    { id: 41551, cityId: 1439, code: "421202" },
    { id: 41552, cityId: 1439, code: "421205" },
    { id: 41553, cityId: 1439, code: "421303" },
    { id: 41554, cityId: 1439, code: "421305" },
    { id: 41555, cityId: 1439, code: "421306" },
    { id: 41556, cityId: 1439, code: "421311" },
    { id: 41557, cityId: 1439, code: "421403" },
    { id: 41558, cityId: 2778, code: "421501" },
    { id: 41559, cityId: 1439, code: "421502" },
    { id: 41560, cityId: 1439, code: "421602" },
    { id: 41561, cityId: 2777, code: "421605" },
    { id: 41562, cityId: 1439, code: "400602" },
    { id: 41563, cityId: 1439, code: "400604" },
    { id: 41564, cityId: 1439, code: "400605" },
    { id: 41565, cityId: 1439, code: "400607" },
    { id: 41566, cityId: 1439, code: "400612" },
    { id: 41567, cityId: 1439, code: "400613" },
    { id: 41568, cityId: 1439, code: "400615" },
    { id: 41569, cityId: 1439, code: "400703" },
    { id: 41570, cityId: 1439, code: "401103" },
    { id: 41571, cityId: 1439, code: "401105" },
    { id: 41572, cityId: 1439, code: "401201" },
    { id: 41573, cityId: 1439, code: "401203" },
    { id: 41574, cityId: 1439, code: "401206" },
    { id: 41575, cityId: 1439, code: "401301" },
    { id: 41576, cityId: 1439, code: "401304" },
    { id: 41577, cityId: 1439, code: "401402" },
    { id: 41578, cityId: 1439, code: "401404" },
    { id: 41579, cityId: 1439, code: "401405" },
    { id: 41580, cityId: 1439, code: "401407" },
    { id: 41581, cityId: 1439, code: "401505" },
    { id: 41582, cityId: 1439, code: "401606" },
    { id: 41583, cityId: 1439, code: "401608" },
    { id: 41584, cityId: 1439, code: "401701" },
    { id: 41585, cityId: 1439, code: "416544" },
    { id: 41586, cityId: 2774, code: "421103" },
    { id: 41587, cityId: 1439, code: "421201" },
    { id: 41588, cityId: 1439, code: "421203" },
    { id: 41589, cityId: 1439, code: "421204" },
    { id: 41590, cityId: 1439, code: "421206" },
    { id: 41591, cityId: 2773, code: "421301" },
    { id: 41592, cityId: 1439, code: "421304" },
    { id: 41593, cityId: 1439, code: "421402" },
    { id: 41594, cityId: 1439, code: "421503" },
    { id: 41595, cityId: 1439, code: "421505" },
    { id: 41596, cityId: 2776, code: "421601" },
    { id: 41597, cityId: 1439, code: "421603" },
    { id: 41598, cityId: 2775, code: "421604" },
    { id: 41599, cityId: 1440, code: "441911" },
    { id: 41600, cityId: 1441, code: "422212" },
    { id: 41601, cityId: 1442, code: "413601" },
    { id: 41602, cityId: 1443, code: "441912" },
    { id: 41603, cityId: 1444, code: "413517" },
    { id: 41604, cityId: 1445, code: "421001" },
    { id: 41605, cityId: 1446, code: "441203" },
    { id: 41606, cityId: 1447, code: "400702" },
    { id: 41607, cityId: 1448, code: "415409" },
    { id: 41608, cityId: 1449, code: "412402" },
    { id: 41609, cityId: 1450, code: "412106" },
    { id: 41610, cityId: 1450, code: "416112" },
    { id: 41611, cityId: 1451, code: "423701" },
    { id: 41612, cityId: 1452, code: "416516" },
    { id: 41613, cityId: 1453, code: "401303" },
    { id: 41614, cityId: 1454, code: "440023" },
    { id: 41615, cityId: 1454, code: "585225" },
    { id: 41616, cityId: 1455, code: "431734" },
    { id: 41617, cityId: 1456, code: "445304" },
    { id: 41618, cityId: 1456, code: "400080" },
    { id: 41619, cityId: 1457, code: "442005" },
    { id: 41620, cityId: 1457, code: "442103" },
    { id: 41621, cityId: 1457, code: "442106" },
    { id: 41622, cityId: 1457, code: "442110" },
    { id: 41623, cityId: 1457, code: "442111" },
    { id: 41624, cityId: 1457, code: "442201" },
    { id: 41625, cityId: 1457, code: "442203" },
    { id: 41626, cityId: 1457, code: "442204" },
    { id: 41627, cityId: 1457, code: "442304" },
    { id: 41628, cityId: 1457, code: "442306" },
    { id: 41629, cityId: 1457, code: "442307" },
    { id: 41630, cityId: 1457, code: "442001" },
    { id: 41631, cityId: 1457, code: "442003" },
    { id: 41632, cityId: 1457, code: "442006" },
    { id: 41633, cityId: 1457, code: "442102" },
    { id: 41634, cityId: 1457, code: "442202" },
    { id: 41635, cityId: 1457, code: "442205" },
    { id: 41636, cityId: 1457, code: "442207" },
    { id: 41637, cityId: 1457, code: "442303" },
    { id: 41638, cityId: 1457, code: "442305" },
    { id: 41639, cityId: 1457, code: "442308" },
    { id: 41640, cityId: 1457, code: "442310" },
    { id: 41641, cityId: 1457, code: "445311" },
    { id: 41642, cityId: 1458, code: "444906" },
    { id: 41643, cityId: 1459, code: "444505" },
    { id: 41644, cityId: 1459, code: "444110" },
    { id: 41645, cityId: 1460, code: "445001" },
    { id: 41646, cityId: 1460, code: "445102" },
    { id: 41647, cityId: 1460, code: "445105" },
    { id: 41648, cityId: 1460, code: "445110" },
    { id: 41649, cityId: 1460, code: "445205" },
    { id: 41650, cityId: 1460, code: "445208" },
    { id: 41651, cityId: 1460, code: "445210" },
    { id: 41652, cityId: 1460, code: "445211" },
    { id: 41653, cityId: 1460, code: "445213" },
    { id: 41654, cityId: 1460, code: "445216" },
    { id: 41655, cityId: 1460, code: "445301" },
    { id: 41656, cityId: 1460, code: "445303" },
    { id: 41657, cityId: 1460, code: "445306" },
    { id: 41658, cityId: 1460, code: "445308" },
    { id: 41659, cityId: 1460, code: "445309" },
    { id: 41660, cityId: 1460, code: "445003" },
    { id: 41661, cityId: 1460, code: "445101" },
    { id: 41662, cityId: 1460, code: "445103" },
    { id: 41663, cityId: 1460, code: "445106" },
    { id: 41664, cityId: 1460, code: "445201" },
    { id: 41665, cityId: 1460, code: "445207" },
    { id: 41666, cityId: 1460, code: "445209" },
    { id: 41667, cityId: 1460, code: "445212" },
    { id: 41668, cityId: 1460, code: "445215" },
    { id: 41669, cityId: 1460, code: "445217" },
    { id: 41670, cityId: 1460, code: "445302" },
    { id: 41671, cityId: 1460, code: "445304" },
    { id: 41672, cityId: 1460, code: "445305" },
    { id: 41673, cityId: 1460, code: "445307" },
    { id: 41674, cityId: 1460, code: "445323" },
    { id: 41675, cityId: 1460, code: "445402" },
    { id: 41676, cityId: 1461, code: "795126" },
    { id: 41677, cityId: 1461, code: "795132" },
    { id: 41678, cityId: 1461, code: "795134" },
    { id: 41679, cityId: 1462, code: "795102" },
    { id: 41680, cityId: 1462, code: "795126" },
    { id: 41681, cityId: 1462, code: "795133" },
    { id: 41682, cityId: 1462, code: "795127" },
    { id: 41683, cityId: 1462, code: "795135" },
    { id: 41684, cityId: 1463, code: "795128" },
    { id: 41685, cityId: 1463, code: "795139" },
    { id: 41686, cityId: 1463, code: "795144" },
    { id: 41687, cityId: 1463, code: "795124" },
    { id: 41688, cityId: 1463, code: "795143" },
    { id: 41689, cityId: 1464, code: "795001" },
    { id: 41690, cityId: 1464, code: "795002" },
    { id: 41691, cityId: 1464, code: "795004" },
    { id: 41692, cityId: 1464, code: "795115" },
    { id: 41693, cityId: 1464, code: "795136" },
    { id: 41694, cityId: 1464, code: "795137" },
    { id: 41695, cityId: 1464, code: "795145" },
    { id: 41696, cityId: 1464, code: "795003" },
    { id: 41697, cityId: 1464, code: "795011" },
    { id: 41698, cityId: 1464, code: "795140" },
    { id: 41699, cityId: 1464, code: "795146" },
    { id: 41700, cityId: 1465, code: "795116" },
    { id: 41701, cityId: 1466, code: "795132" },
    { id: 41702, cityId: 1467, code: "795133" },
    { id: 41703, cityId: 1468, code: "795131" },
    { id: 41704, cityId: 1469, code: "795134" },
    { id: 41705, cityId: 1470, code: "795104" },
    { id: 41706, cityId: 1470, code: "795120" },
    { id: 41707, cityId: 1470, code: "795122" },
    { id: 41708, cityId: 1470, code: "795105" },
    { id: 41709, cityId: 1470, code: "795106" },
    { id: 41710, cityId: 1470, code: "795121" },
    { id: 41711, cityId: 1470, code: "795129" },
    { id: 41712, cityId: 1470, code: "795150" },
    { id: 41713, cityId: 1470, code: "795151" },
    { id: 41714, cityId: 1470, code: "795158" },
    { id: 41715, cityId: 1471, code: "795101" },
    { id: 41716, cityId: 1472, code: "795147" },
    { id: 41717, cityId: 1472, code: "795125" },
    { id: 41718, cityId: 1472, code: "795141" },
    { id: 41719, cityId: 1473, code: "795103" },
    { id: 41720, cityId: 1473, code: "795123" },
    { id: 41721, cityId: 1473, code: "795130" },
    { id: 41722, cityId: 1473, code: "795138" },
    { id: 41723, cityId: 1474, code: "795010" },
    { id: 41724, cityId: 1474, code: "795142" },
    { id: 41725, cityId: 1475, code: "794102" },
    { id: 41726, cityId: 1476, code: "793108" },
    { id: 41727, cityId: 1477, code: "793002" },
    { id: 41728, cityId: 1478, code: "793150" },
    { id: 41729, cityId: 1478, code: "793106" },
    { id: 41730, cityId: 1479, code: "793021" },
    { id: 41731, cityId: 1480, code: "793102" },
    { id: 41732, cityId: 1481, code: "793119" },
    { id: 41733, cityId: 1481, code: "794101" },
    { id: 41734, cityId: 1482, code: "793014" },
    { id: 41735, cityId: 1483, code: "794108" },
    { id: 41736, cityId: 1484, code: "793002" },
    { id: 41737, cityId: 1484, code: "793005" },
    { id: 41738, cityId: 1484, code: "793007" },
    { id: 41739, cityId: 1484, code: "793008" },
    { id: 41740, cityId: 1484, code: "793010" },
    { id: 41741, cityId: 1484, code: "793012" },
    { id: 41742, cityId: 1484, code: "793013" },
    { id: 41743, cityId: 1484, code: "793103" },
    { id: 41744, cityId: 1484, code: "793105" },
    { id: 41745, cityId: 1484, code: "793110" },
    { id: 41746, cityId: 1484, code: "793111" },
    { id: 41747, cityId: 1484, code: "793113" },
    { id: 41748, cityId: 1484, code: "793121" },
    { id: 41749, cityId: 1484, code: "793001" },
    { id: 41750, cityId: 1484, code: "793003" },
    { id: 41751, cityId: 1484, code: "793004" },
    { id: 41752, cityId: 1484, code: "793006" },
    { id: 41753, cityId: 1484, code: "793009" },
    { id: 41754, cityId: 1484, code: "793011" },
    { id: 41755, cityId: 1484, code: "793025" },
    { id: 41756, cityId: 1484, code: "793101" },
    { id: 41757, cityId: 1484, code: "793104" },
    { id: 41758, cityId: 1484, code: "793107" },
    { id: 41759, cityId: 1484, code: "793109" },
    { id: 41760, cityId: 1484, code: "793112" },
    { id: 41761, cityId: 1484, code: "793120" },
    { id: 41762, cityId: 1484, code: "793122" },
    { id: 41763, cityId: 1485, code: "794001" },
    { id: 41764, cityId: 1485, code: "794104" },
    { id: 41765, cityId: 1485, code: "794109" },
    { id: 41766, cityId: 1485, code: "794002" },
    { id: 41767, cityId: 1485, code: "794005" },
    { id: 41768, cityId: 1485, code: "794103" },
    { id: 41769, cityId: 1485, code: "794105" },
    { id: 41770, cityId: 1485, code: "794106" },
    { id: 41771, cityId: 1486, code: "794107" },
    { id: 41772, cityId: 1486, code: "794110" },
    { id: 41773, cityId: 1486, code: "794112" },
    { id: 41774, cityId: 1486, code: "794111" },
    { id: 41775, cityId: 1487, code: "796001" },
    { id: 41776, cityId: 1487, code: "796007" },
    { id: 41777, cityId: 1487, code: "796009" },
    { id: 41778, cityId: 1487, code: "796012" },
    { id: 41779, cityId: 1487, code: "796015" },
    { id: 41780, cityId: 1487, code: "796017" },
    { id: 41781, cityId: 1487, code: "796025" },
    { id: 41782, cityId: 1487, code: "796070" },
    { id: 41783, cityId: 1487, code: "796081" },
    { id: 41784, cityId: 1487, code: "796161" },
    { id: 41785, cityId: 1487, code: "796190" },
    { id: 41786, cityId: 1487, code: "796441" },
    { id: 41787, cityId: 1487, code: "796005" },
    { id: 41788, cityId: 1487, code: "796230" },
    { id: 41789, cityId: 1487, code: "796321" },
    { id: 41790, cityId: 1487, code: "796471" },
    { id: 41791, cityId: 1488, code: "796290" },
    { id: 41792, cityId: 1489, code: "796111" },
    { id: 41793, cityId: 1490, code: "796571" },
    { id: 41794, cityId: 1491, code: "796310" },
    { id: 41795, cityId: 1492, code: "796031" },
    { id: 41796, cityId: 1493, code: "796770" },
    { id: 41797, cityId: 1494, code: "796629" },
    { id: 41798, cityId: 1494, code: "796751" },
    { id: 41799, cityId: 1494, code: "796901" },
    { id: 41800, cityId: 1494, code: "796691" },
    { id: 41801, cityId: 1494, code: "796710" },
    { id: 41802, cityId: 1495, code: "796701" },
    { id: 41803, cityId: 1496, code: "796730" },
    { id: 41804, cityId: 1497, code: "796370" },
    { id: 41805, cityId: 1498, code: "796410" },
    { id: 41806, cityId: 1499, code: "796261" },
    { id: 41807, cityId: 1500, code: "796181" },
    { id: 41808, cityId: 1501, code: "796161" },
    { id: 41809, cityId: 1501, code: "796370" },
    { id: 41810, cityId: 1501, code: "796181" },
    { id: 41811, cityId: 1502, code: "796101" },
    { id: 41812, cityId: 1503, code: "797103" },
    { id: 41813, cityId: 1504, code: "798621" },
    { id: 41814, cityId: 1505, code: "797111" },
    { id: 41815, cityId: 1506, code: "798631" },
    { id: 41816, cityId: 1507, code: "797112" },
    { id: 41817, cityId: 1508, code: "797105" },
    { id: 41818, cityId: 1508, code: "797110" },
    { id: 41819, cityId: 1508, code: "797121" },
    { id: 41820, cityId: 1508, code: "797123" },
    { id: 41821, cityId: 1508, code: "797124" },
    { id: 41822, cityId: 1508, code: "797126" },
    { id: 41823, cityId: 1508, code: "797001" },
    { id: 41824, cityId: 1508, code: "797101" },
    { id: 41825, cityId: 1508, code: "797106" },
    { id: 41826, cityId: 1508, code: "797109" },
    { id: 41827, cityId: 1508, code: "797122" },
    { id: 41828, cityId: 1508, code: "797125" },
    { id: 41829, cityId: 1508, code: "797127" },
    { id: 41830, cityId: 1509, code: "798613" },
    { id: 41831, cityId: 1509, code: "798615" },
    { id: 41832, cityId: 1509, code: "798618" },
    { id: 41833, cityId: 1509, code: "798623" },
    { id: 41834, cityId: 1509, code: "798628" },
    { id: 41835, cityId: 1509, code: "798601" },
    { id: 41836, cityId: 1509, code: "798614" },
    { id: 41837, cityId: 1509, code: "798617" },
    { id: 41838, cityId: 1509, code: "798622" },
    { id: 41839, cityId: 1509, code: "798630" },
    { id: 41840, cityId: 1509, code: "798632" },
    { id: 41841, cityId: 1510, code: "797108" },
    { id: 41842, cityId: 1510, code: "797102" },
    { id: 41843, cityId: 1510, code: "797104" },
    { id: 41844, cityId: 1510, code: "797107" },
    { id: 41845, cityId: 1511, code: "798611" },
    { id: 41846, cityId: 1511, code: "798616" },
    { id: 41847, cityId: 1511, code: "798612" },
    { id: 41848, cityId: 1512, code: "798619" },
    { id: 41849, cityId: 1512, code: "798626" },
    { id: 41850, cityId: 1512, code: "798627" },
    { id: 41851, cityId: 1512, code: "798629" },
    { id: 41852, cityId: 1512, code: "798620" },
    { id: 41853, cityId: 1513, code: "758021" },
    { id: 41854, cityId: 1514, code: "752105" },
    { id: 41855, cityId: 1514, code: "754036" },
    { id: 41856, cityId: 1514, code: "759034" },
    { id: 41857, cityId: 1514, code: "759129" },
    { id: 41858, cityId: 1514, code: "759138" },
    { id: 41859, cityId: 1514, code: "759140" },
    { id: 41860, cityId: 1514, code: "762014" },
    { id: 41861, cityId: 1514, code: "759118" },
    { id: 41862, cityId: 1514, code: "759133" },
    { id: 41863, cityId: 1514, code: "759136" },
    { id: 41864, cityId: 1514, code: "759142" },
    { id: 41865, cityId: 1514, code: "759144" },
    { id: 41866, cityId: 1514, code: "761118" },
    { id: 41867, cityId: 1515, code: "759125" },
    { id: 41868, cityId: 1516, code: "767001" },
    { id: 41869, cityId: 1517, code: "756003" },
    { id: 41870, cityId: 1517, code: "756018" },
    { id: 41871, cityId: 1517, code: "756024" },
    { id: 41872, cityId: 1517, code: "756026" },
    { id: 41873, cityId: 1517, code: "756027" },
    { id: 41874, cityId: 1517, code: "756029" },
    { id: 41875, cityId: 1517, code: "756032" },
    { id: 41876, cityId: 1517, code: "756034" },
    { id: 41877, cityId: 1517, code: "756035" },
    { id: 41878, cityId: 1517, code: "756037" },
    { id: 41879, cityId: 1517, code: "756040" },
    { id: 41880, cityId: 1517, code: "756042" },
    { id: 41881, cityId: 1517, code: "756043" },
    { id: 41882, cityId: 1517, code: "756045" },
    { id: 41883, cityId: 1517, code: "756048" },
    { id: 41884, cityId: 1517, code: "756050" },
    { id: 41885, cityId: 1517, code: "756051" },
    { id: 41886, cityId: 1517, code: "756053" },
    { id: 41887, cityId: 1517, code: "756055" },
    { id: 41888, cityId: 1517, code: "756056" },
    { id: 41889, cityId: 1517, code: "756058" },
    { id: 41890, cityId: 1517, code: "756071" },
    { id: 41891, cityId: 1517, code: "756072" },
    { id: 41892, cityId: 1517, code: "756074" },
    { id: 41893, cityId: 1517, code: "756077" },
    { id: 41894, cityId: 1517, code: "756079" },
    { id: 41895, cityId: 1517, code: "756080" },
    { id: 41896, cityId: 1517, code: "756082" },
    { id: 41897, cityId: 1517, code: "756101" },
    { id: 41898, cityId: 1517, code: "756111" },
    { id: 41899, cityId: 1517, code: "756114" },
    { id: 41900, cityId: 1517, code: "756116" },
    { id: 41901, cityId: 1517, code: "756117" },
    { id: 41902, cityId: 1517, code: "756122" },
    { id: 41903, cityId: 1517, code: "756124" },
    { id: 41904, cityId: 1517, code: "756125" },
    { id: 41905, cityId: 1517, code: "756127" },
    { id: 41906, cityId: 1517, code: "756130" },
    { id: 41907, cityId: 1517, code: "756132" },
    { id: 41908, cityId: 1517, code: "756133" },
    { id: 41909, cityId: 1517, code: "756135" },
    { id: 41910, cityId: 1517, code: "756138" },
    { id: 41911, cityId: 1517, code: "756140" },
    { id: 41912, cityId: 1517, code: "756141" },
    { id: 41913, cityId: 1517, code: "756143" },
    { id: 41914, cityId: 1517, code: "756162" },
    { id: 41915, cityId: 1517, code: "756167" },
    { id: 41916, cityId: 1517, code: "756169" },
    { id: 41917, cityId: 1517, code: "756001" },
    { id: 41918, cityId: 1517, code: "756002" },
    { id: 41919, cityId: 1517, code: "756017" },
    { id: 41920, cityId: 1517, code: "756020" },
    { id: 41921, cityId: 1517, code: "756022" },
    { id: 41922, cityId: 1517, code: "756023" },
    { id: 41923, cityId: 1517, code: "756025" },
    { id: 41924, cityId: 1517, code: "756028" },
    { id: 41925, cityId: 1517, code: "756030" },
    { id: 41926, cityId: 1517, code: "756033" },
    { id: 41927, cityId: 1517, code: "756036" },
    { id: 41928, cityId: 1517, code: "756038" },
    { id: 41929, cityId: 1517, code: "756041" },
    { id: 41930, cityId: 1517, code: "756046" },
    { id: 41931, cityId: 1517, code: "756047" },
    { id: 41932, cityId: 1517, code: "756049" },
    { id: 41933, cityId: 1517, code: "756052" },
    { id: 41934, cityId: 1517, code: "756054" },
    { id: 41935, cityId: 1517, code: "756057" },
    { id: 41936, cityId: 1517, code: "756059" },
    { id: 41937, cityId: 1517, code: "756060" },
    { id: 41938, cityId: 1517, code: "756073" },
    { id: 41939, cityId: 1517, code: "756075" },
    { id: 41940, cityId: 1517, code: "756076" },
    { id: 41941, cityId: 1517, code: "756078" },
    { id: 41942, cityId: 1517, code: "756081" },
    { id: 41943, cityId: 1517, code: "756083" },
    { id: 41944, cityId: 1517, code: "756084" },
    { id: 41945, cityId: 1517, code: "756110" },
    { id: 41946, cityId: 1517, code: "756112" },
    { id: 41947, cityId: 1517, code: "756113" },
    { id: 41948, cityId: 1517, code: "756115" },
    { id: 41949, cityId: 1517, code: "756120" },
    { id: 41950, cityId: 1517, code: "756121" },
    { id: 41951, cityId: 1517, code: "756123" },
    { id: 41952, cityId: 1517, code: "756128" },
    { id: 41953, cityId: 1517, code: "756129" },
    { id: 41954, cityId: 1517, code: "756131" },
    { id: 41955, cityId: 1517, code: "756134" },
    { id: 41956, cityId: 1517, code: "756136" },
    { id: 41957, cityId: 1517, code: "756137" },
    { id: 41958, cityId: 1517, code: "756139" },
    { id: 41959, cityId: 1517, code: "756142" },
    { id: 41960, cityId: 1517, code: "756144" },
    { id: 41961, cityId: 1517, code: "756163" },
    { id: 41962, cityId: 1517, code: "756165" },
    { id: 41963, cityId: 1517, code: "756166" },
    { id: 41964, cityId: 1517, code: "756168" },
    { id: 41965, cityId: 1517, code: "756181" },
    { id: 41966, cityId: 1517, code: "760001" },
    { id: 41967, cityId: 1518, code: "764051" },
    { id: 41968, cityId: 1519, code: "752030" },
    { id: 41969, cityId: 1519, code: "752095" },
    { id: 41970, cityId: 1520, code: "225001" },
    { id: 41971, cityId: 1520, code: "754008" },
    { id: 41972, cityId: 1521, code: "758035" },
    { id: 41973, cityId: 1522, code: "759122" },
    { id: 41974, cityId: 1522, code: "768039" },
    { id: 41975, cityId: 1522, code: "768042" },
    { id: 41976, cityId: 1522, code: "768050" },
    { id: 41977, cityId: 1523, code: "757002" },
    { id: 41978, cityId: 1523, code: "757015" },
    { id: 41979, cityId: 1523, code: "757018" },
    { id: 41980, cityId: 1523, code: "757020" },
    { id: 41981, cityId: 1523, code: "757021" },
    { id: 41982, cityId: 1523, code: "757023" },
    { id: 41983, cityId: 1523, code: "757025" },
    { id: 41984, cityId: 1523, code: "757026" },
    { id: 41985, cityId: 1523, code: "757028" },
    { id: 41986, cityId: 1523, code: "757031" },
    { id: 41987, cityId: 1523, code: "757033" },
    { id: 41988, cityId: 1523, code: "757034" },
    { id: 41989, cityId: 1523, code: "757036" },
    { id: 41990, cityId: 1523, code: "757039" },
    { id: 41991, cityId: 1523, code: "757042" },
    { id: 41992, cityId: 1523, code: "757047" },
    { id: 41993, cityId: 1523, code: "757049" },
    { id: 41994, cityId: 1523, code: "757050" },
    { id: 41995, cityId: 1523, code: "757052" },
    { id: 41996, cityId: 1523, code: "757055" },
    { id: 41997, cityId: 1523, code: "757071" },
    { id: 41998, cityId: 1523, code: "757073" },
    { id: 41999, cityId: 1523, code: "757076" },
    { id: 42000, cityId: 1523, code: "757078" },
    { id: 42001, cityId: 1523, code: "757081" },
    { id: 42002, cityId: 1523, code: "757084" },
    { id: 42003, cityId: 1523, code: "757086" },
    { id: 42004, cityId: 1523, code: "757087" },
    { id: 42005, cityId: 1523, code: "757092" },
    { id: 42006, cityId: 1523, code: "757102" },
    { id: 42007, cityId: 1523, code: "757103" },
    { id: 42008, cityId: 1523, code: "757105" },
    { id: 42009, cityId: 1523, code: "757001" },
    { id: 42010, cityId: 1523, code: "757003" },
    { id: 42011, cityId: 1523, code: "757014" },
    { id: 42012, cityId: 1523, code: "757016" },
    { id: 42013, cityId: 1523, code: "757017" },
    { id: 42014, cityId: 1523, code: "757019" },
    { id: 42015, cityId: 1523, code: "757024" },
    { id: 42016, cityId: 1523, code: "757027" },
    { id: 42017, cityId: 1523, code: "757029" },
    { id: 42018, cityId: 1523, code: "757030" },
    { id: 42019, cityId: 1523, code: "757032" },
    { id: 42020, cityId: 1523, code: "757035" },
    { id: 42021, cityId: 1523, code: "757037" },
    { id: 42022, cityId: 1523, code: "757038" },
    { id: 42023, cityId: 1523, code: "757040" },
    { id: 42024, cityId: 1523, code: "757043" },
    { id: 42025, cityId: 1523, code: "757045" },
    { id: 42026, cityId: 1523, code: "757046" },
    { id: 42027, cityId: 1523, code: "757048" },
    { id: 42028, cityId: 1523, code: "757051" },
    { id: 42029, cityId: 1523, code: "757054" },
    { id: 42030, cityId: 1523, code: "757072" },
    { id: 42031, cityId: 1523, code: "757074" },
    { id: 42032, cityId: 1523, code: "757075" },
    { id: 42033, cityId: 1523, code: "757077" },
    { id: 42034, cityId: 1523, code: "757080" },
    { id: 42035, cityId: 1523, code: "757082" },
    { id: 42036, cityId: 1523, code: "757083" },
    { id: 42037, cityId: 1523, code: "757085" },
    { id: 42038, cityId: 1523, code: "757091" },
    { id: 42039, cityId: 1523, code: "757093" },
    { id: 42040, cityId: 1523, code: "757101" },
    { id: 42041, cityId: 1523, code: "757104" },
    { id: 42042, cityId: 1523, code: "757106" },
    { id: 42043, cityId: 1524, code: "752013" },
    { id: 42044, cityId: 1525, code: "762021" },
    { id: 42045, cityId: 1525, code: "762030" },
    { id: 42046, cityId: 1525, code: "760004" },
    { id: 42047, cityId: 1525, code: "762015" },
    { id: 42048, cityId: 1525, code: "762017" },
    { id: 42049, cityId: 1525, code: "768001" },
    { id: 42050, cityId: 1525, code: "768120" },
    { id: 42051, cityId: 1526, code: "768217" },
    { id: 42052, cityId: 1526, code: "768218" },
    { id: 42053, cityId: 1527, code: "753003" },
    { id: 42054, cityId: 1527, code: "756118" },
    { id: 42055, cityId: 1527, code: "756119" },
    { id: 42056, cityId: 1527, code: "756126" },
    { id: 42057, cityId: 1527, code: "756164" },
    { id: 42058, cityId: 1527, code: "752107" },
    { id: 42059, cityId: 1527, code: "759131" },
    { id: 42060, cityId: 1528, code: "766001" },
    { id: 42061, cityId: 1529, code: "759017" },
    { id: 42062, cityId: 1530, code: "751001" },
    { id: 42063, cityId: 1530, code: "751009" },
    { id: 42064, cityId: 1531, code: "767002" },
    { id: 42065, cityId: 1531, code: "767016" },
    { id: 42066, cityId: 1531, code: "767018" },
    { id: 42067, cityId: 1531, code: "767019" },
    { id: 42068, cityId: 1531, code: "767021" },
    { id: 42069, cityId: 1531, code: "767024" },
    { id: 42070, cityId: 1531, code: "767026" },
    { id: 42071, cityId: 1531, code: "767027" },
    { id: 42072, cityId: 1531, code: "767029" },
    { id: 42073, cityId: 1531, code: "767032" },
    { id: 42074, cityId: 1531, code: "767034" },
    { id: 42075, cityId: 1531, code: "767035" },
    { id: 42076, cityId: 1531, code: "767037" },
    { id: 42077, cityId: 1531, code: "767040" },
    { id: 42078, cityId: 1531, code: "767042" },
    { id: 42079, cityId: 1531, code: "767043" },
    { id: 42080, cityId: 1531, code: "767045" },
    { id: 42081, cityId: 1531, code: "767048" },
    { id: 42082, cityId: 1531, code: "767050" },
    { id: 42083, cityId: 1531, code: "767061" },
    { id: 42084, cityId: 1531, code: "767063" },
    { id: 42085, cityId: 1531, code: "767066" },
    { id: 42086, cityId: 1531, code: "767001" },
    { id: 42087, cityId: 1531, code: "767017" },
    { id: 42088, cityId: 1531, code: "767020" },
    { id: 42089, cityId: 1531, code: "767022" },
    { id: 42090, cityId: 1531, code: "767023" },
    { id: 42091, cityId: 1531, code: "767028" },
    { id: 42092, cityId: 1531, code: "767030" },
    { id: 42093, cityId: 1531, code: "767031" },
    { id: 42094, cityId: 1531, code: "767033" },
    { id: 42095, cityId: 1531, code: "767036" },
    { id: 42096, cityId: 1531, code: "767038" },
    { id: 42097, cityId: 1531, code: "767041" },
    { id: 42098, cityId: 1531, code: "767044" },
    { id: 42099, cityId: 1531, code: "767046" },
    { id: 42100, cityId: 1531, code: "767049" },
    { id: 42101, cityId: 1531, code: "767062" },
    { id: 42102, cityId: 1531, code: "767065" },
    { id: 42103, cityId: 1531, code: "767067" },
    { id: 42104, cityId: 1531, code: "767068" },
    { id: 42105, cityId: 1532, code: "761118" },
    { id: 42106, cityId: 1533, code: "768017" },
    { id: 42107, cityId: 1533, code: "768018" },
    { id: 42108, cityId: 1534, code: "758041" },
    { id: 42109, cityId: 1535, code: "761020" },
    { id: 42110, cityId: 1535, code: "760003" },
    { id: 42111, cityId: 1535, code: "760005" },
    { id: 42112, cityId: 1535, code: "760008" },
    { id: 42113, cityId: 1535, code: "760010" },
    { id: 42114, cityId: 1535, code: "760031" },
    { id: 42115, cityId: 1535, code: "760032" },
    { id: 42116, cityId: 1535, code: "760034" },
    { id: 42117, cityId: 1535, code: "761001" },
    { id: 42118, cityId: 1535, code: "761004" },
    { id: 42119, cityId: 1535, code: "761006" },
    { id: 42120, cityId: 1535, code: "761009" },
    { id: 42121, cityId: 1535, code: "761011" },
    { id: 42122, cityId: 1535, code: "761014" },
    { id: 42123, cityId: 1535, code: "761019" },
    { id: 42124, cityId: 1535, code: "761020" },
    { id: 42125, cityId: 1535, code: "761025" },
    { id: 42126, cityId: 1535, code: "761027" },
    { id: 42127, cityId: 1535, code: "761028" },
    { id: 42128, cityId: 1535, code: "761030" },
    { id: 42129, cityId: 1535, code: "761033" },
    { id: 42130, cityId: 1535, code: "761035" },
    { id: 42131, cityId: 1535, code: "761036" },
    { id: 42132, cityId: 1535, code: "761038" },
    { id: 42133, cityId: 1535, code: "761041" },
    { id: 42134, cityId: 1535, code: "761044" },
    { id: 42135, cityId: 1535, code: "761046" },
    { id: 42136, cityId: 1535, code: "761052" },
    { id: 42137, cityId: 1535, code: "761054" },
    { id: 42138, cityId: 1535, code: "761056" },
    { id: 42139, cityId: 1535, code: "761102" },
    { id: 42140, cityId: 1535, code: "761104" },
    { id: 42141, cityId: 1535, code: "761107" },
    { id: 42142, cityId: 1535, code: "761109" },
    { id: 42143, cityId: 1535, code: "761110" },
    { id: 42144, cityId: 1535, code: "761112" },
    { id: 42145, cityId: 1535, code: "761115" },
    { id: 42146, cityId: 1535, code: "761117" },
    { id: 42147, cityId: 1535, code: "761120" },
    { id: 42148, cityId: 1535, code: "761123" },
    { id: 42149, cityId: 1535, code: "761125" },
    { id: 42150, cityId: 1535, code: "761126" },
    { id: 42151, cityId: 1535, code: "761128" },
    { id: 42152, cityId: 1535, code: "761131" },
    { id: 42153, cityId: 1535, code: "761133" },
    { id: 42154, cityId: 1535, code: "761134" },
    { id: 42155, cityId: 1535, code: "761136" },
    { id: 42156, cityId: 1535, code: "761139" },
    { id: 42157, cityId: 1535, code: "761141" },
    { id: 42158, cityId: 1535, code: "761142" },
    { id: 42159, cityId: 1535, code: "761144" },
    { id: 42160, cityId: 1535, code: "761207" },
    { id: 42161, cityId: 1535, code: "761208" },
    { id: 42162, cityId: 1535, code: "761213" },
    { id: 42163, cityId: 1535, code: "760001" },
    { id: 42164, cityId: 1535, code: "760004" },
    { id: 42165, cityId: 1535, code: "760006" },
    { id: 42166, cityId: 1535, code: "760007" },
    { id: 42167, cityId: 1535, code: "760009" },
    { id: 42168, cityId: 1535, code: "760033" },
    { id: 42169, cityId: 1535, code: "761002" },
    { id: 42170, cityId: 1535, code: "761003" },
    { id: 42171, cityId: 1535, code: "761005" },
    { id: 42172, cityId: 1535, code: "761007" },
    { id: 42173, cityId: 1535, code: "761008" },
    { id: 42174, cityId: 1535, code: "761010" },
    { id: 42175, cityId: 1535, code: "761013" },
    { id: 42176, cityId: 1535, code: "761016" },
    { id: 42177, cityId: 1535, code: "761018" },
    { id: 42178, cityId: 1535, code: "761021" },
    { id: 42179, cityId: 1535, code: "761029" },
    { id: 42180, cityId: 1535, code: "761031" },
    { id: 42181, cityId: 1535, code: "761034" },
    { id: 42182, cityId: 1535, code: "761037" },
    { id: 42183, cityId: 1535, code: "761039" },
    { id: 42184, cityId: 1535, code: "761040" },
    { id: 42185, cityId: 1535, code: "761042" },
    { id: 42186, cityId: 1535, code: "761045" },
    { id: 42187, cityId: 1535, code: "761053" },
    { id: 42188, cityId: 1535, code: "761055" },
    { id: 42189, cityId: 1535, code: "761101" },
    { id: 42190, cityId: 1535, code: "761103" },
    { id: 42191, cityId: 1535, code: "761105" },
    { id: 42192, cityId: 1535, code: "761106" },
    { id: 42193, cityId: 1535, code: "761108" },
    { id: 42194, cityId: 1535, code: "761111" },
    { id: 42195, cityId: 1535, code: "761113" },
    { id: 42196, cityId: 1535, code: "761114" },
    { id: 42197, cityId: 1535, code: "761116" },
    { id: 42198, cityId: 1535, code: "761119" },
    { id: 42199, cityId: 1535, code: "761121" },
    { id: 42200, cityId: 1535, code: "761122" },
    { id: 42201, cityId: 1535, code: "761124" },
    { id: 42202, cityId: 1535, code: "761127" },
    { id: 42203, cityId: 1535, code: "761132" },
    { id: 42204, cityId: 1535, code: "761135" },
    { id: 42205, cityId: 1535, code: "761137" },
    { id: 42206, cityId: 1535, code: "761138" },
    { id: 42207, cityId: 1535, code: "761140" },
    { id: 42208, cityId: 1535, code: "761143" },
    { id: 42209, cityId: 1535, code: "761145" },
    { id: 42210, cityId: 1535, code: "761151" },
    { id: 42211, cityId: 1535, code: "761201" },
    { id: 42212, cityId: 1535, code: "761206" },
    { id: 42213, cityId: 1535, code: "761209" },
    { id: 42214, cityId: 1535, code: "761211" },
    { id: 42215, cityId: 1535, code: "761212" },
    { id: 42216, cityId: 1535, code: "761214" },
    { id: 42217, cityId: 1535, code: "761217" },
    { id: 42218, cityId: 1536, code: "753002" },
    { id: 42219, cityId: 1536, code: "753003" },
    { id: 42220, cityId: 1536, code: "753005" },
    { id: 42221, cityId: 1536, code: "753008" },
    { id: 42222, cityId: 1536, code: "753010" },
    { id: 42223, cityId: 1536, code: "753011" },
    { id: 42224, cityId: 1536, code: "753013" },
    { id: 42225, cityId: 1536, code: "754001" },
    { id: 42226, cityId: 1536, code: "754006" },
    { id: 42227, cityId: 1536, code: "754007" },
    { id: 42228, cityId: 1536, code: "754009" },
    { id: 42229, cityId: 1536, code: "754012" },
    { id: 42230, cityId: 1536, code: "754014" },
    { id: 42231, cityId: 1536, code: "754015" },
    { id: 42232, cityId: 1536, code: "754017" },
    { id: 42233, cityId: 1536, code: "754020" },
    { id: 42234, cityId: 1536, code: "754022" },
    { id: 42235, cityId: 1536, code: "754025" },
    { id: 42236, cityId: 1536, code: "754028" },
    { id: 42237, cityId: 1536, code: "754030" },
    { id: 42238, cityId: 1536, code: "754031" },
    { id: 42239, cityId: 1536, code: "754033" },
    { id: 42240, cityId: 1536, code: "754070" },
    { id: 42241, cityId: 1536, code: "754081" },
    { id: 42242, cityId: 1536, code: "754104" },
    { id: 42243, cityId: 1536, code: "754105" },
    { id: 42244, cityId: 1536, code: "754107" },
    { id: 42245, cityId: 1536, code: "754110" },
    { id: 42246, cityId: 1536, code: "754112" },
    { id: 42247, cityId: 1536, code: "754115" },
    { id: 42248, cityId: 1536, code: "754118" },
    { id: 42249, cityId: 1536, code: "754131" },
    { id: 42250, cityId: 1536, code: "754134" },
    { id: 42251, cityId: 1536, code: "754136" },
    { id: 42252, cityId: 1536, code: "754139" },
    { id: 42253, cityId: 1536, code: "754142" },
    { id: 42254, cityId: 1536, code: "754155" },
    { id: 42255, cityId: 1536, code: "754157" },
    { id: 42256, cityId: 1536, code: "754158" },
    { id: 42257, cityId: 1536, code: "754160" },
    { id: 42258, cityId: 1536, code: "754202" },
    { id: 42259, cityId: 1536, code: "754203" },
    { id: 42260, cityId: 1536, code: "754205" },
    { id: 42261, cityId: 1536, code: "754208" },
    { id: 42262, cityId: 1536, code: "754210" },
    { id: 42263, cityId: 1536, code: "754211" },
    { id: 42264, cityId: 1536, code: "754213" },
    { id: 42265, cityId: 1536, code: "754216" },
    { id: 42266, cityId: 1536, code: "754219" },
    { id: 42267, cityId: 1536, code: "754221" },
    { id: 42268, cityId: 1536, code: "754224" },
    { id: 42269, cityId: 1536, code: "754226" },
    { id: 42270, cityId: 1536, code: "754227" },
    { id: 42271, cityId: 1536, code: "754229" },
    { id: 42272, cityId: 1536, code: "754232" },
    { id: 42273, cityId: 1536, code: "754234" },
    { id: 42274, cityId: 1536, code: "754239" },
    { id: 42275, cityId: 1536, code: "754242" },
    { id: 42276, cityId: 1536, code: "754245" },
    { id: 42277, cityId: 1536, code: "754247" },
    { id: 42278, cityId: 1536, code: "754248" },
    { id: 42279, cityId: 1536, code: "754250" },
    { id: 42280, cityId: 1536, code: "754253" },
    { id: 42281, cityId: 1536, code: "754280" },
    { id: 42282, cityId: 1536, code: "754282" },
    { id: 42283, cityId: 1536, code: "754284" },
    { id: 42284, cityId: 1536, code: "754285" },
    { id: 42285, cityId: 1536, code: "754287" },
    { id: 42286, cityId: 1536, code: "754290" },
    { id: 42287, cityId: 1536, code: "754292" },
    { id: 42288, cityId: 1536, code: "755003" },
    { id: 42289, cityId: 1536, code: "755005" },
    { id: 42290, cityId: 1536, code: "755008" },
    { id: 42291, cityId: 1536, code: "755010" },
    { id: 42292, cityId: 1536, code: "755011" },
    { id: 42293, cityId: 1536, code: "755013" },
    { id: 42294, cityId: 1536, code: "755015" },
    { id: 42295, cityId: 1536, code: "755016" },
    { id: 42296, cityId: 1536, code: "755021" },
    { id: 42297, cityId: 1536, code: "755023" },
    { id: 42298, cityId: 1536, code: "755024" },
    { id: 42299, cityId: 1536, code: "755026" },
    { id: 42300, cityId: 1536, code: "755029" },
    { id: 42301, cityId: 1536, code: "755031" },
    { id: 42302, cityId: 1536, code: "755032" },
    { id: 42303, cityId: 1536, code: "755034" },
    { id: 42304, cityId: 1536, code: "755037" },
    { id: 42305, cityId: 1536, code: "755039" },
    { id: 42306, cityId: 1536, code: "755042" },
    { id: 42307, cityId: 1536, code: "755045" },
    { id: 42308, cityId: 1536, code: "755047" },
    { id: 42309, cityId: 1536, code: "755048" },
    { id: 42310, cityId: 1536, code: "755050" },
    { id: 42311, cityId: 1536, code: "755061" },
    { id: 42312, cityId: 1536, code: "753001" },
    { id: 42313, cityId: 1536, code: "753004" },
    { id: 42314, cityId: 1536, code: "753006" },
    { id: 42315, cityId: 1536, code: "753007" },
    { id: 42316, cityId: 1536, code: "753009" },
    { id: 42317, cityId: 1536, code: "753012" },
    { id: 42318, cityId: 1536, code: "753051" },
    { id: 42319, cityId: 1536, code: "753052" },
    { id: 42320, cityId: 1536, code: "754002" },
    { id: 42321, cityId: 1536, code: "754003" },
    { id: 42322, cityId: 1536, code: "754005" },
    { id: 42323, cityId: 1536, code: "754008" },
    { id: 42324, cityId: 1536, code: "754010" },
    { id: 42325, cityId: 1536, code: "754011" },
    { id: 42326, cityId: 1536, code: "754013" },
    { id: 42327, cityId: 1536, code: "754018" },
    { id: 42328, cityId: 1536, code: "754021" },
    { id: 42329, cityId: 1536, code: "754026" },
    { id: 42330, cityId: 1536, code: "754027" },
    { id: 42331, cityId: 1536, code: "754029" },
    { id: 42332, cityId: 1536, code: "754032" },
    { id: 42333, cityId: 1536, code: "754034" },
    { id: 42334, cityId: 1536, code: "754037" },
    { id: 42335, cityId: 1536, code: "754071" },
    { id: 42336, cityId: 1536, code: "754080" },
    { id: 42337, cityId: 1536, code: "754101" },
    { id: 42338, cityId: 1536, code: "754103" },
    { id: 42339, cityId: 1536, code: "754106" },
    { id: 42340, cityId: 1536, code: "754108" },
    { id: 42341, cityId: 1536, code: "754111" },
    { id: 42342, cityId: 1536, code: "754117" },
    { id: 42343, cityId: 1536, code: "754119" },
    { id: 42344, cityId: 1536, code: "754130" },
    { id: 42345, cityId: 1536, code: "754132" },
    { id: 42346, cityId: 1536, code: "754135" },
    { id: 42347, cityId: 1536, code: "754137" },
    { id: 42348, cityId: 1536, code: "754140" },
    { id: 42349, cityId: 1536, code: "754143" },
    { id: 42350, cityId: 1536, code: "754153" },
    { id: 42351, cityId: 1536, code: "754154" },
    { id: 42352, cityId: 1536, code: "754156" },
    { id: 42353, cityId: 1536, code: "754159" },
    { id: 42354, cityId: 1536, code: "754161" },
    { id: 42355, cityId: 1536, code: "754162" },
    { id: 42356, cityId: 1536, code: "754201" },
    { id: 42357, cityId: 1536, code: "754204" },
    { id: 42358, cityId: 1536, code: "754206" },
    { id: 42359, cityId: 1536, code: "754207" },
    { id: 42360, cityId: 1536, code: "754209" },
    { id: 42361, cityId: 1536, code: "754212" },
    { id: 42362, cityId: 1536, code: "754214" },
    { id: 42363, cityId: 1536, code: "754217" },
    { id: 42364, cityId: 1536, code: "754222" },
    { id: 42365, cityId: 1536, code: "754223" },
    { id: 42366, cityId: 1536, code: "754228" },
    { id: 42367, cityId: 1536, code: "754230" },
    { id: 42368, cityId: 1536, code: "754231" },
    { id: 42369, cityId: 1536, code: "754233" },
    { id: 42370, cityId: 1536, code: "754235" },
    { id: 42371, cityId: 1536, code: "754236" },
    { id: 42372, cityId: 1536, code: "754238" },
    { id: 42373, cityId: 1536, code: "754243" },
    { id: 42374, cityId: 1536, code: "754244" },
    { id: 42375, cityId: 1536, code: "754246" },
    { id: 42376, cityId: 1536, code: "754249" },
    { id: 42377, cityId: 1536, code: "754251" },
    { id: 42378, cityId: 1536, code: "754252" },
    { id: 42379, cityId: 1536, code: "754281" },
    { id: 42380, cityId: 1536, code: "754283" },
    { id: 42381, cityId: 1536, code: "754286" },
    { id: 42382, cityId: 1536, code: "754288" },
    { id: 42383, cityId: 1536, code: "754289" },
    { id: 42384, cityId: 1536, code: "754291" },
    { id: 42385, cityId: 1536, code: "755001" },
    { id: 42386, cityId: 1536, code: "755004" },
    { id: 42387, cityId: 1536, code: "755006" },
    { id: 42388, cityId: 1536, code: "755007" },
    { id: 42389, cityId: 1536, code: "755009" },
    { id: 42390, cityId: 1536, code: "755012" },
    { id: 42391, cityId: 1536, code: "755014" },
    { id: 42392, cityId: 1536, code: "755019" },
    { id: 42393, cityId: 1536, code: "755020" },
    { id: 42394, cityId: 1536, code: "755022" },
    { id: 42395, cityId: 1536, code: "755025" },
    { id: 42396, cityId: 1536, code: "755027" },
    { id: 42397, cityId: 1536, code: "755028" },
    { id: 42398, cityId: 1536, code: "755033" },
    { id: 42399, cityId: 1536, code: "755035" },
    { id: 42400, cityId: 1536, code: "755036" },
    { id: 42401, cityId: 1536, code: "755038" },
    { id: 42402, cityId: 1536, code: "755041" },
    { id: 42403, cityId: 1536, code: "755043" },
    { id: 42404, cityId: 1536, code: "755044" },
    { id: 42405, cityId: 1536, code: "755049" },
    { id: 42406, cityId: 1536, code: "764027" },
    { id: 42407, cityId: 1537, code: "763008" },
    { id: 42408, cityId: 1538, code: "752087" },
    { id: 42409, cityId: 1538, code: "758076" },
    { id: 42410, cityId: 1538, code: "759116" },
    { id: 42411, cityId: 1538, code: "768109" },
    { id: 42412, cityId: 1538, code: "768110" },
    { id: 42413, cityId: 1538, code: "768114" },
    { id: 42414, cityId: 1539, code: "759013" },
    { id: 42415, cityId: 1539, code: "759016" },
    { id: 42416, cityId: 1539, code: "759018" },
    { id: 42417, cityId: 1539, code: "759019" },
    { id: 42418, cityId: 1539, code: "759021" },
    { id: 42419, cityId: 1539, code: "759024" },
    { id: 42420, cityId: 1539, code: "759026" },
    { id: 42421, cityId: 1539, code: "759027" },
    { id: 42422, cityId: 1539, code: "759029" },
    { id: 42423, cityId: 1539, code: "759032" },
    { id: 42424, cityId: 1539, code: "759035" },
    { id: 42425, cityId: 1539, code: "759037" },
    { id: 42426, cityId: 1539, code: "759101" },
    { id: 42427, cityId: 1539, code: "759103" },
    { id: 42428, cityId: 1539, code: "759106" },
    { id: 42429, cityId: 1539, code: "759117" },
    { id: 42430, cityId: 1539, code: "759119" },
    { id: 42431, cityId: 1539, code: "759122" },
    { id: 42432, cityId: 1539, code: "759124" },
    { id: 42433, cityId: 1539, code: "759127" },
    { id: 42434, cityId: 1539, code: "759130" },
    { id: 42435, cityId: 1539, code: "759132" },
    { id: 42436, cityId: 1539, code: "759135" },
    { id: 42437, cityId: 1539, code: "759141" },
    { id: 42438, cityId: 1539, code: "759143" },
    { id: 42439, cityId: 1539, code: "759001" },
    { id: 42440, cityId: 1539, code: "759014" },
    { id: 42441, cityId: 1539, code: "759020" },
    { id: 42442, cityId: 1539, code: "759022" },
    { id: 42443, cityId: 1539, code: "759025" },
    { id: 42444, cityId: 1539, code: "759028" },
    { id: 42445, cityId: 1539, code: "759030" },
    { id: 42446, cityId: 1539, code: "759031" },
    { id: 42447, cityId: 1539, code: "759033" },
    { id: 42448, cityId: 1539, code: "759036" },
    { id: 42449, cityId: 1539, code: "759039" },
    { id: 42450, cityId: 1539, code: "759102" },
    { id: 42451, cityId: 1539, code: "759104" },
    { id: 42452, cityId: 1539, code: "759105" },
    { id: 42453, cityId: 1539, code: "759107" },
    { id: 42454, cityId: 1539, code: "759120" },
    { id: 42455, cityId: 1539, code: "759121" },
    { id: 42456, cityId: 1539, code: "759123" },
    { id: 42457, cityId: 1539, code: "759126" },
    { id: 42458, cityId: 1539, code: "759128" },
    { id: 42459, cityId: 1539, code: "759134" },
    { id: 42460, cityId: 1539, code: "759137" },
    { id: 42461, cityId: 1539, code: "759139" },
    { id: 42462, cityId: 1539, code: "759145" },
    { id: 42463, cityId: 1540, code: "761012" },
    { id: 42464, cityId: 1541, code: "761026" },
    { id: 42465, cityId: 1542, code: "756044" },
    { id: 42466, cityId: 1543, code: "765026" },
    { id: 42467, cityId: 1544, code: "765022" },
    { id: 42468, cityId: 1545, code: "761102" },
    { id: 42469, cityId: 1546, code: "768016" },
    { id: 42470, cityId: 1547, code: "752024" },
    { id: 42471, cityId: 1547, code: "754113" },
    { id: 42472, cityId: 1547, code: "754114" },
    { id: 42473, cityId: 1547, code: "754116" },
    { id: 42474, cityId: 1547, code: "754142" },
    { id: 42475, cityId: 1547, code: "754025" },
    { id: 42476, cityId: 1547, code: "754102" },
    { id: 42477, cityId: 1547, code: "754109" },
    { id: 42478, cityId: 1547, code: "754133" },
    { id: 42479, cityId: 1547, code: "754141" },
    { id: 42480, cityId: 1547, code: "754144" },
    { id: 42481, cityId: 1547, code: "761043" },
    { id: 42482, cityId: 1548, code: "769043" },
    { id: 42483, cityId: 1549, code: "756032" },
    { id: 42484, cityId: 1550, code: "752050" },
    { id: 42485, cityId: 1551, code: "768213" },
    { id: 42486, cityId: 1551, code: "768053" },
    { id: 42487, cityId: 1551, code: "768201" },
    { id: 42488, cityId: 1551, code: "768212" },
    { id: 42489, cityId: 1551, code: "770076" },
    { id: 42490, cityId: 1552, code: "758031" },
    { id: 42491, cityId: 1553, code: "758034" },
    { id: 42492, cityId: 1554, code: "766014" },
    { id: 42493, cityId: 1555, code: "766002" },
    { id: 42494, cityId: 1555, code: "766011" },
    { id: 42495, cityId: 1555, code: "766013" },
    { id: 42496, cityId: 1555, code: "766016" },
    { id: 42497, cityId: 1555, code: "766018" },
    { id: 42498, cityId: 1555, code: "766019" },
    { id: 42499, cityId: 1555, code: "766021" },
    { id: 42500, cityId: 1555, code: "766024" },
    { id: 42501, cityId: 1555, code: "766027" },
    { id: 42502, cityId: 1555, code: "766029" },
    { id: 42503, cityId: 1555, code: "766101" },
    { id: 42504, cityId: 1555, code: "766103" },
    { id: 42505, cityId: 1555, code: "766106" },
    { id: 42506, cityId: 1555, code: "766108" },
    { id: 42507, cityId: 1555, code: "766109" },
    { id: 42508, cityId: 1555, code: "766114" },
    { id: 42509, cityId: 1555, code: "766116" },
    { id: 42510, cityId: 1555, code: "766117" },
    { id: 42511, cityId: 1555, code: "766001" },
    { id: 42512, cityId: 1555, code: "766012" },
    { id: 42513, cityId: 1555, code: "766015" },
    { id: 42514, cityId: 1555, code: "766017" },
    { id: 42515, cityId: 1555, code: "766020" },
    { id: 42516, cityId: 1555, code: "766022" },
    { id: 42517, cityId: 1555, code: "766023" },
    { id: 42518, cityId: 1555, code: "766025" },
    { id: 42519, cityId: 1555, code: "766028" },
    { id: 42520, cityId: 1555, code: "766104" },
    { id: 42521, cityId: 1555, code: "766105" },
    { id: 42522, cityId: 1555, code: "766107" },
    { id: 42523, cityId: 1555, code: "766110" },
    { id: 42524, cityId: 1555, code: "766112" },
    { id: 42525, cityId: 1555, code: "766113" },
    { id: 42526, cityId: 1555, code: "766115" },
    { id: 42527, cityId: 1555, code: "766118" },
    { id: 42528, cityId: 1556, code: "762001" },
    { id: 42529, cityId: 1556, code: "762011" },
    { id: 42530, cityId: 1556, code: "762014" },
    { id: 42531, cityId: 1556, code: "762019" },
    { id: 42532, cityId: 1556, code: "762022" },
    { id: 42533, cityId: 1556, code: "762027" },
    { id: 42534, cityId: 1556, code: "762028" },
    { id: 42535, cityId: 1556, code: "762102" },
    { id: 42536, cityId: 1556, code: "762104" },
    { id: 42537, cityId: 1556, code: "762107" },
    { id: 42538, cityId: 1556, code: "762109" },
    { id: 42539, cityId: 1556, code: "762110" },
    { id: 42540, cityId: 1556, code: "762010" },
    { id: 42541, cityId: 1556, code: "762013" },
    { id: 42542, cityId: 1556, code: "762016" },
    { id: 42543, cityId: 1556, code: "762018" },
    { id: 42544, cityId: 1556, code: "762021" },
    { id: 42545, cityId: 1556, code: "762023" },
    { id: 42546, cityId: 1556, code: "762024" },
    { id: 42547, cityId: 1556, code: "762026" },
    { id: 42548, cityId: 1556, code: "762029" },
    { id: 42549, cityId: 1556, code: "762103" },
    { id: 42550, cityId: 1556, code: "762105" },
    { id: 42551, cityId: 1556, code: "762106" },
    { id: 42552, cityId: 1556, code: "762108" },
    { id: 42553, cityId: 1556, code: "762111" },
    { id: 42554, cityId: 1557, code: "767039" },
    { id: 42555, cityId: 1558, code: "752078" },
    { id: 42556, cityId: 1559, code: "758044" },
    { id: 42557, cityId: 1560, code: "754218" },
    { id: 42558, cityId: 1560, code: "754237" },
    { id: 42559, cityId: 1560, code: "754240" },
    { id: 42560, cityId: 1560, code: "752018" },
    { id: 42561, cityId: 1560, code: "754220" },
    { id: 42562, cityId: 1560, code: "754225" },
    { id: 42563, cityId: 1560, code: "757001" },
    { id: 42564, cityId: 1560, code: "758017" },
    { id: 42565, cityId: 1561, code: "758001" },
    { id: 42566, cityId: 1561, code: "758016" },
    { id: 42567, cityId: 1561, code: "758019" },
    { id: 42568, cityId: 1561, code: "758022" },
    { id: 42569, cityId: 1561, code: "758025" },
    { id: 42570, cityId: 1561, code: "758027" },
    { id: 42571, cityId: 1561, code: "758030" },
    { id: 42572, cityId: 1561, code: "758032" },
    { id: 42573, cityId: 1561, code: "758033" },
    { id: 42574, cityId: 1561, code: "758035" },
    { id: 42575, cityId: 1561, code: "758038" },
    { id: 42576, cityId: 1561, code: "758040" },
    { id: 42577, cityId: 1561, code: "758043" },
    { id: 42578, cityId: 1561, code: "758046" },
    { id: 42579, cityId: 1561, code: "758048" },
    { id: 42580, cityId: 1561, code: "758049" },
    { id: 42581, cityId: 1561, code: "758051" },
    { id: 42582, cityId: 1561, code: "758054" },
    { id: 42583, cityId: 1561, code: "758061" },
    { id: 42584, cityId: 1561, code: "758062" },
    { id: 42585, cityId: 1561, code: "758064" },
    { id: 42586, cityId: 1561, code: "758072" },
    { id: 42587, cityId: 1561, code: "758075" },
    { id: 42588, cityId: 1561, code: "758077" },
    { id: 42589, cityId: 1561, code: "758078" },
    { id: 42590, cityId: 1561, code: "758080" },
    { id: 42591, cityId: 1561, code: "758002" },
    { id: 42592, cityId: 1561, code: "758013" },
    { id: 42593, cityId: 1561, code: "758015" },
    { id: 42594, cityId: 1561, code: "758018" },
    { id: 42595, cityId: 1561, code: "758023" },
    { id: 42596, cityId: 1561, code: "758026" },
    { id: 42597, cityId: 1561, code: "758029" },
    { id: 42598, cityId: 1561, code: "758036" },
    { id: 42599, cityId: 1561, code: "758037" },
    { id: 42600, cityId: 1561, code: "758042" },
    { id: 42601, cityId: 1561, code: "758045" },
    { id: 42602, cityId: 1561, code: "758047" },
    { id: 42603, cityId: 1561, code: "758052" },
    { id: 42604, cityId: 1561, code: "758053" },
    { id: 42605, cityId: 1561, code: "758063" },
    { id: 42606, cityId: 1561, code: "758071" },
    { id: 42607, cityId: 1561, code: "758073" },
    { id: 42608, cityId: 1561, code: "758074" },
    { id: 42609, cityId: 1561, code: "758079" },
    { id: 42610, cityId: 1561, code: "758081" },
    { id: 42611, cityId: 1561, code: "770048" },
    { id: 42612, cityId: 1562, code: "766012" },
    { id: 42613, cityId: 1563, code: "766107" },
    { id: 42614, cityId: 1564, code: "761032" },
    { id: 42615, cityId: 1565, code: "752111" },
    { id: 42616, cityId: 1566, code: "763001" },
    { id: 42617, cityId: 1566, code: "763002" },
    { id: 42618, cityId: 1566, code: "764002" },
    { id: 42619, cityId: 1566, code: "764003" },
    { id: 42620, cityId: 1566, code: "764005" },
    { id: 42621, cityId: 1566, code: "764008" },
    { id: 42622, cityId: 1566, code: "764011" },
    { id: 42623, cityId: 1566, code: "764021" },
    { id: 42624, cityId: 1566, code: "764037" },
    { id: 42625, cityId: 1566, code: "764040" },
    { id: 42626, cityId: 1566, code: "764042" },
    { id: 42627, cityId: 1566, code: "764047" },
    { id: 42628, cityId: 1566, code: "764053" },
    { id: 42629, cityId: 1566, code: "764056" },
    { id: 42630, cityId: 1566, code: "764063" },
    { id: 42631, cityId: 1566, code: "764069" },
    { id: 42632, cityId: 1566, code: "764072" },
    { id: 42633, cityId: 1566, code: "764077" },
    { id: 42634, cityId: 1566, code: "764079" },
    { id: 42635, cityId: 1566, code: "764082" },
    { id: 42636, cityId: 1566, code: "764085" },
    { id: 42637, cityId: 1566, code: "765001" },
    { id: 42638, cityId: 1566, code: "765012" },
    { id: 42639, cityId: 1566, code: "765014" },
    { id: 42640, cityId: 1566, code: "765017" },
    { id: 42641, cityId: 1566, code: "765019" },
    { id: 42642, cityId: 1566, code: "765020" },
    { id: 42643, cityId: 1566, code: "765025" },
    { id: 42644, cityId: 1566, code: "765028" },
    { id: 42645, cityId: 1566, code: "765030" },
    { id: 42646, cityId: 1566, code: "763003" },
    { id: 42647, cityId: 1566, code: "764001" },
    { id: 42648, cityId: 1566, code: "764004" },
    { id: 42649, cityId: 1566, code: "764012" },
    { id: 42650, cityId: 1566, code: "764020" },
    { id: 42651, cityId: 1566, code: "764022" },
    { id: 42652, cityId: 1566, code: "764038" },
    { id: 42653, cityId: 1566, code: "764039" },
    { id: 42654, cityId: 1566, code: "764041" },
    { id: 42655, cityId: 1566, code: "764043" },
    { id: 42656, cityId: 1566, code: "764044" },
    { id: 42657, cityId: 1566, code: "764046" },
    { id: 42658, cityId: 1566, code: "764049" },
    { id: 42659, cityId: 1566, code: "764052" },
    { id: 42660, cityId: 1566, code: "764054" },
    { id: 42661, cityId: 1566, code: "764057" },
    { id: 42662, cityId: 1566, code: "764059" },
    { id: 42663, cityId: 1566, code: "764060" },
    { id: 42664, cityId: 1566, code: "764070" },
    { id: 42665, cityId: 1566, code: "764073" },
    { id: 42666, cityId: 1566, code: "764078" },
    { id: 42667, cityId: 1566, code: "764081" },
    { id: 42668, cityId: 1566, code: "764083" },
    { id: 42669, cityId: 1566, code: "764084" },
    { id: 42670, cityId: 1566, code: "765002" },
    { id: 42671, cityId: 1566, code: "765013" },
    { id: 42672, cityId: 1566, code: "765016" },
    { id: 42673, cityId: 1566, code: "765018" },
    { id: 42674, cityId: 1566, code: "765021" },
    { id: 42675, cityId: 1566, code: "765031" },
    { id: 42676, cityId: 1566, code: "765032" },
    { id: 42677, cityId: 1567, code: "752020" },
    { id: 42678, cityId: 1567, code: "752028" },
    { id: 42679, cityId: 1567, code: "752063" },
    { id: 42680, cityId: 1567, code: "752066" },
    { id: 42681, cityId: 1567, code: "752092" },
    { id: 42682, cityId: 1567, code: "754241" },
    { id: 42683, cityId: 1567, code: "755046" },
    { id: 42684, cityId: 1567, code: "757079" },
    { id: 42685, cityId: 1567, code: "761105" },
    { id: 42686, cityId: 1567, code: "752035" },
    { id: 42687, cityId: 1567, code: "752038" },
    { id: 42688, cityId: 1567, code: "752101" },
    { id: 42689, cityId: 1567, code: "754016" },
    { id: 42690, cityId: 1567, code: "759015" },
    { id: 42691, cityId: 1567, code: "759023" },
    { id: 42692, cityId: 1567, code: "761051" },
    { id: 42693, cityId: 1567, code: "768226" },
    { id: 42694, cityId: 1568, code: "764058" },
    { id: 42695, cityId: 1569, code: "764036" },
    { id: 42696, cityId: 1569, code: "764048" },
    { id: 42697, cityId: 1569, code: "764045" },
    { id: 42698, cityId: 1570, code: "766026" },
    { id: 42699, cityId: 1571, code: "764071" },
    { id: 42700, cityId: 1571, code: "764061" },
    { id: 42701, cityId: 1571, code: "764074" },
    { id: 42702, cityId: 1571, code: "764075" },
    { id: 42703, cityId: 1572, code: "764055" },
    { id: 42704, cityId: 1572, code: "766104" },
    { id: 42705, cityId: 1572, code: "766111" },
    { id: 42706, cityId: 1572, code: "767047" },
    { id: 42707, cityId: 1573, code: "752070" },
    { id: 42708, cityId: 1573, code: "756003" },
    { id: 42709, cityId: 1573, code: "752069" },
    { id: 42710, cityId: 1574, code: "754035" },
    { id: 42711, cityId: 1575, code: "754260" },
    { id: 42712, cityId: 1576, code: "754023" },
    { id: 42713, cityId: 1576, code: "754024" },
    { id: 42714, cityId: 1576, code: "754082" },
    { id: 42715, cityId: 1576, code: "755001" },
    { id: 42716, cityId: 1576, code: "755017" },
    { id: 42717, cityId: 1576, code: "755030" },
    { id: 42718, cityId: 1576, code: "755046" },
    { id: 42719, cityId: 1576, code: "756161" },
    { id: 42720, cityId: 1576, code: "758020" },
    { id: 42721, cityId: 1576, code: "758028" },
    { id: 42722, cityId: 1576, code: "764001" },
    { id: 42723, cityId: 1576, code: "752044" },
    { id: 42724, cityId: 1576, code: "753002" },
    { id: 42725, cityId: 1576, code: "755018" },
    { id: 42726, cityId: 1576, code: "756048" },
    { id: 42727, cityId: 1576, code: "758014" },
    { id: 42728, cityId: 1577, code: "769004" },
    { id: 42729, cityId: 1578, code: "761015" },
    { id: 42730, cityId: 1578, code: "761216" },
    { id: 42731, cityId: 1578, code: "765001" },
    { id: 42732, cityId: 1578, code: "761215" },
    { id: 42733, cityId: 1578, code: "762012" },
    { id: 42734, cityId: 1578, code: "764062" },
    { id: 42735, cityId: 1579, code: "767025" },
    { id: 42736, cityId: 1580, code: "754215" },
    { id: 42737, cityId: 1581, code: "762025" },
    { id: 42738, cityId: 1581, code: "762112" },
    { id: 42739, cityId: 1581, code: "761210" },
    { id: 42740, cityId: 1581, code: "762101" },
    { id: 42741, cityId: 1582, code: "751002" },
    { id: 42742, cityId: 1582, code: "751004" },
    { id: 42743, cityId: 1582, code: "751005" },
    { id: 42744, cityId: 1582, code: "751007" },
    { id: 42745, cityId: 1582, code: "751010" },
    { id: 42746, cityId: 1582, code: "751012" },
    { id: 42747, cityId: 1582, code: "751013" },
    { id: 42748, cityId: 1582, code: "751031" },
    { id: 42749, cityId: 1582, code: "752006" },
    { id: 42750, cityId: 1582, code: "752011" },
    { id: 42751, cityId: 1582, code: "752014" },
    { id: 42752, cityId: 1582, code: "752016" },
    { id: 42753, cityId: 1582, code: "752019" },
    { id: 42754, cityId: 1582, code: "752021" },
    { id: 42755, cityId: 1582, code: "752022" },
    { id: 42756, cityId: 1582, code: "752027" },
    { id: 42757, cityId: 1582, code: "752029" },
    { id: 42758, cityId: 1582, code: "752032" },
    { id: 42759, cityId: 1582, code: "752037" },
    { id: 42760, cityId: 1582, code: "752043" },
    { id: 42761, cityId: 1582, code: "752045" },
    { id: 42762, cityId: 1582, code: "752046" },
    { id: 42763, cityId: 1582, code: "752050" },
    { id: 42764, cityId: 1582, code: "752056" },
    { id: 42765, cityId: 1582, code: "752058" },
    { id: 42766, cityId: 1582, code: "752059" },
    { id: 42767, cityId: 1582, code: "752061" },
    { id: 42768, cityId: 1582, code: "752064" },
    { id: 42769, cityId: 1582, code: "752067" },
    { id: 42770, cityId: 1582, code: "752077" },
    { id: 42771, cityId: 1582, code: "752080" },
    { id: 42772, cityId: 1582, code: "752082" },
    { id: 42773, cityId: 1582, code: "752083" },
    { id: 42774, cityId: 1582, code: "752088" },
    { id: 42775, cityId: 1582, code: "752090" },
    { id: 42776, cityId: 1582, code: "752091" },
    { id: 42777, cityId: 1582, code: "752093" },
    { id: 42778, cityId: 1582, code: "752096" },
    { id: 42779, cityId: 1582, code: "752103" },
    { id: 42780, cityId: 1582, code: "752104" },
    { id: 42781, cityId: 1582, code: "752106" },
    { id: 42782, cityId: 1582, code: "752109" },
    { id: 42783, cityId: 1582, code: "752112" },
    { id: 42784, cityId: 1582, code: "752114" },
    { id: 42785, cityId: 1582, code: "752117" },
    { id: 42786, cityId: 1582, code: "752119" },
    { id: 42787, cityId: 1582, code: "752120" },
    { id: 42788, cityId: 1582, code: "752201" },
    { id: 42789, cityId: 1582, code: "751001" },
    { id: 42790, cityId: 1582, code: "751003" },
    { id: 42791, cityId: 1582, code: "751006" },
    { id: 42792, cityId: 1582, code: "751008" },
    { id: 42793, cityId: 1582, code: "751009" },
    { id: 42794, cityId: 1582, code: "751011" },
    { id: 42795, cityId: 1582, code: "751014" },
    { id: 42796, cityId: 1582, code: "751030" },
    { id: 42797, cityId: 1582, code: "752001" },
    { id: 42798, cityId: 1582, code: "752002" },
    { id: 42799, cityId: 1582, code: "752015" },
    { id: 42800, cityId: 1582, code: "752017" },
    { id: 42801, cityId: 1582, code: "752023" },
    { id: 42802, cityId: 1582, code: "752025" },
    { id: 42803, cityId: 1582, code: "752026" },
    { id: 42804, cityId: 1582, code: "752031" },
    { id: 42805, cityId: 1582, code: "752033" },
    { id: 42806, cityId: 1582, code: "752034" },
    { id: 42807, cityId: 1582, code: "752036" },
    { id: 42808, cityId: 1582, code: "752041" },
    { id: 42809, cityId: 1582, code: "752042" },
    { id: 42810, cityId: 1582, code: "752054" },
    { id: 42811, cityId: 1582, code: "752055" },
    { id: 42812, cityId: 1582, code: "752057" },
    { id: 42813, cityId: 1582, code: "752060" },
    { id: 42814, cityId: 1582, code: "752062" },
    { id: 42815, cityId: 1582, code: "752068" },
    { id: 42816, cityId: 1582, code: "752079" },
    { id: 42817, cityId: 1582, code: "752081" },
    { id: 42818, cityId: 1582, code: "752084" },
    { id: 42819, cityId: 1582, code: "752086" },
    { id: 42820, cityId: 1582, code: "752089" },
    { id: 42821, cityId: 1582, code: "752094" },
    { id: 42822, cityId: 1582, code: "752102" },
    { id: 42823, cityId: 1582, code: "752108" },
    { id: 42824, cityId: 1582, code: "752110" },
    { id: 42825, cityId: 1582, code: "752113" },
    { id: 42826, cityId: 1582, code: "752115" },
    { id: 42827, cityId: 1582, code: "752116" },
    { id: 42828, cityId: 1582, code: "752118" },
    { id: 42829, cityId: 1582, code: "752121" },
    { id: 42830, cityId: 1583, code: "761018" },
    { id: 42831, cityId: 1584, code: "757043" },
    { id: 42832, cityId: 1585, code: "761028" },
    { id: 42833, cityId: 1586, code: "765015" },
    { id: 42834, cityId: 1586, code: "765023" },
    { id: 42835, cityId: 1586, code: "765024" },
    { id: 42836, cityId: 1586, code: "765029" },
    { id: 42837, cityId: 1586, code: "754004" },
    { id: 42838, cityId: 1586, code: "761017" },
    { id: 42839, cityId: 1587, code: "756021" },
    { id: 42840, cityId: 1588, code: "768002" },
    { id: 42841, cityId: 1588, code: "768003" },
    { id: 42842, cityId: 1588, code: "768016" },
    { id: 42843, cityId: 1588, code: "768018" },
    { id: 42844, cityId: 1588, code: "768026" },
    { id: 42845, cityId: 1588, code: "768029" },
    { id: 42846, cityId: 1588, code: "768031" },
    { id: 42847, cityId: 1588, code: "768032" },
    { id: 42848, cityId: 1588, code: "768034" },
    { id: 42849, cityId: 1588, code: "768037" },
    { id: 42850, cityId: 1588, code: "768040" },
    { id: 42851, cityId: 1588, code: "768045" },
    { id: 42852, cityId: 1588, code: "768047" },
    { id: 42853, cityId: 1588, code: "768048" },
    { id: 42854, cityId: 1588, code: "768101" },
    { id: 42855, cityId: 1588, code: "768103" },
    { id: 42856, cityId: 1588, code: "768106" },
    { id: 42857, cityId: 1588, code: "768108" },
    { id: 42858, cityId: 1588, code: "768111" },
    { id: 42859, cityId: 1588, code: "768113" },
    { id: 42860, cityId: 1588, code: "768116" },
    { id: 42861, cityId: 1588, code: "768119" },
    { id: 42862, cityId: 1588, code: "768121" },
    { id: 42863, cityId: 1588, code: "768151" },
    { id: 42864, cityId: 1588, code: "768201" },
    { id: 42865, cityId: 1588, code: "768204" },
    { id: 42866, cityId: 1588, code: "768211" },
    { id: 42867, cityId: 1588, code: "768214" },
    { id: 42868, cityId: 1588, code: "768219" },
    { id: 42869, cityId: 1588, code: "768220" },
    { id: 42870, cityId: 1588, code: "768222" },
    { id: 42871, cityId: 1588, code: "768225" },
    { id: 42872, cityId: 1588, code: "768227" },
    { id: 42873, cityId: 1588, code: "768228" },
    { id: 42874, cityId: 1588, code: "768230" },
    { id: 42875, cityId: 1588, code: "768001" },
    { id: 42876, cityId: 1588, code: "768004" },
    { id: 42877, cityId: 1588, code: "768017" },
    { id: 42878, cityId: 1588, code: "768019" },
    { id: 42879, cityId: 1588, code: "768027" },
    { id: 42880, cityId: 1588, code: "768028" },
    { id: 42881, cityId: 1588, code: "768030" },
    { id: 42882, cityId: 1588, code: "768033" },
    { id: 42883, cityId: 1588, code: "768035" },
    { id: 42884, cityId: 1588, code: "768036" },
    { id: 42885, cityId: 1588, code: "768038" },
    { id: 42886, cityId: 1588, code: "768041" },
    { id: 42887, cityId: 1588, code: "768043" },
    { id: 42888, cityId: 1588, code: "768044" },
    { id: 42889, cityId: 1588, code: "768046" },
    { id: 42890, cityId: 1588, code: "768049" },
    { id: 42891, cityId: 1588, code: "768051" },
    { id: 42892, cityId: 1588, code: "768052" },
    { id: 42893, cityId: 1588, code: "768054" },
    { id: 42894, cityId: 1588, code: "768102" },
    { id: 42895, cityId: 1588, code: "768104" },
    { id: 42896, cityId: 1588, code: "768105" },
    { id: 42897, cityId: 1588, code: "768107" },
    { id: 42898, cityId: 1588, code: "768112" },
    { id: 42899, cityId: 1588, code: "768115" },
    { id: 42900, cityId: 1588, code: "768117" },
    { id: 42901, cityId: 1588, code: "768118" },
    { id: 42902, cityId: 1588, code: "768150" },
    { id: 42903, cityId: 1588, code: "768203" },
    { id: 42904, cityId: 1588, code: "768205" },
    { id: 42905, cityId: 1588, code: "768215" },
    { id: 42906, cityId: 1588, code: "768216" },
    { id: 42907, cityId: 1588, code: "768221" },
    { id: 42908, cityId: 1588, code: "768223" },
    { id: 42909, cityId: 1588, code: "768224" },
    { id: 42910, cityId: 1588, code: "768229" },
    { id: 42911, cityId: 1588, code: "768231" },
    { id: 42912, cityId: 1588, code: "768232" },
    { id: 42913, cityId: 1589, code: "752085" },
    { id: 42914, cityId: 1589, code: "767064" },
    { id: 42915, cityId: 1589, code: "770020" },
    { id: 42916, cityId: 1590, code: "756045" },
    { id: 42917, cityId: 1591, code: "769001" },
    { id: 42918, cityId: 1591, code: "769003" },
    { id: 42919, cityId: 1591, code: "769006" },
    { id: 42920, cityId: 1591, code: "769008" },
    { id: 42921, cityId: 1591, code: "769009" },
    { id: 42922, cityId: 1591, code: "769014" },
    { id: 42923, cityId: 1591, code: "769016" },
    { id: 42924, cityId: 1591, code: "770002" },
    { id: 42925, cityId: 1591, code: "770012" },
    { id: 42926, cityId: 1591, code: "770015" },
    { id: 42927, cityId: 1591, code: "770017" },
    { id: 42928, cityId: 1591, code: "770018" },
    { id: 42929, cityId: 1591, code: "770023" },
    { id: 42930, cityId: 1591, code: "770025" },
    { id: 42931, cityId: 1591, code: "770026" },
    { id: 42932, cityId: 1591, code: "770028" },
    { id: 42933, cityId: 1591, code: "770031" },
    { id: 42934, cityId: 1591, code: "770033" },
    { id: 42935, cityId: 1591, code: "770034" },
    { id: 42936, cityId: 1591, code: "770036" },
    { id: 42937, cityId: 1591, code: "770039" },
    { id: 42938, cityId: 1591, code: "770041" },
    { id: 42939, cityId: 1591, code: "770044" },
    { id: 42940, cityId: 1591, code: "770047" },
    { id: 42941, cityId: 1591, code: "770049" },
    { id: 42942, cityId: 1591, code: "770050" },
    { id: 42943, cityId: 1591, code: "770052" },
    { id: 42944, cityId: 1591, code: "770071" },
    { id: 42945, cityId: 1591, code: "770073" },
    { id: 42946, cityId: 1591, code: "769002" },
    { id: 42947, cityId: 1591, code: "769004" },
    { id: 42948, cityId: 1591, code: "769005" },
    { id: 42949, cityId: 1591, code: "769007" },
    { id: 42950, cityId: 1591, code: "769010" },
    { id: 42951, cityId: 1591, code: "769012" },
    { id: 42952, cityId: 1591, code: "769013" },
    { id: 42953, cityId: 1591, code: "769015" },
    { id: 42954, cityId: 1591, code: "769041" },
    { id: 42955, cityId: 1591, code: "769042" },
    { id: 42956, cityId: 1591, code: "770001" },
    { id: 42957, cityId: 1591, code: "770011" },
    { id: 42958, cityId: 1591, code: "770013" },
    { id: 42959, cityId: 1591, code: "770014" },
    { id: 42960, cityId: 1591, code: "770016" },
    { id: 42961, cityId: 1591, code: "770019" },
    { id: 42962, cityId: 1591, code: "770021" },
    { id: 42963, cityId: 1591, code: "770024" },
    { id: 42964, cityId: 1591, code: "770027" },
    { id: 42965, cityId: 1591, code: "770029" },
    { id: 42966, cityId: 1591, code: "770032" },
    { id: 42967, cityId: 1591, code: "770035" },
    { id: 42968, cityId: 1591, code: "770037" },
    { id: 42969, cityId: 1591, code: "770038" },
    { id: 42970, cityId: 1591, code: "770040" },
    { id: 42971, cityId: 1591, code: "770043" },
    { id: 42972, cityId: 1591, code: "770045" },
    { id: 42973, cityId: 1591, code: "770046" },
    { id: 42974, cityId: 1591, code: "770051" },
    { id: 42975, cityId: 1591, code: "770072" },
    { id: 42976, cityId: 1591, code: "770074" },
    { id: 42977, cityId: 1591, code: "770075" },
    { id: 42978, cityId: 1591, code: "770077" },
    { id: 42979, cityId: 1592, code: "770042" },
    { id: 42980, cityId: 1593, code: "757041" },
    { id: 42981, cityId: 1594, code: "609601" },
    { id: 42982, cityId: 1594, code: "609606" },
    { id: 42983, cityId: 1594, code: "609609" },
    { id: 42984, cityId: 1594, code: "609602" },
    { id: 42985, cityId: 1594, code: "609605" },
    { id: 42986, cityId: 1594, code: "609607" },
    { id: 42987, cityId: 1595, code: "673310" },
    { id: 42988, cityId: 1595, code: "673311" },
    { id: 42989, cityId: 1596, code: "605001" },
    { id: 42990, cityId: 1596, code: "605003" },
    { id: 42991, cityId: 1596, code: "605004" },
    { id: 42992, cityId: 1596, code: "605006" },
    { id: 42993, cityId: 1596, code: "605008" },
    { id: 42994, cityId: 1596, code: "605009" },
    { id: 42995, cityId: 1596, code: "605011" },
    { id: 42996, cityId: 1596, code: "605014" },
    { id: 42997, cityId: 1596, code: "605106" },
    { id: 42998, cityId: 1596, code: "605501" },
    { id: 42999, cityId: 1596, code: "605002" },
    { id: 43000, cityId: 1596, code: "605005" },
    { id: 43001, cityId: 1596, code: "605007" },
    { id: 43002, cityId: 1596, code: "605010" },
    { id: 43003, cityId: 1596, code: "605012" },
    { id: 43004, cityId: 1596, code: "605013" },
    { id: 43005, cityId: 1596, code: "605110" },
    { id: 43006, cityId: 1596, code: "607402" },
    { id: 43007, cityId: 1597, code: "533464" },
    { id: 43008, cityId: 1598, code: "152116" },
    { id: 43009, cityId: 1599, code: "148021" },
    { id: 43010, cityId: 1600, code: "143102" },
    { id: 43011, cityId: 1601, code: "148033" },
    { id: 43012, cityId: 1602, code: "144301" },
    { id: 43013, cityId: 1603, code: "147203" },
    { id: 43014, cityId: 1604, code: "143001" },
    { id: 43015, cityId: 1604, code: "143004" },
    { id: 43016, cityId: 1604, code: "143006" },
    { id: 43017, cityId: 1604, code: "143036" },
    { id: 43018, cityId: 1604, code: "143104" },
    { id: 43019, cityId: 1604, code: "143105" },
    { id: 43020, cityId: 1604, code: "143107" },
    { id: 43021, cityId: 1604, code: "143110" },
    { id: 43022, cityId: 1604, code: "143112" },
    { id: 43023, cityId: 1604, code: "143113" },
    { id: 43024, cityId: 1604, code: "143115" },
    { id: 43025, cityId: 1604, code: "143118" },
    { id: 43026, cityId: 1604, code: "143144" },
    { id: 43027, cityId: 1604, code: "143202" },
    { id: 43028, cityId: 1604, code: "143203" },
    { id: 43029, cityId: 1604, code: "143205" },
    { id: 43030, cityId: 1604, code: "143301" },
    { id: 43031, cityId: 1604, code: "143401" },
    { id: 43032, cityId: 1604, code: "143406" },
    { id: 43033, cityId: 1604, code: "143407" },
    { id: 43034, cityId: 1604, code: "143412" },
    { id: 43035, cityId: 1604, code: "143414" },
    { id: 43036, cityId: 1604, code: "143415" },
    { id: 43037, cityId: 1604, code: "143417" },
    { id: 43038, cityId: 1604, code: "143420" },
    { id: 43039, cityId: 1604, code: "143422" },
    { id: 43040, cityId: 1604, code: "143502" },
    { id: 43041, cityId: 1604, code: "143504" },
    { id: 43042, cityId: 1604, code: "143603" },
    { id: 43043, cityId: 1604, code: "143002" },
    { id: 43044, cityId: 1604, code: "143003" },
    { id: 43045, cityId: 1604, code: "143021" },
    { id: 43046, cityId: 1604, code: "143101" },
    { id: 43047, cityId: 1604, code: "143103" },
    { id: 43048, cityId: 1604, code: "143106" },
    { id: 43049, cityId: 1604, code: "143108" },
    { id: 43050, cityId: 1604, code: "143109" },
    { id: 43051, cityId: 1604, code: "143111" },
    { id: 43052, cityId: 1604, code: "143116" },
    { id: 43053, cityId: 1604, code: "143117" },
    { id: 43054, cityId: 1604, code: "143201" },
    { id: 43055, cityId: 1604, code: "143204" },
    { id: 43056, cityId: 1604, code: "143302" },
    { id: 43057, cityId: 1604, code: "143304" },
    { id: 43058, cityId: 1604, code: "143305" },
    { id: 43059, cityId: 1604, code: "143408" },
    { id: 43060, cityId: 1604, code: "143410" },
    { id: 43061, cityId: 1604, code: "143411" },
    { id: 43062, cityId: 1604, code: "143413" },
    { id: 43063, cityId: 1604, code: "143418" },
    { id: 43064, cityId: 1604, code: "143421" },
    { id: 43065, cityId: 1604, code: "143501" },
    { id: 43066, cityId: 1604, code: "143503" },
    { id: 43067, cityId: 1604, code: "143606" },
    { id: 43068, cityId: 1604, code: "143607" },
    { id: 43069, cityId: 1605, code: "140118" },
    { id: 43070, cityId: 1606, code: "142037" },
    { id: 43071, cityId: 1607, code: "144401" },
    { id: 43072, cityId: 1607, code: "144505" },
    { id: 43073, cityId: 1608, code: "152025" },
    { id: 43074, cityId: 1609, code: "148101" },
    { id: 43075, cityId: 1610, code: "143505" },
    { id: 43076, cityId: 1610, code: "143506" },
    { id: 43077, cityId: 1611, code: "144621" },
    { id: 43078, cityId: 1612, code: "148102" },
    { id: 43079, cityId: 1613, code: "148109" },
    { id: 43080, cityId: 1613, code: "148112" },
    { id: 43081, cityId: 1613, code: "148114" },
    { id: 43082, cityId: 1613, code: "148115" },
    { id: 43083, cityId: 1613, code: "151001" },
    { id: 43084, cityId: 1613, code: "151002" },
    { id: 43085, cityId: 1613, code: "151102" },
    { id: 43086, cityId: 1613, code: "151104" },
    { id: 43087, cityId: 1613, code: "151105" },
    { id: 43088, cityId: 1613, code: "151107" },
    { id: 43089, cityId: 1613, code: "151110" },
    { id: 43090, cityId: 1613, code: "151510" },
    { id: 43091, cityId: 1613, code: "148110" },
    { id: 43092, cityId: 1613, code: "148111" },
    { id: 43093, cityId: 1613, code: "148113" },
    { id: 43094, cityId: 1613, code: "148116" },
    { id: 43095, cityId: 1613, code: "151003" },
    { id: 43096, cityId: 1613, code: "151005" },
    { id: 43097, cityId: 1613, code: "151101" },
    { id: 43098, cityId: 1613, code: "151106" },
    { id: 43099, cityId: 1613, code: "151108" },
    { id: 43100, cityId: 1613, code: "151201" },
    { id: 43101, cityId: 1613, code: "151206" },
    { id: 43102, cityId: 1613, code: "151207" },
    { id: 43103, cityId: 1613, code: "151302" },
    { id: 43104, cityId: 1613, code: "151501" },
    { id: 43105, cityId: 1613, code: "151503" },
    { id: 43106, cityId: 1613, code: "151506" },
    { id: 43107, cityId: 1613, code: "151508" },
    { id: 43108, cityId: 1613, code: "151511" },
    { id: 43109, cityId: 1614, code: "148026" },
    { id: 43110, cityId: 1615, code: "151504" },
    { id: 43111, cityId: 1616, code: "143303" },
    { id: 43112, cityId: 1617, code: "151502" },
    { id: 43113, cityId: 1618, code: "148029" },
    { id: 43114, cityId: 1619, code: "143604" },
    { id: 43115, cityId: 1620, code: "148105" },
    { id: 43116, cityId: 1621, code: "142042" },
    { id: 43117, cityId: 1622, code: "143515" },
    { id: 43118, cityId: 1623, code: "144804" },
    { id: 43119, cityId: 1624, code: "148024" },
    { id: 43120, cityId: 1625, code: "143531" },
    { id: 43121, cityId: 1626, code: "148035" },
    { id: 43122, cityId: 1627, code: "151204" },
    { id: 43123, cityId: 1627, code: "151205" },
    { id: 43124, cityId: 1627, code: "151210" },
    { id: 43125, cityId: 1627, code: "152026" },
    { id: 43126, cityId: 1627, code: "152031" },
    { id: 43127, cityId: 1627, code: "152103" },
    { id: 43128, cityId: 1627, code: "152113" },
    { id: 43129, cityId: 1627, code: "152115" },
    { id: 43130, cityId: 1627, code: "151203" },
    { id: 43131, cityId: 1627, code: "151208" },
    { id: 43132, cityId: 1627, code: "151209" },
    { id: 43133, cityId: 1627, code: "152032" },
    { id: 43134, cityId: 1627, code: "152112" },
    { id: 43135, cityId: 1627, code: "152114" },
    { id: 43136, cityId: 1628, code: "143602" },
    { id: 43137, cityId: 1629, code: "140412" },
    { id: 43138, cityId: 1629, code: "140802" },
    { id: 43139, cityId: 1629, code: "141411" },
    { id: 43140, cityId: 1629, code: "142039" },
    { id: 43141, cityId: 1629, code: "143532" },
    { id: 43142, cityId: 1629, code: "145024" },
    { id: 43143, cityId: 1629, code: "152003" },
    { id: 43144, cityId: 1629, code: "140901" },
    { id: 43145, cityId: 1629, code: "142058" },
    { id: 43146, cityId: 1629, code: "143112" },
    { id: 43147, cityId: 1629, code: "152128" },
    { id: 43148, cityId: 1630, code: "142041" },
    { id: 43149, cityId: 1630, code: "142047" },
    { id: 43150, cityId: 1630, code: "142049" },
    { id: 43151, cityId: 1630, code: "142050" },
    { id: 43152, cityId: 1630, code: "142052" },
    { id: 43153, cityId: 1630, code: "142055" },
    { id: 43154, cityId: 1630, code: "142057" },
    { id: 43155, cityId: 1630, code: "142060" },
    { id: 43156, cityId: 1630, code: "152005" },
    { id: 43157, cityId: 1630, code: "152021" },
    { id: 43158, cityId: 1630, code: "152116" },
    { id: 43159, cityId: 1630, code: "152117" },
    { id: 43160, cityId: 1630, code: "152122" },
    { id: 43161, cityId: 1630, code: "152124" },
    { id: 43162, cityId: 1630, code: "152125" },
    { id: 43163, cityId: 1630, code: "152127" },
    { id: 43164, cityId: 1630, code: "152130" },
    { id: 43165, cityId: 1630, code: "152132" },
    { id: 43166, cityId: 1630, code: "142001" },
    { id: 43167, cityId: 1630, code: "142011" },
    { id: 43168, cityId: 1630, code: "142040" },
    { id: 43169, cityId: 1630, code: "142043" },
    { id: 43170, cityId: 1630, code: "142046" },
    { id: 43171, cityId: 1630, code: "142048" },
    { id: 43172, cityId: 1630, code: "142051" },
    { id: 43173, cityId: 1630, code: "142053" },
    { id: 43174, cityId: 1630, code: "142054" },
    { id: 43175, cityId: 1630, code: "142056" },
    { id: 43176, cityId: 1630, code: "142059" },
    { id: 43177, cityId: 1630, code: "142061" },
    { id: 43178, cityId: 1630, code: "152001" },
    { id: 43179, cityId: 1630, code: "152004" },
    { id: 43180, cityId: 1630, code: "152022" },
    { id: 43181, cityId: 1630, code: "152023" },
    { id: 43182, cityId: 1630, code: "152033" },
    { id: 43183, cityId: 1630, code: "152120" },
    { id: 43184, cityId: 1630, code: "152121" },
    { id: 43185, cityId: 1630, code: "152123" },
    { id: 43186, cityId: 1630, code: "152126" },
    { id: 43187, cityId: 1630, code: "152129" },
    { id: 43188, cityId: 1630, code: "152131" },
    { id: 43189, cityId: 1631, code: "147102" },
    { id: 43190, cityId: 1632, code: "140702" },
    { id: 43191, cityId: 1633, code: "152101" },
    { id: 43192, cityId: 1633, code: "152102" },
    { id: 43193, cityId: 1634, code: "144409" },
    { id: 43194, cityId: 1635, code: "143505" },
    { id: 43195, cityId: 1635, code: "143508" },
    { id: 43196, cityId: 1635, code: "143510" },
    { id: 43197, cityId: 1635, code: "143511" },
    { id: 43198, cityId: 1635, code: "143513" },
    { id: 43199, cityId: 1635, code: "143518" },
    { id: 43200, cityId: 1635, code: "143521" },
    { id: 43201, cityId: 1635, code: "143524" },
    { id: 43202, cityId: 1635, code: "143526" },
    { id: 43203, cityId: 1635, code: "143527" },
    { id: 43204, cityId: 1635, code: "143529" },
    { id: 43205, cityId: 1635, code: "143531" },
    { id: 43206, cityId: 1635, code: "143534" },
    { id: 43207, cityId: 1635, code: "143537" },
    { id: 43208, cityId: 1635, code: "145001" },
    { id: 43209, cityId: 1635, code: "145002" },
    { id: 43210, cityId: 1635, code: "145025" },
    { id: 43211, cityId: 1635, code: "145026" },
    { id: 43212, cityId: 1635, code: "143507" },
    { id: 43213, cityId: 1635, code: "143514" },
    { id: 43214, cityId: 1635, code: "143515" },
    { id: 43215, cityId: 1635, code: "143517" },
    { id: 43216, cityId: 1635, code: "143520" },
    { id: 43217, cityId: 1635, code: "143523" },
    { id: 43218, cityId: 1635, code: "143528" },
    { id: 43219, cityId: 1635, code: "143530" },
    { id: 43220, cityId: 1635, code: "143533" },
    { id: 43221, cityId: 1635, code: "143535" },
    { id: 43222, cityId: 1635, code: "143536" },
    { id: 43223, cityId: 1635, code: "143538" },
    { id: 43224, cityId: 1635, code: "143605" },
    { id: 43225, cityId: 1635, code: "144502" },
    { id: 43226, cityId: 1635, code: "145003" },
    { id: 43227, cityId: 1635, code: "145021" },
    { id: 43228, cityId: 1635, code: "145022" },
    { id: 43229, cityId: 1635, code: "145027" },
    { id: 43230, cityId: 1635, code: "145029" },
    { id: 43231, cityId: 1636, code: "144221" },
    { id: 43232, cityId: 1636, code: "844101" },
    { id: 43233, cityId: 1637, code: "144208" },
    { id: 43234, cityId: 1638, code: "144202" },
    { id: 43235, cityId: 1638, code: "144204" },
    { id: 43236, cityId: 1638, code: "144207" },
    { id: 43237, cityId: 1638, code: "144209" },
    { id: 43238, cityId: 1638, code: "144214" },
    { id: 43239, cityId: 1638, code: "144222" },
    { id: 43240, cityId: 1638, code: "144223" },
    { id: 43241, cityId: 1638, code: "144305" },
    { id: 43242, cityId: 1638, code: "144519" },
    { id: 43243, cityId: 1638, code: "144522" },
    { id: 43244, cityId: 1638, code: "144524" },
    { id: 43245, cityId: 1638, code: "144525" },
    { id: 43246, cityId: 1638, code: "144527" },
    { id: 43247, cityId: 1638, code: "144530" },
    { id: 43248, cityId: 1638, code: "144532" },
    { id: 43249, cityId: 1638, code: "146021" },
    { id: 43250, cityId: 1638, code: "146023" },
    { id: 43251, cityId: 1638, code: "146101" },
    { id: 43252, cityId: 1638, code: "146103" },
    { id: 43253, cityId: 1638, code: "146106" },
    { id: 43254, cityId: 1638, code: "146108" },
    { id: 43255, cityId: 1638, code: "146109" },
    { id: 43256, cityId: 1638, code: "146111" },
    { id: 43257, cityId: 1638, code: "146113" },
    { id: 43258, cityId: 1638, code: "146114" },
    { id: 43259, cityId: 1638, code: "144105" },
    { id: 43260, cityId: 1638, code: "144203" },
    { id: 43261, cityId: 1638, code: "144205" },
    { id: 43262, cityId: 1638, code: "144206" },
    { id: 43263, cityId: 1638, code: "144210" },
    { id: 43264, cityId: 1638, code: "144211" },
    { id: 43265, cityId: 1638, code: "144213" },
    { id: 43266, cityId: 1638, code: "144216" },
    { id: 43267, cityId: 1638, code: "144218" },
    { id: 43268, cityId: 1638, code: "144224" },
    { id: 43269, cityId: 1638, code: "144304" },
    { id: 43270, cityId: 1638, code: "144404" },
    { id: 43271, cityId: 1638, code: "144406" },
    { id: 43272, cityId: 1638, code: "144520" },
    { id: 43273, cityId: 1638, code: "144521" },
    { id: 43274, cityId: 1638, code: "144523" },
    { id: 43275, cityId: 1638, code: "144528" },
    { id: 43276, cityId: 1638, code: "144529" },
    { id: 43277, cityId: 1638, code: "144531" },
    { id: 43278, cityId: 1638, code: "144619" },
    { id: 43279, cityId: 1638, code: "145101" },
    { id: 43280, cityId: 1638, code: "146001" },
    { id: 43281, cityId: 1638, code: "146022" },
    { id: 43282, cityId: 1638, code: "146102" },
    { id: 43283, cityId: 1638, code: "146104" },
    { id: 43284, cityId: 1638, code: "146107" },
    { id: 43285, cityId: 1638, code: "146110" },
    { id: 43286, cityId: 1638, code: "146112" },
    { id: 43287, cityId: 1638, code: "146115" },
    { id: 43288, cityId: 1639, code: "151202" },
    { id: 43289, cityId: 1640, code: "152024" },
    { id: 43290, cityId: 1640, code: "247772" },
    { id: 43291, cityId: 1640, code: "275207" },
    { id: 43292, cityId: 1641, code: "144001" },
    { id: 43293, cityId: 1641, code: "144004" },
    { id: 43294, cityId: 1641, code: "144006" },
    { id: 43295, cityId: 1641, code: "144007" },
    { id: 43296, cityId: 1641, code: "144009" },
    { id: 43297, cityId: 1641, code: "144020" },
    { id: 43298, cityId: 1641, code: "144022" },
    { id: 43299, cityId: 1641, code: "144025" },
    { id: 43300, cityId: 1641, code: "144027" },
    { id: 43301, cityId: 1641, code: "144028" },
    { id: 43302, cityId: 1641, code: "144102" },
    { id: 43303, cityId: 1641, code: "144104" },
    { id: 43304, cityId: 1641, code: "144303" },
    { id: 43305, cityId: 1641, code: "144409" },
    { id: 43306, cityId: 1641, code: "144417" },
    { id: 43307, cityId: 1641, code: "144419" },
    { id: 43308, cityId: 1641, code: "144422" },
    { id: 43309, cityId: 1641, code: "144504" },
    { id: 43310, cityId: 1641, code: "144507" },
    { id: 43311, cityId: 1641, code: "144509" },
    { id: 43312, cityId: 1641, code: "144510" },
    { id: 43313, cityId: 1641, code: "144512" },
    { id: 43314, cityId: 1641, code: "144515" },
    { id: 43315, cityId: 1641, code: "144518" },
    { id: 43316, cityId: 1641, code: "144002" },
    { id: 43317, cityId: 1641, code: "144003" },
    { id: 43318, cityId: 1641, code: "144005" },
    { id: 43319, cityId: 1641, code: "144008" },
    { id: 43320, cityId: 1641, code: "144010" },
    { id: 43321, cityId: 1641, code: "144011" },
    { id: 43322, cityId: 1641, code: "144021" },
    { id: 43323, cityId: 1641, code: "144023" },
    { id: 43324, cityId: 1641, code: "144024" },
    { id: 43325, cityId: 1641, code: "144026" },
    { id: 43326, cityId: 1641, code: "144101" },
    { id: 43327, cityId: 1641, code: "144103" },
    { id: 43328, cityId: 1641, code: "144116" },
    { id: 43329, cityId: 1641, code: "144201" },
    { id: 43330, cityId: 1641, code: "144302" },
    { id: 43331, cityId: 1641, code: "144410" },
    { id: 43332, cityId: 1641, code: "144415" },
    { id: 43333, cityId: 1641, code: "144418" },
    { id: 43334, cityId: 1641, code: "144421" },
    { id: 43335, cityId: 1641, code: "144423" },
    { id: 43336, cityId: 1641, code: "144503" },
    { id: 43337, cityId: 1641, code: "144506" },
    { id: 43338, cityId: 1641, code: "144508" },
    { id: 43339, cityId: 1641, code: "144511" },
    { id: 43340, cityId: 1641, code: "144513" },
    { id: 43341, cityId: 1641, code: "144514" },
    { id: 43342, cityId: 1641, code: "144516" },
    { id: 43343, cityId: 1642, code: "141303" },
    { id: 43344, cityId: 1643, code: "124113" },
    { id: 43345, cityId: 1643, code: "143512" },
    { id: 43346, cityId: 1644, code: "141302" },
    { id: 43347, cityId: 1644, code: "141305" },
    { id: 43348, cityId: 1644, code: "141307" },
    { id: 43349, cityId: 1644, code: "141310" },
    { id: 43350, cityId: 1644, code: "141315" },
    { id: 43351, cityId: 1644, code: "141318" },
    { id: 43352, cityId: 1644, code: "144401" },
    { id: 43353, cityId: 1644, code: "144403" },
    { id: 43354, cityId: 1644, code: "144408" },
    { id: 43355, cityId: 1644, code: "144620" },
    { id: 43356, cityId: 1644, code: "144623" },
    { id: 43357, cityId: 1644, code: "144626" },
    { id: 43358, cityId: 1644, code: "144628" },
    { id: 43359, cityId: 1644, code: "144629" },
    { id: 43360, cityId: 1644, code: "144631" },
    { id: 43361, cityId: 1644, code: "144703" },
    { id: 43362, cityId: 1644, code: "144803" },
    { id: 43363, cityId: 1644, code: "144806" },
    { id: 43364, cityId: 1644, code: "141306" },
    { id: 43365, cityId: 1644, code: "141308" },
    { id: 43366, cityId: 1644, code: "141309" },
    { id: 43367, cityId: 1644, code: "141311" },
    { id: 43368, cityId: 1644, code: "141316" },
    { id: 43369, cityId: 1644, code: "141317" },
    { id: 43370, cityId: 1644, code: "144402" },
    { id: 43371, cityId: 1644, code: "144405" },
    { id: 43372, cityId: 1644, code: "144407" },
    { id: 43373, cityId: 1644, code: "144601" },
    { id: 43374, cityId: 1644, code: "144606" },
    { id: 43375, cityId: 1644, code: "144622" },
    { id: 43376, cityId: 1644, code: "144624" },
    { id: 43377, cityId: 1644, code: "144630" },
    { id: 43378, cityId: 1644, code: "144632" },
    { id: 43379, cityId: 1644, code: "144633" },
    { id: 43380, cityId: 1644, code: "144701" },
    { id: 43381, cityId: 1644, code: "144802" },
    { id: 43382, cityId: 1645, code: "144801" },
    { id: 43383, cityId: 1646, code: "140301" },
    { id: 43384, cityId: 1646, code: "721222" },
    { id: 43385, cityId: 1647, code: "143419" },
    { id: 43386, cityId: 1648, code: "140103" },
    { id: 43387, cityId: 1649, code: "148031" },
    { id: 43388, cityId: 1650, code: "148106" },
    { id: 43389, cityId: 1651, code: "140801" },
    { id: 43390, cityId: 1651, code: "141002" },
    { id: 43391, cityId: 1651, code: "141005" },
    { id: 43392, cityId: 1651, code: "141007" },
    { id: 43393, cityId: 1651, code: "141008" },
    { id: 43394, cityId: 1651, code: "141103" },
    { id: 43395, cityId: 1651, code: "141105" },
    { id: 43396, cityId: 1651, code: "141106" },
    { id: 43397, cityId: 1651, code: "141108" },
    { id: 43398, cityId: 1651, code: "141111" },
    { id: 43399, cityId: 1651, code: "141113" },
    { id: 43400, cityId: 1651, code: "141116" },
    { id: 43401, cityId: 1651, code: "141119" },
    { id: 43402, cityId: 1651, code: "141121" },
    { id: 43403, cityId: 1651, code: "141122" },
    { id: 43404, cityId: 1651, code: "141124" },
    { id: 43405, cityId: 1651, code: "141201" },
    { id: 43406, cityId: 1651, code: "141203" },
    { id: 43407, cityId: 1651, code: "141204" },
    { id: 43408, cityId: 1651, code: "141206" },
    { id: 43409, cityId: 1651, code: "141402" },
    { id: 43410, cityId: 1651, code: "141413" },
    { id: 43411, cityId: 1651, code: "141415" },
    { id: 43412, cityId: 1651, code: "141418" },
    { id: 43413, cityId: 1651, code: "141421" },
    { id: 43414, cityId: 1651, code: "142022" },
    { id: 43415, cityId: 1651, code: "142024" },
    { id: 43416, cityId: 1651, code: "142025" },
    { id: 43417, cityId: 1651, code: "142027" },
    { id: 43418, cityId: 1651, code: "142030" },
    { id: 43419, cityId: 1651, code: "142032" },
    { id: 43420, cityId: 1651, code: "142033" },
    { id: 43421, cityId: 1651, code: "142035" },
    { id: 43422, cityId: 1651, code: "141001" },
    { id: 43423, cityId: 1651, code: "141003" },
    { id: 43424, cityId: 1651, code: "141004" },
    { id: 43425, cityId: 1651, code: "141006" },
    { id: 43426, cityId: 1651, code: "141101" },
    { id: 43427, cityId: 1651, code: "141102" },
    { id: 43428, cityId: 1651, code: "141104" },
    { id: 43429, cityId: 1651, code: "141107" },
    { id: 43430, cityId: 1651, code: "141112" },
    { id: 43431, cityId: 1651, code: "141117" },
    { id: 43432, cityId: 1651, code: "141118" },
    { id: 43433, cityId: 1651, code: "141120" },
    { id: 43434, cityId: 1651, code: "141202" },
    { id: 43435, cityId: 1651, code: "141205" },
    { id: 43436, cityId: 1651, code: "141401" },
    { id: 43437, cityId: 1651, code: "141412" },
    { id: 43438, cityId: 1651, code: "141414" },
    { id: 43439, cityId: 1651, code: "141417" },
    { id: 43440, cityId: 1651, code: "141419" },
    { id: 43441, cityId: 1651, code: "142021" },
    { id: 43442, cityId: 1651, code: "142023" },
    { id: 43444, cityId: 1651, code: "142029" },
    { id: 43445, cityId: 1651, code: "142031" },
    { id: 43446, cityId: 1651, code: "142034" },
    { id: 43447, cityId: 1651, code: "142036" },
    { id: 43448, cityId: 1652, code: "141115" },
    { id: 43449, cityId: 1653, code: "146105" },
    { id: 43450, cityId: 1654, code: "143601" },
    { id: 43451, cityId: 1655, code: "142044" },
    { id: 43452, cityId: 1656, code: "148023" },
    { id: 43453, cityId: 1657, code: "152107" },
    { id: 43454, cityId: 1658, code: "151505" },
    { id: 43455, cityId: 1659, code: "151509" },
    { id: 43456, cityId: 1660, code: "142001" },
    { id: 43457, cityId: 1661, code: "140101" },
    { id: 43458, cityId: 1662, code: "144211" },
    { id: 43459, cityId: 1663, code: "152026" },
    { id: 43460, cityId: 1664, code: "144624" },
    { id: 43461, cityId: 1665, code: "141310" },
    { id: 43462, cityId: 1666, code: "140125" },
    { id: 43463, cityId: 1667, code: "144505" },
    { id: 43464, cityId: 1667, code: "144514" },
    { id: 43465, cityId: 1668, code: "145001" },
    { id: 43466, cityId: 1669, code: "140401" },
    { id: 43467, cityId: 1669, code: "140407" },
    { id: 43468, cityId: 1669, code: "140417" },
    { id: 43469, cityId: 1669, code: "140502" },
    { id: 43470, cityId: 1669, code: "140701" },
    { id: 43471, cityId: 1669, code: "147002" },
    { id: 43472, cityId: 1669, code: "147105" },
    { id: 43473, cityId: 1669, code: "147205" },
    { id: 43474, cityId: 1669, code: "147301" },
    { id: 43475, cityId: 1669, code: "140405" },
    { id: 43476, cityId: 1669, code: "140406" },
    { id: 43477, cityId: 1669, code: "140501" },
    { id: 43478, cityId: 1669, code: "140506" },
    { id: 43479, cityId: 1669, code: "140601" },
    { id: 43480, cityId: 1669, code: "140602" },
    { id: 43481, cityId: 1669, code: "147001" },
    { id: 43482, cityId: 1669, code: "147003" },
    { id: 43483, cityId: 1669, code: "147021" },
    { id: 43484, cityId: 1669, code: "147104" },
    { id: 43485, cityId: 1669, code: "147201" },
    { id: 43486, cityId: 1669, code: "147202" },
    { id: 43487, cityId: 1670, code: "143416" },
    { id: 43488, cityId: 1670, code: "230135" },
    { id: 43489, cityId: 1671, code: "141416" },
    { id: 43490, cityId: 1672, code: "144401" },
    { id: 43491, cityId: 1673, code: "144410" },
    { id: 43492, cityId: 1674, code: "143516" },
    { id: 43493, cityId: 1675, code: "144517" },
    { id: 43494, cityId: 1676, code: "141109" },
    { id: 43495, cityId: 1677, code: "140401" },
    { id: 43496, cityId: 1678, code: "151301" },
    { id: 43497, cityId: 1679, code: "151103" },
    { id: 43498, cityId: 1680, code: "140108" },
    { id: 43499, cityId: 1680, code: "140109" },
    { id: 43500, cityId: 1680, code: "140111" },
    { id: 43501, cityId: 1680, code: "140114" },
    { id: 43502, cityId: 1680, code: "140116" },
    { id: 43503, cityId: 1680, code: "140117" },
    { id: 43504, cityId: 1680, code: "140119" },
    { id: 43505, cityId: 1680, code: "140124" },
    { id: 43506, cityId: 1680, code: "140201" },
    { id: 43507, cityId: 1680, code: "140307" },
    { id: 43508, cityId: 1680, code: "140413" },
    { id: 43509, cityId: 1680, code: "144526" },
    { id: 43510, cityId: 1680, code: "140001" },
    { id: 43511, cityId: 1680, code: "140102" },
    { id: 43512, cityId: 1680, code: "140104" },
    { id: 43513, cityId: 1680, code: "140110" },
    { id: 43514, cityId: 1680, code: "140112" },
    { id: 43515, cityId: 1680, code: "140113" },
    { id: 43516, cityId: 1680, code: "140115" },
    { id: 43517, cityId: 1680, code: "140123" },
    { id: 43518, cityId: 1680, code: "140126" },
    { id: 43519, cityId: 1680, code: "140202" },
    { id: 43520, cityId: 1680, code: "140203" },
    { id: 43521, cityId: 1680, code: "140306" },
    { id: 43522, cityId: 1680, code: "140308" },
    { id: 43523, cityId: 1681, code: "147101" },
    { id: 43524, cityId: 1682, code: "141114" },
    { id: 43525, cityId: 1683, code: "147103" },
    { id: 43526, cityId: 1684, code: "151401" },
    { id: 43527, cityId: 1685, code: "148001" },
    { id: 43528, cityId: 1685, code: "148004" },
    { id: 43529, cityId: 1685, code: "148007" },
    { id: 43530, cityId: 1685, code: "148009" },
    { id: 43531, cityId: 1685, code: "148020" },
    { id: 43532, cityId: 1685, code: "148022" },
    { id: 43533, cityId: 1685, code: "148023" },
    { id: 43534, cityId: 1685, code: "148025" },
    { id: 43535, cityId: 1685, code: "148036" },
    { id: 43536, cityId: 1685, code: "148038" },
    { id: 43537, cityId: 1685, code: "148039" },
    { id: 43538, cityId: 1685, code: "148041" },
    { id: 43539, cityId: 1685, code: "148044" },
    { id: 43540, cityId: 1685, code: "148046" },
    { id: 43541, cityId: 1685, code: "148047" },
    { id: 43542, cityId: 1685, code: "148049" },
    { id: 43543, cityId: 1685, code: "148107" },
    { id: 43544, cityId: 1685, code: "148005" },
    { id: 43545, cityId: 1685, code: "148006" },
    { id: 43546, cityId: 1685, code: "148008" },
    { id: 43547, cityId: 1685, code: "148024" },
    { id: 43548, cityId: 1685, code: "148027" },
    { id: 43549, cityId: 1685, code: "148032" },
    { id: 43550, cityId: 1685, code: "148034" },
    { id: 43551, cityId: 1685, code: "148040" },
    { id: 43552, cityId: 1685, code: "148042" },
    { id: 43553, cityId: 1685, code: "148043" },
    { id: 43554, cityId: 1685, code: "148045" },
    { id: 43555, cityId: 1685, code: "148048" },
    { id: 43556, cityId: 1685, code: "148050" },
    { id: 43557, cityId: 1685, code: "148051" },
    { id: 43558, cityId: 1685, code: "148101" },
    { id: 43559, cityId: 1685, code: "148103" },
    { id: 43560, cityId: 1685, code: "148104" },
    { id: 43561, cityId: 1685, code: "148108" },
    { id: 43562, cityId: 1685, code: "148117" },
    { id: 43563, cityId: 1686, code: "151507" },
    { id: 43564, cityId: 1687, code: "144702" },
    { id: 43565, cityId: 1688, code: "143515" },
    { id: 43566, cityId: 1689, code: "145023" },
    { id: 43567, cityId: 1690, code: "144626" },
    { id: 43568, cityId: 1691, code: "148028" },
    { id: 43569, cityId: 1692, code: "142050" },
    { id: 43570, cityId: 1693, code: "142047" },
    { id: 43571, cityId: 1694, code: "305001" },
    { id: 43572, cityId: 1694, code: "305004" },
    { id: 43573, cityId: 1694, code: "305006" },
    { id: 43574, cityId: 1694, code: "305007" },
    { id: 43575, cityId: 1694, code: "305025" },
    { id: 43576, cityId: 1694, code: "305202" },
    { id: 43577, cityId: 1694, code: "305205" },
    { id: 43578, cityId: 1694, code: "305207" },
    { id: 43579, cityId: 1694, code: "305401" },
    { id: 43580, cityId: 1694, code: "305404" },
    { id: 43581, cityId: 1694, code: "305406" },
    { id: 43582, cityId: 1694, code: "305412" },
    { id: 43583, cityId: 1694, code: "305621" },
    { id: 43584, cityId: 1694, code: "305623" },
    { id: 43585, cityId: 1694, code: "305624" },
    { id: 43586, cityId: 1694, code: "305801" },
    { id: 43587, cityId: 1694, code: "305811" },
    { id: 43588, cityId: 1694, code: "305812" },
    { id: 43589, cityId: 1694, code: "305814" },
    { id: 43590, cityId: 1694, code: "305817" },
    { id: 43591, cityId: 1694, code: "305819" },
    { id: 43592, cityId: 1694, code: "305820" },
    { id: 43593, cityId: 1694, code: "305901" },
    { id: 43594, cityId: 1694, code: "305912" },
    { id: 43595, cityId: 1694, code: "305923" },
    { id: 43596, cityId: 1694, code: "305925" },
    { id: 43597, cityId: 1694, code: "305926" },
    { id: 43598, cityId: 1694, code: "305928" },
    { id: 43599, cityId: 1694, code: "305002" },
    { id: 43600, cityId: 1694, code: "305003" },
    { id: 43601, cityId: 1694, code: "305005" },
    { id: 43602, cityId: 1694, code: "305008" },
    { id: 43603, cityId: 1694, code: "305021" },
    { id: 43604, cityId: 1694, code: "305023" },
    { id: 43605, cityId: 1694, code: "305024" },
    { id: 43606, cityId: 1694, code: "305201" },
    { id: 43607, cityId: 1694, code: "305203" },
    { id: 43608, cityId: 1694, code: "305204" },
    { id: 43609, cityId: 1694, code: "305206" },
    { id: 43610, cityId: 1694, code: "305402" },
    { id: 43611, cityId: 1694, code: "305405" },
    { id: 43612, cityId: 1694, code: "305407" },
    { id: 43613, cityId: 1694, code: "305408" },
    { id: 43614, cityId: 1694, code: "305415" },
    { id: 43615, cityId: 1694, code: "305416" },
    { id: 43616, cityId: 1694, code: "305601" },
    { id: 43617, cityId: 1694, code: "305622" },
    { id: 43618, cityId: 1694, code: "305625" },
    { id: 43619, cityId: 1694, code: "305627" },
    { id: 43620, cityId: 1694, code: "305802" },
    { id: 43621, cityId: 1694, code: "305813" },
    { id: 43622, cityId: 1694, code: "305815" },
    { id: 43623, cityId: 1694, code: "305816" },
    { id: 43624, cityId: 1694, code: "305818" },
    { id: 43625, cityId: 1694, code: "305922" },
    { id: 43626, cityId: 1694, code: "305924" },
    { id: 43627, cityId: 1694, code: "305927" },
    { id: 43628, cityId: 1695, code: "326033" },
    { id: 43629, cityId: 1696, code: "301021" },
    { id: 43630, cityId: 1696, code: "301023" },
    { id: 43631, cityId: 1696, code: "301024" },
    { id: 43632, cityId: 1696, code: "301026" },
    { id: 43633, cityId: 1696, code: "301029" },
    { id: 43634, cityId: 1696, code: "301031" },
    { id: 43635, cityId: 1696, code: "301032" },
    { id: 43636, cityId: 1696, code: "301034" },
    { id: 43637, cityId: 1696, code: "301037" },
    { id: 43638, cityId: 1696, code: "301042" },
    { id: 43639, cityId: 1696, code: "301402" },
    { id: 43640, cityId: 1696, code: "301407" },
    { id: 43641, cityId: 1696, code: "301408" },
    { id: 43642, cityId: 1696, code: "301410" },
    { id: 43643, cityId: 1696, code: "301413" },
    { id: 43644, cityId: 1696, code: "301415" },
    { id: 43645, cityId: 1696, code: "301416" },
    { id: 43646, cityId: 1696, code: "301418" },
    { id: 43647, cityId: 1696, code: "301421" },
    { id: 43648, cityId: 1696, code: "301423" },
    { id: 43649, cityId: 1696, code: "301424" },
    { id: 43650, cityId: 1696, code: "301426" },
    { id: 43651, cityId: 1696, code: "301701" },
    { id: 43652, cityId: 1696, code: "301702" },
    { id: 43653, cityId: 1696, code: "301704" },
    { id: 43654, cityId: 1696, code: "301707" },
    { id: 43655, cityId: 1696, code: "301709" },
    { id: 43656, cityId: 1696, code: "301710" },
    { id: 43657, cityId: 1696, code: "301712" },
    { id: 43658, cityId: 1696, code: "321604" },
    { id: 43659, cityId: 1696, code: "321607" },
    { id: 43660, cityId: 1696, code: "321636" },
    { id: 43661, cityId: 1696, code: "321638" },
    { id: 43662, cityId: 1696, code: "321639" },
    { id: 43663, cityId: 1696, code: "321641" },
    { id: 43664, cityId: 1696, code: "301001" },
    { id: 43665, cityId: 1696, code: "301019" },
    { id: 43666, cityId: 1696, code: "301020" },
    { id: 43667, cityId: 1696, code: "301022" },
    { id: 43668, cityId: 1696, code: "301025" },
    { id: 43669, cityId: 1696, code: "301027" },
    { id: 43670, cityId: 1696, code: "301028" },
    { id: 43671, cityId: 1696, code: "301033" },
    { id: 43672, cityId: 1696, code: "301035" },
    { id: 43673, cityId: 1696, code: "301036" },
    { id: 43674, cityId: 1696, code: "301043" },
    { id: 43675, cityId: 1696, code: "301044" },
    { id: 43676, cityId: 1696, code: "301401" },
    { id: 43677, cityId: 1696, code: "301403" },
    { id: 43678, cityId: 1696, code: "301406" },
    { id: 43679, cityId: 1696, code: "301409" },
    { id: 43680, cityId: 1696, code: "301412" },
    { id: 43681, cityId: 1696, code: "301414" },
    { id: 43682, cityId: 1696, code: "301417" },
    { id: 43683, cityId: 1696, code: "301419" },
    { id: 43684, cityId: 1696, code: "301420" },
    { id: 43685, cityId: 1696, code: "301425" },
    { id: 43686, cityId: 1696, code: "301427" },
    { id: 43687, cityId: 1696, code: "301703" },
    { id: 43688, cityId: 1696, code: "301705" },
    { id: 43689, cityId: 1696, code: "301706" },
    { id: 43690, cityId: 1696, code: "301708" },
    { id: 43691, cityId: 1696, code: "301711" },
    { id: 43692, cityId: 1696, code: "301713" },
    { id: 43693, cityId: 1696, code: "321605" },
    { id: 43694, cityId: 1696, code: "321634" },
    { id: 43695, cityId: 1696, code: "321637" },
    { id: 43696, cityId: 1696, code: "321640" },
    { id: 43697, cityId: 1697, code: "335701" },
    { id: 43698, cityId: 1698, code: "311301" },
    { id: 43699, cityId: 1699, code: "303007" },
    { id: 43700, cityId: 1700, code: "326022" },
    { id: 43701, cityId: 1701, code: "306701" },
    { id: 43702, cityId: 1702, code: "344022" },
    { id: 43703, cityId: 1703, code: "303313" },
    { id: 43704, cityId: 1704, code: "327023" },
    { id: 43705, cityId: 1704, code: "327025" },
    { id: 43706, cityId: 1704, code: "327026" },
    { id: 43707, cityId: 1704, code: "327028" },
    { id: 43708, cityId: 1704, code: "327031" },
    { id: 43709, cityId: 1704, code: "327033" },
    { id: 43710, cityId: 1704, code: "327605" },
    { id: 43711, cityId: 1704, code: "327606" },
    { id: 43712, cityId: 1704, code: "327001" },
    { id: 43713, cityId: 1704, code: "327021" },
    { id: 43714, cityId: 1704, code: "327022" },
    { id: 43715, cityId: 1704, code: "327024" },
    { id: 43716, cityId: 1704, code: "327027" },
    { id: 43717, cityId: 1704, code: "327029" },
    { id: 43718, cityId: 1704, code: "327030" },
    { id: 43719, cityId: 1704, code: "327032" },
    { id: 43720, cityId: 1704, code: "327601" },
    { id: 43721, cityId: 1704, code: "327602" },
    { id: 43722, cityId: 1704, code: "327604" },
    { id: 43723, cityId: 1705, code: "325008" },
    { id: 43724, cityId: 1705, code: "325217" },
    { id: 43725, cityId: 1705, code: "325222" },
    { id: 43726, cityId: 1705, code: "328001" },
    { id: 43727, cityId: 1705, code: "301422" },
    { id: 43728, cityId: 1705, code: "303705" },
    { id: 43729, cityId: 1705, code: "312620" },
    { id: 43730, cityId: 1705, code: "325215" },
    { id: 43731, cityId: 1705, code: "328034" },
    { id: 43732, cityId: 1706, code: "313025" },
    { id: 43733, cityId: 1706, code: "312403" },
    { id: 43734, cityId: 1707, code: "343043" },
    { id: 43735, cityId: 1707, code: "344001" },
    { id: 43736, cityId: 1707, code: "344012" },
    { id: 43737, cityId: 1707, code: "344014" },
    { id: 43738, cityId: 1707, code: "344015" },
    { id: 43739, cityId: 1707, code: "344023" },
    { id: 43740, cityId: 1707, code: "344025" },
    { id: 43741, cityId: 1707, code: "344028" },
    { id: 43742, cityId: 1707, code: "344030" },
    { id: 43743, cityId: 1707, code: "344031" },
    { id: 43744, cityId: 1707, code: "344033" },
    { id: 43745, cityId: 1707, code: "344036" },
    { id: 43746, cityId: 1707, code: "344038" },
    { id: 43747, cityId: 1707, code: "344039" },
    { id: 43748, cityId: 1707, code: "344502" },
    { id: 43749, cityId: 1707, code: "344701" },
    { id: 43750, cityId: 1707, code: "344706" },
    { id: 43751, cityId: 1707, code: "344708" },
    { id: 43752, cityId: 1707, code: "344709" },
    { id: 43753, cityId: 1707, code: "344801" },
    { id: 43754, cityId: 1707, code: "343044" },
    { id: 43755, cityId: 1707, code: "344011" },
    { id: 43756, cityId: 1707, code: "344013" },
    { id: 43757, cityId: 1707, code: "344021" },
    { id: 43758, cityId: 1707, code: "344024" },
    { id: 43759, cityId: 1707, code: "344026" },
    { id: 43760, cityId: 1707, code: "344027" },
    { id: 43761, cityId: 1707, code: "344029" },
    { id: 43762, cityId: 1707, code: "344032" },
    { id: 43763, cityId: 1707, code: "344034" },
    { id: 43764, cityId: 1707, code: "344035" },
    { id: 43765, cityId: 1707, code: "344037" },
    { id: 43766, cityId: 1707, code: "344501" },
    { id: 43767, cityId: 1707, code: "344503" },
    { id: 43768, cityId: 1707, code: "344702" },
    { id: 43769, cityId: 1707, code: "344704" },
    { id: 43770, cityId: 1707, code: "344705" },
    { id: 43771, cityId: 1708, code: "321401" },
    { id: 43772, cityId: 1709, code: "305901" },
    { id: 43773, cityId: 1710, code: "312023" },
    { id: 43774, cityId: 1711, code: "321021" },
    { id: 43775, cityId: 1711, code: "321023" },
    { id: 43776, cityId: 1711, code: "321024" },
    { id: 43777, cityId: 1711, code: "321026" },
    { id: 43778, cityId: 1711, code: "321029" },
    { id: 43779, cityId: 1711, code: "321032" },
    { id: 43780, cityId: 1711, code: "321034" },
    { id: 43781, cityId: 1711, code: "321201" },
    { id: 43782, cityId: 1711, code: "321204" },
    { id: 43783, cityId: 1711, code: "321207" },
    { id: 43784, cityId: 1711, code: "321209" },
    { id: 43785, cityId: 1711, code: "321211" },
    { id: 43786, cityId: 1711, code: "321302" },
    { id: 43787, cityId: 1711, code: "321304" },
    { id: 43788, cityId: 1711, code: "321305" },
    { id: 43789, cityId: 1711, code: "321402" },
    { id: 43790, cityId: 1711, code: "321403" },
    { id: 43791, cityId: 1711, code: "321405" },
    { id: 43792, cityId: 1711, code: "321407" },
    { id: 43793, cityId: 1711, code: "321410" },
    { id: 43794, cityId: 1711, code: "321413" },
    { id: 43795, cityId: 1711, code: "321415" },
    { id: 43796, cityId: 1711, code: "321416" },
    { id: 43797, cityId: 1711, code: "321418" },
    { id: 43798, cityId: 1711, code: "321421" },
    { id: 43799, cityId: 1711, code: "321423" },
    { id: 43800, cityId: 1711, code: "321424" },
    { id: 43801, cityId: 1711, code: "321426" },
    { id: 43802, cityId: 1711, code: "321429" },
    { id: 43803, cityId: 1711, code: "321506" },
    { id: 43804, cityId: 1711, code: "321601" },
    { id: 43805, cityId: 1711, code: "321603" },
    { id: 43806, cityId: 1711, code: "321614" },
    { id: 43807, cityId: 1711, code: "321619" },
    { id: 43808, cityId: 1711, code: "321622" },
    { id: 43809, cityId: 1711, code: "321628" },
    { id: 43810, cityId: 1711, code: "321630" },
    { id: 43811, cityId: 1711, code: "321001" },
    { id: 43812, cityId: 1711, code: "321022" },
    { id: 43813, cityId: 1711, code: "321025" },
    { id: 43814, cityId: 1711, code: "321027" },
    { id: 43815, cityId: 1711, code: "321030" },
    { id: 43816, cityId: 1711, code: "321033" },
    { id: 43817, cityId: 1711, code: "321035" },
    { id: 43818, cityId: 1711, code: "321036" },
    { id: 43819, cityId: 1711, code: "321202" },
    { id: 43820, cityId: 1711, code: "321203" },
    { id: 43821, cityId: 1711, code: "321205" },
    { id: 43822, cityId: 1711, code: "321208" },
    { id: 43823, cityId: 1711, code: "321210" },
    { id: 43824, cityId: 1711, code: "321301" },
    { id: 43825, cityId: 1711, code: "321303" },
    { id: 43826, cityId: 1711, code: "321401" },
    { id: 43827, cityId: 1711, code: "321404" },
    { id: 43828, cityId: 1711, code: "321406" },
    { id: 43829, cityId: 1711, code: "321409" },
    { id: 43830, cityId: 1711, code: "321411" },
    { id: 43831, cityId: 1711, code: "321412" },
    { id: 43832, cityId: 1711, code: "321414" },
    { id: 43833, cityId: 1711, code: "321417" },
    { id: 43834, cityId: 1711, code: "321419" },
    { id: 43835, cityId: 1711, code: "321420" },
    { id: 43836, cityId: 1711, code: "321422" },
    { id: 43837, cityId: 1711, code: "321425" },
    { id: 43838, cityId: 1711, code: "321427" },
    { id: 43839, cityId: 1711, code: "321428" },
    { id: 43840, cityId: 1711, code: "321430" },
    { id: 43841, cityId: 1711, code: "321615" },
    { id: 43842, cityId: 1711, code: "321616" },
    { id: 43843, cityId: 1711, code: "321618" },
    { id: 43844, cityId: 1711, code: "321621" },
    { id: 43845, cityId: 1711, code: "321623" },
    { id: 43846, cityId: 1711, code: "321626" },
    { id: 43847, cityId: 1711, code: "321629" },
    { id: 43848, cityId: 1711, code: "321631" },
    { id: 43849, cityId: 1711, code: "321632" },
    { id: 43850, cityId: 1712, code: "326502" },
    { id: 43851, cityId: 1713, code: "305410" },
    { id: 43852, cityId: 1713, code: "305413" },
    { id: 43853, cityId: 1713, code: "311001" },
    { id: 43854, cityId: 1713, code: "311011" },
    { id: 43855, cityId: 1713, code: "311012" },
    { id: 43856, cityId: 1713, code: "311022" },
    { id: 43857, cityId: 1713, code: "311025" },
    { id: 43858, cityId: 1713, code: "311027" },
    { id: 43859, cityId: 1713, code: "311030" },
    { id: 43860, cityId: 1713, code: "311032" },
    { id: 43861, cityId: 1713, code: "311303" },
    { id: 43862, cityId: 1713, code: "311401" },
    { id: 43863, cityId: 1713, code: "311403" },
    { id: 43864, cityId: 1713, code: "311406" },
    { id: 43865, cityId: 1713, code: "311602" },
    { id: 43866, cityId: 1713, code: "311605" },
    { id: 43867, cityId: 1713, code: "311607" },
    { id: 43868, cityId: 1713, code: "311608" },
    { id: 43869, cityId: 1713, code: "311801" },
    { id: 43870, cityId: 1713, code: "311803" },
    { id: 43871, cityId: 1713, code: "311804" },
    { id: 43872, cityId: 1713, code: "311806" },
    { id: 43873, cityId: 1713, code: "311808" },
    { id: 43874, cityId: 1713, code: "311809" },
    { id: 43875, cityId: 1713, code: "305011" },
    { id: 43876, cityId: 1713, code: "305411" },
    { id: 43877, cityId: 1713, code: "305414" },
    { id: 43878, cityId: 1713, code: "305626" },
    { id: 43879, cityId: 1713, code: "311013" },
    { id: 43880, cityId: 1713, code: "311023" },
    { id: 43881, cityId: 1713, code: "311024" },
    { id: 43882, cityId: 1713, code: "311026" },
    { id: 43883, cityId: 1713, code: "311028" },
    { id: 43884, cityId: 1713, code: "311029" },
    { id: 43885, cityId: 1713, code: "311031" },
    { id: 43886, cityId: 1713, code: "311302" },
    { id: 43887, cityId: 1713, code: "311402" },
    { id: 43888, cityId: 1713, code: "311405" },
    { id: 43889, cityId: 1713, code: "311407" },
    { id: 43890, cityId: 1713, code: "311408" },
    { id: 43891, cityId: 1713, code: "311601" },
    { id: 43892, cityId: 1713, code: "311603" },
    { id: 43893, cityId: 1713, code: "311606" },
    { id: 43894, cityId: 1713, code: "311609" },
    { id: 43895, cityId: 1713, code: "311802" },
    { id: 43896, cityId: 1713, code: "311805" },
    { id: 43897, cityId: 1713, code: "311807" },
    { id: 43898, cityId: 1713, code: "311810" },
    { id: 43899, cityId: 1714, code: "313603" },
    { id: 43900, cityId: 1715, code: "321406" },
    { id: 43901, cityId: 1716, code: "331501" },
    { id: 43902, cityId: 1717, code: "334002" },
    { id: 43903, cityId: 1717, code: "334021" },
    { id: 43904, cityId: 1717, code: "334023" },
    { id: 43905, cityId: 1717, code: "334201" },
    { id: 43906, cityId: 1717, code: "334302" },
    { id: 43907, cityId: 1717, code: "334304" },
    { id: 43908, cityId: 1717, code: "334402" },
    { id: 43909, cityId: 1717, code: "334601" },
    { id: 43910, cityId: 1717, code: "334603" },
    { id: 43911, cityId: 1717, code: "334604" },
    { id: 43912, cityId: 1717, code: "334802" },
    { id: 43913, cityId: 1717, code: "334001" },
    { id: 43914, cityId: 1717, code: "334022" },
    { id: 43915, cityId: 1717, code: "334202" },
    { id: 43916, cityId: 1717, code: "334301" },
    { id: 43917, cityId: 1717, code: "334303" },
    { id: 43918, cityId: 1717, code: "334305" },
    { id: 43919, cityId: 1717, code: "334401" },
    { id: 43920, cityId: 1717, code: "334403" },
    { id: 43921, cityId: 1717, code: "334404" },
    { id: 43922, cityId: 1717, code: "334602" },
    { id: 43923, cityId: 1717, code: "334801" },
    { id: 43924, cityId: 1717, code: "334803" },
    { id: 43925, cityId: 1717, code: "334804" },
    { id: 43926, cityId: 1718, code: "342602" },
    { id: 43927, cityId: 1719, code: "331027" },
    { id: 43928, cityId: 1720, code: "323001" },
    { id: 43929, cityId: 1720, code: "323022" },
    { id: 43930, cityId: 1720, code: "323025" },
    { id: 43931, cityId: 1720, code: "323613" },
    { id: 43932, cityId: 1720, code: "323801" },
    { id: 43933, cityId: 1720, code: "323803" },
    { id: 43934, cityId: 1720, code: "323021" },
    { id: 43935, cityId: 1720, code: "323023" },
    { id: 43936, cityId: 1720, code: "323024" },
    { id: 43937, cityId: 1720, code: "323026" },
    { id: 43938, cityId: 1720, code: "323301" },
    { id: 43939, cityId: 1720, code: "323614" },
    { id: 43940, cityId: 1720, code: "323802" },
    { id: 43941, cityId: 1721, code: "303901" },
    { id: 43942, cityId: 1722, code: "313001" },
    { id: 43943, cityId: 1722, code: "326518" },
    { id: 43944, cityId: 1723, code: "325220" },
    { id: 43945, cityId: 1724, code: "331502" },
    { id: 43946, cityId: 1725, code: "312604" },
    { id: 43947, cityId: 1726, code: "333026" },
    { id: 43948, cityId: 1727, code: "312001" },
    { id: 43949, cityId: 1727, code: "312022" },
    { id: 43950, cityId: 1727, code: "312025" },
    { id: 43951, cityId: 1727, code: "312205" },
    { id: 43952, cityId: 1727, code: "312208" },
    { id: 43953, cityId: 1727, code: "312401" },
    { id: 43954, cityId: 1727, code: "312404" },
    { id: 43955, cityId: 1727, code: "312602" },
    { id: 43956, cityId: 1727, code: "312603" },
    { id: 43957, cityId: 1727, code: "312605" },
    { id: 43958, cityId: 1727, code: "312608" },
    { id: 43959, cityId: 1727, code: "312610" },
    { id: 43960, cityId: 1727, code: "312611" },
    { id: 43961, cityId: 1727, code: "312613" },
    { id: 43962, cityId: 1727, code: "312616" },
    { id: 43963, cityId: 1727, code: "312618" },
    { id: 43964, cityId: 1727, code: "312619" },
    { id: 43965, cityId: 1727, code: "312621" },
    { id: 43966, cityId: 1727, code: "312902" },
    { id: 43967, cityId: 1727, code: "323304" },
    { id: 43968, cityId: 1727, code: "323306" },
    { id: 43969, cityId: 1727, code: "312021" },
    { id: 43970, cityId: 1727, code: "312024" },
    { id: 43971, cityId: 1727, code: "312026" },
    { id: 43972, cityId: 1727, code: "312201" },
    { id: 43973, cityId: 1727, code: "312204" },
    { id: 43974, cityId: 1727, code: "312206" },
    { id: 43975, cityId: 1727, code: "312207" },
    { id: 43976, cityId: 1727, code: "312402" },
    { id: 43977, cityId: 1727, code: "312606" },
    { id: 43978, cityId: 1727, code: "312607" },
    { id: 43979, cityId: 1727, code: "312609" },
    { id: 43980, cityId: 1727, code: "312612" },
    { id: 43981, cityId: 1727, code: "312614" },
    { id: 43982, cityId: 1727, code: "312615" },
    { id: 43983, cityId: 1727, code: "312901" },
    { id: 43984, cityId: 1727, code: "323303" },
    { id: 43985, cityId: 1727, code: "323305" },
    { id: 43986, cityId: 1728, code: "303702" },
    { id: 43987, cityId: 1729, code: "331001" },
    { id: 43988, cityId: 1729, code: "331020" },
    { id: 43989, cityId: 1729, code: "331023" },
    { id: 43990, cityId: 1729, code: "331031" },
    { id: 43991, cityId: 1729, code: "331301" },
    { id: 43992, cityId: 1729, code: "331303" },
    { id: 43993, cityId: 1729, code: "331306" },
    { id: 43994, cityId: 1729, code: "331402" },
    { id: 43995, cityId: 1729, code: "331505" },
    { id: 43996, cityId: 1729, code: "331507" },
    { id: 43997, cityId: 1729, code: "331508" },
    { id: 43998, cityId: 1729, code: "331510" },
    { id: 43999, cityId: 1729, code: "331518" },
    { id: 44000, cityId: 1729, code: "331701" },
    { id: 44001, cityId: 1729, code: "331801" },
    { id: 44002, cityId: 1729, code: "331804" },
    { id: 44003, cityId: 1729, code: "331022" },
    { id: 44004, cityId: 1729, code: "331029" },
    { id: 44005, cityId: 1729, code: "331032" },
    { id: 44006, cityId: 1729, code: "331034" },
    { id: 44007, cityId: 1729, code: "331035" },
    { id: 44008, cityId: 1729, code: "331302" },
    { id: 44009, cityId: 1729, code: "331305" },
    { id: 44010, cityId: 1729, code: "331307" },
    { id: 44011, cityId: 1729, code: "331403" },
    { id: 44012, cityId: 1729, code: "331411" },
    { id: 44013, cityId: 1729, code: "331503" },
    { id: 44014, cityId: 1729, code: "331504" },
    { id: 44015, cityId: 1729, code: "331509" },
    { id: 44016, cityId: 1729, code: "331517" },
    { id: 44017, cityId: 1729, code: "331803" },
    { id: 44018, cityId: 1729, code: "331805" },
    { id: 44019, cityId: 1729, code: "331811" },
    { id: 44020, cityId: 1730, code: "303304" },
    { id: 44021, cityId: 1730, code: "303310" },
    { id: 44022, cityId: 1730, code: "321620" },
    { id: 44023, cityId: 1730, code: "321633" },
    { id: 44024, cityId: 1730, code: "303327" },
    { id: 44025, cityId: 1730, code: "321617" },
    { id: 44026, cityId: 1730, code: "321625" },
    { id: 44027, cityId: 1731, code: "321203" },
    { id: 44028, cityId: 1732, code: "304804" },
    { id: 44029, cityId: 1732, code: "442101" },
    { id: 44030, cityId: 1733, code: "313605" },
    { id: 44031, cityId: 1734, code: "328001" },
    { id: 44032, cityId: 1734, code: "328022" },
    { id: 44033, cityId: 1734, code: "328027" },
    { id: 44034, cityId: 1734, code: "328028" },
    { id: 44035, cityId: 1734, code: "328030" },
    { id: 44036, cityId: 1734, code: "328033" },
    { id: 44037, cityId: 1734, code: "328035" },
    { id: 44038, cityId: 1734, code: "328036" },
    { id: 44039, cityId: 1734, code: "328038" },
    { id: 44040, cityId: 1734, code: "328041" },
    { id: 44041, cityId: 1734, code: "328021" },
    { id: 44042, cityId: 1734, code: "328023" },
    { id: 44043, cityId: 1734, code: "328024" },
    { id: 44044, cityId: 1734, code: "328026" },
    { id: 44045, cityId: 1734, code: "328029" },
    { id: 44046, cityId: 1734, code: "328031" },
    { id: 44047, cityId: 1734, code: "328032" },
    { id: 44048, cityId: 1734, code: "328037" },
    { id: 44049, cityId: 1734, code: "328039" },
    { id: 44050, cityId: 1734, code: "328040" },
    { id: 44051, cityId: 1735, code: "303511" },
    { id: 44052, cityId: 1735, code: "341303" },
    { id: 44053, cityId: 1736, code: "314011" },
    { id: 44054, cityId: 1736, code: "314013" },
    { id: 44055, cityId: 1736, code: "314021" },
    { id: 44056, cityId: 1736, code: "314024" },
    { id: 44057, cityId: 1736, code: "314029" },
    { id: 44058, cityId: 1736, code: "314031" },
    { id: 44059, cityId: 1736, code: "314032" },
    { id: 44060, cityId: 1736, code: "314034" },
    { id: 44061, cityId: 1736, code: "314037" },
    { id: 44062, cityId: 1736, code: "314402" },
    { id: 44063, cityId: 1736, code: "314403" },
    { id: 44064, cityId: 1736, code: "314405" },
    { id: 44065, cityId: 1736, code: "314802" },
    { id: 44066, cityId: 1736, code: "314803" },
    { id: 44067, cityId: 1736, code: "314001" },
    { id: 44068, cityId: 1736, code: "314012" },
    { id: 44069, cityId: 1736, code: "314022" },
    { id: 44070, cityId: 1736, code: "314023" },
    { id: 44071, cityId: 1736, code: "314025" },
    { id: 44072, cityId: 1736, code: "314027" },
    { id: 44073, cityId: 1736, code: "314028" },
    { id: 44074, cityId: 1736, code: "314030" },
    { id: 44075, cityId: 1736, code: "314033" },
    { id: 44076, cityId: 1736, code: "314035" },
    { id: 44077, cityId: 1736, code: "314036" },
    { id: 44078, cityId: 1736, code: "314038" },
    { id: 44079, cityId: 1736, code: "314401" },
    { id: 44080, cityId: 1736, code: "314404" },
    { id: 44081, cityId: 1736, code: "314406" },
    { id: 44082, cityId: 1736, code: "314407" },
    { id: 44083, cityId: 1736, code: "314801" },
    { id: 44084, cityId: 1736, code: "314804" },
    { id: 44085, cityId: 1737, code: "335024" },
    { id: 44086, cityId: 1738, code: "314026" },
    { id: 44087, cityId: 1739, code: "335021" },
    { id: 44088, cityId: 1739, code: "335026" },
    { id: 44089, cityId: 1739, code: "335027" },
    { id: 44090, cityId: 1739, code: "335037" },
    { id: 44091, cityId: 1739, code: "335040" },
    { id: 44092, cityId: 1739, code: "335042" },
    { id: 44093, cityId: 1739, code: "335043" },
    { id: 44094, cityId: 1739, code: "335061" },
    { id: 44095, cityId: 1739, code: "335064" },
    { id: 44096, cityId: 1739, code: "335074" },
    { id: 44097, cityId: 1739, code: "335501" },
    { id: 44098, cityId: 1739, code: "335503" },
    { id: 44099, cityId: 1739, code: "335511" },
    { id: 44100, cityId: 1739, code: "335514" },
    { id: 44101, cityId: 1739, code: "335524" },
    { id: 44102, cityId: 1739, code: "335525" },
    { id: 44103, cityId: 1739, code: "335527" },
    { id: 44104, cityId: 1739, code: "335702" },
    { id: 44105, cityId: 1739, code: "335704" },
    { id: 44106, cityId: 1739, code: "335705" },
    { id: 44107, cityId: 1739, code: "335707" },
    { id: 44108, cityId: 1739, code: "335710" },
    { id: 44109, cityId: 1739, code: "335802" },
    { id: 44110, cityId: 1739, code: "335805" },
    { id: 44111, cityId: 1739, code: "335901" },
    { id: 44112, cityId: 1739, code: "335001" },
    { id: 44113, cityId: 1739, code: "335022" },
    { id: 44114, cityId: 1739, code: "335023" },
    { id: 44115, cityId: 1739, code: "335025" },
    { id: 44116, cityId: 1739, code: "335038" },
    { id: 44117, cityId: 1739, code: "335039" },
    { id: 44118, cityId: 1739, code: "335065" },
    { id: 44119, cityId: 1739, code: "335073" },
    { id: 44120, cityId: 1739, code: "335502" },
    { id: 44121, cityId: 1739, code: "335504" },
    { id: 44122, cityId: 1739, code: "335512" },
    { id: 44123, cityId: 1739, code: "335513" },
    { id: 44124, cityId: 1739, code: "335515" },
    { id: 44125, cityId: 1739, code: "335526" },
    { id: 44126, cityId: 1739, code: "335528" },
    { id: 44127, cityId: 1739, code: "335703" },
    { id: 44128, cityId: 1739, code: "335706" },
    { id: 44129, cityId: 1739, code: "335708" },
    { id: 44130, cityId: 1739, code: "335801" },
    { id: 44131, cityId: 1739, code: "335804" },
    { id: 44132, cityId: 1739, code: "335806" },
    { id: 44133, cityId: 1739, code: "335807" },
    { id: 44134, cityId: 1739, code: "335902" },
    { id: 44135, cityId: 1740, code: "311021" },
    { id: 44136, cityId: 1740, code: "321031" },
    { id: 44137, cityId: 1741, code: "335523" },
    { id: 44138, cityId: 1741, code: "335063" },
    { id: 44139, cityId: 1741, code: "344703" },
    { id: 44140, cityId: 1742, code: "322230" },
    { id: 44141, cityId: 1743, code: "305409" },
    { id: 44142, cityId: 1744, code: "302002" },
    { id: 44143, cityId: 1744, code: "302004" },
    { id: 44144, cityId: 1744, code: "302005" },
    { id: 44145, cityId: 1744, code: "302007" },
    { id: 44146, cityId: 1744, code: "302010" },
    { id: 44147, cityId: 1744, code: "302012" },
    { id: 44148, cityId: 1744, code: "302013" },
    { id: 44149, cityId: 1744, code: "302015" },
    { id: 44150, cityId: 1744, code: "303001" },
    { id: 44151, cityId: 1744, code: "303003" },
    { id: 44152, cityId: 1744, code: "303006" },
    { id: 44153, cityId: 1744, code: "303008" },
    { id: 44154, cityId: 1744, code: "303009" },
    { id: 44155, cityId: 1744, code: "303011" },
    { id: 44156, cityId: 1744, code: "303101" },
    { id: 44157, cityId: 1744, code: "303104" },
    { id: 44158, cityId: 1744, code: "303106" },
    { id: 44159, cityId: 1744, code: "303109" },
    { id: 44160, cityId: 1744, code: "303111" },
    { id: 44161, cityId: 1744, code: "303112" },
    { id: 44162, cityId: 1744, code: "303114" },
    { id: 44163, cityId: 1744, code: "303117" },
    { id: 44164, cityId: 1744, code: "303119" },
    { id: 44165, cityId: 1744, code: "303120" },
    { id: 44166, cityId: 1744, code: "303209" },
    { id: 44167, cityId: 1744, code: "303302" },
    { id: 44168, cityId: 1744, code: "303305" },
    { id: 44169, cityId: 1744, code: "303307" },
    { id: 44170, cityId: 1744, code: "303308" },
    { id: 44171, cityId: 1744, code: "303315" },
    { id: 44172, cityId: 1744, code: "303323" },
    { id: 44173, cityId: 1744, code: "303324" },
    { id: 44174, cityId: 1744, code: "303326" },
    { id: 44175, cityId: 1744, code: "303329" },
    { id: 44176, cityId: 1744, code: "303331" },
    { id: 44177, cityId: 1744, code: "303339" },
    { id: 44178, cityId: 1744, code: "303340" },
    { id: 44179, cityId: 1744, code: "303348" },
    { id: 44180, cityId: 1744, code: "303501" },
    { id: 44181, cityId: 1744, code: "303504" },
    { id: 44182, cityId: 1744, code: "303506" },
    { id: 44183, cityId: 1744, code: "303509" },
    { id: 44184, cityId: 1744, code: "303601" },
    { id: 44185, cityId: 1744, code: "303602" },
    { id: 44186, cityId: 1744, code: "303604" },
    { id: 44187, cityId: 1744, code: "303607" },
    { id: 44188, cityId: 1744, code: "303609" },
    { id: 44189, cityId: 1744, code: "303702" },
    { id: 44190, cityId: 1744, code: "303803" },
    { id: 44191, cityId: 1744, code: "303805" },
    { id: 44192, cityId: 1744, code: "303806" },
    { id: 44193, cityId: 1744, code: "303903" },
    { id: 44194, cityId: 1744, code: "303904" },
    { id: 44195, cityId: 1744, code: "303906" },
    { id: 44196, cityId: 1744, code: "302001" },
    { id: 44197, cityId: 1744, code: "302003" },
    { id: 44198, cityId: 1744, code: "302006" },
    { id: 44199, cityId: 1744, code: "302008" },
    { id: 44200, cityId: 1744, code: "302009" },
    { id: 44201, cityId: 1744, code: "302011" },
    { id: 44202, cityId: 1744, code: "302014" },
    { id: 44203, cityId: 1744, code: "302016" },
    { id: 44204, cityId: 1744, code: "302017" },
    { id: 44205, cityId: 1744, code: "303002" },
    { id: 44206, cityId: 1744, code: "303004" },
    { id: 44207, cityId: 1744, code: "303005" },
    { id: 44208, cityId: 1744, code: "303010" },
    { id: 44209, cityId: 1744, code: "303012" },
    { id: 44210, cityId: 1744, code: "303102" },
    { id: 44211, cityId: 1744, code: "303103" },
    { id: 44212, cityId: 1744, code: "303105" },
    { id: 44213, cityId: 1744, code: "303107" },
    { id: 44214, cityId: 1744, code: "303110" },
    { id: 44215, cityId: 1744, code: "303113" },
    { id: 44216, cityId: 1744, code: "303115" },
    { id: 44217, cityId: 1744, code: "303116" },
    { id: 44218, cityId: 1744, code: "303118" },
    { id: 44219, cityId: 1744, code: "303301" },
    { id: 44220, cityId: 1744, code: "303303" },
    { id: 44221, cityId: 1744, code: "303306" },
    { id: 44222, cityId: 1744, code: "303309" },
    { id: 44223, cityId: 1744, code: "303314" },
    { id: 44224, cityId: 1744, code: "303325" },
    { id: 44225, cityId: 1744, code: "303330" },
    { id: 44226, cityId: 1744, code: "303338" },
    { id: 44227, cityId: 1744, code: "303349" },
    { id: 44228, cityId: 1744, code: "303502" },
    { id: 44229, cityId: 1744, code: "303505" },
    { id: 44230, cityId: 1744, code: "303507" },
    { id: 44231, cityId: 1744, code: "303508" },
    { id: 44232, cityId: 1744, code: "303510" },
    { id: 44233, cityId: 1744, code: "303603" },
    { id: 44234, cityId: 1744, code: "303606" },
    { id: 44235, cityId: 1744, code: "303608" },
    { id: 44236, cityId: 1744, code: "303611" },
    { id: 44237, cityId: 1744, code: "303701" },
    { id: 44238, cityId: 1744, code: "303703" },
    { id: 44239, cityId: 1744, code: "303704" },
    { id: 44240, cityId: 1744, code: "303712" },
    { id: 44241, cityId: 1744, code: "303801" },
    { id: 44242, cityId: 1744, code: "303802" },
    { id: 44243, cityId: 1744, code: "303804" },
    { id: 44244, cityId: 1744, code: "303807" },
    { id: 44245, cityId: 1744, code: "303902" },
    { id: 44246, cityId: 1744, code: "303905" },
    { id: 44247, cityId: 1744, code: "303907" },
    { id: 44248, cityId: 1745, code: "345021" },
    { id: 44249, cityId: 1745, code: "345022" },
    { id: 44250, cityId: 1745, code: "345024" },
    { id: 44251, cityId: 1745, code: "345027" },
    { id: 44252, cityId: 1745, code: "345029" },
    { id: 44253, cityId: 1745, code: "345030" },
    { id: 44254, cityId: 1745, code: "345032" },
    { id: 44255, cityId: 1745, code: "345001" },
    { id: 44256, cityId: 1745, code: "345002" },
    { id: 44257, cityId: 1745, code: "345023" },
    { id: 44258, cityId: 1745, code: "345025" },
    { id: 44259, cityId: 1745, code: "345026" },
    { id: 44260, cityId: 1745, code: "345028" },
    { id: 44261, cityId: 1745, code: "345031" },
    { id: 44262, cityId: 1746, code: "306913" },
    { id: 44263, cityId: 1746, code: "307029" },
    { id: 44264, cityId: 1746, code: "307030" },
    { id: 44265, cityId: 1746, code: "307032" },
    { id: 44266, cityId: 1746, code: "307035" },
    { id: 44267, cityId: 1746, code: "307037" },
    { id: 44268, cityId: 1746, code: "307038" },
    { id: 44269, cityId: 1746, code: "307040" },
    { id: 44270, cityId: 1746, code: "307803" },
    { id: 44271, cityId: 1746, code: "343001" },
    { id: 44272, cityId: 1746, code: "343011" },
    { id: 44273, cityId: 1746, code: "343022" },
    { id: 44274, cityId: 1746, code: "343025" },
    { id: 44275, cityId: 1746, code: "343027" },
    { id: 44276, cityId: 1746, code: "343028" },
    { id: 44277, cityId: 1746, code: "343030" },
    { id: 44278, cityId: 1746, code: "343033" },
    { id: 44279, cityId: 1746, code: "343040" },
    { id: 44280, cityId: 1746, code: "343046" },
    { id: 44281, cityId: 1746, code: "343048" },
    { id: 44282, cityId: 1746, code: "307031" },
    { id: 44283, cityId: 1746, code: "307033" },
    { id: 44284, cityId: 1746, code: "307034" },
    { id: 44285, cityId: 1746, code: "307036" },
    { id: 44286, cityId: 1746, code: "307039" },
    { id: 44287, cityId: 1746, code: "307041" },
    { id: 44288, cityId: 1746, code: "307042" },
    { id: 44289, cityId: 1746, code: "343021" },
    { id: 44290, cityId: 1746, code: "343023" },
    { id: 44291, cityId: 1746, code: "343024" },
    { id: 44292, cityId: 1746, code: "343026" },
    { id: 44293, cityId: 1746, code: "343029" },
    { id: 44294, cityId: 1746, code: "343031" },
    { id: 44295, cityId: 1746, code: "343032" },
    { id: 44296, cityId: 1746, code: "343034" },
    { id: 44297, cityId: 1746, code: "343039" },
    { id: 44298, cityId: 1746, code: "343042" },
    { id: 44299, cityId: 1746, code: "343045" },
    { id: 44300, cityId: 1746, code: "343047" },
    { id: 44301, cityId: 1747, code: "326021" },
    { id: 44302, cityId: 1747, code: "326024" },
    { id: 44303, cityId: 1747, code: "326035" },
    { id: 44304, cityId: 1747, code: "326040" },
    { id: 44305, cityId: 1747, code: "326501" },
    { id: 44306, cityId: 1747, code: "326503" },
    { id: 44307, cityId: 1747, code: "326514" },
    { id: 44308, cityId: 1747, code: "326516" },
    { id: 44309, cityId: 1747, code: "326001" },
    { id: 44310, cityId: 1747, code: "326023" },
    { id: 44311, cityId: 1747, code: "326036" },
    { id: 44312, cityId: 1747, code: "326039" },
    { id: 44313, cityId: 1747, code: "326041" },
    { id: 44314, cityId: 1747, code: "326512" },
    { id: 44315, cityId: 1747, code: "326513" },
    { id: 44316, cityId: 1747, code: "326515" },
    { id: 44317, cityId: 1748, code: "331028" },
    { id: 44318, cityId: 1748, code: "331030" },
    { id: 44319, cityId: 1748, code: "332717" },
    { id: 44320, cityId: 1748, code: "333001" },
    { id: 44321, cityId: 1748, code: "333011" },
    { id: 44322, cityId: 1748, code: "333014" },
    { id: 44323, cityId: 1748, code: "333016" },
    { id: 44324, cityId: 1748, code: "333022" },
    { id: 44325, cityId: 1748, code: "333024" },
    { id: 44326, cityId: 1748, code: "333025" },
    { id: 44327, cityId: 1748, code: "333027" },
    { id: 44328, cityId: 1748, code: "333030" },
    { id: 44329, cityId: 1748, code: "333032" },
    { id: 44330, cityId: 1748, code: "333033" },
    { id: 44331, cityId: 1748, code: "333035" },
    { id: 44332, cityId: 1748, code: "333038" },
    { id: 44333, cityId: 1748, code: "333040" },
    { id: 44334, cityId: 1748, code: "333041" },
    { id: 44335, cityId: 1748, code: "333043" },
    { id: 44336, cityId: 1748, code: "333046" },
    { id: 44337, cityId: 1748, code: "333048" },
    { id: 44338, cityId: 1748, code: "333053" },
    { id: 44339, cityId: 1748, code: "333302" },
    { id: 44340, cityId: 1748, code: "333303" },
    { id: 44341, cityId: 1748, code: "333305" },
    { id: 44342, cityId: 1748, code: "333308" },
    { id: 44343, cityId: 1748, code: "333310" },
    { id: 44344, cityId: 1748, code: "333311" },
    { id: 44345, cityId: 1748, code: "333313" },
    { id: 44346, cityId: 1748, code: "333501" },
    { id: 44347, cityId: 1748, code: "333504" },
    { id: 44348, cityId: 1748, code: "333514" },
    { id: 44349, cityId: 1748, code: "333515" },
    { id: 44350, cityId: 1748, code: "333517" },
    { id: 44351, cityId: 1748, code: "333702" },
    { id: 44352, cityId: 1748, code: "333703" },
    { id: 44353, cityId: 1748, code: "333705" },
    { id: 44354, cityId: 1748, code: "331026" },
    { id: 44355, cityId: 1748, code: "332716" },
    { id: 44356, cityId: 1748, code: "333012" },
    { id: 44357, cityId: 1748, code: "333015" },
    { id: 44358, cityId: 1748, code: "333021" },
    { id: 44359, cityId: 1748, code: "333023" },
    { id: 44360, cityId: 1748, code: "333026" },
    { id: 44361, cityId: 1748, code: "333028" },
    { id: 44362, cityId: 1748, code: "333029" },
    { id: 44363, cityId: 1748, code: "333031" },
    { id: 44364, cityId: 1748, code: "333034" },
    { id: 44365, cityId: 1748, code: "333036" },
    { id: 44366, cityId: 1748, code: "333037" },
    { id: 44367, cityId: 1748, code: "333039" },
    { id: 44368, cityId: 1748, code: "333042" },
    { id: 44369, cityId: 1748, code: "333044" },
    { id: 44370, cityId: 1748, code: "333045" },
    { id: 44371, cityId: 1748, code: "333047" },
    { id: 44372, cityId: 1748, code: "333052" },
    { id: 44373, cityId: 1748, code: "333301" },
    { id: 44374, cityId: 1748, code: "333304" },
    { id: 44375, cityId: 1748, code: "333306" },
    { id: 44376, cityId: 1748, code: "333309" },
    { id: 44377, cityId: 1748, code: "333312" },
    { id: 44378, cityId: 1748, code: "333314" },
    { id: 44379, cityId: 1748, code: "333315" },
    { id: 44380, cityId: 1748, code: "333502" },
    { id: 44381, cityId: 1748, code: "333503" },
    { id: 44382, cityId: 1748, code: "333516" },
    { id: 44383, cityId: 1748, code: "333701" },
    { id: 44384, cityId: 1748, code: "333706" },
    { id: 44385, cityId: 1748, code: "333707" },
    { id: 44386, cityId: 1748, code: "333709" },
    { id: 44387, cityId: 1749, code: "303328" },
    { id: 44388, cityId: 1750, code: "342002" },
    { id: 44389, cityId: 1750, code: "342003" },
    { id: 44390, cityId: 1750, code: "342005" },
    { id: 44391, cityId: 1750, code: "342008" },
    { id: 44392, cityId: 1750, code: "342021" },
    { id: 44393, cityId: 1750, code: "342023" },
    { id: 44394, cityId: 1750, code: "342024" },
    { id: 44395, cityId: 1750, code: "342026" },
    { id: 44396, cityId: 1750, code: "342029" },
    { id: 44397, cityId: 1750, code: "342031" },
    { id: 44398, cityId: 1750, code: "342032" },
    { id: 44399, cityId: 1750, code: "342034" },
    { id: 44400, cityId: 1750, code: "342037" },
    { id: 44401, cityId: 1750, code: "342302" },
    { id: 44402, cityId: 1750, code: "342307" },
    { id: 44403, cityId: 1750, code: "342309" },
    { id: 44404, cityId: 1750, code: "342310" },
    { id: 44405, cityId: 1750, code: "342312" },
    { id: 44406, cityId: 1750, code: "342601" },
    { id: 44407, cityId: 1750, code: "342603" },
    { id: 44408, cityId: 1750, code: "342604" },
    { id: 44409, cityId: 1750, code: "342606" },
    { id: 44410, cityId: 1750, code: "342609" },
    { id: 44411, cityId: 1750, code: "342611" },
    { id: 44412, cityId: 1750, code: "342612" },
    { id: 44413, cityId: 1750, code: "342802" },
    { id: 44414, cityId: 1750, code: "342001" },
    { id: 44415, cityId: 1750, code: "342004" },
    { id: 44416, cityId: 1750, code: "342006" },
    { id: 44417, cityId: 1750, code: "342007" },
    { id: 44418, cityId: 1750, code: "342022" },
    { id: 44419, cityId: 1750, code: "342025" },
    { id: 44420, cityId: 1750, code: "342027" },
    { id: 44421, cityId: 1750, code: "342028" },
    { id: 44422, cityId: 1750, code: "342030" },
    { id: 44423, cityId: 1750, code: "342033" },
    { id: 44424, cityId: 1750, code: "342303" },
    { id: 44425, cityId: 1750, code: "342305" },
    { id: 44426, cityId: 1750, code: "342306" },
    { id: 44427, cityId: 1750, code: "342308" },
    { id: 44428, cityId: 1750, code: "342311" },
    { id: 44429, cityId: 1750, code: "342314" },
    { id: 44430, cityId: 1750, code: "342602" },
    { id: 44431, cityId: 1750, code: "342605" },
    { id: 44432, cityId: 1750, code: "342607" },
    { id: 44433, cityId: 1750, code: "342608" },
    { id: 44434, cityId: 1750, code: "342801" },
    { id: 44435, cityId: 1750, code: "342803" },
    { id: 44436, cityId: 1750, code: "342804" },
    { id: 44437, cityId: 1750, code: "342901" },
    { id: 44438, cityId: 1751, code: "321022" },
    { id: 44439, cityId: 1752, code: "312202" },
    { id: 44440, cityId: 1753, code: "322244" },
    { id: 44441, cityId: 1754, code: "303341" },
    { id: 44442, cityId: 1754, code: "312617" },
    { id: 44443, cityId: 1754, code: "322232" },
    { id: 44444, cityId: 1754, code: "322243" },
    { id: 44445, cityId: 1754, code: "321206" },
    { id: 44446, cityId: 1754, code: "322204" },
    { id: 44447, cityId: 1754, code: "322215" },
    { id: 44448, cityId: 1754, code: "322218" },
    { id: 44449, cityId: 1754, code: "322231" },
    { id: 44450, cityId: 1754, code: "322236" },
    { id: 44451, cityId: 1754, code: "322252" },
    { id: 44452, cityId: 1754, code: "322254" },
    { id: 44453, cityId: 1754, code: "322255" },
    { id: 44454, cityId: 1754, code: "332724" },
    { id: 44455, cityId: 1755, code: "305404" },
    { id: 44456, cityId: 1756, code: "323602" },
    { id: 44457, cityId: 1756, code: "323601" },
    { id: 44458, cityId: 1757, code: "301404" },
    { id: 44459, cityId: 1758, code: "332709" },
    { id: 44460, cityId: 1759, code: "321028" },
    { id: 44461, cityId: 1759, code: "321606" },
    { id: 44462, cityId: 1760, code: "333503" },
    { id: 44463, cityId: 1761, code: "301405" },
    { id: 44464, cityId: 1761, code: "305802" },
    { id: 44465, cityId: 1762, code: "303603" },
    { id: 44466, cityId: 1763, code: "324003" },
    { id: 44467, cityId: 1763, code: "324005" },
    { id: 44468, cityId: 1763, code: "324006" },
    { id: 44469, cityId: 1763, code: "324008" },
    { id: 44470, cityId: 1763, code: "325001" },
    { id: 44471, cityId: 1763, code: "325004" },
    { id: 44472, cityId: 1763, code: "325006" },
    { id: 44473, cityId: 1763, code: "325007" },
    { id: 44474, cityId: 1763, code: "325009" },
    { id: 44475, cityId: 1763, code: "325202" },
    { id: 44476, cityId: 1763, code: "325203" },
    { id: 44477, cityId: 1763, code: "325205" },
    { id: 44478, cityId: 1763, code: "325208" },
    { id: 44479, cityId: 1763, code: "325216" },
    { id: 44480, cityId: 1763, code: "325218" },
    { id: 44481, cityId: 1763, code: "325219" },
    { id: 44482, cityId: 1763, code: "325221" },
    { id: 44483, cityId: 1763, code: "325224" },
    { id: 44484, cityId: 1763, code: "325226" },
    { id: 44485, cityId: 1763, code: "325227" },
    { id: 44486, cityId: 1763, code: "325602" },
    { id: 44487, cityId: 1763, code: "326519" },
    { id: 44488, cityId: 1763, code: "326521" },
    { id: 44489, cityId: 1763, code: "326529" },
    { id: 44490, cityId: 1763, code: "324001" },
    { id: 44491, cityId: 1763, code: "324002" },
    { id: 44492, cityId: 1763, code: "324004" },
    { id: 44493, cityId: 1763, code: "324007" },
    { id: 44494, cityId: 1763, code: "324009" },
    { id: 44495, cityId: 1763, code: "325003" },
    { id: 44496, cityId: 1763, code: "325201" },
    { id: 44497, cityId: 1763, code: "325204" },
    { id: 44498, cityId: 1763, code: "325206" },
    { id: 44499, cityId: 1763, code: "325207" },
    { id: 44500, cityId: 1763, code: "325214" },
    { id: 44501, cityId: 1763, code: "325220" },
    { id: 44502, cityId: 1763, code: "325223" },
    { id: 44503, cityId: 1763, code: "325225" },
    { id: 44504, cityId: 1763, code: "326038" },
    { id: 44505, cityId: 1763, code: "326517" },
    { id: 44506, cityId: 1763, code: "326520" },
    { id: 44507, cityId: 1764, code: "303108" },
    { id: 44508, cityId: 1765, code: "341024" },
    { id: 44509, cityId: 1766, code: "321201" },
    { id: 44510, cityId: 1767, code: "327801" },
    { id: 44511, cityId: 1768, code: "323615" },
    { id: 44512, cityId: 1768, code: "323603" },
    { id: 44513, cityId: 1769, code: "303503" },
    { id: 44514, cityId: 1770, code: "332025" },
    { id: 44515, cityId: 1771, code: "322202" },
    { id: 44516, cityId: 1772, code: "321608" },
    { id: 44517, cityId: 1772, code: "321609" },
    { id: 44518, cityId: 1773, code: "341505" },
    { id: 44519, cityId: 1774, code: "304502" },
    { id: 44520, cityId: 1775, code: "311604" },
    { id: 44521, cityId: 1776, code: "333704" },
    { id: 44522, cityId: 1777, code: "326037" },
    { id: 44523, cityId: 1778, code: "341510" },
    { id: 44524, cityId: 1778, code: "341511" },
    { id: 44525, cityId: 1779, code: "333705" },
    { id: 44526, cityId: 1780, code: "321602" },
    { id: 44527, cityId: 1781, code: "341002" },
    { id: 44528, cityId: 1781, code: "341012" },
    { id: 44529, cityId: 1781, code: "341013" },
    { id: 44530, cityId: 1781, code: "341021" },
    { id: 44531, cityId: 1781, code: "341023" },
    { id: 44532, cityId: 1781, code: "341026" },
    { id: 44533, cityId: 1781, code: "341028" },
    { id: 44534, cityId: 1781, code: "341029" },
    { id: 44535, cityId: 1781, code: "341031" },
    { id: 44536, cityId: 1781, code: "341034" },
    { id: 44537, cityId: 1781, code: "341301" },
    { id: 44538, cityId: 1781, code: "341304" },
    { id: 44539, cityId: 1781, code: "341306" },
    { id: 44540, cityId: 1781, code: "341317" },
    { id: 44541, cityId: 1781, code: "341502" },
    { id: 44542, cityId: 1781, code: "341503" },
    { id: 44543, cityId: 1781, code: "341508" },
    { id: 44544, cityId: 1781, code: "341513" },
    { id: 44545, cityId: 1781, code: "341516" },
    { id: 44546, cityId: 1781, code: "341518" },
    { id: 44547, cityId: 1781, code: "341519" },
    { id: 44548, cityId: 1781, code: "341521" },
    { id: 44549, cityId: 1781, code: "341524" },
    { id: 44550, cityId: 1781, code: "341526" },
    { id: 44551, cityId: 1781, code: "341527" },
    { id: 44552, cityId: 1781, code: "341529" },
    { id: 44553, cityId: 1781, code: "341532" },
    { id: 44554, cityId: 1781, code: "341534" },
    { id: 44555, cityId: 1781, code: "341535" },
    { id: 44556, cityId: 1781, code: "341537" },
    { id: 44557, cityId: 1781, code: "341540" },
    { id: 44558, cityId: 1781, code: "341542" },
    { id: 44559, cityId: 1781, code: "341545" },
    { id: 44560, cityId: 1781, code: "341547" },
    { id: 44561, cityId: 1781, code: "341548" },
    { id: 44562, cityId: 1781, code: "341550" },
    { id: 44563, cityId: 1781, code: "303610" },
    { id: 44564, cityId: 1781, code: "305026" },
    { id: 44565, cityId: 1781, code: "341001" },
    { id: 44566, cityId: 1781, code: "341011" },
    { id: 44567, cityId: 1781, code: "341022" },
    { id: 44568, cityId: 1781, code: "341025" },
    { id: 44569, cityId: 1781, code: "341027" },
    { id: 44570, cityId: 1781, code: "341030" },
    { id: 44571, cityId: 1781, code: "341032" },
    { id: 44572, cityId: 1781, code: "341033" },
    { id: 44573, cityId: 1781, code: "341035" },
    { id: 44574, cityId: 1781, code: "341302" },
    { id: 44575, cityId: 1781, code: "341305" },
    { id: 44576, cityId: 1781, code: "341313" },
    { id: 44577, cityId: 1781, code: "341316" },
    { id: 44578, cityId: 1781, code: "341318" },
    { id: 44579, cityId: 1781, code: "341319" },
    { id: 44580, cityId: 1781, code: "341501" },
    { id: 44581, cityId: 1781, code: "341504" },
    { id: 44582, cityId: 1781, code: "341506" },
    { id: 44583, cityId: 1781, code: "341507" },
    { id: 44584, cityId: 1781, code: "341509" },
    { id: 44585, cityId: 1781, code: "341512" },
    { id: 44586, cityId: 1781, code: "341514" },
    { id: 44587, cityId: 1781, code: "341515" },
    { id: 44588, cityId: 1781, code: "341517" },
    { id: 44589, cityId: 1781, code: "341520" },
    { id: 44590, cityId: 1781, code: "341522" },
    { id: 44591, cityId: 1781, code: "341523" },
    { id: 44592, cityId: 1781, code: "341525" },
    { id: 44593, cityId: 1781, code: "341528" },
    { id: 44594, cityId: 1781, code: "341530" },
    { id: 44595, cityId: 1781, code: "341531" },
    { id: 44596, cityId: 1781, code: "341533" },
    { id: 44597, cityId: 1781, code: "341536" },
    { id: 44598, cityId: 1781, code: "341538" },
    { id: 44599, cityId: 1781, code: "341539" },
    { id: 44600, cityId: 1781, code: "341541" },
    { id: 44601, cityId: 1781, code: "341544" },
    { id: 44602, cityId: 1781, code: "341546" },
    { id: 44603, cityId: 1781, code: "341549" },
    { id: 44604, cityId: 1781, code: "342902" },
    { id: 44605, cityId: 1782, code: "305601" },
    { id: 44606, cityId: 1783, code: "313301" },
    { id: 44607, cityId: 1784, code: "333042" },
    { id: 44608, cityId: 1785, code: "312601" },
    { id: 44609, cityId: 1786, code: "335523" },
    { id: 44610, cityId: 1787, code: "334803" },
    { id: 44611, cityId: 1788, code: "335041" },
    { id: 44612, cityId: 1789, code: "241123" },
    { id: 44613, cityId: 1789, code: "306021" },
    { id: 44614, cityId: 1789, code: "306024" },
    { id: 44615, cityId: 1789, code: "306026" },
    { id: 44616, cityId: 1789, code: "306027" },
    { id: 44617, cityId: 1789, code: "306101" },
    { id: 44618, cityId: 1789, code: "306103" },
    { id: 44619, cityId: 1789, code: "306106" },
    { id: 44620, cityId: 1789, code: "306108" },
    { id: 44621, cityId: 1789, code: "306114" },
    { id: 44622, cityId: 1789, code: "306116" },
    { id: 44623, cityId: 1789, code: "306117" },
    { id: 44624, cityId: 1789, code: "306119" },
    { id: 44625, cityId: 1789, code: "306127" },
    { id: 44626, cityId: 1789, code: "306302" },
    { id: 44627, cityId: 1789, code: "306304" },
    { id: 44628, cityId: 1789, code: "306305" },
    { id: 44629, cityId: 1789, code: "306307" },
    { id: 44630, cityId: 1789, code: "306310" },
    { id: 44631, cityId: 1789, code: "306421" },
    { id: 44632, cityId: 1789, code: "306501" },
    { id: 44633, cityId: 1789, code: "306503" },
    { id: 44634, cityId: 1789, code: "306601" },
    { id: 44635, cityId: 1789, code: "306704" },
    { id: 44636, cityId: 1789, code: "306705" },
    { id: 44637, cityId: 1789, code: "306707" },
    { id: 44638, cityId: 1789, code: "306710" },
    { id: 44639, cityId: 1789, code: "306901" },
    { id: 44640, cityId: 1789, code: "306001" },
    { id: 44641, cityId: 1789, code: "306022" },
    { id: 44642, cityId: 1789, code: "306023" },
    { id: 44643, cityId: 1789, code: "306025" },
    { id: 44644, cityId: 1789, code: "306028" },
    { id: 44645, cityId: 1789, code: "306102" },
    { id: 44646, cityId: 1789, code: "306104" },
    { id: 44647, cityId: 1789, code: "306107" },
    { id: 44648, cityId: 1789, code: "306115" },
    { id: 44649, cityId: 1789, code: "306118" },
    { id: 44650, cityId: 1789, code: "306126" },
    { id: 44651, cityId: 1789, code: "306128" },
    { id: 44652, cityId: 1789, code: "306301" },
    { id: 44653, cityId: 1789, code: "306303" },
    { id: 44654, cityId: 1789, code: "306306" },
    { id: 44655, cityId: 1789, code: "306308" },
    { id: 44656, cityId: 1789, code: "306309" },
    { id: 44657, cityId: 1789, code: "306401" },
    { id: 44658, cityId: 1789, code: "306502" },
    { id: 44659, cityId: 1789, code: "306504" },
    { id: 44660, cityId: 1789, code: "306505" },
    { id: 44661, cityId: 1789, code: "306602" },
    { id: 44662, cityId: 1789, code: "306603" },
    { id: 44663, cityId: 1789, code: "306701" },
    { id: 44664, cityId: 1789, code: "306703" },
    { id: 44665, cityId: 1789, code: "306706" },
    { id: 44666, cityId: 1789, code: "306708" },
    { id: 44667, cityId: 1789, code: "306709" },
    { id: 44668, cityId: 1789, code: "306902" },
    { id: 44669, cityId: 1789, code: "410205" },
    { id: 44670, cityId: 1790, code: "341512" },
    { id: 44671, cityId: 1791, code: "322026" },
    { id: 44672, cityId: 1791, code: "342301" },
    { id: 44673, cityId: 1792, code: "333031" },
    { id: 44674, cityId: 1793, code: "335803" },
    { id: 44675, cityId: 1794, code: "307022" },
    { id: 44676, cityId: 1795, code: "326034" },
    { id: 44677, cityId: 1796, code: "345021" },
    { id: 44678, cityId: 1797, code: "305022" },
    { id: 44679, cityId: 1798, code: "335051" },
    { id: 44680, cityId: 1799, code: "328025" },
    { id: 44681, cityId: 1800, code: "331802" },
    { id: 44682, cityId: 1801, code: "305921" },
    { id: 44683, cityId: 1801, code: "312203" },
    { id: 44684, cityId: 1801, code: "313336" },
    { id: 44685, cityId: 1801, code: "313341" },
    { id: 44686, cityId: 1801, code: "306105" },
    { id: 44687, cityId: 1801, code: "307024" },
    { id: 44688, cityId: 1801, code: "313301" },
    { id: 44689, cityId: 1801, code: "313709" },
    { id: 44690, cityId: 1802, code: "326519" },
    { id: 44691, cityId: 1803, code: "306115" },
    { id: 44692, cityId: 1804, code: "331022" },
    { id: 44693, cityId: 1804, code: "458226" },
    { id: 44694, cityId: 1805, code: "331021" },
    { id: 44695, cityId: 1806, code: "306702" },
    { id: 44696, cityId: 1807, code: "335062" },
    { id: 44697, cityId: 1808, code: "314025" },
    { id: 44698, cityId: 1809, code: "313027" },
    { id: 44699, cityId: 1810, code: "343041" },
    { id: 44700, cityId: 1811, code: "325601" },
    { id: 44701, cityId: 1812, code: "331401" },
    { id: 44702, cityId: 1812, code: "331403" },
    { id: 44703, cityId: 1813, code: "305403" },
    { id: 44704, cityId: 1814, code: "311404" },
    { id: 44705, cityId: 1814, code: "460440" },
    { id: 44706, cityId: 1814, code: "483119" },
    { id: 44707, cityId: 1815, code: "307027" },
    { id: 44708, cityId: 1816, code: "322214" },
    { id: 44709, cityId: 1816, code: "332001" },
    { id: 44710, cityId: 1816, code: "332021" },
    { id: 44711, cityId: 1816, code: "332022" },
    { id: 44712, cityId: 1816, code: "332024" },
    { id: 44713, cityId: 1816, code: "332027" },
    { id: 44714, cityId: 1816, code: "332029" },
    { id: 44715, cityId: 1816, code: "332030" },
    { id: 44716, cityId: 1816, code: "332032" },
    { id: 44717, cityId: 1816, code: "332035" },
    { id: 44718, cityId: 1816, code: "332037" },
    { id: 44719, cityId: 1816, code: "332038" },
    { id: 44720, cityId: 1816, code: "332040" },
    { id: 44721, cityId: 1816, code: "332043" },
    { id: 44722, cityId: 1816, code: "332045" },
    { id: 44723, cityId: 1816, code: "332302" },
    { id: 44724, cityId: 1816, code: "332303" },
    { id: 44725, cityId: 1816, code: "332305" },
    { id: 44726, cityId: 1816, code: "332307" },
    { id: 44727, cityId: 1816, code: "332308" },
    { id: 44728, cityId: 1816, code: "332313" },
    { id: 44729, cityId: 1816, code: "332315" },
    { id: 44730, cityId: 1816, code: "332316" },
    { id: 44731, cityId: 1816, code: "332318" },
    { id: 44732, cityId: 1816, code: "332403" },
    { id: 44733, cityId: 1816, code: "332405" },
    { id: 44734, cityId: 1816, code: "332406" },
    { id: 44735, cityId: 1816, code: "332408" },
    { id: 44736, cityId: 1816, code: "332411" },
    { id: 44737, cityId: 1816, code: "332413" },
    { id: 44738, cityId: 1816, code: "332601" },
    { id: 44739, cityId: 1816, code: "332602" },
    { id: 44740, cityId: 1816, code: "332604" },
    { id: 44741, cityId: 1816, code: "332702" },
    { id: 44742, cityId: 1816, code: "332705" },
    { id: 44743, cityId: 1816, code: "332707" },
    { id: 44744, cityId: 1816, code: "332708" },
    { id: 44745, cityId: 1816, code: "332710" },
    { id: 44746, cityId: 1816, code: "332713" },
    { id: 44747, cityId: 1816, code: "332715" },
    { id: 44748, cityId: 1816, code: "332718" },
    { id: 44749, cityId: 1816, code: "332721" },
    { id: 44750, cityId: 1816, code: "332723" },
    { id: 44751, cityId: 1816, code: "332726" },
    { id: 44752, cityId: 1816, code: "332729" },
    { id: 44753, cityId: 1816, code: "332731" },
    { id: 44754, cityId: 1816, code: "332732" },
    { id: 44755, cityId: 1816, code: "332734" },
    { id: 44756, cityId: 1816, code: "332737" },
    { id: 44757, cityId: 1816, code: "332739" },
    { id: 44758, cityId: 1816, code: "332740" },
    { id: 44759, cityId: 1816, code: "332742" },
    { id: 44760, cityId: 1816, code: "332744" },
    { id: 44761, cityId: 1816, code: "332745" },
    { id: 44762, cityId: 1816, code: "332747" },
    { id: 44763, cityId: 1816, code: "331024" },
    { id: 44764, cityId: 1816, code: "331033" },
    { id: 44765, cityId: 1816, code: "332023" },
    { id: 44766, cityId: 1816, code: "332026" },
    { id: 44767, cityId: 1816, code: "332028" },
    { id: 44768, cityId: 1816, code: "332031" },
    { id: 44769, cityId: 1816, code: "332033" },
    { id: 44770, cityId: 1816, code: "332034" },
    { id: 44771, cityId: 1816, code: "332036" },
    { id: 44772, cityId: 1816, code: "332039" },
    { id: 44773, cityId: 1816, code: "332041" },
    { id: 44774, cityId: 1816, code: "332042" },
    { id: 44775, cityId: 1816, code: "332044" },
    { id: 44776, cityId: 1816, code: "332301" },
    { id: 44777, cityId: 1816, code: "332304" },
    { id: 44778, cityId: 1816, code: "332306" },
    { id: 44779, cityId: 1816, code: "332311" },
    { id: 44780, cityId: 1816, code: "332312" },
    { id: 44781, cityId: 1816, code: "332314" },
    { id: 44782, cityId: 1816, code: "332317" },
    { id: 44783, cityId: 1816, code: "332401" },
    { id: 44784, cityId: 1816, code: "332402" },
    { id: 44785, cityId: 1816, code: "332404" },
    { id: 44786, cityId: 1816, code: "332407" },
    { id: 44787, cityId: 1816, code: "332409" },
    { id: 44788, cityId: 1816, code: "332410" },
    { id: 44789, cityId: 1816, code: "332412" },
    { id: 44790, cityId: 1816, code: "332603" },
    { id: 44791, cityId: 1816, code: "332605" },
    { id: 44792, cityId: 1816, code: "332701" },
    { id: 44793, cityId: 1816, code: "332703" },
    { id: 44794, cityId: 1816, code: "332704" },
    { id: 44795, cityId: 1816, code: "332706" },
    { id: 44796, cityId: 1816, code: "332709" },
    { id: 44797, cityId: 1816, code: "332711" },
    { id: 44798, cityId: 1816, code: "332712" },
    { id: 44799, cityId: 1816, code: "332714" },
    { id: 44800, cityId: 1816, code: "332719" },
    { id: 44801, cityId: 1816, code: "332722" },
    { id: 44802, cityId: 1816, code: "332725" },
    { id: 44803, cityId: 1816, code: "332727" },
    { id: 44804, cityId: 1816, code: "332728" },
    { id: 44805, cityId: 1816, code: "332730" },
    { id: 44806, cityId: 1816, code: "332733" },
    { id: 44807, cityId: 1816, code: "332735" },
    { id: 44808, cityId: 1816, code: "332736" },
    { id: 44809, cityId: 1816, code: "332738" },
    { id: 44810, cityId: 1816, code: "332741" },
    { id: 44811, cityId: 1816, code: "332743" },
    { id: 44812, cityId: 1816, code: "332748" },
    { id: 44813, cityId: 1817, code: "307021" },
    { id: 44814, cityId: 1817, code: "307023" },
    { id: 44815, cityId: 1817, code: "307026" },
    { id: 44816, cityId: 1817, code: "307028" },
    { id: 44817, cityId: 1817, code: "307044" },
    { id: 44818, cityId: 1817, code: "307045" },
    { id: 44819, cityId: 1817, code: "307511" },
    { id: 44820, cityId: 1817, code: "307513" },
    { id: 44821, cityId: 1817, code: "307514" },
    { id: 44822, cityId: 1817, code: "307802" },
    { id: 44823, cityId: 1817, code: "307001" },
    { id: 44824, cityId: 1817, code: "307019" },
    { id: 44825, cityId: 1817, code: "307020" },
    { id: 44826, cityId: 1817, code: "307027" },
    { id: 44827, cityId: 1817, code: "307043" },
    { id: 44828, cityId: 1817, code: "307501" },
    { id: 44829, cityId: 1817, code: "307512" },
    { id: 44830, cityId: 1817, code: "307515" },
    { id: 44831, cityId: 1817, code: "307801" },
    { id: 44832, cityId: 1817, code: "307804" },
    { id: 44833, cityId: 1818, code: "332715" },
    { id: 44834, cityId: 1819, code: "331507" },
    { id: 44835, cityId: 1820, code: "326530" },
    { id: 44836, cityId: 1821, code: "306902" },
    { id: 44837, cityId: 1822, code: "333029" },
    { id: 44838, cityId: 1823, code: "335804" },
    { id: 44839, cityId: 1824, code: "321610" },
    { id: 44840, cityId: 1824, code: "321612" },
    { id: 44841, cityId: 1824, code: "321613" },
    { id: 44842, cityId: 1824, code: "322023" },
    { id: 44843, cityId: 1824, code: "322025" },
    { id: 44844, cityId: 1824, code: "322028" },
    { id: 44845, cityId: 1824, code: "322031" },
    { id: 44846, cityId: 1824, code: "322034" },
    { id: 44847, cityId: 1824, code: "322036" },
    { id: 44848, cityId: 1824, code: "322201" },
    { id: 44849, cityId: 1824, code: "322203" },
    { id: 44850, cityId: 1824, code: "322206" },
    { id: 44851, cityId: 1824, code: "322209" },
    { id: 44852, cityId: 1824, code: "322211" },
    { id: 44853, cityId: 1824, code: "322216" },
    { id: 44854, cityId: 1824, code: "322219" },
    { id: 44855, cityId: 1824, code: "322221" },
    { id: 44856, cityId: 1824, code: "322222" },
    { id: 44857, cityId: 1824, code: "322224" },
    { id: 44858, cityId: 1824, code: "322230" },
    { id: 44859, cityId: 1824, code: "322235" },
    { id: 44860, cityId: 1824, code: "322240" },
    { id: 44861, cityId: 1824, code: "322245" },
    { id: 44862, cityId: 1824, code: "322246" },
    { id: 44863, cityId: 1824, code: "322248" },
    { id: 44864, cityId: 1824, code: "322251" },
    { id: 44865, cityId: 1824, code: "322327" },
    { id: 44866, cityId: 1824, code: "322701" },
    { id: 44867, cityId: 1824, code: "322703" },
    { id: 44868, cityId: 1824, code: "322704" },
    { id: 44869, cityId: 1824, code: "321611" },
    { id: 44870, cityId: 1824, code: "322001" },
    { id: 44871, cityId: 1824, code: "322021" },
    { id: 44872, cityId: 1824, code: "322022" },
    { id: 44873, cityId: 1824, code: "322024" },
    { id: 44874, cityId: 1824, code: "322027" },
    { id: 44875, cityId: 1824, code: "322029" },
    { id: 44876, cityId: 1824, code: "322030" },
    { id: 44877, cityId: 1824, code: "322032" },
    { id: 44878, cityId: 1824, code: "322035" },
    { id: 44879, cityId: 1824, code: "322204" },
    { id: 44880, cityId: 1824, code: "322205" },
    { id: 44881, cityId: 1824, code: "322212" },
    { id: 44882, cityId: 1824, code: "322213" },
    { id: 44883, cityId: 1824, code: "322217" },
    { id: 44884, cityId: 1824, code: "322220" },
    { id: 44885, cityId: 1824, code: "322223" },
    { id: 44886, cityId: 1824, code: "322233" },
    { id: 44887, cityId: 1824, code: "322234" },
    { id: 44888, cityId: 1824, code: "322241" },
    { id: 44889, cityId: 1824, code: "322242" },
    { id: 44890, cityId: 1824, code: "322247" },
    { id: 44891, cityId: 1824, code: "322252" },
    { id: 44892, cityId: 1824, code: "322702" },
    { id: 44893, cityId: 1825, code: "331304" },
    { id: 44894, cityId: 1826, code: "301411" },
    { id: 44895, cityId: 1827, code: "304001" },
    { id: 44896, cityId: 1827, code: "304022" },
    { id: 44897, cityId: 1827, code: "304025" },
    { id: 44898, cityId: 1827, code: "304501" },
    { id: 44899, cityId: 1827, code: "304504" },
    { id: 44900, cityId: 1827, code: "304506" },
    { id: 44901, cityId: 1827, code: "304507" },
    { id: 44902, cityId: 1827, code: "304509" },
    { id: 44903, cityId: 1827, code: "304801" },
    { id: 44904, cityId: 1827, code: "304803" },
    { id: 44905, cityId: 1827, code: "304806" },
    { id: 44906, cityId: 1827, code: "323302" },
    { id: 44907, cityId: 1827, code: "304020" },
    { id: 44908, cityId: 1827, code: "304021" },
    { id: 44909, cityId: 1827, code: "304023" },
    { id: 44910, cityId: 1827, code: "304026" },
    { id: 44911, cityId: 1827, code: "304503" },
    { id: 44912, cityId: 1827, code: "304505" },
    { id: 44913, cityId: 1827, code: "304508" },
    { id: 44914, cityId: 1827, code: "304510" },
    { id: 44915, cityId: 1827, code: "304511" },
    { id: 44916, cityId: 1827, code: "304802" },
    { id: 44917, cityId: 1827, code: "304804" },
    { id: 44918, cityId: 1827, code: "304805" },
    { id: 44919, cityId: 1827, code: "304807" },
    { id: 44920, cityId: 1828, code: "307025" },
    { id: 44921, cityId: 1828, code: "313001" },
    { id: 44922, cityId: 1828, code: "313011" },
    { id: 44923, cityId: 1828, code: "313014" },
    { id: 44924, cityId: 1828, code: "313016" },
    { id: 44925, cityId: 1828, code: "313022" },
    { id: 44926, cityId: 1828, code: "313024" },
    { id: 44927, cityId: 1828, code: "313030" },
    { id: 44928, cityId: 1828, code: "313032" },
    { id: 44929, cityId: 1828, code: "313033" },
    { id: 44930, cityId: 1828, code: "313038" },
    { id: 44931, cityId: 1828, code: "313202" },
    { id: 44932, cityId: 1828, code: "313204" },
    { id: 44933, cityId: 1828, code: "313205" },
    { id: 44934, cityId: 1828, code: "313207" },
    { id: 44935, cityId: 1828, code: "313210" },
    { id: 44936, cityId: 1828, code: "313212" },
    { id: 44937, cityId: 1828, code: "313303" },
    { id: 44938, cityId: 1828, code: "313321" },
    { id: 44939, cityId: 1828, code: "313324" },
    { id: 44940, cityId: 1828, code: "313326" },
    { id: 44941, cityId: 1828, code: "313327" },
    { id: 44942, cityId: 1828, code: "313329" },
    { id: 44943, cityId: 1828, code: "313332" },
    { id: 44944, cityId: 1828, code: "313337" },
    { id: 44945, cityId: 1828, code: "313340" },
    { id: 44946, cityId: 1828, code: "313342" },
    { id: 44947, cityId: 1828, code: "313602" },
    { id: 44948, cityId: 1828, code: "313604" },
    { id: 44949, cityId: 1828, code: "313607" },
    { id: 44950, cityId: 1828, code: "313610" },
    { id: 44951, cityId: 1828, code: "313612" },
    { id: 44952, cityId: 1828, code: "313613" },
    { id: 44953, cityId: 1828, code: "313702" },
    { id: 44954, cityId: 1828, code: "313703" },
    { id: 44955, cityId: 1828, code: "313705" },
    { id: 44956, cityId: 1828, code: "313708" },
    { id: 44957, cityId: 1828, code: "313801" },
    { id: 44958, cityId: 1828, code: "313803" },
    { id: 44959, cityId: 1828, code: "313806" },
    { id: 44960, cityId: 1828, code: "313901" },
    { id: 44961, cityId: 1828, code: "313904" },
    { id: 44962, cityId: 1828, code: "313906" },
    { id: 44963, cityId: 1828, code: "313907" },
    { id: 44964, cityId: 1828, code: "799104" },
    { id: 44965, cityId: 1828, code: "799120" },
    { id: 44966, cityId: 1828, code: "799122" },
    { id: 44967, cityId: 1828, code: "799123" },
    { id: 44968, cityId: 1828, code: "799125" },
    { id: 44969, cityId: 1828, code: "799141" },
    { id: 44970, cityId: 1828, code: "799144" },
    { id: 44971, cityId: 1828, code: "799146" },
    { id: 44972, cityId: 1828, code: "799149" },
    { id: 44973, cityId: 1828, code: "799157" },
    { id: 44974, cityId: 1828, code: "799159" },
    { id: 44975, cityId: 1828, code: "313012" },
    { id: 44976, cityId: 1828, code: "313013" },
    { id: 44977, cityId: 1828, code: "313015" },
    { id: 44978, cityId: 1828, code: "313021" },
    { id: 44979, cityId: 1828, code: "313023" },
    { id: 44980, cityId: 1828, code: "313026" },
    { id: 44981, cityId: 1828, code: "313028" },
    { id: 44982, cityId: 1828, code: "313029" },
    { id: 44983, cityId: 1828, code: "313031" },
    { id: 44984, cityId: 1828, code: "313034" },
    { id: 44985, cityId: 1828, code: "313201" },
    { id: 44986, cityId: 1828, code: "313203" },
    { id: 44987, cityId: 1828, code: "313206" },
    { id: 44988, cityId: 1828, code: "313209" },
    { id: 44989, cityId: 1828, code: "313211" },
    { id: 44990, cityId: 1828, code: "313322" },
    { id: 44991, cityId: 1828, code: "313323" },
    { id: 44992, cityId: 1828, code: "313325" },
    { id: 44993, cityId: 1828, code: "313328" },
    { id: 44994, cityId: 1828, code: "313330" },
    { id: 44995, cityId: 1828, code: "313331" },
    { id: 44996, cityId: 1828, code: "313333" },
    { id: 44997, cityId: 1828, code: "313338" },
    { id: 44998, cityId: 1828, code: "313601" },
    { id: 44999, cityId: 1828, code: "313606" },
    { id: 45000, cityId: 1828, code: "313608" },
    { id: 45001, cityId: 1828, code: "313609" },
    { id: 45002, cityId: 1828, code: "313611" },
    { id: 45003, cityId: 1828, code: "313701" },
    { id: 45004, cityId: 1828, code: "313704" },
    { id: 45005, cityId: 1828, code: "313706" },
    { id: 45006, cityId: 1828, code: "313707" },
    { id: 45007, cityId: 1828, code: "313802" },
    { id: 45008, cityId: 1828, code: "313804" },
    { id: 45009, cityId: 1828, code: "313805" },
    { id: 45010, cityId: 1828, code: "313902" },
    { id: 45011, cityId: 1828, code: "313903" },
    { id: 45012, cityId: 1828, code: "313905" },
    { id: 45013, cityId: 1828, code: "799105" },
    { id: 45014, cityId: 1828, code: "799108" },
    { id: 45015, cityId: 1828, code: "799119" },
    { id: 45016, cityId: 1828, code: "799121" },
    { id: 45017, cityId: 1828, code: "799142" },
    { id: 45018, cityId: 1828, code: "799147" },
    { id: 45019, cityId: 1828, code: "799148" },
    { id: 45020, cityId: 1828, code: "799153" },
    { id: 45021, cityId: 1828, code: "799156" },
    { id: 45022, cityId: 1828, code: "799158" },
    { id: 45023, cityId: 1829, code: "333307" },
    { id: 45024, cityId: 1830, code: "304024" },
    { id: 45025, cityId: 1831, code: "303102" },
    { id: 45026, cityId: 1832, code: "321408" },
    { id: 45027, cityId: 1833, code: "737103" },
    { id: 45028, cityId: 1833, code: "737135" },
    { id: 45029, cityId: 1833, code: "737101" },
    { id: 45030, cityId: 1833, code: "737102" },
    { id: 45031, cityId: 1833, code: "737107" },
    { id: 45032, cityId: 1833, code: "737131" },
    { id: 45033, cityId: 1833, code: "737133" },
    { id: 45034, cityId: 1833, code: "737136" },
    { id: 45035, cityId: 1833, code: "737138" },
    { id: 45036, cityId: 1834, code: "737106" },
    { id: 45037, cityId: 1834, code: "737111" },
    { id: 45038, cityId: 1834, code: "737114" },
    { id: 45039, cityId: 1834, code: "737127" },
    { id: 45040, cityId: 1834, code: "737112" },
    { id: 45041, cityId: 1834, code: "737113" },
    { id: 45042, cityId: 1835, code: "737117" },
    { id: 45043, cityId: 1835, code: "737119" },
    { id: 45044, cityId: 1835, code: "737120" },
    { id: 45045, cityId: 1835, code: "737116" },
    { id: 45046, cityId: 1835, code: "737118" },
    { id: 45047, cityId: 1836, code: "737122" },
    { id: 45048, cityId: 1836, code: "737128" },
    { id: 45049, cityId: 1836, code: "737126" },
    { id: 45050, cityId: 1836, code: "737137" },
    { id: 45051, cityId: 1837, code: "737121" },
    { id: 45052, cityId: 1838, code: "737132" },
    { id: 45053, cityId: 1839, code: "737134" },
    { id: 45054, cityId: 1840, code: "623601" },
    { id: 45055, cityId: 1841, code: "603301" },
    { id: 45056, cityId: 1842, code: "600016" },
    { id: 45057, cityId: 1843, code: "625501" },
    { id: 45058, cityId: 1844, code: "635701" },
    { id: 45059, cityId: 1845, code: "622301" },
    { id: 45060, cityId: 1846, code: "627851" },
    { id: 45061, cityId: 1846, code: "626144" },
    { id: 45062, cityId: 1847, code: "608801" },
    { id: 45063, cityId: 1848, code: "627401" },
    { id: 45064, cityId: 1849, code: "635802" },
    { id: 45065, cityId: 1850, code: "631301" },
    { id: 45066, cityId: 1851, code: "632501" },
    { id: 45067, cityId: 1852, code: "626180" },
    { id: 45068, cityId: 1853, code: "600070" },
    { id: 45069, cityId: 1854, code: "622101" },
    { id: 45070, cityId: 1855, code: "638501" },
    { id: 45071, cityId: 1856, code: "605752" },
    { id: 45072, cityId: 1857, code: "639201" },
    { id: 45073, cityId: 1858, code: "622201" },
    { id: 45074, cityId: 1859, code: "607001" },
    { id: 45075, cityId: 1859, code: "621710" },
    { id: 45076, cityId: 1859, code: "624403" },
    { id: 45077, cityId: 1859, code: "627417" },
    { id: 45078, cityId: 1859, code: "627714" },
    { id: 45079, cityId: 1859, code: "629176" },
    { id: 45080, cityId: 1859, code: "612902" },
    { id: 45081, cityId: 1859, code: "621801" },
    { id: 45082, cityId: 1859, code: "621806" },
    { id: 45083, cityId: 1859, code: "636124" },
    { id: 45084, cityId: 1859, code: "638452" },
    { id: 45085, cityId: 1860, code: "605751" },
    { id: 45086, cityId: 1861, code: "621103" },
    { id: 45087, cityId: 1862, code: "628202" },
    { id: 45088, cityId: 1863, code: "638502" },
    { id: 45089, cityId: 1864, code: "636301" },
    { id: 45090, cityId: 1865, code: "637501" },
    { id: 45091, cityId: 1866, code: "636102" },
    { id: 45092, cityId: 1867, code: "600010" },
    { id: 45093, cityId: 1867, code: "600055" },
    { id: 45094, cityId: 1867, code: "600054" },
    { id: 45095, cityId: 1868, code: "638654" },
    { id: 45096, cityId: 1869, code: "625012" },
    { id: 45097, cityId: 1870, code: "624613" },
    { id: 45098, cityId: 1871, code: "624801" },
    { id: 45099, cityId: 1872, code: "621202" },
    { id: 45100, cityId: 1873, code: "631601" },
    { id: 45101, cityId: 1874, code: "621203" },
    { id: 45102, cityId: 1875, code: "624202" },
    { id: 45103, cityId: 1876, code: "638451" },
    { id: 45104, cityId: 1877, code: "608601" },
    { id: 45105, cityId: 1878, code: "603001" },
    { id: 45106, cityId: 1879, code: "606701" },
    { id: 45107, cityId: 1880, code: "600002" },
    { id: 45108, cityId: 1880, code: "600005" },
    { id: 45109, cityId: 1880, code: "600007" },
    { id: 45110, cityId: 1880, code: "600008" },
    { id: 45111, cityId: 1880, code: "600010" },
    { id: 45112, cityId: 1880, code: "600013" },
    { id: 45113, cityId: 1880, code: "600015" },
    { id: 45114, cityId: 1880, code: "600016" },
    { id: 45115, cityId: 1880, code: "600018" },
    { id: 45116, cityId: 1880, code: "600021" },
    { id: 45117, cityId: 1880, code: "600023" },
    { id: 45118, cityId: 1880, code: "600024" },
    { id: 45119, cityId: 1880, code: "600026" },
    { id: 45120, cityId: 1880, code: "600029" },
    { id: 45121, cityId: 1880, code: "600031" },
    { id: 45122, cityId: 1880, code: "600032" },
    { id: 45123, cityId: 1880, code: "600034" },
    { id: 45124, cityId: 1880, code: "600037" },
    { id: 45125, cityId: 1880, code: "600039" },
    { id: 45126, cityId: 1880, code: "600042" },
    { id: 45127, cityId: 1880, code: "600044" },
    { id: 45128, cityId: 1880, code: "600050" },
    { id: 45129, cityId: 1880, code: "600052" },
    { id: 45130, cityId: 1880, code: "600053" },
    { id: 45131, cityId: 1880, code: "600055" },
    { id: 45132, cityId: 1880, code: "600058" },
    { id: 45133, cityId: 1880, code: "600060" },
    { id: 45134, cityId: 1880, code: "600061" },
    { id: 45135, cityId: 1880, code: "600063" },
    { id: 45136, cityId: 1880, code: "600066" },
    { id: 45137, cityId: 1880, code: "600069" },
    { id: 45138, cityId: 1880, code: "600071" },
    { id: 45139, cityId: 1880, code: "600074" },
    { id: 45140, cityId: 1880, code: "600076" },
    { id: 45141, cityId: 1880, code: "600079" },
    { id: 45142, cityId: 1880, code: "600082" },
    { id: 45143, cityId: 1880, code: "600084" },
    { id: 45144, cityId: 1880, code: "600087" },
    { id: 45145, cityId: 1880, code: "600089" },
    { id: 45146, cityId: 1880, code: "600090" },
    { id: 45147, cityId: 1880, code: "600092" },
    { id: 45148, cityId: 1880, code: "600095" },
    { id: 45149, cityId: 1880, code: "600097" },
    { id: 45150, cityId: 1880, code: "600098" },
    { id: 45151, cityId: 1880, code: "600105" },
    { id: 45152, cityId: 1880, code: "600108" },
    { id: 45153, cityId: 1880, code: "600111" },
    { id: 45154, cityId: 1880, code: "600113" },
    { id: 45155, cityId: 1880, code: "600001" },
    { id: 45156, cityId: 1880, code: "600003" },
    { id: 45157, cityId: 1880, code: "600004" },
    { id: 45158, cityId: 1880, code: "600006" },
    { id: 45159, cityId: 1880, code: "600009" },
    { id: 45160, cityId: 1880, code: "600011" },
    { id: 45161, cityId: 1880, code: "600012" },
    { id: 45162, cityId: 1880, code: "600014" },
    { id: 45163, cityId: 1880, code: "600017" },
    { id: 45164, cityId: 1880, code: "600019" },
    { id: 45165, cityId: 1880, code: "600020" },
    { id: 45166, cityId: 1880, code: "600022" },
    { id: 45167, cityId: 1880, code: "600025" },
    { id: 45168, cityId: 1880, code: "600027" },
    { id: 45169, cityId: 1880, code: "600028" },
    { id: 45170, cityId: 1880, code: "600030" },
    { id: 45171, cityId: 1880, code: "600033" },
    { id: 45172, cityId: 1880, code: "600035" },
    { id: 45173, cityId: 1880, code: "600036" },
    { id: 45174, cityId: 1880, code: "600038" },
    { id: 45175, cityId: 1880, code: "600040" },
    { id: 45176, cityId: 1880, code: "600041" },
    { id: 45177, cityId: 1880, code: "600043" },
    { id: 45178, cityId: 1880, code: "600046" },
    { id: 45179, cityId: 1880, code: "600049" },
    { id: 45180, cityId: 1880, code: "600051" },
    { id: 45181, cityId: 1880, code: "600057" },
    { id: 45182, cityId: 1880, code: "600059" },
    { id: 45183, cityId: 1880, code: "600062" },
    { id: 45184, cityId: 1880, code: "600065" },
    { id: 45185, cityId: 1880, code: "600067" },
    { id: 45186, cityId: 1880, code: "600072" },
    { id: 45187, cityId: 1880, code: "600073" },
    { id: 45188, cityId: 1880, code: "600078" },
    { id: 45189, cityId: 1880, code: "600081" },
    { id: 45190, cityId: 1880, code: "600083" },
    { id: 45191, cityId: 1880, code: "600085" },
    { id: 45192, cityId: 1880, code: "600086" },
    { id: 45193, cityId: 1880, code: "600088" },
    { id: 45194, cityId: 1880, code: "600091" },
    { id: 45195, cityId: 1880, code: "600093" },
    { id: 45196, cityId: 1880, code: "600094" },
    { id: 45197, cityId: 1880, code: "600101" },
    { id: 45198, cityId: 1880, code: "600102" },
    { id: 45199, cityId: 1880, code: "600104" },
    { id: 45200, cityId: 1880, code: "600107" },
    { id: 45201, cityId: 1880, code: "600110" },
    { id: 45202, cityId: 1880, code: "600112" },
    { id: 45203, cityId: 1881, code: "632527" },
    { id: 45204, cityId: 1882, code: "638051" },
    { id: 45205, cityId: 1883, code: "641201" },
    { id: 45206, cityId: 1884, code: "608001" },
    { id: 45207, cityId: 1885, code: "624301" },
    { id: 45208, cityId: 1886, code: "626515" },
    { id: 45209, cityId: 1887, code: "606201" },
    { id: 45210, cityId: 1888, code: "600064" },
    { id: 45211, cityId: 1889, code: "614208" },
    { id: 45212, cityId: 1889, code: "638201" },
    { id: 45213, cityId: 1889, code: "641001" },
    { id: 45214, cityId: 1889, code: "641003" },
    { id: 45215, cityId: 1889, code: "641004" },
    { id: 45216, cityId: 1889, code: "641006" },
    { id: 45217, cityId: 1889, code: "641009" },
    { id: 45218, cityId: 1889, code: "641011" },
    { id: 45219, cityId: 1889, code: "641012" },
    { id: 45220, cityId: 1889, code: "641014" },
    { id: 45221, cityId: 1889, code: "641019" },
    { id: 45222, cityId: 1889, code: "641020" },
    { id: 45223, cityId: 1889, code: "641022" },
    { id: 45224, cityId: 1889, code: "641025" },
    { id: 45225, cityId: 1889, code: "641027" },
    { id: 45226, cityId: 1889, code: "641028" },
    { id: 45227, cityId: 1889, code: "641030" },
    { id: 45228, cityId: 1889, code: "641033" },
    { id: 45229, cityId: 1889, code: "641038" },
    { id: 45230, cityId: 1889, code: "641040" },
    { id: 45231, cityId: 1889, code: "641041" },
    { id: 45232, cityId: 1889, code: "641046" },
    { id: 45233, cityId: 1889, code: "641062" },
    { id: 45234, cityId: 1889, code: "641064" },
    { id: 45235, cityId: 1889, code: "641065" },
    { id: 45236, cityId: 1889, code: "641101" },
    { id: 45237, cityId: 1889, code: "641107" },
    { id: 45238, cityId: 1889, code: "641109" },
    { id: 45239, cityId: 1889, code: "641110" },
    { id: 45240, cityId: 1889, code: "641112" },
    { id: 45241, cityId: 1889, code: "641115" },
    { id: 45242, cityId: 1889, code: "641118" },
    { id: 45243, cityId: 1889, code: "641120" },
    { id: 45244, cityId: 1889, code: "641202" },
    { id: 45245, cityId: 1889, code: "641303" },
    { id: 45246, cityId: 1889, code: "641404" },
    { id: 45247, cityId: 1889, code: "641602" },
    { id: 45248, cityId: 1889, code: "642002" },
    { id: 45249, cityId: 1889, code: "642005" },
    { id: 45250, cityId: 1889, code: "642007" },
    { id: 45251, cityId: 1889, code: "642052" },
    { id: 45252, cityId: 1889, code: "642053" },
    { id: 45253, cityId: 1889, code: "642055" },
    { id: 45254, cityId: 1889, code: "642103" },
    { id: 45255, cityId: 1889, code: "642105" },
    { id: 45256, cityId: 1889, code: "642108" },
    { id: 45257, cityId: 1889, code: "642111" },
    { id: 45258, cityId: 1889, code: "642116" },
    { id: 45259, cityId: 1889, code: "642118" },
    { id: 45260, cityId: 1889, code: "642119" },
    { id: 45261, cityId: 1889, code: "642124" },
    { id: 45262, cityId: 1889, code: "642126" },
    { id: 45263, cityId: 1889, code: "642127" },
    { id: 45264, cityId: 1889, code: "642132" },
    { id: 45265, cityId: 1889, code: "642134" },
    { id: 45266, cityId: 1889, code: "642135" },
    { id: 45267, cityId: 1889, code: "642137" },
    { id: 45268, cityId: 1889, code: "642140" },
    { id: 45269, cityId: 1889, code: "642142" },
    { id: 45270, cityId: 1889, code: "642143" },
    { id: 45271, cityId: 1889, code: "642145" },
    { id: 45272, cityId: 1889, code: "642148" },
    { id: 45273, cityId: 1889, code: "642153" },
    { id: 45274, cityId: 1889, code: "638211" },
    { id: 45275, cityId: 1889, code: "638406" },
    { id: 45276, cityId: 1889, code: "641002" },
    { id: 45277, cityId: 1889, code: "641005" },
    { id: 45278, cityId: 1889, code: "641007" },
    { id: 45279, cityId: 1889, code: "641013" },
    { id: 45280, cityId: 1889, code: "641015" },
    { id: 45281, cityId: 1889, code: "641016" },
    { id: 45282, cityId: 1889, code: "641018" },
    { id: 45283, cityId: 1889, code: "641021" },
    { id: 45284, cityId: 1889, code: "641023" },
    { id: 45285, cityId: 1889, code: "641026" },
    { id: 45286, cityId: 1889, code: "641029" },
    { id: 45287, cityId: 1889, code: "641031" },
    { id: 45288, cityId: 1889, code: "641034" },
    { id: 45289, cityId: 1889, code: "641036" },
    { id: 45290, cityId: 1889, code: "641037" },
    { id: 45291, cityId: 1889, code: "641039" },
    { id: 45292, cityId: 1889, code: "641042" },
    { id: 45293, cityId: 1889, code: "641044" },
    { id: 45294, cityId: 1889, code: "641045" },
    { id: 45295, cityId: 1889, code: "641047" },
    { id: 45296, cityId: 1889, code: "641105" },
    { id: 45297, cityId: 1889, code: "641106" },
    { id: 45298, cityId: 1889, code: "641114" },
    { id: 45299, cityId: 1889, code: "641116" },
    { id: 45300, cityId: 1889, code: "641301" },
    { id: 45301, cityId: 1889, code: "641402" },
    { id: 45302, cityId: 1889, code: "641407" },
    { id: 45303, cityId: 1889, code: "641408" },
    { id: 45304, cityId: 1889, code: "641604" },
    { id: 45305, cityId: 1889, code: "642001" },
    { id: 45306, cityId: 1889, code: "642003" },
    { id: 45307, cityId: 1889, code: "642004" },
    { id: 45308, cityId: 1889, code: "642051" },
    { id: 45309, cityId: 1889, code: "642054" },
    { id: 45310, cityId: 1889, code: "642101" },
    { id: 45311, cityId: 1889, code: "642102" },
    { id: 45312, cityId: 1889, code: "642104" },
    { id: 45313, cityId: 1889, code: "642107" },
    { id: 45314, cityId: 1889, code: "642112" },
    { id: 45315, cityId: 1889, code: "642114" },
    { id: 45316, cityId: 1889, code: "642115" },
    { id: 45317, cityId: 1889, code: "642117" },
    { id: 45318, cityId: 1889, code: "642122" },
    { id: 45319, cityId: 1889, code: "642125" },
    { id: 45320, cityId: 1889, code: "642128" },
    { id: 45321, cityId: 1889, code: "642130" },
    { id: 45322, cityId: 1889, code: "642131" },
    { id: 45323, cityId: 1889, code: "642133" },
    { id: 45324, cityId: 1889, code: "642136" },
    { id: 45325, cityId: 1889, code: "642138" },
    { id: 45326, cityId: 1889, code: "642139" },
    { id: 45327, cityId: 1889, code: "642141" },
    { id: 45328, cityId: 1889, code: "642144" },
    { id: 45329, cityId: 1889, code: "642147" },
    { id: 45330, cityId: 1889, code: "642149" },
    { id: 45331, cityId: 1889, code: "642152" },
    { id: 45332, cityId: 1889, code: "642154" },
    { id: 45333, cityId: 1890, code: "603303" },
    { id: 45334, cityId: 1890, code: "604405" },
    { id: 45335, cityId: 1890, code: "604413" },
    { id: 45336, cityId: 1890, code: "606123" },
    { id: 45337, cityId: 1890, code: "607003" },
    { id: 45338, cityId: 1890, code: "607305" },
    { id: 45339, cityId: 1890, code: "608304" },
    { id: 45340, cityId: 1890, code: "608401" },
    { id: 45341, cityId: 1890, code: "608602" },
    { id: 45342, cityId: 1890, code: "609101" },
    { id: 45343, cityId: 1890, code: "609124" },
    { id: 45344, cityId: 1890, code: "611105" },
    { id: 45345, cityId: 1890, code: "614728" },
    { id: 45346, cityId: 1890, code: "629303" },
    { id: 45347, cityId: 1890, code: "641009" },
    { id: 45348, cityId: 1890, code: "606112" },
    { id: 45349, cityId: 1890, code: "606914" },
    { id: 45350, cityId: 1890, code: "607001" },
    { id: 45351, cityId: 1890, code: "608302" },
    { id: 45352, cityId: 1890, code: "608704" },
    { id: 45353, cityId: 1890, code: "622203" },
    { id: 45354, cityId: 1890, code: "623318" },
    { id: 45355, cityId: 1890, code: "626057" },
    { id: 45356, cityId: 1890, code: "641117" },
    { id: 45357, cityId: 1891, code: "604501" },
    { id: 45358, cityId: 1892, code: "626601" },
    { id: 45359, cityId: 1893, code: "643207" },
    { id: 45360, cityId: 1894, code: "635001" },
    { id: 45361, cityId: 1894, code: "635102" },
    { id: 45362, cityId: 1894, code: "635104" },
    { id: 45363, cityId: 1894, code: "635107" },
    { id: 45364, cityId: 1894, code: "635109" },
    { id: 45365, cityId: 1894, code: "635110" },
    { id: 45366, cityId: 1894, code: "635112" },
    { id: 45367, cityId: 1894, code: "635117" },
    { id: 45368, cityId: 1894, code: "635118" },
    { id: 45369, cityId: 1894, code: "635120" },
    { id: 45370, cityId: 1894, code: "635123" },
    { id: 45371, cityId: 1894, code: "635125" },
    { id: 45372, cityId: 1894, code: "635126" },
    { id: 45373, cityId: 1894, code: "635128" },
    { id: 45374, cityId: 1894, code: "635131" },
    { id: 45375, cityId: 1894, code: "635133" },
    { id: 45376, cityId: 1894, code: "635134" },
    { id: 45377, cityId: 1894, code: "635136" },
    { id: 45378, cityId: 1894, code: "635138" },
    { id: 45379, cityId: 1894, code: "635139" },
    { id: 45380, cityId: 1894, code: "635141" },
    { id: 45381, cityId: 1894, code: "635205" },
    { id: 45382, cityId: 1894, code: "635207" },
    { id: 45383, cityId: 1894, code: "635208" },
    { id: 45384, cityId: 1894, code: "635305" },
    { id: 45385, cityId: 1894, code: "635306" },
    { id: 45386, cityId: 1894, code: "635308" },
    { id: 45387, cityId: 1894, code: "635311" },
    { id: 45388, cityId: 1894, code: "635313" },
    { id: 45389, cityId: 1894, code: "635660" },
    { id: 45390, cityId: 1894, code: "635705" },
    { id: 45391, cityId: 1894, code: "635706" },
    { id: 45392, cityId: 1894, code: "635708" },
    { id: 45393, cityId: 1894, code: "635758" },
    { id: 45394, cityId: 1894, code: "635817" },
    { id: 45395, cityId: 1894, code: "635822" },
    { id: 45396, cityId: 1894, code: "635824" },
    { id: 45397, cityId: 1894, code: "635825" },
    { id: 45398, cityId: 1894, code: "635857" },
    { id: 45399, cityId: 1894, code: "636701" },
    { id: 45400, cityId: 1894, code: "636704" },
    { id: 45401, cityId: 1894, code: "636751" },
    { id: 45402, cityId: 1894, code: "636802" },
    { id: 45403, cityId: 1894, code: "636804" },
    { id: 45404, cityId: 1894, code: "636805" },
    { id: 45405, cityId: 1894, code: "636812" },
    { id: 45406, cityId: 1894, code: "636813" },
    { id: 45407, cityId: 1894, code: "636821" },
    { id: 45408, cityId: 1894, code: "636908" },
    { id: 45409, cityId: 1894, code: "635103" },
    { id: 45410, cityId: 1894, code: "635105" },
    { id: 45411, cityId: 1894, code: "635106" },
    { id: 45412, cityId: 1894, code: "635108" },
    { id: 45413, cityId: 1894, code: "635111" },
    { id: 45414, cityId: 1894, code: "635113" },
    { id: 45415, cityId: 1894, code: "635114" },
    { id: 45416, cityId: 1894, code: "635119" },
    { id: 45417, cityId: 1894, code: "635121" },
    { id: 45418, cityId: 1894, code: "635122" },
    { id: 45419, cityId: 1894, code: "635127" },
    { id: 45420, cityId: 1894, code: "635129" },
    { id: 45421, cityId: 1894, code: "635130" },
    { id: 45422, cityId: 1894, code: "635132" },
    { id: 45423, cityId: 1894, code: "635137" },
    { id: 45424, cityId: 1894, code: "635140" },
    { id: 45425, cityId: 1894, code: "635201" },
    { id: 45426, cityId: 1894, code: "635203" },
    { id: 45427, cityId: 1894, code: "635204" },
    { id: 45428, cityId: 1894, code: "635206" },
    { id: 45429, cityId: 1894, code: "635209" },
    { id: 45430, cityId: 1894, code: "635211" },
    { id: 45431, cityId: 1894, code: "635212" },
    { id: 45432, cityId: 1894, code: "635301" },
    { id: 45433, cityId: 1894, code: "635302" },
    { id: 45434, cityId: 1894, code: "635304" },
    { id: 45435, cityId: 1894, code: "635307" },
    { id: 45436, cityId: 1894, code: "635309" },
    { id: 45437, cityId: 1894, code: "635310" },
    { id: 45438, cityId: 1894, code: "635312" },
    { id: 45439, cityId: 1894, code: "635601" },
    { id: 45440, cityId: 1894, code: "635611" },
    { id: 45441, cityId: 1894, code: "635659" },
    { id: 45442, cityId: 1894, code: "635662" },
    { id: 45443, cityId: 1894, code: "635704" },
    { id: 45444, cityId: 1894, code: "635707" },
    { id: 45445, cityId: 1894, code: "635709" },
    { id: 45446, cityId: 1894, code: "635754" },
    { id: 45447, cityId: 1894, code: "635755" },
    { id: 45448, cityId: 1894, code: "635757" },
    { id: 45449, cityId: 1894, code: "635816" },
    { id: 45450, cityId: 1894, code: "635818" },
    { id: 45451, cityId: 1894, code: "635820" },
    { id: 45452, cityId: 1894, code: "635821" },
    { id: 45453, cityId: 1894, code: "635823" },
    { id: 45454, cityId: 1894, code: "635826" },
    { id: 45455, cityId: 1894, code: "635855" },
    { id: 45456, cityId: 1894, code: "636702" },
    { id: 45457, cityId: 1894, code: "636703" },
    { id: 45458, cityId: 1894, code: "636705" },
    { id: 45459, cityId: 1894, code: "636803" },
    { id: 45460, cityId: 1894, code: "636809" },
    { id: 45461, cityId: 1894, code: "636811" },
    { id: 45462, cityId: 1894, code: "636816" },
    { id: 45463, cityId: 1894, code: "636904" },
    { id: 45464, cityId: 1894, code: "636915" },
    { id: 45465, cityId: 1895, code: "624002" },
    { id: 45466, cityId: 1895, code: "624004" },
    { id: 45467, cityId: 1895, code: "624005" },
    { id: 45468, cityId: 1895, code: "624007" },
    { id: 45469, cityId: 1895, code: "624010" },
    { id: 45470, cityId: 1895, code: "624052" },
    { id: 45471, cityId: 1895, code: "624102" },
    { id: 45472, cityId: 1895, code: "624103" },
    { id: 45473, cityId: 1895, code: "624108" },
    { id: 45474, cityId: 1895, code: "624201" },
    { id: 45475, cityId: 1895, code: "624203" },
    { id: 45476, cityId: 1895, code: "624208" },
    { id: 45477, cityId: 1895, code: "624209" },
    { id: 45478, cityId: 1895, code: "624211" },
    { id: 45479, cityId: 1895, code: "624214" },
    { id: 45480, cityId: 1895, code: "624216" },
    { id: 45481, cityId: 1895, code: "624217" },
    { id: 45482, cityId: 1895, code: "624219" },
    { id: 45483, cityId: 1895, code: "624222" },
    { id: 45484, cityId: 1895, code: "624227" },
    { id: 45485, cityId: 1895, code: "624230" },
    { id: 45486, cityId: 1895, code: "624232" },
    { id: 45487, cityId: 1895, code: "624235" },
    { id: 45488, cityId: 1895, code: "624304" },
    { id: 45489, cityId: 1895, code: "624306" },
    { id: 45490, cityId: 1895, code: "624307" },
    { id: 45491, cityId: 1895, code: "624309" },
    { id: 45492, cityId: 1895, code: "624312" },
    { id: 45493, cityId: 1895, code: "624314" },
    { id: 45494, cityId: 1895, code: "624315" },
    { id: 45495, cityId: 1895, code: "624317" },
    { id: 45496, cityId: 1895, code: "624503" },
    { id: 45497, cityId: 1895, code: "624601" },
    { id: 45498, cityId: 1895, code: "624614" },
    { id: 45499, cityId: 1895, code: "624616" },
    { id: 45500, cityId: 1895, code: "624621" },
    { id: 45501, cityId: 1895, code: "624622" },
    { id: 45502, cityId: 1895, code: "624624" },
    { id: 45503, cityId: 1895, code: "624627" },
    { id: 45504, cityId: 1895, code: "624701" },
    { id: 45505, cityId: 1895, code: "624704" },
    { id: 45506, cityId: 1895, code: "624706" },
    { id: 45507, cityId: 1895, code: "624707" },
    { id: 45508, cityId: 1895, code: "624709" },
    { id: 45509, cityId: 1895, code: "624712" },
    { id: 45510, cityId: 1895, code: "624714" },
    { id: 45511, cityId: 1895, code: "624804" },
    { id: 45512, cityId: 1895, code: "624001" },
    { id: 45513, cityId: 1895, code: "624003" },
    { id: 45514, cityId: 1895, code: "624006" },
    { id: 45515, cityId: 1895, code: "624008" },
    { id: 45516, cityId: 1895, code: "624009" },
    { id: 45517, cityId: 1895, code: "624051" },
    { id: 45518, cityId: 1895, code: "624053" },
    { id: 45519, cityId: 1895, code: "624054" },
    { id: 45520, cityId: 1895, code: "624101" },
    { id: 45521, cityId: 1895, code: "624104" },
    { id: 45522, cityId: 1895, code: "624107" },
    { id: 45523, cityId: 1895, code: "624202" },
    { id: 45524, cityId: 1895, code: "624204" },
    { id: 45525, cityId: 1895, code: "624205" },
    { id: 45526, cityId: 1895, code: "624207" },
    { id: 45527, cityId: 1895, code: "624212" },
    { id: 45528, cityId: 1895, code: "624213" },
    { id: 45529, cityId: 1895, code: "624220" },
    { id: 45530, cityId: 1895, code: "624221" },
    { id: 45531, cityId: 1895, code: "624223" },
    { id: 45532, cityId: 1895, code: "624228" },
    { id: 45533, cityId: 1895, code: "624231" },
    { id: 45534, cityId: 1895, code: "624234" },
    { id: 45535, cityId: 1895, code: "624302" },
    { id: 45536, cityId: 1895, code: "624303" },
    { id: 45537, cityId: 1895, code: "624305" },
    { id: 45538, cityId: 1895, code: "624308" },
    { id: 45539, cityId: 1895, code: "624310" },
    { id: 45540, cityId: 1895, code: "624311" },
    { id: 45541, cityId: 1895, code: "624313" },
    { id: 45542, cityId: 1895, code: "624316" },
    { id: 45543, cityId: 1895, code: "624318" },
    { id: 45544, cityId: 1895, code: "624504" },
    { id: 45545, cityId: 1895, code: "624506" },
    { id: 45546, cityId: 1895, code: "624507" },
    { id: 45547, cityId: 1895, code: "624610" },
    { id: 45548, cityId: 1895, code: "624612" },
    { id: 45549, cityId: 1895, code: "624615" },
    { id: 45550, cityId: 1895, code: "624617" },
    { id: 45551, cityId: 1895, code: "624618" },
    { id: 45552, cityId: 1895, code: "624623" },
    { id: 45553, cityId: 1895, code: "624625" },
    { id: 45554, cityId: 1895, code: "624626" },
    { id: 45555, cityId: 1895, code: "624628" },
    { id: 45556, cityId: 1895, code: "624702" },
    { id: 45557, cityId: 1895, code: "624703" },
    { id: 45558, cityId: 1895, code: "624711" },
    { id: 45559, cityId: 1895, code: "624713" },
    { id: 45560, cityId: 1895, code: "625502" },
    { id: 45561, cityId: 1896, code: "631703" },
    { id: 45562, cityId: 1897, code: "627803" },
    { id: 45563, cityId: 1898, code: "626201" },
    { id: 45564, cityId: 1899, code: "628801" },
    { id: 45565, cityId: 1900, code: "638102" },
    { id: 45566, cityId: 1900, code: "638324" },
    { id: 45567, cityId: 1900, code: "638706" },
    { id: 45568, cityId: 1900, code: "639204" },
    { id: 45569, cityId: 1900, code: "624611" },
    { id: 45570, cityId: 1900, code: "635751" },
    { id: 45571, cityId: 1900, code: "638130" },
    { id: 45572, cityId: 1900, code: "638301" },
    { id: 45573, cityId: 1900, code: "638656" },
    { id: 45574, cityId: 1900, code: "638657" },
    { id: 45575, cityId: 1901, code: "600059" },
    { id: 45576, cityId: 1901, code: "629502" },
    { id: 45577, cityId: 1902, code: "627352" },
    { id: 45578, cityId: 1903, code: "636105" },
    { id: 45579, cityId: 1904, code: "638110" },
    { id: 45580, cityId: 1905, code: "636803" },
    { id: 45581, cityId: 1906, code: "626519" },
    { id: 45582, cityId: 1907, code: "635109" },
    { id: 45583, cityId: 1908, code: "627805" },
    { id: 45584, cityId: 1909, code: "641103" },
    { id: 45585, cityId: 1910, code: "643244" },
    { id: 45586, cityId: 1911, code: "638312" },
    { id: 45587, cityId: 1912, code: "679515" },
    { id: 45588, cityId: 1912, code: "605802" },
    { id: 45589, cityId: 1912, code: "670663" },
    { id: 45590, cityId: 1913, code: "635303" },
    { id: 45591, cityId: 1914, code: "627751" },
    { id: 45592, cityId: 1915, code: "606903" },
    { id: 45593, cityId: 1916, code: "641061" },
    { id: 45594, cityId: 1917, code: "637404" },
    { id: 45595, cityId: 1918, code: "632506" },
    { id: 45596, cityId: 1919, code: "621651" },
    { id: 45597, cityId: 1920, code: "627752" },
    { id: 45598, cityId: 1921, code: "626521" },
    { id: 45599, cityId: 1922, code: "635202" },
    { id: 45600, cityId: 1923, code: "623103" },
    { id: 45601, cityId: 1924, code: "628225" },
    { id: 45602, cityId: 1925, code: "601210" },
    { id: 45603, cityId: 1925, code: "603318" },
    { id: 45604, cityId: 1925, code: "607113" },
    { id: 45605, cityId: 1925, code: "631402" },
    { id: 45606, cityId: 1925, code: "638148" },
    { id: 45607, cityId: 1925, code: "603002" },
    { id: 45608, cityId: 1925, code: "603118" },
    { id: 45609, cityId: 1925, code: "603309" },
    { id: 45610, cityId: 1925, code: "603401" },
    { id: 45611, cityId: 1926, code: "623104" },
    { id: 45612, cityId: 1927, code: "641401" },
    { id: 45613, cityId: 1928, code: "638203" },
    { id: 45614, cityId: 1929, code: "638116" },
    { id: 45615, cityId: 1930, code: "632311" },
    { id: 45616, cityId: 1931, code: "641405" },
    { id: 45617, cityId: 1932, code: "636008" },
    { id: 45618, cityId: 1933, code: "624705" },
    { id: 45619, cityId: 1934, code: "629153" },
    { id: 45620, cityId: 1934, code: "629003" },
    { id: 45621, cityId: 1934, code: "629051" },
    { id: 45622, cityId: 1934, code: "629101" },
    { id: 45623, cityId: 1934, code: "629151" },
    { id: 45624, cityId: 1934, code: "629152" },
    { id: 45625, cityId: 1934, code: "629154" },
    { id: 45626, cityId: 1934, code: "629156" },
    { id: 45627, cityId: 1934, code: "629157" },
    { id: 45628, cityId: 1934, code: "629159" },
    { id: 45629, cityId: 1934, code: "629162" },
    { id: 45630, cityId: 1934, code: "629164" },
    { id: 45631, cityId: 1934, code: "629165" },
    { id: 45632, cityId: 1934, code: "629167" },
    { id: 45633, cityId: 1934, code: "629170" },
    { id: 45634, cityId: 1934, code: "629172" },
    { id: 45635, cityId: 1934, code: "629173" },
    { id: 45636, cityId: 1934, code: "629175" },
    { id: 45637, cityId: 1934, code: "629178" },
    { id: 45638, cityId: 1934, code: "629181" },
    { id: 45639, cityId: 1934, code: "629183" },
    { id: 45640, cityId: 1934, code: "629188" },
    { id: 45641, cityId: 1934, code: "629189" },
    { id: 45642, cityId: 1934, code: "629191" },
    { id: 45643, cityId: 1934, code: "629196" },
    { id: 45644, cityId: 1934, code: "629197" },
    { id: 45645, cityId: 1934, code: "629202" },
    { id: 45646, cityId: 1934, code: "629204" },
    { id: 45647, cityId: 1934, code: "629305" },
    { id: 45648, cityId: 1934, code: "629403" },
    { id: 45649, cityId: 1934, code: "629501" },
    { id: 45650, cityId: 1934, code: "629503" },
    { id: 45651, cityId: 1934, code: "629504" },
    { id: 45652, cityId: 1934, code: "629509" },
    { id: 45653, cityId: 1934, code: "629601" },
    { id: 45654, cityId: 1934, code: "629702" },
    { id: 45655, cityId: 1934, code: "629708" },
    { id: 45656, cityId: 1934, code: "629803" },
    { id: 45657, cityId: 1934, code: "629805" },
    { id: 45658, cityId: 1934, code: "629806" },
    { id: 45659, cityId: 1934, code: "629808" },
    { id: 45660, cityId: 1934, code: "629851" },
    { id: 45661, cityId: 1934, code: "629901" },
    { id: 45662, cityId: 1934, code: "629002" },
    { id: 45663, cityId: 1934, code: "629004" },
    { id: 45664, cityId: 1934, code: "629102" },
    { id: 45665, cityId: 1934, code: "629153" },
    { id: 45666, cityId: 1934, code: "629155" },
    { id: 45667, cityId: 1934, code: "629158" },
    { id: 45668, cityId: 1934, code: "629160" },
    { id: 45669, cityId: 1934, code: "629161" },
    { id: 45670, cityId: 1934, code: "629163" },
    { id: 45671, cityId: 1934, code: "629166" },
    { id: 45672, cityId: 1934, code: "629168" },
    { id: 45673, cityId: 1934, code: "629169" },
    { id: 45674, cityId: 1934, code: "629171" },
    { id: 45675, cityId: 1934, code: "629174" },
    { id: 45676, cityId: 1934, code: "629177" },
    { id: 45677, cityId: 1934, code: "629179" },
    { id: 45678, cityId: 1934, code: "629182" },
    { id: 45679, cityId: 1934, code: "629190" },
    { id: 45680, cityId: 1934, code: "629192" },
    { id: 45681, cityId: 1934, code: "629193" },
    { id: 45682, cityId: 1934, code: "629195" },
    { id: 45683, cityId: 1934, code: "629201" },
    { id: 45684, cityId: 1934, code: "629203" },
    { id: 45685, cityId: 1934, code: "629205" },
    { id: 45686, cityId: 1934, code: "629251" },
    { id: 45687, cityId: 1934, code: "629253" },
    { id: 45688, cityId: 1934, code: "629301" },
    { id: 45689, cityId: 1934, code: "629304" },
    { id: 45690, cityId: 1934, code: "629401" },
    { id: 45691, cityId: 1934, code: "629402" },
    { id: 45692, cityId: 1934, code: "629404" },
    { id: 45693, cityId: 1934, code: "629603" },
    { id: 45694, cityId: 1934, code: "629664" },
    { id: 45695, cityId: 1934, code: "629701" },
    { id: 45696, cityId: 1934, code: "629704" },
    { id: 45697, cityId: 1934, code: "629706" },
    { id: 45698, cityId: 1934, code: "629801" },
    { id: 45699, cityId: 1934, code: "629802" },
    { id: 45700, cityId: 1934, code: "629804" },
    { id: 45701, cityId: 1934, code: "629807" },
    { id: 45702, cityId: 1934, code: "629809" },
    { id: 45703, cityId: 1934, code: "629852" },
    { id: 45704, cityId: 1934, code: "629854" },
    { id: 45705, cityId: 1934, code: "629855" },
    { id: 45706, cityId: 1934, code: "629902" },
    { id: 45707, cityId: 1935, code: "641104" },
    { id: 45708, cityId: 1936, code: "636012" },
    { id: 45709, cityId: 1937, code: "604213" },
    { id: 45710, cityId: 1937, code: "621313" },
    { id: 45711, cityId: 1937, code: "627763" },
    { id: 45712, cityId: 1937, code: "636305" },
    { id: 45713, cityId: 1937, code: "626541" },
    { id: 45714, cityId: 1938, code: "632007" },
    { id: 45715, cityId: 1939, code: "608301" },
    { id: 45716, cityId: 1940, code: "614626" },
    { id: 45717, cityId: 1941, code: "629187" },
    { id: 45718, cityId: 1942, code: "604601" },
    { id: 45719, cityId: 1943, code: "611104" },
    { id: 45720, cityId: 1944, code: "642109" },
    { id: 45721, cityId: 1945, code: "624101" },
    { id: 45722, cityId: 1946, code: "612601" },
    { id: 45723, cityId: 1947, code: "638151" },
    { id: 45724, cityId: 1948, code: "638661" },
    { id: 45725, cityId: 1949, code: "600099" },
    { id: 45726, cityId: 1949, code: "636303" },
    { id: 45727, cityId: 1950, code: "638204" },
    { id: 45728, cityId: 1951, code: "626522" },
    { id: 45729, cityId: 1952, code: "632013" },
    { id: 45730, cityId: 1953, code: "636010" },
    { id: 45731, cityId: 1954, code: "637102" },
    { id: 45732, cityId: 1955, code: "613703" },
    { id: 45733, cityId: 1956, code: "643217" },
    { id: 45734, cityId: 1957, code: "623106" },
    { id: 45735, cityId: 1958, code: "605104" },
    { id: 45736, cityId: 1959, code: "629703" },
    { id: 45737, cityId: 1960, code: "614708" },
    { id: 45738, cityId: 1961, code: "642110" },
    { id: 45739, cityId: 1962, code: "621305" },
    { id: 45740, cityId: 1962, code: "626549" },
    { id: 45741, cityId: 1962, code: "627701" },
    { id: 45742, cityId: 1962, code: "627702" },
    { id: 45743, cityId: 1963, code: "635001" },
    { id: 45744, cityId: 1963, code: "635101" },
    { id: 45745, cityId: 1963, code: "635002" },
    { id: 45746, cityId: 1964, code: "639102" },
    { id: 45747, cityId: 1965, code: "629406" },
    { id: 45748, cityId: 1966, code: "641008" },
    { id: 45749, cityId: 1967, code: "607302" },
    { id: 45750, cityId: 1968, code: "641017" },
    { id: 45751, cityId: 1969, code: "621107" },
    { id: 45752, cityId: 1970, code: "621108" },
    { id: 45753, cityId: 1971, code: "621729" },
    { id: 45754, cityId: 1972, code: "608303" },
    { id: 45755, cityId: 1973, code: "642113" },
    { id: 45756, cityId: 1974, code: "641105" },
    { id: 45757, cityId: 1975, code: "614903" },
    { id: 45758, cityId: 1976, code: "624215" },
    { id: 45759, cityId: 1976, code: "625001" },
    { id: 45760, cityId: 1976, code: "625002" },
    { id: 45761, cityId: 1976, code: "625004" },
    { id: 45762, cityId: 1976, code: "625007" },
    { id: 45763, cityId: 1976, code: "625009" },
    { id: 45764, cityId: 1976, code: "625010" },
    { id: 45765, cityId: 1976, code: "625012" },
    { id: 45766, cityId: 1976, code: "625015" },
    { id: 45767, cityId: 1976, code: "625018" },
    { id: 45768, cityId: 1976, code: "625020" },
    { id: 45769, cityId: 1976, code: "625022" },
    { id: 45770, cityId: 1976, code: "625052" },
    { id: 45771, cityId: 1976, code: "625102" },
    { id: 45772, cityId: 1976, code: "625105" },
    { id: 45773, cityId: 1976, code: "625108" },
    { id: 45774, cityId: 1976, code: "625113" },
    { id: 45775, cityId: 1976, code: "625115" },
    { id: 45776, cityId: 1976, code: "625116" },
    { id: 45777, cityId: 1976, code: "625118" },
    { id: 45778, cityId: 1976, code: "625120" },
    { id: 45779, cityId: 1976, code: "625121" },
    { id: 45780, cityId: 1976, code: "625123" },
    { id: 45781, cityId: 1976, code: "625126" },
    { id: 45782, cityId: 1976, code: "625206" },
    { id: 45783, cityId: 1976, code: "625301" },
    { id: 45784, cityId: 1976, code: "625303" },
    { id: 45785, cityId: 1976, code: "625304" },
    { id: 45786, cityId: 1976, code: "625401" },
    { id: 45787, cityId: 1976, code: "625402" },
    { id: 45788, cityId: 1976, code: "626501" },
    { id: 45789, cityId: 1976, code: "626514" },
    { id: 45790, cityId: 1976, code: "626516" },
    { id: 45791, cityId: 1976, code: "626517" },
    { id: 45792, cityId: 1976, code: "626525" },
    { id: 45793, cityId: 1976, code: "626527" },
    { id: 45794, cityId: 1976, code: "626530" },
    { id: 45795, cityId: 1976, code: "626532" },
    { id: 45796, cityId: 1976, code: "626535" },
    { id: 45797, cityId: 1976, code: "626537" },
    { id: 45798, cityId: 1976, code: "626538" },
    { id: 45799, cityId: 1976, code: "626540" },
    { id: 45800, cityId: 1976, code: "626553" },
    { id: 45801, cityId: 1976, code: "626562" },
    { id: 45802, cityId: 1976, code: "626569" },
    { id: 45803, cityId: 1976, code: "626582" },
    { id: 45804, cityId: 1976, code: "626702" },
    { id: 45805, cityId: 1976, code: "626705" },
    { id: 45806, cityId: 1976, code: "626712" },
    { id: 45807, cityId: 1976, code: "638001" },
    { id: 45808, cityId: 1976, code: "638003" },
    { id: 45809, cityId: 1976, code: "638009" },
    { id: 45810, cityId: 1976, code: "638011" },
    { id: 45811, cityId: 1976, code: "638051" },
    { id: 45812, cityId: 1976, code: "638053" },
    { id: 45813, cityId: 1976, code: "638054" },
    { id: 45814, cityId: 1976, code: "638056" },
    { id: 45815, cityId: 1976, code: "638059" },
    { id: 45816, cityId: 1976, code: "638112" },
    { id: 45817, cityId: 1976, code: "638115" },
    { id: 45818, cityId: 1976, code: "638117" },
    { id: 45819, cityId: 1976, code: "638152" },
    { id: 45820, cityId: 1976, code: "638202" },
    { id: 45821, cityId: 1976, code: "638205" },
    { id: 45822, cityId: 1976, code: "638207" },
    { id: 45823, cityId: 1976, code: "638302" },
    { id: 45824, cityId: 1976, code: "638311" },
    { id: 45825, cityId: 1976, code: "638313" },
    { id: 45826, cityId: 1976, code: "638316" },
    { id: 45827, cityId: 1976, code: "638401" },
    { id: 45828, cityId: 1976, code: "638403" },
    { id: 45829, cityId: 1976, code: "638451" },
    { id: 45830, cityId: 1976, code: "638453" },
    { id: 45831, cityId: 1976, code: "638454" },
    { id: 45832, cityId: 1976, code: "638456" },
    { id: 45833, cityId: 1976, code: "638459" },
    { id: 45834, cityId: 1976, code: "638461" },
    { id: 45835, cityId: 1976, code: "638462" },
    { id: 45836, cityId: 1976, code: "638466" },
    { id: 45837, cityId: 1976, code: "638469" },
    { id: 45838, cityId: 1976, code: "638501" },
    { id: 45839, cityId: 1976, code: "638504" },
    { id: 45840, cityId: 1976, code: "638506" },
    { id: 45841, cityId: 1976, code: "638511" },
    { id: 45842, cityId: 1976, code: "638602" },
    { id: 45843, cityId: 1976, code: "638607" },
    { id: 45844, cityId: 1976, code: "638652" },
    { id: 45845, cityId: 1976, code: "638655" },
    { id: 45846, cityId: 1976, code: "638660" },
    { id: 45847, cityId: 1976, code: "638662" },
    { id: 45848, cityId: 1976, code: "638663" },
    { id: 45849, cityId: 1976, code: "638665" },
    { id: 45850, cityId: 1976, code: "638668" },
    { id: 45851, cityId: 1976, code: "638670" },
    { id: 45852, cityId: 1976, code: "638671" },
    { id: 45853, cityId: 1976, code: "638673" },
    { id: 45854, cityId: 1976, code: "638684" },
    { id: 45855, cityId: 1976, code: "638687" },
    { id: 45856, cityId: 1976, code: "638697" },
    { id: 45857, cityId: 1976, code: "638702" },
    { id: 45858, cityId: 1976, code: "638703" },
    { id: 45859, cityId: 1976, code: "638710" },
    { id: 45860, cityId: 1976, code: "638806" },
    { id: 45861, cityId: 1976, code: "639001" },
    { id: 45862, cityId: 1976, code: "639002" },
    { id: 45863, cityId: 1976, code: "639004" },
    { id: 45864, cityId: 1976, code: "639105" },
    { id: 45865, cityId: 1976, code: "639108" },
    { id: 45866, cityId: 1976, code: "639110" },
    { id: 45867, cityId: 1976, code: "639113" },
    { id: 45868, cityId: 1976, code: "639115" },
    { id: 45869, cityId: 1976, code: "639116" },
    { id: 45870, cityId: 1976, code: "639118" },
    { id: 45871, cityId: 1976, code: "639121" },
    { id: 45872, cityId: 1976, code: "639147" },
    { id: 45873, cityId: 1976, code: "639203" },
    { id: 45874, cityId: 1976, code: "639206" },
    { id: 45875, cityId: 1976, code: "641102" },
    { id: 45876, cityId: 1976, code: "641113" },
    { id: 45877, cityId: 1976, code: "624401" },
    { id: 45878, cityId: 1976, code: "624402" },
    { id: 45879, cityId: 1976, code: "624404" },
    { id: 45880, cityId: 1976, code: "625003" },
    { id: 45881, cityId: 1976, code: "625005" },
    { id: 45882, cityId: 1976, code: "625006" },
    { id: 45883, cityId: 1976, code: "625008" },
    { id: 45884, cityId: 1976, code: "625011" },
    { id: 45885, cityId: 1976, code: "625014" },
    { id: 45886, cityId: 1976, code: "625016" },
    { id: 45887, cityId: 1976, code: "625021" },
    { id: 45888, cityId: 1976, code: "625051" },
    { id: 45889, cityId: 1976, code: "625101" },
    { id: 45890, cityId: 1976, code: "625103" },
    { id: 45891, cityId: 1976, code: "625104" },
    { id: 45892, cityId: 1976, code: "625106" },
    { id: 45893, cityId: 1976, code: "625111" },
    { id: 45894, cityId: 1976, code: "625112" },
    { id: 45895, cityId: 1976, code: "625114" },
    { id: 45896, cityId: 1976, code: "625119" },
    { id: 45897, cityId: 1976, code: "625122" },
    { id: 45898, cityId: 1976, code: "625124" },
    { id: 45899, cityId: 1976, code: "625125" },
    { id: 45900, cityId: 1976, code: "625127" },
    { id: 45901, cityId: 1976, code: "625201" },
    { id: 45902, cityId: 1976, code: "625302" },
    { id: 45903, cityId: 1976, code: "625305" },
    { id: 45904, cityId: 1976, code: "625403" },
    { id: 45905, cityId: 1976, code: "625504" },
    { id: 45906, cityId: 1976, code: "625577" },
    { id: 45907, cityId: 1976, code: "625602" },
    { id: 45908, cityId: 1976, code: "626512" },
    { id: 45909, cityId: 1976, code: "626513" },
    { id: 45910, cityId: 1976, code: "626518" },
    { id: 45911, cityId: 1976, code: "626520" },
    { id: 45912, cityId: 1976, code: "626523" },
    { id: 45913, cityId: 1976, code: "626526" },
    { id: 45914, cityId: 1976, code: "626528" },
    { id: 45915, cityId: 1976, code: "626529" },
    { id: 45916, cityId: 1976, code: "626531" },
    { id: 45917, cityId: 1976, code: "626533" },
    { id: 45918, cityId: 1976, code: "626536" },
    { id: 45919, cityId: 1976, code: "626539" },
    { id: 45920, cityId: 1976, code: "626541" },
    { id: 45921, cityId: 1976, code: "626544" },
    { id: 45922, cityId: 1976, code: "626547" },
    { id: 45923, cityId: 1976, code: "626555" },
    { id: 45924, cityId: 1976, code: "626565" },
    { id: 45925, cityId: 1976, code: "626566" },
    { id: 45926, cityId: 1976, code: "626571" },
    { id: 45927, cityId: 1976, code: "626701" },
    { id: 45928, cityId: 1976, code: "626703" },
    { id: 45929, cityId: 1976, code: "626706" },
    { id: 45930, cityId: 1976, code: "626709" },
    { id: 45931, cityId: 1976, code: "626717" },
    { id: 45932, cityId: 1976, code: "626719" },
    { id: 45933, cityId: 1976, code: "636815" },
    { id: 45934, cityId: 1976, code: "638002" },
    { id: 45935, cityId: 1976, code: "638004" },
    { id: 45936, cityId: 1976, code: "638005" },
    { id: 45937, cityId: 1976, code: "638007" },
    { id: 45938, cityId: 1976, code: "638010" },
    { id: 45939, cityId: 1976, code: "638055" },
    { id: 45940, cityId: 1976, code: "638057" },
    { id: 45941, cityId: 1976, code: "638058" },
    { id: 45942, cityId: 1976, code: "638102" },
    { id: 45943, cityId: 1976, code: "638103" },
    { id: 45944, cityId: 1976, code: "638108" },
    { id: 45945, cityId: 1976, code: "638110" },
    { id: 45946, cityId: 1976, code: "638118" },
    { id: 45947, cityId: 1976, code: "638129" },
    { id: 45948, cityId: 1976, code: "638153" },
    { id: 45949, cityId: 1976, code: "638206" },
    { id: 45950, cityId: 1976, code: "638301" },
    { id: 45951, cityId: 1976, code: "638312" },
    { id: 45952, cityId: 1976, code: "638315" },
    { id: 45953, cityId: 1976, code: "638319" },
    { id: 45954, cityId: 1976, code: "638327" },
    { id: 45955, cityId: 1976, code: "638328" },
    { id: 45956, cityId: 1976, code: "638404" },
    { id: 45957, cityId: 1976, code: "638452" },
    { id: 45958, cityId: 1976, code: "638457" },
    { id: 45959, cityId: 1976, code: "638460" },
    { id: 45960, cityId: 1976, code: "638470" },
    { id: 45961, cityId: 1976, code: "638471" },
    { id: 45962, cityId: 1976, code: "638476" },
    { id: 45963, cityId: 1976, code: "638503" },
    { id: 45964, cityId: 1976, code: "638505" },
    { id: 45965, cityId: 1976, code: "638601" },
    { id: 45966, cityId: 1976, code: "638603" },
    { id: 45967, cityId: 1976, code: "638606" },
    { id: 45968, cityId: 1976, code: "638653" },
    { id: 45969, cityId: 1976, code: "638654" },
    { id: 45970, cityId: 1976, code: "638656" },
    { id: 45971, cityId: 1976, code: "638658" },
    { id: 45972, cityId: 1976, code: "638666" },
    { id: 45973, cityId: 1976, code: "638667" },
    { id: 45974, cityId: 1976, code: "638669" },
    { id: 45975, cityId: 1976, code: "638672" },
    { id: 45976, cityId: 1976, code: "638675" },
    { id: 45977, cityId: 1976, code: "638683" },
    { id: 45978, cityId: 1976, code: "638696" },
    { id: 45979, cityId: 1976, code: "638701" },
    { id: 45980, cityId: 1976, code: "638751" },
    { id: 45981, cityId: 1976, code: "638752" },
    { id: 45982, cityId: 1976, code: "638802" },
    { id: 45983, cityId: 1976, code: "638807" },
    { id: 45984, cityId: 1976, code: "638812" },
    { id: 45985, cityId: 1976, code: "639003" },
    { id: 45986, cityId: 1976, code: "639005" },
    { id: 45987, cityId: 1976, code: "639006" },
    { id: 45988, cityId: 1976, code: "639101" },
    { id: 45989, cityId: 1976, code: "639103" },
    { id: 45990, cityId: 1976, code: "639104" },
    { id: 45991, cityId: 1976, code: "639106" },
    { id: 45992, cityId: 1976, code: "639109" },
    { id: 45993, cityId: 1976, code: "639112" },
    { id: 45994, cityId: 1976, code: "639117" },
    { id: 45995, cityId: 1976, code: "639119" },
    { id: 45996, cityId: 1976, code: "639120" },
    { id: 45997, cityId: 1976, code: "639144" },
    { id: 45998, cityId: 1976, code: "639202" },
    { id: 45999, cityId: 1976, code: "639210" },
    { id: 46000, cityId: 1976, code: "639212" },
    { id: 46001, cityId: 1976, code: "641304" },
    { id: 46002, cityId: 1976, code: "641305" },
    { id: 46003, cityId: 1977, code: "602102" },
    { id: 46004, cityId: 1978, code: "637503" },
    { id: 46005, cityId: 1979, code: "603104" },
    { id: 46006, cityId: 1980, code: "621005" },
    { id: 46007, cityId: 1981, code: "600068" },
    { id: 46008, cityId: 1981, code: "600103" },
    { id: 46009, cityId: 1981, code: "610210" },
    { id: 46010, cityId: 1982, code: "609202" },
    { id: 46011, cityId: 1983, code: "605754" },
    { id: 46012, cityId: 1984, code: "629252" },
    { id: 46013, cityId: 1985, code: "623518" },
    { id: 46014, cityId: 1985, code: "623519" },
    { id: 46015, cityId: 1986, code: "602101" },
    { id: 46016, cityId: 1987, code: "606752" },
    { id: 46017, cityId: 1988, code: "603209" },
    { id: 46018, cityId: 1989, code: "636806" },
    { id: 46019, cityId: 1990, code: "639107" },
    { id: 46020, cityId: 1991, code: "636453" },
    { id: 46021, cityId: 1992, code: "627818" },
    { id: 46022, cityId: 1993, code: "614301" },
    { id: 46023, cityId: 1994, code: "621210" },
    { id: 46024, cityId: 1994, code: "600033" },
    { id: 46025, cityId: 1995, code: "627436" },
    { id: 46026, cityId: 1996, code: "601203" },
    { id: 46027, cityId: 1997, code: "638104" },
    { id: 46028, cityId: 1998, code: "637015" },
    { id: 46029, cityId: 1999, code: "623704" },
    { id: 46030, cityId: 2000, code: "627601" },
    { id: 46031, cityId: 2001, code: "638106" },
    { id: 46032, cityId: 2002, code: "638105" },
    { id: 46033, cityId: 2003, code: "643224" },
    { id: 46034, cityId: 2004, code: "609109" },
    { id: 46035, cityId: 2004, code: "609116" },
    { id: 46036, cityId: 2004, code: "609130" },
    { id: 46037, cityId: 2004, code: "609104" },
    { id: 46038, cityId: 2004, code: "609110" },
    { id: 46039, cityId: 2004, code: "609120" },
    { id: 46040, cityId: 2004, code: "609123" },
    { id: 46041, cityId: 2004, code: "609128" },
    { id: 46042, cityId: 2004, code: "609131" },
    { id: 46043, cityId: 2004, code: "611001" },
    { id: 46044, cityId: 2004, code: "622054" },
    { id: 46045, cityId: 2004, code: "624226" },
    { id: 46046, cityId: 2005, code: "629165" },
    { id: 46047, cityId: 2005, code: "606302" },
    { id: 46048, cityId: 2005, code: "627853" },
    { id: 46049, cityId: 2006, code: "637408" },
    { id: 46050, cityId: 2007, code: "638458" },
    { id: 46051, cityId: 2008, code: "636454" },
    { id: 46052, cityId: 2009, code: "627108" },
    { id: 46053, cityId: 2010, code: "610105" },
    { id: 46054, cityId: 2011, code: "626184" },
    { id: 46055, cityId: 2012, code: "626579" },
    { id: 46056, cityId: 2012, code: "636108" },
    { id: 46057, cityId: 2013, code: "638107" },
    { id: 46058, cityId: 2014, code: "623556" },
    { id: 46059, cityId: 2015, code: "607105" },
    { id: 46060, cityId: 2016, code: "622405" },
    { id: 46061, cityId: 2017, code: "607801" },
    { id: 46062, cityId: 2017, code: "607802" },
    { id: 46063, cityId: 2018, code: "624619" },
    { id: 46064, cityId: 2019, code: "638314" },
    { id: 46065, cityId: 2020, code: "636455" },
    { id: 46066, cityId: 2021, code: "625107" },
    { id: 46067, cityId: 2022, code: "641032" },
    { id: 46068, cityId: 2023, code: "629168" },
    { id: 46069, cityId: 2024, code: "637306" },
    { id: 46070, cityId: 2025, code: "600052" },
    { id: 46071, cityId: 2026, code: "629175" },
    { id: 46072, cityId: 2027, code: "602028" },
    { id: 46073, cityId: 2028, code: "624620" },
    { id: 46074, cityId: 2029, code: "638664" },
    { id: 46075, cityId: 2030, code: "636009" },
    { id: 46076, cityId: 2030, code: "624233" },
    { id: 46077, cityId: 2030, code: "625117" },
    { id: 46078, cityId: 2030, code: "639205" },
    { id: 46079, cityId: 2030, code: "639207" },
    { id: 46080, cityId: 2031, code: "623107" },
    { id: 46081, cityId: 2032, code: "635809" },
    { id: 46082, cityId: 2033, code: "628226" },
    { id: 46083, cityId: 2034, code: "600075" },
    { id: 46084, cityId: 2035, code: "627109" },
    { id: 46085, cityId: 2036, code: "631052" },
    { id: 46086, cityId: 2037, code: "624210" },
    { id: 46087, cityId: 2038, code: "626524" },
    { id: 46088, cityId: 2039, code: "607106" },
    { id: 46089, cityId: 2040, code: "636905" },
    { id: 46090, cityId: 2041, code: "639111" },
    { id: 46091, cityId: 2042, code: "608502" },
    { id: 46092, cityId: 2043, code: "625404" },
    { id: 46093, cityId: 2044, code: "638154" },
    { id: 46094, cityId: 2045, code: "606105" },
    { id: 46095, cityId: 2046, code: "636810" },
    { id: 46096, cityId: 2047, code: "632011" },
    { id: 46097, cityId: 2048, code: "614027" },
    { id: 46098, cityId: 2048, code: "623708" },
    { id: 46099, cityId: 2049, code: "609405" },
    { id: 46100, cityId: 2050, code: "612101" },
    { id: 46101, cityId: 2050, code: "621212" },
    { id: 46102, cityId: 2050, code: "621708" },
    { id: 46103, cityId: 2050, code: "621129" },
    { id: 46104, cityId: 2051, code: "626534" },
    { id: 46105, cityId: 2052, code: "638052" },
    { id: 46106, cityId: 2053, code: "600096" },
    { id: 46107, cityId: 2054, code: "623536" },
    { id: 46108, cityId: 2054, code: "628752" },
    { id: 46109, cityId: 2055, code: "641010" },
    { id: 46110, cityId: 2056, code: "600074" },
    { id: 46111, cityId: 2057, code: "642001" },
    { id: 46112, cityId: 2057, code: "642146" },
    { id: 46113, cityId: 2058, code: "606803" },
    { id: 46114, cityId: 2059, code: "601204" },
    { id: 46115, cityId: 2060, code: "621110" },
    { id: 46116, cityId: 2061, code: "637107" },
    { id: 46117, cityId: 2062, code: "600056" },
    { id: 46118, cityId: 2063, code: "602104" },
    { id: 46119, cityId: 2064, code: "626182" },
    { id: 46120, cityId: 2064, code: "622001" },
    { id: 46121, cityId: 2064, code: "628103" },
    { id: 46122, cityId: 2065, code: "614616" },
    { id: 46123, cityId: 2065, code: "614801" },
    { id: 46124, cityId: 2065, code: "622003" },
    { id: 46125, cityId: 2065, code: "622005" },
    { id: 46126, cityId: 2065, code: "622053" },
    { id: 46127, cityId: 2065, code: "622056" },
    { id: 46128, cityId: 2065, code: "622103" },
    { id: 46129, cityId: 2065, code: "622104" },
    { id: 46130, cityId: 2065, code: "622106" },
    { id: 46131, cityId: 2065, code: "622202" },
    { id: 46132, cityId: 2065, code: "622204" },
    { id: 46133, cityId: 2065, code: "622206" },
    { id: 46134, cityId: 2065, code: "622207" },
    { id: 46135, cityId: 2065, code: "622212" },
    { id: 46136, cityId: 2065, code: "622302" },
    { id: 46137, cityId: 2065, code: "622304" },
    { id: 46138, cityId: 2065, code: "622305" },
    { id: 46139, cityId: 2065, code: "622307" },
    { id: 46140, cityId: 2065, code: "622310" },
    { id: 46141, cityId: 2065, code: "622312" },
    { id: 46142, cityId: 2065, code: "622313" },
    { id: 46143, cityId: 2065, code: "622315" },
    { id: 46144, cityId: 2065, code: "622402" },
    { id: 46145, cityId: 2065, code: "622403" },
    { id: 46146, cityId: 2065, code: "622408" },
    { id: 46147, cityId: 2065, code: "622410" },
    { id: 46148, cityId: 2065, code: "622411" },
    { id: 46149, cityId: 2065, code: "622413" },
    { id: 46150, cityId: 2065, code: "622416" },
    { id: 46151, cityId: 2065, code: "622419" },
    { id: 46152, cityId: 2065, code: "622421" },
    { id: 46153, cityId: 2065, code: "622501" },
    { id: 46154, cityId: 2065, code: "622503" },
    { id: 46155, cityId: 2065, code: "622506" },
    { id: 46156, cityId: 2065, code: "622508" },
    { id: 46157, cityId: 2065, code: "622509" },
    { id: 46158, cityId: 2065, code: "622511" },
    { id: 46159, cityId: 2065, code: "622514" },
    { id: 46160, cityId: 2065, code: "621316" },
    { id: 46161, cityId: 2065, code: "622001" },
    { id: 46162, cityId: 2065, code: "622002" },
    { id: 46163, cityId: 2065, code: "622004" },
    { id: 46164, cityId: 2065, code: "622009" },
    { id: 46165, cityId: 2065, code: "622052" },
    { id: 46166, cityId: 2065, code: "622055" },
    { id: 46167, cityId: 2065, code: "622102" },
    { id: 46168, cityId: 2065, code: "622105" },
    { id: 46169, cityId: 2065, code: "622107" },
    { id: 46170, cityId: 2065, code: "622108" },
    { id: 46171, cityId: 2065, code: "622205" },
    { id: 46172, cityId: 2065, code: "622208" },
    { id: 46173, cityId: 2065, code: "622210" },
    { id: 46174, cityId: 2065, code: "622211" },
    { id: 46175, cityId: 2065, code: "622213" },
    { id: 46176, cityId: 2065, code: "622303" },
    { id: 46177, cityId: 2065, code: "622306" },
    { id: 46178, cityId: 2065, code: "622309" },
    { id: 46179, cityId: 2065, code: "622311" },
    { id: 46180, cityId: 2065, code: "622314" },
    { id: 46181, cityId: 2065, code: "622316" },
    { id: 46182, cityId: 2065, code: "622317" },
    { id: 46183, cityId: 2065, code: "622401" },
    { id: 46184, cityId: 2065, code: "622404" },
    { id: 46185, cityId: 2065, code: "622406" },
    { id: 46186, cityId: 2065, code: "622407" },
    { id: 46187, cityId: 2065, code: "622409" },
    { id: 46188, cityId: 2065, code: "622412" },
    { id: 46189, cityId: 2065, code: "622414" },
    { id: 46190, cityId: 2065, code: "622415" },
    { id: 46191, cityId: 2065, code: "622417" },
    { id: 46192, cityId: 2065, code: "622420" },
    { id: 46193, cityId: 2065, code: "622502" },
    { id: 46194, cityId: 2065, code: "622504" },
    { id: 46195, cityId: 2065, code: "622505" },
    { id: 46196, cityId: 2065, code: "622507" },
    { id: 46197, cityId: 2065, code: "622510" },
    { id: 46198, cityId: 2065, code: "622512" },
    { id: 46199, cityId: 2065, code: "622513" },
    { id: 46200, cityId: 2065, code: "622515" },
    { id: 46201, cityId: 2066, code: "626117" },
    { id: 46202, cityId: 2067, code: "626704" },
    { id: 46203, cityId: 2067, code: "626556" },
    { id: 46204, cityId: 2068, code: "629602" },
    { id: 46205, cityId: 2069, code: "621712" },
    { id: 46206, cityId: 2070, code: "626117" },
    { id: 46207, cityId: 2071, code: "623403" },
    { id: 46208, cityId: 2071, code: "623501" },
    { id: 46209, cityId: 2071, code: "623502" },
    { id: 46210, cityId: 2071, code: "623512" },
    { id: 46211, cityId: 2071, code: "623515" },
    { id: 46212, cityId: 2071, code: "623517" },
    { id: 46213, cityId: 2071, code: "623520" },
    { id: 46214, cityId: 2071, code: "623522" },
    { id: 46215, cityId: 2071, code: "623525" },
    { id: 46216, cityId: 2071, code: "623528" },
    { id: 46217, cityId: 2071, code: "623530" },
    { id: 46218, cityId: 2071, code: "623531" },
    { id: 46219, cityId: 2071, code: "623533" },
    { id: 46220, cityId: 2071, code: "623539" },
    { id: 46221, cityId: 2071, code: "623544" },
    { id: 46222, cityId: 2071, code: "623546" },
    { id: 46223, cityId: 2071, code: "623562" },
    { id: 46224, cityId: 2071, code: "623703" },
    { id: 46225, cityId: 2071, code: "623706" },
    { id: 46226, cityId: 2071, code: "623710" },
    { id: 46227, cityId: 2071, code: "623711" },
    { id: 46228, cityId: 2071, code: "623713" },
    { id: 46229, cityId: 2071, code: "623716" },
    { id: 46230, cityId: 2071, code: "623718" },
    { id: 46231, cityId: 2071, code: "623719" },
    { id: 46232, cityId: 2071, code: "623721" },
    { id: 46233, cityId: 2071, code: "623804" },
    { id: 46234, cityId: 2071, code: "623806" },
    { id: 46235, cityId: 2071, code: "623513" },
    { id: 46236, cityId: 2071, code: "623516" },
    { id: 46237, cityId: 2071, code: "623521" },
    { id: 46238, cityId: 2071, code: "623524" },
    { id: 46239, cityId: 2071, code: "623527" },
    { id: 46240, cityId: 2071, code: "623529" },
    { id: 46241, cityId: 2071, code: "623532" },
    { id: 46242, cityId: 2071, code: "623534" },
    { id: 46243, cityId: 2071, code: "623535" },
    { id: 46244, cityId: 2071, code: "623537" },
    { id: 46245, cityId: 2071, code: "623543" },
    { id: 46246, cityId: 2071, code: "623545" },
    { id: 46247, cityId: 2071, code: "623566" },
    { id: 46248, cityId: 2071, code: "623611" },
    { id: 46249, cityId: 2071, code: "623701" },
    { id: 46250, cityId: 2071, code: "623704" },
    { id: 46251, cityId: 2071, code: "623707" },
    { id: 46252, cityId: 2071, code: "623709" },
    { id: 46253, cityId: 2071, code: "623712" },
    { id: 46254, cityId: 2071, code: "627725" },
    { id: 46255, cityId: 2072, code: "635115" },
    { id: 46256, cityId: 2073, code: "623526" },
    { id: 46257, cityId: 2074, code: "637408" },
    { id: 46258, cityId: 2075, code: "636001" },
    { id: 46259, cityId: 2075, code: "636004" },
    { id: 46260, cityId: 2075, code: "636006" },
    { id: 46261, cityId: 2075, code: "636007" },
    { id: 46262, cityId: 2075, code: "636009" },
    { id: 46263, cityId: 2075, code: "636014" },
    { id: 46264, cityId: 2075, code: "636102" },
    { id: 46265, cityId: 2075, code: "636104" },
    { id: 46266, cityId: 2075, code: "636107" },
    { id: 46267, cityId: 2075, code: "636110" },
    { id: 46268, cityId: 2075, code: "636112" },
    { id: 46269, cityId: 2075, code: "636115" },
    { id: 46270, cityId: 2075, code: "636118" },
    { id: 46271, cityId: 2075, code: "636121" },
    { id: 46272, cityId: 2075, code: "636139" },
    { id: 46273, cityId: 2075, code: "636141" },
    { id: 46274, cityId: 2075, code: "636202" },
    { id: 46275, cityId: 2075, code: "636203" },
    { id: 46276, cityId: 2075, code: "636308" },
    { id: 46277, cityId: 2075, code: "636319" },
    { id: 46278, cityId: 2075, code: "636351" },
    { id: 46279, cityId: 2075, code: "636354" },
    { id: 46280, cityId: 2075, code: "636401" },
    { id: 46281, cityId: 2075, code: "636404" },
    { id: 46282, cityId: 2075, code: "636451" },
    { id: 46283, cityId: 2075, code: "636452" },
    { id: 46284, cityId: 2075, code: "636457" },
    { id: 46285, cityId: 2075, code: "636462" },
    { id: 46286, cityId: 2075, code: "636602" },
    { id: 46287, cityId: 2075, code: "636902" },
    { id: 46288, cityId: 2075, code: "637002" },
    { id: 46289, cityId: 2075, code: "637013" },
    { id: 46290, cityId: 2075, code: "637018" },
    { id: 46291, cityId: 2075, code: "637023" },
    { id: 46292, cityId: 2075, code: "637024" },
    { id: 46293, cityId: 2075, code: "637026" },
    { id: 46294, cityId: 2075, code: "637103" },
    { id: 46295, cityId: 2075, code: "637201" },
    { id: 46296, cityId: 2075, code: "637203" },
    { id: 46297, cityId: 2075, code: "637204" },
    { id: 46298, cityId: 2075, code: "637206" },
    { id: 46299, cityId: 2075, code: "637209" },
    { id: 46300, cityId: 2075, code: "636007" },
    { id: 46301, cityId: 2075, code: "637212" },
    { id: 46302, cityId: 2075, code: "637217" },
    { id: 46303, cityId: 2075, code: "637301" },
    { id: 46304, cityId: 2075, code: "637302" },
    { id: 46305, cityId: 2075, code: "637304" },
    { id: 46306, cityId: 2075, code: "637402" },
    { id: 46307, cityId: 2075, code: "637405" },
    { id: 46308, cityId: 2075, code: "637416" },
    { id: 46309, cityId: 2075, code: "637418" },
    { id: 46310, cityId: 2075, code: "637505" },
    { id: 46311, cityId: 2075, code: "637508" },
    { id: 46312, cityId: 2075, code: "638181" },
    { id: 46313, cityId: 2075, code: "636002" },
    { id: 46314, cityId: 2075, code: "636003" },
    { id: 46315, cityId: 2075, code: "636008" },
    { id: 46316, cityId: 2075, code: "636011" },
    { id: 46317, cityId: 2075, code: "636013" },
    { id: 46318, cityId: 2075, code: "636016" },
    { id: 46319, cityId: 2075, code: "636101" },
    { id: 46320, cityId: 2075, code: "636103" },
    { id: 46321, cityId: 2075, code: "636106" },
    { id: 46322, cityId: 2075, code: "636109" },
    { id: 46323, cityId: 2075, code: "636111" },
    { id: 46324, cityId: 2075, code: "636114" },
    { id: 46325, cityId: 2075, code: "636116" },
    { id: 46326, cityId: 2075, code: "636117" },
    { id: 46327, cityId: 2075, code: "636119" },
    { id: 46328, cityId: 2075, code: "636122" },
    { id: 46329, cityId: 2075, code: "636130" },
    { id: 46330, cityId: 2075, code: "636137" },
    { id: 46331, cityId: 2075, code: "636138" },
    { id: 46332, cityId: 2075, code: "636140" },
    { id: 46333, cityId: 2075, code: "636204" },
    { id: 46334, cityId: 2075, code: "636302" },
    { id: 46335, cityId: 2075, code: "636304" },
    { id: 46336, cityId: 2075, code: "636307" },
    { id: 46337, cityId: 2075, code: "636318" },
    { id: 46338, cityId: 2075, code: "636352" },
    { id: 46339, cityId: 2075, code: "636402" },
    { id: 46340, cityId: 2075, code: "636403" },
    { id: 46341, cityId: 2075, code: "636456" },
    { id: 46342, cityId: 2075, code: "636458" },
    { id: 46343, cityId: 2075, code: "636463" },
    { id: 46344, cityId: 2075, code: "636501" },
    { id: 46345, cityId: 2075, code: "636503" },
    { id: 46346, cityId: 2075, code: "636601" },
    { id: 46347, cityId: 2075, code: "636604" },
    { id: 46348, cityId: 2075, code: "636807" },
    { id: 46349, cityId: 2075, code: "636808" },
    { id: 46350, cityId: 2075, code: "636906" },
    { id: 46351, cityId: 2075, code: "637001" },
    { id: 46352, cityId: 2075, code: "637003" },
    { id: 46353, cityId: 2075, code: "637014" },
    { id: 46354, cityId: 2075, code: "637017" },
    { id: 46355, cityId: 2075, code: "637019" },
    { id: 46356, cityId: 2075, code: "637020" },
    { id: 46357, cityId: 2075, code: "637101" },
    { id: 46358, cityId: 2075, code: "637104" },
    { id: 46359, cityId: 2075, code: "637109" },
    { id: 46360, cityId: 2075, code: "637202" },
    { id: 46361, cityId: 2075, code: "637207" },
    { id: 46362, cityId: 2075, code: "637208" },
    { id: 46363, cityId: 2075, code: "637210" },
    { id: 46364, cityId: 2075, code: "637213" },
    { id: 46365, cityId: 2075, code: "637303" },
    { id: 46366, cityId: 2075, code: "637401" },
    { id: 46367, cityId: 2075, code: "637403" },
    { id: 46368, cityId: 2075, code: "637406" },
    { id: 46369, cityId: 2075, code: "637409" },
    { id: 46370, cityId: 2075, code: "637420" },
    { id: 46371, cityId: 2075, code: "637502" },
    { id: 46372, cityId: 2075, code: "637504" },
    { id: 46373, cityId: 2076, code: "642123" },
    { id: 46374, cityId: 2077, code: "606401" },
    { id: 46375, cityId: 2078, code: "626203" },
    { id: 46376, cityId: 2078, code: "632523" },
    { id: 46377, cityId: 2079, code: "626120" },
    { id: 46378, cityId: 2080, code: "626121" },
    { id: 46379, cityId: 2081, code: "603108" },
    { id: 46380, cityId: 2082, code: "624224" },
    { id: 46381, cityId: 2083, code: "632008" },
    { id: 46382, cityId: 2084, code: "643259" },
    { id: 46383, cityId: 2085, code: "624502" },
    { id: 46384, cityId: 2086, code: "641302" },
    { id: 46385, cityId: 2087, code: "624708" },
    { id: 46386, cityId: 2088, code: "623001" },
    { id: 46387, cityId: 2088, code: "623004" },
    { id: 46388, cityId: 2088, code: "623006" },
    { id: 46389, cityId: 2088, code: "623102" },
    { id: 46390, cityId: 2088, code: "623104" },
    { id: 46391, cityId: 2088, code: "623105" },
    { id: 46392, cityId: 2088, code: "623109" },
    { id: 46393, cityId: 2088, code: "623110" },
    { id: 46394, cityId: 2088, code: "623202" },
    { id: 46395, cityId: 2088, code: "623203" },
    { id: 46396, cityId: 2088, code: "623205" },
    { id: 46397, cityId: 2088, code: "623207" },
    { id: 46398, cityId: 2088, code: "623208" },
    { id: 46399, cityId: 2088, code: "623210" },
    { id: 46400, cityId: 2088, code: "623213" },
    { id: 46401, cityId: 2088, code: "623215" },
    { id: 46402, cityId: 2088, code: "623216" },
    { id: 46403, cityId: 2088, code: "623301" },
    { id: 46404, cityId: 2088, code: "623303" },
    { id: 46405, cityId: 2088, code: "623305" },
    { id: 46406, cityId: 2088, code: "623306" },
    { id: 46407, cityId: 2088, code: "623308" },
    { id: 46408, cityId: 2088, code: "623311" },
    { id: 46409, cityId: 2088, code: "623313" },
    { id: 46410, cityId: 2088, code: "623314" },
    { id: 46411, cityId: 2088, code: "623319" },
    { id: 46412, cityId: 2088, code: "623321" },
    { id: 46413, cityId: 2088, code: "623401" },
    { id: 46414, cityId: 2088, code: "623403" },
    { id: 46415, cityId: 2088, code: "623404" },
    { id: 46416, cityId: 2088, code: "623409" },
    { id: 46417, cityId: 2088, code: "623552" },
    { id: 46418, cityId: 2088, code: "623554" },
    { id: 46419, cityId: 2088, code: "623557" },
    { id: 46420, cityId: 2088, code: "623560" },
    { id: 46421, cityId: 2088, code: "623565" },
    { id: 46422, cityId: 2088, code: "623602" },
    { id: 46423, cityId: 2088, code: "623605" },
    { id: 46424, cityId: 2088, code: "623607" },
    { id: 46425, cityId: 2088, code: "623608" },
    { id: 46426, cityId: 2088, code: "623610" },
    { id: 46427, cityId: 2088, code: "623613" },
    { id: 46428, cityId: 2088, code: "624505" },
    { id: 46429, cityId: 2088, code: "635656" },
    { id: 46430, cityId: 2088, code: "623002" },
    { id: 46431, cityId: 2088, code: "623003" },
    { id: 46432, cityId: 2088, code: "623005" },
    { id: 46433, cityId: 2088, code: "623101" },
    { id: 46434, cityId: 2088, code: "623108" },
    { id: 46435, cityId: 2088, code: "623111" },
    { id: 46436, cityId: 2088, code: "623201" },
    { id: 46437, cityId: 2088, code: "623204" },
    { id: 46438, cityId: 2088, code: "623206" },
    { id: 46439, cityId: 2088, code: "623209" },
    { id: 46440, cityId: 2088, code: "623211" },
    { id: 46441, cityId: 2088, code: "623212" },
    { id: 46442, cityId: 2088, code: "623214" },
    { id: 46443, cityId: 2088, code: "623217" },
    { id: 46444, cityId: 2088, code: "623302" },
    { id: 46445, cityId: 2088, code: "623304" },
    { id: 46446, cityId: 2088, code: "623307" },
    { id: 46447, cityId: 2088, code: "623309" },
    { id: 46448, cityId: 2088, code: "623310" },
    { id: 46449, cityId: 2088, code: "623312" },
    { id: 46450, cityId: 2088, code: "623315" },
    { id: 46451, cityId: 2088, code: "623317" },
    { id: 46452, cityId: 2088, code: "623320" },
    { id: 46453, cityId: 2088, code: "623402" },
    { id: 46454, cityId: 2088, code: "623405" },
    { id: 46455, cityId: 2088, code: "623407" },
    { id: 46456, cityId: 2088, code: "623408" },
    { id: 46457, cityId: 2088, code: "623410" },
    { id: 46458, cityId: 2088, code: "623538" },
    { id: 46459, cityId: 2088, code: "623551" },
    { id: 46460, cityId: 2088, code: "623553" },
    { id: 46461, cityId: 2088, code: "623558" },
    { id: 46462, cityId: 2088, code: "623559" },
    { id: 46463, cityId: 2088, code: "623561" },
    { id: 46464, cityId: 2088, code: "623603" },
    { id: 46465, cityId: 2088, code: "623604" },
    { id: 46466, cityId: 2088, code: "623606" },
    { id: 46467, cityId: 2088, code: "623609" },
    { id: 46468, cityId: 2088, code: "623612" },
    { id: 46469, cityId: 2088, code: "623617" },
    { id: 46470, cityId: 2088, code: "624501" },
    { id: 46471, cityId: 2088, code: "635652" },
    { id: 46472, cityId: 2088, code: "635654" },
    { id: 46473, cityId: 2088, code: "635655" },
    { id: 46474, cityId: 2088, code: "635856" },
    { id: 46475, cityId: 2088, code: "635901" },
    { id: 46476, cityId: 2089, code: "638109" },
    { id: 46477, cityId: 2089, code: "627757" },
    { id: 46478, cityId: 2090, code: "608703" },
    { id: 46479, cityId: 2091, code: "602105" },
    { id: 46480, cityId: 2092, code: "629704" },
    { id: 46481, cityId: 2093, code: "627858" },
    { id: 46482, cityId: 2093, code: "623406" },
    { id: 46483, cityId: 2093, code: "626126" },
    { id: 46484, cityId: 2094, code: "638009" },
    { id: 46485, cityId: 2095, code: "627859" },
    { id: 46486, cityId: 2096, code: "600045" },
    { id: 46487, cityId: 2096, code: "600047" },
    { id: 46488, cityId: 2096, code: "600046" },
    { id: 46489, cityId: 2097, code: "642146" },
    { id: 46490, cityId: 2098, code: "636113" },
    { id: 46491, cityId: 2099, code: "609003" },
    { id: 46492, cityId: 2099, code: "609103" },
    { id: 46493, cityId: 2099, code: "609106" },
    { id: 46494, cityId: 2099, code: "609111" },
    { id: 46495, cityId: 2099, code: "609112" },
    { id: 46496, cityId: 2099, code: "609114" },
    { id: 46497, cityId: 2099, code: "609117" },
    { id: 46498, cityId: 2099, code: "609119" },
    { id: 46499, cityId: 2099, code: "609122" },
    { id: 46500, cityId: 2099, code: "609125" },
    { id: 46501, cityId: 2099, code: "609127" },
    { id: 46502, cityId: 2099, code: "609201" },
    { id: 46503, cityId: 2099, code: "609204" },
    { id: 46504, cityId: 2099, code: "609302" },
    { id: 46505, cityId: 2099, code: "609305" },
    { id: 46506, cityId: 2099, code: "609307" },
    { id: 46507, cityId: 2099, code: "609308" },
    { id: 46508, cityId: 2099, code: "609310" },
    { id: 46509, cityId: 2099, code: "609313" },
    { id: 46510, cityId: 2099, code: "609403" },
    { id: 46511, cityId: 2099, code: "609406" },
    { id: 46512, cityId: 2099, code: "609501" },
    { id: 46513, cityId: 2099, code: "609503" },
    { id: 46514, cityId: 2099, code: "609504" },
    { id: 46515, cityId: 2099, code: "609506" },
    { id: 46516, cityId: 2099, code: "609601" },
    { id: 46517, cityId: 2099, code: "609602" },
    { id: 46518, cityId: 2099, code: "609604" },
    { id: 46519, cityId: 2099, code: "609609" },
    { id: 46520, cityId: 2099, code: "609702" },
    { id: 46521, cityId: 2099, code: "609704" },
    { id: 46522, cityId: 2099, code: "609705" },
    { id: 46523, cityId: 2099, code: "609802" },
    { id: 46524, cityId: 2099, code: "609803" },
    { id: 46525, cityId: 2099, code: "609805" },
    { id: 46526, cityId: 2099, code: "609808" },
    { id: 46527, cityId: 2099, code: "609810" },
    { id: 46528, cityId: 2099, code: "609811" },
    { id: 46529, cityId: 2099, code: "609813" },
    { id: 46530, cityId: 2099, code: "610051" },
    { id: 46531, cityId: 2099, code: "610102" },
    { id: 46532, cityId: 2099, code: "610104" },
    { id: 46533, cityId: 2099, code: "610105" },
    { id: 46534, cityId: 2099, code: "610107" },
    { id: 46535, cityId: 2099, code: "610110" },
    { id: 46536, cityId: 2099, code: "610112" },
    { id: 46537, cityId: 2099, code: "610113" },
    { id: 46538, cityId: 2099, code: "610115" },
    { id: 46539, cityId: 2099, code: "610202" },
    { id: 46540, cityId: 2099, code: "610203" },
    { id: 46541, cityId: 2099, code: "610205" },
    { id: 46542, cityId: 2099, code: "610208" },
    { id: 46543, cityId: 2099, code: "610211" },
    { id: 46544, cityId: 2099, code: "611001" },
    { id: 46545, cityId: 2099, code: "611102" },
    { id: 46546, cityId: 2099, code: "611110" },
    { id: 46547, cityId: 2099, code: "611112" },
    { id: 46548, cityId: 2099, code: "611113" },
    { id: 46549, cityId: 2099, code: "611115" },
    { id: 46550, cityId: 2099, code: "611117" },
    { id: 46551, cityId: 2099, code: "612002" },
    { id: 46552, cityId: 2099, code: "612103" },
    { id: 46553, cityId: 2099, code: "612106" },
    { id: 46554, cityId: 2099, code: "612108" },
    { id: 46555, cityId: 2099, code: "612201" },
    { id: 46556, cityId: 2099, code: "612203" },
    { id: 46557, cityId: 2099, code: "612204" },
    { id: 46558, cityId: 2099, code: "612206" },
    { id: 46559, cityId: 2099, code: "612301" },
    { id: 46560, cityId: 2099, code: "612302" },
    { id: 46561, cityId: 2099, code: "612304" },
    { id: 46562, cityId: 2099, code: "612402" },
    { id: 46563, cityId: 2099, code: "612503" },
    { id: 46564, cityId: 2099, code: "612505" },
    { id: 46565, cityId: 2099, code: "612506" },
    { id: 46566, cityId: 2099, code: "612603" },
    { id: 46567, cityId: 2099, code: "612604" },
    { id: 46568, cityId: 2099, code: "612606" },
    { id: 46569, cityId: 2099, code: "612609" },
    { id: 46570, cityId: 2099, code: "612701" },
    { id: 46571, cityId: 2099, code: "612702" },
    { id: 46572, cityId: 2099, code: "612704" },
    { id: 46573, cityId: 2099, code: "612802" },
    { id: 46574, cityId: 2099, code: "612805" },
    { id: 46575, cityId: 2099, code: "612807" },
    { id: 46576, cityId: 2099, code: "612903" },
    { id: 46577, cityId: 2099, code: "612905" },
    { id: 46578, cityId: 2099, code: "613001" },
    { id: 46579, cityId: 2099, code: "613003" },
    { id: 46580, cityId: 2099, code: "613004" },
    { id: 46581, cityId: 2099, code: "613006" },
    { id: 46582, cityId: 2099, code: "613009" },
    { id: 46583, cityId: 2099, code: "613051" },
    { id: 46584, cityId: 2099, code: "613054" },
    { id: 46585, cityId: 2099, code: "613101" },
    { id: 46586, cityId: 2099, code: "613102" },
    { id: 46587, cityId: 2099, code: "613104" },
    { id: 46588, cityId: 2099, code: "613107" },
    { id: 46589, cityId: 2099, code: "613110" },
    { id: 46590, cityId: 2099, code: "613202" },
    { id: 46591, cityId: 2099, code: "613205" },
    { id: 46592, cityId: 2099, code: "613207" },
    { id: 46593, cityId: 2099, code: "613303" },
    { id: 46594, cityId: 2099, code: "613305" },
    { id: 46595, cityId: 2099, code: "613401" },
    { id: 46596, cityId: 2099, code: "613501" },
    { id: 46597, cityId: 2099, code: "613502" },
    { id: 46598, cityId: 2099, code: "613504" },
    { id: 46599, cityId: 2099, code: "613506" },
    { id: 46600, cityId: 2099, code: "613602" },
    { id: 46601, cityId: 2099, code: "613702" },
    { id: 46602, cityId: 2099, code: "613705" },
    { id: 46603, cityId: 2099, code: "614012" },
    { id: 46604, cityId: 2099, code: "614013" },
    { id: 46605, cityId: 2099, code: "614015" },
    { id: 46606, cityId: 2099, code: "614020" },
    { id: 46607, cityId: 2099, code: "614021" },
    { id: 46608, cityId: 2099, code: "614023" },
    { id: 46609, cityId: 2099, code: "614026" },
    { id: 46610, cityId: 2099, code: "614028" },
    { id: 46611, cityId: 2099, code: "614029" },
    { id: 46612, cityId: 2099, code: "614031" },
    { id: 46613, cityId: 2099, code: "614102" },
    { id: 46614, cityId: 2099, code: "614103" },
    { id: 46615, cityId: 2099, code: "614201" },
    { id: 46616, cityId: 2099, code: "614203" },
    { id: 46617, cityId: 2099, code: "614206" },
    { id: 46618, cityId: 2099, code: "614209" },
    { id: 46619, cityId: 2099, code: "614211" },
    { id: 46620, cityId: 2099, code: "614402" },
    { id: 46621, cityId: 2099, code: "614404" },
    { id: 46622, cityId: 2099, code: "614405" },
    { id: 46623, cityId: 2099, code: "614407" },
    { id: 46624, cityId: 2099, code: "614601" },
    { id: 46625, cityId: 2099, code: "614614" },
    { id: 46626, cityId: 2099, code: "614617" },
    { id: 46627, cityId: 2099, code: "614619" },
    { id: 46628, cityId: 2099, code: "614622" },
    { id: 46629, cityId: 2099, code: "614627" },
    { id: 46630, cityId: 2099, code: "614629" },
    { id: 46631, cityId: 2099, code: "614630" },
    { id: 46632, cityId: 2099, code: "614632" },
    { id: 46633, cityId: 2099, code: "614635" },
    { id: 46634, cityId: 2099, code: "614637" },
    { id: 46635, cityId: 2099, code: "614638" },
    { id: 46636, cityId: 2099, code: "614640" },
    { id: 46637, cityId: 2099, code: "614643" },
    { id: 46638, cityId: 2099, code: "614645" },
    { id: 46639, cityId: 2099, code: "614701" },
    { id: 46640, cityId: 2099, code: "614704" },
    { id: 46641, cityId: 2099, code: "614706" },
    { id: 46642, cityId: 2099, code: "614707" },
    { id: 46643, cityId: 2099, code: "614709" },
    { id: 46644, cityId: 2099, code: "614712" },
    { id: 46645, cityId: 2099, code: "614714" },
    { id: 46646, cityId: 2099, code: "614715" },
    { id: 46647, cityId: 2099, code: "614717" },
    { id: 46648, cityId: 2099, code: "614720" },
    { id: 46649, cityId: 2099, code: "614722" },
    { id: 46650, cityId: 2099, code: "614725" },
    { id: 46651, cityId: 2099, code: "614727" },
    { id: 46652, cityId: 2099, code: "614730" },
    { id: 46653, cityId: 2099, code: "614733" },
    { id: 46654, cityId: 2099, code: "614735" },
    { id: 46655, cityId: 2099, code: "614736" },
    { id: 46656, cityId: 2099, code: "614738" },
    { id: 46657, cityId: 2099, code: "614802" },
    { id: 46658, cityId: 2099, code: "614804" },
    { id: 46659, cityId: 2099, code: "614805" },
    { id: 46660, cityId: 2099, code: "614807" },
    { id: 46661, cityId: 2099, code: "614810" },
    { id: 46662, cityId: 2099, code: "614812" },
    { id: 46663, cityId: 2099, code: "614813" },
    { id: 46664, cityId: 2099, code: "614815" },
    { id: 46665, cityId: 2099, code: "614818" },
    { id: 46666, cityId: 2099, code: "614820" },
    { id: 46667, cityId: 2099, code: "614902" },
    { id: 46668, cityId: 2099, code: "614905" },
    { id: 46669, cityId: 2099, code: "614908" },
    { id: 46670, cityId: 2099, code: "614910" },
    { id: 46671, cityId: 2099, code: "614911" },
    { id: 46672, cityId: 2099, code: "614913" },
    { id: 46673, cityId: 2099, code: "608901" },
    { id: 46674, cityId: 2099, code: "609001" },
    { id: 46675, cityId: 2099, code: "609002" },
    { id: 46676, cityId: 2099, code: "609102" },
    { id: 46677, cityId: 2099, code: "609105" },
    { id: 46678, cityId: 2099, code: "609107" },
    { id: 46679, cityId: 2099, code: "609113" },
    { id: 46680, cityId: 2099, code: "609115" },
    { id: 46681, cityId: 2099, code: "609118" },
    { id: 46682, cityId: 2099, code: "609121" },
    { id: 46683, cityId: 2099, code: "609126" },
    { id: 46684, cityId: 2099, code: "609129" },
    { id: 46685, cityId: 2099, code: "609203" },
    { id: 46686, cityId: 2099, code: "609301" },
    { id: 46687, cityId: 2099, code: "609303" },
    { id: 46688, cityId: 2099, code: "609304" },
    { id: 46689, cityId: 2099, code: "609306" },
    { id: 46690, cityId: 2099, code: "609309" },
    { id: 46691, cityId: 2099, code: "609311" },
    { id: 46692, cityId: 2099, code: "609312" },
    { id: 46693, cityId: 2099, code: "609401" },
    { id: 46694, cityId: 2099, code: "609404" },
    { id: 46695, cityId: 2099, code: "609502" },
    { id: 46696, cityId: 2099, code: "609505" },
    { id: 46697, cityId: 2099, code: "609507" },
    { id: 46698, cityId: 2099, code: "609508" },
    { id: 46699, cityId: 2099, code: "609603" },
    { id: 46700, cityId: 2099, code: "609605" },
    { id: 46701, cityId: 2099, code: "609606" },
    { id: 46702, cityId: 2099, code: "609608" },
    { id: 46703, cityId: 2099, code: "609610" },
    { id: 46704, cityId: 2099, code: "609701" },
    { id: 46705, cityId: 2099, code: "609703" },
    { id: 46706, cityId: 2099, code: "609801" },
    { id: 46707, cityId: 2099, code: "609804" },
    { id: 46708, cityId: 2099, code: "609806" },
    { id: 46709, cityId: 2099, code: "609807" },
    { id: 46710, cityId: 2099, code: "609809" },
    { id: 46711, cityId: 2099, code: "609812" },
    { id: 46712, cityId: 2099, code: "609814" },
    { id: 46713, cityId: 2099, code: "610002" },
    { id: 46714, cityId: 2099, code: "610101" },
    { id: 46715, cityId: 2099, code: "610103" },
    { id: 46716, cityId: 2099, code: "610106" },
    { id: 46717, cityId: 2099, code: "610109" },
    { id: 46718, cityId: 2099, code: "610111" },
    { id: 46719, cityId: 2099, code: "610114" },
    { id: 46720, cityId: 2099, code: "610116" },
    { id: 46721, cityId: 2099, code: "610201" },
    { id: 46722, cityId: 2099, code: "610204" },
    { id: 46723, cityId: 2099, code: "610206" },
    { id: 46724, cityId: 2099, code: "610207" },
    { id: 46725, cityId: 2099, code: "610209" },
    { id: 46726, cityId: 2099, code: "610212" },
    { id: 46727, cityId: 2099, code: "611002" },
    { id: 46728, cityId: 2099, code: "611101" },
    { id: 46729, cityId: 2099, code: "611103" },
    { id: 46730, cityId: 2099, code: "611106" },
    { id: 46731, cityId: 2099, code: "611108" },
    { id: 46732, cityId: 2099, code: "611109" },
    { id: 46733, cityId: 2099, code: "611111" },
    { id: 46734, cityId: 2099, code: "611114" },
    { id: 46735, cityId: 2099, code: "611116" },
    { id: 46736, cityId: 2099, code: "611119" },
    { id: 46737, cityId: 2099, code: "612001" },
    { id: 46738, cityId: 2099, code: "612102" },
    { id: 46739, cityId: 2099, code: "612104" },
    { id: 46740, cityId: 2099, code: "612107" },
    { id: 46741, cityId: 2099, code: "612109" },
    { id: 46742, cityId: 2099, code: "612110" },
    { id: 46743, cityId: 2099, code: "612202" },
    { id: 46744, cityId: 2099, code: "612205" },
    { id: 46745, cityId: 2099, code: "612303" },
    { id: 46746, cityId: 2099, code: "612401" },
    { id: 46747, cityId: 2099, code: "612501" },
    { id: 46748, cityId: 2099, code: "612502" },
    { id: 46749, cityId: 2099, code: "612504" },
    { id: 46750, cityId: 2099, code: "612602" },
    { id: 46751, cityId: 2099, code: "612605" },
    { id: 46752, cityId: 2099, code: "612607" },
    { id: 46753, cityId: 2099, code: "612608" },
    { id: 46754, cityId: 2099, code: "612703" },
    { id: 46755, cityId: 2099, code: "612801" },
    { id: 46756, cityId: 2099, code: "612803" },
    { id: 46757, cityId: 2099, code: "612804" },
    { id: 46758, cityId: 2099, code: "612806" },
    { id: 46759, cityId: 2099, code: "612901" },
    { id: 46760, cityId: 2099, code: "612904" },
    { id: 46761, cityId: 2099, code: "613002" },
    { id: 46762, cityId: 2099, code: "613005" },
    { id: 46763, cityId: 2099, code: "613007" },
    { id: 46764, cityId: 2099, code: "613008" },
    { id: 46765, cityId: 2099, code: "613052" },
    { id: 46766, cityId: 2099, code: "613053" },
    { id: 46767, cityId: 2099, code: "613103" },
    { id: 46768, cityId: 2099, code: "613105" },
    { id: 46769, cityId: 2099, code: "613106" },
    { id: 46770, cityId: 2099, code: "613108" },
    { id: 46771, cityId: 2099, code: "613201" },
    { id: 46772, cityId: 2099, code: "613203" },
    { id: 46773, cityId: 2099, code: "613204" },
    { id: 46774, cityId: 2099, code: "613206" },
    { id: 46775, cityId: 2099, code: "613301" },
    { id: 46776, cityId: 2099, code: "613302" },
    { id: 46777, cityId: 2099, code: "613304" },
    { id: 46778, cityId: 2099, code: "613307" },
    { id: 46779, cityId: 2099, code: "613402" },
    { id: 46780, cityId: 2099, code: "613503" },
    { id: 46781, cityId: 2099, code: "613505" },
    { id: 46782, cityId: 2099, code: "613601" },
    { id: 46783, cityId: 2099, code: "613603" },
    { id: 46784, cityId: 2099, code: "613701" },
    { id: 46785, cityId: 2099, code: "613704" },
    { id: 46786, cityId: 2099, code: "613706" },
    { id: 46787, cityId: 2099, code: "613707" },
    { id: 46788, cityId: 2099, code: "614001" },
    { id: 46789, cityId: 2099, code: "614014" },
    { id: 46790, cityId: 2099, code: "614016" },
    { id: 46791, cityId: 2099, code: "614017" },
    { id: 46792, cityId: 2099, code: "614019" },
    { id: 46793, cityId: 2099, code: "614022" },
    { id: 46794, cityId: 2099, code: "614024" },
    { id: 46795, cityId: 2099, code: "614025" },
    { id: 46796, cityId: 2099, code: "614030" },
    { id: 46797, cityId: 2099, code: "614101" },
    { id: 46798, cityId: 2099, code: "614204" },
    { id: 46799, cityId: 2099, code: "614205" },
    { id: 46800, cityId: 2099, code: "614207" },
    { id: 46801, cityId: 2099, code: "614210" },
    { id: 46802, cityId: 2099, code: "614212" },
    { id: 46803, cityId: 2099, code: "614213" },
    { id: 46804, cityId: 2099, code: "614302" },
    { id: 46805, cityId: 2099, code: "614303" },
    { id: 46806, cityId: 2099, code: "614401" },
    { id: 46807, cityId: 2099, code: "614403" },
    { id: 46808, cityId: 2099, code: "614406" },
    { id: 46809, cityId: 2099, code: "614602" },
    { id: 46810, cityId: 2099, code: "614612" },
    { id: 46811, cityId: 2099, code: "614613" },
    { id: 46812, cityId: 2099, code: "614615" },
    { id: 46813, cityId: 2099, code: "614618" },
    { id: 46814, cityId: 2099, code: "614620" },
    { id: 46815, cityId: 2099, code: "614621" },
    { id: 46816, cityId: 2099, code: "614623" },
    { id: 46817, cityId: 2099, code: "614625" },
    { id: 46818, cityId: 2099, code: "614626" },
    { id: 46819, cityId: 2099, code: "614628" },
    { id: 46820, cityId: 2099, code: "614631" },
    { id: 46821, cityId: 2099, code: "614633" },
    { id: 46822, cityId: 2099, code: "614634" },
    { id: 46823, cityId: 2099, code: "614636" },
    { id: 46824, cityId: 2099, code: "614639" },
    { id: 46825, cityId: 2099, code: "614641" },
    { id: 46826, cityId: 2099, code: "614642" },
    { id: 46827, cityId: 2099, code: "614644" },
    { id: 46828, cityId: 2099, code: "614647" },
    { id: 46829, cityId: 2099, code: "614702" },
    { id: 46830, cityId: 2099, code: "614703" },
    { id: 46831, cityId: 2099, code: "614705" },
    { id: 46832, cityId: 2099, code: "614710" },
    { id: 46833, cityId: 2099, code: "614711" },
    { id: 46834, cityId: 2099, code: "614713" },
    { id: 46835, cityId: 2099, code: "614716" },
    { id: 46836, cityId: 2099, code: "614719" },
    { id: 46837, cityId: 2099, code: "614721" },
    { id: 46838, cityId: 2099, code: "614723" },
    { id: 46839, cityId: 2099, code: "614726" },
    { id: 46840, cityId: 2099, code: "614729" },
    { id: 46841, cityId: 2099, code: "614731" },
    { id: 46842, cityId: 2099, code: "614732" },
    { id: 46843, cityId: 2099, code: "614734" },
    { id: 46844, cityId: 2099, code: "614737" },
    { id: 46845, cityId: 2099, code: "614803" },
    { id: 46846, cityId: 2099, code: "614806" },
    { id: 46847, cityId: 2099, code: "614808" },
    { id: 46848, cityId: 2099, code: "614809" },
    { id: 46849, cityId: 2099, code: "614811" },
    { id: 46850, cityId: 2099, code: "614814" },
    { id: 46851, cityId: 2099, code: "614816" },
    { id: 46852, cityId: 2099, code: "614817" },
    { id: 46853, cityId: 2099, code: "614821" },
    { id: 46854, cityId: 2099, code: "614822" },
    { id: 46855, cityId: 2099, code: "614901" },
    { id: 46856, cityId: 2099, code: "614904" },
    { id: 46857, cityId: 2099, code: "614906" },
    { id: 46858, cityId: 2099, code: "614909" },
    { id: 46859, cityId: 2099, code: "614912" },
    { id: 46860, cityId: 2099, code: "614914" },
    { id: 46861, cityId: 2099, code: "614915" },
    { id: 46862, cityId: 2099, code: "641024" },
    { id: 46863, cityId: 2100, code: "636502" },
    { id: 46864, cityId: 2101, code: "624225" },
    { id: 46865, cityId: 2101, code: "629707" },
    { id: 46866, cityId: 2101, code: "639001" },
    { id: 46867, cityId: 2101, code: "627129" },
    { id: 46868, cityId: 2102, code: "628623" },
    { id: 46869, cityId: 2103, code: "602027" },
    { id: 46870, cityId: 2103, code: "631401" },
    { id: 46871, cityId: 2103, code: "600034" },
    { id: 46872, cityId: 2103, code: "602030" },
    { id: 46873, cityId: 2103, code: "603103" },
    { id: 46874, cityId: 2103, code: "631203" },
    { id: 46875, cityId: 2103, code: "636821" },
    { id: 46876, cityId: 2104, code: "610001" },
    { id: 46877, cityId: 2104, code: "610002" },
    { id: 46878, cityId: 2104, code: "627867" },
    { id: 46879, cityId: 2104, code: "635661" },
    { id: 46880, cityId: 2105, code: "626134" },
    { id: 46881, cityId: 2105, code: "627305" },
    { id: 46882, cityId: 2105, code: "627726" },
    { id: 46883, cityId: 2105, code: "628653" },
    { id: 46884, cityId: 2105, code: "628706" },
    { id: 46885, cityId: 2106, code: "632002" },
    { id: 46886, cityId: 2107, code: "635811" },
    { id: 46887, cityId: 2108, code: "632512" },
    { id: 46888, cityId: 2109, code: "628215" },
    { id: 46889, cityId: 2110, code: "606611" },
    { id: 46890, cityId: 2110, code: "620001" },
    { id: 46891, cityId: 2110, code: "620003" },
    { id: 46892, cityId: 2110, code: "620006" },
    { id: 46893, cityId: 2110, code: "620008" },
    { id: 46894, cityId: 2110, code: "620009" },
    { id: 46895, cityId: 2110, code: "620011" },
    { id: 46896, cityId: 2110, code: "620014" },
    { id: 46897, cityId: 2110, code: "620016" },
    { id: 46898, cityId: 2110, code: "620017" },
    { id: 46899, cityId: 2110, code: "620019" },
    { id: 46900, cityId: 2110, code: "620021" },
    { id: 46901, cityId: 2110, code: "620022" },
    { id: 46902, cityId: 2110, code: "620051" },
    { id: 46903, cityId: 2110, code: "620101" },
    { id: 46904, cityId: 2110, code: "621001" },
    { id: 46905, cityId: 2110, code: "621002" },
    { id: 46906, cityId: 2110, code: "621004" },
    { id: 46907, cityId: 2110, code: "621007" },
    { id: 46908, cityId: 2110, code: "621009" },
    { id: 46909, cityId: 2110, code: "621010" },
    { id: 46910, cityId: 2110, code: "621012" },
    { id: 46911, cityId: 2110, code: "621015" },
    { id: 46912, cityId: 2110, code: "621017" },
    { id: 46913, cityId: 2110, code: "621018" },
    { id: 46914, cityId: 2110, code: "621020" },
    { id: 46915, cityId: 2110, code: "621023" },
    { id: 46916, cityId: 2110, code: "621105" },
    { id: 46917, cityId: 2110, code: "621113" },
    { id: 46918, cityId: 2110, code: "621115" },
    { id: 46919, cityId: 2110, code: "621116" },
    { id: 46920, cityId: 2110, code: "621118" },
    { id: 46921, cityId: 2110, code: "621121" },
    { id: 46922, cityId: 2110, code: "621126" },
    { id: 46923, cityId: 2110, code: "621132" },
    { id: 46924, cityId: 2110, code: "621205" },
    { id: 46925, cityId: 2110, code: "621206" },
    { id: 46926, cityId: 2110, code: "621208" },
    { id: 46927, cityId: 2110, code: "621213" },
    { id: 46928, cityId: 2110, code: "621214" },
    { id: 46929, cityId: 2110, code: "621216" },
    { id: 46930, cityId: 2110, code: "621219" },
    { id: 46931, cityId: 2110, code: "621224" },
    { id: 46932, cityId: 2110, code: "621229" },
    { id: 46933, cityId: 2110, code: "621303" },
    { id: 46934, cityId: 2110, code: "621304" },
    { id: 46935, cityId: 2110, code: "621306" },
    { id: 46936, cityId: 2110, code: "621309" },
    { id: 46937, cityId: 2110, code: "621311" },
    { id: 46938, cityId: 2110, code: "621312" },
    { id: 46939, cityId: 2110, code: "621314" },
    { id: 46940, cityId: 2110, code: "621317" },
    { id: 46941, cityId: 2110, code: "621701" },
    { id: 46942, cityId: 2110, code: "621703" },
    { id: 46943, cityId: 2110, code: "621704" },
    { id: 46944, cityId: 2110, code: "621709" },
    { id: 46945, cityId: 2110, code: "621711" },
    { id: 46946, cityId: 2110, code: "621714" },
    { id: 46947, cityId: 2110, code: "621717" },
    { id: 46948, cityId: 2110, code: "621719" },
    { id: 46949, cityId: 2110, code: "621722" },
    { id: 46950, cityId: 2110, code: "621802" },
    { id: 46951, cityId: 2110, code: "623555" },
    { id: 46952, cityId: 2110, code: "626572" },
    { id: 46953, cityId: 2110, code: "637412" },
    { id: 46954, cityId: 2110, code: "620002" },
    { id: 46955, cityId: 2110, code: "620004" },
    { id: 46956, cityId: 2110, code: "620005" },
    { id: 46957, cityId: 2110, code: "620007" },
    { id: 46958, cityId: 2110, code: "620010" },
    { id: 46959, cityId: 2110, code: "620012" },
    { id: 46960, cityId: 2110, code: "620013" },
    { id: 46961, cityId: 2110, code: "620015" },
    { id: 46962, cityId: 2110, code: "620018" },
    { id: 46963, cityId: 2110, code: "620020" },
    { id: 46964, cityId: 2110, code: "620052" },
    { id: 46965, cityId: 2110, code: "620102" },
    { id: 46966, cityId: 2110, code: "621003" },
    { id: 46967, cityId: 2110, code: "621005" },
    { id: 46968, cityId: 2110, code: "621006" },
    { id: 46969, cityId: 2110, code: "621008" },
    { id: 46970, cityId: 2110, code: "621014" },
    { id: 46971, cityId: 2110, code: "621016" },
    { id: 46972, cityId: 2110, code: "621019" },
    { id: 46973, cityId: 2110, code: "621021" },
    { id: 46974, cityId: 2110, code: "621022" },
    { id: 46975, cityId: 2110, code: "621101" },
    { id: 46976, cityId: 2110, code: "621104" },
    { id: 46977, cityId: 2110, code: "621106" },
    { id: 46978, cityId: 2110, code: "621109" },
    { id: 46979, cityId: 2110, code: "621111" },
    { id: 46980, cityId: 2110, code: "621112" },
    { id: 46981, cityId: 2110, code: "621114" },
    { id: 46982, cityId: 2110, code: "621117" },
    { id: 46983, cityId: 2110, code: "621120" },
    { id: 46984, cityId: 2110, code: "621127" },
    { id: 46985, cityId: 2110, code: "621128" },
    { id: 46986, cityId: 2110, code: "621201" },
    { id: 46987, cityId: 2110, code: "621209" },
    { id: 46988, cityId: 2110, code: "621212" },
    { id: 46989, cityId: 2110, code: "621215" },
    { id: 46990, cityId: 2110, code: "621217" },
    { id: 46991, cityId: 2110, code: "621218" },
    { id: 46992, cityId: 2110, code: "621220" },
    { id: 46993, cityId: 2110, code: "621302" },
    { id: 46994, cityId: 2110, code: "621307" },
    { id: 46995, cityId: 2110, code: "621601" },
    { id: 46996, cityId: 2110, code: "621652" },
    { id: 46997, cityId: 2110, code: "621702" },
    { id: 46998, cityId: 2110, code: "621705" },
    { id: 46999, cityId: 2110, code: "621707" },
    { id: 47000, cityId: 2110, code: "621713" },
    { id: 47001, cityId: 2110, code: "621715" },
    { id: 47002, cityId: 2110, code: "621716" },
    { id: 47003, cityId: 2110, code: "621718" },
    { id: 47004, cityId: 2110, code: "621803" },
    { id: 47005, cityId: 2110, code: "621805" },
    { id: 47006, cityId: 2110, code: "621851" },
    { id: 47007, cityId: 2110, code: "621853" },
    { id: 47008, cityId: 2110, code: "637001" },
    { id: 47009, cityId: 2111, code: "627001" },
    { id: 47010, cityId: 2111, code: "627004" },
    { id: 47011, cityId: 2111, code: "627006" },
    { id: 47012, cityId: 2111, code: "627007" },
    { id: 47013, cityId: 2111, code: "627009" },
    { id: 47014, cityId: 2111, code: "627051" },
    { id: 47015, cityId: 2111, code: "627102" },
    { id: 47016, cityId: 2111, code: "627104" },
    { id: 47017, cityId: 2111, code: "627105" },
    { id: 47018, cityId: 2111, code: "627107" },
    { id: 47019, cityId: 2111, code: "627110" },
    { id: 47020, cityId: 2111, code: "627112" },
    { id: 47021, cityId: 2111, code: "627113" },
    { id: 47022, cityId: 2111, code: "627115" },
    { id: 47023, cityId: 2111, code: "627118" },
    { id: 47024, cityId: 2111, code: "627120" },
    { id: 47025, cityId: 2111, code: "627121" },
    { id: 47026, cityId: 2111, code: "627123" },
    { id: 47027, cityId: 2111, code: "627126" },
    { id: 47028, cityId: 2111, code: "627128" },
    { id: 47029, cityId: 2111, code: "627131" },
    { id: 47030, cityId: 2111, code: "627152" },
    { id: 47031, cityId: 2111, code: "627202" },
    { id: 47032, cityId: 2111, code: "627253" },
    { id: 47033, cityId: 2111, code: "627255" },
    { id: 47034, cityId: 2111, code: "627301" },
    { id: 47035, cityId: 2111, code: "627303" },
    { id: 47036, cityId: 2111, code: "627351" },
    { id: 47037, cityId: 2111, code: "627353" },
    { id: 47038, cityId: 2111, code: "627354" },
    { id: 47039, cityId: 2111, code: "627356" },
    { id: 47040, cityId: 2111, code: "627359" },
    { id: 47041, cityId: 2111, code: "627361" },
    { id: 47042, cityId: 2111, code: "627401" },
    { id: 47043, cityId: 2111, code: "627412" },
    { id: 47044, cityId: 2111, code: "627414" },
    { id: 47045, cityId: 2111, code: "627415" },
    { id: 47046, cityId: 2111, code: "627419" },
    { id: 47047, cityId: 2111, code: "627420" },
    { id: 47048, cityId: 2111, code: "627422" },
    { id: 47049, cityId: 2111, code: "627425" },
    { id: 47050, cityId: 2111, code: "627427" },
    { id: 47051, cityId: 2111, code: "627428" },
    { id: 47052, cityId: 2111, code: "627430" },
    { id: 47053, cityId: 2111, code: "627433" },
    { id: 47054, cityId: 2111, code: "627435" },
    { id: 47055, cityId: 2111, code: "627451" },
    { id: 47056, cityId: 2111, code: "627452" },
    { id: 47057, cityId: 2111, code: "627502" },
    { id: 47058, cityId: 2111, code: "627602" },
    { id: 47059, cityId: 2111, code: "627603" },
    { id: 47060, cityId: 2111, code: "627706" },
    { id: 47061, cityId: 2111, code: "627713" },
    { id: 47062, cityId: 2111, code: "627716" },
    { id: 47063, cityId: 2111, code: "627719" },
    { id: 47064, cityId: 2111, code: "627721" },
    { id: 47065, cityId: 2111, code: "627722" },
    { id: 47066, cityId: 2111, code: "627724" },
    { id: 47067, cityId: 2111, code: "627727" },
    { id: 47068, cityId: 2111, code: "627751" },
    { id: 47069, cityId: 2111, code: "627753" },
    { id: 47070, cityId: 2111, code: "627754" },
    { id: 47071, cityId: 2111, code: "627756" },
    { id: 47072, cityId: 2111, code: "627759" },
    { id: 47073, cityId: 2111, code: "627761" },
    { id: 47074, cityId: 2111, code: "627764" },
    { id: 47075, cityId: 2111, code: "627766" },
    { id: 47076, cityId: 2111, code: "627767" },
    { id: 47077, cityId: 2111, code: "627769" },
    { id: 47078, cityId: 2111, code: "627774" },
    { id: 47079, cityId: 2111, code: "627801" },
    { id: 47080, cityId: 2111, code: "627804" },
    { id: 47081, cityId: 2111, code: "627806" },
    { id: 47082, cityId: 2111, code: "627809" },
    { id: 47083, cityId: 2111, code: "627811" },
    { id: 47084, cityId: 2111, code: "627812" },
    { id: 47085, cityId: 2111, code: "627814" },
    { id: 47086, cityId: 2111, code: "627817" },
    { id: 47087, cityId: 2111, code: "627819" },
    { id: 47088, cityId: 2111, code: "627820" },
    { id: 47089, cityId: 2111, code: "627822" },
    { id: 47090, cityId: 2111, code: "627852" },
    { id: 47091, cityId: 2111, code: "627854" },
    { id: 47092, cityId: 2111, code: "627857" },
    { id: 47093, cityId: 2111, code: "627862" },
    { id: 47094, cityId: 2111, code: "627864" },
    { id: 47095, cityId: 2111, code: "627902" },
    { id: 47096, cityId: 2111, code: "627904" },
    { id: 47097, cityId: 2111, code: "627909" },
    { id: 47098, cityId: 2111, code: "627910" },
    { id: 47099, cityId: 2111, code: "627912" },
    { id: 47100, cityId: 2111, code: "627952" },
    { id: 47101, cityId: 2111, code: "627954" },
    { id: 47102, cityId: 2111, code: "627955" },
    { id: 47103, cityId: 2111, code: "627957" },
    { id: 47104, cityId: 2792, code: "628002" },
    { id: 47105, cityId: 2792, code: "628005" },
    { id: 47106, cityId: 2792, code: "628007" },
    { id: 47107, cityId: 2792, code: "628008" },
    { id: 47108, cityId: 2111, code: "628105" },
    { id: 47109, cityId: 2111, code: "628151" },
    { id: 47110, cityId: 2111, code: "628153" },
    { id: 47111, cityId: 2111, code: "628201" },
    { id: 47112, cityId: 2111, code: "628203" },
    { id: 47113, cityId: 2111, code: "628204" },
    { id: 47114, cityId: 2111, code: "628206" },
    { id: 47115, cityId: 2111, code: "628209" },
    { id: 47116, cityId: 2111, code: "628211" },
    { id: 47117, cityId: 2111, code: "628214" },
    { id: 47118, cityId: 2111, code: "628217" },
    { id: 47119, cityId: 2111, code: "628219" },
    { id: 47120, cityId: 2111, code: "628220" },
    { id: 47121, cityId: 2111, code: "628222" },
    { id: 47122, cityId: 2111, code: "628227" },
    { id: 47123, cityId: 2111, code: "628228" },
    { id: 47124, cityId: 2111, code: "628251" },
    { id: 47125, cityId: 2111, code: "628301" },
    { id: 47126, cityId: 2111, code: "628302" },
    { id: 47127, cityId: 2111, code: "628304" },
    { id: 47128, cityId: 2111, code: "628307" },
    { id: 47129, cityId: 2111, code: "628309" },
    { id: 47130, cityId: 2111, code: "628402" },
    { id: 47131, cityId: 2111, code: "628513" },
    { id: 47132, cityId: 2111, code: "628601" },
    { id: 47133, cityId: 2111, code: "628612" },
    { id: 47134, cityId: 2111, code: "628614" },
    { id: 47135, cityId: 2111, code: "628617" },
    { id: 47136, cityId: 2111, code: "628619" },
    { id: 47137, cityId: 2111, code: "628620" },
    { id: 47138, cityId: 2111, code: "628622" },
    { id: 47139, cityId: 2111, code: "628625" },
    { id: 47140, cityId: 2111, code: "628627" },
    { id: 47141, cityId: 2111, code: "628628" },
    { id: 47142, cityId: 2111, code: "628630" },
    { id: 47143, cityId: 2111, code: "628651" },
    { id: 47144, cityId: 2111, code: "628654" },
    { id: 47145, cityId: 2111, code: "628656" },
    { id: 47146, cityId: 2111, code: "628657" },
    { id: 47147, cityId: 2111, code: "628659" },
    { id: 47148, cityId: 2111, code: "628662" },
    { id: 47149, cityId: 2111, code: "628701" },
    { id: 47150, cityId: 2111, code: "628702" },
    { id: 47151, cityId: 2111, code: "628704" },
    { id: 47152, cityId: 2111, code: "628707" },
    { id: 47153, cityId: 2111, code: "628802" },
    { id: 47154, cityId: 2111, code: "623705" },
    { id: 47155, cityId: 2111, code: "626716" },
    { id: 47156, cityId: 2111, code: "627002" },
    { id: 47157, cityId: 2111, code: "627003" },
    { id: 47158, cityId: 2111, code: "627005" },
    { id: 47159, cityId: 2111, code: "627008" },
    { id: 47160, cityId: 2111, code: "627010" },
    { id: 47161, cityId: 2111, code: "627011" },
    { id: 47162, cityId: 2111, code: "627101" },
    { id: 47163, cityId: 2111, code: "627103" },
    { id: 47164, cityId: 2111, code: "627106" },
    { id: 47165, cityId: 2111, code: "627108" },
    { id: 47166, cityId: 2111, code: "627111" },
    { id: 47167, cityId: 2111, code: "627114" },
    { id: 47168, cityId: 2111, code: "627116" },
    { id: 47169, cityId: 2111, code: "627117" },
    { id: 47170, cityId: 2111, code: "627122" },
    { id: 47171, cityId: 2111, code: "627124" },
    { id: 47172, cityId: 2111, code: "627125" },
    { id: 47173, cityId: 2111, code: "627127" },
    { id: 47174, cityId: 2111, code: "627130" },
    { id: 47175, cityId: 2111, code: "627132" },
    { id: 47176, cityId: 2111, code: "627151" },
    { id: 47177, cityId: 2111, code: "627153" },
    { id: 47178, cityId: 2111, code: "627154" },
    { id: 47179, cityId: 2111, code: "627201" },
    { id: 47180, cityId: 2111, code: "627251" },
    { id: 47181, cityId: 2111, code: "627252" },
    { id: 47182, cityId: 2111, code: "627254" },
    { id: 47183, cityId: 2111, code: "627302" },
    { id: 47184, cityId: 2111, code: "627304" },
    { id: 47185, cityId: 2111, code: "627355" },
    { id: 47186, cityId: 2111, code: "627357" },
    { id: 47187, cityId: 2111, code: "627358" },
    { id: 47188, cityId: 2111, code: "627360" },
    { id: 47189, cityId: 2111, code: "627413" },
    { id: 47190, cityId: 2111, code: "627416" },
    { id: 47191, cityId: 2111, code: "627418" },
    { id: 47192, cityId: 2111, code: "627421" },
    { id: 47193, cityId: 2111, code: "627423" },
    { id: 47194, cityId: 2111, code: "627424" },
    { id: 47195, cityId: 2111, code: "627426" },
    { id: 47196, cityId: 2111, code: "627431" },
    { id: 47197, cityId: 2111, code: "627432" },
    { id: 47198, cityId: 2111, code: "627434" },
    { id: 47199, cityId: 2111, code: "627453" },
    { id: 47200, cityId: 2111, code: "627501" },
    { id: 47201, cityId: 2111, code: "627551" },
    { id: 47202, cityId: 2111, code: "627604" },
    { id: 47203, cityId: 2111, code: "627702" },
    { id: 47204, cityId: 2111, code: "627712" },
    { id: 47205, cityId: 2111, code: "627717" },
    { id: 47206, cityId: 2111, code: "627718" },
    { id: 47207, cityId: 2111, code: "627720" },
    { id: 47208, cityId: 2111, code: "627723" },
    { id: 47209, cityId: 2111, code: "627765" },
    { id: 47210, cityId: 2111, code: "627768" },
    { id: 47211, cityId: 2111, code: "627770" },
    { id: 47212, cityId: 2111, code: "627771" },
    { id: 47213, cityId: 2111, code: "627773" },
    { id: 47214, cityId: 2111, code: "627802" },
    { id: 47215, cityId: 2111, code: "627810" },
    { id: 47216, cityId: 2111, code: "627813" },
    { id: 47217, cityId: 2111, code: "627815" },
    { id: 47218, cityId: 2111, code: "627816" },
    { id: 47219, cityId: 2111, code: "627821" },
    { id: 47220, cityId: 2111, code: "627823" },
    { id: 47221, cityId: 2111, code: "627855" },
    { id: 47222, cityId: 2111, code: "627856" },
    { id: 47223, cityId: 2111, code: "627860" },
    { id: 47224, cityId: 2111, code: "627861" },
    { id: 47225, cityId: 2111, code: "627863" },
    { id: 47226, cityId: 2111, code: "627866" },
    { id: 47227, cityId: 2111, code: "627901" },
    { id: 47228, cityId: 2111, code: "627903" },
    { id: 47229, cityId: 2111, code: "627905" },
    { id: 47230, cityId: 2111, code: "627906" },
    { id: 47231, cityId: 2111, code: "627908" },
    { id: 47232, cityId: 2111, code: "627911" },
    { id: 47233, cityId: 2111, code: "627951" },
    { id: 47234, cityId: 2111, code: "627953" },
    { id: 47235, cityId: 2111, code: "627956" },
    { id: 47236, cityId: 2792, code: "628001" },
    { id: 47237, cityId: 2792, code: "628003" },
    { id: 47238, cityId: 2792, code: "628004" },
    { id: 47239, cityId: 2792, code: "628006" },
    { id: 47240, cityId: 2111, code: "628051" },
    { id: 47241, cityId: 2111, code: "628101" },
    { id: 47242, cityId: 2111, code: "628102" },
    { id: 47243, cityId: 2111, code: "628104" },
    { id: 47244, cityId: 2111, code: "628152" },
    { id: 47245, cityId: 2111, code: "628154" },
    { id: 47246, cityId: 2111, code: "628155" },
    { id: 47247, cityId: 2111, code: "628205" },
    { id: 47248, cityId: 2111, code: "628208" },
    { id: 47249, cityId: 2111, code: "628210" },
    { id: 47250, cityId: 2111, code: "628213" },
    { id: 47251, cityId: 2111, code: "628215" },
    { id: 47252, cityId: 2111, code: "628216" },
    { id: 47253, cityId: 2111, code: "628218" },
    { id: 47254, cityId: 2111, code: "628221" },
    { id: 47255, cityId: 2111, code: "628223" },
    { id: 47256, cityId: 2111, code: "628224" },
    { id: 47257, cityId: 2111, code: "628252" },
    { id: 47258, cityId: 2111, code: "628303" },
    { id: 47259, cityId: 2111, code: "628305" },
    { id: 47260, cityId: 2111, code: "628306" },
    { id: 47261, cityId: 2111, code: "628401" },
    { id: 47262, cityId: 2111, code: "628613" },
    { id: 47263, cityId: 2111, code: "628615" },
    { id: 47264, cityId: 2111, code: "628616" },
    { id: 47265, cityId: 2111, code: "628618" },
    { id: 47266, cityId: 2111, code: "628621" },
    { id: 47267, cityId: 2111, code: "628624" },
    { id: 47268, cityId: 2111, code: "628626" },
    { id: 47269, cityId: 2111, code: "628629" },
    { id: 47270, cityId: 2111, code: "628631" },
    { id: 47271, cityId: 2111, code: "628652" },
    { id: 47272, cityId: 2111, code: "628655" },
    { id: 47273, cityId: 2111, code: "628658" },
    { id: 47274, cityId: 2111, code: "628660" },
    { id: 47275, cityId: 2111, code: "628661" },
    { id: 47276, cityId: 2111, code: "628663" },
    { id: 47277, cityId: 2111, code: "628703" },
    { id: 47278, cityId: 2111, code: "628705" },
    { id: 47279, cityId: 2111, code: "628751" },
    { id: 47280, cityId: 2111, code: "628753" },
    { id: 47281, cityId: 2111, code: "628803" },
    { id: 47282, cityId: 2111, code: "629103" },
    { id: 47283, cityId: 2112, code: "631209" },
    { id: 47284, cityId: 2113, code: "600109" },
    { id: 47285, cityId: 2113, code: "601103" },
    { id: 47286, cityId: 2113, code: "601105" },
    { id: 47287, cityId: 2113, code: "601201" },
    { id: 47288, cityId: 2113, code: "601206" },
    { id: 47289, cityId: 2113, code: "601209" },
    { id: 47290, cityId: 2113, code: "601211" },
    { id: 47291, cityId: 2113, code: "601212" },
    { id: 47292, cityId: 2113, code: "601214" },
    { id: 47293, cityId: 2113, code: "601301" },
    { id: 47294, cityId: 2113, code: "601302" },
    { id: 47295, cityId: 2113, code: "601304" },
    { id: 47296, cityId: 2113, code: "602001" },
    { id: 47297, cityId: 2113, code: "602003" },
    { id: 47298, cityId: 2113, code: "602022" },
    { id: 47299, cityId: 2113, code: "602024" },
    { id: 47300, cityId: 2113, code: "602025" },
    { id: 47301, cityId: 2113, code: "602104" },
    { id: 47302, cityId: 2113, code: "602106" },
    { id: 47303, cityId: 2113, code: "602107" },
    { id: 47304, cityId: 2113, code: "602109" },
    { id: 47305, cityId: 2113, code: "602112" },
    { id: 47306, cityId: 2113, code: "602114" },
    { id: 47307, cityId: 2113, code: "602115" },
    { id: 47308, cityId: 2113, code: "603002" },
    { id: 47309, cityId: 2113, code: "603102" },
    { id: 47310, cityId: 2113, code: "603105" },
    { id: 47311, cityId: 2113, code: "603110" },
    { id: 47312, cityId: 2113, code: "603111" },
    { id: 47313, cityId: 2113, code: "603113" },
    { id: 47314, cityId: 2113, code: "603116" },
    { id: 47315, cityId: 2113, code: "603121" },
    { id: 47316, cityId: 2113, code: "603201" },
    { id: 47317, cityId: 2113, code: "603203" },
    { id: 47318, cityId: 2113, code: "603301" },
    { id: 47319, cityId: 2113, code: "603304" },
    { id: 47320, cityId: 2113, code: "603306" },
    { id: 47321, cityId: 2113, code: "603307" },
    { id: 47322, cityId: 2113, code: "603311" },
    { id: 47323, cityId: 2113, code: "603312" },
    { id: 47324, cityId: 2113, code: "603314" },
    { id: 47325, cityId: 2113, code: "603317" },
    { id: 47326, cityId: 2113, code: "603319" },
    { id: 47327, cityId: 2113, code: "603320" },
    { id: 47328, cityId: 2113, code: "603402" },
    { id: 47329, cityId: 2113, code: "603404" },
    { id: 47330, cityId: 2113, code: "603405" },
    { id: 47331, cityId: 2113, code: "603407" },
    { id: 47332, cityId: 2113, code: "631051" },
    { id: 47333, cityId: 2113, code: "631105" },
    { id: 47334, cityId: 2113, code: "631202" },
    { id: 47335, cityId: 2113, code: "631203" },
    { id: 47336, cityId: 2113, code: "631205" },
    { id: 47337, cityId: 2113, code: "631211" },
    { id: 47338, cityId: 2113, code: "631213" },
    { id: 47339, cityId: 2113, code: "631303" },
    { id: 47340, cityId: 2113, code: "631502" },
    { id: 47341, cityId: 2113, code: "631602" },
    { id: 47342, cityId: 2113, code: "631603" },
    { id: 47343, cityId: 2113, code: "631605" },
    { id: 47344, cityId: 2113, code: "600093" },
    { id: 47345, cityId: 2113, code: "600106" },
    { id: 47346, cityId: 2113, code: "601101" },
    { id: 47347, cityId: 2113, code: "601102" },
    { id: 47348, cityId: 2113, code: "601104" },
    { id: 47349, cityId: 2113, code: "601202" },
    { id: 47350, cityId: 2113, code: "601205" },
    { id: 47351, cityId: 2113, code: "601207" },
    { id: 47352, cityId: 2113, code: "601208" },
    { id: 47353, cityId: 2113, code: "601213" },
    { id: 47354, cityId: 2113, code: "601303" },
    { id: 47355, cityId: 2113, code: "602004" },
    { id: 47356, cityId: 2113, code: "602021" },
    { id: 47357, cityId: 2113, code: "602023" },
    { id: 47358, cityId: 2113, code: "602026" },
    { id: 47359, cityId: 2113, code: "602029" },
    { id: 47360, cityId: 2113, code: "602031" },
    { id: 47361, cityId: 2113, code: "602103" },
    { id: 47362, cityId: 2113, code: "602105" },
    { id: 47363, cityId: 2113, code: "602108" },
    { id: 47364, cityId: 2113, code: "602111" },
    { id: 47365, cityId: 2113, code: "602113" },
    { id: 47366, cityId: 2113, code: "602116" },
    { id: 47367, cityId: 2113, code: "603001" },
    { id: 47368, cityId: 2113, code: "603011" },
    { id: 47369, cityId: 2113, code: "603101" },
    { id: 47370, cityId: 2113, code: "603106" },
    { id: 47371, cityId: 2113, code: "603107" },
    { id: 47372, cityId: 2113, code: "603109" },
    { id: 47373, cityId: 2113, code: "603112" },
    { id: 47374, cityId: 2113, code: "603114" },
    { id: 47375, cityId: 2113, code: "603115" },
    { id: 47376, cityId: 2113, code: "603117" },
    { id: 47377, cityId: 2113, code: "603119" },
    { id: 47378, cityId: 2113, code: "603120" },
    { id: 47379, cityId: 2113, code: "603122" },
    { id: 47380, cityId: 2113, code: "603202" },
    { id: 47381, cityId: 2113, code: "603204" },
    { id: 47382, cityId: 2113, code: "603302" },
    { id: 47383, cityId: 2113, code: "603305" },
    { id: 47384, cityId: 2113, code: "603308" },
    { id: 47385, cityId: 2113, code: "603310" },
    { id: 47386, cityId: 2113, code: "603313" },
    { id: 47387, cityId: 2113, code: "603315" },
    { id: 47388, cityId: 2113, code: "603316" },
    { id: 47389, cityId: 2113, code: "603403" },
    { id: 47390, cityId: 2113, code: "603408" },
    { id: 47391, cityId: 2113, code: "604402" },
    { id: 47392, cityId: 2113, code: "631201" },
    { id: 47393, cityId: 2113, code: "631204" },
    { id: 47394, cityId: 2113, code: "631206" },
    { id: 47395, cityId: 2113, code: "631207" },
    { id: 47396, cityId: 2113, code: "631209" },
    { id: 47397, cityId: 2113, code: "631302" },
    { id: 47398, cityId: 2113, code: "631304" },
    { id: 47399, cityId: 2113, code: "631501" },
    { id: 47400, cityId: 2113, code: "631503" },
    { id: 47401, cityId: 2113, code: "631551" },
    { id: 47402, cityId: 2113, code: "631606" },
    { id: 47403, cityId: 2113, code: "631609" },
    { id: 47404, cityId: 2114, code: "604408" },
    { id: 47405, cityId: 2114, code: "606803" },
    { id: 47406, cityId: 2115, code: "600077" },
    { id: 47407, cityId: 2116, code: "600019" },
    { id: 47408, cityId: 2117, code: "636102" },
    { id: 47409, cityId: 2118, code: "621011" },
    { id: 47410, cityId: 2119, code: "642106" },
    { id: 47411, cityId: 2119, code: "643001" },
    { id: 47412, cityId: 2119, code: "643003" },
    { id: 47413, cityId: 2119, code: "643004" },
    { id: 47414, cityId: 2119, code: "643006" },
    { id: 47415, cityId: 2119, code: "643051" },
    { id: 47416, cityId: 2119, code: "643054" },
    { id: 47417, cityId: 2119, code: "643101" },
    { id: 47418, cityId: 2119, code: "643102" },
    { id: 47419, cityId: 2119, code: "643104" },
    { id: 47420, cityId: 2119, code: "643201" },
    { id: 47421, cityId: 2119, code: "643203" },
    { id: 47422, cityId: 2119, code: "643204" },
    { id: 47423, cityId: 2119, code: "643206" },
    { id: 47424, cityId: 2119, code: "643209" },
    { id: 47425, cityId: 2119, code: "643211" },
    { id: 47426, cityId: 2119, code: "643212" },
    { id: 47427, cityId: 2119, code: "643214" },
    { id: 47428, cityId: 2119, code: "643217" },
    { id: 47429, cityId: 2119, code: "643219" },
    { id: 47430, cityId: 2119, code: "643220" },
    { id: 47431, cityId: 2119, code: "643222" },
    { id: 47432, cityId: 2119, code: "643225" },
    { id: 47433, cityId: 2119, code: "643228" },
    { id: 47434, cityId: 2119, code: "643230" },
    { id: 47435, cityId: 2119, code: "643233" },
    { id: 47436, cityId: 2119, code: "643235" },
    { id: 47437, cityId: 2119, code: "643236" },
    { id: 47438, cityId: 2119, code: "643238" },
    { id: 47439, cityId: 2119, code: "643240" },
    { id: 47440, cityId: 2119, code: "643241" },
    { id: 47441, cityId: 2119, code: "643243" },
    { id: 47442, cityId: 2119, code: "643246" },
    { id: 47443, cityId: 2119, code: "643248" },
    { id: 47444, cityId: 2119, code: "643249" },
    { id: 47445, cityId: 2119, code: "643251" },
    { id: 47446, cityId: 2119, code: "643254" },
    { id: 47447, cityId: 2119, code: "643256" },
    { id: 47448, cityId: 2119, code: "643257" },
    { id: 47449, cityId: 2119, code: "643264" },
    { id: 47450, cityId: 2119, code: "643265" },
    { id: 47451, cityId: 2119, code: "643267" },
    { id: 47452, cityId: 2119, code: "643270" },
    { id: 47453, cityId: 2119, code: "643272" },
    { id: 47454, cityId: 2119, code: "643273" },
    { id: 47455, cityId: 2119, code: "643278" },
    { id: 47456, cityId: 2119, code: "643280" },
    { id: 47457, cityId: 2119, code: "643002" },
    { id: 47458, cityId: 2119, code: "643005" },
    { id: 47459, cityId: 2119, code: "643007" },
    { id: 47460, cityId: 2119, code: "643052" },
    { id: 47461, cityId: 2119, code: "643053" },
    { id: 47462, cityId: 2119, code: "643055" },
    { id: 47463, cityId: 2119, code: "643103" },
    { id: 47464, cityId: 2119, code: "643105" },
    { id: 47465, cityId: 2119, code: "643106" },
    { id: 47466, cityId: 2119, code: "643202" },
    { id: 47467, cityId: 2119, code: "643205" },
    { id: 47468, cityId: 2119, code: "643210" },
    { id: 47469, cityId: 2119, code: "643213" },
    { id: 47470, cityId: 2119, code: "643215" },
    { id: 47471, cityId: 2119, code: "643216" },
    { id: 47472, cityId: 2119, code: "643218" },
    { id: 47473, cityId: 2119, code: "643221" },
    { id: 47474, cityId: 2119, code: "643223" },
    { id: 47475, cityId: 2119, code: "643226" },
    { id: 47476, cityId: 2119, code: "643229" },
    { id: 47477, cityId: 2119, code: "643231" },
    { id: 47478, cityId: 2119, code: "643232" },
    { id: 47479, cityId: 2119, code: "643234" },
    { id: 47480, cityId: 2119, code: "643237" },
    { id: 47481, cityId: 2119, code: "643239" },
    { id: 47482, cityId: 2119, code: "643242" },
    { id: 47483, cityId: 2119, code: "643245" },
    { id: 47484, cityId: 2119, code: "643247" },
    { id: 47485, cityId: 2119, code: "643250" },
    { id: 47486, cityId: 2119, code: "643252" },
    { id: 47487, cityId: 2119, code: "643253" },
    { id: 47488, cityId: 2119, code: "643255" },
    { id: 47489, cityId: 2119, code: "643258" },
    { id: 47490, cityId: 2119, code: "643260" },
    { id: 47491, cityId: 2119, code: "643261" },
    { id: 47492, cityId: 2119, code: "643263" },
    { id: 47493, cityId: 2119, code: "643266" },
    { id: 47494, cityId: 2119, code: "643268" },
    { id: 47495, cityId: 2119, code: "643269" },
    { id: 47496, cityId: 2119, code: "643271" },
    { id: 47497, cityId: 2119, code: "643276" },
    { id: 47498, cityId: 2119, code: "643277" },
    { id: 47499, cityId: 2119, code: "643279" },
    { id: 47500, cityId: 2119, code: "643282" },
    { id: 47501, cityId: 2119, code: "643518" },
    { id: 47502, cityId: 2119, code: "666213" },
    { id: 47503, cityId: 2120, code: "626533" },
    { id: 47504, cityId: 2121, code: "603406" },
    { id: 47505, cityId: 2122, code: "624802" },
    { id: 47506, cityId: 2123, code: "624218" },
    { id: 47507, cityId: 2124, code: "632204" },
    { id: 47508, cityId: 2125, code: "613403" },
    { id: 47509, cityId: 2126, code: "642127" },
    { id: 47510, cityId: 2127, code: "600048" },
    { id: 47511, cityId: 2128, code: "604408" },
    { id: 47512, cityId: 2129, code: "635752" },
    { id: 47513, cityId: 2130, code: "627758" },
    { id: 47514, cityId: 2131, code: "624710" },
    { id: 47515, cityId: 2132, code: "627866" },
    { id: 47516, cityId: 2132, code: "638605" },
    { id: 47517, cityId: 2133, code: "638111" },
    { id: 47518, cityId: 2134, code: "641111" },
    { id: 47519, cityId: 2135, code: "600050" },
    { id: 47520, cityId: 2135, code: "604002" },
    { id: 47521, cityId: 2135, code: "604103" },
    { id: 47522, cityId: 2135, code: "604151" },
    { id: 47523, cityId: 2135, code: "604153" },
    { id: 47524, cityId: 2135, code: "604204" },
    { id: 47525, cityId: 2135, code: "604301" },
    { id: 47526, cityId: 2135, code: "604302" },
    { id: 47527, cityId: 2135, code: "604304" },
    { id: 47528, cityId: 2135, code: "604307" },
    { id: 47529, cityId: 2135, code: "604407" },
    { id: 47530, cityId: 2135, code: "604408" },
    { id: 47531, cityId: 2135, code: "604410" },
    { id: 47532, cityId: 2135, code: "604412" },
    { id: 47533, cityId: 2135, code: "604415" },
    { id: 47534, cityId: 2135, code: "604503" },
    { id: 47535, cityId: 2135, code: "604505" },
    { id: 47536, cityId: 2135, code: "605009" },
    { id: 47537, cityId: 2135, code: "605051" },
    { id: 47538, cityId: 2135, code: "605101" },
    { id: 47539, cityId: 2135, code: "605107" },
    { id: 47540, cityId: 2135, code: "605202" },
    { id: 47541, cityId: 2135, code: "605302" },
    { id: 47542, cityId: 2135, code: "605401" },
    { id: 47543, cityId: 2135, code: "605602" },
    { id: 47544, cityId: 2135, code: "605604" },
    { id: 47545, cityId: 2135, code: "605605" },
    { id: 47546, cityId: 2135, code: "605702" },
    { id: 47547, cityId: 2135, code: "605753" },
    { id: 47548, cityId: 2135, code: "605755" },
    { id: 47549, cityId: 2135, code: "605756" },
    { id: 47550, cityId: 2135, code: "605758" },
    { id: 47551, cityId: 2135, code: "605801" },
    { id: 47552, cityId: 2135, code: "605803" },
    { id: 47553, cityId: 2135, code: "605809" },
    { id: 47554, cityId: 2135, code: "606002" },
    { id: 47555, cityId: 2135, code: "606103" },
    { id: 47556, cityId: 2135, code: "606110" },
    { id: 47557, cityId: 2135, code: "606111" },
    { id: 47558, cityId: 2135, code: "606115" },
    { id: 47559, cityId: 2135, code: "606203" },
    { id: 47560, cityId: 2135, code: "606206" },
    { id: 47561, cityId: 2135, code: "606208" },
    { id: 47562, cityId: 2135, code: "606221" },
    { id: 47563, cityId: 2135, code: "606301" },
    { id: 47564, cityId: 2135, code: "606304" },
    { id: 47565, cityId: 2135, code: "606307" },
    { id: 47566, cityId: 2135, code: "606402" },
    { id: 47567, cityId: 2135, code: "606603" },
    { id: 47568, cityId: 2135, code: "606703" },
    { id: 47569, cityId: 2135, code: "606706" },
    { id: 47570, cityId: 2135, code: "606709" },
    { id: 47571, cityId: 2135, code: "606711" },
    { id: 47572, cityId: 2135, code: "606712" },
    { id: 47573, cityId: 2135, code: "606714" },
    { id: 47574, cityId: 2135, code: "606717" },
    { id: 47575, cityId: 2135, code: "606751" },
    { id: 47576, cityId: 2135, code: "606801" },
    { id: 47577, cityId: 2135, code: "606802" },
    { id: 47578, cityId: 2135, code: "606804" },
    { id: 47579, cityId: 2135, code: "606807" },
    { id: 47580, cityId: 2135, code: "606809" },
    { id: 47581, cityId: 2135, code: "606810" },
    { id: 47582, cityId: 2135, code: "606902" },
    { id: 47583, cityId: 2135, code: "606905" },
    { id: 47584, cityId: 2135, code: "606907" },
    { id: 47585, cityId: 2135, code: "606908" },
    { id: 47586, cityId: 2135, code: "606910" },
    { id: 47587, cityId: 2135, code: "607003" },
    { id: 47588, cityId: 2135, code: "607051" },
    { id: 47589, cityId: 2135, code: "607103" },
    { id: 47590, cityId: 2135, code: "607104" },
    { id: 47591, cityId: 2135, code: "607109" },
    { id: 47592, cityId: 2135, code: "607111" },
    { id: 47593, cityId: 2135, code: "607201" },
    { id: 47594, cityId: 2135, code: "607202" },
    { id: 47595, cityId: 2135, code: "607204" },
    { id: 47596, cityId: 2135, code: "607302" },
    { id: 47597, cityId: 2135, code: "607307" },
    { id: 47598, cityId: 2135, code: "607803" },
    { id: 47599, cityId: 2135, code: "607805" },
    { id: 47600, cityId: 2135, code: "608001" },
    { id: 47601, cityId: 2135, code: "608002" },
    { id: 47602, cityId: 2135, code: "608102" },
    { id: 47603, cityId: 2135, code: "608502" },
    { id: 47604, cityId: 2135, code: "608701" },
    { id: 47605, cityId: 2135, code: "613109" },
    { id: 47606, cityId: 2135, code: "620001" },
    { id: 47607, cityId: 2135, code: "631003" },
    { id: 47608, cityId: 2135, code: "631053" },
    { id: 47609, cityId: 2135, code: "631061" },
    { id: 47610, cityId: 2135, code: "631101" },
    { id: 47611, cityId: 2135, code: "631104" },
    { id: 47612, cityId: 2135, code: "631151" },
    { id: 47613, cityId: 2135, code: "631210" },
    { id: 47614, cityId: 2135, code: "631604" },
    { id: 47615, cityId: 2135, code: "631702" },
    { id: 47616, cityId: 2135, code: "632001" },
    { id: 47617, cityId: 2135, code: "632002" },
    { id: 47618, cityId: 2135, code: "632004" },
    { id: 47619, cityId: 2135, code: "632009" },
    { id: 47620, cityId: 2135, code: "632010" },
    { id: 47621, cityId: 2135, code: "632012" },
    { id: 47622, cityId: 2135, code: "632052" },
    { id: 47623, cityId: 2135, code: "632054" },
    { id: 47624, cityId: 2135, code: "632055" },
    { id: 47625, cityId: 2135, code: "632057" },
    { id: 47626, cityId: 2135, code: "632102" },
    { id: 47627, cityId: 2135, code: "632105" },
    { id: 47628, cityId: 2135, code: "632107" },
    { id: 47629, cityId: 2135, code: "632108" },
    { id: 47630, cityId: 2135, code: "632110" },
    { id: 47631, cityId: 2135, code: "632203" },
    { id: 47632, cityId: 2135, code: "632205" },
    { id: 47633, cityId: 2135, code: "632206" },
    { id: 47634, cityId: 2135, code: "632208" },
    { id: 47635, cityId: 2135, code: "632211" },
    { id: 47636, cityId: 2135, code: "632301" },
    { id: 47637, cityId: 2135, code: "632312" },
    { id: 47638, cityId: 2135, code: "632314" },
    { id: 47639, cityId: 2135, code: "632316" },
    { id: 47640, cityId: 2135, code: "632317" },
    { id: 47641, cityId: 2135, code: "632319" },
    { id: 47642, cityId: 2135, code: "632322" },
    { id: 47643, cityId: 2135, code: "632324" },
    { id: 47644, cityId: 2135, code: "632325" },
    { id: 47645, cityId: 2135, code: "632401" },
    { id: 47646, cityId: 2135, code: "632402" },
    { id: 47647, cityId: 2135, code: "632404" },
    { id: 47648, cityId: 2135, code: "632502" },
    { id: 47649, cityId: 2135, code: "632505" },
    { id: 47650, cityId: 2135, code: "632507" },
    { id: 47651, cityId: 2135, code: "632510" },
    { id: 47652, cityId: 2135, code: "632513" },
    { id: 47653, cityId: 2135, code: "632515" },
    { id: 47654, cityId: 2135, code: "632526" },
    { id: 47655, cityId: 2135, code: "632528" },
    { id: 47656, cityId: 2135, code: "632529" },
    { id: 47657, cityId: 2135, code: "632531" },
    { id: 47658, cityId: 2135, code: "632603" },
    { id: 47659, cityId: 2135, code: "632605" },
    { id: 47660, cityId: 2135, code: "632608" },
    { id: 47661, cityId: 2135, code: "635129" },
    { id: 47662, cityId: 2135, code: "635135" },
    { id: 47663, cityId: 2135, code: "635651" },
    { id: 47664, cityId: 2135, code: "635657" },
    { id: 47665, cityId: 2135, code: "635702" },
    { id: 47666, cityId: 2135, code: "635805" },
    { id: 47667, cityId: 2135, code: "635807" },
    { id: 47668, cityId: 2135, code: "635808" },
    { id: 47669, cityId: 2135, code: "635810" },
    { id: 47670, cityId: 2135, code: "635813" },
    { id: 47671, cityId: 2135, code: "635815" },
    { id: 47672, cityId: 2135, code: "635853" },
    { id: 47673, cityId: 2135, code: "636001" },
    { id: 47674, cityId: 2135, code: "637021" },
    { id: 47675, cityId: 2135, code: "637413" },
    { id: 47676, cityId: 2135, code: "638008" },
    { id: 47677, cityId: 2135, code: "604001" },
    { id: 47678, cityId: 2135, code: "604101" },
    { id: 47679, cityId: 2135, code: "604102" },
    { id: 47680, cityId: 2135, code: "604152" },
    { id: 47681, cityId: 2135, code: "604202" },
    { id: 47682, cityId: 2135, code: "604205" },
    { id: 47683, cityId: 2135, code: "604207" },
    { id: 47684, cityId: 2135, code: "604303" },
    { id: 47685, cityId: 2135, code: "604305" },
    { id: 47686, cityId: 2135, code: "604306" },
    { id: 47687, cityId: 2135, code: "604401" },
    { id: 47688, cityId: 2135, code: "604403" },
    { id: 47689, cityId: 2135, code: "604404" },
    { id: 47690, cityId: 2135, code: "604406" },
    { id: 47691, cityId: 2135, code: "604409" },
    { id: 47692, cityId: 2135, code: "604414" },
    { id: 47693, cityId: 2135, code: "604504" },
    { id: 47694, cityId: 2135, code: "605012" },
    { id: 47695, cityId: 2135, code: "605102" },
    { id: 47696, cityId: 2135, code: "605103" },
    { id: 47697, cityId: 2135, code: "605105" },
    { id: 47698, cityId: 2135, code: "605113" },
    { id: 47699, cityId: 2135, code: "605118" },
    { id: 47700, cityId: 2135, code: "605201" },
    { id: 47701, cityId: 2135, code: "605203" },
    { id: 47702, cityId: 2135, code: "605301" },
    { id: 47703, cityId: 2135, code: "605402" },
    { id: 47704, cityId: 2135, code: "605502" },
    { id: 47705, cityId: 2135, code: "605601" },
    { id: 47706, cityId: 2135, code: "605651" },
    { id: 47707, cityId: 2135, code: "605701" },
    { id: 47708, cityId: 2135, code: "605757" },
    { id: 47709, cityId: 2135, code: "605759" },
    { id: 47710, cityId: 2135, code: "605805" },
    { id: 47711, cityId: 2135, code: "606001" },
    { id: 47712, cityId: 2135, code: "606003" },
    { id: 47713, cityId: 2135, code: "606104" },
    { id: 47714, cityId: 2135, code: "606106" },
    { id: 47715, cityId: 2135, code: "606107" },
    { id: 47716, cityId: 2135, code: "606120" },
    { id: 47717, cityId: 2135, code: "606202" },
    { id: 47718, cityId: 2135, code: "606204" },
    { id: 47719, cityId: 2135, code: "606205" },
    { id: 47720, cityId: 2135, code: "606207" },
    { id: 47721, cityId: 2135, code: "606223" },
    { id: 47722, cityId: 2135, code: "606303" },
    { id: 47723, cityId: 2135, code: "606601" },
    { id: 47724, cityId: 2135, code: "606602" },
    { id: 47725, cityId: 2135, code: "606604" },
    { id: 47726, cityId: 2135, code: "606702" },
    { id: 47727, cityId: 2135, code: "606705" },
    { id: 47728, cityId: 2135, code: "606707" },
    { id: 47729, cityId: 2135, code: "606708" },
    { id: 47730, cityId: 2135, code: "606710" },
    { id: 47731, cityId: 2135, code: "606713" },
    { id: 47732, cityId: 2135, code: "606715" },
    { id: 47733, cityId: 2135, code: "606716" },
    { id: 47734, cityId: 2135, code: "606753" },
    { id: 47735, cityId: 2135, code: "606803" },
    { id: 47736, cityId: 2135, code: "606805" },
    { id: 47737, cityId: 2135, code: "606806" },
    { id: 47738, cityId: 2135, code: "606901" },
    { id: 47739, cityId: 2135, code: "606904" },
    { id: 47740, cityId: 2135, code: "606906" },
    { id: 47741, cityId: 2135, code: "606909" },
    { id: 47742, cityId: 2135, code: "606912" },
    { id: 47743, cityId: 2135, code: "607001" },
    { id: 47744, cityId: 2135, code: "607002" },
    { id: 47745, cityId: 2135, code: "607004" },
    { id: 47746, cityId: 2135, code: "607102" },
    { id: 47747, cityId: 2135, code: "607105" },
    { id: 47748, cityId: 2135, code: "607108" },
    { id: 47749, cityId: 2135, code: "607116" },
    { id: 47750, cityId: 2135, code: "607203" },
    { id: 47751, cityId: 2135, code: "607301" },
    { id: 47752, cityId: 2135, code: "607401" },
    { id: 47753, cityId: 2135, code: "607802" },
    { id: 47754, cityId: 2135, code: "607804" },
    { id: 47755, cityId: 2135, code: "607807" },
    { id: 47756, cityId: 2135, code: "608201" },
    { id: 47757, cityId: 2135, code: "608305" },
    { id: 47758, cityId: 2135, code: "608501" },
    { id: 47759, cityId: 2135, code: "608702" },
    { id: 47760, cityId: 2135, code: "608803" },
    { id: 47761, cityId: 2135, code: "630001" },
    { id: 47762, cityId: 2135, code: "631001" },
    { id: 47763, cityId: 2135, code: "631004" },
    { id: 47764, cityId: 2135, code: "631057" },
    { id: 47765, cityId: 2135, code: "631060" },
    { id: 47766, cityId: 2135, code: "631102" },
    { id: 47767, cityId: 2135, code: "631404" },
    { id: 47768, cityId: 2135, code: "631553" },
    { id: 47769, cityId: 2135, code: "631701" },
    { id: 47770, cityId: 2135, code: "632003" },
    { id: 47771, cityId: 2135, code: "632005" },
    { id: 47772, cityId: 2135, code: "632006" },
    { id: 47773, cityId: 2135, code: "632051" },
    { id: 47774, cityId: 2135, code: "632053" },
    { id: 47775, cityId: 2135, code: "632101" },
    { id: 47776, cityId: 2135, code: "632103" },
    { id: 47777, cityId: 2135, code: "632104" },
    { id: 47778, cityId: 2135, code: "632106" },
    { id: 47779, cityId: 2135, code: "632109" },
    { id: 47780, cityId: 2135, code: "632112" },
    { id: 47781, cityId: 2135, code: "632201" },
    { id: 47782, cityId: 2135, code: "632202" },
    { id: 47783, cityId: 2135, code: "632204" },
    { id: 47784, cityId: 2135, code: "632207" },
    { id: 47785, cityId: 2135, code: "632209" },
    { id: 47786, cityId: 2135, code: "632313" },
    { id: 47787, cityId: 2135, code: "632315" },
    { id: 47788, cityId: 2135, code: "632318" },
    { id: 47789, cityId: 2135, code: "632320" },
    { id: 47790, cityId: 2135, code: "632323" },
    { id: 47791, cityId: 2135, code: "632403" },
    { id: 47792, cityId: 2135, code: "632405" },
    { id: 47793, cityId: 2135, code: "632503" },
    { id: 47794, cityId: 2135, code: "632504" },
    { id: 47795, cityId: 2135, code: "632508" },
    { id: 47796, cityId: 2135, code: "632509" },
    { id: 47797, cityId: 2135, code: "632511" },
    { id: 47798, cityId: 2135, code: "632514" },
    { id: 47799, cityId: 2135, code: "632516" },
    { id: 47800, cityId: 2135, code: "632517" },
    { id: 47801, cityId: 2135, code: "632519" },
    { id: 47802, cityId: 2135, code: "632522" },
    { id: 47803, cityId: 2135, code: "632524" },
    { id: 47804, cityId: 2135, code: "632525" },
    { id: 47805, cityId: 2135, code: "632530" },
    { id: 47806, cityId: 2135, code: "632601" },
    { id: 47807, cityId: 2135, code: "632602" },
    { id: 47808, cityId: 2135, code: "632604" },
    { id: 47809, cityId: 2135, code: "632606" },
    { id: 47810, cityId: 2135, code: "632607" },
    { id: 47811, cityId: 2135, code: "635210" },
    { id: 47812, cityId: 2135, code: "635602" },
    { id: 47813, cityId: 2135, code: "635653" },
    { id: 47814, cityId: 2135, code: "635703" },
    { id: 47815, cityId: 2135, code: "635751" },
    { id: 47816, cityId: 2135, code: "635753" },
    { id: 47817, cityId: 2135, code: "635756" },
    { id: 47818, cityId: 2135, code: "635801" },
    { id: 47819, cityId: 2135, code: "635803" },
    { id: 47820, cityId: 2135, code: "635804" },
    { id: 47821, cityId: 2135, code: "635806" },
    { id: 47822, cityId: 2135, code: "635812" },
    { id: 47823, cityId: 2135, code: "635814" },
    { id: 47824, cityId: 2135, code: "635819" },
    { id: 47825, cityId: 2135, code: "635851" },
    { id: 47826, cityId: 2135, code: "635854" },
    { id: 47827, cityId: 2135, code: "638402" },
    { id: 47828, cityId: 2136, code: "604154" },
    { id: 47829, cityId: 2136, code: "614724" },
    { id: 47830, cityId: 2136, code: "638182" },
    { id: 47831, cityId: 2137, code: "612105" },
    { id: 47832, cityId: 2138, code: "642129" },
    { id: 47833, cityId: 2139, code: "606754" },
    { id: 47834, cityId: 2140, code: "627425" },
    { id: 47835, cityId: 2141, code: "605652" },
    { id: 47836, cityId: 2142, code: "632521" },
    { id: 47837, cityId: 2143, code: "627907" },
    { id: 47838, cityId: 2144, code: "629180" },
    { id: 47839, cityId: 2145, code: "600080" },
    { id: 47840, cityId: 2145, code: "604201" },
    { id: 47841, cityId: 2145, code: "604212" },
    { id: 47842, cityId: 2145, code: "605655" },
    { id: 47843, cityId: 2145, code: "606718" },
    { id: 47844, cityId: 2145, code: "606911" },
    { id: 47845, cityId: 2145, code: "607101" },
    { id: 47846, cityId: 2145, code: "607107" },
    { id: 47847, cityId: 2145, code: "607207" },
    { id: 47848, cityId: 2145, code: "626160" },
    { id: 47849, cityId: 2145, code: "628207" },
    { id: 47850, cityId: 2145, code: "632518" },
    { id: 47851, cityId: 2145, code: "637411" },
    { id: 47852, cityId: 2145, code: "641108" },
    { id: 47853, cityId: 2145, code: "604155" },
    { id: 47854, cityId: 2145, code: "604203" },
    { id: 47855, cityId: 2145, code: "604208" },
    { id: 47856, cityId: 2145, code: "604210" },
    { id: 47857, cityId: 2145, code: "605109" },
    { id: 47858, cityId: 2145, code: "606102" },
    { id: 47859, cityId: 2145, code: "606305" },
    { id: 47860, cityId: 2145, code: "621102" },
    { id: 47861, cityId: 2145, code: "621221" },
    { id: 47862, cityId: 2145, code: "626169" },
    { id: 47863, cityId: 2145, code: "637205" },
    { id: 47864, cityId: 2146, code: "609314" },
    { id: 47865, cityId: 2146, code: "621315" },
    { id: 47866, cityId: 2146, code: "626001" },
    { id: 47867, cityId: 2146, code: "626003" },
    { id: 47868, cityId: 2146, code: "626004" },
    { id: 47869, cityId: 2146, code: "626051" },
    { id: 47870, cityId: 2146, code: "626054" },
    { id: 47871, cityId: 2146, code: "626056" },
    { id: 47872, cityId: 2146, code: "626059" },
    { id: 47873, cityId: 2146, code: "626101" },
    { id: 47874, cityId: 2146, code: "626102" },
    { id: 47875, cityId: 2146, code: "626104" },
    { id: 47876, cityId: 2146, code: "626107" },
    { id: 47877, cityId: 2146, code: "626109" },
    { id: 47878, cityId: 2146, code: "626110" },
    { id: 47879, cityId: 2146, code: "626112" },
    { id: 47880, cityId: 2146, code: "626115" },
    { id: 47881, cityId: 2146, code: "626117" },
    { id: 47882, cityId: 2146, code: "626122" },
    { id: 47883, cityId: 2146, code: "626123" },
    { id: 47884, cityId: 2146, code: "626125" },
    { id: 47885, cityId: 2146, code: "626128" },
    { id: 47886, cityId: 2146, code: "626130" },
    { id: 47887, cityId: 2146, code: "626131" },
    { id: 47888, cityId: 2146, code: "626133" },
    { id: 47889, cityId: 2146, code: "626136" },
    { id: 47890, cityId: 2146, code: "626138" },
    { id: 47891, cityId: 2146, code: "626139" },
    { id: 47892, cityId: 2146, code: "626141" },
    { id: 47893, cityId: 2146, code: "626146" },
    { id: 47894, cityId: 2146, code: "626147" },
    { id: 47895, cityId: 2146, code: "626149" },
    { id: 47896, cityId: 2146, code: "626152" },
    { id: 47897, cityId: 2146, code: "626154" },
    { id: 47898, cityId: 2146, code: "626155" },
    { id: 47899, cityId: 2146, code: "626157" },
    { id: 47900, cityId: 2146, code: "626162" },
    { id: 47901, cityId: 2146, code: "626163" },
    { id: 47902, cityId: 2146, code: "626165" },
    { id: 47903, cityId: 2146, code: "626167" },
    { id: 47904, cityId: 2146, code: "626168" },
    { id: 47905, cityId: 2146, code: "626170" },
    { id: 47906, cityId: 2146, code: "626173" },
    { id: 47907, cityId: 2146, code: "626175" },
    { id: 47908, cityId: 2146, code: "626178" },
    { id: 47909, cityId: 2146, code: "626181" },
    { id: 47910, cityId: 2146, code: "626183" },
    { id: 47911, cityId: 2146, code: "626186" },
    { id: 47912, cityId: 2146, code: "626202" },
    { id: 47913, cityId: 2146, code: "626205" },
    { id: 47914, cityId: 2146, code: "626207" },
    { id: 47915, cityId: 2146, code: "626208" },
    { id: 47916, cityId: 2146, code: "626210" },
    { id: 47917, cityId: 2146, code: "626213" },
    { id: 47918, cityId: 2146, code: "627762" },
    { id: 47919, cityId: 2146, code: "628308" },
    { id: 47920, cityId: 2146, code: "626005" },
    { id: 47921, cityId: 2146, code: "626052" },
    { id: 47922, cityId: 2146, code: "626053" },
    { id: 47923, cityId: 2146, code: "626055" },
    { id: 47924, cityId: 2146, code: "626058" },
    { id: 47925, cityId: 2146, code: "626103" },
    { id: 47926, cityId: 2146, code: "626105" },
    { id: 47927, cityId: 2146, code: "626106" },
    { id: 47928, cityId: 2146, code: "626108" },
    { id: 47929, cityId: 2146, code: "626111" },
    { id: 47930, cityId: 2146, code: "626113" },
    { id: 47931, cityId: 2146, code: "626114" },
    { id: 47932, cityId: 2146, code: "626116" },
    { id: 47933, cityId: 2146, code: "626118" },
    { id: 47934, cityId: 2146, code: "626119" },
    { id: 47935, cityId: 2146, code: "626124" },
    { id: 47936, cityId: 2146, code: "626127" },
    { id: 47937, cityId: 2146, code: "626129" },
    { id: 47938, cityId: 2146, code: "626132" },
    { id: 47939, cityId: 2146, code: "626135" },
    { id: 47940, cityId: 2146, code: "626137" },
    { id: 47941, cityId: 2146, code: "626140" },
    { id: 47942, cityId: 2146, code: "626142" },
    { id: 47943, cityId: 2146, code: "626145" },
    { id: 47944, cityId: 2146, code: "626148" },
    { id: 47945, cityId: 2146, code: "626150" },
    { id: 47946, cityId: 2146, code: "626151" },
    { id: 47947, cityId: 2146, code: "626153" },
    { id: 47948, cityId: 2146, code: "626156" },
    { id: 47949, cityId: 2146, code: "626158" },
    { id: 47950, cityId: 2146, code: "626159" },
    { id: 47951, cityId: 2146, code: "626161" },
    { id: 47952, cityId: 2146, code: "626164" },
    { id: 47953, cityId: 2146, code: "626166" },
    { id: 47954, cityId: 2146, code: "626171" },
    { id: 47955, cityId: 2146, code: "626172" },
    { id: 47956, cityId: 2146, code: "626177" },
    { id: 47957, cityId: 2146, code: "626179" },
    { id: 47958, cityId: 2146, code: "626180" },
    { id: 47959, cityId: 2146, code: "626187" },
    { id: 47960, cityId: 2146, code: "626188" },
    { id: 47961, cityId: 2146, code: "626195" },
    { id: 47962, cityId: 2146, code: "626204" },
    { id: 47963, cityId: 2146, code: "626206" },
    { id: 47964, cityId: 2146, code: "626209" },
    { id: 47965, cityId: 2146, code: "626211" },
    { id: 47966, cityId: 2146, code: "626212" },
    { id: 47967, cityId: 2146, code: "627755" },
    { id: 47968, cityId: 2146, code: "637410" },
    { id: 47969, cityId: 2147, code: "626176" },
    { id: 47970, cityId: 2148, code: "631605" },
    { id: 47971, cityId: 2149, code: "632513" },
    { id: 47972, cityId: 2150, code: "643231" },
    { id: 47973, cityId: 2151, code: "799101" },
    { id: 47974, cityId: 2152, code: "799001" },
    { id: 47975, cityId: 2153, code: "799155" },
    { id: 47976, cityId: 2154, code: "799250" },
    { id: 47977, cityId: 2155, code: "799010" },
    { id: 47978, cityId: 2156, code: "799285" },
    { id: 47979, cityId: 2157, code: "799270" },
    { id: 47980, cityId: 2158, code: "799201" },
    { id: 47981, cityId: 2159, code: "799264" },
    { id: 47982, cityId: 2160, code: "799006" },
    { id: 47983, cityId: 2161, code: "799035" },
    { id: 47984, cityId: 2162, code: "799145" },
    { id: 47985, cityId: 2163, code: "799205" },
    { id: 47986, cityId: 2164, code: "799003" },
    { id: 47987, cityId: 2164, code: "799008" },
    { id: 47988, cityId: 2164, code: "799009" },
    { id: 47989, cityId: 2164, code: "799011" },
    { id: 47990, cityId: 2164, code: "799045" },
    { id: 47991, cityId: 2164, code: "799106" },
    { id: 47992, cityId: 2164, code: "799107" },
    { id: 47993, cityId: 2164, code: "799109" },
    { id: 47994, cityId: 2164, code: "799115" },
    { id: 47995, cityId: 2164, code: "799130" },
    { id: 47996, cityId: 2164, code: "799202" },
    { id: 47997, cityId: 2164, code: "799210" },
    { id: 47998, cityId: 2164, code: "799212" },
    { id: 47999, cityId: 2164, code: "799213" },
    { id: 48000, cityId: 2164, code: "799002" },
    { id: 48001, cityId: 2164, code: "799004" },
    { id: 48002, cityId: 2164, code: "799005" },
    { id: 48003, cityId: 2164, code: "799007" },
    { id: 48004, cityId: 2164, code: "799012" },
    { id: 48005, cityId: 2164, code: "799015" },
    { id: 48006, cityId: 2164, code: "799055" },
    { id: 48007, cityId: 2164, code: "799102" },
    { id: 48008, cityId: 2164, code: "799103" },
    { id: 48009, cityId: 2164, code: "799131" },
    { id: 48010, cityId: 2164, code: "799132" },
    { id: 48011, cityId: 2164, code: "799203" },
    { id: 48012, cityId: 2164, code: "799206" },
    { id: 48013, cityId: 2164, code: "799211" },
    { id: 48014, cityId: 2164, code: "799214" },
    { id: 48015, cityId: 2165, code: "799289" },
    { id: 48016, cityId: 2165, code: "799278" },
    { id: 48017, cityId: 2166, code: "799001" },
    { id: 48018, cityId: 2166, code: "799261" },
    { id: 48019, cityId: 2166, code: "799263" },
    { id: 48020, cityId: 2166, code: "799269" },
    { id: 48021, cityId: 2166, code: "799271" },
    { id: 48022, cityId: 2166, code: "799277" },
    { id: 48023, cityId: 2166, code: "799279" },
    { id: 48024, cityId: 2166, code: "799287" },
    { id: 48025, cityId: 2166, code: "799290" },
    { id: 48026, cityId: 2166, code: "799143" },
    { id: 48027, cityId: 2166, code: "799204" },
    { id: 48028, cityId: 2166, code: "799251" },
    { id: 48029, cityId: 2166, code: "799252" },
    { id: 48030, cityId: 2166, code: "799260" },
    { id: 48031, cityId: 2166, code: "799262" },
    { id: 48032, cityId: 2166, code: "799265" },
    { id: 48033, cityId: 2166, code: "799273" },
    { id: 48034, cityId: 2166, code: "799275" },
    { id: 48035, cityId: 2166, code: "799286" },
    { id: 48036, cityId: 2166, code: "799288" },
    { id: 48037, cityId: 2167, code: "313012" },
    { id: 48038, cityId: 2167, code: "313015" },
    { id: 48039, cityId: 2167, code: "313023" },
    { id: 48040, cityId: 2167, code: "313026" },
    { id: 48041, cityId: 2167, code: "313028" },
    { id: 48042, cityId: 2167, code: "313031" },
    { id: 48043, cityId: 2167, code: "313033" },
    { id: 48044, cityId: 2167, code: "313034" },
    { id: 48045, cityId: 2167, code: "313203" },
    { id: 48046, cityId: 2167, code: "313205" },
    { id: 48047, cityId: 2167, code: "313206" },
    { id: 48048, cityId: 2167, code: "313211" },
    { id: 48049, cityId: 2167, code: "313303" },
    { id: 48050, cityId: 2167, code: "313322" },
    { id: 48051, cityId: 2167, code: "313325" },
    { id: 48052, cityId: 2167, code: "313327" },
    { id: 48053, cityId: 2167, code: "313328" },
    { id: 48054, cityId: 2167, code: "313330" },
    { id: 48055, cityId: 2167, code: "313333" },
    { id: 48056, cityId: 2167, code: "313338" },
    { id: 48057, cityId: 2167, code: "313606" },
    { id: 48058, cityId: 2167, code: "313608" },
    { id: 48059, cityId: 2167, code: "313611" },
    { id: 48060, cityId: 2167, code: "313613" },
    { id: 48061, cityId: 2167, code: "313701" },
    { id: 48062, cityId: 2167, code: "313703" },
    { id: 48063, cityId: 2167, code: "313704" },
    { id: 48064, cityId: 2167, code: "313706" },
    { id: 48065, cityId: 2167, code: "313801" },
    { id: 48066, cityId: 2167, code: "313802" },
    { id: 48067, cityId: 2167, code: "313804" },
    { id: 48068, cityId: 2167, code: "313902" },
    { id: 48069, cityId: 2167, code: "313905" },
    { id: 48070, cityId: 2167, code: "313907" },
    { id: 48071, cityId: 2167, code: "799105" },
    { id: 48072, cityId: 2167, code: "799108" },
    { id: 48073, cityId: 2167, code: "799121" },
    { id: 48074, cityId: 2167, code: "799123" },
    { id: 48075, cityId: 2167, code: "799142" },
    { id: 48076, cityId: 2167, code: "799144" },
    { id: 48077, cityId: 2167, code: "799147" },
    { id: 48078, cityId: 2167, code: "799153" },
    { id: 48079, cityId: 2167, code: "799158" },
    { id: 48080, cityId: 2167, code: "307025" },
    { id: 48081, cityId: 2167, code: "313001" },
    { id: 48082, cityId: 2167, code: "313011" },
    { id: 48083, cityId: 2167, code: "313013" },
    { id: 48084, cityId: 2167, code: "313014" },
    { id: 48085, cityId: 2167, code: "313016" },
    { id: 48086, cityId: 2167, code: "313021" },
    { id: 48087, cityId: 2167, code: "313022" },
    { id: 48088, cityId: 2167, code: "313024" },
    { id: 48089, cityId: 2167, code: "313029" },
    { id: 48090, cityId: 2167, code: "313030" },
    { id: 48091, cityId: 2167, code: "313032" },
    { id: 48092, cityId: 2167, code: "313038" },
    { id: 48093, cityId: 2167, code: "313201" },
    { id: 48094, cityId: 2167, code: "313202" },
    { id: 48095, cityId: 2167, code: "313204" },
    { id: 48096, cityId: 2167, code: "313207" },
    { id: 48097, cityId: 2167, code: "313209" },
    { id: 48098, cityId: 2167, code: "313210" },
    { id: 48099, cityId: 2167, code: "313212" },
    { id: 48100, cityId: 2167, code: "313321" },
    { id: 48101, cityId: 2167, code: "313323" },
    { id: 48102, cityId: 2167, code: "313324" },
    { id: 48103, cityId: 2167, code: "313326" },
    { id: 48104, cityId: 2167, code: "313329" },
    { id: 48105, cityId: 2167, code: "313331" },
    { id: 48106, cityId: 2167, code: "313332" },
    { id: 48107, cityId: 2167, code: "313337" },
    { id: 48108, cityId: 2167, code: "313340" },
    { id: 48109, cityId: 2167, code: "313342" },
    { id: 48110, cityId: 2167, code: "313601" },
    { id: 48111, cityId: 2167, code: "313602" },
    { id: 48112, cityId: 2167, code: "313604" },
    { id: 48113, cityId: 2167, code: "313607" },
    { id: 48114, cityId: 2167, code: "313609" },
    { id: 48115, cityId: 2167, code: "313610" },
    { id: 48116, cityId: 2167, code: "313612" },
    { id: 48117, cityId: 2167, code: "313702" },
    { id: 48118, cityId: 2167, code: "313705" },
    { id: 48119, cityId: 2167, code: "313707" },
    { id: 48120, cityId: 2167, code: "313708" },
    { id: 48121, cityId: 2167, code: "313803" },
    { id: 48122, cityId: 2167, code: "313805" },
    { id: 48123, cityId: 2167, code: "313806" },
    { id: 48124, cityId: 2167, code: "313901" },
    { id: 48125, cityId: 2167, code: "313903" },
    { id: 48126, cityId: 2167, code: "313904" },
    { id: 48127, cityId: 2167, code: "313906" },
    { id: 48128, cityId: 2167, code: "799104" },
    { id: 48129, cityId: 2167, code: "799119" },
    { id: 48130, cityId: 2167, code: "799120" },
    { id: 48131, cityId: 2167, code: "799122" },
    { id: 48132, cityId: 2167, code: "799125" },
    { id: 48133, cityId: 2167, code: "799141" },
    { id: 48134, cityId: 2167, code: "799146" },
    { id: 48135, cityId: 2167, code: "799148" },
    { id: 48136, cityId: 2167, code: "799149" },
    { id: 48137, cityId: 2167, code: "799156" },
    { id: 48138, cityId: 2167, code: "799157" },
    { id: 48139, cityId: 2167, code: "799159" },
    { id: 48140, cityId: 2168, code: "246722" },
    { id: 48141, cityId: 2169, code: "282001" },
    { id: 48142, cityId: 2169, code: "282004" },
    { id: 48143, cityId: 2169, code: "282006" },
    { id: 48144, cityId: 2169, code: "282007" },
    { id: 48145, cityId: 2169, code: "282009" },
    { id: 48146, cityId: 2169, code: "283103" },
    { id: 48147, cityId: 2169, code: "283105" },
    { id: 48148, cityId: 2169, code: "283114" },
    { id: 48149, cityId: 2169, code: "283119" },
    { id: 48150, cityId: 2169, code: "283121" },
    { id: 48151, cityId: 2169, code: "283122" },
    { id: 48152, cityId: 2169, code: "283124" },
    { id: 48153, cityId: 2169, code: "283201" },
    { id: 48154, cityId: 2169, code: "283203" },
    { id: 48155, cityId: 2169, code: "282002" },
    { id: 48156, cityId: 2169, code: "282003" },
    { id: 48157, cityId: 2169, code: "282005" },
    { id: 48158, cityId: 2169, code: "282008" },
    { id: 48159, cityId: 2169, code: "283101" },
    { id: 48160, cityId: 2169, code: "283102" },
    { id: 48161, cityId: 2169, code: "283112" },
    { id: 48162, cityId: 2169, code: "283115" },
    { id: 48163, cityId: 2169, code: "283125" },
    { id: 48164, cityId: 2169, code: "283202" },
    { id: 48165, cityId: 2170, code: "231301" },
    { id: 48166, cityId: 2171, code: "247771" },
    { id: 48167, cityId: 2172, code: "209101" },
    { id: 48168, cityId: 2172, code: "224122" },
    { id: 48169, cityId: 2172, code: "845513" },
    { id: 48170, cityId: 2173, code: "207247" },
    { id: 48171, cityId: 2173, code: "210001" },
    { id: 48172, cityId: 2173, code: "243305" },
    { id: 48173, cityId: 2174, code: "202118" },
    { id: 48174, cityId: 2174, code: "202121" },
    { id: 48175, cityId: 2174, code: "202126" },
    { id: 48176, cityId: 2174, code: "202134" },
    { id: 48177, cityId: 2174, code: "202137" },
    { id: 48178, cityId: 2174, code: "202139" },
    { id: 48179, cityId: 2174, code: "202140" },
    { id: 48180, cityId: 2174, code: "202142" },
    { id: 48181, cityId: 2174, code: "202145" },
    { id: 48182, cityId: 2174, code: "202150" },
    { id: 48183, cityId: 2174, code: "202155" },
    { id: 48184, cityId: 2174, code: "202171" },
    { id: 48185, cityId: 2174, code: "202280" },
    { id: 48186, cityId: 2174, code: "202282" },
    { id: 48187, cityId: 2174, code: "204105" },
    { id: 48188, cityId: 2174, code: "204205" },
    { id: 48189, cityId: 2174, code: "204208" },
    { id: 48190, cityId: 2174, code: "204210" },
    { id: 48191, cityId: 2174, code: "204211" },
    { id: 48192, cityId: 2174, code: "204216" },
    { id: 48193, cityId: 2174, code: "205130" },
    { id: 48194, cityId: 2174, code: "202001" },
    { id: 48195, cityId: 2174, code: "202117" },
    { id: 48196, cityId: 2174, code: "202119" },
    { id: 48197, cityId: 2174, code: "202122" },
    { id: 48198, cityId: 2174, code: "202128" },
    { id: 48199, cityId: 2174, code: "202130" },
    { id: 48200, cityId: 2174, code: "202133" },
    { id: 48201, cityId: 2174, code: "202135" },
    { id: 48202, cityId: 2174, code: "202136" },
    { id: 48203, cityId: 2174, code: "202138" },
    { id: 48204, cityId: 2174, code: "202141" },
    { id: 48205, cityId: 2174, code: "202143" },
    { id: 48206, cityId: 2174, code: "202144" },
    { id: 48207, cityId: 2174, code: "202146" },
    { id: 48208, cityId: 2174, code: "202151" },
    { id: 48209, cityId: 2174, code: "202165" },
    { id: 48210, cityId: 2174, code: "202281" },
    { id: 48211, cityId: 2174, code: "202308" },
    { id: 48212, cityId: 2174, code: "204101" },
    { id: 48213, cityId: 2174, code: "204103" },
    { id: 48214, cityId: 2174, code: "204206" },
    { id: 48215, cityId: 2174, code: "204207" },
    { id: 48216, cityId: 2174, code: "204209" },
    { id: 48217, cityId: 2174, code: "204214" },
    { id: 48218, cityId: 2174, code: "204215" },
    { id: 48219, cityId: 2175, code: "211002" },
    { id: 48220, cityId: 2175, code: "211004" },
    { id: 48221, cityId: 2175, code: "211005" },
    { id: 48222, cityId: 2175, code: "211007" },
    { id: 48223, cityId: 2175, code: "211012" },
    { id: 48224, cityId: 2175, code: "211013" },
    { id: 48225, cityId: 2175, code: "211015" },
    { id: 48226, cityId: 2175, code: "212106" },
    { id: 48227, cityId: 2175, code: "212204" },
    { id: 48228, cityId: 2175, code: "212212" },
    { id: 48229, cityId: 2175, code: "212215" },
    { id: 48230, cityId: 2175, code: "212302" },
    { id: 48231, cityId: 2175, code: "212305" },
    { id: 48232, cityId: 2175, code: "212403" },
    { id: 48233, cityId: 2175, code: "212501" },
    { id: 48234, cityId: 2175, code: "212503" },
    { id: 48235, cityId: 2175, code: "221508" },
    { id: 48236, cityId: 2175, code: "229411" },
    { id: 48237, cityId: 2175, code: "229413" },
    { id: 48238, cityId: 2175, code: "242222" },
    { id: 48239, cityId: 2175, code: "211001" },
    { id: 48240, cityId: 2175, code: "211003" },
    { id: 48241, cityId: 2175, code: "211006" },
    { id: 48242, cityId: 2175, code: "211008" },
    { id: 48243, cityId: 2175, code: "211011" },
    { id: 48244, cityId: 2175, code: "211014" },
    { id: 48245, cityId: 2175, code: "212105" },
    { id: 48246, cityId: 2175, code: "212107" },
    { id: 48247, cityId: 2175, code: "212205" },
    { id: 48248, cityId: 2175, code: "212208" },
    { id: 48249, cityId: 2175, code: "212213" },
    { id: 48250, cityId: 2175, code: "212214" },
    { id: 48251, cityId: 2175, code: "212216" },
    { id: 48252, cityId: 2175, code: "212301" },
    { id: 48253, cityId: 2175, code: "212303" },
    { id: 48254, cityId: 2175, code: "212304" },
    { id: 48255, cityId: 2175, code: "212306" },
    { id: 48256, cityId: 2175, code: "212401" },
    { id: 48257, cityId: 2175, code: "212404" },
    { id: 48258, cityId: 2175, code: "212410" },
    { id: 48259, cityId: 2175, code: "212502" },
    { id: 48260, cityId: 2175, code: "221504" },
    { id: 48261, cityId: 2175, code: "221505" },
    { id: 48262, cityId: 2175, code: "221507" },
    { id: 48263, cityId: 2175, code: "229412" },
    { id: 48264, cityId: 2176, code: "207241" },
    { id: 48265, cityId: 2177, code: "224218" },
    { id: 48266, cityId: 2177, code: "242473" },
    { id: 48267, cityId: 2178, code: "247340" },
    { id: 48268, cityId: 2179, code: "227120" },
    { id: 48269, cityId: 2179, code: "227405" },
    { id: 48270, cityId: 2180, code: "275301" },
    { id: 48271, cityId: 2181, code: "276401" },
    { id: 48272, cityId: 2182, code: "250604" },
    { id: 48273, cityId: 2183, code: "209112" },
    { id: 48274, cityId: 2184, code: "244221" },
    { id: 48275, cityId: 2185, code: "230501" },
    { id: 48276, cityId: 2186, code: "202391" },
    { id: 48277, cityId: 2187, code: "243301" },
    { id: 48278, cityId: 2188, code: "208039" },
    { id: 48279, cityId: 2189, code: "202280" },
    { id: 48280, cityId: 2190, code: "223223" },
    { id: 48281, cityId: 2191, code: "206122" },
    { id: 48282, cityId: 2192, code: "262728" },
    { id: 48283, cityId: 2192, code: "423702" },
    { id: 48284, cityId: 2192, code: "423704" },
    { id: 48285, cityId: 2192, code: "431001" },
    { id: 48286, cityId: 2192, code: "431004" },
    { id: 48287, cityId: 2192, code: "431102" },
    { id: 48288, cityId: 2192, code: "431104" },
    { id: 48289, cityId: 2192, code: "431105" },
    { id: 48290, cityId: 2192, code: "431110" },
    { id: 48291, cityId: 2192, code: "431115" },
    { id: 48292, cityId: 2192, code: "431133" },
    { id: 48293, cityId: 2192, code: "431139" },
    { id: 48294, cityId: 2192, code: "431144" },
    { id: 48295, cityId: 2192, code: "431147" },
    { id: 48296, cityId: 2192, code: "431208" },
    { id: 48297, cityId: 2192, code: "431210" },
    { id: 48298, cityId: 2192, code: "431213" },
    { id: 48299, cityId: 2192, code: "814155" },
    { id: 48300, cityId: 2192, code: "814156" },
    { id: 48301, cityId: 2192, code: "824101" },
    { id: 48302, cityId: 2192, code: "824112" },
    { id: 48303, cityId: 2192, code: "824114" },
    { id: 48304, cityId: 2192, code: "824115" },
    { id: 48305, cityId: 2192, code: "824120" },
    { id: 48306, cityId: 2192, code: "824122" },
    { id: 48307, cityId: 2192, code: "824123" },
    { id: 48308, cityId: 2192, code: "824128" },
    { id: 48309, cityId: 2192, code: "824130" },
    { id: 48310, cityId: 2192, code: "824202" },
    { id: 48311, cityId: 2192, code: "824218" },
    { id: 48312, cityId: 2192, code: "824302" },
    { id: 48313, cityId: 2192, code: "824303" },
    { id: 48314, cityId: 2192, code: "221001" },
    { id: 48315, cityId: 2192, code: "245401" },
    { id: 48316, cityId: 2192, code: "261403" },
    { id: 48317, cityId: 2192, code: "415570" },
    { id: 48318, cityId: 2192, code: "431002" },
    { id: 48319, cityId: 2192, code: "431005" },
    { id: 48320, cityId: 2192, code: "431108" },
    { id: 48321, cityId: 2192, code: "431111" },
    { id: 48322, cityId: 2192, code: "431116" },
    { id: 48323, cityId: 2192, code: "431119" },
    { id: 48324, cityId: 2192, code: "431121" },
    { id: 48325, cityId: 2192, code: "431137" },
    { id: 48326, cityId: 2192, code: "431138" },
    { id: 48327, cityId: 2192, code: "431140" },
    { id: 48328, cityId: 2192, code: "431146" },
    { id: 48329, cityId: 2192, code: "431148" },
    { id: 48330, cityId: 2192, code: "431201" },
    { id: 48331, cityId: 2192, code: "431212" },
    { id: 48332, cityId: 2192, code: "431402" },
    { id: 48333, cityId: 2192, code: "742201" },
    { id: 48334, cityId: 2192, code: "814133" },
    { id: 48335, cityId: 2192, code: "814141" },
    { id: 48336, cityId: 2192, code: "814147" },
    { id: 48337, cityId: 2192, code: "814154" },
    { id: 48338, cityId: 2192, code: "814165" },
    { id: 48339, cityId: 2192, code: "824102" },
    { id: 48340, cityId: 2192, code: "824113" },
    { id: 48341, cityId: 2192, code: "824121" },
    { id: 48342, cityId: 2192, code: "824124" },
    { id: 48343, cityId: 2192, code: "824126" },
    { id: 48344, cityId: 2192, code: "824127" },
    { id: 48345, cityId: 2192, code: "824129" },
    { id: 48346, cityId: 2192, code: "824203" },
    { id: 48347, cityId: 2192, code: "824211" },
    { id: 48348, cityId: 2192, code: "824216" },
    { id: 48349, cityId: 2192, code: "825101" },
    { id: 48350, cityId: 2193, code: "207301" },
    { id: 48351, cityId: 2194, code: "224123" },
    { id: 48352, cityId: 2195, code: "223221" },
    { id: 48353, cityId: 2195, code: "275101" },
    { id: 48354, cityId: 2195, code: "275302" },
    { id: 48355, cityId: 2195, code: "275307" },
    { id: 48356, cityId: 2195, code: "275501" },
    { id: 48357, cityId: 2195, code: "276001" },
    { id: 48358, cityId: 2195, code: "276121" },
    { id: 48359, cityId: 2195, code: "276123" },
    { id: 48360, cityId: 2195, code: "276126" },
    { id: 48361, cityId: 2195, code: "276128" },
    { id: 48362, cityId: 2195, code: "276129" },
    { id: 48363, cityId: 2195, code: "276131" },
    { id: 48364, cityId: 2195, code: "276136" },
    { id: 48365, cityId: 2195, code: "276137" },
    { id: 48366, cityId: 2195, code: "276139" },
    { id: 48367, cityId: 2195, code: "276142" },
    { id: 48368, cityId: 2195, code: "276203" },
    { id: 48369, cityId: 2195, code: "276205" },
    { id: 48370, cityId: 2195, code: "276208" },
    { id: 48371, cityId: 2195, code: "276301" },
    { id: 48372, cityId: 2195, code: "276303" },
    { id: 48373, cityId: 2195, code: "221601" },
    { id: 48374, cityId: 2195, code: "223222" },
    { id: 48375, cityId: 2195, code: "223224" },
    { id: 48376, cityId: 2195, code: "223225" },
    { id: 48377, cityId: 2195, code: "223227" },
    { id: 48378, cityId: 2195, code: "275102" },
    { id: 48379, cityId: 2195, code: "275105" },
    { id: 48380, cityId: 2195, code: "275303" },
    { id: 48381, cityId: 2195, code: "275306" },
    { id: 48382, cityId: 2195, code: "276122" },
    { id: 48383, cityId: 2195, code: "276124" },
    { id: 48384, cityId: 2195, code: "276125" },
    { id: 48385, cityId: 2195, code: "276127" },
    { id: 48386, cityId: 2195, code: "276135" },
    { id: 48387, cityId: 2195, code: "276138" },
    { id: 48388, cityId: 2195, code: "276207" },
    { id: 48389, cityId: 2195, code: "276302" },
    { id: 48390, cityId: 2195, code: "276304" },
    { id: 48391, cityId: 2195, code: "276402" },
    { id: 48392, cityId: 2195, code: "276403" },
    { id: 48393, cityId: 2196, code: "210121" },
    { id: 48394, cityId: 2197, code: "285241" },
    { id: 48395, cityId: 2198, code: "202521" },
    { id: 48396, cityId: 2199, code: "245201" },
    { id: 48397, cityId: 2200, code: "229301" },
    { id: 48398, cityId: 2201, code: "202524" },
    { id: 48399, cityId: 2201, code: "202527" },
    { id: 48400, cityId: 2201, code: "243631" },
    { id: 48401, cityId: 2201, code: "243634" },
    { id: 48402, cityId: 2201, code: "243636" },
    { id: 48403, cityId: 2201, code: "202523" },
    { id: 48404, cityId: 2201, code: "243601" },
    { id: 48405, cityId: 2201, code: "243632" },
    { id: 48406, cityId: 2202, code: "250345" },
    { id: 48407, cityId: 2202, code: "250626" },
    { id: 48408, cityId: 2202, code: "250609" },
    { id: 48409, cityId: 2203, code: "283104" },
    { id: 48410, cityId: 2204, code: "242001" },
    { id: 48411, cityId: 2204, code: "846004" },
    { id: 48412, cityId: 2204, code: "275201" },
    { id: 48413, cityId: 2204, code: "855101" },
    { id: 48414, cityId: 2205, code: "243201" },
    { id: 48415, cityId: 2206, code: "202410" },
    { id: 48416, cityId: 2207, code: "271801" },
    { id: 48417, cityId: 2207, code: "271806" },
    { id: 48418, cityId: 2207, code: "271822" },
    { id: 48419, cityId: 2207, code: "271824" },
    { id: 48420, cityId: 2207, code: "271825" },
    { id: 48421, cityId: 2207, code: "271827" },
    { id: 48422, cityId: 2207, code: "271832" },
    { id: 48423, cityId: 2207, code: "271833" },
    { id: 48424, cityId: 2207, code: "271851" },
    { id: 48425, cityId: 2207, code: "271864" },
    { id: 48426, cityId: 2207, code: "271872" },
    { id: 48427, cityId: 2207, code: "271875" },
    { id: 48428, cityId: 2207, code: "271880" },
    { id: 48429, cityId: 2207, code: "271901" },
    { id: 48430, cityId: 2207, code: "271902" },
    { id: 48431, cityId: 2207, code: "271821" },
    { id: 48432, cityId: 2207, code: "271823" },
    { id: 48433, cityId: 2207, code: "271826" },
    { id: 48434, cityId: 2207, code: "271829" },
    { id: 48435, cityId: 2207, code: "271834" },
    { id: 48436, cityId: 2207, code: "271836" },
    { id: 48437, cityId: 2207, code: "271855" },
    { id: 48438, cityId: 2207, code: "271882" },
    { id: 48439, cityId: 2207, code: "271903" },
    { id: 48440, cityId: 2207, code: "271905" },
    { id: 48441, cityId: 2208, code: "281201" },
    { id: 48442, cityId: 2209, code: "206124" },
    { id: 48443, cityId: 2210, code: "281301" },
    { id: 48444, cityId: 2211, code: "221701" },
    { id: 48445, cityId: 2211, code: "221709" },
    { id: 48446, cityId: 2211, code: "221712" },
    { id: 48447, cityId: 2211, code: "221715" },
    { id: 48448, cityId: 2211, code: "221717" },
    { id: 48449, cityId: 2211, code: "221718" },
    { id: 48450, cityId: 2211, code: "221720" },
    { id: 48451, cityId: 2211, code: "277001" },
    { id: 48452, cityId: 2211, code: "277107" },
    { id: 48453, cityId: 2211, code: "277123" },
    { id: 48454, cityId: 2211, code: "277203" },
    { id: 48455, cityId: 2211, code: "277205" },
    { id: 48456, cityId: 2211, code: "277208" },
    { id: 48457, cityId: 2211, code: "277210" },
    { id: 48458, cityId: 2211, code: "277213" },
    { id: 48459, cityId: 2211, code: "277215" },
    { id: 48460, cityId: 2211, code: "277218" },
    { id: 48461, cityId: 2211, code: "277301" },
    { id: 48462, cityId: 2211, code: "277306" },
    { id: 48463, cityId: 2211, code: "277401" },
    { id: 48464, cityId: 2211, code: "277404" },
    { id: 48465, cityId: 2211, code: "277502" },
    { id: 48466, cityId: 2211, code: "277504" },
    { id: 48467, cityId: 2211, code: "221705" },
    { id: 48468, cityId: 2211, code: "221706" },
    { id: 48469, cityId: 2211, code: "221711" },
    { id: 48470, cityId: 2211, code: "221713" },
    { id: 48471, cityId: 2211, code: "221714" },
    { id: 48472, cityId: 2211, code: "221716" },
    { id: 48473, cityId: 2211, code: "221719" },
    { id: 48474, cityId: 2211, code: "221721" },
    { id: 48475, cityId: 2211, code: "221722" },
    { id: 48476, cityId: 2211, code: "277121" },
    { id: 48477, cityId: 2211, code: "277122" },
    { id: 48478, cityId: 2211, code: "277127" },
    { id: 48479, cityId: 2211, code: "277201" },
    { id: 48480, cityId: 2211, code: "277204" },
    { id: 48481, cityId: 2211, code: "277206" },
    { id: 48482, cityId: 2211, code: "277207" },
    { id: 48483, cityId: 2211, code: "277212" },
    { id: 48484, cityId: 2211, code: "277214" },
    { id: 48485, cityId: 2211, code: "277302" },
    { id: 48486, cityId: 2211, code: "277304" },
    { id: 48487, cityId: 2211, code: "277305" },
    { id: 48488, cityId: 2211, code: "277307" },
    { id: 48489, cityId: 2211, code: "277403" },
    { id: 48490, cityId: 2211, code: "277405" },
    { id: 48491, cityId: 2211, code: "277503" },
    { id: 48492, cityId: 2211, code: "277506" },
    { id: 48493, cityId: 2212, code: "271201" },
    { id: 48494, cityId: 2213, code: "210201" },
    { id: 48495, cityId: 2213, code: "210203" },
    { id: 48496, cityId: 2213, code: "210204" },
    { id: 48497, cityId: 2213, code: "210206" },
    { id: 48498, cityId: 2213, code: "210209" },
    { id: 48499, cityId: 2213, code: "210001" },
    { id: 48500, cityId: 2213, code: "210101" },
    { id: 48501, cityId: 2213, code: "210120" },
    { id: 48502, cityId: 2213, code: "210123" },
    { id: 48503, cityId: 2213, code: "210125" },
    { id: 48504, cityId: 2213, code: "210126" },
    { id: 48505, cityId: 2213, code: "210202" },
    { id: 48506, cityId: 2213, code: "242402" },
    { id: 48507, cityId: 2214, code: "241501" },
    { id: 48508, cityId: 2215, code: "754008" },
    { id: 48509, cityId: 2215, code: "225001" },
    { id: 48510, cityId: 2216, code: "277202" },
    { id: 48511, cityId: 2217, code: "273403" },
    { id: 48512, cityId: 2218, code: "284122" },
    { id: 48513, cityId: 2218, code: "272153" },
    { id: 48514, cityId: 2219, code: "225119" },
    { id: 48515, cityId: 2219, code: "225120" },
    { id: 48516, cityId: 2219, code: "225201" },
    { id: 48517, cityId: 2219, code: "225202" },
    { id: 48518, cityId: 2219, code: "225204" },
    { id: 48519, cityId: 2219, code: "225302" },
    { id: 48520, cityId: 2219, code: "225305" },
    { id: 48521, cityId: 2219, code: "225403" },
    { id: 48522, cityId: 2219, code: "225405" },
    { id: 48523, cityId: 2219, code: "225406" },
    { id: 48524, cityId: 2219, code: "225411" },
    { id: 48525, cityId: 2219, code: "225413" },
    { id: 48526, cityId: 2219, code: "227302" },
    { id: 48527, cityId: 2219, code: "225001" },
    { id: 48528, cityId: 2219, code: "225002" },
    { id: 48529, cityId: 2219, code: "225121" },
    { id: 48530, cityId: 2219, code: "225123" },
    { id: 48531, cityId: 2219, code: "225203" },
    { id: 48532, cityId: 2219, code: "225205" },
    { id: 48533, cityId: 2219, code: "225206" },
    { id: 48534, cityId: 2219, code: "225304" },
    { id: 48535, cityId: 2219, code: "225401" },
    { id: 48536, cityId: 2219, code: "225402" },
    { id: 48537, cityId: 2219, code: "225404" },
    { id: 48538, cityId: 2219, code: "225407" },
    { id: 48539, cityId: 2219, code: "225409" },
    { id: 48540, cityId: 2219, code: "225412" },
    { id: 48541, cityId: 2219, code: "225415" },
    { id: 48542, cityId: 2219, code: "271841" },
    { id: 48543, cityId: 2220, code: "221204" },
    { id: 48544, cityId: 2220, code: "222102" },
    { id: 48545, cityId: 2220, code: "224126" },
    { id: 48546, cityId: 2220, code: "284121" },
    { id: 48547, cityId: 2221, code: "221502" },
    { id: 48548, cityId: 2221, code: "250611" },
    { id: 48549, cityId: 2222, code: "243001" },
    { id: 48550, cityId: 2222, code: "243123" },
    { id: 48551, cityId: 2222, code: "243125" },
    { id: 48552, cityId: 2222, code: "243126" },
    { id: 48553, cityId: 2222, code: "243202" },
    { id: 48554, cityId: 2222, code: "243203" },
    { id: 48555, cityId: 2222, code: "243208" },
    { id: 48556, cityId: 2222, code: "243301" },
    { id: 48557, cityId: 2222, code: "243401" },
    { id: 48558, cityId: 2222, code: "243403" },
    { id: 48559, cityId: 2222, code: "243404" },
    { id: 48560, cityId: 2222, code: "243501" },
    { id: 48561, cityId: 2222, code: "243502" },
    { id: 48562, cityId: 2222, code: "243509" },
    { id: 48563, cityId: 2222, code: "262411" },
    { id: 48564, cityId: 2222, code: "243002" },
    { id: 48565, cityId: 2222, code: "243122" },
    { id: 48566, cityId: 2222, code: "243124" },
    { id: 48567, cityId: 2222, code: "243127" },
    { id: 48568, cityId: 2222, code: "243201" },
    { id: 48569, cityId: 2222, code: "243204" },
    { id: 48570, cityId: 2222, code: "243206" },
    { id: 48571, cityId: 2222, code: "243304" },
    { id: 48572, cityId: 2222, code: "243408" },
    { id: 48573, cityId: 2222, code: "243506" },
    { id: 48574, cityId: 2222, code: "262407" },
    { id: 48575, cityId: 2223, code: "273402" },
    { id: 48576, cityId: 2224, code: "262203" },
    { id: 48577, cityId: 2225, code: "281405" },
    { id: 48578, cityId: 2226, code: "272001" },
    { id: 48579, cityId: 2226, code: "272002" },
    { id: 48580, cityId: 2226, code: "272124" },
    { id: 48581, cityId: 2226, code: "272131" },
    { id: 48582, cityId: 2226, code: "272152" },
    { id: 48583, cityId: 2226, code: "272161" },
    { id: 48584, cityId: 2226, code: "272163" },
    { id: 48585, cityId: 2226, code: "272181" },
    { id: 48586, cityId: 2226, code: "272182" },
    { id: 48587, cityId: 2226, code: "272190" },
    { id: 48588, cityId: 2226, code: "272205" },
    { id: 48589, cityId: 2226, code: "272206" },
    { id: 48590, cityId: 2226, code: "272208" },
    { id: 48591, cityId: 2226, code: "272211" },
    { id: 48592, cityId: 2226, code: "272301" },
    { id: 48593, cityId: 2226, code: "272003" },
    { id: 48594, cityId: 2226, code: "272120" },
    { id: 48595, cityId: 2226, code: "272125" },
    { id: 48596, cityId: 2226, code: "272127" },
    { id: 48597, cityId: 2226, code: "272141" },
    { id: 48598, cityId: 2226, code: "272151" },
    { id: 48599, cityId: 2226, code: "272159" },
    { id: 48600, cityId: 2226, code: "272162" },
    { id: 48601, cityId: 2226, code: "272165" },
    { id: 48602, cityId: 2226, code: "272172" },
    { id: 48603, cityId: 2226, code: "272178" },
    { id: 48604, cityId: 2226, code: "272191" },
    { id: 48605, cityId: 2226, code: "272201" },
    { id: 48606, cityId: 2226, code: "272202" },
    { id: 48607, cityId: 2226, code: "272204" },
    { id: 48608, cityId: 2226, code: "272207" },
    { id: 48609, cityId: 2226, code: "272212" },
    { id: 48610, cityId: 2226, code: "272302" },
    { id: 48611, cityId: 2227, code: "241304" },
    { id: 48612, cityId: 2228, code: "206301" },
    { id: 48613, cityId: 2228, code: "210501" },
    { id: 48614, cityId: 2229, code: "221401" },
    { id: 48615, cityId: 2230, code: "229502" },
    { id: 48616, cityId: 2230, code: "241303" },
    { id: 48617, cityId: 2231, code: "212104" },
    { id: 48618, cityId: 2232, code: "206242" },
    { id: 48619, cityId: 2233, code: "212201" },
    { id: 48620, cityId: 2234, code: "271831" },
    { id: 48621, cityId: 2235, code: "205262" },
    { id: 48622, cityId: 2236, code: "206243" },
    { id: 48623, cityId: 2237, code: "246701" },
    { id: 48624, cityId: 2238, code: "246723" },
    { id: 48625, cityId: 2238, code: "246724" },
    { id: 48626, cityId: 2238, code: "246732" },
    { id: 48627, cityId: 2238, code: "246734" },
    { id: 48628, cityId: 2238, code: "246761" },
    { id: 48629, cityId: 2238, code: "246763" },
    { id: 48630, cityId: 2238, code: "246701" },
    { id: 48631, cityId: 2238, code: "246725" },
    { id: 48632, cityId: 2238, code: "246727" },
    { id: 48633, cityId: 2238, code: "246733" },
    { id: 48634, cityId: 2238, code: "246735" },
    { id: 48635, cityId: 2238, code: "246746" },
    { id: 48636, cityId: 2238, code: "246748" },
    { id: 48637, cityId: 2238, code: "246751" },
    { id: 48638, cityId: 2238, code: "246762" },
    { id: 48639, cityId: 2239, code: "224204" },
    { id: 48640, cityId: 2240, code: "202411" },
    { id: 48641, cityId: 2241, code: "95221" },
    { id: 48642, cityId: 2241, code: "135102" },
    { id: 48643, cityId: 2241, code: "174011" },
    { id: 48644, cityId: 2241, code: "174022" },
    { id: 48645, cityId: 2241, code: "174027" },
    { id: 48646, cityId: 2241, code: "174029" },
    { id: 48647, cityId: 2241, code: "174030" },
    { id: 48648, cityId: 2241, code: "174032" },
    { id: 48649, cityId: 2241, code: "174034" },
    { id: 48650, cityId: 2241, code: "174035" },
    { id: 48651, cityId: 2241, code: "174201" },
    { id: 48652, cityId: 2241, code: "174310" },
    { id: 48653, cityId: 2241, code: "244921" },
    { id: 48654, cityId: 2241, code: "495001" },
    { id: 48655, cityId: 2241, code: "495004" },
    { id: 48656, cityId: 2241, code: "495007" },
    { id: 48657, cityId: 2241, code: "495009" },
    { id: 48658, cityId: 2241, code: "495112" },
    { id: 48659, cityId: 2241, code: "495117" },
    { id: 48660, cityId: 2241, code: "495118" },
    { id: 48661, cityId: 2241, code: "495223" },
    { id: 48662, cityId: 2241, code: "495335" },
    { id: 48663, cityId: 2241, code: "495446" },
    { id: 48664, cityId: 2241, code: "495452" },
    { id: 48665, cityId: 2241, code: "495550" },
    { id: 48666, cityId: 2241, code: "495557" },
    { id: 48667, cityId: 2241, code: "495660" },
    { id: 48668, cityId: 2241, code: "495663" },
    { id: 48669, cityId: 2241, code: "495674" },
    { id: 48670, cityId: 2241, code: "495677" },
    { id: 48671, cityId: 2241, code: "495679" },
    { id: 48672, cityId: 2241, code: "495682" },
    { id: 48673, cityId: 2241, code: "495684" },
    { id: 48674, cityId: 2241, code: "495687" },
    { id: 48675, cityId: 2241, code: "495695" },
    { id: 48676, cityId: 2241, code: "174001" },
    { id: 48677, cityId: 2241, code: "174004" },
    { id: 48678, cityId: 2241, code: "174010" },
    { id: 48679, cityId: 2241, code: "174012" },
    { id: 48680, cityId: 2241, code: "174026" },
    { id: 48681, cityId: 2241, code: "174028" },
    { id: 48682, cityId: 2241, code: "174031" },
    { id: 48683, cityId: 2241, code: "174033" },
    { id: 48684, cityId: 2241, code: "495113" },
    { id: 48685, cityId: 2241, code: "495116" },
    { id: 48686, cityId: 2241, code: "495220" },
    { id: 48687, cityId: 2241, code: "495222" },
    { id: 48688, cityId: 2241, code: "495447" },
    { id: 48689, cityId: 2241, code: "495453" },
    { id: 48690, cityId: 2241, code: "495551" },
    { id: 48691, cityId: 2241, code: "495553" },
    { id: 48692, cityId: 2241, code: "495680" },
    { id: 48693, cityId: 2241, code: "495681" },
    { id: 48694, cityId: 2241, code: "495683" },
    { id: 48695, cityId: 2242, code: "241301" },
    { id: 48696, cityId: 2243, code: "262202" },
    { id: 48697, cityId: 2244, code: "243633" },
    { id: 48698, cityId: 2245, code: "212635" },
    { id: 48699, cityId: 2246, code: "262201" },
    { id: 48700, cityId: 2247, code: "232115" },
    { id: 48701, cityId: 2248, code: "261201" },
    { id: 48702, cityId: 2249, code: "209201" },
    { id: 48703, cityId: 2250, code: "243601" },
    { id: 48704, cityId: 2251, code: "251309" },
    { id: 48705, cityId: 2252, code: "245403" },
    { id: 48706, cityId: 2253, code: "202398" },
    { id: 48707, cityId: 2253, code: "203121" },
    { id: 48708, cityId: 2253, code: "203129" },
    { id: 48709, cityId: 2253, code: "203132" },
    { id: 48710, cityId: 2253, code: "203145" },
    { id: 48711, cityId: 2253, code: "203150" },
    { id: 48712, cityId: 2253, code: "203155" },
    { id: 48713, cityId: 2253, code: "203203" },
    { id: 48714, cityId: 2253, code: "245402" },
    { id: 48715, cityId: 2253, code: "245407" },
    { id: 48716, cityId: 2253, code: "245409" },
    { id: 48717, cityId: 2253, code: "245412" },
    { id: 48718, cityId: 2253, code: "202389" },
    { id: 48719, cityId: 2253, code: "202391" },
    { id: 48720, cityId: 2253, code: "202392" },
    { id: 48721, cityId: 2253, code: "202394" },
    { id: 48722, cityId: 2253, code: "202397" },
    { id: 48723, cityId: 2253, code: "203001" },
    { id: 48724, cityId: 2253, code: "203131" },
    { id: 48725, cityId: 2253, code: "203202" },
    { id: 48726, cityId: 2253, code: "203205" },
    { id: 48727, cityId: 2253, code: "245406" },
    { id: 48728, cityId: 2253, code: "245408" },
    { id: 48729, cityId: 2254, code: "212202" },
    { id: 48730, cityId: 2255, code: "232103" },
    { id: 48731, cityId: 2256, code: "224164" },
    { id: 48732, cityId: 2256, code: "232102" },
    { id: 48733, cityId: 2256, code: "232104" },
    { id: 48734, cityId: 2256, code: "232117" },
    { id: 48735, cityId: 2256, code: "202127" },
    { id: 48736, cityId: 2256, code: "202144" },
    { id: 48737, cityId: 2256, code: "221009" },
    { id: 48738, cityId: 2256, code: "221115" },
    { id: 48739, cityId: 2256, code: "232105" },
    { id: 48740, cityId: 2256, code: "242308" },
    { id: 48741, cityId: 2257, code: "202412" },
    { id: 48742, cityId: 2258, code: "246725" },
    { id: 48743, cityId: 2259, code: "250617" },
    { id: 48744, cityId: 2260, code: "202721" },
    { id: 48745, cityId: 2261, code: "276405" },
    { id: 48746, cityId: 2261, code: "221602" },
    { id: 48747, cityId: 2261, code: "221603" },
    { id: 48748, cityId: 2262, code: "231205" },
    { id: 48749, cityId: 2263, code: "231304" },
    { id: 48750, cityId: 2264, code: "271308" },
    { id: 48751, cityId: 2265, code: "203207" },
    { id: 48752, cityId: 2266, code: "229203" },
    { id: 48753, cityId: 2267, code: "203201" },
    { id: 48754, cityId: 2268, code: "243635" },
    { id: 48755, cityId: 2269, code: "250221" },
    { id: 48756, cityId: 2270, code: "282005" },
    { id: 48757, cityId: 2271, code: "247554" },
    { id: 48758, cityId: 2272, code: "224137" },
    { id: 48759, cityId: 2272, code: "274132" },
    { id: 48760, cityId: 2272, code: "274201" },
    { id: 48761, cityId: 2272, code: "274207" },
    { id: 48762, cityId: 2272, code: "274302" },
    { id: 48763, cityId: 2272, code: "274406" },
    { id: 48764, cityId: 2272, code: "274408" },
    { id: 48765, cityId: 2272, code: "274501" },
    { id: 48766, cityId: 2272, code: "274601" },
    { id: 48767, cityId: 2272, code: "274602" },
    { id: 48768, cityId: 2272, code: "274604" },
    { id: 48769, cityId: 2272, code: "274702" },
    { id: 48770, cityId: 2272, code: "274001" },
    { id: 48771, cityId: 2272, code: "274121" },
    { id: 48772, cityId: 2272, code: "274205" },
    { id: 48773, cityId: 2272, code: "274206" },
    { id: 48774, cityId: 2272, code: "274301" },
    { id: 48775, cityId: 2272, code: "274303" },
    { id: 48776, cityId: 2272, code: "274306" },
    { id: 48777, cityId: 2272, code: "274401" },
    { id: 48778, cityId: 2272, code: "274404" },
    { id: 48779, cityId: 2272, code: "274407" },
    { id: 48780, cityId: 2272, code: "274409" },
    { id: 48781, cityId: 2272, code: "274502" },
    { id: 48782, cityId: 2272, code: "274505" },
    { id: 48783, cityId: 2272, code: "274508" },
    { id: 48784, cityId: 2272, code: "274603" },
    { id: 48785, cityId: 2272, code: "274701" },
    { id: 48786, cityId: 2272, code: "274703" },
    { id: 48787, cityId: 2273, code: "225301" },
    { id: 48788, cityId: 2274, code: "246761" },
    { id: 48789, cityId: 2275, code: "202393" },
    { id: 48790, cityId: 2276, code: "228131" },
    { id: 48791, cityId: 2277, code: "231208" },
    { id: 48792, cityId: 2278, code: "206126" },
    { id: 48793, cityId: 2279, code: "284302" },
    { id: 48794, cityId: 2280, code: "207001" },
    { id: 48795, cityId: 2280, code: "202132" },
    { id: 48796, cityId: 2280, code: "207126" },
    { id: 48797, cityId: 2280, code: "207302" },
    { id: 48798, cityId: 2280, code: "227805" },
    { id: 48799, cityId: 2280, code: "242415" },
    { id: 48800, cityId: 2281, code: "206002" },
    { id: 48801, cityId: 2281, code: "206001" },
    { id: 48802, cityId: 2282, code: "206003" },
    { id: 48803, cityId: 2282, code: "206013" },
    { id: 48804, cityId: 2282, code: "206120" },
    { id: 48805, cityId: 2282, code: "206122" },
    { id: 48806, cityId: 2282, code: "206125" },
    { id: 48807, cityId: 2282, code: "206128" },
    { id: 48808, cityId: 2282, code: "206130" },
    { id: 48809, cityId: 2282, code: "206241" },
    { id: 48810, cityId: 2282, code: "206244" },
    { id: 48811, cityId: 2282, code: "206246" },
    { id: 48812, cityId: 2282, code: "206247" },
    { id: 48813, cityId: 2282, code: "206249" },
    { id: 48814, cityId: 2282, code: "206252" },
    { id: 48815, cityId: 2282, code: "206254" },
    { id: 48816, cityId: 2282, code: "207001" },
    { id: 48817, cityId: 2282, code: "207121" },
    { id: 48818, cityId: 2282, code: "207242" },
    { id: 48819, cityId: 2282, code: "207243" },
    { id: 48820, cityId: 2282, code: "207248" },
    { id: 48821, cityId: 2282, code: "207404" },
    { id: 48822, cityId: 2282, code: "206001" },
    { id: 48823, cityId: 2282, code: "206002" },
    { id: 48824, cityId: 2282, code: "206121" },
    { id: 48825, cityId: 2282, code: "206123" },
    { id: 48826, cityId: 2282, code: "206129" },
    { id: 48827, cityId: 2282, code: "206131" },
    { id: 48828, cityId: 2282, code: "206248" },
    { id: 48829, cityId: 2282, code: "206250" },
    { id: 48830, cityId: 2282, code: "206251" },
    { id: 48831, cityId: 2282, code: "206253" },
    { id: 48832, cityId: 2282, code: "207122" },
    { id: 48833, cityId: 2282, code: "207124" },
    { id: 48834, cityId: 2282, code: "207125" },
    { id: 48835, cityId: 2282, code: "207244" },
    { id: 48836, cityId: 2282, code: "207246" },
    { id: 48837, cityId: 2282, code: "207249" },
    { id: 48838, cityId: 2282, code: "207402" },
    { id: 48839, cityId: 2282, code: "207403" },
    { id: 48840, cityId: 2283, code: "224001" },
    { id: 48841, cityId: 2283, code: "224121" },
    { id: 48842, cityId: 2283, code: "224123" },
    { id: 48843, cityId: 2283, code: "224129" },
    { id: 48844, cityId: 2283, code: "224139" },
    { id: 48845, cityId: 2283, code: "224145" },
    { id: 48846, cityId: 2283, code: "224147" },
    { id: 48847, cityId: 2283, code: "224152" },
    { id: 48848, cityId: 2283, code: "224153" },
    { id: 48849, cityId: 2283, code: "224155" },
    { id: 48850, cityId: 2283, code: "224157" },
    { id: 48851, cityId: 2283, code: "224166" },
    { id: 48852, cityId: 2283, code: "224168" },
    { id: 48853, cityId: 2283, code: "224171" },
    { id: 48854, cityId: 2283, code: "224182" },
    { id: 48855, cityId: 2283, code: "224195" },
    { id: 48856, cityId: 2283, code: "224198" },
    { id: 48857, cityId: 2283, code: "224203" },
    { id: 48858, cityId: 2283, code: "224205" },
    { id: 48859, cityId: 2283, code: "224208" },
    { id: 48860, cityId: 2283, code: "224210" },
    { id: 48861, cityId: 2283, code: "224211" },
    { id: 48862, cityId: 2283, code: "224213" },
    { id: 48863, cityId: 2283, code: "224216" },
    { id: 48864, cityId: 2283, code: "224219" },
    { id: 48865, cityId: 2283, code: "224221" },
    { id: 48866, cityId: 2283, code: "224224" },
    { id: 48867, cityId: 2283, code: "209723" },
    { id: 48868, cityId: 2283, code: "224122" },
    { id: 48869, cityId: 2283, code: "224127" },
    { id: 48870, cityId: 2283, code: "224132" },
    { id: 48871, cityId: 2283, code: "224133" },
    { id: 48872, cityId: 2283, code: "224141" },
    { id: 48873, cityId: 2283, code: "224143" },
    { id: 48874, cityId: 2283, code: "224151" },
    { id: 48875, cityId: 2283, code: "224159" },
    { id: 48876, cityId: 2283, code: "224161" },
    { id: 48877, cityId: 2283, code: "224167" },
    { id: 48878, cityId: 2283, code: "224175" },
    { id: 48879, cityId: 2283, code: "224183" },
    { id: 48880, cityId: 2283, code: "224188" },
    { id: 48881, cityId: 2283, code: "224201" },
    { id: 48882, cityId: 2283, code: "224202" },
    { id: 48883, cityId: 2283, code: "224206" },
    { id: 48884, cityId: 2283, code: "224207" },
    { id: 48885, cityId: 2283, code: "224209" },
    { id: 48886, cityId: 2283, code: "224212" },
    { id: 48887, cityId: 2283, code: "224214" },
    { id: 48888, cityId: 2283, code: "224215" },
    { id: 48889, cityId: 2283, code: "224217" },
    { id: 48890, cityId: 2283, code: "224220" },
    { id: 48891, cityId: 2283, code: "224222" },
    { id: 48892, cityId: 2283, code: "224223" },
    { id: 48893, cityId: 2284, code: "243503" },
    { id: 48894, cityId: 2285, code: "205301" },
    { id: 48895, cityId: 2285, code: "207502" },
    { id: 48896, cityId: 2285, code: "207504" },
    { id: 48897, cityId: 2285, code: "209602" },
    { id: 48898, cityId: 2285, code: "209621" },
    { id: 48899, cityId: 2285, code: "209726" },
    { id: 48900, cityId: 2285, code: "209727" },
    { id: 48901, cityId: 2285, code: "209734" },
    { id: 48902, cityId: 2285, code: "209739" },
    { id: 48903, cityId: 2285, code: "207503" },
    { id: 48904, cityId: 2285, code: "209601" },
    { id: 48905, cityId: 2285, code: "209622" },
    { id: 48906, cityId: 2285, code: "209625" },
    { id: 48907, cityId: 2285, code: "209725" },
    { id: 48908, cityId: 2285, code: "209733" },
    { id: 48909, cityId: 2285, code: "209736" },
    { id: 48910, cityId: 2285, code: "209738" },
    { id: 48911, cityId: 2285, code: "209743" },
    { id: 48912, cityId: 2285, code: "209770" },
    { id: 48913, cityId: 2286, code: "125050" },
    { id: 48914, cityId: 2286, code: "283111" },
    { id: 48915, cityId: 2287, code: "209601" },
    { id: 48916, cityId: 2287, code: "209602" },
    { id: 48917, cityId: 2288, code: "212631" },
    { id: 48918, cityId: 2288, code: "212645" },
    { id: 48919, cityId: 2288, code: "212653" },
    { id: 48920, cityId: 2288, code: "212658" },
    { id: 48921, cityId: 2288, code: "212661" },
    { id: 48922, cityId: 2288, code: "212663" },
    { id: 48923, cityId: 2288, code: "213113" },
    { id: 48924, cityId: 2288, code: "212601" },
    { id: 48925, cityId: 2288, code: "212622" },
    { id: 48926, cityId: 2288, code: "212641" },
    { id: 48927, cityId: 2288, code: "212652" },
    { id: 48928, cityId: 2288, code: "212654" },
    { id: 48929, cityId: 2288, code: "212656" },
    { id: 48930, cityId: 2288, code: "212657" },
    { id: 48931, cityId: 2288, code: "212659" },
    { id: 48932, cityId: 2288, code: "212664" },
    { id: 48933, cityId: 2288, code: "212665" },
    { id: 48934, cityId: 2289, code: "283110" },
    { id: 48935, cityId: 2290, code: "205141" },
    { id: 48936, cityId: 2290, code: "283203" },
    { id: 48937, cityId: 2291, code: "244235" },
    { id: 48938, cityId: 2292, code: "209861" },
    { id: 48939, cityId: 2293, code: "221302" },
    { id: 48940, cityId: 2293, code: "431109" },
    { id: 48941, cityId: 2294, code: "247341" },
    { id: 48942, cityId: 2295, code: "284203" },
    { id: 48943, cityId: 2296, code: "274202" },
    { id: 48944, cityId: 2297, code: "241305" },
    { id: 48945, cityId: 2298, code: "201301" },
    { id: 48946, cityId: 2298, code: "123456" },
    { id: 48947, cityId: 2299, code: "209206" },
    { id: 48948, cityId: 2300, code: "201001" },
    { id: 48949, cityId: 2300, code: "201003" },
    { id: 48950, cityId: 2968, code: "201005" },
    { id: 48951, cityId: 2300, code: "201006" },
    { id: 48952, cityId: 2300, code: "201008" },
    { id: 48953, cityId: 2300, code: "201011" },
    { id: 48954, cityId: 2300, code: "201101" },
    { id: 48955, cityId: 2300, code: "201201" },
    { id: 48956, cityId: 2300, code: "201302" },
    { id: 48957, cityId: 2300, code: "245301" },
    { id: 48958, cityId: 2300, code: "245304" },
    { id: 48959, cityId: 2300, code: "201002" },
    { id: 48960, cityId: 2300, code: "201004" },
    { id: 48961, cityId: 2300, code: "201007" },
    { id: 48962, cityId: 2300, code: "201009" },
    { id: 48963, cityId: 2300, code: "201012" },
    { id: 48964, cityId: 2300, code: "201205" },
    { id: 48965, cityId: 2300, code: "201206" },
    { id: 48966, cityId: 2300, code: "201304" },
    { id: 48967, cityId: 2300, code: "245101" },
    { id: 48968, cityId: 2300, code: "245102" },
    { id: 48969, cityId: 2300, code: "245205" },
    { id: 48970, cityId: 2300, code: "245207" },
    { id: 48971, cityId: 2300, code: "245208" },
    { id: 48972, cityId: 2301, code: "226010" },
    { id: 48973, cityId: 2301, code: "229501" },
    { id: 48974, cityId: 2301, code: "232326" },
    { id: 48975, cityId: 2301, code: "232327" },
    { id: 48976, cityId: 2301, code: "232332" },
    { id: 48977, cityId: 2301, code: "232334" },
    { id: 48978, cityId: 2301, code: "232335" },
    { id: 48979, cityId: 2301, code: "232340" },
    { id: 48980, cityId: 2301, code: "232342" },
    { id: 48981, cityId: 2301, code: "233201" },
    { id: 48982, cityId: 2301, code: "233208" },
    { id: 48983, cityId: 2301, code: "233222" },
    { id: 48984, cityId: 2301, code: "233224" },
    { id: 48985, cityId: 2301, code: "233225" },
    { id: 48986, cityId: 2301, code: "233227" },
    { id: 48987, cityId: 2301, code: "233232" },
    { id: 48988, cityId: 2301, code: "233233" },
    { id: 48989, cityId: 2301, code: "233235" },
    { id: 48990, cityId: 2301, code: "233301" },
    { id: 48991, cityId: 2301, code: "233304" },
    { id: 48992, cityId: 2301, code: "233309" },
    { id: 48993, cityId: 2301, code: "233312" },
    { id: 48994, cityId: 2301, code: "236488" },
    { id: 48995, cityId: 2301, code: "275203" },
    { id: 48996, cityId: 2301, code: "275205" },
    { id: 48997, cityId: 2301, code: "275206" },
    { id: 48998, cityId: 2301, code: "275208" },
    { id: 48999, cityId: 2301, code: "212621" },
    { id: 49000, cityId: 2301, code: "232325" },
    { id: 49001, cityId: 2301, code: "232328" },
    { id: 49002, cityId: 2301, code: "232331" },
    { id: 49003, cityId: 2301, code: "232333" },
    { id: 49004, cityId: 2301, code: "232336" },
    { id: 49005, cityId: 2301, code: "232338" },
    { id: 49006, cityId: 2301, code: "232341" },
    { id: 49007, cityId: 2301, code: "233001" },
    { id: 49008, cityId: 2301, code: "233221" },
    { id: 49009, cityId: 2301, code: "233226" },
    { id: 49010, cityId: 2301, code: "233228" },
    { id: 49011, cityId: 2301, code: "233229" },
    { id: 49012, cityId: 2301, code: "233234" },
    { id: 49013, cityId: 2301, code: "233236" },
    { id: 49014, cityId: 2301, code: "233302" },
    { id: 49015, cityId: 2301, code: "233303" },
    { id: 49016, cityId: 2301, code: "233305" },
    { id: 49017, cityId: 2301, code: "233310" },
    { id: 49018, cityId: 2301, code: "233311" },
    { id: 49019, cityId: 2301, code: "233337" },
    { id: 49020, cityId: 2301, code: "275202" },
    { id: 49021, cityId: 2302, code: "231210" },
    { id: 49022, cityId: 2303, code: "275304" },
    { id: 49023, cityId: 2304, code: "281303" },
    { id: 49024, cityId: 2305, code: "205001" },
    { id: 49025, cityId: 2306, code: "271002" },
    { id: 49026, cityId: 2306, code: "271122" },
    { id: 49027, cityId: 2306, code: "271125" },
    { id: 49028, cityId: 2306, code: "271127" },
    { id: 49029, cityId: 2306, code: "271201" },
    { id: 49030, cityId: 2306, code: "271204" },
    { id: 49031, cityId: 2306, code: "271207" },
    { id: 49032, cityId: 2306, code: "271209" },
    { id: 49033, cityId: 2306, code: "271212" },
    { id: 49034, cityId: 2306, code: "271302" },
    { id: 49035, cityId: 2306, code: "271304" },
    { id: 49036, cityId: 2306, code: "271305" },
    { id: 49037, cityId: 2306, code: "271307" },
    { id: 49038, cityId: 2306, code: "271310" },
    { id: 49039, cityId: 2306, code: "271312" },
    { id: 49040, cityId: 2306, code: "271313" },
    { id: 49041, cityId: 2306, code: "271315" },
    { id: 49042, cityId: 2306, code: "271318" },
    { id: 49043, cityId: 2306, code: "271320" },
    { id: 49044, cityId: 2306, code: "271402" },
    { id: 49045, cityId: 2306, code: "271403" },
    { id: 49046, cityId: 2306, code: "271405" },
    { id: 49047, cityId: 2306, code: "271408" },
    { id: 49048, cityId: 2306, code: "271601" },
    { id: 49049, cityId: 2306, code: "271607" },
    { id: 49050, cityId: 2306, code: "271861" },
    { id: 49051, cityId: 2306, code: "202123" },
    { id: 49052, cityId: 2306, code: "271001" },
    { id: 49053, cityId: 2306, code: "271123" },
    { id: 49054, cityId: 2306, code: "271126" },
    { id: 49055, cityId: 2306, code: "271202" },
    { id: 49056, cityId: 2306, code: "271203" },
    { id: 49057, cityId: 2306, code: "271210" },
    { id: 49058, cityId: 2306, code: "271211" },
    { id: 49059, cityId: 2306, code: "271213" },
    { id: 49060, cityId: 2306, code: "271301" },
    { id: 49061, cityId: 2306, code: "271306" },
    { id: 49062, cityId: 2306, code: "271309" },
    { id: 49063, cityId: 2306, code: "271311" },
    { id: 49064, cityId: 2306, code: "271314" },
    { id: 49065, cityId: 2306, code: "271316" },
    { id: 49066, cityId: 2306, code: "271317" },
    { id: 49067, cityId: 2306, code: "271319" },
    { id: 49068, cityId: 2306, code: "271321" },
    { id: 49069, cityId: 2306, code: "271401" },
    { id: 49070, cityId: 2306, code: "271404" },
    { id: 49071, cityId: 2306, code: "271407" },
    { id: 49072, cityId: 2306, code: "271602" },
    { id: 49073, cityId: 2306, code: "271603" },
    { id: 49074, cityId: 2306, code: "271605" },
    { id: 49075, cityId: 2306, code: "271828" },
    { id: 49076, cityId: 2307, code: "241404" },
    { id: 49077, cityId: 2308, code: "221303" },
    { id: 49078, cityId: 2309, code: "273002" },
    { id: 49079, cityId: 2309, code: "273004" },
    { id: 49080, cityId: 2309, code: "273005" },
    { id: 49081, cityId: 2309, code: "273007" },
    { id: 49082, cityId: 2309, code: "273010" },
    { id: 49083, cityId: 2309, code: "273012" },
    { id: 49084, cityId: 2309, code: "273013" },
    { id: 49085, cityId: 2309, code: "273153" },
    { id: 49086, cityId: 2309, code: "273155" },
    { id: 49087, cityId: 2309, code: "273158" },
    { id: 49088, cityId: 2309, code: "273164" },
    { id: 49089, cityId: 2309, code: "273201" },
    { id: 49090, cityId: 2309, code: "273301" },
    { id: 49091, cityId: 2309, code: "273306" },
    { id: 49092, cityId: 2309, code: "273404" },
    { id: 49093, cityId: 2309, code: "273405" },
    { id: 49094, cityId: 2309, code: "273407" },
    { id: 49095, cityId: 2309, code: "273412" },
    { id: 49096, cityId: 2309, code: "273415" },
    { id: 49097, cityId: 2309, code: "273001" },
    { id: 49098, cityId: 2309, code: "273003" },
    { id: 49099, cityId: 2309, code: "273006" },
    { id: 49100, cityId: 2309, code: "273008" },
    { id: 49101, cityId: 2309, code: "273009" },
    { id: 49102, cityId: 2309, code: "273011" },
    { id: 49103, cityId: 2309, code: "273151" },
    { id: 49104, cityId: 2309, code: "273152" },
    { id: 49105, cityId: 2309, code: "273157" },
    { id: 49106, cityId: 2309, code: "273165" },
    { id: 49107, cityId: 2309, code: "273202" },
    { id: 49108, cityId: 2309, code: "273302" },
    { id: 49109, cityId: 2309, code: "273303" },
    { id: 49110, cityId: 2309, code: "273305" },
    { id: 49111, cityId: 2309, code: "273308" },
    { id: 49112, cityId: 2309, code: "273401" },
    { id: 49113, cityId: 2309, code: "273406" },
    { id: 49114, cityId: 2309, code: "273408" },
    { id: 49115, cityId: 2309, code: "273409" },
    { id: 49116, cityId: 2309, code: "273411" },
    { id: 49117, cityId: 2309, code: "273413" },
    { id: 49118, cityId: 2309, code: "273414" },
    { id: 49119, cityId: 2310, code: "202522" },
    { id: 49120, cityId: 2311, code: "209722" },
    { id: 49121, cityId: 2312, code: "284202" },
    { id: 49122, cityId: 2313, code: "221304" },
    { id: 49123, cityId: 2314, code: "227301" },
    { id: 49124, cityId: 2315, code: "246726" },
    { id: 49125, cityId: 2316, code: "174311" },
    { id: 49126, cityId: 2316, code: "174313" },
    { id: 49127, cityId: 2316, code: "176027" },
    { id: 49128, cityId: 2316, code: "176030" },
    { id: 49129, cityId: 2316, code: "176032" },
    { id: 49130, cityId: 2316, code: "176035" },
    { id: 49131, cityId: 2316, code: "176040" },
    { id: 49132, cityId: 2316, code: "176043" },
    { id: 49133, cityId: 2316, code: "176045" },
    { id: 49134, cityId: 2316, code: "176048" },
    { id: 49135, cityId: 2316, code: "176111" },
    { id: 49136, cityId: 2316, code: "176501" },
    { id: 49137, cityId: 2316, code: "177001" },
    { id: 49138, cityId: 2316, code: "177007" },
    { id: 49139, cityId: 2316, code: "177020" },
    { id: 49140, cityId: 2316, code: "177023" },
    { id: 49141, cityId: 2316, code: "177025" },
    { id: 49142, cityId: 2316, code: "177026" },
    { id: 49143, cityId: 2316, code: "177028" },
    { id: 49144, cityId: 2316, code: "177030" },
    { id: 49145, cityId: 2316, code: "177038" },
    { id: 49146, cityId: 2316, code: "177041" },
    { id: 49147, cityId: 2316, code: "177044" },
    { id: 49148, cityId: 2316, code: "177046" },
    { id: 49149, cityId: 2316, code: "177047" },
    { id: 49150, cityId: 2316, code: "177102" },
    { id: 49151, cityId: 2316, code: "177105" },
    { id: 49152, cityId: 2316, code: "177107" },
    { id: 49153, cityId: 2316, code: "177108" },
    { id: 49154, cityId: 2316, code: "177113" },
    { id: 49155, cityId: 2316, code: "177116" },
    { id: 49156, cityId: 2316, code: "177118" },
    { id: 49157, cityId: 2316, code: "210301" },
    { id: 49158, cityId: 2316, code: "210422" },
    { id: 49159, cityId: 2316, code: "210423" },
    { id: 49160, cityId: 2316, code: "210425" },
    { id: 49161, cityId: 2316, code: "210428" },
    { id: 49162, cityId: 2316, code: "210431" },
    { id: 49163, cityId: 2316, code: "210433" },
    { id: 49164, cityId: 2316, code: "210502" },
    { id: 49165, cityId: 2316, code: "210504" },
    { id: 49166, cityId: 2316, code: "210507" },
    { id: 49167, cityId: 2316, code: "174304" },
    { id: 49168, cityId: 2316, code: "174309" },
    { id: 49169, cityId: 2316, code: "174312" },
    { id: 49170, cityId: 2316, code: "176026" },
    { id: 49171, cityId: 2316, code: "176031" },
    { id: 49172, cityId: 2316, code: "176034" },
    { id: 49173, cityId: 2316, code: "176036" },
    { id: 49174, cityId: 2316, code: "176039" },
    { id: 49175, cityId: 2316, code: "176042" },
    { id: 49176, cityId: 2316, code: "176044" },
    { id: 49177, cityId: 2316, code: "176049" },
    { id: 49178, cityId: 2316, code: "176055" },
    { id: 49179, cityId: 2316, code: "176108" },
    { id: 49180, cityId: 2316, code: "176110" },
    { id: 49181, cityId: 2316, code: "177005" },
    { id: 49182, cityId: 2316, code: "177006" },
    { id: 49183, cityId: 2316, code: "177021" },
    { id: 49184, cityId: 2316, code: "177022" },
    { id: 49185, cityId: 2316, code: "177024" },
    { id: 49186, cityId: 2316, code: "177027" },
    { id: 49187, cityId: 2316, code: "177029" },
    { id: 49188, cityId: 2316, code: "177034" },
    { id: 49189, cityId: 2316, code: "177035" },
    { id: 49190, cityId: 2316, code: "177040" },
    { id: 49191, cityId: 2316, code: "177042" },
    { id: 49192, cityId: 2316, code: "177043" },
    { id: 49193, cityId: 2316, code: "177045" },
    { id: 49194, cityId: 2316, code: "177048" },
    { id: 49195, cityId: 2316, code: "177101" },
    { id: 49196, cityId: 2316, code: "177103" },
    { id: 49197, cityId: 2316, code: "177104" },
    { id: 49198, cityId: 2316, code: "177106" },
    { id: 49199, cityId: 2316, code: "177111" },
    { id: 49200, cityId: 2316, code: "177112" },
    { id: 49201, cityId: 2316, code: "177114" },
    { id: 49202, cityId: 2316, code: "177117" },
    { id: 49203, cityId: 2316, code: "210321" },
    { id: 49204, cityId: 2316, code: "210421" },
    { id: 49205, cityId: 2316, code: "210424" },
    { id: 49206, cityId: 2316, code: "210429" },
    { id: 49207, cityId: 2316, code: "210432" },
    { id: 49208, cityId: 2316, code: "210434" },
    { id: 49209, cityId: 2316, code: "210506" },
    { id: 49210, cityId: 2317, code: "221503" },
    { id: 49211, cityId: 2318, code: "245101" },
    { id: 49212, cityId: 2319, code: "241121" },
    { id: 49213, cityId: 2319, code: "241122" },
    { id: 49214, cityId: 2319, code: "241201" },
    { id: 49215, cityId: 2319, code: "241402" },
    { id: 49216, cityId: 2319, code: "241405" },
    { id: 49217, cityId: 2319, code: "241407" },
    { id: 49218, cityId: 2319, code: "285131" },
    { id: 49219, cityId: 2319, code: "241001" },
    { id: 49220, cityId: 2319, code: "241126" },
    { id: 49221, cityId: 2319, code: "241202" },
    { id: 49222, cityId: 2319, code: "241203" },
    { id: 49223, cityId: 2319, code: "241401" },
    { id: 49224, cityId: 2319, code: "241406" },
    { id: 49225, cityId: 2320, code: "220325" },
    { id: 49226, cityId: 2321, code: "272164" },
    { id: 49227, cityId: 2322, code: "272135" },
    { id: 49228, cityId: 2323, code: "227808" },
    { id: 49229, cityId: 2323, code: "244241" },
    { id: 49230, cityId: 2324, code: "204212" },
    { id: 49231, cityId: 2325, code: "250404" },
    { id: 49232, cityId: 2326, code: "274203" },
    { id: 49233, cityId: 2327, code: "204102" },
    { id: 49234, cityId: 2327, code: "204101" },
    { id: 49235, cityId: 2327, code: "204215" },
    { id: 49236, cityId: 2327, code: "224125" },
    { id: 49237, cityId: 2328, code: "202124" },
    { id: 49238, cityId: 2329, code: "271845" },
    { id: 49239, cityId: 2330, code: "261202" },
    { id: 49240, cityId: 2331, code: "203141" },
    { id: 49241, cityId: 2332, code: "229305" },
    { id: 49242, cityId: 2333, code: "247772" },
    { id: 49243, cityId: 2333, code: "152024" },
    { id: 49244, cityId: 2333, code: "275207" },
    { id: 49245, cityId: 2334, code: "224149" },
    { id: 49246, cityId: 2335, code: "285122" },
    { id: 49247, cityId: 2335, code: "285124" },
    { id: 49248, cityId: 2335, code: "285125" },
    { id: 49249, cityId: 2335, code: "285130" },
    { id: 49250, cityId: 2335, code: "285132" },
    { id: 49251, cityId: 2335, code: "285133" },
    { id: 49252, cityId: 2335, code: "285201" },
    { id: 49253, cityId: 2335, code: "285202" },
    { id: 49254, cityId: 2335, code: "285222" },
    { id: 49255, cityId: 2335, code: "285223" },
    { id: 49256, cityId: 2335, code: "285233" },
    { id: 49257, cityId: 2335, code: "285252" },
    { id: 49258, cityId: 2335, code: "285001" },
    { id: 49259, cityId: 2335, code: "285121" },
    { id: 49260, cityId: 2335, code: "285123" },
    { id: 49261, cityId: 2335, code: "285128" },
    { id: 49262, cityId: 2335, code: "285136" },
    { id: 49263, cityId: 2335, code: "285187" },
    { id: 49264, cityId: 2335, code: "285203" },
    { id: 49265, cityId: 2335, code: "285205" },
    { id: 49266, cityId: 2335, code: "285211" },
    { id: 49267, cityId: 2335, code: "285221" },
    { id: 49268, cityId: 2335, code: "285224" },
    { id: 49269, cityId: 2335, code: "285232" },
    { id: 49270, cityId: 2335, code: "285242" },
    { id: 49271, cityId: 2335, code: "285243" },
    { id: 49272, cityId: 2335, code: "285251" },
    { id: 49273, cityId: 2336, code: "271904" },
    { id: 49274, cityId: 2337, code: "205125" },
    { id: 49275, cityId: 2338, code: "206254" },
    { id: 49276, cityId: 2339, code: "222001" },
    { id: 49277, cityId: 2339, code: "222002" },
    { id: 49278, cityId: 2339, code: "222102" },
    { id: 49279, cityId: 2339, code: "222104" },
    { id: 49280, cityId: 2339, code: "222105" },
    { id: 49281, cityId: 2339, code: "222107" },
    { id: 49282, cityId: 2339, code: "222110" },
    { id: 49283, cityId: 2339, code: "222112" },
    { id: 49284, cityId: 2339, code: "222113" },
    { id: 49285, cityId: 2339, code: "222128" },
    { id: 49286, cityId: 2339, code: "222129" },
    { id: 49287, cityId: 2339, code: "222136" },
    { id: 49288, cityId: 2339, code: "222137" },
    { id: 49289, cityId: 2339, code: "222139" },
    { id: 49290, cityId: 2339, code: "222142" },
    { id: 49291, cityId: 2339, code: "222145" },
    { id: 49292, cityId: 2339, code: "222202" },
    { id: 49293, cityId: 2339, code: "222226" },
    { id: 49294, cityId: 2339, code: "223101" },
    { id: 49295, cityId: 2339, code: "223103" },
    { id: 49296, cityId: 2339, code: "223106" },
    { id: 49297, cityId: 2339, code: "222101" },
    { id: 49298, cityId: 2339, code: "222103" },
    { id: 49299, cityId: 2339, code: "222108" },
    { id: 49300, cityId: 2339, code: "222109" },
    { id: 49301, cityId: 2339, code: "222111" },
    { id: 49302, cityId: 2339, code: "222125" },
    { id: 49303, cityId: 2339, code: "222127" },
    { id: 49304, cityId: 2339, code: "222132" },
    { id: 49305, cityId: 2339, code: "222133" },
    { id: 49306, cityId: 2339, code: "222135" },
    { id: 49307, cityId: 2339, code: "222138" },
    { id: 49308, cityId: 2339, code: "222141" },
    { id: 49309, cityId: 2339, code: "222143" },
    { id: 49310, cityId: 2339, code: "222146" },
    { id: 49311, cityId: 2339, code: "222148" },
    { id: 49312, cityId: 2339, code: "222149" },
    { id: 49313, cityId: 2339, code: "222162" },
    { id: 49314, cityId: 2339, code: "222170" },
    { id: 49315, cityId: 2339, code: "222172" },
    { id: 49316, cityId: 2339, code: "222175" },
    { id: 49317, cityId: 2339, code: "222180" },
    { id: 49318, cityId: 2339, code: "222201" },
    { id: 49319, cityId: 2339, code: "223102" },
    { id: 49320, cityId: 2339, code: "223104" },
    { id: 49321, cityId: 2339, code: "223105" },
    { id: 49322, cityId: 2339, code: "223107" },
    { id: 49323, cityId: 2340, code: "203133" },
    { id: 49324, cityId: 2341, code: "246728" },
    { id: 49325, cityId: 2342, code: "284001" },
    { id: 49326, cityId: 2342, code: "284128" },
    { id: 49327, cityId: 2342, code: "284129" },
    { id: 49328, cityId: 2342, code: "284401" },
    { id: 49329, cityId: 2342, code: "284002" },
    { id: 49330, cityId: 2342, code: "284003" },
    { id: 49331, cityId: 2342, code: "284127" },
    { id: 49332, cityId: 2342, code: "284201" },
    { id: 49333, cityId: 2342, code: "284204" },
    { id: 49334, cityId: 2343, code: "209320" },
    { id: 49335, cityId: 2344, code: "247773" },
    { id: 49336, cityId: 2345, code: "221506" },
    { id: 49337, cityId: 2346, code: "244222" },
    { id: 49338, cityId: 2347, code: "228145" },
    { id: 49339, cityId: 2348, code: "247774" },
    { id: 49340, cityId: 2349, code: "243637" },
    { id: 49341, cityId: 2350, code: "285204" },
    { id: 49342, cityId: 2351, code: "209724" },
    { id: 49343, cityId: 2352, code: "209725" },
    { id: 49344, cityId: 2352, code: "209732" },
    { id: 49345, cityId: 2352, code: "229418" },
    { id: 49346, cityId: 2352, code: "242404" },
    { id: 49347, cityId: 2353, code: "208002" },
    { id: 49348, cityId: 2353, code: "208004" },
    { id: 49349, cityId: 2353, code: "208005" },
    { id: 49350, cityId: 2353, code: "208007" },
    { id: 49351, cityId: 2353, code: "208010" },
    { id: 49352, cityId: 2353, code: "208012" },
    { id: 49353, cityId: 2353, code: "208015" },
    { id: 49354, cityId: 2353, code: "208017" },
    { id: 49355, cityId: 2353, code: "208018" },
    { id: 49356, cityId: 2353, code: "208020" },
    { id: 49357, cityId: 2353, code: "208023" },
    { id: 49358, cityId: 2353, code: "208025" },
    { id: 49359, cityId: 2353, code: "208039" },
    { id: 49360, cityId: 2353, code: "209125" },
    { id: 49361, cityId: 2353, code: "209202" },
    { id: 49362, cityId: 2353, code: "209204" },
    { id: 49363, cityId: 2353, code: "209207" },
    { id: 49364, cityId: 2353, code: "209209" },
    { id: 49365, cityId: 2353, code: "209305" },
    { id: 49366, cityId: 2353, code: "209307" },
    { id: 49367, cityId: 2353, code: "208001" },
    { id: 49368, cityId: 2353, code: "208003" },
    { id: 49369, cityId: 2353, code: "208006" },
    { id: 49370, cityId: 2353, code: "208011" },
    { id: 49371, cityId: 2353, code: "208013" },
    { id: 49372, cityId: 2353, code: "208014" },
    { id: 49373, cityId: 2353, code: "208016" },
    { id: 49374, cityId: 2353, code: "208019" },
    { id: 49375, cityId: 2353, code: "208021" },
    { id: 49376, cityId: 2353, code: "208022" },
    { id: 49377, cityId: 2353, code: "208024" },
    { id: 49378, cityId: 2353, code: "209115" },
    { id: 49379, cityId: 2353, code: "209121" },
    { id: 49380, cityId: 2353, code: "209203" },
    { id: 49381, cityId: 2353, code: "209205" },
    { id: 49382, cityId: 2353, code: "209206" },
    { id: 49383, cityId: 2353, code: "209208" },
    { id: 49384, cityId: 2353, code: "209301" },
    { id: 49385, cityId: 2353, code: "209304" },
    { id: 49386, cityId: 2353, code: "209401" },
    { id: 49387, cityId: 2353, code: "209402" },
    { id: 49388, cityId: 2354, code: "204104" },
    { id: 49389, cityId: 2355, code: "212206" },
    { id: 49390, cityId: 2356, code: "205264" },
    { id: 49391, cityId: 2357, code: "207123" },
    { id: 49392, cityId: 2358, code: "211002" },
    { id: 49393, cityId: 2358, code: "182301" },
    { id: 49394, cityId: 2359, code: "202129" },
    { id: 49396, cityId: 2360, code: "212203" },
    { id: 49397, cityId: 2360, code: "212207" },
    { id: 49398, cityId: 2360, code: "212218" },
    { id: 49399, cityId: 2361, code: "273415" },
    { id: 49400, cityId: 2362, code: "212655" },
    { id: 49401, cityId: 2363, code: "202138" },
    { id: 49402, cityId: 2364, code: "261131" },
    { id: 49403, cityId: 2365, code: "272175" },
    { id: 49404, cityId: 2366, code: "221306" },
    { id: 49405, cityId: 2367, code: "245405" },
    { id: 49406, cityId: 2368, code: "210425" },
    { id: 49407, cityId: 2369, code: "251201" },
    { id: 49408, cityId: 2370, code: "261502" },
    { id: 49409, cityId: 2370, code: "262701" },
    { id: 49410, cityId: 2370, code: "262702" },
    { id: 49411, cityId: 2370, code: "262723" },
    { id: 49412, cityId: 2370, code: "262725" },
    { id: 49413, cityId: 2370, code: "262726" },
    { id: 49414, cityId: 2370, code: "262802" },
    { id: 49415, cityId: 2370, code: "262903" },
    { id: 49416, cityId: 2370, code: "262905" },
    { id: 49417, cityId: 2370, code: "262906" },
    { id: 49418, cityId: 2370, code: "261505" },
    { id: 49419, cityId: 2370, code: "261506" },
    { id: 49420, cityId: 2370, code: "261606" },
    { id: 49421, cityId: 2370, code: "262721" },
    { id: 49422, cityId: 2370, code: "262722" },
    { id: 49423, cityId: 2370, code: "262724" },
    { id: 49424, cityId: 2370, code: "262727" },
    { id: 49425, cityId: 2370, code: "262801" },
    { id: 49426, cityId: 2370, code: "262901" },
    { id: 49427, cityId: 2370, code: "262902" },
    { id: 49428, cityId: 2370, code: "262904" },
    { id: 49429, cityId: 2370, code: "262907" },
    { id: 49430, cityId: 2371, code: "242305" },
    { id: 49431, cityId: 2372, code: "203131" },
    { id: 49432, cityId: 2373, code: "242405" },
    { id: 49433, cityId: 2374, code: "246731" },
    { id: 49434, cityId: 2375, code: "206302" },
    { id: 49435, cityId: 2376, code: "285205" },
    { id: 49436, cityId: 2377, code: "275305" },
    { id: 49437, cityId: 2378, code: "229406" },
    { id: 49438, cityId: 2379, code: "202413" },
    { id: 49439, cityId: 2380, code: "205265" },
    { id: 49440, cityId: 2381, code: "210505" },
    { id: 49441, cityId: 2382, code: "274403" },
    { id: 49442, cityId: 2382, code: "273149" },
    { id: 49443, cityId: 2382, code: "274402" },
    { id: 49444, cityId: 2383, code: "206303" },
    { id: 49445, cityId: 2384, code: "261135" },
    { id: 49446, cityId: 2385, code: "206127" },
    { id: 49447, cityId: 2386, code: "229206" },
    { id: 49448, cityId: 2386, code: "231211" },
    { id: 49449, cityId: 2386, code: "277216" },
    { id: 49450, cityId: 2386, code: "230132" },
    { id: 49451, cityId: 2386, code: "276202" },
    { id: 49452, cityId: 2386, code: "844121" },
    { id: 49453, cityId: 2387, code: "284123" },
    { id: 49454, cityId: 2387, code: "284404" },
    { id: 49455, cityId: 2387, code: "284406" },
    { id: 49456, cityId: 2387, code: "284407" },
    { id: 49457, cityId: 2387, code: "284124" },
    { id: 49458, cityId: 2387, code: "284125" },
    { id: 49459, cityId: 2387, code: "284402" },
    { id: 49460, cityId: 2387, code: "284403" },
    { id: 49461, cityId: 2387, code: "284405" },
    { id: 49462, cityId: 2388, code: "274502" },
    { id: 49463, cityId: 2389, code: "201102" },
    { id: 49464, cityId: 2390, code: "226001" },
    { id: 49465, cityId: 2390, code: "226004" },
    { id: 49466, cityId: 2390, code: "226006" },
    { id: 49467, cityId: 2390, code: "226007" },
    { id: 49468, cityId: 2390, code: "226009" },
    { id: 49469, cityId: 2390, code: "226012" },
    { id: 49470, cityId: 2390, code: "226014" },
    { id: 49471, cityId: 2390, code: "226015" },
    { id: 49472, cityId: 2390, code: "226017" },
    { id: 49473, cityId: 2390, code: "226020" },
    { id: 49474, cityId: 2390, code: "227101" },
    { id: 49475, cityId: 2390, code: "227106" },
    { id: 49476, cityId: 2390, code: "227116" },
    { id: 49477, cityId: 2390, code: "227132" },
    { id: 49478, cityId: 2390, code: "227305" },
    { id: 49479, cityId: 2390, code: "226002" },
    { id: 49480, cityId: 2390, code: "226003" },
    { id: 49481, cityId: 2390, code: "226005" },
    { id: 49482, cityId: 2390, code: "226008" },
    { id: 49483, cityId: 2390, code: "226011" },
    { id: 49484, cityId: 2390, code: "226016" },
    { id: 49485, cityId: 2390, code: "226018" },
    { id: 49486, cityId: 2390, code: "226106" },
    { id: 49487, cityId: 2390, code: "227105" },
    { id: 49488, cityId: 2390, code: "227115" },
    { id: 49489, cityId: 2390, code: "227125" },
    { id: 49490, cityId: 2390, code: "227131" },
    { id: 49491, cityId: 2390, code: "227202" },
    { id: 49492, cityId: 2390, code: "227205" },
    { id: 49493, cityId: 2390, code: "227208" },
    { id: 49494, cityId: 2390, code: "227309" },
    { id: 49495, cityId: 2391, code: "205141" },
    { id: 49496, cityId: 2391, code: "241302" },
    { id: 49497, cityId: 2391, code: "230403" },
    { id: 49498, cityId: 2392, code: "285126" },
    { id: 49499, cityId: 2393, code: "272173" },
    { id: 49500, cityId: 2394, code: "281305" },
    { id: 49501, cityId: 2395, code: "229401" },
    { id: 49502, cityId: 2395, code: "210427" },
    { id: 49503, cityId: 2396, code: "261141" },
    { id: 49504, cityId: 2397, code: "273161" },
    { id: 49505, cityId: 2397, code: "276141" },
    { id: 49506, cityId: 2398, code: "262803" },
    { id: 49507, cityId: 2399, code: "205119" },
    { id: 49508, cityId: 2399, code: "205122" },
    { id: 49509, cityId: 2399, code: "205135" },
    { id: 49510, cityId: 2399, code: "205145" },
    { id: 49511, cityId: 2399, code: "205231" },
    { id: 49512, cityId: 2399, code: "205262" },
    { id: 49513, cityId: 2399, code: "205267" },
    { id: 49514, cityId: 2399, code: "205268" },
    { id: 49515, cityId: 2399, code: "205302" },
    { id: 49516, cityId: 2399, code: "205001" },
    { id: 49517, cityId: 2399, code: "205120" },
    { id: 49518, cityId: 2399, code: "205121" },
    { id: 49519, cityId: 2399, code: "205142" },
    { id: 49520, cityId: 2399, code: "205147" },
    { id: 49521, cityId: 2399, code: "205261" },
    { id: 49522, cityId: 2399, code: "205263" },
    { id: 49523, cityId: 2399, code: "205266" },
    { id: 49524, cityId: 2400, code: "274506" },
    { id: 49525, cityId: 2401, code: "227111" },
    { id: 49526, cityId: 2402, code: "241303" },
    { id: 49527, cityId: 2402, code: "229416" },
    { id: 49528, cityId: 2403, code: "246721" },
    { id: 49529, cityId: 2404, code: "210208" },
    { id: 49530, cityId: 2404, code: "229407" },
    { id: 49531, cityId: 2405, code: "207401" },
    { id: 49532, cityId: 2406, code: "222161" },
    { id: 49533, cityId: 2407, code: "281001" },
    { id: 49534, cityId: 2407, code: "281003" },
    { id: 49535, cityId: 2407, code: "281006" },
    { id: 49536, cityId: 2407, code: "281112" },
    { id: 49537, cityId: 2407, code: "281202" },
    { id: 49538, cityId: 2407, code: "281302" },
    { id: 49539, cityId: 2407, code: "281307" },
    { id: 49540, cityId: 2407, code: "281308" },
    { id: 49541, cityId: 2407, code: "281403" },
    { id: 49542, cityId: 2407, code: "281406" },
    { id: 49543, cityId: 2407, code: "281501" },
    { id: 49544, cityId: 2407, code: "281503" },
    { id: 49545, cityId: 2407, code: "204101" },
    { id: 49546, cityId: 2407, code: "261204" },
    { id: 49547, cityId: 2407, code: "281002" },
    { id: 49548, cityId: 2407, code: "281004" },
    { id: 49549, cityId: 2407, code: "281005" },
    { id: 49550, cityId: 2407, code: "281121" },
    { id: 49551, cityId: 2407, code: "281123" },
    { id: 49552, cityId: 2407, code: "281203" },
    { id: 49553, cityId: 2407, code: "281205" },
    { id: 49554, cityId: 2407, code: "281206" },
    { id: 49555, cityId: 2407, code: "281304" },
    { id: 49556, cityId: 2407, code: "281401" },
    { id: 49557, cityId: 2407, code: "281402" },
    { id: 49558, cityId: 2407, code: "281502" },
    { id: 49559, cityId: 2408, code: "284204" },
    { id: 49560, cityId: 2409, code: "209821" },
    { id: 49561, cityId: 2410, code: "250401" },
    { id: 49562, cityId: 2411, code: "245206" },
    { id: 49563, cityId: 2411, code: "250003" },
    { id: 49564, cityId: 2411, code: "250005" },
    { id: 49565, cityId: 2411, code: "250013" },
    { id: 49566, cityId: 2411, code: "250104" },
    { id: 49567, cityId: 2411, code: "250106" },
    { id: 49568, cityId: 2411, code: "250223" },
    { id: 49569, cityId: 2411, code: "250342" },
    { id: 49570, cityId: 2411, code: "250344" },
    { id: 49571, cityId: 2411, code: "250403" },
    { id: 49572, cityId: 2411, code: "250406" },
    { id: 49573, cityId: 2411, code: "250501" },
    { id: 49574, cityId: 2411, code: "250601" },
    { id: 49575, cityId: 2411, code: "250602" },
    { id: 49576, cityId: 2411, code: "250612" },
    { id: 49577, cityId: 2411, code: "250615" },
    { id: 49578, cityId: 2411, code: "250622" },
    { id: 49579, cityId: 2411, code: "250623" },
    { id: 49580, cityId: 2411, code: "250625" },
    { id: 49581, cityId: 2411, code: "255006" },
    { id: 49582, cityId: 2411, code: "250001" },
    { id: 49583, cityId: 2411, code: "250002" },
    { id: 49584, cityId: 2411, code: "250004" },
    { id: 49585, cityId: 2411, code: "250102" },
    { id: 49586, cityId: 2411, code: "250105" },
    { id: 49587, cityId: 2411, code: "250110" },
    { id: 49588, cityId: 2411, code: "250222" },
    { id: 49589, cityId: 2411, code: "250341" },
    { id: 49590, cityId: 2411, code: "250401" },
    { id: 49591, cityId: 2411, code: "250402" },
    { id: 49592, cityId: 2411, code: "250502" },
    { id: 49593, cityId: 2411, code: "250611" },
    { id: 49594, cityId: 2411, code: "250619" },
    { id: 49595, cityId: 2411, code: "250621" },
    { id: 49596, cityId: 2412, code: "272171" },
    { id: 49597, cityId: 2413, code: "276204" },
    { id: 49598, cityId: 2414, code: "243701" },
    { id: 49599, cityId: 2415, code: "243504" },
    { id: 49600, cityId: 2415, code: "841438" },
    { id: 49601, cityId: 2415, code: "222165" },
    { id: 49602, cityId: 2416, code: "231001" },
    { id: 49603, cityId: 2416, code: "231213" },
    { id: 49604, cityId: 2416, code: "231216" },
    { id: 49605, cityId: 2416, code: "231218" },
    { id: 49606, cityId: 2416, code: "231219" },
    { id: 49607, cityId: 2416, code: "231221" },
    { id: 49608, cityId: 2416, code: "231303" },
    { id: 49609, cityId: 2416, code: "231306" },
    { id: 49610, cityId: 2416, code: "231309" },
    { id: 49611, cityId: 2416, code: "231311" },
    { id: 49612, cityId: 2416, code: "231314" },
    { id: 49613, cityId: 2416, code: "221501" },
    { id: 49614, cityId: 2416, code: "231002" },
    { id: 49615, cityId: 2416, code: "231206" },
    { id: 49616, cityId: 2416, code: "231207" },
    { id: 49617, cityId: 2416, code: "231209" },
    { id: 49618, cityId: 2416, code: "231214" },
    { id: 49619, cityId: 2416, code: "231215" },
    { id: 49620, cityId: 2416, code: "231217" },
    { id: 49621, cityId: 2416, code: "231220" },
    { id: 49622, cityId: 2416, code: "231222" },
    { id: 49623, cityId: 2416, code: "231223" },
    { id: 49624, cityId: 2416, code: "231225" },
    { id: 49625, cityId: 2416, code: "231302" },
    { id: 49626, cityId: 2416, code: "231304" },
    { id: 49627, cityId: 2416, code: "231305" },
    { id: 49628, cityId: 2416, code: "231310" },
    { id: 49629, cityId: 2416, code: "231312" },
    { id: 49630, cityId: 2416, code: "232221" },
    { id: 49631, cityId: 2417, code: "201204" },
    { id: 49632, cityId: 2418, code: "276403" },
    { id: 49633, cityId: 2418, code: "206451" },
    { id: 49634, cityId: 2418, code: "233227" },
    { id: 49635, cityId: 2419, code: "262804" },
    { id: 49636, cityId: 2420, code: "209851" },
    { id: 49637, cityId: 2421, code: "201205" },
    { id: 49638, cityId: 2422, code: "202412" },
    { id: 49639, cityId: 2422, code: "202415" },
    { id: 49640, cityId: 2422, code: "244001" },
    { id: 49641, cityId: 2422, code: "244102" },
    { id: 49642, cityId: 2422, code: "244221" },
    { id: 49643, cityId: 2422, code: "244231" },
    { id: 49644, cityId: 2422, code: "244236" },
    { id: 49645, cityId: 2422, code: "244255" },
    { id: 49646, cityId: 2422, code: "244303" },
    { id: 49647, cityId: 2422, code: "244401" },
    { id: 49648, cityId: 2422, code: "244502" },
    { id: 49649, cityId: 2422, code: "244711" },
    { id: 49650, cityId: 2422, code: "244713" },
    { id: 49651, cityId: 2422, code: "202416" },
    { id: 49652, cityId: 2422, code: "241502" },
    { id: 49653, cityId: 2422, code: "244249" },
    { id: 49654, cityId: 2422, code: "244251" },
    { id: 49655, cityId: 2422, code: "244302" },
    { id: 49656, cityId: 2422, code: "244304" },
    { id: 49657, cityId: 2422, code: "244402" },
    { id: 49658, cityId: 2422, code: "244712" },
    { id: 49659, cityId: 2422, code: "244714" },
    { id: 49660, cityId: 2422, code: "244715" },
    { id: 49661, cityId: 2422, code: "244926" },
    { id: 49662, cityId: 2423, code: "284303" },
    { id: 49663, cityId: 2424, code: "276404" },
    { id: 49664, cityId: 2425, code: "201206" },
    { id: 49665, cityId: 2426, code: "204213" },
    { id: 49666, cityId: 2427, code: "227813" },
    { id: 49667, cityId: 2428, code: "251202" },
    { id: 49668, cityId: 2428, code: "251305" },
    { id: 49669, cityId: 2428, code: "251308" },
    { id: 49670, cityId: 2428, code: "251310" },
    { id: 49671, cityId: 2428, code: "251315" },
    { id: 49672, cityId: 2428, code: "251316" },
    { id: 49673, cityId: 2428, code: "247775" },
    { id: 49674, cityId: 2428, code: "247776" },
    { id: 49675, cityId: 2428, code: "251001" },
    { id: 49676, cityId: 2428, code: "251002" },
    { id: 49677, cityId: 2428, code: "251203" },
    { id: 49678, cityId: 2428, code: "251301" },
    { id: 49679, cityId: 2428, code: "251306" },
    { id: 49680, cityId: 2428, code: "251311" },
    { id: 49681, cityId: 2428, code: "251317" },
    { id: 49682, cityId: 2429, code: "285206" },
    { id: 49683, cityId: 2430, code: "246762" },
    { id: 49684, cityId: 2431, code: "227308" },
    { id: 49685, cityId: 2432, code: "274001" },
    { id: 49686, cityId: 2432, code: "221409" },
    { id: 49687, cityId: 2433, code: "246763" },
    { id: 49688, cityId: 2434, code: "247342" },
    { id: 49689, cityId: 2435, code: "247452" },
    { id: 49690, cityId: 2436, code: "271865" },
    { id: 49691, cityId: 2437, code: "210129" },
    { id: 49692, cityId: 2438, code: "202414" },
    { id: 49693, cityId: 2439, code: "207501" },
    { id: 49694, cityId: 2439, code: "208002" },
    { id: 49695, cityId: 2439, code: "209859" },
    { id: 49696, cityId: 2439, code: "262406" },
    { id: 49697, cityId: 2439, code: "271303" },
    { id: 49698, cityId: 2440, code: "273304" },
    { id: 49699, cityId: 2441, code: "276206" },
    { id: 49700, cityId: 2441, code: "503001" },
    { id: 49701, cityId: 2441, code: "503003" },
    { id: 49702, cityId: 2441, code: "503101" },
    { id: 49703, cityId: 2441, code: "503102" },
    { id: 49704, cityId: 2441, code: "503110" },
    { id: 49705, cityId: 2441, code: "503115" },
    { id: 49706, cityId: 2441, code: "503120" },
    { id: 49707, cityId: 2441, code: "503123" },
    { id: 49708, cityId: 2441, code: "503125" },
    { id: 49709, cityId: 2441, code: "503144" },
    { id: 49710, cityId: 2441, code: "503165" },
    { id: 49711, cityId: 2441, code: "503176" },
    { id: 49712, cityId: 2441, code: "503178" },
    { id: 49713, cityId: 2441, code: "503186" },
    { id: 49714, cityId: 2441, code: "503187" },
    { id: 49715, cityId: 2441, code: "503192" },
    { id: 49716, cityId: 2441, code: "503202" },
    { id: 49717, cityId: 2441, code: "503207" },
    { id: 49718, cityId: 2441, code: "503213" },
    { id: 49719, cityId: 2441, code: "503215" },
    { id: 49720, cityId: 2441, code: "503218" },
    { id: 49721, cityId: 2441, code: "503221" },
    { id: 49722, cityId: 2441, code: "503224" },
    { id: 49723, cityId: 2441, code: "503226" },
    { id: 49724, cityId: 2441, code: "503245" },
    { id: 49725, cityId: 2441, code: "503305" },
    { id: 49726, cityId: 2441, code: "503306" },
    { id: 49727, cityId: 2441, code: "503308" },
    { id: 49728, cityId: 2441, code: "503311" },
    { id: 49729, cityId: 2441, code: "503313" },
    { id: 49730, cityId: 2441, code: "503314" },
    { id: 49731, cityId: 2441, code: "503321" },
    { id: 49732, cityId: 2441, code: "521206" },
    { id: 49733, cityId: 2441, code: "503002" },
    { id: 49734, cityId: 2441, code: "503103" },
    { id: 49735, cityId: 2441, code: "503111" },
    { id: 49736, cityId: 2441, code: "503114" },
    { id: 49737, cityId: 2441, code: "503122" },
    { id: 49738, cityId: 2441, code: "503124" },
    { id: 49739, cityId: 2441, code: "503145" },
    { id: 49740, cityId: 2441, code: "503164" },
    { id: 49741, cityId: 2441, code: "503166" },
    { id: 49742, cityId: 2441, code: "503174" },
    { id: 49743, cityId: 2441, code: "503175" },
    { id: 49744, cityId: 2441, code: "503177" },
    { id: 49745, cityId: 2441, code: "503180" },
    { id: 49746, cityId: 2441, code: "503185" },
    { id: 49747, cityId: 2441, code: "503188" },
    { id: 49748, cityId: 2441, code: "503193" },
    { id: 49749, cityId: 2441, code: "503201" },
    { id: 49750, cityId: 2441, code: "503203" },
    { id: 49751, cityId: 2441, code: "503206" },
    { id: 49752, cityId: 2441, code: "503212" },
    { id: 49753, cityId: 2441, code: "503214" },
    { id: 49754, cityId: 2441, code: "503219" },
    { id: 49755, cityId: 2441, code: "503220" },
    { id: 49756, cityId: 2441, code: "503222" },
    { id: 49757, cityId: 2441, code: "503225" },
    { id: 49758, cityId: 2441, code: "503227" },
    { id: 49759, cityId: 2441, code: "503228" },
    { id: 49760, cityId: 2441, code: "503230" },
    { id: 49761, cityId: 2441, code: "503235" },
    { id: 49762, cityId: 2441, code: "503236" },
    { id: 49763, cityId: 2441, code: "503246" },
    { id: 49764, cityId: 2441, code: "503301" },
    { id: 49765, cityId: 2441, code: "503302" },
    { id: 49766, cityId: 2441, code: "503307" },
    { id: 49767, cityId: 2441, code: "503309" },
    { id: 49768, cityId: 2441, code: "503310" },
    { id: 49769, cityId: 2441, code: "503315" },
    { id: 49770, cityId: 2442, code: "231219" },
    { id: 49771, cityId: 2443, code: "285001" },
    { id: 49772, cityId: 2444, code: "271206" },
    { id: 49773, cityId: 2445, code: "274304" },
    { id: 49774, cityId: 2446, code: "202396" },
    { id: 49775, cityId: 2447, code: "241123" },
    { id: 49776, cityId: 2447, code: "306021" },
    { id: 49777, cityId: 2447, code: "306024" },
    { id: 49778, cityId: 2447, code: "306026" },
    { id: 49779, cityId: 2447, code: "306027" },
    { id: 49780, cityId: 2447, code: "306101" },
    { id: 49781, cityId: 2447, code: "306103" },
    { id: 49782, cityId: 2447, code: "306106" },
    { id: 49783, cityId: 2447, code: "306108" },
    { id: 49784, cityId: 2447, code: "306114" },
    { id: 49785, cityId: 2447, code: "306116" },
    { id: 49786, cityId: 2447, code: "306117" },
    { id: 49787, cityId: 2447, code: "306119" },
    { id: 49788, cityId: 2447, code: "306127" },
    { id: 49789, cityId: 2447, code: "306302" },
    { id: 49790, cityId: 2447, code: "306304" },
    { id: 49791, cityId: 2447, code: "306305" },
    { id: 49792, cityId: 2447, code: "306307" },
    { id: 49793, cityId: 2447, code: "306310" },
    { id: 49794, cityId: 2447, code: "306421" },
    { id: 49795, cityId: 2447, code: "306501" },
    { id: 49796, cityId: 2447, code: "306503" },
    { id: 49797, cityId: 2447, code: "306601" },
    { id: 49798, cityId: 2447, code: "306704" },
    { id: 49799, cityId: 2447, code: "306705" },
    { id: 49800, cityId: 2447, code: "306707" },
    { id: 49801, cityId: 2447, code: "306710" },
    { id: 49802, cityId: 2447, code: "306901" },
    { id: 49803, cityId: 2447, code: "306001" },
    { id: 49804, cityId: 2447, code: "306022" },
    { id: 49805, cityId: 2447, code: "306023" },
    { id: 49806, cityId: 2447, code: "306025" },
    { id: 49807, cityId: 2447, code: "306028" },
    { id: 49808, cityId: 2447, code: "306102" },
    { id: 49809, cityId: 2447, code: "306104" },
    { id: 49810, cityId: 2447, code: "306107" },
    { id: 49811, cityId: 2447, code: "306115" },
    { id: 49812, cityId: 2447, code: "306118" },
    { id: 49813, cityId: 2447, code: "306126" },
    { id: 49814, cityId: 2447, code: "306128" },
    { id: 49815, cityId: 2447, code: "306301" },
    { id: 49816, cityId: 2447, code: "306303" },
    { id: 49817, cityId: 2447, code: "306306" },
    { id: 49818, cityId: 2447, code: "306308" },
    { id: 49819, cityId: 2447, code: "306309" },
    { id: 49820, cityId: 2447, code: "306401" },
    { id: 49821, cityId: 2447, code: "306502" },
    { id: 49822, cityId: 2447, code: "306504" },
    { id: 49823, cityId: 2447, code: "306505" },
    { id: 49824, cityId: 2447, code: "306602" },
    { id: 49825, cityId: 2447, code: "306603" },
    { id: 49826, cityId: 2447, code: "306701" },
    { id: 49827, cityId: 2447, code: "306703" },
    { id: 49828, cityId: 2447, code: "306706" },
    { id: 49829, cityId: 2447, code: "306708" },
    { id: 49830, cityId: 2447, code: "306709" },
    { id: 49831, cityId: 2447, code: "306902" },
    { id: 49832, cityId: 2447, code: "410205" },
    { id: 49833, cityId: 2448, code: "230135" },
    { id: 49834, cityId: 2448, code: "143416" },
    { id: 49835, cityId: 2449, code: "212402" },
    { id: 49836, cityId: 2449, code: "221205" },
    { id: 49837, cityId: 2449, code: "276304" },
    { id: 49838, cityId: 2450, code: "241406" },
    { id: 49839, cityId: 2451, code: "262121" },
    { id: 49840, cityId: 2451, code: "262123" },
    { id: 49841, cityId: 2451, code: "262201" },
    { id: 49842, cityId: 2451, code: "262301" },
    { id: 49843, cityId: 2451, code: "262302" },
    { id: 49844, cityId: 2451, code: "262001" },
    { id: 49845, cityId: 2451, code: "262122" },
    { id: 49846, cityId: 2451, code: "262305" },
    { id: 49847, cityId: 2452, code: "202120" },
    { id: 49848, cityId: 2453, code: "245304" },
    { id: 49849, cityId: 2454, code: "283123" },
    { id: 49850, cityId: 2455, code: "229407" },
    { id: 49851, cityId: 2455, code: "229408" },
    { id: 49852, cityId: 2455, code: "229410" },
    { id: 49853, cityId: 2455, code: "229415" },
    { id: 49854, cityId: 2455, code: "229416" },
    { id: 49855, cityId: 2455, code: "230001" },
    { id: 49856, cityId: 2455, code: "230122" },
    { id: 49857, cityId: 2455, code: "230123" },
    { id: 49858, cityId: 2455, code: "230125" },
    { id: 49859, cityId: 2455, code: "230128" },
    { id: 49860, cityId: 2455, code: "230130" },
    { id: 49861, cityId: 2455, code: "230133" },
    { id: 49862, cityId: 2455, code: "230136" },
    { id: 49863, cityId: 2455, code: "230138" },
    { id: 49864, cityId: 2455, code: "230139" },
    { id: 49865, cityId: 2455, code: "230141" },
    { id: 49866, cityId: 2455, code: "230144" },
    { id: 49867, cityId: 2455, code: "230303" },
    { id: 49868, cityId: 2455, code: "230305" },
    { id: 49869, cityId: 2455, code: "230306" },
    { id: 49870, cityId: 2455, code: "230401" },
    { id: 49871, cityId: 2455, code: "230404" },
    { id: 49872, cityId: 2455, code: "230406" },
    { id: 49873, cityId: 2455, code: "230502" },
    { id: 49874, cityId: 2455, code: "229406" },
    { id: 49875, cityId: 2455, code: "229414" },
    { id: 49876, cityId: 2455, code: "229417" },
    { id: 49877, cityId: 2455, code: "229419" },
    { id: 49878, cityId: 2455, code: "230124" },
    { id: 49879, cityId: 2455, code: "230126" },
    { id: 49880, cityId: 2455, code: "230127" },
    { id: 49881, cityId: 2455, code: "230129" },
    { id: 49882, cityId: 2455, code: "230134" },
    { id: 49883, cityId: 2455, code: "230137" },
    { id: 49884, cityId: 2455, code: "230140" },
    { id: 49885, cityId: 2455, code: "230142" },
    { id: 49886, cityId: 2455, code: "230143" },
    { id: 49887, cityId: 2455, code: "230145" },
    { id: 49888, cityId: 2455, code: "230301" },
    { id: 49889, cityId: 2455, code: "230302" },
    { id: 49890, cityId: 2455, code: "230304" },
    { id: 49891, cityId: 2455, code: "230402" },
    { id: 49892, cityId: 2455, code: "230405" },
    { id: 49893, cityId: 2455, code: "230503" },
    { id: 49894, cityId: 2456, code: "230002" },
    { id: 49895, cityId: 2457, code: "209111" },
    { id: 49896, cityId: 2458, code: "262122" },
    { id: 49897, cityId: 2459, code: "209825" },
    { id: 49898, cityId: 2460, code: "281504" },
    { id: 49899, cityId: 2461, code: "229001" },
    { id: 49900, cityId: 2462, code: "229122" },
    { id: 49901, cityId: 2462, code: "229125" },
    { id: 49902, cityId: 2462, code: "229128" },
    { id: 49903, cityId: 2462, code: "229130" },
    { id: 49904, cityId: 2462, code: "229201" },
    { id: 49905, cityId: 2462, code: "229202" },
    { id: 49906, cityId: 2462, code: "229204" },
    { id: 49907, cityId: 2462, code: "229207" },
    { id: 49908, cityId: 2462, code: "229209" },
    { id: 49909, cityId: 2462, code: "229212" },
    { id: 49910, cityId: 2462, code: "229215" },
    { id: 49911, cityId: 2462, code: "229302" },
    { id: 49912, cityId: 2462, code: "229307" },
    { id: 49913, cityId: 2462, code: "229308" },
    { id: 49914, cityId: 2462, code: "229310" },
    { id: 49915, cityId: 2462, code: "229403" },
    { id: 49916, cityId: 2462, code: "230131" },
    { id: 49917, cityId: 2462, code: "229001" },
    { id: 49918, cityId: 2462, code: "229010" },
    { id: 49919, cityId: 2462, code: "229121" },
    { id: 49920, cityId: 2462, code: "229123" },
    { id: 49921, cityId: 2462, code: "229124" },
    { id: 49922, cityId: 2462, code: "229126" },
    { id: 49923, cityId: 2462, code: "229129" },
    { id: 49924, cityId: 2462, code: "229205" },
    { id: 49925, cityId: 2462, code: "229208" },
    { id: 49926, cityId: 2462, code: "229211" },
    { id: 49927, cityId: 2462, code: "229216" },
    { id: 49928, cityId: 2462, code: "229303" },
    { id: 49929, cityId: 2462, code: "229304" },
    { id: 49930, cityId: 2462, code: "229309" },
    { id: 49931, cityId: 2462, code: "229311" },
    { id: 49932, cityId: 2462, code: "229402" },
    { id: 49933, cityId: 2462, code: "229404" },
    { id: 49934, cityId: 2462, code: "229405" },
    { id: 49935, cityId: 2463, code: "210205" },
    { id: 49936, cityId: 2463, code: "211002" },
    { id: 49937, cityId: 2463, code: "282002" },
    { id: 49938, cityId: 2463, code: "416702" },
    { id: 49939, cityId: 2464, code: "274305" },
    { id: 49940, cityId: 2465, code: "224181" },
    { id: 49941, cityId: 2465, code: "250002" },
    { id: 49942, cityId: 2465, code: "712411" },
    { id: 49943, cityId: 2465, code: "201009" },
    { id: 49944, cityId: 2465, code: "221008" },
    { id: 49945, cityId: 2465, code: "243303" },
    { id: 49946, cityId: 2465, code: "247667" },
    { id: 49947, cityId: 2465, code: "721441" },
    { id: 49948, cityId: 2466, code: "175042" },
    { id: 49949, cityId: 2466, code: "233223" },
    { id: 49950, cityId: 2466, code: "244901" },
    { id: 49951, cityId: 2466, code: "261204" },
    { id: 49952, cityId: 2466, code: "274405" },
    { id: 49953, cityId: 2466, code: "222203" },
    { id: 49954, cityId: 2467, code: "285127" },
    { id: 49955, cityId: 2468, code: "211002" },
    { id: 49956, cityId: 2468, code: "284205" },
    { id: 49957, cityId: 2469, code: "221712" },
    { id: 49958, cityId: 2470, code: "209306" },
    { id: 49959, cityId: 2470, code: "224172" },
    { id: 49960, cityId: 2471, code: "281204" },
    { id: 49961, cityId: 2472, code: "277209" },
    { id: 49962, cityId: 2473, code: "242315" },
    { id: 49963, cityId: 2473, code: "274204" },
    { id: 49964, cityId: 2473, code: "263153" },
    { id: 49965, cityId: 2473, code: "263154" },
    { id: 49966, cityId: 2474, code: "209303" },
    { id: 49967, cityId: 2475, code: "281306" },
    { id: 49968, cityId: 2476, code: "275204" },
    { id: 49969, cityId: 2477, code: "241504" },
    { id: 49970, cityId: 2478, code: "246749" },
    { id: 49971, cityId: 2479, code: "247001" },
    { id: 49972, cityId: 2479, code: "247002" },
    { id: 49973, cityId: 2479, code: "247121" },
    { id: 49974, cityId: 2479, code: "247129" },
    { id: 49975, cityId: 2479, code: "247232" },
    { id: 49976, cityId: 2479, code: "247343" },
    { id: 49977, cityId: 2479, code: "247656" },
    { id: 49978, cityId: 2479, code: "247661" },
    { id: 49979, cityId: 2479, code: "247664" },
    { id: 49980, cityId: 2479, code: "247667" },
    { id: 49981, cityId: 2479, code: "247669" },
    { id: 49982, cityId: 2479, code: "247672" },
    { id: 49983, cityId: 2479, code: "249404" },
    { id: 49984, cityId: 2479, code: "249407" },
    { id: 49985, cityId: 2479, code: "249409" },
    { id: 49986, cityId: 2479, code: "247111" },
    { id: 49987, cityId: 2479, code: "247120" },
    { id: 49988, cityId: 2479, code: "247122" },
    { id: 49989, cityId: 2479, code: "247231" },
    { id: 49990, cityId: 2479, code: "247451" },
    { id: 49991, cityId: 2479, code: "247453" },
    { id: 49992, cityId: 2479, code: "247551" },
    { id: 49993, cityId: 2479, code: "247554" },
    { id: 49994, cityId: 2479, code: "247662" },
    { id: 49995, cityId: 2479, code: "247663" },
    { id: 49996, cityId: 2479, code: "247665" },
    { id: 49997, cityId: 2479, code: "247668" },
    { id: 49998, cityId: 2479, code: "247670" },
    { id: 49999, cityId: 2479, code: "247671" },
    { id: 50000, cityId: 2479, code: "247673" },
    { id: 50001, cityId: 2479, code: "249402" },
    { id: 50002, cityId: 2479, code: "249403" },
    { id: 50003, cityId: 2479, code: "249405" },
    { id: 50004, cityId: 2479, code: "249408" },
    { id: 50005, cityId: 2479, code: "249410" },
    { id: 50006, cityId: 2480, code: "246745" },
    { id: 50007, cityId: 2481, code: "243638" },
    { id: 50008, cityId: 2482, code: "277211" },
    { id: 50009, cityId: 2483, code: "207245" },
    { id: 50010, cityId: 2484, code: "272209" },
    { id: 50011, cityId: 2485, code: "245411" },
    { id: 50012, cityId: 2485, code: "202525" },
    { id: 50013, cityId: 2486, code: "274509" },
    { id: 50014, cityId: 2487, code: "229127" },
    { id: 50015, cityId: 2488, code: "244302" },
    { id: 50016, cityId: 2489, code: "284304" },
    { id: 50017, cityId: 2490, code: "241403" },
    { id: 50018, cityId: 2491, code: "241204" },
    { id: 50019, cityId: 2492, code: "276305" },
    { id: 50020, cityId: 2493, code: "204216" },
    { id: 50021, cityId: 2494, code: "225122" },
    { id: 50022, cityId: 2495, code: "209728" },
    { id: 50023, cityId: 2496, code: "246746" },
    { id: 50024, cityId: 2497, code: "585228" },
    { id: 50025, cityId: 2497, code: "241124" },
    { id: 50026, cityId: 2497, code: "244922" },
    { id: 50027, cityId: 2498, code: "223101" },
    { id: 50028, cityId: 2498, code: "282002" },
    { id: 50029, cityId: 2498, code: "224184" },
    { id: 50030, cityId: 2499, code: "243505" },
    { id: 50031, cityId: 2500, code: "242101" },
    { id: 50032, cityId: 2500, code: "242103" },
    { id: 50033, cityId: 2500, code: "242223" },
    { id: 50034, cityId: 2500, code: "242225" },
    { id: 50035, cityId: 2500, code: "242228" },
    { id: 50036, cityId: 2500, code: "242230" },
    { id: 50037, cityId: 2500, code: "242231" },
    { id: 50038, cityId: 2500, code: "242302" },
    { id: 50039, cityId: 2500, code: "242307" },
    { id: 50040, cityId: 2500, code: "242310" },
    { id: 50041, cityId: 2500, code: "242312" },
    { id: 50042, cityId: 2500, code: "242313" },
    { id: 50043, cityId: 2500, code: "242408" },
    { id: 50044, cityId: 2500, code: "242410" },
    { id: 50045, cityId: 2500, code: "242411" },
    { id: 50046, cityId: 2500, code: "242413" },
    { id: 50047, cityId: 2500, code: "242416" },
    { id: 50048, cityId: 2500, code: "242418" },
    { id: 50049, cityId: 2500, code: "242419" },
    { id: 50050, cityId: 2500, code: "242421" },
    { id: 50051, cityId: 2500, code: "242001" },
    { id: 50052, cityId: 2500, code: "242102" },
    { id: 50053, cityId: 2500, code: "242221" },
    { id: 50054, cityId: 2500, code: "242226" },
    { id: 50055, cityId: 2500, code: "242227" },
    { id: 50056, cityId: 2500, code: "242229" },
    { id: 50057, cityId: 2500, code: "242232" },
    { id: 50058, cityId: 2500, code: "242234" },
    { id: 50059, cityId: 2500, code: "242301" },
    { id: 50060, cityId: 2500, code: "242303" },
    { id: 50061, cityId: 2500, code: "242306" },
    { id: 50062, cityId: 2500, code: "242309" },
    { id: 50063, cityId: 2500, code: "242311" },
    { id: 50064, cityId: 2500, code: "242314" },
    { id: 50065, cityId: 2500, code: "242401" },
    { id: 50066, cityId: 2500, code: "242406" },
    { id: 50067, cityId: 2500, code: "242407" },
    { id: 50068, cityId: 2500, code: "242409" },
    { id: 50069, cityId: 2500, code: "242415" },
    { id: 50070, cityId: 2500, code: "242417" },
    { id: 50071, cityId: 2500, code: "242420" },
    { id: 50072, cityId: 2500, code: "242473" },
    { id: 50073, cityId: 2501, code: "251318" },
    { id: 50074, cityId: 2501, code: "577401" },
    { id: 50075, cityId: 2501, code: "585319" },
    { id: 50076, cityId: 2501, code: "585375" },
    { id: 50077, cityId: 2501, code: "586129" },
    { id: 50078, cityId: 2501, code: "585273" },
    { id: 50079, cityId: 2502, code: "247776" },
    { id: 50080, cityId: 2503, code: "212108" },
    { id: 50081, cityId: 2504, code: "281404" },
    { id: 50082, cityId: 2505, code: "246747" },
    { id: 50083, cityId: 2506, code: "202395" },
    { id: 50084, cityId: 2506, code: "572166" },
    { id: 50085, cityId: 2507, code: "205135" },
    { id: 50086, cityId: 2508, code: "271871" },
    { id: 50087, cityId: 2509, code: "272192" },
    { id: 50088, cityId: 2509, code: "272203" },
    { id: 50089, cityId: 2509, code: "272189" },
    { id: 50090, cityId: 2510, code: "209729" },
    { id: 50091, cityId: 2510, code: "224186" },
    { id: 50092, cityId: 2510, code: "277303" },
    { id: 50093, cityId: 2511, code: "212109" },
    { id: 50094, cityId: 2512, code: "262805" },
    { id: 50095, cityId: 2512, code: "203205" },
    { id: 50096, cityId: 2513, code: "212217" },
    { id: 50097, cityId: 2514, code: "205151" },
    { id: 50098, cityId: 2515, code: "244301" },
    { id: 50099, cityId: 2515, code: "585258" },
    { id: 50100, cityId: 2516, code: "251319" },
    { id: 50101, cityId: 2517, code: "261121" },
    { id: 50102, cityId: 2517, code: "261145" },
    { id: 50103, cityId: 2517, code: "261151" },
    { id: 50104, cityId: 2517, code: "261203" },
    { id: 50105, cityId: 2517, code: "261301" },
    { id: 50106, cityId: 2517, code: "261302" },
    { id: 50107, cityId: 2517, code: "261402" },
    { id: 50108, cityId: 2517, code: "261405" },
    { id: 50109, cityId: 2517, code: "261001" },
    { id: 50110, cityId: 2517, code: "261125" },
    { id: 50111, cityId: 2517, code: "261136" },
    { id: 50112, cityId: 2517, code: "261205" },
    { id: 50113, cityId: 2517, code: "261207" },
    { id: 50114, cityId: 2517, code: "261208" },
    { id: 50115, cityId: 2517, code: "261303" },
    { id: 50116, cityId: 2517, code: "261401" },
    { id: 50117, cityId: 2517, code: "261501" },
    { id: 50118, cityId: 2518, code: "231212" },
    { id: 50119, cityId: 2519, code: "244924" },
    { id: 50120, cityId: 2520, code: "222302" },
    { id: 50121, cityId: 2520, code: "222303" },
    { id: 50122, cityId: 2520, code: "227407" },
    { id: 50123, cityId: 2520, code: "227408" },
    { id: 50124, cityId: 2520, code: "227802" },
    { id: 50125, cityId: 2520, code: "227807" },
    { id: 50126, cityId: 2520, code: "227815" },
    { id: 50127, cityId: 2520, code: "228001" },
    { id: 50128, cityId: 2520, code: "228125" },
    { id: 50129, cityId: 2520, code: "228133" },
    { id: 50130, cityId: 2520, code: "228141" },
    { id: 50131, cityId: 2520, code: "228159" },
    { id: 50132, cityId: 2520, code: "222301" },
    { id: 50133, cityId: 2520, code: "222304" },
    { id: 50134, cityId: 2520, code: "227406" },
    { id: 50135, cityId: 2520, code: "227409" },
    { id: 50136, cityId: 2520, code: "227411" },
    { id: 50137, cityId: 2520, code: "227412" },
    { id: 50138, cityId: 2520, code: "227801" },
    { id: 50139, cityId: 2520, code: "227806" },
    { id: 50140, cityId: 2520, code: "227809" },
    { id: 50141, cityId: 2520, code: "227811" },
    { id: 50142, cityId: 2520, code: "227812" },
    { id: 50143, cityId: 2520, code: "227814" },
    { id: 50144, cityId: 2520, code: "227816" },
    { id: 50145, cityId: 2520, code: "227817" },
    { id: 50146, cityId: 2520, code: "228118" },
    { id: 50147, cityId: 2520, code: "228119" },
    { id: 50148, cityId: 2520, code: "228121" },
    { id: 50149, cityId: 2520, code: "228124" },
    { id: 50150, cityId: 2520, code: "228132" },
    { id: 50151, cityId: 2520, code: "228151" },
    { id: 50152, cityId: 2520, code: "228155" },
    { id: 50153, cityId: 2520, code: "228161" },
    { id: 50154, cityId: 2520, code: "228171" },
    { id: 50155, cityId: 2520, code: "228820" },
    { id: 50156, cityId: 2520, code: "262125" },
    { id: 50157, cityId: 2520, code: "464986" },
    { id: 50158, cityId: 2521, code: "221404" },
    { id: 50159, cityId: 2522, code: "234126" },
    { id: 50160, cityId: 2523, code: "209731" },
    { id: 50161, cityId: 2524, code: "224190" },
    { id: 50162, cityId: 2524, code: "244925" },
    { id: 50163, cityId: 2525, code: "272207" },
    { id: 50164, cityId: 2526, code: "244601" },
    { id: 50165, cityId: 2527, code: "247777" },
    { id: 50166, cityId: 2528, code: "242307" },
    { id: 50167, cityId: 2529, code: "210128" },
    { id: 50168, cityId: 2530, code: "271208" },
    { id: 50169, cityId: 2531, code: "283204" },
    { id: 50170, cityId: 2532, code: "243639" },
    { id: 50171, cityId: 2533, code: "244242" },
    { id: 50172, cityId: 2534, code: "285129" },
    { id: 50173, cityId: 2535, code: "385560" },
    { id: 50174, cityId: 2535, code: "247778" },
    { id: 50175, cityId: 2536, code: "209801" },
    { id: 50176, cityId: 2536, code: "209841" },
    { id: 50177, cityId: 2536, code: "229503" },
    { id: 50178, cityId: 2536, code: "241503" },
    { id: 50179, cityId: 2536, code: "209821" },
    { id: 50180, cityId: 2536, code: "229504" },
    { id: 50181, cityId: 2536, code: "241502" },
    { id: 50182, cityId: 2537, code: "243621" },
    { id: 50183, cityId: 2538, code: "243641" },
    { id: 50184, cityId: 2539, code: "271604" },
    { id: 50185, cityId: 2540, code: "221002" },
    { id: 50186, cityId: 2540, code: "221004" },
    { id: 50187, cityId: 2540, code: "221005" },
    { id: 50188, cityId: 2540, code: "221007" },
    { id: 50189, cityId: 2540, code: "221010" },
    { id: 50190, cityId: 2540, code: "221102" },
    { id: 50191, cityId: 2540, code: "221103" },
    { id: 50192, cityId: 2540, code: "221105" },
    { id: 50193, cityId: 2540, code: "221108" },
    { id: 50194, cityId: 2540, code: "221110" },
    { id: 50195, cityId: 2540, code: "221111" },
    { id: 50196, cityId: 2540, code: "221113" },
    { id: 50197, cityId: 2540, code: "221131" },
    { id: 50198, cityId: 2540, code: "221201" },
    { id: 50199, cityId: 2540, code: "221206" },
    { id: 50200, cityId: 2540, code: "221208" },
    { id: 50201, cityId: 2540, code: "221209" },
    { id: 50202, cityId: 2540, code: "221211" },
    { id: 50203, cityId: 2540, code: "221301" },
    { id: 50204, cityId: 2540, code: "221307" },
    { id: 50205, cityId: 2540, code: "221309" },
    { id: 50206, cityId: 2540, code: "221312" },
    { id: 50207, cityId: 2540, code: "221314" },
    { id: 50208, cityId: 2540, code: "221402" },
    { id: 50209, cityId: 2540, code: "221405" },
    { id: 50210, cityId: 2540, code: "221407" },
    { id: 50211, cityId: 2540, code: "232101" },
    { id: 50212, cityId: 2540, code: "232106" },
    { id: 50213, cityId: 2540, code: "232109" },
    { id: 50214, cityId: 2540, code: "232111" },
    { id: 50215, cityId: 2540, code: "232112" },
    { id: 50216, cityId: 2540, code: "232114" },
    { id: 50217, cityId: 2540, code: "232119" },
    { id: 50218, cityId: 2540, code: "232120" },
    { id: 50219, cityId: 2540, code: "221001" },
    { id: 50220, cityId: 2540, code: "221003" },
    { id: 50221, cityId: 2540, code: "221006" },
    { id: 50222, cityId: 2540, code: "221008" },
    { id: 50223, cityId: 2540, code: "221101" },
    { id: 50224, cityId: 2540, code: "221104" },
    { id: 50225, cityId: 2540, code: "221106" },
    { id: 50226, cityId: 2540, code: "221107" },
    { id: 50227, cityId: 2540, code: "221109" },
    { id: 50228, cityId: 2540, code: "221112" },
    { id: 50229, cityId: 2540, code: "221115" },
    { id: 50230, cityId: 2540, code: "221202" },
    { id: 50231, cityId: 2540, code: "221207" },
    { id: 50232, cityId: 2540, code: "221210" },
    { id: 50233, cityId: 2540, code: "221305" },
    { id: 50234, cityId: 2540, code: "221308" },
    { id: 50235, cityId: 2540, code: "221310" },
    { id: 50236, cityId: 2540, code: "221311" },
    { id: 50237, cityId: 2540, code: "221403" },
    { id: 50238, cityId: 2540, code: "221406" },
    { id: 50239, cityId: 2540, code: "221408" },
    { id: 50240, cityId: 2540, code: "232107" },
    { id: 50241, cityId: 2540, code: "232108" },
    { id: 50242, cityId: 2540, code: "232110" },
    { id: 50243, cityId: 2540, code: "232113" },
    { id: 50244, cityId: 2540, code: "232116" },
    { id: 50245, cityId: 2540, code: "232118" },
    { id: 50246, cityId: 2540, code: "244225" },
    { id: 50247, cityId: 2541, code: "202526" },
    { id: 50248, cityId: 2541, code: "226001" },
    { id: 50249, cityId: 2541, code: "271124" },
    { id: 50250, cityId: 2542, code: "225414" },
    { id: 50251, cityId: 2543, code: "232329" },
    { id: 50252, cityId: 2544, code: "246188" },
    { id: 50253, cityId: 2545, code: "246440" },
    { id: 50254, cityId: 2546, code: "246421" },
    { id: 50255, cityId: 2547, code: "263621" },
    { id: 50256, cityId: 2547, code: "263622" },
    { id: 50257, cityId: 2547, code: "263624" },
    { id: 50258, cityId: 2547, code: "263626" },
    { id: 50259, cityId: 2547, code: "263632" },
    { id: 50260, cityId: 2547, code: "263634" },
    { id: 50261, cityId: 2547, code: "263635" },
    { id: 50262, cityId: 2547, code: "263640" },
    { id: 50263, cityId: 2547, code: "263643" },
    { id: 50264, cityId: 2547, code: "263645" },
    { id: 50265, cityId: 2547, code: "263648" },
    { id: 50266, cityId: 2547, code: "263651" },
    { id: 50267, cityId: 2547, code: "263656" },
    { id: 50268, cityId: 2547, code: "263658" },
    { id: 50269, cityId: 2547, code: "263659" },
    { id: 50270, cityId: 2547, code: "263661" },
    { id: 50271, cityId: 2547, code: "263664" },
    { id: 50272, cityId: 2547, code: "263667" },
    { id: 50273, cityId: 2547, code: "263669" },
    { id: 50274, cityId: 2547, code: "263677" },
    { id: 50275, cityId: 2547, code: "263679" },
    { id: 50276, cityId: 2547, code: "263680" },
    { id: 50277, cityId: 2547, code: "263682" },
    { id: 50278, cityId: 2547, code: "263685" },
    { id: 50279, cityId: 2547, code: "263687" },
    { id: 50280, cityId: 2547, code: "263688" },
    { id: 50281, cityId: 2547, code: "244711" },
    { id: 50282, cityId: 2547, code: "263601" },
    { id: 50283, cityId: 2547, code: "263610" },
    { id: 50284, cityId: 2547, code: "263623" },
    { id: 50285, cityId: 2547, code: "263625" },
    { id: 50286, cityId: 2547, code: "263628" },
    { id: 50287, cityId: 2547, code: "263630" },
    { id: 50288, cityId: 2547, code: "263631" },
    { id: 50289, cityId: 2547, code: "263633" },
    { id: 50290, cityId: 2547, code: "263636" },
    { id: 50291, cityId: 2547, code: "263638" },
    { id: 50292, cityId: 2547, code: "263641" },
    { id: 50293, cityId: 2547, code: "263646" },
    { id: 50294, cityId: 2547, code: "263647" },
    { id: 50295, cityId: 2547, code: "263652" },
    { id: 50296, cityId: 2547, code: "263654" },
    { id: 50297, cityId: 2547, code: "263660" },
    { id: 50298, cityId: 2547, code: "263662" },
    { id: 50299, cityId: 2547, code: "263663" },
    { id: 50300, cityId: 2547, code: "263665" },
    { id: 50301, cityId: 2547, code: "263670" },
    { id: 50302, cityId: 2547, code: "263671" },
    { id: 50303, cityId: 2547, code: "263675" },
    { id: 50304, cityId: 2547, code: "263676" },
    { id: 50305, cityId: 2547, code: "263678" },
    { id: 50306, cityId: 2547, code: "263681" },
    { id: 50307, cityId: 2547, code: "263683" },
    { id: 50308, cityId: 2547, code: "263684" },
    { id: 50309, cityId: 2547, code: "263686" },
    { id: 50310, cityId: 2547, code: "263689" },
    { id: 50311, cityId: 2548, code: "246422" },
    { id: 50312, cityId: 2549, code: "263632" },
    { id: 50313, cityId: 2549, code: "263642" },
    { id: 50314, cityId: 2550, code: "263136" },
    { id: 50315, cityId: 2551, code: "246121" },
    { id: 50316, cityId: 2552, code: "263131" },
    { id: 50317, cityId: 2552, code: "263132" },
    { id: 50318, cityId: 2553, code: "261405" },
    { id: 50319, cityId: 2554, code: "246130" },
    { id: 50320, cityId: 2555, code: "248123" },
    { id: 50321, cityId: 2556, code: "246424" },
    { id: 50322, cityId: 2557, code: "262523" },
    { id: 50323, cityId: 2557, code: "262309" },
    { id: 50324, cityId: 2558, code: "246122" },
    { id: 50325, cityId: 2559, code: "246123" },
    { id: 50326, cityId: 2560, code: "246125" },
    { id: 50327, cityId: 2561, code: "248002" },
    { id: 50328, cityId: 2561, code: "248005" },
    { id: 50329, cityId: 2561, code: "248007" },
    { id: 50330, cityId: 2561, code: "248102" },
    { id: 50331, cityId: 2561, code: "248110" },
    { id: 50332, cityId: 2561, code: "248116" },
    { id: 50333, cityId: 2561, code: "248119" },
    { id: 50334, cityId: 2561, code: "248121" },
    { id: 50335, cityId: 2561, code: "248124" },
    { id: 50336, cityId: 2561, code: "248145" },
    { id: 50337, cityId: 2561, code: "248147" },
    { id: 50338, cityId: 2561, code: "248148" },
    { id: 50339, cityId: 2561, code: "248161" },
    { id: 50340, cityId: 2561, code: "248164" },
    { id: 50341, cityId: 2561, code: "248171" },
    { id: 50342, cityId: 2561, code: "248195" },
    { id: 50343, cityId: 2561, code: "248201" },
    { id: 50344, cityId: 2561, code: "248203" },
    { id: 50345, cityId: 2561, code: "249202" },
    { id: 50346, cityId: 2561, code: "249204" },
    { id: 50347, cityId: 2561, code: "248001" },
    { id: 50348, cityId: 2561, code: "248003" },
    { id: 50349, cityId: 2561, code: "248006" },
    { id: 50350, cityId: 2561, code: "248008" },
    { id: 50351, cityId: 2561, code: "248009" },
    { id: 50352, cityId: 2561, code: "248115" },
    { id: 50353, cityId: 2561, code: "248122" },
    { id: 50354, cityId: 2561, code: "248125" },
    { id: 50355, cityId: 2561, code: "248141" },
    { id: 50356, cityId: 2561, code: "248143" },
    { id: 50357, cityId: 2561, code: "248144" },
    { id: 50358, cityId: 2561, code: "248146" },
    { id: 50359, cityId: 2561, code: "248152" },
    { id: 50360, cityId: 2561, code: "248159" },
    { id: 50361, cityId: 2561, code: "248160" },
    { id: 50362, cityId: 2561, code: "248165" },
    { id: 50363, cityId: 2561, code: "248196" },
    { id: 50364, cityId: 2561, code: "248197" },
    { id: 50365, cityId: 2561, code: "248199" },
    { id: 50366, cityId: 2561, code: "248202" },
    { id: 50367, cityId: 2561, code: "248528" },
    { id: 50368, cityId: 2562, code: "246126" },
    { id: 50369, cityId: 2563, code: "262580" },
    { id: 50370, cityId: 2564, code: "246186" },
    { id: 50371, cityId: 2565, code: "249134" },
    { id: 50372, cityId: 2566, code: "262551" },
    { id: 50373, cityId: 2567, code: "263160" },
    { id: 50374, cityId: 2568, code: "248140" },
    { id: 50375, cityId: 2569, code: "246127" },
    { id: 50376, cityId: 2570, code: "246129" },
    { id: 50377, cityId: 2571, code: "263653" },
    { id: 50378, cityId: 2572, code: "246128" },
    { id: 50379, cityId: 2573, code: "246131" },
    { id: 50380, cityId: 2574, code: "263152" },
    { id: 50381, cityId: 2575, code: "246428" },
    { id: 50382, cityId: 2576, code: "246429" },
    { id: 50383, cityId: 2577, code: "263147" },
    { id: 50384, cityId: 2578, code: "246423" },
    { id: 50385, cityId: 2578, code: "246426" },
    { id: 50386, cityId: 2578, code: "246431" },
    { id: 50387, cityId: 2578, code: "246437" },
    { id: 50388, cityId: 2578, code: "246447" },
    { id: 50389, cityId: 2578, code: "246450" },
    { id: 50390, cityId: 2578, code: "246453" },
    { id: 50391, cityId: 2578, code: "246455" },
    { id: 50392, cityId: 2578, code: "246471" },
    { id: 50393, cityId: 2578, code: "246474" },
    { id: 50394, cityId: 2578, code: "246476" },
    { id: 50395, cityId: 2578, code: "246482" },
    { id: 50396, cityId: 2578, code: "246487" },
    { id: 50397, cityId: 2578, code: "246495" },
    { id: 50398, cityId: 2578, code: "246401" },
    { id: 50399, cityId: 2578, code: "246419" },
    { id: 50400, cityId: 2578, code: "246425" },
    { id: 50401, cityId: 2578, code: "246427" },
    { id: 50402, cityId: 2578, code: "246435" },
    { id: 50403, cityId: 2578, code: "246438" },
    { id: 50404, cityId: 2578, code: "246446" },
    { id: 50405, cityId: 2578, code: "246452" },
    { id: 50406, cityId: 2578, code: "246456" },
    { id: 50407, cityId: 2578, code: "246470" },
    { id: 50408, cityId: 2578, code: "246473" },
    { id: 50409, cityId: 2578, code: "246481" },
    { id: 50410, cityId: 2578, code: "246488" },
    { id: 50411, cityId: 2579, code: "246439" },
    { id: 50412, cityId: 2580, code: "246441" },
    { id: 50413, cityId: 2581, code: "263139" },
    { id: 50414, cityId: 2582, code: "248142" },
    { id: 50415, cityId: 2583, code: "246442" },
    { id: 50416, cityId: 2584, code: "264712" },
    { id: 50417, cityId: 2585, code: "246443" },
    { id: 50418, cityId: 2586, code: "263140" },
    { id: 50419, cityId: 2587, code: "246142" },
    { id: 50420, cityId: 2588, code: "246113" },
    { id: 50421, cityId: 2589, code: "246144" },
    { id: 50422, cityId: 2590, code: "246146" },
    { id: 50423, cityId: 2591, code: "246444" },
    { id: 50424, cityId: 2592, code: "244713" },
    { id: 50425, cityId: 2593, code: "263629" },
    { id: 50426, cityId: 2593, code: "263630" },
    { id: 50427, cityId: 2594, code: "262308" },
    { id: 50428, cityId: 2595, code: "246147" },
    { id: 50429, cityId: 2596, code: "263148" },
    { id: 50430, cityId: 2597, code: "246149" },
    { id: 50431, cityId: 2597, code: "246191" },
    { id: 50432, cityId: 2598, code: "246149" },
    { id: 50433, cityId: 2599, code: "246155" },
    { id: 50434, cityId: 2600, code: "262524" },
    { id: 50435, cityId: 2601, code: "246458" },
    { id: 50436, cityId: 2602, code: "246163" },
    { id: 50437, cityId: 2603, code: "262554" },
    { id: 50438, cityId: 2604, code: "248179" },
    { id: 50439, cityId: 2605, code: "246161" },
    { id: 50440, cityId: 2606, code: "244714" },
    { id: 50441, cityId: 2606, code: "244716" },
    { id: 50442, cityId: 2606, code: "244717" },
    { id: 50443, cityId: 2606, code: "262301" },
    { id: 50444, cityId: 2606, code: "262310" },
    { id: 50445, cityId: 2606, code: "262402" },
    { id: 50446, cityId: 2606, code: "262408" },
    { id: 50447, cityId: 2606, code: "263001" },
    { id: 50448, cityId: 2606, code: "263126" },
    { id: 50449, cityId: 2606, code: "263128" },
    { id: 50450, cityId: 2606, code: "263138" },
    { id: 50451, cityId: 2606, code: "263146" },
    { id: 50452, cityId: 2606, code: "263149" },
    { id: 50453, cityId: 2606, code: "263155" },
    { id: 50454, cityId: 2606, code: "263157" },
    { id: 50455, cityId: 2606, code: "246185" },
    { id: 50456, cityId: 2606, code: "262311" },
    { id: 50457, cityId: 2606, code: "262401" },
    { id: 50458, cityId: 2606, code: "262403" },
    { id: 50459, cityId: 2606, code: "263002" },
    { id: 50460, cityId: 2606, code: "263127" },
    { id: 50461, cityId: 2606, code: "263129" },
    { id: 50462, cityId: 2606, code: "263134" },
    { id: 50463, cityId: 2606, code: "263135" },
    { id: 50464, cityId: 2606, code: "263142" },
    { id: 50465, cityId: 2606, code: "263151" },
    { id: 50466, cityId: 2606, code: "263158" },
    { id: 50467, cityId: 2606, code: "263159" },
    { id: 50468, cityId: 2607, code: "246175" },
    { id: 50469, cityId: 2608, code: "246449" },
    { id: 50470, cityId: 2609, code: "246162" },
    { id: 50471, cityId: 2610, code: "246469" },
    { id: 50472, cityId: 2611, code: "246164" },
    { id: 50473, cityId: 2612, code: "246165" },
    { id: 50474, cityId: 2613, code: "263145" },
    { id: 50475, cityId: 2614, code: "246166" },
    { id: 50476, cityId: 2615, code: "246167" },
    { id: 50477, cityId: 2616, code: "246168" },
    { id: 50478, cityId: 2617, code: "246001" },
    { id: 50479, cityId: 2617, code: "246149" },
    { id: 50480, cityId: 2617, code: "246189" },
    { id: 50481, cityId: 2617, code: "246276" },
    { id: 50482, cityId: 2617, code: "246278" },
    { id: 50483, cityId: 2617, code: "246281" },
    { id: 50484, cityId: 2617, code: "246148" },
    { id: 50485, cityId: 2617, code: "246192" },
    { id: 50486, cityId: 2617, code: "246193" },
    { id: 50487, cityId: 2617, code: "246275" },
    { id: 50488, cityId: 2617, code: "246277" },
    { id: 50489, cityId: 2617, code: "246280" },
    { id: 50490, cityId: 2617, code: "246285" },
    { id: 50491, cityId: 2617, code: "249132" },
    { id: 50492, cityId: 2617, code: "249302" },
    { id: 50493, cityId: 2617, code: "249304" },
    { id: 50494, cityId: 2618, code: "246472" },
    { id: 50495, cityId: 2619, code: "262502" },
    { id: 50496, cityId: 2619, code: "262520" },
    { id: 50497, cityId: 2619, code: "262521" },
    { id: 50498, cityId: 2619, code: "262526" },
    { id: 50499, cityId: 2619, code: "262528" },
    { id: 50500, cityId: 2619, code: "262529" },
    { id: 50501, cityId: 2619, code: "262531" },
    { id: 50502, cityId: 2619, code: "262533" },
    { id: 50503, cityId: 2619, code: "262534" },
    { id: 50504, cityId: 2619, code: "262542" },
    { id: 50505, cityId: 2619, code: "262544" },
    { id: 50506, cityId: 2619, code: "262547" },
    { id: 50507, cityId: 2619, code: "262550" },
    { id: 50508, cityId: 2619, code: "262552" },
    { id: 50509, cityId: 2619, code: "262555" },
    { id: 50510, cityId: 2619, code: "262571" },
    { id: 50511, cityId: 2619, code: "262573" },
    { id: 50512, cityId: 2619, code: "262574" },
    { id: 50513, cityId: 2619, code: "262576" },
    { id: 50514, cityId: 2619, code: "262501" },
    { id: 50515, cityId: 2619, code: "262519" },
    { id: 50516, cityId: 2619, code: "262522" },
    { id: 50517, cityId: 2619, code: "262525" },
    { id: 50518, cityId: 2619, code: "262527" },
    { id: 50519, cityId: 2619, code: "262530" },
    { id: 50520, cityId: 2619, code: "262532" },
    { id: 50521, cityId: 2619, code: "262543" },
    { id: 50522, cityId: 2619, code: "262545" },
    { id: 50523, cityId: 2619, code: "262546" },
    { id: 50524, cityId: 2619, code: "262553" },
    { id: 50525, cityId: 2619, code: "262561" },
    { id: 50526, cityId: 2619, code: "262572" },
    { id: 50527, cityId: 2619, code: "262575" },
    { id: 50528, cityId: 2619, code: "265441" },
    { id: 50529, cityId: 2620, code: "246169" },
    { id: 50530, cityId: 2621, code: "492001" },
    { id: 50531, cityId: 2621, code: "492003" },
    { id: 50532, cityId: 2621, code: "492008" },
    { id: 50533, cityId: 2621, code: "492009" },
    { id: 50534, cityId: 2621, code: "492109" },
    { id: 50535, cityId: 2621, code: "492112" },
    { id: 50536, cityId: 2621, code: "493111" },
    { id: 50537, cityId: 2621, code: "493116" },
    { id: 50538, cityId: 2621, code: "493330" },
    { id: 50539, cityId: 2621, code: "493335" },
    { id: 50540, cityId: 2621, code: "493338" },
    { id: 50541, cityId: 2621, code: "493344" },
    { id: 50542, cityId: 2621, code: "493354" },
    { id: 50543, cityId: 2621, code: "493449" },
    { id: 50544, cityId: 2621, code: "493555" },
    { id: 50545, cityId: 2621, code: "493661" },
    { id: 50546, cityId: 2621, code: "493881" },
    { id: 50547, cityId: 2621, code: "493889" },
    { id: 50548, cityId: 2621, code: "493895" },
    { id: 50549, cityId: 2621, code: "493992" },
    { id: 50550, cityId: 2621, code: "248008" },
    { id: 50551, cityId: 2621, code: "486114" },
    { id: 50552, cityId: 2621, code: "492004" },
    { id: 50553, cityId: 2621, code: "492005" },
    { id: 50554, cityId: 2621, code: "492007" },
    { id: 50555, cityId: 2621, code: "492012" },
    { id: 50556, cityId: 2621, code: "492015" },
    { id: 50557, cityId: 2621, code: "493114" },
    { id: 50558, cityId: 2621, code: "493225" },
    { id: 50559, cityId: 2621, code: "493228" },
    { id: 50560, cityId: 2621, code: "493332" },
    { id: 50561, cityId: 2621, code: "493551" },
    { id: 50562, cityId: 2621, code: "493559" },
    { id: 50563, cityId: 2621, code: "493562" },
    { id: 50564, cityId: 2621, code: "493885" },
    { id: 50565, cityId: 2621, code: "493890" },
    { id: 50566, cityId: 2621, code: "493996" },
    { id: 50567, cityId: 2622, code: "249205" },
    { id: 50568, cityId: 2623, code: "244715" },
    { id: 50569, cityId: 2624, code: "263137" },
    { id: 50570, cityId: 2625, code: "246170" },
    { id: 50571, cityId: 2626, code: "249201" },
    { id: 50572, cityId: 2627, code: "246132" },
    { id: 50573, cityId: 2628, code: "247667" },
    { id: 50574, cityId: 2629, code: "246448" },
    { id: 50575, cityId: 2629, code: "246475" },
    { id: 50576, cityId: 2629, code: "246171" },
    { id: 50577, cityId: 2630, code: "263154" },
    { id: 50578, cityId: 2630, code: "274204" },
    { id: 50579, cityId: 2630, code: "242315" },
    { id: 50580, cityId: 2630, code: "263153" },
    { id: 50581, cityId: 2631, code: "246172" },
    { id: 50582, cityId: 2632, code: "246173" },
    { id: 50583, cityId: 2633, code: "262125" },
    { id: 50584, cityId: 2634, code: "190002" },
    { id: 50585, cityId: 2634, code: "190004" },
    { id: 50586, cityId: 2634, code: "190005" },
    { id: 50587, cityId: 2634, code: "190007" },
    { id: 50588, cityId: 2634, code: "190010" },
    { id: 50589, cityId: 2634, code: "190012" },
    { id: 50590, cityId: 2634, code: "190015" },
    { id: 50591, cityId: 2634, code: "191102" },
    { id: 50592, cityId: 2634, code: "191121" },
    { id: 50593, cityId: 2634, code: "191131" },
    { id: 50594, cityId: 2634, code: "191203" },
    { id: 50595, cityId: 2634, code: "190001" },
    { id: 50596, cityId: 2634, code: "190003" },
    { id: 50597, cityId: 2634, code: "190006" },
    { id: 50598, cityId: 2634, code: "190008" },
    { id: 50599, cityId: 2634, code: "190009" },
    { id: 50600, cityId: 2634, code: "190011" },
    { id: 50601, cityId: 2634, code: "190014" },
    { id: 50602, cityId: 2634, code: "190016" },
    { id: 50603, cityId: 2634, code: "190017" },
    { id: 50604, cityId: 2634, code: "191101" },
    { id: 50605, cityId: 2634, code: "191104" },
    { id: 50606, cityId: 2634, code: "191112" },
    { id: 50607, cityId: 2634, code: "191115" },
    { id: 50608, cityId: 2634, code: "191123" },
    { id: 50609, cityId: 2634, code: "191141" },
    { id: 50610, cityId: 2634, code: "191202" },
    { id: 50611, cityId: 2634, code: "191204" },
    { id: 50612, cityId: 2634, code: "191205" },
    { id: 50613, cityId: 2634, code: "246174" },
    { id: 50614, cityId: 2635, code: "246176" },
    { id: 50615, cityId: 2636, code: "246485" },
    { id: 50616, cityId: 2637, code: "249151" },
    { id: 50617, cityId: 2637, code: "249156" },
    { id: 50618, cityId: 2637, code: "249185" },
    { id: 50619, cityId: 2637, code: "249193" },
    { id: 50620, cityId: 2637, code: "279181" },
    { id: 50621, cityId: 2637, code: "249134" },
    { id: 50622, cityId: 2637, code: "249141" },
    { id: 50623, cityId: 2637, code: "249152" },
    { id: 50624, cityId: 2637, code: "249171" },
    { id: 50625, cityId: 2637, code: "249194" },
    { id: 50626, cityId: 2637, code: "249195" },
    { id: 50627, cityId: 2638, code: "246177" },
    { id: 50628, cityId: 2639, code: "248191" },
    { id: 50629, cityId: 2640, code: "733102" },
    { id: 50630, cityId: 2640, code: "733121" },
    { id: 50631, cityId: 2640, code: "733123" },
    { id: 50632, cityId: 2640, code: "733126" },
    { id: 50633, cityId: 2640, code: "733128" },
    { id: 50634, cityId: 2640, code: "733129" },
    { id: 50635, cityId: 2640, code: "733131" },
    { id: 50636, cityId: 2640, code: "733142" },
    { id: 50637, cityId: 2640, code: "733144" },
    { id: 50638, cityId: 2640, code: "733147" },
    { id: 50639, cityId: 2640, code: "733149" },
    { id: 50640, cityId: 2640, code: "733150" },
    { id: 50641, cityId: 2640, code: "733157" },
    { id: 50642, cityId: 2640, code: "733208" },
    { id: 50643, cityId: 2640, code: "733210" },
    { id: 50644, cityId: 2640, code: "733211" },
    { id: 50645, cityId: 2640, code: "733213" },
    { id: 50646, cityId: 2640, code: "733216" },
    { id: 50647, cityId: 2640, code: "735152" },
    { id: 50648, cityId: 2640, code: "733101" },
    { id: 50649, cityId: 2640, code: "733103" },
    { id: 50650, cityId: 2640, code: "733130" },
    { id: 50651, cityId: 2640, code: "733132" },
    { id: 50652, cityId: 2640, code: "733133" },
    { id: 50653, cityId: 2640, code: "733140" },
    { id: 50654, cityId: 2640, code: "733141" },
    { id: 50655, cityId: 2640, code: "733143" },
    { id: 50656, cityId: 2640, code: "733145" },
    { id: 50657, cityId: 2640, code: "733146" },
    { id: 50658, cityId: 2640, code: "733148" },
    { id: 50659, cityId: 2640, code: "733151" },
    { id: 50660, cityId: 2640, code: "733153" },
    { id: 50661, cityId: 2640, code: "733154" },
    { id: 50662, cityId: 2640, code: "733156" },
    { id: 50663, cityId: 2640, code: "733201" },
    { id: 50664, cityId: 2640, code: "733207" },
    { id: 50665, cityId: 2640, code: "733209" },
    { id: 50666, cityId: 2640, code: "733212" },
    { id: 50667, cityId: 2640, code: "733214" },
    { id: 50668, cityId: 2640, code: "733215" },
    { id: 50669, cityId: 2641, code: "700057" },
    { id: 50671, cityId: 2641, code: "700063" },
    { id: 50672, cityId: 2641, code: "700065" },
    { id: 50673, cityId: 2641, code: "700073" },
    { id: 50674, cityId: 2641, code: "700074" },
    { id: 50675, cityId: 2641, code: "700076" },
    { id: 50676, cityId: 2641, code: "700078" },
    { id: 50677, cityId: 2641, code: "700079" },
    { id: 50678, cityId: 2641, code: "700081" },
    { id: 50679, cityId: 2641, code: "700084" },
    { id: 50680, cityId: 2641, code: "700086" },
    { id: 50682, cityId: 2641, code: "700092" },
    { id: 50683, cityId: 2641, code: "700056" },
    { id: 50684, cityId: 2641, code: "700061" },
    { id: 50685, cityId: 2641, code: "700075" },
    { id: 50686, cityId: 2641, code: "700077" },
    { id: 50687, cityId: 2641, code: "700080" },
    { id: 50688, cityId: 2641, code: "700082" },
    { id: 50689, cityId: 2641, code: "700083" },
    { id: 50690, cityId: 2641, code: "700088" },
    { id: 50691, cityId: 2641, code: "700090" },
    { id: 50693, cityId: 2641, code: "743440" },
    { id: 50694, cityId: 2642, code: "723121" },
    { id: 50695, cityId: 2643, code: "732121" },
    { id: 50696, cityId: 2644, code: "700035" },
    { id: 50697, cityId: 2644, code: "700048" },
    { id: 50698, cityId: 2644, code: "700050" },
    { id: 50699, cityId: 2644, code: "700051" },
    { id: 50700, cityId: 2644, code: "700056" },
    { id: 50701, cityId: 2644, code: "700059" },
    { id: 50702, cityId: 2644, code: "700074" },
    { id: 50703, cityId: 2644, code: "700080" },
    { id: 50704, cityId: 2644, code: "743121" },
    { id: 50705, cityId: 2644, code: "743122" },
    { id: 50706, cityId: 2644, code: "743126" },
    { id: 50707, cityId: 2644, code: "743127" },
    { id: 50708, cityId: 2644, code: "743129" },
    { id: 50709, cityId: 2644, code: "743135" },
    { id: 50710, cityId: 2644, code: "743166" },
    { id: 50711, cityId: 2644, code: "743177" },
    { id: 50712, cityId: 2644, code: "743179" },
    { id: 50713, cityId: 2644, code: "743180" },
    { id: 50714, cityId: 2644, code: "743187" },
    { id: 50715, cityId: 2644, code: "743193" },
    { id: 50717, cityId: 2644, code: "743203" },
    { id: 50718, cityId: 2644, code: "743204" },
    { id: 50720, cityId: 2644, code: "743232" },
    { id: 50721, cityId: 2644, code: "743233" },
    { id: 50722, cityId: 2644, code: "743235" },
    { id: 50723, cityId: 2644, code: "743246" },
    { id: 50724, cityId: 2644, code: "743248" },
    { id: 50725, cityId: 2644, code: "743249" },
    { id: 50726, cityId: 2644, code: "743251" },
    { id: 50727, cityId: 2644, code: "743262" },
    { id: 50728, cityId: 2644, code: "743270" },
    { id: 50729, cityId: 2644, code: "743272" },
    { id: 50730, cityId: 2644, code: "743275" },
    { id: 50731, cityId: 2644, code: "743286" },
    { id: 50732, cityId: 2644, code: "743288" },
    { id: 50733, cityId: 2644, code: "743291" },
    { id: 50734, cityId: 2644, code: "743293" },
    { id: 50735, cityId: 2644, code: "743294" },
    { id: 50736, cityId: 2644, code: "743296" },
    { id: 50737, cityId: 2644, code: "743378" },
    { id: 50738, cityId: 2644, code: "743402" },
    { id: 50739, cityId: 2644, code: "743413" },
    { id: 50740, cityId: 2644, code: "743423" },
    { id: 50741, cityId: 2644, code: "743426" },
    { id: 50742, cityId: 2644, code: "743428" },
    { id: 50743, cityId: 2644, code: "743436" },
    { id: 50744, cityId: 2644, code: "743437" },
    { id: 50745, cityId: 2644, code: "743442" },
    { id: 50746, cityId: 2644, code: "743511" },
    { id: 50747, cityId: 2644, code: "743701" },
    { id: 50748, cityId: 2644, code: "743702" },
    { id: 50749, cityId: 2644, code: "743704" },
    { id: 50750, cityId: 2644, code: "743707" },
    { id: 50751, cityId: 2644, code: "700028" },
    { id: 50752, cityId: 2644, code: "700030" },
    { id: 50753, cityId: 2644, code: "700036" },
    { id: 50754, cityId: 2644, code: "700049" },
    { id: 50756, cityId: 2644, code: "700057" },
    { id: 50757, cityId: 2644, code: "700065" },
    { id: 50758, cityId: 2644, code: "700081" },
    { id: 50759, cityId: 2644, code: "700083" },
    { id: 50761, cityId: 2644, code: "743101" },
    { id: 50762, cityId: 2644, code: "743102" },
    { id: 50763, cityId: 2644, code: "743120" },
    { id: 50764, cityId: 2644, code: "743123" },
    { id: 50765, cityId: 2644, code: "743125" },
    { id: 50766, cityId: 2644, code: "743128" },
    { id: 50767, cityId: 2644, code: "743133" },
    { id: 50768, cityId: 2644, code: "743136" },
    { id: 50769, cityId: 2644, code: "743144" },
    { id: 50770, cityId: 2644, code: "743155" },
    { id: 50771, cityId: 2644, code: "743170" },
    { id: 50772, cityId: 2644, code: "743175" },
    { id: 50773, cityId: 2644, code: "743178" },
    { id: 50774, cityId: 2644, code: "743186" },
    { id: 50775, cityId: 2644, code: "743194" },
    { id: 50776, cityId: 2644, code: "743202" },
    { id: 50777, cityId: 2644, code: "743221" },
    { id: 50778, cityId: 2644, code: "743234" },
    { id: 50779, cityId: 2644, code: "743245" },
    { id: 50780, cityId: 2644, code: "743247" },
    { id: 50781, cityId: 2644, code: "743250" },
    { id: 50782, cityId: 2644, code: "743263" },
    { id: 50783, cityId: 2644, code: "743268" },
    { id: 50784, cityId: 2644, code: "743269" },
    { id: 50785, cityId: 2644, code: "743271" },
    { id: 50786, cityId: 2644, code: "743273" },
    { id: 50787, cityId: 2644, code: "743274" },
    { id: 50788, cityId: 2644, code: "743276" },
    { id: 50789, cityId: 2644, code: "743287" },
    { id: 50790, cityId: 2644, code: "743290" },
    { id: 50791, cityId: 2644, code: "743292" },
    { id: 50792, cityId: 2644, code: "743295" },
    { id: 50793, cityId: 2644, code: "743297" },
    { id: 50794, cityId: 2644, code: "743298" },
    { id: 50795, cityId: 2644, code: "743411" },
    { id: 50796, cityId: 2644, code: "743412" },
    { id: 50797, cityId: 2644, code: "743422" },
    { id: 50798, cityId: 2644, code: "743424" },
    { id: 50799, cityId: 2644, code: "743425" },
    { id: 50800, cityId: 2644, code: "743427" },
    { id: 50801, cityId: 2644, code: "743435" },
    { id: 50802, cityId: 2644, code: "743438" },
    { id: 50803, cityId: 2644, code: "743440" },
    { id: 50804, cityId: 2644, code: "743443" },
    { id: 50805, cityId: 2644, code: "743502" },
    { id: 50806, cityId: 2644, code: "743510" },
    { id: 50807, cityId: 2644, code: "743703" },
    { id: 50808, cityId: 2644, code: "743705" },
    { id: 50809, cityId: 2644, code: "743710" },
    { id: 50810, cityId: 2645, code: "736121" },
    { id: 50811, cityId: 2646, code: "742121" },
    { id: 50812, cityId: 2647, code: "262728" },
    { id: 50813, cityId: 2647, code: "423704" },
    { id: 50814, cityId: 2647, code: "431001" },
    { id: 50815, cityId: 2647, code: "431004" },
    { id: 50816, cityId: 2647, code: "431102" },
    { id: 50817, cityId: 2647, code: "431104" },
    { id: 50818, cityId: 2647, code: "431110" },
    { id: 50819, cityId: 2647, code: "431115" },
    { id: 50820, cityId: 2647, code: "431133" },
    { id: 50821, cityId: 2647, code: "431139" },
    { id: 50822, cityId: 2647, code: "431144" },
    { id: 50823, cityId: 2647, code: "431147" },
    { id: 50824, cityId: 2647, code: "431208" },
    { id: 50825, cityId: 2647, code: "431210" },
    { id: 50826, cityId: 2647, code: "431213" },
    { id: 50827, cityId: 2647, code: "814147" },
    { id: 50828, cityId: 2647, code: "814155" },
    { id: 50829, cityId: 2647, code: "814156" },
    { id: 50830, cityId: 2647, code: "824101" },
    { id: 50831, cityId: 2647, code: "824112" },
    { id: 50832, cityId: 2647, code: "824114" },
    { id: 50833, cityId: 2647, code: "824120" },
    { id: 50834, cityId: 2647, code: "824122" },
    { id: 50835, cityId: 2647, code: "824127" },
    { id: 50836, cityId: 2647, code: "824128" },
    { id: 50837, cityId: 2647, code: "824130" },
    { id: 50838, cityId: 2647, code: "824202" },
    { id: 50839, cityId: 2647, code: "824218" },
    { id: 50840, cityId: 2647, code: "824302" },
    { id: 50841, cityId: 2647, code: "824303" },
    { id: 50842, cityId: 2647, code: "221001" },
    { id: 50843, cityId: 2647, code: "245401" },
    { id: 50844, cityId: 2647, code: "261403" },
    { id: 50845, cityId: 2647, code: "415570" },
    { id: 50846, cityId: 2647, code: "423702" },
    { id: 50847, cityId: 2647, code: "431002" },
    { id: 50848, cityId: 2647, code: "431005" },
    { id: 50849, cityId: 2647, code: "431105" },
    { id: 50850, cityId: 2647, code: "431108" },
    { id: 50851, cityId: 2647, code: "431111" },
    { id: 50852, cityId: 2647, code: "431116" },
    { id: 50853, cityId: 2647, code: "431119" },
    { id: 50854, cityId: 2647, code: "431121" },
    { id: 50855, cityId: 2647, code: "431137" },
    { id: 50856, cityId: 2647, code: "431138" },
    { id: 50857, cityId: 2647, code: "431140" },
    { id: 50858, cityId: 2647, code: "431146" },
    { id: 50859, cityId: 2647, code: "431148" },
    { id: 50860, cityId: 2647, code: "431201" },
    { id: 50861, cityId: 2647, code: "431212" },
    { id: 50862, cityId: 2647, code: "431402" },
    { id: 50863, cityId: 2647, code: "742201" },
    { id: 50864, cityId: 2647, code: "814133" },
    { id: 50865, cityId: 2647, code: "814141" },
    { id: 50866, cityId: 2647, code: "814154" },
    { id: 50867, cityId: 2647, code: "814165" },
    { id: 50868, cityId: 2647, code: "824102" },
    { id: 50869, cityId: 2647, code: "824113" },
    { id: 50870, cityId: 2647, code: "824115" },
    { id: 50871, cityId: 2647, code: "824121" },
    { id: 50872, cityId: 2647, code: "824123" },
    { id: 50873, cityId: 2647, code: "824124" },
    { id: 50874, cityId: 2647, code: "824126" },
    { id: 50875, cityId: 2647, code: "824129" },
    { id: 50876, cityId: 2647, code: "824203" },
    { id: 50877, cityId: 2647, code: "824211" },
    { id: 50878, cityId: 2647, code: "824216" },
    { id: 50879, cityId: 2647, code: "825101" },
    { id: 50880, cityId: 2648, code: "743401" },
    { id: 50881, cityId: 2649, code: "711303" },
    { id: 50882, cityId: 2650, code: "713322" },
    { id: 50883, cityId: 2651, code: "721124" },
    { id: 50884, cityId: 2652, code: "713323" },
    { id: 50885, cityId: 2653, code: "711201" },
    { id: 50886, cityId: 2654, code: "700056" },
    { id: 50887, cityId: 2654, code: "733125" },
    { id: 50888, cityId: 2654, code: "733127" },
    { id: 50889, cityId: 2655, code: "721101" },
    { id: 50890, cityId: 2655, code: "721122" },
    { id: 50891, cityId: 2655, code: "721136" },
    { id: 50892, cityId: 2655, code: "721138" },
    { id: 50893, cityId: 2655, code: "721141" },
    { id: 50894, cityId: 2655, code: "721144" },
    { id: 50895, cityId: 2655, code: "721146" },
    { id: 50896, cityId: 2655, code: "721149" },
    { id: 50897, cityId: 2655, code: "721151" },
    { id: 50898, cityId: 2655, code: "721154" },
    { id: 50899, cityId: 2655, code: "721156" },
    { id: 50900, cityId: 2655, code: "721157" },
    { id: 50901, cityId: 2655, code: "721159" },
    { id: 50902, cityId: 2655, code: "722102" },
    { id: 50903, cityId: 2655, code: "722107" },
    { id: 50904, cityId: 2655, code: "722121" },
    { id: 50905, cityId: 2655, code: "722134" },
    { id: 50906, cityId: 2655, code: "722137" },
    { id: 50907, cityId: 2655, code: "722139" },
    { id: 50908, cityId: 2655, code: "722142" },
    { id: 50909, cityId: 2655, code: "722144" },
    { id: 50910, cityId: 2655, code: "722145" },
    { id: 50911, cityId: 2655, code: "722147" },
    { id: 50912, cityId: 2655, code: "722152" },
    { id: 50913, cityId: 2655, code: "722153" },
    { id: 50914, cityId: 2655, code: "722155" },
    { id: 50915, cityId: 2655, code: "722158" },
    { id: 50916, cityId: 2655, code: "722205" },
    { id: 50917, cityId: 2655, code: "722206" },
    { id: 50918, cityId: 2655, code: "722208" },
    { id: 50919, cityId: 2655, code: "721121" },
    { id: 50920, cityId: 2655, code: "721134" },
    { id: 50921, cityId: 2655, code: "721137" },
    { id: 50922, cityId: 2655, code: "721139" },
    { id: 50923, cityId: 2655, code: "721140" },
    { id: 50924, cityId: 2655, code: "721142" },
    { id: 50925, cityId: 2655, code: "721145" },
    { id: 50926, cityId: 2655, code: "721147" },
    { id: 50927, cityId: 2655, code: "721148" },
    { id: 50928, cityId: 2655, code: "721150" },
    { id: 50929, cityId: 2655, code: "721152" },
    { id: 50930, cityId: 2655, code: "721155" },
    { id: 50931, cityId: 2655, code: "721158" },
    { id: 50932, cityId: 2655, code: "721160" },
    { id: 50933, cityId: 2655, code: "722101" },
    { id: 50934, cityId: 2655, code: "722122" },
    { id: 50935, cityId: 2655, code: "722132" },
    { id: 50936, cityId: 2655, code: "722133" },
    { id: 50937, cityId: 2655, code: "722135" },
    { id: 50938, cityId: 2655, code: "722138" },
    { id: 50939, cityId: 2655, code: "722140" },
    { id: 50940, cityId: 2655, code: "722141" },
    { id: 50941, cityId: 2655, code: "722143" },
    { id: 50942, cityId: 2655, code: "722146" },
    { id: 50943, cityId: 2655, code: "722148" },
    { id: 50944, cityId: 2655, code: "722149" },
    { id: 50945, cityId: 2655, code: "722151" },
    { id: 50946, cityId: 2655, code: "722154" },
    { id: 50947, cityId: 2655, code: "722156" },
    { id: 50948, cityId: 2655, code: "722157" },
    { id: 50949, cityId: 2655, code: "722159" },
    { id: 50950, cityId: 2655, code: "722201" },
    { id: 50951, cityId: 2655, code: "722202" },
    { id: 50952, cityId: 2655, code: "722204" },
    { id: 50953, cityId: 2655, code: "722207" },
    { id: 50954, cityId: 2656, code: "712502" },
    { id: 50955, cityId: 2657, code: "700036" },
    { id: 50956, cityId: 2658, code: "712136" },
    { id: 50957, cityId: 2659, code: "700041" },
    { id: 50958, cityId: 2659, code: "700044" },
    { id: 50959, cityId: 2659, code: "700070" },
    { id: 50960, cityId: 2659, code: "700078" },
    { id: 50961, cityId: 2659, code: "700086" },
    { id: 50962, cityId: 2659, code: "700088" },
    { id: 50963, cityId: 2659, code: "700089" },
    { id: 50964, cityId: 2659, code: "743252" },
    { id: 50965, cityId: 2659, code: "743302" },
    { id: 50966, cityId: 2659, code: "743313" },
    { id: 50967, cityId: 2659, code: "743316" },
    { id: 50968, cityId: 2659, code: "743329" },
    { id: 50969, cityId: 2659, code: "743331" },
    { id: 50970, cityId: 2659, code: "743332" },
    { id: 50971, cityId: 2659, code: "743337" },
    { id: 50972, cityId: 2659, code: "743347" },
    { id: 50973, cityId: 2659, code: "743348" },
    { id: 50974, cityId: 2659, code: "743355" },
    { id: 50975, cityId: 2659, code: "743358" },
    { id: 50976, cityId: 2659, code: "743360" },
    { id: 50977, cityId: 2659, code: "743368" },
    { id: 50978, cityId: 2659, code: "743369" },
    { id: 50979, cityId: 2659, code: "743371" },
    { id: 50980, cityId: 2659, code: "743374" },
    { id: 50981, cityId: 2659, code: "743376" },
    { id: 50982, cityId: 2659, code: "743377" },
    { id: 50983, cityId: 2659, code: "743379" },
    { id: 50984, cityId: 2659, code: "743382" },
    { id: 50985, cityId: 2659, code: "743385" },
    { id: 50986, cityId: 2659, code: "743387" },
    { id: 50987, cityId: 2659, code: "743390" },
    { id: 50988, cityId: 2659, code: "743393" },
    { id: 50989, cityId: 2659, code: "743395" },
    { id: 50990, cityId: 2659, code: "743398" },
    { id: 50991, cityId: 2659, code: "743504" },
    { id: 50992, cityId: 2659, code: "743506" },
    { id: 50993, cityId: 2659, code: "743512" },
    { id: 50994, cityId: 2659, code: "743514" },
    { id: 50995, cityId: 2659, code: "743517" },
    { id: 50996, cityId: 2659, code: "743601" },
    { id: 50997, cityId: 2659, code: "743602" },
    { id: 50998, cityId: 2659, code: "743604" },
    { id: 50999, cityId: 2659, code: "743607" },
    { id: 51000, cityId: 2659, code: "743609" },
    { id: 51001, cityId: 2659, code: "743610" },
    { id: 51002, cityId: 2659, code: "753353" },
    { id: 51003, cityId: 2659, code: "700008" },
    { id: 51004, cityId: 2659, code: "700018" },
    { id: 51005, cityId: 2659, code: "700032" },
    { id: 51006, cityId: 2659, code: "700034" },
    { id: 51007, cityId: 2659, code: "700040" },
    { id: 51008, cityId: 2659, code: "700042" },
    { id: 51009, cityId: 2659, code: "700045" },
    { id: 51010, cityId: 2659, code: "700047" },
    { id: 51011, cityId: 2659, code: "700060" },
    { id: 51012, cityId: 2659, code: "700061" },
    { id: 51013, cityId: 2659, code: "700063" },
    { id: 51014, cityId: 2659, code: "700066" },
    { id: 51015, cityId: 2659, code: "700082" },
    { id: 51016, cityId: 2659, code: "700084" },
    { id: 51017, cityId: 2659, code: "700092" },
    { id: 51018, cityId: 2659, code: "700093" },
    { id: 51019, cityId: 2659, code: "743301" },
    { id: 51020, cityId: 2659, code: "743312" },
    { id: 51021, cityId: 2659, code: "743330" },
    { id: 51022, cityId: 2659, code: "743336" },
    { id: 51023, cityId: 2659, code: "743338" },
    { id: 51024, cityId: 2659, code: "743343" },
    { id: 51025, cityId: 2659, code: "743349" },
    { id: 51026, cityId: 2659, code: "743351" },
    { id: 51027, cityId: 2659, code: "743354" },
    { id: 51028, cityId: 2659, code: "743356" },
    { id: 51029, cityId: 2659, code: "743357" },
    { id: 51030, cityId: 2659, code: "743370" },
    { id: 51031, cityId: 2659, code: "743372" },
    { id: 51032, cityId: 2659, code: "743373" },
    { id: 51033, cityId: 2659, code: "743375" },
    { id: 51034, cityId: 2659, code: "743380" },
    { id: 51035, cityId: 2659, code: "743381" },
    { id: 51036, cityId: 2659, code: "743383" },
    { id: 51037, cityId: 2659, code: "743388" },
    { id: 51038, cityId: 2659, code: "743389" },
    { id: 51039, cityId: 2659, code: "743391" },
    { id: 51040, cityId: 2659, code: "743394" },
    { id: 51041, cityId: 2659, code: "743396" },
    { id: 51042, cityId: 2659, code: "743397" },
    { id: 51043, cityId: 2659, code: "743399" },
    { id: 51044, cityId: 2659, code: "743441" },
    { id: 51045, cityId: 2659, code: "743505" },
    { id: 51046, cityId: 2659, code: "743507" },
    { id: 51047, cityId: 2659, code: "743508" },
    { id: 51048, cityId: 2659, code: "743513" },
    { id: 51049, cityId: 2659, code: "743515" },
    { id: 51050, cityId: 2659, code: "743516" },
    { id: 51051, cityId: 2659, code: "743603" },
    { id: 51052, cityId: 2659, code: "743605" },
    { id: 51053, cityId: 2659, code: "743606" },
    { id: 51054, cityId: 2659, code: "743608" },
    { id: 51055, cityId: 2659, code: "743611" },
    { id: 51056, cityId: 2659, code: "743613" },
    { id: 51057, cityId: 2660, code: "712613" },
    { id: 51058, cityId: 2660, code: "713102" },
    { id: 51059, cityId: 2660, code: "713103" },
    { id: 51060, cityId: 2660, code: "713121" },
    { id: 51061, cityId: 2660, code: "713123" },
    { id: 51062, cityId: 2660, code: "713124" },
    { id: 51063, cityId: 2660, code: "713126" },
    { id: 51064, cityId: 2660, code: "713129" },
    { id: 51065, cityId: 2660, code: "713140" },
    { id: 51066, cityId: 2660, code: "713142" },
    { id: 51067, cityId: 2660, code: "713145" },
    { id: 51068, cityId: 2660, code: "713147" },
    { id: 51069, cityId: 2660, code: "713148" },
    { id: 51070, cityId: 2660, code: "713150" },
    { id: 51071, cityId: 2660, code: "713153" },
    { id: 51072, cityId: 2660, code: "713155" },
    { id: 51073, cityId: 2660, code: "713156" },
    { id: 51074, cityId: 2660, code: "713158" },
    { id: 51075, cityId: 2660, code: "713160" },
    { id: 51076, cityId: 2660, code: "713161" },
    { id: 51077, cityId: 2660, code: "713168" },
    { id: 51078, cityId: 2660, code: "713169" },
    { id: 51079, cityId: 2660, code: "713171" },
    { id: 51080, cityId: 2660, code: "713174" },
    { id: 51081, cityId: 2660, code: "713203" },
    { id: 51082, cityId: 2660, code: "713206" },
    { id: 51083, cityId: 2660, code: "713301" },
    { id: 51084, cityId: 2660, code: "713304" },
    { id: 51085, cityId: 2660, code: "713325" },
    { id: 51086, cityId: 2660, code: "713330" },
    { id: 51087, cityId: 2660, code: "713333" },
    { id: 51088, cityId: 2660, code: "713335" },
    { id: 51089, cityId: 2660, code: "713336" },
    { id: 51090, cityId: 2660, code: "713338" },
    { id: 51091, cityId: 2660, code: "713341" },
    { id: 51092, cityId: 2660, code: "713344" },
    { id: 51093, cityId: 2660, code: "713346" },
    { id: 51094, cityId: 2660, code: "713357" },
    { id: 51095, cityId: 2660, code: "713359" },
    { id: 51096, cityId: 2660, code: "713362" },
    { id: 51097, cityId: 2660, code: "713364" },
    { id: 51098, cityId: 2660, code: "713367" },
    { id: 51099, cityId: 2660, code: "713370" },
    { id: 51100, cityId: 2660, code: "713372" },
    { id: 51101, cityId: 2660, code: "713373" },
    { id: 51102, cityId: 2660, code: "713375" },
    { id: 51103, cityId: 2660, code: "713380" },
    { id: 51104, cityId: 2660, code: "713381" },
    { id: 51105, cityId: 2660, code: "713383" },
    { id: 51106, cityId: 2660, code: "713386" },
    { id: 51107, cityId: 2660, code: "713402" },
    { id: 51108, cityId: 2660, code: "713404" },
    { id: 51109, cityId: 2660, code: "713407" },
    { id: 51110, cityId: 2660, code: "713409" },
    { id: 51111, cityId: 2660, code: "713420" },
    { id: 51112, cityId: 2660, code: "713423" },
    { id: 51113, cityId: 2660, code: "713425" },
    { id: 51114, cityId: 2660, code: "713426" },
    { id: 51115, cityId: 2660, code: "713428" },
    { id: 51116, cityId: 2660, code: "713431" },
    { id: 51117, cityId: 2660, code: "713433" },
    { id: 51118, cityId: 2660, code: "713434" },
    { id: 51119, cityId: 2660, code: "713513" },
    { id: 51120, cityId: 2660, code: "713515" },
    { id: 51121, cityId: 2660, code: "713518" },
    { id: 51122, cityId: 2660, code: "700090" },
    { id: 51123, cityId: 2660, code: "713101" },
    { id: 51124, cityId: 2660, code: "713104" },
    { id: 51125, cityId: 2660, code: "713122" },
    { id: 51126, cityId: 2660, code: "713125" },
    { id: 51127, cityId: 2660, code: "713127" },
    { id: 51128, cityId: 2660, code: "713128" },
    { id: 51129, cityId: 2660, code: "713130" },
    { id: 51130, cityId: 2660, code: "713141" },
    { id: 51131, cityId: 2660, code: "713143" },
    { id: 51132, cityId: 2660, code: "713144" },
    { id: 51133, cityId: 2660, code: "713146" },
    { id: 51134, cityId: 2660, code: "713149" },
    { id: 51135, cityId: 2660, code: "713151" },
    { id: 51136, cityId: 2660, code: "713152" },
    { id: 51137, cityId: 2660, code: "713154" },
    { id: 51138, cityId: 2660, code: "713157" },
    { id: 51139, cityId: 2660, code: "713162" },
    { id: 51140, cityId: 2660, code: "713164" },
    { id: 51141, cityId: 2660, code: "713165" },
    { id: 51142, cityId: 2660, code: "713167" },
    { id: 51143, cityId: 2660, code: "713170" },
    { id: 51144, cityId: 2660, code: "713173" },
    { id: 51145, cityId: 2660, code: "713202" },
    { id: 51146, cityId: 2660, code: "713212" },
    { id: 51147, cityId: 2660, code: "713215" },
    { id: 51148, cityId: 2660, code: "713303" },
    { id: 51149, cityId: 2660, code: "713321" },
    { id: 51150, cityId: 2660, code: "713324" },
    { id: 51151, cityId: 2660, code: "713326" },
    { id: 51152, cityId: 2660, code: "713331" },
    { id: 51153, cityId: 2660, code: "713332" },
    { id: 51154, cityId: 2660, code: "713334" },
    { id: 51155, cityId: 2660, code: "713337" },
    { id: 51156, cityId: 2660, code: "713339" },
    { id: 51157, cityId: 2660, code: "713340" },
    { id: 51158, cityId: 2660, code: "713342" },
    { id: 51159, cityId: 2660, code: "713345" },
    { id: 51160, cityId: 2660, code: "713347" },
    { id: 51161, cityId: 2660, code: "713358" },
    { id: 51162, cityId: 2660, code: "713360" },
    { id: 51163, cityId: 2660, code: "713361" },
    { id: 51164, cityId: 2660, code: "713363" },
    { id: 51165, cityId: 2660, code: "713366" },
    { id: 51166, cityId: 2660, code: "713368" },
    { id: 51167, cityId: 2660, code: "713369" },
    { id: 51168, cityId: 2660, code: "713371" },
    { id: 51169, cityId: 2660, code: "713374" },
    { id: 51170, cityId: 2660, code: "713377" },
    { id: 51171, cityId: 2660, code: "713379" },
    { id: 51172, cityId: 2660, code: "713382" },
    { id: 51173, cityId: 2660, code: "713384" },
    { id: 51174, cityId: 2660, code: "713385" },
    { id: 51175, cityId: 2660, code: "713387" },
    { id: 51176, cityId: 2660, code: "713401" },
    { id: 51177, cityId: 2660, code: "713403" },
    { id: 51178, cityId: 2660, code: "713406" },
    { id: 51179, cityId: 2660, code: "713408" },
    { id: 51180, cityId: 2660, code: "713419" },
    { id: 51181, cityId: 2660, code: "713421" },
    { id: 51182, cityId: 2660, code: "713422" },
    { id: 51183, cityId: 2660, code: "713424" },
    { id: 51184, cityId: 2660, code: "713427" },
    { id: 51185, cityId: 2660, code: "713429" },
    { id: 51186, cityId: 2660, code: "713430" },
    { id: 51187, cityId: 2660, code: "713432" },
    { id: 51188, cityId: 2660, code: "713501" },
    { id: 51189, cityId: 2660, code: "713512" },
    { id: 51190, cityId: 2660, code: "713514" },
    { id: 51191, cityId: 2660, code: "713517" },
    { id: 51192, cityId: 2661, code: "712306" },
    { id: 51193, cityId: 2662, code: "722203" },
    { id: 51194, cityId: 2663, code: "741188" },
    { id: 51195, cityId: 2663, code: "742101" },
    { id: 51196, cityId: 2663, code: "742109" },
    { id: 51197, cityId: 2663, code: "742122" },
    { id: 51198, cityId: 2663, code: "742123" },
    { id: 51199, cityId: 2663, code: "742133" },
    { id: 51200, cityId: 2663, code: "742135" },
    { id: 51201, cityId: 2663, code: "742136" },
    { id: 51202, cityId: 2663, code: "742138" },
    { id: 51203, cityId: 2663, code: "742151" },
    { id: 51204, cityId: 2663, code: "742160" },
    { id: 51205, cityId: 2663, code: "742165" },
    { id: 51206, cityId: 2663, code: "742167" },
    { id: 51207, cityId: 2663, code: "742168" },
    { id: 51208, cityId: 2663, code: "742170" },
    { id: 51209, cityId: 2663, code: "742173" },
    { id: 51210, cityId: 2663, code: "742175" },
    { id: 51211, cityId: 2663, code: "742176" },
    { id: 51212, cityId: 2663, code: "742178" },
    { id: 51213, cityId: 2663, code: "742181" },
    { id: 51214, cityId: 2663, code: "742183" },
    { id: 51215, cityId: 2663, code: "742186" },
    { id: 51216, cityId: 2663, code: "742191" },
    { id: 51217, cityId: 2663, code: "742212" },
    { id: 51218, cityId: 2663, code: "742223" },
    { id: 51219, cityId: 2663, code: "742226" },
    { id: 51220, cityId: 2663, code: "742228" },
    { id: 51221, cityId: 2663, code: "742231" },
    { id: 51222, cityId: 2663, code: "742233" },
    { id: 51223, cityId: 2663, code: "742234" },
    { id: 51224, cityId: 2663, code: "742236" },
    { id: 51225, cityId: 2663, code: "742302" },
    { id: 51226, cityId: 2663, code: "742303" },
    { id: 51227, cityId: 2663, code: "742305" },
    { id: 51228, cityId: 2663, code: "742308" },
    { id: 51229, cityId: 2663, code: "742401" },
    { id: 51230, cityId: 2663, code: "742403" },
    { id: 51231, cityId: 2663, code: "742103" },
    { id: 51232, cityId: 2663, code: "742132" },
    { id: 51233, cityId: 2663, code: "742134" },
    { id: 51234, cityId: 2663, code: "742137" },
    { id: 51235, cityId: 2663, code: "742139" },
    { id: 51236, cityId: 2663, code: "742140" },
    { id: 51237, cityId: 2663, code: "742147" },
    { id: 51238, cityId: 2663, code: "742148" },
    { id: 51239, cityId: 2663, code: "742150" },
    { id: 51240, cityId: 2663, code: "742161" },
    { id: 51241, cityId: 2663, code: "742163" },
    { id: 51242, cityId: 2663, code: "742164" },
    { id: 51243, cityId: 2663, code: "742166" },
    { id: 51244, cityId: 2663, code: "742169" },
    { id: 51245, cityId: 2663, code: "742171" },
    { id: 51246, cityId: 2663, code: "742172" },
    { id: 51247, cityId: 2663, code: "742174" },
    { id: 51248, cityId: 2663, code: "742177" },
    { id: 51249, cityId: 2663, code: "742179" },
    { id: 51250, cityId: 2663, code: "742180" },
    { id: 51251, cityId: 2663, code: "742182" },
    { id: 51252, cityId: 2663, code: "742187" },
    { id: 51253, cityId: 2663, code: "742190" },
    { id: 51254, cityId: 2663, code: "742224" },
    { id: 51255, cityId: 2663, code: "742225" },
    { id: 51256, cityId: 2663, code: "742227" },
    { id: 51257, cityId: 2663, code: "742230" },
    { id: 51258, cityId: 2663, code: "742232" },
    { id: 51259, cityId: 2663, code: "742235" },
    { id: 51260, cityId: 2663, code: "742237" },
    { id: 51261, cityId: 2663, code: "742301" },
    { id: 51262, cityId: 2663, code: "742304" },
    { id: 51263, cityId: 2663, code: "742306" },
    { id: 51264, cityId: 2663, code: "742307" },
    { id: 51265, cityId: 2663, code: "742402" },
    { id: 51266, cityId: 2663, code: "742405" },
    { id: 51267, cityId: 2664, code: "712124" },
    { id: 51268, cityId: 2665, code: "700064" },
    { id: 51269, cityId: 2666, code: "743318" },
    { id: 51270, cityId: 2667, code: "712601" },
    { id: 51271, cityId: 2668, code: "731204" },
    { id: 51272, cityId: 2669, code: "743384" },
    { id: 51273, cityId: 2670, code: "743319" },
    { id: 51274, cityId: 2671, code: "711109" },
    { id: 51275, cityId: 2672, code: "741111" },
    { id: 51276, cityId: 2673, code: "712222" },
    { id: 51277, cityId: 2674, code: "712102" },
    { id: 51278, cityId: 2674, code: "712104" },
    { id: 51279, cityId: 2674, code: "712105" },
    { id: 51280, cityId: 2674, code: "712121" },
    { id: 51281, cityId: 2674, code: "712123" },
    { id: 51282, cityId: 2674, code: "712125" },
    { id: 51283, cityId: 2674, code: "712134" },
    { id: 51284, cityId: 2674, code: "712136" },
    { id: 51285, cityId: 2674, code: "712147" },
    { id: 51286, cityId: 2674, code: "712149" },
    { id: 51287, cityId: 2674, code: "712150" },
    { id: 51288, cityId: 2674, code: "712152" },
    { id: 51289, cityId: 2674, code: "712155" },
    { id: 51290, cityId: 2674, code: "712157" },
    { id: 51291, cityId: 2674, code: "712158" },
    { id: 51292, cityId: 2674, code: "712202" },
    { id: 51293, cityId: 2674, code: "712203" },
    { id: 51294, cityId: 2674, code: "712205" },
    { id: 51295, cityId: 2674, code: "712208" },
    { id: 51296, cityId: 2674, code: "712221" },
    { id: 51297, cityId: 2674, code: "712223" },
    { id: 51298, cityId: 2674, code: "712232" },
    { id: 51299, cityId: 2674, code: "712245" },
    { id: 51300, cityId: 2674, code: "712248" },
    { id: 51301, cityId: 2674, code: "712258" },
    { id: 51302, cityId: 2674, code: "712301" },
    { id: 51303, cityId: 2674, code: "712303" },
    { id: 51304, cityId: 2674, code: "712308" },
    { id: 51305, cityId: 2674, code: "712309" },
    { id: 51306, cityId: 2674, code: "712401" },
    { id: 51307, cityId: 2674, code: "712404" },
    { id: 51308, cityId: 2674, code: "712406" },
    { id: 51309, cityId: 2674, code: "712407" },
    { id: 51310, cityId: 2674, code: "712412" },
    { id: 51311, cityId: 2674, code: "712414" },
    { id: 51312, cityId: 2674, code: "712417" },
    { id: 51313, cityId: 2674, code: "712419" },
    { id: 51314, cityId: 2674, code: "712420" },
    { id: 51315, cityId: 2674, code: "712422" },
    { id: 51316, cityId: 2674, code: "712425" },
    { id: 51317, cityId: 2674, code: "712428" },
    { id: 51318, cityId: 2674, code: "712502" },
    { id: 51319, cityId: 2674, code: "712504" },
    { id: 51320, cityId: 2674, code: "712512" },
    { id: 51321, cityId: 2674, code: "712515" },
    { id: 51322, cityId: 2674, code: "712615" },
    { id: 51323, cityId: 2674, code: "712616" },
    { id: 51324, cityId: 2674, code: "712701" },
    { id: 51325, cityId: 2674, code: "712703" },
    { id: 51326, cityId: 2674, code: "712706" },
    { id: 51327, cityId: 2674, code: "712101" },
    { id: 51328, cityId: 2674, code: "712103" },
    { id: 51329, cityId: 2674, code: "712122" },
    { id: 51330, cityId: 2674, code: "712135" },
    { id: 51331, cityId: 2674, code: "712137" },
    { id: 51332, cityId: 2674, code: "712138" },
    { id: 51333, cityId: 2674, code: "712146" },
    { id: 51334, cityId: 2674, code: "712148" },
    { id: 51335, cityId: 2674, code: "712151" },
    { id: 51336, cityId: 2674, code: "712153" },
    { id: 51337, cityId: 2674, code: "712154" },
    { id: 51338, cityId: 2674, code: "712156" },
    { id: 51339, cityId: 2674, code: "712201" },
    { id: 51340, cityId: 2674, code: "712204" },
    { id: 51341, cityId: 2674, code: "712222" },
    { id: 51342, cityId: 2674, code: "712233" },
    { id: 51343, cityId: 2674, code: "712235" },
    { id: 51344, cityId: 2674, code: "712302" },
    { id: 51345, cityId: 2674, code: "712304" },
    { id: 51346, cityId: 2674, code: "712305" },
    { id: 51347, cityId: 2674, code: "712307" },
    { id: 51348, cityId: 2674, code: "712365" },
    { id: 51349, cityId: 2674, code: "712402" },
    { id: 51350, cityId: 2674, code: "712403" },
    { id: 51351, cityId: 2674, code: "712405" },
    { id: 51352, cityId: 2674, code: "712408" },
    { id: 51353, cityId: 2674, code: "712413" },
    { id: 51354, cityId: 2674, code: "712415" },
    { id: 51355, cityId: 2674, code: "712418" },
    { id: 51356, cityId: 2674, code: "712421" },
    { id: 51357, cityId: 2674, code: "712423" },
    { id: 51358, cityId: 2674, code: "712424" },
    { id: 51359, cityId: 2674, code: "712426" },
    { id: 51360, cityId: 2674, code: "712429" },
    { id: 51361, cityId: 2674, code: "712501" },
    { id: 51362, cityId: 2674, code: "712503" },
    { id: 51363, cityId: 2674, code: "712513" },
    { id: 51364, cityId: 2674, code: "712514" },
    { id: 51365, cityId: 2674, code: "712601" },
    { id: 51366, cityId: 2674, code: "712611" },
    { id: 51367, cityId: 2674, code: "712612" },
    { id: 51368, cityId: 2674, code: "712614" },
    { id: 51369, cityId: 2674, code: "712617" },
    { id: 51370, cityId: 2674, code: "712702" },
    { id: 51371, cityId: 2674, code: "712704" },
    { id: 51372, cityId: 2674, code: "712705" },
    { id: 51373, cityId: 2674, code: "712906" },
    { id: 51374, cityId: 2674, code: "741101" },
    { id: 51375, cityId: 2675, code: "713331" },
    { id: 51376, cityId: 2676, code: "713502" },
    { id: 51377, cityId: 2677, code: "734102" },
    { id: 51378, cityId: 2677, code: "734104" },
    { id: 51379, cityId: 2677, code: "734105" },
    { id: 51380, cityId: 2677, code: "734203" },
    { id: 51381, cityId: 2677, code: "734213" },
    { id: 51382, cityId: 2677, code: "734216" },
    { id: 51383, cityId: 2677, code: "734218" },
    { id: 51384, cityId: 2677, code: "734219" },
    { id: 51385, cityId: 2677, code: "734221" },
    { id: 51386, cityId: 2677, code: "734224" },
    { id: 51387, cityId: 2677, code: "734226" },
    { id: 51388, cityId: 2677, code: "734301" },
    { id: 51389, cityId: 2677, code: "734311" },
    { id: 51390, cityId: 2677, code: "734314" },
    { id: 51391, cityId: 2677, code: "734316" },
    { id: 51392, cityId: 2677, code: "734317" },
    { id: 51393, cityId: 2677, code: "734401" },
    { id: 51394, cityId: 2677, code: "734404" },
    { id: 51395, cityId: 2677, code: "734406" },
    { id: 51396, cityId: 2677, code: "734422" },
    { id: 51397, cityId: 2677, code: "734425" },
    { id: 51398, cityId: 2677, code: "734427" },
    { id: 51399, cityId: 2677, code: "734428" },
    { id: 51400, cityId: 2677, code: "734430" },
    { id: 51401, cityId: 2677, code: "734433" },
    { id: 51402, cityId: 2677, code: "734435" },
    { id: 51403, cityId: 2677, code: "734502" },
    { id: 51404, cityId: 2677, code: "734101" },
    { id: 51405, cityId: 2677, code: "734103" },
    { id: 51406, cityId: 2677, code: "734201" },
    { id: 51407, cityId: 2677, code: "734204" },
    { id: 51408, cityId: 2677, code: "734215" },
    { id: 51409, cityId: 2677, code: "734217" },
    { id: 51410, cityId: 2677, code: "734220" },
    { id: 51411, cityId: 2677, code: "734222" },
    { id: 51412, cityId: 2677, code: "734223" },
    { id: 51413, cityId: 2677, code: "734225" },
    { id: 51414, cityId: 2677, code: "734312" },
    { id: 51415, cityId: 2677, code: "734313" },
    { id: 51416, cityId: 2677, code: "734315" },
    { id: 51417, cityId: 2677, code: "734403" },
    { id: 51418, cityId: 2677, code: "734405" },
    { id: 51419, cityId: 2677, code: "734421" },
    { id: 51420, cityId: 2677, code: "734423" },
    { id: 51421, cityId: 2677, code: "734424" },
    { id: 51422, cityId: 2677, code: "734426" },
    { id: 51423, cityId: 2677, code: "734429" },
    { id: 51424, cityId: 2677, code: "734431" },
    { id: 51425, cityId: 2677, code: "734432" },
    { id: 51426, cityId: 2677, code: "734434" },
    { id: 51427, cityId: 2677, code: "734501" },
    { id: 51428, cityId: 2678, code: "742124" },
    { id: 51429, cityId: 2679, code: "700031" },
    { id: 51430, cityId: 2680, code: "713376" },
    { id: 51431, cityId: 2681, code: "713405" },
    { id: 51432, cityId: 2682, code: "742202" },
    { id: 51433, cityId: 2683, code: "736135" },
    { id: 51434, cityId: 2684, code: "711405" },
    { id: 51435, cityId: 2685, code: "731123" },
    { id: 51436, cityId: 2686, code: "713211" },
    { id: 51437, cityId: 2687, code: "721429" },
    { id: 51438, cityId: 2688, code: "732102" },
    { id: 51439, cityId: 2688, code: "732104" },
    { id: 51440, cityId: 2688, code: "732123" },
    { id: 51441, cityId: 2688, code: "732125" },
    { id: 51442, cityId: 2688, code: "732126" },
    { id: 51443, cityId: 2688, code: "732128" },
    { id: 51444, cityId: 2688, code: "732139" },
    { id: 51445, cityId: 2688, code: "732141" },
    { id: 51446, cityId: 2688, code: "732142" },
    { id: 51447, cityId: 2688, code: "732147" },
    { id: 51448, cityId: 2688, code: "732149" },
    { id: 51449, cityId: 2688, code: "732150" },
    { id: 51450, cityId: 2688, code: "732152" },
    { id: 51451, cityId: 2688, code: "732155" },
    { id: 51452, cityId: 2688, code: "732157" },
    { id: 51453, cityId: 2688, code: "732158" },
    { id: 51454, cityId: 2688, code: "732160" },
    { id: 51455, cityId: 2688, code: "732163" },
    { id: 51456, cityId: 2688, code: "732202" },
    { id: 51457, cityId: 2688, code: "732203" },
    { id: 51458, cityId: 2688, code: "732205" },
    { id: 51459, cityId: 2688, code: "732208" },
    { id: 51460, cityId: 2688, code: "732210" },
    { id: 51461, cityId: 2688, code: "732211" },
    { id: 51462, cityId: 2688, code: "732213" },
    { id: 51463, cityId: 2688, code: "732101" },
    { id: 51464, cityId: 2688, code: "732103" },
    { id: 51465, cityId: 2688, code: "732122" },
    { id: 51466, cityId: 2688, code: "732127" },
    { id: 51467, cityId: 2688, code: "732138" },
    { id: 51468, cityId: 2688, code: "732140" },
    { id: 51469, cityId: 2688, code: "732143" },
    { id: 51470, cityId: 2688, code: "732145" },
    { id: 51471, cityId: 2688, code: "732146" },
    { id: 51472, cityId: 2688, code: "732148" },
    { id: 51473, cityId: 2688, code: "732151" },
    { id: 51474, cityId: 2688, code: "732153" },
    { id: 51475, cityId: 2688, code: "732154" },
    { id: 51476, cityId: 2688, code: "732156" },
    { id: 51477, cityId: 2688, code: "732159" },
    { id: 51478, cityId: 2688, code: "732161" },
    { id: 51479, cityId: 2688, code: "732162" },
    { id: 51480, cityId: 2688, code: "732201" },
    { id: 51481, cityId: 2688, code: "732204" },
    { id: 51482, cityId: 2688, code: "732206" },
    { id: 51483, cityId: 2688, code: "732207" },
    { id: 51484, cityId: 2688, code: "732209" },
    { id: 51485, cityId: 2688, code: "732212" },
    { id: 51486, cityId: 2688, code: "732214" },
    { id: 51487, cityId: 2688, code: "732215" },
    { id: 51488, cityId: 2688, code: "741179" },
    { id: 51489, cityId: 2689, code: "735211" },
    { id: 51490, cityId: 2690, code: "735212" },
    { id: 51491, cityId: 2691, code: "733124" },
    { id: 51492, cityId: 2692, code: "711102" },
    { id: 51493, cityId: 2692, code: "721212" },
    { id: 51494, cityId: 2693, code: "742229" },
    { id: 51495, cityId: 2694, code: "742188" },
    { id: 51496, cityId: 2695, code: "743252" },
    { id: 51497, cityId: 2696, code: "721661" },
    { id: 51498, cityId: 2696, code: "741198" },
    { id: 51499, cityId: 2697, code: "721604" },
    { id: 51500, cityId: 2698, code: "735122" },
    { id: 51501, cityId: 2699, code: "743134" },
    { id: 51502, cityId: 2700, code: "713378" },
    { id: 51503, cityId: 2701, code: "711101" },
    { id: 51504, cityId: 2701, code: "711102" },
    { id: 51505, cityId: 2701, code: "711104" },
    { id: 51506, cityId: 2701, code: "711107" },
    { id: 51507, cityId: 2701, code: "711109" },
    { id: 51508, cityId: 2701, code: "711202" },
    { id: 51509, cityId: 2701, code: "711205" },
    { id: 51510, cityId: 2701, code: "711226" },
    { id: 51511, cityId: 2701, code: "711305" },
    { id: 51512, cityId: 2701, code: "711306" },
    { id: 51513, cityId: 2701, code: "711308" },
    { id: 51514, cityId: 2701, code: "711311" },
    { id: 51515, cityId: 2701, code: "711314" },
    { id: 51516, cityId: 2701, code: "711321" },
    { id: 51517, cityId: 2701, code: "711324" },
    { id: 51518, cityId: 2701, code: "711326" },
    { id: 51519, cityId: 2701, code: "711327" },
    { id: 51520, cityId: 2701, code: "711401" },
    { id: 51521, cityId: 2701, code: "711403" },
    { id: 51522, cityId: 2701, code: "711404" },
    { id: 51523, cityId: 2701, code: "711406" },
    { id: 51524, cityId: 2701, code: "711409" },
    { id: 51525, cityId: 2701, code: "711411" },
    { id: 51526, cityId: 2701, code: "711412" },
    { id: 51527, cityId: 2701, code: "711414" },
    { id: 51528, cityId: 2701, code: "711416" },
    { id: 51529, cityId: 2701, code: "711103" },
    { id: 51530, cityId: 2701, code: "711105" },
    { id: 51531, cityId: 2701, code: "711106" },
    { id: 51532, cityId: 2701, code: "711108" },
    { id: 51533, cityId: 2701, code: "711201" },
    { id: 51534, cityId: 2701, code: "711203" },
    { id: 51535, cityId: 2701, code: "711204" },
    { id: 51536, cityId: 2701, code: "711224" },
    { id: 51537, cityId: 2701, code: "711225" },
    { id: 51538, cityId: 2701, code: "711227" },
    { id: 51539, cityId: 2701, code: "711301" },
    { id: 51540, cityId: 2701, code: "711302" },
    { id: 51541, cityId: 2701, code: "711304" },
    { id: 51542, cityId: 2701, code: "711307" },
    { id: 51543, cityId: 2701, code: "711309" },
    { id: 51544, cityId: 2701, code: "711310" },
    { id: 51545, cityId: 2701, code: "711312" },
    { id: 51546, cityId: 2701, code: "711315" },
    { id: 51547, cityId: 2701, code: "711323" },
    { id: 51548, cityId: 2701, code: "711325" },
    { id: 51549, cityId: 2701, code: "711402" },
    { id: 51550, cityId: 2701, code: "711408" },
    { id: 51551, cityId: 2701, code: "711410" },
    { id: 51552, cityId: 2701, code: "711413" },
    { id: 51553, cityId: 2701, code: "711415" },
    { id: 51554, cityId: 2702, code: "733202" },
    { id: 51555, cityId: 2702, code: "801303" },
    { id: 51556, cityId: 2703, code: "735101" },
    { id: 51557, cityId: 2703, code: "735132" },
    { id: 51558, cityId: 2703, code: "735133" },
    { id: 51559, cityId: 2703, code: "735135" },
    { id: 51560, cityId: 2703, code: "735138" },
    { id: 51561, cityId: 2703, code: "735140" },
    { id: 51562, cityId: 2703, code: "735201" },
    { id: 51563, cityId: 2703, code: "735202" },
    { id: 51564, cityId: 2703, code: "735204" },
    { id: 51565, cityId: 2703, code: "735207" },
    { id: 51566, cityId: 2703, code: "735209" },
    { id: 51567, cityId: 2703, code: "735210" },
    { id: 51568, cityId: 2703, code: "735215" },
    { id: 51569, cityId: 2703, code: "735217" },
    { id: 51570, cityId: 2703, code: "735220" },
    { id: 51571, cityId: 2703, code: "735223" },
    { id: 51572, cityId: 2703, code: "735225" },
    { id: 51573, cityId: 2703, code: "735228" },
    { id: 51574, cityId: 2703, code: "735230" },
    { id: 51575, cityId: 2703, code: "735231" },
    { id: 51576, cityId: 2703, code: "735233" },
    { id: 51577, cityId: 2703, code: "735236" },
    { id: 51578, cityId: 2703, code: "735238" },
    { id: 51579, cityId: 2703, code: "735302" },
    { id: 51580, cityId: 2703, code: "735305" },
    { id: 51581, cityId: 2703, code: "735307" },
    { id: 51582, cityId: 2703, code: "736121" },
    { id: 51583, cityId: 2703, code: "736202" },
    { id: 51584, cityId: 2703, code: "736203" },
    { id: 51585, cityId: 2703, code: "736205" },
    { id: 51586, cityId: 2703, code: "736208" },
    { id: 51587, cityId: 2703, code: "735102" },
    { id: 51588, cityId: 2703, code: "735121" },
    { id: 51589, cityId: 2703, code: "735136" },
    { id: 51590, cityId: 2703, code: "735137" },
    { id: 51591, cityId: 2703, code: "735139" },
    { id: 51592, cityId: 2703, code: "735203" },
    { id: 51593, cityId: 2703, code: "735205" },
    { id: 51594, cityId: 2703, code: "735206" },
    { id: 51595, cityId: 2703, code: "735208" },
    { id: 51596, cityId: 2703, code: "735213" },
    { id: 51597, cityId: 2703, code: "735214" },
    { id: 51598, cityId: 2703, code: "735216" },
    { id: 51599, cityId: 2703, code: "735219" },
    { id: 51600, cityId: 2703, code: "735221" },
    { id: 51601, cityId: 2703, code: "735222" },
    { id: 51602, cityId: 2703, code: "735224" },
    { id: 51603, cityId: 2703, code: "735226" },
    { id: 51604, cityId: 2703, code: "735227" },
    { id: 51605, cityId: 2703, code: "735229" },
    { id: 51606, cityId: 2703, code: "735232" },
    { id: 51607, cityId: 2703, code: "735234" },
    { id: 51608, cityId: 2703, code: "735235" },
    { id: 51609, cityId: 2703, code: "735237" },
    { id: 51610, cityId: 2703, code: "735301" },
    { id: 51611, cityId: 2703, code: "735306" },
    { id: 51612, cityId: 2703, code: "735505" },
    { id: 51613, cityId: 2703, code: "736122" },
    { id: 51614, cityId: 2703, code: "736130" },
    { id: 51615, cityId: 2703, code: "736201" },
    { id: 51616, cityId: 2703, code: "736206" },
    { id: 51617, cityId: 2703, code: "736207" },
    { id: 51618, cityId: 2704, code: "742213" },
    { id: 51619, cityId: 2705, code: "723202" },
    { id: 51620, cityId: 2706, code: "734301" },
    { id: 51621, cityId: 2707, code: "713409" },
    { id: 51622, cityId: 2708, code: "741235" },
    { id: 51623, cityId: 2709, code: "700058" },
    { id: 51624, cityId: 2710, code: "712234" },
    { id: 51625, cityId: 2711, code: "741251" },
    { id: 51626, cityId: 2711, code: "743145" },
    { id: 51627, cityId: 2712, code: "741152" },
    { id: 51628, cityId: 2713, code: "700042" },
    { id: 51629, cityId: 2713, code: "854330" },
    { id: 51630, cityId: 2714, code: "713343" },
    { id: 51631, cityId: 2715, code: "721301" },
    { id: 51632, cityId: 2716, code: "140301" },
    { id: 51633, cityId: 2716, code: "721222" },
    { id: 51634, cityId: 2717, code: "735303" },
    { id: 51635, cityId: 2717, code: "736102" },
    { id: 51636, cityId: 2717, code: "736132" },
    { id: 51637, cityId: 2717, code: "736134" },
    { id: 51638, cityId: 2717, code: "736135" },
    { id: 51639, cityId: 2717, code: "736145" },
    { id: 51640, cityId: 2717, code: "736150" },
    { id: 51641, cityId: 2717, code: "736156" },
    { id: 51642, cityId: 2717, code: "736158" },
    { id: 51643, cityId: 2717, code: "736166" },
    { id: 51644, cityId: 2717, code: "736171" },
    { id: 51645, cityId: 2717, code: "736172" },
    { id: 51646, cityId: 2717, code: "736101" },
    { id: 51647, cityId: 2717, code: "736131" },
    { id: 51648, cityId: 2717, code: "736133" },
    { id: 51649, cityId: 2717, code: "736159" },
    { id: 51650, cityId: 2717, code: "736160" },
    { id: 51651, cityId: 2717, code: "736165" },
    { id: 51652, cityId: 2717, code: "736167" },
    { id: 51653, cityId: 2717, code: "736168" },
    { id: 51654, cityId: 2717, code: "736170" },
    { id: 51655, cityId: 2717, code: "736204" },
    { id: 51656, cityId: 2717, code: "736257" },
    { id: 51657, cityId: 2718, code: "721134" },
    { id: 51658, cityId: 2718, code: "721171" },
    { id: 51659, cityId: 2719, code: "700001" },
    { id: 51660, cityId: 2719, code: "700003" },
    { id: 51661, cityId: 2719, code: "700006" },
    { id: 51662, cityId: 2719, code: "700008" },
    { id: 51663, cityId: 2719, code: "700009" },
    { id: 51664, cityId: 2719, code: "700011" },
    { id: 51665, cityId: 2719, code: "700014" },
    { id: 51666, cityId: 2719, code: "700016" },
    { id: 51667, cityId: 2719, code: "700017" },
    { id: 51668, cityId: 2719, code: "700019" },
    { id: 51669, cityId: 2719, code: "700022" },
    { id: 51670, cityId: 2719, code: "700024" },
    { id: 51671, cityId: 2719, code: "700025" },
    { id: 51672, cityId: 2719, code: "700027" },
    { id: 51673, cityId: 2719, code: "700030" },
    { id: 51674, cityId: 2719, code: "700032" },
    { id: 51675, cityId: 2719, code: "700033" },
    { id: 51676, cityId: 2719, code: "700035" },
    { id: 51677, cityId: 2719, code: "700040" },
    { id: 51678, cityId: 2719, code: "700041" },
    { id: 51679, cityId: 2719, code: "700043" },
    { id: 51680, cityId: 2719, code: "700046" },
    { id: 51681, cityId: 2719, code: "700048" },
    { id: 51682, cityId: 2719, code: "700051" },
    { id: 51683, cityId: 2719, code: "700053" },
    { id: 51684, cityId: 2719, code: "700054" },
    { id: 51685, cityId: 2719, code: "700059" },
    { id: 51686, cityId: 2719, code: "700062" },
    { id: 51687, cityId: 2719, code: "700067" },
    { id: 51688, cityId: 2719, code: "700069" },
    { id: 51689, cityId: 2719, code: "700072" },
    { id: 51690, cityId: 2719, code: "700085" },
    { id: 51691, cityId: 2719, code: "700002" },
    { id: 51692, cityId: 2719, code: "700004" },
    { id: 51693, cityId: 2719, code: "700005" },
    { id: 51694, cityId: 2719, code: "700007" },
    { id: 51695, cityId: 2719, code: "700010" },
    { id: 51696, cityId: 2719, code: "700012" },
    { id: 51697, cityId: 2719, code: "700013" },
    { id: 51698, cityId: 2719, code: "700015" },
    { id: 51699, cityId: 2719, code: "700018" },
    { id: 51700, cityId: 2719, code: "700020" },
    { id: 51701, cityId: 2719, code: "700021" },
    { id: 51702, cityId: 2719, code: "700023" },
    { id: 51703, cityId: 2719, code: "700026" },
    { id: 51704, cityId: 2719, code: "700028" },
    { id: 51705, cityId: 2719, code: "700029" },
    { id: 51706, cityId: 2719, code: "700031" },
    { id: 51707, cityId: 2719, code: "700034" },
    { id: 51708, cityId: 2719, code: "700036" },
    { id: 51709, cityId: 2719, code: "700037" },
    { id: 51710, cityId: 2719, code: "700039" },
    { id: 51711, cityId: 2719, code: "700042" },
    { id: 51712, cityId: 2719, code: "700044" },
    { id: 51713, cityId: 2719, code: "700045" },
    { id: 51714, cityId: 2719, code: "700047" },
    { id: 51715, cityId: 2719, code: "700049" },
    { id: 51716, cityId: 2719, code: "700050" },
    { id: 51717, cityId: 2719, code: "700052" },
    { id: 51719, cityId: 2719, code: "700060" },
    { id: 51720, cityId: 2719, code: "700066" },
    { id: 51721, cityId: 2719, code: "700068" },
    { id: 51722, cityId: 2719, code: "700071" },
    { id: 51723, cityId: 2719, code: "700087" },
    { id: 51724, cityId: 2719, code: "711204" },
    { id: 51725, cityId: 2720, code: "712235" },
    { id: 51726, cityId: 2721, code: "712421" },
    { id: 51727, cityId: 2721, code: "741101" },
    { id: 51728, cityId: 2721, code: "741102" },
    { id: 51729, cityId: 2721, code: "741104" },
    { id: 51730, cityId: 2721, code: "741123" },
    { id: 51731, cityId: 2721, code: "741125" },
    { id: 51732, cityId: 2721, code: "741126" },
    { id: 51733, cityId: 2721, code: "741139" },
    { id: 51734, cityId: 2721, code: "741154" },
    { id: 51735, cityId: 2721, code: "741155" },
    { id: 51736, cityId: 2721, code: "741157" },
    { id: 51737, cityId: 2721, code: "741160" },
    { id: 51738, cityId: 2721, code: "741162" },
    { id: 51739, cityId: 2721, code: "741163" },
    { id: 51740, cityId: 2721, code: "741165" },
    { id: 51741, cityId: 2721, code: "741168" },
    { id: 51742, cityId: 2721, code: "741170" },
    { id: 51743, cityId: 2721, code: "741171" },
    { id: 51744, cityId: 2721, code: "741173" },
    { id: 51745, cityId: 2721, code: "741176" },
    { id: 51746, cityId: 2721, code: "741178" },
    { id: 51747, cityId: 2721, code: "741181" },
    { id: 51748, cityId: 2721, code: "741184" },
    { id: 51749, cityId: 2721, code: "741186" },
    { id: 51750, cityId: 2721, code: "741187" },
    { id: 51751, cityId: 2721, code: "741189" },
    { id: 51752, cityId: 2721, code: "741192" },
    { id: 51753, cityId: 2721, code: "741194" },
    { id: 51754, cityId: 2721, code: "741195" },
    { id: 51755, cityId: 2721, code: "741197" },
    { id: 51756, cityId: 2721, code: "741199" },
    { id: 51757, cityId: 2721, code: "741221" },
    { id: 51758, cityId: 2721, code: "741232" },
    { id: 51759, cityId: 2721, code: "741247" },
    { id: 51760, cityId: 2721, code: "741250" },
    { id: 51761, cityId: 2721, code: "741252" },
    { id: 51762, cityId: 2721, code: "741253" },
    { id: 51763, cityId: 2721, code: "741255" },
    { id: 51764, cityId: 2721, code: "741313" },
    { id: 51765, cityId: 2721, code: "741314" },
    { id: 51766, cityId: 2721, code: "741316" },
    { id: 51767, cityId: 2721, code: "741319" },
    { id: 51768, cityId: 2721, code: "741401" },
    { id: 51769, cityId: 2721, code: "741403" },
    { id: 51770, cityId: 2721, code: "741501" },
    { id: 51771, cityId: 2721, code: "741502" },
    { id: 51772, cityId: 2721, code: "741504" },
    { id: 51773, cityId: 2721, code: "741507" },
    { id: 51774, cityId: 2721, code: "741103" },
    { id: 51775, cityId: 2721, code: "741121" },
    { id: 51776, cityId: 2721, code: "741122" },
    { id: 51777, cityId: 2721, code: "741124" },
    { id: 51778, cityId: 2721, code: "741127" },
    { id: 51779, cityId: 2721, code: "741137" },
    { id: 51780, cityId: 2721, code: "741138" },
    { id: 51781, cityId: 2721, code: "741140" },
    { id: 51782, cityId: 2721, code: "741150" },
    { id: 51783, cityId: 2721, code: "741151" },
    { id: 51784, cityId: 2721, code: "741153" },
    { id: 51785, cityId: 2721, code: "741156" },
    { id: 51786, cityId: 2721, code: "741158" },
    { id: 51787, cityId: 2721, code: "741161" },
    { id: 51788, cityId: 2721, code: "741164" },
    { id: 51789, cityId: 2721, code: "741166" },
    { id: 51790, cityId: 2721, code: "741167" },
    { id: 51791, cityId: 2721, code: "741169" },
    { id: 51792, cityId: 2721, code: "741172" },
    { id: 51793, cityId: 2721, code: "741174" },
    { id: 51794, cityId: 2721, code: "741175" },
    { id: 51795, cityId: 2721, code: "741177" },
    { id: 51796, cityId: 2721, code: "741180" },
    { id: 51797, cityId: 2721, code: "741182" },
    { id: 51798, cityId: 2721, code: "741183" },
    { id: 51799, cityId: 2721, code: "741185" },
    { id: 51800, cityId: 2721, code: "741190" },
    { id: 51801, cityId: 2721, code: "741191" },
    { id: 51802, cityId: 2721, code: "741193" },
    { id: 51803, cityId: 2721, code: "741196" },
    { id: 51804, cityId: 2721, code: "741201" },
    { id: 51805, cityId: 2721, code: "741236" },
    { id: 51806, cityId: 2721, code: "741238" },
    { id: 51807, cityId: 2721, code: "741243" },
    { id: 51808, cityId: 2721, code: "741246" },
    { id: 51809, cityId: 2721, code: "741248" },
    { id: 51810, cityId: 2721, code: "741249" },
    { id: 51811, cityId: 2721, code: "741251" },
    { id: 51812, cityId: 2721, code: "741254" },
    { id: 51813, cityId: 2721, code: "741256" },
    { id: 51814, cityId: 2721, code: "741257" },
    { id: 51815, cityId: 2721, code: "741301" },
    { id: 51816, cityId: 2721, code: "741302" },
    { id: 51817, cityId: 2721, code: "741312" },
    { id: 51818, cityId: 2721, code: "741315" },
    { id: 51819, cityId: 2721, code: "741317" },
    { id: 51820, cityId: 2721, code: "741318" },
    { id: 51821, cityId: 2721, code: "741402" },
    { id: 51822, cityId: 2721, code: "741503" },
    { id: 51823, cityId: 2721, code: "741505" },
    { id: 51824, cityId: 2721, code: "741506" },
    { id: 51825, cityId: 2722, code: "742185" },
    { id: 51826, cityId: 2722, code: "712601" },
    { id: 51827, cityId: 2723, code: "713343" },
    { id: 51828, cityId: 2724, code: "734203" },
    { id: 51829, cityId: 2725, code: "741245" },
    { id: 51830, cityId: 2726, code: "743289" },
    { id: 51831, cityId: 2727, code: "736146" },
    { id: 51832, cityId: 2728, code: "713202" },
    { id: 51833, cityId: 2728, code: "713205" },
    { id: 51834, cityId: 2728, code: "713210" },
    { id: 51835, cityId: 2728, code: "713213" },
    { id: 51836, cityId: 2728, code: "721101" },
    { id: 51837, cityId: 2728, code: "721125" },
    { id: 51838, cityId: 2728, code: "721127" },
    { id: 51839, cityId: 2728, code: "721130" },
    { id: 51840, cityId: 2728, code: "721133" },
    { id: 51841, cityId: 2728, code: "721135" },
    { id: 51842, cityId: 2728, code: "721138" },
    { id: 51843, cityId: 2728, code: "721140" },
    { id: 51844, cityId: 2728, code: "721141" },
    { id: 51845, cityId: 2728, code: "721146" },
    { id: 51846, cityId: 2728, code: "721148" },
    { id: 51847, cityId: 2728, code: "721151" },
    { id: 51848, cityId: 2728, code: "721154" },
    { id: 51849, cityId: 2728, code: "721156" },
    { id: 51850, cityId: 2728, code: "721157" },
    { id: 51851, cityId: 2728, code: "721159" },
    { id: 51852, cityId: 2728, code: "721162" },
    { id: 51853, cityId: 2728, code: "721164" },
    { id: 51854, cityId: 2728, code: "721165" },
    { id: 51855, cityId: 2728, code: "721167" },
    { id: 51856, cityId: 2728, code: "721170" },
    { id: 51857, cityId: 2728, code: "721201" },
    { id: 51858, cityId: 2728, code: "721252" },
    { id: 51859, cityId: 2728, code: "721254" },
    { id: 51860, cityId: 2728, code: "721257" },
    { id: 51861, cityId: 2728, code: "721260" },
    { id: 51862, cityId: 2728, code: "721302" },
    { id: 51863, cityId: 2728, code: "721305" },
    { id: 51864, cityId: 2728, code: "721307" },
    { id: 51865, cityId: 2728, code: "721421" },
    { id: 51866, cityId: 2728, code: "721424" },
    { id: 51867, cityId: 2728, code: "721426" },
    { id: 51868, cityId: 2728, code: "721427" },
    { id: 51869, cityId: 2728, code: "721432" },
    { id: 51870, cityId: 2728, code: "721434" },
    { id: 51871, cityId: 2728, code: "721435" },
    { id: 51872, cityId: 2728, code: "721437" },
    { id: 51873, cityId: 2728, code: "721440" },
    { id: 51874, cityId: 2728, code: "721442" },
    { id: 51875, cityId: 2728, code: "721443" },
    { id: 51876, cityId: 2728, code: "721445" },
    { id: 51877, cityId: 2728, code: "721448" },
    { id: 51878, cityId: 2728, code: "721450" },
    { id: 51879, cityId: 2728, code: "721451" },
    { id: 51880, cityId: 2728, code: "721453" },
    { id: 51881, cityId: 2728, code: "721456" },
    { id: 51882, cityId: 2728, code: "721459" },
    { id: 51883, cityId: 2728, code: "721464" },
    { id: 51884, cityId: 2728, code: "721466" },
    { id: 51885, cityId: 2728, code: "721501" },
    { id: 51886, cityId: 2728, code: "721503" },
    { id: 51887, cityId: 2728, code: "721506" },
    { id: 51888, cityId: 2728, code: "721514" },
    { id: 51889, cityId: 2728, code: "721516" },
    { id: 51890, cityId: 2728, code: "721519" },
    { id: 51891, cityId: 2728, code: "721577" },
    { id: 51892, cityId: 2728, code: "721601" },
    { id: 51893, cityId: 2728, code: "721602" },
    { id: 51894, cityId: 2728, code: "721607" },
    { id: 51895, cityId: 2728, code: "721625" },
    { id: 51896, cityId: 2728, code: "721628" },
    { id: 51897, cityId: 2728, code: "721630" },
    { id: 51898, cityId: 2728, code: "721631" },
    { id: 51899, cityId: 2728, code: "721633" },
    { id: 51900, cityId: 2728, code: "721636" },
    { id: 51901, cityId: 2728, code: "721641" },
    { id: 51902, cityId: 2728, code: "721644" },
    { id: 51903, cityId: 2728, code: "721646" },
    { id: 51904, cityId: 2728, code: "721649" },
    { id: 51905, cityId: 2728, code: "721652" },
    { id: 51906, cityId: 2728, code: "721654" },
    { id: 51907, cityId: 2728, code: "721655" },
    { id: 51908, cityId: 2728, code: "721657" },
    { id: 51909, cityId: 2728, code: "721660" },
    { id: 51910, cityId: 2728, code: "721662" },
    { id: 51911, cityId: 2728, code: "721665" },
    { id: 51912, cityId: 2728, code: "721667" },
    { id: 51913, cityId: 2728, code: "721668" },
    { id: 51914, cityId: 2728, code: "721670" },
    { id: 51915, cityId: 2728, code: "722145" },
    { id: 51916, cityId: 2728, code: "731223" },
    { id: 51917, cityId: 2728, code: "713201" },
    { id: 51918, cityId: 2728, code: "713204" },
    { id: 51919, cityId: 2728, code: "713207" },
    { id: 51920, cityId: 2728, code: "713209" },
    { id: 51921, cityId: 2728, code: "713214" },
    { id: 51922, cityId: 2728, code: "721102" },
    { id: 51923, cityId: 2728, code: "721121" },
    { id: 51924, cityId: 2728, code: "721123" },
    { id: 51925, cityId: 2728, code: "721126" },
    { id: 51926, cityId: 2728, code: "721128" },
    { id: 51927, cityId: 2728, code: "721129" },
    { id: 51928, cityId: 2728, code: "721136" },
    { id: 51929, cityId: 2728, code: "721137" },
    { id: 51930, cityId: 2728, code: "721142" },
    { id: 51931, cityId: 2728, code: "721144" },
    { id: 51932, cityId: 2728, code: "721147" },
    { id: 51933, cityId: 2728, code: "721150" },
    { id: 51934, cityId: 2728, code: "721152" },
    { id: 51935, cityId: 2728, code: "721153" },
    { id: 51936, cityId: 2728, code: "721155" },
    { id: 51937, cityId: 2728, code: "721158" },
    { id: 51938, cityId: 2728, code: "721160" },
    { id: 51939, cityId: 2728, code: "721161" },
    { id: 51940, cityId: 2728, code: "721163" },
    { id: 51941, cityId: 2728, code: "721166" },
    { id: 51942, cityId: 2728, code: "721168" },
    { id: 51943, cityId: 2728, code: "721169" },
    { id: 51944, cityId: 2728, code: "721211" },
    { id: 51945, cityId: 2728, code: "721232" },
    { id: 51946, cityId: 2728, code: "721253" },
    { id: 51947, cityId: 2728, code: "721256" },
    { id: 51948, cityId: 2728, code: "721258" },
    { id: 51949, cityId: 2728, code: "721259" },
    { id: 51950, cityId: 2728, code: "721303" },
    { id: 51951, cityId: 2728, code: "721304" },
    { id: 51952, cityId: 2728, code: "721306" },
    { id: 51953, cityId: 2728, code: "721401" },
    { id: 51954, cityId: 2728, code: "721423" },
    { id: 51955, cityId: 2728, code: "721425" },
    { id: 51956, cityId: 2728, code: "721428" },
    { id: 51957, cityId: 2728, code: "721430" },
    { id: 51958, cityId: 2728, code: "721431" },
    { id: 51959, cityId: 2728, code: "721433" },
    { id: 51960, cityId: 2728, code: "721436" },
    { id: 51961, cityId: 2728, code: "721438" },
    { id: 51962, cityId: 2728, code: "721439" },
    { id: 51963, cityId: 2728, code: "721444" },
    { id: 51964, cityId: 2728, code: "721446" },
    { id: 51965, cityId: 2728, code: "721447" },
    { id: 51966, cityId: 2728, code: "721449" },
    { id: 51967, cityId: 2728, code: "721452" },
    { id: 51968, cityId: 2728, code: "721454" },
    { id: 51969, cityId: 2728, code: "721455" },
    { id: 51970, cityId: 2728, code: "721457" },
    { id: 51971, cityId: 2728, code: "721460" },
    { id: 51972, cityId: 2728, code: "721462" },
    { id: 51973, cityId: 2728, code: "721465" },
    { id: 51974, cityId: 2728, code: "721467" },
    { id: 51975, cityId: 2728, code: "721502" },
    { id: 51976, cityId: 2728, code: "721505" },
    { id: 51977, cityId: 2728, code: "721507" },
    { id: 51978, cityId: 2728, code: "721513" },
    { id: 51979, cityId: 2728, code: "721515" },
    { id: 51980, cityId: 2728, code: "721518" },
    { id: 51981, cityId: 2728, code: "721603" },
    { id: 51982, cityId: 2728, code: "721605" },
    { id: 51983, cityId: 2728, code: "721606" },
    { id: 51984, cityId: 2728, code: "721626" },
    { id: 51985, cityId: 2728, code: "721627" },
    { id: 51986, cityId: 2728, code: "721629" },
    { id: 51987, cityId: 2728, code: "721632" },
    { id: 51988, cityId: 2728, code: "721634" },
    { id: 51989, cityId: 2728, code: "721635" },
    { id: 51990, cityId: 2728, code: "721642" },
    { id: 51991, cityId: 2728, code: "721643" },
    { id: 51992, cityId: 2728, code: "721645" },
    { id: 51993, cityId: 2728, code: "721648" },
    { id: 51994, cityId: 2728, code: "721650" },
    { id: 51995, cityId: 2728, code: "721651" },
    { id: 51996, cityId: 2728, code: "721653" },
    { id: 51997, cityId: 2728, code: "721656" },
    { id: 51998, cityId: 2728, code: "721658" },
    { id: 51999, cityId: 2728, code: "721659" },
    { id: 52000, cityId: 2728, code: "721663" },
    { id: 52001, cityId: 2728, code: "721666" },
    { id: 52002, cityId: 2728, code: "721669" },
    { id: 52003, cityId: 2729, code: "735304" },
    { id: 52004, cityId: 2730, code: "713146" },
    { id: 52005, cityId: 2731, code: "734214" },
    { id: 52006, cityId: 2732, code: "712246" },
    { id: 52007, cityId: 2732, code: "713166" },
    { id: 52008, cityId: 2732, code: "742184" },
    { id: 52009, cityId: 2733, code: "743164" },
    { id: 52010, cityId: 2733, code: "743165" },
    { id: 52011, cityId: 2734, code: "741202" },
    { id: 52012, cityId: 2735, code: "712416" },
    { id: 52013, cityId: 2736, code: "711322" },
    { id: 52014, cityId: 2737, code: "712149" },
    { id: 52015, cityId: 2738, code: "743176" },
    { id: 52016, cityId: 2739, code: "713516" },
    { id: 52017, cityId: 2740, code: "712153" },
    { id: 52018, cityId: 2740, code: "722213" },
    { id: 52019, cityId: 2740, code: "723101" },
    { id: 52020, cityId: 2740, code: "723103" },
    { id: 52021, cityId: 2740, code: "723127" },
    { id: 52022, cityId: 2740, code: "723129" },
    { id: 52023, cityId: 2740, code: "723130" },
    { id: 52024, cityId: 2740, code: "723132" },
    { id: 52025, cityId: 2740, code: "723143" },
    { id: 52026, cityId: 2740, code: "723145" },
    { id: 52027, cityId: 2740, code: "723146" },
    { id: 52028, cityId: 2740, code: "723148" },
    { id: 52029, cityId: 2740, code: "723151" },
    { id: 52030, cityId: 2740, code: "723154" },
    { id: 52031, cityId: 2740, code: "723156" },
    { id: 52032, cityId: 2740, code: "723158" },
    { id: 52033, cityId: 2740, code: "723159" },
    { id: 52034, cityId: 2740, code: "723161" },
    { id: 52035, cityId: 2740, code: "723164" },
    { id: 52036, cityId: 2740, code: "723166" },
    { id: 52037, cityId: 2740, code: "723167" },
    { id: 52038, cityId: 2740, code: "723201" },
    { id: 52039, cityId: 2740, code: "723212" },
    { id: 52040, cityId: 2740, code: "723214" },
    { id: 52041, cityId: 2740, code: "723315" },
    { id: 52042, cityId: 2740, code: "700068" },
    { id: 52043, cityId: 2740, code: "722143" },
    { id: 52044, cityId: 2740, code: "723102" },
    { id: 52045, cityId: 2740, code: "723126" },
    { id: 52046, cityId: 2740, code: "723128" },
    { id: 52047, cityId: 2740, code: "723131" },
    { id: 52048, cityId: 2740, code: "723144" },
    { id: 52049, cityId: 2740, code: "723149" },
    { id: 52050, cityId: 2740, code: "723150" },
    { id: 52051, cityId: 2740, code: "723152" },
    { id: 52052, cityId: 2740, code: "723155" },
    { id: 52053, cityId: 2740, code: "723157" },
    { id: 52054, cityId: 2740, code: "723160" },
    { id: 52055, cityId: 2740, code: "723162" },
    { id: 52056, cityId: 2740, code: "723163" },
    { id: 52057, cityId: 2740, code: "723165" },
    { id: 52058, cityId: 2740, code: "723168" },
    { id: 52059, cityId: 2740, code: "723216" },
    { id: 52060, cityId: 2741, code: "712247" },
    { id: 52061, cityId: 2741, code: "723133" },
    { id: 52062, cityId: 2741, code: "802134" },
    { id: 52063, cityId: 2742, code: "733134" },
    { id: 52064, cityId: 2743, code: "700056" },
    { id: 52065, cityId: 2744, code: "743518" },
    { id: 52066, cityId: 2745, code: "721647" },
    { id: 52067, cityId: 2746, code: "721242" },
    { id: 52068, cityId: 2747, code: "201009" },
    { id: 52069, cityId: 2747, code: "221008" },
    { id: 52070, cityId: 2747, code: "243303" },
    { id: 52071, cityId: 2747, code: "224181" },
    { id: 52072, cityId: 2747, code: "247667" },
    { id: 52073, cityId: 2747, code: "250002" },
    { id: 52074, cityId: 2747, code: "712411" },
    { id: 52075, cityId: 2747, code: "721441" },
    { id: 52076, cityId: 2748, code: "712248" },
    { id: 52077, cityId: 2749, code: "700038" },
    { id: 52078, cityId: 2750, code: "731234" },
    { id: 52079, cityId: 2751, code: "711313" },
    { id: 52080, cityId: 2752, code: "741404" },
    { id: 52081, cityId: 2753, code: "700075" },
    { id: 52082, cityId: 2753, code: "743612" },
    { id: 52083, cityId: 2754, code: "722150" },
    { id: 52084, cityId: 2755, code: "700006" },
    { id: 52085, cityId: 2756, code: "712409" },
    { id: 52086, cityId: 2757, code: "722207" },
    { id: 52087, cityId: 2758, code: "731102" },
    { id: 52088, cityId: 2758, code: "731121" },
    { id: 52089, cityId: 2758, code: "731123" },
    { id: 52090, cityId: 2758, code: "731124" },
    { id: 52091, cityId: 2758, code: "731126" },
    { id: 52092, cityId: 2758, code: "731128" },
    { id: 52093, cityId: 2758, code: "731129" },
    { id: 52094, cityId: 2758, code: "731131" },
    { id: 52095, cityId: 2758, code: "731134" },
    { id: 52096, cityId: 2758, code: "731136" },
    { id: 52097, cityId: 2758, code: "731137" },
    { id: 52098, cityId: 2758, code: "731139" },
    { id: 52099, cityId: 2758, code: "731142" },
    { id: 52100, cityId: 2758, code: "731144" },
    { id: 52101, cityId: 2758, code: "731145" },
    { id: 52102, cityId: 2758, code: "731147" },
    { id: 52103, cityId: 2758, code: "731203" },
    { id: 52104, cityId: 2758, code: "731214" },
    { id: 52105, cityId: 2758, code: "731216" },
    { id: 52106, cityId: 2758, code: "731219" },
    { id: 52107, cityId: 2758, code: "731221" },
    { id: 52108, cityId: 2758, code: "731222" },
    { id: 52109, cityId: 2758, code: "731224" },
    { id: 52110, cityId: 2758, code: "731234" },
    { id: 52111, cityId: 2758, code: "731237" },
    { id: 52112, cityId: 2758, code: "731240" },
    { id: 52113, cityId: 2758, code: "731242" },
    { id: 52114, cityId: 2758, code: "731243" },
    { id: 52115, cityId: 2758, code: "731245" },
    { id: 52116, cityId: 2758, code: "731250" },
    { id: 52117, cityId: 2758, code: "731251" },
    { id: 52118, cityId: 2758, code: "731253" },
    { id: 52119, cityId: 2758, code: "731301" },
    { id: 52120, cityId: 2758, code: "731303" },
    { id: 52121, cityId: 2758, code: "731304" },
    { id: 52122, cityId: 2758, code: "731101" },
    { id: 52123, cityId: 2758, code: "731103" },
    { id: 52124, cityId: 2758, code: "731122" },
    { id: 52125, cityId: 2758, code: "731125" },
    { id: 52126, cityId: 2758, code: "731127" },
    { id: 52127, cityId: 2758, code: "731130" },
    { id: 52128, cityId: 2758, code: "731132" },
    { id: 52129, cityId: 2758, code: "731133" },
    { id: 52130, cityId: 2758, code: "731135" },
    { id: 52131, cityId: 2758, code: "731138" },
    { id: 52132, cityId: 2758, code: "731140" },
    { id: 52133, cityId: 2758, code: "731141" },
    { id: 52134, cityId: 2758, code: "731143" },
    { id: 52135, cityId: 2758, code: "731146" },
    { id: 52136, cityId: 2758, code: "731201" },
    { id: 52137, cityId: 2758, code: "731202" },
    { id: 52138, cityId: 2758, code: "731204" },
    { id: 52139, cityId: 2758, code: "731215" },
    { id: 52140, cityId: 2758, code: "731217" },
    { id: 52141, cityId: 2758, code: "731218" },
    { id: 52142, cityId: 2758, code: "731220" },
    { id: 52143, cityId: 2758, code: "731223" },
    { id: 52144, cityId: 2758, code: "731233" },
    { id: 52145, cityId: 2758, code: "731236" },
    { id: 52146, cityId: 2758, code: "731238" },
    { id: 52147, cityId: 2758, code: "731239" },
    { id: 52148, cityId: 2758, code: "731241" },
    { id: 52149, cityId: 2758, code: "731244" },
    { id: 52150, cityId: 2758, code: "731246" },
    { id: 52151, cityId: 2758, code: "731247" },
    { id: 52152, cityId: 2758, code: "731249" },
    { id: 52153, cityId: 2758, code: "731252" },
    { id: 52154, cityId: 2758, code: "731254" },
    { id: 52155, cityId: 2758, code: "731255" },
    { id: 52156, cityId: 2758, code: "731284" },
    { id: 52157, cityId: 2758, code: "731302" },
    { id: 52158, cityId: 2759, code: "741159" },
    { id: 52159, cityId: 2760, code: "743429" },
    { id: 52160, cityId: 2761, code: "743188" },
    { id: 52161, cityId: 2762, code: "713363" },
    { id: 52162, cityId: 2763, code: "711315" },
    { id: 52164, cityId: 1530, code: "751015" },
    { id: 52165, cityId: 2765, code: "390021" },
    { id: 52168, cityId: 902, code: "574004" },
    { id: 52169, cityId: 564, code: "122002" },
    { id: 52170, cityId: 1002, code: "682018" },
    { id: 52171, cityId: 296, code: "456778" },
    { id: 52172, cityId: 2764, code: "201303" },
    { id: 52174, cityId: 1367, code: "401107" },
    { id: 52175, cityId: 2771, code: "734001" },
    { id: 52176, cityId: 2780, code: "410210" },
    { id: 52177, cityId: 2780, code: "400705" },
    { id: 52178, cityId: 2780, code: "400709" },
    { id: 52179, cityId: 1367, code: "401501" },
    { id: 52180, cityId: 2784, code: "249401" },
    { id: 52181, cityId: 2785, code: "637211" },
    { id: 52182, cityId: 2779, code: "441614" },
    { id: 52183, cityId: 382, code: "201011" },
    { id: 52184, cityId: 2787, code: "394601" },
    { id: 52185, cityId: 2300, code: "201010" },
    { id: 52186, cityId: 503, code: "360007" },
    { id: 52187, cityId: 1367, code: "400042" },
    { id: 52189, cityId: 2780, code: "410209" },
    { id: 52190, cityId: 2791, code: "410206" },
    { id: 52191, cityId: 2780, code: "400706" },
    { id: 52192, cityId: 1439, code: "400610" },
    { id: 52193, cityId: 1378, code: "422009" },
    { id: 52194, cityId: 1367, code: "400076" },
    { id: 52195, cityId: 1445, code: "421004" },
    { id: 52196, cityId: 2786, code: "142026" },
    { id: 52197, cityId: 2772, code: "141000" },
    { id: 52199, cityId: 1401, code: "411037" },
    { id: 52200, cityId: 49, code: "500050" },
    { id: 52201, cityId: 531, code: "390020" },
    { id: 52202, cityId: 1313, code: "435001" },
    { id: 52203, cityId: 1121, code: "462042" },
    { id: 52204, cityId: 49, code: "500054" },
    { id: 52205, cityId: 2780, code: "400708" },
    { id: 52206, cityId: 1337, code: "416013" },
    { id: 52207, cityId: 519, code: "395010" },
    { id: 52208, cityId: 2794, code: "402109" },
    { id: 52209, cityId: 2796, code: "403806" },
    { id: 52210, cityId: 2795, code: "403507" },
    { id: 52211, cityId: 2797, code: "141100" },
    { id: 52212, cityId: 49, code: "500072" },
    { id: 52213, cityId: 49, code: "500068" },
    { id: 52214, cityId: 2771, code: "734006" },
    { id: 52215, cityId: 853, code: "580021" },
    { id: 52216, cityId: 1261, code: "431003" },
    { id: 52217, cityId: 405, code: "382210" },
    { id: 52218, cityId: 1744, code: "302039" },
    { id: 52219, cityId: 49, code: "500060" },
    { id: 52220, cityId: 49, code: "500094" },
    { id: 52221, cityId: 49, code: "500070" },
    { id: 52222, cityId: 781, code: "560094" },
    { id: 52223, cityId: 821, code: "580011" },
    { id: 52224, cityId: 781, code: "560102" },
    { id: 52225, cityId: 564, code: "122011" },
    { id: 52226, cityId: 49, code: "500062" },
    { id: 52227, cityId: 49, code: "500078" },
    { id: 52228, cityId: 1925, code: "600166" },
    { id: 52229, cityId: 1889, code: "642120" },
    { id: 52230, cityId: 121, code: "530032" },
    { id: 52231, cityId: 781, code: "560098" },
    { id: 52232, cityId: 557, code: "121010" },
    { id: 52233, cityId: 557, code: "121009" },
    { id: 52234, cityId: 2802, code: "700110" },
    { id: 52235, cityId: 2300, code: "201015" },
    { id: 52236, cityId: 99, code: "500090" },
    { id: 52237, cityId: 1880, code: "600117" },
    { id: 52238, cityId: 49, code: "500081" },
    { id: 52239, cityId: 1439, code: "401208" },
    { id: 52240, cityId: 2719, code: "700141" },
    { id: 52241, cityId: 2719, code: "700148" },
    { id: 52242, cityId: 2805, code: "201308" },
    { id: 52243, cityId: 1439, code: "421506" },
    { id: 52244, cityId: 1268, code: "431222" },
    { id: 52245, cityId: 2798, code: "631002" },
    { id: 52246, cityId: 2807, code: "760002" },
    { id: 52247, cityId: 2701, code: "711114" },
    { id: 52248, cityId: 1154, code: "452018" },
    { id: 52249, cityId: 337, code: "495559" },
    { id: 52250, cityId: 2809, code: "490020" },
    { id: 52251, cityId: 2810, code: "629001" },
    { id: 52252, cityId: 2771, code: "734002" },
    { id: 52253, cityId: 2771, code: "734003" },
    { id: 52254, cityId: 2771, code: "734004" },
    { id: 52255, cityId: 2771, code: "734005" },
    { id: 52256, cityId: 2771, code: "734007" },
    { id: 52257, cityId: 2771, code: "734009" },
    { id: 52258, cityId: 2771, code: "734008" },
    { id: 52259, cityId: 2641, code: "700157" },
    { id: 52260, cityId: 2641, code: "700101" },
    { id: 52261, cityId: 2641, code: "700102" },
    { id: 52262, cityId: 2744, code: "700136" },
    { id: 52263, cityId: 2812, code: "700091" },
    { id: 52264, cityId: 2641, code: "743201" },
    { id: 52265, cityId: 2641, code: "743222" },
    { id: 52266, cityId: 2641, code: "700055" },
    { id: 52267, cityId: 2813, code: "380058" },
    { id: 52268, cityId: 49, code: "500019" },
    { id: 52269, cityId: 49, code: "500074" },
    { id: 52270, cityId: 49, code: "500055" },
    { id: 52271, cityId: 49, code: "500080" },
    { id: 52272, cityId: 49, code: "500073" },
    { id: 52273, cityId: 49, code: "500009" },
    { id: 52274, cityId: 49, code: "500064" },
    { id: 52275, cityId: 405, code: "380059" },
    { id: 52276, cityId: 447, code: "382006" },
    { id: 52277, cityId: 49, code: "500056" },
    { id: 52278, cityId: 49, code: "500061" },
    { id: 52279, cityId: 49, code: "500063" },
    { id: 52280, cityId: 49, code: "500065" },
    { id: 52281, cityId: 49, code: "500066" },
    { id: 52282, cityId: 49, code: "500067" },
    { id: 52283, cityId: 49, code: "500069" },
    { id: 52284, cityId: 49, code: "500071" },
    { id: 52285, cityId: 49, code: "500075" },
    { id: 52286, cityId: 49, code: "500076" },
    { id: 52287, cityId: 49, code: "500077" },
    { id: 52288, cityId: 49, code: "500079" },
    { id: 52289, cityId: 1880, code: "600114" },
    { id: 52290, cityId: 1880, code: "600115" },
    { id: 52291, cityId: 1880, code: "600116" },
    { id: 52292, cityId: 49, code: "500098" },
    { id: 52293, cityId: 49, code: "500084" },
    { id: 52294, cityId: 49, code: "500096" },
    { id: 52295, cityId: 405, code: "380063" },
    { id: 52296, cityId: 1401, code: "411048" },
    { id: 52297, cityId: 2175, code: "211019" },
    { id: 52298, cityId: 2175, code: "211016" },
    { id: 52299, cityId: 2175, code: "226024" },
    { id: 52300, cityId: 405, code: "380060" },
    { id: 52301, cityId: 405, code: "380038" },
    { id: 52302, cityId: 447, code: "382007" },
    { id: 52303, cityId: 405, code: "382428" },
    { id: 52304, cityId: 2641, code: "700140" },
    { id: 52305, cityId: 1508, code: "797005" },
    { id: 52306, cityId: 1510, code: "797114" },
    { id: 52307, cityId: 1464, code: "795118" },
    { id: 52308, cityId: 1002, code: "682038" },
    { id: 52309, cityId: 1002, code: "682306" },
    { id: 52310, cityId: 1002, code: "682041" },
    { id: 52311, cityId: 2719, code: "700118" },
    { id: 52312, cityId: 1054, code: "679505" },
    { id: 52313, cityId: 286, code: "855116" },
    { id: 52314, cityId: 2677, code: "734320" },
    { id: 52315, cityId: 5, code: "504303" },
    { id: 52316, cityId: 5, code: "504302" },
    { id: 52317, cityId: 5, code: "504107" },
    { id: 52318, cityId: 5, code: "504297" },
    { id: 52319, cityId: 5, code: "504219" },
    { id: 52320, cityId: 124, code: "506170" },
    { id: 52321, cityId: 124, code: "506169" },
    { id: 52322, cityId: 76, code: "502335" },
    { id: 52323, cityId: 76, code: "502115" },
    { id: 52324, cityId: 76, code: "502125" },
    { id: 52325, cityId: 76, code: "502336" },
    { id: 52326, cityId: 78, code: "508004" },
    { id: 52327, cityId: 78, code: "508377" },
    { id: 52328, cityId: 86, code: "503322" },
    { id: 52329, cityId: 2441, code: "503108" },
    { id: 52330, cityId: 76, code: "502205" },
    { id: 52331, cityId: 76, code: "502345" },
    { id: 52332, cityId: 76, code: "502300" },
    { id: 52333, cityId: 76, code: "502032" },
    { id: 52334, cityId: 76, code: "502295" },
    { id: 52335, cityId: 76, code: "502316" },
    { id: 52336, cityId: 124, code: "506324" },
    { id: 52337, cityId: 124, code: "506365" },
    { id: 52338, cityId: 124, code: "506102" },
    { id: 52339, cityId: 124, code: "506135" },
    { id: 52340, cityId: 49, code: "500095" },
    { id: 52341, cityId: 49, code: "500091" },
    { id: 52342, cityId: 49, code: "500033" },
    { id: 52343, cityId: 49, code: "500082" },
    { id: 52344, cityId: 49, code: "500057" },
    { id: 52345, cityId: 49, code: "500058" },
    { id: 52346, cityId: 49, code: "500053" },
    { id: 52347, cityId: 49, code: "500059" },
    { id: 52348, cityId: 49, code: "500085" },
    { id: 52349, cityId: 49, code: "500087" },
    { id: 52350, cityId: 49, code: "500093" },
    { id: 52351, cityId: 27, code: "517426" },
    { id: 52352, cityId: 67, code: "518006" },
    { id: 52353, cityId: 67, code: "518007" },
    { id: 52354, cityId: 67, code: "518218" },
    { id: 52355, cityId: 67, code: "518508" },
    { id: 52356, cityId: 67, code: "518343" },
    { id: 52357, cityId: 67, code: "518010" },
    { id: 52358, cityId: 67, code: "518308" },
    { id: 52359, cityId: 67, code: "518313" },
    { id: 52360, cityId: 67, code: "518380" },
    { id: 52361, cityId: 93, code: "523334" },
    { id: 52362, cityId: 67, code: "518563" },
    { id: 52363, cityId: 93, code: "523336" },
    { id: 52364, cityId: 67, code: "518674" },
    { id: 52365, cityId: 67, code: "518502" },
    { id: 52366, cityId: 28, code: "516312" },
    { id: 52367, cityId: 28, code: "516355" },
    { id: 52368, cityId: 28, code: "516391" },
    { id: 52369, cityId: 27, code: "517645" },
    { id: 52370, cityId: 27, code: "517551" },
    { id: 52371, cityId: 27, code: "517582" },
    { id: 52372, cityId: 125, code: "534210" },
    { id: 52373, cityId: 125, code: "534245" },
    { id: 52374, cityId: 125, code: "534324" },
    { id: 52375, cityId: 125, code: "534338" },
    { id: 52376, cityId: 125, code: "534204" },
    { id: 52377, cityId: 125, code: "534442" },
    { id: 52378, cityId: 125, code: "534406" },
    { id: 52379, cityId: 125, code: "534432" },
    { id: 52380, cityId: 125, code: "534425" },
    { id: 52381, cityId: 125, code: "534467" },
    { id: 52382, cityId: 125, code: "534475" },
    { id: 52383, cityId: 125, code: "534007" },
    { id: 52384, cityId: 65, code: "521324" },
    { id: 52385, cityId: 83, code: "524342" },
    { id: 52386, cityId: 83, code: "524341" },
    { id: 52387, cityId: 83, code: "524345" },
    { id: 52388, cityId: 83, code: "524134" },
    { id: 52389, cityId: 65, code: "521328" },
    { id: 52390, cityId: 65, code: "521158" },
    { id: 52391, cityId: 45, code: "522437" },
    { id: 52392, cityId: 45, code: "522616" },
    { id: 52393, cityId: 45, code: "522647" },
    { id: 52394, cityId: 45, code: "522415" },
    { id: 52395, cityId: 45, code: "522414" },
    { id: 52396, cityId: 45, code: "522617" },
    { id: 52397, cityId: 45, code: "522438" },
    { id: 52398, cityId: 45, code: "522613" },
    { id: 52399, cityId: 45, code: "522619" },
    { id: 52400, cityId: 45, code: "522435" },
    { id: 52401, cityId: 83, code: "524239" },
    { id: 52402, cityId: 83, code: "524240" },
    { id: 52403, cityId: 93, code: "523116" },
    { id: 52404, cityId: 93, code: "523171" },
    { id: 52405, cityId: 93, code: "523214" },
    { id: 52406, cityId: 93, code: "523167" },
    { id: 52407, cityId: 93, code: "523117" },
    { id: 52408, cityId: 93, code: "523270" },
    { id: 52409, cityId: 125, code: "534165" },
    { id: 52410, cityId: 125, code: "534318" },
    { id: 52411, cityId: 45, code: "522113" },
    { id: 52412, cityId: 45, code: "522102" },
    { id: 52413, cityId: 45, code: "522341" },
    { id: 52414, cityId: 65, code: "521225" },
    { id: 52415, cityId: 65, code: "521457" },
    { id: 52416, cityId: 65, code: "521241" },
    { id: 52417, cityId: 65, code: "521180" },
    { id: 52418, cityId: 65, code: "521247" },
    { id: 52419, cityId: 34, code: "533229" },
    { id: 52420, cityId: 34, code: "533254" },
    { id: 52421, cityId: 120, code: "531020" },
    { id: 52422, cityId: 120, code: "531118" },
    { id: 52423, cityId: 120, code: "531019" },
    { id: 52424, cityId: 34, code: "533401" },
    { id: 52425, cityId: 34, code: "533444" },
    { id: 52426, cityId: 34, code: "533483" },
    { id: 52427, cityId: 122, code: "535559" },
    { id: 52428, cityId: 122, code: "535126" },
    { id: 52429, cityId: 122, code: "535547" },
    { id: 52430, cityId: 122, code: "535102" },
    { id: 52431, cityId: 122, code: "535524" },
    { id: 52432, cityId: 122, code: "535594" },
    { id: 52433, cityId: 122, code: "535591" },
    { id: 52434, cityId: 122, code: "535534" },
    { id: 52435, cityId: 122, code: "535501" },
    { id: 52436, cityId: 122, code: "535568" },
    { id: 52437, cityId: 122, code: "535592" },
    { id: 52438, cityId: 122, code: "535546" },
    { id: 52439, cityId: 122, code: "535124" },
    { id: 52440, cityId: 122, code: "535578" },
    { id: 52441, cityId: 122, code: "535526" },
    { id: 52442, cityId: 122, code: "535558" },
    { id: 52443, cityId: 122, code: "535502" },
    { id: 52444, cityId: 122, code: "535525" },
    { id: 52445, cityId: 122, code: "535521" },
    { id: 52446, cityId: 122, code: "535573" },
    { id: 52447, cityId: 122, code: "535579" },
    { id: 52448, cityId: 122, code: "535593" },
    { id: 52449, cityId: 122, code: "535101" },
    { id: 52450, cityId: 122, code: "535523" },
    { id: 52451, cityId: 122, code: "535527" },
    { id: 52452, cityId: 122, code: "535557" },
    { id: 52453, cityId: 122, code: "535463" },
    { id: 52454, cityId: 122, code: "535522" },
    { id: 52455, cityId: 34, code: "533296" },
    { id: 52456, cityId: 34, code: "533284" },
    { id: 52457, cityId: 34, code: "533297" },
    { id: 52458, cityId: 34, code: "533256" },
    { id: 52459, cityId: 34, code: "533102" },
    { id: 52460, cityId: 34, code: "533107" },
    { id: 52461, cityId: 109, code: "532186" },
    { id: 52462, cityId: 109, code: "532410" },
    { id: 52463, cityId: 109, code: "532203" },
    { id: 52464, cityId: 109, code: "532455" },
    { id: 52465, cityId: 120, code: "530041" },
    { id: 52466, cityId: 120, code: "530053" },
    { id: 52467, cityId: 120, code: "530045" },
    { id: 52468, cityId: 120, code: "530047" },
    { id: 52469, cityId: 120, code: "530044" },
    { id: 52470, cityId: 120, code: "530049" },
    { id: 52471, cityId: 120, code: "530051" },
    { id: 52472, cityId: 120, code: "530052" },
    { id: 52473, cityId: 120, code: "530046" },
    { id: 52474, cityId: 120, code: "530048" },
    { id: 52475, cityId: 120, code: "530043" },
    { id: 52476, cityId: 122, code: "535280" },
    { id: 52477, cityId: 122, code: "535581" },
    { id: 52478, cityId: 122, code: "535213" },
    { id: 52479, cityId: 122, code: "535260" },
    { id: 52480, cityId: 122, code: "535281" },
    { id: 52481, cityId: 122, code: "535220" },
    { id: 52482, cityId: 122, code: "535240" },
    { id: 52483, cityId: 122, code: "535217" },
    { id: 52484, cityId: 122, code: "535002" },
    { id: 52485, cityId: 122, code: "535204" },
    { id: 52486, cityId: 122, code: "535214" },
    { id: 52487, cityId: 122, code: "535580" },
    { id: 52488, cityId: 122, code: "535270" },
    { id: 52489, cityId: 122, code: "535216" },
    { id: 52490, cityId: 122, code: "535003" },
    { id: 52491, cityId: 122, code: "535221" },
    { id: 52492, cityId: 122, code: "535215" },
    { id: 52493, cityId: 122, code: "535006" },
    { id: 52494, cityId: 122, code: "535161" },
    { id: 52495, cityId: 122, code: "535218" },
    { id: 52496, cityId: 122, code: "535160" },
    { id: 52497, cityId: 122, code: "535148" },
    { id: 52498, cityId: 122, code: "535001" },
    { id: 52499, cityId: 122, code: "535004" },
    { id: 52500, cityId: 180, code: "788713" },
    { id: 52501, cityId: 172, code: "788168" },
    { id: 52502, cityId: 180, code: "788712" },
    { id: 52503, cityId: 180, code: "788728" },
    { id: 52504, cityId: 180, code: "788709" },
    { id: 52505, cityId: 164, code: "786692" },
    { id: 52506, cityId: 164, code: "786006" },
    { id: 52507, cityId: 161, code: "787061" },
    { id: 52508, cityId: 161, code: "787026" },
    { id: 52509, cityId: 164, code: "786191" },
    { id: 52510, cityId: 161, code: "787110" },
    { id: 52511, cityId: 192, code: "782106" },
    { id: 52512, cityId: 192, code: "782413" },
    { id: 52513, cityId: 194, code: "782144" },
    { id: 52514, cityId: 194, code: "782003" },
    { id: 52515, cityId: 194, code: "782429" },
    { id: 52516, cityId: 169, code: "785699" },
    { id: 52517, cityId: 178, code: "785704" },
    { id: 52518, cityId: 208, code: "785697" },
    { id: 52519, cityId: 169, code: "785609" },
    { id: 52520, cityId: 169, code: "785702" },
    { id: 52521, cityId: 178, code: "785700" },
    { id: 52522, cityId: 208, code: "785698" },
    { id: 52523, cityId: 215, code: "786126" },
    { id: 52524, cityId: 215, code: "786160" },
    { id: 52525, cityId: 215, code: "786190" },
    { id: 52526, cityId: 215, code: "786179" },
    { id: 52527, cityId: 215, code: "786188" },
    { id: 52528, cityId: 215, code: "786192" },
    { id: 52529, cityId: 215, code: "786187" },
    { id: 52530, cityId: 215, code: "786174" },
    { id: 52531, cityId: 215, code: "786156" },
    { id: 52532, cityId: 181, code: "783354" },
    { id: 52533, cityId: 181, code: "783375" },
    { id: 52534, cityId: 181, code: "783336" },
    { id: 52535, cityId: 163, code: "783128" },
    { id: 52536, cityId: 155, code: "783394" },
    { id: 52537, cityId: 181, code: "783369" },
    { id: 52538, cityId: 163, code: "783323" },
    { id: 52539, cityId: 181, code: "783376" },
    { id: 52540, cityId: 163, code: "783135" },
    { id: 52541, cityId: 155, code: "783393" },
    { id: 52542, cityId: 163, code: "783324" },
    { id: 52543, cityId: 150, code: "781313" },
    { id: 52544, cityId: 195, code: "781334" },
    { id: 52545, cityId: 150, code: "781311" },
    { id: 52546, cityId: 195, code: "781343" },
    { id: 52547, cityId: 195, code: "781138" },
    { id: 52548, cityId: 195, code: "781341" },
    { id: 52549, cityId: 195, code: "781340" },
    { id: 52550, cityId: 195, code: "781344" },
    { id: 52551, cityId: 195, code: "781312" },
    { id: 52552, cityId: 195, code: "781355" },
    { id: 52553, cityId: 195, code: "781333" },
    { id: 52554, cityId: 239, code: "851210" },
    { id: 52555, cityId: 283, code: "851202" },
    { id: 52556, cityId: 255, code: "847337" },
    { id: 52557, cityId: 255, code: "847429" },
    { id: 52558, cityId: 255, code: "846009" },
    { id: 52559, cityId: 255, code: "847428" },
    { id: 52560, cityId: 255, code: "846008" },
    { id: 52561, cityId: 255, code: "847427" },
    { id: 52562, cityId: 292, code: "847225" },
    { id: 52563, cityId: 292, code: "847215" },
    { id: 52564, cityId: 292, code: "847214" },
    { id: 52565, cityId: 217, code: "854109" },
    { id: 52566, cityId: 217, code: "854112" },
    { id: 52567, cityId: 311, code: "854306" },
    { id: 52568, cityId: 286, code: "855108" },
    { id: 52569, cityId: 286, code: "855116" },
    { id: 52570, cityId: 311, code: "854304" },
    { id: 52571, cityId: 291, code: "852132" },
    { id: 52572, cityId: 291, code: "852115" },
    { id: 52573, cityId: 318, code: "841302" },
    { id: 52574, cityId: 318, code: "841305" },
    { id: 52575, cityId: 318, code: "841209" },
    { id: 52576, cityId: 318, code: "841460" },
    { id: 52577, cityId: 325, code: "841509" },
    { id: 52578, cityId: 325, code: "841286" },
    { id: 52579, cityId: 325, code: "841446" },
    { id: 52580, cityId: 325, code: "841287" },
    { id: 52581, cityId: 325, code: "841406" },
    { id: 52582, cityId: 266, code: "841441" },
    { id: 52583, cityId: 325, code: "841227" },
    { id: 52584, cityId: 262, code: "824221" },
    { id: 52585, cityId: 262, code: "824220" },
    { id: 52586, cityId: 245, code: "813214" },
    { id: 52587, cityId: 251, code: "802122" },
    { id: 52588, cityId: 262, code: "805236" },
    { id: 52589, cityId: 262, code: "823311" },
    { id: 52590, cityId: 289, code: "811112" },
    { id: 52591, cityId: 308, code: "805133" },
    { id: 52592, cityId: 308, code: "805112" },
    { id: 52593, cityId: 308, code: "805111" },
    { id: 52594, cityId: 310, code: "800029" },
    { id: 52595, cityId: 310, code: "800026" },
    { id: 52596, cityId: 310, code: "800028" },
    { id: 52597, cityId: 310, code: "800025" },
    { id: 52598, cityId: 310, code: "801501" },
    { id: 52599, cityId: 310, code: "800027" },
    { id: 52600, cityId: 310, code: "800024" },
    { id: 52601, cityId: 310, code: "804454" },
    { id: 52602, cityId: 362, code: "495455" },
    { id: 52603, cityId: 362, code: "495448" },
    { id: 52604, cityId: 362, code: "495454" },
    { id: 52605, cityId: 356, code: "491559" },
    { id: 52606, cityId: 371, code: "491666" },
    { id: 52607, cityId: 348, code: "491107" },
    { id: 52608, cityId: 369, code: "496108" },
    { id: 52609, cityId: 1096, code: "496005" },
    { id: 52610, cityId: 369, code: "496109" },
    { id: 52611, cityId: 353, code: "496220" },
    { id: 52612, cityId: 353, code: "496245" },
    { id: 52613, cityId: 370, code: "492002" },
    { id: 52614, cityId: 2767, code: "493331" },
    { id: 52615, cityId: 370, code: "492101" },
    { id: 52616, cityId: 2767, code: "492013" },
    { id: 52617, cityId: 370, code: "492010" },
    { id: 52618, cityId: 2767, code: "493195" },
    { id: 52619, cityId: 370, code: "493196" },
    { id: 52620, cityId: 2767, code: "492099" },
    { id: 52621, cityId: 370, code: "493526" },
    { id: 52622, cityId: 346, code: "493770" },
    { id: 52623, cityId: 364, code: "493554" },
    { id: 52624, cityId: 370, code: "492014" },
    { id: 52625, cityId: 346, code: "493662" },
    { id: 52626, cityId: 370, code: "493888" },
    { id: 52627, cityId: 2767, code: "493229" },
    { id: 52628, cityId: 405, code: "382427" },
    { id: 52629, cityId: 405, code: "380063" },
    { id: 52630, cityId: 405, code: "382245" },
    { id: 52631, cityId: 405, code: "382225" },
    { id: 52632, cityId: 478, code: "384012" },
    { id: 52633, cityId: 478, code: "382830" },
    { id: 52634, cityId: 478, code: "384003" },
    { id: 52635, cityId: 407, code: "365645" },
    { id: 52636, cityId: 407, code: "365456" },
    { id: 52637, cityId: 407, code: "365610" },
    { id: 52638, cityId: 407, code: "365550" },
    { id: 52639, cityId: 407, code: "365421" },
    { id: 52640, cityId: 407, code: "365601" },
    { id: 52641, cityId: 407, code: "365630" },
    { id: 52642, cityId: 407, code: "365410" },
    { id: 52643, cityId: 407, code: "365650" },
    { id: 52644, cityId: 407, code: "365640" },
    { id: 52645, cityId: 407, code: "365435" },
    { id: 52646, cityId: 407, code: "365540" },
    { id: 52647, cityId: 407, code: "365455" },
    { id: 52648, cityId: 407, code: "365460" },
    { id: 52649, cityId: 407, code: "365560" },
    { id: 52650, cityId: 407, code: "365565" },
    { id: 52651, cityId: 407, code: "365535" },
    { id: 52652, cityId: 407, code: "365635" },
    { id: 52653, cityId: 407, code: "365545" },
    { id: 52654, cityId: 407, code: "365450" },
    { id: 52655, cityId: 407, code: "365620" },
    { id: 52656, cityId: 407, code: "365555" },
    { id: 52657, cityId: 407, code: "365220" },
    { id: 52658, cityId: 407, code: "365430" },
    { id: 52659, cityId: 407, code: "365660" },
    { id: 52660, cityId: 407, code: "365541" },
    { id: 52661, cityId: 417, code: "364081" },
    { id: 52662, cityId: 503, code: "360330" },
    { id: 52663, cityId: 503, code: "360030" },
    { id: 52664, cityId: 458, code: "361141" },
    { id: 52665, cityId: 458, code: "361142" },
    { id: 52666, cityId: 460, code: "362229" },
    { id: 52667, cityId: 460, code: "362269" },
    { id: 52668, cityId: 503, code: "360024" },
    { id: 52669, cityId: 503, code: "360021" },
    { id: 52670, cityId: 408, code: "388345" },
    { id: 52671, cityId: 519, code: "394248" },
    { id: 52672, cityId: 519, code: "394246" },
    { id: 52673, cityId: 416, code: "394116" },
    { id: 52674, cityId: 416, code: "392215" },
    { id: 52675, cityId: 408, code: "388590" },
    { id: 52676, cityId: 491, code: "396433" },
    { id: 52677, cityId: 519, code: "395023" },
    { id: 52678, cityId: 519, code: "394516" },
    { id: 52679, cityId: 519, code: "395017" },
    { id: 52680, cityId: 519, code: "394518" },
    { id: 52681, cityId: 519, code: "395011" },
    { id: 52682, cityId: 519, code: "394107" },
    { id: 52683, cityId: 519, code: "394111" },
    { id: 52684, cityId: 519, code: "395012" },
    { id: 52685, cityId: 519, code: "394517" },
    { id: 52686, cityId: 531, code: "390022" },
    { id: 52687, cityId: 531, code: "390025" },
    { id: 52688, cityId: 531, code: "390023" },
    { id: 52689, cityId: 531, code: "390024" },
    { id: 52690, cityId: 531, code: "391761" },
    { id: 52691, cityId: 532, code: "396002" },
    { id: 52692, cityId: 380, code: "396215" },
    { id: 52693, cityId: 544, code: "133006" },
    { id: 52694, cityId: 544, code: "134005" },
    { id: 52695, cityId: 591, code: "134114" },
    { id: 52696, cityId: 591, code: "134116" },
    { id: 52697, cityId: 591, code: "134117" },
    { id: 52698, cityId: 591, code: "134103" },
    { id: 52699, cityId: 551, code: "127114" },
    { id: 52700, cityId: 551, code: "127045" },
    { id: 52701, cityId: 551, code: "127046" },
    { id: 52702, cityId: 551, code: "127026" },
    { id: 52703, cityId: 551, code: "127035" },
    { id: 52704, cityId: 551, code: "127025" },
    { id: 52705, cityId: 551, code: "127028" },
    { id: 52706, cityId: 551, code: "127031" },
    { id: 52707, cityId: 551, code: "127310" },
    { id: 52708, cityId: 551, code: "127041" },
    { id: 52709, cityId: 551, code: "127027" },
    { id: 52710, cityId: 551, code: "127040" },
    { id: 52711, cityId: 551, code: "127111" },
    { id: 52712, cityId: 551, code: "127043" },
    { id: 52713, cityId: 551, code: "127030" },
    { id: 52714, cityId: 551, code: "127029" },
    { id: 52715, cityId: 551, code: "127021" },
    { id: 52716, cityId: 551, code: "127032" },
    { id: 52717, cityId: 551, code: "127307" },
    { id: 52718, cityId: 551, code: "127306" },
    { id: 52719, cityId: 551, code: "127022" },
    { id: 52720, cityId: 551, code: "127042" },
    { id: 52721, cityId: 551, code: "127308" },
    { id: 52722, cityId: 551, code: "127309" },
    { id: 52723, cityId: 551, code: "127201" },
    { id: 52724, cityId: 557, code: "121008" },
    { id: 52725, cityId: 557, code: "121012" },
    { id: 52726, cityId: 557, code: "121013" },
    { id: 52727, cityId: 564, code: "122010" },
    { id: 52728, cityId: 564, code: "122008" },
    { id: 52729, cityId: 564, code: "122052" },
    { id: 52730, cityId: 564, code: "122051" },
    { id: 52731, cityId: 564, code: "122009" },
    { id: 52732, cityId: 564, code: "122018" },
    { id: 52733, cityId: 564, code: "122007" },
    { id: 52734, cityId: 564, code: "122017" },
    { id: 52735, cityId: 564, code: "122006" },
    { id: 52736, cityId: 564, code: "122503" },
    { id: 52737, cityId: 564, code: "122505" },
    { id: 52738, cityId: 564, code: "122003" },
    { id: 52739, cityId: 564, code: "122414" },
    { id: 52740, cityId: 600, code: "123110" },
    { id: 52741, cityId: 564, code: "122508" },
    { id: 52742, cityId: 564, code: "122004" },
    { id: 52743, cityId: 564, code: "122413" },
    { id: 52744, cityId: 564, code: "122504" },
    { id: 52745, cityId: 564, code: "122506" },
    { id: 52746, cityId: 564, code: "122502" },
    { id: 52747, cityId: 558, code: "125111" },
    { id: 52748, cityId: 2286, code: "125133" },
    { id: 52749, cityId: 604, code: "125110" },
    { id: 52750, cityId: 592, code: "132122" },
    { id: 52751, cityId: 578, code: "132054" },
    { id: 52752, cityId: 572, code: "126125" },
    { id: 52753, cityId: 578, code: "132157" },
    { id: 52754, cityId: 592, code: "132107" },
    { id: 52755, cityId: 578, code: "132114" },
    { id: 52756, cityId: 572, code: "126112" },
    { id: 52757, cityId: 578, code: "132023" },
    { id: 52758, cityId: 579, code: "136038" },
    { id: 52759, cityId: 579, code: "136118" },
    { id: 52760, cityId: 574, code: "136044" },
    { id: 52761, cityId: 574, code: "136042" },
    { id: 52762, cityId: 579, code: "136132" },
    { id: 52763, cityId: 574, code: "136021" },
    { id: 52764, cityId: 579, code: "136030" },
    { id: 52765, cityId: 574, code: "136026" },
    { id: 52766, cityId: 574, code: "136034" },
    { id: 52767, cityId: 579, code: "136135" },
    { id: 52768, cityId: 579, code: "136119" },
    { id: 52769, cityId: 579, code: "136131" },
    { id: 52770, cityId: 574, code: "136117" },
    { id: 52771, cityId: 579, code: "136136" },
    { id: 52772, cityId: 574, code: "136020" },
    { id: 52773, cityId: 579, code: "136128" },
    { id: 52774, cityId: 579, code: "136156" },
    { id: 52775, cityId: 574, code: "136033" },
    { id: 52776, cityId: 574, code: "136035" },
    { id: 52777, cityId: 574, code: "136043" },
    { id: 52778, cityId: 574, code: "136027" },
    { id: 52779, cityId: 579, code: "136130" },
    { id: 52780, cityId: 579, code: "136129" },
    { id: 52781, cityId: 601, code: "124010" },
    { id: 52782, cityId: 571, code: "124142" },
    { id: 52783, cityId: 571, code: "124106" },
    { id: 52784, cityId: 571, code: "124146" },
    { id: 52785, cityId: 618, code: "176308" },
    { id: 52786, cityId: 618, code: "176309" },
    { id: 52787, cityId: 618, code: "176303" },
    { id: 52788, cityId: 627, code: "176066" },
    { id: 52789, cityId: 627, code: "176502" },
    { id: 52790, cityId: 627, code: "176056" },
    { id: 52791, cityId: 627, code: "176077" },
    { id: 52792, cityId: 627, code: "176071" },
    { id: 52793, cityId: 627, code: "176097" },
    { id: 52794, cityId: 627, code: "176082" },
    { id: 52795, cityId: 627, code: "176098" },
    { id: 52796, cityId: 627, code: "176200" },
    { id: 52797, cityId: 627, code: "176073" },
    { id: 52798, cityId: 631, code: "175019" },
    { id: 52799, cityId: 631, code: "175010" },
    { id: 52800, cityId: 631, code: "175017" },
    { id: 52801, cityId: 630, code: "175143" },
    { id: 52802, cityId: 631, code: "175016" },
    { id: 52803, cityId: 630, code: "175103" },
    { id: 52804, cityId: 630, code: "175102" },
    { id: 52805, cityId: 630, code: "175126" },
    { id: 52806, cityId: 630, code: "175104" },
    { id: 52807, cityId: 631, code: "175015" },
    { id: 52808, cityId: 630, code: "175105" },
    { id: 52809, cityId: 631, code: "175014" },
    { id: 52810, cityId: 631, code: "175023" },
    { id: 52811, cityId: 631, code: "175012" },
    { id: 52812, cityId: 631, code: "175008" },
    { id: 52813, cityId: 631, code: "175018" },
    { id: 52814, cityId: 631, code: "175009" },
    { id: 52815, cityId: 631, code: "175011" },
    { id: 52816, cityId: 647, code: "172028" },
    { id: 52817, cityId: 647, code: "171223" },
    { id: 52818, cityId: 647, code: "171224" },
    { id: 52819, cityId: 647, code: "171222" },
    { id: 52820, cityId: 647, code: "171301" },
    { id: 52821, cityId: 647, code: "171018" },
    { id: 52822, cityId: 647, code: "171220" },
    { id: 52823, cityId: 647, code: "171221" },
    { id: 52824, cityId: 647, code: "171225" },
    { id: 52825, cityId: 648, code: "173233" },
    { id: 52826, cityId: 648, code: "173234" },
    { id: 52827, cityId: 648, code: "173205" },
    { id: 52828, cityId: 648, code: "173235" },
    { id: 52829, cityId: 650, code: "174317" },
    { id: 52830, cityId: 650, code: "174503" },
    { id: 52831, cityId: 650, code: "174320" },
    { id: 52832, cityId: 650, code: "174314" },
    { id: 52833, cityId: 650, code: "174316" },
    { id: 52834, cityId: 650, code: "174319" },
    { id: 52835, cityId: 650, code: "174321" },
    { id: 52836, cityId: 668, code: "180020" },
    { id: 52837, cityId: 668, code: "180018" },
    { id: 52838, cityId: 668, code: "180016" },
    { id: 52839, cityId: 668, code: "180013" },
    { id: 52840, cityId: 668, code: "180006" },
    { id: 52841, cityId: 668, code: "180019" },
    { id: 52842, cityId: 668, code: "180015" },
    { id: 52843, cityId: 668, code: "185154" },
    { id: 52844, cityId: 668, code: "180017" },
    { id: 52845, cityId: 668, code: "180012" },
    { id: 52846, cityId: 680, code: "194404" },
    { id: 52847, cityId: 680, code: "194402" },
    { id: 52848, cityId: 670, code: "194403" },
    { id: 52849, cityId: 695, code: "190020" },
    { id: 52850, cityId: 2634, code: "190018" },
    { id: 52851, cityId: 695, code: "190024" },
    { id: 52852, cityId: 2634, code: "190023" },
    { id: 52853, cityId: 695, code: "190025" },
    { id: 52854, cityId: 686, code: "192302" },
    { id: 52855, cityId: 663, code: "182206" },
    { id: 52856, cityId: 663, code: "182147" },
    { id: 52857, cityId: 663, code: "182221" },
    { id: 52858, cityId: 699, code: "182127" },
    { id: 52859, cityId: 663, code: "182148" },
    { id: 52860, cityId: 714, code: "828105" },
    { id: 52861, cityId: 714, code: "828124" },
    { id: 52862, cityId: 714, code: "828132" },
    { id: 52863, cityId: 714, code: "828309" },
    { id: 52864, cityId: 704, code: "829301" },
    { id: 52865, cityId: 704, code: "827006" },
    { id: 52866, cityId: 714, code: "828130" },
    { id: 52867, cityId: 714, code: "826005" },
    { id: 52868, cityId: 714, code: "828401" },
    { id: 52869, cityId: 714, code: "828201" },
    { id: 52870, cityId: 704, code: "829132" },
    { id: 52871, cityId: 704, code: "829123" },
    { id: 52872, cityId: 704, code: "829111" },
    { id: 52873, cityId: 704, code: "829104" },
    { id: 52874, cityId: 2624, code: "825326" },
    { id: 52875, cityId: 2800, code: "829150" },
    { id: 52876, cityId: 716, code: "822134" },
    { id: 52877, cityId: 723, code: "835203" },
    { id: 52878, cityId: 723, code: "835231" },
    { id: 52879, cityId: 723, code: "835324" },
    { id: 52880, cityId: 713, code: "814122" },
    { id: 52881, cityId: 715, code: "814167" },
    { id: 52882, cityId: 755, code: "816110" },
    { id: 52883, cityId: 713, code: "814115" },
    { id: 52884, cityId: 713, code: "814157" },
    { id: 52885, cityId: 713, code: "814149" },
    { id: 52886, cityId: 715, code: "816118" },
    { id: 52887, cityId: 715, code: "814110" },
    { id: 52888, cityId: 781, code: "560093" },
    { id: 52889, cityId: 781, code: "560300" },
    { id: 52890, cityId: 781, code: "560103" },
    { id: 52891, cityId: 781, code: "560109" },
    { id: 52892, cityId: 781, code: "560100" },
    { id: 52893, cityId: 781, code: "560105" },
    { id: 52894, cityId: 781, code: "560108" },
    { id: 52895, cityId: 781, code: "560095" },
    { id: 52896, cityId: 781, code: "560110" },
    { id: 52897, cityId: 781, code: "560104" },
    { id: 52898, cityId: 781, code: "560096" },
    { id: 52899, cityId: 778, code: "587113" },
    { id: 52900, cityId: 778, code: "587330" },
    { id: 52901, cityId: 789, code: "591156" },
    { id: 52902, cityId: 764, code: "590019" },
    { id: 52903, cityId: 789, code: "590016" },
    { id: 52904, cityId: 764, code: "591117" },
    { id: 52905, cityId: 789, code: "591153" },
    { id: 52906, cityId: 764, code: "591345" },
    { id: 52907, cityId: 789, code: "590018" },
    { id: 52908, cityId: 764, code: "590020" },
    { id: 52909, cityId: 789, code: "590017" },
    { id: 52910, cityId: 790, code: "583105" },
    { id: 52911, cityId: 790, code: "583275" },
    { id: 52912, cityId: 790, code: "583276" },
    { id: 52913, cityId: 790, code: "583152" },
    { id: 52914, cityId: 795, code: "585444" },
    { id: 52915, cityId: 789, code: "591223" },
    { id: 52916, cityId: 821, code: "580026" },
    { id: 52917, cityId: 821, code: "581195" },
    { id: 52918, cityId: 821, code: "581196" },
    { id: 52919, cityId: 821, code: "580002" },
    { id: 52920, cityId: 877, code: "583278" },
    { id: 52921, cityId: 824, code: "582202" },
    { id: 52922, cityId: 877, code: "583283" },
    { id: 52923, cityId: 824, code: "582103" },
    { id: 52924, cityId: 877, code: "583281" },
    { id: 52925, cityId: 877, code: "583280" },
    { id: 52926, cityId: 972, code: "585355" },
    { id: 52927, cityId: 839, code: "581197" },
    { id: 52928, cityId: 839, code: "581109" },
    { id: 52929, cityId: 839, code: "581203" },
    { id: 52930, cityId: 925, code: "584104" },
    { id: 52931, cityId: 925, code: "584115" },
    { id: 52932, cityId: 925, code: "584103" },
    { id: 52933, cityId: 815, code: "577597" },
    { id: 52934, cityId: 815, code: "577599" },
    { id: 52935, cityId: 815, code: "577598" },
    { id: 52936, cityId: 838, code: "573225" },
    { id: 52937, cityId: 838, code: "573202" },
    { id: 52938, cityId: 838, code: "573165" },
    { id: 52939, cityId: 838, code: "573164" },
    { id: 52940, cityId: 873, code: "563160" },
    { id: 52941, cityId: 873, code: "563162" },
    { id: 52942, cityId: 873, code: "563102" },
    { id: 52943, cityId: 873, code: "563103" },
    { id: 52944, cityId: 873, code: "563161" },
    { id: 52945, cityId: 901, code: "571448" },
    { id: 52946, cityId: 901, code: "571606" },
    { id: 52947, cityId: 901, code: "571475" },
    { id: 52948, cityId: 913, code: "570022" },
    { id: 52949, cityId: 913, code: "570027" },
    { id: 52950, cityId: 913, code: "570026" },
    { id: 52951, cityId: 913, code: "570003" },
    { id: 52952, cityId: 913, code: "570028" },
    { id: 52953, cityId: 913, code: "570025" },
    { id: 52954, cityId: 913, code: "571116" },
    { id: 52955, cityId: 913, code: "570029" },
    { id: 52956, cityId: 913, code: "570023" },
    { id: 52957, cityId: 913, code: "571129" },
    { id: 52958, cityId: 942, code: "577302" },
    { id: 52959, cityId: 942, code: "577451" },
    { id: 52960, cityId: 942, code: "577453" },
    { id: 52961, cityId: 942, code: "577203" },
    { id: 52962, cityId: 942, code: "577204" },
    { id: 52963, cityId: 942, code: "577431" },
    { id: 52964, cityId: 942, code: "577452" },
    { id: 52965, cityId: 942, code: "577205" },
    { id: 52966, cityId: 942, code: "577430" },
    { id: 52967, cityId: 964, code: "572107" },
    { id: 52968, cityId: 964, code: "572133" },
    { id: 52969, cityId: 964, code: "572102" },
    { id: 52970, cityId: 966, code: "576283" },
    { id: 52971, cityId: 966, code: "576105" },
    { id: 52972, cityId: 966, code: "576108" },
    { id: 52973, cityId: 966, code: "576107" },
    { id: 52974, cityId: 966, code: "576106" },
    { id: 52975, cityId: 1027, code: "673570" },
    { id: 52976, cityId: 1027, code: "673582" },
    { id: 52977, cityId: 1015, code: "670353" },
    { id: 52978, cityId: 866, code: "670503" },
    { id: 52979, cityId: 1015, code: "670304" },
    { id: 52980, cityId: 866, code: "670521" },
    { id: 52981, cityId: 1015, code: "670567" },
    { id: 52982, cityId: 866, code: "670008" },
    { id: 52983, cityId: 1015, code: "670310" },
    { id: 52984, cityId: 866, code: "670504" },
    { id: 52985, cityId: 1054, code: "678546" },
    { id: 52986, cityId: 1054, code: "678731" },
    { id: 52987, cityId: 1015, code: "670651" },
    { id: 52988, cityId: 866, code: "670642" },
    { id: 52989, cityId: 1031, code: "679572" },
    { id: 52990, cityId: 978, code: "688541" },
    { id: 52991, cityId: 1002, code: "683576" },
    { id: 52992, cityId: 1002, code: "683112" },
    { id: 52993, cityId: 1025, code: "686101" },
    { id: 52994, cityId: 1002, code: "682010" },
    { id: 52995, cityId: 1002, code: "682003" },
    { id: 52996, cityId: 1002, code: "682033" },
    { id: 52997, cityId: 1002, code: "682037" },
    { id: 52998, cityId: 1002, code: "682306" },
    { id: 52999, cityId: 1002, code: "682038" },
    { id: 53000, cityId: 1002, code: "682039" },
    { id: 53001, cityId: 1002, code: "682040" },
    { id: 53002, cityId: 1002, code: "682041" },
    { id: 53003, cityId: 1002, code: "682042" },
    { id: 53004, cityId: 1080, code: "680697" },
    { id: 53005, cityId: 1080, code: "680722" },
    { id: 53006, cityId: 1025, code: "686022" },
    { id: 53007, cityId: 1025, code: "686630" },
    { id: 53008, cityId: 1025, code: "686121" },
    { id: 53009, cityId: 1025, code: "686021" },
    { id: 53010, cityId: 1025, code: "686637" },
    { id: 53011, cityId: 1025, code: "686005" },
    { id: 53012, cityId: 1025, code: "686146" },
    { id: 53013, cityId: 1025, code: "686013" },
    { id: 53014, cityId: 978, code: "690509" },
    { id: 53015, cityId: 1080, code: "680515" },
    { id: 53016, cityId: 1080, code: "680022" },
    { id: 53017, cityId: 1080, code: "680555" },
    { id: 53018, cityId: 1022, code: "690540" },
    { id: 53019, cityId: 1059, code: "689514" },
    { id: 53020, cityId: 1022, code: "691011" },
    { id: 53021, cityId: 1022, code: "691016" },
    { id: 53022, cityId: 1022, code: "691520" },
    { id: 53023, cityId: 1022, code: "691566" },
    { id: 53024, cityId: 1059, code: "689112" },
    { id: 53025, cityId: 1076, code: "695589" },
    { id: 53026, cityId: 1076, code: "695528" },
    { id: 53027, cityId: 1076, code: "695134" },
    { id: 53028, cityId: 1178, code: "481666" },
    { id: 53029, cityId: 1178, code: "481998" },
    { id: 53030, cityId: 1139, code: "481882" },
    { id: 53031, cityId: 1178, code: "481664" },
    { id: 53032, cityId: 1095, code: "481224" },
    { id: 53033, cityId: 1095, code: "481337" },
    { id: 53034, cityId: 1227, code: "480886" },
    { id: 53035, cityId: 1178, code: "481996" },
    { id: 53036, cityId: 1227, code: "480991" },
    { id: 53037, cityId: 1139, code: "481884" },
    { id: 53038, cityId: 1178, code: "481668" },
    { id: 53039, cityId: 1139, code: "481880" },
    { id: 53040, cityId: 1227, code: "480888" },
    { id: 53041, cityId: 1178, code: "481768" },
    { id: 53042, cityId: 1095, code: "481331" },
    { id: 53043, cityId: 1121, code: "462045" },
    { id: 53044, cityId: 1121, code: "462066" },
    { id: 53045, cityId: 1121, code: "462041" },
    { id: 53046, cityId: 1121, code: "462027" },
    { id: 53047, cityId: 1121, code: "462039" },
    { id: 53048, cityId: 1121, code: "462033" },
    { id: 53049, cityId: 1121, code: "462020" },
    { id: 53050, cityId: 1121, code: "462038" },
    { id: 53051, cityId: 1121, code: "462043" },
    { id: 53052, cityId: 1121, code: "462022" },
    { id: 53053, cityId: 1121, code: "462044" },
    { id: 53054, cityId: 1121, code: "463106" },
    { id: 53055, cityId: 1121, code: "462101" },
    { id: 53056, cityId: 1121, code: "462047" },
    { id: 53057, cityId: 1121, code: "462120" },
    { id: 53058, cityId: 1121, code: "462037" },
    { id: 53059, cityId: 1127, code: "471516" },
    { id: 53060, cityId: 1201, code: "488443" },
    { id: 53061, cityId: 1201, code: "488059" },
    { id: 53062, cityId: 1240, code: "472331" },
    { id: 53063, cityId: 1201, code: "488333" },
    { id: 53064, cityId: 1240, code: "472339" },
    { id: 53065, cityId: 1127, code: "471606" },
    { id: 53066, cityId: 1127, code: "471315" },
    { id: 53067, cityId: 1201, code: "488222" },
    { id: 53068, cityId: 1201, code: "488448" },
    { id: 53069, cityId: 1127, code: "471405" },
    { id: 53070, cityId: 1201, code: "488446" },
    { id: 53071, cityId: 1128, code: "480555" },
    { id: 53072, cityId: 1128, code: "480108" },
    { id: 53073, cityId: 1128, code: "480109" },
    { id: 53074, cityId: 1115, code: "460110" },
    { id: 53075, cityId: 1153, code: "461122" },
    { id: 53076, cityId: 1153, code: "461661" },
    { id: 53077, cityId: 1153, code: "461775" },
    { id: 53078, cityId: 1153, code: "461668" },
    { id: 53079, cityId: 1213, code: "486451" },
    { id: 53080, cityId: 1221, code: "485334" },
    { id: 53081, cityId: 1221, code: "485772" },
    { id: 53082, cityId: 1213, code: "486446" },
    { id: 53083, cityId: 1213, code: "486003" },
    { id: 53084, cityId: 1213, code: "486335" },
    { id: 53085, cityId: 1221, code: "485113" },
    { id: 53086, cityId: 1213, code: "486005" },
    { id: 53087, cityId: 1213, code: "486447" },
    { id: 53088, cityId: 1213, code: "486450" },
    { id: 53089, cityId: 1221, code: "485112" },
    { id: 53090, cityId: 1213, code: "486117" },
    { id: 53091, cityId: 1213, code: "486440" },
    { id: 53092, cityId: 1215, code: "470124" },
    { id: 53093, cityId: 930, code: "470004" },
    { id: 53094, cityId: 1215, code: "470232" },
    { id: 53095, cityId: 1132, code: "470673" },
    { id: 53096, cityId: 1215, code: "470021" },
    { id: 53097, cityId: 1132, code: "470663" },
    { id: 53098, cityId: 1245, code: "484664" },
    { id: 53099, cityId: 1233, code: "486884" },
    { id: 53100, cityId: 1233, code: "486675" },
    { id: 53101, cityId: 1245, code: "484552" },
    { id: 53102, cityId: 1233, code: "486776" },
    { id: 53103, cityId: 1233, code: "486882" },
    { id: 53104, cityId: 1229, code: "484669" },
    { id: 53105, cityId: 1229, code: "484120" },
    { id: 53106, cityId: 1229, code: "484774" },
    { id: 53107, cityId: 1233, code: "486670" },
    { id: 53108, cityId: 1246, code: "464113" },
    { id: 53109, cityId: 1246, code: "464258" },
    { id: 53110, cityId: 1206, code: "464886" },
    { id: 53111, cityId: 1206, code: "464672" },
    { id: 53112, cityId: 1206, code: "464881" },
    { id: 53113, cityId: 1145, code: "473112" },
    { id: 53114, cityId: 1232, code: "473638" },
    { id: 53115, cityId: 1145, code: "473111" },
    { id: 53116, cityId: 1145, code: "473115" },
    { id: 53117, cityId: 1145, code: "473113" },
    { id: 53118, cityId: 1145, code: "473222" },
    { id: 53119, cityId: 1232, code: "473995" },
    { id: 53120, cityId: 1104, code: "473332" },
    { id: 53121, cityId: 1232, code: "473585" },
    { id: 53122, cityId: 1104, code: "473444" },
    { id: 53123, cityId: 1104, code: "473446" },
    { id: 53124, cityId: 1147, code: "474012" },
    { id: 53125, cityId: 1147, code: "474015" },
    { id: 53126, cityId: 1147, code: "474011" },
    { id: 53127, cityId: 1133, code: "475682" },
    { id: 53128, cityId: 1147, code: "475330" },
    { id: 53129, cityId: 1133, code: "475685" },
    { id: 53130, cityId: 1188, code: "476444" },
    { id: 53131, cityId: 1119, code: "477555" },
    { id: 53132, cityId: 1119, code: "477449" },
    { id: 53133, cityId: 1119, code: "477446" },
    { id: 53134, cityId: 1188, code: "476554" },
    { id: 53135, cityId: 1188, code: "476219" },
    { id: 53136, cityId: 1119, code: "477117" },
    { id: 53137, cityId: 1119, code: "477566" },
    { id: 53138, cityId: 1188, code: "476134" },
    { id: 53139, cityId: 1154, code: "452013" },
    { id: 53140, cityId: 1154, code: "452014" },
    { id: 53141, cityId: 1154, code: "452011" },
    { id: 53142, cityId: 1154, code: "452010" },
    { id: 53143, cityId: 1154, code: "452007" },
    { id: 53144, cityId: 1154, code: "452015" },
    { id: 53145, cityId: 1154, code: "452003" },
    { id: 53146, cityId: 1137, code: "454775" },
    { id: 53147, cityId: 1154, code: "453556" },
    { id: 53148, cityId: 1154, code: "453332" },
    { id: 53149, cityId: 1137, code: "454774" },
    { id: 53150, cityId: 1154, code: "453111" },
    { id: 53151, cityId: 1154, code: "453555" },
    { id: 53152, cityId: 1154, code: "453771" },
    { id: 53153, cityId: 1137, code: "454335" },
    { id: 53154, cityId: 1154, code: "453112" },
    { id: 53155, cityId: 1154, code: "452016" },
    { id: 53156, cityId: 1137, code: "454001" },
    { id: 53157, cityId: 1156, code: "482008" },
    { id: 53158, cityId: 1156, code: "482021" },
    { id: 53159, cityId: 1156, code: "483053" },
    { id: 53160, cityId: 1164, code: "483770" },
    { id: 53161, cityId: 1164, code: "483336" },
    { id: 53162, cityId: 1196, code: "458336" },
    { id: 53163, cityId: 1196, code: "458470" },
    { id: 53164, cityId: 1099, code: "457893" },
    { id: 53165, cityId: 1212, code: "457331" },
    { id: 53166, cityId: 1157, code: "457773" },
    { id: 53167, cityId: 1212, code: "457119" },
    { id: 53168, cityId: 1212, code: "457340" },
    { id: 53169, cityId: 1157, code: "457772" },
    { id: 53170, cityId: 1225, code: "466120" },
    { id: 53171, cityId: 1225, code: "466113" },
    { id: 53172, cityId: 1207, code: "465680" },
    { id: 53173, cityId: 641, code: "465691" },
    { id: 53174, cityId: 1207, code: "465669" },
    { id: 53175, cityId: 1243, code: "456770" },
    { id: 53176, cityId: 1243, code: "456313" },
    { id: 53177, cityId: 1231, code: "465339" },
    { id: 53178, cityId: 1231, code: "465226" },
    { id: 53179, cityId: 1231, code: "465227" },
    { id: 53180, cityId: 1314, code: "431215" },
    { id: 53181, cityId: 1314, code: "431214" },
    { id: 53182, cityId: 1261, code: "431154" },
    { id: 53183, cityId: 2192, code: "431009" },
    { id: 53184, cityId: 1261, code: "431010" },
    { id: 53185, cityId: 2192, code: "431006" },
    { id: 53186, cityId: 1314, code: "431211" },
    { id: 53187, cityId: 1261, code: "431008" },
    { id: 53188, cityId: 2192, code: "423703" },
    { id: 53189, cityId: 1261, code: "431136" },
    { id: 53190, cityId: 1314, code: "431209" },
    { id: 53191, cityId: 1261, code: "431120" },
    { id: 53192, cityId: 2647, code: "431106" },
    { id: 53193, cityId: 1261, code: "431007" },
    { id: 53194, cityId: 1268, code: "431530" },
    { id: 53195, cityId: 1268, code: "431518" },
    { id: 53196, cityId: 1268, code: "431130" },
    { id: 53197, cityId: 1268, code: "431153" },
    { id: 53198, cityId: 1268, code: "431143" },
    { id: 53199, cityId: 1313, code: "424204" },
    { id: 53200, cityId: 1313, code: "425203" },
    { id: 53201, cityId: 1313, code: "425310" },
    { id: 53202, cityId: 1313, code: "425327" },
    { id: 53203, cityId: 1295, code: "425403" },
    { id: 53204, cityId: 1377, code: "425452" },
    { id: 53205, cityId: 1295, code: "424006" },
    { id: 53206, cityId: 1377, code: "425416" },
    { id: 53207, cityId: 1295, code: "424318" },
    { id: 53208, cityId: 1377, code: "425414" },
    { id: 53209, cityId: 1295, code: "425427" },
    { id: 53210, cityId: 1295, code: "425428" },
    { id: 53211, cityId: 1295, code: "424305" },
    { id: 53212, cityId: 1313, code: "425004" },
    { id: 53213, cityId: 1313, code: "425003" },
    { id: 53214, cityId: 1313, code: "425402" },
    { id: 53215, cityId: 1313, code: "424119" },
    { id: 53216, cityId: 1378, code: "423403" },
    { id: 53217, cityId: 1378, code: "424109" },
    { id: 53218, cityId: 1378, code: "422304" },
    { id: 53219, cityId: 1378, code: "423110" },
    { id: 53220, cityId: 1378, code: "423205" },
    { id: 53221, cityId: 1378, code: "422308" },
    { id: 53222, cityId: 1374, code: "431603" },
    { id: 53223, cityId: 1374, code: "431808" },
    { id: 53224, cityId: 1374, code: "431716" },
    { id: 53225, cityId: 1374, code: "431750" },
    { id: 53226, cityId: 1374, code: "431606" },
    { id: 53227, cityId: 1374, code: "431710" },
    { id: 53228, cityId: 1374, code: "431714" },
    { id: 53229, cityId: 1374, code: "431736" },
    { id: 53230, cityId: 1374, code: "431810" },
    { id: 53231, cityId: 1374, code: "431605" },
    { id: 53232, cityId: 1378, code: "422013" },
    { id: 53233, cityId: 1378, code: "422011" },
    { id: 53234, cityId: 1378, code: "422012" },
    { id: 53235, cityId: 1378, code: "422222" },
    { id: 53236, cityId: 1378, code: "422113" },
    { id: 53237, cityId: 1378, code: "422201" },
    { id: 53238, cityId: 1378, code: "422221" },
    { id: 53239, cityId: 1378, code: "422606" },
    { id: 53240, cityId: 1378, code: "422112" },
    { id: 53241, cityId: 1381, code: "413604" },
    { id: 53242, cityId: 1389, code: "431521" },
    { id: 53243, cityId: 1309, code: "431702" },
    { id: 53244, cityId: 1309, code: "431542" },
    { id: 53245, cityId: 1389, code: "431536" },
    { id: 53246, cityId: 1337, code: "416144" },
    { id: 53247, cityId: 1337, code: "416234" },
    { id: 53248, cityId: 1337, code: "416236" },
    { id: 53249, cityId: 1337, code: "416229" },
    { id: 53250, cityId: 1337, code: "416552" },
    { id: 53251, cityId: 1337, code: "416551" },
    { id: 53252, cityId: 1337, code: "416146" },
    { id: 53253, cityId: 1337, code: "416143" },
    { id: 53254, cityId: 1337, code: "416118" },
    { id: 53255, cityId: 1337, code: "416235" },
    { id: 53256, cityId: 1337, code: "416012" },
    { id: 53257, cityId: 1409, code: "415634" },
    { id: 53258, cityId: 1409, code: "415640" },
    { id: 53259, cityId: 1409, code: "415619" },
    { id: 53260, cityId: 1409, code: "415639" },
    { id: 53261, cityId: 1409, code: "415643" },
    { id: 53262, cityId: 1409, code: "416713" },
    { id: 53263, cityId: 1409, code: "415730" },
    { id: 53264, cityId: 1409, code: "415616" },
    { id: 53265, cityId: 1409, code: "415214" },
    { id: 53266, cityId: 1409, code: "415729" },
    { id: 53267, cityId: 1409, code: "416701" },
    { id: 53268, cityId: 1414, code: "416437" },
    { id: 53269, cityId: 1414, code: "416436" },
    { id: 53270, cityId: 1414, code: "415414" },
    { id: 53271, cityId: 1414, code: "416413" },
    { id: 53272, cityId: 1414, code: "415306" },
    { id: 53273, cityId: 1414, code: "415410" },
    { id: 53274, cityId: 1414, code: "415411" },
    { id: 53275, cityId: 1439, code: "400710" },
    { id: 53276, cityId: 1439, code: "421005" },
    { id: 53277, cityId: 1439, code: "421308" },
    { id: 53278, cityId: 1439, code: "400608" },
    { id: 53279, cityId: 1439, code: "421002" },
    { id: 53280, cityId: 1439, code: "421312" },
    { id: 53281, cityId: 1439, code: "401209" },
    { id: 53282, cityId: 1439, code: "401305" },
    { id: 53283, cityId: 1439, code: "401101" },
    { id: 53284, cityId: 1439, code: "401102" },
    { id: 53285, cityId: 1439, code: "401605" },
    { id: 53286, cityId: 1250, code: "444006" },
    { id: 53287, cityId: 1257, code: "444606" },
    { id: 53288, cityId: 1257, code: "444813" },
    { id: 53289, cityId: 1257, code: "444719" },
    { id: 53290, cityId: 1257, code: "444607" },
    { id: 53291, cityId: 1257, code: "444720" },
    { id: 53292, cityId: 1276, code: "444304" },
    { id: 53293, cityId: 1276, code: "443002" },
    { id: 53294, cityId: 1280, code: "442501" },
    { id: 53295, cityId: 1280, code: "442917" },
    { id: 53296, cityId: 1280, code: "442404" },
    { id: 53297, cityId: 1300, code: "442709" },
    { id: 53298, cityId: 1300, code: "442704" },
    { id: 53299, cityId: 1280, code: "442505" },
    { id: 53300, cityId: 1280, code: "442507" },
    { id: 53301, cityId: 1280, code: "442918" },
    { id: 53302, cityId: 1300, code: "442707" },
    { id: 53303, cityId: 1280, code: "441228" },
    { id: 53304, cityId: 1280, code: "442406" },
    { id: 53305, cityId: 1280, code: "441212" },
    { id: 53306, cityId: 1300, code: "441217" },
    { id: 53307, cityId: 1372, code: "440019" },
    { id: 53308, cityId: 1372, code: "440032" },
    { id: 53309, cityId: 1372, code: "440033" },
    { id: 53310, cityId: 1372, code: "440030" },
    { id: 53311, cityId: 1372, code: "440037" },
    { id: 53312, cityId: 1372, code: "440036" },
    { id: 53313, cityId: 1372, code: "441123" },
    { id: 53314, cityId: 1372, code: "441214" },
    { id: 53315, cityId: 1372, code: "440035" },
    { id: 53316, cityId: 1372, code: "441113" },
    { id: 53317, cityId: 1271, code: "441802" },
    { id: 53318, cityId: 1372, code: "441122" },
    { id: 53319, cityId: 1372, code: "440034" },
    { id: 53320, cityId: 1271, code: "441906" },
    { id: 53321, cityId: 1372, code: "441108" },
    { id: 53322, cityId: 1457, code: "442104" },
    { id: 53323, cityId: 1432, code: "413252" },
    { id: 53324, cityId: 1432, code: "413322" },
    { id: 53325, cityId: 1432, code: "413305" },
    { id: 53326, cityId: 1432, code: "413315" },
    { id: 53327, cityId: 1401, code: "411047" },
    { id: 53328, cityId: 1401, code: "411061" },
    { id: 53329, cityId: 1401, code: "411057" },
    { id: 53330, cityId: 1401, code: "411060" },
    { id: 53331, cityId: 1401, code: "411048" },
    { id: 53332, cityId: 1401, code: "411062" },
    { id: 53333, cityId: 1401, code: "411058" },
    { id: 53334, cityId: 1401, code: "411052" },
    { id: 53335, cityId: 1401, code: "413133" },
    { id: 53336, cityId: 1401, code: "410406" },
    { id: 53337, cityId: 1401, code: "412312" },
    { id: 53338, cityId: 1401, code: "410516" },
    { id: 53339, cityId: 1401, code: "412115" },
    { id: 53340, cityId: 1401, code: "410512" },
    { id: 53341, cityId: 1401, code: "412219" },
    { id: 53342, cityId: 1401, code: "410513" },
    { id: 53343, cityId: 1401, code: "413802" },
    { id: 53344, cityId: 1401, code: "412220" },
    { id: 53345, cityId: 1401, code: "412406" },
    { id: 53346, cityId: 1401, code: "412216" },
    { id: 53347, cityId: 1401, code: "410510" },
    { id: 53348, cityId: 1418, code: "415122" },
    { id: 53349, cityId: 1418, code: "415023" },
    { id: 53350, cityId: 1418, code: "415003" },
    { id: 53351, cityId: 1418, code: "415540" },
    { id: 53352, cityId: 1418, code: "415539" },
    { id: 53353, cityId: 1418, code: "415020" },
    { id: 53354, cityId: 1418, code: "415537" },
    { id: 53355, cityId: 1418, code: "415538" },
    { id: 53356, cityId: 1418, code: "415124" },
    { id: 53357, cityId: 1418, code: "415109" },
    { id: 53358, cityId: 1432, code: "413411" },
    { id: 53359, cityId: 1432, code: "413255" },
    { id: 53360, cityId: 1432, code: "413253" },
    { id: 53361, cityId: 1432, code: "413008" },
    { id: 53362, cityId: 1463, code: "795006" },
    { id: 53363, cityId: 1470, code: "795112" },
    { id: 53364, cityId: 1463, code: "795117" },
    { id: 53365, cityId: 1470, code: "795107" },
    { id: 53366, cityId: 1472, code: "795159" },
    { id: 53367, cityId: 1473, code: "795149" },
    { id: 53368, cityId: 1470, code: "795015" },
    { id: 53369, cityId: 1470, code: "795007" },
    { id: 53370, cityId: 1473, code: "795148" },
    { id: 53371, cityId: 1500, code: "796184" },
    { id: 53372, cityId: 1500, code: "796186" },
    { id: 53373, cityId: 1492, code: "796091" },
    { id: 53374, cityId: 1492, code: "796082" },
    { id: 53375, cityId: 1488, code: "796320" },
    { id: 53376, cityId: 1493, code: "796891" },
    { id: 53377, cityId: 1495, code: "796581" },
    { id: 53378, cityId: 1508, code: "797120" },
    { id: 53379, cityId: 1507, code: "797117" },
    { id: 53380, cityId: 1505, code: "797099" },
    { id: 53381, cityId: 1508, code: "797003" },
    { id: 53382, cityId: 1507, code: "797113" },
    { id: 53383, cityId: 1510, code: "797114" },
    { id: 53384, cityId: 1508, code: "797004" },
    { id: 53385, cityId: 1507, code: "797115" },
    { id: 53386, cityId: 1509, code: "798604" },
    { id: 53387, cityId: 1508, code: "797002" },
    { id: 53388, cityId: 1508, code: "797005" },
    { id: 53389, cityId: 1505, code: "797100" },
    { id: 53390, cityId: 1504, code: "798602" },
    { id: 53391, cityId: 1504, code: "798603" },
    { id: 53392, cityId: 1507, code: "797116" },
    { id: 53393, cityId: 134, code: "792056" },
    { id: 53394, cityId: 1541, code: "761146" },
    { id: 53395, cityId: 1541, code: "761100" },
    { id: 53396, cityId: 1555, code: "766032" },
    { id: 53397, cityId: 1555, code: "766100" },
    { id: 53398, cityId: 1555, code: "766036" },
    { id: 53399, cityId: 1555, code: "766031" },
    { id: 53400, cityId: 1555, code: "766037" },
    { id: 53401, cityId: 1555, code: "766102" },
    { id: 53402, cityId: 1566, code: "764006" },
    { id: 53403, cityId: 1569, code: "764087" },
    { id: 53404, cityId: 1566, code: "763004" },
    { id: 53405, cityId: 1569, code: "764086" },
    { id: 53406, cityId: 1571, code: "764076" },
    { id: 53407, cityId: 1566, code: "764014" },
    { id: 53408, cityId: 1586, code: "765034" },
    { id: 53409, cityId: 1571, code: "764088" },
    { id: 53410, cityId: 1566, code: "764028" },
    { id: 53411, cityId: 1586, code: "765033" },
    { id: 53412, cityId: 1556, code: "762100" },
    { id: 53413, cityId: 1556, code: "762002" },
    { id: 53414, cityId: 1527, code: "756100" },
    { id: 53415, cityId: 1527, code: "756171" },
    { id: 53416, cityId: 1536, code: "753015" },
    { id: 53417, cityId: 1536, code: "753014" },
    { id: 53418, cityId: 1536, code: "754100" },
    { id: 53419, cityId: 1536, code: "754293" },
    { id: 53420, cityId: 1536, code: "754295" },
    { id: 53421, cityId: 1547, code: "754120" },
    { id: 53422, cityId: 1547, code: "754145" },
    { id: 53423, cityId: 1547, code: "754294" },
    { id: 53424, cityId: 1536, code: "754200" },
    { id: 53425, cityId: 1547, code: "754138" },
    { id: 53426, cityId: 1573, code: "752065" },
    { id: 53427, cityId: 1582, code: "752003" },
    { id: 53428, cityId: 1582, code: "752012" },
    { id: 53429, cityId: 1516, code: "767070" },
    { id: 53430, cityId: 1516, code: "767060" },
    { id: 53431, cityId: 1561, code: "758082" },
    { id: 53432, cityId: 1561, code: "758083" },
    { id: 53433, cityId: 1561, code: "758084" },
    { id: 53434, cityId: 1561, code: "758085" },
    { id: 53435, cityId: 1588, code: "768020" },
    { id: 53436, cityId: 1551, code: "768233" },
    { id: 53437, cityId: 1551, code: "768234" },
    { id: 53438, cityId: 1588, code: "768006" },
    { id: 53439, cityId: 1588, code: "768005" },
    { id: 53440, cityId: 1588, code: "768025" },
    { id: 53441, cityId: 1551, code: "768202" },
    { id: 53442, cityId: 1588, code: "768200" },
    { id: 53443, cityId: 332, code: "160004" },
    { id: 53444, cityId: 332, code: "160025" },
    { id: 53445, cityId: 2808, code: "160103" },
    { id: 53446, cityId: 332, code: "160047" },
    { id: 53447, cityId: 332, code: "160015" },
    { id: 53448, cityId: 2808, code: "140604" },
    { id: 53449, cityId: 1680, code: "160062" },
    { id: 53450, cityId: 1680, code: "160071" },
    { id: 53451, cityId: 2808, code: "160104" },
    { id: 53452, cityId: 332, code: "160102" },
    { id: 53453, cityId: 332, code: "160030" },
    { id: 53454, cityId: 1651, code: "141016" },
    { id: 53455, cityId: 1651, code: "141017" },
    { id: 53456, cityId: 1651, code: "141012" },
    { id: 53457, cityId: 1651, code: "141014" },
    { id: 53458, cityId: 1651, code: "141010" },
    { id: 53459, cityId: 1651, code: "141013" },
    { id: 53460, cityId: 1651, code: "141015" },
    { id: 53461, cityId: 1651, code: "141123" },
    { id: 53462, cityId: 1651, code: "141422" },
    { id: 53463, cityId: 1651, code: "141127" },
    { id: 53464, cityId: 1651, code: "141126" },
    { id: 53465, cityId: 1651, code: "141125" },
    { id: 53466, cityId: 1651, code: "141110" },
    { id: 53467, cityId: 1669, code: "147005" },
    { id: 53468, cityId: 1669, code: "147006" },
    { id: 53469, cityId: 2808, code: "140507" },
    { id: 53470, cityId: 1669, code: "147004" },
    { id: 53471, cityId: 1669, code: "147111" },
    { id: 53472, cityId: 1669, code: "147007" },
    { id: 53473, cityId: 1669, code: "140402" },
    { id: 53474, cityId: 1685, code: "148017" },
    { id: 53475, cityId: 1685, code: "148019" },
    { id: 53476, cityId: 1685, code: "148018" },
    { id: 53477, cityId: 1609, code: "148100" },
    { id: 53478, cityId: 1685, code: "148030" },
    { id: 53479, cityId: 1685, code: "148002" },
    { id: 53480, cityId: 1604, code: "143005" },
    { id: 53481, cityId: 1604, code: "143149" },
    { id: 53482, cityId: 1604, code: "143008" },
    { id: 53483, cityId: 1604, code: "143119" },
    { id: 53484, cityId: 1604, code: "143022" },
    { id: 53485, cityId: 1660, code: "142002" },
    { id: 53486, cityId: 1660, code: "142003" },
    { id: 53487, cityId: 1627, code: "151212" },
    { id: 53488, cityId: 1660, code: "142038" },
    { id: 53489, cityId: 1663, code: "151211" },
    { id: 53490, cityId: 1660, code: "142045" },
    { id: 53491, cityId: 1627, code: "151213" },
    { id: 53492, cityId: 1635, code: "143525" },
    { id: 53493, cityId: 1635, code: "143519" },
    { id: 53494, cityId: 1638, code: "146024" },
    { id: 53495, cityId: 1638, code: "146116" },
    { id: 53496, cityId: 1638, code: "144212" },
    { id: 53497, cityId: 1638, code: "144306" },
    { id: 53498, cityId: 1667, code: "144533" },
    { id: 53499, cityId: 1641, code: "144013" },
    { id: 53500, cityId: 1641, code: "144416" },
    { id: 53501, cityId: 1667, code: "144501" },
    { id: 53502, cityId: 1641, code: "144030" },
    { id: 53503, cityId: 1641, code: "144014" },
    { id: 53504, cityId: 1641, code: "144106" },
    { id: 53505, cityId: 1641, code: "144012" },
    { id: 53506, cityId: 1641, code: "144031" },
    { id: 53507, cityId: 1641, code: "144603" },
    { id: 53508, cityId: 1644, code: "144819" },
    { id: 53509, cityId: 1644, code: "144602" },
    { id: 53510, cityId: 1641, code: "144805" },
    { id: 53511, cityId: 1644, code: "144625" },
    { id: 53512, cityId: 1641, code: "144037" },
    { id: 53513, cityId: 1641, code: "144044" },
    { id: 53514, cityId: 1641, code: "144043" },
    { id: 53515, cityId: 1641, code: "144039" },
    { id: 53516, cityId: 1641, code: "144042" },
    { id: 53517, cityId: 1641, code: "144036" },
    { id: 53518, cityId: 1641, code: "144035" },
    { id: 53519, cityId: 1641, code: "144034" },
    { id: 53520, cityId: 1641, code: "144311" },
    { id: 53521, cityId: 1641, code: "144040" },
    { id: 53522, cityId: 1641, code: "144041" },
    { id: 53523, cityId: 1644, code: "144411" },
    { id: 53524, cityId: 1694, code: "305009" },
    { id: 53525, cityId: 1694, code: "305012" },
    { id: 53526, cityId: 1694, code: "305629" },
    { id: 53527, cityId: 1694, code: "305630" },
    { id: 53528, cityId: 1694, code: "305628" },
    { id: 53529, cityId: 1713, code: "311201" },
    { id: 53530, cityId: 1713, code: "311204" },
    { id: 53531, cityId: 1713, code: "311202" },
    { id: 53532, cityId: 1713, code: "311203" },
    { id: 53533, cityId: 1727, code: "312622" },
    { id: 53534, cityId: 1727, code: "323307" },
    { id: 53535, cityId: 1727, code: "312027" },
    { id: 53536, cityId: 1727, code: "312623" },
    { id: 53537, cityId: 1704, code: "327603" },
    { id: 53538, cityId: 1704, code: "327034" },
    { id: 53539, cityId: 1763, code: "324010" },
    { id: 53540, cityId: 1705, code: "325209" },
    { id: 53541, cityId: 1720, code: "323616" },
    { id: 53542, cityId: 1828, code: "313002" },
    { id: 53543, cityId: 2167, code: "313004" },
    { id: 53544, cityId: 1828, code: "313003" },
    { id: 53545, cityId: 1801, code: "313334" },
    { id: 53546, cityId: 1696, code: "301018" },
    { id: 53547, cityId: 1696, code: "301002" },
    { id: 53548, cityId: 1696, code: "301604" },
    { id: 53549, cityId: 1696, code: "301030" },
    { id: 53550, cityId: 1696, code: "301714" },
    { id: 53551, cityId: 1711, code: "321642" },
    { id: 53552, cityId: 1744, code: "302034" },
    { id: 53553, cityId: 1744, code: "302018" },
    { id: 53554, cityId: 1744, code: "302036" },
    { id: 53555, cityId: 1744, code: "302037" },
    { id: 53556, cityId: 1744, code: "302033" },
    { id: 53557, cityId: 1744, code: "302019" },
    { id: 53558, cityId: 1744, code: "302026" },
    { id: 53559, cityId: 1744, code: "302040" },
    { id: 53560, cityId: 1744, code: "302029" },
    { id: 53561, cityId: 1744, code: "302020" },
    { id: 53562, cityId: 1744, code: "302031" },
    { id: 53563, cityId: 1744, code: "302027" },
    { id: 53564, cityId: 1744, code: "302022" },
    { id: 53565, cityId: 1744, code: "302028" },
    { id: 53566, cityId: 1744, code: "302021" },
    { id: 53567, cityId: 1744, code: "303121" },
    { id: 53568, cityId: 1744, code: "303122" },
    { id: 53569, cityId: 1744, code: "303706" },
    { id: 53570, cityId: 1744, code: "303908" },
    { id: 53571, cityId: 1754, code: "322249" },
    { id: 53572, cityId: 1754, code: "322238" },
    { id: 53573, cityId: 1707, code: "344043" },
    { id: 53574, cityId: 1707, code: "344044" },
    { id: 53575, cityId: 1717, code: "334006" },
    { id: 53576, cityId: 1717, code: "334808" },
    { id: 53577, cityId: 1717, code: "334003" },
    { id: 53578, cityId: 1717, code: "334004" },
    { id: 53579, cityId: 1729, code: "331506" },
    { id: 53580, cityId: 1750, code: "342304" },
    { id: 53581, cityId: 1750, code: "342012" },
    { id: 53582, cityId: 1745, code: "345033" },
    { id: 53583, cityId: 1750, code: "342011" },
    { id: 53584, cityId: 1750, code: "342015" },
    { id: 53585, cityId: 1750, code: "342014" },
    { id: 53586, cityId: 1745, code: "345034" },
    { id: 53587, cityId: 1750, code: "342013" },
    { id: 53588, cityId: 1781, code: "341551" },
    { id: 53589, cityId: 1789, code: "306422" },
    { id: 53590, cityId: 2447, code: "306912" },
    { id: 53591, cityId: 1816, code: "332002" },
    { id: 53592, cityId: 1817, code: "307510" },
    { id: 53593, cityId: 1739, code: "335002" },
    { id: 53594, cityId: 1739, code: "335711" },
    { id: 53595, cityId: 2135, code: "631005" },
    { id: 53596, cityId: 2135, code: "632406" },
    { id: 53597, cityId: 2135, code: "631006" },
    { id: 53598, cityId: 2135, code: "631152" },
    { id: 53599, cityId: 2135, code: "632520" },
    { id: 53600, cityId: 2113, code: "602002" },
    { id: 53601, cityId: 2113, code: "631212" },
    { id: 53602, cityId: 2113, code: "631208" },
    { id: 53603, cityId: 1880, code: "600118" },
    { id: 53604, cityId: 2113, code: "600123" },
    { id: 53605, cityId: 2113, code: "600124" },
    { id: 53606, cityId: 2113, code: "600120" },
    { id: 53607, cityId: 2114, code: "606755" },
    { id: 53608, cityId: 2114, code: "606811" },
    { id: 53609, cityId: 2114, code: "604502" },
    { id: 53610, cityId: 2114, code: "606808" },
    { id: 53611, cityId: 2114, code: "606704" },
    { id: 53612, cityId: 2114, code: "632326" },
    { id: 53613, cityId: 2135, code: "632115" },
    { id: 53614, cityId: 2135, code: "632058" },
    { id: 53615, cityId: 2135, code: "632059" },
    { id: 53616, cityId: 2135, code: "632014" },
    { id: 53617, cityId: 2135, code: "632113" },
    { id: 53618, cityId: 2135, code: "632114" },
    { id: 53619, cityId: 1889, code: "641043" },
    { id: 53620, cityId: 1889, code: "641049" },
    { id: 53621, cityId: 1889, code: "641050" },
    { id: 53622, cityId: 1889, code: "641048" },
    { id: 53623, cityId: 1889, code: "641035" },
    { id: 53624, cityId: 1894, code: "636903" },
    { id: 53625, cityId: 2006, code: "638006" },
    { id: 53626, cityId: 1900, code: "638012" },
    { id: 53627, cityId: 1900, code: "638455" },
    { id: 53628, cityId: 1900, code: "638101" },
    { id: 53629, cityId: 1963, code: "635124" },
    { id: 53630, cityId: 1963, code: "635116" },
    { id: 53631, cityId: 2006, code: "637215" },
    { id: 53632, cityId: 2006, code: "638183" },
    { id: 53633, cityId: 2006, code: "637214" },
    { id: 53634, cityId: 1889, code: "642201" },
    { id: 53635, cityId: 1889, code: "642203" },
    { id: 53636, cityId: 1889, code: "642205" },
    { id: 53637, cityId: 1889, code: "642006" },
    { id: 53638, cityId: 1889, code: "642202" },
    { id: 53639, cityId: 1889, code: "642204" },
    { id: 53640, cityId: 1889, code: "642207" },
    { id: 53641, cityId: 2075, code: "636201" },
    { id: 53642, cityId: 2075, code: "636015" },
    { id: 53643, cityId: 2075, code: "636030" },
    { id: 53644, cityId: 2075, code: "636406" },
    { id: 53645, cityId: 2075, code: "636309" },
    { id: 53646, cityId: 2075, code: "636306" },
    { id: 53647, cityId: 2075, code: "636005" },
    { id: 53648, cityId: 2135, code: "635852" },
    { id: 53649, cityId: 2135, code: "635710" },
    { id: 53650, cityId: 1889, code: "641603" },
    { id: 53651, cityId: 1889, code: "641667" },
    { id: 53652, cityId: 1889, code: "641658" },
    { id: 53653, cityId: 1889, code: "641601" },
    { id: 53654, cityId: 1889, code: "641666" },
    { id: 53655, cityId: 1889, code: "641606" },
    { id: 53656, cityId: 1889, code: "641670" },
    { id: 53657, cityId: 1889, code: "641652" },
    { id: 53658, cityId: 1889, code: "641665" },
    { id: 53659, cityId: 1889, code: "641697" },
    { id: 53660, cityId: 1889, code: "641671" },
    { id: 53661, cityId: 1889, code: "641659" },
    { id: 53662, cityId: 1889, code: "641669" },
    { id: 53663, cityId: 1889, code: "641664" },
    { id: 53664, cityId: 1889, code: "641655" },
    { id: 53665, cityId: 1889, code: "641663" },
    { id: 53666, cityId: 1889, code: "641653" },
    { id: 53667, cityId: 1889, code: "641668" },
    { id: 53668, cityId: 1889, code: "641662" },
    { id: 53669, cityId: 1889, code: "641654" },
    { id: 53670, cityId: 1895, code: "624206" },
    { id: 53671, cityId: 1934, code: "629810" },
    { id: 53672, cityId: 1934, code: "629302" },
    { id: 53673, cityId: 2088, code: "630004" },
    { id: 53674, cityId: 2088, code: "630005" },
    { id: 53675, cityId: 2088, code: "630006" },
    { id: 53676, cityId: 2088, code: "630102" },
    { id: 53677, cityId: 2088, code: "630103" },
    { id: 53678, cityId: 2088, code: "630003" },
    { id: 53679, cityId: 2088, code: "630301" },
    { id: 53680, cityId: 2088, code: "630101" },
    { id: 53681, cityId: 2088, code: "630212" },
    { id: 53682, cityId: 2088, code: "630206" },
    { id: 53683, cityId: 2088, code: "630202" },
    { id: 53684, cityId: 2088, code: "630105" },
    { id: 53685, cityId: 2088, code: "630208" },
    { id: 53686, cityId: 2088, code: "630311" },
    { id: 53687, cityId: 2088, code: "630314" },
    { id: 53688, cityId: 2088, code: "630302" },
    { id: 53689, cityId: 2088, code: "630306" },
    { id: 53690, cityId: 2088, code: "630104" },
    { id: 53691, cityId: 2088, code: "630002" },
    { id: 53692, cityId: 2088, code: "630405" },
    { id: 53693, cityId: 2088, code: "630201" },
    { id: 53694, cityId: 2088, code: "630205" },
    { id: 53695, cityId: 2088, code: "630106" },
    { id: 53696, cityId: 2088, code: "630501" },
    { id: 53697, cityId: 2088, code: "630309" },
    { id: 53698, cityId: 2088, code: "630410" },
    { id: 53699, cityId: 2088, code: "630307" },
    { id: 53700, cityId: 2088, code: "630502" },
    { id: 53701, cityId: 2088, code: "630107" },
    { id: 53702, cityId: 2088, code: "630207" },
    { id: 53703, cityId: 2088, code: "630108" },
    { id: 53704, cityId: 2088, code: "630303" },
    { id: 53705, cityId: 2792, code: "628906" },
    { id: 53706, cityId: 2792, code: "628503" },
    { id: 53707, cityId: 2792, code: "628501" },
    { id: 53708, cityId: 2792, code: "628908" },
    { id: 53709, cityId: 2792, code: "628712" },
    { id: 53710, cityId: 2792, code: "628952" },
    { id: 53711, cityId: 2792, code: "628722" },
    { id: 53712, cityId: 2792, code: "628716" },
    { id: 53713, cityId: 2111, code: "627807" },
    { id: 53714, cityId: 2111, code: "627808" },
    { id: 53715, cityId: 2792, code: "628903" },
    { id: 53716, cityId: 2792, code: "628901" },
    { id: 53717, cityId: 2111, code: "627760" },
    { id: 53718, cityId: 2792, code: "628907" },
    { id: 53719, cityId: 2792, code: "628904" },
    { id: 53720, cityId: 2792, code: "628718" },
    { id: 53721, cityId: 2792, code: "628721" },
    { id: 53722, cityId: 2792, code: "628720" },
    { id: 53723, cityId: 2792, code: "628902" },
    { id: 53724, cityId: 2792, code: "628714" },
    { id: 53725, cityId: 2792, code: "628905" },
    { id: 53726, cityId: 1976, code: "625205" },
    { id: 53727, cityId: 1976, code: "625110" },
    { id: 53728, cityId: 1976, code: "625707" },
    { id: 53729, cityId: 1976, code: "625023" },
    { id: 53730, cityId: 1976, code: "625214" },
    { id: 53731, cityId: 1976, code: "625234" },
    { id: 53732, cityId: 1976, code: "625706" },
    { id: 53733, cityId: 1976, code: "625514" },
    { id: 53734, cityId: 1976, code: "625218" },
    { id: 53735, cityId: 1976, code: "625207" },
    { id: 53736, cityId: 1976, code: "625701" },
    { id: 53737, cityId: 1976, code: "625708" },
    { id: 53738, cityId: 1976, code: "625019" },
    { id: 53739, cityId: 1976, code: "625703" },
    { id: 53740, cityId: 1976, code: "625221" },
    { id: 53741, cityId: 1976, code: "625704" },
    { id: 53742, cityId: 1976, code: "625109" },
    { id: 53743, cityId: 1976, code: "625017" },
    { id: 53744, cityId: 1976, code: "625702" },
    { id: 53745, cityId: 1976, code: "625503" },
    { id: 53746, cityId: 2071, code: "623504" },
    { id: 53747, cityId: 2071, code: "623514" },
    { id: 53748, cityId: 2071, code: "623120" },
    { id: 53749, cityId: 2071, code: "623115" },
    { id: 53750, cityId: 2071, code: "623503" },
    { id: 53751, cityId: 2071, code: "623135" },
    { id: 53752, cityId: 2071, code: "623523" },
    { id: 53753, cityId: 2088, code: "630321" },
    { id: 53754, cityId: 2088, code: "630556" },
    { id: 53755, cityId: 2088, code: "630566" },
    { id: 53756, cityId: 2088, code: "630210" },
    { id: 53757, cityId: 2088, code: "630558" },
    { id: 53758, cityId: 2088, code: "630553" },
    { id: 53759, cityId: 2088, code: "630555" },
    { id: 53760, cityId: 2088, code: "630313" },
    { id: 53761, cityId: 2088, code: "630551" },
    { id: 53762, cityId: 2088, code: "630606" },
    { id: 53763, cityId: 2088, code: "630204" },
    { id: 53764, cityId: 2088, code: "630411" },
    { id: 53765, cityId: 2088, code: "630561" },
    { id: 53766, cityId: 2088, code: "630554" },
    { id: 53767, cityId: 2088, code: "630713" },
    { id: 53768, cityId: 2088, code: "630559" },
    { id: 53769, cityId: 2088, code: "630611" },
    { id: 53770, cityId: 2088, code: "630609" },
    { id: 53771, cityId: 2088, code: "630552" },
    { id: 53772, cityId: 2088, code: "630203" },
    { id: 53773, cityId: 2088, code: "630602" },
    { id: 53774, cityId: 2088, code: "630709" },
    { id: 53775, cityId: 2088, code: "630557" },
    { id: 53776, cityId: 2088, code: "630702" },
    { id: 53777, cityId: 2088, code: "630562" },
    { id: 53778, cityId: 2088, code: "630710" },
    { id: 53779, cityId: 2088, code: "630211" },
    { id: 53780, cityId: 2088, code: "630408" },
    { id: 53781, cityId: 2088, code: "630610" },
    { id: 53782, cityId: 2088, code: "630305" },
    { id: 53783, cityId: 2101, code: "625526" },
    { id: 53784, cityId: 2101, code: "625522" },
    { id: 53785, cityId: 2101, code: "625538" },
    { id: 53786, cityId: 2101, code: "625556" },
    { id: 53787, cityId: 2101, code: "625533" },
    { id: 53788, cityId: 2101, code: "625513" },
    { id: 53789, cityId: 2101, code: "625517" },
    { id: 53790, cityId: 2101, code: "625516" },
    { id: 53791, cityId: 2101, code: "625203" },
    { id: 53792, cityId: 2101, code: "625605" },
    { id: 53793, cityId: 2101, code: "625536" },
    { id: 53794, cityId: 1976, code: "625529" },
    { id: 53795, cityId: 2101, code: "625540" },
    { id: 53796, cityId: 2101, code: "625523" },
    { id: 53797, cityId: 2101, code: "625531" },
    { id: 53798, cityId: 2101, code: "625515" },
    { id: 53799, cityId: 2101, code: "625521" },
    { id: 53800, cityId: 2101, code: "625528" },
    { id: 53801, cityId: 2101, code: "625582" },
    { id: 53802, cityId: 2101, code: "625520" },
    { id: 53803, cityId: 2101, code: "625518" },
    { id: 53804, cityId: 2101, code: "625519" },
    { id: 53805, cityId: 2101, code: "625603" },
    { id: 53806, cityId: 2101, code: "625604" },
    { id: 53807, cityId: 2101, code: "625524" },
    { id: 53808, cityId: 2101, code: "625601" },
    { id: 53809, cityId: 2101, code: "625525" },
    { id: 53810, cityId: 2101, code: "625512" },
    { id: 53811, cityId: 2101, code: "625530" },
    { id: 53812, cityId: 1976, code: "625535" },
    { id: 53813, cityId: 2101, code: "625579" },
    { id: 53814, cityId: 2101, code: "625534" },
    { id: 53815, cityId: 1976, code: "625532" },
    { id: 53816, cityId: 1976, code: "625537" },
    { id: 53817, cityId: 2101, code: "625562" },
    { id: 53818, cityId: 2111, code: "627133" },
    { id: 53819, cityId: 2111, code: "627012" },
    { id: 53820, cityId: 2111, code: "627659" },
    { id: 53821, cityId: 2111, code: "627119" },
    { id: 53822, cityId: 2111, code: "627654" },
    { id: 53823, cityId: 2111, code: "627651" },
    { id: 53824, cityId: 2111, code: "627657" },
    { id: 53825, cityId: 2111, code: "627652" },
    { id: 53826, cityId: 2792, code: "628229" },
    { id: 53827, cityId: 2792, code: "628809" },
    { id: 53828, cityId: 2792, code: "628212" },
    { id: 53829, cityId: 2792, code: "628851" },
    { id: 53830, cityId: 2146, code: "626612" },
    { id: 53831, cityId: 2146, code: "626002" },
    { id: 53832, cityId: 2146, code: "626607" },
    { id: 53833, cityId: 2146, code: "626189" },
    { id: 53834, cityId: 1890, code: "608306" },
    { id: 53835, cityId: 1890, code: "607005" },
    { id: 53836, cityId: 1890, code: "607308" },
    { id: 53837, cityId: 1890, code: "607006" },
    { id: 53838, cityId: 1890, code: "607205" },
    { id: 53839, cityId: 1890, code: "607112" },
    { id: 53840, cityId: 1890, code: "607303" },
    { id: 53841, cityId: 1937, code: "639007" },
    { id: 53842, cityId: 1937, code: "639008" },
    { id: 53843, cityId: 2110, code: "621310" },
    { id: 53844, cityId: 1937, code: "621301" },
    { id: 53845, cityId: 1937, code: "639114" },
    { id: 53846, cityId: 1937, code: "639136" },
    { id: 53847, cityId: 2004, code: "609108" },
    { id: 53848, cityId: 2004, code: "609402" },
    { id: 53849, cityId: 2004, code: "609205" },
    { id: 53850, cityId: 2004, code: "611003" },
    { id: 53851, cityId: 2064, code: "622209" },
    { id: 53852, cityId: 2064, code: "614624" },
    { id: 53853, cityId: 2064, code: "622422" },
    { id: 53854, cityId: 2110, code: "621204" },
    { id: 53855, cityId: 2050, code: "621133" },
    { id: 53856, cityId: 2110, code: "621211" },
    { id: 53857, cityId: 2110, code: "621207" },
    { id: 53858, cityId: 2099, code: "614202" },
    { id: 53859, cityId: 2099, code: "613010" },
    { id: 53860, cityId: 2110, code: "620024" },
    { id: 53861, cityId: 2110, code: "620023" },
    { id: 53862, cityId: 2110, code: "620026" },
    { id: 53863, cityId: 1859, code: "621730" },
    { id: 53864, cityId: 2110, code: "620025" },
    { id: 53865, cityId: 2110, code: "621706" },
    { id: 53866, cityId: 1859, code: "621804" },
    { id: 53867, cityId: 1890, code: "606108" },
    { id: 53868, cityId: 2169, code: "282010" },
    { id: 53869, cityId: 2169, code: "283113" },
    { id: 53870, cityId: 2169, code: "283126" },
    { id: 53871, cityId: 2174, code: "202170" },
    { id: 53872, cityId: 2174, code: "202131" },
    { id: 53873, cityId: 2174, code: "202125" },
    { id: 53874, cityId: 2253, code: "203401" },
    { id: 53875, cityId: 2253, code: "203206" },
    { id: 53876, cityId: 2253, code: "203407" },
    { id: 53877, cityId: 2253, code: "203409" },
    { id: 53878, cityId: 2253, code: "203396" },
    { id: 53879, cityId: 2253, code: "203402" },
    { id: 53880, cityId: 2253, code: "203399" },
    { id: 53881, cityId: 2253, code: "203408" },
    { id: 53882, cityId: 2253, code: "203405" },
    { id: 53883, cityId: 2253, code: "203390" },
    { id: 53884, cityId: 2253, code: "203392" },
    { id: 53885, cityId: 2253, code: "203394" },
    { id: 53886, cityId: 2253, code: "203403" },
    { id: 53887, cityId: 2253, code: "203389" },
    { id: 53888, cityId: 2253, code: "203393" },
    { id: 53889, cityId: 2253, code: "203391" },
    { id: 53890, cityId: 2253, code: "203002" },
    { id: 53891, cityId: 2253, code: "203412" },
    { id: 53892, cityId: 2253, code: "203411" },
    { id: 53893, cityId: 2253, code: "203397" },
    { id: 53894, cityId: 2253, code: "203398" },
    { id: 53895, cityId: 2253, code: "203395" },
    { id: 53896, cityId: 2280, code: "207002" },
    { id: 53897, cityId: 2280, code: "207120" },
    { id: 53898, cityId: 2280, code: "207003" },
    { id: 53899, cityId: 2280, code: "207250" },
    { id: 53900, cityId: 2191, code: "206255" },
    { id: 53901, cityId: 2281, code: "206245" },
    { id: 53902, cityId: 2342, code: "284419" },
    { id: 53903, cityId: 2342, code: "284135" },
    { id: 53904, cityId: 2387, code: "284136" },
    { id: 53905, cityId: 2342, code: "284120" },
    { id: 53906, cityId: 2342, code: "284206" },
    { id: 53907, cityId: 2342, code: "284305" },
    { id: 53908, cityId: 2342, code: "284301" },
    { id: 53909, cityId: 2387, code: "284126" },
    { id: 53910, cityId: 2387, code: "284501" },
    { id: 53911, cityId: 2290, code: "283205" },
    { id: 53912, cityId: 2290, code: "283206" },
    { id: 53913, cityId: 2399, code: "205304" },
    { id: 53914, cityId: 2290, code: "283135" },
    { id: 53915, cityId: 2399, code: "205247" },
    { id: 53916, cityId: 2290, code: "283142" },
    { id: 53917, cityId: 2290, code: "283136" },
    { id: 53918, cityId: 2290, code: "283141" },
    { id: 53919, cityId: 2290, code: "283151" },
    { id: 53920, cityId: 2290, code: "283130" },
    { id: 53921, cityId: 2290, code: "283152" },
    { id: 53922, cityId: 2290, code: "283207" },
    { id: 53923, cityId: 2399, code: "205303" },
    { id: 53924, cityId: 2290, code: "283145" },
    { id: 53925, cityId: 2327, code: "281104" },
    { id: 53926, cityId: 2407, code: "281122" },
    { id: 53927, cityId: 2175, code: "211018" },
    { id: 53928, cityId: 2175, code: "211016" },
    { id: 53929, cityId: 2175, code: "211017" },
    { id: 53930, cityId: 2175, code: "211009" },
    { id: 53931, cityId: 2175, code: "212111" },
    { id: 53932, cityId: 2175, code: "211010" },
    { id: 53933, cityId: 2175, code: "211019" },
    { id: 53934, cityId: 2175, code: "212307" },
    { id: 53935, cityId: 2175, code: "212405" },
    { id: 53936, cityId: 2301, code: "232339" },
    { id: 53937, cityId: 2301, code: "232330" },
    { id: 53938, cityId: 2301, code: "233300" },
    { id: 53939, cityId: 2301, code: "233231" },
    { id: 53940, cityId: 2301, code: "233002" },
    { id: 53941, cityId: 2301, code: "233307" },
    { id: 53942, cityId: 2301, code: "233306" },
    { id: 53943, cityId: 2301, code: "233230" },
    { id: 53944, cityId: 2339, code: "222131" },
    { id: 53945, cityId: 2339, code: "222003" },
    { id: 53946, cityId: 2339, code: "222144" },
    { id: 53947, cityId: 2339, code: "222181" },
    { id: 53948, cityId: 2339, code: "222204" },
    { id: 53949, cityId: 2518, code: "231224" },
    { id: 53950, cityId: 2416, code: "231313" },
    { id: 53951, cityId: 2416, code: "231501" },
    { id: 53952, cityId: 2518, code: "231226" },
    { id: 53953, cityId: 2416, code: "231307" },
    { id: 53954, cityId: 2455, code: "230121" },
    { id: 53955, cityId: 2455, code: "230202" },
    { id: 53956, cityId: 2455, code: "230201" },
    { id: 53957, cityId: 2455, code: "230204" },
    { id: 53958, cityId: 2540, code: "221011" },
    { id: 53959, cityId: 2540, code: "221116" },
    { id: 53960, cityId: 2540, code: "221313" },
    { id: 53961, cityId: 2222, code: "243006" },
    { id: 53962, cityId: 2451, code: "262124" },
    { id: 53963, cityId: 2222, code: "243004" },
    { id: 53964, cityId: 2222, code: "243402" },
    { id: 53965, cityId: 2222, code: "243302" },
    { id: 53966, cityId: 2222, code: "243407" },
    { id: 53967, cityId: 2222, code: "243005" },
    { id: 53968, cityId: 2237, code: "246737" },
    { id: 53969, cityId: 2237, code: "246729" },
    { id: 53970, cityId: 2237, code: "246736" },
    { id: 53971, cityId: 2237, code: "246764" },
    { id: 53972, cityId: 2250, code: "242021" },
    { id: 53973, cityId: 2250, code: "243751" },
    { id: 53974, cityId: 2250, code: "243723" },
    { id: 53975, cityId: 2250, code: "243724" },
    { id: 53976, cityId: 2250, code: "243725" },
    { id: 53977, cityId: 2250, code: "243722" },
    { id: 53978, cityId: 2250, code: "243727" },
    { id: 53979, cityId: 2250, code: "243630" },
    { id: 53980, cityId: 2250, code: "243726" },
    { id: 53981, cityId: 2250, code: "243720" },
    { id: 53982, cityId: 2319, code: "241127" },
    { id: 53983, cityId: 2319, code: "241125" },
    { id: 53984, cityId: 2411, code: "250103" },
    { id: 53985, cityId: 2411, code: "250205" },
    { id: 53986, cityId: 2422, code: "244103" },
    { id: 53987, cityId: 2422, code: "244504" },
    { id: 53988, cityId: 2422, code: "244411" },
    { id: 53989, cityId: 2422, code: "244104" },
    { id: 53990, cityId: 2422, code: "244413" },
    { id: 53991, cityId: 2466, code: "244928" },
    { id: 53992, cityId: 642, code: "244701" },
    { id: 53993, cityId: 2466, code: "244927" },
    { id: 53994, cityId: 2422, code: "244415" },
    { id: 53995, cityId: 2422, code: "244412" },
    { id: 53996, cityId: 2422, code: "244410" },
    { id: 53997, cityId: 2422, code: "244414" },
    { id: 53998, cityId: 2422, code: "244602" },
    { id: 53999, cityId: 2428, code: "251320" },
    { id: 54000, cityId: 2428, code: "251307" },
    { id: 54001, cityId: 2428, code: "251314" },
    { id: 54002, cityId: 2428, code: "251327" },
    { id: 54003, cityId: 2428, code: "251003" },
    { id: 54004, cityId: 2500, code: "242123" },
    { id: 54005, cityId: 2500, code: "242220" },
    { id: 54006, cityId: 2500, code: "242042" },
    { id: 54007, cityId: 2500, code: "242127" },
    { id: 54008, cityId: 1182, code: "275103" },
    { id: 54009, cityId: 2195, code: "276288" },
    { id: 54010, cityId: 2195, code: "223226" },
    { id: 54011, cityId: 2195, code: "276140" },
    { id: 54012, cityId: 2195, code: "276143" },
    { id: 54013, cityId: 2195, code: "276201" },
    { id: 54014, cityId: 2195, code: "276406" },
    { id: 54015, cityId: 2508, code: "271835" },
    { id: 54016, cityId: 2207, code: "271881" },
    { id: 54017, cityId: 2508, code: "271805" },
    { id: 54018, cityId: 2508, code: "271840" },
    { id: 54019, cityId: 2508, code: "271803" },
    { id: 54020, cityId: 2207, code: "271830" },
    { id: 54021, cityId: 2211, code: "277219" },
    { id: 54022, cityId: 2211, code: "277501" },
    { id: 54023, cityId: 2211, code: "277402" },
    { id: 54024, cityId: 2211, code: "277124" },
    { id: 54025, cityId: 2226, code: "272128" },
    { id: 54026, cityId: 2226, code: "272123" },
    { id: 54027, cityId: 2226, code: "272177" },
    { id: 54028, cityId: 2226, code: "272150" },
    { id: 54029, cityId: 2226, code: "272130" },
    { id: 54030, cityId: 2509, code: "272195" },
    { id: 54031, cityId: 2226, code: "272155" },
    { id: 54032, cityId: 2509, code: "272193" },
    { id: 54033, cityId: 2272, code: "274807" },
    { id: 54034, cityId: 2382, code: "274801" },
    { id: 54035, cityId: 2272, code: "274806" },
    { id: 54036, cityId: 2272, code: "274705" },
    { id: 54037, cityId: 2272, code: "274182" },
    { id: 54038, cityId: 2272, code: "274704" },
    { id: 54039, cityId: 2272, code: "274208" },
    { id: 54040, cityId: 2272, code: "274808" },
    { id: 54041, cityId: 2382, code: "274149" },
    { id: 54042, cityId: 2382, code: "274802" },
    { id: 54043, cityId: 2306, code: "271129" },
    { id: 54044, cityId: 2212, code: "271205" },
    { id: 54045, cityId: 2212, code: "271609" },
    { id: 54046, cityId: 2306, code: "271503" },
    { id: 54047, cityId: 2306, code: "271502" },
    { id: 54048, cityId: 2306, code: "271003" },
    { id: 54049, cityId: 2212, code: "271215" },
    { id: 54050, cityId: 293, code: "273310" },
    { id: 54051, cityId: 293, code: "273309" },
    { id: 54052, cityId: 2309, code: "273213" },
    { id: 54053, cityId: 2309, code: "273015" },
    { id: 54054, cityId: 2309, code: "273203" },
    { id: 54055, cityId: 293, code: "273311" },
    { id: 54056, cityId: 2309, code: "273017" },
    { id: 54057, cityId: 2309, code: "273211" },
    { id: 54058, cityId: 2309, code: "273014" },
    { id: 54059, cityId: 2309, code: "273212" },
    { id: 54060, cityId: 293, code: "273162" },
    { id: 54061, cityId: 293, code: "273207" },
    { id: 54062, cityId: 2309, code: "273016" },
    { id: 54063, cityId: 2309, code: "273209" },
    { id: 54064, cityId: 2316, code: "210341" },
    { id: 54065, cityId: 2395, code: "210426" },
    { id: 54066, cityId: 2316, code: "210430" },
    { id: 54067, cityId: 2352, code: "209720" },
    { id: 54068, cityId: 2352, code: "209747" },
    { id: 54069, cityId: 2352, code: "209735" },
    { id: 54070, cityId: 2288, code: "212651" },
    { id: 54071, cityId: 2288, code: "212620" },
    { id: 54072, cityId: 2288, code: "212650" },
    { id: 54073, cityId: 2536, code: "209831" },
    { id: 54074, cityId: 2536, code: "229881" },
    { id: 54075, cityId: 2536, code: "209869" },
    { id: 54076, cityId: 2536, code: "209862" },
    { id: 54077, cityId: 2536, code: "209863" },
    { id: 54078, cityId: 2536, code: "209868" },
    { id: 54079, cityId: 2536, code: "209867" },
    { id: 54080, cityId: 2536, code: "209871" },
    { id: 54081, cityId: 2536, code: "209866" },
    { id: 54082, cityId: 2536, code: "209827" },
    { id: 54083, cityId: 2536, code: "209870" },
    { id: 54084, cityId: 2536, code: "209865" },
    { id: 54085, cityId: 2536, code: "209864" },
    { id: 54086, cityId: 2219, code: "225303" },
    { id: 54087, cityId: 2219, code: "225208" },
    { id: 54088, cityId: 2219, code: "225306" },
    { id: 54089, cityId: 2219, code: "225003" },
    { id: 54090, cityId: 2219, code: "225125" },
    { id: 54091, cityId: 2219, code: "225207" },
    { id: 54092, cityId: 2219, code: "225416" },
    { id: 54093, cityId: 2219, code: "225126" },
    { id: 54094, cityId: 2219, code: "225124" },
    { id: 54095, cityId: 2283, code: "224225" },
    { id: 54096, cityId: 2177, code: "224232" },
    { id: 54097, cityId: 2177, code: "224230" },
    { id: 54098, cityId: 2177, code: "224227" },
    { id: 54099, cityId: 2177, code: "224231" },
    { id: 54100, cityId: 2177, code: "224176" },
    { id: 54101, cityId: 2177, code: "224146" },
    { id: 54102, cityId: 2177, code: "224235" },
    { id: 54103, cityId: 2177, code: "224238" },
    { id: 54104, cityId: 2300, code: "201014" },
    { id: 54105, cityId: 2300, code: "201019" },
    { id: 54106, cityId: 2300, code: "201016" },
    { id: 54107, cityId: 2300, code: "201017" },
    { id: 54108, cityId: 2300, code: "201103" },
    { id: 54109, cityId: 2300, code: "201013" },
    { id: 54110, cityId: 2390, code: "226019" },
    { id: 54111, cityId: 2390, code: "226027" },
    { id: 54112, cityId: 2390, code: "226202" },
    { id: 54113, cityId: 2390, code: "226029" },
    { id: 54114, cityId: 2390, code: "226025" },
    { id: 54115, cityId: 2390, code: "226030" },
    { id: 54116, cityId: 2390, code: "226031" },
    { id: 54117, cityId: 2390, code: "226023" },
    { id: 54118, cityId: 2390, code: "226302" },
    { id: 54119, cityId: 2390, code: "226024" },
    { id: 54120, cityId: 2390, code: "226022" },
    { id: 54121, cityId: 2390, code: "226028" },
    { id: 54122, cityId: 2390, code: "226013" },
    { id: 54123, cityId: 2390, code: "226021" },
    { id: 54124, cityId: 2390, code: "226201" },
    { id: 54125, cityId: 2390, code: "226303" },
    { id: 54126, cityId: 2390, code: "226102" },
    { id: 54127, cityId: 2390, code: "226101" },
    { id: 54128, cityId: 2390, code: "226026" },
    { id: 54129, cityId: 2390, code: "226103" },
    { id: 54130, cityId: 2390, code: "226203" },
    { id: 54131, cityId: 2390, code: "226501" },
    { id: 54132, cityId: 2390, code: "226104" },
    { id: 54133, cityId: 2390, code: "226301" },
    { id: 54134, cityId: 2390, code: "226401" },
    { id: 54135, cityId: 2517, code: "261404" },
    { id: 54136, cityId: 2517, code: "261206" },
    { id: 54137, cityId: 2520, code: "228142" },
    { id: 54138, cityId: 1236, code: "228120" },
    { id: 54139, cityId: 2520, code: "227304" },
    { id: 54140, cityId: 1236, code: "227413" },
    { id: 54141, cityId: 2547, code: "263655" },
    { id: 54142, cityId: 2547, code: "263639" },
    { id: 54143, cityId: 2547, code: "263637" },
    { id: 54144, cityId: 2549, code: "263619" },
    { id: 54145, cityId: 2547, code: "263620" },
    { id: 54146, cityId: 2556, code: "246486" },
    { id: 54147, cityId: 2556, code: "246483" },
    { id: 54148, cityId: 2784, code: "249411" },
    { id: 54149, cityId: 2561, code: "248015" },
    { id: 54150, cityId: 2561, code: "248014" },
    { id: 54151, cityId: 2784, code: "247666" },
    { id: 54152, cityId: 2561, code: "248011" },
    { id: 54153, cityId: 2561, code: "248012" },
    { id: 54154, cityId: 2561, code: "248158" },
    { id: 54155, cityId: 2561, code: "249203" },
    { id: 54156, cityId: 2561, code: "248013" },
    { id: 54157, cityId: 2561, code: "248198" },
    { id: 54158, cityId: 2606, code: "263156" },
    { id: 54159, cityId: 2619, code: "262541" },
    { id: 54160, cityId: 2619, code: "262540" },
    { id: 54161, cityId: 2637, code: "249135" },
    { id: 54162, cityId: 2719, code: "700107" },
    { id: 54163, cityId: 2719, code: "700094" },
    { id: 54164, cityId: 2719, code: "700095" },
    { id: 54165, cityId: 2719, code: "700099" },
    { id: 54166, cityId: 2719, code: "700108" },
    { id: 54167, cityId: 2703, code: "736182" },
    { id: 54168, cityId: 2703, code: "736123" },
    { id: 54169, cityId: 2677, code: "734321" },
    { id: 54170, cityId: 2677, code: "734227" },
    { id: 54171, cityId: 2677, code: "734011" },
    { id: 54172, cityId: 2703, code: "734015" },
    { id: 54173, cityId: 2677, code: "734010" },
    { id: 54174, cityId: 2677, code: "734436" },
    { id: 54175, cityId: 2677, code: "734123" },
    { id: 54176, cityId: 2677, code: "734320" },
    { id: 54177, cityId: 2677, code: "734012" },
    { id: 54178, cityId: 2677, code: "734121" },
    { id: 54179, cityId: 2677, code: "734319" },
    { id: 54180, cityId: 2677, code: "734014" },
    { id: 54181, cityId: 2677, code: "734122" },
    { id: 54182, cityId: 2677, code: "734209" },
    { id: 54183, cityId: 2677, code: "734013" },
    { id: 54184, cityId: 2677, code: "734124" },
    { id: 54185, cityId: 2677, code: "734503" },
    { id: 54186, cityId: 2703, code: "735134" },
    { id: 54187, cityId: 2703, code: "735218" },
    { id: 54188, cityId: 2660, code: "713217" },
    { id: 54189, cityId: 2660, code: "713208" },
    { id: 54190, cityId: 2660, code: "713305" },
    { id: 54191, cityId: 2660, code: "713365" },
    { id: 54192, cityId: 2660, code: "713216" },
    { id: 54193, cityId: 2660, code: "713302" },
    { id: 54194, cityId: 2660, code: "713219" },
    { id: 54195, cityId: 2660, code: "713315" },
    { id: 54196, cityId: 2660, code: "713218" },
    { id: 54197, cityId: 2655, code: "722165" },
    { id: 54198, cityId: 2655, code: "722110" },
    { id: 54199, cityId: 2655, code: "722171" },
    { id: 54200, cityId: 2655, code: "722175" },
    { id: 54201, cityId: 2655, code: "722183" },
    { id: 54202, cityId: 2655, code: "722178" },
    { id: 54203, cityId: 2655, code: "722176" },
    { id: 54204, cityId: 2655, code: "722170" },
    { id: 54205, cityId: 2655, code: "722177" },
    { id: 54206, cityId: 2655, code: "722112" },
    { id: 54207, cityId: 2655, code: "722174" },
    { id: 54208, cityId: 2655, code: "722179" },
    { id: 54209, cityId: 2655, code: "722166" },
    { id: 54210, cityId: 2655, code: "722168" },
    { id: 54211, cityId: 2655, code: "722161" },
    { id: 54212, cityId: 2655, code: "722181" },
    { id: 54213, cityId: 2655, code: "722160" },
    { id: 54214, cityId: 2655, code: "722173" },
    { id: 54215, cityId: 2655, code: "722169" },
    { id: 54216, cityId: 2655, code: "722180" },
    { id: 54217, cityId: 2655, code: "722182" },
    { id: 54218, cityId: 2655, code: "722209" },
    { id: 54219, cityId: 2655, code: "722111" },
    { id: 54220, cityId: 2655, code: "722162" },
    { id: 54221, cityId: 2655, code: "722163" },
    { id: 54222, cityId: 2655, code: "722172" },
    { id: 54223, cityId: 2655, code: "722136" },
    { id: 54224, cityId: 2655, code: "722164" },
    { id: 54225, cityId: 2660, code: "713172" },
    { id: 54226, cityId: 2660, code: "713520" },
    { id: 54227, cityId: 2660, code: "713131" },
    { id: 54228, cityId: 2701, code: "711110" },
    { id: 54229, cityId: 2701, code: "711111" },
    { id: 54230, cityId: 2701, code: "711317" },
    { id: 54231, cityId: 2701, code: "711113" },
    { id: 54232, cityId: 2701, code: "711316" },
    { id: 54233, cityId: 2701, code: "711112" },
    { id: 54234, cityId: 2740, code: "723142" },
    { id: 54235, cityId: 2740, code: "723104" },
    { id: 54236, cityId: 2740, code: "723153" },
    { id: 54237, cityId: 2740, code: "723215" },
    { id: 54238, cityId: 2740, code: "723213" },
    { id: 54239, cityId: 2740, code: "723147" },
    { id: 54240, cityId: 902, code: "575030" },
    { id: 54241, cityId: 786, code: "575014" },
    { id: 54242, cityId: 2641, code: "743248" },
    { id: 54243, cityId: 178, code: "785634" },
    { id: 54244, cityId: 170, code: "781024" },
    { id: 54245, cityId: 902, code: "575014" },
    { id: 54246, cityId: 1025, code: "686121" },
    { id: 54247, cityId: 1075, code: "670671" },
    { id: 54248, cityId: 786, code: "574169" },
    { id: 54249, cityId: 966, code: "576104" },
    { id: 54250, cityId: 786, code: "574211" },
    { id: 54251, cityId: 902, code: "575017" },
    { id: 54252, cityId: 966, code: "576201" },
    { id: 54253, cityId: 902, code: "575015" },
    { id: 54254, cityId: 902, code: "575028" },
    { id: 54255, cityId: 966, code: "576102" },
    { id: 54256, cityId: 2111, code: "627818" },
    { id: 54257, cityId: 1976, code: "625107" },
    { id: 54258, cityId: 2105, code: "628952" },
    { id: 54259, cityId: 2105, code: "628002" },
    { id: 54260, cityId: 2105, code: "628005" },
    { id: 54261, cityId: 2105, code: "628004" },
    { id: 54262, cityId: 2105, code: "628003" },
    { id: 54263, cityId: 2105, code: "628002" },
    { id: 54264, cityId: 2105, code: "628001" },
    { id: 54265, cityId: 2105, code: "628501" },
    { id: 54266, cityId: 170, code: "781029" },
    { id: 54267, cityId: 1907, code: "635126" },
    { id: 54268, cityId: 781, code: "560060" },
    { id: 54269, cityId: 49, code: "500097" },
    { id: 54270, cityId: 2641, code: "700089" },
    { id: 54271, cityId: 2641, code: "700129" },
    { id: 54272, cityId: 2655, code: "722101" },
    { id: 54273, cityId: 2816, code: "712201" },
    { id: 54274, cityId: 2817, code: "741155" },
    { id: 54275, cityId: 786, code: "574231" },
    { id: 54276, cityId: 2818, code: "560099" },
    { id: 54277, cityId: 1351, code: "423203" },
    { id: 54278, cityId: 382, code: "110009" },
    { id: 54279, cityId: 1880, code: "600106" },
    { id: 54280, cityId: 1925, code: "600125" },
    { id: 54281, cityId: 2004, code: "609801" },
    { id: 54282, cityId: 1880, code: "600100" },
    { id: 54283, cityId: 1878, code: "603002" },
    { id: 54284, cityId: 119, code: "521107" },
    { id: 54285, cityId: 2099, code: "613009" },
    { id: 54286, cityId: 1925, code: "600126" },
    { id: 54287, cityId: 1880, code: "600045" },
    { id: 54288, cityId: 1880, code: "600047" },
    { id: 54289, cityId: 1880, code: "600048" },
    { id: 54290, cityId: 1880, code: "600056" },
    { id: 54291, cityId: 1880, code: "600064" },
    { id: 54292, cityId: 1880, code: "600068" },
    { id: 54293, cityId: 1880, code: "600070" },
    { id: 54294, cityId: 1880, code: "600075" },
    { id: 54295, cityId: 1880, code: "600080" },
    { id: 54296, cityId: 1880, code: "600096" },
    { id: 54297, cityId: 1880, code: "600099" },
    { id: 54298, cityId: 1880, code: "600103" },
    { id: 54299, cityId: 1880, code: "600103" },
    { id: 54300, cityId: 1880, code: "600103" },
    { id: 54301, cityId: 1880, code: "600109" },
    { id: 54302, cityId: 1880, code: "600118" },
    { id: 54303, cityId: 1880, code: "600119" },
    { id: 54304, cityId: 1880, code: "600120" },
    { id: 54305, cityId: 1880, code: "600121" },
    { id: 54306, cityId: 2719, code: "700070" },
    { id: 54307, cityId: 2719, code: "700057" },
    { id: 54308, cityId: 2719, code: "700056" },
    { id: 54309, cityId: 2719, code: "700055" },
    { id: 54310, cityId: 2814, code: "733201" },
    { id: 54311, cityId: 1925, code: "631501" },
    { id: 54312, cityId: 2641, code: "743422" },
    { id: 54313, cityId: 2641, code: "700109" },
    { id: 54314, cityId: 2641, code: "743165" },
    { id: 54315, cityId: 2641, code: "700123" },
    { id: 54316, cityId: 2641, code: "700132" },
    { id: 54317, cityId: 2719, code: "700070" },
    { id: 54318, cityId: 2817, code: "741235" },
    { id: 54319, cityId: 2719, code: "700058" },
    { id: 54320, cityId: 2719, code: "700061" },
    { id: 54321, cityId: 2719, code: "700063" },
    { id: 54322, cityId: 2719, code: "700064" },
    { id: 54323, cityId: 2719, code: "700065" },
    { id: 54324, cityId: 2719, code: "700073" },
    { id: 54325, cityId: 2719, code: "700074" },
    { id: 54326, cityId: 2120, code: "625533" },
    { id: 54327, cityId: 2719, code: "700075" },
    { id: 54328, cityId: 2719, code: "700076" },
    { id: 54329, cityId: 2719, code: "700077" },
    { id: 54330, cityId: 2719, code: "700078" },
    { id: 54331, cityId: 2719, code: "700079" },
    { id: 54332, cityId: 2719, code: "700080" },
    { id: 54333, cityId: 2719, code: "700081" },
    { id: 54334, cityId: 2719, code: "700082" },
    { id: 54335, cityId: 2719, code: "700083" },
    { id: 54336, cityId: 2719, code: "700084" },
    { id: 54337, cityId: 2719, code: "700084" },
    { id: 54338, cityId: 2719, code: "700086" },
    { id: 54339, cityId: 2719, code: "700088" },
    { id: 54340, cityId: 2719, code: "700089" },
    { id: 54341, cityId: 2719, code: "700090" },
    { id: 54342, cityId: 2719, code: "700091" },
    { id: 54343, cityId: 2719, code: "700092" },
    { id: 54344, cityId: 2719, code: "700093" },
    { id: 54345, cityId: 2719, code: "700096" },
    { id: 54346, cityId: 2719, code: "700097" },
    { id: 54347, cityId: 2719, code: "700098" },
    { id: 54348, cityId: 2719, code: "700101" },
    { id: 54349, cityId: 2719, code: "700102" },
    { id: 54350, cityId: 2719, code: "700103" },
    { id: 54351, cityId: 2719, code: "700104" },
    { id: 54352, cityId: 2719, code: "700106" },
    { id: 54353, cityId: 2719, code: "700109" },
    { id: 54354, cityId: 2719, code: "700110" },
    { id: 54355, cityId: 2719, code: "735153" },
    { id: 54356, cityId: 2719, code: "735153" },
    { id: 54357, cityId: 2816, code: "712223" },
    { id: 54358, cityId: 2719, code: "712204" },
    { id: 54359, cityId: 2719, code: "712258" },
    { id: 54360, cityId: 2719, code: "712222" },
    { id: 54361, cityId: 2816, code: "712223" },
    { id: 54362, cityId: 2816, code: "712246" },
    { id: 54363, cityId: 2816, code: "712203" },
    { id: 54364, cityId: 2641, code: "743165" },
    { id: 54365, cityId: 2816, code: "743129" },
    { id: 54366, cityId: 2660, code: "713101" },
    { id: 54367, cityId: 2701, code: "711101" },
    { id: 54368, cityId: 2641, code: "743125" },
    { id: 54369, cityId: 2641, code: "700159" },
    { id: 54370, cityId: 2641, code: "700131" },
    { id: 54371, cityId: 2641, code: "700048" },
    { id: 54372, cityId: 2641, code: "700035" },
    { id: 54373, cityId: 2641, code: "700093" },
    { id: 54374, cityId: 902, code: "575029" },
    { id: 54375, cityId: 2641, code: "743223" },
    { id: 54376, cityId: 2641, code: "700155" },
    { id: 54377, cityId: 2641, code: "700130" },
    { id: 54378, cityId: 2641, code: "700133" },
    { id: 54379, cityId: 2641, code: "743405" },
    { id: 54380, cityId: 2641, code: "700135" },
    { id: 54381, cityId: 2641, code: "700124" },
    { id: 54382, cityId: 2641, code: "700128" },
    { id: 54383, cityId: 2641, code: "743445" },
    { id: 54384, cityId: 2641, code: "700127" },
    { id: 54385, cityId: 2641, code: "700126" },
    { id: 54386, cityId: 2641, code: "743446" },
    { id: 54387, cityId: 2641, code: "700135" },
    { id: 54388, cityId: 2641, code: "743456" },
    { id: 54389, cityId: 2641, code: "700125" },
    { id: 54390, cityId: 2641, code: "743439" },
    { id: 54391, cityId: 1880, code: "600122" },
    { id: 54392, cityId: 2641, code: "743711" },
    { id: 54393, cityId: 2641, code: "700106" },
    { id: 54394, cityId: 2641, code: "700098" },
    { id: 54395, cityId: 2641, code: "700156" },
    { id: 54396, cityId: 2641, code: "700097" },
    { id: 54397, cityId: 2641, code: "700105" },
    { id: 54398, cityId: 2641, code: "700105" },
    { id: 54399, cityId: 2641, code: "700100" },
    { id: 54400, cityId: 2641, code: "700158" },
    { id: 54401, cityId: 2641, code: "700118" },
    { id: 54402, cityId: 2641, code: "743124" },
    { id: 54403, cityId: 2641, code: "700134" },
    { id: 54404, cityId: 2641, code: "743130" },
    { id: 54405, cityId: 2641, code: "700112" },
    { id: 54406, cityId: 2641, code: "700111" },
    { id: 54407, cityId: 2641, code: "700121" },
    { id: 54408, cityId: 2641, code: "700115" },
    { id: 54409, cityId: 2641, code: "700119" },
    { id: 54410, cityId: 2641, code: "700116" },
    { id: 54411, cityId: 2641, code: "700122" },
    { id: 54412, cityId: 2641, code: "700113" },
    { id: 54413, cityId: 2641, code: "700114" },
    { id: 54414, cityId: 2641, code: "700117" },
    { id: 54415, cityId: 2641, code: "700120" },
    { id: 54416, cityId: 2641, code: "700147" },
    { id: 54417, cityId: 2641, code: "743339" },
    { id: 54418, cityId: 2641, code: "700146" },
    { id: 54419, cityId: 2641, code: "700143" },
    { id: 54420, cityId: 2641, code: "700103" },
    { id: 54421, cityId: 2641, code: "700149" },
    { id: 54422, cityId: 2641, code: "743392" },
    { id: 54423, cityId: 2641, code: "700154" },
    { id: 54424, cityId: 2641, code: "700138" },
    { id: 54425, cityId: 2641, code: "700152" },
    { id: 54426, cityId: 2641, code: "700142" },
    { id: 54427, cityId: 2641, code: "700145" },
    { id: 54428, cityId: 2641, code: "700151" },
    { id: 54429, cityId: 2641, code: "700153" },
    { id: 54430, cityId: 2641, code: "700104" },
    { id: 54431, cityId: 2641, code: "700150" },
    { id: 54432, cityId: 2641, code: "700139" },
    { id: 54433, cityId: 2641, code: "700144" },
    { id: 54434, cityId: 2641, code: "700096" },
    { id: 54435, cityId: 2641, code: "700137" },
    { id: 54436, cityId: 2641, code: "743503" },
    { id: 54437, cityId: 2641, code: "743363" },
    { id: 54438, cityId: 2641, code: "743345" },
    { id: 54439, cityId: 2816, code: "712602" },
    { id: 54440, cityId: 2816, code: "712249" },
    { id: 54441, cityId: 2816, code: "712139" },
    { id: 54442, cityId: 2816, code: "712310" },
    { id: 54443, cityId: 2816, code: "712250" },
    { id: 54444, cityId: 2816, code: "712311" },
    { id: 54445, cityId: 2816, code: "712708" },
    { id: 54446, cityId: 2816, code: "712707" },
    { id: 54447, cityId: 2816, code: "712410" },
    { id: 54448, cityId: 1377, code: "425419" },
    { id: 54449, cityId: 1422, code: "421601" },
    { id: 54450, cityId: 1333, code: "410204" },
    { id: 54451, cityId: 1484, code: "793014" },
    { id: 54452, cityId: 1484, code: "793017" },
    { id: 54453, cityId: 1484, code: "793022" },
    { id: 54454, cityId: 1484, code: "793015" },
    { id: 54455, cityId: 1484, code: "793018" },
    { id: 54456, cityId: 1484, code: "793200" },
    { id: 54457, cityId: 170, code: "781032" },
    { id: 54458, cityId: 2105, code: "628006" },
    { id: 54459, cityId: 2105, code: "628007" },
    { id: 54460, cityId: 2105, code: "628008" },
    { id: 54461, cityId: 2105, code: "628901" },
    { id: 54462, cityId: 2105, code: "628902" },
    { id: 54463, cityId: 2105, code: "628903" },
    { id: 54464, cityId: 2105, code: "628904" },
    { id: 54465, cityId: 2105, code: "628905" },
    { id: 54466, cityId: 2105, code: "628906" },
    { id: 54467, cityId: 2105, code: "628907" },
    { id: 54468, cityId: 2105, code: "628908" },
    { id: 54469, cityId: 2105, code: "628212" },
    { id: 54470, cityId: 2105, code: "628229" },
    { id: 54471, cityId: 2105, code: "628503" },
    { id: 54472, cityId: 2105, code: "628712" },
    { id: 54473, cityId: 2105, code: "628714" },
    { id: 54474, cityId: 2105, code: "628716" },
    { id: 54475, cityId: 2105, code: "628718" },
    { id: 54476, cityId: 2105, code: "628720" },
    { id: 54477, cityId: 2105, code: "628721" },
    { id: 54478, cityId: 2105, code: "628722" },
    { id: 54479, cityId: 2105, code: "628809" },
    { id: 54480, cityId: 2105, code: "628851" },
    { id: 54481, cityId: 2105, code: "628204" },
    { id: 54482, cityId: 2641, code: "743233" },
    { id: 54483, cityId: 2641, code: "743287" },
    { id: 54484, cityId: 2641, code: "743272" },
    { id: 54485, cityId: 2641, code: "743428" },
    { id: 54486, cityId: 2641, code: "743426" },
    { id: 54487, cityId: 2641, code: "743270" },
    { id: 54488, cityId: 2641, code: "743437" },
    { id: 54489, cityId: 2641, code: "700136" },
    { id: 54490, cityId: 2641, code: "743289" },
    { id: 54491, cityId: 2641, code: "743424" },
    { id: 54492, cityId: 2641, code: "743268" },
    { id: 54493, cityId: 2641, code: "743293" },
    { id: 54494, cityId: 2641, code: "743427" },
    { id: 54495, cityId: 2641, code: "743411" },
    { id: 54496, cityId: 2641, code: "743438" },
    { id: 54497, cityId: 2641, code: "743425" },
    { id: 54498, cityId: 2641, code: "743291" },
    { id: 54499, cityId: 2641, code: "743702" },
    { id: 54500, cityId: 2641, code: "743401" },
    { id: 54501, cityId: 2641, code: "743701" },
    { id: 54502, cityId: 2641, code: "743429" },
    { id: 54503, cityId: 2641, code: "743234" },
    { id: 54504, cityId: 2641, code: "743232" },
    { id: 54505, cityId: 2641, code: "743412" },
    { id: 54506, cityId: 2641, code: "743251" },
    { id: 54507, cityId: 2641, code: "743245" },
    { id: 54508, cityId: 2641, code: "743263" },
    { id: 54509, cityId: 2641, code: "743247" },
    { id: 54510, cityId: 2641, code: "743249" },
    { id: 54511, cityId: 2641, code: "743294" },
    { id: 54512, cityId: 2641, code: "743710" },
    { id: 54513, cityId: 2641, code: "743292" },
    { id: 54514, cityId: 2641, code: "743235" },
    { id: 54515, cityId: 2641, code: "743704" },
    { id: 54516, cityId: 2641, code: "743442" },
    { id: 54517, cityId: 2641, code: "743423" },
    { id: 54518, cityId: 2641, code: "743290" },
    { id: 54519, cityId: 2641, code: "743221" },
    { id: 54520, cityId: 2641, code: "743273" },
    { id: 54521, cityId: 2641, code: "743252" },
    { id: 54522, cityId: 2641, code: "743262" },
    { id: 54523, cityId: 2641, code: "743271" },
    { id: 54524, cityId: 2641, code: "743286" },
    { id: 54525, cityId: 2641, code: "743435" },
    { id: 54526, cityId: 2641, code: "743297" },
    { id: 54527, cityId: 2641, code: "700091" },
    { id: 54528, cityId: 2641, code: "700064" },
    { id: 54529, cityId: 2641, code: "700059" },
    { id: 54530, cityId: 2641, code: "700039" },
    { id: 54531, cityId: 2641, code: "743122" },
    { id: 54532, cityId: 2641, code: "743193" },
    { id: 54533, cityId: 2641, code: "743123" },
    { id: 54534, cityId: 2641, code: "743133" },
    { id: 54535, cityId: 2641, code: "700049" },
    { id: 54536, cityId: 2641, code: "743129" },
    { id: 54537, cityId: 2641, code: "700058" },
    { id: 54538, cityId: 2641, code: "743128" },
    { id: 54539, cityId: 2641, code: "700051" },
    { id: 54540, cityId: 2641, code: "743134" },
    { id: 54541, cityId: 2641, code: "743126" },
    { id: 54542, cityId: 2641, code: "743127" },
    { id: 54543, cityId: 2641, code: "700110" },
    { id: 54544, cityId: 2641, code: "743194" },
    { id: 54545, cityId: 2641, code: "743145" },
    { id: 54546, cityId: 2641, code: "743166" },
    { id: 54547, cityId: 2641, code: "743135" },
    { id: 54548, cityId: 2641, code: "743144" },
    { id: 54549, cityId: 2641, code: "743136" },
    { id: 54550, cityId: 2641, code: "700148" },
    { id: 54551, cityId: 2641, code: "743389" },
    { id: 54552, cityId: 2641, code: "743507" },
    { id: 54553, cityId: 2641, code: "743391" },
    { id: 54554, cityId: 2641, code: "743603" },
    { id: 54555, cityId: 2641, code: "743396" },
    { id: 54556, cityId: 2641, code: "743329" },
    { id: 54557, cityId: 2641, code: "743601" },
    { id: 54558, cityId: 2641, code: "743390" },
    { id: 54559, cityId: 2641, code: "743398" },
    { id: 54560, cityId: 2641, code: "743385" },
    { id: 54561, cityId: 2641, code: "743613" },
    { id: 54562, cityId: 2641, code: "743513" },
    { id: 54563, cityId: 2641, code: "743606" },
    { id: 54564, cityId: 2641, code: "700070" },
    { id: 54565, cityId: 2641, code: "743330" },
    { id: 54566, cityId: 2641, code: "743338" },
    { id: 54567, cityId: 2641, code: "743387" },
    { id: 54568, cityId: 2641, code: "743384" },
    { id: 54569, cityId: 2641, code: "743348" },
    { id: 54570, cityId: 2641, code: "743399" },
    { id: 54571, cityId: 2641, code: "743376" },
    { id: 54572, cityId: 2641, code: "743331" },
    { id: 54573, cityId: 2641, code: "743611" },
    { id: 54574, cityId: 2641, code: "743611" },
    { id: 54575, cityId: 2641, code: "743332" },
    { id: 54576, cityId: 2641, code: "700141" },
    { id: 54577, cityId: 2641, code: "743312" },
    { id: 54578, cityId: 2641, code: "743378" },
    { id: 54579, cityId: 2641, code: "743502" },
    { id: 54580, cityId: 2641, code: "743371" },
    { id: 54581, cityId: 2641, code: "743383" },
    { id: 54582, cityId: 2641, code: "743357" },
    { id: 54583, cityId: 2641, code: "743329" },
    { id: 54584, cityId: 2641, code: "743609" },
    { id: 54585, cityId: 2641, code: "743355" },
    { id: 54586, cityId: 2641, code: "743337" },
    { id: 54587, cityId: 2641, code: "743318" },
    { id: 54588, cityId: 2641, code: "743377" },
    { id: 54589, cityId: 2641, code: "743356" },
    { id: 54590, cityId: 2641, code: "743347" },
    { id: 54591, cityId: 2641, code: "743372" },
    { id: 54592, cityId: 2641, code: "743336" },
    { id: 54593, cityId: 2641, code: "743368" },
    { id: 54594, cityId: 2641, code: "743504" },
    { id: 54595, cityId: 2641, code: "743354" },
    { id: 54596, cityId: 2641, code: "743370" },
    { id: 54597, cityId: 2641, code: "743374" },
    { id: 54598, cityId: 2641, code: "743351" },
    { id: 54599, cityId: 2641, code: "743395" },
    { id: 54600, cityId: 2641, code: "743610" },
    { id: 54601, cityId: 2641, code: "743349" },
    { id: 54602, cityId: 2641, code: "743373" },
    { id: 54603, cityId: 2641, code: "743375" },
    { id: 54604, cityId: 2719, code: "700038" },
    { id: 54605, cityId: 2817, code: "741319" },
    { id: 54606, cityId: 2817, code: "741301" },
    { id: 54607, cityId: 2817, code: "741162" },
    { id: 54608, cityId: 2817, code: "741139" },
    { id: 54609, cityId: 2817, code: "741153" },
    { id: 54610, cityId: 2817, code: "741316" },
    { id: 54611, cityId: 2817, code: "741157" },
    { id: 54612, cityId: 2817, code: "741102" },
    { id: 54613, cityId: 2817, code: "741302" },
    { id: 54614, cityId: 2817, code: "741140" },
    { id: 54615, cityId: 2817, code: "741161" },
    { id: 54616, cityId: 2817, code: "741167" },
    { id: 54617, cityId: 2817, code: "741315" },
    { id: 54618, cityId: 2817, code: "741122" },
    { id: 54619, cityId: 2817, code: "741124" },
    { id: 54620, cityId: 2817, code: "741156" },
    { id: 54621, cityId: 2817, code: "741103" },
    { id: 54622, cityId: 2817, code: "741163" },
    { id: 54623, cityId: 2817, code: "741138" },
    { id: 54624, cityId: 2817, code: "741137" },
    { id: 54625, cityId: 2817, code: "741317" },
    { id: 54626, cityId: 2817, code: "741150" },
    { id: 54627, cityId: 2817, code: "741166" },
    { id: 54628, cityId: 2817, code: "741160" },
    { id: 54629, cityId: 2817, code: "741101" },
    { id: 54630, cityId: 2817, code: "741125" },
    { id: 54631, cityId: 2817, code: "741165" },
    { id: 54632, cityId: 2817, code: "741181" },
    { id: 54633, cityId: 2817, code: "741158" },
    { id: 54634, cityId: 2817, code: "741123" },
    { id: 54635, cityId: 2817, code: "741154" },
    { id: 54636, cityId: 2817, code: "741313" },
    { id: 54637, cityId: 2817, code: "741152" },
    { id: 54638, cityId: 2817, code: "741164" },
    { id: 54639, cityId: 2817, code: "741126" },
    { id: 54640, cityId: 2817, code: "741247" },
    { id: 54641, cityId: 2817, code: "741253" },
    { id: 54642, cityId: 2817, code: "741250" },
    { id: 54643, cityId: 2817, code: "741159" },
    { id: 54644, cityId: 2817, code: "741221" },
    { id: 54645, cityId: 2817, code: "741252" },
    { id: 54646, cityId: 2817, code: "741232" },
    { id: 54647, cityId: 2817, code: "741401" },
    { id: 54648, cityId: 2817, code: "741234" },
    { id: 54649, cityId: 2817, code: "741246" },
    { id: 54650, cityId: 2817, code: "741503" },
    { id: 54651, cityId: 2817, code: "741127" },
    { id: 54652, cityId: 2817, code: "741256" },
    { id: 54653, cityId: 2817, code: "741505" },
    { id: 54654, cityId: 2817, code: "741151" },
    { id: 54655, cityId: 2817, code: "741255" },
    { id: 54656, cityId: 2817, code: "741254" },
    { id: 54657, cityId: 2817, code: "741202" },
    { id: 54658, cityId: 2817, code: "741251" },
    { id: 54659, cityId: 2817, code: "741222" },
    { id: 54660, cityId: 2817, code: "741223" },
    { id: 54661, cityId: 2817, code: "741121" },
    { id: 54662, cityId: 2817, code: "741501" },
    { id: 54663, cityId: 2817, code: "741507" },
    { id: 54664, cityId: 2817, code: "741504" },
    { id: 54665, cityId: 2817, code: "741508" },
    { id: 54666, cityId: 2817, code: "741402" },
    { id: 54667, cityId: 2817, code: "741404" },
    { id: 54668, cityId: 2817, code: "741249" },
    { id: 54669, cityId: 2817, code: "741502" },
    { id: 54670, cityId: 2817, code: "741257" },
    { id: 54671, cityId: 2817, code: "741201" },
    { id: 54672, cityId: 2817, code: "741245" },
    { id: 54673, cityId: 2817, code: "741509" },
    { id: 54674, cityId: 2817, code: "741248" },
    { id: 54675, cityId: 2817, code: "741506" },
    { id: 54676, cityId: 2817, code: "741238" },
    { id: 54677, cityId: 2703, code: "736204" },
    { id: 54678, cityId: 2703, code: "734004" },
    { id: 54679, cityId: 2703, code: "734007" },
    { id: 54680, cityId: 2703, code: "734006" },
    { id: 54681, cityId: 2703, code: "734001" },
    { id: 54682, cityId: 2703, code: "735303" },
    { id: 54683, cityId: 2703, code: "735122" },
    { id: 54684, cityId: 2703, code: "734501" },
    { id: 54685, cityId: 2703, code: "735211" },
    { id: 54686, cityId: 2703, code: "735212" },
    { id: 54687, cityId: 2677, code: "734004" },
    { id: 54688, cityId: 2677, code: "734003" },
    { id: 54689, cityId: 2677, code: "734007" },
    { id: 54690, cityId: 2677, code: "734009" },
    { id: 54691, cityId: 2677, code: "734005" },
    { id: 54692, cityId: 2677, code: "734001" },
    { id: 54693, cityId: 2677, code: "734214" },
    { id: 54694, cityId: 2677, code: "734008" },
    { id: 54695, cityId: 2677, code: "735206" },
    { id: 54696, cityId: 2677, code: "735231" },
    { id: 54697, cityId: 2740, code: "723202" },
    { id: 54698, cityId: 2740, code: "723121" },
    { id: 54699, cityId: 2740, code: "723133" },
    { id: 54700, cityId: 2815, code: "733121" },
    { id: 54701, cityId: 2815, code: "733130" },
    { id: 54702, cityId: 2815, code: "733132" },
    { id: 54703, cityId: 2815, code: "733156" },
    { id: 54704, cityId: 2815, code: "733210" },
    { id: 54705, cityId: 2815, code: "733128" },
    { id: 54706, cityId: 2815, code: "733208" },
    { id: 54707, cityId: 2815, code: "733209" },
    { id: 54708, cityId: 2815, code: "733201" },
    { id: 54709, cityId: 2815, code: "733202" },
    { id: 54710, cityId: 2815, code: "733143" },
    { id: 54711, cityId: 2815, code: "733207" },
    { id: 54712, cityId: 2815, code: "733123" },
    { id: 54713, cityId: 2815, code: "733125" },
    { id: 54714, cityId: 2815, code: "733215" },
    { id: 54715, cityId: 2815, code: "733134" },
    { id: 54716, cityId: 2815, code: "733129" },
    { id: 54717, cityId: 1512, code: "797109" },
    { id: 54718, cityId: 1717, code: "331803" },
    { id: 54719, cityId: 2816, code: "712103" },
    { id: 54720, cityId: 2819, code: "742101" },
    { id: 54721, cityId: 2701, code: "712408" },
    { id: 54722, cityId: 2701, code: "711405" },
    { id: 54723, cityId: 2701, code: "711322" },
    { id: 54724, cityId: 2701, code: "711313" },
    { id: 54725, cityId: 2701, code: "711303" },
    { id: 54726, cityId: 2816, code: "712514" },
    { id: 54727, cityId: 2816, code: "712152" },
    { id: 54728, cityId: 2816, code: "712135" },
    { id: 54729, cityId: 2816, code: "712412" },
    { id: 54730, cityId: 2816, code: "712121" },
    { id: 54731, cityId: 2816, code: "712504" },
    { id: 54732, cityId: 2816, code: "712515" },
    { id: 54733, cityId: 2816, code: "712147" },
    { id: 54734, cityId: 2816, code: "712615" },
    { id: 54735, cityId: 2816, code: "712102" },
    { id: 54736, cityId: 2816, code: "712105" },
    { id: 54737, cityId: 2816, code: "712513" },
    { id: 54738, cityId: 2816, code: "712417" },
    { id: 54739, cityId: 2816, code: "712308" },
    { id: 54740, cityId: 2816, code: "712123" },
    { id: 54741, cityId: 2816, code: "712601" },
    { id: 54742, cityId: 2816, code: "712301" },
    { id: 54743, cityId: 2816, code: "712414" },
    { id: 54744, cityId: 2816, code: "712502" },
    { id: 54745, cityId: 2816, code: "712134" },
    { id: 54746, cityId: 2816, code: "712302" },
    { id: 54747, cityId: 2816, code: "712416" },
    { id: 54748, cityId: 2816, code: "712613" },
    { id: 54749, cityId: 2816, code: "712413" },
    { id: 54750, cityId: 2816, code: "712305" },
    { id: 54751, cityId: 2816, code: "712104" },
    { id: 54752, cityId: 2816, code: "712617" },
    { id: 54753, cityId: 2816, code: "712146" },
    { id: 54754, cityId: 2816, code: "712303" },
    { id: 54755, cityId: 2816, code: "712149" },
    { id: 54756, cityId: 2816, code: "712501" },
    { id: 54757, cityId: 2816, code: "712512" },
    { id: 54758, cityId: 2816, code: "712415" },
    { id: 54759, cityId: 2816, code: "712616" },
    { id: 54760, cityId: 2816, code: "712402" },
    { id: 54761, cityId: 2816, code: "712101" },
    { id: 54762, cityId: 2816, code: "712611" },
    { id: 54763, cityId: 2816, code: "712122" },
    { id: 54764, cityId: 2816, code: "712406" },
    { id: 54765, cityId: 2816, code: "712614" },
    { id: 54766, cityId: 2816, code: "712148" },
    { id: 54767, cityId: 2816, code: "712612" },
    { id: 54768, cityId: 2816, code: "712503" },
    { id: 54769, cityId: 2816, code: "712204" },
    { id: 54770, cityId: 2816, code: "712202" },
    { id: 54771, cityId: 2816, code: "712232" },
    { id: 54772, cityId: 2816, code: "712235" },
    { id: 54773, cityId: 2816, code: "712137" },
    { id: 54774, cityId: 2816, code: "712702" },
    { id: 54775, cityId: 2816, code: "712426" },
    { id: 54776, cityId: 2816, code: "712124" },
    { id: 54777, cityId: 2816, code: "712234" },
    { id: 54778, cityId: 2816, code: "712418" },
    { id: 54779, cityId: 2816, code: "712247" },
    { id: 54780, cityId: 2816, code: "712411" },
    { id: 54781, cityId: 2816, code: "712221" },
    { id: 54782, cityId: 2816, code: "712248" },
    { id: 54783, cityId: 2816, code: "712704" },
    { id: 54784, cityId: 2816, code: "712408" },
    { id: 54785, cityId: 2816, code: "712706" },
    { id: 54786, cityId: 2816, code: "712136" },
    { id: 54787, cityId: 2816, code: "712258" },
    { id: 54788, cityId: 2816, code: "712405" },
    { id: 54789, cityId: 2816, code: "712222" },
    { id: 54790, cityId: 2816, code: "712404" },
    { id: 54791, cityId: 2816, code: "712233" },
    { id: 54792, cityId: 2816, code: "712419" },
    { id: 54793, cityId: 2816, code: "712245" },
    { id: 54794, cityId: 2816, code: "712701" },
    { id: 54795, cityId: 2816, code: "712138" },
    { id: 54796, cityId: 2816, code: "712424" },
    { id: 54797, cityId: 2816, code: "712401" },
    { id: 54798, cityId: 2816, code: "712409" },
    { id: 54799, cityId: 2816, code: "712705" },
    { id: 54800, cityId: 2816, code: "712304" },
    { id: 54801, cityId: 2816, code: "712407" },
    { id: 54802, cityId: 2816, code: "712306" },
    { id: 54803, cityId: 2816, code: "712403" },
    { id: 54804, cityId: 2816, code: "712125" },
    { id: 54805, cityId: 447, code: "382308" },
    { id: 54806, cityId: 2655, code: "722203" },
    { id: 54807, cityId: 2655, code: "722150" },
    { id: 54808, cityId: 2655, code: "713425" },
    { id: 54809, cityId: 2655, code: "713512" },
    { id: 54810, cityId: 2655, code: "713519" },
    { id: 54811, cityId: 2655, code: "713513" },
    { id: 54812, cityId: 2655, code: "713150" },
    { id: 54813, cityId: 2655, code: "713514" },
    { id: 54814, cityId: 2655, code: "713517" },
    { id: 54815, cityId: 2660, code: "713376" },
    { id: 54816, cityId: 2660, code: "713207" },
    { id: 54817, cityId: 2660, code: "713211" },
    { id: 54818, cityId: 2660, code: "713201" },
    { id: 54819, cityId: 2660, code: "713205" },
    { id: 54820, cityId: 2660, code: "713210" },
    { id: 54821, cityId: 2660, code: "713343" },
    { id: 54822, cityId: 2660, code: "713204" },
    { id: 54823, cityId: 2660, code: "713213" },
    { id: 54824, cityId: 2660, code: "713378" },
    { id: 54825, cityId: 2660, code: "713322" },
    { id: 54826, cityId: 2660, code: "713214" },
    { id: 54827, cityId: 2660, code: "713209" },
    { id: 54828, cityId: 2660, code: "713323" },
    { id: 54829, cityId: 2660, code: "713519" },
    { id: 54830, cityId: 2660, code: "713516" },
    { id: 54831, cityId: 2660, code: "713405" },
    { id: 54832, cityId: 2660, code: "713166" },
    { id: 54833, cityId: 2660, code: "713502" },
    { id: 54834, cityId: 2660, code: "712410" },
    { id: 54835, cityId: 1470, code: "795118" },
    { id: 54836, cityId: 2816, code: "712201" },
    { id: 54837, cityId: 2655, code: "722101" },
    { id: 54838, cityId: 2658, code: "700125" },
    { id: 54839, cityId: 2655, code: "722134" },
    { id: 54840, cityId: 2820, code: "410218" },
    { id: 54841, cityId: 2641, code: "700030" },
    { id: 54842, cityId: 2641, code: "743102" },
    { id: 54843, cityId: 405, code: "382424" },
    { id: 54844, cityId: 405, code: "382480" },
    { id: 54845, cityId: 405, code: "381481" },
    { id: 54846, cityId: 405, code: "380058" },
    { id: 54847, cityId: 405, code: "380058" },
    { id: 54848, cityId: 1530, code: "751006" },
    { id: 54849, cityId: 1530, code: "751010" },
    { id: 54850, cityId: 1530, code: "751007" },
    { id: 54851, cityId: 1530, code: "757020" },
    { id: 54852, cityId: 1530, code: "751012" },
    { id: 54853, cityId: 1530, code: "751020" },
    { id: 54854, cityId: 1530, code: "751024" },
    { id: 54855, cityId: 2821, code: "797110" },
    { id: 54856, cityId: 2822, code: "798625" },
    { id: 54857, cityId: 2390, code: "226010" },
    { id: 54858, cityId: 408, code: "388120" },
    { id: 54859, cityId: 1530, code: "751002" },
    { id: 54860, cityId: 1530, code: "751003" },
    { id: 54861, cityId: 1530, code: "751004" },
    { id: 54862, cityId: 1530, code: "751005" },
    { id: 54863, cityId: 1530, code: "751006" },
    { id: 54864, cityId: 1530, code: "751007" },
    { id: 54865, cityId: 1530, code: "751008" },
    { id: 54866, cityId: 1530, code: "751010" },
    { id: 54867, cityId: 1530, code: "751011" },
    { id: 54868, cityId: 1530, code: "751013" },
    { id: 54869, cityId: 1530, code: "751014" },
    { id: 54870, cityId: 1530, code: "751016" },
    { id: 54871, cityId: 1530, code: "751017" },
    { id: 54872, cityId: 1530, code: "751019" },
    { id: 54873, cityId: 1530, code: "751021" },
    { id: 54874, cityId: 1530, code: "751022" },
    { id: 54875, cityId: 1530, code: "751023" },
    { id: 54876, cityId: 1530, code: "751025" },
    { id: 54877, cityId: 1530, code: "751026" },
    { id: 54878, cityId: 1530, code: "751027" },
    { id: 54879, cityId: 1530, code: "751027" },
    { id: 54880, cityId: 1530, code: "751028" },
    { id: 54881, cityId: 1530, code: "751029" },
    { id: 54882, cityId: 1530, code: "751030" },
    { id: 54883, cityId: 2819, code: "742402" },
    { id: 54884, cityId: 2819, code: "742407" },
    { id: 54885, cityId: 2819, code: "742113" },
    { id: 54886, cityId: 2819, code: "742164" },
    { id: 54887, cityId: 2819, code: "742160" },
    { id: 54888, cityId: 2819, code: "742408" },
    { id: 54889, cityId: 2819, code: "742165" },
    { id: 54890, cityId: 2819, code: "742137" },
    { id: 54891, cityId: 2819, code: "742104" },
    { id: 54892, cityId: 2819, code: "742406" },
    { id: 54893, cityId: 2819, code: "742238" },
    { id: 54894, cityId: 2819, code: "742225" },
    { id: 54895, cityId: 2819, code: "742303" },
    { id: 54896, cityId: 2819, code: "742404" },
    { id: 54897, cityId: 2819, code: "742187" },
    { id: 54898, cityId: 2819, code: "742175" },
    { id: 54899, cityId: 2819, code: "742213" },
    { id: 54900, cityId: 2819, code: "742136" },
    { id: 54901, cityId: 2819, code: "742122" },
    { id: 54902, cityId: 2819, code: "742132" },
    { id: 54903, cityId: 2819, code: "742135" },
    { id: 54904, cityId: 2819, code: "742237" },
    { id: 54905, cityId: 2819, code: "742148" },
    { id: 54906, cityId: 2819, code: "742103" },
    { id: 54907, cityId: 2819, code: "742138" },
    { id: 54908, cityId: 2819, code: "742133" },
    { id: 54909, cityId: 2819, code: "742168" },
    { id: 54910, cityId: 2819, code: "742236" },
    { id: 54911, cityId: 2819, code: "742121" },
    { id: 54912, cityId: 2819, code: "742134" },
    { id: 54913, cityId: 2819, code: "742227" },
    { id: 54914, cityId: 2819, code: "742306" },
    { id: 54915, cityId: 2819, code: "742212" },
    { id: 54916, cityId: 2819, code: "742149" },
    { id: 54917, cityId: 2819, code: "742184" },
    { id: 54918, cityId: 2819, code: "742304" },
    { id: 54919, cityId: 2819, code: "742147" },
    { id: 54920, cityId: 2819, code: "742202" },
    { id: 54921, cityId: 2819, code: "742163" },
    { id: 54922, cityId: 2819, code: "742223" },
    { id: 54923, cityId: 2819, code: "742224" },
    { id: 54924, cityId: 2819, code: "742302" },
    { id: 54925, cityId: 2819, code: "742140" },
    { id: 54926, cityId: 2819, code: "742201" },
    { id: 54927, cityId: 2819, code: "742308" },
    { id: 54928, cityId: 2819, code: "742189" },
    { id: 54929, cityId: 2819, code: "742123" },
    { id: 54930, cityId: 2819, code: "742159" },
    { id: 54931, cityId: 2819, code: "742401" },
    { id: 54932, cityId: 2819, code: "742174" },
    { id: 54933, cityId: 2819, code: "742301" },
    { id: 54934, cityId: 2819, code: "742161" },
    { id: 54935, cityId: 2819, code: "742151" },
    { id: 54936, cityId: 2819, code: "742405" },
    { id: 54937, cityId: 2819, code: "742226" },
    { id: 54938, cityId: 2819, code: "742102" },
    { id: 54939, cityId: 2819, code: "742166" },
    { id: 54940, cityId: 2819, code: "742305" },
    { id: 54941, cityId: 2819, code: "742235" },
    { id: 54942, cityId: 2819, code: "713123" },
    { id: 54943, cityId: 2823, code: "721423" },
    { id: 54944, cityId: 2819, code: "742402" },
    { id: 54945, cityId: 2819, code: "742407" },
    { id: 54946, cityId: 2819, code: "742113" },
    { id: 54947, cityId: 2819, code: "742164" },
    { id: 54948, cityId: 2819, code: "742160" },
    { id: 54949, cityId: 2819, code: "742408" },
    { id: 54950, cityId: 2819, code: "742165" },
    { id: 54951, cityId: 2819, code: "742137" },
    { id: 54952, cityId: 2819, code: "742104" },
    { id: 54953, cityId: 2819, code: "742406" },
    { id: 54954, cityId: 2819, code: "742238" },
    { id: 54955, cityId: 2819, code: "742225" },
    { id: 54956, cityId: 2819, code: "742303" },
    { id: 54957, cityId: 2819, code: "742404" },
    { id: 54958, cityId: 2819, code: "742187" },
    { id: 54959, cityId: 2819, code: "742175" },
    { id: 54960, cityId: 2819, code: "742213" },
    { id: 54961, cityId: 2819, code: "742136" },
    { id: 54962, cityId: 2819, code: "742122" },
    { id: 54963, cityId: 2819, code: "742132" },
    { id: 54964, cityId: 2819, code: "742135" },
    { id: 54965, cityId: 2819, code: "742237" },
    { id: 54966, cityId: 2819, code: "742148" },
    { id: 54967, cityId: 2819, code: "742103" },
    { id: 54968, cityId: 2819, code: "742138" },
    { id: 54969, cityId: 2819, code: "742133" },
    { id: 54970, cityId: 2819, code: "742168" },
    { id: 54971, cityId: 2819, code: "742236" },
    { id: 54972, cityId: 2819, code: "742121" },
    { id: 54973, cityId: 2819, code: "742134" },
    { id: 54974, cityId: 2819, code: "742227" },
    { id: 54975, cityId: 2819, code: "742306" },
    { id: 54976, cityId: 2819, code: "742212" },
    { id: 54977, cityId: 2819, code: "742149" },
    { id: 54978, cityId: 2819, code: "742184" },
    { id: 54979, cityId: 2819, code: "742304" },
    { id: 54980, cityId: 2819, code: "742147" },
    { id: 54981, cityId: 2824, code: "731235" },
    { id: 54982, cityId: 2824, code: "731133" },
    { id: 54983, cityId: 2824, code: "731244" },
    { id: 54984, cityId: 2824, code: "731224" },
    { id: 54985, cityId: 2824, code: "731130" },
    { id: 54986, cityId: 2824, code: "731104" },
    { id: 54987, cityId: 2824, code: "731242" },
    { id: 54988, cityId: 2824, code: "731220" },
    { id: 54989, cityId: 2824, code: "731245" },
    { id: 54990, cityId: 2824, code: "731213" },
    { id: 54991, cityId: 2824, code: "731126" },
    { id: 54992, cityId: 2824, code: "731238" },
    { id: 54993, cityId: 2824, code: "731123" },
    { id: 54994, cityId: 2824, code: "731121" },
    { id: 54995, cityId: 2824, code: "731243" },
    { id: 54996, cityId: 2824, code: "731223" },
    { id: 54997, cityId: 2824, code: "731219" },
    { id: 54998, cityId: 2824, code: "731215" },
    { id: 54999, cityId: 2824, code: "731241" },
    { id: 55000, cityId: 2824, code: "731214" },
    { id: 55001, cityId: 2824, code: "731102" },
    { id: 55002, cityId: 2824, code: "731303" },
    { id: 55003, cityId: 2824, code: "731237" },
    { id: 55004, cityId: 2824, code: "731124" },
    { id: 55005, cityId: 2824, code: "731103" },
    { id: 55006, cityId: 2824, code: "731233" },
    { id: 55007, cityId: 2824, code: "731302" },
    { id: 55008, cityId: 2824, code: "731129" },
    { id: 55009, cityId: 2824, code: "731216" },
    { id: 55010, cityId: 2824, code: "731202" },
    { id: 55011, cityId: 2824, code: "731221" },
    { id: 55012, cityId: 2824, code: "731132" },
    { id: 55013, cityId: 2824, code: "731201" },
    { id: 55014, cityId: 2824, code: "731204" },
    { id: 55015, cityId: 2824, code: "731125" },
    { id: 55016, cityId: 2824, code: "731236" },
    { id: 55017, cityId: 2824, code: "731301" },
    { id: 55018, cityId: 2824, code: "731127" },
    { id: 55019, cityId: 2824, code: "731240" },
    { id: 55020, cityId: 2824, code: "731101" },
    { id: 55021, cityId: 2824, code: "731222" },
    { id: 55022, cityId: 2824, code: "731234" },
    { id: 55023, cityId: 2825, code: "736204" },
    { id: 55024, cityId: 2825, code: "736206" },
    { id: 55025, cityId: 2825, code: "736176" },
    { id: 55026, cityId: 2825, code: "736158" },
    { id: 55027, cityId: 2825, code: "736160" },
    { id: 55028, cityId: 2825, code: "735217" },
    { id: 55029, cityId: 2825, code: "736169" },
    { id: 55030, cityId: 2825, code: "736172" },
    { id: 55031, cityId: 2825, code: "736101" },
    { id: 55032, cityId: 2825, code: "736159" },
    { id: 55033, cityId: 2825, code: "736135" },
    { id: 55034, cityId: 2825, code: "736134" },
    { id: 55035, cityId: 2825, code: "736133" },
    { id: 55036, cityId: 2825, code: "736156" },
    { id: 55037, cityId: 2825, code: "736167" },
    { id: 55038, cityId: 2825, code: "736145" },
    { id: 55039, cityId: 2825, code: "736170" },
    { id: 55040, cityId: 2825, code: "736146" },
    { id: 55041, cityId: 2825, code: "736157" },
    { id: 55042, cityId: 2825, code: "736168" },
    { id: 55043, cityId: 2825, code: "736165" },
    { id: 55044, cityId: 2825, code: "736179" },
    { id: 55045, cityId: 2825, code: "736171" },
    { id: 55046, cityId: 2825, code: "736131" },
    { id: 55047, cityId: 2825, code: "735211" },
    { id: 55048, cityId: 2825, code: "735224" },
    { id: 55049, cityId: 2825, code: "735303" },
    { id: 55050, cityId: 2825, code: "735301" },
    { id: 55051, cityId: 2825, code: "735304" },
    { id: 55052, cityId: 2825, code: "735122" },
    { id: 55053, cityId: 2826, code: "721135" },
    { id: 55054, cityId: 2826, code: "721435" },
    { id: 55055, cityId: 2826, code: "721443" },
    { id: 55056, cityId: 2826, code: "721438" },
    { id: 55057, cityId: 2826, code: "721423" },
    { id: 55058, cityId: 2826, code: "721437" },
    { id: 55059, cityId: 2826, code: "721440" },
    { id: 55060, cityId: 2826, code: "721450" },
    { id: 55061, cityId: 2826, code: "721442" },
    { id: 55062, cityId: 2826, code: "721463" },
    { id: 55063, cityId: 2826, code: "721448" },
    { id: 55064, cityId: 2826, code: "721439" },
    { id: 55065, cityId: 2826, code: "721434" },
    { id: 55066, cityId: 2826, code: "721422" },
    { id: 55067, cityId: 2826, code: "721429" },
    { id: 55068, cityId: 2826, code: "721427" },
    { id: 55069, cityId: 2826, code: "721458" },
    { id: 55070, cityId: 2826, code: "721455" },
    { id: 55071, cityId: 2826, code: "721425" },
    { id: 55072, cityId: 2826, code: "721441" },
    { id: 55073, cityId: 2826, code: "721420" },
    { id: 55074, cityId: 2826, code: "721432" },
    { id: 55075, cityId: 2826, code: "721444" },
    { id: 55076, cityId: 2826, code: "721433" },
    { id: 55077, cityId: 2826, code: "721456" },
    { id: 55078, cityId: 2826, code: "721449" },
    { id: 55079, cityId: 2826, code: "721430" },
    { id: 55080, cityId: 2826, code: "721447" },
    { id: 55081, cityId: 2826, code: "721431" },
    { id: 55082, cityId: 2826, code: "721446" },
    { id: 55083, cityId: 2826, code: "721428" },
    { id: 55084, cityId: 2826, code: "721454" },
    { id: 55085, cityId: 2826, code: "721401" },
    { id: 55086, cityId: 2826, code: "721452" },
    { id: 55087, cityId: 2826, code: "721453" },
    { id: 55088, cityId: 2826, code: "721131" },
    { id: 55089, cityId: 2826, code: "721253" },
    { id: 55090, cityId: 2826, code: "721153" },
    { id: 55091, cityId: 2826, code: "721606" },
    { id: 55092, cityId: 2826, code: "721607" },
    { id: 55093, cityId: 2826, code: "721172" },
    { id: 55094, cityId: 2826, code: "721652" },
    { id: 55095, cityId: 2826, code: "721604" },
    { id: 55096, cityId: 2826, code: "721632" },
    { id: 55097, cityId: 2826, code: "721130" },
    { id: 55098, cityId: 2826, code: "721137" },
    { id: 55099, cityId: 2826, code: "721646" },
    { id: 55100, cityId: 2826, code: "721643" },
    { id: 55101, cityId: 2826, code: "721171" },
    { id: 55102, cityId: 2826, code: "721658" },
    { id: 55103, cityId: 2826, code: "721634" },
    { id: 55104, cityId: 2826, code: "721648" },
    { id: 55105, cityId: 2826, code: "721603" },
    { id: 55106, cityId: 2826, code: "721647" },
    { id: 55107, cityId: 2826, code: "721158" },
    { id: 55108, cityId: 2826, code: "721657" },
    { id: 55109, cityId: 2826, code: "721635" },
    { id: 55110, cityId: 2826, code: "721645" },
    { id: 55111, cityId: 2826, code: "721653" },
    { id: 55112, cityId: 2826, code: "721167" },
    { id: 55113, cityId: 2826, code: "721151" },
    { id: 55114, cityId: 2826, code: "721631" },
    { id: 55115, cityId: 2826, code: "721654" },
    { id: 55116, cityId: 2826, code: "721626" },
    { id: 55117, cityId: 2826, code: "721633" },
    { id: 55118, cityId: 2826, code: "721625" },
    { id: 55119, cityId: 2826, code: "721641" },
    { id: 55120, cityId: 2826, code: "721627" },
    { id: 55121, cityId: 2826, code: "721602" },
    { id: 55122, cityId: 2826, code: "721134" },
    { id: 55123, cityId: 2826, code: "721649" },
    { id: 55124, cityId: 2826, code: "721601" },
    { id: 55125, cityId: 2826, code: "721655" },
    { id: 55126, cityId: 2826, code: "721656" },
    { id: 55127, cityId: 2826, code: "721636" },
    { id: 55128, cityId: 2826, code: "721642" },
    { id: 55129, cityId: 2826, code: "721659" },
    { id: 55130, cityId: 2826, code: "721152" },
    { id: 55131, cityId: 2826, code: "721629" },
    { id: 55132, cityId: 2826, code: "721628" },
    { id: 55133, cityId: 2826, code: "721154" },
    { id: 55134, cityId: 2826, code: "721650" },
    { id: 55135, cityId: 2826, code: "721139" },
    { id: 55136, cityId: 2826, code: "721644" },
    { id: 55137, cityId: 2826, code: "721651" },
    { id: 55138, cityId: 2827, code: "732143" },
    { id: 55139, cityId: 2827, code: "732213" },
    { id: 55140, cityId: 2827, code: "732147" },
    { id: 55141, cityId: 2827, code: "732212" },
    { id: 55142, cityId: 2827, code: "732215" },
    { id: 55143, cityId: 2827, code: "732144" },
    { id: 55144, cityId: 2827, code: "732211" },
    { id: 55145, cityId: 2827, code: "732209" },
    { id: 55146, cityId: 2827, code: "732141" },
    { id: 55147, cityId: 2827, code: "732202" },
    { id: 55148, cityId: 2827, code: "732150" },
    { id: 55149, cityId: 2827, code: "732127" },
    { id: 55150, cityId: 2827, code: "732103" },
    { id: 55151, cityId: 2827, code: "732214" },
    { id: 55152, cityId: 2827, code: "732121" },
    { id: 55153, cityId: 2827, code: "732122" },
    { id: 55154, cityId: 2827, code: "732210" },
    { id: 55155, cityId: 2827, code: "732140" },
    { id: 55156, cityId: 2827, code: "732142" },
    { id: 55157, cityId: 2827, code: "732128" },
    { id: 55158, cityId: 2827, code: "732123" },
    { id: 55159, cityId: 2827, code: "732205" },
    { id: 55160, cityId: 2827, code: "732206" },
    { id: 55161, cityId: 2827, code: "732125" },
    { id: 55162, cityId: 2827, code: "732102" },
    { id: 55163, cityId: 2827, code: "732139" },
    { id: 55164, cityId: 2827, code: "732207" },
    { id: 55165, cityId: 2827, code: "732101" },
    { id: 55166, cityId: 2827, code: "732208" },
    { id: 55167, cityId: 2827, code: "732204" },
    { id: 55168, cityId: 2827, code: "732138" },
    { id: 55169, cityId: 2827, code: "732124" },
    { id: 55170, cityId: 2827, code: "732126" },
    { id: 55171, cityId: 2827, code: "732201" },
    { id: 55172, cityId: 2827, code: "732203" },
    { id: 55173, cityId: 2827, code: "732216" },
    { id: 55174, cityId: 2827, code: "733142" },
    { id: 55175, cityId: 2827, code: "733124" },
    { id: 55176, cityId: 2828, code: "721425" },
    { id: 55177, cityId: 2828, code: "721443" },
    { id: 55178, cityId: 2828, code: "721426" },
    { id: 55179, cityId: 2828, code: "721467" },
    { id: 55180, cityId: 2828, code: "721125" },
    { id: 55181, cityId: 2828, code: "721424" },
    { id: 55182, cityId: 2828, code: "721135" },
    { id: 55183, cityId: 2828, code: "721451" },
    { id: 55184, cityId: 2828, code: "721159" },
    { id: 55185, cityId: 2828, code: "721133" },
    { id: 55186, cityId: 2828, code: "721435" },
    { id: 55187, cityId: 2828, code: "721143" },
    { id: 55188, cityId: 2828, code: "721445" },
    { id: 55189, cityId: 2828, code: "721436" },
    { id: 55190, cityId: 2828, code: "721457" },
    { id: 55191, cityId: 2828, code: "721437" },
    { id: 55192, cityId: 2828, code: "721303" },
    { id: 55193, cityId: 2828, code: "721304" },
    { id: 55194, cityId: 2828, code: "721132" },
    { id: 55195, cityId: 2828, code: "721129" },
    { id: 55196, cityId: 2828, code: "721505" },
    { id: 55197, cityId: 2828, code: "721302" },
    { id: 55198, cityId: 2828, code: "721124" },
    { id: 55199, cityId: 2828, code: "721161" },
    { id: 55200, cityId: 2828, code: "721201" },
    { id: 55201, cityId: 2828, code: "721122" },
    { id: 55202, cityId: 2828, code: "721222" },
    { id: 55203, cityId: 2828, code: "721306" },
    { id: 55204, cityId: 2828, code: "721517" },
    { id: 55205, cityId: 2828, code: "721121" },
    { id: 55206, cityId: 2828, code: "721155" },
    { id: 55207, cityId: 2828, code: "721160" },
    { id: 55208, cityId: 2828, code: "721126" },
    { id: 55209, cityId: 2828, code: "721128" },
    { id: 55210, cityId: 2828, code: "721145" },
    { id: 55211, cityId: 2828, code: "721501" },
    { id: 55212, cityId: 2828, code: "721516" },
    { id: 55213, cityId: 2828, code: "721144" },
    { id: 55214, cityId: 2828, code: "721149" },
    { id: 55215, cityId: 2828, code: "721504" },
    { id: 55216, cityId: 2828, code: "721232" },
    { id: 55217, cityId: 2828, code: "721131" },
    { id: 55218, cityId: 2828, code: "721136" },
    { id: 55219, cityId: 2828, code: "721515" },
    { id: 55220, cityId: 2828, code: "721513" },
    { id: 55221, cityId: 2828, code: "721503" },
    { id: 55222, cityId: 2828, code: "721101" },
    { id: 55223, cityId: 2828, code: "721253" },
    { id: 55224, cityId: 2828, code: "721156" },
    { id: 55225, cityId: 2828, code: "721140" },
    { id: 55226, cityId: 2828, code: "721514" },
    { id: 55227, cityId: 2828, code: "721507" },
    { id: 55228, cityId: 2828, code: "721305" },
    { id: 55229, cityId: 2828, code: "721127" },
    { id: 55230, cityId: 2828, code: "721212" },
    { id: 55231, cityId: 2828, code: "721150" },
    { id: 55232, cityId: 2828, code: "721147" },
    { id: 55233, cityId: 2828, code: "721157" },
    { id: 55234, cityId: 2828, code: "721301" },
    { id: 55235, cityId: 2828, code: "721146" },
    { id: 55236, cityId: 2828, code: "721506" },
    { id: 55237, cityId: 2828, code: "721242" },
    { id: 55238, cityId: 2828, code: "721102" },
    { id: 55239, cityId: 2828, code: "721166" },
    { id: 55240, cityId: 2828, code: "721260" },
    { id: 55241, cityId: 2828, code: "721211" },
    { id: 55242, cityId: 2828, code: "721130" },
    { id: 55243, cityId: 2828, code: "721153" },
    { id: 55244, cityId: 2828, code: "721627" },
    { id: 55245, cityId: 2828, code: "721148" },
    { id: 55246, cityId: 2828, code: "721641" },
    { id: 55247, cityId: 967, code: "575020" },
    { id: 55248, cityId: 1530, code: "751001" },
    { id: 55249, cityId: 1530, code: "751020" },
    { id: 55250, cityId: 1530, code: "752101" },
    { id: 55251, cityId: 1530, code: "752102" },
    { id: 55252, cityId: 1530, code: "752103" },
    { id: 55253, cityId: 1530, code: "752100" },
    { id: 55254, cityId: 1530, code: "751024" },
    { id: 55255, cityId: 1530, code: "751006" },
    { id: 55256, cityId: 1530, code: "751002" },
    { id: 55257, cityId: 1530, code: "752102" },
    { id: 55258, cityId: 1530, code: "751001" },
    { id: 55259, cityId: 1530, code: "752102" },
    { id: 55260, cityId: 1530, code: "751018" },
    { id: 55261, cityId: 1530, code: "752102" },
    { id: 55262, cityId: 1530, code: "751003" },
    { id: 55263, cityId: 1530, code: "751002" },
    { id: 55264, cityId: 1530, code: "751015" },
    { id: 55265, cityId: 1530, code: "752101" },
    { id: 55266, cityId: 1530, code: "751017" },
    { id: 55267, cityId: 1530, code: "751017" },
    { id: 55268, cityId: 1530, code: "751024" },
    { id: 55269, cityId: 1530, code: "751020" },
    { id: 55270, cityId: 1530, code: "752102" },
    { id: 55271, cityId: 1530, code: "751023" },
    { id: 55272, cityId: 1530, code: "752100" },
    { id: 55273, cityId: 1530, code: "752102" },
    { id: 55274, cityId: 1530, code: "751004" },
    { id: 55275, cityId: 1530, code: "751022" },
    { id: 55276, cityId: 1530, code: "752103" },
    { id: 55277, cityId: 1530, code: "751009" },
    { id: 55278, cityId: 1530, code: "751003" },
    { id: 55279, cityId: 1530, code: "751022" },
    { id: 55280, cityId: 1530, code: "751014" },
    { id: 55281, cityId: 1530, code: "752102" },
    { id: 55282, cityId: 1530, code: "751019" },
    { id: 55283, cityId: 1530, code: "751025" },
    { id: 55284, cityId: 1530, code: "752101" },
    { id: 55285, cityId: 1530, code: "752100" },
    { id: 55286, cityId: 1530, code: "751002" },
    { id: 55287, cityId: 1530, code: "751002" },
    { id: 55288, cityId: 1530, code: "752101" },
    { id: 55289, cityId: 1530, code: "752103" },
    { id: 55290, cityId: 1530, code: "751007" },
    { id: 55291, cityId: 1530, code: "751006" },
    { id: 55292, cityId: 1530, code: "751003" },
    { id: 55293, cityId: 1530, code: "751009" },
    { id: 55294, cityId: 1530, code: "751007" },
    { id: 55295, cityId: 1530, code: "752102" },
    { id: 55296, cityId: 1530, code: "752100" },
    { id: 55297, cityId: 1530, code: "751002" },
    { id: 55298, cityId: 1530, code: "751001" },
    { id: 55299, cityId: 1530, code: "751001" },
    { id: 55300, cityId: 1530, code: "751003" },
    { id: 55301, cityId: 1530, code: "751002" },
    { id: 55302, cityId: 1530, code: "751017" },
    { id: 55303, cityId: 1530, code: "751002" },
    { id: 55304, cityId: 1530, code: "751013" },
    { id: 55305, cityId: 1530, code: "751021" },
    { id: 55306, cityId: 1530, code: "751019" },
    { id: 55307, cityId: 1530, code: "752100" },
    { id: 55308, cityId: 1530, code: "752101" },
    { id: 55309, cityId: 1530, code: "752103" },
    { id: 55310, cityId: 1530, code: "751003" },
    { id: 55311, cityId: 1530, code: "751006" },
    { id: 55312, cityId: 1530, code: "752102" },
    { id: 55313, cityId: 1530, code: "752102" },
    { id: 55314, cityId: 1530, code: "751024" },
    { id: 55315, cityId: 1530, code: "751019" },
    { id: 55316, cityId: 1530, code: "751017" },
    { id: 55317, cityId: 1530, code: "752103" },
    { id: 55318, cityId: 1530, code: "751002" },
    { id: 55319, cityId: 1530, code: "751009" },
    { id: 55320, cityId: 1530, code: "751030" },
    { id: 55321, cityId: 1530, code: "751001" },
    { id: 55322, cityId: 1530, code: "752102" },
    { id: 55323, cityId: 1530, code: "751010" },
    { id: 55324, cityId: 1530, code: "751005" },
    { id: 55325, cityId: 1530, code: "751002" },
    { id: 55326, cityId: 1530, code: "752100" },
    { id: 55327, cityId: 1530, code: "752103" },
    { id: 55328, cityId: 1530, code: "752103" },
    { id: 55329, cityId: 1530, code: "752100" },
    { id: 55330, cityId: 1530, code: "751011" },
    { id: 55331, cityId: 1530, code: "751002" },
    { id: 55332, cityId: 1530, code: "751002" },
    { id: 55333, cityId: 1530, code: "752100" },
    { id: 55334, cityId: 1530, code: "752102" },
    { id: 55335, cityId: 1530, code: "752103" },
    { id: 55336, cityId: 1530, code: "751003" },
    { id: 55337, cityId: 1530, code: "751019" },
    { id: 55338, cityId: 1530, code: "752100" },
    { id: 55339, cityId: 1530, code: "752102" },
    { id: 55340, cityId: 1530, code: "752100" },
    { id: 55341, cityId: 1530, code: "751007" },
    { id: 55342, cityId: 1530, code: "751020" },
    { id: 55343, cityId: 1530, code: "751003" },
    { id: 55344, cityId: 1530, code: "751014" },
    { id: 55345, cityId: 1530, code: "751009" },
    { id: 55346, cityId: 1530, code: "751001" },
    { id: 55347, cityId: 1530, code: "751016" },
    { id: 55348, cityId: 1530, code: "752102" },
    { id: 55349, cityId: 1530, code: "752102" },
    { id: 55350, cityId: 1530, code: "752103" },
    { id: 55351, cityId: 1530, code: "751006" },
    { id: 55352, cityId: 1530, code: "751022" },
    { id: 55353, cityId: 1530, code: "751012" },
    { id: 55354, cityId: 1530, code: "751008" },
    { id: 55355, cityId: 1530, code: "751002" },
    { id: 55356, cityId: 1530, code: "752054" },
    { id: 55357, cityId: 1530, code: "752054" },
    { id: 55358, cityId: 1530, code: "752050" },
    { id: 55359, cityId: 1530, code: "752050" },
    { id: 55360, cityId: 1530, code: "752054" },
    { id: 55361, cityId: 1530, code: "752050" },
    { id: 55362, cityId: 1530, code: "752050" },
    { id: 55363, cityId: 1530, code: "752054" },
    { id: 55364, cityId: 1530, code: "752050" },
    { id: 55365, cityId: 1530, code: "752054" },
    { id: 55366, cityId: 1530, code: "752050" },
    { id: 55367, cityId: 1530, code: "752054" },
    { id: 55368, cityId: 1530, code: "752050" },
    { id: 55369, cityId: 1530, code: "752050" },
    { id: 55370, cityId: 1530, code: "752054" },
    { id: 55371, cityId: 1530, code: "752054" },
    { id: 55372, cityId: 1530, code: "752050" },
    { id: 55373, cityId: 1530, code: "752054" },
    { id: 55374, cityId: 1530, code: "752050" },
    { id: 55375, cityId: 1530, code: "752054" },
    { id: 55376, cityId: 1530, code: "752054" },
    { id: 55377, cityId: 1530, code: "752050" },
    { id: 55378, cityId: 2829, code: "798618" },
    { id: 55379, cityId: 2830, code: "797002" },
    { id: 55380, cityId: 2831, code: "798622" },
    { id: 55381, cityId: 2833, code: "790003" },
    { id: 55382, cityId: 2834, code: "791119" },
    { id: 55383, cityId: 2835, code: "791003" },
    { id: 55384, cityId: 2836, code: "791119" },
    { id: 55385, cityId: 2837, code: "792129" },
    { id: 55386, cityId: 134, code: "792056" },
    { id: 55387, cityId: 2836, code: "791110" },
    { id: 55388, cityId: 2836, code: "791109" },
    { id: 55389, cityId: 2839, code: "790106" },
    { id: 55390, cityId: 2836, code: "791123" },
    { id: 55391, cityId: 2835, code: "791125" },
    { id: 55392, cityId: 2837, code: "792130" },
    { id: 55393, cityId: 2839, code: "790105" },
    { id: 55394, cityId: 2840, code: "792105" },
    { id: 55395, cityId: 2835, code: "791105" },
    { id: 55396, cityId: 2842, code: "791118" },
    { id: 55397, cityId: 2833, code: "790116" },
    { id: 55398, cityId: 2837, code: "792131" },
    { id: 55399, cityId: 134, code: "792123" },
    { id: 55400, cityId: 134, code: "792121" },
    { id: 55401, cityId: 134, code: "792120" },
    { id: 55402, cityId: 134, code: "792103" },
    { id: 55403, cityId: 134, code: "792122" },
    { id: 55404, cityId: 2835, code: "791101" },
    { id: 55405, cityId: 2835, code: "791001" },
    { id: 55406, cityId: 2833, code: "790102" },
    { id: 55407, cityId: 2833, code: "790001" },
    { id: 55408, cityId: 2833, code: "790002" },
    { id: 55409, cityId: 2833, code: "790114" },
    { id: 55410, cityId: 2833, code: "790101" },
    { id: 55411, cityId: 2841, code: "791102" },
    { id: 55412, cityId: 2841, code: "791002" },
    { id: 55413, cityId: 2841, code: "791105" },
    { id: 55414, cityId: 2839, code: "790104" },
    { id: 55415, cityId: 2836, code: "791001" },
    { id: 55416, cityId: 2836, code: "790001" },
    { id: 55417, cityId: 2836, code: "791121" },
    { id: 55418, cityId: 2836, code: "791111" },
    { id: 55419, cityId: 2836, code: "791113" },
    { id: 55420, cityId: 2836, code: "792104" },
    { id: 55421, cityId: 2836, code: "791112" },
    { id: 55422, cityId: 2834, code: "791113" },
    { id: 55423, cityId: 2834, code: "791120" },
    { id: 55424, cityId: 2840, code: "792102" },
    { id: 55425, cityId: 2840, code: "792103" },
    { id: 55426, cityId: 2840, code: "792104" },
    { id: 55427, cityId: 2840, code: "792111" },
    { id: 55428, cityId: 2840, code: "792001" },
    { id: 55429, cityId: 2641, code: "700047" },
    { id: 55430, cityId: 1880, code: "600071" },
    { id: 55431, cityId: 1880, code: "600125" },
    { id: 55432, cityId: 902, code: "575019" },
    { id: 55433, cityId: 786, code: "574243" },
    { id: 55434, cityId: 966, code: "574118" },
    { id: 55435, cityId: 786, code: "574219" },
    { id: 55436, cityId: 852, code: "583201" },
    { id: 55438, cityId: 5, code: "504104" },
    { id: 55439, cityId: 5, code: "504272" },
    { id: 55440, cityId: 5, code: "504293" },
    { id: 55441, cityId: 27, code: "517592" },
    { id: 55442, cityId: 27, code: "517113" },
    { id: 55443, cityId: 28, code: "516421" },
    { id: 55444, cityId: 28, code: "515465" },
    { id: 55445, cityId: 34, code: "533263" },
    { id: 55446, cityId: 34, code: "507130" },
    { id: 55447, cityId: 34, code: "534315" },
    { id: 55448, cityId: 34, code: "533125" },
    { id: 55449, cityId: 34, code: "533464" },
    { id: 55450, cityId: 34, code: "533430" },
    { id: 55451, cityId: 34, code: "533234" },
    { id: 55452, cityId: 49, code: "500101" },
    { id: 55453, cityId: 49, code: "500088" },
    { id: 55454, cityId: 49, code: "501101" },
    { id: 55455, cityId: 49, code: "501301" },
    { id: 55456, cityId: 49, code: "501401" },
    { id: 55457, cityId: 49, code: "500090" },
    { id: 55458, cityId: 62, code: "507128" },
    { id: 55459, cityId: 62, code: "507306" },
    { id: 55460, cityId: 62, code: "507209" },
    { id: 55461, cityId: 65, code: "521332" },
    { id: 55462, cityId: 65, code: "521132" },
    { id: 55463, cityId: 65, code: "521153" },
    { id: 55464, cityId: 65, code: "521134" },
    { id: 55465, cityId: 65, code: "521227" },
    { id: 55466, cityId: 67, code: "518466" },
    { id: 55467, cityId: 67, code: "518510" },
    { id: 55468, cityId: 67, code: "518465" },
    { id: 55469, cityId: 76, code: "502313" },
    { id: 55470, cityId: 78, code: "508376" },
    { id: 55471, cityId: 86, code: "503108" },
    { id: 55472, cityId: 86, code: "503217" },
    { id: 55473, cityId: 109, code: "532428" },
    { id: 55474, cityId: 109, code: "535125" },
    { id: 55475, cityId: 109, code: "532403" },
    { id: 55476, cityId: 109, code: "532218" },
    { id: 55477, cityId: 109, code: "532291" },
    { id: 55478, cityId: 109, code: "532127" },
    { id: 55479, cityId: 109, code: "535128" },
    { id: 55480, cityId: 109, code: "532430" },
    { id: 55481, cityId: 109, code: "532429" },
    { id: 55482, cityId: 120, code: "531085" },
    { id: 55483, cityId: 120, code: "531028" },
    { id: 55484, cityId: 120, code: "531060" },
    { id: 55485, cityId: 120, code: "530020" },
    { id: 55486, cityId: 120, code: "531022" },
    { id: 55487, cityId: 120, code: "530007" },
    { id: 55488, cityId: 120, code: "531034" },
    { id: 55489, cityId: 120, code: "531117" },
    { id: 55490, cityId: 120, code: "531111" },
    { id: 55491, cityId: 120, code: "530032" },
    { id: 55492, cityId: 120, code: "535273" },
    { id: 55493, cityId: 120, code: "531029" },
    { id: 55494, cityId: 120, code: "531149" },
    { id: 55495, cityId: 120, code: "530013" },
    { id: 55496, cityId: 120, code: "531035" },
    { id: 55497, cityId: 120, code: "531219" },
    { id: 55498, cityId: 120, code: "531162" },
    { id: 55499, cityId: 120, code: "530026" },
    { id: 55500, cityId: 120, code: "531105" },
    { id: 55501, cityId: 120, code: "531075" },
    { id: 55502, cityId: 120, code: "531011" },
    { id: 55503, cityId: 120, code: "531151" },
    { id: 55504, cityId: 120, code: "530027" },
    { id: 55505, cityId: 120, code: "530014" },
    { id: 55506, cityId: 120, code: "531113" },
    { id: 55507, cityId: 120, code: "530040" },
    { id: 55508, cityId: 120, code: "531081" },
    { id: 55509, cityId: 120, code: "531024" },
    { id: 55510, cityId: 120, code: "530008" },
    { id: 55511, cityId: 120, code: "530002" },
    { id: 55512, cityId: 120, code: "531030" },
    { id: 55513, cityId: 120, code: "531163" },
    { id: 55514, cityId: 120, code: "531055" },
    { id: 55515, cityId: 120, code: "530015" },
    { id: 55516, cityId: 120, code: "531023" },
    { id: 55517, cityId: 120, code: "531036" },
    { id: 55518, cityId: 120, code: "530003" },
    { id: 55519, cityId: 120, code: "530009" },
    { id: 55520, cityId: 120, code: "531061" },
    { id: 55521, cityId: 120, code: "530022" },
    { id: 55522, cityId: 120, code: "530012" },
    { id: 55523, cityId: 120, code: "531077" },
    { id: 55524, cityId: 120, code: "531084" },
    { id: 55525, cityId: 120, code: "530005" },
    { id: 55526, cityId: 120, code: "531021" },
    { id: 55527, cityId: 120, code: "535183" },
    { id: 55528, cityId: 120, code: "531027" },
    { id: 55529, cityId: 120, code: "530011" },
    { id: 55530, cityId: 120, code: "531115" },
    { id: 55531, cityId: 120, code: "535145" },
    { id: 55532, cityId: 120, code: "531116" },
    { id: 55533, cityId: 120, code: "531173" },
    { id: 55534, cityId: 120, code: "530024" },
    { id: 55535, cityId: 120, code: "535005" },
    { id: 55536, cityId: 120, code: "531002" },
    { id: 55537, cityId: 120, code: "530018" },
    { id: 55538, cityId: 120, code: "531040" },
    { id: 55539, cityId: 120, code: "535250" },
    { id: 55540, cityId: 120, code: "531114" },
    { id: 55541, cityId: 120, code: "530004" },
    { id: 55542, cityId: 120, code: "531133" },
    { id: 55543, cityId: 120, code: "530017" },
    { id: 55544, cityId: 120, code: "531082" },
    { id: 55545, cityId: 120, code: "531025" },
    { id: 55546, cityId: 120, code: "531126" },
    { id: 55547, cityId: 120, code: "531031" },
    { id: 55548, cityId: 120, code: "531127" },
    { id: 55549, cityId: 120, code: "531032" },
    { id: 55550, cityId: 120, code: "530016" },
    { id: 55551, cityId: 120, code: "531087" },
    { id: 55552, cityId: 120, code: "530028" },
    { id: 55553, cityId: 120, code: "531026" },
    { id: 55554, cityId: 120, code: "530029" },
    { id: 55555, cityId: 120, code: "530035" },
    { id: 55556, cityId: 120, code: "531083" },
    { id: 55557, cityId: 120, code: "531001" },
    { id: 55558, cityId: 120, code: "530031" },
    { id: 55559, cityId: 120, code: "531033" },
    { id: 55560, cityId: 122, code: "535273" },
    { id: 55561, cityId: 122, code: "535145" },
    { id: 55562, cityId: 122, code: "535183" },
    { id: 55563, cityId: 122, code: "535125" },
    { id: 55564, cityId: 122, code: "532127" },
    { id: 55565, cityId: 122, code: "531162" },
    { id: 55566, cityId: 122, code: "535005" },
    { id: 55567, cityId: 122, code: "532122" },
    { id: 55568, cityId: 122, code: "535250" },
    { id: 55569, cityId: 122, code: "535128" },
    { id: 55570, cityId: 122, code: "532407" },
    { id: 55571, cityId: 124, code: "506134" },
    { id: 55572, cityId: 125, code: "534329" },
    { id: 55573, cityId: 125, code: "534448" },
    { id: 55574, cityId: 125, code: "534427" },
    { id: 55575, cityId: 125, code: "534123" },
    { id: 55576, cityId: 125, code: "534447" },
    { id: 55577, cityId: 125, code: "534199" },
    { id: 55578, cityId: 150, code: "781367" },
    { id: 55579, cityId: 150, code: "781316" },
    { id: 55580, cityId: 150, code: "781307" },
    { id: 55581, cityId: 150, code: "781325" },
    { id: 55582, cityId: 150, code: "781350" },
    { id: 55583, cityId: 155, code: "783389" },
    { id: 55584, cityId: 155, code: "783383" },
    { id: 55585, cityId: 155, code: "783390" },
    { id: 55586, cityId: 155, code: "783134" },
    { id: 55587, cityId: 155, code: "783388" },
    { id: 55588, cityId: 155, code: "783382" },
    { id: 55589, cityId: 155, code: "783391" },
    { id: 55590, cityId: 155, code: "783384" },
    { id: 55591, cityId: 155, code: "783385" },
    { id: 55592, cityId: 155, code: "783360" },
    { id: 55593, cityId: 155, code: "783392" },
    { id: 55594, cityId: 155, code: "783381" },
    { id: 55595, cityId: 161, code: "787059" },
    { id: 55596, cityId: 161, code: "787053" },
    { id: 55597, cityId: 161, code: "787034" },
    { id: 55598, cityId: 161, code: "787058" },
    { id: 55599, cityId: 161, code: "787035" },
    { id: 55600, cityId: 163, code: "783131" },
    { id: 55601, cityId: 163, code: "783345" },
    { id: 55602, cityId: 163, code: "783383" },
    { id: 55603, cityId: 163, code: "783371" },
    { id: 55604, cityId: 163, code: "783348" },
    { id: 55605, cityId: 163, code: "783337" },
    { id: 55606, cityId: 163, code: "783325" },
    { id: 55607, cityId: 163, code: "783388" },
    { id: 55608, cityId: 164, code: "786184" },
    { id: 55609, cityId: 164, code: "786189" },
    { id: 55610, cityId: 164, code: "786103" },
    { id: 55611, cityId: 164, code: "786621" },
    { id: 55612, cityId: 167, code: "783126" },
    { id: 55613, cityId: 169, code: "785602" },
    { id: 55614, cityId: 169, code: "785671" },
    { id: 55615, cityId: 169, code: "785601" },
    { id: 55616, cityId: 169, code: "785626" },
    { id: 55617, cityId: 169, code: "785625" },
    { id: 55618, cityId: 169, code: "785612" },
    { id: 55619, cityId: 169, code: "785613" },
    { id: 55620, cityId: 169, code: "785619" },
    { id: 55621, cityId: 169, code: "785610" },
    { id: 55622, cityId: 169, code: "785705" },
    { id: 55623, cityId: 169, code: "785622" },
    { id: 55624, cityId: 169, code: "785615" },
    { id: 55625, cityId: 169, code: "785611" },
    { id: 55626, cityId: 169, code: "785618" },
    { id: 55627, cityId: 169, code: "785104" },
    { id: 55628, cityId: 169, code: "785603" },
    { id: 55629, cityId: 169, code: "785703" },
    { id: 55630, cityId: 169, code: "785691" },
    { id: 55631, cityId: 172, code: "788165" },
    { id: 55632, cityId: 172, code: "788152" },
    { id: 55633, cityId: 172, code: "788736" },
    { id: 55634, cityId: 172, code: "788735" },
    { id: 55635, cityId: 172, code: "788163" },
    { id: 55636, cityId: 172, code: "788164" },
    { id: 55637, cityId: 172, code: "788734" },
    { id: 55638, cityId: 172, code: "788801" },
    { id: 55639, cityId: 172, code: "788161" },
    { id: 55640, cityId: 172, code: "788160" },
    { id: 55641, cityId: 172, code: "788117" },
    { id: 55642, cityId: 172, code: "788737" },
    { id: 55643, cityId: 172, code: "788155" },
    { id: 55644, cityId: 172, code: "788802" },
    { id: 55645, cityId: 172, code: "788156" },
    { id: 55646, cityId: 172, code: "788150" },
    { id: 55647, cityId: 172, code: "788162" },
    { id: 55648, cityId: 178, code: "785633" },
    { id: 55649, cityId: 178, code: "785112" },
    { id: 55650, cityId: 178, code: "785601" },
    { id: 55651, cityId: 178, code: "785010" },
    { id: 55652, cityId: 178, code: "785015" },
    { id: 55653, cityId: 178, code: "785111" },
    { id: 55654, cityId: 178, code: "785009" },
    { id: 55655, cityId: 178, code: "785666" },
    { id: 55656, cityId: 178, code: "785101" },
    { id: 55657, cityId: 178, code: "785703" },
    { id: 55658, cityId: 178, code: "785014" },
    { id: 55659, cityId: 178, code: "785635" },
    { id: 55660, cityId: 180, code: "788120" },
    { id: 55661, cityId: 180, code: "788006" },
    { id: 55662, cityId: 180, code: "788806" },
    { id: 55663, cityId: 181, code: "783127" },
    { id: 55664, cityId: 181, code: "783337" },
    { id: 55665, cityId: 181, code: "783372" },
    { id: 55666, cityId: 192, code: "782410" },
    { id: 55667, cityId: 192, code: "782104" },
    { id: 55668, cityId: 192, code: "782103" },
    { id: 55669, cityId: 192, code: "782412" },
    { id: 55670, cityId: 192, code: "782001" },
    { id: 55671, cityId: 192, code: "782127" },
    { id: 55672, cityId: 192, code: "782411" },
    { id: 55673, cityId: 192, code: "782126" },
    { id: 55674, cityId: 194, code: "782460" },
    { id: 55675, cityId: 194, code: "782123" },
    { id: 55676, cityId: 194, code: "782446" },
    { id: 55677, cityId: 194, code: "785602" },
    { id: 55678, cityId: 194, code: "782481" },
    { id: 55679, cityId: 194, code: "782442" },
    { id: 55680, cityId: 195, code: "781375" },
    { id: 55681, cityId: 195, code: "781351" },
    { id: 55682, cityId: 195, code: "781329" },
    { id: 55683, cityId: 195, code: "781317" },
    { id: 55684, cityId: 195, code: "781309" },
    { id: 55685, cityId: 195, code: "781371" },
    { id: 55686, cityId: 195, code: "781305" },
    { id: 55687, cityId: 197, code: "494661" },
    { id: 55688, cityId: 208, code: "785681" },
    { id: 55689, cityId: 208, code: "785694" },
    { id: 55690, cityId: 208, code: "785688" },
    { id: 55691, cityId: 208, code: "785701" },
    { id: 55692, cityId: 208, code: "785614" },
    { id: 55693, cityId: 208, code: "785690" },
    { id: 55694, cityId: 208, code: "785670" },
    { id: 55695, cityId: 208, code: "785616" },
    { id: 55696, cityId: 208, code: "785692" },
    { id: 55697, cityId: 208, code: "785705" },
    { id: 55698, cityId: 208, code: "785006" },
    { id: 55699, cityId: 208, code: "785685" },
    { id: 55700, cityId: 208, code: "785691" },
    { id: 55701, cityId: 208, code: "785602" },
    { id: 55702, cityId: 208, code: "785107" },
    { id: 55703, cityId: 208, code: "785680" },
    { id: 55704, cityId: 215, code: "786157" },
    { id: 55705, cityId: 215, code: "786170" },
    { id: 55706, cityId: 215, code: "786158" },
    { id: 55707, cityId: 215, code: "786189" },
    { id: 55708, cityId: 215, code: "786183" },
    { id: 55709, cityId: 215, code: "786171" },
    { id: 55710, cityId: 215, code: "786145" },
    { id: 55711, cityId: 215, code: "786159" },
    { id: 55712, cityId: 215, code: "786152" },
    { id: 55713, cityId: 215, code: "786601" },
    { id: 55714, cityId: 215, code: "786147" },
    { id: 55715, cityId: 215, code: "786153" },
    { id: 55716, cityId: 215, code: "786146" },
    { id: 55717, cityId: 215, code: "786150" },
    { id: 55718, cityId: 215, code: "786182" },
    { id: 55719, cityId: 215, code: "786173" },
    { id: 55720, cityId: 215, code: "786154" },
    { id: 55721, cityId: 217, code: "855102" },
    { id: 55722, cityId: 217, code: "853204" },
    { id: 55723, cityId: 217, code: "854335" },
    { id: 55724, cityId: 217, code: "854114" },
    { id: 55725, cityId: 226, code: "854325" },
    { id: 55726, cityId: 226, code: "854331" },
    { id: 55727, cityId: 226, code: "854329" },
    { id: 55728, cityId: 226, code: "854336" },
    { id: 55729, cityId: 226, code: "854334" },
    { id: 55730, cityId: 226, code: "854316" },
    { id: 55731, cityId: 226, code: "854335" },
    { id: 55732, cityId: 226, code: "854328" },
    { id: 55733, cityId: 226, code: "854332" },
    { id: 55734, cityId: 226, code: "854333" },
    { id: 55735, cityId: 226, code: "854318" },
    { id: 55736, cityId: 226, code: "854102" },
    { id: 55737, cityId: 230, code: "431101" },
    { id: 55738, cityId: 230, code: "431009" },
    { id: 55739, cityId: 230, code: "431010" },
    { id: 55740, cityId: 230, code: "431118" },
    { id: 55741, cityId: 230, code: "431007" },
    { id: 55742, cityId: 230, code: "431106" },
    { id: 55743, cityId: 230, code: "431103" },
    { id: 55744, cityId: 230, code: "431109" },
    { id: 55745, cityId: 230, code: "431150" },
    { id: 55746, cityId: 230, code: "431134" },
    { id: 55747, cityId: 230, code: "423703" },
    { id: 55748, cityId: 230, code: "431132" },
    { id: 55749, cityId: 230, code: "431202" },
    { id: 55750, cityId: 230, code: "431154" },
    { id: 55751, cityId: 230, code: "431135" },
    { id: 55752, cityId: 230, code: "431008" },
    { id: 55753, cityId: 230, code: "431113" },
    { id: 55754, cityId: 230, code: "431151" },
    { id: 55755, cityId: 230, code: "423701" },
    { id: 55756, cityId: 230, code: "431112" },
    { id: 55757, cityId: 230, code: "431120" },
    { id: 55758, cityId: 230, code: "431107" },
    { id: 55759, cityId: 230, code: "431136" },
    { id: 55760, cityId: 230, code: "431006" },
    { id: 55761, cityId: 230, code: "431117" },
    { id: 55762, cityId: 230, code: "431114" },
    { id: 55763, cityId: 236, code: "813101" },
    { id: 55764, cityId: 236, code: "813110" },
    { id: 55765, cityId: 236, code: "813108" },
    { id: 55766, cityId: 236, code: "813103" },
    { id: 55767, cityId: 236, code: "813211" },
    { id: 55768, cityId: 236, code: "813109" },
    { id: 55769, cityId: 236, code: "811308" },
    { id: 55770, cityId: 236, code: "814131" },
    { id: 55771, cityId: 236, code: "813205" },
    { id: 55772, cityId: 236, code: "813207" },
    { id: 55773, cityId: 236, code: "813105" },
    { id: 55774, cityId: 236, code: "813104" },
    { id: 55775, cityId: 236, code: "813212" },
    { id: 55776, cityId: 236, code: "813106" },
    { id: 55777, cityId: 236, code: "813201" },
    { id: 55778, cityId: 236, code: "813202" },
    { id: 55779, cityId: 236, code: "813107" },
    { id: 55780, cityId: 236, code: "813221" },
    { id: 55781, cityId: 239, code: "851128" },
    { id: 55782, cityId: 239, code: "851217" },
    { id: 55783, cityId: 239, code: "811106" },
    { id: 55784, cityId: 239, code: "851211" },
    { id: 55785, cityId: 239, code: "851218" },
    { id: 55786, cityId: 239, code: "851215" },
    { id: 55787, cityId: 245, code: "813221" },
    { id: 55788, cityId: 245, code: "811211" },
    { id: 55789, cityId: 245, code: "813206" },
    { id: 55790, cityId: 251, code: "802113" },
    { id: 55791, cityId: 251, code: "802118" },
    { id: 55792, cityId: 251, code: "802112" },
    { id: 55793, cityId: 251, code: "802125" },
    { id: 55794, cityId: 251, code: "802131" },
    { id: 55795, cityId: 251, code: "802111" },
    { id: 55796, cityId: 251, code: "802130" },
    { id: 55797, cityId: 251, code: "802136" },
    { id: 55798, cityId: 251, code: "802117" },
    { id: 55799, cityId: 251, code: "802123" },
    { id: 55800, cityId: 251, code: "802114" },
    { id: 55801, cityId: 251, code: "802127" },
    { id: 55802, cityId: 251, code: "802133" },
    { id: 55803, cityId: 251, code: "802119" },
    { id: 55804, cityId: 251, code: "802120" },
    { id: 55805, cityId: 251, code: "802126" },
    { id: 55806, cityId: 251, code: "802128" },
    { id: 55807, cityId: 251, code: "802129" },
    { id: 55808, cityId: 251, code: "802135" },
    { id: 55809, cityId: 251, code: "802134" },
    { id: 55810, cityId: 251, code: "802115" },
    { id: 55811, cityId: 251, code: "802313" },
    { id: 55812, cityId: 255, code: "847233" },
    { id: 55813, cityId: 255, code: "847239" },
    { id: 55814, cityId: 255, code: "847302" },
    { id: 55815, cityId: 255, code: "847423" },
    { id: 55816, cityId: 255, code: "847201" },
    { id: 55817, cityId: 255, code: "847107" },
    { id: 55818, cityId: 255, code: "847424" },
    { id: 55819, cityId: 255, code: "852216" },
    { id: 55820, cityId: 255, code: "848209" },
    { id: 55821, cityId: 255, code: "848205" },
    { id: 55822, cityId: 255, code: "847102" },
    { id: 55823, cityId: 255, code: "847407" },
    { id: 55824, cityId: 255, code: "847122" },
    { id: 55825, cityId: 255, code: "848506" },
    { id: 55826, cityId: 255, code: "848207" },
    { id: 55827, cityId: 262, code: "804401" },
    { id: 55828, cityId: 262, code: "824231" },
    { id: 55829, cityId: 262, code: "805131" },
    { id: 55830, cityId: 262, code: "804421" },
    { id: 55831, cityId: 262, code: "824219" },
    { id: 55832, cityId: 262, code: "804402" },
    { id: 55833, cityId: 262, code: "824236" },
    { id: 55834, cityId: 262, code: "805129" },
    { id: 55835, cityId: 262, code: "824211" },
    { id: 55836, cityId: 262, code: "804426" },
    { id: 55837, cityId: 262, code: "804419" },
    { id: 55838, cityId: 262, code: "824116" },
    { id: 55839, cityId: 262, code: "804428" },
    { id: 55840, cityId: 262, code: "804435" },
    { id: 55841, cityId: 262, code: "824113" },
    { id: 55842, cityId: 262, code: "805128" },
    { id: 55843, cityId: 262, code: "804430" },
    { id: 55844, cityId: 262, code: "805109" },
    { id: 55845, cityId: 262, code: "804423" },
    { id: 55846, cityId: 266, code: "841438" },
    { id: 55847, cityId: 275, code: "811311" },
    { id: 55848, cityId: 275, code: "811301" },
    { id: 55849, cityId: 275, code: "811313" },
    { id: 55850, cityId: 275, code: "811316" },
    { id: 55851, cityId: 275, code: "811303" },
    { id: 55852, cityId: 283, code: "853203" },
    { id: 55853, cityId: 283, code: "811202" },
    { id: 55854, cityId: 283, code: "851215" },
    { id: 55855, cityId: 286, code: "855115" },
    { id: 55856, cityId: 286, code: "855101" },
    { id: 55857, cityId: 286, code: "855117" },
    { id: 55858, cityId: 289, code: "811304" },
    { id: 55859, cityId: 289, code: "811107" },
    { id: 55860, cityId: 289, code: "811310" },
    { id: 55861, cityId: 289, code: "811201" },
    { id: 55862, cityId: 289, code: "811315" },
    { id: 55863, cityId: 289, code: "811309" },
    { id: 55864, cityId: 289, code: "811302" },
    { id: 55865, cityId: 291, code: "852122" },
    { id: 55866, cityId: 291, code: "852116" },
    { id: 55867, cityId: 291, code: "852108" },
    { id: 55868, cityId: 291, code: "852127" },
    { id: 55869, cityId: 291, code: "852121" },
    { id: 55870, cityId: 291, code: "853204" },
    { id: 55871, cityId: 291, code: "813204" },
    { id: 55872, cityId: 291, code: "852124" },
    { id: 55873, cityId: 291, code: "852202" },
    { id: 55874, cityId: 292, code: "847303" },
    { id: 55875, cityId: 292, code: "847404" },
    { id: 55876, cityId: 292, code: "847411" },
    { id: 55877, cityId: 292, code: "847240" },
    { id: 55878, cityId: 292, code: "847109" },
    { id: 55879, cityId: 292, code: "847108" },
    { id: 55880, cityId: 292, code: "847402" },
    { id: 55881, cityId: 292, code: "847452" },
    { id: 55882, cityId: 292, code: "847122" },
    { id: 55883, cityId: 293, code: "273161" },
    { id: 55884, cityId: 293, code: "273405" },
    { id: 55885, cityId: 293, code: "273306" },
    { id: 55886, cityId: 293, code: "273157" },
    { id: 55887, cityId: 293, code: "273163" },
    { id: 55888, cityId: 293, code: "273151" },
    { id: 55889, cityId: 293, code: "273303" },
    { id: 55890, cityId: 293, code: "273164" },
    { id: 55891, cityId: 293, code: "273155" },
    { id: 55892, cityId: 293, code: "273304" },
    { id: 55893, cityId: 293, code: "273301" },
    { id: 55894, cityId: 293, code: "273305" },
    { id: 55895, cityId: 293, code: "273302" },
    { id: 55896, cityId: 293, code: "273308" },
    { id: 55897, cityId: 303, code: "813212" },
    { id: 55898, cityId: 303, code: "853204" },
    { id: 55899, cityId: 303, code: "813211" },
    { id: 55900, cityId: 303, code: "813110" },
    { id: 55901, cityId: 303, code: "813103" },
    { id: 55902, cityId: 303, code: "813207" },
    { id: 55903, cityId: 303, code: "813201" },
    { id: 55904, cityId: 305, code: "844118" },
    { id: 55905, cityId: 305, code: "844111" },
    { id: 55906, cityId: 305, code: "847307" },
    { id: 55907, cityId: 305, code: "843111" },
    { id: 55908, cityId: 305, code: "843120" },
    { id: 55909, cityId: 308, code: "803109" },
    { id: 55910, cityId: 308, code: "805130" },
    { id: 55911, cityId: 308, code: "805141" },
    { id: 55912, cityId: 310, code: "804426" },
    { id: 55913, cityId: 310, code: "804452" },
    { id: 55914, cityId: 310, code: "803202" },
    { id: 55915, cityId: 310, code: "801108" },
    { id: 55916, cityId: 310, code: "803212" },
    { id: 55917, cityId: 310, code: "803110" },
    { id: 55918, cityId: 310, code: "801304" },
    { id: 55919, cityId: 310, code: "811302" },
    { id: 55920, cityId: 310, code: "804406" },
    { id: 55921, cityId: 310, code: "811104" },
    { id: 55922, cityId: 311, code: "853204" },
    { id: 55923, cityId: 311, code: "854113" },
    { id: 55924, cityId: 311, code: "854317" },
    { id: 55925, cityId: 311, code: "854102" },
    { id: 55926, cityId: 316, code: "852217" },
    { id: 55927, cityId: 316, code: "852116" },
    { id: 55928, cityId: 316, code: "852129" },
    { id: 55929, cityId: 316, code: "852107" },
    { id: 55930, cityId: 316, code: "852202" },
    { id: 55931, cityId: 316, code: "852121" },
    { id: 55932, cityId: 317, code: "848129" },
    { id: 55933, cityId: 317, code: "844501" },
    { id: 55934, cityId: 317, code: "848134" },
    { id: 55935, cityId: 317, code: "848213" },
    { id: 55936, cityId: 317, code: "844506" },
    { id: 55937, cityId: 317, code: "847301" },
    { id: 55938, cityId: 317, code: "848501" },
    { id: 55939, cityId: 317, code: "847105" },
    { id: 55940, cityId: 318, code: "841207" },
    { id: 55941, cityId: 318, code: "841202" },
    { id: 55942, cityId: 320, code: "811315" },
    { id: 55943, cityId: 320, code: "811201" },
    { id: 55944, cityId: 320, code: "811304" },
    { id: 55945, cityId: 320, code: "811107" },
    { id: 55946, cityId: 320, code: "811102" },
    { id: 55947, cityId: 320, code: "811103" },
    { id: 55948, cityId: 321, code: "843325" },
    { id: 55949, cityId: 321, code: "843316" },
    { id: 55950, cityId: 321, code: "843334" },
    { id: 55951, cityId: 321, code: "843313" },
    { id: 55952, cityId: 321, code: "843317" },
    { id: 55953, cityId: 324, code: "843360" },
    { id: 55954, cityId: 324, code: "847307" },
    { id: 55955, cityId: 324, code: "847302" },
    { id: 55956, cityId: 325, code: "841223" },
    { id: 55957, cityId: 325, code: "841233" },
    { id: 55958, cityId: 325, code: "841242" },
    { id: 55959, cityId: 325, code: "841203" },
    { id: 55960, cityId: 325, code: "841235" },
    { id: 55961, cityId: 325, code: "841241" },
    { id: 55962, cityId: 325, code: "841210" },
    { id: 55963, cityId: 325, code: "841234" },
    { id: 55964, cityId: 325, code: "841240" },
    { id: 55965, cityId: 325, code: "841417" },
    { id: 55966, cityId: 325, code: "841231" },
    { id: 55967, cityId: 325, code: "841408" },
    { id: 55968, cityId: 325, code: "841237" },
    { id: 55969, cityId: 325, code: "841243" },
    { id: 55970, cityId: 325, code: "841245" },
    { id: 55971, cityId: 325, code: "841416" },
    { id: 55972, cityId: 325, code: "841239" },
    { id: 55973, cityId: 325, code: "841236" },
    { id: 55974, cityId: 325, code: "841232" },
    { id: 55975, cityId: 325, code: "841244" },
    { id: 55976, cityId: 325, code: "841238" },
    { id: 55977, cityId: 325, code: "841422" },
    { id: 55978, cityId: 329, code: "854340" },
    { id: 55979, cityId: 329, code: "847408" },
    { id: 55980, cityId: 329, code: "852108" },
    { id: 55981, cityId: 329, code: "852215" },
    { id: 55982, cityId: 329, code: "852139" },
    { id: 55983, cityId: 329, code: "852125" },
    { id: 55984, cityId: 329, code: "847451" },
    { id: 55985, cityId: 329, code: "852137" },
    { id: 55986, cityId: 329, code: "852214" },
    { id: 55987, cityId: 329, code: "852138" },
    { id: 55988, cityId: 329, code: "854339" },
    { id: 55989, cityId: 329, code: "852109" },
    { id: 55990, cityId: 329, code: "854338" },
    { id: 55991, cityId: 329, code: "852130" },
    { id: 55992, cityId: 329, code: "852105" },
    { id: 55993, cityId: 329, code: "852218" },
    { id: 55994, cityId: 329, code: "852110" },
    { id: 55995, cityId: 329, code: "852123" },
    { id: 55996, cityId: 329, code: "852111" },
    { id: 55997, cityId: 332, code: "140119" },
    { id: 55998, cityId: 332, code: "140133" },
    { id: 55999, cityId: 332, code: "140125" },
    { id: 56000, cityId: 345, code: "494448" },
    { id: 56001, cityId: 345, code: "494553" },
    { id: 56002, cityId: 345, code: "494556" },
    { id: 56003, cityId: 345, code: "494115" },
    { id: 56004, cityId: 345, code: "494122" },
    { id: 56005, cityId: 345, code: "494551" },
    { id: 56006, cityId: 345, code: "494450" },
    { id: 56007, cityId: 345, code: "494552" },
    { id: 56008, cityId: 345, code: "494111" },
    { id: 56009, cityId: 345, code: "494441" },
    { id: 56010, cityId: 346, code: "493663" },
    { id: 56011, cityId: 348, code: "491888" },
    { id: 56012, cityId: 348, code: "491111" },
    { id: 56013, cityId: 348, code: "490020" },
    { id: 56014, cityId: 353, code: "496331" },
    { id: 56015, cityId: 353, code: "497118" },
    { id: 56016, cityId: 353, code: "496338" },
    { id: 56017, cityId: 353, code: "496227" },
    { id: 56018, cityId: 353, code: "496334" },
    { id: 56019, cityId: 353, code: "496242" },
    { id: 56020, cityId: 353, code: "496225" },
    { id: 56021, cityId: 353, code: "496330" },
    { id: 56022, cityId: 354, code: "494777" },
    { id: 56023, cityId: 354, code: "494333" },
    { id: 56024, cityId: 354, code: "494771" },
    { id: 56025, cityId: 354, code: "494635" },
    { id: 56026, cityId: 354, code: "494670" },
    { id: 56027, cityId: 354, code: "494334" },
    { id: 56028, cityId: 354, code: "494669" },
    { id: 56029, cityId: 354, code: "494335" },
    { id: 56030, cityId: 354, code: "494776" },
    { id: 56031, cityId: 354, code: "494665" },
    { id: 56032, cityId: 356, code: "491336" },
    { id: 56033, cityId: 362, code: "495691" },
    { id: 56034, cityId: 362, code: "495677" },
    { id: 56035, cityId: 362, code: "495674" },
    { id: 56036, cityId: 362, code: "495452" },
    { id: 56037, cityId: 362, code: "495690" },
    { id: 56038, cityId: 362, code: "495687" },
    { id: 56039, cityId: 362, code: "495684" },
    { id: 56040, cityId: 362, code: "495446" },
    { id: 56041, cityId: 362, code: "495683" },
    { id: 56042, cityId: 362, code: "495118" },
    { id: 56043, cityId: 362, code: "495445" },
    { id: 56044, cityId: 362, code: "495661" },
    { id: 56045, cityId: 362, code: "495447" },
    { id: 56046, cityId: 362, code: "495682" },
    { id: 56047, cityId: 362, code: "495660" },
    { id: 56048, cityId: 364, code: "493551" },
    { id: 56049, cityId: 364, code: "493558" },
    { id: 56050, cityId: 364, code: "492112" },
    { id: 56051, cityId: 364, code: "493555" },
    { id: 56052, cityId: 364, code: "493449" },
    { id: 56053, cityId: 367, code: "384229" },
    { id: 56054, cityId: 367, code: "385340" },
    { id: 56055, cityId: 367, code: "385350" },
    { id: 56056, cityId: 367, code: "384241" },
    { id: 56057, cityId: 367, code: "384285" },
    { id: 56058, cityId: 367, code: "384225" },
    { id: 56059, cityId: 367, code: "384272" },
    { id: 56060, cityId: 367, code: "385360" },
    { id: 56061, cityId: 367, code: "384240" },
    { id: 56062, cityId: 367, code: "384151" },
    { id: 56063, cityId: 367, code: "384221" },
    { id: 56064, cityId: 367, code: "384245" },
    { id: 56065, cityId: 367, code: "384246" },
    { id: 56066, cityId: 367, code: "384230" },
    { id: 56067, cityId: 367, code: "384275" },
    { id: 56068, cityId: 367, code: "384220" },
    { id: 56069, cityId: 367, code: "384290" },
    { id: 56070, cityId: 369, code: "496661" },
    { id: 56071, cityId: 369, code: "496445" },
    { id: 56072, cityId: 369, code: "496242" },
    { id: 56073, cityId: 369, code: "496005" },
    { id: 56074, cityId: 369, code: "496111" },
    { id: 56075, cityId: 370, code: "493195" },
    { id: 56076, cityId: 370, code: "493331" },
    { id: 56077, cityId: 370, code: "493118" },
    { id: 56078, cityId: 370, code: "493229" },
    { id: 56079, cityId: 370, code: "493663" },
    { id: 56080, cityId: 370, code: "493222" },
    { id: 56081, cityId: 370, code: "493441" },
    { id: 56082, cityId: 370, code: "493101" },
    { id: 56083, cityId: 370, code: "492099" },
    { id: 56084, cityId: 370, code: "493221" },
    { id: 56085, cityId: 370, code: "493113" },
    { id: 56086, cityId: 370, code: "492013" },
    { id: 56087, cityId: 371, code: "491881" },
    { id: 56088, cityId: 371, code: "491661" },
    { id: 56089, cityId: 381, code: "362540" },
    { id: 56090, cityId: 381, code: "362570" },
    { id: 56091, cityId: 405, code: "382481" },
    { id: 56092, cityId: 405, code: "382421" },
    { id: 56093, cityId: 405, code: "382470" },
    { id: 56094, cityId: 405, code: "382435" },
    { id: 56095, cityId: 405, code: "382460" },
    { id: 56096, cityId: 405, code: "383345" },
    { id: 56097, cityId: 407, code: "364522" },
    { id: 56098, cityId: 407, code: "362730" },
    { id: 56099, cityId: 407, code: "364515" },
    { id: 56100, cityId: 407, code: "364525" },
    { id: 56101, cityId: 407, code: "365480" },
    { id: 56102, cityId: 407, code: "364521" },
    { id: 56103, cityId: 407, code: "364530" },
    { id: 56104, cityId: 407, code: "365440" },
    { id: 56105, cityId: 408, code: "388307" },
    { id: 56106, cityId: 408, code: "388440" },
    { id: 56107, cityId: 408, code: "388510" },
    { id: 56108, cityId: 408, code: "388430" },
    { id: 56109, cityId: 408, code: "388630" },
    { id: 56110, cityId: 408, code: "388335" },
    { id: 56111, cityId: 408, code: "387710" },
    { id: 56112, cityId: 408, code: "388465" },
    { id: 56113, cityId: 408, code: "388170" },
    { id: 56114, cityId: 408, code: "388450" },
    { id: 56115, cityId: 408, code: "388545" },
    { id: 56116, cityId: 408, code: "388130" },
    { id: 56117, cityId: 408, code: "388460" },
    { id: 56118, cityId: 408, code: "388315" },
    { id: 56119, cityId: 408, code: "388210" },
    { id: 56120, cityId: 408, code: "388540" },
    { id: 56121, cityId: 408, code: "388610" },
    { id: 56122, cityId: 408, code: "388121" },
    { id: 56123, cityId: 408, code: "388140" },
    { id: 56124, cityId: 408, code: "388235" },
    { id: 56125, cityId: 408, code: "387220" },
    { id: 56126, cityId: 408, code: "388480" },
    { id: 56127, cityId: 408, code: "388350" },
    { id: 56128, cityId: 408, code: "388550" },
    { id: 56129, cityId: 408, code: "388220" },
    { id: 56130, cityId: 408, code: "387240" },
    { id: 56131, cityId: 408, code: "388325" },
    { id: 56132, cityId: 408, code: "387310" },
    { id: 56133, cityId: 408, code: "388620" },
    { id: 56134, cityId: 408, code: "388560" },
    { id: 56135, cityId: 408, code: "387345" },
    { id: 56136, cityId: 408, code: "387210" },
    { id: 56137, cityId: 416, code: "392170" },
    { id: 56138, cityId: 416, code: "393150" },
    { id: 56139, cityId: 416, code: "392220" },
    { id: 56140, cityId: 416, code: "394120" },
    { id: 56141, cityId: 416, code: "393050" },
    { id: 56142, cityId: 416, code: "393040" },
    { id: 56143, cityId: 416, code: "393025" },
    { id: 56144, cityId: 416, code: "392165" },
    { id: 56145, cityId: 416, code: "393041" },
    { id: 56146, cityId: 417, code: "364060" },
    { id: 56147, cityId: 417, code: "364320" },
    { id: 56148, cityId: 417, code: "364140" },
    { id: 56149, cityId: 417, code: "364250" },
    { id: 56150, cityId: 458, code: "360480" },
    { id: 56151, cityId: 458, code: "361310" },
    { id: 56152, cityId: 458, code: "361210" },
    { id: 56153, cityId: 458, code: "361140" },
    { id: 56154, cityId: 458, code: "360590" },
    { id: 56155, cityId: 458, code: "360540" },
    { id: 56156, cityId: 458, code: "361345" },
    { id: 56157, cityId: 458, code: "360490" },
    { id: 56158, cityId: 458, code: "360110" },
    { id: 56159, cityId: 460, code: "362650" },
    { id: 56160, cityId: 460, code: "362130" },
    { id: 56161, cityId: 460, code: "362250" },
    { id: 56162, cityId: 460, code: "360490" },
    { id: 56163, cityId: 460, code: "365440" },
    { id: 56164, cityId: 471, code: "388245" },
    { id: 56165, cityId: 471, code: "387110" },
    { id: 56166, cityId: 471, code: "387560" },
    { id: 56167, cityId: 471, code: "387620" },
    { id: 56168, cityId: 471, code: "388410" },
    { id: 56169, cityId: 471, code: "387230" },
    { id: 56170, cityId: 471, code: "387360" },
    { id: 56171, cityId: 471, code: "387325" },
    { id: 56172, cityId: 471, code: "387350" },
    { id: 56173, cityId: 471, code: "388235" },
    { id: 56174, cityId: 471, code: "387610" },
    { id: 56175, cityId: 471, code: "387550" },
    { id: 56176, cityId: 471, code: "388140" },
    { id: 56177, cityId: 471, code: "387315" },
    { id: 56178, cityId: 471, code: "387002" },
    { id: 56179, cityId: 471, code: "387430" },
    { id: 56180, cityId: 471, code: "388239" },
    { id: 56181, cityId: 471, code: "387001" },
    { id: 56182, cityId: 471, code: "387335" },
    { id: 56183, cityId: 471, code: "388220" },
    { id: 56184, cityId: 471, code: "387630" },
    { id: 56185, cityId: 471, code: "388255" },
    { id: 56186, cityId: 471, code: "388230" },
    { id: 56187, cityId: 471, code: "387345" },
    { id: 56188, cityId: 471, code: "387640" },
    { id: 56189, cityId: 471, code: "387370" },
    { id: 56190, cityId: 471, code: "388265" },
    { id: 56191, cityId: 471, code: "387510" },
    { id: 56192, cityId: 471, code: "387570" },
    { id: 56193, cityId: 471, code: "387650" },
    { id: 56194, cityId: 471, code: "387710" },
    { id: 56195, cityId: 471, code: "387355" },
    { id: 56196, cityId: 471, code: "388440" },
    { id: 56197, cityId: 471, code: "387115" },
    { id: 56198, cityId: 471, code: "388180" },
    { id: 56199, cityId: 471, code: "388421" },
    { id: 56200, cityId: 471, code: "387520" },
    { id: 56201, cityId: 471, code: "388215" },
    { id: 56202, cityId: 471, code: "387320" },
    { id: 56203, cityId: 471, code: "387380" },
    { id: 56204, cityId: 471, code: "387120" },
    { id: 56205, cityId: 471, code: "387530" },
    { id: 56206, cityId: 471, code: "387330" },
    { id: 56207, cityId: 471, code: "388250" },
    { id: 56208, cityId: 471, code: "387365" },
    { id: 56209, cityId: 471, code: "387305" },
    { id: 56210, cityId: 471, code: "388225" },
    { id: 56211, cityId: 471, code: "387540" },
    { id: 56212, cityId: 471, code: "387130" },
    { id: 56213, cityId: 471, code: "387375" },
    { id: 56214, cityId: 471, code: "388260" },
    { id: 56215, cityId: 471, code: "387635" },
    { id: 56216, cityId: 471, code: "387210" },
    { id: 56217, cityId: 471, code: "387340" },
    { id: 56218, cityId: 478, code: "382115" },
    { id: 56219, cityId: 478, code: "382165" },
    { id: 56220, cityId: 478, code: "384325" },
    { id: 56221, cityId: 478, code: "382120" },
    { id: 56222, cityId: 478, code: "382170" },
    { id: 56223, cityId: 478, code: "384260" },
    { id: 56224, cityId: 491, code: "396412" },
    { id: 56225, cityId: 491, code: "396406" },
    { id: 56226, cityId: 491, code: "396409" },
    { id: 56227, cityId: 491, code: "396380" },
    { id: 56228, cityId: 491, code: "396450" },
    { id: 56229, cityId: 491, code: "396580" },
    { id: 56230, cityId: 491, code: "396418" },
    { id: 56231, cityId: 491, code: "396472" },
    { id: 56232, cityId: 491, code: "396403" },
    { id: 56233, cityId: 491, code: "396460" },
    { id: 56234, cityId: 491, code: "396051" },
    { id: 56235, cityId: 491, code: "396321" },
    { id: 56236, cityId: 491, code: "396521" },
    { id: 56237, cityId: 491, code: "396360" },
    { id: 56238, cityId: 491, code: "394730" },
    { id: 56239, cityId: 491, code: "396436" },
    { id: 56240, cityId: 491, code: "396325" },
    { id: 56241, cityId: 491, code: "396427" },
    { id: 56242, cityId: 491, code: "396430" },
    { id: 56243, cityId: 491, code: "396560" },
    { id: 56244, cityId: 491, code: "396570" },
    { id: 56245, cityId: 491, code: "396370" },
    { id: 56246, cityId: 491, code: "396421" },
    { id: 56247, cityId: 498, code: "384275" },
    { id: 56248, cityId: 498, code: "384272" },
    { id: 56249, cityId: 498, code: "384230" },
    { id: 56250, cityId: 498, code: "385350" },
    { id: 56251, cityId: 498, code: "384285" },
    { id: 56252, cityId: 498, code: "384225" },
    { id: 56253, cityId: 498, code: "384246" },
    { id: 56254, cityId: 498, code: "385340" },
    { id: 56255, cityId: 498, code: "384240" },
    { id: 56256, cityId: 498, code: "384151" },
    { id: 56257, cityId: 498, code: "384221" },
    { id: 56258, cityId: 498, code: "385360" },
    { id: 56259, cityId: 498, code: "384229" },
    { id: 56260, cityId: 498, code: "384245" },
    { id: 56261, cityId: 498, code: "384220" },
    { id: 56262, cityId: 498, code: "384290" },
    { id: 56263, cityId: 498, code: "384241" },
    { id: 56264, cityId: 500, code: "360577" },
    { id: 56265, cityId: 500, code: "360590" },
    { id: 56266, cityId: 500, code: "360578" },
    { id: 56267, cityId: 500, code: "362620" },
    { id: 56268, cityId: 500, code: "362230" },
    { id: 56269, cityId: 500, code: "360530" },
    { id: 56270, cityId: 500, code: "360579" },
    { id: 56271, cityId: 500, code: "360490" },
    { id: 56272, cityId: 500, code: "360545" },
    { id: 56273, cityId: 500, code: "362650" },
    { id: 56274, cityId: 500, code: "360576" },
    { id: 56275, cityId: 500, code: "360510" },
    { id: 56276, cityId: 500, code: "360570" },
    { id: 56277, cityId: 503, code: "360405" },
    { id: 56278, cityId: 503, code: "365480" },
    { id: 56279, cityId: 503, code: "364470" },
    { id: 56280, cityId: 503, code: "364490" },
    { id: 56281, cityId: 503, code: "360110" },
    { id: 56282, cityId: 503, code: "360055" },
    { id: 56283, cityId: 503, code: "363660" },
    { id: 56284, cityId: 519, code: "393125" },
    { id: 56285, cityId: 519, code: "394716" },
    { id: 56286, cityId: 519, code: "394601" },
    { id: 56287, cityId: 519, code: "394633" },
    { id: 56288, cityId: 519, code: "394230" },
    { id: 56289, cityId: 519, code: "394430" },
    { id: 56290, cityId: 519, code: "394715" },
    { id: 56291, cityId: 519, code: "394651" },
    { id: 56292, cityId: 519, code: "392150" },
    { id: 56293, cityId: 519, code: "394352" },
    { id: 56294, cityId: 519, code: "393130" },
    { id: 56295, cityId: 519, code: "396510" },
    { id: 56296, cityId: 519, code: "394130" },
    { id: 56297, cityId: 519, code: "394635" },
    { id: 56298, cityId: 519, code: "394305" },
    { id: 56299, cityId: 519, code: "394327" },
    { id: 56300, cityId: 519, code: "393050" },
    { id: 56301, cityId: 525, code: "394715" },
    { id: 56302, cityId: 531, code: "393130" },
    { id: 56303, cityId: 531, code: "393041" },
    { id: 56304, cityId: 531, code: "393105" },
    { id: 56305, cityId: 531, code: "392160" },
    { id: 56306, cityId: 531, code: "392030" },
    { id: 56307, cityId: 531, code: "391135" },
    { id: 56308, cityId: 531, code: "392150" },
    { id: 56309, cityId: 531, code: "393010" },
    { id: 56310, cityId: 531, code: "391170" },
    { id: 56311, cityId: 531, code: "392220" },
    { id: 56312, cityId: 531, code: "390021" },
    { id: 56313, cityId: 531, code: "392210" },
    { id: 56314, cityId: 531, code: "392140" },
    { id: 56315, cityId: 531, code: "391121" },
    { id: 56316, cityId: 531, code: "391350" },
    { id: 56317, cityId: 531, code: "392130" },
    { id: 56318, cityId: 531, code: "391130" },
    { id: 56319, cityId: 531, code: "392012" },
    { id: 56320, cityId: 531, code: "391780" },
    { id: 56321, cityId: 531, code: "388710" },
    { id: 56322, cityId: 531, code: "392015" },
    { id: 56323, cityId: 531, code: "392110" },
    { id: 56324, cityId: 531, code: "391440" },
    { id: 56325, cityId: 531, code: "392180" },
    { id: 56326, cityId: 531, code: "393002" },
    { id: 56327, cityId: 531, code: "391140" },
    { id: 56328, cityId: 532, code: "396191" },
    { id: 56329, cityId: 532, code: "396375" },
    { id: 56330, cityId: 532, code: "396193" },
    { id: 56331, cityId: 532, code: "396050" },
    { id: 56332, cityId: 544, code: "134203" },
    { id: 56333, cityId: 544, code: "134118" },
    { id: 56334, cityId: 544, code: "134204" },
    { id: 56335, cityId: 557, code: "121103" },
    { id: 56336, cityId: 557, code: "121107" },
    { id: 56337, cityId: 558, code: "125133" },
    { id: 56338, cityId: 558, code: "125053" },
    { id: 56339, cityId: 558, code: "125106" },
    { id: 56340, cityId: 558, code: "125113" },
    { id: 56341, cityId: 558, code: "125052" },
    { id: 56342, cityId: 558, code: "125048" },
    { id: 56343, cityId: 558, code: "125120" },
    { id: 56344, cityId: 558, code: "125051" },
    { id: 56345, cityId: 564, code: "122107" },
    { id: 56346, cityId: 564, code: "123401" },
    { id: 56347, cityId: 564, code: "122103" },
    { id: 56348, cityId: 564, code: "123106" },
    { id: 56349, cityId: 564, code: "122104" },
    { id: 56350, cityId: 571, code: "124505" },
    { id: 56351, cityId: 571, code: "124109" },
    { id: 56352, cityId: 571, code: "124506" },
    { id: 56353, cityId: 571, code: "124501" },
    { id: 56354, cityId: 571, code: "124105" },
    { id: 56355, cityId: 571, code: "124404" },
    { id: 56356, cityId: 571, code: "124102" },
    { id: 56357, cityId: 571, code: "124508" },
    { id: 56358, cityId: 571, code: "124504" },
    { id: 56359, cityId: 571, code: "124108" },
    { id: 56360, cityId: 571, code: "124107" },
    { id: 56361, cityId: 571, code: "124202" },
    { id: 56362, cityId: 572, code: "126101" },
    { id: 56363, cityId: 572, code: "126115" },
    { id: 56364, cityId: 578, code: "132117" },
    { id: 56365, cityId: 578, code: "132039" },
    { id: 56366, cityId: 591, code: "134102" },
    { id: 56367, cityId: 591, code: "134113" },
    { id: 56368, cityId: 591, code: "134202" },
    { id: 56369, cityId: 591, code: "134205" },
    { id: 56370, cityId: 591, code: "134118" },
    { id: 56371, cityId: 591, code: "133301" },
    { id: 56372, cityId: 591, code: "134203" },
    { id: 56373, cityId: 591, code: "134109" },
    { id: 56374, cityId: 591, code: "134101" },
    { id: 56375, cityId: 591, code: "134204" },
    { id: 56376, cityId: 591, code: "134104" },
    { id: 56377, cityId: 591, code: "134112" },
    { id: 56378, cityId: 591, code: "134107" },
    { id: 56379, cityId: 591, code: "134108" },
    { id: 56380, cityId: 592, code: "132115" },
    { id: 56381, cityId: 592, code: "132145" },
    { id: 56382, cityId: 592, code: "132108" },
    { id: 56383, cityId: 592, code: "132105" },
    { id: 56384, cityId: 592, code: "132140" },
    { id: 56385, cityId: 592, code: "132113" },
    { id: 56386, cityId: 592, code: "132106" },
    { id: 56387, cityId: 592, code: "132104" },
    { id: 56388, cityId: 592, code: "132101" },
    { id: 56389, cityId: 600, code: "123101" },
    { id: 56390, cityId: 600, code: "123301" },
    { id: 56391, cityId: 600, code: "123412" },
    { id: 56392, cityId: 600, code: "123021" },
    { id: 56393, cityId: 600, code: "123106" },
    { id: 56394, cityId: 600, code: "123102" },
    { id: 56395, cityId: 600, code: "123034" },
    { id: 56396, cityId: 600, code: "123103" },
    { id: 56397, cityId: 600, code: "123501" },
    { id: 56398, cityId: 600, code: "123035" },
    { id: 56399, cityId: 601, code: "124113" },
    { id: 56400, cityId: 604, code: "125201" },
    { id: 56401, cityId: 604, code: "125076" },
    { id: 56402, cityId: 604, code: "125102" },
    { id: 56403, cityId: 618, code: "176301" },
    { id: 56404, cityId: 624, code: "210430" },
    { id: 56405, cityId: 624, code: "210427" },
    { id: 56406, cityId: 624, code: "210505" },
    { id: 56407, cityId: 624, code: "210341" },
    { id: 56408, cityId: 624, code: "210501" },
    { id: 56409, cityId: 627, code: "176063" },
    { id: 56410, cityId: 627, code: "176202" },
    { id: 56411, cityId: 627, code: "176025" },
    { id: 56412, cityId: 627, code: "177117" },
    { id: 56413, cityId: 627, code: "176210" },
    { id: 56414, cityId: 627, code: "176055" },
    { id: 56415, cityId: 627, code: "176213" },
    { id: 56416, cityId: 627, code: "176047" },
    { id: 56417, cityId: 627, code: "176101" },
    { id: 56418, cityId: 627, code: "176036" },
    { id: 56419, cityId: 627, code: "176093" },
    { id: 56420, cityId: 627, code: "177114" },
    { id: 56421, cityId: 627, code: "176058" },
    { id: 56422, cityId: 627, code: "176028" },
    { id: 56423, cityId: 627, code: "176205" },
    { id: 56424, cityId: 627, code: "176085" },
    { id: 56425, cityId: 627, code: "176216" },
    { id: 56426, cityId: 627, code: "177103" },
    { id: 56427, cityId: 627, code: "176208" },
    { id: 56428, cityId: 627, code: "177106" },
    { id: 56429, cityId: 627, code: "176031" },
    { id: 56430, cityId: 627, code: "177112" },
    { id: 56431, cityId: 627, code: "176075" },
    { id: 56432, cityId: 627, code: "176029" },
    { id: 56433, cityId: 627, code: "176064" },
    { id: 56434, cityId: 627, code: "176102" },
    { id: 56435, cityId: 627, code: "177104" },
    { id: 56436, cityId: 627, code: "176083" },
    { id: 56437, cityId: 627, code: "176026" },
    { id: 56438, cityId: 627, code: "176211" },
    { id: 56439, cityId: 627, code: "176032" },
    { id: 56440, cityId: 627, code: "176091" },
    { id: 56441, cityId: 627, code: "177101" },
    { id: 56442, cityId: 627, code: "176219" },
    { id: 56443, cityId: 627, code: "176115" },
    { id: 56444, cityId: 627, code: "175013" },
    { id: 56445, cityId: 627, code: "176023" },
    { id: 56446, cityId: 627, code: "176053" },
    { id: 56447, cityId: 627, code: "176088" },
    { id: 56448, cityId: 627, code: "177107" },
    { id: 56449, cityId: 627, code: "176107" },
    { id: 56450, cityId: 627, code: "176203" },
    { id: 56451, cityId: 627, code: "176037" },
    { id: 56452, cityId: 627, code: "176061" },
    { id: 56453, cityId: 627, code: "176403" },
    { id: 56454, cityId: 627, code: "176096" },
    { id: 56455, cityId: 627, code: "176225" },
    { id: 56456, cityId: 627, code: "177105" },
    { id: 56457, cityId: 627, code: "176059" },
    { id: 56458, cityId: 627, code: "176094" },
    { id: 56459, cityId: 627, code: "176501" },
    { id: 56460, cityId: 627, code: "176217" },
    { id: 56461, cityId: 627, code: "176086" },
    { id: 56462, cityId: 627, code: "176401" },
    { id: 56463, cityId: 627, code: "176214" },
    { id: 56464, cityId: 627, code: "177113" },
    { id: 56465, cityId: 627, code: "176206" },
    { id: 56466, cityId: 627, code: "176021" },
    { id: 56467, cityId: 627, code: "176081" },
    { id: 56468, cityId: 627, code: "176209" },
    { id: 56469, cityId: 627, code: "177034" },
    { id: 56470, cityId: 627, code: "176051" },
    { id: 56471, cityId: 627, code: "176201" },
    { id: 56472, cityId: 627, code: "176057" },
    { id: 56473, cityId: 627, code: "176027" },
    { id: 56474, cityId: 627, code: "176128" },
    { id: 56475, cityId: 627, code: "176054" },
    { id: 56476, cityId: 627, code: "177110" },
    { id: 56477, cityId: 627, code: "176089" },
    { id: 56478, cityId: 627, code: "176062" },
    { id: 56479, cityId: 627, code: "176022" },
    { id: 56480, cityId: 627, code: "177043" },
    { id: 56481, cityId: 627, code: "176052" },
    { id: 56482, cityId: 627, code: "176218" },
    { id: 56483, cityId: 627, code: "176060" },
    { id: 56484, cityId: 627, code: "176095" },
    { id: 56485, cityId: 627, code: "176215" },
    { id: 56486, cityId: 627, code: "176402" },
    { id: 56487, cityId: 627, code: "176087" },
    { id: 56488, cityId: 627, code: "177108" },
    { id: 56489, cityId: 627, code: "176033" },
    { id: 56490, cityId: 627, code: "176125" },
    { id: 56491, cityId: 627, code: "176065" },
    { id: 56492, cityId: 627, code: "176084" },
    { id: 56493, cityId: 627, code: "176092" },
    { id: 56494, cityId: 627, code: "176103" },
    { id: 56495, cityId: 627, code: "176030" },
    { id: 56496, cityId: 627, code: "177111" },
    { id: 56497, cityId: 627, code: "176204" },
    { id: 56498, cityId: 627, code: "176076" },
    { id: 56499, cityId: 627, code: "176038" },
    { id: 56500, cityId: 627, code: "177033" },
    { id: 56501, cityId: 630, code: "172002" },
    { id: 56502, cityId: 630, code: "172201" },
    { id: 56503, cityId: 630, code: "175123" },
    { id: 56504, cityId: 630, code: "172033" },
    { id: 56505, cityId: 630, code: "172026" },
    { id: 56506, cityId: 630, code: "172032" },
    { id: 56507, cityId: 630, code: "172023" },
    { id: 56508, cityId: 630, code: "172025" },
    { id: 56509, cityId: 630, code: "172001" },
    { id: 56510, cityId: 630, code: "175106" },
    { id: 56511, cityId: 630, code: "175125" },
    { id: 56512, cityId: 631, code: "175134" },
    { id: 56513, cityId: 631, code: "175123" },
    { id: 56514, cityId: 631, code: "175106" },
    { id: 56515, cityId: 631, code: "175125" },
    { id: 56516, cityId: 631, code: "175141" },
    { id: 56517, cityId: 631, code: "175024" },
    { id: 56518, cityId: 631, code: "175013" },
    { id: 56519, cityId: 631, code: "175124" },
    { id: 56520, cityId: 631, code: "175121" },
    { id: 56521, cityId: 641, code: "465679" },
    { id: 56522, cityId: 641, code: "465685" },
    { id: 56523, cityId: 641, code: "465697" },
    { id: 56524, cityId: 641, code: "465669" },
    { id: 56525, cityId: 641, code: "465687" },
    { id: 56526, cityId: 641, code: "465693" },
    { id: 56527, cityId: 641, code: "465674" },
    { id: 56528, cityId: 641, code: "465677" },
    { id: 56529, cityId: 641, code: "465683" },
    { id: 56530, cityId: 641, code: "465680" },
    { id: 56531, cityId: 641, code: "465667" },
    { id: 56532, cityId: 641, code: "465689" },
    { id: 56533, cityId: 641, code: "465661" },
    { id: 56534, cityId: 642, code: "244922" },
    { id: 56535, cityId: 642, code: "244928" },
    { id: 56536, cityId: 642, code: "244925" },
    { id: 56537, cityId: 642, code: "244923" },
    { id: 56538, cityId: 642, code: "244926" },
    { id: 56539, cityId: 642, code: "244921" },
    { id: 56540, cityId: 642, code: "244927" },
    { id: 56541, cityId: 642, code: "244924" },
    { id: 56542, cityId: 647, code: "171008" },
    { id: 56543, cityId: 647, code: "172021" },
    { id: 56544, cityId: 647, code: "172029" },
    { id: 56545, cityId: 647, code: "172024" },
    { id: 56546, cityId: 647, code: "172031" },
    { id: 56547, cityId: 647, code: "171201" },
    { id: 56548, cityId: 647, code: "172102" },
    { id: 56549, cityId: 647, code: "172034" },
    { id: 56550, cityId: 647, code: "173217" },
    { id: 56551, cityId: 647, code: "171226" },
    { id: 56552, cityId: 647, code: "171213" },
    { id: 56553, cityId: 647, code: "172101" },
    { id: 56554, cityId: 647, code: "172030" },
    { id: 56555, cityId: 647, code: "172201" },
    { id: 56556, cityId: 647, code: "172027" },
    { id: 56557, cityId: 647, code: "172022" },
    { id: 56558, cityId: 647, code: "171207" },
    { id: 56559, cityId: 647, code: "171205" },
    { id: 56560, cityId: 648, code: "173220" },
    { id: 56561, cityId: 648, code: "174101" },
    { id: 56562, cityId: 648, code: "171102" },
    { id: 56563, cityId: 648, code: "173210" },
    { id: 56564, cityId: 650, code: "174301" },
    { id: 56565, cityId: 650, code: "177201" },
    { id: 56566, cityId: 650, code: "177041" },
    { id: 56567, cityId: 657, code: "193403" },
    { id: 56568, cityId: 657, code: "193503" },
    { id: 56569, cityId: 657, code: "192125" },
    { id: 56570, cityId: 657, code: "193401" },
    { id: 56571, cityId: 657, code: "193501" },
    { id: 56572, cityId: 657, code: "193404" },
    { id: 56573, cityId: 657, code: "193123" },
    { id: 56574, cityId: 657, code: "193121" },
    { id: 56575, cityId: 657, code: "193108" },
    { id: 56576, cityId: 663, code: "182204" },
    { id: 56577, cityId: 663, code: "182144" },
    { id: 56578, cityId: 663, code: "182146" },
    { id: 56579, cityId: 663, code: "182143" },
    { id: 56580, cityId: 663, code: "182124" },
    { id: 56581, cityId: 668, code: "181111" },
    { id: 56582, cityId: 668, code: "181131" },
    { id: 56583, cityId: 668, code: "181203" },
    { id: 56584, cityId: 668, code: "184120" },
    { id: 56585, cityId: 668, code: "181202" },
    { id: 56586, cityId: 670, code: "194302" },
    { id: 56587, cityId: 671, code: "184121" },
    { id: 56588, cityId: 671, code: "184151" },
    { id: 56589, cityId: 671, code: "184145" },
    { id: 56590, cityId: 677, code: "192233" },
    { id: 56591, cityId: 679, code: "193302" },
    { id: 56592, cityId: 679, code: "193221" },
    { id: 56593, cityId: 679, code: "193303" },
    { id: 56594, cityId: 680, code: "194105" },
    { id: 56595, cityId: 685, code: "184121" },
    { id: 56596, cityId: 686, code: "191112" },
    { id: 56597, cityId: 686, code: "192221" },
    { id: 56598, cityId: 686, code: "192121" },
    { id: 56599, cityId: 686, code: "192211" },
    { id: 56600, cityId: 686, code: "192303" },
    { id: 56601, cityId: 686, code: "192124" },
    { id: 56602, cityId: 686, code: "192122" },
    { id: 56603, cityId: 686, code: "192301" },
    { id: 56604, cityId: 686, code: "192123" },
    { id: 56605, cityId: 686, code: "192231" },
    { id: 56606, cityId: 686, code: "192304" },
    { id: 56607, cityId: 692, code: "182320" },
    { id: 56608, cityId: 692, code: "185233" },
    { id: 56609, cityId: 695, code: "192121" },
    { id: 56610, cityId: 695, code: "191201" },
    { id: 56611, cityId: 695, code: "190019" },
    { id: 56612, cityId: 695, code: "190018" },
    { id: 56613, cityId: 695, code: "190023" },
    { id: 56614, cityId: 695, code: "193401" },
    { id: 56615, cityId: 695, code: "191103" },
    { id: 56616, cityId: 699, code: "182301" },
    { id: 56617, cityId: 699, code: "182144" },
    { id: 56618, cityId: 699, code: "182141" },
    { id: 56619, cityId: 699, code: "182204" },
    { id: 56620, cityId: 699, code: "182161" },
    { id: 56621, cityId: 699, code: "182142" },
    { id: 56622, cityId: 699, code: "182311" },
    { id: 56623, cityId: 699, code: "184205" },
    { id: 56624, cityId: 699, code: "184121" },
    { id: 56625, cityId: 704, code: "829144" },
    { id: 56626, cityId: 704, code: "829112" },
    { id: 56627, cityId: 704, code: "828307" },
    { id: 56628, cityId: 704, code: "829113" },
    { id: 56629, cityId: 704, code: "814155" },
    { id: 56630, cityId: 704, code: "827013" },
    { id: 56631, cityId: 704, code: "829114" },
    { id: 56632, cityId: 704, code: "828302" },
    { id: 56633, cityId: 704, code: "829127" },
    { id: 56634, cityId: 704, code: "828125" },
    { id: 56635, cityId: 704, code: "825102" },
    { id: 56636, cityId: 704, code: "829121" },
    { id: 56637, cityId: 704, code: "827014" },
    { id: 56638, cityId: 704, code: "828404" },
    { id: 56639, cityId: 704, code: "828403" },
    { id: 56640, cityId: 704, code: "827302" },
    { id: 56641, cityId: 704, code: "829149" },
    { id: 56642, cityId: 704, code: "825322" },
    { id: 56643, cityId: 704, code: "827004" },
    { id: 56644, cityId: 704, code: "827009" },
    { id: 56645, cityId: 704, code: "828303" },
    { id: 56646, cityId: 704, code: "829128" },
    { id: 56647, cityId: 704, code: "825315" },
    { id: 56648, cityId: 704, code: "827003" },
    { id: 56649, cityId: 704, code: "829116" },
    { id: 56650, cityId: 710, code: "829201" },
    { id: 56651, cityId: 710, code: "825403" },
    { id: 56652, cityId: 713, code: "814146" },
    { id: 56653, cityId: 713, code: "814120" },
    { id: 56654, cityId: 713, code: "814153" },
    { id: 56655, cityId: 713, code: "814142" },
    { id: 56656, cityId: 713, code: "815353" },
    { id: 56657, cityId: 713, code: "814143" },
    { id: 56658, cityId: 714, code: "828109" },
    { id: 56659, cityId: 714, code: "827302" },
    { id: 56660, cityId: 714, code: "828121" },
    { id: 56661, cityId: 714, code: "828202" },
    { id: 56662, cityId: 714, code: "828304" },
    { id: 56663, cityId: 714, code: "828402" },
    { id: 56664, cityId: 714, code: "828122" },
    { id: 56665, cityId: 714, code: "828111" },
    { id: 56666, cityId: 714, code: "828112" },
    { id: 56667, cityId: 715, code: "816107" },
    { id: 56668, cityId: 715, code: "814150" },
    { id: 56669, cityId: 715, code: "816117" },
    { id: 56670, cityId: 715, code: "814151" },
    { id: 56671, cityId: 716, code: "822133" },
    { id: 56672, cityId: 716, code: "829201" },
    { id: 56673, cityId: 716, code: "822132" },
    { id: 56674, cityId: 716, code: "822128" },
    { id: 56675, cityId: 716, code: "822112" },
    { id: 56676, cityId: 716, code: "822118" },
    { id: 56677, cityId: 716, code: "822124" },
    { id: 56678, cityId: 716, code: "822129" },
    { id: 56679, cityId: 716, code: "822125" },
    { id: 56680, cityId: 723, code: "835227" },
    { id: 56681, cityId: 723, code: "835208" },
    { id: 56682, cityId: 723, code: "835214" },
    { id: 56683, cityId: 723, code: "835206" },
    { id: 56684, cityId: 723, code: "835302" },
    { id: 56685, cityId: 727, code: "815355" },
    { id: 56686, cityId: 727, code: "815354" },
    { id: 56687, cityId: 727, code: "814166" },
    { id: 56688, cityId: 727, code: "815352" },
    { id: 56689, cityId: 727, code: "815359" },
    { id: 56690, cityId: 737, code: "835235" },
    { id: 56691, cityId: 737, code: "835302" },
    { id: 56692, cityId: 740, code: "822119" },
    { id: 56693, cityId: 740, code: "822112" },
    { id: 56694, cityId: 740, code: "829204" },
    { id: 56695, cityId: 740, code: "822111" },
    { id: 56696, cityId: 740, code: "829203" },
    { id: 56697, cityId: 740, code: "829202" },
    { id: 56698, cityId: 740, code: "829207" },
    { id: 56699, cityId: 741, code: "834009" },
    { id: 56700, cityId: 741, code: "834004" },
    { id: 56701, cityId: 741, code: "835325" },
    { id: 56702, cityId: 753, code: "835204" },
    { id: 56703, cityId: 753, code: "835210" },
    { id: 56704, cityId: 753, code: "835221" },
    { id: 56705, cityId: 753, code: "829205" },
    { id: 56706, cityId: 753, code: "835325" },
    { id: 56707, cityId: 755, code: "816101" },
    { id: 56708, cityId: 755, code: "816120" },
    { id: 56709, cityId: 755, code: "816108" },
    { id: 56710, cityId: 755, code: "816102" },
    { id: 56711, cityId: 755, code: "813208" },
    { id: 56712, cityId: 755, code: "816115" },
    { id: 56713, cityId: 755, code: "816116" },
    { id: 56714, cityId: 755, code: "816129" },
    { id: 56715, cityId: 755, code: "816105" },
    { id: 56716, cityId: 757, code: "835201" },
    { id: 56717, cityId: 757, code: "835226" },
    { id: 56718, cityId: 757, code: "835212" },
    { id: 56719, cityId: 757, code: "835211" },
    { id: 56720, cityId: 757, code: "835235" },
    { id: 56721, cityId: 757, code: "835228" },
    { id: 56722, cityId: 764, code: "591223" },
    { id: 56723, cityId: 764, code: "590018" },
    { id: 56724, cityId: 764, code: "591301" },
    { id: 56725, cityId: 764, code: "591156" },
    { id: 56726, cityId: 764, code: "591231" },
    { id: 56727, cityId: 764, code: "590016" },
    { id: 56728, cityId: 764, code: "590017" },
    { id: 56729, cityId: 764, code: "591311" },
    { id: 56730, cityId: 764, code: "591153" },
    { id: 56731, cityId: 778, code: "587316" },
    { id: 56732, cityId: 778, code: "587119" },
    { id: 56733, cityId: 778, code: "587112" },
    { id: 56734, cityId: 778, code: "587315" },
    { id: 56735, cityId: 778, code: "587118" },
    { id: 56736, cityId: 778, code: "587125" },
    { id: 56737, cityId: 778, code: "587207" },
    { id: 56738, cityId: 778, code: "587201" },
    { id: 56739, cityId: 778, code: "587120" },
    { id: 56740, cityId: 778, code: "587202" },
    { id: 56741, cityId: 778, code: "587311" },
    { id: 56742, cityId: 778, code: "587203" },
    { id: 56743, cityId: 778, code: "587121" },
    { id: 56744, cityId: 778, code: "587206" },
    { id: 56745, cityId: 778, code: "586125" },
    { id: 56746, cityId: 778, code: "587205" },
    { id: 56747, cityId: 778, code: "587122" },
    { id: 56748, cityId: 778, code: "587116" },
    { id: 56749, cityId: 778, code: "587312" },
    { id: 56750, cityId: 778, code: "587115" },
    { id: 56751, cityId: 778, code: "586113" },
    { id: 56752, cityId: 778, code: "587313" },
    { id: 56753, cityId: 778, code: "587117" },
    { id: 56754, cityId: 778, code: "587155" },
    { id: 56755, cityId: 778, code: "587301" },
    { id: 56756, cityId: 778, code: "587314" },
    { id: 56757, cityId: 778, code: "587111" },
    { id: 56758, cityId: 778, code: "587124" },
    { id: 56759, cityId: 778, code: "587154" },
    { id: 56760, cityId: 781, code: "560099" },
    { id: 56761, cityId: 781, code: "560048" },
    { id: 56762, cityId: 781, code: "560092" },
    { id: 56763, cityId: 781, code: "560068" },
    { id: 56764, cityId: 781, code: "562162" },
    { id: 56765, cityId: 781, code: "562106" },
    { id: 56766, cityId: 781, code: "560057" },
    { id: 56767, cityId: 781, code: "562120" },
    { id: 56768, cityId: 789, code: "591345" },
    { id: 56769, cityId: 789, code: "590019" },
    { id: 56770, cityId: 789, code: "591311" },
    { id: 56771, cityId: 789, code: "590020" },
    { id: 56772, cityId: 789, code: "591117" },
    { id: 56773, cityId: 789, code: "591231" },
    { id: 56774, cityId: 789, code: "591301" },
    { id: 56775, cityId: 790, code: "583122" },
    { id: 56776, cityId: 795, code: "585330" },
    { id: 56777, cityId: 795, code: "585331" },
    { id: 56778, cityId: 795, code: "585328" },
    { id: 56779, cityId: 815, code: "577542" },
    { id: 56780, cityId: 815, code: "577511" },
    { id: 56781, cityId: 815, code: "577531" },
    { id: 56782, cityId: 815, code: "577558" },
    { id: 56783, cityId: 815, code: "577539" },
    { id: 56784, cityId: 815, code: "577533" },
    { id: 56785, cityId: 821, code: "580114" },
    { id: 56786, cityId: 821, code: "580006" },
    { id: 56787, cityId: 821, code: "582201" },
    { id: 56788, cityId: 821, code: "580025" },
    { id: 56789, cityId: 821, code: "581117" },
    { id: 56790, cityId: 821, code: "580001" },
    { id: 56791, cityId: 821, code: "580007" },
    { id: 56792, cityId: 821, code: "581206" },
    { id: 56793, cityId: 821, code: "580032" },
    { id: 56794, cityId: 821, code: "580020" },
    { id: 56795, cityId: 821, code: "581207" },
    { id: 56796, cityId: 821, code: "580008" },
    { id: 56797, cityId: 821, code: "580028" },
    { id: 56798, cityId: 821, code: "582208" },
    { id: 56799, cityId: 821, code: "580021" },
    { id: 56800, cityId: 821, code: "581201" },
    { id: 56801, cityId: 821, code: "580031" },
    { id: 56802, cityId: 821, code: "580005" },
    { id: 56803, cityId: 821, code: "581103" },
    { id: 56804, cityId: 821, code: "580003" },
    { id: 56805, cityId: 821, code: "581113" },
    { id: 56806, cityId: 821, code: "580004" },
    { id: 56807, cityId: 821, code: "581209" },
    { id: 56808, cityId: 821, code: "580009" },
    { id: 56809, cityId: 821, code: "581107" },
    { id: 56810, cityId: 821, code: "580118" },
    { id: 56811, cityId: 821, code: "580112" },
    { id: 56812, cityId: 821, code: "580029" },
    { id: 56813, cityId: 821, code: "580023" },
    { id: 56814, cityId: 821, code: "581204" },
    { id: 56815, cityId: 821, code: "580024" },
    { id: 56816, cityId: 821, code: "580030" },
    { id: 56817, cityId: 824, code: "582117" },
    { id: 56818, cityId: 824, code: "582120" },
    { id: 56819, cityId: 824, code: "583277" },
    { id: 56820, cityId: 824, code: "583233" },
    { id: 56821, cityId: 824, code: "582211" },
    { id: 56822, cityId: 824, code: "582116" },
    { id: 56823, cityId: 824, code: "583226" },
    { id: 56824, cityId: 824, code: "583238" },
    { id: 56825, cityId: 824, code: "583279" },
    { id: 56826, cityId: 824, code: "582206" },
    { id: 56827, cityId: 824, code: "583227" },
    { id: 56828, cityId: 824, code: "582111" },
    { id: 56829, cityId: 824, code: "582118" },
    { id: 56830, cityId: 824, code: "582102" },
    { id: 56831, cityId: 824, code: "582210" },
    { id: 56832, cityId: 824, code: "582114" },
    { id: 56833, cityId: 824, code: "582101" },
    { id: 56834, cityId: 824, code: "582209" },
    { id: 56835, cityId: 824, code: "582203" },
    { id: 56836, cityId: 824, code: "583282" },
    { id: 56837, cityId: 824, code: "582113" },
    { id: 56838, cityId: 824, code: "583268" },
    { id: 56839, cityId: 824, code: "582119" },
    { id: 56840, cityId: 824, code: "583235" },
    { id: 56841, cityId: 824, code: "582112" },
    { id: 56842, cityId: 824, code: "583229" },
    { id: 56843, cityId: 824, code: "582207" },
    { id: 56844, cityId: 830, code: "585305" },
    { id: 56845, cityId: 830, code: "585318" },
    { id: 56846, cityId: 830, code: "585228" },
    { id: 56847, cityId: 830, code: "585322" },
    { id: 56848, cityId: 830, code: "585303" },
    { id: 56849, cityId: 830, code: "585211" },
    { id: 56850, cityId: 830, code: "585325" },
    { id: 56851, cityId: 830, code: "585319" },
    { id: 56852, cityId: 830, code: "585321" },
    { id: 56853, cityId: 830, code: "585217" },
    { id: 56854, cityId: 830, code: "585312" },
    { id: 56855, cityId: 830, code: "585218" },
    { id: 56856, cityId: 830, code: "585301" },
    { id: 56857, cityId: 830, code: "585314" },
    { id: 56858, cityId: 830, code: "585225" },
    { id: 56859, cityId: 830, code: "585310" },
    { id: 56860, cityId: 830, code: "585307" },
    { id: 56861, cityId: 830, code: "585313" },
    { id: 56862, cityId: 838, code: "573102" },
    { id: 56863, cityId: 838, code: "573141" },
    { id: 56864, cityId: 838, code: "573218" },
    { id: 56865, cityId: 838, code: "573123" },
    { id: 56866, cityId: 838, code: "573112" },
    { id: 56867, cityId: 838, code: "573213" },
    { id: 56868, cityId: 838, code: "573117" },
    { id: 56869, cityId: 838, code: "573130" },
    { id: 56870, cityId: 838, code: "573136" },
    { id: 56871, cityId: 838, code: "573124" },
    { id: 56872, cityId: 838, code: "573127" },
    { id: 56873, cityId: 838, code: "573216" },
    { id: 56874, cityId: 838, code: "573210" },
    { id: 56875, cityId: 838, code: "573121" },
    { id: 56876, cityId: 838, code: "573144" },
    { id: 56877, cityId: 838, code: "573119" },
    { id: 56878, cityId: 838, code: "573125" },
    { id: 56879, cityId: 838, code: "573120" },
    { id: 56880, cityId: 838, code: "573215" },
    { id: 56881, cityId: 838, code: "573101" },
    { id: 56882, cityId: 839, code: "581115" },
    { id: 56883, cityId: 839, code: "581102" },
    { id: 56884, cityId: 839, code: "581193" },
    { id: 56885, cityId: 839, code: "581205" },
    { id: 56886, cityId: 839, code: "581211" },
    { id: 56887, cityId: 839, code: "581111" },
    { id: 56888, cityId: 839, code: "581123" },
    { id: 56889, cityId: 839, code: "581212" },
    { id: 56890, cityId: 839, code: "581210" },
    { id: 56891, cityId: 839, code: "581104" },
    { id: 56892, cityId: 839, code: "581101" },
    { id: 56893, cityId: 839, code: "581120" },
    { id: 56894, cityId: 839, code: "581145" },
    { id: 56895, cityId: 839, code: "581126" },
    { id: 56896, cityId: 839, code: "581118" },
    { id: 56897, cityId: 839, code: "581112" },
    { id: 56898, cityId: 839, code: "581116" },
    { id: 56899, cityId: 839, code: "581106" },
    { id: 56900, cityId: 839, code: "581119" },
    { id: 56901, cityId: 839, code: "581202" },
    { id: 56902, cityId: 839, code: "581208" },
    { id: 56903, cityId: 866, code: "670567" },
    { id: 56904, cityId: 866, code: "670675" },
    { id: 56905, cityId: 866, code: "670561" },
    { id: 56906, cityId: 866, code: "673312" },
    { id: 56907, cityId: 866, code: "670307" },
    { id: 56908, cityId: 866, code: "673316" },
    { id: 56909, cityId: 866, code: "670571" },
    { id: 56910, cityId: 866, code: "670621" },
    { id: 56911, cityId: 866, code: "670107" },
    { id: 56912, cityId: 866, code: "670304" },
    { id: 56913, cityId: 866, code: "670622" },
    { id: 56914, cityId: 866, code: "670006" },
    { id: 56915, cityId: 866, code: "670102" },
    { id: 56916, cityId: 866, code: "670673" },
    { id: 56917, cityId: 866, code: "670305" },
    { id: 56918, cityId: 866, code: "670704" },
    { id: 56919, cityId: 866, code: "670641" },
    { id: 56920, cityId: 866, code: "670502" },
    { id: 56921, cityId: 866, code: "670501" },
    { id: 56922, cityId: 866, code: "670013" },
    { id: 56923, cityId: 866, code: "670692" },
    { id: 56924, cityId: 866, code: "670331" },
    { id: 56925, cityId: 866, code: "670591" },
    { id: 56926, cityId: 866, code: "670705" },
    { id: 56927, cityId: 866, code: "670104" },
    { id: 56928, cityId: 866, code: "670592" },
    { id: 56929, cityId: 866, code: "670358" },
    { id: 56930, cityId: 866, code: "670643" },
    { id: 56931, cityId: 866, code: "670694" },
    { id: 56932, cityId: 866, code: "670009" },
    { id: 56933, cityId: 866, code: "670002" },
    { id: 56934, cityId: 866, code: "670142" },
    { id: 56935, cityId: 866, code: "670662" },
    { id: 56936, cityId: 866, code: "670604" },
    { id: 56937, cityId: 866, code: "670661" },
    { id: 56938, cityId: 866, code: "670611" },
    { id: 56939, cityId: 866, code: "670674" },
    { id: 56940, cityId: 866, code: "670649" },
    { id: 56941, cityId: 866, code: "670706" },
    { id: 56942, cityId: 866, code: "670141" },
    { id: 56943, cityId: 866, code: "670103" },
    { id: 56944, cityId: 866, code: "673311" },
    { id: 56945, cityId: 866, code: "670693" },
    { id: 56946, cityId: 866, code: "670325" },
    { id: 56947, cityId: 866, code: "670014" },
    { id: 56948, cityId: 866, code: "670007" },
    { id: 56949, cityId: 866, code: "670011" },
    { id: 56950, cityId: 866, code: "670582" },
    { id: 56951, cityId: 866, code: "670581" },
    { id: 56952, cityId: 866, code: "670106" },
    { id: 56953, cityId: 866, code: "670303" },
    { id: 56954, cityId: 866, code: "670005" },
    { id: 56955, cityId: 866, code: "670633" },
    { id: 56956, cityId: 866, code: "670671" },
    { id: 56957, cityId: 866, code: "670309" },
    { id: 56958, cityId: 866, code: "670563" },
    { id: 56959, cityId: 866, code: "670703" },
    { id: 56960, cityId: 866, code: "670741" },
    { id: 56961, cityId: 866, code: "670595" },
    { id: 56962, cityId: 866, code: "670672" },
    { id: 56963, cityId: 866, code: "670101" },
    { id: 56964, cityId: 866, code: "670018" },
    { id: 56965, cityId: 866, code: "670012" },
    { id: 56966, cityId: 866, code: "670310" },
    { id: 56967, cityId: 866, code: "670601" },
    { id: 56968, cityId: 866, code: "670602" },
    { id: 56969, cityId: 866, code: "670691" },
    { id: 56970, cityId: 866, code: "670353" },
    { id: 56971, cityId: 866, code: "670010" },
    { id: 56972, cityId: 866, code: "670632" },
    { id: 56973, cityId: 866, code: "670004" },
    { id: 56974, cityId: 866, code: "670651" },
    { id: 56975, cityId: 866, code: "670334" },
    { id: 56976, cityId: 866, code: "670613" },
    { id: 56977, cityId: 866, code: "670562" },
    { id: 56978, cityId: 866, code: "670702" },
    { id: 56979, cityId: 866, code: "670017" },
    { id: 56980, cityId: 866, code: "670594" },
    { id: 56981, cityId: 866, code: "670302" },
    { id: 56982, cityId: 866, code: "670327" },
    { id: 56983, cityId: 866, code: "670301" },
    { id: 56984, cityId: 866, code: "670701" },
    { id: 56985, cityId: 866, code: "670663" },
    { id: 56986, cityId: 866, code: "670612" },
    { id: 56987, cityId: 866, code: "673313" },
    { id: 56988, cityId: 866, code: "670003" },
    { id: 56989, cityId: 866, code: "670631" },
    { id: 56990, cityId: 866, code: "670593" },
    { id: 56991, cityId: 866, code: "670650" },
    { id: 56992, cityId: 866, code: "670105" },
    { id: 56993, cityId: 866, code: "670308" },
    { id: 56994, cityId: 866, code: "670676" },
    { id: 56995, cityId: 866, code: "670511" },
    { id: 56996, cityId: 866, code: "670143" },
    { id: 56997, cityId: 873, code: "561209" },
    { id: 56998, cityId: 873, code: "563139" },
    { id: 56999, cityId: 873, code: "561228" },
    { id: 57000, cityId: 873, code: "562104" },
    { id: 57001, cityId: 873, code: "563138" },
    { id: 57002, cityId: 873, code: "561212" },
    { id: 57003, cityId: 873, code: "563128" },
    { id: 57004, cityId: 873, code: "561210" },
    { id: 57005, cityId: 873, code: "563159" },
    { id: 57006, cityId: 873, code: "561207" },
    { id: 57007, cityId: 873, code: "563137" },
    { id: 57008, cityId: 873, code: "562103" },
    { id: 57009, cityId: 873, code: "563136" },
    { id: 57010, cityId: 873, code: "561213" },
    { id: 57011, cityId: 873, code: "562101" },
    { id: 57012, cityId: 873, code: "563116" },
    { id: 57013, cityId: 873, code: "563123" },
    { id: 57014, cityId: 877, code: "583236" },
    { id: 57015, cityId: 877, code: "583268" },
    { id: 57016, cityId: 877, code: "583237" },
    { id: 57017, cityId: 877, code: "583235" },
    { id: 57018, cityId: 877, code: "583229" },
    { id: 57019, cityId: 877, code: "583282" },
    { id: 57020, cityId: 877, code: "583232" },
    { id: 57021, cityId: 877, code: "583228" },
    { id: 57022, cityId: 877, code: "583234" },
    { id: 57023, cityId: 877, code: "583279" },
    { id: 57024, cityId: 877, code: "583227" },
    { id: 57025, cityId: 877, code: "583238" },
    { id: 57026, cityId: 877, code: "583277" },
    { id: 57027, cityId: 877, code: "583226" },
    { id: 57028, cityId: 901, code: "571477" },
    { id: 57029, cityId: 901, code: "571807" },
    { id: 57030, cityId: 901, code: "571605" },
    { id: 57031, cityId: 901, code: "571415" },
    { id: 57032, cityId: 901, code: "571478" },
    { id: 57033, cityId: 901, code: "571446" },
    { id: 57034, cityId: 901, code: "571426" },
    { id: 57035, cityId: 901, code: "571450" },
    { id: 57036, cityId: 901, code: "571476" },
    { id: 57037, cityId: 901, code: "571425" },
    { id: 57038, cityId: 901, code: "571812" },
    { id: 57039, cityId: 901, code: "571811" },
    { id: 57040, cityId: 901, code: "571436" },
    { id: 57041, cityId: 901, code: "571417" },
    { id: 57042, cityId: 901, code: "571607" },
    { id: 57043, cityId: 901, code: "571418" },
    { id: 57044, cityId: 901, code: "571423" },
    { id: 57045, cityId: 901, code: "571424" },
    { id: 57046, cityId: 913, code: "571314" },
    { id: 57047, cityId: 913, code: "571187" },
    { id: 57048, cityId: 913, code: "571118" },
    { id: 57049, cityId: 913, code: "571103" },
    { id: 57050, cityId: 913, code: "571119" },
    { id: 57051, cityId: 913, code: "571101" },
    { id: 57052, cityId: 913, code: "571610" },
    { id: 57053, cityId: 913, code: "571604" },
    { id: 57054, cityId: 913, code: "571102" },
    { id: 57055, cityId: 913, code: "571121" },
    { id: 57056, cityId: 913, code: "571603" },
    { id: 57057, cityId: 913, code: "571108" },
    { id: 57058, cityId: 925, code: "584129" },
    { id: 57059, cityId: 925, code: "584123" },
    { id: 57060, cityId: 925, code: "584124" },
    { id: 57061, cityId: 925, code: "584203" },
    { id: 57062, cityId: 925, code: "584132" },
    { id: 57063, cityId: 925, code: "584118" },
    { id: 57064, cityId: 925, code: "584170" },
    { id: 57065, cityId: 925, code: "584125" },
    { id: 57066, cityId: 925, code: "584139" },
    { id: 57067, cityId: 930, code: "470441" },
    { id: 57068, cityId: 930, code: "464240" },
    { id: 57069, cityId: 930, code: "470124" },
    { id: 57070, cityId: 930, code: "470021" },
    { id: 57071, cityId: 930, code: "470232" },
    { id: 57072, cityId: 942, code: "577232" },
    { id: 57073, cityId: 942, code: "577422" },
    { id: 57074, cityId: 942, code: "577416" },
    { id: 57075, cityId: 942, code: "577423" },
    { id: 57076, cityId: 942, code: "577417" },
    { id: 57077, cityId: 942, code: "577412" },
    { id: 57078, cityId: 942, code: "577424" },
    { id: 57079, cityId: 942, code: "577436" },
    { id: 57080, cityId: 942, code: "577415" },
    { id: 57081, cityId: 942, code: "577243" },
    { id: 57082, cityId: 942, code: "577115" },
    { id: 57083, cityId: 942, code: "577419" },
    { id: 57084, cityId: 942, code: "577413" },
    { id: 57085, cityId: 942, code: "577414" },
    { id: 57086, cityId: 964, code: "572217" },
    { id: 57087, cityId: 964, code: "572211" },
    { id: 57088, cityId: 964, code: "572141" },
    { id: 57089, cityId: 964, code: "572223" },
    { id: 57090, cityId: 964, code: "572121" },
    { id: 57091, cityId: 964, code: "572115" },
    { id: 57092, cityId: 964, code: "572215" },
    { id: 57093, cityId: 964, code: "572126" },
    { id: 57094, cityId: 964, code: "572221" },
    { id: 57095, cityId: 964, code: "572120" },
    { id: 57096, cityId: 964, code: "572228" },
    { id: 57097, cityId: 964, code: "572127" },
    { id: 57098, cityId: 964, code: "572139" },
    { id: 57099, cityId: 964, code: "572113" },
    { id: 57100, cityId: 964, code: "572218" },
    { id: 57101, cityId: 964, code: "572224" },
    { id: 57102, cityId: 964, code: "572142" },
    { id: 57103, cityId: 964, code: "572111" },
    { id: 57104, cityId: 964, code: "572212" },
    { id: 57105, cityId: 964, code: "572136" },
    { id: 57106, cityId: 964, code: "572220" },
    { id: 57107, cityId: 964, code: "572214" },
    { id: 57108, cityId: 964, code: "572119" },
    { id: 57109, cityId: 964, code: "572125" },
    { id: 57110, cityId: 964, code: "572105" },
    { id: 57111, cityId: 964, code: "572112" },
    { id: 57112, cityId: 964, code: "572226" },
    { id: 57113, cityId: 964, code: "572124" },
    { id: 57114, cityId: 964, code: "572222" },
    { id: 57115, cityId: 966, code: "576214" },
    { id: 57116, cityId: 966, code: "574108" },
    { id: 57117, cityId: 966, code: "574102" },
    { id: 57118, cityId: 966, code: "576221" },
    { id: 57119, cityId: 966, code: "576227" },
    { id: 57120, cityId: 966, code: "576113" },
    { id: 57121, cityId: 966, code: "576234" },
    { id: 57122, cityId: 966, code: "576114" },
    { id: 57123, cityId: 966, code: "574115" },
    { id: 57124, cityId: 966, code: "576247" },
    { id: 57125, cityId: 966, code: "576222" },
    { id: 57126, cityId: 966, code: "576215" },
    { id: 57127, cityId: 966, code: "574109" },
    { id: 57128, cityId: 966, code: "574103" },
    { id: 57129, cityId: 966, code: "576120" },
    { id: 57130, cityId: 966, code: "574122" },
    { id: 57131, cityId: 966, code: "576217" },
    { id: 57132, cityId: 966, code: "576122" },
    { id: 57133, cityId: 966, code: "576115" },
    { id: 57134, cityId: 966, code: "574117" },
    { id: 57135, cityId: 966, code: "574104" },
    { id: 57136, cityId: 966, code: "574110" },
    { id: 57137, cityId: 966, code: "576223" },
    { id: 57138, cityId: 966, code: "576229" },
    { id: 57139, cityId: 966, code: "576228" },
    { id: 57140, cityId: 966, code: "574116" },
    { id: 57141, cityId: 966, code: "576210" },
    { id: 57142, cityId: 966, code: "574129" },
    { id: 57143, cityId: 966, code: "576121" },
    { id: 57144, cityId: 966, code: "576216" },
    { id: 57145, cityId: 966, code: "576235" },
    { id: 57146, cityId: 966, code: "574113" },
    { id: 57147, cityId: 966, code: "574107" },
    { id: 57148, cityId: 966, code: "576220" },
    { id: 57149, cityId: 966, code: "576112" },
    { id: 57150, cityId: 966, code: "574101" },
    { id: 57151, cityId: 966, code: "576233" },
    { id: 57152, cityId: 966, code: "574114" },
    { id: 57153, cityId: 966, code: "574119" },
    { id: 57154, cityId: 966, code: "576257" },
    { id: 57155, cityId: 966, code: "576111" },
    { id: 57156, cityId: 966, code: "576226" },
    { id: 57157, cityId: 966, code: "576225" },
    { id: 57158, cityId: 966, code: "576282" },
    { id: 57159, cityId: 966, code: "574144" },
    { id: 57160, cityId: 966, code: "576117" },
    { id: 57161, cityId: 966, code: "576124" },
    { id: 57162, cityId: 966, code: "576232" },
    { id: 57163, cityId: 966, code: "576219" },
    { id: 57164, cityId: 966, code: "576213" },
    { id: 57165, cityId: 966, code: "576218" },
    { id: 57166, cityId: 966, code: "576211" },
    { id: 57167, cityId: 966, code: "576230" },
    { id: 57168, cityId: 966, code: "574111" },
    { id: 57169, cityId: 966, code: "574244" },
    { id: 57170, cityId: 966, code: "576224" },
    { id: 57171, cityId: 966, code: "574105" },
    { id: 57172, cityId: 966, code: "576212" },
    { id: 57173, cityId: 966, code: "574106" },
    { id: 57174, cityId: 966, code: "574112" },
    { id: 57175, cityId: 966, code: "576231" },
    { id: 57176, cityId: 972, code: "585216" },
    { id: 57177, cityId: 972, code: "585221" },
    { id: 57178, cityId: 972, code: "585215" },
    { id: 57179, cityId: 972, code: "585304" },
    { id: 57180, cityId: 972, code: "585291" },
    { id: 57181, cityId: 972, code: "585202" },
    { id: 57182, cityId: 972, code: "585323" },
    { id: 57183, cityId: 972, code: "585214" },
    { id: 57184, cityId: 972, code: "585220" },
    { id: 57185, cityId: 972, code: "585309" },
    { id: 57186, cityId: 972, code: "585290" },
    { id: 57187, cityId: 972, code: "585315" },
    { id: 57188, cityId: 972, code: "585223" },
    { id: 57189, cityId: 972, code: "585319" },
    { id: 57190, cityId: 972, code: "585287" },
    { id: 57191, cityId: 972, code: "585219" },
    { id: 57192, cityId: 972, code: "585224" },
    { id: 57193, cityId: 972, code: "585237" },
    { id: 57194, cityId: 972, code: "585201" },
    { id: 57195, cityId: 978, code: "690547" },
    { id: 57196, cityId: 978, code: "686102" },
    { id: 57197, cityId: 978, code: "686534" },
    { id: 57198, cityId: 978, code: "686103" },
    { id: 57199, cityId: 978, code: "688012" },
    { id: 57200, cityId: 978, code: "689520" },
    { id: 57201, cityId: 978, code: "688524" },
    { id: 57202, cityId: 978, code: "688525" },
    { id: 57203, cityId: 978, code: "688007" },
    { id: 57204, cityId: 978, code: "688534" },
    { id: 57205, cityId: 978, code: "690101" },
    { id: 57206, cityId: 978, code: "688008" },
    { id: 57207, cityId: 1002, code: "686661" },
    { id: 57208, cityId: 1002, code: "683542" },
    { id: 57209, cityId: 1002, code: "680667" },
    { id: 57210, cityId: 1002, code: "682509" },
    { id: 57211, cityId: 1002, code: "682001" },
    { id: 57212, cityId: 1002, code: "683101" },
    { id: 57213, cityId: 1002, code: "682034" },
    { id: 57214, cityId: 1002, code: "682504" },
    { id: 57215, cityId: 1015, code: "670650" },
    { id: 57216, cityId: 1015, code: "670593" },
    { id: 57217, cityId: 1015, code: "670663" },
    { id: 57218, cityId: 1015, code: "670009" },
    { id: 57219, cityId: 1015, code: "670631" },
    { id: 57220, cityId: 1015, code: "670003" },
    { id: 57221, cityId: 1015, code: "670694" },
    { id: 57222, cityId: 1015, code: "670612" },
    { id: 57223, cityId: 1015, code: "670675" },
    { id: 57224, cityId: 1015, code: "670358" },
    { id: 57225, cityId: 1015, code: "670301" },
    { id: 57226, cityId: 1015, code: "670104" },
    { id: 57227, cityId: 1015, code: "670561" },
    { id: 57228, cityId: 1015, code: "673312" },
    { id: 57229, cityId: 1015, code: "670504" },
    { id: 57230, cityId: 1015, code: "670701" },
    { id: 57231, cityId: 1015, code: "670307" },
    { id: 57232, cityId: 1015, code: "670010" },
    { id: 57233, cityId: 1015, code: "670004" },
    { id: 57234, cityId: 1015, code: "670632" },
    { id: 57235, cityId: 1015, code: "670594" },
    { id: 57236, cityId: 1015, code: "670143" },
    { id: 57237, cityId: 1015, code: "670511" },
    { id: 57238, cityId: 1015, code: "673313" },
    { id: 57239, cityId: 1015, code: "670308" },
    { id: 57240, cityId: 1015, code: "670302" },
    { id: 57241, cityId: 1015, code: "670562" },
    { id: 57242, cityId: 1015, code: "670676" },
    { id: 57243, cityId: 1015, code: "670105" },
    { id: 57244, cityId: 1015, code: "670613" },
    { id: 57245, cityId: 1015, code: "670582" },
    { id: 57246, cityId: 1015, code: "670017" },
    { id: 57247, cityId: 1015, code: "670011" },
    { id: 57248, cityId: 1015, code: "670702" },
    { id: 57249, cityId: 1015, code: "670334" },
    { id: 57250, cityId: 1015, code: "670327" },
    { id: 57251, cityId: 1015, code: "670581" },
    { id: 57252, cityId: 1015, code: "670309" },
    { id: 57253, cityId: 1015, code: "670106" },
    { id: 57254, cityId: 1015, code: "670563" },
    { id: 57255, cityId: 1015, code: "670595" },
    { id: 57256, cityId: 1015, code: "670018" },
    { id: 57257, cityId: 1015, code: "670703" },
    { id: 57258, cityId: 1015, code: "670303" },
    { id: 57259, cityId: 1015, code: "670671" },
    { id: 57260, cityId: 1015, code: "670633" },
    { id: 57261, cityId: 1015, code: "670601" },
    { id: 57262, cityId: 1015, code: "670005" },
    { id: 57263, cityId: 1015, code: "670643" },
    { id: 57264, cityId: 1015, code: "670706" },
    { id: 57265, cityId: 1015, code: "670503" },
    { id: 57266, cityId: 1015, code: "670611" },
    { id: 57267, cityId: 1015, code: "670008" },
    { id: 57268, cityId: 1015, code: "670662" },
    { id: 57269, cityId: 1015, code: "670661" },
    { id: 57270, cityId: 1015, code: "670141" },
    { id: 57271, cityId: 1015, code: "670142" },
    { id: 57272, cityId: 1015, code: "670002" },
    { id: 57273, cityId: 1015, code: "670014" },
    { id: 57274, cityId: 1015, code: "670693" },
    { id: 57275, cityId: 1015, code: "670604" },
    { id: 57276, cityId: 1015, code: "673311" },
    { id: 57277, cityId: 1015, code: "670007" },
    { id: 57278, cityId: 1015, code: "670692" },
    { id: 57279, cityId: 1015, code: "670521" },
    { id: 57280, cityId: 1015, code: "670641" },
    { id: 57281, cityId: 1015, code: "670013" },
    { id: 57282, cityId: 1015, code: "670325" },
    { id: 57283, cityId: 1015, code: "670642" },
    { id: 57284, cityId: 1015, code: "670331" },
    { id: 57285, cityId: 1015, code: "670103" },
    { id: 57286, cityId: 1015, code: "670591" },
    { id: 57287, cityId: 1015, code: "670674" },
    { id: 57288, cityId: 1015, code: "670705" },
    { id: 57289, cityId: 1015, code: "670305" },
    { id: 57290, cityId: 1015, code: "673316" },
    { id: 57291, cityId: 1015, code: "670502" },
    { id: 57292, cityId: 1015, code: "670621" },
    { id: 57293, cityId: 1015, code: "670501" },
    { id: 57294, cityId: 1015, code: "670672" },
    { id: 57295, cityId: 1015, code: "670102" },
    { id: 57296, cityId: 1015, code: "670622" },
    { id: 57297, cityId: 1015, code: "670673" },
    { id: 57298, cityId: 1015, code: "670101" },
    { id: 57299, cityId: 1015, code: "670571" },
    { id: 57300, cityId: 1015, code: "670006" },
    { id: 57301, cityId: 1015, code: "670012" },
    { id: 57302, cityId: 1015, code: "670691" },
    { id: 57303, cityId: 1015, code: "670704" },
    { id: 57304, cityId: 1015, code: "670741" },
    { id: 57305, cityId: 1015, code: "670107" },
    { id: 57306, cityId: 1015, code: "670602" },
    { id: 57307, cityId: 1015, code: "670649" },
    { id: 57308, cityId: 1015, code: "670592" },
    { id: 57309, cityId: 1022, code: "691526" },
    { id: 57310, cityId: 1022, code: "690522" },
    { id: 57311, cityId: 1022, code: "690561" },
    { id: 57312, cityId: 1022, code: "691553" },
    { id: 57313, cityId: 1022, code: "691552" },
    { id: 57314, cityId: 1022, code: "691533" },
    { id: 57315, cityId: 1022, code: "691004" },
    { id: 57316, cityId: 1022, code: "689696" },
    { id: 57317, cityId: 1022, code: "689695" },
    { id: 57318, cityId: 1025, code: "686543" },
    { id: 57319, cityId: 1025, code: "686575" },
    { id: 57320, cityId: 1025, code: "686141" },
    { id: 57321, cityId: 1027, code: "673507" },
    { id: 57322, cityId: 1027, code: "673305" },
    { id: 57323, cityId: 1027, code: "673603" },
    { id: 57324, cityId: 1027, code: "673101" },
    { id: 57325, cityId: 1031, code: "676101" },
    { id: 57326, cityId: 1031, code: "676507" },
    { id: 57327, cityId: 1031, code: "679330" },
    { id: 57328, cityId: 1031, code: "679324" },
    { id: 57329, cityId: 1031, code: "676304" },
    { id: 57330, cityId: 1031, code: "676107" },
    { id: 57331, cityId: 1031, code: "679584" },
    { id: 57332, cityId: 1031, code: "673632" },
    { id: 57333, cityId: 1031, code: "673645" },
    { id: 57334, cityId: 1031, code: "679571" },
    { id: 57335, cityId: 1031, code: "676551" },
    { id: 57336, cityId: 1031, code: "676506" },
    { id: 57337, cityId: 1031, code: "679583" },
    { id: 57338, cityId: 1031, code: "679329" },
    { id: 57339, cityId: 1031, code: "676525" },
    { id: 57340, cityId: 1031, code: "679323" },
    { id: 57341, cityId: 1031, code: "676303" },
    { id: 57342, cityId: 1031, code: "679577" },
    { id: 57343, cityId: 1031, code: "673639" },
    { id: 57344, cityId: 1031, code: "673633" },
    { id: 57345, cityId: 1031, code: "676519" },
    { id: 57346, cityId: 1031, code: "679573" },
    { id: 57347, cityId: 1031, code: "676553" },
    { id: 57348, cityId: 1031, code: "679579" },
    { id: 57349, cityId: 1031, code: "676502" },
    { id: 57350, cityId: 1031, code: "679325" },
    { id: 57351, cityId: 1031, code: "673634" },
    { id: 57352, cityId: 1031, code: "679357" },
    { id: 57353, cityId: 1031, code: "676521" },
    { id: 57354, cityId: 1031, code: "679338" },
    { id: 57355, cityId: 1031, code: "679332" },
    { id: 57356, cityId: 1031, code: "676312" },
    { id: 57357, cityId: 1031, code: "679591" },
    { id: 57358, cityId: 1031, code: "676317" },
    { id: 57359, cityId: 1031, code: "673640" },
    { id: 57360, cityId: 1031, code: "676109" },
    { id: 57361, cityId: 1031, code: "679585" },
    { id: 57362, cityId: 1031, code: "679331" },
    { id: 57363, cityId: 1031, code: "676311" },
    { id: 57364, cityId: 1031, code: "676305" },
    { id: 57365, cityId: 1031, code: "676508" },
    { id: 57366, cityId: 1031, code: "673647" },
    { id: 57367, cityId: 1031, code: "676102" },
    { id: 57368, cityId: 1031, code: "676108" },
    { id: 57369, cityId: 1031, code: "673641" },
    { id: 57370, cityId: 1031, code: "679578" },
    { id: 57371, cityId: 1031, code: "676501" },
    { id: 57372, cityId: 1031, code: "676552" },
    { id: 57373, cityId: 1031, code: "676121" },
    { id: 57374, cityId: 1031, code: "673638" },
    { id: 57375, cityId: 1031, code: "679321" },
    { id: 57376, cityId: 1031, code: "679575" },
    { id: 57377, cityId: 1031, code: "676562" },
    { id: 57378, cityId: 1031, code: "676105" },
    { id: 57379, cityId: 1031, code: "679328" },
    { id: 57380, cityId: 1031, code: "676517" },
    { id: 57381, cityId: 1031, code: "679334" },
    { id: 57382, cityId: 1031, code: "673314" },
    { id: 57383, cityId: 1031, code: "673637" },
    { id: 57384, cityId: 1031, code: "676309" },
    { id: 57385, cityId: 1031, code: "679322" },
    { id: 57386, cityId: 1031, code: "676302" },
    { id: 57387, cityId: 1031, code: "679582" },
    { id: 57388, cityId: 1031, code: "679576" },
    { id: 57389, cityId: 1031, code: "679326" },
    { id: 57390, cityId: 1031, code: "676306" },
    { id: 57391, cityId: 1031, code: "676503" },
    { id: 57392, cityId: 1031, code: "679580" },
    { id: 57393, cityId: 1031, code: "676509" },
    { id: 57394, cityId: 1031, code: "679586" },
    { id: 57395, cityId: 1031, code: "676106" },
    { id: 57396, cityId: 1031, code: "676522" },
    { id: 57397, cityId: 1031, code: "676528" },
    { id: 57398, cityId: 1031, code: "676103" },
    { id: 57399, cityId: 1031, code: "676523" },
    { id: 57400, cityId: 1031, code: "673636" },
    { id: 57401, cityId: 1031, code: "676122" },
    { id: 57402, cityId: 1031, code: "679339" },
    { id: 57403, cityId: 1031, code: "676319" },
    { id: 57404, cityId: 1031, code: "676541" },
    { id: 57405, cityId: 1031, code: "679340" },
    { id: 57406, cityId: 1031, code: "676320" },
    { id: 57407, cityId: 1031, code: "673642" },
    { id: 57408, cityId: 1031, code: "676123" },
    { id: 57409, cityId: 1031, code: "679574" },
    { id: 57410, cityId: 1031, code: "676542" },
    { id: 57411, cityId: 1031, code: "676510" },
    { id: 57412, cityId: 1031, code: "679327" },
    { id: 57413, cityId: 1031, code: "676307" },
    { id: 57414, cityId: 1031, code: "679333" },
    { id: 57415, cityId: 1031, code: "676561" },
    { id: 57416, cityId: 1031, code: "679581" },
    { id: 57417, cityId: 1031, code: "679587" },
    { id: 57418, cityId: 1031, code: "676104" },
    { id: 57419, cityId: 1031, code: "673635" },
    { id: 57420, cityId: 1031, code: "676301" },
    { id: 57421, cityId: 1031, code: "676504" },
    { id: 57422, cityId: 1054, code: "678591" },
    { id: 57423, cityId: 1054, code: "678762" },
    { id: 57424, cityId: 1054, code: "678508" },
    { id: 57425, cityId: 1054, code: "678705" },
    { id: 57426, cityId: 1054, code: "678502" },
    { id: 57427, cityId: 1054, code: "679504" },
    { id: 57428, cityId: 1054, code: "679308" },
    { id: 57429, cityId: 1054, code: "678597" },
    { id: 57430, cityId: 1054, code: "678007" },
    { id: 57431, cityId: 1054, code: "679536" },
    { id: 57432, cityId: 1054, code: "678534" },
    { id: 57433, cityId: 1054, code: "679523" },
    { id: 57434, cityId: 1054, code: "678572" },
    { id: 57435, cityId: 1054, code: "678686" },
    { id: 57436, cityId: 1054, code: "679511" },
    { id: 57437, cityId: 1054, code: "679121" },
    { id: 57438, cityId: 1054, code: "679515" },
    { id: 57439, cityId: 1054, code: "678005" },
    { id: 57440, cityId: 1054, code: "678633" },
    { id: 57441, cityId: 1054, code: "679313" },
    { id: 57442, cityId: 1054, code: "678685" },
    { id: 57443, cityId: 1054, code: "678704" },
    { id: 57444, cityId: 1054, code: "679307" },
    { id: 57445, cityId: 1054, code: "678571" },
    { id: 57446, cityId: 1054, code: "679516" },
    { id: 57447, cityId: 1054, code: "678006" },
    { id: 57448, cityId: 1054, code: "678622" },
    { id: 57449, cityId: 1054, code: "679301" },
    { id: 57450, cityId: 1054, code: "679123" },
    { id: 57451, cityId: 1054, code: "679554" },
    { id: 57452, cityId: 1054, code: "678102" },
    { id: 57453, cityId: 1054, code: "678553" },
    { id: 57454, cityId: 1054, code: "678013" },
    { id: 57455, cityId: 1054, code: "678552" },
    { id: 57456, cityId: 1054, code: "678501" },
    { id: 57457, cityId: 1054, code: "678592" },
    { id: 57458, cityId: 1054, code: "678104" },
    { id: 57459, cityId: 1054, code: "678732" },
    { id: 57460, cityId: 1054, code: "678596" },
    { id: 57461, cityId: 1054, code: "678641" },
    { id: 57462, cityId: 1054, code: "678533" },
    { id: 57463, cityId: 1054, code: "679535" },
    { id: 57464, cityId: 1054, code: "679104" },
    { id: 57465, cityId: 1054, code: "679303" },
    { id: 57466, cityId: 1054, code: "678009" },
    { id: 57467, cityId: 1054, code: "678554" },
    { id: 57468, cityId: 1054, code: "678611" },
    { id: 57469, cityId: 1054, code: "678573" },
    { id: 57470, cityId: 1054, code: "678681" },
    { id: 57471, cityId: 1054, code: "678510" },
    { id: 57472, cityId: 1054, code: "679309" },
    { id: 57473, cityId: 1054, code: "678624" },
    { id: 57474, cityId: 1054, code: "679506" },
    { id: 57475, cityId: 1054, code: "678541" },
    { id: 57476, cityId: 1054, code: "678598" },
    { id: 57477, cityId: 1054, code: "678706" },
    { id: 57478, cityId: 1054, code: "679512" },
    { id: 57479, cityId: 1054, code: "678002" },
    { id: 57480, cityId: 1054, code: "679335" },
    { id: 57481, cityId: 1054, code: "679302" },
    { id: 57482, cityId: 1054, code: "678103" },
    { id: 57483, cityId: 1054, code: "678503" },
    { id: 57484, cityId: 1054, code: "678623" },
    { id: 57485, cityId: 1054, code: "678642" },
    { id: 57486, cityId: 1054, code: "678014" },
    { id: 57487, cityId: 1054, code: "678544" },
    { id: 57488, cityId: 1054, code: "678531" },
    { id: 57489, cityId: 1054, code: "679521" },
    { id: 57490, cityId: 1054, code: "678011" },
    { id: 57491, cityId: 1054, code: "678722" },
    { id: 57492, cityId: 1054, code: "679502" },
    { id: 57493, cityId: 1054, code: "678582" },
    { id: 57494, cityId: 1054, code: "679553" },
    { id: 57495, cityId: 1054, code: "679102" },
    { id: 57496, cityId: 1054, code: "678506" },
    { id: 57497, cityId: 1054, code: "679305" },
    { id: 57498, cityId: 1054, code: "678595" },
    { id: 57499, cityId: 1054, code: "678601" },
    { id: 57500, cityId: 1054, code: "678557" },
    { id: 57501, cityId: 1054, code: "678671" },
    { id: 57502, cityId: 1054, code: "679534" },
    { id: 57503, cityId: 1054, code: "678512" },
    { id: 57504, cityId: 1054, code: "679337" },
    { id: 57505, cityId: 1054, code: "678684" },
    { id: 57506, cityId: 1054, code: "678507" },
    { id: 57507, cityId: 1054, code: "679522" },
    { id: 57508, cityId: 1054, code: "678012" },
    { id: 57509, cityId: 1054, code: "678545" },
    { id: 57510, cityId: 1054, code: "678583" },
    { id: 57511, cityId: 1054, code: "678551" },
    { id: 57512, cityId: 1054, code: "679306" },
    { id: 57513, cityId: 1054, code: "679503" },
    { id: 57514, cityId: 1054, code: "678621" },
    { id: 57515, cityId: 1054, code: "678101" },
    { id: 57516, cityId: 1054, code: "678532" },
    { id: 57517, cityId: 1054, code: "679103" },
    { id: 57518, cityId: 1054, code: "678593" },
    { id: 57519, cityId: 1054, code: "679101" },
    { id: 57520, cityId: 1054, code: "678703" },
    { id: 57521, cityId: 1054, code: "679122" },
    { id: 57522, cityId: 1054, code: "678574" },
    { id: 57523, cityId: 1054, code: "678612" },
    { id: 57524, cityId: 1054, code: "678555" },
    { id: 57525, cityId: 1054, code: "679551" },
    { id: 57526, cityId: 1054, code: "678701" },
    { id: 57527, cityId: 1054, code: "678504" },
    { id: 57528, cityId: 1054, code: "678682" },
    { id: 57529, cityId: 1054, code: "678542" },
    { id: 57530, cityId: 1054, code: "678631" },
    { id: 57531, cityId: 1054, code: "679513" },
    { id: 57532, cityId: 1054, code: "678003" },
    { id: 57533, cityId: 1054, code: "678688" },
    { id: 57534, cityId: 1054, code: "679304" },
    { id: 57535, cityId: 1054, code: "678010" },
    { id: 57536, cityId: 1054, code: "678581" },
    { id: 57537, cityId: 1054, code: "678632" },
    { id: 57538, cityId: 1054, code: "679514" },
    { id: 57539, cityId: 1054, code: "678004" },
    { id: 57540, cityId: 1054, code: "678651" },
    { id: 57541, cityId: 1054, code: "678594" },
    { id: 57542, cityId: 1054, code: "678543" },
    { id: 57543, cityId: 1054, code: "678683" },
    { id: 57544, cityId: 1054, code: "679336" },
    { id: 57545, cityId: 1054, code: "679533" },
    { id: 57546, cityId: 1054, code: "678702" },
    { id: 57547, cityId: 1054, code: "678505" },
    { id: 57548, cityId: 1054, code: "679501" },
    { id: 57549, cityId: 1054, code: "678721" },
    { id: 57550, cityId: 1054, code: "679552" },
    { id: 57551, cityId: 1054, code: "678556" },
    { id: 57552, cityId: 1054, code: "678613" },
    { id: 57553, cityId: 1054, code: "678661" },
    { id: 57554, cityId: 1054, code: "678008" },
    { id: 57555, cityId: 1054, code: "678687" },
    { id: 57556, cityId: 1059, code: "689626" },
    { id: 57557, cityId: 1059, code: "691530" },
    { id: 57558, cityId: 1059, code: "689621" },
    { id: 57559, cityId: 1059, code: "691524" },
    { id: 57560, cityId: 1059, code: "685533" },
    { id: 57561, cityId: 1059, code: "686511" },
    { id: 57562, cityId: 1059, code: "689122" },
    { id: 57563, cityId: 1059, code: "690504" },
    { id: 57564, cityId: 1059, code: "686510" },
    { id: 57565, cityId: 1059, code: "689585" },
    { id: 57566, cityId: 1059, code: "686547" },
    { id: 57567, cityId: 1076, code: "695121" },
    { id: 57568, cityId: 1076, code: "695572" },
    { id: 57569, cityId: 1076, code: "695318" },
    { id: 57570, cityId: 1076, code: "695007" },
    { id: 57571, cityId: 1076, code: "695003" },
    { id: 57572, cityId: 1076, code: "695143" },
    { id: 57573, cityId: 1076, code: "695574" },
    { id: 57574, cityId: 1076, code: "695568" },
    { id: 57575, cityId: 1076, code: "695308" },
    { id: 57576, cityId: 1076, code: "695016" },
    { id: 57577, cityId: 1076, code: "695022" },
    { id: 57578, cityId: 1076, code: "695606" },
    { id: 57579, cityId: 1076, code: "695035" },
    { id: 57580, cityId: 1076, code: "695504" },
    { id: 57581, cityId: 1076, code: "695587" },
    { id: 57582, cityId: 1076, code: "695313" },
    { id: 57583, cityId: 1076, code: "695015" },
    { id: 57584, cityId: 1076, code: "695586" },
    { id: 57585, cityId: 1076, code: "695142" },
    { id: 57586, cityId: 1076, code: "695573" },
    { id: 57587, cityId: 1076, code: "695034" },
    { id: 57588, cityId: 1076, code: "695561" },
    { id: 57589, cityId: 1076, code: "695605" },
    { id: 57590, cityId: 1076, code: "695307" },
    { id: 57591, cityId: 1076, code: "695542" },
    { id: 57592, cityId: 1076, code: "695612" },
    { id: 57593, cityId: 1076, code: "695124" },
    { id: 57594, cityId: 1076, code: "695301" },
    { id: 57595, cityId: 1076, code: "695523" },
    { id: 57596, cityId: 1076, code: "695009" },
    { id: 57597, cityId: 1076, code: "695028" },
    { id: 57598, cityId: 1076, code: "695123" },
    { id: 57599, cityId: 1076, code: "695104" },
    { id: 57600, cityId: 1076, code: "695132" },
    { id: 57601, cityId: 1076, code: "695563" },
    { id: 57602, cityId: 1076, code: "695303" },
    { id: 57603, cityId: 1076, code: "695043" },
    { id: 57604, cityId: 1076, code: "695614" },
    { id: 57605, cityId: 1076, code: "695316" },
    { id: 57606, cityId: 1076, code: "695601" },
    { id: 57607, cityId: 1076, code: "695030" },
    { id: 57608, cityId: 1076, code: "695011" },
    { id: 57609, cityId: 1076, code: "695125" },
    { id: 57610, cityId: 1076, code: "695005" },
    { id: 57611, cityId: 1076, code: "695525" },
    { id: 57612, cityId: 1076, code: "695582" },
    { id: 57613, cityId: 1076, code: "695144" },
    { id: 57614, cityId: 1076, code: "695023" },
    { id: 57615, cityId: 1076, code: "695029" },
    { id: 57616, cityId: 1076, code: "695512" },
    { id: 57617, cityId: 1076, code: "695506" },
    { id: 57618, cityId: 1076, code: "695309" },
    { id: 57619, cityId: 1076, code: "695024" },
    { id: 57620, cityId: 1076, code: "695543" },
    { id: 57621, cityId: 1076, code: "695302" },
    { id: 57622, cityId: 1076, code: "695505" },
    { id: 57623, cityId: 1076, code: "695562" },
    { id: 57624, cityId: 1076, code: "695588" },
    { id: 57625, cityId: 1076, code: "695581" },
    { id: 57626, cityId: 1076, code: "695017" },
    { id: 57627, cityId: 1076, code: "695010" },
    { id: 57628, cityId: 1076, code: "695036" },
    { id: 57629, cityId: 1076, code: "695042" },
    { id: 57630, cityId: 1076, code: "695607" },
    { id: 57631, cityId: 1076, code: "695524" },
    { id: 57632, cityId: 1076, code: "695099" },
    { id: 57633, cityId: 1076, code: "695508" },
    { id: 57634, cityId: 1076, code: "695521" },
    { id: 57635, cityId: 1076, code: "695527" },
    { id: 57636, cityId: 1076, code: "695610" },
    { id: 57637, cityId: 1076, code: "695312" },
    { id: 57638, cityId: 1076, code: "695102" },
    { id: 57639, cityId: 1076, code: "695001" },
    { id: 57640, cityId: 1076, code: "695502" },
    { id: 57641, cityId: 1076, code: "695305" },
    { id: 57642, cityId: 1076, code: "695020" },
    { id: 57643, cityId: 1076, code: "695026" },
    { id: 57644, cityId: 1076, code: "695027" },
    { id: 57645, cityId: 1076, code: "695014" },
    { id: 57646, cityId: 1076, code: "695522" },
    { id: 57647, cityId: 1076, code: "695008" },
    { id: 57648, cityId: 1076, code: "695306" },
    { id: 57649, cityId: 1076, code: "695503" },
    { id: 57650, cityId: 1076, code: "695304" },
    { id: 57651, cityId: 1076, code: "695101" },
    { id: 57652, cityId: 1076, code: "695615" },
    { id: 57653, cityId: 1076, code: "695611" },
    { id: 57654, cityId: 1076, code: "695040" },
    { id: 57655, cityId: 1076, code: "695103" },
    { id: 57656, cityId: 1076, code: "695604" },
    { id: 57657, cityId: 1076, code: "695033" },
    { id: 57658, cityId: 1076, code: "695585" },
    { id: 57659, cityId: 1076, code: "695541" },
    { id: 57660, cityId: 1076, code: "695021" },
    { id: 57661, cityId: 1076, code: "695141" },
    { id: 57662, cityId: 1076, code: "695547" },
    { id: 57663, cityId: 1076, code: "695122" },
    { id: 57664, cityId: 1076, code: "695002" },
    { id: 57665, cityId: 1076, code: "695608" },
    { id: 57666, cityId: 1076, code: "695507" },
    { id: 57667, cityId: 1076, code: "695564" },
    { id: 57668, cityId: 1076, code: "695310" },
    { id: 57669, cityId: 1076, code: "695018" },
    { id: 57670, cityId: 1076, code: "695513" },
    { id: 57671, cityId: 1076, code: "695526" },
    { id: 57672, cityId: 1076, code: "695551" },
    { id: 57673, cityId: 1076, code: "695583" },
    { id: 57674, cityId: 1076, code: "695126" },
    { id: 57675, cityId: 1076, code: "695602" },
    { id: 57676, cityId: 1076, code: "695012" },
    { id: 57677, cityId: 1076, code: "695145" },
    { id: 57678, cityId: 1076, code: "695025" },
    { id: 57679, cityId: 1076, code: "695609" },
    { id: 57680, cityId: 1076, code: "695038" },
    { id: 57681, cityId: 1076, code: "695501" },
    { id: 57682, cityId: 1076, code: "695013" },
    { id: 57683, cityId: 1076, code: "695311" },
    { id: 57684, cityId: 1076, code: "695133" },
    { id: 57685, cityId: 1076, code: "695019" },
    { id: 57686, cityId: 1076, code: "695317" },
    { id: 57687, cityId: 1076, code: "695571" },
    { id: 57688, cityId: 1076, code: "695006" },
    { id: 57689, cityId: 1076, code: "695146" },
    { id: 57690, cityId: 1076, code: "695603" },
    { id: 57691, cityId: 1076, code: "695032" },
    { id: 57692, cityId: 1076, code: "695004" },
    { id: 57693, cityId: 1076, code: "695575" },
    { id: 57694, cityId: 1080, code: "680724" },
    { id: 57695, cityId: 1080, code: "680504" },
    { id: 57696, cityId: 1080, code: "680121" },
    { id: 57697, cityId: 1093, code: "673581" },
    { id: 57698, cityId: 1093, code: "673593" },
    { id: 57699, cityId: 1093, code: "670644" },
    { id: 57700, cityId: 1093, code: "673591" },
    { id: 57701, cityId: 1093, code: "670731" },
    { id: 57702, cityId: 1095, code: "481449" },
    { id: 57703, cityId: 1095, code: "481665" },
    { id: 57704, cityId: 1095, code: "481102" },
    { id: 57705, cityId: 1095, code: "481105" },
    { id: 57706, cityId: 1095, code: "481111" },
    { id: 57707, cityId: 1095, code: "481661" },
    { id: 57708, cityId: 1095, code: "481556" },
    { id: 57709, cityId: 1095, code: "481226" },
    { id: 57710, cityId: 1095, code: "481445" },
    { id: 57711, cityId: 1096, code: "496242" },
    { id: 57712, cityId: 1096, code: "496661" },
    { id: 57713, cityId: 1096, code: "496109" },
    { id: 57714, cityId: 1096, code: "496445" },
    { id: 57715, cityId: 1096, code: "496108" },
    { id: 57716, cityId: 1096, code: "496111" },
    { id: 57717, cityId: 1099, code: "457885" },
    { id: 57718, cityId: 1099, code: "457888" },
    { id: 57719, cityId: 1104, code: "473335" },
    { id: 57720, cityId: 1104, code: "473330" },
    { id: 57721, cityId: 1104, code: "473443" },
    { id: 57722, cityId: 1104, code: "473440" },
    { id: 57723, cityId: 1113, code: "451666" },
    { id: 57724, cityId: 1113, code: "451770" },
    { id: 57725, cityId: 1113, code: "451881" },
    { id: 57726, cityId: 1113, code: "451447" },
    { id: 57727, cityId: 1113, code: "451556" },
    { id: 57728, cityId: 1113, code: "451449" },
    { id: 57729, cityId: 1113, code: "451442" },
    { id: 57730, cityId: 1115, code: "460447" },
    { id: 57731, cityId: 1115, code: "461111" },
    { id: 57732, cityId: 1115, code: "461228" },
    { id: 57733, cityId: 1115, code: "480441" },
    { id: 57734, cityId: 1115, code: "460440" },
    { id: 57735, cityId: 1115, code: "461441" },
    { id: 57736, cityId: 1119, code: "477660" },
    { id: 57737, cityId: 1119, code: "475115" },
    { id: 57738, cityId: 1119, code: "477445" },
    { id: 57739, cityId: 1119, code: "477447" },
    { id: 57740, cityId: 1119, code: "477441" },
    { id: 57741, cityId: 1119, code: "477222" },
    { id: 57742, cityId: 1119, code: "477332" },
    { id: 57743, cityId: 1119, code: "475110" },
    { id: 57744, cityId: 1119, code: "477116" },
    { id: 57745, cityId: 1119, code: "477557" },
    { id: 57746, cityId: 1121, code: "464993" },
    { id: 57747, cityId: 1121, code: "462046" },
    { id: 57748, cityId: 1124, code: "450445" },
    { id: 57749, cityId: 1124, code: "450221" },
    { id: 57750, cityId: 1124, code: "450332" },
    { id: 57751, cityId: 1124, code: "450001" },
    { id: 57752, cityId: 1127, code: "472001" },
    { id: 57753, cityId: 1127, code: "471525" },
    { id: 57754, cityId: 1127, code: "472010" },
    { id: 57755, cityId: 1127, code: "471515" },
    { id: 57756, cityId: 1127, code: "471318" },
    { id: 57757, cityId: 1127, code: "472111" },
    { id: 57758, cityId: 1127, code: "471625" },
    { id: 57759, cityId: 1127, code: "471111" },
    { id: 57760, cityId: 1127, code: "471501" },
    { id: 57761, cityId: 1128, code: "480105" },
    { id: 57762, cityId: 1128, code: "480221" },
    { id: 57763, cityId: 1128, code: "480106" },
    { id: 57764, cityId: 1128, code: "460663" },
    { id: 57765, cityId: 1128, code: "480441" },
    { id: 57766, cityId: 1132, code: "470675" },
    { id: 57767, cityId: 1132, code: "470672" },
    { id: 57768, cityId: 1132, code: "470771" },
    { id: 57769, cityId: 1132, code: "470666" },
    { id: 57770, cityId: 1133, code: "475335" },
    { id: 57771, cityId: 1133, code: "475336" },
    { id: 57772, cityId: 1135, code: "455336" },
    { id: 57773, cityId: 1135, code: "455115" },
    { id: 57774, cityId: 1135, code: "455332" },
    { id: 57775, cityId: 1135, code: "455459" },
    { id: 57776, cityId: 1135, code: "455227" },
    { id: 57777, cityId: 1135, code: "455221" },
    { id: 57778, cityId: 1137, code: "454331" },
    { id: 57779, cityId: 1137, code: "454660" },
    { id: 57780, cityId: 1137, code: "454552" },
    { id: 57781, cityId: 1137, code: "454111" },
    { id: 57782, cityId: 1137, code: "454221" },
    { id: 57783, cityId: 1137, code: "454446" },
    { id: 57784, cityId: 1137, code: "454116" },
    { id: 57785, cityId: 1137, code: "454449" },
    { id: 57786, cityId: 1139, code: "481778" },
    { id: 57787, cityId: 1139, code: "481879" },
    { id: 57788, cityId: 1139, code: "481672" },
    { id: 57789, cityId: 1139, code: "481885" },
    { id: 57790, cityId: 1145, code: "473443" },
    { id: 57791, cityId: 1145, code: "473885" },
    { id: 57792, cityId: 1145, code: "473331" },
    { id: 57793, cityId: 1147, code: "475005" },
    { id: 57794, cityId: 1147, code: "475686" },
    { id: 57795, cityId: 1147, code: "475110" },
    { id: 57796, cityId: 1147, code: "475220" },
    { id: 57797, cityId: 1147, code: "475115" },
    { id: 57798, cityId: 1148, code: "461228" },
    { id: 57799, cityId: 1148, code: "461111" },
    { id: 57800, cityId: 1148, code: "461441" },
    { id: 57801, cityId: 1153, code: "461771" },
    { id: 57802, cityId: 1153, code: "461990" },
    { id: 57803, cityId: 1153, code: "461441" },
    { id: 57804, cityId: 1153, code: "461228" },
    { id: 57805, cityId: 1153, code: "461331" },
    { id: 57806, cityId: 1153, code: "461223" },
    { id: 57807, cityId: 1154, code: "453001" },
    { id: 57808, cityId: 1154, code: "453115" },
    { id: 57809, cityId: 1154, code: "453661" },
    { id: 57810, cityId: 1154, code: "453551" },
    { id: 57811, cityId: 1156, code: "483001" },
    { id: 57812, cityId: 1156, code: "483119" },
    { id: 57813, cityId: 1156, code: "483113" },
    { id: 57814, cityId: 1156, code: "483440" },
    { id: 57815, cityId: 1157, code: "457990" },
    { id: 57816, cityId: 1157, code: "457993" },
    { id: 57817, cityId: 1157, code: "457888" },
    { id: 57818, cityId: 1157, code: "457777" },
    { id: 57819, cityId: 1157, code: "457779" },
    { id: 57820, cityId: 1157, code: "457887" },
    { id: 57821, cityId: 1157, code: "457550" },
    { id: 57822, cityId: 1164, code: "483880" },
    { id: 57823, cityId: 1164, code: "483442" },
    { id: 57824, cityId: 1164, code: "483775" },
    { id: 57825, cityId: 1164, code: "483334" },
    { id: 57826, cityId: 1164, code: "483990" },
    { id: 57827, cityId: 1164, code: "483332" },
    { id: 57828, cityId: 1164, code: "483773" },
    { id: 57829, cityId: 1164, code: "483222" },
    { id: 57830, cityId: 1164, code: "483225" },
    { id: 57831, cityId: 1164, code: "483504" },
    { id: 57832, cityId: 1164, code: "483220" },
    { id: 57833, cityId: 1164, code: "483501" },
    { id: 57834, cityId: 1165, code: "450112" },
    { id: 57835, cityId: 1165, code: "450116" },
    { id: 57836, cityId: 1165, code: "450661" },
    { id: 57837, cityId: 1166, code: "451332" },
    { id: 57838, cityId: 1166, code: "451441" },
    { id: 57839, cityId: 1166, code: "451660" },
    { id: 57840, cityId: 1178, code: "481672" },
    { id: 57841, cityId: 1182, code: "276305" },
    { id: 57842, cityId: 1182, code: "276403" },
    { id: 57843, cityId: 1182, code: "223222" },
    { id: 57844, cityId: 1182, code: "275302" },
    { id: 57845, cityId: 1182, code: "221601" },
    { id: 57846, cityId: 1182, code: "275306" },
    { id: 57847, cityId: 1182, code: "275303" },
    { id: 57848, cityId: 1182, code: "221706" },
    { id: 57849, cityId: 1182, code: "275304" },
    { id: 57850, cityId: 1182, code: "276405" },
    { id: 57851, cityId: 1182, code: "276129" },
    { id: 57852, cityId: 1182, code: "221603" },
    { id: 57853, cityId: 1182, code: "275307" },
    { id: 57854, cityId: 1182, code: "276306" },
    { id: 57855, cityId: 1182, code: "276402" },
    { id: 57856, cityId: 1182, code: "275101" },
    { id: 57857, cityId: 1182, code: "275301" },
    { id: 57858, cityId: 1182, code: "275102" },
    { id: 57859, cityId: 1182, code: "275305" },
    { id: 57860, cityId: 1182, code: "221705" },
    { id: 57861, cityId: 1182, code: "275105" },
    { id: 57862, cityId: 1182, code: "276126" },
    { id: 57863, cityId: 1182, code: "221602" },
    { id: 57864, cityId: 1188, code: "476111" },
    { id: 57865, cityId: 1188, code: "476221" },
    { id: 57866, cityId: 1188, code: "476115" },
    { id: 57867, cityId: 1196, code: "458118" },
    { id: 57868, cityId: 1196, code: "458553" },
    { id: 57869, cityId: 1196, code: "458226" },
    { id: 57870, cityId: 1196, code: "458339" },
    { id: 57871, cityId: 1196, code: "458228" },
    { id: 57872, cityId: 1196, code: "458220" },
    { id: 57873, cityId: 1196, code: "458468" },
    { id: 57874, cityId: 1196, code: "458110" },
    { id: 57875, cityId: 1196, code: "458113" },
    { id: 57876, cityId: 1196, code: "458330" },
    { id: 57877, cityId: 1196, code: "458116" },
    { id: 57878, cityId: 1201, code: "488441" },
    { id: 57879, cityId: 1201, code: "488220" },
    { id: 57880, cityId: 1203, code: "384246" },
    { id: 57881, cityId: 1203, code: "384151" },
    { id: 57882, cityId: 1203, code: "384229" },
    { id: 57883, cityId: 1203, code: "384220" },
    { id: 57884, cityId: 1203, code: "384245" },
    { id: 57885, cityId: 1203, code: "384241" },
    { id: 57886, cityId: 1203, code: "384225" },
    { id: 57887, cityId: 1203, code: "385340" },
    { id: 57888, cityId: 1203, code: "384272" },
    { id: 57889, cityId: 1203, code: "384275" },
    { id: 57890, cityId: 1203, code: "385360" },
    { id: 57891, cityId: 1203, code: "384221" },
    { id: 57892, cityId: 1203, code: "384240" },
    { id: 57893, cityId: 1203, code: "384285" },
    { id: 57894, cityId: 1203, code: "385350" },
    { id: 57895, cityId: 1203, code: "384230" },
    { id: 57896, cityId: 1203, code: "384290" },
    { id: 57897, cityId: 1206, code: "464770" },
    { id: 57898, cityId: 1206, code: "464884" },
    { id: 57899, cityId: 1206, code: "464986" },
    { id: 57900, cityId: 1206, code: "464661" },
    { id: 57901, cityId: 1207, code: "465687" },
    { id: 57902, cityId: 1207, code: "465674" },
    { id: 57903, cityId: 1207, code: "465693" },
    { id: 57904, cityId: 1207, code: "465691" },
    { id: 57905, cityId: 1207, code: "465697" },
    { id: 57906, cityId: 1207, code: "465679" },
    { id: 57907, cityId: 1207, code: "465685" },
    { id: 57908, cityId: 1207, code: "465667" },
    { id: 57909, cityId: 1207, code: "465683" },
    { id: 57910, cityId: 1207, code: "465689" },
    { id: 57911, cityId: 1207, code: "465677" },
    { id: 57912, cityId: 1207, code: "465661" },
    { id: 57913, cityId: 1212, code: "457222" },
    { id: 57914, cityId: 1212, code: "457118" },
    { id: 57915, cityId: 1212, code: "457550" },
    { id: 57916, cityId: 1213, code: "486331" },
    { id: 57917, cityId: 1213, code: "486550" },
    { id: 57918, cityId: 1213, code: "486553" },
    { id: 57919, cityId: 1213, code: "486114" },
    { id: 57920, cityId: 1213, code: "486111" },
    { id: 57921, cityId: 1213, code: "486441" },
    { id: 57922, cityId: 1213, code: "485331" },
    { id: 57923, cityId: 1215, code: "464240" },
    { id: 57924, cityId: 1215, code: "470441" },
    { id: 57925, cityId: 1215, code: "470004" },
    { id: 57926, cityId: 1221, code: "485773" },
    { id: 57927, cityId: 1221, code: "485881" },
    { id: 57928, cityId: 1221, code: "485666" },
    { id: 57929, cityId: 1221, code: "485226" },
    { id: 57930, cityId: 1225, code: "465693" },
    { id: 57931, cityId: 1227, code: "481226" },
    { id: 57932, cityId: 1229, code: "486669" },
    { id: 57933, cityId: 1229, code: "484444" },
    { id: 57934, cityId: 1232, code: "473665" },
    { id: 57935, cityId: 1233, code: "484771" },
    { id: 57936, cityId: 1233, code: "486887" },
    { id: 57937, cityId: 1233, code: "486666" },
    { id: 57938, cityId: 1236, code: "227805" },
    { id: 57939, cityId: 1236, code: "227813" },
    { id: 57940, cityId: 1236, code: "228145" },
    { id: 57941, cityId: 1236, code: "227304" },
    { id: 57942, cityId: 1236, code: "228142" },
    { id: 57943, cityId: 1236, code: "227405" },
    { id: 57944, cityId: 1236, code: "228131" },
    { id: 57945, cityId: 1236, code: "227808" },
    { id: 57946, cityId: 1245, code: "484665" },
    { id: 57947, cityId: 1245, code: "484551" },
    { id: 57948, cityId: 1245, code: "486661" },
    { id: 57949, cityId: 1245, code: "484555" },
    { id: 57950, cityId: 1245, code: "484661" },
    { id: 57951, cityId: 1245, code: "484001" },
    { id: 57952, cityId: 1245, code: "484660" },
    { id: 57953, cityId: 1246, code: "464240" },
    { id: 57954, cityId: 1250, code: "444501" },
    { id: 57955, cityId: 1250, code: "444108" },
    { id: 57956, cityId: 1250, code: "444111" },
    { id: 57957, cityId: 1250, code: "444506" },
    { id: 57958, cityId: 1257, code: "444905" },
    { id: 57959, cityId: 1257, code: "442302" },
    { id: 57960, cityId: 1257, code: "444903" },
    { id: 57961, cityId: 1257, code: "444807" },
    { id: 57962, cityId: 1257, code: "444705" },
    { id: 57963, cityId: 1261, code: "431135" },
    { id: 57964, cityId: 1261, code: "431132" },
    { id: 57965, cityId: 1261, code: "431114" },
    { id: 57966, cityId: 1261, code: "431101" },
    { id: 57967, cityId: 1261, code: "431117" },
    { id: 57968, cityId: 1261, code: "431006" },
    { id: 57969, cityId: 1261, code: "431009" },
    { id: 57970, cityId: 1261, code: "431150" },
    { id: 57971, cityId: 1261, code: "431134" },
    { id: 57972, cityId: 1261, code: "431118" },
    { id: 57973, cityId: 1261, code: "431151" },
    { id: 57974, cityId: 1261, code: "431202" },
    { id: 57975, cityId: 1261, code: "431113" },
    { id: 57976, cityId: 1261, code: "431107" },
    { id: 57977, cityId: 1261, code: "423701" },
    { id: 57978, cityId: 1261, code: "431112" },
    { id: 57979, cityId: 1261, code: "431109" },
    { id: 57980, cityId: 1261, code: "423703" },
    { id: 57981, cityId: 1261, code: "431103" },
    { id: 57982, cityId: 1261, code: "431106" },
    { id: 57983, cityId: 1268, code: "413207" },
    { id: 57984, cityId: 1268, code: "431144" },
    { id: 57985, cityId: 1268, code: "413249" },
    { id: 57986, cityId: 1271, code: "441912" },
    { id: 57987, cityId: 1271, code: "441915" },
    { id: 57988, cityId: 1276, code: "443203" },
    { id: 57989, cityId: 1276, code: "443112" },
    { id: 57990, cityId: 1276, code: "443404" },
    { id: 57991, cityId: 1280, code: "442606" },
    { id: 57992, cityId: 1280, code: "441215" },
    { id: 57993, cityId: 1280, code: "442710" },
    { id: 57994, cityId: 1280, code: "441224" },
    { id: 57995, cityId: 1280, code: "442605" },
    { id: 57996, cityId: 1280, code: "442503" },
    { id: 57997, cityId: 1280, code: "442701" },
    { id: 57998, cityId: 1280, code: "442902" },
    { id: 57999, cityId: 1295, code: "425413" },
    { id: 58000, cityId: 1300, code: "442705" },
    { id: 58001, cityId: 1300, code: "442606" },
    { id: 58002, cityId: 1300, code: "442603" },
    { id: 58003, cityId: 1300, code: "442504" },
    { id: 58004, cityId: 1300, code: "442710" },
    { id: 58005, cityId: 1300, code: "442604" },
    { id: 58006, cityId: 1300, code: "441207" },
    { id: 58007, cityId: 1300, code: "441209" },
    { id: 58008, cityId: 1300, code: "442903" },
    { id: 58009, cityId: 1309, code: "431703" },
    { id: 58010, cityId: 1309, code: "431701" },
    { id: 58011, cityId: 1309, code: "431501" },
    { id: 58012, cityId: 1309, code: "431512" },
    { id: 58013, cityId: 1309, code: "431509" },
    { id: 58014, cityId: 1309, code: "431705" },
    { id: 58015, cityId: 1313, code: "425116" },
    { id: 58016, cityId: 1313, code: "425503" },
    { id: 58017, cityId: 1313, code: "425109" },
    { id: 58018, cityId: 1313, code: "425508" },
    { id: 58019, cityId: 1313, code: "425401" },
    { id: 58020, cityId: 1313, code: "425111" },
    { id: 58021, cityId: 1313, code: "424106" },
    { id: 58022, cityId: 1313, code: "424201" },
    { id: 58023, cityId: 1313, code: "425502" },
    { id: 58024, cityId: 1314, code: "431114" },
    { id: 58025, cityId: 1314, code: "431203" },
    { id: 58026, cityId: 1314, code: "431206" },
    { id: 58027, cityId: 1314, code: "431212" },
    { id: 58028, cityId: 1314, code: "431507" },
    { id: 58029, cityId: 1314, code: "431501" },
    { id: 58030, cityId: 1314, code: "431105" },
    { id: 58031, cityId: 1314, code: "431207" },
    { id: 58032, cityId: 1314, code: "431502" },
    { id: 58033, cityId: 1314, code: "431504" },
    { id: 58034, cityId: 1314, code: "431134" },
    { id: 58035, cityId: 1314, code: "431503" },
    { id: 58036, cityId: 1314, code: "431132" },
    { id: 58037, cityId: 1314, code: "431208" },
    { id: 58038, cityId: 1314, code: "431205" },
    { id: 58039, cityId: 1314, code: "431202" },
    { id: 58040, cityId: 1314, code: "431512" },
    { id: 58041, cityId: 1314, code: "431204" },
    { id: 58042, cityId: 1314, code: "431121" },
    { id: 58043, cityId: 1314, code: "431213" },
    { id: 58044, cityId: 1337, code: "416201" },
    { id: 58045, cityId: 1337, code: "416526" },
    { id: 58046, cityId: 1337, code: "416101" },
    { id: 58047, cityId: 1337, code: "416216" },
    { id: 58048, cityId: 1337, code: "416219" },
    { id: 58049, cityId: 1337, code: "416006" },
    { id: 58050, cityId: 1337, code: "416114" },
    { id: 58051, cityId: 1337, code: "415101" },
    { id: 58052, cityId: 1337, code: "416106" },
    { id: 58053, cityId: 1337, code: "416505" },
    { id: 58054, cityId: 1337, code: "416112" },
    { id: 58055, cityId: 1344, code: "413582" },
    { id: 58056, cityId: 1344, code: "413522" },
    { id: 58057, cityId: 1344, code: "413529" },
    { id: 58058, cityId: 1344, code: "413516" },
    { id: 58059, cityId: 1344, code: "413532" },
    { id: 58060, cityId: 1344, code: "413515" },
    { id: 58061, cityId: 1344, code: "413607" },
    { id: 58062, cityId: 1344, code: "413518" },
    { id: 58063, cityId: 1344, code: "413527" },
    { id: 58064, cityId: 1344, code: "413581" },
    { id: 58065, cityId: 1344, code: "413502" },
    { id: 58066, cityId: 1344, code: "413511" },
    { id: 58067, cityId: 1344, code: "413510" },
    { id: 58068, cityId: 1372, code: "441106" },
    { id: 58069, cityId: 1372, code: "441502" },
    { id: 58070, cityId: 1372, code: "441303" },
    { id: 58071, cityId: 1372, code: "440023" },
    { id: 58072, cityId: 1372, code: "441302" },
    { id: 58073, cityId: 1372, code: "441101" },
    { id: 58074, cityId: 1372, code: "441107" },
    { id: 58075, cityId: 1374, code: "431809" },
    { id: 58076, cityId: 1374, code: "431711" },
    { id: 58077, cityId: 1374, code: "431708" },
    { id: 58078, cityId: 1374, code: "431804" },
    { id: 58079, cityId: 1374, code: "431712" },
    { id: 58080, cityId: 1374, code: "431715" },
    { id: 58081, cityId: 1377, code: "425411" },
    { id: 58082, cityId: 1377, code: "425442" },
    { id: 58083, cityId: 1377, code: "425417" },
    { id: 58084, cityId: 1377, code: "425423" },
    { id: 58085, cityId: 1377, code: "425410" },
    { id: 58086, cityId: 1377, code: "425426" },
    { id: 58087, cityId: 1377, code: "425432" },
    { id: 58088, cityId: 1377, code: "425415" },
    { id: 58089, cityId: 1377, code: "425418" },
    { id: 58090, cityId: 1377, code: "425424" },
    { id: 58091, cityId: 1377, code: "425422" },
    { id: 58092, cityId: 1377, code: "425444" },
    { id: 58093, cityId: 1378, code: "422213" },
    { id: 58094, cityId: 1378, code: "422403" },
    { id: 58095, cityId: 1378, code: "423104" },
    { id: 58096, cityId: 1378, code: "423301" },
    { id: 58097, cityId: 1378, code: "422306" },
    { id: 58098, cityId: 1378, code: "422401" },
    { id: 58099, cityId: 1378, code: "422212" },
    { id: 58100, cityId: 1378, code: "422206" },
    { id: 58101, cityId: 1378, code: "422103" },
    { id: 58102, cityId: 1378, code: "422211" },
    { id: 58103, cityId: 1378, code: "422502" },
    { id: 58104, cityId: 1381, code: "413514" },
    { id: 58105, cityId: 1381, code: "413517" },
    { id: 58106, cityId: 1381, code: "413524" },
    { id: 58107, cityId: 1381, code: "413581" },
    { id: 58108, cityId: 1381, code: "413531" },
    { id: 58109, cityId: 1381, code: "413601" },
    { id: 58110, cityId: 1381, code: "413502" },
    { id: 58111, cityId: 1381, code: "413521" },
    { id: 58112, cityId: 1381, code: "413507" },
    { id: 58113, cityId: 1381, code: "413510" },
    { id: 58114, cityId: 1381, code: "413602" },
    { id: 58115, cityId: 1381, code: "413608" },
    { id: 58116, cityId: 1381, code: "413523" },
    { id: 58117, cityId: 1381, code: "413582" },
    { id: 58118, cityId: 1381, code: "413506" },
    { id: 58119, cityId: 1381, code: "431522" },
    { id: 58120, cityId: 1381, code: "413544" },
    { id: 58121, cityId: 1381, code: "413532" },
    { id: 58122, cityId: 1381, code: "413516" },
    { id: 58123, cityId: 1386, code: "306912" },
    { id: 58124, cityId: 1386, code: "306422" },
    { id: 58125, cityId: 1386, code: "306702" },
    { id: 58126, cityId: 1386, code: "306105" },
    { id: 58127, cityId: 1389, code: "431503" },
    { id: 58128, cityId: 1389, code: "431506" },
    { id: 58129, cityId: 1389, code: "431509" },
    { id: 58130, cityId: 1389, code: "431505" },
    { id: 58131, cityId: 1389, code: "431511" },
    { id: 58132, cityId: 1389, code: "431402" },
    { id: 58133, cityId: 1389, code: "431516" },
    { id: 58134, cityId: 1389, code: "431514" },
    { id: 58135, cityId: 1392, code: "384151" },
    { id: 58136, cityId: 1392, code: "384246" },
    { id: 58137, cityId: 1392, code: "384230" },
    { id: 58138, cityId: 1392, code: "384245" },
    { id: 58139, cityId: 1392, code: "384229" },
    { id: 58140, cityId: 1392, code: "384220" },
    { id: 58141, cityId: 1392, code: "384221" },
    { id: 58142, cityId: 1392, code: "385360" },
    { id: 58143, cityId: 1392, code: "384240" },
    { id: 58144, cityId: 1392, code: "384275" },
    { id: 58145, cityId: 1392, code: "385350" },
    { id: 58146, cityId: 1392, code: "384285" },
    { id: 58147, cityId: 1392, code: "384272" },
    { id: 58148, cityId: 1392, code: "385340" },
    { id: 58149, cityId: 1392, code: "384225" },
    { id: 58150, cityId: 1392, code: "384241" },
    { id: 58151, cityId: 1392, code: "384290" },
    { id: 58152, cityId: 1401, code: "410501" },
    { id: 58153, cityId: 1401, code: "413106" },
    { id: 58154, cityId: 1401, code: "412402" },
    { id: 58155, cityId: 1401, code: "412303" },
    { id: 58156, cityId: 1401, code: "412401" },
    { id: 58157, cityId: 1401, code: "410503" },
    { id: 58158, cityId: 1401, code: "413801" },
    { id: 58159, cityId: 1401, code: "410515" },
    { id: 58160, cityId: 1401, code: "410502" },
    { id: 58161, cityId: 1401, code: "412206" },
    { id: 58162, cityId: 1409, code: "415709" },
    { id: 58163, cityId: 1409, code: "415703" },
    { id: 58164, cityId: 1409, code: "415604" },
    { id: 58165, cityId: 1409, code: "416702" },
    { id: 58166, cityId: 1414, code: "415405" },
    { id: 58167, cityId: 1414, code: "416304" },
    { id: 58168, cityId: 1418, code: "415206" },
    { id: 58169, cityId: 1418, code: "415514" },
    { id: 58170, cityId: 1418, code: "415523" },
    { id: 58171, cityId: 1418, code: "415501" },
    { id: 58172, cityId: 1418, code: "415207" },
    { id: 58173, cityId: 1418, code: "412206" },
    { id: 58174, cityId: 1418, code: "415511" },
    { id: 58175, cityId: 1418, code: "412806" },
    { id: 58176, cityId: 1418, code: "412803" },
    { id: 58177, cityId: 1418, code: "415715" },
    { id: 58178, cityId: 1432, code: "413251" },
    { id: 58179, cityId: 1432, code: "413308" },
    { id: 58180, cityId: 1432, code: "413206" },
    { id: 58181, cityId: 1432, code: "413222" },
    { id: 58182, cityId: 1432, code: "413409" },
    { id: 58183, cityId: 1432, code: "413203" },
    { id: 58184, cityId: 1432, code: "413406" },
    { id: 58185, cityId: 1432, code: "413101" },
    { id: 58186, cityId: 1432, code: "413317" },
    { id: 58187, cityId: 1432, code: "413003" },
    { id: 58188, cityId: 1432, code: "413301" },
    { id: 58189, cityId: 1432, code: "413228" },
    { id: 58190, cityId: 1432, code: "413314" },
    { id: 58191, cityId: 1432, code: "413111" },
    { id: 58192, cityId: 1432, code: "413324" },
    { id: 58193, cityId: 1432, code: "413219" },
    { id: 58194, cityId: 1432, code: "413213" },
    { id: 58195, cityId: 1432, code: "413403" },
    { id: 58196, cityId: 1432, code: "413108" },
    { id: 58197, cityId: 1432, code: "413216" },
    { id: 58198, cityId: 1432, code: "413006" },
    { id: 58199, cityId: 1432, code: "413250" },
    { id: 58200, cityId: 1432, code: "413304" },
    { id: 58201, cityId: 1432, code: "413218" },
    { id: 58202, cityId: 1432, code: "413107" },
    { id: 58203, cityId: 1432, code: "413221" },
    { id: 58204, cityId: 1432, code: "413307" },
    { id: 58205, cityId: 1432, code: "413412" },
    { id: 58206, cityId: 1432, code: "413212" },
    { id: 58207, cityId: 1432, code: "413209" },
    { id: 58208, cityId: 1432, code: "413310" },
    { id: 58209, cityId: 1432, code: "413202" },
    { id: 58210, cityId: 1432, code: "413215" },
    { id: 58211, cityId: 1432, code: "413402" },
    { id: 58212, cityId: 1432, code: "413211" },
    { id: 58213, cityId: 1432, code: "413113" },
    { id: 58214, cityId: 1432, code: "413002" },
    { id: 58215, cityId: 1432, code: "413227" },
    { id: 58216, cityId: 1432, code: "413224" },
    { id: 58217, cityId: 1432, code: "413208" },
    { id: 58218, cityId: 1432, code: "413005" },
    { id: 58219, cityId: 1432, code: "413319" },
    { id: 58220, cityId: 1432, code: "413217" },
    { id: 58221, cityId: 1432, code: "413306" },
    { id: 58222, cityId: 1432, code: "413309" },
    { id: 58223, cityId: 1432, code: "413303" },
    { id: 58224, cityId: 1432, code: "413401" },
    { id: 58225, cityId: 1432, code: "413214" },
    { id: 58226, cityId: 1432, code: "413410" },
    { id: 58227, cityId: 1432, code: "413210" },
    { id: 58228, cityId: 1432, code: "413007" },
    { id: 58229, cityId: 1432, code: "413302" },
    { id: 58230, cityId: 1432, code: "413248" },
    { id: 58231, cityId: 1432, code: "413004" },
    { id: 58232, cityId: 1432, code: "413118" },
    { id: 58233, cityId: 1432, code: "413226" },
    { id: 58234, cityId: 1432, code: "413109" },
    { id: 58235, cityId: 1432, code: "413223" },
    { id: 58236, cityId: 1432, code: "413112" },
    { id: 58237, cityId: 1432, code: "413404" },
    { id: 58238, cityId: 1432, code: "413220" },
    { id: 58239, cityId: 1432, code: "413001" },
    { id: 58240, cityId: 1439, code: "401107" },
    { id: 58241, cityId: 1439, code: "401601" },
    { id: 58242, cityId: 1439, code: "401502" },
    { id: 58243, cityId: 1439, code: "421103" },
    { id: 58244, cityId: 1439, code: "421601" },
    { id: 58245, cityId: 1439, code: "421401" },
    { id: 58246, cityId: 1439, code: "401603" },
    { id: 58247, cityId: 1439, code: "421605" },
    { id: 58248, cityId: 1439, code: "421301" },
    { id: 58249, cityId: 1439, code: "401303" },
    { id: 58250, cityId: 1439, code: "400705" },
    { id: 58251, cityId: 1439, code: "421101" },
    { id: 58252, cityId: 1439, code: "421501" },
    { id: 58253, cityId: 1439, code: "400708" },
    { id: 58254, cityId: 1439, code: "401501" },
    { id: 58255, cityId: 1439, code: "421001" },
    { id: 58256, cityId: 1439, code: "401403" },
    { id: 58257, cityId: 1439, code: "400706" },
    { id: 58258, cityId: 1439, code: "421004" },
    { id: 58259, cityId: 1439, code: "400709" },
    { id: 58260, cityId: 1439, code: "401503" },
    { id: 58261, cityId: 1439, code: "421302" },
    { id: 58262, cityId: 1457, code: "442101" },
    { id: 58263, cityId: 1457, code: "442301" },
    { id: 58264, cityId: 1457, code: "442302" },
    { id: 58265, cityId: 1457, code: "442105" },
    { id: 58266, cityId: 1459, code: "444404" },
    { id: 58267, cityId: 1459, code: "444004" },
    { id: 58268, cityId: 1459, code: "444106" },
    { id: 58269, cityId: 1459, code: "444506" },
    { id: 58270, cityId: 1459, code: "444503" },
    { id: 58271, cityId: 1459, code: "444403" },
    { id: 58272, cityId: 1459, code: "444105" },
    { id: 58273, cityId: 1459, code: "444510" },
    { id: 58274, cityId: 1459, code: "444507" },
    { id: 58275, cityId: 1459, code: "444409" },
    { id: 58276, cityId: 1459, code: "444504" },
    { id: 58277, cityId: 1462, code: "795101" },
    { id: 58278, cityId: 1462, code: "795131" },
    { id: 58279, cityId: 1463, code: "795118" },
    { id: 58280, cityId: 1470, code: "795125" },
    { id: 58281, cityId: 1473, code: "795135" },
    { id: 58282, cityId: 1473, code: "795101" },
    { id: 58283, cityId: 1473, code: "795132" },
    { id: 58284, cityId: 1474, code: "795145" },
    { id: 58285, cityId: 1474, code: "795144" },
    { id: 58286, cityId: 1488, code: "796370" },
    { id: 58287, cityId: 1488, code: "796310" },
    { id: 58288, cityId: 1488, code: "796321" },
    { id: 58289, cityId: 1492, code: "796070" },
    { id: 58290, cityId: 1492, code: "796101" },
    { id: 58291, cityId: 1492, code: "796081" },
    { id: 58292, cityId: 1493, code: "796901" },
    { id: 58293, cityId: 1495, code: "796770" },
    { id: 58294, cityId: 1495, code: "796751" },
    { id: 58295, cityId: 1495, code: "796730" },
    { id: 58296, cityId: 1495, code: "796571" },
    { id: 58297, cityId: 1495, code: "796710" },
    { id: 58298, cityId: 1495, code: "796691" },
    { id: 58299, cityId: 1497, code: "796901" },
    { id: 58300, cityId: 1500, code: "796370" },
    { id: 58301, cityId: 1504, code: "798622" },
    { id: 58302, cityId: 1507, code: "797103" },
    { id: 58303, cityId: 1507, code: "797106" },
    { id: 58304, cityId: 1516, code: "767065" },
    { id: 58305, cityId: 1516, code: "767046" },
    { id: 58306, cityId: 1516, code: "767027" },
    { id: 58307, cityId: 1516, code: "767033" },
    { id: 58308, cityId: 1516, code: "767020" },
    { id: 58309, cityId: 1516, code: "767021" },
    { id: 58310, cityId: 1516, code: "767039" },
    { id: 58311, cityId: 1516, code: "767002" },
    { id: 58312, cityId: 1516, code: "767040" },
    { id: 58313, cityId: 1516, code: "767026" },
    { id: 58314, cityId: 1516, code: "767032" },
    { id: 58315, cityId: 1516, code: "767038" },
    { id: 58316, cityId: 1516, code: "767025" },
    { id: 58317, cityId: 1516, code: "767016" },
    { id: 58318, cityId: 1516, code: "767037" },
    { id: 58319, cityId: 1516, code: "767024" },
    { id: 58320, cityId: 1516, code: "767068" },
    { id: 58321, cityId: 1516, code: "767030" },
    { id: 58322, cityId: 1516, code: "767035" },
    { id: 58323, cityId: 1516, code: "767041" },
    { id: 58324, cityId: 1516, code: "767028" },
    { id: 58325, cityId: 1516, code: "767022" },
    { id: 58326, cityId: 1516, code: "767066" },
    { id: 58327, cityId: 1516, code: "767067" },
    { id: 58328, cityId: 1516, code: "767048" },
    { id: 58329, cityId: 1516, code: "767023" },
    { id: 58330, cityId: 1516, code: "767042" },
    { id: 58331, cityId: 1516, code: "767029" },
    { id: 58332, cityId: 1516, code: "767061" },
    { id: 58333, cityId: 1522, code: "768031" },
    { id: 58334, cityId: 1522, code: "768037" },
    { id: 58335, cityId: 1522, code: "768030" },
    { id: 58336, cityId: 1522, code: "768049" },
    { id: 58337, cityId: 1522, code: "768048" },
    { id: 58338, cityId: 1522, code: "768115" },
    { id: 58339, cityId: 1522, code: "768038" },
    { id: 58340, cityId: 1522, code: "768032" },
    { id: 58341, cityId: 1522, code: "768103" },
    { id: 58342, cityId: 1522, code: "768033" },
    { id: 58343, cityId: 1522, code: "768027" },
    { id: 58344, cityId: 1522, code: "768052" },
    { id: 58345, cityId: 1522, code: "768104" },
    { id: 58346, cityId: 1522, code: "768034" },
    { id: 58347, cityId: 1522, code: "768028" },
    { id: 58348, cityId: 1522, code: "768040" },
    { id: 58349, cityId: 1522, code: "768029" },
    { id: 58350, cityId: 1522, code: "768036" },
    { id: 58351, cityId: 1522, code: "768035" },
    { id: 58352, cityId: 1522, code: "768111" },
    { id: 58353, cityId: 1522, code: "768102" },
    { id: 58354, cityId: 1522, code: "768045" },
    { id: 58355, cityId: 1527, code: "756112" },
    { id: 58356, cityId: 1527, code: "756163" },
    { id: 58357, cityId: 1527, code: "756123" },
    { id: 58358, cityId: 1527, code: "756129" },
    { id: 58359, cityId: 1527, code: "756116" },
    { id: 58360, cityId: 1527, code: "756167" },
    { id: 58361, cityId: 1527, code: "756122" },
    { id: 58362, cityId: 1527, code: "756128" },
    { id: 58363, cityId: 1527, code: "756135" },
    { id: 58364, cityId: 1527, code: "756120" },
    { id: 58365, cityId: 1527, code: "756114" },
    { id: 58366, cityId: 1527, code: "756101" },
    { id: 58367, cityId: 1527, code: "756127" },
    { id: 58368, cityId: 1527, code: "756165" },
    { id: 58369, cityId: 1527, code: "756133" },
    { id: 58370, cityId: 1527, code: "756139" },
    { id: 58371, cityId: 1527, code: "756121" },
    { id: 58372, cityId: 1527, code: "756115" },
    { id: 58373, cityId: 1527, code: "756113" },
    { id: 58374, cityId: 1527, code: "756125" },
    { id: 58375, cityId: 1527, code: "756131" },
    { id: 58376, cityId: 1527, code: "756132" },
    { id: 58377, cityId: 1527, code: "756144" },
    { id: 58378, cityId: 1527, code: "756138" },
    { id: 58379, cityId: 1527, code: "756181" },
    { id: 58380, cityId: 1527, code: "756124" },
    { id: 58381, cityId: 1527, code: "756162" },
    { id: 58382, cityId: 1527, code: "756137" },
    { id: 58383, cityId: 1527, code: "756111" },
    { id: 58384, cityId: 1527, code: "756168" },
    { id: 58385, cityId: 1527, code: "756117" },
    { id: 58386, cityId: 1527, code: "756130" },
    { id: 58387, cityId: 1536, code: "754004" },
    { id: 58388, cityId: 1536, code: "754023" },
    { id: 58389, cityId: 1536, code: "754035" },
    { id: 58390, cityId: 1536, code: "754113" },
    { id: 58391, cityId: 1536, code: "752120" },
    { id: 58392, cityId: 1538, code: "768228" },
    { id: 58393, cityId: 1538, code: "768119" },
    { id: 58394, cityId: 1538, code: "768107" },
    { id: 58395, cityId: 1538, code: "768121" },
    { id: 58396, cityId: 1538, code: "768108" },
    { id: 58397, cityId: 1539, code: "759146" },
    { id: 58398, cityId: 1539, code: "759023" },
    { id: 58399, cityId: 1539, code: "759017" },
    { id: 58400, cityId: 1539, code: "759015" },
    { id: 58401, cityId: 1541, code: "761003" },
    { id: 58402, cityId: 1541, code: "760007" },
    { id: 58403, cityId: 1541, code: "761117" },
    { id: 58404, cityId: 1541, code: "761018" },
    { id: 58405, cityId: 1541, code: "761132" },
    { id: 58406, cityId: 1541, code: "761107" },
    { id: 58407, cityId: 1541, code: "760009" },
    { id: 58408, cityId: 1541, code: "761005" },
    { id: 58409, cityId: 1541, code: "760003" },
    { id: 58410, cityId: 1541, code: "761151" },
    { id: 58411, cityId: 1541, code: "761031" },
    { id: 58412, cityId: 1541, code: "761125" },
    { id: 58413, cityId: 1541, code: "761017" },
    { id: 58414, cityId: 1541, code: "761030" },
    { id: 58415, cityId: 1541, code: "761011" },
    { id: 58416, cityId: 1541, code: "761131" },
    { id: 58417, cityId: 1541, code: "761055" },
    { id: 58418, cityId: 1541, code: "761119" },
    { id: 58419, cityId: 1541, code: "761144" },
    { id: 58420, cityId: 1541, code: "760002" },
    { id: 58421, cityId: 1541, code: "761037" },
    { id: 58422, cityId: 1541, code: "761043" },
    { id: 58423, cityId: 1541, code: "761126" },
    { id: 58424, cityId: 1541, code: "761012" },
    { id: 58425, cityId: 1541, code: "761124" },
    { id: 58426, cityId: 1541, code: "761004" },
    { id: 58427, cityId: 1541, code: "761118" },
    { id: 58428, cityId: 1541, code: "761103" },
    { id: 58429, cityId: 1541, code: "761020" },
    { id: 58430, cityId: 1541, code: "761105" },
    { id: 58431, cityId: 1541, code: "761029" },
    { id: 58432, cityId: 1541, code: "761042" },
    { id: 58433, cityId: 1541, code: "760008" },
    { id: 58434, cityId: 1541, code: "761010" },
    { id: 58435, cityId: 1541, code: "761054" },
    { id: 58436, cityId: 1541, code: "761028" },
    { id: 58437, cityId: 1541, code: "761009" },
    { id: 58438, cityId: 1541, code: "761111" },
    { id: 58439, cityId: 1541, code: "761041" },
    { id: 58440, cityId: 1541, code: "761035" },
    { id: 58441, cityId: 1541, code: "760001" },
    { id: 58442, cityId: 1541, code: "761143" },
    { id: 58443, cityId: 1541, code: "761140" },
    { id: 58444, cityId: 1541, code: "761045" },
    { id: 58445, cityId: 1541, code: "761032" },
    { id: 58446, cityId: 1541, code: "761108" },
    { id: 58447, cityId: 1541, code: "761102" },
    { id: 58448, cityId: 1541, code: "761007" },
    { id: 58449, cityId: 1541, code: "761115" },
    { id: 58450, cityId: 1541, code: "761121" },
    { id: 58451, cityId: 1541, code: "761013" },
    { id: 58452, cityId: 1541, code: "761019" },
    { id: 58453, cityId: 1541, code: "761133" },
    { id: 58454, cityId: 1541, code: "761209" },
    { id: 58455, cityId: 1541, code: "761101" },
    { id: 58456, cityId: 1541, code: "761114" },
    { id: 58457, cityId: 1541, code: "761025" },
    { id: 58458, cityId: 1541, code: "760010" },
    { id: 58459, cityId: 1541, code: "761120" },
    { id: 58460, cityId: 1541, code: "761006" },
    { id: 58461, cityId: 1541, code: "761122" },
    { id: 58462, cityId: 1541, code: "761008" },
    { id: 58463, cityId: 1541, code: "761109" },
    { id: 58464, cityId: 1541, code: "761014" },
    { id: 58465, cityId: 1541, code: "761052" },
    { id: 58466, cityId: 1541, code: "761027" },
    { id: 58467, cityId: 1541, code: "760005" },
    { id: 58468, cityId: 1541, code: "761141" },
    { id: 58469, cityId: 1541, code: "761001" },
    { id: 58470, cityId: 1541, code: "761104" },
    { id: 58471, cityId: 1541, code: "760004" },
    { id: 58472, cityId: 1541, code: "761002" },
    { id: 58473, cityId: 1541, code: "761116" },
    { id: 58474, cityId: 1541, code: "761110" },
    { id: 58475, cityId: 1541, code: "761123" },
    { id: 58476, cityId: 1541, code: "760006" },
    { id: 58477, cityId: 1541, code: "761106" },
    { id: 58478, cityId: 1547, code: "754159" },
    { id: 58479, cityId: 1547, code: "754136" },
    { id: 58480, cityId: 1547, code: "754111" },
    { id: 58481, cityId: 1547, code: "754130" },
    { id: 58482, cityId: 1547, code: "754143" },
    { id: 58483, cityId: 1547, code: "754137" },
    { id: 58484, cityId: 1547, code: "754104" },
    { id: 58485, cityId: 1547, code: "754110" },
    { id: 58486, cityId: 1547, code: "754103" },
    { id: 58487, cityId: 1547, code: "754160" },
    { id: 58488, cityId: 1547, code: "754135" },
    { id: 58489, cityId: 1547, code: "754119" },
    { id: 58490, cityId: 1547, code: "754107" },
    { id: 58491, cityId: 1547, code: "754132" },
    { id: 58492, cityId: 1547, code: "754162" },
    { id: 58493, cityId: 1547, code: "754106" },
    { id: 58494, cityId: 1547, code: "754139" },
    { id: 58495, cityId: 1547, code: "754140" },
    { id: 58496, cityId: 1547, code: "754134" },
    { id: 58497, cityId: 1547, code: "754108" },
    { id: 58498, cityId: 1551, code: "768203" },
    { id: 58499, cityId: 1551, code: "768215" },
    { id: 58500, cityId: 1551, code: "768226" },
    { id: 58501, cityId: 1551, code: "768220" },
    { id: 58502, cityId: 1551, code: "768204" },
    { id: 58503, cityId: 1551, code: "768216" },
    { id: 58504, cityId: 1551, code: "768217" },
    { id: 58505, cityId: 1551, code: "768211" },
    { id: 58506, cityId: 1551, code: "768225" },
    { id: 58507, cityId: 1551, code: "768219" },
    { id: 58508, cityId: 1551, code: "768218" },
    { id: 58509, cityId: 1555, code: "766026" },
    { id: 58510, cityId: 1555, code: "766014" },
    { id: 58511, cityId: 1556, code: "762020" },
    { id: 58512, cityId: 1556, code: "762101" },
    { id: 58513, cityId: 1556, code: "762012" },
    { id: 58514, cityId: 1556, code: "762112" },
    { id: 58515, cityId: 1560, code: "754231" },
    { id: 58516, cityId: 1560, code: "754212" },
    { id: 58517, cityId: 1560, code: "754250" },
    { id: 58518, cityId: 1560, code: "754224" },
    { id: 58519, cityId: 1560, code: "754213" },
    { id: 58520, cityId: 1560, code: "754244" },
    { id: 58521, cityId: 1560, code: "754219" },
    { id: 58522, cityId: 1560, code: "754162" },
    { id: 58523, cityId: 1560, code: "754289" },
    { id: 58524, cityId: 1560, code: "754217" },
    { id: 58525, cityId: 1560, code: "754223" },
    { id: 58526, cityId: 1560, code: "754141" },
    { id: 58527, cityId: 1560, code: "754134" },
    { id: 58528, cityId: 1560, code: "754153" },
    { id: 58529, cityId: 1560, code: "755061" },
    { id: 58530, cityId: 1560, code: "754211" },
    { id: 58531, cityId: 1560, code: "754227" },
    { id: 58532, cityId: 1560, code: "754253" },
    { id: 58533, cityId: 1560, code: "754228" },
    { id: 58534, cityId: 1560, code: "754215" },
    { id: 58535, cityId: 1560, code: "754248" },
    { id: 58536, cityId: 1560, code: "754222" },
    { id: 58537, cityId: 1560, code: "754216" },
    { id: 58538, cityId: 1560, code: "754203" },
    { id: 58539, cityId: 1560, code: "754210" },
    { id: 58540, cityId: 1560, code: "754214" },
    { id: 58541, cityId: 1560, code: "754245" },
    { id: 58542, cityId: 1560, code: "754239" },
    { id: 58543, cityId: 1560, code: "754246" },
    { id: 58544, cityId: 1561, code: "758031" },
    { id: 58545, cityId: 1561, code: "756121" },
    { id: 58546, cityId: 1561, code: "758076" },
    { id: 58547, cityId: 1561, code: "758044" },
    { id: 58548, cityId: 1561, code: "758014" },
    { id: 58549, cityId: 1561, code: "758020" },
    { id: 58550, cityId: 1561, code: "755019" },
    { id: 58551, cityId: 1561, code: "758021" },
    { id: 58552, cityId: 1561, code: "758028" },
    { id: 58553, cityId: 1561, code: "758041" },
    { id: 58554, cityId: 1561, code: "758017" },
    { id: 58555, cityId: 1561, code: "758034" },
    { id: 58556, cityId: 1566, code: "764058" },
    { id: 58557, cityId: 1566, code: "764027" },
    { id: 58558, cityId: 1566, code: "764036" },
    { id: 58559, cityId: 1566, code: "763008" },
    { id: 58560, cityId: 1566, code: "764055" },
    { id: 58561, cityId: 1569, code: "764046" },
    { id: 58562, cityId: 1569, code: "764047" },
    { id: 58563, cityId: 1569, code: "764041" },
    { id: 58564, cityId: 1569, code: "764052" },
    { id: 58565, cityId: 1569, code: "764051" },
    { id: 58566, cityId: 1569, code: "764043" },
    { id: 58567, cityId: 1569, code: "764044" },
    { id: 58568, cityId: 1571, code: "764077" },
    { id: 58569, cityId: 1571, code: "764073" },
    { id: 58570, cityId: 1571, code: "764059" },
    { id: 58571, cityId: 1571, code: "764085" },
    { id: 58572, cityId: 1571, code: "764072" },
    { id: 58573, cityId: 1571, code: "765017" },
    { id: 58574, cityId: 1571, code: "764049" },
    { id: 58575, cityId: 1571, code: "764055" },
    { id: 58576, cityId: 1571, code: "764063" },
    { id: 58577, cityId: 1571, code: "764070" },
    { id: 58578, cityId: 1571, code: "764078" },
    { id: 58579, cityId: 1573, code: "752080" },
    { id: 58580, cityId: 1573, code: "752094" },
    { id: 58581, cityId: 1573, code: "752024" },
    { id: 58582, cityId: 1573, code: "752081" },
    { id: 58583, cityId: 1573, code: "752068" },
    { id: 58584, cityId: 1573, code: "752082" },
    { id: 58585, cityId: 1573, code: "752025" },
    { id: 58586, cityId: 1573, code: "752089" },
    { id: 58587, cityId: 1573, code: "752063" },
    { id: 58588, cityId: 1573, code: "752077" },
    { id: 58589, cityId: 1573, code: "752026" },
    { id: 58590, cityId: 1573, code: "752084" },
    { id: 58591, cityId: 1573, code: "752083" },
    { id: 58592, cityId: 1573, code: "752090" },
    { id: 58593, cityId: 1573, code: "752085" },
    { id: 58594, cityId: 1573, code: "752091" },
    { id: 58595, cityId: 1573, code: "752078" },
    { id: 58596, cityId: 1573, code: "752079" },
    { id: 58597, cityId: 1573, code: "752093" },
    { id: 58598, cityId: 1573, code: "752092" },
    { id: 58599, cityId: 1582, code: "752111" },
    { id: 58600, cityId: 1582, code: "752013" },
    { id: 58601, cityId: 1582, code: "752107" },
    { id: 58602, cityId: 1582, code: "752105" },
    { id: 58603, cityId: 1582, code: "752030" },
    { id: 58604, cityId: 1586, code: "764062" },
    { id: 58605, cityId: 1586, code: "765026" },
    { id: 58606, cityId: 1586, code: "765001" },
    { id: 58607, cityId: 1586, code: "765020" },
    { id: 58608, cityId: 1586, code: "765013" },
    { id: 58609, cityId: 1586, code: "765025" },
    { id: 58610, cityId: 1586, code: "765019" },
    { id: 58611, cityId: 1586, code: "765018" },
    { id: 58612, cityId: 1586, code: "765022" },
    { id: 58613, cityId: 1586, code: "765016" },
    { id: 58614, cityId: 1586, code: "765017" },
    { id: 58615, cityId: 1586, code: "764059" },
    { id: 58616, cityId: 1586, code: "765002" },
    { id: 58617, cityId: 1586, code: "765021" },
    { id: 58618, cityId: 1588, code: "768212" },
    { id: 58619, cityId: 1589, code: "767068" },
    { id: 58620, cityId: 1589, code: "767017" },
    { id: 58621, cityId: 1589, code: "767062" },
    { id: 58622, cityId: 1589, code: "767018" },
    { id: 58623, cityId: 1589, code: "767016" },
    { id: 58624, cityId: 1589, code: "767023" },
    { id: 58625, cityId: 1589, code: "767020" },
    { id: 58626, cityId: 1589, code: "767045" },
    { id: 58627, cityId: 1589, code: "767019" },
    { id: 58628, cityId: 1594, code: "609603" },
    { id: 58629, cityId: 1594, code: "609604" },
    { id: 58630, cityId: 1596, code: "605111" },
    { id: 58631, cityId: 1596, code: "605104" },
    { id: 58632, cityId: 1596, code: "605105" },
    { id: 58633, cityId: 1596, code: "605502" },
    { id: 58634, cityId: 1596, code: "605102" },
    { id: 58635, cityId: 1596, code: "533464" },
    { id: 58636, cityId: 1596, code: "605107" },
    { id: 58637, cityId: 1596, code: "605101" },
    { id: 58638, cityId: 1596, code: "673310" },
    { id: 58639, cityId: 1604, code: "143303" },
    { id: 58640, cityId: 1604, code: "143409" },
    { id: 58641, cityId: 1604, code: "143601" },
    { id: 58642, cityId: 1604, code: "143102" },
    { id: 58643, cityId: 1604, code: "143416" },
    { id: 58644, cityId: 1604, code: "143114" },
    { id: 58645, cityId: 1604, code: "143419" },
    { id: 58646, cityId: 1604, code: "143009" },
    { id: 58647, cityId: 1609, code: "148104" },
    { id: 58648, cityId: 1609, code: "148025" },
    { id: 58649, cityId: 1609, code: "148109" },
    { id: 58650, cityId: 1609, code: "148106" },
    { id: 58651, cityId: 1609, code: "148103" },
    { id: 58652, cityId: 1609, code: "148105" },
    { id: 58653, cityId: 1609, code: "148102" },
    { id: 58654, cityId: 1609, code: "148107" },
    { id: 58655, cityId: 1609, code: "148024" },
    { id: 58656, cityId: 1609, code: "148108" },
    { id: 58657, cityId: 1627, code: "151207" },
    { id: 58658, cityId: 1627, code: "152025" },
    { id: 58659, cityId: 1627, code: "151202" },
    { id: 58660, cityId: 1629, code: "147203" },
    { id: 58661, cityId: 1629, code: "140417" },
    { id: 58662, cityId: 1629, code: "140406" },
    { id: 58663, cityId: 1629, code: "141421" },
    { id: 58664, cityId: 1629, code: "140407" },
    { id: 58665, cityId: 1629, code: "147301" },
    { id: 58666, cityId: 1629, code: "141801" },
    { id: 58667, cityId: 1629, code: "140602" },
    { id: 58668, cityId: 1629, code: "140405" },
    { id: 58669, cityId: 1635, code: "143532" },
    { id: 58670, cityId: 1635, code: "143516" },
    { id: 58671, cityId: 1635, code: "145101" },
    { id: 58672, cityId: 1635, code: "145023" },
    { id: 58673, cityId: 1635, code: "143602" },
    { id: 58674, cityId: 1635, code: "143506" },
    { id: 58675, cityId: 1635, code: "145024" },
    { id: 58676, cityId: 1635, code: "143512" },
    { id: 58677, cityId: 1635, code: "143604" },
    { id: 58678, cityId: 1638, code: "144221" },
    { id: 58679, cityId: 1638, code: "144208" },
    { id: 58680, cityId: 1638, code: "146105" },
    { id: 58681, cityId: 1641, code: "144033" },
    { id: 58682, cityId: 1641, code: "144301" },
    { id: 58683, cityId: 1641, code: "144623" },
    { id: 58684, cityId: 1641, code: "144403" },
    { id: 58685, cityId: 1641, code: "144701" },
    { id: 58686, cityId: 1641, code: "144633" },
    { id: 58687, cityId: 1641, code: "144801" },
    { id: 58688, cityId: 1641, code: "144806" },
    { id: 58689, cityId: 1641, code: "144029" },
    { id: 58690, cityId: 1641, code: "144405" },
    { id: 58691, cityId: 1641, code: "144630" },
    { id: 58692, cityId: 1641, code: "144703" },
    { id: 58693, cityId: 1641, code: "144032" },
    { id: 58694, cityId: 1641, code: "144502" },
    { id: 58695, cityId: 1641, code: "144702" },
    { id: 58696, cityId: 1641, code: "144402" },
    { id: 58697, cityId: 1641, code: "144629" },
    { id: 58698, cityId: 1641, code: "144407" },
    { id: 58699, cityId: 1644, code: "144621" },
    { id: 58700, cityId: 1644, code: "144032" },
    { id: 58701, cityId: 1644, code: "144804" },
    { id: 58702, cityId: 1644, code: "144033" },
    { id: 58703, cityId: 1644, code: "144702" },
    { id: 58704, cityId: 1651, code: "141411" },
    { id: 58705, cityId: 1651, code: "141416" },
    { id: 58706, cityId: 1651, code: "148107" },
    { id: 58707, cityId: 1651, code: "141115" },
    { id: 58708, cityId: 1651, code: "142026" },
    { id: 58709, cityId: 1651, code: "141114" },
    { id: 58710, cityId: 1651, code: "141109" },
    { id: 58711, cityId: 1658, code: "151501" },
    { id: 58712, cityId: 1658, code: "151509" },
    { id: 58713, cityId: 1658, code: "151504" },
    { id: 58714, cityId: 1658, code: "151507" },
    { id: 58715, cityId: 1658, code: "151502" },
    { id: 58716, cityId: 1658, code: "151510" },
    { id: 58717, cityId: 1658, code: "151508" },
    { id: 58718, cityId: 1658, code: "151506" },
    { id: 58719, cityId: 1658, code: "151503" },
    { id: 58720, cityId: 1660, code: "142055" },
    { id: 58721, cityId: 1660, code: "142039" },
    { id: 58722, cityId: 1660, code: "152028" },
    { id: 58723, cityId: 1660, code: "142053" },
    { id: 58724, cityId: 1660, code: "142058" },
    { id: 58725, cityId: 1660, code: "142042" },
    { id: 58726, cityId: 1660, code: "142043" },
    { id: 58727, cityId: 1660, code: "142056" },
    { id: 58728, cityId: 1660, code: "142037" },
    { id: 58729, cityId: 1660, code: "142048" },
    { id: 58730, cityId: 1660, code: "142011" },
    { id: 58731, cityId: 1660, code: "151208" },
    { id: 58732, cityId: 1660, code: "142040" },
    { id: 58733, cityId: 1660, code: "142057" },
    { id: 58734, cityId: 1660, code: "142049" },
    { id: 58735, cityId: 1660, code: "142046" },
    { id: 58736, cityId: 1660, code: "142054" },
    { id: 58737, cityId: 1663, code: "152113" },
    { id: 58738, cityId: 1663, code: "152032" },
    { id: 58739, cityId: 1663, code: "152022" },
    { id: 58740, cityId: 1663, code: "152114" },
    { id: 58741, cityId: 1663, code: "151210" },
    { id: 58742, cityId: 1663, code: "152025" },
    { id: 58743, cityId: 1663, code: "151202" },
    { id: 58744, cityId: 1663, code: "152101" },
    { id: 58745, cityId: 1663, code: "152115" },
    { id: 58746, cityId: 1663, code: "152112" },
    { id: 58747, cityId: 1663, code: "152107" },
    { id: 58748, cityId: 1663, code: "152031" },
    { id: 58749, cityId: 1667, code: "144512" },
    { id: 58750, cityId: 1667, code: "144504" },
    { id: 58751, cityId: 1667, code: "144415" },
    { id: 58752, cityId: 1667, code: "144507" },
    { id: 58753, cityId: 1667, code: "144518" },
    { id: 58754, cityId: 1667, code: "144526" },
    { id: 58755, cityId: 1667, code: "144417" },
    { id: 58756, cityId: 1667, code: "144509" },
    { id: 58757, cityId: 1667, code: "144515" },
    { id: 58758, cityId: 1667, code: "144506" },
    { id: 58759, cityId: 1667, code: "144517" },
    { id: 58760, cityId: 1667, code: "144422" },
    { id: 58761, cityId: 1667, code: "144522" },
    { id: 58762, cityId: 1667, code: "144511" },
    { id: 58763, cityId: 1667, code: "144503" },
    { id: 58764, cityId: 1667, code: "144525" },
    { id: 58765, cityId: 1667, code: "144224" },
    { id: 58766, cityId: 1667, code: "146115" },
    { id: 58767, cityId: 1667, code: "144508" },
    { id: 58768, cityId: 1667, code: "144527" },
    { id: 58769, cityId: 1667, code: "144532" },
    { id: 58770, cityId: 1667, code: "144524" },
    { id: 58771, cityId: 1667, code: "144516" },
    { id: 58772, cityId: 1667, code: "144029" },
    { id: 58773, cityId: 1667, code: "144521" },
    { id: 58774, cityId: 1667, code: "144502" },
    { id: 58775, cityId: 1667, code: "144421" },
    { id: 58776, cityId: 1667, code: "144513" },
    { id: 58777, cityId: 1667, code: "144510" },
    { id: 58778, cityId: 1668, code: "145023" },
    { id: 58779, cityId: 1668, code: "143534" },
    { id: 58780, cityId: 1668, code: "145101" },
    { id: 58781, cityId: 1668, code: "145029" },
    { id: 58782, cityId: 1668, code: "145026" },
    { id: 58783, cityId: 1668, code: "145027" },
    { id: 58784, cityId: 1668, code: "145024" },
    { id: 58785, cityId: 1668, code: "143533" },
    { id: 58786, cityId: 1668, code: "145022" },
    { id: 58787, cityId: 1668, code: "145025" },
    { id: 58788, cityId: 1669, code: "140603" },
    { id: 58789, cityId: 1669, code: "147101" },
    { id: 58790, cityId: 1669, code: "140702" },
    { id: 58791, cityId: 1669, code: "141411" },
    { id: 58792, cityId: 1669, code: "140802" },
    { id: 58793, cityId: 1669, code: "141801" },
    { id: 58794, cityId: 1669, code: "140201" },
    { id: 58795, cityId: 1669, code: "147102" },
    { id: 58796, cityId: 1669, code: "140412" },
    { id: 58797, cityId: 1669, code: "147203" },
    { id: 58798, cityId: 1669, code: "147103" },
    { id: 58799, cityId: 1680, code: "160055" },
    { id: 58800, cityId: 1680, code: "140603" },
    { id: 58801, cityId: 1680, code: "140901" },
    { id: 58802, cityId: 1680, code: "140133" },
    { id: 58803, cityId: 1680, code: "140103" },
    { id: 58804, cityId: 1680, code: "140301" },
    { id: 58805, cityId: 1680, code: "140125" },
    { id: 58806, cityId: 1680, code: "160059" },
    { id: 58807, cityId: 1680, code: "140101" },
    { id: 58808, cityId: 1680, code: "160014" },
    { id: 58809, cityId: 1680, code: "140602" },
    { id: 58810, cityId: 1685, code: "148035" },
    { id: 58811, cityId: 1685, code: "148021" },
    { id: 58812, cityId: 1685, code: "148029" },
    { id: 58813, cityId: 1685, code: "148102" },
    { id: 58814, cityId: 1685, code: "148026" },
    { id: 58815, cityId: 1685, code: "148031" },
    { id: 58816, cityId: 1685, code: "148028" },
    { id: 58817, cityId: 1685, code: "148106" },
    { id: 58818, cityId: 1685, code: "148033" },
    { id: 58819, cityId: 1694, code: "305022" },
    { id: 58820, cityId: 1694, code: "305403" },
    { id: 58821, cityId: 1696, code: "301404" },
    { id: 58822, cityId: 1696, code: "321633" },
    { id: 58823, cityId: 1696, code: "301411" },
    { id: 58824, cityId: 1696, code: "301405" },
    { id: 58825, cityId: 1696, code: "321606" },
    { id: 58826, cityId: 1704, code: "327801" },
    { id: 58827, cityId: 1705, code: "325219" },
    { id: 58828, cityId: 1705, code: "325218" },
    { id: 58829, cityId: 1705, code: "325221" },
    { id: 58830, cityId: 1705, code: "325202" },
    { id: 58831, cityId: 1705, code: "325206" },
    { id: 58832, cityId: 1705, code: "325216" },
    { id: 58833, cityId: 1705, code: "325205" },
    { id: 58834, cityId: 1705, code: "325207" },
    { id: 58835, cityId: 1705, code: "325223" },
    { id: 58836, cityId: 1705, code: "325220" },
    { id: 58837, cityId: 1707, code: "344703" },
    { id: 58838, cityId: 1707, code: "344022" },
    { id: 58839, cityId: 1711, code: "321028" },
    { id: 58840, cityId: 1711, code: "321602" },
    { id: 58841, cityId: 1711, code: "321408" },
    { id: 58842, cityId: 1711, code: "321206" },
    { id: 58843, cityId: 1713, code: "311301" },
    { id: 58844, cityId: 1713, code: "311404" },
    { id: 58845, cityId: 1713, code: "311021" },
    { id: 58846, cityId: 1713, code: "311604" },
    { id: 58847, cityId: 1717, code: "331801" },
    { id: 58848, cityId: 1717, code: "331811" },
    { id: 58849, cityId: 1720, code: "323615" },
    { id: 58850, cityId: 1720, code: "323603" },
    { id: 58851, cityId: 1720, code: "323302" },
    { id: 58852, cityId: 1720, code: "323602" },
    { id: 58853, cityId: 1720, code: "323601" },
    { id: 58854, cityId: 1727, code: "312601" },
    { id: 58855, cityId: 1727, code: "312620" },
    { id: 58856, cityId: 1727, code: "312403" },
    { id: 58857, cityId: 1727, code: "312604" },
    { id: 58858, cityId: 1727, code: "312023" },
    { id: 58859, cityId: 1727, code: "312617" },
    { id: 58860, cityId: 1727, code: "312203" },
    { id: 58861, cityId: 1727, code: "326501" },
    { id: 58862, cityId: 1727, code: "312202" },
    { id: 58863, cityId: 1729, code: "331021" },
    { id: 58864, cityId: 1729, code: "331501" },
    { id: 58865, cityId: 1729, code: "331304" },
    { id: 58866, cityId: 1729, code: "331802" },
    { id: 58867, cityId: 1729, code: "331502" },
    { id: 58868, cityId: 1730, code: "303503" },
    { id: 58869, cityId: 1730, code: "303504" },
    { id: 58870, cityId: 1730, code: "303501" },
    { id: 58871, cityId: 1730, code: "303004" },
    { id: 58872, cityId: 1730, code: "303510" },
    { id: 58873, cityId: 1730, code: "303323" },
    { id: 58874, cityId: 1730, code: "303507" },
    { id: 58875, cityId: 1730, code: "303506" },
    { id: 58876, cityId: 1730, code: "303303" },
    { id: 58877, cityId: 1730, code: "321608" },
    { id: 58878, cityId: 1730, code: "303313" },
    { id: 58879, cityId: 1730, code: "303325" },
    { id: 58880, cityId: 1730, code: "322240" },
    { id: 58881, cityId: 1730, code: "321612" },
    { id: 58882, cityId: 1730, code: "321609" },
    { id: 58883, cityId: 1730, code: "303509" },
    { id: 58884, cityId: 1730, code: "303315" },
    { id: 58885, cityId: 1730, code: "303511" },
    { id: 58886, cityId: 1730, code: "303505" },
    { id: 58887, cityId: 1730, code: "303305" },
    { id: 58888, cityId: 1730, code: "303326" },
    { id: 58889, cityId: 1730, code: "321613" },
    { id: 58890, cityId: 1730, code: "303508" },
    { id: 58891, cityId: 1730, code: "303502" },
    { id: 58892, cityId: 1734, code: "328025" },
    { id: 58893, cityId: 1736, code: "314026" },
    { id: 58894, cityId: 1739, code: "335051" },
    { id: 58895, cityId: 1739, code: "335701" },
    { id: 58896, cityId: 1739, code: "335062" },
    { id: 58897, cityId: 1739, code: "335024" },
    { id: 58898, cityId: 1739, code: "335041" },
    { id: 58899, cityId: 1741, code: "335524" },
    { id: 58900, cityId: 1741, code: "335064" },
    { id: 58901, cityId: 1741, code: "335502" },
    { id: 58902, cityId: 1741, code: "335511" },
    { id: 58903, cityId: 1741, code: "335802" },
    { id: 58904, cityId: 1741, code: "335526" },
    { id: 58905, cityId: 1741, code: "335504" },
    { id: 58906, cityId: 1741, code: "335501" },
    { id: 58907, cityId: 1741, code: "335512" },
    { id: 58908, cityId: 1741, code: "335513" },
    { id: 58909, cityId: 1741, code: "335503" },
    { id: 58910, cityId: 1741, code: "335803" },
    { id: 58911, cityId: 1741, code: "335801" },
    { id: 58912, cityId: 1741, code: "335525" },
    { id: 58913, cityId: 1741, code: "335024" },
    { id: 58914, cityId: 1744, code: "303328" },
    { id: 58915, cityId: 1744, code: "303503" },
    { id: 58916, cityId: 1744, code: "303007" },
    { id: 58917, cityId: 1744, code: "303901" },
    { id: 58918, cityId: 1744, code: "303108" },
    { id: 58919, cityId: 1745, code: "342310" },
    { id: 58920, cityId: 1745, code: "342302" },
    { id: 58921, cityId: 1747, code: "326038" },
    { id: 58922, cityId: 1747, code: "326022" },
    { id: 58923, cityId: 1747, code: "326517" },
    { id: 58924, cityId: 1747, code: "326037" },
    { id: 58925, cityId: 1747, code: "326034" },
    { id: 58926, cityId: 1747, code: "326033" },
    { id: 58927, cityId: 1747, code: "326502" },
    { id: 58928, cityId: 1750, code: "345021" },
    { id: 58929, cityId: 1750, code: "342301" },
    { id: 58930, cityId: 1750, code: "345001" },
    { id: 58931, cityId: 1754, code: "322234" },
    { id: 58932, cityId: 1754, code: "322220" },
    { id: 58933, cityId: 1754, code: "322202" },
    { id: 58934, cityId: 1754, code: "321611" },
    { id: 58935, cityId: 1754, code: "322230" },
    { id: 58936, cityId: 1754, code: "322033" },
    { id: 58937, cityId: 1754, code: "322242" },
    { id: 58938, cityId: 1754, code: "322203" },
    { id: 58939, cityId: 1754, code: "322241" },
    { id: 58940, cityId: 1754, code: "322212" },
    { id: 58941, cityId: 1754, code: "322213" },
    { id: 58942, cityId: 1754, code: "322216" },
    { id: 58943, cityId: 1754, code: "322219" },
    { id: 58944, cityId: 1754, code: "321610" },
    { id: 58945, cityId: 1754, code: "322251" },
    { id: 58946, cityId: 1763, code: "326530" },
    { id: 58947, cityId: 1763, code: "325601" },
    { id: 58948, cityId: 1763, code: "326518" },
    { id: 58949, cityId: 1781, code: "341024" },
    { id: 58950, cityId: 1781, code: "341303" },
    { id: 58951, cityId: 1781, code: "341510" },
    { id: 58952, cityId: 1781, code: "341511" },
    { id: 58953, cityId: 1781, code: "341505" },
    { id: 58954, cityId: 1789, code: "306702" },
    { id: 58955, cityId: 1789, code: "306912" },
    { id: 58956, cityId: 1789, code: "306105" },
    { id: 58957, cityId: 1801, code: "313323" },
    { id: 58958, cityId: 1801, code: "313332" },
    { id: 58959, cityId: 1801, code: "313329" },
    { id: 58960, cityId: 1801, code: "313202" },
    { id: 58961, cityId: 1801, code: "313322" },
    { id: 58962, cityId: 1801, code: "313325" },
    { id: 58963, cityId: 1801, code: "313211" },
    { id: 58964, cityId: 1801, code: "313342" },
    { id: 58965, cityId: 1801, code: "313704" },
    { id: 58966, cityId: 1801, code: "313333" },
    { id: 58967, cityId: 1801, code: "313206" },
    { id: 58968, cityId: 1801, code: "313327" },
    { id: 58969, cityId: 1801, code: "313324" },
    { id: 58970, cityId: 1801, code: "313330" },
    { id: 58971, cityId: 1801, code: "305925" },
    { id: 58972, cityId: 1801, code: "305922" },
    { id: 58973, cityId: 1801, code: "313328" },
    { id: 58974, cityId: 1801, code: "313331" },
    { id: 58975, cityId: 1801, code: "313207" },
    { id: 58976, cityId: 1801, code: "313321" },
    { id: 58977, cityId: 1816, code: "332025" },
    { id: 58978, cityId: 1817, code: "307024" },
    { id: 58979, cityId: 1817, code: "307031" },
    { id: 58980, cityId: 1817, code: "307022" },
    { id: 58981, cityId: 1827, code: "304502" },
    { id: 58982, cityId: 1827, code: "304024" },
    { id: 58983, cityId: 1828, code: "313605" },
    { id: 58984, cityId: 1828, code: "313027" },
    { id: 58985, cityId: 1828, code: "313004" },
    { id: 58986, cityId: 1828, code: "313603" },
    { id: 58987, cityId: 1859, code: "621729" },
    { id: 58988, cityId: 1859, code: "612904" },
    { id: 58989, cityId: 1859, code: "621704" },
    { id: 58990, cityId: 1859, code: "621653" },
    { id: 58991, cityId: 1859, code: "608901" },
    { id: 58992, cityId: 1859, code: "621805" },
    { id: 58993, cityId: 1859, code: "621709" },
    { id: 58994, cityId: 1859, code: "612903" },
    { id: 58995, cityId: 1859, code: "621651" },
    { id: 58996, cityId: 1859, code: "621715" },
    { id: 58997, cityId: 1859, code: "608703" },
    { id: 58998, cityId: 1859, code: "621719" },
    { id: 58999, cityId: 1859, code: "621713" },
    { id: 59000, cityId: 1859, code: "621802" },
    { id: 59001, cityId: 1859, code: "621707" },
    { id: 59002, cityId: 1859, code: "621218" },
    { id: 59003, cityId: 1859, code: "621714" },
    { id: 59004, cityId: 1859, code: "621803" },
    { id: 59005, cityId: 1859, code: "612901" },
    { id: 59006, cityId: 1859, code: "621701" },
    { id: 59007, cityId: 1859, code: "621851" },
    { id: 59008, cityId: 1859, code: "621705" },
    { id: 59009, cityId: 1859, code: "621718" },
    { id: 59010, cityId: 1889, code: "641111" },
    { id: 59011, cityId: 1889, code: "638462" },
    { id: 59012, cityId: 1889, code: "641010" },
    { id: 59013, cityId: 1889, code: "641017" },
    { id: 59014, cityId: 1889, code: "641607" },
    { id: 59015, cityId: 1889, code: "641302" },
    { id: 59016, cityId: 1889, code: "641201" },
    { id: 59017, cityId: 1889, code: "641024" },
    { id: 59018, cityId: 1889, code: "641113" },
    { id: 59019, cityId: 1889, code: "642109" },
    { id: 59020, cityId: 1889, code: "638402" },
    { id: 59021, cityId: 1889, code: "642110" },
    { id: 59022, cityId: 1889, code: "641108" },
    { id: 59023, cityId: 1889, code: "638103" },
    { id: 59024, cityId: 1889, code: "624622" },
    { id: 59025, cityId: 1889, code: "642206" },
    { id: 59026, cityId: 1889, code: "642123" },
    { id: 59027, cityId: 1889, code: "638458" },
    { id: 59028, cityId: 1889, code: "641032" },
    { id: 59029, cityId: 1889, code: "642129" },
    { id: 59030, cityId: 1889, code: "641103" },
    { id: 59031, cityId: 1889, code: "641305" },
    { id: 59032, cityId: 1889, code: "641401" },
    { id: 59033, cityId: 1889, code: "641687" },
    { id: 59034, cityId: 1889, code: "641008" },
    { id: 59035, cityId: 1889, code: "641104" },
    { id: 59036, cityId: 1889, code: "642106" },
    { id: 59037, cityId: 1889, code: "642113" },
    { id: 59038, cityId: 1889, code: "641605" },
    { id: 59039, cityId: 1890, code: "608002" },
    { id: 59040, cityId: 1890, code: "608801" },
    { id: 59041, cityId: 1890, code: "607805" },
    { id: 59042, cityId: 1890, code: "607101" },
    { id: 59043, cityId: 1890, code: "607106" },
    { id: 59044, cityId: 1890, code: "608502" },
    { id: 59045, cityId: 1890, code: "606106" },
    { id: 59046, cityId: 1890, code: "608001" },
    { id: 59047, cityId: 1890, code: "607804" },
    { id: 59048, cityId: 1890, code: "608501" },
    { id: 59049, cityId: 1890, code: "606105" },
    { id: 59050, cityId: 1890, code: "607105" },
    { id: 59051, cityId: 1890, code: "607802" },
    { id: 59052, cityId: 1890, code: "606110" },
    { id: 59053, cityId: 1890, code: "607803" },
    { id: 59054, cityId: 1890, code: "606111" },
    { id: 59055, cityId: 1890, code: "605007" },
    { id: 59056, cityId: 1890, code: "606003" },
    { id: 59057, cityId: 1890, code: "608102" },
    { id: 59058, cityId: 1890, code: "608305" },
    { id: 59059, cityId: 1890, code: "607302" },
    { id: 59060, cityId: 1890, code: "607004" },
    { id: 59061, cityId: 1890, code: "607002" },
    { id: 59062, cityId: 1890, code: "608201" },
    { id: 59063, cityId: 1890, code: "607801" },
    { id: 59064, cityId: 1890, code: "608702" },
    { id: 59065, cityId: 1890, code: "606304" },
    { id: 59066, cityId: 1890, code: "607103" },
    { id: 59067, cityId: 1890, code: "607401" },
    { id: 59068, cityId: 1890, code: "606103" },
    { id: 59069, cityId: 1890, code: "607402" },
    { id: 59070, cityId: 1890, code: "608601" },
    { id: 59071, cityId: 1890, code: "606104" },
    { id: 59072, cityId: 1890, code: "608303" },
    { id: 59073, cityId: 1890, code: "607301" },
    { id: 59074, cityId: 1890, code: "607104" },
    { id: 59075, cityId: 1890, code: "608703" },
    { id: 59076, cityId: 1890, code: "606001" },
    { id: 59077, cityId: 1890, code: "607109" },
    { id: 59078, cityId: 1890, code: "608701" },
    { id: 59079, cityId: 1890, code: "606303" },
    { id: 59080, cityId: 1890, code: "605106" },
    { id: 59081, cityId: 1890, code: "607807" },
    { id: 59082, cityId: 1890, code: "607108" },
    { id: 59083, cityId: 1890, code: "606302" },
    { id: 59084, cityId: 1890, code: "608301" },
    { id: 59085, cityId: 1890, code: "607102" },
    { id: 59086, cityId: 1894, code: "636352" },
    { id: 59087, cityId: 1894, code: "636905" },
    { id: 59088, cityId: 1894, code: "636808" },
    { id: 59089, cityId: 1894, code: "635202" },
    { id: 59090, cityId: 1894, code: "636902" },
    { id: 59091, cityId: 1894, code: "636807" },
    { id: 59092, cityId: 1894, code: "636001" },
    { id: 59093, cityId: 1894, code: "635303" },
    { id: 59094, cityId: 1894, code: "636806" },
    { id: 59095, cityId: 1894, code: "636810" },
    { id: 59096, cityId: 1894, code: "636906" },
    { id: 59097, cityId: 1895, code: "624210" },
    { id: 59098, cityId: 1895, code: "624801" },
    { id: 59099, cityId: 1895, code: "624401" },
    { id: 59100, cityId: 1895, code: "624705" },
    { id: 59101, cityId: 1895, code: "624710" },
    { id: 59102, cityId: 1895, code: "624215" },
    { id: 59103, cityId: 1895, code: "639203" },
    { id: 59104, cityId: 1895, code: "624619" },
    { id: 59105, cityId: 1895, code: "624613" },
    { id: 59106, cityId: 1895, code: "624620" },
    { id: 59107, cityId: 1895, code: "624708" },
    { id: 59108, cityId: 1895, code: "624403" },
    { id: 59109, cityId: 1895, code: "624802" },
    { id: 59110, cityId: 1895, code: "624301" },
    { id: 59111, cityId: 1895, code: "642113" },
    { id: 59112, cityId: 1895, code: "624402" },
    { id: 59113, cityId: 1900, code: "638056" },
    { id: 59114, cityId: 1900, code: "638456" },
    { id: 59115, cityId: 1900, code: "638462" },
    { id: 59116, cityId: 1900, code: "641607" },
    { id: 59117, cityId: 1900, code: "638672" },
    { id: 59118, cityId: 1900, code: "638107" },
    { id: 59119, cityId: 1900, code: "638660" },
    { id: 59120, cityId: 1900, code: "638152" },
    { id: 59121, cityId: 1900, code: "638051" },
    { id: 59122, cityId: 1900, code: "638812" },
    { id: 59123, cityId: 1900, code: "638501" },
    { id: 59124, cityId: 1900, code: "638457" },
    { id: 59125, cityId: 1900, code: "638476" },
    { id: 59126, cityId: 1900, code: "638108" },
    { id: 59127, cityId: 1900, code: "638057" },
    { id: 59128, cityId: 1900, code: "638311" },
    { id: 59129, cityId: 1900, code: "638001" },
    { id: 59130, cityId: 1900, code: "638002" },
    { id: 59131, cityId: 1900, code: "638116" },
    { id: 59132, cityId: 1900, code: "638103" },
    { id: 59133, cityId: 1900, code: "638401" },
    { id: 59134, cityId: 1900, code: "642206" },
    { id: 59135, cityId: 1900, code: "638052" },
    { id: 59136, cityId: 1900, code: "638503" },
    { id: 59137, cityId: 1900, code: "638154" },
    { id: 59138, cityId: 1900, code: "638153" },
    { id: 59139, cityId: 1900, code: "638451" },
    { id: 59140, cityId: 1900, code: "638673" },
    { id: 59141, cityId: 1900, code: "638109" },
    { id: 59142, cityId: 1900, code: "638007" },
    { id: 59143, cityId: 1900, code: "638458" },
    { id: 59144, cityId: 1900, code: "638661" },
    { id: 59145, cityId: 1900, code: "638502" },
    { id: 59146, cityId: 1900, code: "638115" },
    { id: 59147, cityId: 1900, code: "638312" },
    { id: 59148, cityId: 1900, code: "638452" },
    { id: 59149, cityId: 1900, code: "638459" },
    { id: 59150, cityId: 1900, code: "638402" },
    { id: 59151, cityId: 1900, code: "638313" },
    { id: 59152, cityId: 1900, code: "638453" },
    { id: 59153, cityId: 1900, code: "638751" },
    { id: 59154, cityId: 1900, code: "638053" },
    { id: 59155, cityId: 1900, code: "638504" },
    { id: 59156, cityId: 1900, code: "638110" },
    { id: 59157, cityId: 1900, code: "638009" },
    { id: 59158, cityId: 1900, code: "638003" },
    { id: 59159, cityId: 1900, code: "638454" },
    { id: 59160, cityId: 1900, code: "638104" },
    { id: 59161, cityId: 1900, code: "638105" },
    { id: 59162, cityId: 1900, code: "638111" },
    { id: 59163, cityId: 1900, code: "638054" },
    { id: 59164, cityId: 1900, code: "638314" },
    { id: 59165, cityId: 1900, code: "638701" },
    { id: 59166, cityId: 1900, code: "638460" },
    { id: 59167, cityId: 1900, code: "638004" },
    { id: 59168, cityId: 1900, code: "638010" },
    { id: 59169, cityId: 1900, code: "638461" },
    { id: 59170, cityId: 1900, code: "638315" },
    { id: 59171, cityId: 1900, code: "638316" },
    { id: 59172, cityId: 1900, code: "638005" },
    { id: 59173, cityId: 1900, code: "638151" },
    { id: 59174, cityId: 1900, code: "638011" },
    { id: 59175, cityId: 1900, code: "638506" },
    { id: 59176, cityId: 1900, code: "638703" },
    { id: 59177, cityId: 1900, code: "638106" },
    { id: 59178, cityId: 1900, code: "638505" },
    { id: 59179, cityId: 1900, code: "638702" },
    { id: 59180, cityId: 1900, code: "639201" },
    { id: 59181, cityId: 1900, code: "638055" },
    { id: 59182, cityId: 1900, code: "638112" },
    { id: 59183, cityId: 1900, code: "638752" },
    { id: 59184, cityId: 1900, code: "641605" },
    { id: 59185, cityId: 1900, code: "639202" },
    { id: 59186, cityId: 1934, code: "629180" },
    { id: 59187, cityId: 1934, code: "629502" },
    { id: 59188, cityId: 1934, code: "629001" },
    { id: 59189, cityId: 1934, code: "629602" },
    { id: 59190, cityId: 1934, code: "629703" },
    { id: 59191, cityId: 1934, code: "629176" },
    { id: 59192, cityId: 1934, code: "629252" },
    { id: 59193, cityId: 1937, code: "639108" },
    { id: 59194, cityId: 1937, code: "639203" },
    { id: 59195, cityId: 1937, code: "639006" },
    { id: 59196, cityId: 1937, code: "639102" },
    { id: 59197, cityId: 1937, code: "621311" },
    { id: 59198, cityId: 1937, code: "639104" },
    { id: 59199, cityId: 1937, code: "621306" },
    { id: 59200, cityId: 1937, code: "639002" },
    { id: 59201, cityId: 1937, code: "639110" },
    { id: 59202, cityId: 1937, code: "639205" },
    { id: 59203, cityId: 1937, code: "639109" },
    { id: 59204, cityId: 1937, code: "639001" },
    { id: 59205, cityId: 1937, code: "639116" },
    { id: 59206, cityId: 1937, code: "639004" },
    { id: 59207, cityId: 1937, code: "639207" },
    { id: 59208, cityId: 1937, code: "639105" },
    { id: 59209, cityId: 1937, code: "639117" },
    { id: 59210, cityId: 1937, code: "639206" },
    { id: 59211, cityId: 1937, code: "639003" },
    { id: 59212, cityId: 1937, code: "639111" },
    { id: 59213, cityId: 1937, code: "639113" },
    { id: 59214, cityId: 1937, code: "639202" },
    { id: 59215, cityId: 1937, code: "639120" },
    { id: 59216, cityId: 1937, code: "638151" },
    { id: 59217, cityId: 1937, code: "639107" },
    { id: 59218, cityId: 1937, code: "621315" },
    { id: 59219, cityId: 1937, code: "639201" },
    { id: 59220, cityId: 1937, code: "639118" },
    { id: 59221, cityId: 1937, code: "639119" },
    { id: 59222, cityId: 1937, code: "639005" },
    { id: 59223, cityId: 1963, code: "635122" },
    { id: 59224, cityId: 1963, code: "635112" },
    { id: 59225, cityId: 1963, code: "635103" },
    { id: 59226, cityId: 1963, code: "635109" },
    { id: 59227, cityId: 1963, code: "635306" },
    { id: 59228, cityId: 1963, code: "635307" },
    { id: 59229, cityId: 1963, code: "635104" },
    { id: 59230, cityId: 1963, code: "635110" },
    { id: 59231, cityId: 1963, code: "635105" },
    { id: 59232, cityId: 1963, code: "635117" },
    { id: 59233, cityId: 1963, code: "635111" },
    { id: 59234, cityId: 1963, code: "635120" },
    { id: 59235, cityId: 1963, code: "635207" },
    { id: 59236, cityId: 1963, code: "635118" },
    { id: 59237, cityId: 1963, code: "635206" },
    { id: 59238, cityId: 1963, code: "635119" },
    { id: 59239, cityId: 1963, code: "635106" },
    { id: 59240, cityId: 1963, code: "635304" },
    { id: 59241, cityId: 1963, code: "635113" },
    { id: 59242, cityId: 1963, code: "635107" },
    { id: 59243, cityId: 1963, code: "635126" },
    { id: 59244, cityId: 1963, code: "635121" },
    { id: 59245, cityId: 1963, code: "635204" },
    { id: 59246, cityId: 1963, code: "635115" },
    { id: 59247, cityId: 1963, code: "635102" },
    { id: 59248, cityId: 1963, code: "635203" },
    { id: 59249, cityId: 1963, code: "635114" },
    { id: 59250, cityId: 1963, code: "635108" },
    { id: 59251, cityId: 1963, code: "635123" },
    { id: 59252, cityId: 1976, code: "625527" },
    { id: 59253, cityId: 1976, code: "625501" },
    { id: 59254, cityId: 1976, code: "625705" },
    { id: 59255, cityId: 2004, code: "612203" },
    { id: 59256, cityId: 2004, code: "609106" },
    { id: 59257, cityId: 2004, code: "609303" },
    { id: 59258, cityId: 2004, code: "610204" },
    { id: 59259, cityId: 2004, code: "609202" },
    { id: 59260, cityId: 2004, code: "614714" },
    { id: 59261, cityId: 2004, code: "609703" },
    { id: 59262, cityId: 2004, code: "609310" },
    { id: 59263, cityId: 2004, code: "611111" },
    { id: 59264, cityId: 2004, code: "609113" },
    { id: 59265, cityId: 2004, code: "609107" },
    { id: 59266, cityId: 2004, code: "609403" },
    { id: 59267, cityId: 2004, code: "609810" },
    { id: 59268, cityId: 2004, code: "609702" },
    { id: 59269, cityId: 2004, code: "609804" },
    { id: 59270, cityId: 2004, code: "609404" },
    { id: 59271, cityId: 2004, code: "609309" },
    { id: 59272, cityId: 2004, code: "609112" },
    { id: 59273, cityId: 2004, code: "614810" },
    { id: 59274, cityId: 2004, code: "611105" },
    { id: 59275, cityId: 2004, code: "609201" },
    { id: 59276, cityId: 2004, code: "609504" },
    { id: 59277, cityId: 2004, code: "609307" },
    { id: 59278, cityId: 2004, code: "609701" },
    { id: 59279, cityId: 2004, code: "609802" },
    { id: 59280, cityId: 2004, code: "612201" },
    { id: 59281, cityId: 2004, code: "609314" },
    { id: 59282, cityId: 2004, code: "609301" },
    { id: 59283, cityId: 2004, code: "614707" },
    { id: 59284, cityId: 2004, code: "611002" },
    { id: 59285, cityId: 2004, code: "609111" },
    { id: 59286, cityId: 2004, code: "614808" },
    { id: 59287, cityId: 2004, code: "611110" },
    { id: 59288, cityId: 2004, code: "610101" },
    { id: 59289, cityId: 2004, code: "609117" },
    { id: 59290, cityId: 2004, code: "614809" },
    { id: 59291, cityId: 2004, code: "609003" },
    { id: 59292, cityId: 2004, code: "611109" },
    { id: 59293, cityId: 2004, code: "609302" },
    { id: 59294, cityId: 2004, code: "611103" },
    { id: 59295, cityId: 2004, code: "609105" },
    { id: 59296, cityId: 2004, code: "609308" },
    { id: 59297, cityId: 2004, code: "609803" },
    { id: 59298, cityId: 2004, code: "609118" },
    { id: 59299, cityId: 2004, code: "610203" },
    { id: 59300, cityId: 2004, code: "609114" },
    { id: 59301, cityId: 2004, code: "609304" },
    { id: 59302, cityId: 2004, code: "609501" },
    { id: 59303, cityId: 2004, code: "609704" },
    { id: 59304, cityId: 2004, code: "609203" },
    { id: 59305, cityId: 2004, code: "609805" },
    { id: 59306, cityId: 2004, code: "609101" },
    { id: 59307, cityId: 2004, code: "614716" },
    { id: 59308, cityId: 2004, code: "609311" },
    { id: 59309, cityId: 2004, code: "609102" },
    { id: 59310, cityId: 2004, code: "612102" },
    { id: 59311, cityId: 2004, code: "611106" },
    { id: 59312, cityId: 2004, code: "609305" },
    { id: 59313, cityId: 2004, code: "611112" },
    { id: 59314, cityId: 2004, code: "609806" },
    { id: 59315, cityId: 2004, code: "609115" },
    { id: 59316, cityId: 2004, code: "611101" },
    { id: 59317, cityId: 2004, code: "609808" },
    { id: 59318, cityId: 2004, code: "614806" },
    { id: 59319, cityId: 2004, code: "613702" },
    { id: 59320, cityId: 2004, code: "609503" },
    { id: 59321, cityId: 2004, code: "609313" },
    { id: 59322, cityId: 2004, code: "610106" },
    { id: 59323, cityId: 2004, code: "614711" },
    { id: 59324, cityId: 2004, code: "610201" },
    { id: 59325, cityId: 2004, code: "609306" },
    { id: 59326, cityId: 2004, code: "614712" },
    { id: 59327, cityId: 2004, code: "609103" },
    { id: 59328, cityId: 2004, code: "611102" },
    { id: 59329, cityId: 2004, code: "609312" },
    { id: 59330, cityId: 2004, code: "614807" },
    { id: 59331, cityId: 2004, code: "609001" },
    { id: 59332, cityId: 2004, code: "609204" },
    { id: 59333, cityId: 2004, code: "610207" },
    { id: 59334, cityId: 2004, code: "609604" },
    { id: 59335, cityId: 2004, code: "609401" },
    { id: 59336, cityId: 2004, code: "611108" },
    { id: 59337, cityId: 2004, code: "609807" },
    { id: 59338, cityId: 2004, code: "609811" },
    { id: 59339, cityId: 2004, code: "611104" },
    { id: 59340, cityId: 2006, code: "637001" },
    { id: 59341, cityId: 2006, code: "638007" },
    { id: 59342, cityId: 2006, code: "637411" },
    { id: 59343, cityId: 2006, code: "637003" },
    { id: 59344, cityId: 2006, code: "637303" },
    { id: 59345, cityId: 2006, code: "637206" },
    { id: 59346, cityId: 2006, code: "637404" },
    { id: 59347, cityId: 2006, code: "637207" },
    { id: 59348, cityId: 2006, code: "637405" },
    { id: 59349, cityId: 2006, code: "638008" },
    { id: 59350, cityId: 2006, code: "637105" },
    { id: 59351, cityId: 2006, code: "636301" },
    { id: 59352, cityId: 2006, code: "637018" },
    { id: 59353, cityId: 2006, code: "637410" },
    { id: 59354, cityId: 2006, code: "637213" },
    { id: 59355, cityId: 2006, code: "637302" },
    { id: 59356, cityId: 2006, code: "637107" },
    { id: 59357, cityId: 2006, code: "637505" },
    { id: 59358, cityId: 2006, code: "621215" },
    { id: 59359, cityId: 2006, code: "637202" },
    { id: 59360, cityId: 2006, code: "637301" },
    { id: 59361, cityId: 2006, code: "637409" },
    { id: 59362, cityId: 2006, code: "637212" },
    { id: 59363, cityId: 2006, code: "637017" },
    { id: 59364, cityId: 2006, code: "637201" },
    { id: 59365, cityId: 2006, code: "636142" },
    { id: 59366, cityId: 2006, code: "637403" },
    { id: 59367, cityId: 2006, code: "637208" },
    { id: 59368, cityId: 2006, code: "637015" },
    { id: 59369, cityId: 2006, code: "637002" },
    { id: 59370, cityId: 2006, code: "637205" },
    { id: 59371, cityId: 2006, code: "638181" },
    { id: 59372, cityId: 2006, code: "636202" },
    { id: 59373, cityId: 2006, code: "637103" },
    { id: 59374, cityId: 2006, code: "637412" },
    { id: 59375, cityId: 2006, code: "637304" },
    { id: 59376, cityId: 2006, code: "636113" },
    { id: 59377, cityId: 2006, code: "637211" },
    { id: 59378, cityId: 2006, code: "637014" },
    { id: 59379, cityId: 2006, code: "637406" },
    { id: 59380, cityId: 2006, code: "637203" },
    { id: 59381, cityId: 2006, code: "637503" },
    { id: 59382, cityId: 2006, code: "636118" },
    { id: 59383, cityId: 2006, code: "637019" },
    { id: 59384, cityId: 2006, code: "637407" },
    { id: 59385, cityId: 2006, code: "637104" },
    { id: 59386, cityId: 2006, code: "637021" },
    { id: 59387, cityId: 2006, code: "637102" },
    { id: 59388, cityId: 2006, code: "638182" },
    { id: 59389, cityId: 2006, code: "637020" },
    { id: 59390, cityId: 2006, code: "637013" },
    { id: 59391, cityId: 2006, code: "637204" },
    { id: 59392, cityId: 2006, code: "637210" },
    { id: 59393, cityId: 2006, code: "637402" },
    { id: 59394, cityId: 2006, code: "637101" },
    { id: 59395, cityId: 2006, code: "637209" },
    { id: 59396, cityId: 2006, code: "637401" },
    { id: 59397, cityId: 2050, code: "621103" },
    { id: 59398, cityId: 2050, code: "621110" },
    { id: 59399, cityId: 2050, code: "621108" },
    { id: 59400, cityId: 2050, code: "621115" },
    { id: 59401, cityId: 2050, code: "621109" },
    { id: 59402, cityId: 2050, code: "621107" },
    { id: 59403, cityId: 2050, code: "621101" },
    { id: 59404, cityId: 2050, code: "621114" },
    { id: 59405, cityId: 2050, code: "621716" },
    { id: 59406, cityId: 2050, code: "621717" },
    { id: 59407, cityId: 2050, code: "621102" },
    { id: 59408, cityId: 2050, code: "621117" },
    { id: 59409, cityId: 2050, code: "621713" },
    { id: 59410, cityId: 2050, code: "621104" },
    { id: 59411, cityId: 2050, code: "621219" },
    { id: 59412, cityId: 2050, code: "621113" },
    { id: 59413, cityId: 2050, code: "621106" },
    { id: 59414, cityId: 2050, code: "621118" },
    { id: 59415, cityId: 2050, code: "621220" },
    { id: 59416, cityId: 2050, code: "621116" },
    { id: 59417, cityId: 2064, code: "622411" },
    { id: 59418, cityId: 2064, code: "622515" },
    { id: 59419, cityId: 2064, code: "622204" },
    { id: 59420, cityId: 2064, code: "622401" },
    { id: 59421, cityId: 2064, code: "614801" },
    { id: 59422, cityId: 2064, code: "614630" },
    { id: 59423, cityId: 2064, code: "622407" },
    { id: 59424, cityId: 2064, code: "614617" },
    { id: 59425, cityId: 2064, code: "621316" },
    { id: 59426, cityId: 2064, code: "614902" },
    { id: 59427, cityId: 2064, code: "614629" },
    { id: 59428, cityId: 2064, code: "614616" },
    { id: 59429, cityId: 2064, code: "622002" },
    { id: 59430, cityId: 2064, code: "622502" },
    { id: 59431, cityId: 2064, code: "622103" },
    { id: 59432, cityId: 2064, code: "622503" },
    { id: 59433, cityId: 2064, code: "614805" },
    { id: 59434, cityId: 2064, code: "622102" },
    { id: 59435, cityId: 2064, code: "613301" },
    { id: 59436, cityId: 2064, code: "622501" },
    { id: 59437, cityId: 2064, code: "622203" },
    { id: 59438, cityId: 2064, code: "614621" },
    { id: 59439, cityId: 2064, code: "622202" },
    { id: 59440, cityId: 2064, code: "622412" },
    { id: 59441, cityId: 2064, code: "622507" },
    { id: 59442, cityId: 2064, code: "622304" },
    { id: 59443, cityId: 2064, code: "622101" },
    { id: 59444, cityId: 2064, code: "614622" },
    { id: 59445, cityId: 2064, code: "621308" },
    { id: 59446, cityId: 2064, code: "622003" },
    { id: 59447, cityId: 2064, code: "622402" },
    { id: 59448, cityId: 2064, code: "614618" },
    { id: 59449, cityId: 2064, code: "622409" },
    { id: 59450, cityId: 2064, code: "622403" },
    { id: 59451, cityId: 2064, code: "622408" },
    { id: 59452, cityId: 2064, code: "622504" },
    { id: 59453, cityId: 2064, code: "621305" },
    { id: 59454, cityId: 2064, code: "622104" },
    { id: 59455, cityId: 2064, code: "622301" },
    { id: 59456, cityId: 2064, code: "622404" },
    { id: 59457, cityId: 2064, code: "622004" },
    { id: 59458, cityId: 2064, code: "622201" },
    { id: 59459, cityId: 2064, code: "614620" },
    { id: 59460, cityId: 2064, code: "622302" },
    { id: 59461, cityId: 2064, code: "621312" },
    { id: 59462, cityId: 2064, code: "622005" },
    { id: 59463, cityId: 2064, code: "614619" },
    { id: 59464, cityId: 2064, code: "622303" },
    { id: 59465, cityId: 2064, code: "622506" },
    { id: 59466, cityId: 2064, code: "622505" },
    { id: 59467, cityId: 2071, code: "623401" },
    { id: 59468, cityId: 2071, code: "623402" },
    { id: 59469, cityId: 2071, code: "623605" },
    { id: 59470, cityId: 2071, code: "623604" },
    { id: 59471, cityId: 2071, code: "623406" },
    { id: 59472, cityId: 2071, code: "623538" },
    { id: 59473, cityId: 2071, code: "623603" },
    { id: 59474, cityId: 2071, code: "623407" },
    { id: 59475, cityId: 2071, code: "623705" },
    { id: 59476, cityId: 2071, code: "623536" },
    { id: 59477, cityId: 2071, code: "623409" },
    { id: 59478, cityId: 2071, code: "623708" },
    { id: 59479, cityId: 2071, code: "623308" },
    { id: 59480, cityId: 2071, code: "630312" },
    { id: 59481, cityId: 2071, code: "623315" },
    { id: 59482, cityId: 2071, code: "623519" },
    { id: 59483, cityId: 2071, code: "623608" },
    { id: 59484, cityId: 2071, code: "623526" },
    { id: 59485, cityId: 2071, code: "623601" },
    { id: 59486, cityId: 2071, code: "623404" },
    { id: 59487, cityId: 2071, code: "623518" },
    { id: 59488, cityId: 2075, code: "636108" },
    { id: 59489, cityId: 2075, code: "637410" },
    { id: 59490, cityId: 2075, code: "636305" },
    { id: 59491, cityId: 2075, code: "636502" },
    { id: 59492, cityId: 2075, code: "636453" },
    { id: 59493, cityId: 2075, code: "636142" },
    { id: 59494, cityId: 2075, code: "636113" },
    { id: 59495, cityId: 2075, code: "637501" },
    { id: 59496, cityId: 2075, code: "621110" },
    { id: 59497, cityId: 2075, code: "636303" },
    { id: 59498, cityId: 2075, code: "637105" },
    { id: 59499, cityId: 2075, code: "636455" },
    { id: 59500, cityId: 2075, code: "637102" },
    { id: 59501, cityId: 2075, code: "637407" },
    { id: 59502, cityId: 2075, code: "636012" },
    { id: 59503, cityId: 2075, code: "636105" },
    { id: 59504, cityId: 2075, code: "637107" },
    { id: 59505, cityId: 2075, code: "636010" },
    { id: 59506, cityId: 2075, code: "636454" },
    { id: 59507, cityId: 2088, code: "630312" },
    { id: 59508, cityId: 2088, code: "630001" },
    { id: 59509, cityId: 2088, code: "623701" },
    { id: 59510, cityId: 2088, code: "621308" },
    { id: 59511, cityId: 2099, code: "613403" },
    { id: 59512, cityId: 2099, code: "614208" },
    { id: 59513, cityId: 2099, code: "612101" },
    { id: 59514, cityId: 2099, code: "614301" },
    { id: 59515, cityId: 2099, code: "614903" },
    { id: 59516, cityId: 2099, code: "612105" },
    { id: 59517, cityId: 2101, code: "625602" },
    { id: 59518, cityId: 2101, code: "625705" },
    { id: 59519, cityId: 2101, code: "625527" },
    { id: 59520, cityId: 2110, code: "621315" },
    { id: 59521, cityId: 2110, code: "639112" },
    { id: 59522, cityId: 2110, code: "639101" },
    { id: 59523, cityId: 2110, code: "621202" },
    { id: 59524, cityId: 2110, code: "621651" },
    { id: 59525, cityId: 2110, code: "621308" },
    { id: 59526, cityId: 2110, code: "621011" },
    { id: 59527, cityId: 2110, code: "621210" },
    { id: 59528, cityId: 2110, code: "621305" },
    { id: 59529, cityId: 2110, code: "607201" },
    { id: 59530, cityId: 2110, code: "621203" },
    { id: 59531, cityId: 2110, code: "621653" },
    { id: 59532, cityId: 2110, code: "621110" },
    { id: 59533, cityId: 2110, code: "621712" },
    { id: 59534, cityId: 2110, code: "639115" },
    { id: 59535, cityId: 2110, code: "639103" },
    { id: 59536, cityId: 2111, code: "627417" },
    { id: 59537, cityId: 2111, code: "627805" },
    { id: 59538, cityId: 2111, code: "627601" },
    { id: 59539, cityId: 2111, code: "628502" },
    { id: 59540, cityId: 2111, code: "628552" },
    { id: 59541, cityId: 2111, code: "627803" },
    { id: 59542, cityId: 2111, code: "627352" },
    { id: 59543, cityId: 2111, code: "627758" },
    { id: 59544, cityId: 2111, code: "627851" },
    { id: 59545, cityId: 2111, code: "627109" },
    { id: 59546, cityId: 2111, code: "627755" },
    { id: 59547, cityId: 2111, code: "627757" },
    { id: 59548, cityId: 2111, code: "627853" },
    { id: 59549, cityId: 2111, code: "627859" },
    { id: 59550, cityId: 2111, code: "627858" },
    { id: 59551, cityId: 2113, code: "600051" },
    { id: 59552, cityId: 2113, code: "631210" },
    { id: 59553, cityId: 2113, code: "600065" },
    { id: 59554, cityId: 2113, code: "600128" },
    { id: 59555, cityId: 2113, code: "601204" },
    { id: 59556, cityId: 2113, code: "600058" },
    { id: 59557, cityId: 2113, code: "600071" },
    { id: 59558, cityId: 2113, code: "600103" },
    { id: 59559, cityId: 2113, code: "600077" },
    { id: 59560, cityId: 2113, code: "600052" },
    { id: 59561, cityId: 2113, code: "600037" },
    { id: 59562, cityId: 2113, code: "600056" },
    { id: 59563, cityId: 2113, code: "600050" },
    { id: 59564, cityId: 2113, code: "600107" },
    { id: 59565, cityId: 2113, code: "600062" },
    { id: 59566, cityId: 2113, code: "600076" },
    { id: 59567, cityId: 2113, code: "600057" },
    { id: 59568, cityId: 2113, code: "600019" },
    { id: 59569, cityId: 2113, code: "600095" },
    { id: 59570, cityId: 2113, code: "631402" },
    { id: 59571, cityId: 2113, code: "600110" },
    { id: 59572, cityId: 2113, code: "601203" },
    { id: 59573, cityId: 2113, code: "600053" },
    { id: 59574, cityId: 2113, code: "600098" },
    { id: 59575, cityId: 2113, code: "600066" },
    { id: 59576, cityId: 2113, code: "600060" },
    { id: 59577, cityId: 2113, code: "631301" },
    { id: 59578, cityId: 2113, code: "600054" },
    { id: 59579, cityId: 2113, code: "600055" },
    { id: 59580, cityId: 2113, code: "600099" },
    { id: 59581, cityId: 2113, code: "600067" },
    { id: 59582, cityId: 2113, code: "600072" },
    { id: 59583, cityId: 2113, code: "600087" },
    { id: 59584, cityId: 2113, code: "600068" },
    { id: 59585, cityId: 2113, code: "600049" },
    { id: 59586, cityId: 2114, code: "606705" },
    { id: 59587, cityId: 2114, code: "604409" },
    { id: 59588, cityId: 2114, code: "604403" },
    { id: 59589, cityId: 2114, code: "604504" },
    { id: 59590, cityId: 2114, code: "632512" },
    { id: 59591, cityId: 2114, code: "604405" },
    { id: 59592, cityId: 2114, code: "604410" },
    { id: 59593, cityId: 2114, code: "632315" },
    { id: 59594, cityId: 2114, code: "606706" },
    { id: 59595, cityId: 2114, code: "606908" },
    { id: 59596, cityId: 2114, code: "606902" },
    { id: 59597, cityId: 2114, code: "606807" },
    { id: 59598, cityId: 2114, code: "606801" },
    { id: 59599, cityId: 2114, code: "606604" },
    { id: 59600, cityId: 2114, code: "604505" },
    { id: 59601, cityId: 2114, code: "632511" },
    { id: 59602, cityId: 2114, code: "604601" },
    { id: 59603, cityId: 2114, code: "604404" },
    { id: 59604, cityId: 2114, code: "632314" },
    { id: 59605, cityId: 2114, code: "606710" },
    { id: 59606, cityId: 2114, code: "635703" },
    { id: 59607, cityId: 2114, code: "606806" },
    { id: 59608, cityId: 2114, code: "606754" },
    { id: 59609, cityId: 2114, code: "632301" },
    { id: 59610, cityId: 2114, code: "606805" },
    { id: 59611, cityId: 2114, code: "606603" },
    { id: 59612, cityId: 2114, code: "606901" },
    { id: 59613, cityId: 2114, code: "632313" },
    { id: 59614, cityId: 2114, code: "606907" },
    { id: 59615, cityId: 2114, code: "631702" },
    { id: 59616, cityId: 2114, code: "606751" },
    { id: 59617, cityId: 2114, code: "606802" },
    { id: 59618, cityId: 2114, code: "606903" },
    { id: 59619, cityId: 2114, code: "604401" },
    { id: 59620, cityId: 2114, code: "632311" },
    { id: 59621, cityId: 2114, code: "606707" },
    { id: 59622, cityId: 2114, code: "632317" },
    { id: 59623, cityId: 2114, code: "604503" },
    { id: 59624, cityId: 2114, code: "606752" },
    { id: 59625, cityId: 2114, code: "631701" },
    { id: 59626, cityId: 2114, code: "606701" },
    { id: 59627, cityId: 2114, code: "606904" },
    { id: 59628, cityId: 2114, code: "632316" },
    { id: 59629, cityId: 2114, code: "632507" },
    { id: 59630, cityId: 2114, code: "606753" },
    { id: 59631, cityId: 2114, code: "605702" },
    { id: 59632, cityId: 2114, code: "632319" },
    { id: 59633, cityId: 2114, code: "606702" },
    { id: 59634, cityId: 2114, code: "606905" },
    { id: 59635, cityId: 2114, code: "606708" },
    { id: 59636, cityId: 2114, code: "604406" },
    { id: 59637, cityId: 2114, code: "604402" },
    { id: 59638, cityId: 2114, code: "604501" },
    { id: 59639, cityId: 2114, code: "632312" },
    { id: 59640, cityId: 2114, code: "606601" },
    { id: 59641, cityId: 2114, code: "604407" },
    { id: 59642, cityId: 2114, code: "606709" },
    { id: 59643, cityId: 2114, code: "606906" },
    { id: 59644, cityId: 2114, code: "606703" },
    { id: 59645, cityId: 2114, code: "606804" },
    { id: 59646, cityId: 2114, code: "606611" },
    { id: 59647, cityId: 2135, code: "635601" },
    { id: 59648, cityId: 2135, code: "632506" },
    { id: 59649, cityId: 2135, code: "635652" },
    { id: 59650, cityId: 2135, code: "632011" },
    { id: 59651, cityId: 2135, code: "635654" },
    { id: 59652, cityId: 2135, code: "635901" },
    { id: 59653, cityId: 2135, code: "631052" },
    { id: 59654, cityId: 2135, code: "632518" },
    { id: 59655, cityId: 2135, code: "632512" },
    { id: 59656, cityId: 2135, code: "631002" },
    { id: 59657, cityId: 2135, code: "635754" },
    { id: 59658, cityId: 2135, code: "635809" },
    { id: 59659, cityId: 2135, code: "635752" },
    { id: 59660, cityId: 2135, code: "632013" },
    { id: 59661, cityId: 2135, code: "635701" },
    { id: 59662, cityId: 2135, code: "632501" },
    { id: 59663, cityId: 2135, code: "632311" },
    { id: 59664, cityId: 2135, code: "632007" },
    { id: 59665, cityId: 2135, code: "635802" },
    { id: 59666, cityId: 2135, code: "632521" },
    { id: 59667, cityId: 2135, code: "635811" },
    { id: 59668, cityId: 2135, code: "635655" },
    { id: 59669, cityId: 2135, code: "632008" },
    { id: 59670, cityId: 2135, code: "631051" },
    { id: 59671, cityId: 2146, code: "626134" },
    { id: 59672, cityId: 2146, code: "626126" },
    { id: 59673, cityId: 2146, code: "626203" },
    { id: 59674, cityId: 2146, code: "626121" },
    { id: 59675, cityId: 2146, code: "626201" },
    { id: 59676, cityId: 2167, code: "313603" },
    { id: 59677, cityId: 2167, code: "313027" },
    { id: 59678, cityId: 2167, code: "313003" },
    { id: 59679, cityId: 2167, code: "313002" },
    { id: 59680, cityId: 2167, code: "313605" },
    { id: 59681, cityId: 2169, code: "283104" },
    { id: 59682, cityId: 2169, code: "283123" },
    { id: 59683, cityId: 2169, code: "202124" },
    { id: 59684, cityId: 2169, code: "283110" },
    { id: 59685, cityId: 2169, code: "283111" },
    { id: 59686, cityId: 2174, code: "202127" },
    { id: 59687, cityId: 2174, code: "202132" },
    { id: 59688, cityId: 2174, code: "202124" },
    { id: 59689, cityId: 2174, code: "202002" },
    { id: 59690, cityId: 2174, code: "202129" },
    { id: 59691, cityId: 2174, code: "204213" },
    { id: 59692, cityId: 2174, code: "204102" },
    { id: 59693, cityId: 2174, code: "202123" },
    { id: 59694, cityId: 2175, code: "212402" },
    { id: 59695, cityId: 2175, code: "212104" },
    { id: 59696, cityId: 2175, code: "221503" },
    { id: 59697, cityId: 2175, code: "212109" },
    { id: 59698, cityId: 2175, code: "212507" },
    { id: 59699, cityId: 2175, code: "212218" },
    { id: 59700, cityId: 2175, code: "212108" },
    { id: 59701, cityId: 2175, code: "212203" },
    { id: 59702, cityId: 2175, code: "212201" },
    { id: 59703, cityId: 2175, code: "221502" },
    { id: 59704, cityId: 2175, code: "212217" },
    { id: 59705, cityId: 2177, code: "224135" },
    { id: 59706, cityId: 2177, code: "224143" },
    { id: 59707, cityId: 2177, code: "224208" },
    { id: 59708, cityId: 2177, code: "224157" },
    { id: 59709, cityId: 2177, code: "224284" },
    { id: 59710, cityId: 2177, code: "224127" },
    { id: 59711, cityId: 2177, code: "224151" },
    { id: 59712, cityId: 2177, code: "224189" },
    { id: 59713, cityId: 2177, code: "224181" },
    { id: 59714, cityId: 2177, code: "224121" },
    { id: 59715, cityId: 2177, code: "224205" },
    { id: 59716, cityId: 2177, code: "224186" },
    { id: 59717, cityId: 2177, code: "224159" },
    { id: 59718, cityId: 2177, code: "224129" },
    { id: 59719, cityId: 2177, code: "224132" },
    { id: 59720, cityId: 2177, code: "224172" },
    { id: 59721, cityId: 2177, code: "224202" },
    { id: 59722, cityId: 2177, code: "224137" },
    { id: 59723, cityId: 2177, code: "224234" },
    { id: 59724, cityId: 2177, code: "224123" },
    { id: 59725, cityId: 2177, code: "224161" },
    { id: 59726, cityId: 2177, code: "224183" },
    { id: 59727, cityId: 2177, code: "224153" },
    { id: 59728, cityId: 2177, code: "224210" },
    { id: 59729, cityId: 2177, code: "224145" },
    { id: 59730, cityId: 2177, code: "224229" },
    { id: 59731, cityId: 2177, code: "224164" },
    { id: 59732, cityId: 2177, code: "224125" },
    { id: 59733, cityId: 2177, code: "224182" },
    { id: 59734, cityId: 2177, code: "224152" },
    { id: 59735, cityId: 2177, code: "224133" },
    { id: 59736, cityId: 2177, code: "224190" },
    { id: 59737, cityId: 2177, code: "224209" },
    { id: 59738, cityId: 2177, code: "224228" },
    { id: 59739, cityId: 2177, code: "224171" },
    { id: 59740, cityId: 2177, code: "224201" },
    { id: 59741, cityId: 2177, code: "224139" },
    { id: 59742, cityId: 2177, code: "224158" },
    { id: 59743, cityId: 2177, code: "224155" },
    { id: 59744, cityId: 2177, code: "224147" },
    { id: 59745, cityId: 2177, code: "224203" },
    { id: 59746, cityId: 2177, code: "224122" },
    { id: 59747, cityId: 2177, code: "224149" },
    { id: 59748, cityId: 2177, code: "224206" },
    { id: 59749, cityId: 2177, code: "224141" },
    { id: 59750, cityId: 2177, code: "224168" },
    { id: 59751, cityId: 2177, code: "224195" },
    { id: 59752, cityId: 2177, code: "224207" },
    { id: 59753, cityId: 2191, code: "206248" },
    { id: 59754, cityId: 2191, code: "206129" },
    { id: 59755, cityId: 2191, code: "206249" },
    { id: 59756, cityId: 2191, code: "206121" },
    { id: 59757, cityId: 2191, code: "206243" },
    { id: 59758, cityId: 2191, code: "206251" },
    { id: 59759, cityId: 2191, code: "206246" },
    { id: 59760, cityId: 2191, code: "206241" },
    { id: 59761, cityId: 2191, code: "206252" },
    { id: 59762, cityId: 2191, code: "206244" },
    { id: 59763, cityId: 2191, code: "206247" },
    { id: 59764, cityId: 2191, code: "206250" },
    { id: 59765, cityId: 2192, code: "431120" },
    { id: 59766, cityId: 2192, code: "431118" },
    { id: 59767, cityId: 2192, code: "431134" },
    { id: 59768, cityId: 2192, code: "431007" },
    { id: 59769, cityId: 2192, code: "431150" },
    { id: 59770, cityId: 2192, code: "431010" },
    { id: 59771, cityId: 2192, code: "431109" },
    { id: 59772, cityId: 2192, code: "431106" },
    { id: 59773, cityId: 2192, code: "431112" },
    { id: 59774, cityId: 2192, code: "431103" },
    { id: 59775, cityId: 2192, code: "431008" },
    { id: 59776, cityId: 2192, code: "431154" },
    { id: 59777, cityId: 2192, code: "431135" },
    { id: 59778, cityId: 2192, code: "431151" },
    { id: 59779, cityId: 2192, code: "431132" },
    { id: 59780, cityId: 2192, code: "431113" },
    { id: 59781, cityId: 2192, code: "431202" },
    { id: 59782, cityId: 2192, code: "431107" },
    { id: 59783, cityId: 2192, code: "423701" },
    { id: 59784, cityId: 2192, code: "431117" },
    { id: 59785, cityId: 2192, code: "431101" },
    { id: 59786, cityId: 2192, code: "431136" },
    { id: 59787, cityId: 2192, code: "431114" },
    { id: 59788, cityId: 2195, code: "276404" },
    { id: 59789, cityId: 2195, code: "276204" },
    { id: 59790, cityId: 2195, code: "221603" },
    { id: 59791, cityId: 2195, code: "276141" },
    { id: 59792, cityId: 2195, code: "221706" },
    { id: 59793, cityId: 2195, code: "276306" },
    { id: 59794, cityId: 2195, code: "276305" },
    { id: 59795, cityId: 2195, code: "221602" },
    { id: 59796, cityId: 2195, code: "276206" },
    { id: 59797, cityId: 2195, code: "275305" },
    { id: 59798, cityId: 2195, code: "281401" },
    { id: 59799, cityId: 2195, code: "223223" },
    { id: 59800, cityId: 2195, code: "275301" },
    { id: 59801, cityId: 2195, code: "275304" },
    { id: 59802, cityId: 2195, code: "276405" },
    { id: 59803, cityId: 2195, code: "276202" },
    { id: 59804, cityId: 2207, code: "271802" },
    { id: 59805, cityId: 2207, code: "271865" },
    { id: 59806, cityId: 2207, code: "271904" },
    { id: 59807, cityId: 2207, code: "271870" },
    { id: 59808, cityId: 2207, code: "271841" },
    { id: 59809, cityId: 2207, code: "271804" },
    { id: 59810, cityId: 2207, code: "271845" },
    { id: 59811, cityId: 2207, code: "271871" },
    { id: 59812, cityId: 2211, code: "277202" },
    { id: 59813, cityId: 2211, code: "277303" },
    { id: 59814, cityId: 2211, code: "277211" },
    { id: 59815, cityId: 2211, code: "277216" },
    { id: 59816, cityId: 2211, code: "277209" },
    { id: 59817, cityId: 2212, code: "271203" },
    { id: 59818, cityId: 2212, code: "271209" },
    { id: 59819, cityId: 2212, code: "271206" },
    { id: 59820, cityId: 2212, code: "271504" },
    { id: 59821, cityId: 2212, code: "271204" },
    { id: 59822, cityId: 2212, code: "271210" },
    { id: 59823, cityId: 2212, code: "271207" },
    { id: 59824, cityId: 2212, code: "271307" },
    { id: 59825, cityId: 2212, code: "271604" },
    { id: 59826, cityId: 2212, code: "271861" },
    { id: 59827, cityId: 2212, code: "271607" },
    { id: 59828, cityId: 2212, code: "271306" },
    { id: 59829, cityId: 2212, code: "271208" },
    { id: 59830, cityId: 2213, code: "210208" },
    { id: 59831, cityId: 2213, code: "210129" },
    { id: 59832, cityId: 2213, code: "210121" },
    { id: 59833, cityId: 2213, code: "210207" },
    { id: 59834, cityId: 2213, code: "210128" },
    { id: 59835, cityId: 2219, code: "224120" },
    { id: 59836, cityId: 2219, code: "224117" },
    { id: 59837, cityId: 2219, code: "225414" },
    { id: 59838, cityId: 2219, code: "225301" },
    { id: 59839, cityId: 2219, code: "224118" },
    { id: 59840, cityId: 2219, code: "225122" },
    { id: 59841, cityId: 2219, code: "224119" },
    { id: 59842, cityId: 2219, code: "224116" },
    { id: 59843, cityId: 2222, code: "243503" },
    { id: 59844, cityId: 2222, code: "243303" },
    { id: 59845, cityId: 2222, code: "243003" },
    { id: 59846, cityId: 2222, code: "262406" },
    { id: 59847, cityId: 2222, code: "243504" },
    { id: 59848, cityId: 2222, code: "262203" },
    { id: 59849, cityId: 2222, code: "243505" },
    { id: 59850, cityId: 2222, code: "262201" },
    { id: 59851, cityId: 2222, code: "262302" },
    { id: 59852, cityId: 2226, code: "272171" },
    { id: 59853, cityId: 2226, code: "272126" },
    { id: 59854, cityId: 2226, code: "272175" },
    { id: 59855, cityId: 2226, code: "272194" },
    { id: 59856, cityId: 2226, code: "271305" },
    { id: 59857, cityId: 2226, code: "272153" },
    { id: 59858, cityId: 2226, code: "272170" },
    { id: 59859, cityId: 2226, code: "272129" },
    { id: 59860, cityId: 2226, code: "272148" },
    { id: 59861, cityId: 2237, code: "246723" },
    { id: 59862, cityId: 2237, code: "246731" },
    { id: 59863, cityId: 2237, code: "246761" },
    { id: 59864, cityId: 2237, code: "246747" },
    { id: 59865, cityId: 2237, code: "246728" },
    { id: 59866, cityId: 2237, code: "246749" },
    { id: 59867, cityId: 2237, code: "246722" },
    { id: 59868, cityId: 2237, code: "246725" },
    { id: 59869, cityId: 2237, code: "246724" },
    { id: 59870, cityId: 2237, code: "246763" },
    { id: 59871, cityId: 2237, code: "246733" },
    { id: 59872, cityId: 2237, code: "246732" },
    { id: 59873, cityId: 2237, code: "246762" },
    { id: 59874, cityId: 2237, code: "246735" },
    { id: 59875, cityId: 2237, code: "246727" },
    { id: 59876, cityId: 2237, code: "246746" },
    { id: 59877, cityId: 2237, code: "246726" },
    { id: 59878, cityId: 2237, code: "246745" },
    { id: 59879, cityId: 2237, code: "246734" },
    { id: 59880, cityId: 2237, code: "246721" },
    { id: 59881, cityId: 2250, code: "243634" },
    { id: 59882, cityId: 2250, code: "243637" },
    { id: 59883, cityId: 2250, code: "243636" },
    { id: 59884, cityId: 2250, code: "243639" },
    { id: 59885, cityId: 2250, code: "243631" },
    { id: 59886, cityId: 2250, code: "243638" },
    { id: 59887, cityId: 2250, code: "243641" },
    { id: 59888, cityId: 2250, code: "243633" },
    { id: 59889, cityId: 2250, code: "243635" },
    { id: 59890, cityId: 2250, code: "243632" },
    { id: 59891, cityId: 2253, code: "203141" },
    { id: 59892, cityId: 2253, code: "203201" },
    { id: 59893, cityId: 2256, code: "232111" },
    { id: 59894, cityId: 2256, code: "232103" },
    { id: 59895, cityId: 2256, code: "232108" },
    { id: 59896, cityId: 2256, code: "232118" },
    { id: 59897, cityId: 2256, code: "232107" },
    { id: 59898, cityId: 2256, code: "232109" },
    { id: 59899, cityId: 2256, code: "232101" },
    { id: 59900, cityId: 2256, code: "232120" },
    { id: 59901, cityId: 2256, code: "232106" },
    { id: 59902, cityId: 2256, code: "232110" },
    { id: 59903, cityId: 2261, code: "210207" },
    { id: 59904, cityId: 2261, code: "210204" },
    { id: 59905, cityId: 2261, code: "210202" },
    { id: 59906, cityId: 2261, code: "210205" },
    { id: 59907, cityId: 2261, code: "210206" },
    { id: 59908, cityId: 2261, code: "210203" },
    { id: 59909, cityId: 2261, code: "210208" },
    { id: 59910, cityId: 2261, code: "210209" },
    { id: 59911, cityId: 2272, code: "274509" },
    { id: 59912, cityId: 2272, code: "274204" },
    { id: 59913, cityId: 2272, code: "274506" },
    { id: 59914, cityId: 2272, code: "274405" },
    { id: 59915, cityId: 2272, code: "274402" },
    { id: 59916, cityId: 2272, code: "274202" },
    { id: 59917, cityId: 2280, code: "207248" },
    { id: 59918, cityId: 2280, code: "207402" },
    { id: 59919, cityId: 2280, code: "207242" },
    { id: 59920, cityId: 2280, code: "207123" },
    { id: 59921, cityId: 2280, code: "207245" },
    { id: 59922, cityId: 2280, code: "207125" },
    { id: 59923, cityId: 2280, code: "207247" },
    { id: 59924, cityId: 2280, code: "207244" },
    { id: 59925, cityId: 2280, code: "207401" },
    { id: 59926, cityId: 2280, code: "207301" },
    { id: 59927, cityId: 2280, code: "207249" },
    { id: 59928, cityId: 2280, code: "207241" },
    { id: 59929, cityId: 2280, code: "207122" },
    { id: 59930, cityId: 2280, code: "207246" },
    { id: 59931, cityId: 2280, code: "207124" },
    { id: 59932, cityId: 2280, code: "207121" },
    { id: 59933, cityId: 2280, code: "207243" },
    { id: 59934, cityId: 2280, code: "207403" },
    { id: 59935, cityId: 2281, code: "206124" },
    { id: 59936, cityId: 2281, code: "206126" },
    { id: 59937, cityId: 2281, code: "206127" },
    { id: 59938, cityId: 2281, code: "206242" },
    { id: 59939, cityId: 2281, code: "206131" },
    { id: 59940, cityId: 2281, code: "206253" },
    { id: 59941, cityId: 2281, code: "206123" },
    { id: 59942, cityId: 2281, code: "206120" },
    { id: 59943, cityId: 2281, code: "206128" },
    { id: 59944, cityId: 2281, code: "206125" },
    { id: 59945, cityId: 2281, code: "206130" },
    { id: 59946, cityId: 2281, code: "206003" },
    { id: 59947, cityId: 2283, code: "224117" },
    { id: 59948, cityId: 2283, code: "224284" },
    { id: 59949, cityId: 2283, code: "224158" },
    { id: 59950, cityId: 2283, code: "224120" },
    { id: 59951, cityId: 2283, code: "224204" },
    { id: 59952, cityId: 2283, code: "224228" },
    { id: 59953, cityId: 2283, code: "224126" },
    { id: 59954, cityId: 2283, code: "224118" },
    { id: 59955, cityId: 2283, code: "224164" },
    { id: 59956, cityId: 2283, code: "224229" },
    { id: 59957, cityId: 2283, code: "224135" },
    { id: 59958, cityId: 2283, code: "224119" },
    { id: 59959, cityId: 2283, code: "224116" },
    { id: 59960, cityId: 2283, code: "224189" },
    { id: 59961, cityId: 2283, code: "224234" },
    { id: 59962, cityId: 2286, code: "125051" },
    { id: 59963, cityId: 2286, code: "125111" },
    { id: 59964, cityId: 2286, code: "125120" },
    { id: 59965, cityId: 2286, code: "125052" },
    { id: 59966, cityId: 2286, code: "125048" },
    { id: 59967, cityId: 2286, code: "125113" },
    { id: 59968, cityId: 2286, code: "125053" },
    { id: 59969, cityId: 2286, code: "125106" },
    { id: 59970, cityId: 2288, code: "212655" },
    { id: 59971, cityId: 2288, code: "212621" },
    { id: 59972, cityId: 2288, code: "212635" },
    { id: 59973, cityId: 2290, code: "283204" },
    { id: 59974, cityId: 2290, code: "283103" },
    { id: 59975, cityId: 2290, code: "207301" },
    { id: 59976, cityId: 2290, code: "205262" },
    { id: 59977, cityId: 2300, code: "201303" },
    { id: 59978, cityId: 2300, code: "245201" },
    { id: 59979, cityId: 2300, code: "201301" },
    { id: 59980, cityId: 2300, code: "201102" },
    { id: 59981, cityId: 2300, code: "201204" },
    { id: 59982, cityId: 2301, code: "232329" },
    { id: 59983, cityId: 2301, code: "275204" },
    { id: 59984, cityId: 2301, code: "275201" },
    { id: 59985, cityId: 2301, code: "233223" },
    { id: 59986, cityId: 2306, code: "271504" },
    { id: 59987, cityId: 2306, code: "271208" },
    { id: 59988, cityId: 2306, code: "271303" },
    { id: 59989, cityId: 2306, code: "271604" },
    { id: 59990, cityId: 2306, code: "271308" },
    { id: 59991, cityId: 2306, code: "271124" },
    { id: 59992, cityId: 2309, code: "273402" },
    { id: 59993, cityId: 2309, code: "273163" },
    { id: 59994, cityId: 2309, code: "273403" },
    { id: 59995, cityId: 2316, code: "210505" },
    { id: 59996, cityId: 2316, code: "210427" },
    { id: 59997, cityId: 2316, code: "210501" },
    { id: 59998, cityId: 2319, code: "241403" },
    { id: 59999, cityId: 2319, code: "241303" },
    { id: 60000, cityId: 2319, code: "241124" },
    { id: 60001, cityId: 2319, code: "241404" },
    { id: 60002, cityId: 2319, code: "241304" },
    { id: 60003, cityId: 2319, code: "241301" },
    { id: 60004, cityId: 2319, code: "241204" },
    { id: 60005, cityId: 2319, code: "241302" },
    { id: 60006, cityId: 2319, code: "241123" },
    { id: 60007, cityId: 2319, code: "241305" },
    { id: 60008, cityId: 2327, code: "204214" },
    { id: 60009, cityId: 2327, code: "281307" },
    { id: 60010, cityId: 2327, code: "204211" },
    { id: 60011, cityId: 2327, code: "281306" },
    { id: 60012, cityId: 2327, code: "204216" },
    { id: 60013, cityId: 2327, code: "204213" },
    { id: 60014, cityId: 2327, code: "202002" },
    { id: 60015, cityId: 2327, code: "281001" },
    { id: 60016, cityId: 2327, code: "281308" },
    { id: 60017, cityId: 2327, code: "202139" },
    { id: 60018, cityId: 2327, code: "202121" },
    { id: 60019, cityId: 2327, code: "204212" },
    { id: 60020, cityId: 2335, code: "284303" },
    { id: 60021, cityId: 2335, code: "284306" },
    { id: 60022, cityId: 2335, code: "284204" },
    { id: 60023, cityId: 2335, code: "285204" },
    { id: 60024, cityId: 2335, code: "285206" },
    { id: 60025, cityId: 2335, code: "285127" },
    { id: 60026, cityId: 2335, code: "284203" },
    { id: 60027, cityId: 2335, code: "285129" },
    { id: 60028, cityId: 2335, code: "285126" },
    { id: 60029, cityId: 2339, code: "222165" },
    { id: 60030, cityId: 2339, code: "222161" },
    { id: 60031, cityId: 2339, code: "222203" },
    { id: 60032, cityId: 2342, code: "284302" },
    { id: 60033, cityId: 2342, code: "284121" },
    { id: 60034, cityId: 2342, code: "284123" },
    { id: 60035, cityId: 2342, code: "284203" },
    { id: 60036, cityId: 2342, code: "284205" },
    { id: 60037, cityId: 2342, code: "284306" },
    { id: 60038, cityId: 2342, code: "284303" },
    { id: 60039, cityId: 2342, code: "284304" },
    { id: 60040, cityId: 2342, code: "284405" },
    { id: 60041, cityId: 2342, code: "284202" },
    { id: 60042, cityId: 2342, code: "285125" },
    { id: 60043, cityId: 2342, code: "285205" },
    { id: 60044, cityId: 2352, code: "209738" },
    { id: 60045, cityId: 2352, code: "209722" },
    { id: 60046, cityId: 2352, code: "209733" },
    { id: 60047, cityId: 2352, code: "209736" },
    { id: 60048, cityId: 2352, code: "209728" },
    { id: 60049, cityId: 2352, code: "209731" },
    { id: 60050, cityId: 2352, code: "209721" },
    { id: 60051, cityId: 2352, code: "209726" },
    { id: 60052, cityId: 2352, code: "209723" },
    { id: 60053, cityId: 2352, code: "209727" },
    { id: 60054, cityId: 2352, code: "209734" },
    { id: 60055, cityId: 2352, code: "209729" },
    { id: 60056, cityId: 2360, code: "212202" },
    { id: 60057, cityId: 2360, code: "212205" },
    { id: 60058, cityId: 2360, code: "212208" },
    { id: 60059, cityId: 2360, code: "211011" },
    { id: 60060, cityId: 2360, code: "212216" },
    { id: 60061, cityId: 2360, code: "212213" },
    { id: 60062, cityId: 2360, code: "212217" },
    { id: 60063, cityId: 2360, code: "212201" },
    { id: 60064, cityId: 2360, code: "212401" },
    { id: 60065, cityId: 2360, code: "212507" },
    { id: 60066, cityId: 2360, code: "212204" },
    { id: 60067, cityId: 2360, code: "212206" },
    { id: 60068, cityId: 2360, code: "212214" },
    { id: 60069, cityId: 2370, code: "262803" },
    { id: 60070, cityId: 2370, code: "271855" },
    { id: 60071, cityId: 2370, code: "262805" },
    { id: 60072, cityId: 2370, code: "262804" },
    { id: 60073, cityId: 2370, code: "261501" },
    { id: 60074, cityId: 2370, code: "262728" },
    { id: 60075, cityId: 2382, code: "274206" },
    { id: 60076, cityId: 2382, code: "274302" },
    { id: 60077, cityId: 2382, code: "274406" },
    { id: 60078, cityId: 2382, code: "274305" },
    { id: 60079, cityId: 2382, code: "274409" },
    { id: 60080, cityId: 2382, code: "274301" },
    { id: 60081, cityId: 2382, code: "274203" },
    { id: 60082, cityId: 2382, code: "274304" },
    { id: 60083, cityId: 2382, code: "274401" },
    { id: 60084, cityId: 2382, code: "274306" },
    { id: 60085, cityId: 2382, code: "274407" },
    { id: 60086, cityId: 2382, code: "274303" },
    { id: 60087, cityId: 2382, code: "274207" },
    { id: 60088, cityId: 2387, code: "284122" },
    { id: 60089, cityId: 2395, code: "210424" },
    { id: 60090, cityId: 2395, code: "210425" },
    { id: 60091, cityId: 2395, code: "210433" },
    { id: 60092, cityId: 2395, code: "210431" },
    { id: 60093, cityId: 2395, code: "210504" },
    { id: 60094, cityId: 2395, code: "210423" },
    { id: 60095, cityId: 2395, code: "210507" },
    { id: 60096, cityId: 2395, code: "210429" },
    { id: 60097, cityId: 2395, code: "210421" },
    { id: 60098, cityId: 2399, code: "205301" },
    { id: 60099, cityId: 2399, code: "205265" },
    { id: 60100, cityId: 2399, code: "205264" },
    { id: 60101, cityId: 2407, code: "281404" },
    { id: 60102, cityId: 2407, code: "281204" },
    { id: 60103, cityId: 2407, code: "281201" },
    { id: 60104, cityId: 2407, code: "281305" },
    { id: 60105, cityId: 2407, code: "281303" },
    { id: 60106, cityId: 2407, code: "281301" },
    { id: 60107, cityId: 2407, code: "281504" },
    { id: 60108, cityId: 2407, code: "281405" },
    { id: 60109, cityId: 2411, code: "250404" },
    { id: 60110, cityId: 2411, code: "250221" },
    { id: 60111, cityId: 2416, code: "231301" },
    { id: 60112, cityId: 2416, code: "231210" },
    { id: 60113, cityId: 2416, code: "231211" },
    { id: 60114, cityId: 2422, code: "244301" },
    { id: 60115, cityId: 2422, code: "244501" },
    { id: 60116, cityId: 2422, code: "244601" },
    { id: 60117, cityId: 2422, code: "244923" },
    { id: 60118, cityId: 2422, code: "244235" },
    { id: 60119, cityId: 2422, code: "244925" },
    { id: 60120, cityId: 2428, code: "247773" },
    { id: 60121, cityId: 2428, code: "251319" },
    { id: 60122, cityId: 2428, code: "247771" },
    { id: 60123, cityId: 2428, code: "247778" },
    { id: 60124, cityId: 2428, code: "251309" },
    { id: 60125, cityId: 2428, code: "247772" },
    { id: 60126, cityId: 2428, code: "251318" },
    { id: 60127, cityId: 2428, code: "251201" },
    { id: 60128, cityId: 2428, code: "247774" },
    { id: 60129, cityId: 2428, code: "247777" },
    { id: 60130, cityId: 2441, code: "503322" },
    { id: 60131, cityId: 2441, code: "503217" },
    { id: 60132, cityId: 2447, code: "306105" },
    { id: 60133, cityId: 2447, code: "306702" },
    { id: 60134, cityId: 2447, code: "306422" },
    { id: 60135, cityId: 2451, code: "262202" },
    { id: 60136, cityId: 2451, code: "243003" },
    { id: 60137, cityId: 2451, code: "262203" },
    { id: 60138, cityId: 2451, code: "243123" },
    { id: 60139, cityId: 2455, code: "230131" },
    { id: 60140, cityId: 2455, code: "230002" },
    { id: 60141, cityId: 2455, code: "230132" },
    { id: 60142, cityId: 2455, code: "222301" },
    { id: 60143, cityId: 2455, code: "230135" },
    { id: 60144, cityId: 2455, code: "230403" },
    { id: 60145, cityId: 2455, code: "230501" },
    { id: 60146, cityId: 2466, code: "244922" },
    { id: 60147, cityId: 2466, code: "244925" },
    { id: 60148, cityId: 2466, code: "244924" },
    { id: 60149, cityId: 2466, code: "244921" },
    { id: 60150, cityId: 2466, code: "244701" },
    { id: 60151, cityId: 2466, code: "244923" },
    { id: 60152, cityId: 2466, code: "244926" },
    { id: 60153, cityId: 2479, code: "247342" },
    { id: 60154, cityId: 2479, code: "247340" },
    { id: 60155, cityId: 2479, code: "247452" },
    { id: 60156, cityId: 2479, code: "247341" },
    { id: 60157, cityId: 2500, code: "242405" },
    { id: 60158, cityId: 2500, code: "242305" },
    { id: 60159, cityId: 2508, code: "271831" },
    { id: 60160, cityId: 2508, code: "271870" },
    { id: 60161, cityId: 2508, code: "271845" },
    { id: 60162, cityId: 2508, code: "271201" },
    { id: 60163, cityId: 2508, code: "271802" },
    { id: 60164, cityId: 2508, code: "271821" },
    { id: 60165, cityId: 2508, code: "271875" },
    { id: 60166, cityId: 2508, code: "271804" },
    { id: 60167, cityId: 2508, code: "271865" },
    { id: 60168, cityId: 2509, code: "272204" },
    { id: 60169, cityId: 2509, code: "272207" },
    { id: 60170, cityId: 2509, code: "272191" },
    { id: 60171, cityId: 2509, code: "272194" },
    { id: 60172, cityId: 2509, code: "272206" },
    { id: 60173, cityId: 2509, code: "272152" },
    { id: 60174, cityId: 2509, code: "272153" },
    { id: 60175, cityId: 2509, code: "272201" },
    { id: 60176, cityId: 2509, code: "272154" },
    { id: 60177, cityId: 2509, code: "272208" },
    { id: 60178, cityId: 2509, code: "272151" },
    { id: 60179, cityId: 2509, code: "272205" },
    { id: 60180, cityId: 2509, code: "272148" },
    { id: 60181, cityId: 2509, code: "272129" },
    { id: 60182, cityId: 2509, code: "272202" },
    { id: 60183, cityId: 2517, code: "261131" },
    { id: 60184, cityId: 2517, code: "261204" },
    { id: 60185, cityId: 2517, code: "261201" },
    { id: 60186, cityId: 2517, code: "261141" },
    { id: 60187, cityId: 2517, code: "261202" },
    { id: 60188, cityId: 2517, code: "261135" },
    { id: 60189, cityId: 2517, code: "261403" },
    { id: 60190, cityId: 2518, code: "231216" },
    { id: 60191, cityId: 2518, code: "231208" },
    { id: 60192, cityId: 2518, code: "231205" },
    { id: 60193, cityId: 2518, code: "231221" },
    { id: 60194, cityId: 2518, code: "231225" },
    { id: 60195, cityId: 2518, code: "231222" },
    { id: 60196, cityId: 2518, code: "231213" },
    { id: 60197, cityId: 2518, code: "231206" },
    { id: 60198, cityId: 2518, code: "231219" },
    { id: 60199, cityId: 2518, code: "231218" },
    { id: 60200, cityId: 2518, code: "231210" },
    { id: 60201, cityId: 2518, code: "231207" },
    { id: 60202, cityId: 2518, code: "231215" },
    { id: 60203, cityId: 2518, code: "231223" },
    { id: 60204, cityId: 2518, code: "231217" },
    { id: 60205, cityId: 2518, code: "231209" },
    { id: 60206, cityId: 2518, code: "231220" },
    { id: 60207, cityId: 2520, code: "228131" },
    { id: 60208, cityId: 2520, code: "227405" },
    { id: 60209, cityId: 2520, code: "227413" },
    { id: 60210, cityId: 2520, code: "227808" },
    { id: 60211, cityId: 2520, code: "228120" },
    { id: 60212, cityId: 2520, code: "227805" },
    { id: 60213, cityId: 2520, code: "228145" },
    { id: 60214, cityId: 2520, code: "227813" },
    { id: 60215, cityId: 2536, code: "209825" },
    { id: 60216, cityId: 2536, code: "209861" },
    { id: 60217, cityId: 2536, code: "209859" },
    { id: 60218, cityId: 2536, code: "209101" },
    { id: 60219, cityId: 2540, code: "221302" },
    { id: 60220, cityId: 2540, code: "232105" },
    { id: 60221, cityId: 2540, code: "232102" },
    { id: 60222, cityId: 2540, code: "221304" },
    { id: 60223, cityId: 2540, code: "221204" },
    { id: 60224, cityId: 2540, code: "221306" },
    { id: 60225, cityId: 2540, code: "232104" },
    { id: 60226, cityId: 2540, code: "232103" },
    { id: 60227, cityId: 2540, code: "221401" },
    { id: 60228, cityId: 2547, code: "263138" },
    { id: 60229, cityId: 2547, code: "244715" },
    { id: 60230, cityId: 2547, code: "263629" },
    { id: 60231, cityId: 2547, code: "263653" },
    { id: 60232, cityId: 2549, code: "263641" },
    { id: 60233, cityId: 2549, code: "263679" },
    { id: 60234, cityId: 2549, code: "263631" },
    { id: 60235, cityId: 2549, code: "263628" },
    { id: 60236, cityId: 2549, code: "263630" },
    { id: 60237, cityId: 2549, code: "263633" },
    { id: 60238, cityId: 2549, code: "263635" },
    { id: 60239, cityId: 2549, code: "263624" },
    { id: 60240, cityId: 2549, code: "263640" },
    { id: 60241, cityId: 2549, code: "263634" },
    { id: 60242, cityId: 2556, code: "246443" },
    { id: 60243, cityId: 2556, code: "246473" },
    { id: 60244, cityId: 2556, code: "246435" },
    { id: 60245, cityId: 2556, code: "246427" },
    { id: 60246, cityId: 2556, code: "246481" },
    { id: 60247, cityId: 2556, code: "246422" },
    { id: 60248, cityId: 2556, code: "246449" },
    { id: 60249, cityId: 2556, code: "246487" },
    { id: 60250, cityId: 2556, code: "246428" },
    { id: 60251, cityId: 2556, code: "246482" },
    { id: 60252, cityId: 2556, code: "246441" },
    { id: 60253, cityId: 2556, code: "246474" },
    { id: 60254, cityId: 2556, code: "246444" },
    { id: 60255, cityId: 2556, code: "246455" },
    { id: 60256, cityId: 2556, code: "246440" },
    { id: 60257, cityId: 2556, code: "246429" },
    { id: 60258, cityId: 2556, code: "246426" },
    { id: 60259, cityId: 2556, code: "246431" },
    { id: 60260, cityId: 2556, code: "246401" },
    { id: 60261, cityId: 2556, code: "246472" },
    { id: 60262, cityId: 2556, code: "246488" },
    { id: 60263, cityId: 2556, code: "246453" },
    { id: 60264, cityId: 2556, code: "246446" },
    { id: 60265, cityId: 2557, code: "262310" },
    { id: 60266, cityId: 2557, code: "262580" },
    { id: 60267, cityId: 2557, code: "262525" },
    { id: 60268, cityId: 2557, code: "262528" },
    { id: 60269, cityId: 2557, code: "262308" },
    { id: 60270, cityId: 2557, code: "262524" },
    { id: 60271, cityId: 2557, code: "262527" },
    { id: 60272, cityId: 2561, code: "248142" },
    { id: 60273, cityId: 2561, code: "248123" },
    { id: 60274, cityId: 2561, code: "248140" },
    { id: 60275, cityId: 2561, code: "249201" },
    { id: 60276, cityId: 2561, code: "248179" },
    { id: 60277, cityId: 2561, code: "249205" },
    { id: 60278, cityId: 2561, code: "247670" },
    { id: 60279, cityId: 2606, code: "263140" },
    { id: 60280, cityId: 2606, code: "263137" },
    { id: 60281, cityId: 2606, code: "244713" },
    { id: 60282, cityId: 2606, code: "244715" },
    { id: 60283, cityId: 2606, code: "262580" },
    { id: 60284, cityId: 2606, code: "263132" },
    { id: 60285, cityId: 2606, code: "263136" },
    { id: 60286, cityId: 2606, code: "263139" },
    { id: 60287, cityId: 2619, code: "262551" },
    { id: 60288, cityId: 2619, code: "262554" },
    { id: 60289, cityId: 2619, code: "262523" },
    { id: 60290, cityId: 2621, code: "493526" },
    { id: 60291, cityId: 2621, code: "493196" },
    { id: 60292, cityId: 2621, code: "493101" },
    { id: 60293, cityId: 2621, code: "492014" },
    { id: 60294, cityId: 2621, code: "493888" },
    { id: 60295, cityId: 2621, code: "492099" },
    { id: 60296, cityId: 2621, code: "493441" },
    { id: 60297, cityId: 2621, code: "492013" },
    { id: 60298, cityId: 2621, code: "493118" },
    { id: 60299, cityId: 2621, code: "493229" },
    { id: 60300, cityId: 2621, code: "493663" },
    { id: 60301, cityId: 2621, code: "493222" },
    { id: 60302, cityId: 2621, code: "493195" },
    { id: 60303, cityId: 2621, code: "492002" },
    { id: 60304, cityId: 2621, code: "492101" },
    { id: 60305, cityId: 2621, code: "493113" },
    { id: 60306, cityId: 2621, code: "493331" },
    { id: 60307, cityId: 2621, code: "492010" },
    { id: 60308, cityId: 2621, code: "493221" },
    { id: 60309, cityId: 2624, code: "829131" },
    { id: 60310, cityId: 2624, code: "829118" },
    { id: 60311, cityId: 2624, code: "829150" },
    { id: 60312, cityId: 2624, code: "829125" },
    { id: 60313, cityId: 2624, code: "829119" },
    { id: 60314, cityId: 2624, code: "829106" },
    { id: 60315, cityId: 2624, code: "825330" },
    { id: 60316, cityId: 2624, code: "825101" },
    { id: 60317, cityId: 2624, code: "829143" },
    { id: 60318, cityId: 2624, code: "829105" },
    { id: 60319, cityId: 2624, code: "829130" },
    { id: 60320, cityId: 2624, code: "825325" },
    { id: 60321, cityId: 2624, code: "829110" },
    { id: 60322, cityId: 2624, code: "829117" },
    { id: 60323, cityId: 2624, code: "829129" },
    { id: 60324, cityId: 2624, code: "829108" },
    { id: 60325, cityId: 2624, code: "829133" },
    { id: 60326, cityId: 2624, code: "829102" },
    { id: 60327, cityId: 2624, code: "829126" },
    { id: 60328, cityId: 2624, code: "825316" },
    { id: 60329, cityId: 2624, code: "829101" },
    { id: 60330, cityId: 2624, code: "829103" },
    { id: 60331, cityId: 2624, code: "829135" },
    { id: 60332, cityId: 2624, code: "829122" },
    { id: 60333, cityId: 2624, code: "829109" },
    { id: 60334, cityId: 2624, code: "829134" },
    { id: 60335, cityId: 2624, code: "825314" },
    { id: 60336, cityId: 2634, code: "190020" },
    { id: 60337, cityId: 2634, code: "190025" },
    { id: 60338, cityId: 2634, code: "191103" },
    { id: 60339, cityId: 2634, code: "193401" },
    { id: 60340, cityId: 2634, code: "192121" },
    { id: 60341, cityId: 2634, code: "190019" },
    { id: 60342, cityId: 2634, code: "190024" },
    { id: 60343, cityId: 2634, code: "191201" },
    { id: 60344, cityId: 2637, code: "249165" },
    { id: 60345, cityId: 2637, code: "249131" },
    { id: 60346, cityId: 2637, code: "249196" },
    { id: 60347, cityId: 2637, code: "249128" },
    { id: 60348, cityId: 2647, code: "423701" },
    { id: 60349, cityId: 2647, code: "431113" },
    { id: 60350, cityId: 2647, code: "431132" },
    { id: 60351, cityId: 2647, code: "431151" },
    { id: 60352, cityId: 2647, code: "431202" },
    { id: 60353, cityId: 2647, code: "431101" },
    { id: 60354, cityId: 2647, code: "431120" },
    { id: 60355, cityId: 2647, code: "431107" },
    { id: 60356, cityId: 2647, code: "431009" },
    { id: 60357, cityId: 2647, code: "431006" },
    { id: 60358, cityId: 2647, code: "431136" },
    { id: 60359, cityId: 2647, code: "431114" },
    { id: 60360, cityId: 2647, code: "431150" },
    { id: 60361, cityId: 2647, code: "431112" },
    { id: 60362, cityId: 2647, code: "423703" },
    { id: 60363, cityId: 2647, code: "431117" },
    { id: 60364, cityId: 2647, code: "431134" },
    { id: 60365, cityId: 2647, code: "431118" },
    { id: 60366, cityId: 2647, code: "431109" },
    { id: 60367, cityId: 2647, code: "431154" },
    { id: 60368, cityId: 2647, code: "431010" },
    { id: 60369, cityId: 2647, code: "431007" },
    { id: 60370, cityId: 2647, code: "431103" },
    { id: 60371, cityId: 2647, code: "431008" },
    { id: 60372, cityId: 2647, code: "431135" },
    { id: 60373, cityId: 2667, code: "795124" },
    { id: 60374, cityId: 2667, code: "795118" },
    { id: 60375, cityId: 2667, code: "795126" },
    { id: 60376, cityId: 2667, code: "795133" },
    { id: 60377, cityId: 2667, code: "795134" },
    { id: 60378, cityId: 2767, code: "493101" },
    { id: 60379, cityId: 2767, code: "493888" },
    { id: 60380, cityId: 2767, code: "492014" },
    { id: 60381, cityId: 2767, code: "493526" },
    { id: 60382, cityId: 2767, code: "493196" },
    { id: 60383, cityId: 2767, code: "493118" },
    { id: 60384, cityId: 2767, code: "492010" },
    { id: 60385, cityId: 2767, code: "493663" },
    { id: 60386, cityId: 2767, code: "493222" },
    { id: 60387, cityId: 2767, code: "493441" },
    { id: 60388, cityId: 2767, code: "493113" },
    { id: 60389, cityId: 2767, code: "493221" },
    { id: 60390, cityId: 2767, code: "492002" },
    { id: 60391, cityId: 2767, code: "492101" },
    { id: 60392, cityId: 2769, code: "600106" },
    { id: 60393, cityId: 2769, code: "600118" },
    { id: 60394, cityId: 2779, code: "441901" },
    { id: 60395, cityId: 2779, code: "441701" },
    { id: 60396, cityId: 2779, code: "441806" },
    { id: 60397, cityId: 2779, code: "441916" },
    { id: 60398, cityId: 2779, code: "441807" },
    { id: 60399, cityId: 2779, code: "441902" },
    { id: 60400, cityId: 2779, code: "441702" },
    { id: 60401, cityId: 2779, code: "441911" },
    { id: 60402, cityId: 2779, code: "441601" },
    { id: 60403, cityId: 2779, code: "441801" },
    { id: 60404, cityId: 2784, code: "247663" },
    { id: 60405, cityId: 2784, code: "247671" },
    { id: 60406, cityId: 2784, code: "247668" },
    { id: 60407, cityId: 2784, code: "249403" },
    { id: 60408, cityId: 2784, code: "247661" },
    { id: 60409, cityId: 2784, code: "247665" },
    { id: 60410, cityId: 2784, code: "249410" },
    { id: 60411, cityId: 2784, code: "247670" },
    { id: 60412, cityId: 2784, code: "246763" },
    { id: 60413, cityId: 2784, code: "249404" },
    { id: 60414, cityId: 2784, code: "249407" },
    { id: 60415, cityId: 2784, code: "247662" },
    { id: 60416, cityId: 2784, code: "247667" },
    { id: 60417, cityId: 2784, code: "249408" },
    { id: 60418, cityId: 2784, code: "247664" },
    { id: 60419, cityId: 2784, code: "249402" },
    { id: 60420, cityId: 2784, code: "247656" },
    { id: 60421, cityId: 2784, code: "249405" },
    { id: 60422, cityId: 2788, code: "396215" },
    { id: 60423, cityId: 2792, code: "628620" },
    { id: 60424, cityId: 2792, code: "628252" },
    { id: 60425, cityId: 2792, code: "628151" },
    { id: 60426, cityId: 2792, code: "628601" },
    { id: 60427, cityId: 2792, code: "628614" },
    { id: 60428, cityId: 2792, code: "628303" },
    { id: 60429, cityId: 2792, code: "628201" },
    { id: 60430, cityId: 2792, code: "628753" },
    { id: 60431, cityId: 2792, code: "628202" },
    { id: 60432, cityId: 2792, code: "628215" },
    { id: 60433, cityId: 2792, code: "627758" },
    { id: 60434, cityId: 2792, code: "628703" },
    { id: 60435, cityId: 2792, code: "628621" },
    { id: 60436, cityId: 2792, code: "628101" },
    { id: 60437, cityId: 2792, code: "628304" },
    { id: 60438, cityId: 2792, code: "628219" },
    { id: 60439, cityId: 2792, code: "628612" },
    { id: 60440, cityId: 2792, code: "628301" },
    { id: 60441, cityId: 2792, code: "628752" },
    { id: 60442, cityId: 2792, code: "628701" },
    { id: 60443, cityId: 2792, code: "628206" },
    { id: 60444, cityId: 2792, code: "626202" },
    { id: 60445, cityId: 2792, code: "628213" },
    { id: 60446, cityId: 2792, code: "628105" },
    { id: 60447, cityId: 2792, code: "628302" },
    { id: 60448, cityId: 2792, code: "628613" },
    { id: 60449, cityId: 2792, code: "628619" },
    { id: 60450, cityId: 2792, code: "628702" },
    { id: 60451, cityId: 2792, code: "628251" },
    { id: 60452, cityId: 2792, code: "628207" },
    { id: 60453, cityId: 2792, code: "628802" },
    { id: 60454, cityId: 2792, code: "628402" },
    { id: 60455, cityId: 2792, code: "628103" },
    { id: 60456, cityId: 2792, code: "628623" },
    { id: 60457, cityId: 2792, code: "628801" },
    { id: 60458, cityId: 2792, code: "628617" },
    { id: 60459, cityId: 2792, code: "628401" },
    { id: 60460, cityId: 2792, code: "628205" },
    { id: 60461, cityId: 2792, code: "628656" },
    { id: 60462, cityId: 2792, code: "628104" },
    { id: 60463, cityId: 2792, code: "628218" },
    { id: 60464, cityId: 2792, code: "628622" },
    { id: 60465, cityId: 2792, code: "628618" },
    { id: 60466, cityId: 2792, code: "628751" },
    { id: 60467, cityId: 2792, code: "628216" },
    { id: 60468, cityId: 2792, code: "628704" },
    { id: 60469, cityId: 2792, code: "628653" },
    { id: 60470, cityId: 2792, code: "628615" },
    { id: 60471, cityId: 2792, code: "628552" },
    { id: 60472, cityId: 2792, code: "628502" },
    { id: 60473, cityId: 2792, code: "628209" },
    { id: 60474, cityId: 2792, code: "628152" },
    { id: 60475, cityId: 2792, code: "626205" },
    { id: 60476, cityId: 2792, code: "628203" },
    { id: 60477, cityId: 2792, code: "628102" },
    { id: 60478, cityId: 2792, code: "628616" },
    { id: 60479, cityId: 2792, code: "628204" },
    { id: 60480, cityId: 2792, code: "628210" },
    { id: 60481, cityId: 2792, code: "627855" },
    { id: 60482, cityId: 2792, code: "628208" },
    { id: 60483, cityId: 2792, code: "628217" },
    { id: 60484, cityId: 2792, code: "628211" },
    { id: 60485, cityId: 2800, code: "829134" },
    { id: 60486, cityId: 2800, code: "825314" },
    { id: 60487, cityId: 2800, code: "829103" },
    { id: 60488, cityId: 2800, code: "829122" },
    { id: 60489, cityId: 2800, code: "829109" },
    { id: 60490, cityId: 2800, code: "825326" },
    { id: 60491, cityId: 2800, code: "829110" },
    { id: 60492, cityId: 2800, code: "829135" },
    { id: 60493, cityId: 2800, code: "829126" },
    { id: 60494, cityId: 2800, code: "829129" },
    { id: 60495, cityId: 2800, code: "829133" },
    { id: 60496, cityId: 2800, code: "829102" },
    { id: 60497, cityId: 2800, code: "829108" },
    { id: 60498, cityId: 2800, code: "825316" },
    { id: 60499, cityId: 2800, code: "829101" },
    { id: 60500, cityId: 2800, code: "829131" },
    { id: 60501, cityId: 2800, code: "829125" },
    { id: 60502, cityId: 2800, code: "829106" },
    { id: 60503, cityId: 2800, code: "829118" },
    { id: 60504, cityId: 2800, code: "825330" },
    { id: 60505, cityId: 2800, code: "825101" },
    { id: 60506, cityId: 2800, code: "829119" },
    { id: 60507, cityId: 2800, code: "829117" },
    { id: 60508, cityId: 2800, code: "825325" },
    { id: 60509, cityId: 2800, code: "829130" },
    { id: 60510, cityId: 2800, code: "829143" },
    { id: 60511, cityId: 2800, code: "829105" },
    { id: 60512, cityId: 2808, code: "140201" },
    { id: 60513, cityId: 2808, code: "140109" },
    { id: 60514, cityId: 2808, code: "140112" },
    { id: 60515, cityId: 2808, code: "140307" },
    { id: 60516, cityId: 2808, code: "160003" },
    { id: 60517, cityId: 2808, code: "140413" },
    { id: 60518, cityId: 2808, code: "140110" },
    { id: 60519, cityId: 2808, code: "140901" },
    { id: 60520, cityId: 2808, code: "140603" },
    { id: 60521, cityId: 2808, code: "140506" },
    { id: 60522, cityId: 2808, code: "140103" },
    { id: 60523, cityId: 2808, code: "140301" },
    { id: 60524, cityId: 2808, code: "140501" },
    { id: 60525, cityId: 1925, code: "631502" },
    { id: 60526, cityId: 1925, code: "631555" },
    { id: 60527, cityId: 2145, code: "604206" },
    { id: 60528, cityId: 2105, code: "628215" },
    { id: 60529, cityId: 2843, code: "797106" },
    { id: 60530, cityId: 170, code: "781038" },
    { id: 60531, cityId: 1880, code: "600077" },
    { id: 60532, cityId: 382, code: "110087" },
    { id: 60533, cityId: 49, code: "500050" },
    { id: 60534, cityId: 49, code: "500010" },
    { id: 60535, cityId: 818, code: "577006" },
    { id: 60536, cityId: 950, code: "581315" },
    { id: 60537, cityId: 781, code: "560114" },
    { id: 60538, cityId: 2641, code: "743125" },
    { id: 60539, cityId: 2844, code: "832301" },
    { id: 60540, cityId: 2845, code: "797101" },
    { id: 60541, cityId: 2105, code: "628103" },
    { id: 60542, cityId: 76, code: "502313" },
    { id: 60543, cityId: 1880, code: "600128" },
    { id: 60544, cityId: 1530, code: "754208" },
    { id: 60545, cityId: 1530, code: "754203" },
    { id: 60546, cityId: 2846, code: "793150" },
    { id: 60547, cityId: 2847, code: "793200" },
    { id: 60548, cityId: 2847, code: "793210" },
    { id: 60549, cityId: 2848, code: "793150" },
    { id: 60550, cityId: 49, code: "500083" },
    { id: 60551, cityId: 49, code: "500092" },
    { id: 60552, cityId: 119, code: "520007" },
    { id: 60553, cityId: 122, code: "535003" },
    { id: 60554, cityId: 2641, code: "700036" },
    { id: 60555, cityId: 2849, code: "486889" },
    { id: 60556, cityId: 2105, code: "628216" },
    { id: 60557, cityId: 2851, code: "793008" },
    { id: 60558, cityId: 2851, code: "793017" },
    { id: 60559, cityId: 2851, code: "793022" },
    { id: 60560, cityId: 1880, code: "601203" },
    { id: 60561, cityId: 99, code: "501158" },
    { id: 60562, cityId: 1485, code: "794101" },
    { id: 60563, cityId: 1880, code: "600123" },
    { id: 60564, cityId: 950, code: "581402" },
    { id: 60565, cityId: 950, code: "581402" },
    { id: 60566, cityId: 950, code: "581355" },
    { id: 60567, cityId: 926, code: "562126" },
    { id: 60568, cityId: 382, code: "110078" },
    { id: 60569, cityId: 382, code: "110077" },
    { id: 60570, cityId: 382, code: "110089" },
    { id: 60571, cityId: 382, code: "110088" },
    { id: 60572, cityId: 781, code: "560092" },
    { id: 60573, cityId: 2175, code: "283114" },
    { id: 60574, cityId: 2261, code: "210205" },
    { id: 60575, cityId: 1485, code: "794108" },
    { id: 60576, cityId: 1462, code: "795101" },
    { id: 60577, cityId: 902, code: "575022" },
    { id: 60578, cityId: 1925, code: "603201" },
    { id: 60579, cityId: 1880, code: "600123" },
    { id: 60580, cityId: 1247, code: "414003" },
    { id: 60581, cityId: 2852, code: "389220" },
    { id: 60582, cityId: 2853, code: "370020" },
    { id: 60583, cityId: 382, code: "110077" },
    { id: 60584, cityId: 2794, code: "402304" },
    { id: 60585, cityId: 2854, code: "410222" },
    { id: 60586, cityId: 2855, code: "402120" },
    { id: 60587, cityId: 1367, code: "400102" },
    { id: 60588, cityId: 1925, code: "631601" },
    { id: 60589, cityId: 2145, code: "604303" },
    { id: 60590, cityId: 2071, code: "623704" },
    { id: 60591, cityId: 2103, code: "601103" },
    { id: 60592, cityId: 2103, code: "631208" },
    { id: 60593, cityId: 2641, code: "743352" },
    { id: 60594, cityId: 2641, code: "700028" },
    { id: 60595, cityId: 2856, code: "765001" },
    { id: 60596, cityId: 2856, code: "765002" },
    { id: 60597, cityId: 2856, code: "765003" },
    { id: 60598, cityId: 2856, code: "765004" },
    { id: 60599, cityId: 2856, code: "765005" },
    { id: 60600, cityId: 2856, code: "765006" },
    { id: 60601, cityId: 2856, code: "765007" },
    { id: 60602, cityId: 2856, code: "765008" },
    { id: 60603, cityId: 2856, code: "765009" },
    { id: 60604, cityId: 2856, code: "765010" },
    { id: 60605, cityId: 2856, code: "765011" },
    { id: 60606, cityId: 2856, code: "765012" },
    { id: 60607, cityId: 2856, code: "765013" },
    { id: 60608, cityId: 2856, code: "765014" },
    { id: 60609, cityId: 2856, code: "765015" },
    { id: 60610, cityId: 2856, code: "765016" },
    { id: 60611, cityId: 2856, code: "765017" },
    { id: 60612, cityId: 2856, code: "765018" },
    { id: 60613, cityId: 2856, code: "765019" },
    { id: 60614, cityId: 2856, code: "765020" },
    { id: 60615, cityId: 2856, code: "765021" },
    { id: 60616, cityId: 2856, code: "765022" },
    { id: 60617, cityId: 2856, code: "765023" },
    { id: 60618, cityId: 2856, code: "765024" },
    { id: 60619, cityId: 2856, code: "765025" },
    { id: 60620, cityId: 2856, code: "765026" },
    { id: 60621, cityId: 2856, code: "765027" },
    { id: 60622, cityId: 2856, code: "765028" },
    { id: 60623, cityId: 2856, code: "765029" },
    { id: 60624, cityId: 2856, code: "765030" },
    { id: 60625, cityId: 2105, code: "628202" },
    { id: 60626, cityId: 447, code: "382421" },
    { id: 60627, cityId: 2103, code: "631209" },
    { id: 60628, cityId: 1567, code: "751016" },
    { id: 60629, cityId: 610, code: "135101" },
    { id: 60630, cityId: 1925, code: "603310" },
    { id: 60631, cityId: 2857, code: "757025" },
    { id: 60632, cityId: 1880, code: "600130" },
    { id: 60633, cityId: 447, code: "382845" },
    { id: 60640, cityId: 405, code: "382422" },
    { id: 60641, cityId: 405, code: "382423" },
    { id: 60642, cityId: 405, code: "382424" },
    { id: 60643, cityId: 405, code: "382470" },
    { id: 60644, cityId: 405, code: "382481" },
    { id: 60645, cityId: 2782, code: "641601" },
    { id: 60646, cityId: 2782, code: "641602" },
    { id: 60647, cityId: 2782, code: "641603" },
    { id: 60648, cityId: 2782, code: "641604" },
    { id: 60649, cityId: 2782, code: "641606" },
    { id: 60650, cityId: 2782, code: "641607" },
    { id: 60651, cityId: 2782, code: "641652" },
    { id: 60652, cityId: 2782, code: "641687" },
    { id: 60653, cityId: 2782, code: "641666" },
    { id: 60654, cityId: 2782, code: "642113" },
    { id: 60655, cityId: 2782, code: "642007" },
    { id: 60656, cityId: 2782, code: "628204" },
    { id: 60657, cityId: 2782, code: "638109" },
    { id: 60658, cityId: 2782, code: "639201" },
    { id: 60659, cityId: 2782, code: "638051" },
    { id: 60660, cityId: 2782, code: "641654" },
    { id: 60661, cityId: 2782, code: "638105" },
    { id: 60662, cityId: 2782, code: "638701" },
    { id: 60663, cityId: 1880, code: "601301" },
    { id: 60664, cityId: 447, code: "382355" },
    { id: 60665, cityId: 2860, code: "383310" },
    { id: 60666, cityId: 2860, code: "383316" },
    { id: 60667, cityId: 818, code: "577005" },
    { id: 60668, cityId: 806, code: "562101" },
    { id: 60669, cityId: 786, code: "574222" },
    { id: 60670, cityId: 902, code: "575023" },
    { id: 60671, cityId: 2861, code: "796431" },
    { id: 60672, cityId: 2861, code: "796441" },
    { id: 60673, cityId: 2861, code: "799271" },
    { id: 60674, cityId: 2861, code: "796501" },
    { id: 60675, cityId: 1487, code: "796036" },
    { id: 60676, cityId: 2861, code: "796008" },
    { id: 60677, cityId: 2861, code: "796014" },
    { id: 60678, cityId: 2861, code: "796691" },
    { id: 60679, cityId: 1487, code: "796261" },
    { id: 60680, cityId: 1492, code: "796014" },
    { id: 60681, cityId: 1493, code: "796810" },
    { id: 60682, cityId: 1485, code: "794115" },
    { id: 60683, cityId: 902, code: "575018" },
    { id: 60684, cityId: 902, code: "574509" },
    { id: 60685, cityId: 1484, code: "793016" },
    { id: 60686, cityId: 370, code: "492001" },
    { id: 60687, cityId: 2862, code: "394380" },
    { id: 60688, cityId: 2863, code: "755007" },
    { id: 60689, cityId: 2864, code: "755019" },
    { id: 60690, cityId: 1247, code: "413705" },
    { id: 60691, cityId: 2852, code: "389260" },
    { id: 60692, cityId: 2353, code: "208026" },
    { id: 60694, cityId: 2845, code: "797104" },
    { id: 60695, cityId: 2822, code: "796625" },
    { id: 60696, cityId: 1880, code: "600126" },
    { id: 60697, cityId: 1880, code: "600088" },
    { id: 60698, cityId: 1864, code: "603202" },
    { id: 60699, cityId: 2091, code: "602105" },
    { id: 60700, cityId: 2111, code: "627006" },
    { id: 60701, cityId: 1878, code: "603405" },
    { id: 60702, cityId: 1880, code: "600129" },
    { id: 60703, cityId: 99, code: "500089" },
    { id: 60704, cityId: 886, code: "581332" },
    { id: 60705, cityId: 961, code: "572202" },
    { id: 60706, cityId: 853, code: "580030" },
    { id: 60707, cityId: 818, code: "577002" },
    { id: 60708, cityId: 818, code: "577004" },
    { id: 60709, cityId: 774, code: "573104" },
    { id: 60710, cityId: 2865, code: "410201" },
    { id: 60711, cityId: 2866, code: "370205" },
    { id: 60712, cityId: 2860, code: "383310" },
    { id: 60713, cityId: 2860, code: "383316" },
    { id: 60714, cityId: 2867, code: "385535" },
    { id: 60715, cityId: 964, code: "572136" },
    { id: 60716, cityId: 2782, code: "642126" },
    { id: 60717, cityId: 926, code: "562159" },
    { id: 60718, cityId: 1976, code: "624014" },
    { id: 60719, cityId: 382, code: "110086" },
    { id: 60720, cityId: 119, code: "521108" },
    { id: 60721, cityId: 2868, code: "389151" },
    { id: 60722, cityId: 2866, code: "370201" },
    { id: 60723, cityId: 2719, code: "743359" },
    { id: 60724, cityId: 2719, code: "743369" },
    { id: 60725, cityId: 341, code: "495006" },
    { id: 60726, cityId: 370, code: "492006" },
    { id: 60727, cityId: 818, code: "583131" },
    { id: 60728, cityId: 447, code: "382305" },
    { id: 60729, cityId: 49, code: "500046" },
    { id: 60730, cityId: 49, code: "500089" },
    { id: 60731, cityId: 1925, code: "603203" },
    { id: 60732, cityId: 1004, code: "685884" },
    { id: 60733, cityId: 2869, code: "628704" },
    { id: 60734, cityId: 2870, code: "643120" },
    { id: 60735, cityId: 382, code: "110050" },
    { id: 60736, cityId: 382, code: "110068" },
    { id: 60737, cityId: 382, code: "110069" },
    { id: 60738, cityId: 382, code: "110070" },
    { id: 60739, cityId: 382, code: "110074" },
    { id: 60740, cityId: 382, code: "110076" },
    { id: 60741, cityId: 382, code: "110079" },
    { id: 60742, cityId: 382, code: "110080" },
    { id: 60743, cityId: 382, code: "110090" },
    { id: 60744, cityId: 382, code: "110095" },
    { id: 60746, cityId: 818, code: "577213" },
    { id: 60747, cityId: 862, code: "577182" },
    { id: 60748, cityId: 818, code: "577221" },
    { id: 60749, cityId: 1514, code: "759107" },
    { id: 60750, cityId: 1514, code: "759122" },
    { id: 60751, cityId: 1925, code: "603103" },
    { id: 60752, cityId: 1925, code: "603109" },
    { id: 60753, cityId: 477, code: "389270" },
    { id: 60754, cityId: 2701, code: "711114" },
    { id: 60755, cityId: 2870, code: "643102" },
    { id: 60756, cityId: 2871, code: "630318" },
    { id: 60757, cityId: 2641, code: "743170" },
    { id: 60758, cityId: 1002, code: "686675" },
    { id: 60759, cityId: 49, code: "500080" },
    { id: 60760, cityId: 2641, code: "743170" },
    { id: 60761, cityId: 781, code: "560106" },
    { id: 60762, cityId: 781, code: "560107" },
    { id: 60763, cityId: 392, code: "403602" },
    { id: 60764, cityId: 2816, code: "712331" },
    { id: 60765, cityId: 2872, code: "814153" },
    { id: 60766, cityId: 2145, code: "606202" },
    { id: 60767, cityId: 2103, code: "601201" },
    { id: 60768, cityId: 2717, code: "736118" },
    { id: 60769, cityId: 2101, code: "625601" },
    { id: 60770, cityId: 781, code: "562135" },
    { id: 60771, cityId: 926, code: "562160" },
    { id: 60772, cityId: 1594, code: "609602" },
    { id: 60773, cityId: 2870, code: "643232" },
    { id: 60774, cityId: 2145, code: "606107" },
    { id: 60775, cityId: 2145, code: "606207" },
    { id: 60776, cityId: 2145, code: "606201" },
    { id: 60777, cityId: 2861, code: "796410" },
    { id: 60778, cityId: 2861, code: "796471" },
    { id: 60779, cityId: 1487, code: "796014" },
    { id: 60780, cityId: 1487, code: "796111" },
    { id: 60781, cityId: 1492, code: "796075" },
    { id: 60782, cityId: 1497, code: "796810" },
    { id: 60783, cityId: 2104, code: "602026" },
    { id: 60784, cityId: 2641, code: "743353" },
    { id: 60785, cityId: 2006, code: "638008" },
    { id: 60786, cityId: 2104, code: "641001" },
    { id: 60787, cityId: 1925, code: "603110" },
    { id: 60788, cityId: 2022, code: "643001" },
    { id: 60789, cityId: 2873, code: "402309" },
    { id: 60790, cityId: 531, code: "391380" },
    { id: 60791, cityId: 1396, code: "402125" },
    { id: 60792, cityId: 1280, code: "442509" },
    { id: 60793, cityId: 2113, code: "602024" },
    { id: 60794, cityId: 2874, code: "736100" },
    { id: 60795, cityId: 2724, code: "734203" },
    { id: 60796, cityId: 2875, code: "791110" },
    { id: 60797, cityId: 2876, code: "791112" },
    { id: 60798, cityId: 2877, code: "791110" },
    { id: 60799, cityId: 2876, code: "791112" },
    { id: 60800, cityId: 2878, code: "791102" },
    { id: 60801, cityId: 2879, code: "734011" },
    { id: 60802, cityId: 2880, code: "791102" },
    { id: 60803, cityId: 2881, code: "791119" },
    { id: 60804, cityId: 2882, code: "791104" },
    { id: 60805, cityId: 2883, code: "791113" },
    { id: 60806, cityId: 2825, code: "736169" },
    { id: 60807, cityId: 2884, code: "791105" },
    { id: 60808, cityId: 2877, code: "791001" },
    { id: 60809, cityId: 178, code: "785634" },
    { id: 60810, cityId: 2825, code: "736169" },
    { id: 60811, cityId: 168, code: "784168" },
    { id: 60812, cityId: 2886, code: "791102" },
    { id: 60813, cityId: 2887, code: "791118" },
    { id: 60814, cityId: 2888, code: "791113" },
    { id: 60815, cityId: 2889, code: "791120" },
    { id: 60816, cityId: 2890, code: "791125" },
    { id: 60817, cityId: 1596, code: "605602" },
    { id: 60818, cityId: 1596, code: "607105" },
    { id: 60819, cityId: 2885, code: "790008" },
    { id: 60820, cityId: 135, code: "791122" },
    { id: 60821, cityId: 178, code: "785634" },
    { id: 60822, cityId: 2103, code: "602026" },
    { id: 60823, cityId: 2103, code: "600054" },
    { id: 60824, cityId: 2891, code: "791113" },
    { id: 60825, cityId: 1925, code: "603107" },
    { id: 60826, cityId: 2865, code: "402108" },
    { id: 60827, cityId: 1878, code: "603204" },
    { id: 60828, cityId: 2641, code: "743178" },
    { id: 60829, cityId: 2893, code: "756019" },
    { id: 60830, cityId: 2892, code: "791113" },
    { id: 60831, cityId: 142, code: "790102" },
    { id: 60832, cityId: 2006, code: "636203" },
    { id: 60833, cityId: 867, code: "581400" },
    { id: 60834, cityId: 2805, code: "201308" },
    { id: 60835, cityId: 2298, code: "201304" },
    { id: 60836, cityId: 2805, code: "201306" },
    { id: 60837, cityId: 2805, code: "201310" },
    { id: 60838, cityId: 2805, code: "203207" },
    { id: 60839, cityId: 2894, code: "201009" },
    { id: 60840, cityId: 2894, code: "201009" },
    { id: 60841, cityId: 2860, code: "383325" },
    { id: 60842, cityId: 2860, code: "383001" },
    { id: 60843, cityId: 1925, code: "603202" },
    { id: 60844, cityId: 2895, code: "600100" },
    { id: 60845, cityId: 2633, code: "262405" },
    { id: 60846, cityId: 2145, code: "604001" },
    { id: 60847, cityId: 2088, code: "630318" },
    { id: 60848, cityId: 27, code: "517583" },
    { id: 60849, cityId: 27, code: "517591" },
    { id: 60850, cityId: 2791, code: "410221" },
    { id: 60851, cityId: 1252, code: "402209" },
    { id: 60852, cityId: 950, code: "580401" },
    { id: 60853, cityId: 379, code: "396230" },
    { id: 60854, cityId: 379, code: "396195" },
    { id: 60855, cityId: 379, code: "396193" },
    { id: 60856, cityId: 380, code: "396210" },
    { id: 60857, cityId: 380, code: "396220" },
    { id: 60858, cityId: 380, code: "396215" },
    { id: 60859, cityId: 2896, code: "396170" },
    { id: 60860, cityId: 2896, code: "396171" },
    { id: 60861, cityId: 2896, code: "396165" },
    { id: 60862, cityId: 2896, code: "396007" },
    { id: 60863, cityId: 950, code: "581401" },
    { id: 60864, cityId: 1525, code: "762014" },
    { id: 60865, cityId: 1567, code: "752034" },
    { id: 60866, cityId: 228, code: "802301" },
    { id: 60867, cityId: 2641, code: "743369" },
    { id: 60868, cityId: 2641, code: "743359" },
    { id: 60869, cityId: 2145, code: "605702" },
    { id: 60870, cityId: 610, code: "135001" },
    { id: 60871, cityId: 1925, code: "603210" },
    { id: 60872, cityId: 2596, code: "263153" },
    { id: 60873, cityId: 2865, code: "410208" },
    { id: 60874, cityId: 1925, code: "603111" },
    { id: 60875, cityId: 2808, code: "160071" },
    { id: 60876, cityId: 945, code: "581355" },
    { id: 60877, cityId: 2781, code: "402103" },
    { id: 60878, cityId: 2641, code: "700037" },
    { id: 60879, cityId: 2109, code: "628203" },
    { id: 60880, cityId: 1594, code: "609602" },
    { id: 60881, cityId: 2899, code: "401202" },
    { id: 60882, cityId: 2899, code: "401208" },
    { id: 60883, cityId: 2899, code: "401209" },
    { id: 60884, cityId: 2899, code: "401208" },
    { id: 60885, cityId: 2899, code: "401207" },
    { id: 60886, cityId: 2899, code: "401201" },
    { id: 60887, cityId: 1367, code: "401101" },
    { id: 60888, cityId: 2103, code: "601206" },
    { id: 60889, cityId: 2860, code: "383220" },
    { id: 60890, cityId: 2805, code: "203208" },
    { id: 60891, cityId: 2900, code: "262401" },
    { id: 60892, cityId: 1349, code: "402307" },
    { id: 60893, cityId: 806, code: "561207" },
    { id: 60894, cityId: 926, code: "562108" },
    { id: 60895, cityId: 519, code: "385001" },
    { id: 60896, cityId: 2145, code: "605602" },
    { id: 60897, cityId: 2901, code: "792104" },
    { id: 60898, cityId: 2902, code: "792129" },
    { id: 60899, cityId: 2903, code: "791118" },
    { id: 60900, cityId: 2791, code: "410207" },
    { id: 60901, cityId: 809, code: "577138" },
    { id: 60902, cityId: 2145, code: "605501" },
    { id: 60903, cityId: 2904, code: "792121" },
    { id: 60904, cityId: 2905, code: "792122" },
    { id: 60905, cityId: 99, code: "501218" },
    { id: 60906, cityId: 2145, code: "605201" },
    { id: 60907, cityId: 1878, code: "603101" },
    { id: 60908, cityId: 818, code: "577551" },
    { id: 60909, cityId: 897, code: "561101" },
    { id: 60910, cityId: 332, code: "490020" },
    { id: 60911, cityId: 2641, code: "743275" },
    { id: 60912, cityId: 874, code: "571443" },
    { id: 60913, cityId: 2865, code: "415213" },
    { id: 60914, cityId: 2265, code: "201307" },
    { id: 60915, cityId: 2353, code: "202392" },
    { id: 60916, cityId: 2265, code: "202392" },
    { id: 60917, cityId: 96, code: "533101" },
    { id: 60918, cityId: 96, code: "533101" },
    { id: 60919, cityId: 2809, code: "490001" },
    { id: 60920, cityId: 926, code: "562109" },
    { id: 60921, cityId: 2641, code: "743706" },
    { id: 60922, cityId: 1327, code: "410201" },
    { id: 60923, cityId: 519, code: "395206" },
    { id: 60924, cityId: 519, code: "394211" },
    { id: 60925, cityId: 2787, code: "394602" },
    { id: 60926, cityId: 109, code: "532001" },
    { id: 60927, cityId: 96, code: "533101" },
    { id: 60928, cityId: 27, code: "517128" },
    { id: 60929, cityId: 2791, code: "410202" },
    { id: 60930, cityId: 2865, code: "402109" },
    { id: 60931, cityId: 2865, code: "410218" },
    { id: 60932, cityId: 1925, code: "603127" },
    { id: 60933, cityId: 2787, code: "394602" },
    { id: 60934, cityId: 519, code: "394211" },
    { id: 60935, cityId: 2906, code: "723498" },
    { id: 60936, cityId: 2907, code: "781035" },
    { id: 60937, cityId: 2145, code: "606208" },
    { id: 60938, cityId: 952, code: "571236" },
    { id: 60939, cityId: 2865, code: "402209" },
    { id: 60940, cityId: 1596, code: "606301" },
    { id: 60941, cityId: 2641, code: "743298" },
    { id: 60942, cityId: 2852, code: "389120" },
    { id: 60943, cityId: 2865, code: "402209" },
    { id: 60944, cityId: 2908, code: "591136" },
    { id: 60945, cityId: 1596, code: "606301" },
    { id: 60946, cityId: 2145, code: "606301" },
    { id: 60947, cityId: 2145, code: "605757" },
    { id: 60948, cityId: 2145, code: "605401" },
    { id: 60949, cityId: 2145, code: "606115" },
    { id: 60950, cityId: 2909, code: "396375" },
    { id: 60951, cityId: 49, code: "500028" },
    { id: 60952, cityId: 1833, code: "737106" },
    { id: 60953, cityId: 2253, code: "202393" },
    { id: 60954, cityId: 794, code: "581354" },
    { id: 60955, cityId: 2852, code: "389120" },
    { id: 60956, cityId: 2910, code: "416510" },
    { id: 60957, cityId: 2911, code: "249001" },
    { id: 60958, cityId: 2911, code: "249002" },
    { id: 60959, cityId: 2911, code: "249003" },
    { id: 60960, cityId: 2911, code: "249123" },
    { id: 60961, cityId: 2911, code: "249180" },
    { id: 60962, cityId: 2911, code: "249175" },
    { id: 60963, cityId: 1834, code: "737121" },
    { id: 60964, cityId: 1836, code: "737139" },
    { id: 60965, cityId: 2816, code: "712206" },
    { id: 60966, cityId: 88, code: "523002" },
    { id: 60967, cityId: 1247, code: "414102" },
    { id: 60968, cityId: 2867, code: "385515" },
    { id: 60969, cityId: 2105, code: "628401" },
    { id: 60970, cityId: 2852, code: "389210" },
    { id: 60971, cityId: 2912, code: "500032" },
    { id: 60972, cityId: 2865, code: "402401" },
    { id: 60973, cityId: 1890, code: "609002" },
    { id: 60974, cityId: 2145, code: "607272" },
    { id: 60975, cityId: 2868, code: "389146" },
    { id: 60976, cityId: 2865, code: "402305" },
    { id: 60977, cityId: 1484, code: "793108" },
    { id: 60978, cityId: 417, code: "364005" },
    { id: 60979, cityId: 1925, code: "602105" },
    { id: 60980, cityId: 519, code: "395000" },
    { id: 60981, cityId: 802, code: "571313" },
    { id: 60982, cityId: 2265, code: "201307" },
    { id: 60983, cityId: 1351, code: "416510" },
    { id: 60984, cityId: 2913, code: "571807" },
    { id: 60985, cityId: 2914, code: "799253" },
    { id: 60986, cityId: 2105, code: "628601" },
    { id: 60987, cityId: 2792, code: "628601" },
    { id: 60988, cityId: 2865, code: "402301" },
    { id: 60989, cityId: 2105, code: "628101" },
    { id: 60990, cityId: 99, code: "500102" },
    { id: 60991, cityId: 72, code: "509375" },
    { id: 60992, cityId: 1486, code: "794111" },
    { id: 60993, cityId: 2915, code: "275101" },
    { id: 60994, cityId: 950, code: "581318" },
    { id: 60995, cityId: 806, code: "561208" },
    { id: 60996, cityId: 170, code: "781034" },
    { id: 60997, cityId: 2916, code: "173025" },
    { id: 60998, cityId: 2917, code: "203135" },
    { id: 60999, cityId: 2917, code: "302202" },
    { id: 61000, cityId: 2103, code: "602025" },
    { id: 61001, cityId: 1247, code: "414503" },
    { id: 61002, cityId: 1313, code: "424206" },
    { id: 61003, cityId: 724, code: "825323" },
    { id: 61004, cityId: 2451, code: "262125" },
    { id: 61005, cityId: 2918, code: "403706" },
    { id: 61006, cityId: 2703, code: "734318" },
    { id: 61007, cityId: 2105, code: "628203" },
    { id: 61008, cityId: 2105, code: "628213" },
    { id: 61009, cityId: 2105, code: "628213" },
    { id: 61010, cityId: 2105, code: "628151" },
    { id: 61011, cityId: 1833, code: "737132" },
    { id: 61012, cityId: 2852, code: "389330" },
    { id: 61013, cityId: 2780, code: "410206" },
    { id: 61014, cityId: 2641, code: "743120" },
    { id: 61015, cityId: 2919, code: "792056" },
    { id: 61016, cityId: 2920, code: "791120" },
    { id: 61017, cityId: 2113, code: "601203" },
    { id: 61018, cityId: 447, code: "382428" },
    { id: 61019, cityId: 14, code: "515201" },
    { id: 61020, cityId: 807, code: "577139" },
    { id: 61021, cityId: 134, code: "792103" },
    { id: 61022, cityId: 2641, code: "700032" },
    { id: 61023, cityId: 447, code: "382024" },
    { id: 61024, cityId: 2145, code: "605803" },
    { id: 61025, cityId: 2105, code: "628701" },
    { id: 61026, cityId: 2105, code: "628617" },
    { id: 61027, cityId: 2109, code: "628206" },
    { id: 61028, cityId: 2109, code: "628617" },
    { id: 61029, cityId: 2921, code: "476337" },
    { id: 61030, cityId: 1261, code: "433702" },
    { id: 61031, cityId: 49, code: "500072" },
    { id: 61032, cityId: 2340, code: "203209" },
    { id: 61033, cityId: 2865, code: "402308" },
    { id: 61034, cityId: 2922, code: "312605" },
    { id: 61035, cityId: 568, code: "125121" },
    { id: 61036, cityId: 2865, code: "402115" },
    { id: 61037, cityId: 2105, code: "628502" },
    { id: 61038, cityId: 2792, code: "628502" },
    { id: 61039, cityId: 2184, code: "244223" },
    { id: 61040, cityId: 1559, code: "757037" },
    { id: 61041, cityId: 2184, code: "244223" },
    { id: 61042, cityId: 2184, code: "244223" },
    { id: 61043, cityId: 2674, code: "712106" },
    { id: 61044, cityId: 1460, code: "445206" },
    { id: 61045, cityId: 2917, code: "203207" },
    { id: 61046, cityId: 2923, code: "733125" },
    { id: 61047, cityId: 2924, code: "500055" },
    { id: 61048, cityId: 2917, code: "201004" },
    { id: 61049, cityId: 1613, code: "151509" },
    { id: 61050, cityId: 2105, code: "628801" },
    { id: 61051, cityId: 2925, code: "403726" },
    { id: 61052, cityId: 2865, code: "410210" },
    { id: 61053, cityId: 2104, code: "614001" },
    { id: 61054, cityId: 1979, code: "603112" },
    { id: 61055, cityId: 2926, code: "521225" },
    { id: 61056, cityId: 2926, code: "521225" },
    { id: 61057, cityId: 49, code: "500086" },
    { id: 61058, cityId: 724, code: "825312" },
    { id: 61059, cityId: 2927, code: "403502" },
    { id: 61060, cityId: 2145, code: "604204" },
    { id: 61061, cityId: 2641, code: "743276" },
    { id: 61062, cityId: 2928, code: "403713" },
    { id: 61063, cityId: 2929, code: "370625" },
    { id: 61064, cityId: 2105, code: "627713" },
    { id: 61065, cityId: 1075, code: "670110" },
    { id: 61066, cityId: 1339, code: "416534" },
    { id: 61067, cityId: 1836, code: "737134" },
    { id: 61068, cityId: 2865, code: "402104" },
    { id: 61069, cityId: 1459, code: "444107" },
    { id: 61070, cityId: 2865, code: "410101" },
    { id: 61071, cityId: 2719, code: "700105" },
    { id: 61072, cityId: 2145, code: "605701" },
    { id: 61073, cityId: 2478, code: "247001" },
    { id: 61074, cityId: 2780, code: "400614" },
    { id: 61075, cityId: 2928, code: "403703" },
    { id: 61076, cityId: 806, code: "562102" },
    { id: 61077, cityId: 2927, code: "403005" },
    { id: 61078, cityId: 2145, code: "606402" },
    { id: 61079, cityId: 568, code: "125113" },
    { id: 61080, cityId: 201, code: "781035" },
    { id: 61081, cityId: 1247, code: "414105" },
    { id: 61082, cityId: 2145, code: "606213" },
    { id: 61083, cityId: 2313, code: "221303" },
    { id: 61084, cityId: 2930, code: "770017" },
    { id: 61085, cityId: 99, code: "501359" },
    { id: 61086, cityId: 631, code: "171304" },
    { id: 61087, cityId: 867, code: "581324" },
    { id: 61088, cityId: 2931, code: "574218" },
    { id: 61089, cityId: 2931, code: "574218" },
    { id: 61090, cityId: 2932, code: "752103" },
    { id: 61091, cityId: 2933, code: "844102" },
    { id: 61092, cityId: 2641, code: "733134" },
    { id: 61093, cityId: 49, code: "501218" },
    { id: 61094, cityId: 49, code: "509217" },
    { id: 61095, cityId: 1925, code: "602106" },
    { id: 61096, cityId: 1925, code: "631605" },
    { id: 61097, cityId: 926, code: "562138" },
    { id: 61098, cityId: 896, code: "571253" },
    { id: 61099, cityId: 2912, code: "500029" },
    { id: 61100, cityId: 1925, code: "603102" },
    { id: 61101, cityId: 2781, code: "410203" },
    { id: 61102, cityId: 291, code: "852210" },
    { id: 61103, cityId: 802, code: "571441" },
    { id: 61104, cityId: 2791, code: "410218" },
    { id: 61105, cityId: 2780, code: "400703" },
    { id: 61106, cityId: 2935, code: "791109" },
    { id: 61107, cityId: 2936, code: "845306" },
    { id: 61108, cityId: 138, code: "786630" },
    { id: 61109, cityId: 49, code: "500072" },
    { id: 61110, cityId: 2641, code: "741250" },
    { id: 61111, cityId: 802, code: "571128" },
    { id: 61112, cityId: 447, code: "382002" },
    { id: 61113, cityId: 2937, code: "123029" },
    { id: 61114, cityId: 2782, code: "638656" },
    { id: 61115, cityId: 2179, code: "227809" },
    { id: 61116, cityId: 1412, code: "431504" },
    { id: 61117, cityId: 2938, code: "790101" },
    { id: 61118, cityId: 2939, code: "737132" },
    { id: 61119, cityId: 1514, code: "759119" },
    { id: 61120, cityId: 2928, code: "403713" },
    { id: 61121, cityId: 1925, code: "603305" },
    { id: 61122, cityId: 1925, code: "603306" },
    { id: 61123, cityId: 1925, code: "631551" },
    { id: 61124, cityId: 2300, code: "201309" },
    { id: 61125, cityId: 2940, code: "202520" },
    { id: 61126, cityId: 1630, code: "152002" },
    { id: 61127, cityId: 1488, code: "796261" },
    { id: 61128, cityId: 1495, code: "796181" },
    { id: 61129, cityId: 2941, code: "790114" },
    { id: 61130, cityId: 2942, code: "276403" },
    { id: 61131, cityId: 2796, code: "403804" },
    { id: 61132, cityId: 2796, code: "403804" },
    { id: 61133, cityId: 1497, code: "796911" },
    { id: 61134, cityId: 1567, code: "752030" },
    { id: 61135, cityId: 926, code: "562117" },
    { id: 61136, cityId: 2103, code: "631203" },
    { id: 61137, cityId: 2103, code: "602024" },
    { id: 61138, cityId: 2944, code: "784115" },
    { id: 61139, cityId: 2943, code: "831011" },
    { id: 61140, cityId: 2641, code: "700048" },
    { id: 61141, cityId: 2945, code: "416606" },
    { id: 61142, cityId: 2179, code: "227817" },
    { id: 61143, cityId: 60, code: "505101" },
    { id: 61144, cityId: 2860, code: "383210" },
    { id: 61145, cityId: 2654, code: "733125" },
    { id: 61146, cityId: 2654, code: "733155" },
    { id: 61147, cityId: 2654, code: "733101" },
    { id: 61148, cityId: 2654, code: "733141" },
    { id: 61149, cityId: 2654, code: "733102" },
    { id: 61150, cityId: 2340, code: "203135" },
    { id: 61151, cityId: 2852, code: "389230" },
    { id: 61152, cityId: 2946, code: "790001" },
    { id: 61153, cityId: 1925, code: "603106" },
    { id: 61154, cityId: 1680, code: "160103" },
    { id: 61155, cityId: 807, code: "577547" },
    { id: 61156, cityId: 2135, code: "631101" },
    { id: 61157, cityId: 2868, code: "389180" },
    { id: 61158, cityId: 807, code: "577144" },
    { id: 61159, cityId: 2911, code: "249161" },
    { id: 61160, cityId: 2105, code: "628552" },
    { id: 61161, cityId: 2186, code: "202390" },
    { id: 61162, cityId: 2933, code: "844502" },
    { id: 61163, cityId: 2917, code: "203208" },
    { id: 61164, cityId: 2202, code: "250101" },
    { id: 61165, cityId: 1578, code: "761200" },
    { id: 61166, cityId: 2202, code: "250611" },
    { id: 61167, cityId: 99, code: "500048" },
    { id: 61168, cityId: 2164, code: "799286" },
    { id: 61169, cityId: 2947, code: "497778" },
    { id: 61170, cityId: 1925, code: "601301" },
    { id: 61171, cityId: 1487, code: "796008" },
    { id: 61172, cityId: 750, code: "769004" },
    { id: 61173, cityId: 2932, code: "752100" },
    { id: 61174, cityId: 806, code: "563123" },
    { id: 61175, cityId: 2931, code: "574239" },
    { id: 61176, cityId: 2782, code: "642128" },
    { id: 61177, cityId: 2340, code: "203155" },
    { id: 61178, cityId: 99, code: "500039" },
    { id: 61179, cityId: 2353, code: "208027" },
    { id: 61180, cityId: 2422, code: "202413" },
    { id: 61181, cityId: 2105, code: "628252" },
    { id: 61182, cityId: 1836, code: "737132" },
    { id: 61183, cityId: 2948, code: "792102" },
    { id: 61184, cityId: 2949, code: "370165" },
    { id: 61185, cityId: 1925, code: "603105" },
    { id: 61186, cityId: 847, code: "581348" },
    { id: 61187, cityId: 1925, code: "600114" },
    { id: 61188, cityId: 2928, code: "403709" },
    { id: 61189, cityId: 519, code: "395620" },
    { id: 61190, cityId: 1744, code: "302023" },
    { id: 61191, cityId: 624, code: "176109" },
    { id: 61192, cityId: 49, code: "500052" },
    { id: 61193, cityId: 14, code: "515591" },
    { id: 61194, cityId: 2928, code: "403708" },
    { id: 61195, cityId: 2863, code: "755003" },
    { id: 61196, cityId: 724, code: "825311" },
    { id: 61197, cityId: 1925, code: "603404" },
    { id: 61198, cityId: 2462, code: "229401" },
    { id: 61199, cityId: 2927, code: "403503" },
    { id: 61200, cityId: 2257, code: "202410" },
    { id: 61201, cityId: 1500, code: "796310" },
    { id: 61202, cityId: 1464, code: "795005" },
    { id: 61203, cityId: 2868, code: "389380" },
    { id: 61204, cityId: 1447, code: "400707" },
    { id: 61205, cityId: 72, code: "509120" },
    { id: 61206, cityId: 2179, code: "227409" },
    { id: 61207, cityId: 2950, code: "821104" },
    { id: 61208, cityId: 1464, code: "795127" },
    { id: 61209, cityId: 806, code: "563128" },
    { id: 61210, cityId: 14, code: "515921" },
    { id: 61211, cityId: 1439, code: "401609" },
    { id: 61212, cityId: 2927, code: "403506" },
    { id: 61213, cityId: 14, code: "515721" },
    { id: 61214, cityId: 447, code: "382810" },
    { id: 61215, cityId: 1925, code: "600044" },
    { id: 61216, cityId: 1925, code: "631553" },
    { id: 61217, cityId: 2852, code: "389232" },
    { id: 61218, cityId: 2782, code: "641665" },
    { id: 61219, cityId: 1511, code: "798626" },
    { id: 61220, cityId: 1487, code: "796410" },
    { id: 61221, cityId: 1880, code: "600124" },
    { id: 61222, cityId: 1176, code: "458775" },
    { id: 61223, cityId: 2145, code: "606401" },
    { id: 61224, cityId: 2865, code: "402204" },
    { id: 61225, cityId: 1613, code: "151111" },
    { id: 61226, cityId: 2103, code: "600116" },
    { id: 61227, cityId: 2677, code: "734402" },
    { id: 61228, cityId: 2865, code: "402204" },
    { id: 61229, cityId: 2917, code: "203203" },
    { id: 61230, cityId: 2867, code: "385540" },
    { id: 61231, cityId: 2536, code: "241501" },
    { id: 61232, cityId: 803, code: "577215" },
    { id: 61233, cityId: 902, code: "574199" },
    { id: 61234, cityId: 2201, code: "243638" },
    { id: 61235, cityId: 1925, code: "603303" },
    { id: 61236, cityId: 1613, code: "151401" },
    { id: 61237, cityId: 2145, code: "605110" },
    { id: 61238, cityId: 2852, code: "389310" },
    { id: 61239, cityId: 477, code: "389235" },
    { id: 61240, cityId: 2103, code: "602001" },
    { id: 61241, cityId: 867, code: "581339" },
    { id: 61242, cityId: 2865, code: "402309" },
    { id: 61243, cityId: 1604, code: "143026" },
    { id: 61244, cityId: 2179, code: "227412" },
    { id: 61245, cityId: 1613, code: "151401" },
    { id: 61246, cityId: 818, code: "577223" },
    { id: 61247, cityId: 2928, code: "403704" },
    { id: 61248, cityId: 2898, code: "401305" },
    { id: 61249, cityId: 2945, code: "416606" },
    { id: 61250, cityId: 2917, code: "201310" },
    { id: 61251, cityId: 2581, code: "263141" },
    { id: 61252, cityId: 2932, code: "752055" },
    { id: 61253, cityId: 72, code: "509235" },
    { id: 61254, cityId: 2952, code: "793115" },
    { id: 61255, cityId: 2105, code: "628802" },
    { id: 61256, cityId: 926, code: "562112" },
    { id: 61257, cityId: 2906, code: "743302" },
    { id: 61258, cityId: 447, code: "380005" },
    { id: 61259, cityId: 1439, code: "401210" },
    { id: 61260, cityId: 2670, code: "700137" },
    { id: 61261, cityId: 2953, code: "172110" },
    { id: 61262, cityId: 1349, code: "402305" },
    { id: 61263, cityId: 2807, code: "760009" },
    { id: 61264, cityId: 2954, code: "755003" },
    { id: 61265, cityId: 1925, code: "603209" },
    { id: 61266, cityId: 2857, code: "757047" },
    { id: 61267, cityId: 2794, code: "402116" },
    { id: 61268, cityId: 2955, code: "571251" },
    { id: 61269, cityId: 2955, code: "571251" },
    { id: 61270, cityId: 352, code: "495557" },
    { id: 61271, cityId: 1880, code: "600054" },
    { id: 61272, cityId: 2865, code: "402102" },
    { id: 61273, cityId: 2956, code: "389170" },
    { id: 61274, cityId: 2957, code: "491228" },
    { id: 61275, cityId: 475, code: "365430" },
    { id: 61276, cityId: 1372, code: "441002" },
    { id: 61277, cityId: 475, code: "365430" },
    { id: 61278, cityId: 2900, code: "263151" },
    { id: 61279, cityId: 475, code: "365430" },
    { id: 61280, cityId: 945, code: "581340" },
    { id: 61281, cityId: 2641, code: "743313" },
    { id: 61282, cityId: 1339, code: "416521" },
    { id: 61283, cityId: 2202, code: "250622" },
    { id: 61284, cityId: 2958, code: "385505" },
    { id: 61285, cityId: 2105, code: "628620" },
    { id: 61286, cityId: 2105, code: "628105" },
    { id: 61287, cityId: 2936, code: "845106" },
    { id: 61288, cityId: 969, code: "586205" },
    { id: 61289, cityId: 774, code: "573103" },
    { id: 61290, cityId: 1880, code: "600072" },
    { id: 61291, cityId: 2917, code: "201308" },
    { id: 61292, cityId: 447, code: "382729" },
    { id: 61293, cityId: 952, code: "571235" },
    { id: 61294, cityId: 519, code: "395345" },
    { id: 61295, cityId: 970, code: "571216" },
    { id: 61296, cityId: 2911, code: "249122" },
    { id: 61297, cityId: 2105, code: "628210" },
    { id: 61298, cityId: 2103, code: "600087" },
    { id: 61299, cityId: 2865, code: "402303" },
    { id: 61300, cityId: 99, code: "501506" },
    { id: 61301, cityId: 2911, code: "249155" },
    { id: 61302, cityId: 2017, code: "607803" },
    { id: 61303, cityId: 2900, code: "262405" },
    { id: 61304, cityId: 913, code: "570030" },
    { id: 61305, cityId: 2822, code: "798618" },
    { id: 61306, cityId: 2103, code: "601204" },
    { id: 61307, cityId: 2860, code: "383307" },
    { id: 61308, cityId: 34, code: "534316" },
    { id: 61309, cityId: 1904, code: "604202" },
    { id: 61310, cityId: 2865, code: "402112" },
    { id: 61311, cityId: 1004, code: "685607" },
    { id: 61312, cityId: 1367, code: "401202" },
    { id: 61313, cityId: 2791, code: "410208" },
    { id: 61314, cityId: 2188, code: "208009" },
    { id: 61315, cityId: 2641, code: "700161" },
    { id: 61316, cityId: 737, code: "835227" },
    { id: 61317, cityId: 2780, code: "400701" },
    { id: 61318, cityId: 2928, code: "403715" },
    { id: 61319, cityId: 1447, code: "400704" },
    { id: 61320, cityId: 1405, code: "413214" },
    { id: 61321, cityId: 2867, code: "385510" },
    { id: 61322, cityId: 65, code: "520010" },
    { id: 61323, cityId: 2900, code: "244713" },
    { id: 61324, cityId: 2900, code: "244713" },
    { id: 61325, cityId: 1247, code: "414402" },
    { id: 61326, cityId: 2439, code: "243001" },
    { id: 61327, cityId: 2860, code: "383230" },
    { id: 61328, cityId: 67, code: "518484" },
    { id: 61329, cityId: 1486, code: "783130" },
    { id: 61330, cityId: 1878, code: "603210" },
    { id: 61331, cityId: 1493, code: "796772" },
    { id: 61332, cityId: 2808, code: "160062" },
    { id: 61333, cityId: 2353, code: "209111" },
    { id: 61334, cityId: 72, code: "509375" },
    { id: 61335, cityId: 1484, code: "793019" },
    { id: 61336, cityId: 2858, code: "700031" },
    { id: 61337, cityId: 2847, code: "793160" },
    { id: 61338, cityId: 60, code: "505530" },
    { id: 61339, cityId: 2300, code: "201307" },
    { id: 61340, cityId: 2917, code: "201307" },
    { id: 61341, cityId: 2959, code: "845305" },
    { id: 61342, cityId: 2283, code: "225411" },
    { id: 61343, cityId: 2960, code: "180015" },
    { id: 61344, cityId: 2961, code: "793114" },
    { id: 61345, cityId: 2706, code: "737133" },
    { id: 61346, cityId: 807, code: "577111" },
    { id: 61347, cityId: 2962, code: "416604" },
    { id: 61348, cityId: 2963, code: "799263" },
    { id: 61349, cityId: 2075, code: "638452" },
    { id: 61350, cityId: 2906, code: "743675" },
    { id: 61351, cityId: 1349, code: "402302" },
    { id: 61352, cityId: 2781, code: "402104" },
    { id: 61353, cityId: 2855, code: "402104" },
    { id: 61354, cityId: 2898, code: "401203" },
    { id: 61355, cityId: 2825, code: "736181" },
    { id: 61356, cityId: 2964, code: "209302" },
    { id: 61357, cityId: 2965, code: "802158" },
    { id: 61358, cityId: 779, code: "570212" },
    { id: 61359, cityId: 337, code: "493332" },
    { id: 61360, cityId: 49, code: "500044" },
    { id: 61361, cityId: 2860, code: "383450" },
    { id: 61362, cityId: 786, code: "574325" },
    { id: 61363, cityId: 1900, code: "638452" },
    { id: 61364, cityId: 1900, code: "638453" },
    { id: 61365, cityId: 2966, code: "781005" },
    { id: 61366, cityId: 1349, code: "402115" },
    { id: 61367, cityId: 2353, code: "209217" },
    { id: 61368, cityId: 1591, code: "769043" },
    { id: 61369, cityId: 2860, code: "383430" },
    { id: 61370, cityId: 2967, code: "383250" },
    { id: 61371, cityId: 1567, code: "752031" },
    { id: 61372, cityId: 2103, code: "631202" },
    { id: 61373, cityId: 818, code: "577534" },
    { id: 61374, cityId: 902, code: "575016" },
    { id: 61375, cityId: 2932, code: "752031" },
    { id: 61376, cityId: 99, code: "500035" },
    { id: 61377, cityId: 2949, code: "370650" },
    { id: 61378, cityId: 2932, code: "752102" },
    { id: 61379, cityId: 1262, code: "421504" },
    { id: 61380, cityId: 1262, code: "421503" },
    { id: 61381, cityId: 815, code: "577519" },
    { id: 61382, cityId: 1925, code: "603108" },
    { id: 61383, cityId: 2390, code: "227107" },
    { id: 61384, cityId: 2857, code: "757043" },
    { id: 61385, cityId: 2932, code: "752050" },
    { id: 61386, cityId: 1567, code: "751013" },
    { id: 61387, cityId: 1176, code: "458664" },
    { id: 61388, cityId: 1193, code: "487337" },
    { id: 61389, cityId: 718, code: "815316" },
    { id: 61390, cityId: 2857, code: "757046" },
    { id: 61391, cityId: 2857, code: "757054" },
    { id: 61392, cityId: 1635, code: "143419" },
    { id: 61393, cityId: 2145, code: "604202" },
    { id: 61394, cityId: 1591, code: "770022" },
    { id: 61395, cityId: 2808, code: "140601" },
    { id: 61396, cityId: 2202, code: "250515" },
    { id: 61397, cityId: 2808, code: "160055" },
    { id: 61398, cityId: 1591, code: "770070" },
    { id: 61399, cityId: 1839, code: "737116" },
    { id: 61400, cityId: 1833, code: "737134" },
    { id: 61401, cityId: 1833, code: "737113" },
    { id: 61402, cityId: 1833, code: "737126" },
    { id: 61403, cityId: 1833, code: "737116" },
    { id: 61404, cityId: 1833, code: "737111" },
    { id: 61405, cityId: 1833, code: "737117" },
    { id: 61406, cityId: 1833, code: "737121" },
    { id: 61407, cityId: 2105, code: "628658" },
    { id: 61408, cityId: 2105, code: "628658" },
    { id: 61409, cityId: 2111, code: "622009" },
    { id: 61410, cityId: 62, code: "507120" },
    { id: 61411, cityId: 2865, code: "402111" },
    { id: 61412, cityId: 2911, code: "249146" },
    { id: 61413, cityId: 2863, code: "755043" },
    { id: 61414, cityId: 1925, code: "603112" },
    { id: 61415, cityId: 1925, code: "603111" },
    { id: 61416, cityId: 2502, code: "247774" },
    { id: 61417, cityId: 1514, code: "759132" },
    { id: 61418, cityId: 2969, code: "802215" },
    { id: 61419, cityId: 2104, code: "610208" },
    { id: 61420, cityId: 2104, code: "610206" },
    { id: 61421, cityId: 2852, code: "389265" },
    { id: 61422, cityId: 2852, code: "389235" },
    { id: 61423, cityId: 2900, code: "244712" },
    { id: 61424, cityId: 2857, code: "757037" },
    { id: 61425, cityId: 2857, code: "757040" },
    { id: 61426, cityId: 2719, code: "700156" },
    { id: 61427, cityId: 2872, code: "814133" },
    { id: 61428, cityId: 1020, code: "682020" },
    { id: 61429, cityId: 119, code: "520002" },
    { id: 61430, cityId: 2970, code: "603103" },
    { id: 61431, cityId: 2357, code: "207403" },
    { id: 61432, cityId: 2927, code: "403002" },
    { id: 61433, cityId: 447, code: "382350" },
    { id: 61434, cityId: 1938, code: "632006" },
    { id: 61435, cityId: 2863, code: "755028" },
    { id: 61436, cityId: 2488, code: "244301" },
    { id: 61437, cityId: 2728, code: "721458" },
    { id: 61438, cityId: 1378, code: "422687" },
    { id: 61439, cityId: 2971, code: "500075" },
    { id: 61440, cityId: 2898, code: "401303" },
    { id: 61441, cityId: 2898, code: "401102" },
    { id: 61442, cityId: 2973, code: "275304" },
    { id: 61443, cityId: 2974, code: "125052" },
    { id: 61444, cityId: 2868, code: "389190" },
    { id: 61445, cityId: 1925, code: "602108" },
    { id: 61446, cityId: 1925, code: "600069" },
    { id: 61447, cityId: 2975, code: "781366" },
    { id: 61448, cityId: 2932, code: "752022" },
    { id: 61449, cityId: 2977, code: "152123" },
    { id: 61450, cityId: 781, code: "560113" },
    { id: 61451, cityId: 807, code: "577101" },
    { id: 61452, cityId: 2397, code: "273162" },
    { id: 61453, cityId: 1666, code: "140124" },
    { id: 61454, cityId: 2978, code: "627811" },
    { id: 61455, cityId: 21, code: "533352" },
    { id: 61456, cityId: 23, code: "533352" },
    { id: 61457, cityId: 23, code: "508117" },
    { id: 61458, cityId: 27, code: "517646" },
    { id: 61459, cityId: 34, code: "533347" },
    { id: 61460, cityId: 34, code: "533348" },
    { id: 61461, cityId: 34, code: "533349" },
    { id: 61462, cityId: 34, code: "533350" },
    { id: 61463, cityId: 34, code: "533351" },
    { id: 61464, cityId: 34, code: "533352" },
    { id: 61465, cityId: 49, code: "500103" },
    { id: 61466, cityId: 49, code: "500109" },
    { id: 61467, cityId: 49, code: "500110" },
    { id: 61468, cityId: 53, code: "506146" },
    { id: 61469, cityId: 53, code: "506175" },
    { id: 61470, cityId: 57, code: "503112" },
    { id: 61471, cityId: 78, code: "508117" },
    { id: 61472, cityId: 78, code: "508208" },
    { id: 61473, cityId: 83, code: "524347" },
    { id: 61474, cityId: 86, code: "503112" },
    { id: 61475, cityId: 86, code: "503223" },
    { id: 61476, cityId: 99, code: "500112" },
    { id: 61477, cityId: 99, code: "500115" },
    { id: 61478, cityId: 122, code: "534455" },
    { id: 61479, cityId: 124, code: "505497" },
    { id: 61480, cityId: 124, code: "506175" },
    { id: 61481, cityId: 124, code: "506333" },
    { id: 61482, cityId: 125, code: "534435" },
    { id: 61483, cityId: 125, code: "534444" },
    { id: 61484, cityId: 125, code: "534455" },
    { id: 61485, cityId: 161, code: "787031" },
    { id: 61486, cityId: 180, code: "788804" },
    { id: 61487, cityId: 194, code: "782128" },
    { id: 61488, cityId: 216, code: "784114" },
    { id: 61489, cityId: 216, code: "784190" },
    { id: 61490, cityId: 216, code: "784528" },
    { id: 61491, cityId: 230, code: "824103" },
    { id: 61492, cityId: 230, code: "824143" },
    { id: 61493, cityId: 230, code: "431011" },
    { id: 61494, cityId: 230, code: "431152" },
    { id: 61495, cityId: 255, code: "847202" },
    { id: 61496, cityId: 283, code: "851206" },
    { id: 61497, cityId: 305, code: "842006" },
    { id: 61498, cityId: 308, code: "805105" },
    { id: 61499, cityId: 308, code: "805113" },
    { id: 61500, cityId: 310, code: "800030" },
    { id: 61501, cityId: 310, code: "801106" },
    { id: 61502, cityId: 311, code: "800030" },
    { id: 61503, cityId: 329, code: "852133" },
    { id: 61504, cityId: 354, code: "493448" },
    { id: 61505, cityId: 354, code: "494237" },
    { id: 61506, cityId: 356, code: "491996" },
    { id: 61507, cityId: 362, code: "495444" },
    { id: 61508, cityId: 364, code: "493448" },
    { id: 61509, cityId: 366, code: "495115" },
    { id: 61510, cityId: 367, code: "384266" },
    { id: 61511, cityId: 369, code: "402126" },
    { id: 61512, cityId: 369, code: "402208" },
    { id: 61513, cityId: 369, code: "402402" },
    { id: 61514, cityId: 370, code: "492016" },
    { id: 61515, cityId: 370, code: "492017" },
    { id: 61516, cityId: 370, code: "492018" },
    { id: 61517, cityId: 377, code: "497226" },
    { id: 61518, cityId: 405, code: "380049" },
    { id: 61519, cityId: 407, code: "365730" },
    { id: 61520, cityId: 416, code: "392135" },
    { id: 61521, cityId: 447, code: "382722" },
    { id: 61522, cityId: 471, code: "387003" },
    { id: 61523, cityId: 478, code: "384135" },
    { id: 61524, cityId: 478, code: "384412" },
    { id: 61525, cityId: 478, code: "384415" },
    { id: 61526, cityId: 478, code: "384441" },
    { id: 61527, cityId: 478, code: "384445" },
    { id: 61528, cityId: 478, code: "384450" },
    { id: 61529, cityId: 478, code: "384455" },
    { id: 61530, cityId: 478, code: "384460" },
    { id: 61531, cityId: 478, code: "384465" },
    { id: 61532, cityId: 478, code: "384470" },
    { id: 61533, cityId: 478, code: "384515" },
    { id: 61534, cityId: 478, code: "384520" },
    { id: 61535, cityId: 478, code: "384530" },
    { id: 61536, cityId: 478, code: "384540" },
    { id: 61537, cityId: 478, code: "384550" },
    { id: 61538, cityId: 478, code: "384560" },
    { id: 61539, cityId: 478, code: "384565" },
    { id: 61540, cityId: 478, code: "384570" },
    { id: 61541, cityId: 498, code: "384266" },
    { id: 61542, cityId: 503, code: "360026" },
    { id: 61543, cityId: 503, code: "360045" },
    { id: 61544, cityId: 503, code: "360325" },
    { id: 61545, cityId: 503, code: "360465" },
    { id: 61546, cityId: 503, code: "360485" },
    { id: 61547, cityId: 519, code: "394112" },
    { id: 61548, cityId: 519, code: "394541" },
    { id: 61549, cityId: 519, code: "395013" },
    { id: 61550, cityId: 531, code: "391776" },
    { id: 61551, cityId: 532, code: "396067" },
    { id: 61552, cityId: 544, code: "133008" },
    { id: 61553, cityId: 544, code: "133010" },
    { id: 61554, cityId: 544, code: "134008" },
    { id: 61555, cityId: 551, code: "127311" },
    { id: 61556, cityId: 551, code: "127312" },
    { id: 61557, cityId: 557, code: "121014" },
    { id: 61558, cityId: 557, code: "121015" },
    { id: 61559, cityId: 564, code: "122012" },
    { id: 61560, cityId: 564, code: "122098" },
    { id: 61561, cityId: 579, code: "136134" },
    { id: 61562, cityId: 591, code: "134105" },
    { id: 61563, cityId: 610, code: "133103" },
    { id: 61564, cityId: 610, code: "135004" },
    { id: 61565, cityId: 610, code: "135106" },
    { id: 61566, cityId: 610, code: "135133" },
    { id: 61567, cityId: 618, code: "176326" },
    { id: 61568, cityId: 627, code: "176067" },
    { id: 61569, cityId: 631, code: "175075" },
    { id: 61570, cityId: 647, code: "171015" },
    { id: 61571, cityId: 648, code: "173236" },
    { id: 61572, cityId: 650, code: "174507" },
    { id: 61573, cityId: 670, code: "194303" },
    { id: 61574, cityId: 671, code: "184210" },
    { id: 61575, cityId: 680, code: "194107" },
    { id: 61576, cityId: 680, code: "194202" },
    { id: 61577, cityId: 695, code: "191132" },
    { id: 61578, cityId: 778, code: "587104" },
    { id: 61579, cityId: 778, code: "587156" },
    { id: 61580, cityId: 778, code: "587331" },
    { id: 61581, cityId: 790, code: "583153" },
    { id: 61582, cityId: 790, code: "583154" },
    { id: 61583, cityId: 790, code: "583155" },
    { id: 61584, cityId: 795, code: "585445" },
    { id: 61585, cityId: 815, code: "574253" },
    { id: 61586, cityId: 815, code: "577556" },
    { id: 61587, cityId: 821, code: "580027" },
    { id: 61588, cityId: 838, code: "573226" },
    { id: 61589, cityId: 839, code: "581198" },
    { id: 61590, cityId: 839, code: "581199" },
    { id: 61591, cityId: 839, code: "581237" },
    { id: 61592, cityId: 856, code: "571106" },
    { id: 61593, cityId: 873, code: "563163" },
    { id: 61594, cityId: 877, code: "583284" },
    { id: 61595, cityId: 877, code: "583285" },
    { id: 61596, cityId: 877, code: "583287" },
    { id: 61597, cityId: 1002, code: "682050" },
    { id: 61598, cityId: 1002, code: "682051" },
    { id: 61599, cityId: 1027, code: "673051" },
    { id: 61600, cityId: 1031, code: "679341" },
    { id: 61601, cityId: 1076, code: "695570" },
    { id: 61602, cityId: 1096, code: "402126" },
    { id: 61603, cityId: 1096, code: "402208" },
    { id: 61604, cityId: 1096, code: "402402" },
    { id: 61605, cityId: 1104, code: "473445" },
    { id: 61606, cityId: 1121, code: "462040" },
    { id: 61607, cityId: 1121, code: "462100" },
    { id: 61608, cityId: 1128, code: "480003" },
    { id: 61609, cityId: 1128, code: "480112" },
    { id: 61610, cityId: 1139, code: "481883" },
    { id: 61611, cityId: 1154, code: "453552" },
    { id: 61612, cityId: 1165, code: "450119" },
    { id: 61613, cityId: 1166, code: "451225" },
    { id: 61614, cityId: 1178, code: "481883" },
    { id: 61615, cityId: 1188, code: "476332" },
    { id: 61616, cityId: 1188, code: "476335" },
    { id: 61617, cityId: 1188, code: "476355" },
    { id: 61618, cityId: 1203, code: "384266" },
    { id: 61619, cityId: 1206, code: "464570" },
    { id: 61620, cityId: 1236, code: "228172" },
    { id: 61621, cityId: 1246, code: "464334" },
    { id: 61622, cityId: 1246, code: "464570" },
    { id: 61623, cityId: 1261, code: "824103" },
    { id: 61624, cityId: 1261, code: "824143" },
    { id: 61625, cityId: 1261, code: "431011" },
    { id: 61626, cityId: 1261, code: "431152" },
    { id: 61627, cityId: 1280, code: "441226" },
    { id: 61628, cityId: 1300, code: "442919" },
    { id: 61629, cityId: 1337, code: "416138" },
    { id: 61630, cityId: 1386, code: "312625" },
    { id: 61631, cityId: 1392, code: "384266" },
    { id: 61632, cityId: 1401, code: "411067" },
    { id: 61633, cityId: 1401, code: "411068" },
    { id: 61634, cityId: 1457, code: "442107" },
    { id: 61635, cityId: 1484, code: "793116" },
    { id: 61636, cityId: 1485, code: "794003" },
    { id: 61637, cityId: 1507, code: "797118" },
    { id: 61638, cityId: 1508, code: "707004" },
    { id: 61639, cityId: 1508, code: "797006" },
    { id: 61640, cityId: 1508, code: "797118" },
    { id: 61641, cityId: 1509, code: "798607" },
    { id: 61642, cityId: 1516, code: "767071" },
    { id: 61643, cityId: 1527, code: "756182" },
    { id: 61644, cityId: 1536, code: "754297" },
    { id: 61645, cityId: 1539, code: "759040" },
    { id: 61646, cityId: 1541, code: "760011" },
    { id: 61647, cityId: 1551, code: "768210" },
    { id: 61648, cityId: 1561, code: "758086" },
    { id: 61649, cityId: 1561, code: "758087" },
    { id: 61650, cityId: 1582, code: "752010" },
    { id: 61651, cityId: 1596, code: "607403" },
    { id: 61652, cityId: 1629, code: "140408" },
    { id: 61653, cityId: 1651, code: "142028" },
    { id: 61654, cityId: 1669, code: "140408" },
    { id: 61655, cityId: 1694, code: "305631" },
    { id: 61656, cityId: 1705, code: "328216" },
    { id: 61657, cityId: 1727, code: "312627" },
    { id: 61658, cityId: 1744, code: "302038" },
    { id: 61659, cityId: 1744, code: "302041" },
    { id: 61660, cityId: 1744, code: "302042" },
    { id: 61661, cityId: 1744, code: "302043" },
    { id: 61662, cityId: 1744, code: "303123" },
    { id: 61663, cityId: 1744, code: "303124" },
    { id: 61664, cityId: 1789, code: "312625" },
    { id: 61665, cityId: 1859, code: "621731" },
    { id: 61666, cityId: 1890, code: "606109" },
    { id: 61667, cityId: 1900, code: "638060" },
    { id: 61668, cityId: 2004, code: "610005" },
    { id: 61669, cityId: 2075, code: "636017" },
    { id: 61670, cityId: 2075, code: "637415" },
    { id: 61671, cityId: 2088, code: "630612" },
    { id: 61672, cityId: 2110, code: "620027" },
    { id: 61673, cityId: 2175, code: "211021" },
    { id: 61674, cityId: 2175, code: "211022" },
    { id: 61675, cityId: 2184, code: "244245" },
    { id: 61676, cityId: 2192, code: "824103" },
    { id: 61677, cityId: 2192, code: "824143" },
    { id: 61678, cityId: 2192, code: "431011" },
    { id: 61679, cityId: 2192, code: "431152" },
    { id: 61680, cityId: 2212, code: "497224" },
    { id: 61681, cityId: 2213, code: "210122" },
    { id: 61682, cityId: 2256, code: "221012" },
    { id: 61683, cityId: 2272, code: "274805" },
    { id: 61684, cityId: 2300, code: "201018" },
    { id: 61685, cityId: 2300, code: "201020" },
    { id: 61686, cityId: 2300, code: "201021" },
    { id: 61687, cityId: 2339, code: "222126" },
    { id: 61688, cityId: 2370, code: "262908" },
    { id: 61689, cityId: 2382, code: "274307" },
    { id: 61690, cityId: 2382, code: "274308" },
    { id: 61691, cityId: 2382, code: "274309" },
    { id: 61692, cityId: 2422, code: "244105" },
    { id: 61693, cityId: 2441, code: "503112" },
    { id: 61694, cityId: 2441, code: "503223" },
    { id: 61695, cityId: 2447, code: "312625" },
    { id: 61696, cityId: 2520, code: "228172" },
    { id: 61697, cityId: 2536, code: "209860" },
    { id: 61698, cityId: 2536, code: "209881" },
    { id: 61699, cityId: 2536, code: "229306" },
    { id: 61700, cityId: 2561, code: "248016" },
    { id: 61701, cityId: 2561, code: "248018" },
    { id: 61702, cityId: 2606, code: "263150" },
    { id: 61703, cityId: 2621, code: "492016" },
    { id: 61704, cityId: 2621, code: "492017" },
    { id: 61705, cityId: 2621, code: "492018" },
    { id: 61706, cityId: 2634, code: "191132" },
    { id: 61707, cityId: 2637, code: "249130" },
    { id: 61708, cityId: 2637, code: "249136" },
    { id: 61709, cityId: 2647, code: "824103" },
    { id: 61710, cityId: 2647, code: "824143" },
    { id: 61711, cityId: 2647, code: "431011" },
    { id: 61712, cityId: 2647, code: "431152" },
    { id: 61713, cityId: 2660, code: "713132" },
    { id: 61714, cityId: 2701, code: "711115" },
    { id: 61715, cityId: 2701, code: "711206" },
    { id: 61716, cityId: 2719, code: "700162" },
    { id: 61717, cityId: 2767, code: "492016" },
    { id: 61718, cityId: 2767, code: "492017" },
    { id: 61719, cityId: 2767, code: "492018" },
    { id: 61720, cityId: 2819, code: "742409" },
    { id: 61721, cityId: 2819, code: "742410" },
    { id: 61722, cityId: 2826, code: "721402" },
    { id: 61723, cityId: 2826, code: "721403" },
    { id: 61724, cityId: 2826, code: "721405" },
    { id: 61725, cityId: 2826, code: "721406" },
    { id: 61726, cityId: 2826, code: "721624" },
    { id: 61727, cityId: 2826, code: "721637" },
    { id: 61728, cityId: 2828, code: "721404" },
    { id: 61729, cityId: 2836, code: "791114" },
    { id: 61730, cityId: 2849, code: "486885" },
    { id: 61731, cityId: 2849, code: "486888" },
    { id: 61732, cityId: 2857, code: "757022" },
    { id: 61733, cityId: 2857, code: "757053" },
    { id: 61734, cityId: 2857, code: "757100" },
    { id: 61735, cityId: 2857, code: "757107" },
    { id: 61736, cityId: 2860, code: "383006" },
    { id: 61737, cityId: 2861, code: "796470" },
    { id: 61738, cityId: 2862, code: "394652" },
    { id: 61739, cityId: 2865, code: "402126" },
    { id: 61740, cityId: 2865, code: "402208" },
    { id: 61741, cityId: 2865, code: "402402" },
    { id: 61742, cityId: 2868, code: "389152" },
    { id: 61743, cityId: 2868, code: "389154" },
    { id: 61744, cityId: 2908, code: "591346" },
    { id: 61745, cityId: 2911, code: "249121" },
    { id: 61746, cityId: 2911, code: "249124" },
    { id: 61747, cityId: 2911, code: "249125" },
    { id: 61748, cityId: 2911, code: "249126" },
    { id: 61749, cityId: 2911, code: "249127" },
    { id: 61750, cityId: 2911, code: "249130" },
    { id: 61751, cityId: 2911, code: "249137" },
    { id: 61752, cityId: 2911, code: "249145" },
    { id: 61753, cityId: 2911, code: "249181" },
    { id: 61754, cityId: 2911, code: "249186" },
    { id: 61755, cityId: 2911, code: "249192" },
    { id: 61756, cityId: 2911, code: "249199" },
    { id: 61757, cityId: 2911, code: "249301" },
    { id: 61758, cityId: 2916, code: "173030" },
    { id: 61759, cityId: 2916, code: "173031" },
    { id: 61760, cityId: 2916, code: "173032" },
    { id: 61761, cityId: 2921, code: "476332" },
    { id: 61762, cityId: 2921, code: "476335" },
    { id: 61763, cityId: 2921, code: "476355" },
    { id: 61764, cityId: 2927, code: "403109" },
    { id: 61765, cityId: 2927, code: "403114" },
    { id: 61766, cityId: 2927, code: "403115" },
    { id: 61767, cityId: 2927, code: "403201" },
    { id: 61768, cityId: 2927, code: "403202" },
    { id: 61769, cityId: 2927, code: "403206" },
    { id: 61770, cityId: 2927, code: "403409" },
    { id: 61771, cityId: 2927, code: "403504" },
    { id: 61772, cityId: 2927, code: "403524" },
    { id: 61773, cityId: 2928, code: "403410" },
    { id: 61774, cityId: 2928, code: "403530" },
    { id: 61775, cityId: 2928, code: "403731" },
    { id: 61776, cityId: 2933, code: "844103" },
    { id: 61777, cityId: 2936, code: "845404" },
    { id: 61778, cityId: 2949, code: "370115" },
    { id: 61779, cityId: 2949, code: "370601" },
    { id: 61780, cityId: 2949, code: "370641" },
    { id: 61781, cityId: 2951, code: "458389" },
    { id: 61782, cityId: 2951, code: "458556" },
    { id: 61783, cityId: 2951, code: "458667" },
    { id: 61784, cityId: 2951, code: "458669" },
    { id: 61785, cityId: 2951, code: "458771" },
    { id: 61786, cityId: 2951, code: "458778" },
    { id: 61787, cityId: 2951, code: "458880" },
    { id: 61788, cityId: 2951, code: "458883" },
    { id: 61789, cityId: 2951, code: "458888" },
    { id: 61790, cityId: 2951, code: "458895" },
    { id: 61791, cityId: 2953, code: "172116" },
    { id: 61792, cityId: 2953, code: "172118" },
    { id: 61793, cityId: 2959, code: "845315" },
    { id: 61794, cityId: 2959, code: "845415" },
    { id: 61795, cityId: 2962, code: "416511" },
    { id: 61796, cityId: 2962, code: "416549" },
    { id: 61797, cityId: 2962, code: "416611" },
    { id: 61798, cityId: 2962, code: "416614" },
    { id: 61799, cityId: 2962, code: "416632" },
    { id: 61800, cityId: 2962, code: "416806" },
    { id: 61801, cityId: 2962, code: "416811" },
    { id: 61802, cityId: 2962, code: "416812" },
    { id: 61803, cityId: 2962, code: "416813" },
    { id: 61804, cityId: 2963, code: "799254" },
    { id: 61805, cityId: 2963, code: "799256" },
    { id: 61806, cityId: 2963, code: "799280" },
    { id: 61807, cityId: 2963, code: "799281" },
    { id: 61808, cityId: 2964, code: "209210" },
    { id: 61809, cityId: 2964, code: "209310" },
    { id: 61810, cityId: 2964, code: "209311" },
    { id: 61811, cityId: 2964, code: "209312" },
    { id: 61812, cityId: 2964, code: "209881" },
    { id: 61813, cityId: 2969, code: "802214" },
    { id: 61814, cityId: 2969, code: "821108" },
    { id: 61815, cityId: 2969, code: "821112" },
    { id: 61816, cityId: 2972, code: "508117" },
    { id: 61817, cityId: 2972, code: "508208" },
    { id: 61818, cityId: 2977, code: "152020" },
    { id: 61819, cityId: 2977, code: "152118" },
    { id: 61820, cityId: 2980, code: "515413" },
    { id: 61821, cityId: 2980, code: "515556" },
    { id: 61822, cityId: 2980, code: "515871" },
    { id: 61823, cityId: 2984, code: "505129" },
    { id: 61824, cityId: 2985, code: "506103" },
    { id: 61825, cityId: 2987, code: "500108" },
    { id: 61826, cityId: 2987, code: "500100" },
    { id: 61827, cityId: 2987, code: "500104" },
    { id: 61828, cityId: 2987, code: "500107" },
    { id: 61829, cityId: 2987, code: "500111" },
    { id: 61830, cityId: 2987, code: "500114" },
    { id: 61831, cityId: 2988, code: "533352" },
    { id: 61832, cityId: 2993, code: "793116" },
    { id: 61833, cityId: 2993, code: "793126" },
    { id: 61834, cityId: 2993, code: "793151" },
    { id: 61835, cityId: 2993, code: "793161" },
    { id: 61836, cityId: 2993, code: "794003" },
    { id: 61837, cityId: 2993, code: "799113" },
    { id: 61838, cityId: 2997, code: "788026" },
    { id: 61839, cityId: 2997, code: "788031" },
    { id: 61840, cityId: 2997, code: "788118" },
    { id: 61841, cityId: 2997, code: "788127" },
    { id: 61842, cityId: 2997, code: "788804" },
    { id: 61843, cityId: 2997, code: "788820" },
    { id: 61844, cityId: 2997, code: "788931" },
    { id: 61845, cityId: 2998, code: "784146" },
    { id: 61846, cityId: 2998, code: "784148" },
    { id: 61847, cityId: 2998, code: "784190" },
    { id: 61848, cityId: 2998, code: "784529" },
    { id: 61849, cityId: 2999, code: "788931" },
    { id: 61850, cityId: 3000, code: "781039" },
    { id: 61851, cityId: 3000, code: "781104" },
    { id: 61852, cityId: 3000, code: "781137" },
    { id: 61853, cityId: 3000, code: "781141" },
    { id: 61854, cityId: 3001, code: "781002" },
    { id: 61855, cityId: 3001, code: "781036" },
    { id: 61856, cityId: 3001, code: "781040" },
    { id: 61857, cityId: 3002, code: "782441" },
    { id: 61858, cityId: 3002, code: "782462" },
    { id: 61859, cityId: 3002, code: "782490" },
    { id: 61860, cityId: 3003, code: "787023" },
    { id: 61861, cityId: 3003, code: "787031" },
    { id: 61862, cityId: 3003, code: "787033" },
    { id: 61863, cityId: 3004, code: "784010" },
    { id: 61864, cityId: 3004, code: "784026" },
    { id: 61865, cityId: 3004, code: "784027" },
    { id: 61866, cityId: 3004, code: "784028" },
    { id: 61867, cityId: 3004, code: "784105" },
    { id: 61868, cityId: 3004, code: "784153" },
    { id: 61869, cityId: 3004, code: "784169" },
    { id: 61870, cityId: 3004, code: "784501" },
    { id: 61871, cityId: 3007, code: "802207" },
    { id: 61872, cityId: 3007, code: "802302" },
    { id: 61873, cityId: 3007, code: "802351" },
    { id: 61874, cityId: 3007, code: "802352" },
    { id: 61875, cityId: 3009, code: "821108" },
    { id: 61876, cityId: 3010, code: "793116" },
    { id: 61877, cityId: 3010, code: "793126" },
    { id: 61878, cityId: 3010, code: "793151" },
    { id: 61879, cityId: 3010, code: "793161" },
    { id: 61880, cityId: 3010, code: "794003" },
    { id: 61881, cityId: 3010, code: "799113" },
    { id: 61882, cityId: 3011, code: "803114" },
    { id: 61883, cityId: 3011, code: "803121" },
    { id: 61884, cityId: 3011, code: "803215" },
    { id: 61885, cityId: 3011, code: "803216" },
    { id: 61886, cityId: 3011, code: "805105" },
    { id: 61887, cityId: 3016, code: "110099" },
    { id: 61888, cityId: 3019, code: "110097" },
    { id: 61889, cityId: 3022, code: "383317" },
    { id: 61890, cityId: 3030, code: "363623" },
    { id: 61891, cityId: 3030, code: "363635" },
    { id: 61892, cityId: 3030, code: "363643" },
    { id: 61893, cityId: 3031, code: "793116" },
    { id: 61894, cityId: 3031, code: "793126" },
    { id: 61895, cityId: 3031, code: "793151" },
    { id: 61896, cityId: 3031, code: "793161" },
    { id: 61897, cityId: 3031, code: "794003" },
    { id: 61898, cityId: 3031, code: "799113" },
    { id: 61899, cityId: 3033, code: "389002" },
    { id: 61900, cityId: 3033, code: "389115" },
    { id: 61901, cityId: 3034, code: "363351" },
    { id: 61902, cityId: 3034, code: "363745" },
    { id: 61903, cityId: 3034, code: "363750" },
    { id: 61904, cityId: 3034, code: "363755" },
    { id: 61905, cityId: 3034, code: "363760" },
    { id: 61906, cityId: 3034, code: "363765" },
    { id: 61907, cityId: 3034, code: "363775" },
    { id: 61908, cityId: 3034, code: "363780" },
    { id: 61909, cityId: 3036, code: "125006" },
    { id: 61910, cityId: 3036, code: "125007" },
    { id: 61911, cityId: 3037, code: "123031" },
    { id: 61912, cityId: 3039, code: "131039" },
    { id: 61913, cityId: 3039, code: "131301" },
    { id: 61914, cityId: 3039, code: "131302" },
    { id: 61915, cityId: 3039, code: "131304" },
    { id: 61916, cityId: 3039, code: "131305" },
    { id: 61917, cityId: 3039, code: "131306" },
    { id: 61918, cityId: 3039, code: "131402" },
    { id: 61919, cityId: 3039, code: "131403" },
    { id: 61920, cityId: 3039, code: "131408" },
    { id: 61921, cityId: 3039, code: "131409" },
    { id: 61922, cityId: 3041, code: "174002" },
    { id: 61923, cityId: 3041, code: "174003" },
    { id: 61924, cityId: 3041, code: "174005" },
    { id: 61925, cityId: 3041, code: "174013" },
    { id: 61926, cityId: 3041, code: "174015" },
    { id: 61927, cityId: 3041, code: "174017" },
    { id: 61928, cityId: 3041, code: "174023" },
    { id: 61929, cityId: 3041, code: "174024" },
    { id: 61930, cityId: 3041, code: "174036" },
    { id: 61931, cityId: 3043, code: "174505" },
    { id: 61932, cityId: 3043, code: "177119" },
    { id: 61933, cityId: 3043, code: "177301" },
    { id: 61934, cityId: 3043, code: "177401" },
    { id: 61935, cityId: 3043, code: "177501" },
    { id: 61936, cityId: 3043, code: "177601" },
    { id: 61937, cityId: 3044, code: "172117" },
    { id: 61938, cityId: 3044, code: "175139" },
    { id: 61939, cityId: 3045, code: "793116" },
    { id: 61940, cityId: 3045, code: "793126" },
    { id: 61941, cityId: 3045, code: "793151" },
    { id: 61942, cityId: 3045, code: "793161" },
    { id: 61943, cityId: 3045, code: "794003" },
    { id: 61944, cityId: 3045, code: "799113" },
    { id: 61945, cityId: 3047, code: "583155" },
    { id: 61946, cityId: 3048, code: "560111" },
    { id: 61947, cityId: 3048, code: "560116" },
    { id: 61948, cityId: 3048, code: "560117" },
    { id: 61949, cityId: 3048, code: "560500" },
    { id: 61950, cityId: 3049, code: "560112" },
    { id: 61951, cityId: 3049, code: "560115" },
    { id: 61952, cityId: 3049, code: "562163" },
    { id: 61953, cityId: 3049, code: "562164" },
    { id: 61954, cityId: 3050, code: "586108" },
    { id: 61955, cityId: 3050, code: "586109" },
    { id: 61956, cityId: 3050, code: "586130" },
    { id: 61957, cityId: 3050, code: "586216" },
    { id: 61958, cityId: 3051, code: "571342" },
    { id: 61959, cityId: 3052, code: "577129" },
    { id: 61960, cityId: 3052, code: "577146" },
    { id: 61961, cityId: 3052, code: "577181" },
    { id: 61962, cityId: 3055, code: "574229" },
    { id: 61963, cityId: 3055, code: "574233" },
    { id: 61964, cityId: 3055, code: "574253" },
    { id: 61965, cityId: 3055, code: "574267" },
    { id: 61966, cityId: 3055, code: "574324" },
    { id: 61967, cityId: 3055, code: "574326" },
    { id: 61968, cityId: 3055, code: "574327" },
    { id: 61969, cityId: 3055, code: "574328" },
    { id: 61970, cityId: 3055, code: "575025" },
    { id: 61971, cityId: 3056, code: "577007" },
    { id: 61972, cityId: 3056, code: "577556" },
    { id: 61973, cityId: 3057, code: "571106" },
    { id: 61974, cityId: 3059, code: "581121" },
    { id: 61975, cityId: 3059, code: "581453" },
    { id: 61976, cityId: 3060, code: "585107" },
    { id: 61977, cityId: 3060, code: "585367" },
    { id: 61978, cityId: 3061, code: "570031" },
    { id: 61979, cityId: 3061, code: "570032" },
    { id: 61980, cityId: 3061, code: "570033" },
    { id: 61981, cityId: 3061, code: "570034" },
    { id: 61982, cityId: 3062, code: "562161" },
    { id: 61983, cityId: 3064, code: "571106" },
    { id: 61984, cityId: 3067, code: "581307" },
    { id: 61985, cityId: 3067, code: "581308" },
    { id: 61986, cityId: 3067, code: "581356" },
    { id: 61987, cityId: 3067, code: "581396" },
    { id: 61988, cityId: 3067, code: "581453" },
    { id: 61989, cityId: 3068, code: "685514" },
    { id: 61990, cityId: 3068, code: "685606" },
    { id: 61991, cityId: 3068, code: "685608" },
    { id: 61992, cityId: 3068, code: "685609" },
    { id: 61993, cityId: 3069, code: "671348" },
    { id: 61994, cityId: 3069, code: "671534" },
    { id: 61995, cityId: 3072, code: "484447" },
    { id: 61996, cityId: 3072, code: "484887" },
    { id: 61997, cityId: 3073, code: "487330" },
    { id: 61998, cityId: 3073, code: "487334" },
    { id: 61999, cityId: 3073, code: "487661" },
    { id: 62000, cityId: 3074, code: "413738" },
    { id: 62001, cityId: 3074, code: "414006" },
    { id: 62002, cityId: 3074, code: "414110" },
    { id: 62003, cityId: 3074, code: "414609" },
    { id: 62004, cityId: 3074, code: "422602" },
    { id: 62005, cityId: 3074, code: "422622" },
    { id: 62006, cityId: 3077, code: "793116" },
    { id: 62007, cityId: 3077, code: "793126" },
    { id: 62008, cityId: 3077, code: "793151" },
    { id: 62009, cityId: 3077, code: "793161" },
    { id: 62010, cityId: 3077, code: "794003" },
    { id: 62011, cityId: 3077, code: "799113" },
    { id: 62012, cityId: 3078, code: "410216" },
    { id: 62013, cityId: 3078, code: "410220" },
    { id: 62014, cityId: 3080, code: "445002" },
    { id: 62015, cityId: 3080, code: "445109" },
    { id: 62016, cityId: 3080, code: "445230" },
    { id: 62017, cityId: 3080, code: "445324" },
    { id: 62018, cityId: 3081, code: "795008" },
    { id: 62019, cityId: 3081, code: "795114" },
    { id: 62020, cityId: 3082, code: "795009" },
    { id: 62021, cityId: 3082, code: "795113" },
    { id: 62022, cityId: 3083, code: "793116" },
    { id: 62023, cityId: 3083, code: "793126" },
    { id: 62024, cityId: 3083, code: "793151" },
    { id: 62025, cityId: 3083, code: "793161" },
    { id: 62026, cityId: 3083, code: "794003" },
    { id: 62027, cityId: 3083, code: "799113" },
    { id: 62028, cityId: 3086, code: "799046" },
    { id: 62029, cityId: 3086, code: "799014" },
    { id: 62030, cityId: 3086, code: "799022" },
    { id: 62031, cityId: 3086, code: "799207" },
    { id: 62032, cityId: 3088, code: "796004" },
    { id: 62033, cityId: 3088, code: "796421" },
    { id: 62034, cityId: 3088, code: "796470" },
    { id: 62035, cityId: 3089, code: "796470" },
    { id: 62036, cityId: 3090, code: "793116" },
    { id: 62037, cityId: 3090, code: "793126" },
    { id: 62038, cityId: 3090, code: "793151" },
    { id: 62039, cityId: 3090, code: "793161" },
    { id: 62040, cityId: 3090, code: "794003" },
    { id: 62041, cityId: 3090, code: "799113" },
    { id: 62042, cityId: 3091, code: "799046" },
    { id: 62043, cityId: 3091, code: "799014" },
    { id: 62044, cityId: 3091, code: "799022" },
    { id: 62045, cityId: 3091, code: "799207" },
    { id: 62046, cityId: 3093, code: "793116" },
    { id: 62047, cityId: 3093, code: "793126" },
    { id: 62048, cityId: 3093, code: "793151" },
    { id: 62049, cityId: 3093, code: "793161" },
    { id: 62050, cityId: 3093, code: "794003" },
    { id: 62051, cityId: 3093, code: "799113" },
    { id: 62052, cityId: 3097, code: "605108" },
    { id: 62053, cityId: 3097, code: "605766" },
    { id: 62054, cityId: 3097, code: "606209" },
    { id: 62055, cityId: 3097, code: "607209" },
    { id: 62056, cityId: 3098, code: "151004" },
    { id: 62057, cityId: 3099, code: "152020" },
    { id: 62058, cityId: 3100, code: "140127" },
    { id: 62059, cityId: 3100, code: "140128" },
    { id: 62060, cityId: 3101, code: "143402" },
    { id: 62061, cityId: 3102, code: "343002" },
    { id: 62062, cityId: 3102, code: "343049" },
    { id: 62063, cityId: 3103, code: "331025" },
    { id: 62064, cityId: 3103, code: "332746" },
    { id: 62065, cityId: 3103, code: "333801" },
    { id: 62066, cityId: 3104, code: "312624" },
    { id: 62067, cityId: 3104, code: "312625" },
    { id: 62068, cityId: 3104, code: "312626" },
    { id: 62069, cityId: 3112, code: "600127" },
    { id: 62070, cityId: 3112, code: "600131" },
    { id: 62071, cityId: 3112, code: "600132" },
    { id: 62072, cityId: 3112, code: "602117" },
    { id: 62073, cityId: 3112, code: "603003" },
    { id: 62074, cityId: 3112, code: "603004" },
    { id: 62075, cityId: 3112, code: "603211" },
    { id: 62076, cityId: 3112, code: "631552" },
    { id: 62077, cityId: 3112, code: "631561" },
    { id: 62078, cityId: 3115, code: "610003" },
    { id: 62079, cityId: 3115, code: "610004" },
    { id: 62080, cityId: 3115, code: "610005" },
    { id: 62081, cityId: 3115, code: "612610" },
    { id: 62082, cityId: 3115, code: "614018" },
    { id: 62083, cityId: 3116, code: "605108" },
    { id: 62084, cityId: 3116, code: "605766" },
    { id: 62085, cityId: 3116, code: "606209" },
    { id: 62086, cityId: 3116, code: "607209" },
    { id: 62087, cityId: 3118, code: "799284" },
    { id: 62088, cityId: 3119, code: "799266" },
    { id: 62089, cityId: 3119, code: "799282" },
    { id: 62090, cityId: 3120, code: "799013" },
    { id: 62091, cityId: 3120, code: "799113" },
    { id: 62092, cityId: 3120, code: "799114" },
    { id: 62093, cityId: 3121, code: "799113" },
    { id: 62094, cityId: 3122, code: "793116" },
    { id: 62095, cityId: 3122, code: "793126" },
    { id: 62096, cityId: 3122, code: "793151" },
    { id: 62097, cityId: 3122, code: "793161" },
    { id: 62098, cityId: 3122, code: "794003" },
    { id: 62099, cityId: 3122, code: "799113" },
    { id: 62100, cityId: 3124, code: "799013" },
    { id: 62101, cityId: 3124, code: "799114" },
    { id: 62102, cityId: 3124, code: "799150" },
    { id: 62103, cityId: 3125, code: "799046" },
    { id: 62104, cityId: 3125, code: "799014" },
    { id: 62105, cityId: 3125, code: "799022" },
    { id: 62106, cityId: 3125, code: "799207" },
    { id: 62107, cityId: 3126, code: "250606" },
    { id: 62108, cityId: 3126, code: "250620" },
    { id: 62109, cityId: 3127, code: "209501" },
    { id: 62110, cityId: 3127, code: "209502" },
    { id: 62111, cityId: 3127, code: "209503" },
    { id: 62112, cityId: 3127, code: "209504" },
    { id: 62113, cityId: 3127, code: "209505" },
    { id: 62114, cityId: 3127, code: "209651" },
    { id: 62115, cityId: 3127, code: "209652" },
    { id: 62116, cityId: 3127, code: "209745" },
    { id: 62117, cityId: 3127, code: "209749" },
    { id: 62118, cityId: 3128, code: "201305" },
    { id: 62119, cityId: 3128, code: "201311" },
    { id: 62120, cityId: 3128, code: "201312" },
    { id: 62121, cityId: 3128, code: "201313" },
    { id: 62122, cityId: 3128, code: "201314" },
    { id: 62123, cityId: 3128, code: "201315" },
    { id: 62124, cityId: 3128, code: "201316" },
    { id: 62125, cityId: 3128, code: "201317" },
    { id: 62126, cityId: 3128, code: "201318" },
    { id: 62127, cityId: 3129, code: "208008" },
    { id: 62128, cityId: 3129, code: "209210" },
    { id: 62129, cityId: 3129, code: "209214" },
    { id: 62130, cityId: 3129, code: "209308" },
    { id: 62131, cityId: 3131, code: "211020" },
    { id: 62132, cityId: 3132, code: "229103" },
    { id: 62133, cityId: 3132, code: "229120" },
    { id: 62134, cityId: 3132, code: "229135" },
    { id: 62135, cityId: 3132, code: "229210" },
    { id: 62136, cityId: 3132, code: "229306" },
    { id: 62137, cityId: 3132, code: "229316" },
    { id: 62138, cityId: 3132, code: "229801" },
    { id: 62139, cityId: 3132, code: "229802" },
    { id: 62140, cityId: 3133, code: "272176" },
    { id: 62141, cityId: 3133, code: "272199" },
    { id: 62142, cityId: 3133, code: "272270" },
    { id: 62143, cityId: 3133, code: "272271" },
    { id: 62144, cityId: 3137, code: "700160" },
    { id: 62145, cityId: 3137, code: "700163" },
    { id: 62146, cityId: 3140, code: "733158" },
    { id: 62147, cityId: 3146, code: "505129" },
    { id: 62148, cityId: 3150, code: "506103" },
    { id: 62149, cityId: 3151, code: "506103" },
    { id: 62150, cityId: 3155, code: "505212" },
    { id: 62151, cityId: 3156, code: "500108" },
    { id: 62152, cityId: 3156, code: "500100" },
    { id: 62153, cityId: 3156, code: "500104" },
    { id: 62154, cityId: 3156, code: "500107" },
    { id: 62155, cityId: 3156, code: "500111" },
    { id: 62156, cityId: 3156, code: "500114" },
    { id: 62157, cityId: 3162, code: "506333" },
    { id: 62158, cityId: 3165, code: "494347" },
    { id: 62159, cityId: 3168, code: "495003" },
    { id: 62160, cityId: 3168, code: "495442" },
    { id: 62161, cityId: 3168, code: "495555" },
    { id: 62162, cityId: 3169, code: "493887" },
    { id: 62163, cityId: 3169, code: "493891" },
    { id: 62164, cityId: 3170, code: "495686" },
    { id: 62165, cityId: 3171, code: "495669" },
    { id: 62166, cityId: 3172, code: "497450" },
    { id: 62167, cityId: 3173, code: "494237" },
    { id: 62168, cityId: 3175, code: "497117" },
    { id: 62169, cityId: 3177, code: "193306" },
    { id: 62170, cityId: 3179, code: "190021" },
    { id: 62171, cityId: 3180, code: "185202" },
    { id: 62172, cityId: 3180, code: "185234" },
    { id: 62173, cityId: 3186, code: "793151" },
    { id: 62174, cityId: 3186, code: "793161" },
    { id: 62175, cityId: 3187, code: "793123" },
    { id: 62176, cityId: 3188, code: "794114" },
    { id: 62177, cityId: 3192, code: "793126" },
    { id: 62178, cityId: 3193, code: "759100" },
    { id: 62179, cityId: 3193, code: "759111" },
    { id: 62180, cityId: 3193, code: "759147" },
    { id: 62181, cityId: 3193, code: "759148" },
    { id: 62182, cityId: 3194, code: "756039" },
    { id: 62183, cityId: 3194, code: "756085" },
    { id: 62184, cityId: 3194, code: "756086" },
    { id: 62185, cityId: 3194, code: "756087" },
    { id: 62186, cityId: 3194, code: "756182" },
    { id: 62187, cityId: 3197, code: "754296" },
    { id: 62188, cityId: 3197, code: "755051" },
    { id: 62189, cityId: 3197, code: "755062" },
    { id: 62190, cityId: 3200, code: "769011" },
    { id: 62191, cityId: 3201, code: "246124" },
    { id: 62192, cityId: 3201, code: "246150" },
    { id: 62193, cityId: 3201, code: "246159" },
    { id: 62194, cityId: 3201, code: "246178" },
    { id: 62195, cityId: 3201, code: "246179" },
    { id: 62196, cityId: 3201, code: "246194" },
    { id: 62197, cityId: 3201, code: "246279" },
    { id: 62198, cityId: 3201, code: "249301" },
    { id: 62199, cityId: 3201, code: "249306" },
    { id: 62200, cityId: 3202, code: "246141" },
    { id: 62201, cityId: 3202, code: "246445" },
    { id: 62202, cityId: 332, code: "160005" },
    { id: 62203, cityId: 332, code: "160043" },
    { id: 62204, cityId: 447, code: "382045" },
    { id: 62205, cityId: 2973, code: "276405" },
    { id: 62206, cityId: 3116, code: "605103" },
    { id: 62207, cityId: 3203, code: "606001" },
    { id: 62208, cityId: 3204, code: "606102" },
    { id: 62209, cityId: 2174, code: "202011" },
    { id: 62210, cityId: 1439, code: "402307" },
    { id: 62211, cityId: 2817, code: "741233" },
    { id: 62212, cityId: 2865, code: "402203" },
    { id: 62213, cityId: 2397, code: "273151" },
    { id: 62214, cityId: 3145, code: "500076" },
    { id: 62215, cityId: 3198, code: "752027" },
    { id: 62216, cityId: 2863, code: "755011" },
    { id: 62217, cityId: 3112, code: "600073" },
    { id: 62218, cityId: 3112, code: "600064" },
    { id: 62219, cityId: 781, code: "562114" },
    { id: 62220, cityId: 3112, code: "600048" },
    { id: 62221, cityId: 1483, code: "783124" },
    { id: 62222, cityId: 3060, code: "585302" },
    { id: 62223, cityId: 1492, code: "796007" },
    { id: 62224, cityId: 825, code: "583227" },
    { id: 62225, cityId: 726, code: "832302" },
    { id: 62226, cityId: 3132, code: "229301" },
    { id: 62227, cityId: 3205, code: "416810" },
    { id: 62228, cityId: 1484, code: "794112" },
    { id: 62229, cityId: 1484, code: "794107" },
    { id: 62230, cityId: 3196, code: "761017" },
    { id: 62231, cityId: 3051, code: "571109" },
    { id: 62232, cityId: 3206, code: "500016" },
    { id: 62233, cityId: 2290, code: "205151" },
    { id: 62234, cityId: 2863, code: "755036" },
    { id: 62235, cityId: 2955, code: "571217" },
    { id: 62236, cityId: 2906, code: "743329" },
    { id: 62237, cityId: 2962, code: "416703" },
    { id: 62238, cityId: 2857, code: "757045" },
    { id: 62239, cityId: 1460, code: "445001" },
    { id: 62240, cityId: 3207, code: "605203" },
    { id: 62241, cityId: 1522, code: "768028" },
    { id: 62242, cityId: 1567, code: "751003" },
    { id: 62243, cityId: 2117, code: "643001" },
    { id: 62244, cityId: 3116, code: "606206" },
    { id: 62245, cityId: 2860, code: "383215" },
    { id: 62246, cityId: 447, code: "382315" },
    { id: 62247, cityId: 119, code: "520010" },
    { id: 62248, cityId: 3063, code: "562119" },
    { id: 62249, cityId: 3197, code: "755008" },
    { id: 62250, cityId: 1514, code: "759145" },
    { id: 62251, cityId: 1512, code: "798601" },
    { id: 62252, cityId: 2863, code: "755023" },
    { id: 62253, cityId: 3198, code: "752021" },
    { id: 62254, cityId: 3196, code: "761215" },
    { id: 62255, cityId: 1746, code: "343401" },
    { id: 62256, cityId: 1925, code: "600088" },
    { id: 62257, cityId: 2962, code: "416518" },
    { id: 62258, cityId: 3208, code: "767019" },
    { id: 62259, cityId: 896, code: "571252" },
    { id: 62260, cityId: 3113, code: "643212" },
    { id: 62261, cityId: 796, code: "586109" },
    { id: 62262, cityId: 3198, code: "751022" },
    { id: 62263, cityId: 3198, code: "751020" },
    { id: 62264, cityId: 3116, code: "605601" },
    { id: 62265, cityId: 3183, code: "794110" },
    { id: 62266, cityId: 3183, code: "794110" },
    { id: 62267, cityId: 2870, code: "643101" },
    { id: 62268, cityId: 3048, code: "560067" },
    { id: 62269, cityId: 2825, code: "736180" },
    { id: 62270, cityId: 3198, code: "751015" },
    { id: 62271, cityId: 3210, code: "571231" },
    { id: 62272, cityId: 3067, code: "581347" },
    { id: 62273, cityId: 2805, code: "201306" },
    { id: 62274, cityId: 2857, code: "757024" },
    { id: 62275, cityId: 2397, code: "273158" },
    { id: 62276, cityId: 2397, code: "273303" },
    { id: 62277, cityId: 2764, code: "201306" },
    { id: 62278, cityId: 1744, code: "302024" },
    { id: 62279, cityId: 1744, code: "302025" },
    { id: 62280, cityId: 1486, code: "783123" },
    { id: 62281, cityId: 3055, code: "574238" },
    { id: 62282, cityId: 2963, code: "799269" },
    { id: 62283, cityId: 2963, code: "799269" },
    { id: 62284, cityId: 1744, code: "302032" },
    { id: 62285, cityId: 1694, code: "302006" },
    { id: 62286, cityId: 3197, code: "755012" },
    { id: 62287, cityId: 3000, code: "781034" },
    { id: 62288, cityId: 3193, code: "759141" },
    { id: 62289, cityId: 3211, code: "781121" },
    { id: 62290, cityId: 3212, code: "500081" },
    { id: 62291, cityId: 3213, code: "794112" },
    { id: 62292, cityId: 3214, code: "500012" },
    { id: 62293, cityId: 3196, code: "761015" },
    { id: 62294, cityId: 902, code: "575087" },
    { id: 62295, cityId: 2959, code: "845437" },
    { id: 62296, cityId: 2640, code: "733313" },
    { id: 62297, cityId: 2640, code: "733134" },
    { id: 62298, cityId: 781, code: "560035" },
    { id: 62299, cityId: 414, code: "370150" },
    { id: 62300, cityId: 1739, code: "335001" },
    { id: 62301, cityId: 1739, code: "335001" },
    { id: 62302, cityId: 3107, code: "335001" },
    { id: 62303, cityId: 3215, code: "793021" },
    { id: 62304, cityId: 3053, code: "561209" },
    { id: 62305, cityId: 3216, code: "673010" },
    { id: 62306, cityId: 1517, code: "756021" },
    { id: 62307, cityId: 3194, code: "756021" },
    { id: 62308, cityId: 781, code: "560062" },
    { id: 62309, cityId: 2536, code: "229501" },
    { id: 62310, cityId: 781, code: "560062" },
    { id: 62311, cityId: 2488, code: "202522" },
    { id: 62312, cityId: 2488, code: "202522" },
    { id: 62313, cityId: 782, code: "560062" },
    { id: 62314, cityId: 783, code: "560062" },
    { id: 62315, cityId: 3137, code: "700090" },
    { id: 62316, cityId: 337, code: "493335" },
    { id: 62317, cityId: 3038, code: "122508" },
    { id: 62318, cityId: 2641, code: "743333" },
    { id: 62319, cityId: 2641, code: "743355" },
    { id: 62320, cityId: 3116, code: "605502" },
    { id: 62321, cityId: 3114, code: "642514" },
    { id: 62322, cityId: 3114, code: "642154" },
    { id: 62323, cityId: 3114, code: "642152" },
    { id: 62324, cityId: 3140, code: "733124" },
    { id: 62325, cityId: 3193, code: "759040" },
    { id: 62326, cityId: 3217, code: "735206" },
    { id: 62327, cityId: 3217, code: "735206" },
    { id: 62328, cityId: 2857, code: "757032" },
    { id: 62329, cityId: 1367, code: "421204" },
    { id: 62330, cityId: 853, code: "580029" },
    { id: 62331, cityId: 3198, code: "751031" },
    { id: 62332, cityId: 3218, code: "416613" },
    { id: 62333, cityId: 2805, code: "201310" },
    { id: 62334, cityId: 216, code: "784522" },
    { id: 62335, cityId: 3004, code: "784101" },
    { id: 62336, cityId: 3004, code: "784025" },
    { id: 62337, cityId: 170, code: "781040" },
    { id: 62338, cityId: 2998, code: "784125" },
    { id: 62339, cityId: 216, code: "784525" },
    { id: 62340, cityId: 3185, code: "793002" },
    { id: 62341, cityId: 362, code: "495678" },
    { id: 62342, cityId: 352, code: "495556" },
    { id: 62343, cityId: 3185, code: "793006" },
    { id: 62344, cityId: 3185, code: "793007" },
    { id: 62345, cityId: 3004, code: "784175" },
    { id: 62346, cityId: 2300, code: "201005" },
    { id: 62347, cityId: 783, code: "560043" },
    { id: 62348, cityId: 2857, code: "757028" },
    { id: 62349, cityId: 3219, code: "781036" },
    { id: 62350, cityId: 3201, code: "246164" },
    { id: 62351, cityId: 3220, code: "734429" },
    { id: 62352, cityId: 853, code: "580032" },
    { id: 62353, cityId: 3188, code: "794103" },
    { id: 62354, cityId: 2784, code: "249406" },
    { id: 62355, cityId: 3172, code: "497778" },
    { id: 62356, cityId: 3221, code: "733144" },
    { id: 62357, cityId: 2613, code: "263145" },
    { id: 62358, cityId: 2900, code: "263153" },
    { id: 62359, cityId: 3222, code: "752066" },
    { id: 62360, cityId: 964, code: "572100" },
    { id: 62361, cityId: 2911, code: "249105" },
    { id: 62362, cityId: 3165, code: "494442" },
    { id: 62363, cityId: 1361, code: "416436" },
    { id: 62364, cityId: 2290, code: "205152" },
    { id: 62365, cityId: 3072, code: "484224" },
    { id: 62366, cityId: 3172, code: "497339" },
    { id: 62367, cityId: 2466, code: "243701" },
    { id: 62368, cityId: 3166, code: "491335" },
    { id: 62369, cityId: 2957, code: "491226" },
    { id: 62370, cityId: 369, code: "496001" },
    { id: 62371, cityId: 853, code: "580023" },
    { id: 62372, cityId: 1486, code: "783134" },
    { id: 62373, cityId: 1486, code: "794108" },
    { id: 62374, cityId: 1261, code: "431001" },
    { id: 62375, cityId: 3223, code: "431001" },
    { id: 62376, cityId: 2298, code: "201301" },
    { id: 62377, cityId: 853, code: "580020" },
    { id: 62378, cityId: 3214, code: "500002" },
    { id: 62379, cityId: 3224, code: "401107" },
    { id: 62380, cityId: 2104, code: "614703" },
    { id: 62381, cityId: 2104, code: "614715" },
    { id: 62382, cityId: 3226, code: "534201" },
    { id: 62383, cityId: 2986, code: "534245" },
    { id: 62384, cityId: 2799, code: "393002" },
    { id: 62385, cityId: 3101, code: "143301" },
    { id: 62386, cityId: 2741, code: "700059" },
    { id: 62387, cityId: 1486, code: "794104" },
    { id: 62388, cityId: 3037, code: "123001" },
    { id: 62389, cityId: 3016, code: "110034" },
    { id: 62390, cityId: 1486, code: "794101" },
    { id: 62391, cityId: 3039, code: "131001" },
    { id: 62392, cityId: 447, code: "382721" },
    { id: 62393, cityId: 379, code: "396230" },
    { id: 62394, cityId: 3214, code: "500015" },
    { id: 62395, cityId: 1176, code: "458001" },
    { id: 62396, cityId: 1176, code: "458001" },
    { id: 62397, cityId: 2951, code: "458001" },
    { id: 62398, cityId: 3137, code: "700059" },
    { id: 62399, cityId: 2996, code: "781360" },
    { id: 62400, cityId: 3208, code: "767016" },
    { id: 62401, cityId: 3036, code: "125052" },
    { id: 62402, cityId: 853, code: "580024" },
    { id: 62403, cityId: 332, code: "160048" },
    { id: 62404, cityId: 2641, code: "700055" },
    { id: 62405, cityId: 2298, code: "201309" },
    { id: 62406, cityId: 3137, code: "700055" },
    { id: 62407, cityId: 332, code: "160015" },
    { id: 62408, cityId: 3228, code: "785689" },
    { id: 62409, cityId: 3229, code: "785693" },
    { id: 62410, cityId: 830, code: "585104" },
    { id: 62411, cityId: 830, code: "585104" },
    { id: 62412, cityId: 572, code: "126101" },
    { id: 62413, cityId: 3036, code: "125039" },
    { id: 62414, cityId: 3116, code: "605106" },
    { id: 62415, cityId: 3197, code: "755004" },
    { id: 62416, cityId: 3194, code: "756044" },
    { id: 62417, cityId: 3230, code: "500050" },
    { id: 62418, cityId: 2397, code: "273301" },
    { id: 62419, cityId: 2340, code: "203202" },
    { id: 62420, cityId: 2805, code: "201318" },
    { id: 62421, cityId: 843, code: "577598" },
    { id: 62422, cityId: 3001, code: "781024" },
    { id: 62423, cityId: 2946, code: "790114" },
    { id: 62424, cityId: 3019, code: "110043" },
    { id: 62425, cityId: 836, code: "583131" },
    { id: 62426, cityId: 843, code: "577599" },
    { id: 62427, cityId: 3019, code: "110045" },
    { id: 62428, cityId: 2781, code: "402113" },
    { id: 62429, cityId: 380, code: "396210" },
    { id: 62430, cityId: 2949, code: "370135" },
    { id: 62431, cityId: 1717, code: "334810" },
    { id: 62432, cityId: 2816, code: "712124" },
    { id: 62433, cityId: 3101, code: "143302" },
    { id: 62434, cityId: 2805, code: "201312" },
    { id: 62435, cityId: 2991, code: "791102" },
    { id: 62436, cityId: 3231, code: "781122" },
    { id: 62437, cityId: 447, code: "382835" },
    { id: 62438, cityId: 445, code: "361347" },
    { id: 62439, cityId: 3101, code: "143411" },
    { id: 62440, cityId: 3101, code: "143401" },
    { id: 62441, cityId: 1735, code: "341506" },
    { id: 62442, cityId: 3117, code: "799001" },
    { id: 62443, cityId: 3193, code: "759143" },
    { id: 62444, cityId: 1514, code: "759143" },
    { id: 62445, cityId: 325, code: "841428" },
    { id: 62446, cityId: 3101, code: "143410" },
    { id: 62447, cityId: 1536, code: "752115" },
    { id: 62448, cityId: 3101, code: "143410" },
    { id: 62449, cityId: 3101, code: "143415" },
    { id: 62450, cityId: 2145, code: "605402" },
    { id: 62451, cityId: 1925, code: "600115" },
    { id: 62452, cityId: 2822, code: "798622" },
    { id: 62453, cityId: 3000, code: "781122" },
    { id: 62454, cityId: 3007, code: "802203" },
    { id: 62455, cityId: 3232, code: "781122" },
    { id: 62456, cityId: 3003, code: "784161" },
    { id: 62457, cityId: 3081, code: "795116" },
    { id: 62458, cityId: 2667, code: "733314" },
    { id: 62459, cityId: 2298, code: "201307" },
    { id: 62460, cityId: 3101, code: "143419" },
    { id: 62461, cityId: 2298, code: "201004" },
    { id: 62462, cityId: 3082, code: "795004" },
    { id: 62463, cityId: 2836, code: "791113" },
    { id: 62464, cityId: 2184, code: "244225" },
    { id: 62465, cityId: 796, code: "586117" },
    { id: 62466, cityId: 3080, code: "445204" },
    { id: 62467, cityId: 2857, code: "757052" },
    { id: 62468, cityId: 352, code: "495689" },
    { id: 62469, cityId: 3198, code: "752030" },
    { id: 62470, cityId: 3198, code: "752034" },
    { id: 62471, cityId: 3198, code: "752103" },
    { id: 62472, cityId: 2738, code: "700114" },
    { id: 62473, cityId: 2468, code: "284205" },
    { id: 62474, cityId: 2468, code: "241312" },
    { id: 62475, cityId: 337, code: "493344" },
    { id: 62476, cityId: 796, code: "586113" },
    { id: 62477, cityId: 3205, code: "416810" },
    { id: 62478, cityId: 1247, code: "413204" },
    { id: 62479, cityId: 3019, code: "110077" },
    { id: 62480, cityId: 3101, code: "143107" },
    { id: 62481, cityId: 843, code: "577546" },
];